
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0672"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0672"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("cpTWE", function(module, exports) {

$parcel$export(module.exports, "NonFullScreenPageMode", () => NonFullScreenPageMode);
$parcel$export(module.exports, "ReadingDirection", () => ReadingDirection);
$parcel$export(module.exports, "PrintScaling", () => PrintScaling);
$parcel$export(module.exports, "Duplex", () => Duplex);
$parcel$export(module.exports, "default", () => $90a3375623cd9a5a$export$2e2bcd8739ae039);

var $8auL6 = parcelRequire("8auL6");

var $8gQNC = parcelRequire("8gQNC");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var asEnum = function(rawValue, enumType) {
    if (rawValue === undefined) return undefined;
    return enumType[rawValue];
};
var NonFullScreenPageMode;
(function(NonFullScreenPageMode) {
    /**
     * After exiting FullScreen mode, neither the document outline nor thumbnail
     * images should be visible.
     */ NonFullScreenPageMode["UseNone"] = "UseNone";
    /** After exiting FullScreen mode, the document outline should be visible. */ NonFullScreenPageMode["UseOutlines"] = "UseOutlines";
    /** After exiting FullScreen mode, thumbnail images should be visible. */ NonFullScreenPageMode["UseThumbs"] = "UseThumbs";
    /**
     * After exiting FullScreen mode, the optional content group panel should be
     * visible.
     */ NonFullScreenPageMode["UseOC"] = "UseOC";
})(NonFullScreenPageMode || (NonFullScreenPageMode = {}));
var ReadingDirection;
(function(ReadingDirection) {
    /** The predominant reading order is Left to Right. */ ReadingDirection["L2R"] = "L2R";
    /**
     * The predominant reading order is Right to left (including vertical writing
     * systems, such as Chinese, Japanese and Korean).
     */ ReadingDirection["R2L"] = "R2L";
})(ReadingDirection || (ReadingDirection = {}));
var PrintScaling;
(function(PrintScaling) {
    /** No page scaling. */ PrintScaling["None"] = "None";
    /* Use the PDF reader's default print scaling. */ PrintScaling["AppDefault"] = "AppDefault";
})(PrintScaling || (PrintScaling = {}));
var Duplex;
(function(Duplex) {
    /** The PDF reader should print single-sided. */ Duplex["Simplex"] = "Simplex";
    /**
     * The PDF reader should print double sided and flip on the short edge of the
     * sheet.
     */ Duplex["DuplexFlipShortEdge"] = "DuplexFlipShortEdge";
    /**
     * The PDF reader should print double sided and flip on the long edge of the
     * sheet.
     */ Duplex["DuplexFlipLongEdge"] = "DuplexFlipLongEdge";
})(Duplex || (Duplex = {}));
var ViewerPreferences = /** @class */ function() {
    /** @ignore */ function ViewerPreferences(dict) {
        this.dict = dict;
    }
    ViewerPreferences.prototype.lookupBool = function(key) {
        var returnObj = this.dict.lookup((0, $dPHSK.default).of(key));
        if (returnObj instanceof (0, $8gQNC.default)) return returnObj;
        return undefined;
    };
    ViewerPreferences.prototype.lookupName = function(key) {
        var returnObj = this.dict.lookup((0, $dPHSK.default).of(key));
        if (returnObj instanceof (0, $dPHSK.default)) return returnObj;
        return undefined;
    };
    /** @ignore */ ViewerPreferences.prototype.HideToolbar = function() {
        return this.lookupBool('HideToolbar');
    };
    /** @ignore */ ViewerPreferences.prototype.HideMenubar = function() {
        return this.lookupBool('HideMenubar');
    };
    /** @ignore */ ViewerPreferences.prototype.HideWindowUI = function() {
        return this.lookupBool('HideWindowUI');
    };
    /** @ignore */ ViewerPreferences.prototype.FitWindow = function() {
        return this.lookupBool('FitWindow');
    };
    /** @ignore */ ViewerPreferences.prototype.CenterWindow = function() {
        return this.lookupBool('CenterWindow');
    };
    /** @ignore */ ViewerPreferences.prototype.DisplayDocTitle = function() {
        return this.lookupBool('DisplayDocTitle');
    };
    /** @ignore */ ViewerPreferences.prototype.NonFullScreenPageMode = function() {
        return this.lookupName('NonFullScreenPageMode');
    };
    /** @ignore */ ViewerPreferences.prototype.Direction = function() {
        return this.lookupName('Direction');
    };
    /** @ignore */ ViewerPreferences.prototype.PrintScaling = function() {
        return this.lookupName('PrintScaling');
    };
    /** @ignore */ ViewerPreferences.prototype.Duplex = function() {
        return this.lookupName('Duplex');
    };
    /** @ignore */ ViewerPreferences.prototype.PickTrayByPDFSize = function() {
        return this.lookupBool('PickTrayByPDFSize');
    };
    /** @ignore */ ViewerPreferences.prototype.PrintPageRange = function() {
        var PrintPageRange = this.dict.lookup((0, $dPHSK.default).of('PrintPageRange'));
        if (PrintPageRange instanceof (0, $8auL6.default)) return PrintPageRange;
        return undefined;
    };
    /** @ignore */ ViewerPreferences.prototype.NumCopies = function() {
        var NumCopies = this.dict.lookup((0, $dPHSK.default).of('NumCopies'));
        if (NumCopies instanceof (0, $j04jt.default)) return NumCopies;
        return undefined;
    };
    /**
     * Returns `true` if PDF readers should hide the toolbar menus when displaying
     * this document.
     * @returns Whether or not toolbars should be hidden.
     */ ViewerPreferences.prototype.getHideToolbar = function() {
        var _a, _b;
        return (_b = (_a = this.HideToolbar()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should hide the menu bar when displaying this
     * document.
     * @returns Whether or not the menu bar should be hidden.
     */ ViewerPreferences.prototype.getHideMenubar = function() {
        var _a, _b;
        return (_b = (_a = this.HideMenubar()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should hide the user interface elements in
     * the document's window (such as scroll bars and navigation controls),
     * leaving only the document's contents displayed.
     * @returns Whether or not user interface elements should be hidden.
     */ ViewerPreferences.prototype.getHideWindowUI = function() {
        var _a, _b;
        return (_b = (_a = this.HideWindowUI()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should resize the document's window to fit
     * the size of the first displayed page.
     * @returns Whether or not the window should be resized to fit.
     */ ViewerPreferences.prototype.getFitWindow = function() {
        var _a, _b;
        return (_b = (_a = this.FitWindow()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should position the document's window in the
     * center of the screen.
     * @returns Whether or not to center the document window.
     */ ViewerPreferences.prototype.getCenterWindow = function() {
        var _a, _b;
        return (_b = (_a = this.CenterWindow()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if the window's title bar should display the document
     * `Title`, taken from the document metadata (see [[PDFDocument.getTitle]]).
     * Returns `false` if the title bar should instead display the filename of the
     * PDF file.
     * @returns Whether to display the document title.
     */ ViewerPreferences.prototype.getDisplayDocTitle = function() {
        var _a, _b;
        return (_b = (_a = this.DisplayDocTitle()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns the page mode, which tells the PDF reader how to display the
     * document after exiting full-screen mode.
     * @returns The page mode after exiting full-screen mode.
     */ ViewerPreferences.prototype.getNonFullScreenPageMode = function() {
        var _a, _b;
        var mode = (_a = this.NonFullScreenPageMode()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(mode, NonFullScreenPageMode)) !== null && _b !== void 0 ? _b : NonFullScreenPageMode.UseNone;
    };
    /**
     * Returns the predominant reading order for text.
     * @returns The text reading order.
     */ ViewerPreferences.prototype.getReadingDirection = function() {
        var _a, _b;
        var direction = (_a = this.Direction()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(direction, ReadingDirection)) !== null && _b !== void 0 ? _b : ReadingDirection.L2R;
    };
    /**
     * Returns the page scaling option that the PDF reader should select when the
     * print dialog is displayed.
     * @returns The page scaling option.
     */ ViewerPreferences.prototype.getPrintScaling = function() {
        var _a, _b;
        var scaling = (_a = this.PrintScaling()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(scaling, PrintScaling)) !== null && _b !== void 0 ? _b : PrintScaling.AppDefault;
    };
    /**
     * Returns the paper handling option that should be used when printing the
     * file from the print dialog.
     * @returns The paper handling option.
     */ ViewerPreferences.prototype.getDuplex = function() {
        var _a;
        var duplex = (_a = this.Duplex()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return asEnum(duplex, Duplex);
    };
    /**
     * Returns `true` if the PDF page size should be used to select the input
     * paper tray.
     * @returns Whether or not the PDF page size should be used to select the
     *          input paper tray.
     */ ViewerPreferences.prototype.getPickTrayByPDFSize = function() {
        var _a;
        return (_a = this.PickTrayByPDFSize()) === null || _a === void 0 ? void 0 : _a.asBoolean();
    };
    /**
     * Returns an array of page number ranges, which are the values used to
     * initialize the print dialog box when the file is printed. Each range
     * specifies the first (`start`) and last (`end`) pages in a sub-range of
     * pages to be printed. The first page of the PDF file is denoted by 0.
     * For example:
     * ```js
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * const includesPage3 = viewerPrefs
     *   .getPrintRanges()
     *   .some(pr => pr.start =< 2 && pr.end >= 2)
     * if (includesPage3) console.log('printRange includes page 3')
     * ```
     * @returns An array of objects, each with the properties `start` and `end`,
     *          denoting page indices. If not, specified an empty array is
     *          returned.
     */ ViewerPreferences.prototype.getPrintPageRange = function() {
        var rng = this.PrintPageRange();
        if (!rng) return [];
        var pageRanges = [];
        for(var i = 0; i < rng.size(); i += 2){
            // Despite the spec clearly stating that "The first page of the PDF file
            // shall be donoted by 1", several test PDFs (spec 1.7) created in
            // Acrobat XI 11.0 and also read with Reader DC 2020.013 indicate this is
            // actually a 0 based index.
            var start = rng.lookup(i, (0, $j04jt.default)).asNumber();
            var end = rng.lookup(i + 1, (0, $j04jt.default)).asNumber();
            pageRanges.push({
                start: start,
                end: end
            });
        }
        return pageRanges;
    };
    /**
     * Returns the number of copies to be printed when the print dialog is opened
     * for this document.
     * @returns The default number of copies to be printed.
     */ ViewerPreferences.prototype.getNumCopies = function() {
        var _a, _b;
        return (_b = (_a = this.NumCopies()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 1;
    };
    /**
     * Choose whether the PDF reader's toolbars should be hidden while the
     * document is active.
     * @param hideToolbar `true` if the toolbar should be hidden.
     */ ViewerPreferences.prototype.setHideToolbar = function(hideToolbar) {
        var HideToolbar = this.dict.context.obj(hideToolbar);
        this.dict.set((0, $dPHSK.default).of('HideToolbar'), HideToolbar);
    };
    /**
     * Choose whether the PDF reader's menu bar should be hidden while the
     * document is active.
     * @param hideMenubar `true` if the menu bar should be hidden.
     */ ViewerPreferences.prototype.setHideMenubar = function(hideMenubar) {
        var HideMenubar = this.dict.context.obj(hideMenubar);
        this.dict.set((0, $dPHSK.default).of('HideMenubar'), HideMenubar);
    };
    /**
     * Choose whether the PDF reader should hide user interface elements in the
     * document's window (such as scroll bars and navigation controls), leaving
     * only the document's contents displayed.
     * @param hideWindowUI `true` if the user interface elements should be hidden.
     */ ViewerPreferences.prototype.setHideWindowUI = function(hideWindowUI) {
        var HideWindowUI = this.dict.context.obj(hideWindowUI);
        this.dict.set((0, $dPHSK.default).of('HideWindowUI'), HideWindowUI);
    };
    /**
     * Choose whether the PDF reader should resize the document's window to fit
     * the size of the first displayed page.
     * @param fitWindow `true` if the window should be resized.
     */ ViewerPreferences.prototype.setFitWindow = function(fitWindow) {
        var FitWindow = this.dict.context.obj(fitWindow);
        this.dict.set((0, $dPHSK.default).of('FitWindow'), FitWindow);
    };
    /**
     * Choose whether the PDF reader should position the document's window in the
     * center of the screen.
     * @param centerWindow `true` if the window should be centered.
     */ ViewerPreferences.prototype.setCenterWindow = function(centerWindow) {
        var CenterWindow = this.dict.context.obj(centerWindow);
        this.dict.set((0, $dPHSK.default).of('CenterWindow'), CenterWindow);
    };
    /**
     * Choose whether the window's title bar should display the document `Title`
     * taken from the document metadata (see [[PDFDocument.setTitle]]). If
     * `false`, the title bar should instead display the PDF filename.
     * @param displayTitle `true` if the document title should be displayed.
     */ ViewerPreferences.prototype.setDisplayDocTitle = function(displayTitle) {
        var DisplayDocTitle = this.dict.context.obj(displayTitle);
        this.dict.set((0, $dPHSK.default).of('DisplayDocTitle'), DisplayDocTitle);
    };
    /**
     * Choose how the PDF reader should display the document upon exiting
     * full-screen mode. This entry is meaningful only if the value of the
     * `PageMode` entry in the document's [[PDFCatalog]] is `FullScreen`.
     *
     * For example:
     * ```js
     * import { PDFDocument, NonFullScreenPageMode, PDFName } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     *
     * // Set the PageMode
     * pdfDoc.catalog.set(PDFName.of('PageMode'),PDFName.of('FullScreen'))
     *
     * // Set what happens when full-screen is closed
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setNonFullScreenPageMode(NonFullScreenPageMode.UseOutlines)
     * ```
     *
     * @param nonFullScreenPageMode How the document should be displayed upon
     *                              exiting full screen mode.
     */ ViewerPreferences.prototype.setNonFullScreenPageMode = function(nonFullScreenPageMode) {
        (0, $j0tvB.assertIsOneOf)(nonFullScreenPageMode, 'nonFullScreenPageMode', NonFullScreenPageMode);
        var mode = (0, $dPHSK.default).of(nonFullScreenPageMode);
        this.dict.set((0, $dPHSK.default).of('NonFullScreenPageMode'), mode);
    };
    /**
     * Choose the predominant reading order for text.
     *
     * This entry has no direct effect on the document's contents or page
     * numbering, but may be used to determine the relative positioning of pages
     * when displayed side by side or printed n-up.
     *
     * For example:
     * ```js
     * import { PDFDocument, ReadingDirection } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setReadingDirection(ReadingDirection.R2L)
     * ```
     *
     * @param readingDirection The reading order for text.
     */ ViewerPreferences.prototype.setReadingDirection = function(readingDirection) {
        (0, $j0tvB.assertIsOneOf)(readingDirection, 'readingDirection', ReadingDirection);
        var direction = (0, $dPHSK.default).of(readingDirection);
        this.dict.set((0, $dPHSK.default).of('Direction'), direction);
    };
    /**
     * Choose the page scaling option that should be selected when a print dialog
     * is displayed for this document.
     *
     * For example:
     * ```js
     * import { PDFDocument, PrintScaling } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setPrintScaling(PrintScaling.None)
     * ```
     *
     * @param printScaling The print scaling option.
     */ ViewerPreferences.prototype.setPrintScaling = function(printScaling) {
        (0, $j0tvB.assertIsOneOf)(printScaling, 'printScaling', PrintScaling);
        var scaling = (0, $dPHSK.default).of(printScaling);
        this.dict.set((0, $dPHSK.default).of('PrintScaling'), scaling);
    };
    /**
     * Choose the paper handling option that should be selected by default in the
     * print dialog.
     *
     * For example:
     * ```js
     * import { PDFDocument, Duplex } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setDuplex(Duplex.DuplexFlipShortEdge)
     * ```
     *
     * @param duplex The double or single sided printing option.
     */ ViewerPreferences.prototype.setDuplex = function(duplex) {
        (0, $j0tvB.assertIsOneOf)(duplex, 'duplex', Duplex);
        var dup = (0, $dPHSK.default).of(duplex);
        this.dict.set((0, $dPHSK.default).of('Duplex'), dup);
    };
    /**
     * Choose whether the PDF document's page size should be used to select the
     * input paper tray when printing. This setting influences only the preset
     * values used to populate the print dialog presented by a PDF reader.
     *
     * If PickTrayByPDFSize is true, the check box in the print dialog associated
     * with input paper tray should be checked. This setting has no effect on
     * operating systems that do not provide the ability to pick the input tray
     * by size.
     *
     * @param pickTrayByPDFSize `true` if the document's page size should be used
     *                          to select the input paper tray.
     */ ViewerPreferences.prototype.setPickTrayByPDFSize = function(pickTrayByPDFSize) {
        var PickTrayByPDFSize = this.dict.context.obj(pickTrayByPDFSize);
        this.dict.set((0, $dPHSK.default).of('PickTrayByPDFSize'), PickTrayByPDFSize);
    };
    /**
     * Choose the page numbers used to initialize the print dialog box when the
     * file is printed. The first page of the PDF file is denoted by 0.
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     *
     * // We can set the default print range to only the first page
     * viewerPrefs.setPrintPageRange({ start: 0, end: 0 })
     *
     * // Or we can supply noncontiguous ranges (e.g. pages 1, 3, and 5-7)
     * viewerPrefs.setPrintPageRange([
     *   { start: 0, end: 0 },
     *   { start: 2, end: 2 },
     *   { start: 4, end: 6 },
     * ])
     * ```
     *
     * @param printPageRange An object or array of objects, each with the
     *                       properties `start` and `end`, denoting a range of
     *                       page indices.
     */ ViewerPreferences.prototype.setPrintPageRange = function(printPageRange) {
        if (!Array.isArray(printPageRange)) printPageRange = [
            printPageRange
        ];
        var flatRange = [];
        for(var idx = 0, len = printPageRange.length; idx < len; idx++){
            flatRange.push(printPageRange[idx].start);
            flatRange.push(printPageRange[idx].end);
        }
        (0, $j0tvB.assertEachIs)(flatRange, 'printPageRange', [
            'number'
        ]);
        var pageRanges = this.dict.context.obj(flatRange);
        this.dict.set((0, $dPHSK.default).of('PrintPageRange'), pageRanges);
    };
    /**
     * Choose the default number of copies to be printed when the print dialog is
     * opened for this file.
     * @param numCopies The default number of copies.
     */ ViewerPreferences.prototype.setNumCopies = function(numCopies) {
        (0, $j0tvB.assertRange)(numCopies, 'numCopies', 1, Number.MAX_VALUE);
        (0, $j0tvB.assertInteger)(numCopies, 'numCopies');
        var NumCopies = this.dict.context.obj(numCopies);
        this.dict.set((0, $dPHSK.default).of('NumCopies'), NumCopies);
    };
    /** @ignore */ ViewerPreferences.fromDict = function(dict) {
        return new ViewerPreferences(dict);
    };
    /** @ignore */ ViewerPreferences.create = function(context) {
        var dict = context.obj({});
        return new ViewerPreferences(dict);
    };
    return ViewerPreferences;
}();
var $90a3375623cd9a5a$export$2e2bcd8739ae039 = ViewerPreferences;

});
parcelRegister("8auL6", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f271df805933107$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $j04jt = parcelRequire("j04jt");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");

var $nAWRe = parcelRequire("nAWRe");
var $5f271df805933107$var$PDFArray = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFArray, _super);
    function PDFArray(context) {
        var _this = _super.call(this) || this;
        _this.array = [];
        _this.context = context;
        return _this;
    }
    PDFArray.prototype.size = function() {
        return this.array.length;
    };
    PDFArray.prototype.push = function(object) {
        this.array.push(object);
    };
    PDFArray.prototype.insert = function(index, object) {
        this.array.splice(index, 0, object);
    };
    PDFArray.prototype.indexOf = function(object) {
        var index = this.array.indexOf(object);
        return index === -1 ? undefined : index;
    };
    PDFArray.prototype.remove = function(index) {
        this.array.splice(index, 1);
    };
    PDFArray.prototype.set = function(idx, object) {
        this.array[idx] = object;
    };
    PDFArray.prototype.get = function(index) {
        return this.array[index];
    };
    PDFArray.prototype.lookupMaybe = function(index) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        return (_a = this.context).lookupMaybe.apply(_a, (0, $cOQTW.__spreadArrays)([
            this.get(index)
        ], types));
    };
    PDFArray.prototype.lookup = function(index) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        return (_a = this.context).lookup.apply(_a, (0, $cOQTW.__spreadArrays)([
            this.get(index)
        ], types));
    };
    PDFArray.prototype.asRectangle = function() {
        if (this.size() !== 4) throw new (0, $nAWRe.PDFArrayIsNotRectangleError)(this.size());
        var lowerLeftX = this.lookup(0, (0, $j04jt.default)).asNumber();
        var lowerLeftY = this.lookup(1, (0, $j04jt.default)).asNumber();
        var upperRightX = this.lookup(2, (0, $j04jt.default)).asNumber();
        var upperRightY = this.lookup(3, (0, $j04jt.default)).asNumber();
        var x = lowerLeftX;
        var y = lowerLeftY;
        var width = upperRightX - lowerLeftX;
        var height = upperRightY - lowerLeftY;
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    };
    PDFArray.prototype.asArray = function() {
        return this.array.slice();
    };
    PDFArray.prototype.clone = function(context) {
        var clone = PDFArray.withContext(context || this.context);
        for(var idx = 0, len = this.size(); idx < len; idx++)clone.push(this.array[idx]);
        return clone;
    };
    PDFArray.prototype.toString = function() {
        var arrayString = '[ ';
        for(var idx = 0, len = this.size(); idx < len; idx++){
            arrayString += this.get(idx).toString();
            arrayString += ' ';
        }
        arrayString += ']';
        return arrayString;
    };
    PDFArray.prototype.sizeInBytes = function() {
        var size = 3;
        for(var idx = 0, len = this.size(); idx < len; idx++)size += this.get(idx).sizeInBytes() + 1;
        return size;
    };
    PDFArray.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).LeftSquareBracket;
        buffer[offset++] = (0, $8zvel.default).Space;
        for(var idx = 0, len = this.size(); idx < len; idx++){
            offset += this.get(idx).copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
        }
        buffer[offset++] = (0, $8zvel.default).RightSquareBracket;
        return offset - initialOffset;
    };
    PDFArray.prototype.scalePDFNumbers = function(x, y) {
        for(var idx = 0, len = this.size(); idx < len; idx++){
            var el = this.lookup(idx);
            if (el instanceof (0, $j04jt.default)) {
                var factor = idx % 2 === 0 ? x : y;
                this.set(idx, (0, $j04jt.default).of(el.asNumber() * factor));
            }
        }
    };
    PDFArray.withContext = function(context) {
        return new PDFArray(context);
    };
    return PDFArray;
}((0, $11c5J.default));
var $5f271df805933107$export$2e2bcd8739ae039 = $5f271df805933107$var$PDFArray;

});
parcelRegister("cOQTW", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $955330a26152f448$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $955330a26152f448$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $955330a26152f448$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $955330a26152f448$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $955330a26152f448$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__spreadArrays", () => $955330a26152f448$export$6388937ca91ccae8);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $955330a26152f448$var$extendStatics = function(d, b) {
    $955330a26152f448$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $955330a26152f448$var$extendStatics(d, b);
};
function $955330a26152f448$export$a8ba968b8961cb8a(d, b) {
    $955330a26152f448$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $955330a26152f448$export$18ce0697a983be9b = function() {
    $955330a26152f448$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $955330a26152f448$export$18ce0697a983be9b.apply(this, arguments);
};
function $955330a26152f448$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $955330a26152f448$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $955330a26152f448$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $955330a26152f448$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $955330a26152f448$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $955330a26152f448$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $955330a26152f448$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $955330a26152f448$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $955330a26152f448$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $955330a26152f448$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $955330a26152f448$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($955330a26152f448$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $955330a26152f448$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $955330a26152f448$export$10c90e4f7922046c(v) {
    return this instanceof $955330a26152f448$export$10c90e4f7922046c ? (this.v = v, this) : new $955330a26152f448$export$10c90e4f7922046c(v);
}
function $955330a26152f448$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $955330a26152f448$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $955330a26152f448$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $955330a26152f448$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $955330a26152f448$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $955330a26152f448$export$19a8beecd37a4c45 === "function" ? $955330a26152f448$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $955330a26152f448$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $955330a26152f448$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $955330a26152f448$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $955330a26152f448$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $955330a26152f448$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("j04jt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd515ce6ac431bbb$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $hiEdU = parcelRequire("hiEdU");

var $11c5J = parcelRequire("11c5J");
var $dd515ce6ac431bbb$var$PDFNumber = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFNumber, _super);
    function PDFNumber(value) {
        var _this = _super.call(this) || this;
        _this.numberValue = value;
        _this.stringValue = (0, $hiEdU.numberToString)(value);
        return _this;
    }
    PDFNumber.prototype.asNumber = function() {
        return this.numberValue;
    };
    /** @deprecated in favor of [[PDFNumber.asNumber]] */ PDFNumber.prototype.value = function() {
        return this.numberValue;
    };
    PDFNumber.prototype.clone = function() {
        return PDFNumber.of(this.numberValue);
    };
    PDFNumber.prototype.toString = function() {
        return this.stringValue;
    };
    PDFNumber.prototype.sizeInBytes = function() {
        return this.stringValue.length;
    };
    PDFNumber.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.stringValue, buffer, offset);
        return this.stringValue.length;
    };
    PDFNumber.of = function(value) {
        return new PDFNumber(value);
    };
    return PDFNumber;
}((0, $11c5J.default));
var $dd515ce6ac431bbb$export$2e2bcd8739ae039 = $dd515ce6ac431bbb$var$PDFNumber;

});
parcelRegister("fvYKZ", function(module, exports) {
$parcel$export(module.exports, "arrayAsString", () => (parcelRequire("4ISq8")).arrayAsString);
$parcel$export(module.exports, "byAscendingId", () => (parcelRequire("4ISq8")).byAscendingId);
$parcel$export(module.exports, "canBeConvertedToUint8Array", () => (parcelRequire("4ISq8")).canBeConvertedToUint8Array);
$parcel$export(module.exports, "last", () => (parcelRequire("4ISq8")).last);
$parcel$export(module.exports, "mergeIntoTypedArray", () => (parcelRequire("4ISq8")).mergeIntoTypedArray);
$parcel$export(module.exports, "mergeUint8Arrays", () => (parcelRequire("4ISq8")).mergeUint8Arrays);
$parcel$export(module.exports, "pluckIndices", () => (parcelRequire("4ISq8")).pluckIndices);
$parcel$export(module.exports, "range", () => (parcelRequire("4ISq8")).range);
$parcel$export(module.exports, "reverseArray", () => (parcelRequire("4ISq8")).reverseArray);
$parcel$export(module.exports, "sortedUniq", () => (parcelRequire("4ISq8")).sortedUniq);
$parcel$export(module.exports, "sum", () => (parcelRequire("4ISq8")).sum);
$parcel$export(module.exports, "toUint8Array", () => (parcelRequire("4ISq8")).toUint8Array);
$parcel$export(module.exports, "typedArrayFor", () => (parcelRequire("4ISq8")).typedArrayFor);
$parcel$export(module.exports, "waitForTick", () => (parcelRequire("ggjMi")).waitForTick);
$parcel$export(module.exports, "breakTextIntoLines", () => (parcelRequire("7Kmy8")).breakTextIntoLines);
$parcel$export(module.exports, "charAtIndex", () => (parcelRequire("7Kmy8")).charAtIndex);
$parcel$export(module.exports, "charFromCode", () => (parcelRequire("7Kmy8")).charFromCode);
$parcel$export(module.exports, "charFromHexCode", () => (parcelRequire("7Kmy8")).charFromHexCode);
$parcel$export(module.exports, "charSplit", () => (parcelRequire("7Kmy8")).charSplit);
$parcel$export(module.exports, "cleanText", () => (parcelRequire("7Kmy8")).cleanText);
$parcel$export(module.exports, "copyStringIntoBuffer", () => (parcelRequire("7Kmy8")).copyStringIntoBuffer);
$parcel$export(module.exports, "findLastMatch", () => (parcelRequire("7Kmy8")).findLastMatch);
$parcel$export(module.exports, "lineSplit", () => (parcelRequire("7Kmy8")).lineSplit);
$parcel$export(module.exports, "mergeLines", () => (parcelRequire("7Kmy8")).mergeLines);
$parcel$export(module.exports, "padStart", () => (parcelRequire("7Kmy8")).padStart);
$parcel$export(module.exports, "parseDate", () => (parcelRequire("7Kmy8")).parseDate);
$parcel$export(module.exports, "toCharCode", () => (parcelRequire("7Kmy8")).toCharCode);
$parcel$export(module.exports, "toCodePoint", () => (parcelRequire("7Kmy8")).toCodePoint);
$parcel$export(module.exports, "toHexString", () => (parcelRequire("7Kmy8")).toHexString);
$parcel$export(module.exports, "toHexStringOfMinLength", () => (parcelRequire("7Kmy8")).toHexStringOfMinLength);
$parcel$export(module.exports, "hasUtf16BOM", () => (parcelRequire("ejAvl")).hasUtf16BOM);
$parcel$export(module.exports, "utf16Decode", () => (parcelRequire("ejAvl")).utf16Decode);
$parcel$export(module.exports, "utf16Encode", () => (parcelRequire("ejAvl")).utf16Encode);
$parcel$export(module.exports, "bytesFor", () => (parcelRequire("hiEdU")).bytesFor);
$parcel$export(module.exports, "numberToString", () => (parcelRequire("hiEdU")).numberToString);
$parcel$export(module.exports, "sizeInBytes", () => (parcelRequire("hiEdU")).sizeInBytes);
$parcel$export(module.exports, "error", () => (parcelRequire("hP0hy")).error);
$parcel$export(module.exports, "encodeToBase64", () => (parcelRequire("fZ8o5")).encodeToBase64);
$parcel$export(module.exports, "isStandardFont", () => (parcelRequire("cbIAG")).isStandardFont);
$parcel$export(module.exports, "rectanglesAreEqual", () => (parcelRequire("cbIAG")).rectanglesAreEqual);
$parcel$export(module.exports, "assertEachIs", () => (parcelRequire("j0tvB")).assertEachIs);
$parcel$export(module.exports, "assertInteger", () => (parcelRequire("j0tvB")).assertInteger);
$parcel$export(module.exports, "assertIs", () => (parcelRequire("j0tvB")).assertIs);
$parcel$export(module.exports, "assertIsOneOf", () => (parcelRequire("j0tvB")).assertIsOneOf);
$parcel$export(module.exports, "assertIsOneOfOrUndefined", () => (parcelRequire("j0tvB")).assertIsOneOfOrUndefined);
$parcel$export(module.exports, "assertIsSubset", () => (parcelRequire("j0tvB")).assertIsSubset);
$parcel$export(module.exports, "assertMultiple", () => (parcelRequire("j0tvB")).assertMultiple);
$parcel$export(module.exports, "assertOrUndefined", () => (parcelRequire("j0tvB")).assertOrUndefined);
$parcel$export(module.exports, "assertPositive", () => (parcelRequire("j0tvB")).assertPositive);
$parcel$export(module.exports, "assertRange", () => (parcelRequire("j0tvB")).assertRange);
$parcel$export(module.exports, "assertRangeOrUndefined", () => (parcelRequire("j0tvB")).assertRangeOrUndefined);
$parcel$export(module.exports, "pdfDocEncodingDecode", () => (parcelRequire("iSBb0")).pdfDocEncodingDecode);

$parcel$export(module.exports, "Cache", () => (parcelRequire("clYSv")).default);
parcelRequire("4ISq8");
parcelRequire("ggjMi");
parcelRequire("7Kmy8");
parcelRequire("ejAvl");
parcelRequire("hiEdU");
parcelRequire("hP0hy");
parcelRequire("fZ8o5");
parcelRequire("cbIAG");
parcelRequire("j0tvB");
parcelRequire("iSBb0");

var $clYSv = parcelRequire("clYSv");

});
parcelRegister("4ISq8", function(module, exports) {

$parcel$export(module.exports, "last", () => $37057c446bb711eb$export$4c7897fafd92b108);
$parcel$export(module.exports, "typedArrayFor", () => $37057c446bb711eb$export$98b44e66722b6f4d);
$parcel$export(module.exports, "mergeIntoTypedArray", () => $37057c446bb711eb$export$8907b5381cbcd9a7);
$parcel$export(module.exports, "mergeUint8Arrays", () => $37057c446bb711eb$export$99cee7ee2de7e6e4);
$parcel$export(module.exports, "arrayAsString", () => $37057c446bb711eb$export$5f8f9664fe5c5f14);
$parcel$export(module.exports, "byAscendingId", () => $37057c446bb711eb$export$55b6b1f56c6e1ba5);
$parcel$export(module.exports, "sortedUniq", () => $37057c446bb711eb$export$720e3b5aefb27114);
$parcel$export(module.exports, "reverseArray", () => $37057c446bb711eb$export$c9b97e771c4a8302);
$parcel$export(module.exports, "sum", () => $37057c446bb711eb$export$8a63f25cc62965f1);
$parcel$export(module.exports, "range", () => $37057c446bb711eb$export$d02631cccf789723);
$parcel$export(module.exports, "pluckIndices", () => $37057c446bb711eb$export$279d041ff3481d88);
$parcel$export(module.exports, "canBeConvertedToUint8Array", () => $37057c446bb711eb$export$20e9c5ed92218c4b);
$parcel$export(module.exports, "toUint8Array", () => $37057c446bb711eb$export$73470fd2221e6aef);

var $fZ8o5 = parcelRequire("fZ8o5");

var $7Kmy8 = parcelRequire("7Kmy8");
var $37057c446bb711eb$export$4c7897fafd92b108 = function(array) {
    return array[array.length - 1];
};
var $37057c446bb711eb$export$98b44e66722b6f4d = function(value) {
    if (value instanceof Uint8Array) return value;
    var length = value.length;
    var typedArray = new Uint8Array(length);
    for(var idx = 0; idx < length; idx++)typedArray[idx] = value.charCodeAt(idx);
    return typedArray;
};
var $37057c446bb711eb$export$8907b5381cbcd9a7 = function() {
    var arrays = [];
    for(var _i = 0; _i < arguments.length; _i++)arrays[_i] = arguments[_i];
    var arrayCount = arrays.length;
    var typedArrays = [];
    for(var idx = 0; idx < arrayCount; idx++){
        var element = arrays[idx];
        typedArrays[idx] = element instanceof Uint8Array ? element : $37057c446bb711eb$export$98b44e66722b6f4d(element);
    }
    var totalSize = 0;
    for(var idx = 0; idx < arrayCount; idx++)totalSize += arrays[idx].length;
    var merged = new Uint8Array(totalSize);
    var offset = 0;
    for(var arrIdx = 0; arrIdx < arrayCount; arrIdx++){
        var arr = typedArrays[arrIdx];
        for(var byteIdx = 0, arrLen = arr.length; byteIdx < arrLen; byteIdx++)merged[offset++] = arr[byteIdx];
    }
    return merged;
};
var $37057c446bb711eb$export$99cee7ee2de7e6e4 = function(arrays) {
    var totalSize = 0;
    for(var idx = 0, len = arrays.length; idx < len; idx++)totalSize += arrays[idx].length;
    var mergedBuffer = new Uint8Array(totalSize);
    var offset = 0;
    for(var idx = 0, len = arrays.length; idx < len; idx++){
        var array = arrays[idx];
        mergedBuffer.set(array, offset);
        offset += array.length;
    }
    return mergedBuffer;
};
var $37057c446bb711eb$export$5f8f9664fe5c5f14 = function(array) {
    var str = '';
    for(var idx = 0, len = array.length; idx < len; idx++)str += (0, $7Kmy8.charFromCode)(array[idx]);
    return str;
};
var $37057c446bb711eb$export$55b6b1f56c6e1ba5 = function(a, b) {
    return a.id - b.id;
};
var $37057c446bb711eb$export$720e3b5aefb27114 = function(array, indexer) {
    var uniq = [];
    for(var idx = 0, len = array.length; idx < len; idx++){
        var curr = array[idx];
        var prev = array[idx - 1];
        if (idx === 0 || indexer(curr) !== indexer(prev)) uniq.push(curr);
    }
    return uniq;
};
var $37057c446bb711eb$export$c9b97e771c4a8302 = function(array) {
    var arrayLen = array.length;
    for(var idx = 0, len = Math.floor(arrayLen / 2); idx < len; idx++){
        var leftIdx = idx;
        var rightIdx = arrayLen - idx - 1;
        var temp = array[idx];
        array[leftIdx] = array[rightIdx];
        array[rightIdx] = temp;
    }
    return array;
};
var $37057c446bb711eb$export$8a63f25cc62965f1 = function(array) {
    var total = 0;
    for(var idx = 0, len = array.length; idx < len; idx++)total += array[idx];
    return total;
};
var $37057c446bb711eb$export$d02631cccf789723 = function(start, end) {
    var arr = new Array(end - start);
    for(var idx = 0, len = arr.length; idx < len; idx++)arr[idx] = start + idx;
    return arr;
};
var $37057c446bb711eb$export$279d041ff3481d88 = function(arr, indices) {
    var plucked = new Array(indices.length);
    for(var idx = 0, len = indices.length; idx < len; idx++)plucked[idx] = arr[indices[idx]];
    return plucked;
};
var $37057c446bb711eb$export$20e9c5ed92218c4b = function(input) {
    return input instanceof Uint8Array || input instanceof ArrayBuffer || typeof input === 'string';
};
var $37057c446bb711eb$export$73470fd2221e6aef = function(input) {
    if (typeof input === 'string') return (0, $fZ8o5.decodeFromBase64DataUri)(input);
    else if (input instanceof ArrayBuffer) return new Uint8Array(input);
    else if (input instanceof Uint8Array) return input;
    else throw new TypeError('`input` must be one of `string | ArrayBuffer | Uint8Array`');
};

});
parcelRegister("fZ8o5", function(module, exports) {

$parcel$export(module.exports, "encodeToBase64", () => $ba330f1ee33d4a3b$export$373f4c3083978ffd);
$parcel$export(module.exports, "decodeFromBase64DataUri", () => $ba330f1ee33d4a3b$export$f6810f5086699d73);
/*
 * The `chars`, `lookup`, `encode`, and `decode` members of this file are
 * licensed under the following:
 *
 *     base64-arraybuffer
 *     https://github.com/niklasvh/base64-arraybuffer
 *
 *     Copyright (c) 2012 Niklas von Hertzen
 *     Licensed under the MIT license.
 *
 */ var $ba330f1ee33d4a3b$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $ba330f1ee33d4a3b$var$lookup = new Uint8Array(256);
for(var $ba330f1ee33d4a3b$var$i = 0; $ba330f1ee33d4a3b$var$i < $ba330f1ee33d4a3b$var$chars.length; $ba330f1ee33d4a3b$var$i++)$ba330f1ee33d4a3b$var$lookup[$ba330f1ee33d4a3b$var$chars.charCodeAt($ba330f1ee33d4a3b$var$i)] = $ba330f1ee33d4a3b$var$i;
var $ba330f1ee33d4a3b$export$373f4c3083978ffd = function(bytes) {
    var base64 = '';
    var len = bytes.length;
    for(var i = 0; i < len; i += 3){
        base64 += $ba330f1ee33d4a3b$var$chars[bytes[i] >> 2];
        base64 += $ba330f1ee33d4a3b$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $ba330f1ee33d4a3b$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $ba330f1ee33d4a3b$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
var $ba330f1ee33d4a3b$export$83edfd8fcc66ec17 = function(base64) {
    var bufferLength = base64.length * 0.75;
    var len = base64.length;
    var i;
    var p = 0;
    var encoded1;
    var encoded2;
    var encoded3;
    var encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    var bytes = new Uint8Array(bufferLength);
    for(i = 0; i < len; i += 4){
        encoded1 = $ba330f1ee33d4a3b$var$lookup[base64.charCodeAt(i)];
        encoded2 = $ba330f1ee33d4a3b$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $ba330f1ee33d4a3b$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $ba330f1ee33d4a3b$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
};
// This regex is designed to be as flexible as possible. It will parse certain
// invalid data URIs.
var $ba330f1ee33d4a3b$var$DATA_URI_PREFIX_REGEX = /^(data)?:?([\w\/\+]+)?;?(charset=[\w-]+|base64)?.*,/i;
var $ba330f1ee33d4a3b$export$f6810f5086699d73 = function(dataUri) {
    var trimmedUri = dataUri.trim();
    var prefix = trimmedUri.substring(0, 100);
    var res = prefix.match($ba330f1ee33d4a3b$var$DATA_URI_PREFIX_REGEX);
    // Assume it's not a data URI - just a plain base64 string
    if (!res) return $ba330f1ee33d4a3b$export$83edfd8fcc66ec17(trimmedUri);
    // Remove the data URI prefix and parse the remainder as a base64 string
    var fullMatch = res[0];
    var data = trimmedUri.substring(fullMatch.length);
    return $ba330f1ee33d4a3b$export$83edfd8fcc66ec17(data);
};

});

parcelRegister("7Kmy8", function(module, exports) {

$parcel$export(module.exports, "toCharCode", () => $5a3e522cca792aad$export$d90166409dd04e85);
$parcel$export(module.exports, "toCodePoint", () => $5a3e522cca792aad$export$93bf578f015d73f0);
$parcel$export(module.exports, "toHexStringOfMinLength", () => $5a3e522cca792aad$export$6ac97d2d1bf41f39);
$parcel$export(module.exports, "padStart", () => $5a3e522cca792aad$export$36cf564d487b5178);
$parcel$export(module.exports, "toHexString", () => $5a3e522cca792aad$export$f4915efbb94d4d01);
$parcel$export(module.exports, "charFromCode", () => $5a3e522cca792aad$export$207031940e6950ad);
$parcel$export(module.exports, "charFromHexCode", () => $5a3e522cca792aad$export$ceedd1b69dcde7a5);
$parcel$export(module.exports, "copyStringIntoBuffer", () => $5a3e522cca792aad$export$c41a03555c37a984);
$parcel$export(module.exports, "cleanText", () => $5a3e522cca792aad$export$6b5e57d20078142b);
$parcel$export(module.exports, "lineSplit", () => $5a3e522cca792aad$export$4f60280859794d8c);
$parcel$export(module.exports, "mergeLines", () => $5a3e522cca792aad$export$b5bf5e120f07cbe);
$parcel$export(module.exports, "charAtIndex", () => $5a3e522cca792aad$export$1a93fc5af577aa5c);
$parcel$export(module.exports, "charSplit", () => $5a3e522cca792aad$export$78f5a8ab9b5e7f1e);
$parcel$export(module.exports, "breakTextIntoLines", () => $5a3e522cca792aad$export$38936f7739928807);
$parcel$export(module.exports, "parseDate", () => $5a3e522cca792aad$export$6b862160d295c8e);
$parcel$export(module.exports, "findLastMatch", () => $5a3e522cca792aad$export$dc1d7d42f51764e3);
var $5a3e522cca792aad$export$d90166409dd04e85 = function(character) {
    return character.charCodeAt(0);
};
var $5a3e522cca792aad$export$93bf578f015d73f0 = function(character) {
    return character.codePointAt(0);
};
var $5a3e522cca792aad$export$6ac97d2d1bf41f39 = function(num, minLength) {
    return $5a3e522cca792aad$export$36cf564d487b5178(num.toString(16), minLength, '0').toUpperCase();
};
var $5a3e522cca792aad$export$f4915efbb94d4d01 = function(num) {
    return $5a3e522cca792aad$export$6ac97d2d1bf41f39(num, 2);
};
var $5a3e522cca792aad$export$207031940e6950ad = function(code) {
    return String.fromCharCode(code);
};
var $5a3e522cca792aad$export$ceedd1b69dcde7a5 = function(hex) {
    return $5a3e522cca792aad$export$207031940e6950ad(parseInt(hex, 16));
};
var $5a3e522cca792aad$export$36cf564d487b5178 = function(value, length, padChar) {
    var padding = '';
    for(var idx = 0, len = length - value.length; idx < len; idx++)padding += padChar;
    return padding + value;
};
var $5a3e522cca792aad$export$c41a03555c37a984 = function(str, buffer, offset) {
    var length = str.length;
    for(var idx = 0; idx < length; idx++)buffer[offset++] = str.charCodeAt(idx);
    return length;
};
var $5a3e522cca792aad$export$505d8f7c00d806ca = function(prefix, suffixLength) {
    if (suffixLength === void 0) suffixLength = 4;
    return prefix + "-" + Math.floor(Math.random() * Math.pow(10, suffixLength));
};
var $5a3e522cca792aad$export$7c57da42ce8e346f = function(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
var $5a3e522cca792aad$export$6b5e57d20078142b = function(text) {
    return text.replace(/\t|\u0085|\u2028|\u2029/g, '    ').replace(/[\b\v]/g, '');
};
var $5a3e522cca792aad$export$60bd2eb6e5a75df0 = [
    '\\n',
    '\\f',
    '\\r',
    '\\u000B'
];
var $5a3e522cca792aad$export$634cc0013ed0f624 = [
    '\n',
    '\f',
    '\r',
    '\u000B'
];
var $5a3e522cca792aad$export$3fc8feceeed3beb0 = function(text) {
    return /^[\n\f\r\u000B]$/.test(text);
};
var $5a3e522cca792aad$export$4f60280859794d8c = function(text) {
    return text.split(/[\n\f\r\u000B]/);
};
var $5a3e522cca792aad$export$b5bf5e120f07cbe = function(text) {
    return text.replace(/[\n\f\r\u000B]/g, ' ');
};
var $5a3e522cca792aad$export$1a93fc5af577aa5c = function(text, index) {
    // Get the first code unit and code unit value
    var cuFirst = text.charCodeAt(index);
    var cuSecond;
    var nextIndex = index + 1;
    var length = 1;
    if (// Check if it's the start of a surrogate pair.
    cuFirst >= 0xd800 && cuFirst <= 0xdbff && // high surrogate
    text.length > nextIndex // there is a next code unit
    ) {
        cuSecond = text.charCodeAt(nextIndex);
        if (cuSecond >= 0xdc00 && cuSecond <= 0xdfff) length = 2; // low surrogate
    }
    return [
        text.slice(index, index + length),
        length
    ];
};
var $5a3e522cca792aad$export$78f5a8ab9b5e7f1e = function(text) {
    var chars = [];
    for(var idx = 0, len = text.length; idx < len;){
        var _a = $5a3e522cca792aad$export$1a93fc5af577aa5c(text, idx), c = _a[0], cLen = _a[1];
        chars.push(c);
        idx += cLen;
    }
    return chars;
};
var $5a3e522cca792aad$var$buildWordBreakRegex = function(wordBreaks) {
    var newlineCharUnion = $5a3e522cca792aad$export$60bd2eb6e5a75df0.join('|');
    var escapedRules = [
        '$'
    ];
    for(var idx = 0, len = wordBreaks.length; idx < len; idx++){
        var wordBreak = wordBreaks[idx];
        if ($5a3e522cca792aad$export$3fc8feceeed3beb0(wordBreak)) throw new TypeError("`wordBreak` must not include " + newlineCharUnion);
        escapedRules.push(wordBreak === '' ? '.' : $5a3e522cca792aad$export$7c57da42ce8e346f(wordBreak));
    }
    var breakRules = escapedRules.join('|');
    return new RegExp("(" + newlineCharUnion + ")|((.*?)(" + breakRules + "))", 'gm');
};
var $5a3e522cca792aad$export$38936f7739928807 = function(text, wordBreaks, maxWidth, computeWidthOfText) {
    var regex = $5a3e522cca792aad$var$buildWordBreakRegex(wordBreaks);
    var words = $5a3e522cca792aad$export$6b5e57d20078142b(text).match(regex);
    var currLine = '';
    var currWidth = 0;
    var lines = [];
    var pushCurrLine = function() {
        if (currLine !== '') lines.push(currLine);
        currLine = '';
        currWidth = 0;
    };
    for(var idx = 0, len = words.length; idx < len; idx++){
        var word = words[idx];
        if ($5a3e522cca792aad$export$3fc8feceeed3beb0(word)) pushCurrLine();
        else {
            var width = computeWidthOfText(word);
            if (currWidth + width > maxWidth) pushCurrLine();
            currLine += word;
            currWidth += width;
        }
    }
    pushCurrLine();
    return lines;
};
// See section "7.9.4 Dates" of the PDF specification
var $5a3e522cca792aad$var$dateRegex = /^D:(\d\d\d\d)(\d\d)?(\d\d)?(\d\d)?(\d\d)?(\d\d)?([+\-Z])?(\d\d)?'?(\d\d)?'?$/;
var $5a3e522cca792aad$export$6b862160d295c8e = function(dateStr) {
    var match = dateStr.match($5a3e522cca792aad$var$dateRegex);
    if (!match) return undefined;
    var year = match[1], _a = match[2], month = _a === void 0 ? '01' : _a, _b = match[3], day = _b === void 0 ? '01' : _b, _c = match[4], hours = _c === void 0 ? '00' : _c, _d = match[5], mins = _d === void 0 ? '00' : _d, _e = match[6], secs = _e === void 0 ? '00' : _e, _f = match[7], offsetSign = _f === void 0 ? 'Z' : _f, _g = match[8], offsetHours = _g === void 0 ? '00' : _g, _h = match[9], offsetMins = _h === void 0 ? '00' : _h;
    // http://www.ecma-international.org/ecma-262/5.1/#sec-15.9.1.15
    var tzOffset = offsetSign === 'Z' ? 'Z' : "" + offsetSign + offsetHours + ":" + offsetMins;
    var date = new Date(year + "-" + month + "-" + day + "T" + hours + ":" + mins + ":" + secs + tzOffset);
    return date;
};
var $5a3e522cca792aad$export$dc1d7d42f51764e3 = function(value, regex) {
    var _a;
    var position = 0;
    var lastMatch;
    while(position < value.length){
        var match = value.substring(position).match(regex);
        if (!match) return {
            match: lastMatch,
            pos: position
        };
        lastMatch = match;
        position += ((_a = match.index) !== null && _a !== void 0 ? _a : 0) + match[0].length;
    }
    return {
        match: lastMatch,
        pos: position
    };
};

});


parcelRegister("ggjMi", function(module, exports) {

$parcel$export(module.exports, "waitForTick", () => $bd6d7b74aa8160e5$export$3b7198a3beef1a5f);
/**
 * Returns a Promise that resolves after at least one tick of the
 * Macro Task Queue occurs.
 */ var $bd6d7b74aa8160e5$export$3b7198a3beef1a5f = function() {
    return new Promise(function(resolve) {
        setTimeout(function() {
            return resolve();
        }, 0);
    });
};

});

parcelRegister("ejAvl", function(module, exports) {

$parcel$export(module.exports, "utf16Encode", () => $a6bf2813aae3d0a0$export$73704d2337848c8e);
$parcel$export(module.exports, "highSurrogate", () => $a6bf2813aae3d0a0$export$8d3bd4086f36eaeb);
$parcel$export(module.exports, "lowSurrogate", () => $a6bf2813aae3d0a0$export$382051c72943492d);
$parcel$export(module.exports, "isWithinBMP", () => $a6bf2813aae3d0a0$export$919ae47c3852aa15);
$parcel$export(module.exports, "hasSurrogates", () => $a6bf2813aae3d0a0$export$d5ab89e7561b44ab);
$parcel$export(module.exports, "utf16Decode", () => $a6bf2813aae3d0a0$export$b89f54f9db637f79);
$parcel$export(module.exports, "hasUtf16BOM", () => $a6bf2813aae3d0a0$export$41e7c15c75b1b24d);

var $7Kmy8 = parcelRequire("7Kmy8");
var $a6bf2813aae3d0a0$export$e1b32e613f230dc6 = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    var encoded = [];
    if (byteOrderMark) encoded.push(0xef, 0xbb, 0xbf);
    for(var idx = 0, len = input.length; idx < len;){
        var codePoint = input.codePointAt(idx);
        // One byte encoding
        if (codePoint < 0x80) {
            var byte1 = codePoint & 0x7f;
            encoded.push(byte1);
            idx += 1;
        } else if (codePoint < 0x0800) {
            var byte1 = codePoint >> 6 & 0x1f | 0xc0;
            var byte2 = codePoint & 0x3f | 0x80;
            encoded.push(byte1, byte2);
            idx += 1;
        } else if (codePoint < 0x010000) {
            var byte1 = codePoint >> 12 & 0x0f | 0xe0;
            var byte2 = codePoint >> 6 & 0x3f | 0x80;
            var byte3 = codePoint & 0x3f | 0x80;
            encoded.push(byte1, byte2, byte3);
            idx += 1;
        } else if (codePoint < 0x110000) {
            var byte1 = codePoint >> 18 & 0x07 | 0xf0;
            var byte2 = codePoint >> 12 & 0x3f | 0x80;
            var byte3 = codePoint >> 6 & 0x3f | 0x80;
            var byte4 = codePoint >> 0 & 0x3f | 0x80;
            encoded.push(byte1, byte2, byte3, byte4);
            idx += 2;
        } else throw new Error("Invalid code point: 0x" + (0, $7Kmy8.toHexString)(codePoint));
    }
    return new Uint8Array(encoded);
};
var $a6bf2813aae3d0a0$export$73704d2337848c8e = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    var encoded = [];
    if (byteOrderMark) encoded.push(0xfeff);
    for(var idx = 0, len = input.length; idx < len;){
        var codePoint = input.codePointAt(idx);
        // Two byte encoding
        if (codePoint < 0x010000) {
            encoded.push(codePoint);
            idx += 1;
        } else if (codePoint < 0x110000) {
            encoded.push($a6bf2813aae3d0a0$export$8d3bd4086f36eaeb(codePoint), $a6bf2813aae3d0a0$export$382051c72943492d(codePoint));
            idx += 2;
        } else throw new Error("Invalid code point: 0x" + (0, $7Kmy8.toHexString)(codePoint));
    }
    return new Uint16Array(encoded);
};
var $a6bf2813aae3d0a0$export$919ae47c3852aa15 = function(codePoint) {
    return codePoint >= 0 && codePoint <= 0xffff;
};
var $a6bf2813aae3d0a0$export$d5ab89e7561b44ab = function(codePoint) {
    return codePoint >= 0x010000 && codePoint <= 0x10ffff;
};
var $a6bf2813aae3d0a0$export$8d3bd4086f36eaeb = function(codePoint) {
    return Math.floor((codePoint - 0x10000) / 0x400) + 0xd800;
};
var $a6bf2813aae3d0a0$export$382051c72943492d = function(codePoint) {
    return (codePoint - 0x10000) % 0x400 + 0xdc00;
};
var $a6bf2813aae3d0a0$var$ByteOrder;
(function(ByteOrder) {
    ByteOrder["BigEndian"] = "BigEndian";
    ByteOrder["LittleEndian"] = "LittleEndian";
})($a6bf2813aae3d0a0$var$ByteOrder || ($a6bf2813aae3d0a0$var$ByteOrder = {}));
var $a6bf2813aae3d0a0$var$REPLACEMENT = "\uFFFD".codePointAt(0);
var $a6bf2813aae3d0a0$export$b89f54f9db637f79 = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    // Need at least 2 bytes of data in UTF-16 encodings
    if (input.length <= 1) return String.fromCodePoint($a6bf2813aae3d0a0$var$REPLACEMENT);
    var byteOrder = byteOrderMark ? $a6bf2813aae3d0a0$var$readBOM(input) : $a6bf2813aae3d0a0$var$ByteOrder.BigEndian;
    // Skip byte order mark if needed
    var idx = byteOrderMark ? 2 : 0;
    var codePoints = [];
    while(input.length - idx >= 2){
        var first = $a6bf2813aae3d0a0$var$decodeValues(input[idx++], input[idx++], byteOrder);
        if ($a6bf2813aae3d0a0$var$isHighSurrogate(first)) {
            if (input.length - idx < 2) // Need at least 2 bytes left for the low surrogate that is required
            codePoints.push($a6bf2813aae3d0a0$var$REPLACEMENT);
            else {
                var second = $a6bf2813aae3d0a0$var$decodeValues(input[idx++], input[idx++], byteOrder);
                if ($a6bf2813aae3d0a0$var$isLowSurrogate(second)) codePoints.push(first, second);
                else // Low surrogates should always follow high surrogates
                codePoints.push($a6bf2813aae3d0a0$var$REPLACEMENT);
            }
        } else if ($a6bf2813aae3d0a0$var$isLowSurrogate(first)) {
            // High surrogates should always come first since `decodeValues()`
            // accounts for the byte ordering
            idx += 2;
            codePoints.push($a6bf2813aae3d0a0$var$REPLACEMENT);
        } else codePoints.push(first);
    }
    // There shouldn't be extra byte(s) left over
    if (idx < input.length) codePoints.push($a6bf2813aae3d0a0$var$REPLACEMENT);
    return String.fromCodePoint.apply(String, codePoints);
};
/**
 * Returns `true` if the given `codePoint` is a high surrogate.
 * @param codePoint The code point to be evaluated.
 *
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Description
 */ var $a6bf2813aae3d0a0$var$isHighSurrogate = function(codePoint) {
    return codePoint >= 0xd800 && codePoint <= 0xdbff;
};
/**
 * Returns `true` if the given `codePoint` is a low surrogate.
 * @param codePoint The code point to be evaluated.
 *
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Description
 */ var $a6bf2813aae3d0a0$var$isLowSurrogate = function(codePoint) {
    return codePoint >= 0xdc00 && codePoint <= 0xdfff;
};
/**
 * Decodes the given utf-16 values first and second using the specified
 * byte order.
 * @param first The first byte of the encoding.
 * @param second The second byte of the encoding.
 * @param byteOrder The byte order of the encoding.
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Examples
 */ var $a6bf2813aae3d0a0$var$decodeValues = function(first, second, byteOrder) {
    // Append the binary representation of the preceding byte by shifting the
    // first one 8 to the left and than applying a bitwise or-operator to append
    // the second one.
    if (byteOrder === $a6bf2813aae3d0a0$var$ByteOrder.LittleEndian) return second << 8 | first;
    if (byteOrder === $a6bf2813aae3d0a0$var$ByteOrder.BigEndian) return first << 8 | second;
    throw new Error("Invalid byteOrder: " + byteOrder);
};
/**
 * Returns whether the given array contains a byte order mark for the
 * UTF-16BE or UTF-16LE encoding. If it has neither, BigEndian is assumed.
 *
 * Reference: https://en.wikipedia.org/wiki/Byte_order_mark#UTF-16
 *
 * @param bytes The byte array to be evaluated.
 */ // prettier-ignore
var $a6bf2813aae3d0a0$var$readBOM = function(bytes) {
    return $a6bf2813aae3d0a0$var$hasUtf16BigEndianBOM(bytes) ? $a6bf2813aae3d0a0$var$ByteOrder.BigEndian : $a6bf2813aae3d0a0$var$hasUtf16LittleEndianBOM(bytes) ? $a6bf2813aae3d0a0$var$ByteOrder.LittleEndian : $a6bf2813aae3d0a0$var$ByteOrder.BigEndian;
};
var $a6bf2813aae3d0a0$var$hasUtf16BigEndianBOM = function(bytes) {
    return bytes[0] === 0xfe && bytes[1] === 0xff;
};
var $a6bf2813aae3d0a0$var$hasUtf16LittleEndianBOM = function(bytes) {
    return bytes[0] === 0xff && bytes[1] === 0xfe;
};
var $a6bf2813aae3d0a0$export$41e7c15c75b1b24d = function(bytes) {
    return $a6bf2813aae3d0a0$var$hasUtf16BigEndianBOM(bytes) || $a6bf2813aae3d0a0$var$hasUtf16LittleEndianBOM(bytes);
};

});

parcelRegister("hiEdU", function(module, exports) {

$parcel$export(module.exports, "numberToString", () => $c983519a4c18aa89$export$f67be9d9b0e25d7b);
$parcel$export(module.exports, "sizeInBytes", () => $c983519a4c18aa89$export$cc6acfd7a782614d);
$parcel$export(module.exports, "bytesFor", () => $c983519a4c18aa89$export$3c7962b7d5fa4e42);
// tslint:disable radix
/**
 * Converts a number to its string representation in decimal. This function
 * differs from simply converting a number to a string with `.toString()`
 * because this function's output string will **not** contain exponential
 * notation.
 *
 * Credit: https://stackoverflow.com/a/46545519
 */ var $c983519a4c18aa89$export$f67be9d9b0e25d7b = function(num) {
    var numStr = String(num);
    if (Math.abs(num) < 1.0) {
        var e = parseInt(num.toString().split('e-')[1]);
        if (e) {
            var negative = num < 0;
            if (negative) num *= -1;
            num *= Math.pow(10, e - 1);
            numStr = '0.' + new Array(e).join('0') + num.toString().substring(2);
            if (negative) numStr = '-' + numStr;
        }
    } else {
        var e = parseInt(num.toString().split('+')[1]);
        if (e > 20) {
            e -= 20;
            num /= Math.pow(10, e);
            numStr = num.toString() + new Array(e + 1).join('0');
        }
    }
    return numStr;
};
var $c983519a4c18aa89$export$cc6acfd7a782614d = function(n) {
    return Math.ceil(n.toString(2).length / 8);
};
var $c983519a4c18aa89$export$3c7962b7d5fa4e42 = function(n) {
    var bytes = new Uint8Array($c983519a4c18aa89$export$cc6acfd7a782614d(n));
    for(var i = 1; i <= bytes.length; i++)bytes[i - 1] = n >> (bytes.length - i) * 8;
    return bytes;
};

});

parcelRegister("hP0hy", function(module, exports) {

$parcel$export(module.exports, "error", () => $cf976b189519155d$export$a3bc9b8ed74fc);
var $cf976b189519155d$export$a3bc9b8ed74fc = function(msg) {
    throw new Error(msg);
};

});

parcelRegister("cbIAG", function(module, exports) {

$parcel$export(module.exports, "values", () => $8df919e62912d805$export$68c286be0e7e55b7);
$parcel$export(module.exports, "isStandardFont", () => $8df919e62912d805$export$f2950432a4491977);
$parcel$export(module.exports, "rectanglesAreEqual", () => $8df919e62912d805$export$93263d7e9f52c023);
parcelRequire("eNCdi");
var $kkdJe = parcelRequire("kkdJe");
var $8df919e62912d805$export$68c286be0e7e55b7 = function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $8df919e62912d805$export$59252e21bbb61725 = $8df919e62912d805$export$68c286be0e7e55b7((0, $kkdJe.FontNames));
var $8df919e62912d805$export$f2950432a4491977 = function(input) {
    return $8df919e62912d805$export$59252e21bbb61725.includes(input);
};
var $8df919e62912d805$export$93263d7e9f52c023 = function(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
};

});
parcelRegister("eNCdi", function(module, exports) {
$parcel$export(module.exports, "Font", () => (parcelRequire("kkdJe")).Font);
$parcel$export(module.exports, "FontNames", () => (parcelRequire("kkdJe")).FontNames);
$parcel$export(module.exports, "Encodings", () => (parcelRequire("90iSP")).Encodings);
parcelRequire("kkdJe");
parcelRequire("90iSP");

});
parcelRegister("kkdJe", function(module, exports) {

$parcel$export(module.exports, "FontNames", () => $ecc0531572753d26$export$a1e7b970f5a14844);
$parcel$export(module.exports, "Font", () => $ecc0531572753d26$export$89abf52a030e56ee);

var $5JpfH = parcelRequire("5JpfH");

var $3uXKw = parcelRequire("3uXKw");

var $7ybLn = parcelRequire("7ybLn");

var $fCZVO = parcelRequire("fCZVO");

var $cOHfc = parcelRequire("cOHfc");

var $eVbDh = parcelRequire("eVbDh");

var $g9ZKL = parcelRequire("g9ZKL");

var $hgkij = parcelRequire("hgkij");

var $4W9K8 = parcelRequire("4W9K8");

var $gbK7N = parcelRequire("gbK7N");

var $lan6Z = parcelRequire("lan6Z");

var $1zetG = parcelRequire("1zetG");

var $53nEH = parcelRequire("53nEH");

var $fhfja = parcelRequire("fhfja");

var $enbPQ = parcelRequire("enbPQ");
// prettier-ignore
var $ecc0531572753d26$var$compressedJsonForFontName = {
    'Courier': (0, (/*@__PURE__*/$parcel$interopDefault($cOHfc))),
    'Courier-Bold': (0, (/*@__PURE__*/$parcel$interopDefault($3uXKw))),
    'Courier-Oblique': (0, (/*@__PURE__*/$parcel$interopDefault($fCZVO))),
    'Courier-BoldOblique': (0, (/*@__PURE__*/$parcel$interopDefault($7ybLn))),
    'Helvetica': (0, (/*@__PURE__*/$parcel$interopDefault($4W9K8))),
    'Helvetica-Bold': (0, (/*@__PURE__*/$parcel$interopDefault($eVbDh))),
    'Helvetica-Oblique': (0, (/*@__PURE__*/$parcel$interopDefault($hgkij))),
    'Helvetica-BoldOblique': (0, (/*@__PURE__*/$parcel$interopDefault($g9ZKL))),
    'Times-Roman': (0, (/*@__PURE__*/$parcel$interopDefault($53nEH))),
    'Times-Bold': (0, (/*@__PURE__*/$parcel$interopDefault($gbK7N))),
    'Times-Italic': (0, (/*@__PURE__*/$parcel$interopDefault($1zetG))),
    'Times-BoldItalic': (0, (/*@__PURE__*/$parcel$interopDefault($lan6Z))),
    'Symbol': (0, (/*@__PURE__*/$parcel$interopDefault($fhfja))),
    'ZapfDingbats': (0, (/*@__PURE__*/$parcel$interopDefault($enbPQ)))
};
var $ecc0531572753d26$export$a1e7b970f5a14844;
(function(FontNames) {
    FontNames["Courier"] = "Courier";
    FontNames["CourierBold"] = "Courier-Bold";
    FontNames["CourierOblique"] = "Courier-Oblique";
    FontNames["CourierBoldOblique"] = "Courier-BoldOblique";
    FontNames["Helvetica"] = "Helvetica";
    FontNames["HelveticaBold"] = "Helvetica-Bold";
    FontNames["HelveticaOblique"] = "Helvetica-Oblique";
    FontNames["HelveticaBoldOblique"] = "Helvetica-BoldOblique";
    FontNames["TimesRoman"] = "Times-Roman";
    FontNames["TimesRomanBold"] = "Times-Bold";
    FontNames["TimesRomanItalic"] = "Times-Italic";
    FontNames["TimesRomanBoldItalic"] = "Times-BoldItalic";
    FontNames["Symbol"] = "Symbol";
    FontNames["ZapfDingbats"] = "ZapfDingbats";
})($ecc0531572753d26$export$a1e7b970f5a14844 || ($ecc0531572753d26$export$a1e7b970f5a14844 = {}));
var $ecc0531572753d26$var$fontCache = {};
var $ecc0531572753d26$export$89abf52a030e56ee = /** @class */ function() {
    function Font() {
        var _this = this;
        this.getWidthOfGlyph = function(glyphName) {
            return _this.CharWidths[glyphName];
        };
        this.getXAxisKerningForPair = function(leftGlyphName, rightGlyphName) {
            return (_this.KernPairXAmounts[leftGlyphName] || {})[rightGlyphName];
        };
    }
    Font.load = function(fontName) {
        var cachedFont = $ecc0531572753d26$var$fontCache[fontName];
        if (cachedFont) return cachedFont;
        var json = (0, $5JpfH.decompressJson)($ecc0531572753d26$var$compressedJsonForFontName[fontName]);
        var font = Object.assign(new Font(), JSON.parse(json));
        font.CharWidths = font.CharMetrics.reduce(function(acc, metric) {
            acc[metric.N] = metric.WX;
            return acc;
        }, {});
        font.KernPairXAmounts = font.KernPairs.reduce(function(acc, _a) {
            var name1 = _a[0], name2 = _a[1], width = _a[2];
            if (!acc[name1]) acc[name1] = {};
            acc[name1][name2] = width;
            return acc;
        }, {});
        $ecc0531572753d26$var$fontCache[fontName] = font;
        return font;
    };
    return Font;
}();

});
parcelRegister("5JpfH", function(module, exports) {

$parcel$export(module.exports, "decompressJson", () => $42c4be4670940c1e$export$134b8d792d6efd14);
$parcel$export(module.exports, "padStart", () => $42c4be4670940c1e$export$36cf564d487b5178);
/*
 * The `chars`, `lookup`, and `decodeFromBase64` members of this file are
 * licensed under the following:
 *
 *     base64-arraybuffer
 *     https://github.com/niklasvh/base64-arraybuffer
 *
 *     Copyright (c) 2012 Niklas von Hertzen
 *     Licensed under the MIT license.
 *
 */ 
var $ckCqy = parcelRequire("ckCqy");
var $42c4be4670940c1e$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $42c4be4670940c1e$var$lookup = new Uint8Array(256);
for(var $42c4be4670940c1e$var$i = 0; $42c4be4670940c1e$var$i < $42c4be4670940c1e$var$chars.length; $42c4be4670940c1e$var$i++)$42c4be4670940c1e$var$lookup[$42c4be4670940c1e$var$chars.charCodeAt($42c4be4670940c1e$var$i)] = $42c4be4670940c1e$var$i;
var $42c4be4670940c1e$export$83edfd8fcc66ec17 = function(base64) {
    var bufferLength = base64.length * 0.75;
    var len = base64.length;
    var i;
    var p = 0;
    var encoded1;
    var encoded2;
    var encoded3;
    var encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    var bytes = new Uint8Array(bufferLength);
    for(i = 0; i < len; i += 4){
        encoded1 = $42c4be4670940c1e$var$lookup[base64.charCodeAt(i)];
        encoded2 = $42c4be4670940c1e$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $42c4be4670940c1e$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $42c4be4670940c1e$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
};
var $42c4be4670940c1e$var$arrayToString = function(array) {
    var str = '';
    for(var i = 0; i < array.length; i++)str += String.fromCharCode(array[i]);
    return str;
};
var $42c4be4670940c1e$export$134b8d792d6efd14 = function(compressedJson) {
    return $42c4be4670940c1e$var$arrayToString((0, (/*@__PURE__*/$parcel$interopDefault($ckCqy))).inflate($42c4be4670940c1e$export$83edfd8fcc66ec17(compressedJson)));
};
var $42c4be4670940c1e$export$36cf564d487b5178 = function(value, length, padChar) {
    var padding = '';
    for(var idx = 0, len = length - value.length; idx < len; idx++)padding += padChar;
    return padding + value;
};

});
parcelRegister("ckCqy", function(module, exports) {
// Top level file is just a mixin of submodules & constants
'use strict';

var $9CLQF = parcelRequire("9CLQF");
var $8fa5292818130bae$require$assign = $9CLQF.assign;

var $2wbN5 = parcelRequire("2wbN5");

var $3OYOJ = parcelRequire("3OYOJ");

var $hf4Xu = parcelRequire("hf4Xu");
var $8fa5292818130bae$var$pako = {};
$8fa5292818130bae$require$assign($8fa5292818130bae$var$pako, $2wbN5, $3OYOJ, $hf4Xu);
module.exports = $8fa5292818130bae$var$pako;

});
parcelRegister("9CLQF", function(module, exports) {
'use strict';
var $701cc75d47025217$var$TYPED_OK = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Int32Array !== 'undefined';
function $701cc75d47025217$var$_has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
module.exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
        for(var p in source)if ($701cc75d47025217$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// reduce buffer size, avoiding mem copy
module.exports.shrinkBuf = function(buf, size) {
    if (buf.length === size) return buf;
    if (buf.subarray) return buf.subarray(0, size);
    buf.length = size;
    return buf;
};
var $701cc75d47025217$var$fnTyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
        }
        // Fallback to ordinary array
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        var i, l, len, pos, chunk, result;
        // calculate data length
        len = 0;
        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
        // join chunks
        result = new Uint8Array(len);
        pos = 0;
        for(i = 0, l = chunks.length; i < l; i++){
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }
        return result;
    }
};
var $701cc75d47025217$var$fnUntyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        return [].concat.apply([], chunks);
    }
};
// Enable/Disable typed arrays use, for testing
//
module.exports.setTyped = function(on) {
    if (on) {
        module.exports.Buf8 = Uint8Array;
        module.exports.Buf16 = Uint16Array;
        module.exports.Buf32 = Int32Array;
        module.exports.assign(module.exports, $701cc75d47025217$var$fnTyped);
    } else {
        module.exports.Buf8 = Array;
        module.exports.Buf16 = Array;
        module.exports.Buf32 = Array;
        module.exports.assign(module.exports, $701cc75d47025217$var$fnUntyped);
    }
};
module.exports.setTyped($701cc75d47025217$var$TYPED_OK);

});

parcelRegister("2wbN5", function(module, exports) {

$parcel$export(module.exports, "Deflate", () => $1d57b756249bc6d3$export$ae157b6234afe138, (v) => $1d57b756249bc6d3$export$ae157b6234afe138 = v);
$parcel$export(module.exports, "deflate", () => $1d57b756249bc6d3$export$2316623ecd1285ab, (v) => $1d57b756249bc6d3$export$2316623ecd1285ab = v);
$parcel$export(module.exports, "deflateRaw", () => $1d57b756249bc6d3$export$e95d6a8f69fb340a, (v) => $1d57b756249bc6d3$export$e95d6a8f69fb340a = v);
$parcel$export(module.exports, "gzip", () => $1d57b756249bc6d3$export$69f0ea7cf3a331a8, (v) => $1d57b756249bc6d3$export$69f0ea7cf3a331a8 = v);
var $1d57b756249bc6d3$export$ae157b6234afe138;
var $1d57b756249bc6d3$export$2316623ecd1285ab;
var $1d57b756249bc6d3$export$e95d6a8f69fb340a;
var $1d57b756249bc6d3$export$69f0ea7cf3a331a8;
'use strict';

var $lGf86 = parcelRequire("lGf86");

var $9CLQF = parcelRequire("9CLQF");

var $iC2HB = parcelRequire("iC2HB");

var $7gAmB = parcelRequire("7gAmB");

var $9WDto = parcelRequire("9WDto");
var $1d57b756249bc6d3$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $1d57b756249bc6d3$var$Z_NO_FLUSH = 0;
var $1d57b756249bc6d3$var$Z_FINISH = 4;
var $1d57b756249bc6d3$var$Z_OK = 0;
var $1d57b756249bc6d3$var$Z_STREAM_END = 1;
var $1d57b756249bc6d3$var$Z_SYNC_FLUSH = 2;
var $1d57b756249bc6d3$var$Z_DEFAULT_COMPRESSION = -1;
var $1d57b756249bc6d3$var$Z_DEFAULT_STRATEGY = 0;
var $1d57b756249bc6d3$var$Z_DEFLATED = 8;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $1d57b756249bc6d3$var$Deflate(options) {
    if (!(this instanceof $1d57b756249bc6d3$var$Deflate)) return new $1d57b756249bc6d3$var$Deflate(options);
    this.options = $9CLQF.assign({
        level: $1d57b756249bc6d3$var$Z_DEFAULT_COMPRESSION,
        method: $1d57b756249bc6d3$var$Z_DEFLATED,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $1d57b756249bc6d3$var$Z_DEFAULT_STRATEGY,
        to: ''
    }, options || {});
    var opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $9WDto();
    this.strm.avail_out = 0;
    var status = $lGf86.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $1d57b756249bc6d3$var$Z_OK) throw new Error($7gAmB[status]);
    if (opt.header) $lGf86.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        var dict;
        // Convert data if needed
        if (typeof opt.dictionary === 'string') // If we need to compress text, change encoding to utf8.
        dict = $iC2HB.string2buf(opt.dictionary);
        else if ($1d57b756249bc6d3$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $lGf86.deflateSetDictionary(this.strm, dict);
        if (status !== $1d57b756249bc6d3$var$Z_OK) throw new Error($7gAmB[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $1d57b756249bc6d3$var$Deflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var status, _mode;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $1d57b756249bc6d3$var$Z_FINISH : $1d57b756249bc6d3$var$Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === 'string') // If we need to compress text, change encoding to utf8.
    strm.input = $iC2HB.string2buf(data);
    else if ($1d57b756249bc6d3$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $9CLQF.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $lGf86.deflate(strm, _mode); /* no bad return value */ 
        if (status !== $1d57b756249bc6d3$var$Z_STREAM_END && status !== $1d57b756249bc6d3$var$Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.avail_out === 0 || strm.avail_in === 0 && (_mode === $1d57b756249bc6d3$var$Z_FINISH || _mode === $1d57b756249bc6d3$var$Z_SYNC_FLUSH)) {
            if (this.options.to === 'string') this.onData($iC2HB.buf2binstring($9CLQF.shrinkBuf(strm.output, strm.next_out)));
            else this.onData($9CLQF.shrinkBuf(strm.output, strm.next_out));
        }
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $1d57b756249bc6d3$var$Z_STREAM_END);
    // Finalize on the last chunk.
    if (_mode === $1d57b756249bc6d3$var$Z_FINISH) {
        status = $lGf86.deflateEnd(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $1d57b756249bc6d3$var$Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $1d57b756249bc6d3$var$Z_SYNC_FLUSH) {
        this.onEnd($1d57b756249bc6d3$var$Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $1d57b756249bc6d3$var$Deflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $1d57b756249bc6d3$var$Deflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $1d57b756249bc6d3$var$Z_OK) {
        if (this.options.to === 'string') this.result = this.chunks.join('');
        else this.result = $9CLQF.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $1d57b756249bc6d3$var$deflate(input, options) {
    var deflator = new $1d57b756249bc6d3$var$Deflate(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $7gAmB[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $1d57b756249bc6d3$var$deflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $1d57b756249bc6d3$var$deflate(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $1d57b756249bc6d3$var$gzip(input, options) {
    options = options || {};
    options.gzip = true;
    return $1d57b756249bc6d3$var$deflate(input, options);
}
$1d57b756249bc6d3$export$ae157b6234afe138 = $1d57b756249bc6d3$var$Deflate;
$1d57b756249bc6d3$export$2316623ecd1285ab = $1d57b756249bc6d3$var$deflate;
$1d57b756249bc6d3$export$e95d6a8f69fb340a = $1d57b756249bc6d3$var$deflateRaw;
$1d57b756249bc6d3$export$69f0ea7cf3a331a8 = $1d57b756249bc6d3$var$gzip;

});
parcelRegister("lGf86", function(module, exports) {

$parcel$export(module.exports, "deflateInit2", () => $fc8941aa2060205a$export$a65c7b2bde87cb70, (v) => $fc8941aa2060205a$export$a65c7b2bde87cb70 = v);
$parcel$export(module.exports, "deflateSetHeader", () => $fc8941aa2060205a$export$1cd50f7b2515ba19, (v) => $fc8941aa2060205a$export$1cd50f7b2515ba19 = v);
$parcel$export(module.exports, "deflate", () => $fc8941aa2060205a$export$2316623ecd1285ab, (v) => $fc8941aa2060205a$export$2316623ecd1285ab = v);
$parcel$export(module.exports, "deflateEnd", () => $fc8941aa2060205a$export$599854fa319a815f, (v) => $fc8941aa2060205a$export$599854fa319a815f = v);
$parcel$export(module.exports, "deflateSetDictionary", () => $fc8941aa2060205a$export$f55e0b3ab66b5d46, (v) => $fc8941aa2060205a$export$f55e0b3ab66b5d46 = v);
var $fc8941aa2060205a$export$72b35d618fb8ad9b;
var $fc8941aa2060205a$export$a65c7b2bde87cb70;
var $fc8941aa2060205a$export$8f99f0e30bc7dd53;
var $fc8941aa2060205a$export$e78fab288549509;
var $fc8941aa2060205a$export$1cd50f7b2515ba19;
var $fc8941aa2060205a$export$2316623ecd1285ab;
var $fc8941aa2060205a$export$599854fa319a815f;
var $fc8941aa2060205a$export$f55e0b3ab66b5d46;
var $fc8941aa2060205a$export$12b6e1fcadea22f9;
'use strict';

var $9CLQF = parcelRequire("9CLQF");

var $hx6dX = parcelRequire("hx6dX");

var $gJUj4 = parcelRequire("gJUj4");

var $5UMyJ = parcelRequire("5UMyJ");

var $7gAmB = parcelRequire("7gAmB");
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var $fc8941aa2060205a$var$Z_NO_FLUSH = 0;
var $fc8941aa2060205a$var$Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var $fc8941aa2060205a$var$Z_FULL_FLUSH = 3;
var $fc8941aa2060205a$var$Z_FINISH = 4;
var $fc8941aa2060205a$var$Z_BLOCK = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $fc8941aa2060205a$var$Z_OK = 0;
var $fc8941aa2060205a$var$Z_STREAM_END = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var $fc8941aa2060205a$var$Z_STREAM_ERROR = -2;
var $fc8941aa2060205a$var$Z_DATA_ERROR = -3;
//var Z_MEM_ERROR     = -4;
var $fc8941aa2060205a$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var $fc8941aa2060205a$var$Z_DEFAULT_COMPRESSION = -1;
var $fc8941aa2060205a$var$Z_FILTERED = 1;
var $fc8941aa2060205a$var$Z_HUFFMAN_ONLY = 2;
var $fc8941aa2060205a$var$Z_RLE = 3;
var $fc8941aa2060205a$var$Z_FIXED = 4;
var $fc8941aa2060205a$var$Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var $fc8941aa2060205a$var$Z_UNKNOWN = 2;
/* The deflate compression method */ var $fc8941aa2060205a$var$Z_DEFLATED = 8;
/*============================================================================*/ var $fc8941aa2060205a$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var $fc8941aa2060205a$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $fc8941aa2060205a$var$DEF_MEM_LEVEL = 8;
var $fc8941aa2060205a$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $fc8941aa2060205a$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $fc8941aa2060205a$var$L_CODES = $fc8941aa2060205a$var$LITERALS + 1 + $fc8941aa2060205a$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $fc8941aa2060205a$var$D_CODES = 30;
/* number of distance codes */ var $fc8941aa2060205a$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $fc8941aa2060205a$var$HEAP_SIZE = 2 * $fc8941aa2060205a$var$L_CODES + 1;
/* maximum heap size */ var $fc8941aa2060205a$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $fc8941aa2060205a$var$MIN_MATCH = 3;
var $fc8941aa2060205a$var$MAX_MATCH = 258;
var $fc8941aa2060205a$var$MIN_LOOKAHEAD = $fc8941aa2060205a$var$MAX_MATCH + $fc8941aa2060205a$var$MIN_MATCH + 1;
var $fc8941aa2060205a$var$PRESET_DICT = 0x20;
var $fc8941aa2060205a$var$INIT_STATE = 42;
var $fc8941aa2060205a$var$EXTRA_STATE = 69;
var $fc8941aa2060205a$var$NAME_STATE = 73;
var $fc8941aa2060205a$var$COMMENT_STATE = 91;
var $fc8941aa2060205a$var$HCRC_STATE = 103;
var $fc8941aa2060205a$var$BUSY_STATE = 113;
var $fc8941aa2060205a$var$FINISH_STATE = 666;
var $fc8941aa2060205a$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var $fc8941aa2060205a$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
var $fc8941aa2060205a$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var $fc8941aa2060205a$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var $fc8941aa2060205a$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function $fc8941aa2060205a$var$err(strm, errorCode) {
    strm.msg = $7gAmB[errorCode];
    return errorCode;
}
function $fc8941aa2060205a$var$rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function $fc8941aa2060205a$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function $fc8941aa2060205a$var$flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    $9CLQF.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function $fc8941aa2060205a$var$flush_block_only(s, last) {
    $hx6dX._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $fc8941aa2060205a$var$flush_pending(s.strm);
}
function $fc8941aa2060205a$var$put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function $fc8941aa2060205a$var$putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function $fc8941aa2060205a$var$read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    $9CLQF.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = $gJUj4(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $5UMyJ(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function $fc8941aa2060205a$var$longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + $fc8941aa2060205a$var$MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $fc8941aa2060205a$var$MAX_MATCH - (strend - scan);
        scan = strend - $fc8941aa2060205a$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function $fc8941aa2060205a$var$fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD)) {
            $9CLQF.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $fc8941aa2060205a$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $fc8941aa2060205a$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $fc8941aa2060205a$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function $fc8941aa2060205a$var$deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead === 0 && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function $fc8941aa2060205a$var$deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $fc8941aa2060205a$var$longest_match(s, hash_head);
        if (s.match_length >= $fc8941aa2060205a$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $hx6dX._tr_tally(s, s.strstart - s.match_start, s.match_length - $fc8941aa2060205a$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $fc8941aa2060205a$var$MIN_MATCH - 1 ? s.strstart : $fc8941aa2060205a$var$MIN_MATCH - 1;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function $fc8941aa2060205a$var$deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $fc8941aa2060205a$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $fc8941aa2060205a$var$Z_FILTERED || s.match_length === $fc8941aa2060205a$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $fc8941aa2060205a$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $fc8941aa2060205a$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $hx6dX._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $fc8941aa2060205a$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $fc8941aa2060205a$var$MIN_MATCH - 1 ? s.strstart : $fc8941aa2060205a$var$MIN_MATCH - 1;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function $fc8941aa2060205a$var$deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $fc8941aa2060205a$var$MAX_MATCH) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead <= $fc8941aa2060205a$var$MAX_MATCH && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $fc8941aa2060205a$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $fc8941aa2060205a$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $fc8941aa2060205a$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $hx6dX._tr_tally(s, 1, s.match_length - $fc8941aa2060205a$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function $fc8941aa2060205a$var$deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $fc8941aa2060205a$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var $fc8941aa2060205a$var$configuration_table;
$fc8941aa2060205a$var$configuration_table = [
    /*      good lazy nice chain */ new $fc8941aa2060205a$var$Config(0, 0, 0, 0, $fc8941aa2060205a$var$deflate_stored),
    /* 0 store only */ new $fc8941aa2060205a$var$Config(4, 4, 8, 4, $fc8941aa2060205a$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $fc8941aa2060205a$var$Config(4, 5, 16, 8, $fc8941aa2060205a$var$deflate_fast),
    /* 2 */ new $fc8941aa2060205a$var$Config(4, 6, 32, 32, $fc8941aa2060205a$var$deflate_fast),
    /* 3 */ new $fc8941aa2060205a$var$Config(4, 4, 16, 16, $fc8941aa2060205a$var$deflate_slow),
    /* 4 lazy matches */ new $fc8941aa2060205a$var$Config(8, 16, 32, 32, $fc8941aa2060205a$var$deflate_slow),
    /* 5 */ new $fc8941aa2060205a$var$Config(8, 16, 128, 128, $fc8941aa2060205a$var$deflate_slow),
    /* 6 */ new $fc8941aa2060205a$var$Config(8, 32, 128, 256, $fc8941aa2060205a$var$deflate_slow),
    /* 7 */ new $fc8941aa2060205a$var$Config(32, 128, 258, 1024, $fc8941aa2060205a$var$deflate_slow),
    /* 8 */ new $fc8941aa2060205a$var$Config(32, 258, 258, 4096, $fc8941aa2060205a$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function $fc8941aa2060205a$var$lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $fc8941aa2060205a$var$configuration_table[s.level].max_lazy;
    s.good_match = $fc8941aa2060205a$var$configuration_table[s.level].good_length;
    s.nice_match = $fc8941aa2060205a$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $fc8941aa2060205a$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function $fc8941aa2060205a$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $fc8941aa2060205a$var$Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new $9CLQF.Buf16($fc8941aa2060205a$var$HEAP_SIZE * 2);
    this.dyn_dtree = new $9CLQF.Buf16((2 * $fc8941aa2060205a$var$D_CODES + 1) * 2);
    this.bl_tree = new $9CLQF.Buf16((2 * $fc8941aa2060205a$var$BL_CODES + 1) * 2);
    $fc8941aa2060205a$var$zero(this.dyn_ltree);
    $fc8941aa2060205a$var$zero(this.dyn_dtree);
    $fc8941aa2060205a$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new $9CLQF.Buf16($fc8941aa2060205a$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new $9CLQF.Buf16(2 * $fc8941aa2060205a$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $fc8941aa2060205a$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new $9CLQF.Buf16(2 * $fc8941aa2060205a$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $fc8941aa2060205a$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function $fc8941aa2060205a$var$deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $fc8941aa2060205a$var$Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? $fc8941aa2060205a$var$INIT_STATE : $fc8941aa2060205a$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = $fc8941aa2060205a$var$Z_NO_FLUSH;
    $hx6dX._tr_init(s);
    return $fc8941aa2060205a$var$Z_OK;
}
function $fc8941aa2060205a$var$deflateReset(strm) {
    var ret = $fc8941aa2060205a$var$deflateResetKeep(strm);
    if (ret === $fc8941aa2060205a$var$Z_OK) $fc8941aa2060205a$var$lm_init(strm.state);
    return ret;
}
function $fc8941aa2060205a$var$deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return $fc8941aa2060205a$var$Z_OK;
}
function $fc8941aa2060205a$var$deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    var wrap = 1;
    if (level === $fc8941aa2060205a$var$Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $fc8941aa2060205a$var$MAX_MEM_LEVEL || method !== $fc8941aa2060205a$var$Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $fc8941aa2060205a$var$Z_FIXED) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new $fc8941aa2060205a$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $fc8941aa2060205a$var$MIN_MATCH - 1) / $fc8941aa2060205a$var$MIN_MATCH);
    s.window = new $9CLQF.Buf8(s.w_size * 2);
    s.head = new $9CLQF.Buf16(s.hash_size);
    s.prev = new $9CLQF.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new $9CLQF.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $fc8941aa2060205a$var$deflateReset(strm);
}
function $fc8941aa2060205a$var$deflateInit(strm, level) {
    return $fc8941aa2060205a$var$deflateInit2(strm, level, $fc8941aa2060205a$var$Z_DEFLATED, $fc8941aa2060205a$var$MAX_WBITS, $fc8941aa2060205a$var$DEF_MEM_LEVEL, $fc8941aa2060205a$var$Z_DEFAULT_STRATEGY);
}
function $fc8941aa2060205a$var$deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > $fc8941aa2060205a$var$Z_BLOCK || flush < 0) return strm ? $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR) : $fc8941aa2060205a$var$Z_STREAM_ERROR;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === $fc8941aa2060205a$var$FINISH_STATE && flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$err(strm, strm.avail_out === 0 ? $fc8941aa2060205a$var$Z_BUF_ERROR : $fc8941aa2060205a$var$Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === $fc8941aa2060205a$var$INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            $fc8941aa2060205a$var$put_byte(s, 31);
            $fc8941aa2060205a$var$put_byte(s, 139);
            $fc8941aa2060205a$var$put_byte(s, 8);
            if (!s.gzhead) {
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $fc8941aa2060205a$var$put_byte(s, $fc8941aa2060205a$var$OS_CODE);
                s.status = $fc8941aa2060205a$var$BUSY_STATE;
            } else {
                $fc8941aa2060205a$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra.length & 0xff);
                    $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$EXTRA_STATE;
            }
        } else {
            var header = $fc8941aa2060205a$var$Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= $fc8941aa2060205a$var$PRESET_DICT;
            header += 31 - header % 31;
            s.status = $fc8941aa2060205a$var$BUSY_STATE;
            $fc8941aa2060205a$var$putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                $fc8941aa2060205a$var$putShortMSB(s, strm.adler >>> 16);
                $fc8941aa2060205a$var$putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === $fc8941aa2060205a$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$NAME_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$NAME_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $fc8941aa2060205a$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$COMMENT_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$COMMENT_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $fc8941aa2060205a$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = $fc8941aa2060205a$var$HCRC_STATE;
        } else s.status = $fc8941aa2060205a$var$HCRC_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) $fc8941aa2060205a$var$flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                $fc8941aa2060205a$var$put_byte(s, strm.adler & 0xff);
                $fc8941aa2060205a$var$put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = $fc8941aa2060205a$var$BUSY_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $fc8941aa2060205a$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $fc8941aa2060205a$var$Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $fc8941aa2060205a$var$rank(flush) <= $fc8941aa2060205a$var$rank(old_flush) && flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === $fc8941aa2060205a$var$FINISH_STATE && strm.avail_in !== 0) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $fc8941aa2060205a$var$Z_NO_FLUSH && s.status !== $fc8941aa2060205a$var$FINISH_STATE) {
        var bstate = s.strategy === $fc8941aa2060205a$var$Z_HUFFMAN_ONLY ? $fc8941aa2060205a$var$deflate_huff(s, flush) : s.strategy === $fc8941aa2060205a$var$Z_RLE ? $fc8941aa2060205a$var$deflate_rle(s, flush) : $fc8941aa2060205a$var$configuration_table[s.level].func(s, flush);
        if (bstate === $fc8941aa2060205a$var$BS_FINISH_STARTED || bstate === $fc8941aa2060205a$var$BS_FINISH_DONE) s.status = $fc8941aa2060205a$var$FINISH_STATE;
        if (bstate === $fc8941aa2060205a$var$BS_NEED_MORE || bstate === $fc8941aa2060205a$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $fc8941aa2060205a$var$Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $fc8941aa2060205a$var$BS_BLOCK_DONE) {
            if (flush === $fc8941aa2060205a$var$Z_PARTIAL_FLUSH) $hx6dX._tr_align(s);
            else if (flush !== $fc8941aa2060205a$var$Z_BLOCK) {
                $hx6dX._tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $fc8941aa2060205a$var$Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $fc8941aa2060205a$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $fc8941aa2060205a$var$Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$Z_OK;
    if (s.wrap <= 0) return $fc8941aa2060205a$var$Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        $fc8941aa2060205a$var$put_byte(s, strm.adler & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 8 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 16 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 24 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $fc8941aa2060205a$var$putShortMSB(s, strm.adler >>> 16);
        $fc8941aa2060205a$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $fc8941aa2060205a$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $fc8941aa2060205a$var$Z_OK : $fc8941aa2060205a$var$Z_STREAM_END;
}
function $fc8941aa2060205a$var$deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    status = strm.state.status;
    if (status !== $fc8941aa2060205a$var$INIT_STATE && status !== $fc8941aa2060205a$var$EXTRA_STATE && status !== $fc8941aa2060205a$var$NAME_STATE && status !== $fc8941aa2060205a$var$COMMENT_STATE && status !== $fc8941aa2060205a$var$HCRC_STATE && status !== $fc8941aa2060205a$var$BUSY_STATE && status !== $fc8941aa2060205a$var$FINISH_STATE) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    strm.state = null;
    return status === $fc8941aa2060205a$var$BUSY_STATE ? $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_DATA_ERROR) : $fc8941aa2060205a$var$Z_OK;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function $fc8941aa2060205a$var$deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $fc8941aa2060205a$var$INIT_STATE || s.lookahead) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $gJUj4(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new $9CLQF.Buf8(s.w_size);
        $9CLQF.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $fc8941aa2060205a$var$fill_window(s);
    while(s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - ($fc8941aa2060205a$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $fc8941aa2060205a$var$MIN_MATCH - 1;
        $fc8941aa2060205a$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $fc8941aa2060205a$var$Z_OK;
}
$fc8941aa2060205a$export$72b35d618fb8ad9b = $fc8941aa2060205a$var$deflateInit;
$fc8941aa2060205a$export$a65c7b2bde87cb70 = $fc8941aa2060205a$var$deflateInit2;
$fc8941aa2060205a$export$8f99f0e30bc7dd53 = $fc8941aa2060205a$var$deflateReset;
$fc8941aa2060205a$export$e78fab288549509 = $fc8941aa2060205a$var$deflateResetKeep;
$fc8941aa2060205a$export$1cd50f7b2515ba19 = $fc8941aa2060205a$var$deflateSetHeader;
$fc8941aa2060205a$export$2316623ecd1285ab = $fc8941aa2060205a$var$deflate;
$fc8941aa2060205a$export$599854fa319a815f = $fc8941aa2060205a$var$deflateEnd;
$fc8941aa2060205a$export$f55e0b3ab66b5d46 = $fc8941aa2060205a$var$deflateSetDictionary;
$fc8941aa2060205a$export$12b6e1fcadea22f9 = 'pako deflate (from Nodeca project)'; /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ 

});
parcelRegister("hx6dX", function(module, exports) {

$parcel$export(module.exports, "_tr_init", () => $cc3a58b664fcb155$export$4e4fc0157c3cd14d, (v) => $cc3a58b664fcb155$export$4e4fc0157c3cd14d = v);
$parcel$export(module.exports, "_tr_stored_block", () => $cc3a58b664fcb155$export$8959e34c5e020172, (v) => $cc3a58b664fcb155$export$8959e34c5e020172 = v);
$parcel$export(module.exports, "_tr_flush_block", () => $cc3a58b664fcb155$export$44f15b52eef0cf41, (v) => $cc3a58b664fcb155$export$44f15b52eef0cf41 = v);
$parcel$export(module.exports, "_tr_tally", () => $cc3a58b664fcb155$export$b3cbce147289408f, (v) => $cc3a58b664fcb155$export$b3cbce147289408f = v);
$parcel$export(module.exports, "_tr_align", () => $cc3a58b664fcb155$export$bfb360e02ee9b403, (v) => $cc3a58b664fcb155$export$bfb360e02ee9b403 = v);
var $cc3a58b664fcb155$export$4e4fc0157c3cd14d;
var $cc3a58b664fcb155$export$8959e34c5e020172;
var $cc3a58b664fcb155$export$44f15b52eef0cf41;
var $cc3a58b664fcb155$export$b3cbce147289408f;
var $cc3a58b664fcb155$export$bfb360e02ee9b403;
'use strict';

var $9CLQF = parcelRequire("9CLQF");
/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var $cc3a58b664fcb155$var$Z_FIXED = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var $cc3a58b664fcb155$var$Z_BINARY = 0;
var $cc3a58b664fcb155$var$Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var $cc3a58b664fcb155$var$Z_UNKNOWN = 2;
/*============================================================================*/ function $cc3a58b664fcb155$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var $cc3a58b664fcb155$var$STORED_BLOCK = 0;
var $cc3a58b664fcb155$var$STATIC_TREES = 1;
var $cc3a58b664fcb155$var$DYN_TREES = 2;
/* The three kinds of block type */ var $cc3a58b664fcb155$var$MIN_MATCH = 3;
var $cc3a58b664fcb155$var$MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var $cc3a58b664fcb155$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $cc3a58b664fcb155$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $cc3a58b664fcb155$var$L_CODES = $cc3a58b664fcb155$var$LITERALS + 1 + $cc3a58b664fcb155$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $cc3a58b664fcb155$var$D_CODES = 30;
/* number of distance codes */ var $cc3a58b664fcb155$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $cc3a58b664fcb155$var$HEAP_SIZE = 2 * $cc3a58b664fcb155$var$L_CODES + 1;
/* maximum heap size */ var $cc3a58b664fcb155$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $cc3a58b664fcb155$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var $cc3a58b664fcb155$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var $cc3a58b664fcb155$var$END_BLOCK = 256;
/* end of block literal code */ var $cc3a58b664fcb155$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var $cc3a58b664fcb155$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var $cc3a58b664fcb155$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var $cc3a58b664fcb155$var$extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var $cc3a58b664fcb155$var$extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var $cc3a58b664fcb155$var$extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var $cc3a58b664fcb155$var$bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var $cc3a58b664fcb155$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var $cc3a58b664fcb155$var$static_ltree = new Array(($cc3a58b664fcb155$var$L_CODES + 2) * 2);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var $cc3a58b664fcb155$var$static_dtree = new Array($cc3a58b664fcb155$var$D_CODES * 2);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var $cc3a58b664fcb155$var$_dist_code = new Array($cc3a58b664fcb155$var$DIST_CODE_LEN);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var $cc3a58b664fcb155$var$_length_code = new Array($cc3a58b664fcb155$var$MAX_MATCH - $cc3a58b664fcb155$var$MIN_MATCH + 1);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var $cc3a58b664fcb155$var$base_length = new Array($cc3a58b664fcb155$var$LENGTH_CODES);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var $cc3a58b664fcb155$var$base_dist = new Array($cc3a58b664fcb155$var$D_CODES);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $cc3a58b664fcb155$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var $cc3a58b664fcb155$var$static_l_desc;
var $cc3a58b664fcb155$var$static_d_desc;
var $cc3a58b664fcb155$var$static_bl_desc;
function $cc3a58b664fcb155$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function $cc3a58b664fcb155$var$d_code(dist) {
    return dist < 256 ? $cc3a58b664fcb155$var$_dist_code[dist] : $cc3a58b664fcb155$var$_dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function $cc3a58b664fcb155$var$put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function $cc3a58b664fcb155$var$send_bits(s, value, length) {
    if (s.bi_valid > $cc3a58b664fcb155$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $cc3a58b664fcb155$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $cc3a58b664fcb155$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function $cc3a58b664fcb155$var$send_code(s, c, tree) {
    $cc3a58b664fcb155$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function $cc3a58b664fcb155$var$bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function $cc3a58b664fcb155$var$bi_flush(s) {
    if (s.bi_valid === 16) {
        $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function $cc3a58b664fcb155$var$gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $cc3a58b664fcb155$var$HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function $cc3a58b664fcb155$var$gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array($cc3a58b664fcb155$var$MAX_BITS + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $cc3a58b664fcb155$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function $cc3a58b664fcb155$var$tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array($cc3a58b664fcb155$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $cc3a58b664fcb155$var$LENGTH_CODES - 1; code++){
        $cc3a58b664fcb155$var$base_length[code] = length;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_lbits[code]; n++)$cc3a58b664fcb155$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $cc3a58b664fcb155$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $cc3a58b664fcb155$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_dbits[code]; n++)$cc3a58b664fcb155$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $cc3a58b664fcb155$var$D_CODES; code++){
        $cc3a58b664fcb155$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_dbits[code] - 7; n++)$cc3a58b664fcb155$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $cc3a58b664fcb155$var$gen_codes($cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $cc3a58b664fcb155$var$D_CODES; n++){
        $cc3a58b664fcb155$var$static_dtree[n * 2 + 1] = 5;
        $cc3a58b664fcb155$var$static_dtree[n * 2] = $cc3a58b664fcb155$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $cc3a58b664fcb155$var$static_l_desc = new $cc3a58b664fcb155$var$StaticTreeDesc($cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$extra_lbits, $cc3a58b664fcb155$var$LITERALS + 1, $cc3a58b664fcb155$var$L_CODES, $cc3a58b664fcb155$var$MAX_BITS);
    $cc3a58b664fcb155$var$static_d_desc = new $cc3a58b664fcb155$var$StaticTreeDesc($cc3a58b664fcb155$var$static_dtree, $cc3a58b664fcb155$var$extra_dbits, 0, $cc3a58b664fcb155$var$D_CODES, $cc3a58b664fcb155$var$MAX_BITS);
    $cc3a58b664fcb155$var$static_bl_desc = new $cc3a58b664fcb155$var$StaticTreeDesc(new Array(0), $cc3a58b664fcb155$var$extra_blbits, 0, $cc3a58b664fcb155$var$BL_CODES, $cc3a58b664fcb155$var$MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function $cc3a58b664fcb155$var$init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $cc3a58b664fcb155$var$L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $cc3a58b664fcb155$var$D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $cc3a58b664fcb155$var$BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$cc3a58b664fcb155$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function $cc3a58b664fcb155$var$bi_windup(s) {
    if (s.bi_valid > 8) $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function $cc3a58b664fcb155$var$copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    $cc3a58b664fcb155$var$bi_windup(s); /* align on byte boundary */ 
    if (header) {
        $cc3a58b664fcb155$var$put_short(s, len);
        $cc3a58b664fcb155$var$put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    $9CLQF.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function $cc3a58b664fcb155$var$smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function $cc3a58b664fcb155$var$pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $cc3a58b664fcb155$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($cc3a58b664fcb155$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function $cc3a58b664fcb155$var$compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) $cc3a58b664fcb155$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $cc3a58b664fcb155$var$_length_code[lc];
            $cc3a58b664fcb155$var$send_code(s, code + $cc3a58b664fcb155$var$LITERALS + 1, ltree); /* send the length code */ 
            extra = $cc3a58b664fcb155$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $cc3a58b664fcb155$var$base_length[code];
                $cc3a58b664fcb155$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $cc3a58b664fcb155$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $cc3a58b664fcb155$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $cc3a58b664fcb155$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $cc3a58b664fcb155$var$base_dist[code];
                $cc3a58b664fcb155$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function $cc3a58b664fcb155$var$build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $cc3a58b664fcb155$var$HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$cc3a58b664fcb155$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $cc3a58b664fcb155$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $cc3a58b664fcb155$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $cc3a58b664fcb155$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $cc3a58b664fcb155$var$gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function $cc3a58b664fcb155$var$scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$cc3a58b664fcb155$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$cc3a58b664fcb155$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$cc3a58b664fcb155$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function $cc3a58b664fcb155$var$send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $cc3a58b664fcb155$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $cc3a58b664fcb155$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REP_3_6, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REPZ_3_10, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 3, 3);
        } else {
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REPZ_11_138, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function $cc3a58b664fcb155$var$build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $cc3a58b664fcb155$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $cc3a58b664fcb155$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $cc3a58b664fcb155$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $cc3a58b664fcb155$var$BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$cc3a58b664fcb155$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function $cc3a58b664fcb155$var$send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $cc3a58b664fcb155$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $cc3a58b664fcb155$var$send_bits(s, dcodes - 1, 5);
    $cc3a58b664fcb155$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $cc3a58b664fcb155$var$send_bits(s, s.bl_tree[$cc3a58b664fcb155$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $cc3a58b664fcb155$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $cc3a58b664fcb155$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function $cc3a58b664fcb155$var$detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $cc3a58b664fcb155$var$Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $cc3a58b664fcb155$var$Z_TEXT;
    for(n = 32; n < $cc3a58b664fcb155$var$LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $cc3a58b664fcb155$var$Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $cc3a58b664fcb155$var$Z_BINARY;
}
var $cc3a58b664fcb155$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function $cc3a58b664fcb155$var$_tr_init(s) {
    if (!$cc3a58b664fcb155$var$static_init_done) {
        $cc3a58b664fcb155$var$tr_static_init();
        $cc3a58b664fcb155$var$static_init_done = true;
    }
    s.l_desc = new $cc3a58b664fcb155$var$TreeDesc(s.dyn_ltree, $cc3a58b664fcb155$var$static_l_desc);
    s.d_desc = new $cc3a58b664fcb155$var$TreeDesc(s.dyn_dtree, $cc3a58b664fcb155$var$static_d_desc);
    s.bl_desc = new $cc3a58b664fcb155$var$TreeDesc(s.bl_tree, $cc3a58b664fcb155$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $cc3a58b664fcb155$var$init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function $cc3a58b664fcb155$var$_tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $cc3a58b664fcb155$var$copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function $cc3a58b664fcb155$var$_tr_align(s) {
    $cc3a58b664fcb155$var$send_bits(s, $cc3a58b664fcb155$var$STATIC_TREES << 1, 3);
    $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$END_BLOCK, $cc3a58b664fcb155$var$static_ltree);
    $cc3a58b664fcb155$var$bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function $cc3a58b664fcb155$var$_tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $cc3a58b664fcb155$var$Z_UNKNOWN) s.strm.data_type = $cc3a58b664fcb155$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $cc3a58b664fcb155$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $cc3a58b664fcb155$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $cc3a58b664fcb155$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $cc3a58b664fcb155$var$_tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === $cc3a58b664fcb155$var$Z_FIXED || static_lenb === opt_lenb) {
        $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $cc3a58b664fcb155$var$compress_block(s, $cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$static_dtree);
    } else {
        $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $cc3a58b664fcb155$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $cc3a58b664fcb155$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $cc3a58b664fcb155$var$init_block(s);
    if (last) $cc3a58b664fcb155$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function $cc3a58b664fcb155$var$_tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($cc3a58b664fcb155$var$_length_code[lc] + $cc3a58b664fcb155$var$LITERALS + 1) * 2]++;
        s.dyn_dtree[$cc3a58b664fcb155$var$d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
$cc3a58b664fcb155$export$4e4fc0157c3cd14d = $cc3a58b664fcb155$var$_tr_init;
$cc3a58b664fcb155$export$8959e34c5e020172 = $cc3a58b664fcb155$var$_tr_stored_block;
$cc3a58b664fcb155$export$44f15b52eef0cf41 = $cc3a58b664fcb155$var$_tr_flush_block;
$cc3a58b664fcb155$export$b3cbce147289408f = $cc3a58b664fcb155$var$_tr_tally;
$cc3a58b664fcb155$export$bfb360e02ee9b403 = $cc3a58b664fcb155$var$_tr_align;

});

parcelRegister("gJUj4", function(module, exports) {
'use strict';
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $c2fc869ba2d0859c$var$adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
module.exports = $c2fc869ba2d0859c$var$adler32;

});

parcelRegister("5UMyJ", function(module, exports) {
'use strict';
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function $44e7d98dd6723a9a$var$makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var $44e7d98dd6723a9a$var$crcTable = $44e7d98dd6723a9a$var$makeTable();
function $44e7d98dd6723a9a$var$crc32(crc, buf, len, pos) {
    var t = $44e7d98dd6723a9a$var$crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
module.exports = $44e7d98dd6723a9a$var$crc32;

});

parcelRegister("7gAmB", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    2: 'need dictionary',
    /* Z_NEED_DICT       2  */ 1: 'stream end',
    /* Z_STREAM_END      1  */ 0: '',
    /* Z_OK              0  */ '-1': 'file error',
    /* Z_ERRNO         (-1) */ '-2': 'stream error',
    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
};

});


parcelRegister("iC2HB", function(module, exports) {

$parcel$export(module.exports, "string2buf", () => $d8cddf31faab2448$export$7a4c1b2f775b5a9f, (v) => $d8cddf31faab2448$export$7a4c1b2f775b5a9f = v);
$parcel$export(module.exports, "buf2binstring", () => $d8cddf31faab2448$export$a751fe64af8a9a51, (v) => $d8cddf31faab2448$export$a751fe64af8a9a51 = v);
$parcel$export(module.exports, "binstring2buf", () => $d8cddf31faab2448$export$1d1a7119601ff18c, (v) => $d8cddf31faab2448$export$1d1a7119601ff18c = v);
$parcel$export(module.exports, "buf2string", () => $d8cddf31faab2448$export$49a50563f377746, (v) => $d8cddf31faab2448$export$49a50563f377746 = v);
$parcel$export(module.exports, "utf8border", () => $d8cddf31faab2448$export$53dee3f58a714214, (v) => $d8cddf31faab2448$export$53dee3f58a714214 = v);
// String encode/decode helpers
// convert string to array (typed, when possible)
var $d8cddf31faab2448$export$7a4c1b2f775b5a9f;
// Convert byte array to binary string
var $d8cddf31faab2448$export$a751fe64af8a9a51;
// Convert binary string (typed, when possible)
var $d8cddf31faab2448$export$1d1a7119601ff18c;
// convert array to string
var $d8cddf31faab2448$export$49a50563f377746;
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $d8cddf31faab2448$export$53dee3f58a714214;
'use strict';

var $9CLQF = parcelRequire("9CLQF");
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var $d8cddf31faab2448$var$STR_APPLY_OK = true;
var $d8cddf31faab2448$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, [
        0
    ]);
} catch (__) {
    $d8cddf31faab2448$var$STR_APPLY_OK = false;
}
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $d8cddf31faab2448$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var $d8cddf31faab2448$var$_utf8len = new $9CLQF.Buf8(256);
for(var $d8cddf31faab2448$var$q = 0; $d8cddf31faab2448$var$q < 256; $d8cddf31faab2448$var$q++)$d8cddf31faab2448$var$_utf8len[$d8cddf31faab2448$var$q] = $d8cddf31faab2448$var$q >= 252 ? 6 : $d8cddf31faab2448$var$q >= 248 ? 5 : $d8cddf31faab2448$var$q >= 240 ? 4 : $d8cddf31faab2448$var$q >= 224 ? 3 : $d8cddf31faab2448$var$q >= 192 ? 2 : 1;
$d8cddf31faab2448$var$_utf8len[254] = $d8cddf31faab2448$var$_utf8len[254] = 1; // Invalid sequence start
$d8cddf31faab2448$export$7a4c1b2f775b5a9f = function(str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new $9CLQF.Buf8(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper (used in 2 places)
function $d8cddf31faab2448$var$buf2binstring(buf, len) {
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $d8cddf31faab2448$var$STR_APPLY_UIA_OK || !buf.subarray && $d8cddf31faab2448$var$STR_APPLY_OK) return String.fromCharCode.apply(null, $9CLQF.shrinkBuf(buf, len));
    }
    var result = '';
    for(var i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
}
$d8cddf31faab2448$export$a751fe64af8a9a51 = function(buf) {
    return $d8cddf31faab2448$var$buf2binstring(buf, buf.length);
};
$d8cddf31faab2448$export$1d1a7119601ff18c = function(str) {
    var buf = new $9CLQF.Buf8(str.length);
    for(var i = 0, len = buf.length; i < len; i++)buf[i] = str.charCodeAt(i);
    return buf;
};
$d8cddf31faab2448$export$49a50563f377746 = function(buf, max) {
    var i, out, c, c_len;
    var len = max || buf.length;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        c_len = $d8cddf31faab2448$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $d8cddf31faab2448$var$buf2binstring(utf16buf, out);
};
$d8cddf31faab2448$export$53dee3f58a714214 = function(buf, max) {
    var pos;
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $d8cddf31faab2448$var$_utf8len[buf[pos]] > max ? pos : max;
};

});

parcelRegister("9WDto", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $73d8265e2c50d00b$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
module.exports = $73d8265e2c50d00b$var$ZStream;

});


parcelRegister("3OYOJ", function(module, exports) {

$parcel$export(module.exports, "Inflate", () => $2c8537a6b47169be$export$d1de70a877d6e43c, (v) => $2c8537a6b47169be$export$d1de70a877d6e43c = v);
$parcel$export(module.exports, "inflate", () => $2c8537a6b47169be$export$cae1ce83fe4a1782, (v) => $2c8537a6b47169be$export$cae1ce83fe4a1782 = v);
$parcel$export(module.exports, "inflateRaw", () => $2c8537a6b47169be$export$d0f0aa2d05c905c5, (v) => $2c8537a6b47169be$export$d0f0aa2d05c905c5 = v);
$parcel$export(module.exports, "ungzip", () => $2c8537a6b47169be$export$95adf9d270383091, (v) => $2c8537a6b47169be$export$95adf9d270383091 = v);
/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $2c8537a6b47169be$export$d1de70a877d6e43c;
var $2c8537a6b47169be$export$cae1ce83fe4a1782;
var $2c8537a6b47169be$export$d0f0aa2d05c905c5;
var $2c8537a6b47169be$export$95adf9d270383091;
'use strict';

var $fzvBq = parcelRequire("fzvBq");

var $9CLQF = parcelRequire("9CLQF");

var $iC2HB = parcelRequire("iC2HB");

var $hf4Xu = parcelRequire("hf4Xu");

var $7gAmB = parcelRequire("7gAmB");

var $9WDto = parcelRequire("9WDto");

var $9t6AE = parcelRequire("9t6AE");
var $2c8537a6b47169be$var$toString = Object.prototype.toString;
/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $2c8537a6b47169be$var$Inflate(options) {
    if (!(this instanceof $2c8537a6b47169be$var$Inflate)) return new $2c8537a6b47169be$var$Inflate(options);
    this.options = $9CLQF.assign({
        chunkSize: 16384,
        windowBits: 0,
        to: ''
    }, options || {});
    var opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $9WDto();
    this.strm.avail_out = 0;
    var status = $fzvBq.inflateInit2(this.strm, opt.windowBits);
    if (status !== $hf4Xu.Z_OK) throw new Error($7gAmB[status]);
    this.header = new $9t6AE();
    $fzvBq.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === 'string') opt.dictionary = $iC2HB.string2buf(opt.dictionary);
        else if ($2c8537a6b47169be$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $fzvBq.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $hf4Xu.Z_OK) throw new Error($7gAmB[status]);
        }
    }
}
/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $2c8537a6b47169be$var$Inflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var dictionary = this.options.dictionary;
    var status, _mode;
    var next_out_utf8, tail, utf8str;
    // Flag to properly process Z_BUF_ERROR on testing inflate call
    // when we check that all output data was flushed.
    var allowBufError = false;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $hf4Xu.Z_FINISH : $hf4Xu.Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === 'string') // Only binary strings can be decompressed on practice
    strm.input = $iC2HB.binstring2buf(data);
    else if ($2c8537a6b47169be$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $9CLQF.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $fzvBq.inflate(strm, $hf4Xu.Z_NO_FLUSH); /* no bad return value */ 
        if (status === $hf4Xu.Z_NEED_DICT && dictionary) status = $fzvBq.inflateSetDictionary(this.strm, dictionary);
        if (status === $hf4Xu.Z_BUF_ERROR && allowBufError === true) {
            status = $hf4Xu.Z_OK;
            allowBufError = false;
        }
        if (status !== $hf4Xu.Z_STREAM_END && status !== $hf4Xu.Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $hf4Xu.Z_STREAM_END || strm.avail_in === 0 && (_mode === $hf4Xu.Z_FINISH || _mode === $hf4Xu.Z_SYNC_FLUSH)) {
                if (this.options.to === 'string') {
                    next_out_utf8 = $iC2HB.utf8border(strm.output, strm.next_out);
                    tail = strm.next_out - next_out_utf8;
                    utf8str = $iC2HB.buf2string(strm.output, next_out_utf8);
                    // move tail
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) $9CLQF.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
                    this.onData(utf8str);
                } else this.onData($9CLQF.shrinkBuf(strm.output, strm.next_out));
            }
        }
        // When no more input data, we should check that internal inflate buffers
        // are flushed. The only way to do it when avail_out = 0 - run one more
        // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
        // Here we set flag to process this error properly.
        //
        // NOTE. Deflate does not return error in this case and does not needs such
        // logic.
        if (strm.avail_in === 0 && strm.avail_out === 0) allowBufError = true;
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $hf4Xu.Z_STREAM_END);
    if (status === $hf4Xu.Z_STREAM_END) _mode = $hf4Xu.Z_FINISH;
    // Finalize on the last chunk.
    if (_mode === $hf4Xu.Z_FINISH) {
        status = $fzvBq.inflateEnd(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $hf4Xu.Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $hf4Xu.Z_SYNC_FLUSH) {
        this.onEnd($hf4Xu.Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $2c8537a6b47169be$var$Inflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $2c8537a6b47169be$var$Inflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $hf4Xu.Z_OK) {
        if (this.options.to === 'string') // Glue & convert here, until we teach pako to send
        // utf8 aligned strings to onData
        this.result = this.chunks.join('');
        else this.result = $9CLQF.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/ function $2c8537a6b47169be$var$inflate(input, options) {
    var inflator = new $2c8537a6b47169be$var$Inflate(options);
    inflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $7gAmB[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $2c8537a6b47169be$var$inflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $2c8537a6b47169be$var$inflate(input, options);
}
$2c8537a6b47169be$export$d1de70a877d6e43c = $2c8537a6b47169be$var$Inflate;
$2c8537a6b47169be$export$cae1ce83fe4a1782 = $2c8537a6b47169be$var$inflate;
$2c8537a6b47169be$export$d0f0aa2d05c905c5 = $2c8537a6b47169be$var$inflateRaw;
$2c8537a6b47169be$export$95adf9d270383091 = $2c8537a6b47169be$var$inflate;

});
parcelRegister("fzvBq", function(module, exports) {

$parcel$export(module.exports, "inflateInit2", () => $b562a383a327bea1$export$6792d92addc5c8a0, (v) => $b562a383a327bea1$export$6792d92addc5c8a0 = v);
$parcel$export(module.exports, "inflate", () => $b562a383a327bea1$export$cae1ce83fe4a1782, (v) => $b562a383a327bea1$export$cae1ce83fe4a1782 = v);
$parcel$export(module.exports, "inflateEnd", () => $b562a383a327bea1$export$224e1a443c3fba76, (v) => $b562a383a327bea1$export$224e1a443c3fba76 = v);
$parcel$export(module.exports, "inflateGetHeader", () => $b562a383a327bea1$export$6d4647cb9e1c75fc, (v) => $b562a383a327bea1$export$6d4647cb9e1c75fc = v);
$parcel$export(module.exports, "inflateSetDictionary", () => $b562a383a327bea1$export$60da749bed98ccf8, (v) => $b562a383a327bea1$export$60da749bed98ccf8 = v);
var $b562a383a327bea1$export$42de45683a92ba94;
var $b562a383a327bea1$export$7633ac2cd30f9650;
var $b562a383a327bea1$export$6710ea52c4ec9d6a;
var $b562a383a327bea1$export$9c140b25e26874f9;
var $b562a383a327bea1$export$6792d92addc5c8a0;
var $b562a383a327bea1$export$cae1ce83fe4a1782;
var $b562a383a327bea1$export$224e1a443c3fba76;
var $b562a383a327bea1$export$6d4647cb9e1c75fc;
var $b562a383a327bea1$export$60da749bed98ccf8;
var $b562a383a327bea1$export$220f6291ca35fd71;
'use strict';

var $9CLQF = parcelRequire("9CLQF");

var $gJUj4 = parcelRequire("gJUj4");

var $5UMyJ = parcelRequire("5UMyJ");

var $6OFFF = parcelRequire("6OFFF");

var $bxjQM = parcelRequire("bxjQM");
var $b562a383a327bea1$var$CODES = 0;
var $b562a383a327bea1$var$LENS = 1;
var $b562a383a327bea1$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var $b562a383a327bea1$var$Z_FINISH = 4;
var $b562a383a327bea1$var$Z_BLOCK = 5;
var $b562a383a327bea1$var$Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $b562a383a327bea1$var$Z_OK = 0;
var $b562a383a327bea1$var$Z_STREAM_END = 1;
var $b562a383a327bea1$var$Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var $b562a383a327bea1$var$Z_STREAM_ERROR = -2;
var $b562a383a327bea1$var$Z_DATA_ERROR = -3;
var $b562a383a327bea1$var$Z_MEM_ERROR = -4;
var $b562a383a327bea1$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var $b562a383a327bea1$var$Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var $b562a383a327bea1$var$HEAD = 1; /* i: waiting for magic header */ 
var $b562a383a327bea1$var$FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var $b562a383a327bea1$var$TIME = 3; /* i: waiting for modification time (gzip) */ 
var $b562a383a327bea1$var$OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var $b562a383a327bea1$var$EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var $b562a383a327bea1$var$EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var $b562a383a327bea1$var$NAME = 7; /* i: waiting for end of file name (gzip) */ 
var $b562a383a327bea1$var$COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var $b562a383a327bea1$var$HCRC = 9; /* i: waiting for header crc (gzip) */ 
var $b562a383a327bea1$var$DICTID = 10; /* i: waiting for dictionary check value */ 
var $b562a383a327bea1$var$DICT = 11; /* waiting for inflateSetDictionary() call */ 
var $b562a383a327bea1$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var $b562a383a327bea1$var$TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var $b562a383a327bea1$var$STORED = 14; /* i: waiting for stored size (length and complement) */ 
var $b562a383a327bea1$var$COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var $b562a383a327bea1$var$COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var $b562a383a327bea1$var$TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var $b562a383a327bea1$var$LENLENS = 18; /* i: waiting for code length code lengths */ 
var $b562a383a327bea1$var$CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var $b562a383a327bea1$var$LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var $b562a383a327bea1$var$LEN = 21; /* i: waiting for length/lit/eob code */ 
var $b562a383a327bea1$var$LENEXT = 22; /* i: waiting for length extra bits */ 
var $b562a383a327bea1$var$DIST = 23; /* i: waiting for distance code */ 
var $b562a383a327bea1$var$DISTEXT = 24; /* i: waiting for distance extra bits */ 
var $b562a383a327bea1$var$MATCH = 25; /* o: waiting for output space to copy string */ 
var $b562a383a327bea1$var$LIT = 26; /* o: waiting for output space to write literal */ 
var $b562a383a327bea1$var$CHECK = 27; /* i: waiting for 32-bit check value */ 
var $b562a383a327bea1$var$LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var $b562a383a327bea1$var$DONE = 29; /* finished check, done -- remain here until reset */ 
var $b562a383a327bea1$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $b562a383a327bea1$var$MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var $b562a383a327bea1$var$SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var $b562a383a327bea1$var$ENOUGH_LENS = 852;
var $b562a383a327bea1$var$ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var $b562a383a327bea1$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $b562a383a327bea1$var$DEF_WBITS = $b562a383a327bea1$var$MAX_WBITS;
function $b562a383a327bea1$var$zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function $b562a383a327bea1$var$InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new $9CLQF.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new $9CLQF.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function $b562a383a327bea1$var$inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ''; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $b562a383a327bea1$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new $9CLQF.Buf32($b562a383a327bea1$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new $9CLQF.Buf32($b562a383a327bea1$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $b562a383a327bea1$var$inflateResetKeep(strm);
}
function $b562a383a327bea1$var$inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $b562a383a327bea1$var$inflateReset(strm);
}
function $b562a383a327bea1$var$inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new $b562a383a327bea1$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = $b562a383a327bea1$var$inflateReset2(strm, windowBits);
    if (ret !== $b562a383a327bea1$var$Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function $b562a383a327bea1$var$inflateInit(strm) {
    return $b562a383a327bea1$var$inflateInit2(strm, $b562a383a327bea1$var$DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var $b562a383a327bea1$var$virgin = true;
var $b562a383a327bea1$var$lenfix, $b562a383a327bea1$var$distfix; // We have no pointers in JS, so keep tables separate
function $b562a383a327bea1$var$fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($b562a383a327bea1$var$virgin) {
        var sym;
        $b562a383a327bea1$var$lenfix = new $9CLQF.Buf32(512);
        $b562a383a327bea1$var$distfix = new $9CLQF.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $bxjQM($b562a383a327bea1$var$LENS, state.lens, 0, 288, $b562a383a327bea1$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $bxjQM($b562a383a327bea1$var$DISTS, state.lens, 0, 32, $b562a383a327bea1$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $b562a383a327bea1$var$virgin = false;
    }
    state.lencode = $b562a383a327bea1$var$lenfix;
    state.lenbits = 9;
    state.distcode = $b562a383a327bea1$var$distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function $b562a383a327bea1$var$updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new $9CLQF.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        $9CLQF.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        $9CLQF.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            $9CLQF.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function $b562a383a327bea1$var$inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new $9CLQF.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === $b562a383a327bea1$var$TYPE) state.mode = $b562a383a327bea1$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $b562a383a327bea1$var$Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case $b562a383a327bea1$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $b562a383a327bea1$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $b562a383a327bea1$var$FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $b562a383a327bea1$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $b562a383a327bea1$var$DICTID : $b562a383a327bea1$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $b562a383a327bea1$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $b562a383a327bea1$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$TIME;
        /* falls through */ case $b562a383a327bea1$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$OS;
        /* falls through */ case $b562a383a327bea1$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$EXLEN;
        /* falls through */ case $b562a383a327bea1$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $5UMyJ(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $b562a383a327bea1$var$EXTRA;
        /* falls through */ case $b562a383a327bea1$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        $9CLQF.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = $5UMyJ(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $b562a383a327bea1$var$NAME;
        /* falls through */ case $b562a383a327bea1$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $5UMyJ(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $b562a383a327bea1$var$COMMENT;
        /* falls through */ case $b562a383a327bea1$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $5UMyJ(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $b562a383a327bea1$var$HCRC;
        /* falls through */ case $b562a383a327bea1$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $b562a383a327bea1$var$TYPE;
            break;
        case $b562a383a327bea1$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $b562a383a327bea1$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$DICT;
        /* falls through */ case $b562a383a327bea1$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $b562a383a327bea1$var$Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $b562a383a327bea1$var$TYPE;
        /* falls through */ case $b562a383a327bea1$var$TYPE:
            if (flush === $b562a383a327bea1$var$Z_BLOCK || flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $b562a383a327bea1$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $b562a383a327bea1$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$LEN_; /* decode codes */ 
                    if (flush === $b562a383a327bea1$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$TABLE;
                    break;
                case 3:
                    strm.msg = 'invalid block type';
                    state.mode = $b562a383a327bea1$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $b562a383a327bea1$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$COPY_;
            if (flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$COPY_:
            state.mode = $b562a383a327bea1$var$COPY;
        /* falls through */ case $b562a383a327bea1$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                $9CLQF.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $b562a383a327bea1$var$TYPE;
            break;
        case $b562a383a327bea1$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $b562a383a327bea1$var$LENLENS;
        /* falls through */ case $b562a383a327bea1$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $bxjQM($b562a383a327bea1$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $b562a383a327bea1$var$CODELENS;
        /* falls through */ case $b562a383a327bea1$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = 'invalid bit length repeat';
                            state.mode = $b562a383a327bea1$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = $b562a383a327bea1$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $b562a383a327bea1$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $bxjQM($b562a383a327bea1$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $bxjQM($b562a383a327bea1$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $b562a383a327bea1$var$LEN_;
            if (flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$LEN_:
            state.mode = $b562a383a327bea1$var$LEN;
        /* falls through */ case $b562a383a327bea1$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $6OFFF(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $b562a383a327bea1$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $b562a383a327bea1$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $b562a383a327bea1$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $b562a383a327bea1$var$LENEXT;
        /* falls through */ case $b562a383a327bea1$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $b562a383a327bea1$var$DIST;
        /* falls through */ case $b562a383a327bea1$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $b562a383a327bea1$var$DISTEXT;
        /* falls through */ case $b562a383a327bea1$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $b562a383a327bea1$var$MATCH;
        /* falls through */ case $b562a383a327bea1$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = $b562a383a327bea1$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $b562a383a327bea1$var$LEN;
            break;
        case $b562a383a327bea1$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $b562a383a327bea1$var$LEN;
            break;
        case $b562a383a327bea1$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? $5UMyJ(state.check, output, _out, put - _out) : $gJUj4(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : $b562a383a327bea1$var$zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $b562a383a327bea1$var$LENGTH;
        /* falls through */ case $b562a383a327bea1$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $b562a383a327bea1$var$DONE;
        /* falls through */ case $b562a383a327bea1$var$DONE:
            ret = $b562a383a327bea1$var$Z_STREAM_END;
            break inf_leave;
        case $b562a383a327bea1$var$BAD:
            ret = $b562a383a327bea1$var$Z_DATA_ERROR;
            break inf_leave;
        case $b562a383a327bea1$var$MEM:
            return $b562a383a327bea1$var$Z_MEM_ERROR;
        case $b562a383a327bea1$var$SYNC:
        /* falls through */ default:
            return $b562a383a327bea1$var$Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $b562a383a327bea1$var$BAD && (state.mode < $b562a383a327bea1$var$CHECK || flush !== $b562a383a327bea1$var$Z_FINISH)) {
        if ($b562a383a327bea1$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = $b562a383a327bea1$var$MEM;
            return $b562a383a327bea1$var$Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? $5UMyJ(state.check, output, _out, strm.next_out - _out) : $gJUj4(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $b562a383a327bea1$var$TYPE ? 128 : 0) + (state.mode === $b562a383a327bea1$var$LEN_ || state.mode === $b562a383a327bea1$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $b562a383a327bea1$var$Z_FINISH) && ret === $b562a383a327bea1$var$Z_OK) ret = $b562a383a327bea1$var$Z_BUF_ERROR;
    return ret;
}
function $b562a383a327bea1$var$inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $b562a383a327bea1$var$DICT) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === $b562a383a327bea1$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $gJUj4(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $b562a383a327bea1$var$Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $b562a383a327bea1$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $b562a383a327bea1$var$MEM;
        return $b562a383a327bea1$var$Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $b562a383a327bea1$var$Z_OK;
}
$b562a383a327bea1$export$42de45683a92ba94 = $b562a383a327bea1$var$inflateReset;
$b562a383a327bea1$export$7633ac2cd30f9650 = $b562a383a327bea1$var$inflateReset2;
$b562a383a327bea1$export$6710ea52c4ec9d6a = $b562a383a327bea1$var$inflateResetKeep;
$b562a383a327bea1$export$9c140b25e26874f9 = $b562a383a327bea1$var$inflateInit;
$b562a383a327bea1$export$6792d92addc5c8a0 = $b562a383a327bea1$var$inflateInit2;
$b562a383a327bea1$export$cae1ce83fe4a1782 = $b562a383a327bea1$var$inflate;
$b562a383a327bea1$export$224e1a443c3fba76 = $b562a383a327bea1$var$inflateEnd;
$b562a383a327bea1$export$6d4647cb9e1c75fc = $b562a383a327bea1$var$inflateGetHeader;
$b562a383a327bea1$export$60da749bed98ccf8 = $b562a383a327bea1$var$inflateSetDictionary;
$b562a383a327bea1$export$220f6291ca35fd71 = 'pako inflate (from Nodeca project)'; /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ 

});
parcelRegister("6OFFF", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var $4f67bc996330e695$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $4f67bc996330e695$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module.exports = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = $4f67bc996330e695$var$BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = $4f67bc996330e695$var$BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = 'invalid distance code';
                        state.mode = $4f67bc996330e695$var$BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $4f67bc996330e695$var$TYPE;
                break top;
            } else {
                strm.msg = 'invalid literal/length code';
                state.mode = $4f67bc996330e695$var$BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};

});

parcelRegister("bxjQM", function(module, exports) {
'use strict';

var $9CLQF = parcelRequire("9CLQF");
var $86622ca50c32b2ec$var$MAXBITS = 15;
var $86622ca50c32b2ec$var$ENOUGH_LENS = 852;
var $86622ca50c32b2ec$var$ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var $86622ca50c32b2ec$var$CODES = 0;
var $86622ca50c32b2ec$var$LENS = 1;
var $86622ca50c32b2ec$var$DISTS = 2;
var $86622ca50c32b2ec$var$lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var $86622ca50c32b2ec$var$lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var $86622ca50c32b2ec$var$dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var $86622ca50c32b2ec$var$dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new $9CLQF.Buf16($86622ca50c32b2ec$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new $9CLQF.Buf16($86622ca50c32b2ec$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $86622ca50c32b2ec$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $86622ca50c32b2ec$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $86622ca50c32b2ec$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $86622ca50c32b2ec$var$CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $86622ca50c32b2ec$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $86622ca50c32b2ec$var$CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === $86622ca50c32b2ec$var$LENS) {
        base = $86622ca50c32b2ec$var$lbase;
        base_index -= 257;
        extra = $86622ca50c32b2ec$var$lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = $86622ca50c32b2ec$var$dbase;
        extra = $86622ca50c32b2ec$var$dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $86622ca50c32b2ec$var$LENS && used > $86622ca50c32b2ec$var$ENOUGH_LENS || type === $86622ca50c32b2ec$var$DISTS && used > $86622ca50c32b2ec$var$ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $86622ca50c32b2ec$var$LENS && used > $86622ca50c32b2ec$var$ENOUGH_LENS || type === $86622ca50c32b2ec$var$DISTS && used > $86622ca50c32b2ec$var$ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};

});


parcelRegister("hf4Xu", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};

});

parcelRegister("9t6AE", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $6e4bef2851e6b301$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = '';
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = '';
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
module.exports = $6e4bef2851e6b301$var$GZheader;

});




parcelRegister("3uXKw", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("7ybLn", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("fCZVO", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("cOHfc", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("eVbDh", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("g9ZKL", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("hgkij", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("4W9K8", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("gbK7N", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("lan6Z", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("1zetG", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("53nEH", function(module, exports) {
module.exports = JSON.parse("\"eJyFnVtzG0mOhf+Kgk+7Ee5ZSdbN/aa+ebzuMdvupmjORD9QUlnmmmJpSMoSZ2L++9YNwMEBkn5xuL6TdUkkgLxUFvXv0Y/1/X212o6+H1397XEzv6sOTl6+Onx1cHry6uXJ6MXol3q1fTe/r5oCfyzuq813H+r7+aoVHpdLFA5UmN8vljuUGjitFnef27tIqTfb+XJxc7m6WzbFDpvjzS+L5+r2t8X25vPo++36sXox+vHzfD2/2Vbr36v21J+ft9XqtrrVGzWP9sMP9fPo+398d3R28eK746OLF0eHh4cvLl5d/PliNGkKr5eLVfVbvVlsF/Vq9P13jQzCH58XN19W1WYz+v604VfVetMVGx0eHv+luVBzk3f1dnHT1uTH+mG3bitx8F83/31w9Ori9EX773n376v231eH3b8vu3/PDy5v6+vq4PfdZlvdbw7erG7q9UO9nm+r278cHFwulwcf2qs1dqs21fprQ3szLjYH84Pten5b3c/XXw7qTwe/Llb1dvdQfffXqjnr8vXBfHX7P/X6YNGcvHm83ixuF/P1otr8pXncn5vb3C5Wd7/ffK66Buie4vdtc8p8fStqU/DH+cNfhzY5Ozt+MfooRyetJS43N62p14148fLF6KdKjxsjn78Y/b69/et09P3xRfffq+a/Fyd9e/2t2q4XN41B//Hv0fRjU6S93LvmQTYP88aO/3nR45cvX/a4er5Zzu+Vnxxe9Pyfj3VjqeulKqeHw4VWj/fXbUPdraJ2Wy+X87XyC7nLQ7W+ab1chPPz4Tbz+0baNNaJT9Y9QdfiUXuYr6vVsvpUkvxp+njzTXvFzRdTzk6Gs5aPG6Vqs5smOOfxFp93D5+rVSzeVGVRW02OpZKb5XzzOT7Nv6p1HWm9qiLcPiUlt5/XVVL2U/24Tujia1J2s3hOYPW1Stq2ym26WsADa5Vv6mW9SixR3S+8pC2wbNNAoNU/H+fLiO/WVRPIVs2TkxNxmmrTpRpRXh0fDW0P3nd83LNLRWdn5z36IaIf44k/Wamj4fo/21OenvXol3ji64j+Gh3sjaEmtXXof+OJb+ND/GqhJyf+LZ74LqJxfPrfYqn30Tgf4om/x+f6I15rEtGVtZq05zSW+hjRLN7x79Gq101n9qXaurShnnndaD5O+TyfU07OXklOuVksbhbrm0fLohocj23S3jQ9T5J5u/zmHka9eB6vdB1L3ST5N5ZK7vwpnngX0edopEVE/xdP/BJLWQhr5k+slSSdJO09RPTPWEfLDRpCm/hcST57jOhr9LinWCrJpLvYHP8ydHFo/uUd4VhbHTpTX556uJMj8MbtYnlb7Opv66fEzq53tp5g243TzDmOJOw/tQNDzLNW56zv+LSs14uEb6rCVW4e1003fmMGPJLad2GzWXQD1yT996MWZ01z8sdFo9zX23zk0Mrdhb8hk+kl7X1aJCwZPzUDuXQ4cDu/u6uSnrvnOBSjAUfbdtW6gtg/tbHQ/G49f4CkJqdeN9OHKqmlmfd6vtlj4f1qYfylDeD1bs7Q22a5XDxsFptEauq6/Vw/urFi6Padc1vLredfk3iY3zxuE9zn8k/L6jlqhci6n9+s6+TG1+squ/FtvZ3fuIgzadG0JBrAEhrGoT1sdduYNBujPq7u5uvH++X8MblNfdcMM78kl5tjPaBd7p3P6uDi0kY9x+eDz9fr20/NMM+NC22A4vtYG394rjcY2w1eHh3qDe6bPPe4dHeQzDRPRqO3bchvNkn3tSyMzevCc9bJILqJzmZC3Hh90mpvQoNax+z9zzp/7zXWMaVNapfzbWdjo/AEOoq+XXxdgDvbKf7JbLichIY9duGkSXKSdRYUg9pVdzMvChKoaryk3c8FiuFyQ8wpGuwc/3TWEnSCzQHCTWzG0GQImIL4KSZV9PxMxWHNI7kV5RwbFXo/sFrmdnmXPYCFR8lHfUq1cX52NZtIla7m0yqYMyZK8xBXTeCUEW3wSnc/H+6yrP9Vre6STPKhEFGvs0qac+wNkn2ee1nqRtaFJr3hutrsJ1pOxyR/fK7XSa3GdHczA0WBTvOIX0iyLZhtQjcwi/muzS1vbB67Mc46eV7vgmbFEqe0Kknw/nG5XTwsd8lz+QqCk/vmkI6vGW1tF/Pl7eJTMsHalVPDO38fc9jEWSw29rrZnl6nLN0U0t2qlAapQSGnzFM/fkMXwsW3ZsCAK3A6AVrXX6oVToM0Oa6ru8XGD3wtRAsjrzcxLs50LvLYRLWbjZixCyPIdcEyNceSxmXBpf7uLXZ68kpGrt06l18F01r+vLURiiXZYgJcZnnr5fHgvdtCkqmKvWNJuCwNH/Z4pTewzZZLoVG697jUIqWuh3Ou9iOlO5fjeLx3WMI9powLquU2We7ZuiRtOfGp3pMR40hPzrt/TGrin8hMlY4zLRbI9DZP9SOc81PM440DrxtHhkfTbiRMYaRtloWO5G06yNAZhm+4V7JuoK90spxYnpC9KYT+m1KI/0pPLWZojPZ5voSeQWK8nZnQMrc2xb6x88qPmszTvtF+hUioSt3znc+lWKGhVbNG9fnMeDbcVQfOZzjqYE2WyF541BRalgnn+XiDks2pZvPbxU2WZ38q9GfrvbV559vHHpdGuzbc3OvWe+91WfCFy2KOzmcDY38dy8NJv2kjkUJvX0oUX9Lxs47H3EDArrY3FPwj2PLu3jst67u2vVd1Moqvy7n0MUoSys2lCpF8t3fOUEFHbjYvuO8q7cbh9WHoISzll2L858f2VeSfL0Zvq/Xqt/li3b5A/sfosn1RPXrx3cnhny+Goz57ONQ/p0dDTkf42h/1WcUhrBgK4+bo9FSP5BEAgXM4rk3laB//DrnM45TBZI71i0MO9YGD6L07+qM5Ojo60kMxmmOu/qBM3KUm0QCTggEmqQEm0QCTogEmiQFk6OdYl1GQXLWVeKmH0+bwlbbprBUPVZxJnZDBwwOGfQHOSF+bw/MTOXpq73YsRzt/JDcDBPca6FAIA0ARRYFyCgXjHA+ivE4QRYbyNDxEhRhRRH6iPHMWFaPHqERuozz3HZXZgVSgMFJOsST8fUQYVco4tExI40vkSbw8R5ryfRZMYk6lggUL0adyyYIhDlXwwSgYI1IYhKUgjE1lHKAqJFEqWhqqIkK8CoKgFbRLEIWv8hjDQyhhDCuiGFZOMWycY1iU1wmiGFaexrCoEMOKyAOVZx6oYvRAlcgDleceqDJ7oAoUw8ophoW/jwhjWBnHsAlpDIs8iZfnGFa+z4JJDKtUsGAhhlUuWTDEsAo+hgVjDAuDGBaEMayMY1iFJIZFS2NYRIhhQRDDgnYJohhWHmMY2wkD2XOKZi9SSJPIce3k1yVOEe7FNMxdEYh1z8ldvZj5rC8RHdfr5L1ezF3Yl2E/9iqlAy9STnDi+wLH7OAFThGkpnnClZkUbskZw4vfbIIkd3h9XxMUsogvs7cJQj7xqk8qTsPM4gRIL45jjvECJxqvJtnGFUhTjisBecdxSD6O70qc0pAXYy4ygpkIKeUhlCgLOYlzEIivc0r5B6U0+0AByD1Iye1Rypwe9ejyqJLDo5S7O5ZgZ0eNsg1KlGtAep9SzDOIOcs4Lc0xUGKS3orzC0rfMHSSW1AtG7qQV7DEHkOHnIKazyigYD4BDNkEKOYSxJxJUEvyCMhpFgEdcghQyCBAdzml7IFSzB1D42DiUERZQzmlDOOcL0R5nSDKFMrTNCEq5AhF5LfKM6dVMXqsSuSuynNfVZkdVQVKB8opFwh/HxFmAWWcAkxI41/kSbw8R77yfRZMYl6lggUL0a5yyYIhzlXwQS4YI1wYhLcgjG1lHNgqJFEtWhrSIkI8C4JgFrRLEIWx8hjDYjgMYmMUxSZQGIPAcazS64xRJJuQhrLKEMvGyBVNyHzR1OiMppE3mpC7o+nsj6ZQSJtAMa3C+4RhVBvksAYljWvVJ8ktOLJN2GvOJLZNK5mzEN2mF80Z4tsUH+DKMcIVQogrwxg3yEFuShLlKqZhrirEuTIIdGW7jFGomxBjXWyFsW6MYt0EinUQONZVep0xinUT0lhXGWLdGDmnCZlzmhqd0zRyThNy5zSdndMUinUTKNZVeJ8wjHWDHOugpLGu+iS5Bce6CXvNmcS6aSVzFmLd9KI5Q6yb4mNdOca6Qoh1ZRjrBjnWTUliXcU01lWFWFfWxvopheguY9pMLGBD9Np6+CjbAkoIxblginLFHOOD8DoSim/BaXQPIsS2EHJFwZkjihbdUBRyQsG5C4rKDiicolkwxfKA3weCcSyIo1h5GsODOgmX5vgVvMdoSeyKkhutELeiFowWYla4j9iBYrwOCKJ1IBirgjhShSdxOkhplA4axOhAoDceyC4S6okFx3548BgMTkUUncopPI1zfIryOkEUocrTEBUVYlQR+ZvyzOFUjB6nErmc8tznVGanU4FCVTnFqvD3EWG0KuNwNSGNV5En8fIcscr3WTCJWZUKFixErcolC4a4VcEHrmCMXGEQuoIwdpVx8KqQRK9oafiKCPErCAJY0C5BFMLKQwz/0NDL5qivcnck5wKSeAPk2hc43AGotCogbTFg2ljAhnYCIs5vaNJZVo+sIRS5xwXumkapPC4g8j9QtCLAtCLAhor05KfB7id25DPmT2h3QK4iwKEiQKUigPRxgenjAhseF4jY3dCVO2rj5KUezTS4fsLgABSywLCb11lGEZlHOdlIeWYoFaO1VCKTKWe7qcDGU8FbUDGZUfhVRGBQQbNoLDat8sS+3XcA3r6C2L7C2b7CU/uKmNhXJLav8GBfEYJ9RSD7Cmb7DvwqIrTvgGbRWMG+woN9fxlM2+fsX9CqgMSggJwtgcMdgIoFAanxgKndgA0mAyLWMtSOwY60PnNNpoakBoB8fjWO+dWo5ldDlkWNWRY1JlnUiNTAUP/jUC++uzgUUju9jnWqCxWo0wrUsQI1dxCmJFWrZWAHKNZj+NUqqcj/Du51ZkdSEUDSOIBc3YBD3YBK3QBpDYBp4wAbGgeIVKpHb0f9MPylHelow5AfWhjHoYVRHVoYoqYAxQYdxqQpAOkIQ1F7dHyqR/LUgGRMjQgrAhwqglQ/5HBY6gdIawFMm8NYrWOkt+j0gJJB3FtyeqB+EPc2cXpQaHj3Fp0ekB/LtehRQ6A78qHaoSRUOx5CtaM+VDuUhmqnUKh2jLJQx1wWasnOWX4X/WMXG91NtjAuSKAQITWLFioSA4cKUAyRmocTFeLIIpmCjFSKN69WJYtxFJJKAclqEptU5FstlkUslaDgJZXjmGQOaS9DdJNAgU5qFvNUJIY/FaBMQGqeFKgQ5weSKVWQSlnDq5BASKBcQmqWVqhIzDBUgJINqXneoUKcgkjmbESyT0xe3JVcidMVqSEOfh3160r9EkJ3JMGGyK0lmdAtsRweyuFUB5+/jmRhRUVYUzHm5uyK3UqK3a17/6BPvfNj+V+pegPFb1iGK4VPWALPauu+7hgeFb/uGOrtv+7wxYIF8q87vJbZAj/boHqyVbLPNgZJJpfZHUTbxeJ8B+XJHZzzQROQQA3BatYcvgw2ilegabwwK54SmonkpLF8idSgIXxTGwXjFsN3KDAkVzSuIjKr8cygoqIphYERBc2SYsFwKiQmEy0zlmi7WE82kPJgmncjXA7tjnxv2iG/HNqhpFfteOhKO+r7zw5Rf9gxWg7tmFsO7YjvDN9J8F4miOqinCqkPKuVirFqKlH9lHMlVeCaquCrq5jqjOuGjKjOYd2QeVbnbN2QJapzXDdkgevM64aMuc4uyi+LAtffq2wFr6a28EUSi/gCbBevBut4OdjIy2QpL5K95B3IZYLIRsrJOsozu6gYLaIS2UI5W0EFrr8KvuaKfZ3HrrrjWNNxrOS4UL9xWrVxrNU4qdA4qcs4VGOc16DtpfqF2zF2UIiS177joVs61aOpu+pHV3LmStqKryHsKnoaE+24kGjHhUQ73pdox+VEOy4k2nEp0Y5LiXacJ9pxIdEqhzYJI+PAs9bBkTHZcxpv9zGeOIsncrNlI+VBcl8TQQN6Tq3oRWpKL2bt6UvERvU6tawXuXm9ym3sVd/QXqPWDp/7nSTW43bf97FfVuSq0CrTwnN8LFxnVrgOe0Xxg7dBh09FwDGQklugRE6BUuYSqEeHQJXcASV2BtTYFVDzjoAKuQF9i3US7MQuUP4SKxa4Si0/Te/+Mb3CLL0CN3vh66RBlQ8LoMUVUXMrp7ZWnjW0irGVVaImVs7tqwI3rgq+ZRVTs+KXNSfeDNyghe9qSL2K9pzG232MJ87iidx82Tcog+RX1bAJWaGWZJkalOWsXblMbF4uQa3MMjc269zmrPumZ5U8gGRwBFbIH4KcuQUVuiq22LT4RB+LV5sVr8aew3J0IP3UAFzHGDmNCeQuJmSOYmp0EdPIOUxgtzCFHcIU7wrGyQnctzgnZBFu+NKXOCxfJdadJvf8mJw7S87lRk2/Vhk0Wd2B1lREjamc2lJ51pQqxpZUiRpSObejCtyMKvhWVEyNiCt6J94M3ISFFT1Sr6I9p/F2H+OJs3giN162wjdIcZI+LkzSx4VJ+njfJH1cnqSPC5P0cWmSPi5N0sf5JH1cmqTjTt0TbwZuu8I+XVKvoj2n8XYf44mzeCK3XbantZd+G5qtX479DVsMkDQWINdOwMNe1d+wdQBpwwDTNgE2NAcQaQlDtvmpO/JvDDvkNz91KHlz2PHwurCj/h1hh+idX8foRV/H3Nu9jvhNQy2SzU/DZuIW6T6igb0f4ZbZ7shvme1QsmW242HLbEf9ltkOpVtmO4W2zHaMtsx2zG2Z/TDqN0mc2JHfs9ihZFtix8OOxI76zYgdoqcGhXYodkzeUwPy+w8/DJF9ZkcS1IhcPJswcdeZxPpOCvWdpPWdxPpyK4GS1HdCmzE/QCsZaRPQhR61uad/u/JhyDFndqQb2AzhrrSeykIOtL4iMonyzC4qRuOoRBZSnptJZbaVCuQgyslLcGHtjBD5S2FhjdRJvDa7j/J9tkocSaWCrQoupXLJVsG5VPAehmuHFx6Br+FCIfkRe122UDhI8vYFXE8RmVN5Zk4VozlVInMqz82pMptTBXI95eR6wsH1FJHrGc9cT9RJvDa7nvJ9tkpcT6WCrQqup3LJVsH1VPCuh5v1LzwC18PN+uRH7HrZZn2RwvZAeYh8e2CupgYubg/MC7Cx924PzAsFw+fbA3OVHTbsEDlLBXbefTtE0jKT0j2DO3v12zbPXNsX2Gvzkpv7QvttHl3ey+T4YevMRSZgEISdM6lfh4Ao7pvpC/wxGqYZL/VIpxmGdJphyE8zjOM0w6hOMwzZNMOYTTOMyTTDiE4zFLXRfHShRzr6NuRH38Zx9G1UR9+GePRtio2+jen3CIZ0aqHIvqnojuSpAYndAbmKAA8R0FHv9h0iN+6Y2h0uONgdiM8bLer/wrVMWXvST5f6rUotac84V103GQOSxILIfcFjPGy97ilsHIbC+mGPIdpW3TH7sEfZ8HfPZSbbosVIpvzdkV896RCtW7SsdgasYwvXhebEPcNApUaAyC9B0boCE78EJK1qSOe31ohrV611rP1aGhGR6xJMsL+NLtmtpe0+4xM70i7BkO8HjKPrG1XXN8Rp3hQLCmOW0I1JFlfy5Cy380exvXexXXGz1ZDRwmYr5pSP881WLMbMHDZbMeccHTdbseCzddhsRRzydpgGMM8yeDYNYIlyeWkawDJn9TANYE75Xfg8tjRneuWU7pVnSULFmPhVouyvnLsAFbgfUMF3BoqpRxBO3YJh1zcIhhStiHoJ5dRVGI9f7ZgYOw2TYs+hGnUfyrkPUYE7EhG4NxEOXYoiyqzKuXMRoY6twt2M8n1ulHQ4KlGvozzvelTm/kcF6oSUU08knLsj4etoDe6YlFPvZDzrokRN+imRoLNSRD2W8qzbUjH2XSpRB6Y878VU5q5MBe7PVPCdmuCn2BK7BBWcLevowg5b6Q3yHba5yl3fnh22eZGkG8x32OZq6BILO2xzmbrHfIdtqmJXmS9Y5GrabRYXLPIC3IXuXbDIC4XuNF+wyFXuWp06L3lY6Ga9yp2tV9Nc6YskHa8vwN2vV0Mn7OXQFXuZOmQvcrfsVO6cSfRdtP+CEro2L3B37VXutEnNum5fJOnAqUDSjfsS/pNcVu33HlI5dOxODt27U7GT9wL3VV4NHb7/ZLPU9qHz9+q33TobCPgCPBzwamFQ4AuFoYGXeYDgVR4mODUMFpy6LtkzDBy8ysMHUtNBhCuTDSVcARxQeIGHFV5NBxe+SDLE8AV4oOHVwnDDFwqDDi+HoYeXaQDixKdSS++Kwt4QiAOTyTAaObEjvx49wXEHoGRdekIjDKC+N5i4sQQwWkaewKgBiM/wsn6O1QjfTjCnCuXfTrAYqxa+nWDOlYzfTrDgqxu+nRh4+OYg5VT7/JuDVMzsUPzmINXJIoVvDlKVbZN+c5BqZCXafp9QslC2/T6RMusUtt8nKlkm3X6faGyVZPt9opBFcG86I7JF2JvOPLNCtjedJap/3JvOAtec96Yzpjone7oLClmgtKe7IGf22LOnu1CCrFPc013Q2VaFPd0FlSznNjMHRtaKm5mDkFko3cwcNLJKspk5KGyJsJk5cKq9/pL0Zcao9iZQ7U3Iam9qrL1pVHsTuPamcO1N8bU3TrUffqn3MhKquWCqt+Cs1qLFOotCNRbM9RXOtRXu6yrU1/RqqOXwS61XWEVkulcTmF9fAAFXFQDrWgIwWxwAaBsYAcoORkC6OGCs/Y3jIzvyW0w75IfsJoydTWgvSIeSxux4aMiO+kbsULrXoFOoaTvmd3J0KLYd7E/tDrXtgKkRgPm3rMbxdxKN6nq4IZs3G7N2gztJuwHSX0pUJBOkfurWk2Hz7fErQVSHKqmrLTgAyqtapVV16wl44WiCKjFBlZlAVwmGH99oWbs2cGZHunXDkP9ZLeP4G0JG9eexDNlvYhmjnxpsWe2NbL/oCMxHOgg4ozKqywSGeKUQrmErAsZ0URDK6eRfke3GtmI43TZvaufY5xrqOrEG5L3EOHqJUfUGQ1RDUMxPjNm6kjH5SdGOTCUx9603dYkZmAY3MGouEzAxA9bEDMwSM0DzboAS4IA0MRvrFrHtyO+Sn4b0Cjzskp9iegWU7pKfuvQKTF3MkD62Ilthno7CsvJ0FNaSpyG3Ag/LD1PMrYBojWw6iovC0xGvBE8xsxqSWHh5bqTPrP2a5XRIrHZGFWupaRVRXssq9IZTTqtQ2HeSU5dVgSWV16R6puGycCctfA8+denPWO2uWse6ZwunU859RmNz5uui01FcDJ2OwgrodBSWPaeY+awRMfFZY7eJ71RP08QHyP95AePhs6QpJj5A/PcETLE/JWDM/oqAMfkDAkraBb7zl3qk6doQpuWOzny+nCX5cpbky1kpX87yfDlL8uUsy5ezLF/OYr6cJflyNsIfMZ1hvgSUvD2ZUb4E6t+CzJJ8CQrtc5hhvgTkf2x0NuTLYZQzw4SJTFsAGOV+E3DXqlH/w8ozlzOBwYdQBvVLKEP+p5VnkDX78JqNwnh0NqRNuEyVVFYTp2OFylZpZf2IFEpHI1SJEarMCDYi7UepsyF79u8nZpg9AdEfAJkN2fPoSK9rg0dgvrogYAwb9XtvZkkCxWvQ67sZZlAsp1MORTx4nFEOtaZ/9IZ6pHnHLGRRFMIsY4ZpFFCopEk00Zi5PIoF/VxrpuvnkFrCy4EgcIbMXw8ENcmV4QVBEELWjK8IgkL5M7wkYAEyafjWjXmWU7Nv3Vii7Fr61o1lzrPhWzfmlHGFY9pVxulIBU7AKqSJSdWYnVSiVKSc85EKISmpQulZOeVo4RSthn22Fp5VO+RtFTh5m7DPUEkaNynJ5SoWrBiyugpFK4b8LgIkeUWU6ZVzuhcBc74yTvwqpNlf1dgFqET9gPJCZ6A69wgqcLegAvUNwkMHIULSS4j0mNg89BcqpJ2GqrHnUIm6D+WFPkR17khUCL2JKtSl0EtFybXZW8VM476l+F4xK5D0MNmbxUwL/Uz6bjETqbfJ3i4mGvQ5SKnbQSnreVCPnQ+q1P+glHdBWIJ7IdSoI0KJ+iKQsDtCzIkWNe6UUEvTLRaIGRdVyqsocWpFLWRXFKmbQslWkYJGWcMpvsMCqXCt0G2hxj2X075hzaT/cmrShaFetnboyFDbZ+3QnYEGPRpS6tRQ4n4NNOzaEHPvhlrawWGB2MehSt0cSoWeDotwZ4ca93eoUZcHUuj1QEs6PlAf8wYK3R9qaQ+IBWIniCr1gygVukIswr0haqFDRNH3iU3Ydn9fsu8F2qN241r/YlFSHhYQBKWG5IelBEEpt9sHijoO5eGRoTRQKCvbR6CgICiluwWgmDIo5/629VDO/W3roRz8dd2hFPx13aEM/gnPoRD+Cc++1DV6br+4ez245LEdiScCSt6yXZPfAfVv2a4TPwOF3r9dO7cCNniTka9arZtRvxYKRxpNhnBc1FNxsV2C6ALK41Xw2w9GdJXs2w+R5M8Ru+sY5CuZEq/Vd5L9Hy24vV7K3y3os5hTvdRW0H7uqTvyOwM6lO0MUM/Toyd39OxK7vyRr1puZenG8fkU0UMqT5/UpRqPniJ6jifuEkRVKHuLDDmwHoqoHsrTeogK9cAPkwg9xxN3CaJ6lP3VDY9cZRznGjkxr1bI3gl/KvDnwnV2Jc71dWKsNHQKdzmlCqOUVpc7n0CfUvqcXmGXU6okSkkVbdzq6oiYK4laXksogdUE/JTj5/wiuwLmqqIW6ypd912CqI7K0/q5YYFHTxE9xxN3CaK6KI/10LHFXcaoJiakVfFjF2JPCXtOzt1ljOpjQqyQDoLuMkYVMiGtkB9kEXtK2HNy7i5jVCETQoU+jWS2r0d+Z0eHbG6vKNns0fGw2aOjfrNHh2hLR8fohw875n74sCN+l0eLmmhaVptNN5VU+Ekt2B4tdITWHfmR5CcadfQTy7vBNnagk1IlYhkj/nW8Ynwbr1BfxiuxN+6KbLqrSN63KxCT9ESmHvNIfA0U+2ooTuqiWqiQKr5Wiqlqyql+yl0llfqaxs9JU+5rXfiYNBUTC5Q/JU11b43Sh6SpSpbJPyNNNWcl/VNgeuDsEf78VwsXLi0t4tB0URgOLdJxwyL2Q4skny+SlNgeWbR3Rz5DdcjWywzFDNXxkKF66lbFFPvE1SFKXB2jxNWy2h/FZ64LD1inD1jHJwnrS6Ykz1j7/XId8pnUdydJR5J3IV/il8bD9QpfGucqteC+L43zItFse740zkuQjUtfGucy+0D86jcX9poldZLyV795gb3VKnhR6avfXCbfKnz1m6q7kiOx85W/Be0LLIdRU3+XpVul61H8OnUQ5GfYDUleOtEje85kzJiPFleYNocrxbn6qjBXX5Xn6iucYg8XjpPnVWHyvCpPnlfeRHj5QqOxwLf6RqOtcHVwuJWgXSzFl1ceLlyPcB2udiPqWi5+qEc+CGu+ZE+xOYfrxgWa2rWwP5Fvk7ZwL4XudbhhYbWhjqsKyXX4/uVVhV6nvnx4hHQNoObZfrgC37w02+9VHDAM940T19rNUv2JfLt0ltpL9B0h3JIUuDMpu+LV+DlYjo/jBkbDgyQT3dpPaulcvm0+qe01SX9wP8yIxx7t4ol8s+yvyg4SxvtwL3wbcOzRLp7I90pTQCc9uAs8xHMf8tOG1xCFVWove03OWFaf5Fvdi1SQ58hV/0kCq8l2di4CdcoL+E3urNKudpZpMz/L7qMGFv1O+E7NjbXHUnvM9C0b7TfQHuvsM80+u5SN8m2LwP+HL6HQ5Ubtm7LTw4ibB5xvc22pTu6xDwuv0dJVUsIP/pzmYyTWYZ0/p/6kS6bJRCHV3MMmJboJ7mnEfruB1/SGmSZvu3LVP05S4mF+U+Wm6ax9ETG1RyzxVWveWFf3pZwoudPTuiNd2zOU3aIVdBvHsV5M39n2lZOG49u6d2QXHtEDlN6ReZUfJez5G56Hf79yeB73ruvCI3qe0rsur/LzhB9AlOdJf7JLnsqJ+Gxe4Cf0av6c+c9eHWc3pmcefLRL0ER81CjWFTWP/Vqa13D9ySu6fuaxrZx5TpuDlMtqmae6TubwH2o3Jbo6QTixtYj2t6eEdH96ypH2t+BfeSI2JQwG6pUmzLsFz37E1B3porYhaQpAfseEcdwxYVR3TBiyfRHGbF+EMdkXYUTMbUgi4EyJze66Iz/h65C2BaD4Z6c6HqaFPcWFIMP+r1F1iP4aVcfor1G1rNZQ6o78y4UOJdtUOh62qXTUb1PpULpNpVNom0rHpEsGpLZXpHHeG/9phK+CntChAPlXQU/BoYCHkfUTOhQgWlx6cg4FzL0KekKHMuQd6mmEK29Po7Dc9hQaB3hagTpWIF9CexrFdbOnUVgsexqFFbKn2DjPLjKeY2Q8x8h4LkTGcxoZz3lkPMfIeE4i4zmJjF1ojl2s2I5HDIS5eLLlNip40p//+X+DG1I7\"");

});

parcelRegister("fhfja", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("enbPQ", function(module, exports) {
module.exports = JSON.parse("\"eJxtmNtu20YQhl+F4FULyMGeD7pz3AY1ChtG7NpFA18w1NomIlECSRcxgrx7SVk7+wOdG8H5OJydf2Z2d5gf9cV+t0v9VK/r+6vXsXlOlbHe28paq229qj/t++m62aXZ4J/m8PRb1z9/baZxefK63Z6eXN5dVMvTCh83u277xr/6kLrnl2XNq7TpXnczuZyabdee98/b2VzM/x4/dd/T5qab2pd6PQ2vaVVfvDRD005puE3Lu7eH1HbN9hTjx4/77/X6y5lcnUmjVzHIVVDicVX/1W/SsO36dLMfu6nb9/X6TAoBD+5euvZbn8axXtuZ36dhPJrVQqgPQoh5hev91LWLkIv94W1Ygq9+aX+tZAx2tfz64284/sblN/rqfLP/mqrbt3FKu7G67Nv9cNgPzZQ2H6rz7bb6vLgZq89pTMO/M/xfEqturJpqSM/d7GJIm2oamk3aNcO3av80O5xh3yyKmm1193ZIT02bqovTKjP+MAf++7zsZvZ3276kYyWWXB0z99S18/PbafPHQ71W4fjn/fxnFO+ZvkrT0LVzTr78qB/+nk38bHM9exgP8zr1z9U7jt6840YW5uSJKcZOCaBBnKgm5mU8MVNYyMwWFvO7Ukagkmgg6sDWQ5yFFqjzUrLEaQ3BEmiwNsMSaZS0vgWfOkPHWQowNeTUc0kumnxZvsgPxlGai6VTGUqAVCTQ6QkWnc77DKEiLktSUBJKqHIQZ86d8gCpHYoiEzMsb1ubYy8vW50DChB5ZhGqrijD0EqUIeiaEHIfCg5Kpuu0ApiToaGPSY0uaQsyr65L2oKi1yFt1PLaQ3lzfXTgXodGoJYzglndSLDMPg1sTPJpQJHJigw0QrGERqD9YhyTOgONQDUyuF1zaxuokc/BW2ztXCMrGZ9WMW1oQZHIXWNBkSCfRZEL5BMUiZw6CzVSFCfUSGZFNjIldoKDkonTKQiJIGzWmFd3BizJJ9SINoLDriOfUCOZS+zg+KGD1qGiLNMLxtJD1/ns00ON6EzyUCM6vbxhoBKaqbG3DFQCNiL1iHccBPV0DHhQH/JW8EW90dkyFKGywCJU0WkVSvSGeiSUODWFFD0HYdPQVoiRgfPMA+/nnRgiAyNYSjpWNQcNSMrtFCUH4ZIRpSCWocFCSuhCEY6hoUClc0WC52BJlCYYLQdhN+hygRRRlo5BKRRLS6oihSqh+ZzzRGG1Mo4Iz1LoP0qsxDGFzk0JE42ji0jCPejomJKCuwil4m5CiRMEUMVSzVLDUstSx1Juc0oVWMpqY295qVltmtWmWW2a1aZZbZrVplltmtWmWW2G1WZYbYbVZlhthtVmWG2G1WZYbYbVZlhtltVmWW2W1WZZbZbVZlltltVmWW2W1QYjQCh7E2aAQHeGhCFgPoNoy8KNb2wxBhmGKBxoUZXlLGsLI6AsftEDHV0wIURVbANLcTKlGGBIKPOAxCmhePCKUwFzAmpDFRQvjA9R06Hq8TONvshgKDCuRAZTXigUxjxNFfKRo3CLhnIJBMFRvMZpqpNBMlQJzGT5WFQMVQI/AikPMIhEU1aDjqJvQwmjSHB05cC9jbYwc5UtAHNLhDw41ha+lEqF4JaH3gmB61SYcqInxTDmQK8v08vjqv4zDf1N0w3Lf4A8/vwPpfK11w==\"");

});


parcelRegister("90iSP", function(module, exports) {

$parcel$export(module.exports, "Encodings", () => $68e2c2ff57f5b549$export$c85030bb86979d84);
/* tslint:disable max-classes-per-file */ 
var $5JpfH = parcelRequire("5JpfH");

var $9zuq9 = parcelRequire("9zuq9");
var $68e2c2ff57f5b549$var$decompressedEncodings = (0, $5JpfH.decompressJson)((0, (/*@__PURE__*/$parcel$interopDefault($9zuq9))));
var $68e2c2ff57f5b549$var$allUnicodeMappings = JSON.parse($68e2c2ff57f5b549$var$decompressedEncodings);
var $68e2c2ff57f5b549$var$Encoding = /** @class */ function() {
    function Encoding(name, unicodeMappings) {
        var _this = this;
        this.canEncodeUnicodeCodePoint = function(codePoint) {
            return codePoint in _this.unicodeMappings;
        };
        this.encodeUnicodeCodePoint = function(codePoint) {
            var mapped = _this.unicodeMappings[codePoint];
            if (!mapped) {
                var str = String.fromCharCode(codePoint);
                var hexCode = "0x" + (0, $5JpfH.padStart)(codePoint.toString(16), 4, '0');
                var msg = _this.name + " cannot encode \"" + str + "\" (" + hexCode + ")";
                throw new Error(msg);
            }
            return {
                code: mapped[0],
                name: mapped[1]
            };
        };
        this.name = name;
        this.supportedCodePoints = Object.keys(unicodeMappings).map(Number).sort(function(a, b) {
            return a - b;
        });
        this.unicodeMappings = unicodeMappings;
    }
    return Encoding;
}();
var $68e2c2ff57f5b549$export$c85030bb86979d84 = {
    Symbol: new $68e2c2ff57f5b549$var$Encoding('Symbol', $68e2c2ff57f5b549$var$allUnicodeMappings.symbol),
    ZapfDingbats: new $68e2c2ff57f5b549$var$Encoding('ZapfDingbats', $68e2c2ff57f5b549$var$allUnicodeMappings.zapfdingbats),
    WinAnsi: new $68e2c2ff57f5b549$var$Encoding('WinAnsi', $68e2c2ff57f5b549$var$allUnicodeMappings.win1252)
};

});
parcelRegister("9zuq9", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});




parcelRegister("j0tvB", function(module, exports) {

$parcel$export(module.exports, "assertIsOneOf", () => $dd64e83d12710def$export$8883a3014ee46cd1);
$parcel$export(module.exports, "assertIsOneOfOrUndefined", () => $dd64e83d12710def$export$846079600c50354e);
$parcel$export(module.exports, "assertIsSubset", () => $dd64e83d12710def$export$dce66947695c582f);
$parcel$export(module.exports, "assertIs", () => $dd64e83d12710def$export$6fee1f82edcf4a03);
$parcel$export(module.exports, "assertOrUndefined", () => $dd64e83d12710def$export$92143017cb173fb0);
$parcel$export(module.exports, "assertEachIs", () => $dd64e83d12710def$export$47fbce961905bcd0);
$parcel$export(module.exports, "assertRange", () => $dd64e83d12710def$export$6698b6d148bc9b0c);
$parcel$export(module.exports, "assertRangeOrUndefined", () => $dd64e83d12710def$export$bce4080186be486);
$parcel$export(module.exports, "assertMultiple", () => $dd64e83d12710def$export$c9f5acf8e31d1a2e);
$parcel$export(module.exports, "assertInteger", () => $dd64e83d12710def$export$a59e49f1e2708383);
$parcel$export(module.exports, "assertPositive", () => $dd64e83d12710def$export$2cad8b74f3cf13dd);
/* tslint:disable:ban-types */ 
var $cbIAG = parcelRequire("cbIAG");
var $dd64e83d12710def$export$c7ce26e85cccb3a8 = function(val) {
    return "`" + val + "`";
};
var $dd64e83d12710def$export$1909b7b8a28995a9 = function(val) {
    return "'" + val + "'";
};
// prettier-ignore
var $dd64e83d12710def$var$formatValue = function(value) {
    var type = typeof value;
    if (type === 'string') return $dd64e83d12710def$export$1909b7b8a28995a9(value);
    else if (type === 'undefined') return $dd64e83d12710def$export$c7ce26e85cccb3a8(value);
    else return value;
};
var $dd64e83d12710def$export$2ac73c5d250d45a9 = function(value, valueName, values) {
    var allowedValues = new Array(values.length);
    for(var idx = 0, len = values.length; idx < len; idx++){
        var v = values[idx];
        allowedValues[idx] = $dd64e83d12710def$var$formatValue(v);
    }
    var joinedValues = allowedValues.join(' or ');
    // prettier-ignore
    return $dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be one of " + joinedValues + ", but was actually " + $dd64e83d12710def$var$formatValue(value);
};
var $dd64e83d12710def$export$8883a3014ee46cd1 = function(value, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $cbIAG.values)(allowedValues);
    for(var idx = 0, len = allowedValues.length; idx < len; idx++){
        if (value === allowedValues[idx]) return;
    }
    throw new TypeError($dd64e83d12710def$export$2ac73c5d250d45a9(value, valueName, allowedValues));
};
var $dd64e83d12710def$export$846079600c50354e = function(value, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $cbIAG.values)(allowedValues);
    $dd64e83d12710def$export$8883a3014ee46cd1(value, valueName, allowedValues.concat(undefined));
};
var $dd64e83d12710def$export$dce66947695c582f = function(values, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $cbIAG.values)(allowedValues);
    for(var idx = 0, len = values.length; idx < len; idx++)$dd64e83d12710def$export$8883a3014ee46cd1(values[idx], valueName, allowedValues);
};
var $dd64e83d12710def$export$e2b5c5db9e2009fd = function(val) {
    if (val === null) return 'null';
    if (val === undefined) return 'undefined';
    if (typeof val === 'string') return 'string';
    if (isNaN(val)) return 'NaN';
    if (typeof val === 'number') return 'number';
    if (typeof val === 'boolean') return 'boolean';
    if (typeof val === 'symbol') return 'symbol';
    if (typeof val === 'bigint') return 'bigint';
    if (val.constructor && val.constructor.name) return val.constructor.name;
    if (val.name) return val.name;
    if (val.constructor) return String(val.constructor);
    return String(val);
};
var $dd64e83d12710def$export$26b9f946b448f23e = function(value, type) {
    if (type === 'null') return value === null;
    if (type === 'undefined') return value === undefined;
    if (type === 'string') return typeof value === 'string';
    if (type === 'number') return typeof value === 'number' && !isNaN(value);
    if (type === 'boolean') return typeof value === 'boolean';
    if (type === 'symbol') return typeof value === 'symbol';
    if (type === 'bigint') return typeof value === 'bigint';
    if (type === Date) return value instanceof Date;
    if (type === Array) return value instanceof Array;
    if (type === Uint8Array) return value instanceof Uint8Array;
    if (type === ArrayBuffer) return value instanceof ArrayBuffer;
    if (type === Function) return value instanceof Function;
    return value instanceof type[0];
};
var $dd64e83d12710def$export$6e3e1e6304e79984 = function(value, valueName, types) {
    var allowedTypes = new Array(types.length);
    for(var idx = 0, len = types.length; idx < len; idx++){
        var type = types[idx];
        if (type === 'null') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('null');
        if (type === 'undefined') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('undefined');
        if (type === 'string') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('string');
        else if (type === 'number') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('number');
        else if (type === 'boolean') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('boolean');
        else if (type === 'symbol') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('symbol');
        else if (type === 'bigint') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('bigint');
        else if (type === Array) allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('Array');
        else if (type === Uint8Array) allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('Uint8Array');
        else if (type === ArrayBuffer) allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('ArrayBuffer');
        else allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8(type[1]);
    }
    var joinedTypes = allowedTypes.join(' or ');
    // prettier-ignore
    return $dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be of type " + joinedTypes + ", but was actually of type " + $dd64e83d12710def$export$c7ce26e85cccb3a8($dd64e83d12710def$export$e2b5c5db9e2009fd(value));
};
var $dd64e83d12710def$export$6fee1f82edcf4a03 = function(value, valueName, types) {
    for(var idx = 0, len = types.length; idx < len; idx++){
        if ($dd64e83d12710def$export$26b9f946b448f23e(value, types[idx])) return;
    }
    throw new TypeError($dd64e83d12710def$export$6e3e1e6304e79984(value, valueName, types));
};
var $dd64e83d12710def$export$92143017cb173fb0 = function(value, valueName, types) {
    $dd64e83d12710def$export$6fee1f82edcf4a03(value, valueName, types.concat('undefined'));
};
var $dd64e83d12710def$export$47fbce961905bcd0 = function(values, valueName, types) {
    for(var idx = 0, len = values.length; idx < len; idx++)$dd64e83d12710def$export$6fee1f82edcf4a03(values[idx], valueName, types);
};
var $dd64e83d12710def$export$6698b6d148bc9b0c = function(value, valueName, min, max) {
    $dd64e83d12710def$export$6fee1f82edcf4a03(value, valueName, [
        'number'
    ]);
    $dd64e83d12710def$export$6fee1f82edcf4a03(min, 'min', [
        'number'
    ]);
    $dd64e83d12710def$export$6fee1f82edcf4a03(max, 'max', [
        'number'
    ]);
    max = Math.max(min, max);
    if (value < min || value > max) // prettier-ignore
    throw new Error($dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be at least " + min + " and at most " + max + ", but was actually " + value);
};
var $dd64e83d12710def$export$bce4080186be486 = function(value, valueName, min, max) {
    $dd64e83d12710def$export$6fee1f82edcf4a03(value, valueName, [
        'number',
        'undefined'
    ]);
    if (typeof value === 'number') $dd64e83d12710def$export$6698b6d148bc9b0c(value, valueName, min, max);
};
var $dd64e83d12710def$export$c9f5acf8e31d1a2e = function(value, valueName, multiplier) {
    $dd64e83d12710def$export$6fee1f82edcf4a03(value, valueName, [
        'number'
    ]);
    if (value % multiplier !== 0) // prettier-ignore
    throw new Error($dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be a multiple of " + multiplier + ", but was actually " + value);
};
var $dd64e83d12710def$export$a59e49f1e2708383 = function(value, valueName) {
    if (!Number.isInteger(value)) throw new Error($dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be an integer, but was actually " + value);
};
var $dd64e83d12710def$export$2cad8b74f3cf13dd = function(value, valueName) {
    if (![
        1,
        0
    ].includes(Math.sign(value))) // prettier-ignore
    throw new Error($dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be a positive number or 0, but was actually " + value);
};

});

parcelRegister("iSBb0", function(module, exports) {

$parcel$export(module.exports, "pdfDocEncodingDecode", () => $dbea1b9ee80fa12b$export$ea426b9c784ba215);

var $7Kmy8 = parcelRequire("7Kmy8");
// Mapping from PDFDocEncoding to Unicode code point
var $dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode = new Uint16Array(256);
// Initialize the code points which are the same
for(var $dbea1b9ee80fa12b$var$idx = 0; $dbea1b9ee80fa12b$var$idx < 256; $dbea1b9ee80fa12b$var$idx++)$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[$dbea1b9ee80fa12b$var$idx] = $dbea1b9ee80fa12b$var$idx;
// Set differences (see "Table D.2 – PDFDocEncoding Character Set" of the PDF spec)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x16] = (0, $7Kmy8.toCharCode)('\u0017'); // SYNCRONOUS IDLE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x18] = (0, $7Kmy8.toCharCode)('\u02D8'); // BREVE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x19] = (0, $7Kmy8.toCharCode)('\u02C7'); // CARON
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1a] = (0, $7Kmy8.toCharCode)('\u02C6'); // MODIFIER LETTER CIRCUMFLEX ACCENT
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1b] = (0, $7Kmy8.toCharCode)('\u02D9'); // DOT ABOVE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1c] = (0, $7Kmy8.toCharCode)('\u02DD'); // DOUBLE ACUTE ACCENT
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1d] = (0, $7Kmy8.toCharCode)('\u02DB'); // OGONEK
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1e] = (0, $7Kmy8.toCharCode)('\u02DA'); // RING ABOVE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1f] = (0, $7Kmy8.toCharCode)('\u02DC'); // SMALL TILDE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x7f] = (0, $7Kmy8.toCharCode)('\uFFFD'); // REPLACEMENT CHARACTER (box with questionmark)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x80] = (0, $7Kmy8.toCharCode)('\u2022'); // BULLET
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x81] = (0, $7Kmy8.toCharCode)('\u2020'); // DAGGER
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x82] = (0, $7Kmy8.toCharCode)('\u2021'); // DOUBLE DAGGER
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x83] = (0, $7Kmy8.toCharCode)('\u2026'); // HORIZONTAL ELLIPSIS
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x84] = (0, $7Kmy8.toCharCode)('\u2014'); // EM DASH
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x85] = (0, $7Kmy8.toCharCode)('\u2013'); // EN DASH
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x86] = (0, $7Kmy8.toCharCode)('\u0192'); // LATIN SMALL LETTER SCRIPT F
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x87] = (0, $7Kmy8.toCharCode)('\u2044'); // FRACTION SLASH (solidus)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x88] = (0, $7Kmy8.toCharCode)('\u2039'); // SINGLE LEFT-POINTING ANGLE QUOTATION MARK
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x89] = (0, $7Kmy8.toCharCode)('\u203A'); // SINGLE RIGHT-POINTING ANGLE QUOTATION MARK
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8a] = (0, $7Kmy8.toCharCode)('\u2212'); // MINUS SIGN
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8b] = (0, $7Kmy8.toCharCode)('\u2030'); // PER MILLE SIGN
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8c] = (0, $7Kmy8.toCharCode)('\u201E'); // DOUBLE LOW-9 QUOTATION MARK (quotedblbase)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8d] = (0, $7Kmy8.toCharCode)('\u201C'); // LEFT DOUBLE QUOTATION MARK (quotedblleft)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8e] = (0, $7Kmy8.toCharCode)('\u201D'); // RIGHT DOUBLE QUOTATION MARK (quotedblright)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8f] = (0, $7Kmy8.toCharCode)('\u2018'); // LEFT SINGLE QUOTATION MARK (quoteleft)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x90] = (0, $7Kmy8.toCharCode)('\u2019'); // RIGHT SINGLE QUOTATION MARK (quoteright)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x91] = (0, $7Kmy8.toCharCode)('\u201A'); // SINGLE LOW-9 QUOTATION MARK (quotesinglbase)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x92] = (0, $7Kmy8.toCharCode)('\u2122'); // TRADE MARK SIGN
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x93] = (0, $7Kmy8.toCharCode)('\uFB01'); // LATIN SMALL LIGATURE FI
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x94] = (0, $7Kmy8.toCharCode)('\uFB02'); // LATIN SMALL LIGATURE FL
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x95] = (0, $7Kmy8.toCharCode)('\u0141'); // LATIN CAPITAL LETTER L WITH STROKE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x96] = (0, $7Kmy8.toCharCode)('\u0152'); // LATIN CAPITAL LIGATURE OE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x97] = (0, $7Kmy8.toCharCode)('\u0160'); // LATIN CAPITAL LETTER S WITH CARON
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x98] = (0, $7Kmy8.toCharCode)('\u0178'); // LATIN CAPITAL LETTER Y WITH DIAERESIS
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x99] = (0, $7Kmy8.toCharCode)('\u017D'); // LATIN CAPITAL LETTER Z WITH CARON
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9a] = (0, $7Kmy8.toCharCode)('\u0131'); // LATIN SMALL LETTER DOTLESS I
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9b] = (0, $7Kmy8.toCharCode)('\u0142'); // LATIN SMALL LETTER L WITH STROKE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9c] = (0, $7Kmy8.toCharCode)('\u0153'); // LATIN SMALL LIGATURE OE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9d] = (0, $7Kmy8.toCharCode)('\u0161'); // LATIN SMALL LETTER S WITH CARON
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9e] = (0, $7Kmy8.toCharCode)('\u017E'); // LATIN SMALL LETTER Z WITH CARON
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9f] = (0, $7Kmy8.toCharCode)('\uFFFD'); // REPLACEMENT CHARACTER (box with questionmark)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0xa0] = (0, $7Kmy8.toCharCode)('\u20AC'); // EURO SIGN
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0xad] = (0, $7Kmy8.toCharCode)('\uFFFD'); // REPLACEMENT CHARACTER (box with questionmark)
var $dbea1b9ee80fa12b$export$ea426b9c784ba215 = function(bytes) {
    var codePoints = new Array(bytes.length);
    for(var idx = 0, len = bytes.length; idx < len; idx++)codePoints[idx] = $dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[bytes[idx]];
    return String.fromCodePoint.apply(String, codePoints);
};

});

parcelRegister("clYSv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fe6ab59ebda0f6a$export$2e2bcd8739ae039);
var $8fe6ab59ebda0f6a$var$Cache = /** @class */ function() {
    function Cache(populate) {
        this.populate = populate;
        this.value = undefined;
    }
    Cache.prototype.getValue = function() {
        return this.value;
    };
    Cache.prototype.access = function() {
        if (!this.value) this.value = this.populate();
        return this.value;
    };
    Cache.prototype.invalidate = function() {
        this.value = undefined;
    };
    Cache.populatedBy = function(populate) {
        return new Cache(populate);
    };
    return Cache;
}();
var $8fe6ab59ebda0f6a$export$2e2bcd8739ae039 = $8fe6ab59ebda0f6a$var$Cache;

});


parcelRegister("11c5J", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bdf4392b99cfcf1$export$2e2bcd8739ae039);

var $nAWRe = parcelRequire("nAWRe");
var $0bdf4392b99cfcf1$var$PDFObject = /** @class */ function() {
    function PDFObject() {}
    PDFObject.prototype.clone = function(_context) {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'clone');
    };
    PDFObject.prototype.toString = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'toString');
    };
    PDFObject.prototype.sizeInBytes = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'sizeInBytes');
    };
    PDFObject.prototype.copyBytesInto = function(_buffer, _offset) {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'copyBytesInto');
    };
    return PDFObject;
}();
var $0bdf4392b99cfcf1$export$2e2bcd8739ae039 = $0bdf4392b99cfcf1$var$PDFObject;

});
parcelRegister("nAWRe", function(module, exports) {

$parcel$export(module.exports, "MethodNotImplementedError", () => $046ecf435f71da9c$export$b549a6777be1bc17);
$parcel$export(module.exports, "PrivateConstructorError", () => $046ecf435f71da9c$export$20e18464cd4b43a);
$parcel$export(module.exports, "UnexpectedObjectTypeError", () => $046ecf435f71da9c$export$ab03f98a62c22159);
$parcel$export(module.exports, "UnsupportedEncodingError", () => $046ecf435f71da9c$export$5de8fe8a6031fb92);
$parcel$export(module.exports, "ReparseError", () => $046ecf435f71da9c$export$df523155c7c35e23);
$parcel$export(module.exports, "MissingPageContentsEmbeddingError", () => $046ecf435f71da9c$export$48e9be38307e3c37);
$parcel$export(module.exports, "UnrecognizedStreamTypeError", () => $046ecf435f71da9c$export$f8343077e7fd3a86);
$parcel$export(module.exports, "PageEmbeddingMismatchedContextError", () => $046ecf435f71da9c$export$22c55e00f6509a2c);
$parcel$export(module.exports, "PDFArrayIsNotRectangleError", () => $046ecf435f71da9c$export$a76bae7761f3d760);
$parcel$export(module.exports, "InvalidPDFDateStringError", () => $046ecf435f71da9c$export$8638e3ad1edceac8);
$parcel$export(module.exports, "InvalidTargetIndexError", () => $046ecf435f71da9c$export$845c01ec1ddb8877);
$parcel$export(module.exports, "CorruptPageTreeError", () => $046ecf435f71da9c$export$1012d63cae1523f8);
$parcel$export(module.exports, "IndexOutOfBoundsError", () => $046ecf435f71da9c$export$19a77d83c7473130);
$parcel$export(module.exports, "InvalidAcroFieldValueError", () => $046ecf435f71da9c$export$d39c49ea9be644ec);
$parcel$export(module.exports, "MultiSelectValueError", () => $046ecf435f71da9c$export$6606fe23b6c4542c);
$parcel$export(module.exports, "MissingDAEntryError", () => $046ecf435f71da9c$export$dfa101de065b3cc2);
$parcel$export(module.exports, "MissingTfOperatorError", () => $046ecf435f71da9c$export$b5ee390f1267b133);
$parcel$export(module.exports, "NumberParsingError", () => $046ecf435f71da9c$export$81adf4c464255546);
$parcel$export(module.exports, "NextByteAssertionError", () => $046ecf435f71da9c$export$fda6cb3cf0fe0c76);
$parcel$export(module.exports, "PDFObjectParsingError", () => $046ecf435f71da9c$export$b8907968b8d7f502);
$parcel$export(module.exports, "PDFInvalidObjectParsingError", () => $046ecf435f71da9c$export$72474f06fb3a1c6b);
$parcel$export(module.exports, "PDFStreamParsingError", () => $046ecf435f71da9c$export$b1a91b84397f50d6);
$parcel$export(module.exports, "UnbalancedParenthesisError", () => $046ecf435f71da9c$export$92803ff0e03167f9);
$parcel$export(module.exports, "StalledParserError", () => $046ecf435f71da9c$export$b934c61834236c8);
$parcel$export(module.exports, "MissingPDFHeaderError", () => $046ecf435f71da9c$export$cf6bd1b11dd05d74);
$parcel$export(module.exports, "MissingKeywordError", () => $046ecf435f71da9c$export$bc024c15c94be864);

var $cOQTW = parcelRequire("cOQTW");
parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");
var $046ecf435f71da9c$export$b549a6777be1bc17 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MethodNotImplementedError, _super);
    function MethodNotImplementedError(className, methodName) {
        var _this = this;
        var msg = "Method " + className + "." + methodName + "() not implemented";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MethodNotImplementedError;
}(Error);
var $046ecf435f71da9c$export$20e18464cd4b43a = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PrivateConstructorError, _super);
    function PrivateConstructorError(className) {
        var _this = this;
        var msg = "Cannot construct " + className + " - it has a private constructor";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PrivateConstructorError;
}(Error);
var $046ecf435f71da9c$export$ab03f98a62c22159 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(UnexpectedObjectTypeError, _super);
    function UnexpectedObjectTypeError(expected, actual) {
        var _this = this;
        var name = function(t) {
            var _a, _b;
            return (_a = t === null || t === void 0 ? void 0 : t.name) !== null && _a !== void 0 ? _a : (_b = t === null || t === void 0 ? void 0 : t.constructor) === null || _b === void 0 ? void 0 : _b.name;
        };
        var expectedTypes = Array.isArray(expected) ? expected.map(name) : [
            name(expected)
        ];
        var msg = "Expected instance of " + expectedTypes.join(' or ') + ", " + ("but got instance of " + (actual ? name(actual) : actual));
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnexpectedObjectTypeError;
}(Error);
var $046ecf435f71da9c$export$5de8fe8a6031fb92 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(UnsupportedEncodingError, _super);
    function UnsupportedEncodingError(encoding) {
        var _this = this;
        var msg = encoding + " stream encoding not supported";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnsupportedEncodingError;
}(Error);
var $046ecf435f71da9c$export$df523155c7c35e23 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(ReparseError, _super);
    function ReparseError(className, methodName) {
        var _this = this;
        var msg = "Cannot call " + className + "." + methodName + "() more than once";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ReparseError;
}(Error);
var $046ecf435f71da9c$export$3afc9350d4666214 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingCatalogError, _super);
    function MissingCatalogError(ref) {
        var _this = this;
        var msg = "Missing catalog (ref=" + ref + ")";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingCatalogError;
}(Error);
var $046ecf435f71da9c$export$48e9be38307e3c37 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingPageContentsEmbeddingError, _super);
    function MissingPageContentsEmbeddingError() {
        var _this = this;
        var msg = "Can't embed page with missing Contents";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingPageContentsEmbeddingError;
}(Error);
var $046ecf435f71da9c$export$f8343077e7fd3a86 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(UnrecognizedStreamTypeError, _super);
    function UnrecognizedStreamTypeError(stream) {
        var _a, _b, _c;
        var _this = this;
        var streamType = (_c = (_b = (_a = stream === null || stream === void 0 ? void 0 : stream.contructor) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : stream === null || stream === void 0 ? void 0 : stream.name) !== null && _c !== void 0 ? _c : stream;
        var msg = "Unrecognized stream type: " + streamType;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnrecognizedStreamTypeError;
}(Error);
var $046ecf435f71da9c$export$22c55e00f6509a2c = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PageEmbeddingMismatchedContextError, _super);
    function PageEmbeddingMismatchedContextError() {
        var _this = this;
        var msg = "Found mismatched contexts while embedding pages. All pages in the array passed to `PDFDocument.embedPages()` must be from the same document.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PageEmbeddingMismatchedContextError;
}(Error);
var $046ecf435f71da9c$export$a76bae7761f3d760 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFArrayIsNotRectangleError, _super);
    function PDFArrayIsNotRectangleError(size) {
        var _this = this;
        var msg = "Attempted to convert PDFArray with " + size + " elements to rectangle, but must have exactly 4 elements.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PDFArrayIsNotRectangleError;
}(Error);
var $046ecf435f71da9c$export$8638e3ad1edceac8 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(InvalidPDFDateStringError, _super);
    function InvalidPDFDateStringError(value) {
        var _this = this;
        var msg = "Attempted to convert \"" + value + "\" to a date, but it does not match the PDF date string format.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidPDFDateStringError;
}(Error);
var $046ecf435f71da9c$export$845c01ec1ddb8877 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(InvalidTargetIndexError, _super);
    function InvalidTargetIndexError(targetIndex, Count) {
        var _this = this;
        var msg = "Invalid targetIndex specified: targetIndex=" + targetIndex + " must be less than Count=" + Count;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidTargetIndexError;
}(Error);
var $046ecf435f71da9c$export$1012d63cae1523f8 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(CorruptPageTreeError, _super);
    function CorruptPageTreeError(targetIndex, operation) {
        var _this = this;
        var msg = "Failed to " + operation + " at targetIndex=" + targetIndex + " due to corrupt page tree: It is likely that one or more 'Count' entries are invalid";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return CorruptPageTreeError;
}(Error);
var $046ecf435f71da9c$export$19a77d83c7473130 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(IndexOutOfBoundsError, _super);
    function IndexOutOfBoundsError(index, min, max) {
        var _this = this;
        var msg = "index should be at least " + min + " and at most " + max + ", but was actually " + index;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return IndexOutOfBoundsError;
}(Error);
var $046ecf435f71da9c$export$d39c49ea9be644ec = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(InvalidAcroFieldValueError, _super);
    function InvalidAcroFieldValueError() {
        var _this = this;
        var msg = "Attempted to set invalid field value";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidAcroFieldValueError;
}(Error);
var $046ecf435f71da9c$export$6606fe23b6c4542c = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MultiSelectValueError, _super);
    function MultiSelectValueError() {
        var _this = this;
        var msg = "Attempted to select multiple values for single-select field";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MultiSelectValueError;
}(Error);
var $046ecf435f71da9c$export$dfa101de065b3cc2 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingDAEntryError, _super);
    function MissingDAEntryError(fieldName) {
        var _this = this;
        var msg = "No /DA (default appearance) entry found for field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingDAEntryError;
}(Error);
var $046ecf435f71da9c$export$b5ee390f1267b133 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingTfOperatorError, _super);
    function MissingTfOperatorError(fieldName) {
        var _this = this;
        var msg = "No Tf operator found for DA of field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingTfOperatorError;
}(Error);
var $046ecf435f71da9c$export$81adf4c464255546 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(NumberParsingError, _super);
    function NumberParsingError(pos, value) {
        var _this = this;
        var msg = "Failed to parse number " + ("(line:" + pos.line + " col:" + pos.column + " offset=" + pos.offset + "): \"" + value + "\"");
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return NumberParsingError;
}(Error);
var $046ecf435f71da9c$export$fd202455a19cb700 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFParsingError, _super);
    function PDFParsingError(pos, details) {
        var _this = this;
        var msg = "Failed to parse PDF document " + ("(line:" + pos.line + " col:" + pos.column + " offset=" + pos.offset + "): " + details);
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PDFParsingError;
}(Error);
var $046ecf435f71da9c$export$fda6cb3cf0fe0c76 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(NextByteAssertionError, _super);
    function NextByteAssertionError(pos, expectedByte, actualByte) {
        var _this = this;
        var msg = "Expected next byte to be " + expectedByte + " but it was actually " + actualByte;
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return NextByteAssertionError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$b8907968b8d7f502 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFObjectParsingError, _super);
    function PDFObjectParsingError(pos, byte) {
        var _this = this;
        var msg = "Failed to parse PDF object starting with the following byte: " + byte;
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFObjectParsingError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$72474f06fb3a1c6b = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFInvalidObjectParsingError, _super);
    function PDFInvalidObjectParsingError(pos) {
        var _this = this;
        var msg = "Failed to parse invalid PDF object";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFInvalidObjectParsingError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$b1a91b84397f50d6 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFStreamParsingError, _super);
    function PDFStreamParsingError(pos) {
        var _this = this;
        var msg = "Failed to parse PDF stream";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFStreamParsingError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$92803ff0e03167f9 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(UnbalancedParenthesisError, _super);
    function UnbalancedParenthesisError(pos) {
        var _this = this;
        var msg = "Failed to parse PDF literal string due to unbalanced parenthesis";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return UnbalancedParenthesisError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$b934c61834236c8 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(StalledParserError, _super);
    function StalledParserError(pos) {
        var _this = this;
        var msg = "Parser stalled";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return StalledParserError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$cf6bd1b11dd05d74 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingPDFHeaderError, _super);
    function MissingPDFHeaderError(pos) {
        var _this = this;
        var msg = "No PDF header found";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return MissingPDFHeaderError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$bc024c15c94be864 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingKeywordError, _super);
    function MissingKeywordError(pos, keyword) {
        var _this = this;
        var msg = "Did not find expected keyword '" + (0, $4ISq8.arrayAsString)(keyword) + "'";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return MissingKeywordError;
}($046ecf435f71da9c$export$fd202455a19cb700);

});



parcelRegister("8zvel", function(module, exports) {

$parcel$export(module.exports, "default", () => $63d9d14d65819945$export$2e2bcd8739ae039);
var $63d9d14d65819945$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Null"] = 0] = "Null";
    CharCodes[CharCodes["Backspace"] = 8] = "Backspace";
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["Newline"] = 10] = "Newline";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationPoint"] = 33] = "ExclamationPoint";
    CharCodes[CharCodes["Hash"] = 35] = "Hash";
    CharCodes[CharCodes["Percent"] = 37] = "Percent";
    CharCodes[CharCodes["LeftParen"] = 40] = "LeftParen";
    CharCodes[CharCodes["RightParen"] = 41] = "RightParen";
    CharCodes[CharCodes["Plus"] = 43] = "Plus";
    CharCodes[CharCodes["Minus"] = 45] = "Minus";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Period"] = 46] = "Period";
    CharCodes[CharCodes["ForwardSlash"] = 47] = "ForwardSlash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["One"] = 49] = "One";
    CharCodes[CharCodes["Two"] = 50] = "Two";
    CharCodes[CharCodes["Three"] = 51] = "Three";
    CharCodes[CharCodes["Four"] = 52] = "Four";
    CharCodes[CharCodes["Five"] = 53] = "Five";
    CharCodes[CharCodes["Six"] = 54] = "Six";
    CharCodes[CharCodes["Seven"] = 55] = "Seven";
    CharCodes[CharCodes["Eight"] = 56] = "Eight";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["LessThan"] = 60] = "LessThan";
    CharCodes[CharCodes["GreaterThan"] = 62] = "GreaterThan";
    CharCodes[CharCodes["A"] = 65] = "A";
    CharCodes[CharCodes["D"] = 68] = "D";
    CharCodes[CharCodes["E"] = 69] = "E";
    CharCodes[CharCodes["F"] = 70] = "F";
    CharCodes[CharCodes["O"] = 79] = "O";
    CharCodes[CharCodes["P"] = 80] = "P";
    CharCodes[CharCodes["R"] = 82] = "R";
    CharCodes[CharCodes["LeftSquareBracket"] = 91] = "LeftSquareBracket";
    CharCodes[CharCodes["BackSlash"] = 92] = "BackSlash";
    CharCodes[CharCodes["RightSquareBracket"] = 93] = "RightSquareBracket";
    CharCodes[CharCodes["a"] = 97] = "a";
    CharCodes[CharCodes["b"] = 98] = "b";
    CharCodes[CharCodes["d"] = 100] = "d";
    CharCodes[CharCodes["e"] = 101] = "e";
    CharCodes[CharCodes["f"] = 102] = "f";
    CharCodes[CharCodes["i"] = 105] = "i";
    CharCodes[CharCodes["j"] = 106] = "j";
    CharCodes[CharCodes["l"] = 108] = "l";
    CharCodes[CharCodes["m"] = 109] = "m";
    CharCodes[CharCodes["n"] = 110] = "n";
    CharCodes[CharCodes["o"] = 111] = "o";
    CharCodes[CharCodes["r"] = 114] = "r";
    CharCodes[CharCodes["s"] = 115] = "s";
    CharCodes[CharCodes["t"] = 116] = "t";
    CharCodes[CharCodes["u"] = 117] = "u";
    CharCodes[CharCodes["x"] = 120] = "x";
    CharCodes[CharCodes["LeftCurly"] = 123] = "LeftCurly";
    CharCodes[CharCodes["RightCurly"] = 125] = "RightCurly";
    CharCodes[CharCodes["Tilde"] = 126] = "Tilde";
})($63d9d14d65819945$var$CharCodes || ($63d9d14d65819945$var$CharCodes = {}));
var $63d9d14d65819945$export$2e2bcd8739ae039 = $63d9d14d65819945$var$CharCodes;

});


parcelRegister("8gQNC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6058c6342b5f9099$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
var $6058c6342b5f9099$var$ENFORCER = {};
var $6058c6342b5f9099$var$PDFBool = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFBool, _super);
    function PDFBool(enforcer, value) {
        var _this = this;
        if (enforcer !== $6058c6342b5f9099$var$ENFORCER) throw new (0, $nAWRe.PrivateConstructorError)('PDFBool');
        _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFBool.prototype.asBoolean = function() {
        return this.value;
    };
    PDFBool.prototype.clone = function() {
        return this;
    };
    PDFBool.prototype.toString = function() {
        return String(this.value);
    };
    PDFBool.prototype.sizeInBytes = function() {
        return this.value ? 4 : 5;
    };
    PDFBool.prototype.copyBytesInto = function(buffer, offset) {
        if (this.value) {
            buffer[offset++] = (0, $8zvel.default).t;
            buffer[offset++] = (0, $8zvel.default).r;
            buffer[offset++] = (0, $8zvel.default).u;
            buffer[offset++] = (0, $8zvel.default).e;
            return 4;
        } else {
            buffer[offset++] = (0, $8zvel.default).f;
            buffer[offset++] = (0, $8zvel.default).a;
            buffer[offset++] = (0, $8zvel.default).l;
            buffer[offset++] = (0, $8zvel.default).s;
            buffer[offset++] = (0, $8zvel.default).e;
            return 5;
        }
    };
    PDFBool.True = new PDFBool($6058c6342b5f9099$var$ENFORCER, true);
    PDFBool.False = new PDFBool($6058c6342b5f9099$var$ENFORCER, false);
    return PDFBool;
}((0, $11c5J.default));
var $6058c6342b5f9099$export$2e2bcd8739ae039 = $6058c6342b5f9099$var$PDFBool;

});

parcelRegister("dPHSK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a12213d87b46303c$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");

var $6InlX = parcelRequire("6InlX");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $a12213d87b46303c$var$decodeName = function(name) {
    return name.replace(/#([\dABCDEF]{2})/g, function(_, hex) {
        return (0, $7Kmy8.charFromHexCode)(hex);
    });
};
var $a12213d87b46303c$var$isRegularChar = function(charCode) {
    return charCode >= (0, $8zvel.default).ExclamationPoint && charCode <= (0, $8zvel.default).Tilde && !(0, $6InlX.IsIrregular)[charCode];
};
var $a12213d87b46303c$var$ENFORCER = {};
var $a12213d87b46303c$var$pool = new Map();
var $a12213d87b46303c$var$PDFName = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFName, _super);
    function PDFName(enforcer, name) {
        var _this = this;
        if (enforcer !== $a12213d87b46303c$var$ENFORCER) throw new (0, $nAWRe.PrivateConstructorError)('PDFName');
        _this = _super.call(this) || this;
        var encodedName = '/';
        for(var idx = 0, len = name.length; idx < len; idx++){
            var character = name[idx];
            var code = (0, $7Kmy8.toCharCode)(character);
            encodedName += $a12213d87b46303c$var$isRegularChar(code) ? character : "#" + (0, $7Kmy8.toHexString)(code);
        }
        _this.encodedName = encodedName;
        return _this;
    }
    PDFName.prototype.asBytes = function() {
        var bytes = [];
        var hex = '';
        var escaped = false;
        var pushByte = function(byte) {
            if (byte !== undefined) bytes.push(byte);
            escaped = false;
        };
        for(var idx = 1, len = this.encodedName.length; idx < len; idx++){
            var char = this.encodedName[idx];
            var byte = (0, $7Kmy8.toCharCode)(char);
            var nextChar = this.encodedName[idx + 1];
            if (!escaped) {
                if (byte === (0, $8zvel.default).Hash) escaped = true;
                else pushByte(byte);
            } else if (byte >= (0, $8zvel.default).Zero && byte <= (0, $8zvel.default).Nine || byte >= (0, $8zvel.default).a && byte <= (0, $8zvel.default).f || byte >= (0, $8zvel.default).A && byte <= (0, $8zvel.default).F) {
                hex += char;
                if (hex.length === 2 || !(nextChar >= '0' && nextChar <= '9' || nextChar >= 'a' && nextChar <= 'f' || nextChar >= 'A' && nextChar <= 'F')) {
                    pushByte(parseInt(hex, 16));
                    hex = '';
                }
            } else pushByte(byte);
        }
        return new Uint8Array(bytes);
    };
    // TODO: This should probably use `utf8Decode()`
    // TODO: Polyfill Array.from?
    PDFName.prototype.decodeText = function() {
        var bytes = this.asBytes();
        return String.fromCharCode.apply(String, Array.from(bytes));
    };
    PDFName.prototype.asString = function() {
        return this.encodedName;
    };
    /** @deprecated in favor of [[PDFName.asString]] */ PDFName.prototype.value = function() {
        return this.encodedName;
    };
    PDFName.prototype.clone = function() {
        return this;
    };
    PDFName.prototype.toString = function() {
        return this.encodedName;
    };
    PDFName.prototype.sizeInBytes = function() {
        return this.encodedName.length;
    };
    PDFName.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.encodedName, buffer, offset);
        return this.encodedName.length;
    };
    PDFName.of = function(name) {
        var decodedValue = $a12213d87b46303c$var$decodeName(name);
        var instance = $a12213d87b46303c$var$pool.get(decodedValue);
        if (!instance) {
            instance = new PDFName($a12213d87b46303c$var$ENFORCER, decodedValue);
            $a12213d87b46303c$var$pool.set(decodedValue, instance);
        }
        return instance;
    };
    /* tslint:disable member-ordering */ PDFName.Length = PDFName.of('Length');
    PDFName.FlateDecode = PDFName.of('FlateDecode');
    PDFName.Resources = PDFName.of('Resources');
    PDFName.Font = PDFName.of('Font');
    PDFName.XObject = PDFName.of('XObject');
    PDFName.ExtGState = PDFName.of('ExtGState');
    PDFName.Contents = PDFName.of('Contents');
    PDFName.Type = PDFName.of('Type');
    PDFName.Parent = PDFName.of('Parent');
    PDFName.MediaBox = PDFName.of('MediaBox');
    PDFName.Page = PDFName.of('Page');
    PDFName.Annots = PDFName.of('Annots');
    PDFName.TrimBox = PDFName.of('TrimBox');
    PDFName.ArtBox = PDFName.of('ArtBox');
    PDFName.BleedBox = PDFName.of('BleedBox');
    PDFName.CropBox = PDFName.of('CropBox');
    PDFName.Rotate = PDFName.of('Rotate');
    PDFName.Title = PDFName.of('Title');
    PDFName.Author = PDFName.of('Author');
    PDFName.Subject = PDFName.of('Subject');
    PDFName.Creator = PDFName.of('Creator');
    PDFName.Keywords = PDFName.of('Keywords');
    PDFName.Producer = PDFName.of('Producer');
    PDFName.CreationDate = PDFName.of('CreationDate');
    PDFName.ModDate = PDFName.of('ModDate');
    return PDFName;
}((0, $11c5J.default));
var $a12213d87b46303c$export$2e2bcd8739ae039 = $a12213d87b46303c$var$PDFName;

});
parcelRegister("6InlX", function(module, exports) {

$parcel$export(module.exports, "IsIrregular", () => $4e38f796f0a0073a$export$5a447e10c710a69b);

var $8zvel = parcelRequire("8zvel");

var $eOx0D = parcelRequire("eOx0D");

var $14u6w = parcelRequire("14u6w");
var $4e38f796f0a0073a$export$5a447e10c710a69b = new Uint8Array(256);
for(var $4e38f796f0a0073a$var$idx = 0, $4e38f796f0a0073a$var$len = 256; $4e38f796f0a0073a$var$idx < $4e38f796f0a0073a$var$len; $4e38f796f0a0073a$var$idx++)$4e38f796f0a0073a$export$5a447e10c710a69b[$4e38f796f0a0073a$var$idx] = (0, $14u6w.IsWhitespace)[$4e38f796f0a0073a$var$idx] || (0, $eOx0D.IsDelimiter)[$4e38f796f0a0073a$var$idx] ? 1 : 0;
$4e38f796f0a0073a$export$5a447e10c710a69b[(0, $8zvel.default).Hash] = 1;

});
parcelRegister("eOx0D", function(module, exports) {

$parcel$export(module.exports, "IsDelimiter", () => $ac8f572666c7d7dc$export$30620680eaa3becd);

var $8zvel = parcelRequire("8zvel");
var $ac8f572666c7d7dc$export$30620680eaa3becd = new Uint8Array(256);
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).LeftParen] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).RightParen] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).LessThan] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).GreaterThan] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).LeftSquareBracket] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).RightSquareBracket] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).LeftCurly] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).RightCurly] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).ForwardSlash] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).Percent] = 1;

});

parcelRegister("14u6w", function(module, exports) {

$parcel$export(module.exports, "IsWhitespace", () => $0c7d843fbd7cd19d$export$38c4de915d0e2c37);

var $8zvel = parcelRequire("8zvel");
var $0c7d843fbd7cd19d$export$38c4de915d0e2c37 = new Uint8Array(256);
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).Null] = 1;
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).Tab] = 1;
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).Newline] = 1;
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).FormFeed] = 1;
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).CarriageReturn] = 1;
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).Space] = 1;

});




var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};

$parcel$export($7e96a608cb33bf79$exports, "createRoot", () => $7e96a608cb33bf79$export$882461b6382ed46c, (v) => $7e96a608cb33bf79$export$882461b6382ed46c = v);
$parcel$export($7e96a608cb33bf79$exports, "hydrateRoot", () => $7e96a608cb33bf79$export$757ceba2d55c277e, (v) => $7e96a608cb33bf79$export$757ceba2d55c277e = v);
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;




var $acw62 = parcelRequire("acw62");
'use strict';
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const { iterator: $c319b2c832c2914a$var$iterator, toStringTag: $c319b2c832c2914a$var$toStringTag } = Symbol;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== 'object') return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($c319b2c832c2914a$var$toStringTag in val) && !($c319b2c832c2914a$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $c319b2c832c2914a$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$c319b2c832c2914a$var$isObject(val) || $c319b2c832c2914a$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $c319b2c832c2914a$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $c319b2c832c2914a$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $c319b2c832c2914a$var$G = $c319b2c832c2914a$var$getGlobal();
const $c319b2c832c2914a$var$FormDataCtor = typeof $c319b2c832c2914a$var$G.FormData !== 'undefined' ? $c319b2c832c2914a$var$G.FormData : undefined;
const $c319b2c832c2914a$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($c319b2c832c2914a$var$FormDataCtor && thing instanceof $c319b2c832c2914a$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $c319b2c832c2914a$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$c319b2c832c2914a$var$isFunction(thing.append)) return false;
    const kind = $c319b2c832c2914a$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest('URLSearchParams');
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($c319b2c832c2914a$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $c319b2c832c2914a$var$findKey(obj, key) {
    if ($c319b2c832c2914a$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $c319b2c832c2914a$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $c319b2c832c2914a$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($c319b2c832c2914a$var$isPlainObject(existing) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(existing, val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$c319b2c832c2914a$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $c319b2c832c2914a$var$isBuffer(source)) continue;
        $c319b2c832c2914a$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $c319b2c832c2914a$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($c319b2c832c2914a$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$c319b2c832c2914a$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest('HTMLFormElement');
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
const { propertyIsEnumerable: $c319b2c832c2914a$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest('RegExp');
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[$c319b2c832c2914a$var$toStringTag] === 'FormData' && thing[$c319b2c832c2914a$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($c319b2c832c2914a$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : $c319b2c832c2914a$var$_setImmediate;
// *********************
const $c319b2c832c2914a$var$isIterable = (thing)=>thing != null && $c319b2c832c2914a$var$isFunction(thing[$c319b2c832c2914a$var$iterator]);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isEmptyObject: $c319b2c832c2914a$var$isEmptyObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isReactNativeBlob: $c319b2c832c2914a$var$isReactNativeBlob,
    isReactNative: $c319b2c832c2914a$var$isReactNative,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap,
    isIterable: $c319b2c832c2914a$var$isIterable
};









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $f8f5102fdfcbfec9$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $f8f5102fdfcbfec9$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $f8f5102fdfcbfec9$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $f8f5102fdfcbfec9$var$sanitizeValue(value, invalidChars) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$f8f5102fdfcbfec9$var$sanitizeValue(item, invalidChars));
    return $f8f5102fdfcbfec9$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $f8f5102fdfcbfec9$export$9e344cffce061a22 = (value)=>$f8f5102fdfcbfec9$var$sanitizeValue(value, $f8f5102fdfcbfec9$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $f8f5102fdfcbfec9$export$59dd66c2a12d8f62 = (value)=>$f8f5102fdfcbfec9$var$sanitizeValue(value, $f8f5102fdfcbfec9$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $f8f5102fdfcbfec9$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $f8f5102fdfcbfec9$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
const $866cce54f6bdfb0c$var$$internals = Symbol('internals');
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : (0, $f8f5102fdfcbfec9$export$9e344cffce061a22)(String(value));
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(header) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


'use strict';
const $4e2395edb77acf3a$var$REDACTED = '[REDACTED ****]';
function $4e2395edb77acf3a$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $4e2395edb77acf3a$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source) && $4e2395edb77acf3a$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $4e2395edb77acf3a$var$REDACTED : visit(value);
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
class $4e2395edb77acf3a$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $4e2395edb77acf3a$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $4e2395edb77acf3a$var$redactConfig(config, redactKeys) : (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$4e2395edb77acf3a$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$4e2395edb77acf3a$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$4e2395edb77acf3a$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$4e2395edb77acf3a$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$4e2395edb77acf3a$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$4e2395edb77acf3a$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$4e2395edb77acf3a$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$4e2395edb77acf3a$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$4e2395edb77acf3a$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$4e2395edb77acf3a$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $e6cbd383b18c9625$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? 100 : options.maxDepth;
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNative(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (depth > maxDepth) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


'use strict';
function $8df8fedf1c1e4428$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$export$c564cdbbe6da493;
    const _options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    const serializeFn = _options && _options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





'use strict';
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false
};






'use strict';
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


'use strict';
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $565e85ead8bde60a$exports = {};

$parcel$export($565e85ead8bde60a$exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export($565e85ead8bde60a$exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export($565e85ead8bde60a$exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$565e85ead8bde60a$exports,
    ...(0, $2f71637df772b183$export$2e2bcd8739ae039)
};


'use strict';
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


'use strict';
const $843bf0209bc94df8$var$own = (obj, key)=>obj != null && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $843bf0209bc94df8$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $843bf0209bc94df8$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $843bf0209bc94df8$var$own(this, 'transitional') || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $843bf0209bc94df8$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isResponse(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $843bf0209bc94df8$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $843bf0209bc94df8$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch',
    'query'
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;



'use strict';
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $9fd0919e266b4fda$var$CanceledError extends (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







'use strict';
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;



const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (0, $9b3ced92bc7bdc99$export$2e2bcd8739ae039)((e)=>{
        if (!e || typeof e.loaded !== 'number') return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin), (0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) return decodeURIComponent(cookie.slice(eq + 1));
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




const $ab4625fac3104691$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $ab4625fac3104691$var$setFormDataHeaders(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders).forEach(([key, val])=>{
        if ($ab4625fac3104691$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $ab4625fac3104691$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $ab4625fac3104691$var$resolveConfig(config) {
    const newConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)((0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? $ab4625fac3104691$var$encodeUTF8(auth.password) : '')));
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        $ab4625fac3104691$var$setFormDataHeaders(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $ab4625fac3104691$export$2e2bcd8739ae039 = $ab4625fac3104691$var$resolveConfig;



const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request aborted', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(msg, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach((0, $f8f5102fdfcbfec9$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $bb8180acb278e187$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) ? err : new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>signal.addEventListener('abort', onabort));
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;


const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate decoded byte length of a data:// URL *without* allocating large buffers.
 * - For base64: compute exact decoded size using length and padding;
 *               handle %XX at the character-count level (no string allocation).
 * - For non-base64: use UTF-8 byteLength of the encoded body as a safe upper bound.
 *
 * @param {string} url
 * @returns {number}
 */ 
var $da69a2069c6136ea$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
function $da69a2069c6136ea$export$2e2bcd8739ae039(url) {
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) {
        let effectiveLen = body.length;
        const len = body.length; // cache length
        for(let i = 0; i < len; i++)if (body.charCodeAt(i) === 37 /* '%' */  && i + 2 < len) {
            const a = body.charCodeAt(i + 1);
            const b = body.charCodeAt(i + 2);
            const isHex = (a >= 48 && a <= 57 || a >= 65 && a <= 70 || a >= 97 && a <= 102) && (b >= 48 && b <= 57 || b >= 65 && b <= 70 || b >= 97 && b <= 102);
            if (isHex) {
                effectiveLen -= 2;
                i += 2;
            }
        }
        let pad = 0;
        let idx = len - 1;
        const tailIsPct3D = (j)=>j >= 2 && body.charCodeAt(j - 2) === 37 && // '%'
            body.charCodeAt(j - 1) === 51 && // '3'
            (body.charCodeAt(j) === 68 || body.charCodeAt(j) === 100); // 'D' or 'd'
        if (idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) {
                pad++;
                idx--;
            } else if (tailIsPct3D(idx)) {
                pad++;
                idx -= 3;
            }
        }
        if (pad === 1 && idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) pad++;
            else if (tailIsPct3D(idx)) pad++;
        }
        const groups = Math.floor(effectiveLen / 4);
        const bytes = groups * 3 - (pad || 0);
        return bytes > 0 ? bytes : 0;
    }
    if (typeof $da69a2069c6136ea$require$Buffer !== 'undefined' && typeof $da69a2069c6136ea$require$Buffer.byteLength === 'function') return $da69a2069c6136ea$require$Buffer.byteLength(body, 'utf8');
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Using body.length here would undercount non-ASCII (e.g. '€' is 1 code unit
    // but 3 UTF-8 bytes).
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
}


const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.17.0";



const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $e52be20a9fc15e96$var$isFunction } = (0, $c319b2c832c2914a$export$2e2bcd8739ae039);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $e52be20a9fc15e96$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $e52be20a9fc15e96$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $e52be20a9fc15e96$var$factory = (env)=>{
    const globalObject = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global !== undefined && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global !== null ? (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $e52be20a9fc15e96$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $e52be20a9fc15e96$var$isFunction(Request);
    const isResponseSupported = $e52be20a9fc15e96$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $e52be20a9fc15e96$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $a052b9a6636aacdc$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = configAuth.username || '';
                const password = configAuth.password || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($e52be20a9fc15e96$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $e52be20a9fc15e96$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $e52be20a9fc15e96$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($e52be20a9fc15e96$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $da69a2069c6136ea$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against the outbound request body before dispatch.
            // Mirrors http.js behavior (ERR_BAD_REQUEST / 'Request body larger than
            // maxBodyLength limit'). Skip when the body length cannot be determined
            // (e.g. a live ReadableStream supplied by the caller).
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await resolveBodyLength(headers, data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength) && outboundLength > maxBodyLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
            }
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: 'half'
                });
                let contentTypeHeader;
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(requestContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $c9465135abb26626$export$b0119225647bd83)(_request.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132), false);
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $f8f5102fdfcbfec9$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(responseContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $c9465135abb26626$export$b0119225647bd83)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                err !== canceledError && (canceledError.cause = err);
                throw canceledError;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Network Error', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $e52be20a9fc15e96$var$seedCache = new Map();
const $e52be20a9fc15e96$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $e52be20a9fc15e96$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $e52be20a9fc15e96$var$factory(env));
        map = target;
    }
    return target;
};
const $e52be20a9fc15e96$var$adapter = $e52be20a9fc15e96$export$3105c6651375d4fa();
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039),
    fetch: {
        get: $e52be20a9fc15e96$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $e8c8c7960873e9ee$var$getAdapter(adapters, config) {
    adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e8c8c7960873e9ee$var$renderReason).join('\n') : ' ' + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $e8c8c7960873e9ee$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $e8c8c7960873e9ee$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}






'use strict';
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('options must be an object', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};




'use strict';
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            legacyInterceptorReqResOrdering: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            advertiseZstdAcceptEncoding: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling('baseURL'),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'query',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $a93486d2307f31c3$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






'use strict';
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a, create: $b302555736d21bd7$export$185802fd694ee1f5 } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);


// @ts-check
/**
 * @import {Acr, KeycloakAccountOptions, KeycloakAdapter, KeycloakConfig, KeycloakError, KeycloakFlow, KeycloakInitOptions, KeycloakLoginOptions, KeycloakLogoutOptions, KeycloakPkceMethod, KeycloakProfile, KeycloakRegisterOptions, KeycloakResourceAccess, KeycloakResponseMode, KeycloakResponseType, KeycloakRoles, KeycloakTokenParsed, OpenIdProviderMetadata} from "./keycloak.ts"
 */ /*
 * Copyright 2016 Red Hat, Inc. and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e73f77be32ef41cd$var$CONTENT_TYPE_JSON = 'application/json';
class $e73f77be32ef41cd$export$2e2bcd8739ae039 {
    /** @type {Pick<PromiseWithResolvers<boolean>, 'resolve' | 'reject'>[]} */ #refreshQueue = [];
    /** @type {KeycloakAdapter} */ #adapter;
    /** @type {boolean} */ #useNonce = true;
    /** @type {CallbackStorage} */ #callbackStorage;
    #logInfo = this.#createLogger(console.info);
    #logWarn = this.#createLogger(console.warn);
    /** @type {LoginIframe} */ #loginIframe = {
        enable: true,
        callbackList: [],
        interval: 5
    };
    /** @type {KeycloakConfig} config */ #config;
    didInitialize = false;
    authenticated = false;
    loginRequired = false;
    /** @type {KeycloakResponseMode} */ responseMode = 'fragment';
    /** @type {KeycloakResponseType} */ responseType = 'code';
    /** @type {KeycloakFlow} */ flow = 'standard';
    /** @type {number?} */ timeSkew = null;
    /** @type {string=} */ redirectUri;
    /** @type {string=} */ silentCheckSsoRedirectUri;
    /** @type {boolean} */ silentCheckSsoFallback = true;
    /** @type {KeycloakPkceMethod} */ pkceMethod = 'S256';
    enableLogging = false;
    /** @type {'GET' | 'POST'} */ logoutMethod = 'GET';
    /** @type {string=} */ scope;
    messageReceiveTimeout = 10000;
    /** @type {string=} */ idToken;
    /** @type {KeycloakTokenParsed=} */ idTokenParsed;
    /** @type {string=} */ token;
    /** @type {KeycloakTokenParsed=} */ tokenParsed;
    /** @type {string=} */ refreshToken;
    /** @type {KeycloakTokenParsed=} */ refreshTokenParsed;
    /** @type {string=} */ clientId;
    /** @type {string=} */ sessionId;
    /** @type {string=} */ subject;
    /** @type {string=} */ authServerUrl;
    /** @type {string=} */ realm;
    /** @type {KeycloakRoles=} */ realmAccess;
    /** @type {KeycloakResourceAccess=} */ resourceAccess;
    /** @type {KeycloakProfile=} */ profile;
    /** @type {{}=} */ userInfo;
    /** @type {Endpoints} */ endpoints;
    /** @type {number=} */ tokenTimeoutHandle;
    /** @type {() => void=} */ onAuthSuccess;
    /** @type {(errorData?: KeycloakError) => void=} */ onAuthError;
    /** @type {() => void=} */ onAuthRefreshSuccess;
    /** @type {() => void=} */ onAuthRefreshError;
    /** @type {() => void=} */ onTokenExpired;
    /** @type {() => void=} */ onAuthLogout;
    /** @type {(authenticated: boolean) => void=} */ onReady;
    /** @type {(status: 'success' | 'cancelled' | 'error', action: string) => void=} */ onActionUpdate;
    /**
   * @param {KeycloakConfig} config
   */ constructor(config){
        if (typeof config !== 'string' && !$e73f77be32ef41cd$var$isObject(config)) throw new Error("The 'Keycloak' constructor must be provided with a configuration object, or a URL to a JSON configuration file.");
        if ($e73f77be32ef41cd$var$isObject(config)) {
            const requiredProperties = 'oidcProvider' in config ? [
                'clientId'
            ] : [
                'url',
                'realm',
                'clientId'
            ];
            for (const property of requiredProperties){
                if (!(property in config)) throw new Error(`The configuration object is missing the required '${property}' property.`);
            }
        }
        if (!globalThis.isSecureContext) this.#logWarn("[KEYCLOAK] Keycloak JS must be used in a 'secure context' to function properly as it relies on browser APIs that are otherwise not available.\nContinuing to run your application insecurely will lead to unexpected behavior and breakage.\n\nFor more information see: https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts");
        this.#config = config;
    }
    /**
   * @param {KeycloakInitOptions} initOptions
   * @returns {Promise<boolean>}
   */ init = async (initOptions = {})=>{
        if (this.didInitialize) throw new Error("A 'Keycloak' instance can only be initialized once.");
        this.didInitialize = true;
        this.#callbackStorage = $e73f77be32ef41cd$var$createCallbackStorage();
        const adapters = [
            'default',
            'cordova',
            'cordova-native'
        ];
        if (typeof initOptions.adapter === 'string' && adapters.includes(initOptions.adapter)) this.#adapter = this.#loadAdapter(initOptions.adapter);
        else if (typeof initOptions.adapter === 'object') this.#adapter = initOptions.adapter;
        else if ('Cordova' in window || 'cordova' in window) this.#adapter = this.#loadAdapter('cordova');
        else this.#adapter = this.#loadAdapter('default');
        if (typeof initOptions.useNonce !== 'undefined') this.#useNonce = initOptions.useNonce;
        if (typeof initOptions.checkLoginIframe !== 'undefined') this.#loginIframe.enable = initOptions.checkLoginIframe;
        if (initOptions.checkLoginIframeInterval) this.#loginIframe.interval = initOptions.checkLoginIframeInterval;
        if (initOptions.onLoad === 'login-required') this.loginRequired = true;
        if (initOptions.responseMode) {
            if (initOptions.responseMode === 'query' || initOptions.responseMode === 'fragment') this.responseMode = initOptions.responseMode;
            else throw new Error('Invalid value for responseMode');
        }
        if (initOptions.flow) {
            switch(initOptions.flow){
                case 'standard':
                    this.responseType = 'code';
                    break;
                case 'implicit':
                    this.responseType = 'id_token token';
                    break;
                case 'hybrid':
                    this.responseType = 'code id_token token';
                    break;
                default:
                    throw new Error('Invalid value for flow');
            }
            this.flow = initOptions.flow;
        }
        if (typeof initOptions.timeSkew === 'number') this.timeSkew = initOptions.timeSkew;
        if (initOptions.redirectUri) this.redirectUri = initOptions.redirectUri;
        if (initOptions.silentCheckSsoRedirectUri) this.silentCheckSsoRedirectUri = initOptions.silentCheckSsoRedirectUri;
        if (typeof initOptions.silentCheckSsoFallback === 'boolean') this.silentCheckSsoFallback = initOptions.silentCheckSsoFallback;
        if (typeof initOptions.pkceMethod !== 'undefined') {
            if (initOptions.pkceMethod !== 'S256' && initOptions.pkceMethod !== false) throw new TypeError(`Invalid value for pkceMethod', expected 'S256' or false but got ${initOptions.pkceMethod}.`);
            this.pkceMethod = initOptions.pkceMethod;
        }
        if (typeof initOptions.enableLogging === 'boolean') this.enableLogging = initOptions.enableLogging;
        if (initOptions.logoutMethod === 'POST') this.logoutMethod = 'POST';
        if (typeof initOptions.scope === 'string') this.scope = initOptions.scope;
        if (typeof initOptions.messageReceiveTimeout === 'number' && initOptions.messageReceiveTimeout > 0) this.messageReceiveTimeout = initOptions.messageReceiveTimeout;
        await this.#loadConfig();
        await this.#check3pCookiesSupported();
        await this.#processInit(initOptions);
        this.onReady?.(this.authenticated);
        return this.authenticated;
    };
    /**
   * @param {"default" | "cordova" | "cordova-native"} type
   * @returns {KeycloakAdapter}
   */ #loadAdapter(type) {
        if (type === 'default') return this.#loadDefaultAdapter();
        if (type === 'cordova') {
            this.#loginIframe.enable = false;
            return this.#loadCordovaAdapter();
        }
        if (type === 'cordova-native') {
            this.#loginIframe.enable = false;
            return this.#loadCordovaNativeAdapter();
        }
        throw new Error('invalid adapter type: ' + type);
    }
    /**
   * @returns {KeycloakAdapter}
   */ #loadDefaultAdapter() {
        /** @type {KeycloakAdapter['redirectUri']}{} */ const redirectUri = (options)=>{
            return options?.redirectUri || this.redirectUri || globalThis.location.href;
        };
        return {
            login: async (options)=>{
                window.location.assign(await this.createLoginUrl(options));
                return await new Promise(()=>{});
            },
            logout: async (options)=>{
                const logoutMethod = options?.logoutMethod ?? this.logoutMethod;
                if (logoutMethod === 'GET') {
                    window.location.replace(this.createLogoutUrl(options));
                    return;
                }
                // Create form to send POST request.
                const form = document.createElement('form');
                form.setAttribute('method', 'POST');
                form.setAttribute('action', this.createLogoutUrl(options));
                form.style.display = 'none';
                // Add data to form as hidden input fields.
                const data = {
                    id_token_hint: this.idToken,
                    client_id: this.clientId,
                    post_logout_redirect_uri: redirectUri(options)
                };
                for (const [name, value] of Object.entries(data)){
                    const input = document.createElement('input');
                    input.setAttribute('type', 'hidden');
                    input.setAttribute('name', name);
                    input.setAttribute('value', /** @type {string} */ value);
                    form.appendChild(input);
                }
                // Append form to page and submit it to perform logout and redirect.
                document.body.appendChild(form);
                form.submit();
            },
            register: async (options)=>{
                window.location.assign(await this.createRegisterUrl(options));
                return await new Promise(()=>{});
            },
            accountManagement: async ()=>{
                const accountUrl = this.createAccountUrl();
                if (typeof accountUrl !== 'undefined') window.location.href = accountUrl;
                else throw new Error('Not supported by the OIDC server');
                return await new Promise(()=>{});
            },
            redirectUri: redirectUri
        };
    }
    /**
   * @returns {KeycloakAdapter}
   */ #loadCordovaAdapter() {
        /**
     * @param {string} loginUrl
     * @param {string} target
     * @param {string} options
     * @returns {WindowProxy | null}
     */ const cordovaOpenWindowWrapper = (loginUrl, target, options)=>{
            if (window.cordova && window.cordova.InAppBrowser) // Use inappbrowser for IOS and Android if available
            return window.cordova.InAppBrowser.open(loginUrl, target, options);
            else return window.open(loginUrl, target, options);
        };
        const shallowCloneCordovaOptions = (userOptions)=>{
            if (userOptions && userOptions.cordovaOptions) return Object.keys(userOptions.cordovaOptions).reduce((options, optionName)=>{
                options[optionName] = userOptions.cordovaOptions[optionName];
                return options;
            }, {});
            else return {};
        };
        const formatCordovaOptions = (cordovaOptions)=>{
            return Object.keys(cordovaOptions).reduce((options, optionName)=>{
                options.push(optionName + '=' + cordovaOptions[optionName]);
                return options;
            }, []).join(',');
        };
        const createCordovaOptions = (userOptions)=>{
            const cordovaOptions = shallowCloneCordovaOptions(userOptions);
            cordovaOptions.location = 'no';
            if (userOptions && userOptions.prompt === 'none') cordovaOptions.hidden = 'yes';
            return formatCordovaOptions(cordovaOptions);
        };
        const getCordovaRedirectUri = ()=>{
            return this.redirectUri || 'http://localhost';
        };
        return {
            login: async (options)=>{
                const cordovaOptions = createCordovaOptions(options);
                const loginUrl = await this.createLoginUrl(options);
                const ref = cordovaOpenWindowWrapper(loginUrl, '_blank', cordovaOptions);
                let completed = false;
                let closed = false;
                function closeBrowser() {
                    closed = true;
                    ref.close();
                }
                return await new Promise((resolve, reject)=>{
                    ref.addEventListener('loadstart', async (event)=>{
                        if (event.url.indexOf(getCordovaRedirectUri()) === 0) {
                            const callback = this.#parseCallback(event.url);
                            completed = true;
                            closeBrowser();
                            try {
                                await this.#processCallback(callback);
                                resolve();
                            } catch (error) {
                                reject(error);
                            }
                        }
                    });
                    ref.addEventListener('loaderror', async (event)=>{
                        if (!completed) {
                            if (event.url.indexOf(getCordovaRedirectUri()) === 0) {
                                const callback = this.#parseCallback(event.url);
                                completed = true;
                                closeBrowser();
                                try {
                                    await this.#processCallback(callback);
                                    resolve();
                                } catch (error) {
                                    reject(error);
                                }
                            } else {
                                reject(new Error('Unable to process login.'));
                                closeBrowser();
                            }
                        }
                    });
                    ref.addEventListener('exit', function(event) {
                        if (!closed) reject(new Error('User closed the login window.'));
                    });
                });
            },
            logout: async (options)=>{
                const logoutUrl = this.createLogoutUrl(options);
                const ref = cordovaOpenWindowWrapper(logoutUrl, '_blank', 'location=no,hidden=yes,clearcache=yes');
                let error = false;
                ref.addEventListener('loadstart', (event)=>{
                    if (event.url.indexOf(getCordovaRedirectUri()) === 0) ref.close();
                });
                ref.addEventListener('loaderror', (event)=>{
                    if (event.url.indexOf(getCordovaRedirectUri()) === 0) ref.close();
                    else {
                        error = true;
                        ref.close();
                    }
                });
                await new Promise((resolve, reject)=>{
                    ref.addEventListener('exit', ()=>{
                        if (error) reject(new Error('User closed the login window.'));
                        else {
                            this.clearToken();
                            resolve();
                        }
                    });
                });
            },
            register: async (options)=>{
                const registerUrl = await this.createRegisterUrl();
                const cordovaOptions = createCordovaOptions(options);
                const ref = cordovaOpenWindowWrapper(registerUrl, '_blank', cordovaOptions);
                /** @type {Promise<void>} */ const promise = new Promise((resolve, reject)=>{
                    ref.addEventListener('loadstart', async (event)=>{
                        if (event.url.indexOf(getCordovaRedirectUri()) === 0) {
                            ref.close();
                            const oauth = this.#parseCallback(event.url);
                            try {
                                await this.#processCallback(oauth);
                                resolve();
                            } catch (error) {
                                reject(error);
                            }
                        }
                    });
                });
                await promise;
            },
            accountManagement: async ()=>{
                const accountUrl = this.createAccountUrl();
                if (typeof accountUrl !== 'undefined') {
                    const ref = cordovaOpenWindowWrapper(accountUrl, '_blank', 'location=no');
                    ref.addEventListener('loadstart', function(event) {
                        if (event.url.indexOf(getCordovaRedirectUri()) === 0) ref.close();
                    });
                } else throw new Error('Not supported by the OIDC server');
            },
            redirectUri: ()=>{
                return getCordovaRedirectUri();
            }
        };
    }
    /**
   * @returns {KeycloakAdapter}
   */ #loadCordovaNativeAdapter() {
        /* global universalLinks */ return {
            login: async (options)=>{
                const loginUrl = await this.createLoginUrl(options);
                await new Promise((resolve, reject)=>{
                    universalLinks.subscribe('keycloak', async (event)=>{
                        universalLinks.unsubscribe('keycloak');
                        window.cordova.plugins.browsertab.close();
                        const oauth = this.#parseCallback(event.url);
                        try {
                            await this.#processCallback(oauth);
                            resolve();
                        } catch (error) {
                            reject(error);
                        }
                    });
                    window.cordova.plugins.browsertab.openUrl(loginUrl);
                });
            },
            logout: async (options)=>{
                const logoutUrl = this.createLogoutUrl(options);
                await new Promise((resolve)=>{
                    universalLinks.subscribe('keycloak', ()=>{
                        universalLinks.unsubscribe('keycloak');
                        window.cordova.plugins.browsertab.close();
                        this.clearToken();
                        resolve();
                    });
                    window.cordova.plugins.browsertab.openUrl(logoutUrl);
                });
            },
            register: async (options)=>{
                const registerUrl = await this.createRegisterUrl(options);
                await new Promise((resolve, reject)=>{
                    universalLinks.subscribe('keycloak', async (event)=>{
                        universalLinks.unsubscribe('keycloak');
                        window.cordova.plugins.browsertab.close();
                        const oauth = this.#parseCallback(event.url);
                        try {
                            await this.#processCallback(oauth);
                            resolve();
                        } catch (error) {
                            reject(error);
                        }
                    });
                    window.cordova.plugins.browsertab.openUrl(registerUrl);
                });
            },
            accountManagement: async ()=>{
                const accountUrl = this.createAccountUrl();
                if (typeof accountUrl !== 'undefined') window.cordova.plugins.browsertab.openUrl(accountUrl);
                else throw new Error('Not supported by the OIDC server');
            },
            redirectUri: (options)=>{
                if (options && options.redirectUri) return options.redirectUri;
                else if (this.redirectUri) return this.redirectUri;
                else return 'http://localhost';
            }
        };
    }
    /**
   * @returns {Promise<void>}
   */ async #loadConfig() {
        if (typeof this.#config === 'string') {
            const jsonConfig = await $e73f77be32ef41cd$var$fetchJsonConfig(this.#config);
            this.authServerUrl = jsonConfig['auth-server-url'];
            this.realm = jsonConfig.realm;
            this.clientId = jsonConfig.resource;
            this.#setupEndpoints();
        } else {
            this.clientId = this.#config.clientId;
            if ('oidcProvider' in this.#config) await this.#loadOidcConfig(this.#config.oidcProvider);
            else {
                this.authServerUrl = this.#config.url;
                this.realm = this.#config.realm;
                this.#setupEndpoints();
            }
        }
    }
    /**
   * @returns {void}
   */ #setupEndpoints() {
        this.endpoints = {
            authorize: ()=>{
                return this.#getRealmUrl() + '/protocol/openid-connect/auth';
            },
            token: ()=>{
                return this.#getRealmUrl() + '/protocol/openid-connect/token';
            },
            logout: ()=>{
                return this.#getRealmUrl() + '/protocol/openid-connect/logout';
            },
            checkSessionIframe: ()=>{
                return this.#getRealmUrl() + '/protocol/openid-connect/login-status-iframe.html';
            },
            thirdPartyCookiesIframe: ()=>{
                return this.#getRealmUrl() + '/protocol/openid-connect/3p-cookies/step1.html';
            },
            register: ()=>{
                return this.#getRealmUrl() + '/protocol/openid-connect/registrations';
            },
            userinfo: ()=>{
                return this.#getRealmUrl() + '/protocol/openid-connect/userinfo';
            }
        };
    }
    /**
   * @param {string | OpenIdProviderMetadata} oidcProvider
   * @returns {Promise<void>}
   */ async #loadOidcConfig(oidcProvider) {
        if (typeof oidcProvider === 'string') {
            const url = `${$e73f77be32ef41cd$var$stripTrailingSlash(oidcProvider)}/.well-known/openid-configuration`;
            const openIdConfig = await $e73f77be32ef41cd$var$fetchOpenIdConfig(url);
            this.#setupOidcEndpoints(openIdConfig);
        } else this.#setupOidcEndpoints(oidcProvider);
    }
    /**
   * @param {OpenIdProviderMetadata} config
   * @returns {void}
   */ #setupOidcEndpoints(config) {
        this.endpoints = {
            authorize () {
                return config.authorization_endpoint;
            },
            token () {
                return config.token_endpoint;
            },
            logout () {
                if (!config.end_session_endpoint) throw new Error('Not supported by the OIDC server');
                return config.end_session_endpoint;
            },
            checkSessionIframe () {
                if (!config.check_session_iframe) throw new Error('Not supported by the OIDC server');
                return config.check_session_iframe;
            },
            register () {
                throw new Error('Redirection to "Register user" page not supported in standard OIDC mode');
            },
            userinfo () {
                if (!config.userinfo_endpoint) throw new Error('Not supported by the OIDC server');
                return config.userinfo_endpoint;
            }
        };
    }
    /**
   * @returns {Promise<void>}
   */ async #check3pCookiesSupported() {
        if (!this.#loginIframe.enable && !this.silentCheckSsoRedirectUri || typeof this.endpoints.thirdPartyCookiesIframe !== 'function') return;
        const iframe = document.createElement('iframe');
        iframe.setAttribute('src', this.endpoints.thirdPartyCookiesIframe());
        iframe.setAttribute('sandbox', 'allow-storage-access-by-user-activation allow-scripts allow-same-origin');
        iframe.setAttribute('title', 'keycloak-3p-check-iframe');
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        /** @type {Promise<void>} */ const promise = new Promise((resolve)=>{
            /**
       * @param {MessageEvent} event
       */ const messageCallback = (event)=>{
                if (iframe.contentWindow !== event.source) return;
                if (event.data !== 'supported' && event.data !== 'unsupported') return;
                else if (event.data === 'unsupported') {
                    this.#logWarn("[KEYCLOAK] Your browser is blocking access to 3rd-party cookies, this means:\n\n - It is not possible to retrieve tokens without redirecting to the Keycloak server (a.k.a. no support for silent authentication).\n - It is not possible to automatically detect changes to the session status (such as the user logging out in another tab).\n\nFor more information see: https://www.keycloak.org/securing-apps/javascript-adapter#_modern_browsers");
                    this.#loginIframe.enable = false;
                    if (this.silentCheckSsoFallback) this.silentCheckSsoRedirectUri = undefined;
                }
                document.body.removeChild(iframe);
                window.removeEventListener('message', messageCallback);
                resolve();
            };
            window.addEventListener('message', messageCallback, false);
        });
        return await $e73f77be32ef41cd$var$applyTimeoutToPromise(promise, this.messageReceiveTimeout, 'Timeout when waiting for 3rd party check iframe message.');
    }
    /**
   * @param {KeycloakInitOptions} initOptions
   * @returns {Promise<void>}
   */ async #processInit(initOptions) {
        const callback = this.#parseCallback(window.location.href);
        if (callback?.newUrl) window.history.replaceState(window.history.state, '', callback.newUrl);
        if (callback && callback.valid) {
            await this.#setupCheckLoginIframe();
            await this.#processCallback(callback);
            return;
        }
        /** @param {boolean} prompt */ const doLogin = async (prompt)=>{
            /** @type {KeycloakLoginOptions} */ const options = {};
            if (!prompt) options.prompt = 'none';
            if (initOptions.locale) options.locale = initOptions.locale;
            await this.login(options);
        };
        const onLoad = async ()=>{
            switch(initOptions.onLoad){
                case 'check-sso':
                    if (this.#loginIframe.enable) {
                        await this.#setupCheckLoginIframe();
                        const unchanged = await this.#checkLoginIframe();
                        if (!unchanged) this.silentCheckSsoRedirectUri ? await this.#checkSsoSilently() : await doLogin(false);
                    } else this.silentCheckSsoRedirectUri ? await this.#checkSsoSilently() : await doLogin(false);
                    break;
                case 'login-required':
                    await doLogin(true);
                    break;
                default:
                    throw new Error('Invalid value for onLoad');
            }
        };
        if (initOptions.token && initOptions.refreshToken) {
            this.#setToken(initOptions.token, initOptions.refreshToken, initOptions.idToken);
            if (this.#loginIframe.enable) {
                await this.#setupCheckLoginIframe();
                const unchanged = await this.#checkLoginIframe();
                if (unchanged) {
                    this.onAuthSuccess?.();
                    this.#scheduleCheckIframe();
                }
            } else try {
                await this.updateToken(-1);
                this.onAuthSuccess?.();
            } catch (error) {
                this.onAuthError?.();
                if (initOptions.onLoad) await onLoad();
                else throw error;
            }
        } else if (initOptions.onLoad) await onLoad();
    }
    /**
   * @returns {Promise<void>}
   */ async #setupCheckLoginIframe() {
        if (!this.#loginIframe.enable || this.#loginIframe.iframe) return;
        const iframe = document.createElement('iframe');
        this.#loginIframe.iframe = iframe;
        iframe.setAttribute('src', this.endpoints.checkSessionIframe());
        iframe.setAttribute('sandbox', 'allow-storage-access-by-user-activation allow-scripts allow-same-origin');
        iframe.setAttribute('title', 'keycloak-session-iframe');
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        /**
     * @param {MessageEvent} event
     */ const messageCallback = (event)=>{
            if (event.origin !== this.#loginIframe.iframeOrigin || this.#loginIframe.iframe?.contentWindow !== event.source) return;
            if (!(event.data === 'unchanged' || event.data === 'changed' || event.data === 'error')) return;
            if (event.data !== 'unchanged') this.clearToken();
            const callbacks = this.#loginIframe.callbackList;
            this.#loginIframe.callbackList = [];
            for (const callback of callbacks.reverse())if (event.data === 'error') callback(new Error('Error while checking login iframe'));
            else callback(null, event.data === 'unchanged');
        };
        window.addEventListener('message', messageCallback, false);
        /** @type {Promise<void>} */ const promise = new Promise((resolve)=>{
            iframe.addEventListener('load', ()=>{
                const authUrl = this.endpoints.authorize();
                if (authUrl.startsWith('/')) this.#loginIframe.iframeOrigin = globalThis.location.origin;
                else this.#loginIframe.iframeOrigin = new URL(authUrl).origin;
                resolve();
            });
        });
        await promise;
    }
    /**
   * @returns {Promise<boolean | undefined>}
   */ async #checkLoginIframe() {
        if (!this.#loginIframe.iframe || !this.#loginIframe.iframeOrigin) return;
        const message = `${this.clientId} ${this.sessionId ? this.sessionId : ''}`;
        const origin = this.#loginIframe.iframeOrigin;
        /** @type {Promise<boolean>} */ const promise = new Promise((resolve, reject)=>{
            /** @type {(error: Error | null, value?: boolean) => void} */ const callback = (error, result)=>error ? reject(error) : resolve(/** @type {boolean} */ result);
            this.#loginIframe.callbackList.push(callback);
            if (this.#loginIframe.callbackList.length === 1) this.#loginIframe.iframe?.contentWindow?.postMessage(message, origin);
        });
        return await promise;
    }
    /**
   * @returns {Promise<void>}
   */ async #checkSsoSilently() {
        const iframe = document.createElement('iframe');
        const src = await this.createLoginUrl({
            prompt: 'none',
            redirectUri: this.silentCheckSsoRedirectUri
        });
        iframe.setAttribute('src', src);
        iframe.setAttribute('sandbox', 'allow-storage-access-by-user-activation allow-scripts allow-same-origin');
        iframe.setAttribute('title', 'keycloak-silent-check-sso');
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        return await new Promise((resolve, reject)=>{
            /**
       * @param {MessageEvent} event
       */ const messageCallback = async (event)=>{
                if (event.origin !== window.location.origin || iframe.contentWindow !== event.source) return;
                const oauth = this.#parseCallback(event.data);
                try {
                    await this.#processCallback(oauth);
                    resolve();
                } catch (error) {
                    reject(error);
                }
                document.body.removeChild(iframe);
                window.removeEventListener('message', messageCallback);
            };
            window.addEventListener('message', messageCallback);
        });
    }
    /**
   * @param {string} url
   */ #parseCallback(url) {
        const oauth = this.#parseCallbackUrl(url);
        if (!oauth) return;
        const oauthState = this.#callbackStorage.get(oauth.state);
        if (oauthState) {
            oauth.valid = true;
            oauth.redirectUri = oauthState.redirectUri;
            oauth.storedNonce = oauthState.nonce;
            oauth.prompt = oauthState.prompt;
            oauth.pkceCodeVerifier = oauthState.pkceCodeVerifier;
            oauth.loginOptions = oauthState.loginOptions;
        }
        return oauth;
    }
    /**
   * @param {string} urlString
   */ #parseCallbackUrl(urlString) {
        let supportedParams = [];
        switch(this.flow){
            case 'standard':
                supportedParams = [
                    'code',
                    'state',
                    'session_state',
                    'kc_action_status',
                    'kc_action',
                    'iss'
                ];
                break;
            case 'implicit':
                supportedParams = [
                    'access_token',
                    'token_type',
                    'id_token',
                    'state',
                    'session_state',
                    'expires_in',
                    'kc_action_status',
                    'kc_action',
                    'iss'
                ];
                break;
            case 'hybrid':
                supportedParams = [
                    'access_token',
                    'token_type',
                    'id_token',
                    'code',
                    'state',
                    'session_state',
                    'expires_in',
                    'kc_action_status',
                    'kc_action',
                    'iss'
                ];
                break;
        }
        supportedParams.push('error');
        supportedParams.push('error_description');
        supportedParams.push('error_uri');
        const url = new URL(urlString);
        let newUrl = '';
        let parsed;
        if (this.responseMode === 'query' && url.searchParams.size > 0) {
            parsed = this.#parseCallbackParams(url.search, supportedParams);
            url.search = parsed.paramsString;
            newUrl = url.toString();
        } else if (this.responseMode === 'fragment' && url.hash.length > 0) {
            parsed = this.#parseCallbackParams(url.hash.substring(1), supportedParams);
            url.hash = parsed.paramsString;
            newUrl = url.toString();
        }
        if (parsed?.oauthParams) {
            if (this.flow === 'standard' || this.flow === 'hybrid') {
                if ((parsed.oauthParams.code || parsed.oauthParams.error) && parsed.oauthParams.state) {
                    parsed.oauthParams.newUrl = newUrl;
                    return parsed.oauthParams;
                }
            } else if (this.flow === 'implicit') {
                if ((parsed.oauthParams.access_token || parsed.oauthParams.error) && parsed.oauthParams.state) {
                    parsed.oauthParams.newUrl = newUrl;
                    return parsed.oauthParams;
                }
            }
        }
    }
    /**
   * @typedef {Object} ParsedCallbackParams
   * @property {string} paramsString
   * @property {Record<string, string | undefined>} oauthParams
   */ /**
   * @param {string} paramsString
   * @param {string[]} supportedParams
   * @returns {ParsedCallbackParams}
   */ #parseCallbackParams(paramsString, supportedParams) {
        const params = paramsString.split('&');
        /** @type {Record<string, string>} */ const oauthParams = {};
        let result = '';
        for (const param of params.reverse()){
            const entry = new URLSearchParams(param).entries().next().value;
            if (!entry) {
                result = '&' + result;
                continue;
            }
            const [key, value] = entry;
            if (supportedParams.includes(key) && !(key in oauthParams)) oauthParams[key] = value;
            else result = result.length === 0 ? param : param + '&' + result;
        }
        return {
            paramsString: result,
            oauthParams: oauthParams
        };
    }
    async #processCallback(oauth) {
        const { code: code, error: error, prompt: prompt } = oauth;
        let timeLocal = new Date().getTime();
        /**
     * @param {string} accessToken
     * @param {string=} refreshToken
     * @param {string=} idToken
     */ const authSuccess = (accessToken, refreshToken, idToken)=>{
            timeLocal = (timeLocal + new Date().getTime()) / 2;
            this.#setToken(accessToken, refreshToken, idToken, timeLocal);
            if (this.#useNonce && this.idTokenParsed && this.idTokenParsed.nonce !== oauth.storedNonce) {
                this.#logInfo('[KEYCLOAK] Invalid nonce, clearing token');
                this.clearToken();
                throw new Error('Invalid nonce.');
            }
        };
        if (oauth.kc_action_status) this.onActionUpdate && this.onActionUpdate(oauth.kc_action_status, oauth.kc_action);
        if (error) {
            if (prompt !== 'none') {
                if (oauth.error_description && oauth.error_description === 'authentication_expired') await this.login(oauth.loginOptions);
                else {
                    const errorData = {
                        error: error,
                        error_description: oauth.error_description
                    };
                    this.onAuthError?.(errorData);
                    throw errorData;
                }
            }
            return;
        } else if (this.flow !== 'standard' && (oauth.access_token || oauth.id_token)) {
            authSuccess(oauth.access_token, undefined, oauth.id_token);
            this.onAuthSuccess?.();
        }
        if (this.flow !== 'implicit' && code) try {
            const response = await $e73f77be32ef41cd$var$fetchAccessToken(this.endpoints.token(), code, /** @type {string} */ this.clientId, oauth.redirectUri, oauth.pkceCodeVerifier);
            authSuccess(response.access_token, response.refresh_token, response.id_token);
            if (this.flow === 'standard') this.onAuthSuccess?.();
            this.#scheduleCheckIframe();
        } catch (error) {
            this.onAuthError?.();
            throw error;
        }
    }
    async #scheduleCheckIframe() {
        if (this.#loginIframe.enable && this.token) {
            await $e73f77be32ef41cd$var$waitForTimeout(this.#loginIframe.interval * 1000);
            const unchanged = await this.#checkLoginIframe();
            if (unchanged) await this.#scheduleCheckIframe();
        }
    }
    /**
   * @param {KeycloakLoginOptions} [options]
   * @returns {Promise<void>}
   */ login = (options)=>{
        return this.#adapter.login(options);
    };
    /**
   * @param {KeycloakLoginOptions} [options]
   * @returns {Promise<string>}
   */ createLoginUrl = async (options)=>{
        const state = $e73f77be32ef41cd$var$createUUID();
        const nonce = $e73f77be32ef41cd$var$createUUID();
        const redirectUri = this.#adapter.redirectUri(options);
        /** @type {CallbackState} */ const callbackState = {
            state: state,
            nonce: nonce,
            redirectUri: redirectUri,
            loginOptions: options
        };
        if (options?.prompt) callbackState.prompt = options.prompt;
        const url = options?.action === 'register' ? this.endpoints.register() : this.endpoints.authorize();
        let scope = options?.scope || this.scope;
        const scopeValues = scope ? scope.split(' ') : [];
        // Ensure the 'openid' scope is always included.
        if (!scopeValues.includes('openid')) scopeValues.unshift('openid');
        scope = scopeValues.join(' ');
        const params = new URLSearchParams([
            [
                'client_id',
                /** @type {string} */ this.clientId
            ],
            [
                'redirect_uri',
                redirectUri
            ],
            [
                'state',
                state
            ],
            [
                'response_mode',
                this.responseMode
            ],
            [
                'response_type',
                this.responseType
            ],
            [
                'scope',
                scope
            ]
        ]);
        if (this.#useNonce) params.append('nonce', nonce);
        if (options?.prompt) params.append('prompt', options.prompt);
        if (typeof options?.maxAge === 'number') params.append('max_age', options.maxAge.toString());
        if (options?.loginHint) params.append('login_hint', options.loginHint);
        if (options?.idpHint) params.append('kc_idp_hint', options.idpHint);
        if (options?.action && options.action !== 'register') params.append('kc_action', options.action);
        if (options?.locale) params.append('ui_locales', options.locale);
        if (options?.acr) params.append('claims', $e73f77be32ef41cd$var$buildClaimsParameter(options.acr));
        if (options?.acrValues) params.append('acr_values', options.acrValues);
        if (this.pkceMethod) try {
            const codeVerifier = $e73f77be32ef41cd$var$generateCodeVerifier(96);
            const pkceChallenge = await $e73f77be32ef41cd$var$generatePkceChallenge(this.pkceMethod, codeVerifier);
            callbackState.pkceCodeVerifier = codeVerifier;
            params.append('code_challenge', pkceChallenge);
            params.append('code_challenge_method', this.pkceMethod);
        } catch (error) {
            throw new Error('Failed to generate PKCE challenge.', {
                cause: error
            });
        }
        this.#callbackStorage.add(callbackState);
        return `${url}?${params.toString()}`;
    };
    /**
   * @param {KeycloakLogoutOptions} [options]
   * @returns {Promise<void>}
   */ logout = (options)=>{
        return this.#adapter.logout(options);
    };
    /**
   * @param {KeycloakLogoutOptions} [options]
   * @returns {string}
   */ createLogoutUrl = (options)=>{
        const logoutMethod = options?.logoutMethod ?? this.logoutMethod;
        const url = this.endpoints.logout();
        if (logoutMethod === 'POST') return url;
        const params = new URLSearchParams([
            [
                'client_id',
                /** @type {string} */ this.clientId
            ],
            [
                'post_logout_redirect_uri',
                this.#adapter.redirectUri(options)
            ]
        ]);
        if (this.idToken) params.append('id_token_hint', this.idToken);
        return `${url}?${params.toString()}`;
    };
    /**
   * @param {KeycloakRegisterOptions} [options]
   * @returns {Promise<void>}
   */ register = (options)=>{
        return this.#adapter.register(options);
    };
    /**
   * @param {KeycloakRegisterOptions} [options]
   * @returns {Promise<string>}
   */ createRegisterUrl = (options)=>{
        return this.createLoginUrl({
            ...options,
            action: 'register'
        });
    };
    /**
   * @param {KeycloakAccountOptions} [options]
   * @returns {string}
   */ createAccountUrl = (options)=>{
        const url = this.#getRealmUrl();
        if (!url) throw new Error('Unable to create account URL, make sure the adapter is not configured using a generic OIDC provider.');
        const params = new URLSearchParams([
            [
                'referrer',
                /** @type {string} */ this.clientId
            ],
            [
                'referrer_uri',
                this.#adapter.redirectUri(options)
            ]
        ]);
        return `${url}/account?${params.toString()}`;
    };
    /**
   * @returns {Promise<void>}
   */ accountManagement = ()=>{
        return this.#adapter.accountManagement();
    };
    /**
   * @param {string} role
   * @returns {boolean}
   */ hasRealmRole = (role)=>{
        const access = this.realmAccess;
        return !!access && access.roles.indexOf(role) >= 0;
    };
    /**
   * @param {string} role
   * @param {string} [resource]
   * @returns {boolean}
   */ hasResourceRole = (role, resource)=>{
        if (!this.resourceAccess) return false;
        const access = this.resourceAccess[resource || /** @type {string} */ this.clientId];
        return !!access && access.roles.indexOf(role) >= 0;
    };
    /**
   * @returns {Promise<KeycloakProfile>}
   */ loadUserProfile = async ()=>{
        const realmUrl = this.#getRealmUrl();
        if (!realmUrl) throw new Error('Unable to load user profile, make sure the adapter is not configured using a generic OIDC provider.');
        const url = `${realmUrl}/account`;
        /** @type {KeycloakProfile} */ const profile = await $e73f77be32ef41cd$var$fetchJSON(url, {
            headers: [
                $e73f77be32ef41cd$var$buildAuthorizationHeader(this.token)
            ]
        });
        return this.profile = profile;
    };
    /**
   * @returns {Promise<{}>}
   */ loadUserInfo = async ()=>{
        const url = this.endpoints.userinfo();
        /** @type {{}} */ const userInfo = await $e73f77be32ef41cd$var$fetchJSON(url, {
            headers: [
                $e73f77be32ef41cd$var$buildAuthorizationHeader(this.token)
            ]
        });
        return this.userInfo = userInfo;
    };
    /**
   * @param {number} [minValidity]
   * @returns {boolean}
   */ isTokenExpired = (minValidity)=>{
        if (!this.tokenParsed || !this.refreshToken && this.flow !== 'implicit') throw new Error('Not authenticated');
        if (this.timeSkew == null) {
            this.#logInfo('[KEYCLOAK] Unable to determine if token is expired as timeskew is not set');
            return true;
        }
        if (typeof this.tokenParsed.exp !== 'number') return false;
        let expiresIn = this.tokenParsed.exp - Math.ceil(new Date().getTime() / 1000) + this.timeSkew;
        if (minValidity) {
            if (isNaN(minValidity)) throw new Error('Invalid minValidity');
            expiresIn -= minValidity;
        }
        return expiresIn < 0;
    };
    /**
   * @param {number} minValidity
   * @returns {Promise<boolean>}
   */ updateToken = async (minValidity)=>{
        if (!this.refreshToken) throw new Error('Unable to update token, no refresh token available.');
        minValidity = minValidity || 5;
        if (this.#loginIframe.enable) await this.#checkLoginIframe();
        let refreshToken = false;
        if (minValidity === -1) {
            refreshToken = true;
            this.#logInfo('[KEYCLOAK] Refreshing token: forced refresh');
        } else if (!this.tokenParsed || this.isTokenExpired(minValidity)) {
            refreshToken = true;
            this.#logInfo('[KEYCLOAK] Refreshing token: token expired');
        }
        if (!refreshToken) return false;
        /** @type {PromiseWithResolvers<boolean>} */ const { promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers();
        this.#refreshQueue.push({
            resolve: resolve,
            reject: reject
        });
        if (this.#refreshQueue.length === 1) {
            const url = this.endpoints.token();
            let timeLocal = new Date().getTime();
            try {
                const response = await $e73f77be32ef41cd$var$fetchRefreshToken(url, this.refreshToken, /** @type {string} */ this.clientId);
                this.#logInfo('[KEYCLOAK] Token refreshed');
                timeLocal = (timeLocal + new Date().getTime()) / 2;
                this.#setToken(response.access_token, response.refresh_token, response.id_token, timeLocal);
                this.onAuthRefreshSuccess?.();
                for(let p = this.#refreshQueue.pop(); p != null; p = this.#refreshQueue.pop())p.resolve(true);
            } catch (error) {
                this.#logWarn('[KEYCLOAK] Failed to refresh token');
                if (error instanceof $e73f77be32ef41cd$export$bae979e68e4dc802 && error.response.status === 400) this.clearToken();
                this.onAuthRefreshError?.();
                for(let p = this.#refreshQueue.pop(); p != null; p = this.#refreshQueue.pop())p.reject(error);
            }
        }
        return await promise;
    };
    clearToken = ()=>{
        if (this.token) {
            this.#setToken();
            this.onAuthLogout?.();
            if (this.loginRequired) this.login();
        }
    };
    /**
   * @param {string} [token]
   * @param {string} [refreshToken]
   * @param {string} [idToken]
   * @param {number} [timeLocal]
   */ #setToken(token, refreshToken, idToken, timeLocal) {
        if (this.tokenTimeoutHandle) {
            clearTimeout(this.tokenTimeoutHandle);
            this.tokenTimeoutHandle = undefined;
        }
        if (refreshToken) {
            this.refreshToken = refreshToken;
            this.refreshTokenParsed = $e73f77be32ef41cd$var$decodeToken(refreshToken);
        } else {
            delete this.refreshToken;
            delete this.refreshTokenParsed;
        }
        if (idToken) {
            this.idToken = idToken;
            this.idTokenParsed = $e73f77be32ef41cd$var$decodeToken(idToken);
        } else {
            delete this.idToken;
            delete this.idTokenParsed;
        }
        if (token) {
            this.token = token;
            this.tokenParsed = $e73f77be32ef41cd$var$decodeToken(token);
            this.sessionId = this.tokenParsed.sid;
            this.authenticated = true;
            this.subject = this.tokenParsed.sub;
            this.realmAccess = this.tokenParsed.realm_access;
            this.resourceAccess = this.tokenParsed.resource_access;
            if (timeLocal) this.timeSkew = Math.floor(timeLocal / 1000) - this.tokenParsed.iat;
            if (this.timeSkew !== null) {
                this.#logInfo('[KEYCLOAK] Estimated time difference between browser and server is ' + this.timeSkew + ' seconds');
                if (this.onTokenExpired) {
                    const expiresIn = (this.tokenParsed.exp - new Date().getTime() / 1000 + this.timeSkew) * 1000;
                    this.#logInfo('[KEYCLOAK] Token expires in ' + Math.round(expiresIn / 1000) + ' s');
                    if (expiresIn <= 0) this.onTokenExpired();
                    else this.tokenTimeoutHandle = window.setTimeout(this.onTokenExpired, expiresIn);
                }
            }
        } else {
            delete this.token;
            delete this.tokenParsed;
            delete this.subject;
            delete this.realmAccess;
            delete this.resourceAccess;
            this.authenticated = false;
        }
    }
    /**
   * @returns {string=}
   */ #getRealmUrl() {
        if (typeof this.authServerUrl === 'undefined') return;
        return `${$e73f77be32ef41cd$var$stripTrailingSlash(this.authServerUrl)}/realms/${encodeURIComponent(/** @type {string} */ this.realm)}`;
    }
    /**
   * @param {Function} fn
   * @returns {(message: string) => void}
   */ #createLogger(fn) {
        return (message)=>{
            if (this.enableLogging) fn.call(console, message);
        };
    }
}
/**
 * @returns {string}
 */ function $e73f77be32ef41cd$var$createUUID() {
    if (typeof crypto === 'undefined' || typeof crypto.randomUUID === 'undefined') throw new Error('Web Crypto API is not available.');
    return crypto.randomUUID();
}
/**
 * @param {Acr} requestedAcr
 * @returns {string}
 */ function $e73f77be32ef41cd$var$buildClaimsParameter(requestedAcr) {
    return JSON.stringify({
        id_token: {
            acr: requestedAcr
        }
    });
}
/**
 * @param {number} len
 * @returns {string}
 */ function $e73f77be32ef41cd$var$generateCodeVerifier(len) {
    return $e73f77be32ef41cd$var$generateRandomString(len, 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789');
}
/**
 * @param {string} pkceMethod
 * @param {string} codeVerifier
 * @returns {Promise<string>}
 */ async function $e73f77be32ef41cd$var$generatePkceChallenge(pkceMethod, codeVerifier) {
    if (pkceMethod !== 'S256') throw new TypeError(`Invalid value for 'pkceMethod', expected 'S256' but got '${pkceMethod}'.`);
    // hash codeVerifier, then encode as url-safe base64 without padding
    const hashBytes = new Uint8Array(await $e73f77be32ef41cd$var$sha256Digest(codeVerifier));
    const encodedHash = $e73f77be32ef41cd$var$bytesToBase64(hashBytes).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    return encodedHash;
}
/**
 * @param {number} len
 * @param {string} alphabet
 * @returns {string}
 */ function $e73f77be32ef41cd$var$generateRandomString(len, alphabet) {
    const randomData = $e73f77be32ef41cd$var$generateRandomData(len);
    const chars = new Array(len);
    for(let i = 0; i < len; i++)chars[i] = alphabet.charCodeAt(randomData[i] % alphabet.length);
    return String.fromCharCode.apply(null, chars);
}
/**
 * @param {number} len
 * @returns {Uint8Array<ArrayBuffer>}
 */ function $e73f77be32ef41cd$var$generateRandomData(len) {
    if (typeof crypto === 'undefined' || typeof crypto.getRandomValues === 'undefined') throw new Error('Web Crypto API is not available.');
    return crypto.getRandomValues(new Uint8Array(len));
}
/**
 * Function to extend existing native Promise with timeout
 *
 * @template T
 * @param {Promise<T>} promise
 * @param {number} timeout
 * @param {string} errorMessage
 * @returns {Promise<T>}
 */ function $e73f77be32ef41cd$var$applyTimeoutToPromise(promise, timeout, errorMessage) {
    /** @type {number} */ let timeoutHandle;
    const timeoutPromise = new Promise(function(resolve, reject) {
        timeoutHandle = window.setTimeout(function() {
            reject(new Error(errorMessage || 'Promise is not settled within timeout of ' + timeout + 'ms'));
        }, timeout);
    });
    return Promise.race([
        promise,
        timeoutPromise
    ]).finally(function() {
        clearTimeout(timeoutHandle);
    });
}
/**
 * @returns {CallbackStorage}
 */ function $e73f77be32ef41cd$var$createCallbackStorage() {
    try {
        return new $e73f77be32ef41cd$var$LocalStorage();
    } catch (err) {
        return new $e73f77be32ef41cd$var$CookieStorage();
    }
}
const $e73f77be32ef41cd$var$STORAGE_KEY_PREFIX = 'kc-callback-';
/**
 * @typedef {Object} CallbackState
 * @property {string} state
 * @property {string} nonce
 * @property {string} redirectUri
 * @property {KeycloakLoginOptions} [loginOptions]
 * @property {KeycloakLoginOptions['prompt']} [prompt]
 * @property {string} [pkceCodeVerifier]
 */ /**
 * @typedef {Object} CallbackStorage
 * @property {(state?: string) => CallbackState | null} get
 * @property {(state: CallbackState) => void} add
 */ /**
 * @implements {CallbackStorage}
 */ class $e73f77be32ef41cd$var$LocalStorage {
    constructor(){
        globalThis.localStorage.setItem('kc-test', 'test');
        globalThis.localStorage.removeItem('kc-test');
    }
    /**
   * @param {string} [state]
   * @returns {CallbackState | null}
   */ get(state) {
        if (!state) return null;
        this.#clearInvalidValues();
        const key = $e73f77be32ef41cd$var$STORAGE_KEY_PREFIX + state;
        const value = globalThis.localStorage.getItem(key);
        if (value) {
            globalThis.localStorage.removeItem(key);
            return JSON.parse(value);
        }
        return null;
    }
    /**
   * @param {CallbackState} state
   */ add(state) {
        this.#clearInvalidValues();
        const key = $e73f77be32ef41cd$var$STORAGE_KEY_PREFIX + state.state;
        const value = JSON.stringify({
            ...state,
            // Set the expiry time to 1 hour from now.
            expires: Date.now() + 3600000
        });
        try {
            globalThis.localStorage.setItem(key, value);
        } catch (error) {
            // If the storage is full, clear all known values and try again.
            this.#clearAllValues();
            globalThis.localStorage.setItem(key, value);
        }
    }
    /**
   * Clears all values from local storage that are no longer valid.
   */ #clearInvalidValues() {
        const currentTime = Date.now();
        for (const [key, value] of this.#getStoredEntries()){
            // Attempt to parse the expiry time from the value.
            const expiry = this.#parseExpiry(value);
            // Discard the value if it is malformed or expired.
            if (expiry === null || expiry < currentTime) globalThis.localStorage.removeItem(key);
        }
    }
    /**
   * Clears all known values from local storage.
   */ #clearAllValues() {
        for (const [key] of this.#getStoredEntries())globalThis.localStorage.removeItem(key);
    }
    /**
   * Gets all entries stored in local storage that are known to be managed by this class.
   * @returns {[string, string][]} An array of key-value pairs.
   */ #getStoredEntries() {
        return Object.entries(globalThis.localStorage).filter(([key])=>key.startsWith($e73f77be32ef41cd$var$STORAGE_KEY_PREFIX));
    }
    /**
   * Parses the expiry time from a value stored in local storage.
   * @param {string} value
   * @returns {number | null} The expiry time in milliseconds, or `null` if the value is malformed.
   */ #parseExpiry(value) {
        let parsedValue;
        // Attempt to parse the value as JSON.
        try {
            parsedValue = JSON.parse(value);
        } catch (error) {
            return null;
        }
        // Attempt to extract the 'expires' property.
        if ($e73f77be32ef41cd$var$isObject(parsedValue) && 'expires' in parsedValue && typeof parsedValue.expires === 'number') return parsedValue.expires;
        return null;
    }
}
/**
 * @implements {CallbackStorage}
 */ class $e73f77be32ef41cd$var$CookieStorage {
    /**
   * @param {string} [state]
   * @returns {CallbackState | null}
   */ get(state) {
        if (!state) return null;
        const value = this.#getCookie($e73f77be32ef41cd$var$STORAGE_KEY_PREFIX + state);
        this.#setCookie($e73f77be32ef41cd$var$STORAGE_KEY_PREFIX + state, '', this.#cookieExpiration(-100));
        if (value) return JSON.parse(value);
        return null;
    }
    /**
   * @param {CallbackState} state
   */ add(state) {
        this.#setCookie($e73f77be32ef41cd$var$STORAGE_KEY_PREFIX + state.state, JSON.stringify(state), this.#cookieExpiration(60));
    }
    /**
   * @param {string} key
   * @returns
   */ #getCookie(key) {
        const name = key + '=';
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1);
            if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
        }
        return '';
    }
    /**
   * @param {string} key
   * @param {string} value
   * @param {Date} expirationDate
   */ #setCookie(key, value, expirationDate) {
        const cookie = key + '=' + value + '; ' + 'expires=' + expirationDate.toUTCString() + '; ';
        document.cookie = cookie;
    }
    /**
   * @param {number} minutes
   * @returns {Date}
   */ #cookieExpiration(minutes) {
        const exp = new Date();
        exp.setTime(exp.getTime() + minutes * 60000);
        return exp;
    }
}
/**
 * @param {Uint8Array<ArrayBuffer>} bytes
 * @see https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
 */ function $e73f77be32ef41cd$var$bytesToBase64(bytes) {
    const binString = String.fromCodePoint(...bytes);
    return btoa(binString);
}
/**
 * @param {string} message
 * @see https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest#basic_example
 */ async function $e73f77be32ef41cd$var$sha256Digest(message) {
    const encoder = new TextEncoder();
    const data = encoder.encode(message);
    if (typeof crypto === 'undefined' || typeof crypto.subtle === 'undefined') throw new Error('Web Crypto API is not available.');
    return await crypto.subtle.digest('SHA-256', data);
}
/**
 * @param {string} token
 * @returns {KeycloakTokenParsed}
 */ function $e73f77be32ef41cd$var$decodeToken(token) {
    const [, payload] = token.split('.');
    if (typeof payload !== 'string') throw new Error('Unable to decode token, payload not found.');
    let decoded;
    try {
        decoded = $e73f77be32ef41cd$var$base64UrlDecode(payload);
    } catch (error) {
        throw new Error('Unable to decode token, payload is not a valid Base64URL value.', {
            cause: error
        });
    }
    try {
        return JSON.parse(decoded);
    } catch (error) {
        throw new Error('Unable to decode token, payload is not a valid JSON value.', {
            cause: error
        });
    }
}
/**
 * @param {string} input
 */ function $e73f77be32ef41cd$var$base64UrlDecode(input) {
    let output = input.replaceAll('-', '+').replaceAll('_', '/');
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += '==';
            break;
        case 3:
            output += '=';
            break;
        default:
            throw new Error('Input is not of the correct length.');
    }
    try {
        return $e73f77be32ef41cd$var$b64DecodeUnicode(output);
    } catch (error) {
        return atob(output);
    }
}
/**
 * @param {string} input
 */ function $e73f77be32ef41cd$var$b64DecodeUnicode(input) {
    return decodeURIComponent(atob(input).replace(/(.)/g, (m, p)=>{
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = '0' + code;
        return '%' + code;
    }));
}
/**
 * Check if the input is an object that can be operated on.
 * @param {unknown} input
 */ function $e73f77be32ef41cd$var$isObject(input) {
    return typeof input === 'object' && input !== null;
}
/**
 * @typedef {Object} JsonConfig The JSON version of the adapter configuration.
 * @property {string} auth-server-url The URL of the authentication server.
 * @property {string} realm The name of the realm.
 * @property {string} resource The name of the resource, usually the client ID.
 */ /**
 * Fetch the adapter configuration from the given URL.
 * @param {string} url
 * @returns {Promise<JsonConfig>}
 */ async function $e73f77be32ef41cd$var$fetchJsonConfig(url) {
    return await $e73f77be32ef41cd$var$fetchJSON(url);
}
/**
 * Fetch the OpenID configuration from the given URL.
 * @param {string} url
 * @returns {Promise<OpenIdProviderMetadata>}
 */ async function $e73f77be32ef41cd$var$fetchOpenIdConfig(url) {
    return await $e73f77be32ef41cd$var$fetchJSON(url);
}
/**
 * @typedef {Object} AccessTokenResponse The successful token response from the authorization server, based on the {@link https://datatracker.ietf.org/doc/html/rfc6749#section-5.1 OAuth 2.0 Authorization Framework specification}.
 * @property {string} access_token The access token issued by the authorization server.
 * @property {string} token_type The type of the token issued by the authorization server.
 * @property {number} [expires_in] The lifetime in seconds of the access token.
 * @property {string} [refresh_token] The refresh token issued by the authorization server.
 * @property {string} [id_token] The ID token issued by the authorization server, if requested.
 * @property {string} [scope] The scope of the access token.
 */ /**
 * Fetch the access token from the given URL.
 * @param {string} url
 * @param {string} code
 * @param {string} clientId
 * @param {string} redirectUri
 * @param {string} [pkceCodeVerifier]
 * @returns {Promise<AccessTokenResponse>}
 */ async function $e73f77be32ef41cd$var$fetchAccessToken(url, code, clientId, redirectUri, pkceCodeVerifier) {
    const body = new URLSearchParams([
        [
            'code',
            code
        ],
        [
            'grant_type',
            'authorization_code'
        ],
        [
            'client_id',
            clientId
        ],
        [
            'redirect_uri',
            redirectUri
        ]
    ]);
    if (pkceCodeVerifier) body.append('code_verifier', pkceCodeVerifier);
    return await $e73f77be32ef41cd$var$fetchJSON(url, {
        method: 'POST',
        credentials: 'include',
        body: body
    });
}
/**
 * Fetch the refresh token from the given URL.
 * @param {string} url
 * @param {string} refreshToken
 * @param {string} clientId
 * @returns {Promise<AccessTokenResponse>}
 */ async function $e73f77be32ef41cd$var$fetchRefreshToken(url, refreshToken, clientId) {
    const body = new URLSearchParams([
        [
            'grant_type',
            'refresh_token'
        ],
        [
            'refresh_token',
            refreshToken
        ],
        [
            'client_id',
            clientId
        ]
    ]);
    return await $e73f77be32ef41cd$var$fetchJSON(url, {
        method: 'POST',
        credentials: 'include',
        body: body
    });
}
/**
 * @template [T=unknown]
 * @param {string} url
 * @param {RequestInit} init
 * @returns {Promise<T>}
 */ async function $e73f77be32ef41cd$var$fetchJSON(url, init = {}) {
    const headers = new Headers(init.headers);
    headers.set('Accept', $e73f77be32ef41cd$var$CONTENT_TYPE_JSON);
    const response = await $e73f77be32ef41cd$var$fetchWithErrorHandling(url, {
        ...init,
        headers: headers
    });
    return await response.json();
}
/**
 * @param {string} url
 * @param {RequestInit} [init]
 * @returns {Promise<Response>}
 */ async function $e73f77be32ef41cd$var$fetchWithErrorHandling(url, init) {
    const response = await fetch(url, init);
    if (!response.ok) throw new $e73f77be32ef41cd$export$bae979e68e4dc802('Server responded with an invalid status.', {
        response: response
    });
    return response;
}
/**
 * @param {string} [token]
 * @returns {[string, string]}
 */ function $e73f77be32ef41cd$var$buildAuthorizationHeader(token) {
    if (!token) throw new Error('Unable to build authorization header, token is not set, make sure the user is authenticated.');
    return [
        'Authorization',
        `bearer ${token}`
    ];
}
/**
 * @param {string} url
 * @returns {string}
 */ function $e73f77be32ef41cd$var$stripTrailingSlash(url) {
    return url.endsWith('/') ? url.slice(0, -1) : url;
}
class $e73f77be32ef41cd$export$bae979e68e4dc802 extends Error {
    /** @type {Response} */ response;
    /**
   * @param {string} message
   * @param {NetworkErrorOptions} options
   */ constructor(message, options){
        super(message, options);
        this.response = options.response;
    }
}
/**
 * @param {number} delay
 * @returns {Promise<void>}
 */ const $e73f77be32ef41cd$var$waitForTimeout = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));


const $96e14f2a7c3555e4$var$DJANGO_BASE_URL = "https://apbot-test.ngrisetech.com";
const $96e14f2a7c3555e4$var$API_BASE_URL = "https://apbot-test.ngrisetech.com/api";
const $96e14f2a7c3555e4$var$KEYCLOAK_URL = "https://apbot-test.ngrisetech.com/auth";
const $96e14f2a7c3555e4$var$KEYCLOAK_REALM = "ngrisetech";
const $96e14f2a7c3555e4$var$KEYCLOAK_CLIENT_ID = "ngrisetech";
const $96e14f2a7c3555e4$var$KEYCLOAK_ADMIN_BASE_URL = `${$96e14f2a7c3555e4$var$KEYCLOAK_URL}/admin/realms/${$96e14f2a7c3555e4$var$KEYCLOAK_REALM}`;
const $96e14f2a7c3555e4$export$44ffa8fec8da147b = [
    "SuperUser",
    "Processor",
    "Checker",
    "Uploader",
    "Data_Uploader",
    "Initiator",
    "Approver"
];
const $96e14f2a7c3555e4$var$keycloak = new (0, $e73f77be32ef41cd$export$2e2bcd8739ae039)({
    url: $96e14f2a7c3555e4$var$KEYCLOAK_URL,
    realm: $96e14f2a7c3555e4$var$KEYCLOAK_REALM,
    clientId: $96e14f2a7c3555e4$var$KEYCLOAK_CLIENT_ID
});
let $96e14f2a7c3555e4$var$authInitialized = false;
let $96e14f2a7c3555e4$var$authInitPromise = null;
function $96e14f2a7c3555e4$var$resolvePkceMethod() {
    const configuredMethod = "".trim().toLowerCase();
    if (configuredMethod === "false" || configuredMethod === "off" || configuredMethod === "none") return false;
    if (configuredMethod === "s256") return "S256";
    return window.isSecureContext ? "S256" : false;
}
async function $96e14f2a7c3555e4$var$getAccessToken() {
    if (!$96e14f2a7c3555e4$var$keycloak.authenticated) return null;
    try {
        await $96e14f2a7c3555e4$var$keycloak.updateToken(30);
    } catch (error) {
        await $96e14f2a7c3555e4$var$keycloak.login({
            redirectUri: $96e14f2a7c3555e4$var$getKeycloakRedirectUri()
        });
        return null;
    }
    return $96e14f2a7c3555e4$var$keycloak.token || null;
}
function $96e14f2a7c3555e4$var$getKeycloakRedirectUri() {
    return `${window.location.origin}${window.location.pathname}`;
}
function $96e14f2a7c3555e4$export$5d9c32988b6a9848(path) {
    if (path.startsWith("http://") || path.startsWith("https://")) return path;
    return `${$96e14f2a7c3555e4$var$DJANGO_BASE_URL}${path}`;
}
async function $96e14f2a7c3555e4$export$84e83902d3a16987() {
    return null;
}
async function $96e14f2a7c3555e4$export$e9dbbdd5c9d6144f() {
    if ($96e14f2a7c3555e4$var$authInitialized) return $96e14f2a7c3555e4$var$keycloak.authenticated === true;
    if ($96e14f2a7c3555e4$var$authInitPromise) return $96e14f2a7c3555e4$var$authInitPromise;
    $96e14f2a7c3555e4$var$authInitPromise = $96e14f2a7c3555e4$var$keycloak.init({
        onLoad: "check-sso",
        checkLoginIframe: false,
        pkceMethod: $96e14f2a7c3555e4$var$resolvePkceMethod(),
        responseMode: "query"
    }).then((authenticated)=>{
        $96e14f2a7c3555e4$var$authInitialized = true;
        return authenticated;
    }).catch(()=>{
        $96e14f2a7c3555e4$var$authInitialized = true;
        return false;
    });
    return $96e14f2a7c3555e4$var$authInitPromise;
}
function $96e14f2a7c3555e4$export$ab2fed14dcfadce5() {
    return $96e14f2a7c3555e4$var$keycloak.login({
        redirectUri: $96e14f2a7c3555e4$var$getKeycloakRedirectUri()
    });
}
function $96e14f2a7c3555e4$export$aea3261845a0a415() {
    return $96e14f2a7c3555e4$var$keycloak.logout({
        redirectUri: window.location.origin
    });
}
function $96e14f2a7c3555e4$export$d4b13869fa98ba02() {
    if (!$96e14f2a7c3555e4$var$keycloak.tokenParsed) return null;
    return {
        sub: $96e14f2a7c3555e4$var$keycloak.tokenParsed.sub,
        username: $96e14f2a7c3555e4$var$keycloak.tokenParsed.preferred_username,
        email: $96e14f2a7c3555e4$var$keycloak.tokenParsed.email,
        name: $96e14f2a7c3555e4$var$keycloak.tokenParsed.name
    };
}
function $96e14f2a7c3555e4$export$e819be646df26d02() {
    if (!$96e14f2a7c3555e4$var$keycloak.authenticated || !$96e14f2a7c3555e4$var$keycloak.tokenParsed) return {
        authenticated: false,
        roles: [],
        teams: [],
        profile: null
    };
    const realmAccess = $96e14f2a7c3555e4$var$keycloak.tokenParsed.realm_access || {};
    const roles = Array.isArray(realmAccess.roles) ? realmAccess.roles : [];
    const rawGroups = Array.isArray($96e14f2a7c3555e4$var$keycloak.tokenParsed.groups) ? $96e14f2a7c3555e4$var$keycloak.tokenParsed.groups : [];
    const groupTeams = rawGroups.map((groupPath)=>String(groupPath || "")).map((groupPath)=>groupPath.split("/").filter(Boolean).pop() || "").filter(Boolean);
    const tokenTeams = Array.isArray($96e14f2a7c3555e4$var$keycloak.tokenParsed.teams) ? $96e14f2a7c3555e4$var$keycloak.tokenParsed.teams : [];
    const teams = groupTeams.length ? groupTeams : tokenTeams;
    const organizations = Array.isArray($96e14f2a7c3555e4$var$keycloak.tokenParsed.organizations) ? $96e14f2a7c3555e4$var$keycloak.tokenParsed.organizations : [];
    return {
        authenticated: true,
        roles: roles,
        teams: teams,
        organizations: organizations,
        profile: $96e14f2a7c3555e4$export$d4b13869fa98ba02()
    };
}
const $96e14f2a7c3555e4$var$djangoClient = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).create({
    baseURL: $96e14f2a7c3555e4$var$DJANGO_BASE_URL,
    timeout: 60000
});
const $96e14f2a7c3555e4$var$keycloakAdminClient = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).create({
    baseURL: $96e14f2a7c3555e4$var$KEYCLOAK_ADMIN_BASE_URL,
    timeout: 60000
});
$96e14f2a7c3555e4$var$djangoClient.interceptors.request.use(async (config)=>{
    const token = await $96e14f2a7c3555e4$var$getAccessToken();
    const headers = config.headers || {};
    if (token) headers.Authorization = `Bearer ${token}`;
    config.headers = headers;
    return config;
});
$96e14f2a7c3555e4$var$keycloakAdminClient.interceptors.request.use(async (config)=>{
    const token = await $96e14f2a7c3555e4$var$getAccessToken();
    if (!token) throw new Error("Keycloak authentication is required.");
    const headers = config.headers || {};
    headers.Authorization = `Bearer ${token}`;
    config.headers = headers;
    return config;
});
function $96e14f2a7c3555e4$var$toAbsoluteBackendUrl(url) {
    if (!url) return `${$96e14f2a7c3555e4$var$DJANGO_BASE_URL}/`;
    if (typeof url !== "string") return String(url);
    if (url.startsWith("http://") || url.startsWith("https://")) return url;
    return `${$96e14f2a7c3555e4$var$DJANGO_BASE_URL}${url.startsWith("/") ? "" : "/"}${url}`;
}
function $96e14f2a7c3555e4$var$headersToObject(headers) {
    if (!headers) return {};
    if (headers instanceof Headers) {
        const result = {};
        headers.forEach((value, key)=>{
            result[key] = value;
        });
        return result;
    }
    return {
        ...headers
    };
}
function $96e14f2a7c3555e4$export$521461945d438145() {
    const originalFetch = window.fetch.bind(window);
    const resolveWithCredentials = (credentials, requestUrl)=>{
        const effectiveCredentials = credentials || "same-origin";
        if (effectiveCredentials === "include") return true;
        if (effectiveCredentials === "omit") return false;
        try {
            const absolute = new URL(requestUrl, window.location.href);
            return absolute.origin === window.location.origin;
        } catch (error) {
            return false;
        }
    };
    window.fetch = async (input, init = {})=>{
        const url = typeof input === "string" ? input : input.url;
        const method = (init.method || "GET").toUpperCase();
        // Preserve non-HTTP calls and data URIs.
        if (typeof url === "string" && (url.startsWith("data:") || url.startsWith("blob:"))) return originalFetch(input, init);
        const requestHeaders = $96e14f2a7c3555e4$var$headersToObject(init.headers);
        const targetUrl = $96e14f2a7c3555e4$var$toAbsoluteBackendUrl(url);
        const requestCredentials = init.credentials || (typeof input === "string" ? undefined : input.credentials);
        const response = await $96e14f2a7c3555e4$var$djangoClient.request({
            url: targetUrl,
            method: method,
            data: init.body,
            headers: requestHeaders,
            withCredentials: resolveWithCredentials(requestCredentials, targetUrl),
            responseType: "arraybuffer",
            validateStatus: ()=>true
        });
        const responseHeaders = new Headers();
        Object.entries(response.headers || {}).forEach(([key, value])=>{
            if (value !== undefined && value !== null) responseHeaders.set(key, String(value));
        });
        return new Response(response.data, {
            status: response.status,
            statusText: response.statusText,
            headers: responseHeaders
        });
    };
}
async function $96e14f2a7c3555e4$export$52e83573e7782585(path, options = {}) {
    const method = (options.method || "GET").toUpperCase();
    const headers = $96e14f2a7c3555e4$var$headersToObject(options.headers);
    const url = `${$96e14f2a7c3555e4$var$API_BASE_URL}${path}`;
    const hasBody = options.body !== undefined && options.body !== null;
    let body = options.body;
    if (hasBody && !(body instanceof FormData) && typeof body === "object") {
        headers["Content-Type"] = headers["Content-Type"] || "application/json";
        body = JSON.stringify(body);
    }
    const response = await $96e14f2a7c3555e4$var$djangoClient.request({
        url: url,
        method: method,
        data: body,
        headers: headers,
        validateStatus: ()=>true
    });
    if (response.status < 200 || response.status >= 300) {
        const payload = response.data || {};
        const message = payload.message || payload.error || "Request failed.";
        const error = new Error(message);
        error.payload = payload;
        error.status = response.status;
        throw error;
    }
    return response.data;
}
async function $96e14f2a7c3555e4$export$bffbe311d3d57b6a() {
    const payload = await $96e14f2a7c3555e4$export$52e83573e7782585("/user-rights/context/");
    return payload.data || {
        teams: [],
        users: [],
        supportedRoles: []
    };
}
async function $96e14f2a7c3555e4$export$ccad2a7dac8e08f9(team, role) {
    const payload = await $96e14f2a7c3555e4$export$52e83573e7782585(`/user-rights/?team=${encodeURIComponent(team)}&role=${encodeURIComponent(role)}`);
    return payload;
}
async function $96e14f2a7c3555e4$export$439490942e4c7c4e({ team: team, role: role, assignments: assignments }) {
    return $96e14f2a7c3555e4$export$52e83573e7782585("/user-rights/", {
        method: "POST",
        body: {
            team: team,
            role: role,
            assignments: assignments
        }
    });
}
async function $96e14f2a7c3555e4$export$49da68078f51bd0(team = "") {
    const query = team ? `?team=${encodeURIComponent(team)}` : "";
    const payload = await $96e14f2a7c3555e4$export$52e83573e7782585(`/user-rights/processor-matrix/${query}`);
    return payload.data || [];
}
async function $96e14f2a7c3555e4$export$ea54bcf9867fe13b(matrix, team = "") {
    return $96e14f2a7c3555e4$export$52e83573e7782585("/user-rights/processor-matrix/save/", {
        method: "POST",
        body: {
            matrix: matrix,
            team: team
        }
    });
}
async function $96e14f2a7c3555e4$export$aab004e0eb724d5b(matrixType) {
    const payload = await $96e14f2a7c3555e4$export$52e83573e7782585(`/invoice-approval-matrix/?matrix_type=${encodeURIComponent(matrixType)}`);
    return payload.data || [];
}
async function $96e14f2a7c3555e4$export$6bc70d616f171655(row) {
    return $96e14f2a7c3555e4$export$52e83573e7782585("/invoice-approval-matrix/save/", {
        method: "POST",
        body: row
    });
}
async function $96e14f2a7c3555e4$export$247ba625cb591878(matrixType, file) {
    const formData = new FormData();
    formData.append("matrix_type", matrixType);
    formData.append("file", file);
    return $96e14f2a7c3555e4$export$52e83573e7782585("/invoice-approval-matrix/import/", {
        method: "POST",
        body: formData
    });
}
async function $96e14f2a7c3555e4$export$728c5e6f0290f179(rowId) {
    return $96e14f2a7c3555e4$export$52e83573e7782585(`/invoice-approval-matrix/${rowId}/delete/`, {
        method: "POST"
    });
}
async function $96e14f2a7c3555e4$export$eb512712615120e9() {
    const payload = await $96e14f2a7c3555e4$export$52e83573e7782585("/invoice-po-conditions/");
    return payload.data || {
        conditions: [],
        headers: {
            PO: [],
            GRN: []
        },
        budget: false
    };
}
async function $96e14f2a7c3555e4$export$2f4225d126d5377e() {
    const payload = await $96e14f2a7c3555e4$export$52e83573e7782585("/invoice-non-po-conditions/");
    return payload.data || {
        conditions: [],
        headers: {
            "Vendor Master": [],
            "Invoice OCR": []
        }
    };
}
async function $96e14f2a7c3555e4$export$6ae993a427eddd10(condition) {
    return $96e14f2a7c3555e4$export$52e83573e7782585("/invoice-non-po-conditions/save/", {
        method: "POST",
        body: condition
    });
}
async function $96e14f2a7c3555e4$export$211a4b2824e301f(conditionId) {
    return $96e14f2a7c3555e4$export$52e83573e7782585(`/invoice-non-po-conditions/${conditionId}/delete/`, {
        method: "POST"
    });
}
async function $96e14f2a7c3555e4$export$651266238c1d31a6(condition) {
    return $96e14f2a7c3555e4$export$52e83573e7782585("/invoice-po-conditions/save/", {
        method: "POST",
        body: condition
    });
}
async function $96e14f2a7c3555e4$export$3f9a16e716514553(conditionId) {
    return $96e14f2a7c3555e4$export$52e83573e7782585(`/invoice-po-conditions/${conditionId}/delete/`, {
        method: "POST"
    });
}
async function $96e14f2a7c3555e4$export$8fd59c52d687a33b(mapping) {
    return $96e14f2a7c3555e4$export$52e83573e7782585("/invoice-po-custom-mappings/save/", {
        method: "POST",
        body: mapping
    });
}
async function $96e14f2a7c3555e4$export$855fb363082ea033(mappingId) {
    return $96e14f2a7c3555e4$export$52e83573e7782585(`/invoice-po-custom-mappings/${mappingId}/delete/`, {
        method: "POST"
    });
}
async function $96e14f2a7c3555e4$export$8ddce44871d78da0(filters = {}) {
    const params = new URLSearchParams();
    if (filters.queueType) params.set("queue_type", filters.queueType);
    if (filters.status) params.set("status", filters.status);
    const suffix = params.toString() ? `?${params.toString()}` : "";
    const payload = await $96e14f2a7c3555e4$export$52e83573e7782585(`/invoice-initiator-queue/${suffix}`);
    return payload.data || [];
}
async function $96e14f2a7c3555e4$export$db2f16277e9476ae(queueId) {
    const payload = await $96e14f2a7c3555e4$export$52e83573e7782585(`/invoice-initiator-queue/${queueId}/`);
    return payload.data || null;
}
async function $96e14f2a7c3555e4$export$971ecfbcaef84ff(queueId, values) {
    const payload = await $96e14f2a7c3555e4$export$52e83573e7782585(`/invoice-initiator-queue/${queueId}/recalculate/`, {
        method: "POST",
        body: values
    });
    return payload.data || null;
}
async function $96e14f2a7c3555e4$export$5e75df2a611b6790(queueId) {
    return $96e14f2a7c3555e4$export$52e83573e7782585(`/invoice-initiator-queue/${queueId}/submit-workflow/`, {
        method: "POST"
    });
}
async function $96e14f2a7c3555e4$export$d4ba36157df1a074(filters = {}) {
    const params = new URLSearchParams();
    if (filters.status) params.set("status", filters.status);
    const suffix = params.toString() ? `?${params.toString()}` : "";
    const payload = await $96e14f2a7c3555e4$export$52e83573e7782585(`/invoice-approval-workflows/${suffix}`);
    return payload.data || [];
}
function $96e14f2a7c3555e4$var$keycloakRequestError(error, fallbackMessage) {
    const payload = error?.response?.data;
    if (typeof payload === "string" && payload.trim()) return new Error(payload);
    if (payload?.errorMessage) return new Error(payload.errorMessage);
    if (payload?.error) return new Error(payload.error);
    return new Error(fallbackMessage);
}
function $96e14f2a7c3555e4$var$groupAttr(group, key, fallback = "") {
    const attrs = group.attributes || {};
    const value = attrs[key];
    if (Array.isArray(value) && value.length) return String(value[0]);
    if (typeof value === "string") return value;
    return fallback;
}
async function $96e14f2a7c3555e4$export$319baa9921ab97ab() {
    try {
        const response = await $96e14f2a7c3555e4$var$keycloakAdminClient.get("/groups");
        const groups = response.data || [];
        return groups.map((group)=>({
                id: group.id,
                team: group.name,
                team_name: $96e14f2a7c3555e4$var$groupAttr(group, "team_name", group.name || ""),
                department: $96e14f2a7c3555e4$var$groupAttr(group, "department", ""),
                location: $96e14f2a7c3555e4$var$groupAttr(group, "location", ""),
                path: group.path || `/${group.name}`
            }));
    } catch (error) {
        throw $96e14f2a7c3555e4$var$keycloakRequestError(error, "Unable to load teams from Keycloak.");
    }
}
async function $96e14f2a7c3555e4$export$abfa3f70bc35d5f3({ team: team, team_name: team_name = "", department: department = "", location: location = "" }) {
    const name = (team || "").trim();
    if (!name) throw new Error("Team code is required.");
    try {
        await $96e14f2a7c3555e4$var$keycloakAdminClient.post("/groups", {
            name: name,
            attributes: {
                team_name: [
                    team_name.trim() || name
                ],
                department: [
                    department.trim()
                ],
                location: [
                    location.trim()
                ]
            }
        });
    } catch (error) {
        throw $96e14f2a7c3555e4$var$keycloakRequestError(error, "Unable to create team in Keycloak.");
    }
}
async function $96e14f2a7c3555e4$export$918fc4f0bdbe6f55(groupId, { team: team, team_name: team_name = "", department: department = "", location: location = "" }) {
    if (!groupId) throw new Error("Team id is required.");
    const name = (team || "").trim();
    if (!name) throw new Error("Team code is required.");
    try {
        await $96e14f2a7c3555e4$var$keycloakAdminClient.put(`/groups/${groupId}`, {
            id: groupId,
            name: name,
            attributes: {
                team_name: [
                    team_name.trim() || name
                ],
                department: [
                    department.trim()
                ],
                location: [
                    location.trim()
                ]
            }
        });
    } catch (error) {
        throw $96e14f2a7c3555e4$var$keycloakRequestError(error, "Unable to update team in Keycloak.");
    }
}
async function $96e14f2a7c3555e4$export$ed1b28a9913b41c7(groupId) {
    if (!groupId) throw new Error("Team id is required.");
    try {
        await $96e14f2a7c3555e4$var$keycloakAdminClient.delete(`/groups/${groupId}`);
    } catch (error) {
        throw $96e14f2a7c3555e4$var$keycloakRequestError(error, "Unable to delete team from Keycloak.");
    }
}
async function $96e14f2a7c3555e4$var$fetchKeycloakUserRoles(userId) {
    const response = await $96e14f2a7c3555e4$var$keycloakAdminClient.get(`/users/${userId}/role-mappings/realm`);
    return response.data || [];
}
async function $96e14f2a7c3555e4$var$fetchKeycloakUserGroups(userId) {
    const response = await $96e14f2a7c3555e4$var$keycloakAdminClient.get(`/users/${userId}/groups`);
    return response.data || [];
}
async function $96e14f2a7c3555e4$export$a92d70fb86f2009d() {
    try {
        const usersResp = await $96e14f2a7c3555e4$var$keycloakAdminClient.get("/users", {
            params: {
                max: 1000
            }
        });
        const users = usersResp.data || [];
        const enriched = await Promise.all(users.map(async (user)=>{
            const [roles, groups] = await Promise.all([
                $96e14f2a7c3555e4$var$fetchKeycloakUserRoles(user.id),
                $96e14f2a7c3555e4$var$fetchKeycloakUserGroups(user.id)
            ]);
            return {
                id: user.id,
                first_name: user.firstName || "",
                email: user.email || user.username || "",
                role: roles.map((role)=>role.name).filter(Boolean),
                status: user.enabled ? "Active" : "Disabled",
                team: groups.map((group)=>group.name).filter(Boolean)
            };
        }));
        return enriched.filter((user)=>user.email);
    } catch (error) {
        throw $96e14f2a7c3555e4$var$keycloakRequestError(error, "Unable to load users from Keycloak.");
    }
}
async function $96e14f2a7c3555e4$var$fetchRealmRolesMap() {
    const response = await $96e14f2a7c3555e4$var$keycloakAdminClient.get("/roles");
    const roles = response.data || [];
    const map = {};
    roles.forEach((role)=>{
        if (role?.name) map[role.name] = role;
    });
    return map;
}
function $96e14f2a7c3555e4$var$isManagedRealmRole(roleName) {
    if (!roleName) return false;
    if ($96e14f2a7c3555e4$export$44ffa8fec8da147b.includes(roleName)) return true;
    if (roleName.startsWith("default-roles-")) return false;
    const excluded = new Set([
        "offline_access",
        "uma_authorization",
        "default-roles-master"
    ]);
    return !excluded.has(roleName);
}
async function $96e14f2a7c3555e4$export$ac400a78cc175d() {
    try {
        const response = await $96e14f2a7c3555e4$var$keycloakAdminClient.get("/roles");
        const roles = response.data || [];
        return roles.filter((role)=>$96e14f2a7c3555e4$var$isManagedRealmRole(role?.name)).map((role)=>({
                id: role.id || role.name,
                name: role.name || "",
                description: role.description || ""
            })).sort((a, b)=>a.name.localeCompare(b.name));
    } catch (error) {
        throw $96e14f2a7c3555e4$var$keycloakRequestError(error, "Unable to load roles from Keycloak.");
    }
}
async function $96e14f2a7c3555e4$export$c2fbf74054f01dca({ name: name, description: description = "" }) {
    const roleName = (name || "").trim();
    if (!roleName) throw new Error("Role name is required.");
    try {
        await $96e14f2a7c3555e4$var$keycloakAdminClient.post("/roles", {
            name: roleName,
            description: description.trim()
        });
    } catch (error) {
        throw $96e14f2a7c3555e4$var$keycloakRequestError(error, "Unable to create role in Keycloak.");
    }
}
async function $96e14f2a7c3555e4$export$2f4a31a44355118d(name, { description: description = "" }) {
    const roleName = (name || "").trim();
    if (!roleName) throw new Error("Role name is required.");
    try {
        const roleResponse = await $96e14f2a7c3555e4$var$keycloakAdminClient.get(`/roles/${encodeURIComponent(roleName)}`);
        const role = roleResponse.data || {};
        await $96e14f2a7c3555e4$var$keycloakAdminClient.put(`/roles/${encodeURIComponent(roleName)}`, {
            ...role,
            name: roleName,
            description: description.trim()
        });
    } catch (error) {
        throw $96e14f2a7c3555e4$var$keycloakRequestError(error, "Unable to update role in Keycloak.");
    }
}
async function $96e14f2a7c3555e4$export$ca11adff0f3219e(name) {
    const roleName = (name || "").trim();
    if (!roleName) throw new Error("Role name is required.");
    try {
        await $96e14f2a7c3555e4$var$keycloakAdminClient.delete(`/roles/${encodeURIComponent(roleName)}`);
    } catch (error) {
        throw $96e14f2a7c3555e4$var$keycloakRequestError(error, "Unable to delete role from Keycloak.");
    }
}
async function $96e14f2a7c3555e4$var$syncUserRoles(userId, selectedRoleNames) {
    const [currentRoles, roleMap] = await Promise.all([
        $96e14f2a7c3555e4$var$fetchKeycloakUserRoles(userId),
        $96e14f2a7c3555e4$var$fetchRealmRolesMap()
    ]);
    const currentManagedRoles = currentRoles.filter((role)=>$96e14f2a7c3555e4$export$44ffa8fec8da147b.includes(role.name));
    if (currentManagedRoles.length) await $96e14f2a7c3555e4$var$keycloakAdminClient.delete(`/users/${userId}/role-mappings/realm`, {
        data: currentManagedRoles
    });
    const toAdd = selectedRoleNames.map((name)=>roleMap[name]).filter(Boolean);
    if (toAdd.length) await $96e14f2a7c3555e4$var$keycloakAdminClient.post(`/users/${userId}/role-mappings/realm`, toAdd);
}
async function $96e14f2a7c3555e4$var$syncUserGroups(userId, teamNames) {
    const [currentGroups, allGroups] = await Promise.all([
        $96e14f2a7c3555e4$var$fetchKeycloakUserGroups(userId),
        $96e14f2a7c3555e4$export$319baa9921ab97ab()
    ]);
    const groupIdByName = {};
    allGroups.forEach((group)=>{
        if (group.team && group.id) groupIdByName[group.team] = group.id;
    });
    const targetIds = new Set((teamNames || []).map((team)=>groupIdByName[team]).filter(Boolean));
    const currentIds = new Set(currentGroups.map((group)=>group.id).filter(Boolean));
    const toJoin = [
        ...targetIds
    ].filter((id)=>!currentIds.has(id));
    const toLeave = [
        ...currentIds
    ].filter((id)=>!targetIds.has(id));
    await Promise.all([
        ...toJoin.map((groupId)=>$96e14f2a7c3555e4$var$keycloakAdminClient.put(`/users/${userId}/groups/${groupId}`)),
        ...toLeave.map((groupId)=>$96e14f2a7c3555e4$var$keycloakAdminClient.delete(`/users/${userId}/groups/${groupId}`))
    ]);
}
async function $96e14f2a7c3555e4$var$lookupUserByEmail(email) {
    const response = await $96e14f2a7c3555e4$var$keycloakAdminClient.get("/users", {
        params: {
            email: email,
            exact: true
        }
    });
    const users = response.data || [];
    return users[0] || null;
}
async function $96e14f2a7c3555e4$var$setUserPassword(userId, password) {
    await $96e14f2a7c3555e4$var$keycloakAdminClient.put(`/users/${userId}/reset-password`, {
        type: "password",
        value: password,
        temporary: false
    });
}
async function $96e14f2a7c3555e4$export$b528b6c90ea06b91({ id: id = "", name: name, email: email, password: password, role: role, team: team, status: status }) {
    const normalizedEmail = (email || "").trim().toLowerCase();
    const selectedRoles = Array.isArray(role) ? role : [];
    const selectedTeams = Array.isArray(team) ? team : [];
    const enabled = status === "Active";
    if (!name?.trim() || !normalizedEmail || !selectedRoles.length) throw new Error("Name, email and at least one role are required.");
    try {
        let userId = id || "";
        if (!userId) {
            if (!password) throw new Error("Password is required for new user.");
            await $96e14f2a7c3555e4$var$keycloakAdminClient.post("/users", {
                username: normalizedEmail,
                email: normalizedEmail,
                firstName: name.trim(),
                enabled: enabled,
                emailVerified: true,
                credentials: [
                    {
                        type: "password",
                        value: password,
                        temporary: false
                    }
                ]
            });
            const created = await $96e14f2a7c3555e4$var$lookupUserByEmail(normalizedEmail);
            if (!created?.id) throw new Error("User was created but could not be retrieved.");
            userId = created.id;
        } else {
            await $96e14f2a7c3555e4$var$keycloakAdminClient.put(`/users/${userId}`, {
                email: normalizedEmail,
                username: normalizedEmail,
                firstName: name.trim(),
                enabled: enabled
            });
            if (password) await $96e14f2a7c3555e4$var$setUserPassword(userId, password);
        }
        await Promise.all([
            $96e14f2a7c3555e4$var$syncUserRoles(userId, selectedRoles),
            $96e14f2a7c3555e4$var$syncUserGroups(userId, selectedTeams)
        ]);
    } catch (error) {
        throw $96e14f2a7c3555e4$var$keycloakRequestError(error, "Unable to save user in Keycloak.");
    }
}
async function $96e14f2a7c3555e4$export$be0a570570b4515e(userId) {
    if (!userId) throw new Error("User id is required.");
    try {
        await $96e14f2a7c3555e4$var$keycloakAdminClient.delete(`/users/${userId}`);
    } catch (error) {
        throw $96e14f2a7c3555e4$var$keycloakRequestError(error, "Unable to delete user from Keycloak.");
    }
}
async function $96e14f2a7c3555e4$export$f1c7cb4900148296() {
    try {
        await $96e14f2a7c3555e4$var$keycloakAdminClient.get("/users", {
            params: {
                max: 1
            }
        });
        return {
            ok: true,
            code: "ok",
            message: ""
        };
    } catch (error) {
        const status = error?.response?.status;
        if (status === 401 || status === 403) return {
            ok: false,
            code: "permission",
            message: "Missing Keycloak admin permission. Assign required realm-management roles to this user."
        };
        if (error?.code === "ERR_NETWORK" || !error?.response) return {
            ok: false,
            code: "cors",
            message: "Unable to reach Keycloak Admin API from browser. Check Keycloak admin endpoint CORS/network access for this origin."
        };
        return {
            ok: false,
            code: "unknown",
            message: "Unable to access Keycloak Admin API."
        };
    }
}




var $acw62 = parcelRequire("acw62");

var $99dc7a165646c27f$exports = {};
/*!
* sweetalert2 v11.26.25
* Released under the MIT License.
*/ (function(global, factory) {
    $99dc7a165646c27f$exports = factory();
})($99dc7a165646c27f$exports, function() {
    'use strict';
    function _assertClassBrand(e, t, n) {
        if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
        throw new TypeError("Private element is not present on this object");
    }
    function _checkPrivateRedeclaration(e, t) {
        if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
    function _classPrivateFieldGet2(s, a) {
        return s.get(_assertClassBrand(s, a));
    }
    function _classPrivateFieldInitSpec(e, t, a) {
        _checkPrivateRedeclaration(e, t), t.set(e, a);
    }
    function _classPrivateFieldSet2(s, a, r) {
        return s.set(_assertClassBrand(s, a), r), r;
    }
    const RESTORE_FOCUS_TIMEOUT = 100;
    /** @type {GlobalState} */ const globalState = {};
    const focusPreviousActiveElement = ()=>{
        if (globalState.previousActiveElement instanceof HTMLElement) {
            globalState.previousActiveElement.focus();
            globalState.previousActiveElement = null;
        } else if (document.body) document.body.focus();
    };
    /**
   * Restore previous active (focused) element
   *
   * @param {boolean} returnFocus
   * @returns {Promise<void>}
   */ const restoreActiveElement = (returnFocus)=>{
        return new Promise((resolve)=>{
            if (!returnFocus) return resolve();
            const x = window.scrollX;
            const y = window.scrollY;
            globalState.restoreFocusTimeout = setTimeout(()=>{
                focusPreviousActiveElement();
                resolve();
            }, RESTORE_FOCUS_TIMEOUT); // issues/900
            window.scrollTo(x, y);
        });
    };
    const swalPrefix = 'swal2-';
    /**
   * @typedef {Record<SwalClass, string>} SwalClasses
   */ /**
   * @typedef {'success' | 'warning' | 'info' | 'question' | 'error'} SwalIcon
   * @typedef {Record<SwalIcon, string>} SwalIcons
   */ /** @type {SwalClass[]} */ const classNames = [
        'container',
        'shown',
        'height-auto',
        'iosfix',
        'popup',
        'modal',
        'no-backdrop',
        'no-transition',
        'toast',
        'toast-shown',
        'show',
        'hide',
        'close',
        'title',
        'html-container',
        'actions',
        'confirm',
        'deny',
        'cancel',
        'footer',
        'icon',
        'icon-content',
        'image',
        'input',
        'file',
        'range',
        'select',
        'radio',
        'checkbox',
        'label',
        'textarea',
        'inputerror',
        'input-label',
        'validation-message',
        'progress-steps',
        'active-progress-step',
        'progress-step',
        'progress-step-line',
        'loader',
        'loading',
        'styled',
        'top',
        'top-start',
        'top-end',
        'top-left',
        'top-right',
        'center',
        'center-start',
        'center-end',
        'center-left',
        'center-right',
        'bottom',
        'bottom-start',
        'bottom-end',
        'bottom-left',
        'bottom-right',
        'grow-row',
        'grow-column',
        'grow-fullscreen',
        'rtl',
        'timer-progress-bar',
        'timer-progress-bar-container',
        'scrollbar-measure',
        'icon-success',
        'icon-warning',
        'icon-info',
        'icon-question',
        'icon-error',
        'draggable',
        'dragging'
    ];
    const swalClasses = classNames.reduce((acc, className)=>{
        acc[className] = swalPrefix + className;
        return acc;
    }, /** @type {SwalClasses} */ {});
    /** @type {SwalIcon[]} */ const icons = [
        'success',
        'warning',
        'info',
        'question',
        'error'
    ];
    const iconTypes = icons.reduce((acc, icon)=>{
        acc[icon] = swalPrefix + icon;
        return acc;
    }, /** @type {SwalIcons} */ {});
    const consolePrefix = 'SweetAlert2:';
    /**
   * Capitalize the first letter of a string
   *
   * @param {string} str
   * @returns {string}
   */ const capitalizeFirstLetter = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
    /**
   * Standardize console warnings
   *
   * @param {string | string[]} message
   */ const warn = (message)=>{
        console.warn(`${consolePrefix} ${typeof message === 'object' ? message.join(' ') : message}`);
    };
    /**
   * Standardize console errors
   *
   * @param {string} message
   */ const error = (message)=>{
        console.error(`${consolePrefix} ${message}`);
    };
    /**
   * Private global state for `warnOnce`
   *
   * @type {string[]}
   * @private
   */ const previousWarnOnceMessages = [];
    /**
   * Show a console warning, but only if it hasn't already been shown
   *
   * @param {string} message
   */ const warnOnce = (message)=>{
        if (!previousWarnOnceMessages.includes(message)) {
            previousWarnOnceMessages.push(message);
            warn(message);
        }
    };
    /**
   * Show a one-time console warning about deprecated params/methods
   *
   * @param {string} deprecatedParam
   * @param {string?} useInstead
   */ const warnAboutDeprecation = (deprecatedParam, useInstead = null)=>{
        warnOnce(`"${deprecatedParam}" is deprecated and will be removed in the next major release.${useInstead ? ` Use "${useInstead}" instead.` : ''}`);
    };
    /**
   * If `arg` is a function, call it (with no arguments or context) and return the result.
   * Otherwise, just pass the value through
   *
   * @param {(() => *) | *} arg
   * @returns {*}
   */ const callIfFunction = (arg)=>typeof arg === 'function' ? arg() : arg;
    /**
   * @param {*} arg
   * @returns {boolean}
   */ const hasToPromiseFn = (arg)=>arg && typeof arg.toPromise === 'function';
    /**
   * @param {*} arg
   * @returns {Promise<*>}
   */ const asPromise = (arg)=>hasToPromiseFn(arg) ? arg.toPromise() : Promise.resolve(arg);
    /**
   * @param {*} arg
   * @returns {boolean}
   */ const isPromise = (arg)=>arg && Promise.resolve(arg) === arg;
    /**
   * @returns {boolean}
   */ const isFirefox = ()=>navigator.userAgent.includes('Firefox');
    /**
   * Gets the popup container which contains the backdrop and the popup itself.
   *
   * @returns {HTMLElement | null}
   */ const getContainer = ()=>document.body.querySelector(`.${swalClasses.container}`);
    /**
   * @param {string} selectorString
   * @returns {HTMLElement | null}
   */ const elementBySelector = (selectorString)=>{
        const container = getContainer();
        return container ? container.querySelector(selectorString) : null;
    };
    /**
   * @param {string} className
   * @returns {HTMLElement | null}
   */ const elementByClass = (className)=>{
        return elementBySelector(`.${className}`);
    };
    /**
   * @returns {HTMLElement | null}
   */ const getPopup = ()=>elementByClass(swalClasses.popup);
    /**
   * @returns {HTMLElement | null}
   */ const getIcon = ()=>elementByClass(swalClasses.icon);
    /**
   * @returns {HTMLElement | null}
   */ const getIconContent = ()=>elementByClass(swalClasses['icon-content']);
    /**
   * @returns {HTMLElement | null}
   */ const getTitle = ()=>elementByClass(swalClasses.title);
    /**
   * @returns {HTMLElement | null}
   */ const getHtmlContainer = ()=>elementByClass(swalClasses['html-container']);
    /**
   * @returns {HTMLElement | null}
   */ const getImage = ()=>elementByClass(swalClasses.image);
    /**
   * @returns {HTMLElement | null}
   */ const getProgressSteps = ()=>elementByClass(swalClasses['progress-steps']);
    /**
   * @returns {HTMLElement | null}
   */ const getValidationMessage = ()=>elementByClass(swalClasses['validation-message']);
    /**
   * @returns {HTMLButtonElement | null}
   */ const getConfirmButton = ()=>/** @type {HTMLButtonElement} */ elementBySelector(`.${swalClasses.actions} .${swalClasses.confirm}`);
    /**
   * @returns {HTMLButtonElement | null}
   */ const getCancelButton = ()=>/** @type {HTMLButtonElement} */ elementBySelector(`.${swalClasses.actions} .${swalClasses.cancel}`);
    /**
   * @returns {HTMLButtonElement | null}
   */ const getDenyButton = ()=>/** @type {HTMLButtonElement} */ elementBySelector(`.${swalClasses.actions} .${swalClasses.deny}`);
    /**
   * @returns {HTMLElement | null}
   */ const getInputLabel = ()=>elementByClass(swalClasses['input-label']);
    /**
   * @returns {HTMLElement | null}
   */ const getLoader = ()=>elementBySelector(`.${swalClasses.loader}`);
    /**
   * @returns {HTMLElement | null}
   */ const getActions = ()=>elementByClass(swalClasses.actions);
    /**
   * @returns {HTMLElement | null}
   */ const getFooter = ()=>elementByClass(swalClasses.footer);
    /**
   * @returns {HTMLElement | null}
   */ const getTimerProgressBar = ()=>elementByClass(swalClasses['timer-progress-bar']);
    /**
   * @returns {HTMLElement | null}
   */ const getCloseButton = ()=>elementByClass(swalClasses.close);
    // https://github.com/jkup/focusable/blob/master/index.js
    const focusable = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`;
    /**
   * @returns {HTMLElement[]}
   */ const getFocusableElements = ()=>{
        const popup = getPopup();
        if (!popup) return [];
        /** @type {NodeListOf<HTMLElement>} */ const focusableElementsWithTabindex = popup.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])');
        const focusableElementsWithTabindexSorted = Array.from(focusableElementsWithTabindex)// sort according to tabindex
        .sort((a, b)=>{
            const tabindexA = parseInt(a.getAttribute('tabindex') || '0');
            const tabindexB = parseInt(b.getAttribute('tabindex') || '0');
            if (tabindexA > tabindexB) return 1;
            else if (tabindexA < tabindexB) return -1;
            return 0;
        });
        /** @type {NodeListOf<HTMLElement>} */ const otherFocusableElements = popup.querySelectorAll(focusable);
        const otherFocusableElementsFiltered = Array.from(otherFocusableElements).filter((el)=>el.getAttribute('tabindex') !== '-1');
        return [
            ...new Set(focusableElementsWithTabindexSorted.concat(otherFocusableElementsFiltered))
        ].filter((el)=>isVisible$1(el));
    };
    /**
   * @returns {boolean}
   */ const isModal = ()=>{
        return hasClass(document.body, swalClasses.shown) && !hasClass(document.body, swalClasses['toast-shown']) && !hasClass(document.body, swalClasses['no-backdrop']);
    };
    /**
   * @returns {boolean}
   */ const isToast = ()=>{
        const popup = getPopup();
        if (!popup) return false;
        return hasClass(popup, swalClasses.toast);
    };
    /**
   * @returns {boolean}
   */ const isLoading = ()=>{
        const popup = getPopup();
        if (!popup) return false;
        return popup.hasAttribute('data-loading');
    };
    /**
   * Securely set innerHTML of an element
   * https://github.com/sweetalert2/sweetalert2/issues/1926
   *
   * @param {HTMLElement} elem
   * @param {string} html
   */ const setInnerHtml = (elem, html)=>{
        elem.textContent = '';
        if (html) {
            const parser = new DOMParser();
            const parsed = parser.parseFromString(html, `text/html`);
            const head = parsed.querySelector('head');
            if (head) Array.from(head.childNodes).forEach((child)=>{
                elem.appendChild(child);
            });
            const body = parsed.querySelector('body');
            if (body) Array.from(body.childNodes).forEach((child)=>{
                if (child instanceof HTMLVideoElement || child instanceof HTMLAudioElement) elem.appendChild(child.cloneNode(true)); // https://github.com/sweetalert2/sweetalert2/issues/2507
                else elem.appendChild(child);
            });
        }
    };
    /**
   * @param {HTMLElement} elem
   * @param {string} className
   * @returns {boolean}
   */ const hasClass = (elem, className)=>{
        if (!className) return false;
        return className.split(/\s+/).every((cls)=>elem.classList.contains(cls));
    };
    /**
   * @param {HTMLElement} elem
   * @param {SweetAlertOptions} params
   */ const removeCustomClasses = (elem, params)=>{
        Array.from(elem.classList).forEach((className)=>{
            if (!Object.values(swalClasses).includes(className) && !Object.values(iconTypes).includes(className) && !Object.values(params.showClass || {}).includes(className)) elem.classList.remove(className);
        });
    };
    /**
   * @param {HTMLElement} elem
   * @param {SweetAlertOptions} params
   * @param {string} className
   */ const applyCustomClass = (elem, params, className)=>{
        removeCustomClasses(elem, params);
        if (!params.customClass) return;
        const customClass = params.customClass[/** @type {keyof SweetAlertCustomClass} */ className];
        if (!customClass) return;
        if (typeof customClass !== 'string' && !customClass.forEach) {
            warn(`Invalid type of customClass.${className}! Expected string or iterable object, got "${typeof customClass}"`);
            return;
        }
        addClass(elem, customClass);
    };
    /**
   * @param {HTMLElement} popup
   * @param {import('./renderers/renderInput').InputClass | SweetAlertInput} inputClass
   * @returns {HTMLInputElement | null}
   */ const getInput$1 = (popup, inputClass)=>{
        if (!inputClass) return null;
        switch(inputClass){
            case 'select':
            case 'textarea':
            case 'file':
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses[inputClass]}`);
            case 'checkbox':
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.checkbox} input`);
            case 'radio':
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.radio} input:checked`) || popup.querySelector(`.${swalClasses.popup} > .${swalClasses.radio} input:first-child`);
            case 'range':
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.range} input`);
            default:
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.input}`);
        }
    };
    /**
   * @param {HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement} input
   */ const focusInput = (input)=>{
        input.focus();
        // place cursor at end of text in text input
        if (input.type !== 'file') {
            // http://stackoverflow.com/a/2345915
            const val = input.value;
            input.value = '';
            input.value = val;
        }
    };
    /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[] | undefined} classList
   * @param {boolean} condition
   */ const toggleClass = (target, classList, condition)=>{
        if (!target || !classList) return;
        const classes = typeof classList === 'string' ? classList.split(/\s+/).filter(Boolean) : classList;
        const targets = Array.isArray(target) ? target : [
            target
        ];
        targets.forEach((elem)=>{
            classes.forEach((className)=>{
                if (condition) elem.classList.add(className);
                else elem.classList.remove(className);
            });
        });
    };
    /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[] | undefined} classList
   */ const addClass = (target, classList)=>{
        toggleClass(target, classList, true);
    };
    /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[] | undefined} classList
   */ const removeClass = (target, classList)=>{
        toggleClass(target, classList, false);
    };
    /**
   * Get direct child of an element by class name
   *
   * @param {HTMLElement} elem
   * @param {string} className
   * @returns {HTMLElement | undefined}
   */ const getDirectChildByClass = (elem, className)=>/** @type {HTMLElement | undefined} */ Array.from(elem.children).find((child)=>child instanceof HTMLElement && hasClass(child, className));
    /**
   * @param {HTMLElement} elem
   * @param {string} property
   * @param {string | number | null | undefined} value
   */ const applyNumericalStyle = (elem, property, value)=>{
        if (value === `${parseInt(`${value}`)}`) value = parseInt(value);
        if (value || value === 0) elem.style.setProperty(property, typeof value === 'number' ? `${value}px` : /** @type {string} */ value);
        else elem.style.removeProperty(property);
    };
    /**
   * @param {HTMLElement | null} elem
   * @param {string} display
   */ const show = (elem, display = 'flex')=>{
        if (!elem) return;
        elem.style.display = display;
    };
    /**
   * @param {HTMLElement | null} elem
   */ const hide = (elem)=>{
        if (!elem) return;
        elem.style.display = 'none';
    };
    /**
   * @param {HTMLElement | null} elem
   * @param {string} display
   */ const showWhenInnerHtmlPresent = (elem, display = 'block')=>{
        if (!elem) return;
        new MutationObserver(()=>{
            toggle(elem, elem.innerHTML, display);
        }).observe(elem, {
            childList: true,
            subtree: true
        });
    };
    /**
   * @param {HTMLElement} parent
   * @param {string} selector
   * @param {string} property
   * @param {string} value
   */ const setStyle = (parent, selector, property, value)=>{
        /** @type {HTMLElement | null} */ const el = parent.querySelector(selector);
        if (el) el.style.setProperty(property, value);
    };
    /**
   * @param {HTMLElement} elem
   * @param {boolean | string | null | undefined} condition
   * @param {string} display
   */ const toggle = (elem, condition, display = 'flex')=>{
        if (condition) show(elem, display);
        else hide(elem);
    };
    /**
   * borrowed from jquery $(elem).is(':visible') implementation
   *
   * @param {HTMLElement | null} elem
   * @returns {boolean}
   */ const isVisible$1 = (elem)=>Boolean(elem && (elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length));
    /**
   * @returns {boolean}
   */ const allButtonsAreHidden = ()=>!isVisible$1(getConfirmButton()) && !isVisible$1(getDenyButton()) && !isVisible$1(getCancelButton());
    /**
   * @param {HTMLElement} elem
   * @returns {boolean}
   */ const isScrollable = (elem)=>Boolean(elem.scrollHeight > elem.clientHeight);
    /**
   * @param {HTMLElement} element
   * @param {HTMLElement} stopElement
   * @returns {boolean}
   */ const selfOrParentIsScrollable = (element, stopElement)=>{
        let parent = /** @type {HTMLElement | null} */ element;
        while(parent && parent !== stopElement){
            if (isScrollable(parent)) return true;
            parent = parent.parentElement;
        }
        return false;
    };
    /**
   * borrowed from https://stackoverflow.com/a/46352119
   *
   * @param {HTMLElement} elem
   * @returns {boolean}
   */ const hasCssAnimation = (elem)=>{
        const style = window.getComputedStyle(elem);
        const animDuration = parseFloat(style.getPropertyValue('animation-duration') || '0');
        const transDuration = parseFloat(style.getPropertyValue('transition-duration') || '0');
        return animDuration > 0 || transDuration > 0;
    };
    /**
   * @param {number} timer
   * @param {boolean} reset
   */ const animateTimerProgressBar = (timer, reset = false)=>{
        const timerProgressBar = getTimerProgressBar();
        if (!timerProgressBar) return;
        if (isVisible$1(timerProgressBar)) {
            if (reset) {
                timerProgressBar.style.transition = 'none';
                timerProgressBar.style.width = '100%';
            }
            setTimeout(()=>{
                timerProgressBar.style.transition = `width ${timer / 1000}s linear`;
                timerProgressBar.style.width = '0%';
            }, 10);
        }
    };
    const stopTimerProgressBar = ()=>{
        const timerProgressBar = getTimerProgressBar();
        if (!timerProgressBar) return;
        const timerProgressBarWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
        timerProgressBar.style.removeProperty('transition');
        timerProgressBar.style.width = '100%';
        const timerProgressBarFullWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
        const timerProgressBarPercent = timerProgressBarWidth / timerProgressBarFullWidth * 100;
        timerProgressBar.style.width = `${timerProgressBarPercent}%`;
    };
    /**
   * Detect Node env
   *
   * @returns {boolean}
   */ const isNodeEnv = ()=>typeof window === 'undefined' || typeof document === 'undefined';
    const sweetHTML = `
 <div aria-labelledby="${swalClasses.title}" aria-describedby="${swalClasses['html-container']}" class="${swalClasses.popup}" tabindex="-1">
   <button type="button" class="${swalClasses.close}"></button>
   <ul class="${swalClasses['progress-steps']}"></ul>
   <div class="${swalClasses.icon}"></div>
   <img class="${swalClasses.image}" />
   <h2 class="${swalClasses.title}" id="${swalClasses.title}"></h2>
   <div class="${swalClasses['html-container']}" id="${swalClasses['html-container']}"></div>
   <input class="${swalClasses.input}" id="${swalClasses.input}" />
   <input type="file" class="${swalClasses.file}" />
   <div class="${swalClasses.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${swalClasses.select}" id="${swalClasses.select}"></select>
   <div class="${swalClasses.radio}"></div>
   <label class="${swalClasses.checkbox}">
     <input type="checkbox" id="${swalClasses.checkbox}" />
     <span class="${swalClasses.label}"></span>
   </label>
   <textarea class="${swalClasses.textarea}" id="${swalClasses.textarea}"></textarea>
   <div class="${swalClasses['validation-message']}" id="${swalClasses['validation-message']}"></div>
   <div class="${swalClasses.actions}">
     <div class="${swalClasses.loader}"></div>
     <button type="button" class="${swalClasses.confirm}"></button>
     <button type="button" class="${swalClasses.deny}"></button>
     <button type="button" class="${swalClasses.cancel}"></button>
   </div>
   <div class="${swalClasses.footer}"></div>
   <div class="${swalClasses['timer-progress-bar-container']}">
     <div class="${swalClasses['timer-progress-bar']}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, '');
    /**
   * @returns {boolean}
   */ const resetOldContainer = ()=>{
        const oldContainer = getContainer();
        if (!oldContainer) return false;
        oldContainer.remove();
        removeClass([
            document.documentElement,
            document.body
        ], [
            swalClasses['no-backdrop'],
            swalClasses['toast-shown'],
            // @ts-ignore: 'has-column' is not defined in swalClasses but may be set dynamically
            swalClasses['has-column']
        ]);
        return true;
    };
    const resetValidationMessage$1 = ()=>{
        if (globalState.currentInstance) globalState.currentInstance.resetValidationMessage();
    };
    const addInputChangeListeners = ()=>{
        const popup = getPopup();
        if (!popup) return;
        const input = getDirectChildByClass(popup, swalClasses.input);
        const file = getDirectChildByClass(popup, swalClasses.file);
        /** @type {HTMLInputElement | null} */ const range = popup.querySelector(`.${swalClasses.range} input`);
        /** @type {HTMLOutputElement | null} */ const rangeOutput = popup.querySelector(`.${swalClasses.range} output`);
        const select = getDirectChildByClass(popup, swalClasses.select);
        /** @type {HTMLInputElement | null} */ const checkbox = popup.querySelector(`.${swalClasses.checkbox} input`);
        const textarea = getDirectChildByClass(popup, swalClasses.textarea);
        if (input) input.oninput = resetValidationMessage$1;
        if (file) file.onchange = resetValidationMessage$1;
        if (select) select.onchange = resetValidationMessage$1;
        if (checkbox) checkbox.onchange = resetValidationMessage$1;
        if (textarea) textarea.oninput = resetValidationMessage$1;
        if (range && rangeOutput) {
            range.oninput = ()=>{
                resetValidationMessage$1();
                rangeOutput.value = range.value;
            };
            range.onchange = ()=>{
                resetValidationMessage$1();
                rangeOutput.value = range.value;
            };
        }
    };
    /**
   * @param {string | HTMLElement} target
   * @returns {HTMLElement}
   */ const getTarget = (target)=>{
        if (typeof target === 'string') {
            const element = document.querySelector(target);
            if (!element) throw new Error(`Target element "${target}" not found`);
            return /** @type {HTMLElement} */ element;
        }
        return target;
    };
    /**
   * @param {SweetAlertOptions} params
   */ const setupAccessibility = (params)=>{
        const popup = getPopup();
        if (!popup) return;
        popup.setAttribute('role', params.toast ? 'alert' : 'dialog');
        popup.setAttribute('aria-live', params.toast ? 'polite' : 'assertive');
        if (!params.toast) popup.setAttribute('aria-modal', 'true');
    };
    /**
   * @param {HTMLElement} targetElement
   */ const setupRTL = (targetElement)=>{
        if (window.getComputedStyle(targetElement).direction === 'rtl') {
            addClass(getContainer(), swalClasses.rtl);
            globalState.isRTL = true;
        }
    };
    /**
   * Add modal + backdrop to DOM
   *
   * @param {SweetAlertOptions} params
   */ const init = (params)=>{
        // Clean up the old popup container if it exists
        const oldContainerExisted = resetOldContainer();
        if (isNodeEnv()) {
            error('SweetAlert2 requires document to initialize');
            return;
        }
        const container = document.createElement('div');
        container.className = swalClasses.container;
        if (oldContainerExisted) addClass(container, swalClasses['no-transition']);
        setInnerHtml(container, sweetHTML);
        container.dataset['swal2Theme'] = params.theme;
        const targetElement = getTarget(params.target || 'body');
        targetElement.appendChild(container);
        if (params.topLayer) {
            container.setAttribute('popover', '');
            container.showPopover();
        }
        setupAccessibility(params);
        setupRTL(targetElement);
        addInputChangeListeners();
    };
    /**
   * @param {HTMLElement | object | string} param
   * @param {HTMLElement} target
   */ const parseHtmlToContainer = (param, target)=>{
        // DOM element
        if (param instanceof HTMLElement) target.appendChild(param);
        else if (typeof param === 'object') handleObject(param, target);
        else if (param) setInnerHtml(target, param);
    };
    /**
   * @param {object} param
   * @param {HTMLElement} target
   */ const handleObject = (param, target)=>{
        // JQuery element(s)
        if ('jquery' in param) handleJqueryElem(target, param);
        else setInnerHtml(target, param.toString());
    };
    /**
   * @param {HTMLElement} target
   * @param {any} elem
   */ const handleJqueryElem = (target, elem)=>{
        target.textContent = '';
        if (0 in elem) for(let i = 0; i in elem; i++)target.appendChild(elem[i].cloneNode(true));
        else target.appendChild(elem.cloneNode(true));
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderActions = (instance, params)=>{
        const actions = getActions();
        const loader = getLoader();
        if (!actions || !loader) return;
        // Actions (buttons) wrapper
        if (!params.showConfirmButton && !params.showDenyButton && !params.showCancelButton) hide(actions);
        else show(actions);
        // Custom class
        applyCustomClass(actions, params, 'actions');
        // Render all the buttons
        renderButtons(actions, loader, params);
        // Loader
        setInnerHtml(loader, params.loaderHtml || '');
        applyCustomClass(loader, params, 'loader');
    };
    /**
   * @param {HTMLElement} actions
   * @param {HTMLElement} loader
   * @param {SweetAlertOptions} params
   */ function renderButtons(actions, loader, params) {
        const confirmButton = getConfirmButton();
        const denyButton = getDenyButton();
        const cancelButton = getCancelButton();
        if (!confirmButton || !denyButton || !cancelButton) return;
        // Render buttons
        renderButton(confirmButton, 'confirm', params);
        renderButton(denyButton, 'deny', params);
        renderButton(cancelButton, 'cancel', params);
        handleButtonsStyling(confirmButton, denyButton, cancelButton, params);
        if (params.reverseButtons) {
            if (params.toast) {
                actions.insertBefore(cancelButton, confirmButton);
                actions.insertBefore(denyButton, confirmButton);
            } else {
                actions.insertBefore(cancelButton, loader);
                actions.insertBefore(denyButton, loader);
                actions.insertBefore(confirmButton, loader);
            }
        }
    }
    /**
   * @param {HTMLElement} confirmButton
   * @param {HTMLElement} denyButton
   * @param {HTMLElement} cancelButton
   * @param {SweetAlertOptions} params
   */ function handleButtonsStyling(confirmButton, denyButton, cancelButton, params) {
        if (!params.buttonsStyling) {
            removeClass([
                confirmButton,
                denyButton,
                cancelButton
            ], swalClasses.styled);
            return;
        }
        addClass([
            confirmButton,
            denyButton,
            cancelButton
        ], swalClasses.styled);
        // Apply custom background colors and outline colors to action buttons
        /** @type {[HTMLElement, string, string | undefined][]} */ const buttons = [
            [
                confirmButton,
                'confirm',
                params.confirmButtonColor
            ],
            [
                denyButton,
                'deny',
                params.denyButtonColor
            ],
            [
                cancelButton,
                'cancel',
                params.cancelButtonColor
            ]
        ];
        buttons.forEach(([button, type, color])=>{
            if (color) button.style.setProperty(`--swal2-${type}-button-background-color`, color);
            applyOutlineColor(button);
        });
    }
    /**
   * @param {HTMLElement} button
   */ function applyOutlineColor(button) {
        const buttonStyle = window.getComputedStyle(button);
        if (buttonStyle.getPropertyValue('--swal2-action-button-focus-box-shadow')) // If the button already has a custom outline color, no need to change it
        return;
        const outlineColor = buttonStyle.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, 'rgba($1, $2, $3, 0.5)');
        button.style.setProperty('--swal2-action-button-focus-box-shadow', buttonStyle.getPropertyValue('--swal2-outline').replace(/ rgba\(.*/, ` ${outlineColor}`));
    }
    /**
   * @param {HTMLElement} button
   * @param {'confirm' | 'deny' | 'cancel'} buttonType
   * @param {SweetAlertOptions} params
   */ function renderButton(button, buttonType, params) {
        const buttonName = /** @type {'Confirm' | 'Deny' | 'Cancel'} */ capitalizeFirstLetter(buttonType);
        toggle(button, params[`show${buttonName}Button`], 'inline-block');
        setInnerHtml(button, params[`${buttonType}ButtonText`] || ''); // Set caption text
        button.setAttribute('aria-label', params[`${buttonType}ButtonAriaLabel`] || ''); // ARIA label
        // Add buttons custom classes
        button.className = swalClasses[buttonType];
        applyCustomClass(button, params, `${buttonType}Button`);
    }
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderCloseButton = (instance, params)=>{
        const closeButton = getCloseButton();
        if (!closeButton) return;
        setInnerHtml(closeButton, params.closeButtonHtml || '');
        // Custom class
        applyCustomClass(closeButton, params, 'closeButton');
        toggle(closeButton, params.showCloseButton);
        closeButton.setAttribute('aria-label', params.closeButtonAriaLabel || '');
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderContainer = (instance, params)=>{
        const container = getContainer();
        if (!container) return;
        handleBackdropParam(container, params.backdrop);
        handlePositionParam(container, params.position);
        handleGrowParam(container, params.grow);
        // Custom class
        applyCustomClass(container, params, 'container');
    };
    /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['backdrop']} backdrop
   */ function handleBackdropParam(container, backdrop) {
        if (typeof backdrop === 'string') container.style.background = backdrop;
        else if (!backdrop) addClass([
            document.documentElement,
            document.body
        ], swalClasses['no-backdrop']);
    }
    /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['position']} position
   */ function handlePositionParam(container, position) {
        if (!position) return;
        if (position in swalClasses) addClass(container, swalClasses[position]);
        else {
            warn('The "position" parameter is not valid, defaulting to "center"');
            addClass(container, swalClasses.center);
        }
    }
    /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['grow']} grow
   */ function handleGrowParam(container, grow) {
        if (!grow) return;
        addClass(container, swalClasses[`grow-${grow}`]);
    }
    /**
   * This module contains `WeakMap`s for each effectively-"private  property" that a `Swal` has.
   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
   * This is the approach that Babel will probably take to implement private methods/fields
   *   https://github.com/tc39/proposal-private-methods
   *   https://github.com/babel/babel/pull/7555
   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
   *   then we can use that language feature.
   */ var privateProps = {
        innerParams: new WeakMap(),
        domCache: new WeakMap(),
        focusedElement: new WeakMap()
    };
    /// <reference path="../../../../sweetalert2.d.ts"/>
    /** @type {InputClass[]} */ const inputClasses = [
        'input',
        'file',
        'range',
        'select',
        'radio',
        'checkbox',
        'textarea'
    ];
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderInput = (instance, params)=>{
        const popup = getPopup();
        if (!popup) return;
        const innerParams = privateProps.innerParams.get(instance);
        const rerender = !innerParams || params.input !== innerParams.input;
        inputClasses.forEach((inputClass)=>{
            const inputContainer = getDirectChildByClass(popup, swalClasses[inputClass]);
            if (!inputContainer) return;
            // set attributes
            setAttributes(inputClass, params.inputAttributes);
            // set class
            inputContainer.className = swalClasses[inputClass];
            if (rerender) hide(inputContainer);
        });
        if (params.input) {
            if (rerender) showInput(params);
            // set custom class
            setCustomClass(params);
        }
    };
    /**
   * @param {SweetAlertOptions} params
   */ const showInput = (params)=>{
        if (!params.input) return;
        if (!renderInputType[params.input]) {
            error(`Unexpected type of input! Expected ${Object.keys(renderInputType).join(' | ')}, got "${params.input}"`);
            return;
        }
        const inputContainer = getInputContainer(params.input);
        if (!inputContainer) return;
        const input = renderInputType[params.input](inputContainer, params);
        show(inputContainer);
        // input autofocus
        if (params.inputAutoFocus) setTimeout(()=>{
            focusInput(input);
        });
    };
    /**
   * @param {HTMLInputElement} input
   */ const removeAttributes = (input)=>{
        for (const { name: name } of Array.from(input.attributes))if (![
            'id',
            'type',
            'value',
            'style'
        ].includes(name)) input.removeAttribute(name);
    };
    /**
   * @param {InputClass} inputClass
   * @param {SweetAlertOptions['inputAttributes']} inputAttributes
   */ const setAttributes = (inputClass, inputAttributes)=>{
        const popup = getPopup();
        if (!popup) return;
        const input = getInput$1(popup, inputClass);
        if (!input) return;
        removeAttributes(input);
        for(const attr in inputAttributes)input.setAttribute(attr, inputAttributes[attr]);
    };
    /**
   * @param {SweetAlertOptions} params
   */ const setCustomClass = (params)=>{
        if (!params.input) return;
        const inputContainer = getInputContainer(params.input);
        if (inputContainer) applyCustomClass(inputContainer, params, 'input');
    };
    /**
   * @param {HTMLInputElement | HTMLTextAreaElement} input
   * @param {SweetAlertOptions} params
   */ const setInputPlaceholder = (input, params)=>{
        if (!input.placeholder && params.inputPlaceholder) input.placeholder = params.inputPlaceholder;
    };
    /**
   * @param {Input} input
   * @param {Input} prependTo
   * @param {SweetAlertOptions} params
   */ const setInputLabel = (input, prependTo, params)=>{
        if (params.inputLabel) {
            const label = document.createElement('label');
            const labelClass = swalClasses['input-label'];
            label.setAttribute('for', input.id);
            label.className = labelClass;
            if (typeof params.customClass === 'object') addClass(label, params.customClass.inputLabel);
            label.innerText = params.inputLabel;
            prependTo.insertAdjacentElement('beforebegin', label);
        }
    };
    /**
   * @param {SweetAlertInput} inputType
   * @returns {HTMLElement | undefined}
   */ const getInputContainer = (inputType)=>{
        const popup = getPopup();
        if (!popup) return;
        return getDirectChildByClass(popup, swalClasses[/** @type {SwalClass} */ inputType] || swalClasses.input);
    };
    /**
   * @param {HTMLInputElement | HTMLOutputElement | HTMLTextAreaElement} input
   * @param {SweetAlertOptions['inputValue']} inputValue
   */ const checkAndSetInputValue = (input, inputValue)=>{
        if ([
            'string',
            'number'
        ].includes(typeof inputValue)) input.value = `${inputValue}`;
        else if (!isPromise(inputValue)) warn(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof inputValue}"`);
    };
    /** @type {Record<SweetAlertInput, (input: Input | HTMLElement, params: SweetAlertOptions) => Input>} */ const renderInputType = {};
    /**
   * @param {Input | HTMLElement} input
   * @param {SweetAlertOptions} params
   * @returns {Input}
   */ renderInputType.text = renderInputType.email = renderInputType.password = renderInputType.number = renderInputType.tel = renderInputType.url = renderInputType.search = renderInputType.date = renderInputType['datetime-local'] = renderInputType.time = renderInputType.week = renderInputType.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */ (input, params)=>{
        // oxfmt-ignore
        const inputElement = /** @type {HTMLInputElement} */ input;
        checkAndSetInputValue(inputElement, params.inputValue);
        setInputLabel(inputElement, inputElement, params);
        setInputPlaceholder(inputElement, params);
        // oxfmt-ignore
        inputElement.type = /** @type {string} */ params.input;
        return inputElement;
    };
    /**
   * @param {Input | HTMLElement} input
   * @param {SweetAlertOptions} params
   * @returns {Input}
   */ renderInputType.file = (input, params)=>{
        const inputElement = /** @type {HTMLInputElement} */ input;
        setInputLabel(inputElement, inputElement, params);
        setInputPlaceholder(inputElement, params);
        return inputElement;
    };
    /**
   * @param {Input | HTMLElement} range
   * @param {SweetAlertOptions} params
   * @returns {Input}
   */ renderInputType.range = (range, params)=>{
        const rangeContainer = /** @type {HTMLElement} */ range;
        const rangeInput = rangeContainer.querySelector('input');
        const rangeOutput = rangeContainer.querySelector('output');
        if (rangeInput) {
            checkAndSetInputValue(rangeInput, params.inputValue);
            rangeInput.type = /** @type {string} */ params.input;
            setInputLabel(rangeInput, /** @type {Input} */ range, params);
        }
        if (rangeOutput) checkAndSetInputValue(rangeOutput, params.inputValue);
        return /** @type {Input} */ range;
    };
    /**
   * @param {Input | HTMLElement} select
   * @param {SweetAlertOptions} params
   * @returns {Input}
   */ renderInputType.select = (select, params)=>{
        const selectElement = /** @type {HTMLSelectElement} */ select;
        selectElement.textContent = '';
        if (params.inputPlaceholder) {
            const placeholder = document.createElement('option');
            setInnerHtml(placeholder, params.inputPlaceholder);
            placeholder.value = '';
            placeholder.disabled = true;
            placeholder.selected = true;
            selectElement.appendChild(placeholder);
        }
        setInputLabel(selectElement, selectElement, params);
        return selectElement;
    };
    /**
   * @param {Input | HTMLElement} radio
   * @returns {Input}
   */ renderInputType.radio = (radio)=>{
        const radioElement = /** @type {HTMLElement} */ radio;
        radioElement.textContent = '';
        return /** @type {Input} */ radio;
    };
    /**
   * @param {Input | HTMLElement} checkboxContainer
   * @param {SweetAlertOptions} params
   * @returns {Input}
   */ renderInputType.checkbox = (checkboxContainer, params)=>{
        const popup = getPopup();
        if (!popup) throw new Error('Popup not found');
        const checkbox = getInput$1(popup, 'checkbox');
        if (!checkbox) throw new Error('Checkbox input not found');
        checkbox.value = '1';
        checkbox.checked = Boolean(params.inputValue);
        const containerElement = /** @type {HTMLElement} */ checkboxContainer;
        const label = containerElement.querySelector('span');
        if (label) {
            const placeholderOrLabel = params.inputPlaceholder || params.inputLabel;
            if (placeholderOrLabel) setInnerHtml(label, placeholderOrLabel);
        }
        return checkbox;
    };
    /**
   * @param {Input | HTMLElement} textarea
   * @param {SweetAlertOptions} params
   * @returns {Input}
   */ renderInputType.textarea = (textarea, params)=>{
        const textareaElement = /** @type {HTMLTextAreaElement} */ textarea;
        checkAndSetInputValue(textareaElement, params.inputValue);
        setInputPlaceholder(textareaElement, params);
        setInputLabel(textareaElement, textareaElement, params);
        /**
     * @param {HTMLElement} el
     * @returns {number}
     */ const getMargin = (el)=>parseInt(window.getComputedStyle(el).marginLeft) + parseInt(window.getComputedStyle(el).marginRight);
        // https://github.com/sweetalert2/sweetalert2/issues/2291
        setTimeout(()=>{
            // https://github.com/sweetalert2/sweetalert2/issues/1699
            if ('MutationObserver' in window) {
                const popup = getPopup();
                if (!popup) return;
                const initialPopupWidth = parseInt(window.getComputedStyle(popup).width);
                const textareaResizeHandler = ()=>{
                    // check if texarea is still in document (i.e. popup wasn't closed in the meantime)
                    if (!document.body.contains(textareaElement)) return;
                    const textareaWidth = textareaElement.offsetWidth + getMargin(textareaElement);
                    const popupElement = getPopup();
                    if (popupElement) {
                        if (textareaWidth > initialPopupWidth) popupElement.style.width = `${textareaWidth}px`;
                        else applyNumericalStyle(popupElement, 'width', params.width);
                    }
                };
                new MutationObserver(textareaResizeHandler).observe(textareaElement, {
                    attributes: true,
                    attributeFilter: [
                        'style'
                    ]
                });
            }
        });
        return textareaElement;
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderContent = (instance, params)=>{
        const htmlContainer = getHtmlContainer();
        if (!htmlContainer) return;
        showWhenInnerHtmlPresent(htmlContainer);
        applyCustomClass(htmlContainer, params, 'htmlContainer');
        // Content as HTML
        if (params.html) {
            parseHtmlToContainer(params.html, htmlContainer);
            show(htmlContainer, 'block');
        } else if (params.text) {
            htmlContainer.textContent = params.text;
            show(htmlContainer, 'block');
        } else hide(htmlContainer);
        renderInput(instance, params);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderFooter = (instance, params)=>{
        const footer = getFooter();
        if (!footer) return;
        showWhenInnerHtmlPresent(footer);
        toggle(footer, Boolean(params.footer), 'block');
        if (params.footer) parseHtmlToContainer(params.footer, footer);
        // Custom class
        applyCustomClass(footer, params, 'footer');
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderIcon = (instance, params)=>{
        const innerParams = privateProps.innerParams.get(instance);
        const icon = getIcon();
        if (!icon) return;
        // if the given icon already rendered, apply the styling without re-rendering the icon
        if (innerParams && params.icon === innerParams.icon) {
            // Custom or default content
            setContent(icon, params);
            applyStyles(icon, params);
            return;
        }
        if (!params.icon && !params.iconHtml) {
            hide(icon);
            return;
        }
        if (params.icon && Object.keys(iconTypes).indexOf(params.icon) === -1) {
            error(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${params.icon}"`);
            hide(icon);
            return;
        }
        show(icon);
        // Custom or default content
        setContent(icon, params);
        applyStyles(icon, params);
        // Animate icon
        addClass(icon, params.showClass && params.showClass.icon);
        // Re-adjust the success icon on system theme change
        const colorSchemeQueryList = window.matchMedia('(prefers-color-scheme: dark)');
        colorSchemeQueryList.addEventListener('change', adjustSuccessIconBackgroundColor);
    };
    /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */ const applyStyles = (icon, params)=>{
        for (const [iconType, iconClassName] of Object.entries(iconTypes))if (params.icon !== iconType) removeClass(icon, iconClassName);
        addClass(icon, params.icon && iconTypes[params.icon]);
        // Icon color
        setColor(icon, params);
        // Success icon background color
        adjustSuccessIconBackgroundColor();
        // Custom class
        applyCustomClass(icon, params, 'icon');
    };
    // Adjust success icon background color to match the popup background color
    const adjustSuccessIconBackgroundColor = ()=>{
        const popup = getPopup();
        if (!popup) return;
        const popupBackgroundColor = window.getComputedStyle(popup).getPropertyValue('background-color');
        /** @type {NodeListOf<HTMLElement>} */ const successIconParts = popup.querySelectorAll('[class^=swal2-success-circular-line], .swal2-success-fix');
        successIconParts.forEach((part)=>{
            part.style.backgroundColor = popupBackgroundColor;
        });
    };
    /**
   *
   * @param {SweetAlertOptions} params
   * @returns {string}
   */ const successIconHtml = (params)=>`
  ${params.animation ? '<div class="swal2-success-circular-line-left"></div>' : ''}
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div>
  ${params.animation ? '<div class="swal2-success-fix"></div>' : ''}
  ${params.animation ? '<div class="swal2-success-circular-line-right"></div>' : ''}
`;
    const errorIconHtml = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`;
    /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */ const setContent = (icon, params)=>{
        if (!params.icon && !params.iconHtml) return;
        let oldContent = icon.innerHTML;
        let newContent = '';
        if (params.iconHtml) newContent = iconContent(params.iconHtml);
        else if (params.icon === 'success') {
            newContent = successIconHtml(params);
            oldContent = oldContent.replace(/ style=".*?"/g, ''); // undo adjustSuccessIconBackgroundColor()
        } else if (params.icon === 'error') newContent = errorIconHtml;
        else if (params.icon) {
            const defaultIconHtml = {
                question: '?',
                warning: '!',
                info: 'i'
            };
            newContent = iconContent(defaultIconHtml[params.icon]);
        }
        if (oldContent.trim() !== newContent.trim()) setInnerHtml(icon, newContent);
    };
    /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */ const setColor = (icon, params)=>{
        if (!params.iconColor) return;
        icon.style.color = params.iconColor;
        icon.style.borderColor = params.iconColor;
        for (const sel of [
            '.swal2-success-line-tip',
            '.swal2-success-line-long',
            '.swal2-x-mark-line-left',
            '.swal2-x-mark-line-right'
        ])setStyle(icon, sel, 'background-color', params.iconColor);
        setStyle(icon, '.swal2-success-ring', 'border-color', params.iconColor);
    };
    /**
   * @param {string} content
   * @returns {string}
   */ const iconContent = (content)=>`<div class="${swalClasses['icon-content']}">${content}</div>`;
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderImage = (instance, params)=>{
        const image = getImage();
        if (!image) return;
        if (!params.imageUrl) {
            hide(image);
            return;
        }
        show(image, '');
        // Src, alt
        image.setAttribute('src', params.imageUrl);
        image.setAttribute('alt', params.imageAlt || '');
        // Width, height
        applyNumericalStyle(image, 'width', params.imageWidth);
        applyNumericalStyle(image, 'height', params.imageHeight);
        // Class
        image.className = swalClasses.image;
        applyCustomClass(image, params, 'image');
    };
    let dragging = false;
    let mousedownX = 0;
    let mousedownY = 0;
    let initialX = 0;
    let initialY = 0;
    /**
   * @param {HTMLElement} popup
   */ const addDraggableListeners = (popup)=>{
        popup.addEventListener('mousedown', down);
        document.body.addEventListener('mousemove', move);
        popup.addEventListener('mouseup', up);
        popup.addEventListener('touchstart', down);
        document.body.addEventListener('touchmove', move);
        popup.addEventListener('touchend', up);
    };
    /**
   * @param {HTMLElement} popup
   */ const removeDraggableListeners = (popup)=>{
        popup.removeEventListener('mousedown', down);
        document.body.removeEventListener('mousemove', move);
        popup.removeEventListener('mouseup', up);
        popup.removeEventListener('touchstart', down);
        document.body.removeEventListener('touchmove', move);
        popup.removeEventListener('touchend', up);
    };
    /**
   * @param {MouseEvent | TouchEvent} event
   */ const down = (event)=>{
        const popup = getPopup();
        if (!popup) return;
        const icon = getIcon();
        if (event.target === popup || icon && icon.contains(/** @type {HTMLElement} */ event.target)) {
            dragging = true;
            const clientXY = getClientXY(event);
            mousedownX = clientXY.clientX;
            mousedownY = clientXY.clientY;
            initialX = parseInt(popup.style.insetInlineStart) || 0;
            initialY = parseInt(popup.style.insetBlockStart) || 0;
            addClass(popup, 'swal2-dragging');
        }
    };
    /**
   * @param {MouseEvent | TouchEvent} event
   */ const move = (event)=>{
        const popup = getPopup();
        if (!popup) return;
        if (dragging) {
            let { clientX: clientX, clientY: clientY } = getClientXY(event);
            const deltaX = clientX - mousedownX;
            // In RTL mode, negate the horizontal delta since insetInlineStart refers to the right edge
            popup.style.insetInlineStart = `${initialX + (globalState.isRTL ? -deltaX : deltaX)}px`;
            popup.style.insetBlockStart = `${initialY + (clientY - mousedownY)}px`;
        }
    };
    const up = ()=>{
        const popup = getPopup();
        dragging = false;
        removeClass(popup, 'swal2-dragging');
    };
    /**
   * @param {MouseEvent | TouchEvent} event
   * @returns {{ clientX: number, clientY: number }}
   */ const getClientXY = (event)=>{
        const source = event.type.startsWith('touch') ? /** @type {TouchEvent} */ event.touches[0] : /** @type {MouseEvent} */ event;
        return {
            clientX: source.clientX,
            clientY: source.clientY
        };
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderPopup = (instance, params)=>{
        const container = getContainer();
        const popup = getPopup();
        if (!container || !popup) return;
        // Width
        // https://github.com/sweetalert2/sweetalert2/issues/2170
        if (params.toast) {
            applyNumericalStyle(container, 'width', params.width);
            popup.style.width = '100%';
            const loader = getLoader();
            if (loader) popup.insertBefore(loader, getIcon());
        } else applyNumericalStyle(popup, 'width', params.width);
        // Padding
        applyNumericalStyle(popup, 'padding', params.padding);
        // Color
        if (params.color) popup.style.color = params.color;
        // Background
        if (params.background) popup.style.background = params.background;
        hide(getValidationMessage());
        // Classes
        addClasses$1(popup, params);
        if (params.draggable && !params.toast) {
            addClass(popup, swalClasses.draggable);
            addDraggableListeners(popup);
        } else {
            removeClass(popup, swalClasses.draggable);
            removeDraggableListeners(popup);
        }
    };
    /**
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} params
   */ const addClasses$1 = (popup, params)=>{
        const showClass = params.showClass || {};
        // Default Class + showClass when updating Swal.update({})
        popup.className = `${swalClasses.popup} ${isVisible$1(popup) ? showClass.popup : ''}`;
        if (params.toast) {
            addClass([
                document.documentElement,
                document.body
            ], swalClasses['toast-shown']);
            addClass(popup, swalClasses.toast);
        } else addClass(popup, swalClasses.modal);
        // Custom class
        applyCustomClass(popup, params, 'popup');
        // TODO: remove in the next major
        if (typeof params.customClass === 'string') addClass(popup, params.customClass);
        // Icon class (#1842)
        if (params.icon) addClass(popup, swalClasses[`icon-${params.icon}`]);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderProgressSteps = (instance, params)=>{
        const progressStepsContainer = getProgressSteps();
        if (!progressStepsContainer) return;
        const { progressSteps: progressSteps, currentProgressStep: currentProgressStep } = params;
        if (!progressSteps || progressSteps.length === 0 || currentProgressStep === undefined) {
            hide(progressStepsContainer);
            return;
        }
        show(progressStepsContainer);
        progressStepsContainer.textContent = '';
        if (currentProgressStep >= progressSteps.length) warn("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)");
        progressSteps.forEach((step, index)=>{
            const stepEl = createStepElement(step);
            progressStepsContainer.appendChild(stepEl);
            if (index === currentProgressStep) addClass(stepEl, swalClasses['active-progress-step']);
            if (index !== progressSteps.length - 1) {
                const lineEl = createLineElement(params);
                progressStepsContainer.appendChild(lineEl);
            }
        });
    };
    /**
   * @param {string} step
   * @returns {HTMLLIElement}
   */ const createStepElement = (step)=>{
        const stepEl = document.createElement('li');
        addClass(stepEl, swalClasses['progress-step']);
        setInnerHtml(stepEl, step);
        return stepEl;
    };
    /**
   * @param {SweetAlertOptions} params
   * @returns {HTMLLIElement}
   */ const createLineElement = (params)=>{
        const lineEl = document.createElement('li');
        addClass(lineEl, swalClasses['progress-step-line']);
        if (params.progressStepsDistance) applyNumericalStyle(lineEl, 'width', params.progressStepsDistance);
        return lineEl;
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderTitle = (instance, params)=>{
        const title = getTitle();
        if (!title) return;
        showWhenInnerHtmlPresent(title);
        toggle(title, Boolean(params.title || params.titleText), 'block');
        if (params.title) parseHtmlToContainer(params.title, title);
        if (params.titleText) title.innerText = params.titleText;
        // Custom class
        applyCustomClass(title, params, 'title');
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const render = (instance, params)=>{
        var _globalState$eventEmi;
        renderPopup(instance, params);
        renderContainer(instance, params);
        renderProgressSteps(instance, params);
        renderIcon(instance, params);
        renderImage(instance, params);
        renderTitle(instance, params);
        renderCloseButton(instance, params);
        renderContent(instance, params);
        renderActions(instance, params);
        renderFooter(instance, params);
        const popup = getPopup();
        if (typeof params.didRender === 'function' && popup) params.didRender(popup);
        (_globalState$eventEmi = globalState.eventEmitter) === null || _globalState$eventEmi === void 0 || _globalState$eventEmi.emit('didRender', popup);
    };
    /*
   * Global function to determine if SweetAlert2 popup is shown
   */ const isVisible = ()=>{
        return isVisible$1(getPopup());
    };
    /*
   * Global function to click 'Confirm' button
   */ const clickConfirm = ()=>{
        var _dom$getConfirmButton;
        return (_dom$getConfirmButton = getConfirmButton()) === null || _dom$getConfirmButton === void 0 ? void 0 : _dom$getConfirmButton.click();
    };
    /*
   * Global function to click 'Deny' button
   */ const clickDeny = ()=>{
        var _dom$getDenyButton;
        return (_dom$getDenyButton = getDenyButton()) === null || _dom$getDenyButton === void 0 ? void 0 : _dom$getDenyButton.click();
    };
    /*
   * Global function to click 'Cancel' button
   */ const clickCancel = ()=>{
        var _dom$getCancelButton;
        return (_dom$getCancelButton = getCancelButton()) === null || _dom$getCancelButton === void 0 ? void 0 : _dom$getCancelButton.click();
    };
    /** @type {Record<DismissReason, DismissReason>} */ const DismissReason = Object.freeze({
        cancel: 'cancel',
        backdrop: 'backdrop',
        close: 'close',
        esc: 'esc',
        timer: 'timer'
    });
    /**
   * @param {GlobalState} globalState
   */ const removeKeydownHandler = (globalState)=>{
        if (globalState.keydownTarget && globalState.keydownHandlerAdded && globalState.keydownHandler) {
            const handler = /** @type {EventListenerOrEventListenerObject} */ /** @type {unknown} */ globalState.keydownHandler;
            globalState.keydownTarget.removeEventListener('keydown', handler, {
                capture: globalState.keydownListenerCapture
            });
            globalState.keydownHandlerAdded = false;
        }
    };
    /**
   * @param {GlobalState} globalState
   * @param {SweetAlertOptions} innerParams
   * @param {(dismiss: DismissReason) => void} dismissWith
   */ const addKeydownHandler = (globalState, innerParams, dismissWith)=>{
        removeKeydownHandler(globalState);
        if (!innerParams.toast) {
            /** @type {(this: HTMLElement, event: KeyboardEvent) => void} */ const handler = (e)=>keydownHandler(innerParams, e, dismissWith);
            globalState.keydownHandler = handler;
            const target = innerParams.keydownListenerCapture ? window : getPopup();
            if (target) {
                globalState.keydownTarget = target;
                globalState.keydownListenerCapture = innerParams.keydownListenerCapture;
                const eventHandler = /** @type {EventListenerOrEventListenerObject} */ /** @type {unknown} */ handler;
                globalState.keydownTarget.addEventListener('keydown', eventHandler, {
                    capture: globalState.keydownListenerCapture
                });
                globalState.keydownHandlerAdded = true;
            }
        }
    };
    /**
   * @param {number} index
   * @param {number} increment
   * @returns {boolean} shouldPreventDefault
   */ const setFocus = (index, increment)=>{
        var _dom$getPopup;
        const focusableElements = getFocusableElements();
        // search for visible elements and select the next possible match
        if (focusableElements.length) {
            index = index + increment;
            // shift + tab when .swal2-popup is focused
            if (index === -2) index = focusableElements.length - 1;
            // rollover to first item
            if (index === focusableElements.length) index = 0;
            else if (index === -1) index = focusableElements.length - 1;
            focusableElements[index].focus();
            // don't prevent default for iframes (Firefox fix)
            // https://github.com/sweetalert2/sweetalert2/issues/2931
            if (isFirefox() && focusableElements[index] instanceof HTMLIFrameElement) return false;
            return true;
        }
        // no visible focusable elements, focus the popup
        (_dom$getPopup = getPopup()) === null || _dom$getPopup === void 0 || _dom$getPopup.focus();
        return true;
    };
    const arrowKeysNextButton = [
        'ArrowRight',
        'ArrowDown'
    ];
    const arrowKeysPreviousButton = [
        'ArrowLeft',
        'ArrowUp'
    ];
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {KeyboardEvent} event
   * @param {(dismiss: DismissReason) => void} dismissWith
   */ const keydownHandler = (innerParams, event, dismissWith)=>{
        if (!innerParams) return; // This instance has already been destroyed
        // Ignore keydown during IME composition
        // https://developer.mozilla.org/en-US/docs/Web/API/Document/keydown_event#ignoring_keydown_during_ime_composition
        // https://github.com/sweetalert2/sweetalert2/issues/720
        // https://github.com/sweetalert2/sweetalert2/issues/2406
        if (event.isComposing || event.keyCode === 229) return;
        if (innerParams.stopKeydownPropagation) event.stopPropagation();
        // ENTER
        if (event.key === 'Enter') handleEnter(event, innerParams);
        else if (event.key === 'Tab') handleTab(event);
        else if ([
            ...arrowKeysNextButton,
            ...arrowKeysPreviousButton
        ].includes(event.key)) handleArrows(event.key);
        else if (event.key === 'Escape') handleEsc(event, innerParams, dismissWith);
    };
    /**
   * @param {KeyboardEvent} event
   * @param {SweetAlertOptions} innerParams
   */ const handleEnter = (event, innerParams)=>{
        // https://github.com/sweetalert2/sweetalert2/issues/2386
        if (!callIfFunction(innerParams.allowEnterKey)) return;
        const popup = getPopup();
        if (!popup || !innerParams.input) return;
        const input = getInput$1(popup, innerParams.input);
        if (event.target && input && event.target instanceof HTMLElement && event.target.outerHTML === input.outerHTML) {
            if ([
                'textarea',
                'file'
            ].includes(innerParams.input)) return; // do not submit
            clickConfirm();
            event.preventDefault();
        }
    };
    /**
   * @param {KeyboardEvent} event
   */ const handleTab = (event)=>{
        const targetElement = event.target;
        const focusableElements = getFocusableElements();
        const btnIndex = focusableElements.findIndex((el)=>el === targetElement);
        // don't prevent default for iframes (Firefox fix)
        // https://github.com/sweetalert2/sweetalert2/issues/2931
        let shouldPreventDefault = true;
        // Cycle to the next button
        if (!event.shiftKey) shouldPreventDefault = setFocus(btnIndex, 1);
        else shouldPreventDefault = setFocus(btnIndex, -1);
        event.stopPropagation();
        if (shouldPreventDefault) event.preventDefault();
    };
    /**
   * @param {string} key
   */ const handleArrows = (key)=>{
        const actions = getActions();
        const confirmButton = getConfirmButton();
        const denyButton = getDenyButton();
        const cancelButton = getCancelButton();
        if (!actions || !confirmButton || !denyButton || !cancelButton) return;
        /** @type HTMLElement[] */ const buttons = [
            confirmButton,
            denyButton,
            cancelButton
        ];
        if (document.activeElement instanceof HTMLElement && !buttons.includes(document.activeElement)) return;
        const sibling = arrowKeysNextButton.includes(key) ? 'nextElementSibling' : 'previousElementSibling';
        let buttonToFocus = document.activeElement;
        if (!buttonToFocus) return;
        for(let i = 0; i < actions.children.length; i++){
            buttonToFocus = buttonToFocus[sibling];
            if (!buttonToFocus) return;
            if (buttonToFocus instanceof HTMLButtonElement && isVisible$1(buttonToFocus)) break;
        }
        if (buttonToFocus instanceof HTMLButtonElement) buttonToFocus.focus();
    };
    /**
   * @param {KeyboardEvent} event
   * @param {SweetAlertOptions} innerParams
   * @param {(dismiss: DismissReason) => void} dismissWith
   */ const handleEsc = (event, innerParams, dismissWith)=>{
        event.preventDefault();
        if (callIfFunction(innerParams.allowEscapeKey)) dismissWith(DismissReason.esc);
    };
    /**
   * This module contains `WeakMap`s for each effectively-"private  property" that a `Swal` has.
   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
   * This is the approach that Babel will probably take to implement private methods/fields
   *   https://github.com/tc39/proposal-private-methods
   *   https://github.com/babel/babel/pull/7555
   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
   *   then we can use that language feature.
   */ var privateMethods = {
        swalPromiseResolve: new WeakMap(),
        swalPromiseReject: new WeakMap()
    };
    // From https://developer.paciellogroup.com/blog/2018/06/the-current-state-of-modal-dialog-accessibility/
    // Adding aria-hidden="true" to elements outside of the active modal dialog ensures that
    // elements not within the active modal dialog will not be surfaced if a user opens a screen
    // reader’s list of elements (headings, form controls, landmarks, etc.) in the document.
    const setAriaHidden = ()=>{
        const container = getContainer();
        const bodyChildren = Array.from(document.body.children);
        bodyChildren.forEach((el)=>{
            if (el.contains(container)) return;
            if (el.hasAttribute('aria-hidden')) el.setAttribute('data-previous-aria-hidden', el.getAttribute('aria-hidden') || '');
            el.setAttribute('aria-hidden', 'true');
        });
    };
    const unsetAriaHidden = ()=>{
        const bodyChildren = Array.from(document.body.children);
        bodyChildren.forEach((el)=>{
            if (el.hasAttribute('data-previous-aria-hidden')) {
                el.setAttribute('aria-hidden', el.getAttribute('data-previous-aria-hidden') || '');
                el.removeAttribute('data-previous-aria-hidden');
            } else el.removeAttribute('aria-hidden');
        });
    };
    // @ts-ignore
    const isSafariOrIOS = typeof window !== 'undefined' && Boolean(window.GestureEvent); // true for Safari desktop + all iOS browsers https://stackoverflow.com/a/70585394
    // @ts-ignore
    const isIOS = isSafariOrIOS && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    /**
   * Fix iOS scrolling
   * http://stackoverflow.com/q/39626302
   */ const iOSfix = ()=>{
        if (isSafariOrIOS && !hasClass(document.body, swalClasses.iosfix)) {
            const offset = document.body.scrollTop;
            document.body.style.top = `${offset * -1}px`;
            addClass(document.body, swalClasses.iosfix);
            lockBodyScroll();
        }
    };
    /**
   * https://github.com/sweetalert2/sweetalert2/issues/1246
   */ const lockBodyScroll = ()=>{
        const container = getContainer();
        if (!container) return;
        /** @type {boolean} */ let preventTouchMove;
        /**
     * @param {TouchEvent} event
     */ container.ontouchstart = (event)=>{
            preventTouchMove = shouldPreventTouchMove(event);
        };
        /**
     * @param {TouchEvent} event
     */ container.ontouchmove = (event)=>{
            if (preventTouchMove) {
                event.preventDefault();
                event.stopPropagation();
            }
        };
    };
    /**
   * @param {TouchEvent} event
   * @returns {boolean}
   */ const shouldPreventTouchMove = (event)=>{
        const target = event.target;
        const container = getContainer();
        const htmlContainer = getHtmlContainer();
        if (!container || !htmlContainer) return false;
        if (isStylus(event) || isZoom(event)) return false;
        if (target === container) return true;
        if (!isScrollable(container) && target instanceof HTMLElement && !selfOrParentIsScrollable(target, htmlContainer) && // #2823
        target.tagName !== 'INPUT' && // #1603
        target.tagName !== 'TEXTAREA' && // #2266
        !(isScrollable(htmlContainer) && // #1944
        htmlContainer.contains(target))) return true;
        return false;
    };
    /**
   * https://github.com/sweetalert2/sweetalert2/issues/1786
   *
   * @param {TouchEvent} event
   * @returns {boolean}
   */ const isStylus = (event)=>{
        return Boolean(event.touches && event.touches.length && // @ts-ignore - touchType is not a standard property
        event.touches[0].touchType === 'stylus');
    };
    /**
   * https://github.com/sweetalert2/sweetalert2/issues/1891
   *
   * @param {TouchEvent} event
   * @returns {boolean}
   */ const isZoom = (event)=>{
        return event.touches && event.touches.length > 1;
    };
    const undoIOSfix = ()=>{
        if (hasClass(document.body, swalClasses.iosfix)) {
            const offset = parseInt(document.body.style.top, 10);
            removeClass(document.body, swalClasses.iosfix);
            document.body.style.top = '';
            document.body.scrollTop = offset * -1;
        }
    };
    /**
   * Measure scrollbar width for padding body during modal show/hide
   * https://github.com/twbs/bootstrap/blob/master/js/src/modal.js
   *
   * @returns {number}
   */ const measureScrollbar = ()=>{
        const scrollDiv = document.createElement('div');
        scrollDiv.className = swalClasses['scrollbar-measure'];
        document.body.appendChild(scrollDiv);
        const scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
        return scrollbarWidth;
    };
    /**
   * Remember state in cases where opening and handling a modal will fiddle with it.
   * @type {number | null}
   */ let previousBodyPadding = null;
    /**
   * @param {string} initialBodyOverflow
   */ const replaceScrollbarWithPadding = (initialBodyOverflow)=>{
        // for queues, do not do this more than once
        if (previousBodyPadding !== null) return;
        // if the body has overflow
        if (document.body.scrollHeight > window.innerHeight || initialBodyOverflow === 'scroll' // https://github.com/sweetalert2/sweetalert2/issues/2663
        ) {
            // add padding so the content doesn't shift after removal of scrollbar
            previousBodyPadding = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'));
            document.body.style.paddingRight = `${previousBodyPadding + measureScrollbar()}px`;
        }
    };
    const undoReplaceScrollbarWithPadding = ()=>{
        if (previousBodyPadding !== null) {
            document.body.style.paddingRight = `${previousBodyPadding}px`;
            previousBodyPadding = null;
        }
    };
    /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} container
   * @param {boolean} returnFocus
   * @param {(() => void) | undefined} didClose
   */ function removePopupAndResetState(instance, container, returnFocus, didClose) {
        if (isToast()) triggerDidCloseAndDispose(instance, didClose);
        else {
            restoreActiveElement(returnFocus).then(()=>triggerDidCloseAndDispose(instance, didClose));
            removeKeydownHandler(globalState);
        }
        // workaround for https://github.com/sweetalert2/sweetalert2/issues/2088
        // for some reason removing the container in Safari will scroll the document to bottom
        if (isSafariOrIOS) {
            container.setAttribute('style', 'display:none !important');
            container.removeAttribute('class');
            container.innerHTML = '';
        } else container.remove();
        if (isModal()) {
            undoReplaceScrollbarWithPadding();
            undoIOSfix();
            unsetAriaHidden();
        }
        removeBodyClasses();
    }
    /**
   * Remove SweetAlert2 classes from body
   */ function removeBodyClasses() {
        removeClass([
            document.documentElement,
            document.body
        ], [
            swalClasses.shown,
            swalClasses['height-auto'],
            swalClasses['no-backdrop'],
            swalClasses['toast-shown']
        ]);
    }
    /**
   * Instance method to close sweetAlert
   *
   * @param {SweetAlertResult | undefined} resolveValue
   * @this {SweetAlert}
   */ function close(resolveValue) {
        resolveValue = prepareResolveValue(resolveValue);
        const swalPromiseResolve = privateMethods.swalPromiseResolve.get(this);
        const didClose = triggerClosePopup(this);
        if (this.isAwaitingPromise) // A swal awaiting for a promise (after a click on Confirm or Deny) cannot be dismissed anymore #2335
        {
            if (!resolveValue.isDismissed) {
                handleAwaitingPromise(this);
                swalPromiseResolve(resolveValue);
            }
        } else if (didClose) // Resolve Swal promise
        swalPromiseResolve(resolveValue);
    }
    /**
   * @param {SweetAlert} instance
   * @returns {boolean}
   */ const triggerClosePopup = (instance)=>{
        const popup = getPopup();
        if (!popup) return false;
        const innerParams = privateProps.innerParams.get(instance);
        if (!innerParams || hasClass(popup, innerParams.hideClass.popup)) return false;
        removeClass(popup, innerParams.showClass.popup);
        addClass(popup, innerParams.hideClass.popup);
        const backdrop = getContainer();
        removeClass(backdrop, innerParams.showClass.backdrop);
        addClass(backdrop, innerParams.hideClass.backdrop);
        handlePopupAnimation(instance, popup, innerParams);
        return true;
    };
    /**
   * @param {Error | string} error
   * @this {SweetAlert}
   */ function rejectPromise(error) {
        const rejectPromise = privateMethods.swalPromiseReject.get(this);
        handleAwaitingPromise(this);
        if (rejectPromise) // Reject Swal promise
        rejectPromise(error);
    }
    /**
   * @param {SweetAlert} instance
   */ const handleAwaitingPromise = (instance)=>{
        if (instance.isAwaitingPromise) {
            // @ts-ignore
            delete instance.isAwaitingPromise;
            // The instance might have been previously partly destroyed, we must resume the destroy process in this case #2335
            if (!privateProps.innerParams.get(instance)) instance._destroy();
        }
    };
    /**
   * @param {SweetAlertResult | undefined} resolveValue
   * @returns {SweetAlertResult}
   */ const prepareResolveValue = (resolveValue)=>{
        // When user calls Swal.close()
        if (typeof resolveValue === 'undefined') return {
            isConfirmed: false,
            isDenied: false,
            isDismissed: true
        };
        return Object.assign({
            isConfirmed: false,
            isDenied: false,
            isDismissed: false
        }, resolveValue);
    };
    /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} innerParams
   */ const handlePopupAnimation = (instance, popup, innerParams)=>{
        var _globalState$eventEmi;
        const container = getContainer();
        // If animation is supported, animate
        const animationIsSupported = hasCssAnimation(popup);
        if (typeof innerParams.willClose === 'function') innerParams.willClose(popup);
        (_globalState$eventEmi = globalState.eventEmitter) === null || _globalState$eventEmi === void 0 || _globalState$eventEmi.emit('willClose', popup);
        if (animationIsSupported && container) animatePopup(instance, popup, container, Boolean(innerParams.returnFocus), innerParams.didClose);
        else if (container) // Otherwise, remove immediately
        removePopupAndResetState(instance, container, Boolean(innerParams.returnFocus), innerParams.didClose);
    };
    /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} popup
   * @param {HTMLElement} container
   * @param {boolean} returnFocus
   * @param {(() => void) | undefined} didClose
   */ const animatePopup = (instance, popup, container, returnFocus, didClose)=>{
        globalState.swalCloseEventFinishedCallback = removePopupAndResetState.bind(null, instance, container, returnFocus, didClose);
        /**
     * @param {AnimationEvent | TransitionEvent} e
     */ const swalCloseAnimationFinished = function(e) {
            if (e.target === popup) {
                var _globalState$swalClos;
                (_globalState$swalClos = globalState.swalCloseEventFinishedCallback) === null || _globalState$swalClos === void 0 || _globalState$swalClos.call(globalState);
                delete globalState.swalCloseEventFinishedCallback;
                popup.removeEventListener('animationend', swalCloseAnimationFinished);
                popup.removeEventListener('transitionend', swalCloseAnimationFinished);
            }
        };
        popup.addEventListener('animationend', swalCloseAnimationFinished);
        popup.addEventListener('transitionend', swalCloseAnimationFinished);
    };
    /**
   * @param {SweetAlert} instance
   * @param {(() => void) | undefined} didClose
   */ const triggerDidCloseAndDispose = (instance, didClose)=>{
        setTimeout(()=>{
            var _globalState$eventEmi2;
            if (typeof didClose === 'function') didClose.bind(instance.params)();
            (_globalState$eventEmi2 = globalState.eventEmitter) === null || _globalState$eventEmi2 === void 0 || _globalState$eventEmi2.emit('didClose');
            // instance might have been destroyed already
            if (instance._destroy) instance._destroy();
        });
    };
    /**
   * Shows loader (spinner), this is useful with AJAX requests.
   * By default the loader be shown instead of the "Confirm" button.
   *
   * @param {HTMLButtonElement | null} [buttonToReplace]
   */ const showLoading = (buttonToReplace)=>{
        let popup = getPopup();
        if (!popup) new Swal();
        popup = getPopup();
        if (!popup) return;
        const loader = getLoader();
        if (isToast()) hide(getIcon());
        else replaceButton(popup, buttonToReplace);
        show(loader);
        popup.setAttribute('data-loading', 'true');
        popup.setAttribute('aria-busy', 'true');
        popup.focus();
    };
    /**
   * @param {HTMLElement} popup
   * @param {HTMLButtonElement | null} [buttonToReplace]
   */ const replaceButton = (popup, buttonToReplace)=>{
        const actions = getActions();
        const loader = getLoader();
        if (!actions || !loader) return;
        if (!buttonToReplace && isVisible$1(getConfirmButton())) buttonToReplace = getConfirmButton();
        show(actions);
        if (buttonToReplace) {
            hide(buttonToReplace);
            loader.setAttribute('data-button-to-replace', buttonToReplace.className);
            actions.insertBefore(loader, buttonToReplace);
        }
        addClass([
            popup,
            actions
        ], swalClasses.loading);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const handleInputOptionsAndValue = (instance, params)=>{
        if (params.input === 'select' || params.input === 'radio') handleInputOptions(instance, params);
        else if ([
            'text',
            'email',
            'number',
            'tel',
            'textarea'
        ].some((i)=>i === params.input) && (hasToPromiseFn(params.inputValue) || isPromise(params.inputValue))) {
            showLoading(getConfirmButton());
            handleInputValue(instance, params);
        }
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} innerParams
   * @returns {SweetAlertInputValue}
   */ const getInputValue = (instance, innerParams)=>{
        const input = instance.getInput();
        if (!input) return null;
        switch(innerParams.input){
            case 'checkbox':
                return getCheckboxValue(input);
            case 'radio':
                return getRadioValue(input);
            case 'file':
                return getFileValue(input);
            default:
                return innerParams.inputAutoTrim ? input.value.trim() : input.value;
        }
    };
    /**
   * @param {HTMLInputElement} input
   * @returns {number}
   */ const getCheckboxValue = (input)=>input.checked ? 1 : 0;
    /**
   * @param {HTMLInputElement} input
   * @returns {string | null}
   */ const getRadioValue = (input)=>input.checked ? input.value : null;
    /**
   * @param {HTMLInputElement} input
   * @returns {FileList | File | null}
   */ const getFileValue = (input)=>input.files && input.files.length ? input.getAttribute('multiple') !== null ? input.files : input.files[0] : null;
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const handleInputOptions = (instance, params)=>{
        const popup = getPopup();
        if (!popup) return;
        /**
     * @param {*} inputOptions
     */ const processInputOptions = (inputOptions)=>{
            if (params.input === 'select') populateSelectOptions(popup, formatInputOptions(inputOptions), params);
            else if (params.input === 'radio') populateRadioOptions(popup, formatInputOptions(inputOptions), params);
        };
        if (hasToPromiseFn(params.inputOptions) || isPromise(params.inputOptions)) {
            showLoading(getConfirmButton());
            asPromise(params.inputOptions).then((inputOptions)=>{
                instance.hideLoading();
                processInputOptions(inputOptions);
            });
        } else if (typeof params.inputOptions === 'object') processInputOptions(params.inputOptions);
        else error(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof params.inputOptions}`);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const handleInputValue = (instance, params)=>{
        const input = instance.getInput();
        if (!input) return;
        hide(input);
        asPromise(params.inputValue).then((inputValue)=>{
            input.value = params.input === 'number' ? `${parseFloat(inputValue) || 0}` : `${inputValue}`;
            show(input);
            input.focus();
            instance.hideLoading();
        }).catch((err)=>{
            error(`Error in inputValue promise: ${err}`);
            input.value = '';
            show(input);
            input.focus();
            instance.hideLoading();
        });
    };
    /**
   * @param {HTMLElement} popup
   * @param {InputOptionFlattened[]} inputOptions
   * @param {SweetAlertOptions} params
   */ function populateSelectOptions(popup, inputOptions, params) {
        const select = getDirectChildByClass(popup, swalClasses.select);
        if (!select) return;
        /**
     * @param {HTMLElement} parent
     * @param {string} optionLabel
     * @param {string} optionValue
     */ const renderOption = (parent, optionLabel, optionValue)=>{
            const option = document.createElement('option');
            option.value = optionValue;
            setInnerHtml(option, optionLabel);
            option.selected = isSelected(optionValue, params.inputValue);
            parent.appendChild(option);
        };
        inputOptions.forEach((inputOption)=>{
            const optionValue = inputOption[0];
            const optionLabel = inputOption[1];
            // <optgroup> spec:
            // https://www.w3.org/TR/html401/interact/forms.html#h-17.6
            // "...all OPTGROUP elements must be specified directly within a SELECT element (i.e., groups may not be nested)..."
            // check whether this is a <optgroup>
            if (Array.isArray(optionLabel)) {
                // if it is an array, then it is an <optgroup>
                const optgroup = document.createElement('optgroup');
                optgroup.label = optionValue;
                optgroup.disabled = false; // not configurable for now
                select.appendChild(optgroup);
                optionLabel.forEach((o)=>renderOption(optgroup, o[1], o[0]));
            } else // case of <option>
            renderOption(select, optionLabel, optionValue);
        });
        select.focus();
    }
    /**
   * @param {HTMLElement} popup
   * @param {InputOptionFlattened[]} inputOptions
   * @param {SweetAlertOptions} params
   */ function populateRadioOptions(popup, inputOptions, params) {
        const radio = getDirectChildByClass(popup, swalClasses.radio);
        if (!radio) return;
        inputOptions.forEach((inputOption)=>{
            const radioValue = inputOption[0];
            const radioLabel = inputOption[1];
            const radioInput = document.createElement('input');
            const radioLabelElement = document.createElement('label');
            radioInput.type = 'radio';
            radioInput.name = swalClasses.radio;
            radioInput.value = radioValue;
            if (isSelected(radioValue, params.inputValue)) radioInput.checked = true;
            const label = document.createElement('span');
            setInnerHtml(label, radioLabel);
            label.className = swalClasses.label;
            radioLabelElement.appendChild(radioInput);
            radioLabelElement.appendChild(label);
            radio.appendChild(radioLabelElement);
        });
        const radios = radio.querySelectorAll('input');
        if (radios.length) radios[0].focus();
    }
    /**
   * Converts `inputOptions` into an array of `[value, label]`s
   *
   * @param {*} inputOptions
   * @typedef {string[]} InputOptionFlattened
   * @returns {InputOptionFlattened[]}
   */ const formatInputOptions = (inputOptions)=>{
        const entries = inputOptions instanceof Map ? Array.from(inputOptions) : Object.entries(inputOptions);
        return entries.map(([key, value])=>[
                key,
                typeof value === 'object' ? formatInputOptions(value) : value
            ]); // case of <optgroup>
    };
    /**
   * @param {string} optionValue
   * @param {SweetAlertInputValue} inputValue
   * @returns {boolean}
   */ const isSelected = (optionValue, inputValue)=>Boolean(inputValue) && inputValue != null && inputValue.toString() === optionValue.toString();
    /**
   * @param {SweetAlert} instance
   */ const handleConfirmButtonClick = (instance)=>{
        const innerParams = privateProps.innerParams.get(instance);
        instance.disableButtons();
        if (innerParams.input) handleConfirmOrDenyWithInput(instance, 'confirm');
        else confirm(instance, true);
    };
    /**
   * @param {SweetAlert} instance
   */ const handleDenyButtonClick = (instance)=>{
        const innerParams = privateProps.innerParams.get(instance);
        instance.disableButtons();
        if (innerParams.returnInputValueOnDeny) handleConfirmOrDenyWithInput(instance, 'deny');
        else deny(instance, false);
    };
    /**
   * @param {SweetAlert} instance
   * @param {(dismiss: DismissReason) => void} dismissWith
   */ const handleCancelButtonClick = (instance, dismissWith)=>{
        instance.disableButtons();
        dismissWith(DismissReason.cancel);
    };
    /**
   * @param {SweetAlert} instance
   * @param {'confirm' | 'deny'} type
   */ const handleConfirmOrDenyWithInput = (instance, type)=>{
        const innerParams = privateProps.innerParams.get(instance);
        if (!innerParams.input) {
            error(`The "input" parameter is needed to be set when using returnInputValueOn${capitalizeFirstLetter(type)}`);
            return;
        }
        const input = instance.getInput();
        const inputValue = getInputValue(instance, innerParams);
        if (innerParams.inputValidator) handleInputValidator(instance, inputValue, type);
        else if (input && !input.checkValidity()) {
            instance.enableButtons();
            instance.showValidationMessage(innerParams.validationMessage || input.validationMessage);
        } else if (type === 'deny') deny(instance, inputValue);
        else confirm(instance, inputValue);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertInputValue} inputValue
   * @param {'confirm' | 'deny'} type
   */ const handleInputValidator = (instance, inputValue, type)=>{
        const innerParams = privateProps.innerParams.get(instance);
        instance.disableInput();
        const validationPromise = Promise.resolve().then(()=>asPromise(innerParams.inputValidator(inputValue, innerParams.validationMessage)));
        validationPromise.then((validationMessage)=>{
            instance.enableButtons();
            instance.enableInput();
            if (validationMessage) instance.showValidationMessage(validationMessage);
            else if (type === 'deny') deny(instance, inputValue);
            else confirm(instance, inputValue);
        });
    };
    /**
   * @param {SweetAlert} instance
   * @param {*} value
   */ const deny = (instance, value)=>{
        const innerParams = privateProps.innerParams.get(instance);
        if (innerParams.showLoaderOnDeny) showLoading(getDenyButton());
        if (innerParams.preDeny) {
            instance.isAwaitingPromise = true; // Flagging the instance as awaiting a promise so it's own promise's reject/resolve methods doesn't get destroyed until the result from this preDeny's promise is received
            const preDenyPromise = Promise.resolve().then(()=>asPromise(innerParams.preDeny(value, innerParams.validationMessage)));
            preDenyPromise.then((preDenyValue)=>{
                if (preDenyValue === false) {
                    instance.hideLoading();
                    handleAwaitingPromise(instance);
                } else instance.close(/** @type SweetAlertResult */ {
                    isDenied: true,
                    value: typeof preDenyValue === 'undefined' ? value : preDenyValue
                });
            }).catch((error)=>rejectWith(instance, error));
        } else instance.close(/** @type SweetAlertResult */ {
            isDenied: true,
            value: value
        });
    };
    /**
   * @param {SweetAlert} instance
   * @param {*} value
   */ const succeedWith = (instance, value)=>{
        instance.close(/** @type SweetAlertResult */ {
            isConfirmed: true,
            value: value
        });
    };
    /**
   *
   * @param {SweetAlert} instance
   * @param {string} error
   */ const rejectWith = (instance, error)=>{
        instance.rejectPromise(error);
    };
    /**
   *
   * @param {SweetAlert} instance
   * @param {*} value
   */ const confirm = (instance, value)=>{
        const innerParams = privateProps.innerParams.get(instance);
        if (innerParams.showLoaderOnConfirm) showLoading();
        if (innerParams.preConfirm) {
            instance.resetValidationMessage();
            instance.isAwaitingPromise = true; // Flagging the instance as awaiting a promise so it's own promise's reject/resolve methods doesn't get destroyed until the result from this preConfirm's promise is received
            const preConfirmPromise = Promise.resolve().then(()=>asPromise(innerParams.preConfirm(value, innerParams.validationMessage)));
            preConfirmPromise.then((preConfirmValue)=>{
                if (isVisible$1(getValidationMessage()) || preConfirmValue === false) {
                    instance.hideLoading();
                    handleAwaitingPromise(instance);
                } else succeedWith(instance, typeof preConfirmValue === 'undefined' ? value : preConfirmValue);
            }).catch((error)=>rejectWith(instance, error));
        } else succeedWith(instance, value);
    };
    /**
   * Hides loader and shows back the button which was hidden by .showLoading()
   * @this {SweetAlert}
   */ function hideLoading() {
        // do nothing if popup is closed
        const innerParams = privateProps.innerParams.get(this);
        if (!innerParams) return;
        const domCache = privateProps.domCache.get(this);
        hide(domCache.loader);
        if (isToast()) {
            if (innerParams.icon) show(getIcon());
        } else showRelatedButton(domCache);
        removeClass([
            domCache.popup,
            domCache.actions
        ], swalClasses.loading);
        domCache.popup.removeAttribute('aria-busy');
        domCache.popup.removeAttribute('data-loading');
        this.enableButtons();
    }
    /**
   * @param {DomCache} domCache
   */ const showRelatedButton = (domCache)=>{
        const dataButtonToReplace = domCache.loader.getAttribute('data-button-to-replace');
        const buttonToReplace = dataButtonToReplace ? domCache.popup.getElementsByClassName(dataButtonToReplace) : [];
        if (buttonToReplace.length) show(/** @type {HTMLElement} */ buttonToReplace[0], 'inline-block');
        else if (allButtonsAreHidden()) hide(domCache.actions);
    };
    /**
   * Gets the input DOM node, this method works with input parameter.
   *
   * @returns {HTMLInputElement | null}
   * @this {SweetAlert}
   */ function getInput() {
        const innerParams = privateProps.innerParams.get(this);
        const domCache = privateProps.domCache.get(this);
        if (!domCache) return null;
        return getInput$1(domCache.popup, innerParams.input);
    }
    /**
   * @param {SweetAlert} instance
   * @param {string[]} buttons
   * @param {boolean} disabled
   */ function setButtonsDisabled(instance, buttons, disabled) {
        const domCache = privateProps.domCache.get(instance);
        buttons.forEach((button)=>{
            domCache[button].disabled = disabled;
        });
    }
    /**
   * @param {HTMLInputElement | null} input
   * @param {boolean} disabled
   */ function setInputDisabled(input, disabled) {
        const popup = getPopup();
        if (!popup || !input) return;
        if (input.type === 'radio') {
            /** @type {NodeListOf<HTMLInputElement>} */ const radios = popup.querySelectorAll(`[name="${swalClasses.radio}"]`);
            radios.forEach((radio)=>{
                radio.disabled = disabled;
            });
        } else input.disabled = disabled;
    }
    /**
   * Enable all the buttons
   * @this {SweetAlert}
   */ function enableButtons() {
        setButtonsDisabled(this, [
            'confirmButton',
            'denyButton',
            'cancelButton'
        ], false);
        const focusedElement = privateProps.focusedElement.get(this);
        if (focusedElement instanceof HTMLElement && document.activeElement === document.body) focusedElement.focus();
        privateProps.focusedElement.delete(this);
    }
    /**
   * Disable all the buttons
   * @this {SweetAlert}
   */ function disableButtons() {
        privateProps.focusedElement.set(this, document.activeElement);
        setButtonsDisabled(this, [
            'confirmButton',
            'denyButton',
            'cancelButton'
        ], true);
    }
    /**
   * Enable the input field
   * @this {SweetAlert}
   */ function enableInput() {
        setInputDisabled(this.getInput(), false);
    }
    /**
   * Disable the input field
   * @this {SweetAlert}
   */ function disableInput() {
        setInputDisabled(this.getInput(), true);
    }
    /**
   * Show block with validation message
   *
   * @param {string} error
   * @this {SweetAlert}
   */ function showValidationMessage(error) {
        const domCache = privateProps.domCache.get(this);
        const params = privateProps.innerParams.get(this);
        setInnerHtml(domCache.validationMessage, error);
        domCache.validationMessage.className = swalClasses['validation-message'];
        if (params.customClass && params.customClass.validationMessage) addClass(domCache.validationMessage, params.customClass.validationMessage);
        show(domCache.validationMessage);
        const input = this.getInput();
        if (input) {
            input.setAttribute('aria-invalid', 'true');
            input.setAttribute('aria-describedby', swalClasses['validation-message']);
            focusInput(input);
            addClass(input, swalClasses.inputerror);
        }
    }
    /**
   * Hide block with validation message
   *
   * @this {SweetAlert}
   */ function resetValidationMessage() {
        const domCache = privateProps.domCache.get(this);
        if (domCache.validationMessage) hide(domCache.validationMessage);
        const input = this.getInput();
        if (input) {
            input.removeAttribute('aria-invalid');
            input.removeAttribute('aria-describedby');
            removeClass(input, swalClasses.inputerror);
        }
    }
    const defaultParams = {
        title: '',
        titleText: '',
        text: '',
        html: '',
        footer: '',
        icon: undefined,
        iconColor: undefined,
        iconHtml: undefined,
        template: undefined,
        toast: false,
        draggable: false,
        animation: true,
        theme: 'light',
        showClass: {
            popup: 'swal2-show',
            backdrop: 'swal2-backdrop-show',
            icon: 'swal2-icon-show'
        },
        hideClass: {
            popup: 'swal2-hide',
            backdrop: 'swal2-backdrop-hide',
            icon: 'swal2-icon-hide'
        },
        customClass: {},
        target: 'body',
        color: undefined,
        backdrop: true,
        heightAuto: true,
        allowOutsideClick: true,
        allowEscapeKey: true,
        allowEnterKey: true,
        stopKeydownPropagation: true,
        keydownListenerCapture: false,
        showConfirmButton: true,
        showDenyButton: false,
        showCancelButton: false,
        preConfirm: undefined,
        preDeny: undefined,
        confirmButtonText: 'OK',
        confirmButtonAriaLabel: '',
        confirmButtonColor: undefined,
        denyButtonText: 'No',
        denyButtonAriaLabel: '',
        denyButtonColor: undefined,
        cancelButtonText: 'Cancel',
        cancelButtonAriaLabel: '',
        cancelButtonColor: undefined,
        buttonsStyling: true,
        reverseButtons: false,
        focusConfirm: true,
        focusDeny: false,
        focusCancel: false,
        returnFocus: true,
        showCloseButton: false,
        closeButtonHtml: '&times;',
        closeButtonAriaLabel: 'Close this dialog',
        loaderHtml: '',
        showLoaderOnConfirm: false,
        showLoaderOnDeny: false,
        imageUrl: undefined,
        imageWidth: undefined,
        imageHeight: undefined,
        imageAlt: '',
        timer: undefined,
        timerProgressBar: false,
        width: undefined,
        padding: undefined,
        background: undefined,
        input: undefined,
        inputPlaceholder: '',
        inputLabel: '',
        inputValue: '',
        inputOptions: {},
        inputAutoFocus: true,
        inputAutoTrim: true,
        inputAttributes: {},
        inputValidator: undefined,
        returnInputValueOnDeny: false,
        validationMessage: undefined,
        grow: false,
        position: 'center',
        progressSteps: [],
        currentProgressStep: undefined,
        progressStepsDistance: undefined,
        willOpen: undefined,
        didOpen: undefined,
        didRender: undefined,
        willClose: undefined,
        didClose: undefined,
        didDestroy: undefined,
        scrollbarPadding: true,
        topLayer: false
    };
    const updatableParams = [
        'allowEscapeKey',
        'allowOutsideClick',
        'background',
        'buttonsStyling',
        'cancelButtonAriaLabel',
        'cancelButtonColor',
        'cancelButtonText',
        'closeButtonAriaLabel',
        'closeButtonHtml',
        'color',
        'confirmButtonAriaLabel',
        'confirmButtonColor',
        'confirmButtonText',
        'currentProgressStep',
        'customClass',
        'denyButtonAriaLabel',
        'denyButtonColor',
        'denyButtonText',
        'didClose',
        'didDestroy',
        'draggable',
        'footer',
        'hideClass',
        'html',
        'icon',
        'iconColor',
        'iconHtml',
        'imageAlt',
        'imageHeight',
        'imageUrl',
        'imageWidth',
        'preConfirm',
        'preDeny',
        'progressSteps',
        'returnFocus',
        'reverseButtons',
        'showCancelButton',
        'showCloseButton',
        'showConfirmButton',
        'showDenyButton',
        'text',
        'title',
        'titleText',
        'theme',
        'willClose'
    ];
    /** @type {Record<string, string | undefined>} */ const deprecatedParams = {
        allowEnterKey: undefined
    };
    const toastIncompatibleParams = [
        'allowOutsideClick',
        'allowEnterKey',
        'backdrop',
        'draggable',
        'focusConfirm',
        'focusDeny',
        'focusCancel',
        'returnFocus',
        'heightAuto',
        'keydownListenerCapture'
    ];
    /**
   * Is valid parameter
   *
   * @param {string} paramName
   * @returns {boolean}
   */ const isValidParameter = (paramName)=>{
        return Object.prototype.hasOwnProperty.call(defaultParams, paramName);
    };
    /**
   * Is valid parameter for Swal.update() method
   *
   * @param {string} paramName
   * @returns {boolean}
   */ const isUpdatableParameter = (paramName)=>{
        return updatableParams.indexOf(paramName) !== -1;
    };
    /**
   * Is deprecated parameter
   *
   * @param {string} paramName
   * @returns {string | undefined}
   */ const isDeprecatedParameter = (paramName)=>{
        return deprecatedParams[paramName];
    };
    /**
   * @param {string} param
   */ const checkIfParamIsValid = (param)=>{
        if (!isValidParameter(param)) warn(`Unknown parameter "${param}"`);
    };
    /**
   * @param {string} param
   */ const checkIfToastParamIsValid = (param)=>{
        if (toastIncompatibleParams.includes(param)) warn(`The parameter "${param}" is incompatible with toasts`);
    };
    /**
   * @param {string} param
   */ const checkIfParamIsDeprecated = (param)=>{
        const isDeprecated = isDeprecatedParameter(param);
        if (isDeprecated) warnAboutDeprecation(param, isDeprecated);
    };
    /**
   * Show relevant warnings for given params
   *
   * @param {SweetAlertOptions} params
   */ const showWarningsForParams = (params)=>{
        if (params.backdrop === false && params.allowOutsideClick) warn('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`');
        if (params.theme && ![
            'light',
            'dark',
            'auto',
            'minimal',
            'borderless',
            'bootstrap-4',
            'bootstrap-4-light',
            'bootstrap-4-dark',
            'bootstrap-5',
            'bootstrap-5-light',
            'bootstrap-5-dark',
            'material-ui',
            'material-ui-light',
            'material-ui-dark',
            'embed-iframe',
            'bulma',
            'bulma-light',
            'bulma-dark'
        ].includes(params.theme)) warn(`Invalid theme "${params.theme}"`);
        for(const param in params){
            checkIfParamIsValid(param);
            if (params.toast) checkIfToastParamIsValid(param);
            checkIfParamIsDeprecated(param);
        }
    };
    /**
   * Updates popup parameters.
   *
   * @this {any}
   * @param {SweetAlertOptions} params
   */ function update(params) {
        const container = getContainer();
        const popup = getPopup();
        const innerParams = privateProps.innerParams.get(this);
        if (!popup || hasClass(popup, innerParams.hideClass.popup)) {
            warn(`You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.`);
            return;
        }
        const validUpdatableParams = filterValidParams(params);
        const updatedParams = Object.assign({}, innerParams, validUpdatableParams);
        showWarningsForParams(updatedParams);
        if (container) container.dataset['swal2Theme'] = updatedParams.theme;
        render(this, updatedParams);
        privateProps.innerParams.set(this, updatedParams);
        Object.defineProperties(this, {
            params: {
                value: Object.assign({}, this.params, params),
                writable: false,
                enumerable: true
            }
        });
    }
    /**
   * @param {SweetAlertOptions} params
   * @returns {SweetAlertOptions}
   */ const filterValidParams = (params)=>{
        /** @type {Record<string, any>} */ const validUpdatableParams = {};
        Object.keys(params).forEach((param)=>{
            if (isUpdatableParameter(param)) {
                const typedParams = /** @type {Record<string, any>} */ params;
                validUpdatableParams[param] = typedParams[param];
            } else warn(`Invalid parameter to update: ${param}`);
        });
        return validUpdatableParams;
    };
    /**
   * Dispose the current SweetAlert2 instance
   * @this {SweetAlert}
   */ function _destroy() {
        var _globalState$eventEmi;
        const domCache = privateProps.domCache.get(this);
        const innerParams = privateProps.innerParams.get(this);
        if (!innerParams) {
            disposeWeakMaps(this); // The WeakMaps might have been partly destroyed, we must recall it to dispose any remaining WeakMaps #2335
            return; // This instance has already been destroyed
        }
        // Check if there is another Swal closing
        if (domCache.popup && globalState.swalCloseEventFinishedCallback) {
            globalState.swalCloseEventFinishedCallback();
            delete globalState.swalCloseEventFinishedCallback;
        }
        if (typeof innerParams.didDestroy === 'function') innerParams.didDestroy();
        (_globalState$eventEmi = globalState.eventEmitter) === null || _globalState$eventEmi === void 0 || _globalState$eventEmi.emit('didDestroy');
        disposeSwal(this);
    }
    /**
   * @param {SweetAlert} instance
   */ const disposeSwal = (instance)=>{
        disposeWeakMaps(instance);
        // Unset this.params so GC will dispose it (#1569)
        // @ts-ignore
        delete instance.params;
        // Unset globalState props so GC will dispose globalState (#1569)
        delete globalState.keydownHandler;
        delete globalState.keydownTarget;
        // Unset currentInstance
        delete globalState.currentInstance;
    };
    /**
   * @param {SweetAlert} instance
   */ const disposeWeakMaps = (instance)=>{
        // If the current instance is awaiting a promise result, we keep the privateMethods to call them once the promise result is retrieved #2335
        if (instance.isAwaitingPromise) {
            unsetWeakMaps(privateProps, instance);
            instance.isAwaitingPromise = true;
        } else {
            unsetWeakMaps(privateMethods, instance);
            unsetWeakMaps(privateProps, instance);
            // @ts-ignore
            delete instance.isAwaitingPromise;
            // Unset instance methods
            // @ts-ignore
            delete instance.disableButtons;
            // @ts-ignore
            delete instance.enableButtons;
            // @ts-ignore
            delete instance.getInput;
            // @ts-ignore
            delete instance.disableInput;
            // @ts-ignore
            delete instance.enableInput;
            // @ts-ignore
            delete instance.hideLoading;
            // @ts-ignore
            delete instance.disableLoading;
            // @ts-ignore
            delete instance.showValidationMessage;
            // @ts-ignore
            delete instance.resetValidationMessage;
            // @ts-ignore
            delete instance.close;
            // @ts-ignore
            delete instance.closePopup;
            // @ts-ignore
            delete instance.closeModal;
            // @ts-ignore
            delete instance.closeToast;
            // @ts-ignore
            delete instance.rejectPromise;
            // @ts-ignore
            delete instance.update;
            // @ts-ignore
            delete instance._destroy;
        }
    };
    /**
   * @param {Record<string, WeakMap<any, any>>} obj
   * @param {SweetAlert} instance
   */ const unsetWeakMaps = (obj, instance)=>{
        for(const i in obj)obj[i].delete(instance);
    };
    var instanceMethods = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        _destroy: _destroy,
        close: close,
        closeModal: close,
        closePopup: close,
        closeToast: close,
        disableButtons: disableButtons,
        disableInput: disableInput,
        disableLoading: hideLoading,
        enableButtons: enableButtons,
        enableInput: enableInput,
        getInput: getInput,
        handleAwaitingPromise: handleAwaitingPromise,
        hideLoading: hideLoading,
        rejectPromise: rejectPromise,
        resetValidationMessage: resetValidationMessage,
        showValidationMessage: showValidationMessage,
        update: update
    });
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {DomCache} domCache
   * @param {(dismiss: DismissReason) => void} dismissWith
   */ const handlePopupClick = (innerParams, domCache, dismissWith)=>{
        if (innerParams.toast) handleToastClick(innerParams, domCache, dismissWith);
        else {
            // Ignore click events that had mousedown on the popup but mouseup on the container
            // This can happen when the user drags a slider
            handleModalMousedown(domCache);
            // Ignore click events that had mousedown on the container but mouseup on the popup
            handleContainerMousedown(domCache);
            handleModalClick(innerParams, domCache, dismissWith);
        }
    };
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {DomCache} domCache
   * @param {(dismiss: DismissReason) => void} dismissWith
   */ const handleToastClick = (innerParams, domCache, dismissWith)=>{
        // Closing toast by internal click
        domCache.popup.onclick = ()=>{
            if (innerParams && (isAnyButtonShown(innerParams) || innerParams.timer || innerParams.input)) return;
            dismissWith(DismissReason.close);
        };
    };
    /**
   * @param {SweetAlertOptions} innerParams
   * @returns {boolean}
   */ const isAnyButtonShown = (innerParams)=>{
        return Boolean(innerParams.showConfirmButton || innerParams.showDenyButton || innerParams.showCancelButton || innerParams.showCloseButton);
    };
    let ignoreOutsideClick = false;
    /**
   * @param {DomCache} domCache
   */ const handleModalMousedown = (domCache)=>{
        domCache.popup.onmousedown = ()=>{
            domCache.container.onmouseup = function(e) {
                domCache.container.onmouseup = ()=>{};
                // We only check if the mouseup target is the container because usually it doesn't
                // have any other direct children aside of the popup
                if (e.target === domCache.container) ignoreOutsideClick = true;
            };
        };
    };
    /**
   * @param {DomCache} domCache
   */ const handleContainerMousedown = (domCache)=>{
        domCache.container.onmousedown = (e)=>{
            // prevent the modal text from being selected on double click on the container (allowOutsideClick: false)
            if (e.target === domCache.container) e.preventDefault();
            domCache.popup.onmouseup = function(e) {
                domCache.popup.onmouseup = ()=>{};
                // We also need to check if the mouseup target is a child of the popup
                if (e.target === domCache.popup || e.target instanceof HTMLElement && domCache.popup.contains(e.target)) ignoreOutsideClick = true;
            };
        };
    };
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {DomCache} domCache
   * @param {(dismiss: DismissReason) => void} dismissWith
   */ const handleModalClick = (innerParams, domCache, dismissWith)=>{
        domCache.container.onclick = (e)=>{
            if (ignoreOutsideClick) {
                ignoreOutsideClick = false;
                return;
            }
            if (e.target === domCache.container && callIfFunction(innerParams.allowOutsideClick)) dismissWith(DismissReason.backdrop);
        };
    };
    /**
   * @param {unknown} elem
   * @returns {boolean}
   */ const isJqueryElement = (elem)=>typeof elem === 'object' && elem !== null && 'jquery' in elem;
    /**
   * @param {unknown} elem
   * @returns {boolean}
   */ const isElement = (elem)=>elem instanceof Element || isJqueryElement(elem);
    /**
   * @param {ReadonlyArray<unknown>} args
   * @returns {SweetAlertOptions}
   */ const argsToParams = (args)=>{
        /** @type {Record<string, unknown>} */ const params = {};
        if (typeof args[0] === 'object' && !isElement(args[0])) Object.assign(params, args[0]);
        else [
            'title',
            'html',
            'icon'
        ].forEach((name, index)=>{
            const arg = args[index];
            if (typeof arg === 'string' || isElement(arg)) params[name] = arg;
            else if (arg !== undefined) error(`Unexpected type of ${name}! Expected "string" or "Element", got ${typeof arg}`);
        });
        return /** @type {SweetAlertOptions} */ params;
    };
    /**
   * Main method to create a new SweetAlert2 popup
   *
   * @this {new (...args: any[]) => any}
   * @param  {...SweetAlertOptions} args
   * @returns {Promise<SweetAlertResult>}
   */ function fire(...args) {
        return new this(...args);
    }
    /**
   * Returns an extended version of `Swal` containing `params` as defaults.
   * Useful for reusing Swal configuration.
   *
   * For example:
   *
   * Before:
   * const textPromptOptions = { input: 'text', showCancelButton: true }
   * const {value: firstName} = await Swal.fire({ ...textPromptOptions, title: 'What is your first name?' })
   * const {value: lastName} = await Swal.fire({ ...textPromptOptions, title: 'What is your last name?' })
   *
   * After:
   * const TextPrompt = Swal.mixin({ input: 'text', showCancelButton: true })
   * const {value: firstName} = await TextPrompt('What is your first name?')
   * const {value: lastName} = await TextPrompt('What is your last name?')
   *
   * @param {SweetAlertOptions} mixinParams
   * @returns {SweetAlert}
   * @this {typeof import('../SweetAlert.js').SweetAlert}
   */ function mixin(mixinParams) {
        // @ts-ignore: 'this' refers to the SweetAlert constructor
        class MixinSwal extends this {
            /**
       * @param {any} params
       * @param {any} priorityMixinParams
       */ _main(params, priorityMixinParams) {
                return super._main(params, Object.assign({}, mixinParams, priorityMixinParams));
            }
        }
        // @ts-ignore
        return MixinSwal;
    }
    /**
   * If `timer` parameter is set, returns number of milliseconds of timer remained.
   * Otherwise, returns undefined.
   *
   * @returns {number | undefined}
   */ const getTimerLeft = ()=>{
        return globalState.timeout && globalState.timeout.getTimerLeft();
    };
    /**
   * Stop timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */ const stopTimer = ()=>{
        if (globalState.timeout) {
            stopTimerProgressBar();
            return globalState.timeout.stop();
        }
    };
    /**
   * Resume timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */ const resumeTimer = ()=>{
        if (globalState.timeout) {
            const remaining = globalState.timeout.start();
            animateTimerProgressBar(remaining);
            return remaining;
        }
    };
    /**
   * Resume timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */ const toggleTimer = ()=>{
        const timer = globalState.timeout;
        return timer && (timer.running ? stopTimer() : resumeTimer());
    };
    /**
   * Increase timer. Returns number of milliseconds of an updated timer.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @param {number} ms
   * @returns {number | undefined}
   */ const increaseTimer = (ms)=>{
        if (globalState.timeout) {
            const remaining = globalState.timeout.increase(ms);
            animateTimerProgressBar(remaining, true);
            return remaining;
        }
    };
    /**
   * Check if timer is running. Returns true if timer is running
   * or false if timer is paused or stopped.
   * If `timer` parameter isn't set, returns undefined
   *
   * @returns {boolean}
   */ const isTimerRunning = ()=>{
        return Boolean(globalState.timeout && globalState.timeout.isRunning());
    };
    let bodyClickListenerAdded = false;
    /** @type {Record<string, any>} */ const clickHandlers = {};
    /**
   * @this {any}
   * @param {string} attr
   */ function bindClickHandler(attr = 'data-swal-template') {
        clickHandlers[attr] = this;
        if (!bodyClickListenerAdded) {
            document.body.addEventListener('click', bodyClickListener);
            bodyClickListenerAdded = true;
        }
    }
    /**
   * @param {MouseEvent} event
   */ const bodyClickListener = (event)=>{
        for(let el = /** @type {any} */ event.target; el && el !== document; el = el.parentNode)for(const attr in clickHandlers){
            const template = el.getAttribute && el.getAttribute(attr);
            if (template) {
                clickHandlers[attr].fire({
                    template: template
                });
                return;
            }
        }
    };
    // Source: https://gist.github.com/mudge/5830382?permalink_comment_id=2691957#gistcomment-2691957
    class EventEmitter {
        constructor(){
            /** @type {Events} */ this.events = {};
        }
        /**
     * @param {string} eventName
     * @returns {EventHandlers}
     */ _getHandlersByEventName(eventName) {
            if (typeof this.events[eventName] === 'undefined') // not Set because we need to keep the FIFO order
            // https://github.com/sweetalert2/sweetalert2/pull/2763#discussion_r1748990334
            this.events[eventName] = [];
            return this.events[eventName];
        }
        /**
     * @param {string} eventName
     * @param {EventHandler} eventHandler
     */ on(eventName, eventHandler) {
            const currentHandlers = this._getHandlersByEventName(eventName);
            if (!currentHandlers.includes(eventHandler)) currentHandlers.push(eventHandler);
        }
        /**
     * @param {string} eventName
     * @param {EventHandler} eventHandler
     */ once(eventName, eventHandler) {
            /**
       * @param {...any} args
       */ const onceFn = (...args)=>{
                this.removeListener(eventName, onceFn);
                // @ts-ignore
                eventHandler.apply(this, args);
            };
            this.on(eventName, onceFn);
        }
        /**
     * @param {string} eventName
     * @param {...any} args
     */ emit(eventName, ...args) {
            this._getHandlersByEventName(eventName).forEach(/**
       * @param {EventHandler} eventHandler
       */ (eventHandler)=>{
                try {
                    // @ts-ignore
                    eventHandler.apply(this, args);
                } catch (error) {
                    console.error(error);
                }
            });
        }
        /**
     * @param {string} eventName
     * @param {EventHandler} eventHandler
     */ removeListener(eventName, eventHandler) {
            const currentHandlers = this._getHandlersByEventName(eventName);
            const index = currentHandlers.indexOf(eventHandler);
            if (index > -1) currentHandlers.splice(index, 1);
        }
        /**
     * @param {string} eventName
     */ removeAllListeners(eventName) {
            if (this.events[eventName] !== undefined) // https://github.com/sweetalert2/sweetalert2/pull/2763#discussion_r1749239222
            this.events[eventName].length = 0;
        }
        reset() {
            this.events = {};
        }
    }
    globalState.eventEmitter = new EventEmitter();
    /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */ const on = (eventName, eventHandler)=>{
        if (globalState.eventEmitter) globalState.eventEmitter.on(eventName, eventHandler);
    };
    /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */ const once = (eventName, eventHandler)=>{
        if (globalState.eventEmitter) globalState.eventEmitter.once(eventName, eventHandler);
    };
    /**
   * @param {string} [eventName]
   * @param {EventHandler} [eventHandler]
   */ const off = (eventName, eventHandler)=>{
        if (!globalState.eventEmitter) return;
        // Remove all handlers for all events
        if (!eventName) {
            globalState.eventEmitter.reset();
            return;
        }
        if (eventHandler) // Remove a specific handler
        globalState.eventEmitter.removeListener(eventName, eventHandler);
        else // Remove all handlers for a specific event
        globalState.eventEmitter.removeAllListeners(eventName);
    };
    var staticMethods = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        argsToParams: argsToParams,
        bindClickHandler: bindClickHandler,
        clickCancel: clickCancel,
        clickConfirm: clickConfirm,
        clickDeny: clickDeny,
        enableLoading: showLoading,
        fire: fire,
        getActions: getActions,
        getCancelButton: getCancelButton,
        getCloseButton: getCloseButton,
        getConfirmButton: getConfirmButton,
        getContainer: getContainer,
        getDenyButton: getDenyButton,
        getFocusableElements: getFocusableElements,
        getFooter: getFooter,
        getHtmlContainer: getHtmlContainer,
        getIcon: getIcon,
        getIconContent: getIconContent,
        getImage: getImage,
        getInputLabel: getInputLabel,
        getLoader: getLoader,
        getPopup: getPopup,
        getProgressSteps: getProgressSteps,
        getTimerLeft: getTimerLeft,
        getTimerProgressBar: getTimerProgressBar,
        getTitle: getTitle,
        getValidationMessage: getValidationMessage,
        increaseTimer: increaseTimer,
        isDeprecatedParameter: isDeprecatedParameter,
        isLoading: isLoading,
        isTimerRunning: isTimerRunning,
        isUpdatableParameter: isUpdatableParameter,
        isValidParameter: isValidParameter,
        isVisible: isVisible,
        mixin: mixin,
        off: off,
        on: on,
        once: once,
        resumeTimer: resumeTimer,
        showLoading: showLoading,
        stopTimer: stopTimer,
        toggleTimer: toggleTimer
    });
    class Timer {
        /**
     * @param {() => void} callback
     * @param {number} delay
     */ constructor(callback, delay){
            this.callback = callback;
            this.remaining = delay;
            this.running = false;
            this.start();
        }
        /**
     * @returns {number}
     */ start() {
            if (!this.running) {
                this.running = true;
                this.started = new Date();
                this.id = setTimeout(this.callback, this.remaining);
            }
            return this.remaining;
        }
        /**
     * @returns {number}
     */ stop() {
            if (this.started && this.running) {
                this.running = false;
                clearTimeout(this.id);
                this.remaining -= new Date().getTime() - this.started.getTime();
            }
            return this.remaining;
        }
        /**
     * @param {number} n
     * @returns {number}
     */ increase(n) {
            const running = this.running;
            if (running) this.stop();
            this.remaining += n;
            if (running) this.start();
            return this.remaining;
        }
        /**
     * @returns {number}
     */ getTimerLeft() {
            if (this.running) {
                this.stop();
                this.start();
            }
            return this.remaining;
        }
        /**
     * @returns {boolean}
     */ isRunning() {
            return this.running;
        }
    }
    const swalStringParams = [
        'swal-title',
        'swal-html',
        'swal-footer'
    ];
    /**
   * @param {SweetAlertOptions} params
   * @returns {SweetAlertOptions}
   */ const getTemplateParams = (params)=>{
        const template = typeof params.template === 'string' ? /** @type {HTMLTemplateElement} */ document.querySelector(params.template) : params.template;
        if (!template) return {};
        /** @type {DocumentFragment} */ const templateContent = template.content;
        showWarningsForElements(templateContent);
        const result = Object.assign(getSwalParams(templateContent), getSwalFunctionParams(templateContent), getSwalButtons(templateContent), getSwalImage(templateContent), getSwalIcon(templateContent), getSwalInput(templateContent), getSwalStringParams(templateContent, swalStringParams));
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, string | boolean | number>}
   */ const getSwalParams = (templateContent)=>{
        /** @type {Record<string, string | boolean | number>} */ const result = {};
        /** @type {HTMLElement[]} */ const swalParams = Array.from(templateContent.querySelectorAll('swal-param'));
        swalParams.forEach((param)=>{
            showWarningsForAttributes(param, [
                'name',
                'value'
            ]);
            const paramName = /** @type {keyof SweetAlertOptions} */ param.getAttribute('name');
            const value = param.getAttribute('value');
            if (!paramName || !value) return;
            if (paramName in defaultParams && typeof defaultParams[/** @type {keyof typeof defaultParams} */ paramName] === 'boolean') result[paramName] = value !== 'false';
            else if (paramName in defaultParams && typeof defaultParams[/** @type {keyof typeof defaultParams} */ paramName] === 'object') result[paramName] = JSON.parse(value);
            else result[paramName] = value;
        });
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, () => void>}
   */ const getSwalFunctionParams = (templateContent)=>{
        /** @type {Record<string, () => void>} */ const result = {};
        /** @type {HTMLElement[]} */ const swalFunctions = Array.from(templateContent.querySelectorAll('swal-function-param'));
        swalFunctions.forEach((param)=>{
            const paramName = /** @type {keyof SweetAlertOptions} */ param.getAttribute('name');
            const value = param.getAttribute('value');
            if (!paramName || !value) return;
            result[paramName] = new Function(`return ${value}`)();
        });
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, string | boolean>}
   */ const getSwalButtons = (templateContent)=>{
        /** @type {Record<string, string | boolean>} */ const result = {};
        /** @type {HTMLElement[]} */ const swalButtons = Array.from(templateContent.querySelectorAll('swal-button'));
        swalButtons.forEach((button)=>{
            showWarningsForAttributes(button, [
                'type',
                'color',
                'aria-label'
            ]);
            const type = button.getAttribute('type');
            if (!type || ![
                'confirm',
                'cancel',
                'deny'
            ].includes(type)) return;
            result[`${type}ButtonText`] = button.innerHTML;
            result[`show${capitalizeFirstLetter(type)}Button`] = true;
            const color = button.getAttribute('color');
            if (color !== null) result[`${type}ButtonColor`] = color;
            const ariaLabel = button.getAttribute('aria-label');
            if (ariaLabel !== null) result[`${type}ButtonAriaLabel`] = ariaLabel;
        });
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Pick<SweetAlertOptions, 'imageUrl' | 'imageWidth' | 'imageHeight' | 'imageAlt'>}
   */ const getSwalImage = (templateContent)=>{
        const result = {};
        /** @type {HTMLElement | null} */ const image = templateContent.querySelector('swal-image');
        if (image) {
            showWarningsForAttributes(image, [
                'src',
                'width',
                'height',
                'alt'
            ]);
            // getAttribute returns null if attribute is absent; `|| undefined` converts empty string to undefined
            const src = image.getAttribute('src');
            if (src !== null) result.imageUrl = src || undefined;
            const width = image.getAttribute('width');
            if (width !== null) result.imageWidth = width || undefined;
            const height = image.getAttribute('height');
            if (height !== null) result.imageHeight = height || undefined;
            const alt = image.getAttribute('alt');
            if (alt !== null) result.imageAlt = alt || undefined;
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {object}
   */ const getSwalIcon = (templateContent)=>{
        const result = {};
        /** @type {HTMLElement | null} */ const icon = templateContent.querySelector('swal-icon');
        if (icon) {
            showWarningsForAttributes(icon, [
                'type',
                'color'
            ]);
            if (icon.hasAttribute('type')) result.icon = icon.getAttribute('type');
            if (icon.hasAttribute('color')) result.iconColor = icon.getAttribute('color');
            result.iconHtml = icon.innerHTML;
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {object}
   */ const getSwalInput = (templateContent)=>{
        /** @type {Record<string, any>} */ const result = {};
        /** @type {HTMLElement | null} */ const input = templateContent.querySelector('swal-input');
        if (input) {
            showWarningsForAttributes(input, [
                'type',
                'label',
                'placeholder',
                'value'
            ]);
            result.input = input.getAttribute('type') || 'text';
            if (input.hasAttribute('label')) result.inputLabel = input.getAttribute('label');
            if (input.hasAttribute('placeholder')) result.inputPlaceholder = input.getAttribute('placeholder');
            if (input.hasAttribute('value')) result.inputValue = input.getAttribute('value');
        }
        /** @type {HTMLElement[]} */ const inputOptions = Array.from(templateContent.querySelectorAll('swal-input-option'));
        if (inputOptions.length) {
            result.inputOptions = {};
            inputOptions.forEach((option)=>{
                showWarningsForAttributes(option, [
                    'value'
                ]);
                const optionValue = option.getAttribute('value');
                if (!optionValue) return;
                const optionName = option.innerHTML;
                result.inputOptions[optionValue] = optionName;
            });
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @param {string[]} paramNames
   * @returns {Record<string, string>}
   */ const getSwalStringParams = (templateContent, paramNames)=>{
        /** @type {Record<string, string>} */ const result = {};
        for(const i in paramNames){
            const paramName = paramNames[i];
            /** @type {HTMLElement | null} */ const tag = templateContent.querySelector(paramName);
            if (tag) {
                showWarningsForAttributes(tag, []);
                result[paramName.replace(/^swal-/, '')] = tag.innerHTML.trim();
            }
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   */ const showWarningsForElements = (templateContent)=>{
        const allowedElements = swalStringParams.concat([
            'swal-param',
            'swal-function-param',
            'swal-button',
            'swal-image',
            'swal-icon',
            'swal-input',
            'swal-input-option'
        ]);
        Array.from(templateContent.children).forEach((el)=>{
            const tagName = el.tagName.toLowerCase();
            if (!allowedElements.includes(tagName)) warn(`Unrecognized element <${tagName}>`);
        });
    };
    /**
   * @param {HTMLElement} el
   * @param {string[]} allowedAttributes
   */ const showWarningsForAttributes = (el, allowedAttributes)=>{
        Array.from(el.attributes).forEach((attribute)=>{
            if (allowedAttributes.indexOf(attribute.name) === -1) warn([
                `Unrecognized attribute "${attribute.name}" on <${el.tagName.toLowerCase()}>.`,
                `${allowedAttributes.length ? `Allowed attributes are: ${allowedAttributes.join(', ')}` : 'To set the value, use HTML within the element.'}`
            ]);
        });
    };
    const SHOW_CLASS_TIMEOUT = 10;
    /**
   * Open popup, add necessary classes and styles, fix scrollbar
   *
   * @param {SweetAlertOptions} params
   */ const openPopup = (params)=>{
        var _globalState$eventEmi, _globalState$eventEmi2;
        const container = getContainer();
        const popup = getPopup();
        if (!container || !popup) return;
        if (typeof params.willOpen === 'function') params.willOpen(popup);
        (_globalState$eventEmi = globalState.eventEmitter) === null || _globalState$eventEmi === void 0 || _globalState$eventEmi.emit('willOpen', popup);
        const bodyStyles = window.getComputedStyle(document.body);
        const initialBodyOverflow = bodyStyles.overflowY;
        addClasses(container, popup, params);
        // scrolling is 'hidden' until animation is done, after that 'auto'
        setTimeout(()=>{
            setScrollingVisibility(container, popup);
        }, SHOW_CLASS_TIMEOUT);
        if (isModal()) {
            fixScrollContainer(container, params.scrollbarPadding !== undefined ? params.scrollbarPadding : false, initialBodyOverflow);
            setAriaHidden();
        }
        // https://github.com/sweetalert2/sweetalert2/issues/2923
        if (isIOS && params.backdrop === false && popup.scrollHeight > container.clientHeight) // remove pointer-events: none from container, it breaks scrolling tall popups in iOS
        container.style.pointerEvents = 'auto';
        if (!isToast() && !globalState.previousActiveElement) globalState.previousActiveElement = document.activeElement;
        if (typeof params.didOpen === 'function') {
            const didOpen = params.didOpen;
            setTimeout(()=>didOpen(popup));
        }
        (_globalState$eventEmi2 = globalState.eventEmitter) === null || _globalState$eventEmi2 === void 0 || _globalState$eventEmi2.emit('didOpen', popup);
    };
    /**
   * @param {Event} event
   */ const swalOpenAnimationFinished = (event)=>{
        const popup = getPopup();
        if (!popup || event.target !== popup) return;
        const container = getContainer();
        if (!container) return;
        popup.removeEventListener('animationend', swalOpenAnimationFinished);
        popup.removeEventListener('transitionend', swalOpenAnimationFinished);
        container.style.overflowY = 'auto';
        // no-transition is added in init() in case one swal is opened right after another
        removeClass(container, swalClasses['no-transition']);
    };
    /**
   * @param {HTMLElement} container
   * @param {HTMLElement} popup
   */ const setScrollingVisibility = (container, popup)=>{
        if (hasCssAnimation(popup)) {
            container.style.overflowY = 'hidden';
            popup.addEventListener('animationend', swalOpenAnimationFinished);
            popup.addEventListener('transitionend', swalOpenAnimationFinished);
        } else container.style.overflowY = 'auto';
    };
    /**
   * @param {HTMLElement} container
   * @param {boolean} scrollbarPadding
   * @param {string} initialBodyOverflow
   */ const fixScrollContainer = (container, scrollbarPadding, initialBodyOverflow)=>{
        iOSfix();
        if (scrollbarPadding && initialBodyOverflow !== 'hidden') replaceScrollbarWithPadding(initialBodyOverflow);
        // sweetalert2/issues/1247
        setTimeout(()=>{
            container.scrollTop = 0;
        });
    };
    /**
   * @param {HTMLElement} container
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} params
   */ const addClasses = (container, popup, params)=>{
        var _params$showClass;
        if ((_params$showClass = params.showClass) !== null && _params$showClass !== void 0 && _params$showClass.backdrop) addClass(container, params.showClass.backdrop);
        if (params.animation) {
            // this workaround with opacity is needed for https://github.com/sweetalert2/sweetalert2/issues/2059
            popup.style.setProperty('opacity', '0', 'important');
            show(popup, 'grid');
            setTimeout(()=>{
                var _params$showClass2;
                // Animate popup right after showing it
                if ((_params$showClass2 = params.showClass) !== null && _params$showClass2 !== void 0 && _params$showClass2.popup) addClass(popup, params.showClass.popup);
                // and remove the opacity workaround
                popup.style.removeProperty('opacity');
            }, SHOW_CLASS_TIMEOUT); // 10ms in order to fix #2062
        } else show(popup, 'grid');
        addClass([
            document.documentElement,
            document.body
        ], swalClasses.shown);
        if (params.heightAuto && params.backdrop && !params.toast) addClass([
            document.documentElement,
            document.body
        ], swalClasses['height-auto']);
    };
    var defaultInputValidators = {
        /**
     * @param {string} string
     * @param {string} [validationMessage]
     * @returns {Promise<string | void>}
     */ email: (string, validationMessage)=>{
            return /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid email address');
        },
        /**
     * @param {string} string
     * @param {string} [validationMessage]
     * @returns {Promise<string | void>}
     */ url: (string, validationMessage)=>{
            // taken from https://stackoverflow.com/a/3809435 with a small change from #1306 and #2013
            return /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid URL');
        }
    };
    /**
   * @param {SweetAlertOptions} params
   */ function setDefaultInputValidators(params) {
        // Use default `inputValidator` for supported input types if not provided
        if (params.inputValidator) return;
        if (params.input === 'email') params.inputValidator = defaultInputValidators['email'];
        if (params.input === 'url') params.inputValidator = defaultInputValidators['url'];
    }
    /**
   * @param {SweetAlertOptions} params
   */ function validateCustomTargetElement(params) {
        // Determine if the custom target element is valid
        if (!params.target || typeof params.target === 'string' && !document.querySelector(params.target) || typeof params.target !== 'string' && !params.target.appendChild) {
            warn('Target parameter is not valid, defaulting to "body"');
            params.target = 'body';
        }
    }
    /**
   * Set type, text and actions on popup
   *
   * @param {SweetAlertOptions} params
   */ function setParameters(params) {
        setDefaultInputValidators(params);
        // showLoaderOnConfirm && preConfirm
        if (params.showLoaderOnConfirm && !params.preConfirm) warn("showLoaderOnConfirm is set to true, but preConfirm is not defined.\nshowLoaderOnConfirm should be used together with preConfirm, see usage example:\nhttps://sweetalert2.github.io/#ajax-request");
        validateCustomTargetElement(params);
        // Replace newlines with <br> in title
        if (typeof params.title === 'string') params.title = params.title.split('\n').join('<br />');
        init(params);
    }
    /** @type {SweetAlert} */ let currentInstance;
    var _promise = /*#__PURE__*/ new WeakMap();
    class SweetAlert {
        /**
     * @param {...(SweetAlertOptions | string)} args
     * @this {SweetAlert}
     */ constructor(...args){
            /**
       * @type {Promise<SweetAlertResult>}
       */ _classPrivateFieldInitSpec(this, _promise, /** @type {Promise<SweetAlertResult>} */ Promise.resolve({
                isConfirmed: false,
                isDenied: false,
                isDismissed: true
            }));
            // Prevent run in Node env
            if (typeof window === 'undefined') return;
            currentInstance = this;
            // @ts-ignore
            const outerParams = Object.freeze(this.constructor.argsToParams(args));
            /** @type {Readonly<SweetAlertOptions>} */ this.params = outerParams;
            /** @type {boolean} */ this.isAwaitingPromise = false;
            _classPrivateFieldSet2(_promise, this, this._main(currentInstance.params));
        }
        /**
     * @param {any} userParams
     * @param {any} mixinParams
     */ _main(userParams, mixinParams = {}) {
            showWarningsForParams(Object.assign({}, mixinParams, userParams));
            if (globalState.currentInstance) {
                const swalPromiseResolve = privateMethods.swalPromiseResolve.get(globalState.currentInstance);
                const { isAwaitingPromise: isAwaitingPromise } = globalState.currentInstance;
                globalState.currentInstance._destroy();
                if (!isAwaitingPromise) swalPromiseResolve({
                    isDismissed: true
                });
                if (isModal()) unsetAriaHidden();
            }
            globalState.currentInstance = currentInstance;
            const innerParams = prepareParams(userParams, mixinParams);
            setParameters(innerParams);
            Object.freeze(innerParams);
            // clear the previous timer
            if (globalState.timeout) {
                globalState.timeout.stop();
                delete globalState.timeout;
            }
            // clear the restore focus timeout
            clearTimeout(globalState.restoreFocusTimeout);
            const domCache = populateDomCache(currentInstance);
            render(currentInstance, innerParams);
            privateProps.innerParams.set(currentInstance, innerParams);
            return swalPromise(currentInstance, domCache, innerParams);
        }
        // `catch` cannot be the name of a module export, so we define our thenable methods here instead
        /**
     * @param {any} onFulfilled
     */ // oxlint-disable-next-line unicorn/no-thenable
        then(onFulfilled) {
            return _classPrivateFieldGet2(_promise, this).then(onFulfilled);
        }
        /**
     * @param {any} onFinally
     */ finally(onFinally) {
            return _classPrivateFieldGet2(_promise, this).finally(onFinally);
        }
    }
    /**
   * @param {SweetAlert} instance
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   * @returns {Promise<SweetAlertResult>}
   */ const swalPromise = (instance, domCache, innerParams)=>{
        return new Promise((resolve, reject)=>{
            // functions to handle all closings/dismissals
            /**
       * @param {DismissReason} dismiss
       */ const dismissWith = (dismiss)=>{
                instance.close({
                    isDismissed: true,
                    dismiss: dismiss,
                    isConfirmed: false,
                    isDenied: false
                });
            };
            privateMethods.swalPromiseResolve.set(instance, resolve);
            privateMethods.swalPromiseReject.set(instance, reject);
            domCache.confirmButton.onclick = ()=>{
                handleConfirmButtonClick(instance);
            };
            domCache.denyButton.onclick = ()=>{
                handleDenyButtonClick(instance);
            };
            domCache.cancelButton.onclick = ()=>{
                handleCancelButtonClick(instance, dismissWith);
            };
            domCache.closeButton.onclick = ()=>{
                dismissWith(DismissReason.close);
            };
            handlePopupClick(innerParams, domCache, dismissWith);
            addKeydownHandler(globalState, innerParams, dismissWith);
            handleInputOptionsAndValue(instance, innerParams);
            openPopup(innerParams);
            setupTimer(globalState, innerParams, dismissWith);
            initFocus(domCache, innerParams);
            // Scroll container to top on open (#1247, #1946)
            setTimeout(()=>{
                domCache.container.scrollTop = 0;
            });
        });
    };
    /**
   * @param {SweetAlertOptions} userParams
   * @param {SweetAlertOptions} mixinParams
   * @returns {SweetAlertOptions}
   */ const prepareParams = (userParams, mixinParams)=>{
        const templateParams = getTemplateParams(userParams);
        const params = Object.assign({}, defaultParams, mixinParams, templateParams, userParams); // precedence is described in #2131
        params.showClass = Object.assign({}, defaultParams.showClass, params.showClass);
        params.hideClass = Object.assign({}, defaultParams.hideClass, params.hideClass);
        if (params.animation === false) {
            params.showClass = {
                backdrop: 'swal2-noanimation'
            };
            params.hideClass = {};
        }
        return params;
    };
    /**
   * @param {SweetAlert} instance
   * @returns {DomCache}
   */ const populateDomCache = (instance)=>{
        const domCache = /** @type {DomCache} */ {
            popup: /** @type {HTMLElement} */ getPopup(),
            container: /** @type {HTMLElement} */ getContainer(),
            actions: /** @type {HTMLElement} */ getActions(),
            confirmButton: /** @type {HTMLElement} */ getConfirmButton(),
            denyButton: /** @type {HTMLElement} */ getDenyButton(),
            cancelButton: /** @type {HTMLElement} */ getCancelButton(),
            loader: /** @type {HTMLElement} */ getLoader(),
            closeButton: /** @type {HTMLElement} */ getCloseButton(),
            validationMessage: /** @type {HTMLElement} */ getValidationMessage(),
            progressSteps: /** @type {HTMLElement} */ getProgressSteps()
        };
        privateProps.domCache.set(instance, domCache);
        return domCache;
    };
    /**
   * @param {GlobalState} globalState
   * @param {SweetAlertOptions} innerParams
   * @param {(dismiss: DismissReason) => void} dismissWith
   */ const setupTimer = (globalState, innerParams, dismissWith)=>{
        const timerProgressBar = getTimerProgressBar();
        hide(timerProgressBar);
        if (innerParams.timer) {
            globalState.timeout = new Timer(()=>{
                dismissWith('timer');
                delete globalState.timeout;
            }, innerParams.timer);
            if (innerParams.timerProgressBar && timerProgressBar) {
                show(timerProgressBar);
                applyCustomClass(timerProgressBar, innerParams, 'timerProgressBar');
                setTimeout(()=>{
                    if (globalState.timeout && globalState.timeout.running) // timer can be already stopped or unset at this point
                    animateTimerProgressBar(/** @type {number} */ innerParams.timer);
                });
            }
        }
    };
    /**
   * Initialize focus in the popup:
   *
   * 1. If `toast` is `true`, don't steal focus from the document.
   * 2. Else if there is an [autofocus] element, focus it.
   * 3. Else if `focusConfirm` is `true` and confirm button is visible, focus it.
   * 4. Else if `focusDeny` is `true` and deny button is visible, focus it.
   * 5. Else if `focusCancel` is `true` and cancel button is visible, focus it.
   * 6. Else focus the first focusable element in a popup (if any).
   *
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   */ const initFocus = (domCache, innerParams)=>{
        if (innerParams.toast) return;
        // TODO: this is dumb, remove `allowEnterKey` param in the next major version
        if (!callIfFunction(innerParams.allowEnterKey)) {
            warnAboutDeprecation('allowEnterKey', 'preConfirm: () => false');
            domCache.popup.focus();
            return;
        }
        if (focusAutofocus(domCache)) return;
        if (focusButton(domCache, innerParams)) return;
        setFocus(-1, 1);
    };
    /**
   * @param {DomCache} domCache
   * @returns {boolean}
   */ const focusAutofocus = (domCache)=>{
        const autofocusElements = Array.from(domCache.popup.querySelectorAll('[autofocus]'));
        for (const autofocusElement of autofocusElements)if (autofocusElement instanceof HTMLElement && isVisible$1(autofocusElement)) {
            autofocusElement.focus();
            return true;
        }
        return false;
    };
    /**
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   * @returns {boolean}
   */ const focusButton = (domCache, innerParams)=>{
        if (innerParams.focusDeny && isVisible$1(domCache.denyButton)) {
            domCache.denyButton.focus();
            return true;
        }
        if (innerParams.focusCancel && isVisible$1(domCache.cancelButton)) {
            domCache.cancelButton.focus();
            return true;
        }
        if (innerParams.focusConfirm && isVisible$1(domCache.confirmButton)) {
            domCache.confirmButton.focus();
            return true;
        }
        return false;
    };
    // Assign instance methods from src/instanceMethods/*.js to prototype
    SweetAlert.prototype.disableButtons = disableButtons;
    SweetAlert.prototype.enableButtons = enableButtons;
    SweetAlert.prototype.getInput = getInput;
    SweetAlert.prototype.disableInput = disableInput;
    SweetAlert.prototype.enableInput = enableInput;
    SweetAlert.prototype.hideLoading = hideLoading;
    SweetAlert.prototype.disableLoading = hideLoading;
    SweetAlert.prototype.showValidationMessage = showValidationMessage;
    SweetAlert.prototype.resetValidationMessage = resetValidationMessage;
    SweetAlert.prototype.close = close;
    SweetAlert.prototype.closePopup = close;
    SweetAlert.prototype.closeModal = close;
    SweetAlert.prototype.closeToast = close;
    SweetAlert.prototype.rejectPromise = rejectPromise;
    SweetAlert.prototype.update = update;
    SweetAlert.prototype._destroy = _destroy;
    // Assign static methods from src/staticMethods/*.js to constructor
    Object.assign(SweetAlert, staticMethods);
    // Proxy to instance methods to constructor, for now, for backwards compatibility
    Object.keys(instanceMethods).forEach((key)=>{
        /**
     * @param {...(SweetAlertOptions | string | undefined)} args
     * @returns {SweetAlertResult | Promise<SweetAlertResult> | undefined}
     */ // @ts-ignore: Dynamic property assignment for backwards compatibility
        SweetAlert[key] = function(...args) {
            // @ts-ignore
            if (currentInstance && currentInstance[key]) // @ts-ignore
            return currentInstance[key](...args);
            return undefined;
        };
    });
    SweetAlert.DismissReason = DismissReason;
    SweetAlert.version = '11.26.25';
    const Swal = SweetAlert;
    // @ts-ignore
    Swal.default = Swal;
    return Swal;
});
if (typeof $99dc7a165646c27f$exports !== 'undefined' && $99dc7a165646c27f$exports.Sweetalert2) $99dc7a165646c27f$exports.swal = $99dc7a165646c27f$exports.sweetAlert = $99dc7a165646c27f$exports.Swal = $99dc7a165646c27f$exports.SweetAlert = $99dc7a165646c27f$exports.Sweetalert2;
"undefined" != typeof document && function(e, t) {
    var n = e.createElement("style");
    if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
    else try {
        n.innerHTML = t;
    } catch (e) {
        n.innerText = t;
    }
}(document, ":root{--swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-container-padding: 0.625em;--swal2-backdrop: rgba(0, 0, 0, 0.4);--swal2-backdrop-transition: background-color 0.15s;--swal2-width: 32em;--swal2-padding: 0 0 1.25em;--swal2-border: none;--swal2-border-radius: 0.3125rem;--swal2-background: white;--swal2-color: #545454;--swal2-show-animation: swal2-show 0.3s;--swal2-hide-animation: swal2-hide 0.15s forwards;--swal2-icon-zoom: 1;--swal2-title-padding: 0.8em 1em 0;--swal2-html-container-padding: 1em 1.6em 0.3em;--swal2-input-border: 1px solid #d9d9d9;--swal2-input-border-radius: 0.1875em;--swal2-input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-background: transparent;--swal2-input-transition: border-color 0.2s, box-shadow 0.2s;--swal2-input-hover-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-focus-border: 1px solid #b4dbed;--swal2-input-focus-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-progress-step-background: #add8e6;--swal2-validation-message-background: #f0f0f0;--swal2-validation-message-color: #666;--swal2-footer-border-color: #eee;--swal2-footer-background: transparent;--swal2-footer-color: inherit;--swal2-timer-progress-bar-background: rgba(0, 0, 0, 0.3);--swal2-close-button-position: initial;--swal2-close-button-inset: auto;--swal2-close-button-font-size: 2.5em;--swal2-close-button-color: #ccc;--swal2-close-button-transition: color 0.2s, box-shadow 0.2s;--swal2-close-button-outline: initial;--swal2-close-button-box-shadow: inset 0 0 0 3px transparent;--swal2-close-button-focus-box-shadow: inset var(--swal2-outline);--swal2-close-button-hover-transform: none;--swal2-actions-justify-content: center;--swal2-actions-width: auto;--swal2-actions-margin: 1.25em auto 0;--swal2-actions-padding: 0;--swal2-actions-border-radius: 0;--swal2-actions-background: transparent;--swal2-action-button-transition: background-color 0.2s, box-shadow 0.2s;--swal2-action-button-hover: black 10%;--swal2-action-button-active: black 10%;--swal2-confirm-button-box-shadow: none;--swal2-confirm-button-border-radius: 0.25em;--swal2-confirm-button-background-color: #7066e0;--swal2-confirm-button-color: #fff;--swal2-deny-button-box-shadow: none;--swal2-deny-button-border-radius: 0.25em;--swal2-deny-button-background-color: #dc3741;--swal2-deny-button-color: #fff;--swal2-cancel-button-box-shadow: none;--swal2-cancel-button-border-radius: 0.25em;--swal2-cancel-button-background-color: #6e7881;--swal2-cancel-button-color: #fff;--swal2-toast-show-animation: swal2-toast-show 0.5s;--swal2-toast-hide-animation: swal2-toast-hide 0.1s forwards;--swal2-toast-border: none;--swal2-toast-box-shadow: 0 0 1px hsl(0deg 0% 0% / 0.075), 0 1px 2px hsl(0deg 0% 0% / 0.075), 1px 2px 4px hsl(0deg 0% 0% / 0.075), 1px 3px 8px hsl(0deg 0% 0% / 0.075), 2px 4px 16px hsl(0deg 0% 0% / 0.075)}[data-swal2-theme=dark]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}@media(prefers-color-scheme: dark){[data-swal2-theme=auto]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:auto}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px var(--swal2-backdrop)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:\"top-start     top            top-end\" \"center-start  center         center-end\" \"bottom-start  bottom-center  bottom-end\";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:var(--swal2-container-padding);overflow-x:hidden;transition:var(--swal2-backdrop-transition);-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:var(--swal2-backdrop)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container)[popover]{width:auto;border:0}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:var(--swal2-width);max-width:100%;padding:var(--swal2-padding);border:var(--swal2-border);border-radius:var(--swal2-border-radius);background:var(--swal2-background);color:var(--swal2-color);font-family:inherit;font-size:1rem}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:var(--swal2-title-padding);color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;overflow-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:var(--swal2-actions-justify-content);width:var(--swal2-actions-width);margin:var(--swal2-actions-margin);padding:var(--swal2-actions-padding);border-radius:var(--swal2-actions-border-radius);background:var(--swal2-actions-background)}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:var(--swal2-action-button-transition);border:none;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border-radius:var(--swal2-confirm-button-border-radius);background:initial;background-color:var(--swal2-confirm-button-background-color);box-shadow:var(--swal2-confirm-button-box-shadow);color:var(--swal2-confirm-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):hover{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):active{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border-radius:var(--swal2-deny-button-border-radius);background:initial;background-color:var(--swal2-deny-button-background-color);box-shadow:var(--swal2-deny-button-box-shadow);color:var(--swal2-deny-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):hover{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):active{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border-radius:var(--swal2-cancel-button-border-radius);background:initial;background-color:var(--swal2-cancel-button-background-color);box-shadow:var(--swal2-cancel-button-box-shadow);color:var(--swal2-cancel-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):hover{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):active{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none;box-shadow:var(--swal2-action-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-styled)[disabled]:not(.swal2-loading){opacity:.4}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid var(--swal2-footer-border-color);background:var(--swal2-footer-background);color:var(--swal2-footer-color);font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:var(--swal2-border-radius);border-bottom-left-radius:var(--swal2-border-radius)}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:var(--swal2-timer-progress-bar-background)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){position:var(--swal2-close-button-position);inset:var(--swal2-close-button-inset);z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:var(--swal2-close-button-transition);border:none;border-radius:var(--swal2-border-radius);outline:var(--swal2-close-button-outline);background:rgba(0,0,0,0);color:var(--swal2-close-button-color);font-family:monospace;font-size:var(--swal2-close-button-font-size);cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:var(--swal2-close-button-hover-transform);background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:var(--swal2-close-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:var(--swal2-html-container-padding);overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;overflow-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:var(--swal2-input-transition);border:var(--swal2-input-border);border-radius:var(--swal2-input-border-radius);background:var(--swal2-input-background);box-shadow:var(--swal2-input-box-shadow);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):hover,div:where(.swal2-container) input:where(.swal2-file):hover,div:where(.swal2-container) textarea:where(.swal2-textarea):hover{box-shadow:var(--swal2-input-hover-box-shadow)}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:var(--swal2-input-focus-border);outline:none;box-shadow:var(--swal2-input-focus-box-shadow)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:var(--swal2-background)}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:var(--swal2-input-background);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:var(--swal2-input-background);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:var(--swal2-background);color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:var(--swal2-validation-message-background);color:var(--swal2-validation-message-color);font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:\"!\";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:var(--swal2-progress-step-background);color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:var(--swal2-progress-step-background)}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;zoom:var(--swal2-icon-zoom);border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:var(--swal2-show-animation)}.swal2-hide{animation:var(--swal2-hide-animation)}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;border:var(--swal2-toast-border);background:var(--swal2-background);box-shadow:var(--swal2-toast-box-shadow);pointer-events:auto}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}.swal2-toast.swal2-show{animation:var(--swal2-toast-show-animation)}.swal2-toast.swal2-hide{animation:var(--swal2-toast-hide-animation)}@keyframes swal2-show{0%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}100%{transform:translate3d(0, 0, 0) scale(1);opacity:1}}@keyframes swal2-hide{0%{transform:translate3d(0, 0, 0) scale(1);opacity:1}100%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}");


const $f5222ccf0af895eb$var$MATCHING_OPTIONS = [
    "Invoice Number",
    "PO Number",
    "GRN Number"
];
const $f5222ccf0af895eb$var$NARRATION_FIELDS = [
    {
        value: "invoice_no",
        label: "Invoice No"
    },
    {
        value: "vendor_name",
        label: "Vendor Name"
    },
    {
        value: "amount",
        label: "Amount"
    },
    {
        value: "date",
        label: "Date"
    },
    {
        value: "po_no",
        label: "PO No"
    }
];
const $f5222ccf0af895eb$var$DEFAULT_OPEN_SECTIONS = {
    posting: true,
    matching: false,
    reporting: false,
    unplanned: false,
    matchingLogic: false,
    uploadRights: false,
    companyPan: false,
    materialService: false
};
function $f5222ccf0af895eb$var$getCurrentFY() {
    const today = new Date();
    return today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
}
function $f5222ccf0af895eb$var$getFYOptions() {
    const currentFY = $f5222ccf0af895eb$var$getCurrentFY();
    return Array.from({
        length: 10
    }, (_, index)=>{
        const fy = currentFY - index;
        return {
            value: String(fy),
            label: `FY ${fy}-${String(fy + 1).slice(-2)}`
        };
    });
}
function $f5222ccf0af895eb$var$getMonthOptions(selectedFY) {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentFY = $f5222ccf0af895eb$var$getCurrentFY();
    const months = [
        [
            "April",
            "3"
        ],
        [
            "May",
            "4"
        ],
        [
            "June",
            "5"
        ],
        [
            "July",
            "6"
        ],
        [
            "August",
            "7"
        ],
        [
            "September",
            "8"
        ],
        [
            "October",
            "9"
        ],
        [
            "November",
            "10"
        ],
        [
            "December",
            "11"
        ],
        [
            "January",
            "0"
        ],
        [
            "February",
            "1"
        ],
        [
            "March",
            "2"
        ]
    ];
    return months.filter(([, index])=>{
        if (String(selectedFY) !== String(currentFY)) return true;
        const monthIndex = Number(index);
        return currentMonth >= 3 ? monthIndex <= currentMonth : monthIndex <= currentMonth || monthIndex >= 3;
    });
}
function $f5222ccf0af895eb$var$getCurrentFYMonthOptions() {
    const today = new Date();
    const currentMonth = today.getMonth();
    const months = [
        {
            name: "April",
            index: "3"
        },
        {
            name: "May",
            index: "4"
        },
        {
            name: "June",
            index: "5"
        },
        {
            name: "July",
            index: "6"
        },
        {
            name: "August",
            index: "7"
        },
        {
            name: "September",
            index: "8"
        },
        {
            name: "October",
            index: "9"
        },
        {
            name: "November",
            index: "10"
        },
        {
            name: "December",
            index: "11"
        },
        {
            name: "January",
            index: "0"
        },
        {
            name: "February",
            index: "1"
        },
        {
            name: "March",
            index: "2"
        }
    ];
    return months.filter((month)=>{
        const monthIndex = Number(month.index);
        if (currentMonth >= 3) return monthIndex >= 3 && monthIndex <= currentMonth;
        return monthIndex >= 3 || monthIndex <= currentMonth;
    });
}
function $f5222ccf0af895eb$var$createDefaultConfig() {
    const currentFY = String($f5222ccf0af895eb$var$getCurrentFY());
    const currentMonths = $f5222ccf0af895eb$var$getCurrentFYMonthOptions();
    const previousMonths = $f5222ccf0af895eb$var$getMonthOptions(currentFY);
    return {
        monthly_close: {
            monthly_close: "N",
            date_of_entry: "system",
            auto_on_date: "5",
            auto_or_manual: "automatic",
            manual_close: {
                PreviousYr: currentFY,
                PreviousYrMonth: previousMonths[0]?.[1] || "3",
                CurrentYrMonth: currentMonths[0]?.index || "3",
                scenario_same_month: "system",
                scenario_books_closed: "first_day",
                scenario_books_not_closed: "last_date"
            },
            auto_close: {
                scenario_same_month: "system",
                scenario_books_closed: "first_day",
                scenario_books_not_closed: "last_date"
            }
        },
        gst_input_expired: "31/10",
        tax_period_expired: "31/03",
        matching: {
            matching_type: "3way",
            matching_preference: {
                1: "Invoice Number",
                2: "GRN Number",
                3: "PO Number"
            }
        },
        currency: {
            reporting_currency_name: "",
            reporting_currency_code: "",
            exchange_rate_tolerance: ""
        },
        narration: {
            fields: [
                "invoice_no",
                "vendor_name",
                "date",
                "po_no"
            ],
            symbol: "!"
        },
        unplanned_cost: {
            add_to_material_service: "Y",
            processor: {
                threshold_amount: "1000",
                threshold_percent: "2",
                condition: "AND"
            },
            checker: {
                threshold_amount: "1000",
                threshold_percent: "2",
                condition: "AND"
            }
        },
        threshold: {
            turnover_above_threshold: "Y",
            threshold_amount: "5000000",
            wt_rate: "0.1"
        },
        service_entry_migo: {
            service_entry_migo: ""
        },
        matching_logic: {
            fuzzyratio: "50",
            sementicratio: "50",
            matching_tolerance: "80"
        },
        data_upload_rights: {
            uploader: false,
            processor: false,
            checker: false
        },
        companyPan: "",
        material_service_codes: {
            material: [],
            service: []
        },
        invoice_value_exception: {
            lower_limit: "10",
            upper_limit: "1000000"
        },
        address_matching_threshold: {
            fuzzyratio: "50",
            sementicratio: "50",
            matching_tolerance: "80"
        }
    };
}
function $f5222ccf0af895eb$var$mergeLoadedConfig(payload) {
    const next = $f5222ccf0af895eb$var$createDefaultConfig();
    if (!payload) return next;
    if (payload.monthly_close) next.monthly_close = {
        ...next.monthly_close,
        ...payload.monthly_close,
        manual_close: {
            ...next.monthly_close.manual_close,
            ...payload.monthly_close.manual_close || {}
        },
        auto_close: {
            ...next.monthly_close.auto_close,
            ...payload.monthly_close.auto_close || {}
        }
    };
    if (payload.gst_input_expired) next.gst_input_expired = payload.gst_input_expired;
    if (payload.tax_period_expired) next.tax_period_expired = payload.tax_period_expired;
    if (payload.matching) next.matching = {
        ...next.matching,
        ...payload.matching,
        matching_preference: {
            ...next.matching.matching_preference,
            ...payload.matching.matching_preference || {}
        }
    };
    if (payload.currency) next.currency = {
        ...next.currency,
        ...payload.currency
    };
    if (payload.narration) next.narration = {
        ...next.narration,
        ...payload.narration,
        fields: Array.isArray(payload.narration.fields) ? payload.narration.fields : []
    };
    if (payload.unplanned_cost) next.unplanned_cost = {
        ...next.unplanned_cost,
        ...payload.unplanned_cost,
        processor: {
            ...next.unplanned_cost.processor,
            ...payload.unplanned_cost.processor || {}
        },
        checker: {
            ...next.unplanned_cost.checker,
            ...payload.unplanned_cost.checker || {}
        }
    };
    if (payload.service_entry_migo) next.service_entry_migo = {
        ...next.service_entry_migo,
        ...payload.service_entry_migo
    };
    if (payload.matching_logic_ratio) next.matching_logic = {
        ...next.matching_logic,
        ...payload.matching_logic_ratio
    };
    if (payload.address_matching_threshold) next.address_matching_threshold = {
        ...next.address_matching_threshold,
        ...payload.address_matching_threshold
    };
    if (payload.data_upload_rights) next.data_upload_rights = {
        ...next.data_upload_rights,
        ...payload.data_upload_rights
    };
    if (typeof payload.pans === "string") next.companyPan = payload.pans;
    if (payload.material_service_codes) next.material_service_codes = {
        material: Array.isArray(payload.material_service_codes.material) ? payload.material_service_codes.material : [],
        service: Array.isArray(payload.material_service_codes.service) ? payload.material_service_codes.service : []
    };
    return next;
}
async function $f5222ccf0af895eb$var$parseJsonResponse(response) {
    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (contentType.includes("application/json")) return {
        isJson: true,
        payload: await response.json(),
        text: ""
    };
    return {
        isJson: false,
        payload: null,
        text: await response.text()
    };
}
function $f5222ccf0af895eb$var$normalizeNonJsonError(response, text, fallback) {
    const body = String(text || "");
    const lower = body.toLowerCase();
    const looksLikeHtml = lower.includes("<html") || lower.includes("<!doctype html");
    const looksLikeLogin = lower.includes("miro app login") || lower.includes("name=\"password\"");
    if (response.redirected || response.url.includes("next=") || looksLikeLogin) return "Session is not authenticated. Please login again.";
    if (looksLikeHtml) return fallback;
    return body || fallback;
}
function $f5222ccf0af895eb$var$Section({ title: title, subtitle: subtitle, open: open, onToggle: onToggle, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
        className: "config-card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                className: "config-card__head",
                type: "button",
                onClick: onToggle,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-card__title",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-card__subtitle",
                                children: subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "config-card__toggle",
                        children: open ? "Hide" : "Show"
                    })
                ]
            }),
            open ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-card__body",
                children: children
            }) : null
        ]
    });
}
function $f5222ccf0af895eb$var$RadioGroup({ name: name, value: value, options: options, onChange: onChange }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "config-inline",
        children: options.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                className: "config-choice",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "radio",
                        name: name,
                        value: option.value,
                        checked: value === option.value,
                        onChange: ()=>onChange(option.value)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: option.label
                    })
                ]
            }, option.value))
    });
}
function $f5222ccf0af895eb$export$2e2bcd8739ae039() {
    const [config, setConfig] = (0, $acw62.useState)($f5222ccf0af895eb$var$createDefaultConfig);
    const [openSections, setOpenSections] = (0, $acw62.useState)($f5222ccf0af895eb$var$DEFAULT_OPEN_SECTIONS);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const fyOptions = (0, $acw62.useMemo)(()=>$f5222ccf0af895eb$var$getFYOptions(), []);
    const previousYearMonthOptions = (0, $acw62.useMemo)(()=>$f5222ccf0af895eb$var$getMonthOptions(config.monthly_close.manual_close.PreviousYr), [
        config.monthly_close.manual_close.PreviousYr
    ]);
    const currentFyMonthOptions = (0, $acw62.useMemo)(()=>$f5222ccf0af895eb$var$getCurrentFYMonthOptions(), []);
    const preference1 = config.matching.matching_preference[1];
    const preference2Choices = $f5222ccf0af895eb$var$MATCHING_OPTIONS.filter((item)=>item !== preference1);
    const preference2 = preference2Choices.includes(config.matching.matching_preference[2]) ? config.matching.matching_preference[2] : preference2Choices[0];
    const preference3 = $f5222ccf0af895eb$var$MATCHING_OPTIONS.find((item)=>item !== preference1 && item !== preference2);
    (0, $acw62.useEffect)(()=>{
        setConfig((current)=>({
                ...current,
                matching: {
                    ...current.matching,
                    matching_preference: {
                        1: preference1,
                        2: preference2,
                        3: preference3
                    }
                }
            }));
    }, [
        preference1,
        preference2,
        preference3
    ]);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        async function loadConfiguration() {
            setLoading(true);
            setError("");
            try {
                const response = await fetch("/api/configuration/", {
                    credentials: "include",
                    headers: {
                        Accept: "application/json"
                    }
                });
                const { isJson: isJson, payload: payload, text: text } = await $f5222ccf0af895eb$var$parseJsonResponse(response);
                if (!isJson) throw new Error($f5222ccf0af895eb$var$normalizeNonJsonError(response, text, "Unable to load saved configuration."));
                if (!cancelled) {
                    if (payload.status === "success") setConfig($f5222ccf0af895eb$var$mergeLoadedConfig(payload.data));
                    setStatus("");
                }
            } catch (requestError) {
                if (!cancelled) setError(requestError.message || "Unable to load saved configuration.");
            } finally{
                if (!cancelled) setLoading(false);
            }
        }
        loadConfiguration();
        return ()=>{
            cancelled = true;
        };
    }, []);
    function toggleSection(sectionKey) {
        setOpenSections((current)=>({
                ...current,
                [sectionKey]: !current[sectionKey]
            }));
    }
    function updateTopLevel(key, value) {
        setConfig((current)=>({
                ...current,
                [key]: value
            }));
    }
    function updateSection(sectionKey, field, value) {
        setConfig((current)=>({
                ...current,
                [sectionKey]: {
                    ...current[sectionKey],
                    [field]: value
                }
            }));
    }
    function updateNested(sectionKey, nestedKey, field, value) {
        setConfig((current)=>({
                ...current,
                [sectionKey]: {
                    ...current[sectionKey],
                    [nestedKey]: {
                        ...current[sectionKey][nestedKey],
                        [field]: value
                    }
                }
            }));
    }
    function handleNarrationFieldToggle(value) {
        setConfig((current)=>{
            const alreadySelected = current.narration.fields.includes(value);
            return {
                ...current,
                narration: {
                    ...current.narration,
                    fields: alreadySelected ? current.narration.fields.filter((item)=>item !== value) : [
                        ...current.narration.fields,
                        value
                    ]
                }
            };
        });
    }
    function buildPayload() {
        return {
            monthly_close: config.monthly_close,
            baseline: config.baseline,
            blocking: config.blocking,
            matching: {
                ...config.matching,
                matching_preference: {
                    1: preference1,
                    2: preference2,
                    3: preference3
                }
            },
            currency: config.currency,
            narration: config.narration,
            duplicate_check: config.duplicate_check,
            unplanned_cost: config.unplanned_cost,
            threshold: config.threshold,
            service_entry_migo: config.service_entry_migo,
            matching_logic: config.matching_logic,
            address_matching_threshold: config.address_matching_threshold,
            data_upload_rights: config.data_upload_rights,
            companyPan: config.companyPan.trim().toUpperCase(),
            material_service_codes: {
                material: config.material_service_codes.material,
                service: config.material_service_codes.service
            },
            blocking_activate: config.blocking_activate,
            gst_input_expired: config.gst_input_expired,
            tax_period_expired: config.tax_period_expired,
            invoice_value_exception: {
                lower_limit: config.invoice_value_exception?.lower_limit ?? "",
                upper_limit: config.invoice_value_exception?.upper_limit ?? ""
            }
        };
    }
    async function handleSave() {
        setSaving(true);
        const pan = config.companyPan?.trim().toUpperCase();
        if (!pan || !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(pan)) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "warning",
                title: "Invalid PAN",
                text: "Please enter a valid Company PAN."
            });
            return;
        }
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const formData = new FormData();
            formData.append("payload", JSON.stringify(buildPayload()));
            const response = await fetch("/api/configuration/save/", {
                method: "POST",
                headers: {
                    "X-CSRFToken": csrfToken,
                    Accept: "application/json"
                },
                credentials: "include",
                body: formData
            });
            const { isJson: isJson, payload: payload, text: text } = await $f5222ccf0af895eb$var$parseJsonResponse(response);
            if (!isJson) throw new Error($f5222ccf0af895eb$var$normalizeNonJsonError(response, text, "Unable to save configuration."));
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || "Unable to save configuration.");
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: payload.message || "Configuration saved successfully.",
                confirmButtonText: "OK"
            });
        } catch (requestError) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: requestError.message || "Unable to save configuration.",
                confirmButtonText: "OK"
            });
        } finally{
            setSaving(false);
        }
    }
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "workspace-panel",
        children: "Loading configuration\u2026"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "config-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "config-view__header workspace-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "Basic Configurations"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "Accounting Configuration"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-view__intro",
                                children: "PO Invoice: Configure accounting rules and validations for Purchase Order-based invoices, including matching, verification, and transaction posting."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "primary-button",
                        type: "button",
                        onClick: handleSave,
                        disabled: saving,
                        children: saving ? "Saving..." : "Submit Configuration"
                    })
                ]
            }),
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($f5222ccf0af895eb$var$Section, {
                title: "1. Posting Date",
                subtitle: "Monthly close and posting date rules",
                open: openSections.posting,
                onToggle: ()=>toggleSection("posting"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-grid",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Keep provision of monthly close of WFS?"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f5222ccf0af895eb$var$RadioGroup, {
                                        name: "monthly_close",
                                        value: config.monthly_close.monthly_close,
                                        options: [
                                            {
                                                value: "N",
                                                label: "No"
                                            },
                                            {
                                                value: "Y",
                                                label: "Yes"
                                            }
                                        ],
                                        onChange: (value)=>updateSection("monthly_close", "monthly_close", value)
                                    })
                                ]
                            }),
                            config.monthly_close.monthly_close === "N" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "If No, Date of Entry"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: config.monthly_close.date_of_entry,
                                        onChange: (event)=>updateSection("monthly_close", "date_of_entry", event.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "system",
                                                children: "System Date"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "invoice",
                                                children: "Invoice Date"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "migo",
                                                children: "MIGO Date"
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "If Yes, Automatic or Manual?"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: config.monthly_close.auto_or_manual,
                                        onChange: (event)=>updateSection("monthly_close", "auto_or_manual", event.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "automatic",
                                                children: "Automatic"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "manual",
                                                children: "Manual"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    config.monthly_close.monthly_close === "Y" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            config.monthly_close.auto_or_manual === "automatic" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-grid",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "config-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Automatic on"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "number",
                                            min: "1",
                                            max: "28",
                                            value: config.monthly_close.auto_on_date,
                                            onChange: (event)=>updateSection("monthly_close", "auto_on_date", event.target.value),
                                            placeholder: "day of month"
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-grid",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "config-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Select Previous Year"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                value: config.monthly_close.manual_close.PreviousYr,
                                                onChange: (event)=>{
                                                    updateNested("monthly_close", "manual_close", "PreviousYrMonth", event.target.value);
                                                },
                                                children: fyOptions.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: option.value,
                                                        children: option.label
                                                    }, option.value))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "config-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Select Previous Year Month"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                value: config.monthly_close.manual_close.PreviousYrMonth ?? "",
                                                onChange: (event)=>updateNested("monthly_close", "manual_close", "PreviousYrMonth", event.target.value),
                                                children: previousYearMonthOptions.map(([name, value])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: value,
                                                        children: name
                                                    }, value))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "config-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Select Current Year Month"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                value: config.monthly_close.manual_close.CurrentYrMonth ?? "",
                                                onChange: (event)=>updateNested("monthly_close", "manual_close", "CurrentYrMonth", event.target.value),
                                                children: currentFyMonthOptions.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: option.index,
                                                        children: option.name
                                                    }, option.index))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-grid",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "config-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "IF month(invoice) = month(entry)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: config.monthly_close.auto_or_manual === "manual" ? config.monthly_close.manual_close.scenario_same_month : config.monthly_close.auto_close.scenario_same_month,
                                                onChange: (event)=>updateNested("monthly_close", config.monthly_close.auto_or_manual === "manual" ? "manual_close" : "auto_close", "scenario_same_month", event.target.value),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "system",
                                                        children: "System Date"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "invoice",
                                                        children: "Invoice Date"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "migo",
                                                        children: "MIGO Date"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "config-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "IF month(invoice) != month(entry), books closed"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: config.monthly_close.auto_or_manual === "manual" ? config.monthly_close.manual_close.scenario_books_closed : config.monthly_close.auto_close.scenario_books_closed,
                                                onChange: (event)=>updateNested("monthly_close", config.monthly_close.auto_or_manual === "manual" ? "manual_close" : "auto_close", "scenario_books_closed", event.target.value),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "system",
                                                        children: "System Date"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "first_day",
                                                        children: "First Day of Month"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "block_entry",
                                                        children: "Block The Entry"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "config-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "IF month(invoice) != month(entry), books not closed"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: config.monthly_close.auto_or_manual === "manual" ? config.monthly_close.manual_close.scenario_books_not_closed : config.monthly_close.auto_close.scenario_books_not_closed,
                                                onChange: (event)=>updateNested("monthly_close", config.monthly_close.auto_or_manual === "manual" ? "manual_close" : "auto_close", "scenario_books_not_closed", event.target.value),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "last_date",
                                                        children: "Last date of invoice month"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "system",
                                                        children: "System Date"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "invoice",
                                                        children: "Invoice Date"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "migo",
                                                        children: "MIGO Date"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($f5222ccf0af895eb$var$Section, {
                title: "2. Matching Type",
                subtitle: "Choose 2-way or 3-way invoice verification",
                open: openSections.matching,
                onToggle: ()=>toggleSection("matching"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-grid",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "config-field",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    children: "Matching Type"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f5222ccf0af895eb$var$RadioGroup, {
                                    name: "matching_type",
                                    value: config.matching.matching_type,
                                    options: [
                                        {
                                            value: "3way",
                                            label: "3-way"
                                        },
                                        {
                                            value: "2way",
                                            label: "2-way"
                                        }
                                    ],
                                    onChange: (value)=>updateSection("matching", "matching_type", value)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-grid",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Preference 1"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: preference1,
                                        onChange: (event)=>updateSection("matching", "matching_preference", {
                                                ...config.matching.matching_preference,
                                                1: event.target.value
                                            }),
                                        children: $f5222ccf0af895eb$var$MATCHING_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: option,
                                                children: option
                                            }, option))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Preference 2"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: preference2,
                                        onChange: (event)=>updateSection("matching", "matching_preference", {
                                                ...config.matching.matching_preference,
                                                2: event.target.value
                                            }),
                                        children: preference2Choices.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: option,
                                                children: option
                                            }, option))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Preference 3"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: preference3,
                                        readOnly: true
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f5222ccf0af895eb$var$Section, {
                title: "3. Reporting Currency",
                subtitle: "Currently under development for import invoices",
                open: openSections.reporting,
                onToggle: ()=>toggleSection("reporting"),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: "Reporting currency handling is still under development in the original Django template, so this React version keeps the same placeholder behavior."
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($f5222ccf0af895eb$var$Section, {
                title: "4. Narration String",
                subtitle: "Narration composition",
                open: openSections.narration,
                onToggle: ()=>toggleSection("narration"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-field",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                children: "Narration fields"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-check-grid",
                                children: $f5222ccf0af895eb$var$NARRATION_FIELDS.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "config-check",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                checked: config.narration.fields.includes(field.value),
                                                onChange: ()=>handleNarrationFieldToggle(field.value)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: field.label
                                            })
                                        ]
                                    }, field.value))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-field",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                children: "Delimiter / symbol"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                value: config.narration.symbol,
                                onChange: (event)=>updateSection("narration", "symbol", event.target.value),
                                children: [
                                    "!",
                                    "@",
                                    "#",
                                    "$",
                                    "%",
                                    "^",
                                    "&",
                                    "*"
                                ].map((symbol)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: symbol,
                                        children: symbol
                                    }, symbol))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($f5222ccf0af895eb$var$Section, {
                title: "5. Unplanned Cost",
                subtitle: "Handle costs not considered at PO stage",
                open: openSections.unplanned,
                onToggle: ()=>toggleSection("unplanned"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-field",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                children: "Add unplanned cost to Material / Service?"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f5222ccf0af895eb$var$RadioGroup, {
                                name: "add_to_material_service",
                                value: config.unplanned_cost.add_to_material_service,
                                options: [
                                    {
                                        value: "Y",
                                        label: "Yes"
                                    },
                                    {
                                        value: "N",
                                        label: "No"
                                    }
                                ],
                                onChange: (value)=>updateSection("unplanned_cost", "add_to_material_service", value)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-note",
                                children: config.unplanned_cost.add_to_material_service === "Y" ? "Same GL code will be used for Unallocated Cost which is already used for other items." : "User must select a GL code from dropdown while submitting Unallocated Cost."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-grid",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-rule",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        children: "Processor Rule"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "number",
                                        value: config.unplanned_cost.processor.threshold_amount,
                                        onChange: (event)=>updateNested("unplanned_cost", "processor", "threshold_amount", event.target.value),
                                        placeholder: "Amount limit"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: config.unplanned_cost.processor.condition,
                                        onChange: (event)=>updateNested("unplanned_cost", "processor", "condition", event.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "AND",
                                                children: "AND"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "OR",
                                                children: "OR"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "number",
                                        min: "0",
                                        max: "99",
                                        value: config.unplanned_cost.processor.threshold_percent,
                                        onChange: (event)=>updateNested("unplanned_cost", "processor", "threshold_percent", event.target.value),
                                        placeholder: "Percentage limit"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-rule",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        children: "Checker Rule"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "number",
                                        value: config.unplanned_cost.checker.threshold_amount,
                                        onChange: (event)=>updateNested("unplanned_cost", "checker", "threshold_amount", event.target.value),
                                        placeholder: "Amount limit"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: config.unplanned_cost.checker.condition,
                                        onChange: (event)=>updateNested("unplanned_cost", "checker", "condition", event.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "AND",
                                                children: "AND"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "OR",
                                                children: "OR"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "number",
                                        min: "0",
                                        max: "99",
                                        value: config.unplanned_cost.checker.threshold_percent,
                                        onChange: (event)=>updateNested("unplanned_cost", "checker", "threshold_percent", event.target.value),
                                        placeholder: "Percentage limit"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($f5222ccf0af895eb$var$Section, {
                title: "6. Matching Logic",
                subtitle: "Matching tolerances",
                open: openSections.matchingLogic,
                onToggle: ()=>toggleSection("matchingLogic"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        style: {
                            marginBottom: "10px"
                        },
                        children: "a. 2/3 Way Match Ratio"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-grid",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Fuzzy Ratio"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: config.matching_logic.fuzzyratio,
                                        onChange: (event)=>updateSection("matching_logic", "fuzzyratio", event.target.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Sementic Ratio"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: config.matching_logic.sementicratio,
                                        onChange: (event)=>updateSection("matching_logic", "sementicratio", event.target.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Matching Tolerance %"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: config.matching_logic.matching_tolerance,
                                        onChange: (event)=>updateSection("matching_logic", "matching_tolerance", event.target.value)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        style: {
                            margin: "24px 0 10px"
                        },
                        children: "b. Address Matching Ratio"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-grid",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Fuzzy Ratio"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: config.address_matching_threshold.fuzzyratio,
                                        onChange: (event)=>updateSection("address_matching_threshold", "fuzzyratio", event.target.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Sementic Ratio"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: config.address_matching_threshold.sementicratio,
                                        onChange: (event)=>updateSection("address_matching_threshold", "sementicratio", event.target.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Matching Tolerance %"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: config.address_matching_threshold.matching_tolerance,
                                        onChange: (event)=>updateSection("address_matching_threshold", "matching_tolerance", event.target.value)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


const $29801a9c2c8d5f6b$var$MATCHING_OPTIONS = [
    "Invoice Number",
    "PO Number",
    "GRN Number"
];
const $29801a9c2c8d5f6b$var$NARRATION_FIELDS = [
    {
        value: "invoice_no",
        label: "Invoice No"
    },
    {
        value: "vendor_name",
        label: "Vendor Name"
    },
    {
        value: "amount",
        label: "Amount"
    },
    {
        value: "date",
        label: "Date"
    },
    {
        value: "po_no",
        label: "PO No"
    }
];
const $29801a9c2c8d5f6b$var$BLOCKING_ROWS = [
    {
        key: "pan_inactive",
        label: "Vendor PAN Inactive"
    },
    {
        key: "aadhar_pan",
        label: "Vendor Aadhar & PAN linked (Individual & Proprietor)"
    },
    {
        key: "gst_inactive",
        label: "GST Inactive"
    },
    {
        key: "gstr1",
        label: "GSTR1 not Filed",
        hasMonths: true
    },
    {
        key: "gstr3b",
        label: "GSTR3B Filed (not filed flag)",
        hasMonths: true
    },
    {
        key: "gst_2b",
        label: "GST not appearing in 2B (13 days rule)",
        note: "Under Development"
    },
    {
        key: "new_vendor",
        label: "New Vendor / Irregular Transactions"
    },
    {
        key: "regular_vendor",
        label: "Regular Vendor"
    },
    {
        key: "prev_gst",
        label: "Previous invoice GST not appearing"
    }
];
const $29801a9c2c8d5f6b$var$DEFAULT_OPEN_SECTIONS = {
    posting: true,
    reporting: false,
    narration: false
};
function $29801a9c2c8d5f6b$var$getCurrentFY() {
    const today = new Date();
    return today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
}
function $29801a9c2c8d5f6b$var$getFYOptions() {
    const currentFY = $29801a9c2c8d5f6b$var$getCurrentFY();
    return Array.from({
        length: 10
    }, (_, index)=>{
        const fy = currentFY - index;
        return {
            value: String(fy),
            label: `FY ${fy}-${String(fy + 1).slice(-2)}`
        };
    });
}
function $29801a9c2c8d5f6b$var$getMonthOptions(selectedFY) {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentFY = $29801a9c2c8d5f6b$var$getCurrentFY();
    const months = [
        [
            "April",
            "3"
        ],
        [
            "May",
            "4"
        ],
        [
            "June",
            "5"
        ],
        [
            "July",
            "6"
        ],
        [
            "August",
            "7"
        ],
        [
            "September",
            "8"
        ],
        [
            "October",
            "9"
        ],
        [
            "November",
            "10"
        ],
        [
            "December",
            "11"
        ],
        [
            "January",
            "0"
        ],
        [
            "February",
            "1"
        ],
        [
            "March",
            "2"
        ]
    ];
    return months.filter(([, index])=>{
        if (String(selectedFY) !== String(currentFY)) return true;
        const monthIndex = Number(index);
        return currentMonth >= 3 ? monthIndex <= currentMonth : monthIndex <= currentMonth || monthIndex >= 3;
    });
}
function $29801a9c2c8d5f6b$var$getCurrentFYMonthOptions() {
    const today = new Date();
    const currentMonth = today.getMonth();
    const months = [
        {
            name: "April",
            index: "3"
        },
        {
            name: "May",
            index: "4"
        },
        {
            name: "June",
            index: "5"
        },
        {
            name: "July",
            index: "6"
        },
        {
            name: "August",
            index: "7"
        },
        {
            name: "September",
            index: "8"
        },
        {
            name: "October",
            index: "9"
        },
        {
            name: "November",
            index: "10"
        },
        {
            name: "December",
            index: "11"
        },
        {
            name: "January",
            index: "0"
        },
        {
            name: "February",
            index: "1"
        },
        {
            name: "March",
            index: "2"
        }
    ];
    return months.filter((month)=>{
        const monthIndex = Number(month.index);
        if (currentMonth >= 3) return monthIndex >= 3 && monthIndex <= currentMonth;
        return monthIndex >= 3 || monthIndex <= currentMonth;
    });
}
function $29801a9c2c8d5f6b$var$createDefaultConfig() {
    const currentFY = String($29801a9c2c8d5f6b$var$getCurrentFY());
    const currentMonths = $29801a9c2c8d5f6b$var$getCurrentFYMonthOptions();
    const previousMonths = $29801a9c2c8d5f6b$var$getMonthOptions(currentFY);
    const blocking = $29801a9c2c8d5f6b$var$BLOCKING_ROWS.reduce((accumulator, row)=>{
        accumulator[row.key] = {
            acc: row.key === "gst_inactive" ? "Y" : "N",
            pay: row.key === "regular_vendor" ? "N" : "Y",
            months: "",
            code: ""
        };
        return accumulator;
    }, {});
    return {
        monthly_close: {
            monthly_close: "N",
            date_of_entry: "system",
            auto_on_date: "5",
            auto_or_manual: "automatic",
            manual_close: {
                PreviousYr: currentFY,
                PreviousYrMonth: previousMonths[0]?.[1] || "3",
                CurrentYrMonth: currentMonths[0]?.index || "3",
                scenario_same_month: "system",
                scenario_books_closed: "first_day",
                scenario_books_not_closed: "last_date"
            },
            auto_close: {
                scenario_same_month: "system",
                scenario_books_closed: "first_day",
                scenario_books_not_closed: "last_date"
            }
        },
        currency: {
            reporting_currency_name: "",
            reporting_currency_code: "",
            exchange_rate_tolerance: ""
        },
        narration: {
            fields: [
                "invoice_no",
                "vendor_name",
                "date",
                "po_no"
            ],
            symbol: "!"
        }
    };
}
function $29801a9c2c8d5f6b$var$mergeLoadedConfig(payload) {
    const next = $29801a9c2c8d5f6b$var$createDefaultConfig();
    if (!payload) return next;
    if (payload.monthly_close) next.monthly_close = {
        ...next.monthly_close,
        ...payload.monthly_close,
        manual_close: {
            ...next.monthly_close.manual_close,
            ...payload.monthly_close.manual_close || {}
        },
        auto_close: {
            ...next.monthly_close.auto_close,
            ...payload.monthly_close.auto_close || {}
        }
    };
    if (payload.currency) next.currency = {
        ...next.currency,
        ...payload.currency
    };
    if (payload.narration) next.narration = {
        ...next.narration,
        ...payload.narration,
        fields: Array.isArray(payload.narration.fields) ? payload.narration.fields : []
    };
    return next;
}
async function $29801a9c2c8d5f6b$var$parseJsonResponse(response) {
    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (contentType.includes("application/json")) return {
        isJson: true,
        payload: await response.json(),
        text: ""
    };
    return {
        isJson: false,
        payload: null,
        text: await response.text()
    };
}
function $29801a9c2c8d5f6b$var$normalizeNonJsonError(response, text, fallback) {
    const body = String(text || "");
    const lower = body.toLowerCase();
    const looksLikeHtml = lower.includes("<html") || lower.includes("<!doctype html");
    const looksLikeLogin = lower.includes("miro app login") || lower.includes("name=\"password\"");
    if (response.redirected || response.url.includes("next=") || looksLikeLogin) return "Session is not authenticated. Please login again.";
    if (looksLikeHtml) return fallback;
    return body || fallback;
}
function $29801a9c2c8d5f6b$var$Section({ title: title, subtitle: subtitle, open: open, onToggle: onToggle, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
        className: "config-card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                className: "config-card__head",
                type: "button",
                onClick: onToggle,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-card__title",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-card__subtitle",
                                children: subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "config-card__toggle",
                        children: open ? "Hide" : "Show"
                    })
                ]
            }),
            open ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-card__body",
                children: children
            }) : null
        ]
    });
}
function $29801a9c2c8d5f6b$var$RadioGroup({ name: name, value: value, options: options, onChange: onChange }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "config-inline",
        children: options.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                className: "config-choice",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "radio",
                        name: name,
                        value: option.value,
                        checked: value === option.value,
                        onChange: ()=>onChange(option.value)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: option.label
                    })
                ]
            }, option.value))
    });
}
function $29801a9c2c8d5f6b$export$2e2bcd8739ae039() {
    const [config, setConfig] = (0, $acw62.useState)($29801a9c2c8d5f6b$var$createDefaultConfig);
    const [openSections, setOpenSections] = (0, $acw62.useState)($29801a9c2c8d5f6b$var$DEFAULT_OPEN_SECTIONS);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const fyOptions = (0, $acw62.useMemo)(()=>$29801a9c2c8d5f6b$var$getFYOptions(), []);
    const previousYearMonthOptions = (0, $acw62.useMemo)(()=>$29801a9c2c8d5f6b$var$getMonthOptions(config.monthly_close.manual_close.PreviousYr), [
        config.monthly_close.manual_close.PreviousYr
    ]);
    const currentFyMonthOptions = (0, $acw62.useMemo)(()=>$29801a9c2c8d5f6b$var$getCurrentFYMonthOptions(), []);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        async function loadConfiguration() {
            setLoading(true);
            setError("");
            try {
                const response = await fetch("/api/configuration/", {
                    credentials: "include",
                    headers: {
                        Accept: "application/json"
                    }
                });
                const { isJson: isJson, payload: payload, text: text } = await $29801a9c2c8d5f6b$var$parseJsonResponse(response);
                if (!isJson) throw new Error($29801a9c2c8d5f6b$var$normalizeNonJsonError(response, text, "Unable to load saved configuration."));
                if (!cancelled) {
                    if (payload.status === "success") setConfig($29801a9c2c8d5f6b$var$mergeLoadedConfig(payload.data));
                    setStatus("");
                }
            } catch (requestError) {
                if (!cancelled) setError(requestError.message || "Unable to load saved configuration.");
            } finally{
                if (!cancelled) setLoading(false);
            }
        }
        loadConfiguration();
        return ()=>{
            cancelled = true;
        };
    }, []);
    function toggleSection(sectionKey) {
        setOpenSections((current)=>({
                ...current,
                [sectionKey]: !current[sectionKey]
            }));
    }
    function updateTopLevel(key, value) {
        setConfig((current)=>({
                ...current,
                [key]: value
            }));
    }
    function updateSection(sectionKey, field, value) {
        setConfig((current)=>({
                ...current,
                [sectionKey]: {
                    ...current[sectionKey],
                    [field]: value
                }
            }));
    }
    function updateNested(sectionKey, nestedKey, field, value) {
        setConfig((current)=>({
                ...current,
                [sectionKey]: {
                    ...current[sectionKey],
                    [nestedKey]: {
                        ...current[sectionKey][nestedKey],
                        [field]: value
                    }
                }
            }));
    }
    function updateBlocking(rowKey, field, value) {
        setConfig((current)=>({
                ...current,
                blocking: {
                    ...current.blocking,
                    [rowKey]: {
                        ...current.blocking[rowKey],
                        [field]: value
                    }
                }
            }));
    }
    function handleNarrationFieldToggle(value) {
        setConfig((current)=>{
            const alreadySelected = current.narration.fields.includes(value);
            return {
                ...current,
                narration: {
                    ...current.narration,
                    fields: alreadySelected ? current.narration.fields.filter((item)=>item !== value) : [
                        ...current.narration.fields,
                        value
                    ]
                }
            };
        });
    }
    function buildPayload() {
        return {
            monthly_close: config.monthly_close,
            currency: config.currency,
            narration: config.narration
        };
    }
    async function handleSave() {
        setSaving(true);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const formData = new FormData();
            formData.append("payload", JSON.stringify(buildPayload()));
            const response = await fetch("/api/configuration-nonpo/save/", {
                method: "POST",
                headers: {
                    "X-CSRFToken": csrfToken,
                    Accept: "application/json"
                },
                credentials: "include",
                body: formData
            });
            const { isJson: isJson, payload: payload, text: text } = await $29801a9c2c8d5f6b$var$parseJsonResponse(response);
            if (!isJson) throw new Error($29801a9c2c8d5f6b$var$normalizeNonJsonError(response, text, "Unable to save configuration."));
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || "Unable to save configuration.");
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: payload.message || "Configuration saved successfully.",
                confirmButtonText: "OK"
            });
        } catch (requestError) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: requestError.message || "Unable to save configuration.",
                confirmButtonText: "OK"
            });
        } finally{
            setSaving(false);
        }
    }
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "workspace-panel",
        children: "Loading configuration\u2026"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "config-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "config-view__header workspace-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "Basic Configurations"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "Accounting Configuration"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-view__intro",
                                children: "Non-PO Invoice: Configure accounting rules and validations for invoices without a Purchase Order, including verification, approval, and transaction posting."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "primary-button",
                        type: "button",
                        onClick: handleSave,
                        disabled: saving,
                        children: saving ? "Saving..." : "Submit Configuration"
                    })
                ]
            }),
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($29801a9c2c8d5f6b$var$Section, {
                title: "1. Posting Date",
                subtitle: "Monthly close and posting date rules",
                open: openSections.posting,
                onToggle: ()=>toggleSection("posting"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-grid",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Keep provision of monthly close of WFS?"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($29801a9c2c8d5f6b$var$RadioGroup, {
                                        name: "monthly_close",
                                        value: config.monthly_close.monthly_close,
                                        options: [
                                            {
                                                value: "N",
                                                label: "No"
                                            },
                                            {
                                                value: "Y",
                                                label: "Yes"
                                            }
                                        ],
                                        onChange: (value)=>updateSection("monthly_close", "monthly_close", value)
                                    })
                                ]
                            }),
                            config.monthly_close.monthly_close === "N" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "If No, Date of Entry"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: config.monthly_close.date_of_entry,
                                        onChange: (event)=>updateSection("monthly_close", "date_of_entry", event.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "system",
                                                children: "System Date"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "invoice",
                                                children: "Invoice Date"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "migo",
                                                children: "MIGO Date"
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "If Yes, Automatic or Manual?"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: config.monthly_close.auto_or_manual,
                                        onChange: (event)=>updateSection("monthly_close", "auto_or_manual", event.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "automatic",
                                                children: "Automatic"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "manual",
                                                children: "Manual"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    config.monthly_close.monthly_close === "Y" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            config.monthly_close.auto_or_manual === "automatic" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-grid",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "config-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Automatic on"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "number",
                                            min: "1",
                                            max: "28",
                                            value: config.monthly_close.auto_on_date,
                                            onChange: (event)=>updateSection("monthly_close", "auto_on_date", event.target.value),
                                            placeholder: "day of month"
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-grid",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "config-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Select Previous Year"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                value: config.monthly_close.manual_close.PreviousYr,
                                                onChange: (event)=>{
                                                    updateNested("monthly_close", "manual_close", "PreviousYrMonth", event.target.value);
                                                },
                                                children: fyOptions.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: option.value,
                                                        children: option.label
                                                    }, option.value))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "config-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Select Previous Year Month"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                value: config.monthly_close.manual_close.PreviousYrMonth ?? "",
                                                onChange: (event)=>updateNested("monthly_close", "manual_close", "PreviousYrMonth", event.target.value),
                                                children: previousYearMonthOptions.map(([name, value])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: value,
                                                        children: name
                                                    }, value))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "config-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Select Current Year Month"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                value: config.monthly_close.manual_close.CurrentYrMonth ?? "",
                                                onChange: (event)=>updateNested("monthly_close", "manual_close", "CurrentYrMonth", event.target.value),
                                                children: currentFyMonthOptions.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: option.index,
                                                        children: option.name
                                                    }, option.index))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-grid",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "config-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "IF month(invoice) = month(entry)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: config.monthly_close.auto_or_manual === "manual" ? config.monthly_close.manual_close.scenario_same_month : config.monthly_close.auto_close.scenario_same_month,
                                                onChange: (event)=>updateNested("monthly_close", config.monthly_close.auto_or_manual === "manual" ? "manual_close" : "auto_close", "scenario_same_month", event.target.value),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "system",
                                                        children: "System Date"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "invoice",
                                                        children: "Invoice Date"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "migo",
                                                        children: "MIGO Date"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "config-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "IF month(invoice) != month(entry), books closed"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: config.monthly_close.auto_or_manual === "manual" ? config.monthly_close.manual_close.scenario_books_closed : config.monthly_close.auto_close.scenario_books_closed,
                                                onChange: (event)=>updateNested("monthly_close", config.monthly_close.auto_or_manual === "manual" ? "manual_close" : "auto_close", "scenario_books_closed", event.target.value),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "system",
                                                        children: "System Date"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "first_day",
                                                        children: "First Day of Month"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "block_entry",
                                                        children: "Block The Entry"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "config-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "IF month(invoice) != month(entry), books not closed"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: config.monthly_close.auto_or_manual === "manual" ? config.monthly_close.manual_close.scenario_books_not_closed : config.monthly_close.auto_close.scenario_books_not_closed,
                                                onChange: (event)=>updateNested("monthly_close", config.monthly_close.auto_or_manual === "manual" ? "manual_close" : "auto_close", "scenario_books_not_closed", event.target.value),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "last_date",
                                                        children: "Last date of invoice month"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "system",
                                                        children: "System Date"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "invoice",
                                                        children: "Invoice Date"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "migo",
                                                        children: "MIGO Date"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($29801a9c2c8d5f6b$var$Section, {
                title: "5. Reporting Currency",
                subtitle: "Currently under development for import invoices",
                open: openSections.reporting,
                onToggle: ()=>toggleSection("reporting"),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: "Reporting currency handling is still under development in the original Django template, so this React version keeps the same placeholder behavior."
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($29801a9c2c8d5f6b$var$Section, {
                title: "7. Narration String",
                subtitle: "Narration composition",
                open: openSections.narration,
                onToggle: ()=>toggleSection("narration"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-field",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                children: "Narration fields"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-check-grid",
                                children: $29801a9c2c8d5f6b$var$NARRATION_FIELDS.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "config-check",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                checked: config.narration.fields.includes(field.value),
                                                onChange: ()=>handleNarrationFieldToggle(field.value)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: field.label
                                            })
                                        ]
                                    }, field.value))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-field",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                children: "Delimiter / symbol"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                value: config.narration.symbol,
                                onChange: (event)=>updateSection("narration", "symbol", event.target.value),
                                children: [
                                    "!",
                                    "@",
                                    "#",
                                    "$",
                                    "%",
                                    "^",
                                    "&",
                                    "*"
                                ].map((symbol)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: symbol,
                                        children: symbol
                                    }, symbol))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


const $ab10cea82ecaf379$var$DEFAULT_OPEN_SECTIONS = {
    invoiceType: true,
    duplicate: false,
    companyPan: false,
    materialService: false
};
function $ab10cea82ecaf379$var$createDefaultConfig() {
    return {
        invoiceType: "Both",
        duplicate_check: {
            dup_check: "Y"
        },
        companyPan: "",
        material_service_codes: {
            material: [],
            service: []
        }
    };
}
function $ab10cea82ecaf379$var$mergeLoadedConfig(payload) {
    const next = $ab10cea82ecaf379$var$createDefaultConfig();
    if (!payload) return next;
    if (payload.invoiceType) next.invoiceType = payload.invoiceType;
    if (payload.duplicate_check) next.duplicate_check = {
        ...next.duplicate_check,
        ...payload.duplicate_check
    };
    if (typeof payload.pans === "string") next.companyPan = payload.pans;
    if (payload.material_service_codes) next.material_service_codes = {
        material: Array.isArray(payload.material_service_codes.material) ? payload.material_service_codes.material : [],
        service: Array.isArray(payload.material_service_codes.service) ? payload.material_service_codes.service : []
    };
    return next;
}
async function $ab10cea82ecaf379$var$parseJsonResponse(response) {
    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (contentType.includes("application/json")) return {
        isJson: true,
        payload: await response.json(),
        text: ""
    };
    return {
        isJson: false,
        payload: null,
        text: await response.text()
    };
}
function $ab10cea82ecaf379$var$normalizeNonJsonError(response, text, fallback) {
    const body = String(text || "");
    const lower = body.toLowerCase();
    const looksLikeHtml = lower.includes("<html") || lower.includes("<!doctype html");
    const looksLikeLogin = lower.includes("miro app login") || lower.includes('name="password"');
    if (response.redirected || response.url.includes("next=") || looksLikeLogin) return "Session is not authenticated. Please login again.";
    if (looksLikeHtml) return fallback;
    return body || fallback;
}
function $ab10cea82ecaf379$var$Section({ title: title, subtitle: subtitle, open: open, onToggle: onToggle, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
        className: "config-card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                className: "config-card__head",
                type: "button",
                onClick: onToggle,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-card__title",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-card__subtitle",
                                children: subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "config-card__toggle",
                        children: open ? "Hide" : "Show"
                    })
                ]
            }),
            open ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-card__body",
                children: children
            }) : null
        ]
    });
}
function $ab10cea82ecaf379$var$RadioGroup({ name: name, value: value, options: options, onChange: onChange }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "config-inline",
        children: options.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                className: "config-choice",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "radio",
                        name: name,
                        value: option.value,
                        checked: value === option.value,
                        onChange: ()=>onChange(option.value)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: option.label
                    })
                ]
            }, option.value))
    });
}
function $ab10cea82ecaf379$export$2e2bcd8739ae039() {
    const [config, setConfig] = (0, $acw62.useState)($ab10cea82ecaf379$var$createDefaultConfig);
    const [openSections, setOpenSections] = (0, $acw62.useState)($ab10cea82ecaf379$var$DEFAULT_OPEN_SECTIONS);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        async function loadConfiguration() {
            setLoading(true);
            setError("");
            try {
                const response = await fetch("/api/configuration/", {
                    credentials: "include",
                    headers: {
                        Accept: "application/json"
                    }
                });
                const { isJson: isJson, payload: payload, text: text } = await $ab10cea82ecaf379$var$parseJsonResponse(response);
                if (!isJson) throw new Error($ab10cea82ecaf379$var$normalizeNonJsonError(response, text, "Unable to load saved configuration."));
                if (!cancelled) {
                    if (payload.status === "success") setConfig($ab10cea82ecaf379$var$mergeLoadedConfig(payload.data));
                }
            } catch (requestError) {
                if (!cancelled) setError(requestError.message || "Unable to load saved configuration.");
            } finally{
                if (!cancelled) setLoading(false);
            }
        }
        loadConfiguration();
        return ()=>{
            cancelled = true;
        };
    }, []);
    function toggleSection(sectionKey) {
        setOpenSections((current)=>({
                ...current,
                [sectionKey]: !current[sectionKey]
            }));
    }
    function updateTopLevel(key, value) {
        setConfig((current)=>({
                ...current,
                [key]: value
            }));
    }
    function updateSection(sectionKey, field, value) {
        setConfig((current)=>({
                ...current,
                [sectionKey]: {
                    ...current[sectionKey],
                    [field]: value
                }
            }));
    }
    function buildPayload() {
        return {
            invoiceType: config.invoiceType,
            duplicate_check: config.duplicate_check,
            companyPan: config.companyPan.trim().toUpperCase(),
            material_service_codes: {
                material: config.material_service_codes.material,
                service: config.material_service_codes.service
            }
        };
    }
    async function handleSave() {
        const pan = config.companyPan?.trim().toUpperCase();
        if (!pan || !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(pan)) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "warning",
                title: "Invalid PAN",
                text: "Please enter a valid Company PAN."
            });
            return;
        }
        setSaving(true);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const formData = new FormData();
            formData.append("payload", JSON.stringify(buildPayload()));
            const response = await fetch("/api/configuration/save/", {
                method: "POST",
                headers: {
                    "X-CSRFToken": csrfToken,
                    Accept: "application/json"
                },
                credentials: "include",
                body: formData
            });
            const { isJson: isJson, payload: payload, text: text } = await $ab10cea82ecaf379$var$parseJsonResponse(response);
            if (!isJson) throw new Error($ab10cea82ecaf379$var$normalizeNonJsonError(response, text, "Unable to save configuration."));
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || "Unable to save configuration.");
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: payload.message || "Configuration saved successfully.",
                confirmButtonText: "OK"
            });
        } catch (requestError) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: requestError.message || "Unable to save configuration.",
                confirmButtonText: "OK"
            });
        } finally{
            setSaving(false);
        }
    }
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "workspace-panel",
        children: "Loading configuration\u2026"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "config-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "config-view__header workspace-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "Basic Configurations"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "Accounting Configuration"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-view__intro",
                                children: "Accounting Configuration enables administrators to configure key accounting rules, validations, and processing logic that govern transaction posting, compliance, invoice verification, and financial controls throughout the system."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "primary-button",
                        type: "button",
                        onClick: handleSave,
                        disabled: saving,
                        children: saving ? "Saving..." : "Submit Configuration"
                    })
                ]
            }),
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ab10cea82ecaf379$var$Section, {
                title: "1. Type of Invoices",
                subtitle: "What kind of invoices does the company have?",
                open: openSections.invoiceType,
                onToggle: ()=>toggleSection("invoiceType"),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "config-field",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            children: "Invoice Type"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                            value: config.invoiceType,
                            onChange: (event)=>updateTopLevel("invoiceType", event.target.value),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "",
                                    children: "Select invoice type"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "PO",
                                    children: "PO"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "NonPO",
                                    children: "NonPO"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "Both",
                                    children: "Both"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ab10cea82ecaf379$var$Section, {
                title: "2. Duplicate Invoice",
                subtitle: "Duplicate checking rules",
                open: openSections.duplicate,
                onToggle: ()=>toggleSection("duplicate"),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "config-field",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            children: "Enable duplicate invoice check?"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ab10cea82ecaf379$var$RadioGroup, {
                            name: "dup_check",
                            value: config.duplicate_check.dup_check,
                            options: [
                                {
                                    value: "Y",
                                    label: "Yes"
                                },
                                {
                                    value: "N",
                                    label: "No"
                                }
                            ],
                            onChange: (value)=>updateSection("duplicate_check", "dup_check", value)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ab10cea82ecaf379$var$Section, {
                title: "3. Company PAN",
                subtitle: "Enter PAN number of company",
                open: openSections.companyPan,
                onToggle: ()=>toggleSection("companyPan"),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "config-field",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            children: "Company PAN Number"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            value: config.companyPan,
                            onChange: (event)=>updateTopLevel("companyPan", event.target.value.toUpperCase()),
                            placeholder: "ABCDE1234F"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ab10cea82ecaf379$var$Section, {
                title: "4. Material / Service Codes",
                subtitle: "Enter comma-separated codes",
                open: openSections.materialService,
                onToggle: ()=>toggleSection("materialService"),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "config-grid",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "config-field",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    children: "Material Codes"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    value: config.material_service_codes.material.join(", "),
                                    onChange: (event)=>updateSection("material_service_codes", "material", event.target.value.split(",").map((item)=>item.trim().toUpperCase()).filter(Boolean)),
                                    placeholder: "MAT001, MAT002"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "config-field",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    children: "Service Codes"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    value: config.material_service_codes.service.join(", "),
                                    onChange: (event)=>updateSection("material_service_codes", "service", event.target.value.split(",").map((item)=>item.trim().toUpperCase()).filter(Boolean)),
                                    placeholder: "SER001, SER002"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


const $99c1db87b1ee001c$var$BLOCKING_ROWS = [
    {
        key: "pan_inactive",
        label: "Vendor PAN Inactive"
    },
    {
        key: "aadhar_pan",
        label: "Vendor Aadhar & PAN linked (Individual & Proprietor)"
    },
    {
        key: "gst_inactive",
        label: "GST Inactive"
    },
    {
        key: "gstr1",
        label: "GSTR1 not Filed",
        hasMonths: true
    },
    {
        key: "gstr3b",
        label: "GSTR3B Filed (not filed flag)",
        hasMonths: true
    },
    {
        key: "gst_2b",
        label: "GST not appearing in 2B (13 days rule)",
        note: "Under Development"
    },
    {
        key: "new_vendor",
        label: "New Vendor / Irregular Transactions"
    },
    {
        key: "regular_vendor",
        label: "Regular Vendor"
    },
    {
        key: "prev_gst",
        label: "Previous invoice GST not appearing"
    }
];
const $99c1db87b1ee001c$var$DEFAULT_OPEN_SECTIONS = {
    baseline: true,
    blocking: false,
    threshold: false
};
function $99c1db87b1ee001c$var$createDefaultConfig() {
    const blocking = $99c1db87b1ee001c$var$BLOCKING_ROWS.reduce((accumulator, row)=>{
        accumulator[row.key] = {
            acc: row.key === "gst_inactive" ? "Y" : "N",
            pay: row.key === "regular_vendor" ? "N" : "Y",
            months: "",
            code: ""
        };
        return accumulator;
    }, {});
    return {
        baseline: {
            baseline_active: "N",
            baseline_choice: "posting"
        },
        blocking: blocking,
        blocking_activate: {
            account_blocking_activate: "Y",
            payment_blocking_activate: "Y",
            blocked_vendor_code: "X,Yes,Inactive,Block,Blocked",
            payment_block_codes: "X,Yes,Inactive,Block,Blocked",
            statutory_block_activate: "Y"
        },
        threshold: {
            turnover_above_threshold: "Y",
            threshold_amount: "5000000",
            wt_rate: "0.1"
        }
    };
}
function $99c1db87b1ee001c$var$mergeLoadedConfig(payload) {
    const next = $99c1db87b1ee001c$var$createDefaultConfig();
    if (!payload) return next;
    if (payload.baseline) next.baseline = {
        ...next.baseline,
        ...payload.baseline
    };
    if (payload.blocking) $99c1db87b1ee001c$var$BLOCKING_ROWS.forEach((row)=>{
        next.blocking[row.key] = {
            ...next.blocking[row.key],
            ...payload.blocking[row.key] || {}
        };
    });
    if (payload.blocking_activate) next.blocking_activate = {
        ...next.blocking_activate,
        ...payload.blocking_activate
    };
    if (payload.threshold) next.threshold = {
        ...next.threshold,
        ...payload.threshold
    };
    return next;
}
async function $99c1db87b1ee001c$var$parseJsonResponse(response) {
    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (contentType.includes("application/json")) return {
        isJson: true,
        payload: await response.json(),
        text: ""
    };
    return {
        isJson: false,
        payload: null,
        text: await response.text()
    };
}
function $99c1db87b1ee001c$var$normalizeNonJsonError(response, text, fallback) {
    const body = String(text || "");
    const lower = body.toLowerCase();
    const looksLikeHtml = lower.includes("<html") || lower.includes("<!doctype html");
    const looksLikeLogin = lower.includes("miro app login") || lower.includes("name=\"password\"");
    if (response.redirected || response.url.includes("next=") || looksLikeLogin) return "Session is not authenticated. Please login again.";
    if (looksLikeHtml) return fallback;
    return body || fallback;
}
function $99c1db87b1ee001c$var$Section({ title: title, subtitle: subtitle, open: open, onToggle: onToggle, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
        className: "config-card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                className: "config-card__head",
                type: "button",
                onClick: onToggle,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-card__title",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-card__subtitle",
                                children: subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "config-card__toggle",
                        children: open ? "Hide" : "Show"
                    })
                ]
            }),
            open ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-card__body",
                children: children
            }) : null
        ]
    });
}
function $99c1db87b1ee001c$var$RadioGroup({ name: name, value: value, options: options, onChange: onChange }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "config-inline",
        children: options.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                className: "config-choice",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "radio",
                        name: name,
                        value: option.value,
                        checked: value === option.value,
                        onChange: ()=>onChange(option.value)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: option.label
                    })
                ]
            }, option.value))
    });
}
function $99c1db87b1ee001c$export$2e2bcd8739ae039() {
    const [config, setConfig] = (0, $acw62.useState)($99c1db87b1ee001c$var$createDefaultConfig);
    const [openSections, setOpenSections] = (0, $acw62.useState)($99c1db87b1ee001c$var$DEFAULT_OPEN_SECTIONS);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        async function loadConfiguration() {
            setLoading(true);
            setError("");
            try {
                const response = await fetch("/api/configuration/", {
                    credentials: "include",
                    headers: {
                        Accept: "application/json"
                    }
                });
                const { isJson: isJson, payload: payload, text: text } = await $99c1db87b1ee001c$var$parseJsonResponse(response);
                if (!isJson) throw new Error($99c1db87b1ee001c$var$normalizeNonJsonError(response, text, "Unable to load saved configuration."));
                if (!cancelled) {
                    if (payload.status === "success") setConfig($99c1db87b1ee001c$var$mergeLoadedConfig(payload.data));
                    setStatus("");
                }
            } catch (requestError) {
                if (!cancelled) setError(requestError.message || "Unable to load saved configuration.");
            } finally{
                if (!cancelled) setLoading(false);
            }
        }
        loadConfiguration();
        return ()=>{
            cancelled = true;
        };
    }, []);
    function toggleSection(sectionKey) {
        setOpenSections((current)=>({
                ...current,
                [sectionKey]: !current[sectionKey]
            }));
    }
    function updateSection(sectionKey, field, value) {
        setConfig((current)=>({
                ...current,
                [sectionKey]: {
                    ...current[sectionKey],
                    [field]: value
                }
            }));
    }
    function updateBlocking(rowKey, field, value) {
        setConfig((current)=>({
                ...current,
                blocking: {
                    ...current.blocking,
                    [rowKey]: {
                        ...current.blocking[rowKey],
                        [field]: value
                    }
                }
            }));
    }
    function buildPayload() {
        return {
            baseline: config.baseline,
            blocking: config.blocking,
            threshold: config.threshold
        };
    }
    async function handleSave() {
        setSaving(true);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const formData = new FormData();
            formData.append("payload", JSON.stringify(buildPayload()));
            const response = await fetch("/api/configuration/save/", {
                method: "POST",
                headers: {
                    "X-CSRFToken": csrfToken,
                    Accept: "application/json"
                },
                credentials: "include",
                body: formData
            });
            const { isJson: isJson, payload: payload, text: text } = await $99c1db87b1ee001c$var$parseJsonResponse(response);
            if (!isJson) throw new Error($99c1db87b1ee001c$var$normalizeNonJsonError(response, text, "Unable to save configuration."));
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || "Unable to save configuration.");
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: payload.message || "Configuration saved successfully.",
                confirmButtonText: "OK"
            });
        } catch (requestError) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: requestError.message || "Unable to save configuration.",
                confirmButtonText: "OK"
            });
        } finally{
            setSaving(false);
        }
    }
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "workspace-panel",
        children: "Loading configuration\u2026"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "config-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "config-view__header workspace-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "Basic Configurations"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "Accounting Configuration"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-view__intro",
                                children: "This is a common configuration for both PO & Non PO AP."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "primary-button",
                        type: "button",
                        onClick: handleSave,
                        disabled: saving,
                        children: saving ? "Saving..." : "Submit Configuration"
                    })
                ]
            }),
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($99c1db87b1ee001c$var$Section, {
                title: "1. Baseline Date",
                subtitle: "Activate baseline date",
                open: openSections.baseline,
                onToggle: ()=>toggleSection("baseline"),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "config-grid",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "config-field",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    children: "Activate Baseline date?"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($99c1db87b1ee001c$var$RadioGroup, {
                                    name: "baseline_active",
                                    value: config.baseline.baseline_active,
                                    options: [
                                        {
                                            value: "N",
                                            label: "No"
                                        },
                                        {
                                            value: "Y",
                                            label: "Yes"
                                        }
                                    ],
                                    onChange: (value)=>updateSection("baseline", "baseline_active", value)
                                })
                            ]
                        }),
                        config.baseline.baseline_active === "Y" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "config-field",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    children: "If Yes, baseline date should be"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                    value: config.baseline.baseline_choice,
                                    onChange: (event)=>updateSection("baseline", "baseline_choice", event.target.value),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "posting",
                                            children: "Posting Date"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "invoice",
                                            children: "Invoice Date"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "migo",
                                            children: "GRN Date"
                                        })
                                    ]
                                })
                            ]
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($99c1db87b1ee001c$var$Section, {
                title: "2. Flags for Blocking",
                subtitle: "Block accounting or payment from vendor PAN and GST signals",
                open: openSections.blocking,
                onToggle: ()=>toggleSection("blocking"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-field",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                children: "A. Activate Block from Vendor Master"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($99c1db87b1ee001c$var$RadioGroup, {
                                name: "vendor_master_block",
                                value: config.blocking_activate.account_blocking_activate,
                                options: [
                                    {
                                        value: "Y",
                                        label: "Y"
                                    },
                                    {
                                        value: "N",
                                        label: "N"
                                    }
                                ],
                                onChange: (value)=>updateSection("blocking_activate", "account_blocking_activate", value)
                            }),
                            config.blocking_activate.account_blocking_activate === "Y" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "text",
                                className: "config-input",
                                placeholder: "Enter codes separated by commas",
                                value: config.blocking_activate.blocked_vendor_code ?? "",
                                onChange: (e)=>updateSection("blocking_activate", "blocked_vendor_code", e.target.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-field",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                children: "B. Activate Block from GRN Report"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($99c1db87b1ee001c$var$RadioGroup, {
                                name: "grn_block",
                                value: config.blocking_activate.payment_blocking_activate,
                                options: [
                                    {
                                        value: "Y",
                                        label: "Y"
                                    },
                                    {
                                        value: "N",
                                        label: "N"
                                    }
                                ],
                                onChange: (value)=>updateSection("blocking_activate", "payment_blocking_activate", value)
                            }),
                            config.blocking_activate.payment_blocking_activate === "Y" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "text",
                                className: "config-input",
                                placeholder: "Enter codes separated by commas",
                                value: config.blocking_activate.payment_block_codes ?? "",
                                onChange: (e)=>updateSection("blocking_activate", "payment_block_codes", e.target.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-table",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                children: "C. Activate Statutory Block"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-field",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($99c1db87b1ee001c$var$RadioGroup, {
                                    name: "statutory_block_activate",
                                    value: config.blocking_activate.statutory_block_activate ?? "N",
                                    options: [
                                        {
                                            value: "Y",
                                            label: "Y"
                                        },
                                        {
                                            value: "N",
                                            label: "N"
                                        }
                                    ],
                                    onChange: (value)=>{
                                        updateSection("blocking_activate", "statutory_block_activate", value);
                                        if (value === "N") $99c1db87b1ee001c$var$BLOCKING_ROWS.forEach((row)=>{
                                            updateBlocking(row.key, "acc", "N");
                                            updateBlocking(row.key, "pay", "N");
                                        });
                                    }
                                })
                            }),
                            config.blocking_activate.statutory_block_activate === "Y" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Parameter"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Accounting"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Payment"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Code"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Months"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                        children: $99c1db87b1ee001c$var$BLOCKING_ROWS.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.label
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                            value: config.blocking[row.key].acc,
                                                            onChange: (event)=>updateBlocking(row.key, "acc", event.target.value),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "N",
                                                                    children: "N"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "Y",
                                                                    children: "Y"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                            value: config.blocking[row.key].pay,
                                                            onChange: (event)=>updateBlocking(row.key, "pay", event.target.value),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "N",
                                                                    children: "N"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "Y",
                                                                    children: "Y"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            value: config.blocking[row.key].code,
                                                            maxLength: 3,
                                                            onChange: (event)=>updateBlocking(row.key, "code", event.target.value.toUpperCase())
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.hasMonths ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                            value: config.blocking[row.key].months,
                                                            onChange: (event)=>updateBlocking(row.key, "months", event.target.value),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "",
                                                                    children: "-"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "1",
                                                                    children: "1"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "2",
                                                                    children: "2"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "3",
                                                                    children: "3"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "4",
                                                                    children: "4"
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "config-note",
                                                            children: row.note || "-"
                                                        })
                                                    })
                                                ]
                                            }, row.key))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-field",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                children: "D. GST Input Credit Expiry Date"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "text",
                                className: "config-input",
                                placeholder: "DD/MM",
                                maxLength: 5,
                                value: config.gst_input_expired ?? "",
                                onChange: (e)=>{
                                    let value = e.target.value.replace(/\D/g, "");
                                    if (value.length > 2) value = value.slice(0, 2) + "/" + value.slice(2, 4);
                                    setConfig((prev)=>({
                                            ...prev,
                                            gst_input_expired: value
                                        }));
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-field",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                children: "E. Tax Prior Period Cut-off Date"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "text",
                                className: "config-input",
                                placeholder: "DD/MM",
                                maxLength: 5,
                                value: config.tax_period_expired ?? "",
                                onChange: (e)=>{
                                    let value = e.target.value.replace(/\D/g, "");
                                    if (value.length > 2) value = value.slice(0, 2) + "/" + value.slice(2, 4);
                                    setConfig((prev)=>({
                                            ...prev,
                                            tax_period_expired: value
                                        }));
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($99c1db87b1ee001c$var$Section, {
                title: "3. Threshold Check (u/s 194Q)",
                subtitle: "Check if turnover exceeds the threshold",
                open: openSections.threshold,
                onToggle: ()=>toggleSection("threshold"),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "config-grid",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "config-field",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    children: "Is company turnover above threshold limit?"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($99c1db87b1ee001c$var$RadioGroup, {
                                    name: "turnover_above_threshold",
                                    value: config.threshold.turnover_above_threshold,
                                    options: [
                                        {
                                            value: "Y",
                                            label: "Yes"
                                        },
                                        {
                                            value: "N",
                                            label: "No"
                                        }
                                    ],
                                    onChange: (value)=>updateSection("threshold", "turnover_above_threshold", value)
                                })
                            ]
                        }),
                        config.threshold.turnover_above_threshold === "Y" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "config-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Threshold Amount"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "number",
                                            value: config.threshold.threshold_amount,
                                            onChange: (event)=>updateSection("threshold", "threshold_amount", event.target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "config-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "WT Rate (%)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "number",
                                            step: "0.01",
                                            value: config.threshold.wt_rate,
                                            onChange: (event)=>updateSection("threshold", "wt_rate", event.target.value)
                                        })
                                    ]
                                })
                            ]
                        }) : null
                    ]
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


function $3ab9920e663be072$export$2e2bcd8739ae039() {
    const [glCode, setGlCode] = (0, $acw62.useState)("");
    const [description, setDescription] = (0, $acw62.useState)("");
    const [file, setFile] = (0, $acw62.useState)(null);
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const downloadTemplate = ()=>{
        const csv = "GL Code,Description\n";
        const blob = new Blob([
            csv
        ], {
            type: "text/csv;charset=utf-8;"
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "GL_Code_Template.csv";
        link.click();
        URL.revokeObjectURL(url);
    };
    async function loadGlCodes() {
        setLoading(true);
        setError("");
        try {
            const response = await fetch("/api/unallocatedcost-gl-list/", {
                credentials: "include"
            });
            const payload = await response.json();
            if (!response.ok || !payload.success) throw new Error(payload.message || "Unable to load GL codes.");
            setRows(payload.data || []);
        } catch (requestError) {
            setError(requestError.message || "Unable to load GL codes.");
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadGlCodes();
    }, []);
    async function handleSubmit(event) {
        event.preventDefault();
        setSaving(true);
        setError("");
        if (!file && !(glCode.trim() && description.trim())) {
            setSaving(false);
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "warning",
                title: "Missing Information",
                text: "Enter a GL code and description, or upload an Excel file."
            });
            return;
        }
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const formData = new FormData();
            if (glCode.trim()) formData.append("gl_code", glCode.trim());
            if (description.trim()) formData.append("description", description.trim());
            if (file) formData.append("gl_file", file);
            const response = await fetch("/api/unallocatedcost-gl-save/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "X-CSRFToken": csrfToken
                },
                body: formData
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || "Unable to save GL code.");
            setGlCode("");
            setDescription("");
            setFile(null);
            await loadGlCodes();
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: payload.message || "GL Code saved successfully.",
                confirmButtonText: "OK"
            });
        } catch (requestError) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Save Failed",
                text: requestError.message || "Unable to save GL code.",
                confirmButtonText: "OK"
            });
            setError(requestError.message || "Unable to save GL code.");
        } finally{
            setSaving(false);
        }
    }
    async function handleDelete(code) {
        setError("");
        const result = await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
            title: "Delete GL Code?",
            text: `Are you sure you want to delete GL code "${code}"?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Delete",
            cancelButtonText: "Cancel",
            reverseButtons: true
        });
        if (!result.isConfirmed) return;
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch(`/delete-gl/${encodeURIComponent(code)}/`, {
                method: "GET",
                credentials: "include",
                headers: {
                    "X-CSRFToken": csrfToken
                }
            });
            if (!response.ok) throw new Error("Unable to delete GL code.");
            await loadGlCodes();
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Deleted",
                text: `GL code ${code} deleted successfully.`,
                confirmButtonText: "OK"
            });
        } catch (requestError) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Delete Failed",
                text: requestError.message || "Unable to delete GL code.",
                confirmButtonText: "OK"
            });
            setError(requestError.message || "Unable to delete GL code.");
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "gl-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "workspace-panel upload-view__hero",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "eyebrow",
                            children: "GL Codes"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            children: "Unallocated cost GL list"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "config-view__intro",
                            children: "Add GL codes manually, upload them from Excel, and manage the list used for unallocated cost handling."
                        })
                    ]
                })
            }),
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "gl-layout",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        className: "workspace-panel gl-form",
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "GL Code"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: glCode,
                                        onChange: (event)=>setGlCode(event.target.value),
                                        placeholder: "e.g. 400100"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Description"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: description,
                                        onChange: (event)=>setDescription(event.target.value),
                                        placeholder: "e.g. Office Expenses"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Or Upload Excel"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "file",
                                        accept: ".xlsx,.csv",
                                        onChange: (event)=>setFile(event.target.files?.[0] || null)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "config-note",
                                        children: "Expected columns: `GL Code` and `Description`"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "ghost-button",
                                onClick: downloadTemplate,
                                style: {
                                    marginTop: "10px"
                                },
                                children: "Download Excel Format"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary-button",
                                type: "submit",
                                disabled: saving,
                                children: saving ? "Saving..." : "Add GL Code"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "workspace-panel",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "Existing GL Codes"
                            }),
                            loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-note",
                                children: "Loading existing GL codes\u2026"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-table",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "GL Code"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Description"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Action"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: rows.length ? rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: row.code
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: row.description
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                className: "danger-button",
                                                                type: "button",
                                                                onClick: ()=>handleDelete(row.code),
                                                                children: "Delete"
                                                            })
                                                        })
                                                    ]
                                                }, row.code)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    colSpan: "3",
                                                    children: "No GL codes found."
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");



function $96fe7c33bdd2f764$export$2e2bcd8739ae039({ title: title, intro: intro, metrics: metrics = [], actions: actions, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "processor-view processor-view--pending-actions",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel processor-view__hero processor-view__hero--compact",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "processor-view__hero-copy",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "processor-view__heading-row",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-view__heading-copy",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "processor-view__intro",
                                            children: intro
                                        })
                                    ]
                                }),
                                metrics.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "processor-metrics processor-metrics--inline",
                                    children: metrics.map((metric)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                                            className: "processor-metric-card",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "processor-metric-card__label",
                                                    children: metric.label
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: metric.value
                                                })
                                            ]
                                        }, metric.label))
                                }) : null
                            ]
                        })
                    }),
                    actions ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "processor-view__hero-actions",
                        children: actions
                    }) : null
                ]
            }),
            children
        ]
    });
}



function $3d6d578a87c5904f$var$getRowColor(result, greenValues = []) {
    if (result === "") return "#d3d3d3";
    if (result === "Matching" || greenValues.includes(result)) return "#BFF4BE";
    return "#FFCCCB";
}
function $3d6d578a87c5904f$var$generateTableRows(data) {
    if (!data || typeof data !== "object") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
            colSpan: "2",
            children: "No data available"
        })
    });
    return Object.entries(data).map(([key, value])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                    children: key
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                    children: typeof value === "object" ? JSON.stringify(value, null, 2) : String(value)
                })
            ]
        }, key));
}
function $3d6d578a87c5904f$var$renderInvoiceVsGSTPortal(data) {
    if (!data || Object.keys(data).length === 0) return `
      <tr>
        <td colspan="4">No data available</td>
      </tr>
    `;
    return Object.values(data).map((item)=>`
        <tr style="background:${$3d6d578a87c5904f$var$getRowColor(item.Result)}">

          <td>${item.parameter || ""}</td>

          <td>${item.As_per_Invoice || ""}</td>

          <td>
            Trade Name: ${item.As_per_GST_Portal || ""}

            ${item.As_per_GST_Portal_legal ? `<br><br>Legal Name: ${item.As_per_GST_Portal_legal}` : ""}
          </td>

          <td>${item.Result || ""}</td>

        </tr>
      `).join("");
}
function $3d6d578a87c5904f$var$renderInvoiceValidation(data, greenValues, tooltipKeys) {
    if (!data || Object.keys(data).length === 0) return `
      <tr>
        <td colspan="4">No data available</td>
      </tr>
    `;
    return Object.entries(data).map(([key, item])=>{
        const supportInfo = tooltipKeys.includes(key) ? `
          <span title="${item.As_per_Invoice || ""}"
            style="
              text-decoration:underline;
              cursor:pointer;
              color:blue;
            ">
            info
          </span>
        ` : item.As_per_Invoice || "";
        return `
        <tr style="background:${$3d6d578a87c5904f$var$getRowColor(item.Result, greenValues)}">

          <td>${item.parameter || ""}</td>

          <td>${item.Result || ""}</td>

          <td>${supportInfo}</td>

        </tr>
      `;
    }).join("");
}
function $3d6d578a87c5904f$var$renderTwoColumnTable(data, greenValues = []) {
    if (!data || Object.keys(data).length === 0) return `
      <tr>
        <td colspan="2">No data available</td>
      </tr>
    `;
    return Object.values(data).map((item)=>`
        <tr style="background:${$3d6d578a87c5904f$var$getRowColor(item.Result, greenValues)}">

          <td>${item.parameter || ""}</td>

          <td>${item.Result || ""}</td>

        </tr>
      `).join("");
}
function $3d6d578a87c5904f$export$fce373117e8399e2(data) {
    const greenValues = data["2b_olive_color"] || [];
    const tooltipKeys = data.keys_with_tooltip || [];
    const renderValue = (value)=>{
        if (value === null || value === undefined || value === "") return "-";
        // array
        if (Array.isArray(value)) return value.join(", ");
        // nested object
        if (typeof value === "object") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
            className: "inner-table",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                children: Object.entries(value).map(([k, v])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: k
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                children: renderValue(v)
                            })
                        ]
                    }, k))
            })
        });
        return String(value);
    };
    function generateKeyValueRows(obj, emptyMessage = "No data available") {
        if (!obj || Object.keys(obj).length === 0) return `
        <tr>
          <td colspan="2">${emptyMessage}</td>
        </tr>
      `;
        return Object.entries(obj).map(([key, value])=>{
            if (typeof value === "object" && value !== null) value = JSON.stringify(value, null, 2);
            return `
          <tr>
            <th>${key}</th>
            <td>${value ?? "-"}</td>
          </tr>
        `;
        }).join("");
    }
    return `
  <!DOCTYPE html>

  <html>

  <head>

    <title>Invoice Display</title>

    <style>

      body{
        margin:0;
        font-family: Arial, sans-serif;
        background:#efefef;
      }

      .topbar{
        position:sticky;
        top:0;
        background:#c8b7a9;
        padding:10px;
        text-align:center;
        z-index:999;
        box-shadow:0 2px 5px rgba(0,0,0,0.15);
      }

      .tab-btn{
        background:#0d6efd;
        color:white;
        border:none;
        padding:10px 18px;
        margin:4px;
        border-radius:4px;
        cursor:pointer;
        font-size:15px;
        transition:0.2s;
      }

      .tab-btn:hover{
        opacity:0.9;
      }

      .tab-btn.active{
        background:#11cdef;
      }

      .tab-content{
        display:none;
        padding:20px;
      }

      .tab-content.active{
        display:block;
      }

      table{
        width:70%;
        margin:auto;
        border-collapse:collapse;
        margin-bottom:30px;
        background:white;
        box-shadow:0 2px 8px rgba(0,0,0,0.12);
      }

      th,
      td{
        border:1px solid #d5d5d5;
        padding:10px;
        text-align:left;
        vertical-align:top;
        word-break:break-word;
      }

      th{
        background:#2d2d2d;
        color:white;
      }

      h2,
      h3{
        text-align:center;
        margin-top:25px;
        margin-bottom:15px;
      }

      /* nested object tables */
      .inner-table{
        width:100%;
        margin:0;
        border-collapse:collapse;
        background:#fafafa;
        box-shadow:none;
      }

      .inner-table th,
      .inner-table td{
        border:1px solid #ccc;
        padding:6px;
        font-size:13px;
      }

      .inner-table th{
        background:#f2f2f2;
        color:#222;
        width:35%;
      }

      /* dataframe html tables */
      .dataframe{
        width:100% !important;
        border-collapse:collapse;
      }

      .dataframe th,
      .dataframe td{
        border:1px solid #ccc;
        padding:8px;
      }

      /* mobile responsiveness */
      @media(max-width:900px){

        table{
          width:95%;
        }

        .tab-btn{
          width:90%;
          margin:5px auto;
          display:block;
        }

        th,
        td{
          font-size:13px;
        }
      }
    </style>

  </head>

  <body>

    <div class="topbar">

      <button class="tab-btn active"
        onclick="showTab('invoice-check', this)">
        Invoice Check
      </button>

      <button class="tab-btn"
        onclick="showTab('gst-data', this)">
        Tax Compliance(GST/IT Portal)
      </button>

      <button class="tab-btn"
        onclick="showTab('invoice-grn', this)">
        Invoice vs GRN Data
      </button>

      <button class="tab-btn"
        onclick="showTab('table-data', this)">
        Table Data
      </button>

      <button class="tab-btn"
        onclick="showTab('invoice-data', this)">
        Invoice Data
      </button>

    </div>

    <!-- FIRST TAB -->

    <div id="invoice-check"
      class="tab-content active">

      <h2>Invoice Checks</h2>

      <h3>Table 1: Source - GSTN & Invoice</h3>

      <table>

        <thead>

          <tr>
            <th>Parameters</th>
            <th>As per Invoice</th>
            <th>As per GST Portal</th>
            <th>Result</th>
          </tr>

        </thead>

        <tbody>

          ${$3d6d578a87c5904f$var$renderInvoiceVsGSTPortal(data.Checks?.invoice_vs_gstin_protal)}

        </tbody>

      </table>

      <h3>Table 2A: Source - Invoice</h3>

      <table>

        <thead>

          <tr>
            <th>Parameters</th>
            <th>Result</th>
            <th>Supporting Information</th>
          </tr>

        </thead>

        <tbody>

          ${$3d6d578a87c5904f$var$renderInvoiceValidation(data.Checks?.invoice_validations, greenValues, tooltipKeys)}

        </tbody>

      </table>

      <h3>Table 2B: Source - GSTN Data</h3>

      <table>

        <thead>

          <tr>
            <th>Parameters</th>
            <th>Result</th>
          </tr>

        </thead>

        <tbody>

          ${$3d6d578a87c5904f$var$renderTwoColumnTable(data.Checks?.gst_portal_check, greenValues)}

        </tbody>

      </table>

      <h3>Table 2C: Source - Income Tax Data</h3>

      <table>

        <thead>

          <tr>
            <th>Parameters</th>
            <th>Result</th>
          </tr>

        </thead>

        <tbody>

          ${$3d6d578a87c5904f$var$renderTwoColumnTable(data.Checks?.income_tax_check, greenValues)}

        </tbody>

      </table>

    </div>

    <!-- OTHER EMPTY TABS -->

    <div id="gst-data" class="tab-content">

      <h2>Tax Compliance(GST/IT Portal)</h2>

      <h3 class="centered">Customer GST Data</h3>

      <table class="narrow-table">
        <tbody>
          ${generateKeyValueRows(data.gst_data?.customer_gst_data, "No data available , Invalid GST NO or invoice does not have GST NO")}
        </tbody>
      </table>

      <h3 class="centered">Vendor GST Data</h3>

      <table class="narrow-table">
        <tbody>
          ${generateKeyValueRows(data.gst_data?.vendor_gst_data, "No data available , Invalid GST NO or invoice does not have GST NO")}
        </tbody>
      </table>

      <h3 class="centered">Filing Frequency GST Portal</h3>

      <table class="narrow-table">
        <thead>
          <tr>
            <th>Quarter</th>
            <th>Preference</th>
          </tr>
        </thead>

        <tbody>

          ${Array.isArray(data.Filinq_frequency) && data.Filinq_frequency.length > 0 ? data.Filinq_frequency.map((item)=>`
                  <tr>
                    <td>${item.quarter || "-"}</td>
                    <td>${item.preference || "-"}</td>
                  </tr>
                `).join("") : `
                  <tr>
                    <td colspan="2">
                      ${typeof data.Filinq_frequency === "string" ? data.Filinq_frequency : "No data available"}
                    </td>
                  </tr>
                `}

        </tbody>
      </table>

      <h2>Filing Status GST Portal</h2>

      <h3 class="centered">GSTR-1 Data</h3>

      <div class="html-table-wrapper">
        ${data.df_gstr1_html && data.df_gstr1_html.trim() !== "" ? data.df_gstr1_html : "<p>No GSTR-1 data available.</p>"}
      </div>

      <h3 class="centered">GSTR-3B Data</h3>

      <div class="html-table-wrapper">
        ${data.df_3b_html && data.df_3b_html.trim() !== "" ? data.df_3b_html : "<p>No GSTR-3B data available.</p>"}
      </div>

      <h3 class="centered">Pan Details</h3>

      <table class="narrow-table">
        <tbody>
          ${generateKeyValueRows(data.gst_data?.Pan_Status, "No data available , Invalid PAN NO or invoice does not have PAN NO")}
        </tbody>
      </table>

      <h3 class="centered">206AB Compliance</h3>

      <table class="narrow-table">
        <tbody>
          ${generateKeyValueRows(data.gst_data?.["206AB_Compliance"], "No data available , Invalid PAN NO or invoice does not have PAN NO")}
        </tbody>
      </table>

    </div>

    <div id="invoice-grn" class="tab-content">

      <h2>Table VS GRN</h2>

      <h3>Invoice Table</h3>

      <table class="narrow-table">

        <thead>
          <tr>
            ${Array.isArray(data.grn_vs_invoice?.invoice_data) && data.grn_vs_invoice.invoice_data.length > 0 ? Object.keys(data.grn_vs_invoice.invoice_data[0] || {}).map((column)=>`
                        <th>${column}</th>
                      `).join("") : `
                  <th>No Columns</th>
                `}
          </tr>
        </thead>

        <tbody>
          ${Array.isArray(data.grn_vs_invoice?.invoice_data) && data.grn_vs_invoice.invoice_data.length > 0 ? data.grn_vs_invoice.invoice_data.map((row)=>`
                      <tr>
                        ${row && typeof row === "object" ? Object.values(row).map((value)=>`
                                    <td>
                                      ${typeof value === "object" ? JSON.stringify(value) : String(value ?? "")}
                                    </td>
                                  `).join("") : `
                              <td colspan="20">Invalid Row</td>
                            `}
                      </tr>
                    `).join("") : `
                <tr>
                  <td colspan="20">
                    No Data Available
                  </td>
                </tr>
              `}
        </tbody>

      </table>

      <h3>GRN Data</h3>

      <table class="narrow-table">

        <thead>
          <tr>
            ${Array.isArray(data.grn_vs_invoice?.grn_data) && data.grn_vs_invoice.grn_data.length > 0 ? Object.keys(data.grn_vs_invoice.grn_data[0] || {}).map((column)=>`
                        <th>${column}</th>
                      `).join("") : `
                  <th>No Columns</th>
                `}
          </tr>
        </thead>

        <tbody>
          ${Array.isArray(data.grn_vs_invoice?.grn_data) && data.grn_vs_invoice.grn_data.length > 0 ? data.grn_vs_invoice.grn_data.map((row)=>`
                      <tr>
                        ${row && typeof row === "object" ? Object.values(row).map((value)=>`
                                    <td>
                                      ${typeof value === "object" ? JSON.stringify(value) : String(value ?? "")}
                                    </td>
                                  `).join("") : `
                              <td colspan="20">Invalid Row</td>
                            `}
                      </tr>
                    `).join("") : `
                <tr>
                  <td colspan="20">
                    Invoice Id did not match any OPEN GRN data or no data available against invoice id
                  </td>
                </tr>
              `}
        </tbody>

      </table>

      <h3>Invoice VS GRN</h3>

      <table class="narrow-table">

        <thead>
          <tr>
            <th>Particulars</th>
            <th>As per Open GRN Report</th>
            <th>As per Invoice (OCR)</th>
            <th>Result</th>
          </tr>
        </thead>

        <tbody>
          ${data.Invoicetable_vs_Grntable_compare && typeof data.Invoicetable_vs_Grntable_compare === "object" && Object.keys(data.Invoicetable_vs_Grntable_compare).length > 0 ? Object.values(data.Invoicetable_vs_Grntable_compare).map((item)=>`
                      <tr>
                        <td>${item?.Particulars ?? ""}</td>
                        <td>${item?.As_per_grn ?? ""}</td>
                        <td>${item?.As_per_invoice ?? ""}</td>
                        <td>${item?.result ?? ""}</td>
                      </tr>
                    `).join("") : `
                <tr>
                  <td colspan="4">
                    No data available
                  </td>
                </tr>
              `}
        </tbody>

      </table>

    </div>

    <div id="table-data" class="tab-content">

      <h2>Table Data</h2>

      <h3>Table</h3>

      <table class="narrow-table">

        <thead>
          <tr>
            ${Array.isArray(data.table_data?.tabledata_) && data.table_data.tabledata_.length > 0 ? Object.keys(data.table_data.tabledata_[0] || {}).map((column)=>`
                        <th>${column}</th>
                      `).join("") : `
                  <th>No Columns</th>
                `}
          </tr>
        </thead>

        <tbody>
          ${Array.isArray(data.table_data?.tabledata_) && data.table_data.tabledata_.length > 0 ? data.table_data.tabledata_.map((row)=>`
                      <tr>
                        ${row && typeof row === "object" ? Object.values(row).map((value)=>`
                                    <td>
                                      ${typeof value === "object" ? JSON.stringify(value) : String(value ?? "")}
                                    </td>
                                  `).join("") : `
                              <td colspan="20">Invalid Row</td>
                            `}
                      </tr>
                    `).join("") : `
                <tr>
                  <td colspan="20">
                    No Data Available
                  </td>
                </tr>
              `}
        </tbody>

      </table>

      <h3>Check2</h3>

      <table class="narrow-table">
        <tbody>
          ${data.table_data?.check_2 && typeof data.table_data.check_2 === "object" && Object.keys(data.table_data.check_2).length > 0 ? Object.entries(data.table_data.check_2).map(([key, value])=>`
                      <tr>
                        <th>${key}</th>
                        <td>
                          ${typeof value === "object" ? JSON.stringify(value) : String(value ?? "")}
                        </td>
                      </tr>
                    `).join("") : `
                <tr>
                  <td colspan="2">
                    No Data Available
                  </td>
                </tr>
              `}
        </tbody>
      </table>

      <h3>Check3</h3>

      <table class="narrow-table">
        <tbody>
          ${data.table_data?.check_3 && typeof data.table_data.check_3 === "object" && Object.keys(data.table_data.check_3).length > 0 ? Object.entries(data.table_data.check_3).map(([key, value])=>`
                      <tr>
                        <th>${key}</th>
                        <td>
                          ${typeof value === "object" ? JSON.stringify(value) : String(value ?? "")}
                        </td>
                      </tr>
                    `).join("") : `
                <tr>
                  <td colspan="2">
                    No Data Available
                  </td>
                </tr>
              `}
        </tbody>
      </table>

    </div>

    <div id="invoice-data" class="tab-content">

      <h2>Invoice Data</h2>

      <table class="narrow-table">

        <tbody>

          ${data.invoice_data && Object.keys(data.invoice_data).length > 0 ? Object.entries(data.invoice_data).filter(([key])=>{
        // remove very heavy/unnecessary fields
        const skipKeys = [
            "pages",
            "paragraphs",
            "tables",
            "words",
            "lines",
            "styles",
            "selectionMarks",
            "boundingRegions",
            "spans",
            "content",
            "raw_text"
        ];
        return !skipKeys.includes(key);
    }).map(([key, value])=>`
                      <tr>
                        <th>${key}</th>

                        <td>

                          ${typeof value === "object" && value !== null ? `

                                <table class="inner-table">

                                  <thead>
                                    <tr>
                                      <th>Key</th>
                                      <th>Details</th>
                                    </tr>
                                  </thead>

                                  <tbody>

                                    ${Object.entries(value).map(([subKey, subValue])=>`

                                          <tr>

                                            <td>
                                              ${subKey}
                                            </td>

                                            <td>

                                              ${typeof subValue === "object" ? Object.entries(subValue).map(([k, v])=>`
                                                          <div>
                                                            <strong>${k}</strong> : ${v}
                                                          </div>
                                                        `).join("") : String(subValue ?? "")}

                                            </td>

                                          </tr>

                                        `).join("")}

                                  </tbody>

                                </table>

                              ` : String(value ?? "")}

                        </td>
                      </tr>
                    `).join("") : `
                <tr>
                  <td colspan="2">
                    No Invoice Data Available
                  </td>
                </tr>
              `}

        </tbody>

      </table>

    </div>

    <script>

      function showTab(tabId, button){

        document
          .querySelectorAll(".tab-content")
          .forEach(tab => {
            tab.classList.remove("active");
          });

        document
          .querySelectorAll(".tab-btn")
          .forEach(btn => {
            btn.classList.remove("active");
          });

        document
          .getElementById(tabId)
          .classList.add("active");

        button.classList.add("active");
      }

    </script>

  </body>

  </html>
  `;
}
async function $3d6d578a87c5904f$export$2926f86deb178d44(responseFile) {
    try {
        const url = `/api/invoice-display/?format=json&response_file=${encodeURIComponent(responseFile)}`;
        const response = await fetch(url, {
            credentials: "include"
        });
        const payload = await response.json();
        if (!payload.success) {
            alert(payload.message || "Unable to load invoice data");
            return;
        }
        const data = payload.data;
        console.log(data);
        const newWindow = window.open("", "_blank");
        const html = $3d6d578a87c5904f$export$fce373117e8399e2(data);
        newWindow.document.open();
        newWindow.document.write(html);
        newWindow.document.close();
    } catch (err) {
        console.error(err);
        alert("Error loading invoice data");
    }
}


async function $e267546ad9d86d30$export$a38ce99a4bdccd4e(invoiceId) {
    console.log("Opening PDF for invoice:", invoiceId);
    try {
        const url = `/api/invoice/view/${invoiceId}/`;
        console.log("Request URL:", url);
        const response = await fetch(url, {
            method: "GET",
            credentials: "include"
        });
        console.log("Response status:", response.status);
        console.log("Content-Type:", response.headers.get("content-type"));
        if (!response.ok) {
            const errorText = await response.text();
            console.error("Backend error response:");
            console.error(errorText);
            throw new Error(`HTTP ${response.status} - Unable to load PDF`);
        }
        const blob = await response.blob();
        console.log("Blob received:", blob);
        console.log("Blob type:", blob.type);
        console.log("Blob size:", blob.size);
        const blobUrl = window.URL.createObjectURL(blob);
        console.log("Blob URL:", blobUrl);
        window.open(blobUrl, "_blank");
        console.log("PDF opened successfully");
    } catch (error) {
        console.error("FULL PDF ERROR:");
        console.error(error);
        alert(`Failed to open PDF: ${error.message}`);
    }
}


function $fa35cf08dc84bb84$var$ExceptionDetailModal({ row: row, onClose: onClose, onApprove: onApprove, actionKey: actionKey }) {
    if (!row) return null;
    const exceptionData = row.exception_data || {};
    const allExceptions = Object.entries(exceptionData);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card exception-modal-card",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "checker-exception-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Exception Detail"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "checker-exception-title",
                                    children: row.exception_type || "Invoice Exceptions"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                row.message ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mapping-note-card",
                    children: row.message
                }) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "exception-list",
                    children: allExceptions.map(([exceptionName, exceptionData])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fa35cf08dc84bb84$var$ExceptionTable, {
                            row: row,
                            exceptionName: exceptionName,
                            exceptionData: exceptionData,
                            onApprove: onApprove,
                            actionKey: actionKey
                        }, exceptionName))
                })
            ]
        })
    });
}
function $fa35cf08dc84bb84$var$ExceptionTable({ row: row, exceptionName: exceptionName, exceptionData: exceptionData, onApprove: onApprove, actionKey: actionKey }) {
    const isApproved = exceptionData?.status?.toLowerCase() === "approved";
    const isTaxException = exceptionName === "Mutual Tax Exclusivity";
    const isInvoiceValueException = [
        "No Invoice Value",
        "Invoice Value < Lower Limit",
        "Invoice Value > Upper Limit",
        "Migo > Invoice"
    ].includes(exceptionName);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `exception-table-card ${isApproved ? "exception-table-card--approved" : ""}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "exception-table-header",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: exceptionName
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: `exception-status ${isApproved ? "exception-status--approved" : "exception-status--pending"}`,
                            children: isApproved ? "Approved" : "Pending"
                        })
                    ]
                })
            }),
            isTaxException ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fa35cf08dc84bb84$var$TaxExceptionTable, {
                row: row,
                exceptionName: exceptionName,
                exceptionData: exceptionData,
                onApprove: onApprove,
                actionKey: actionKey,
                disabled: isApproved
            }) : isInvoiceValueException ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fa35cf08dc84bb84$var$InvoiceExceptionTable, {
                row: row,
                exceptionName: exceptionName,
                exceptionData: exceptionData,
                onApprove: onApprove,
                actionKey: actionKey,
                disabled: isApproved
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(GenericExceptionTable, {
                row: row,
                exceptionName: exceptionName,
                exceptionData: exceptionData,
                onApprove: onApprove,
                actionKey: actionKey,
                disabled: isApproved
            })
        ]
    });
}
function $fa35cf08dc84bb84$var$InvoiceExceptionTable({ row: row, exceptionName: exceptionName, exceptionData: exceptionData, onApprove: onApprove, actionKey: actionKey, disabled: disabled }) {
    const [invoiceValue, setInvoiceValue] = (0, $acw62.useState)(exceptionData.InvoiceValue ?? "");
    const actionId = `${row.InvoiceGroupKey}-${exceptionName}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                className: "exception-detail-table",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "Exception"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: exceptionName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "Message"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: exceptionData.message || "-"
                                })
                            ]
                        }),
                        exceptionData.MigoValue !== undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "MIGO Value"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: exceptionData.MigoValue
                                })
                            ]
                        }) : null,
                        exceptionData.LowerLimit !== undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "Lower Limit"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: exceptionData.LowerLimit
                                })
                            ]
                        }) : null,
                        exceptionData.UpperLimit !== undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "Upper Limit"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: exceptionData.UpperLimit
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "Invoice Value"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "number",
                                        step: "0.01",
                                        value: invoiceValue,
                                        onChange: (event)=>setInvoiceValue(event.target.value)
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "exception-table-actions",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "primary-button",
                    type: "button",
                    disabled: disabled || actionKey === `${row.InvoiceGroupKey}-${exceptionName}`,
                    onClick: ()=>onApprove(row, exceptionName, invoiceValue),
                    children: disabled ? "Already Approved" : actionKey === `${row.InvoiceGroupKey}-${exceptionName}` ? "Approving..." : "Approve Exception"
                })
            })
        ]
    });
}
function $fa35cf08dc84bb84$var$TaxExceptionTable({ row: row, exceptionName: exceptionName, exceptionData: exceptionData, onApprove: onApprove, actionKey: actionKey, disabled: disabled }) {
    const vendorGst = String(exceptionData.VendorGst || "");
    const customerGst = String(exceptionData.CustomerGst || "");
    const sameState = vendorGst.substring(0, 2) === customerGst.substring(0, 2);
    const allowedTaxType = sameState ? "CGST_SGST" : "IGST";
    const actionId = `${row.InvoiceGroupKey}-${exceptionName}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                className: "exception-detail-table",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "Vendor GST"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: vendorGst || "-"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "Customer GST"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: customerGst || "-"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "GST State Match"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: sameState ? "Same State" : "Different State"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "Allowed Tax"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: sameState ? "CGST + SGST" : "IGST"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "CGST"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: exceptionData.CGST || "-"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "SGST"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: exceptionData.SGST || "-"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "IGST"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: exceptionData.IGST || "-"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "exception-table-actions",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "primary-button",
                    type: "button",
                    disabled: disabled || actionKey === `${row.InvoiceGroupKey}-${exceptionName}`,
                    onClick: ()=>onApprove(row, exceptionName, allowedTaxType),
                    children: disabled ? "Already Approved" : actionKey === `${row.InvoiceGroupKey}-${exceptionName}` ? "Approving..." : `Approve ${sameState ? "CGST + SGST" : "IGST"}`
                })
            })
        ]
    });
}
function $fa35cf08dc84bb84$export$2e2bcd8739ae039() {
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [actionKey, setActionKey] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [detailRow, setDetailRow] = (0, $acw62.useState)(null);
    const [menuPosition, setMenuPosition] = (0, $acw62.useState)(null);
    const summary = (0, $acw62.useMemo)(()=>({
            count: rows.length,
            migoInvoice: rows.filter((row)=>row.exception_type === "Migo>Invoice").length,
            withResponse: rows.filter((row)=>row.unique_name).length
        }), [
        rows
    ]);
    const menuRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) setMenuPosition(null);
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    async function loadRows() {
        setLoading(true);
        setError("");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/get-exceptioninvoice-pending/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                }
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok) throw new Error(payload?.message || "Unable to load checker exceptions.");
            setRows(payload?.data || []);
        } catch (requestError) {
            setError(requestError.message || "Unable to load checker exceptions.");
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadRows();
    }, []);
    // async function handleApprove(row, invoiceValue) {
    //   const exceptionData = row.exception_data || {};
    //   const migoValue = Number(exceptionData.MigoValue || 0);
    //   const enteredValue = Number(invoiceValue);
    //   if (Number.isNaN(enteredValue)) {
    //     Swal.fire({
    //       icon: "warning",
    //       title: "Invalid Invoice Value",
    //       text: "Please enter a valid invoice value.",
    //     });
    //     return;
    //   }
    //   if (enteredValue < migoValue) {
    //     Swal.fire({
    //       icon: "warning",
    //       title: "Invoice Value Too Low",
    //       text: `Invoice value must be equal to or greater than the MIGO value (${migoValue}).`,
    //     });
    //     return;
    //   }
    //   const confirmResult = await Swal.fire({
    //     title: "Approve Exception?",
    //     text: "Are you sure you want to approve this exception?",
    //     icon: "question",
    //     showCancelButton: true,
    //     customClass: {
    //       popup: "swal-on-top",
    //     },
    //   });
    //   if (!confirmResult.isConfirmed) {
    //     return;
    //   }
    //   setActionKey(`approve-${row.InvoiceGroupKey}`);
    //   try {
    //     const csrfToken = await ensureCsrfToken();
    //     const response = await fetch(
    //       "/api/approve-invoicevalue_migovalue-exception/",
    //       {
    //         method: "POST",
    //         credentials: "include",
    //         headers: {
    //           "Content-Type": "application/json",
    //           "X-CSRFToken": csrfToken,
    //         },
    //         body: JSON.stringify({
    //           InvoiceGroupKey: row.InvoiceGroupKey,
    //           InvoiceValue: enteredValue,
    //         }),
    //       }
    //     );
    //     const isJson = response.headers
    //       .get("content-type")
    //       ?.includes("application/json");
    //     const payload = isJson ? await response.json() : null;
    //     if (!response.ok || !payload?.success) {
    //       throw new Error(payload?.message || "Approval failed.");
    //     }
    //     await Swal.fire({
    //       icon: "success",
    //       title: "Approved",
    //       text: payload.message || "Exception approved successfully.",
    //       timer: 1800,
    //       showConfirmButton: false,
    //     });
    //     setDetailRow(null);
    //     await loadRows();
    //   } catch (err) {
    //     Swal.fire({
    //       icon: "error",
    //       title: "Approval Failed",
    //       text: err.message || "Approval failed.",
    //     });
    //   } finally {
    //     setActionKey("");
    //   }
    // }
    async function handleApprove(row, exceptionName, approvalValue) {
        const exceptionData = row.exception_data?.[exceptionName] || {};
        const actionId = `${row.InvoiceGroupKey}-${exceptionName}`;
        const confirmResult = await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
            title: "Approve Exception?",
            text: `Are you sure you want to approve "${exceptionName}"?`,
            icon: "question",
            showCancelButton: true,
            customClass: {
                popup: "swal-on-top"
            }
        });
        if (!confirmResult.isConfirmed) return;
        setActionKey(actionId);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/approve-invoice-exception/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    InvoiceGroupKey: row.InvoiceGroupKey,
                    exception_name: exceptionName,
                    approval_value: approvalValue,
                    exception_data: exceptionData
                })
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok || !payload?.success) throw new Error(payload?.message || "Approval failed.");
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Approved",
                text: payload.message || "Exception approved successfully.",
                timer: 1800,
                showConfirmButton: false
            });
            setDetailRow((previousRow)=>{
                if (!previousRow) return previousRow;
                return {
                    ...previousRow,
                    exception_data: {
                        ...previousRow.exception_data,
                        [exceptionName]: {
                            ...previousRow.exception_data?.[exceptionName],
                            status: "approved"
                        }
                    }
                };
            });
            loadRows();
        } catch (err) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Approval Failed",
                text: err.message || "Approval failed."
            });
        } finally{
            setActionKey("");
        }
    }
    async function handleReject(row) {
        const confirmResult = await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
            title: "Reject Exception?",
            text: "Are you sure you want to reject this exception?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Reject",
            cancelButtonText: "Cancel",
            reverseButtons: true
        });
        if (!confirmResult.isConfirmed) return;
        setActionKey(`reject-${row.InvoiceGroupKey}`);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/reject-invoicevalue_migovalue-exception/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    invoice_group_key: row.InvoiceGroupKey
                })
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok || payload?.status !== "success") throw new Error(payload?.message || "Unable to reject exception.");
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Rejected",
                text: payload.message || "Exception rejected successfully.",
                timer: 1800,
                showConfirmButton: false
            });
            await loadRows();
        } catch (err) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Rejection Failed",
                text: err.message || "Unable to reject exception."
            });
        } finally{
            setActionKey("");
        }
    }
    function refreshPendingActions() {
        loadRows();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $96fe7c33bdd2f764$export$2e2bcd8739ae039), {
        title: "Checker Exception Approval",
        intro: "Please Approve/Reject Invoice exceptions",
        metrics: [
            {
                label: "Queue",
                value: summary.count
            }
        ],
        actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            className: "ghost-button processor-view__refresh",
            type: "button",
            onClick: refreshPendingActions,
            children: "Refresh"
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "processor-view",
            children: [
                status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "config-banner config-banner--success",
                    children: status
                }) : null,
                error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "config-banner config-banner--error",
                    children: error
                }) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "workspace-panel",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "processor-table__header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "eyebrow",
                                        children: "Exception queue"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "ghost-button",
                                    type: "button",
                                    onClick: loadRows,
                                    disabled: loading,
                                    children: loading ? "Refreshing..." : "Refresh"
                                })
                            ]
                        }),
                        loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "config-note",
                            children: "Loading exception approvals\u2026"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "config-table processor-table",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice ID"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Vendor Code"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Vendor Name"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice Number"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Message"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "File"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Response"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Exception"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Action"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                        children: rows.length ? rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.InvoiceId
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.VendorCode || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.VendorName || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.InvoiceNo || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.message || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.unique_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>(0, $e267546ad9d86d30$export$a38ce99a4bdccd4e)(row.InvoiceId),
                                                            children: "\uD83D\uDCCE"
                                                        }) : "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.unique_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            onClick: ()=>(0, $3d6d578a87c5904f$export$2926f86deb178d44)(`${row.unique_name}.json`),
                                                            children: "Data"
                                                        }) : "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: "ghost-button",
                                                            type: "button",
                                                            onClick: ()=>setDetailRow(row),
                                                            children: "View Exceptions"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "action-dropdown-wrapper",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "action-menu-button",
                                                                onClick: (e)=>{
                                                                    if (menuPosition?.row?.InvoiceGroupKey === row.InvoiceGroupKey) {
                                                                        setMenuPosition(null);
                                                                        return;
                                                                    }
                                                                    const rect = e.currentTarget.getBoundingClientRect();
                                                                    setMenuPosition({
                                                                        row: row,
                                                                        top: rect.bottom + window.scrollY,
                                                                        left: rect.left + window.scrollX
                                                                    });
                                                                },
                                                                children: "Actions \u25BC"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, row.InvoiceGroupKey)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                colSpan: "9",
                                                children: "No invoices found in the checker exception queue."
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fa35cf08dc84bb84$var$ExceptionDetailModal, {
                    row: detailRow,
                    onClose: ()=>setDetailRow(null),
                    onApprove: handleApprove,
                    actionKey: actionKey
                }),
                menuPosition && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "global-action-menu",
                    style: {
                        position: "fixed",
                        top: menuPosition.top,
                        left: menuPosition.left,
                        zIndex: 999999
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        disabled: actionKey === `reject-${menuPosition.row.InvoiceGroupKey}`,
                        onClick: ()=>{
                            handleReject(menuPosition.row);
                            setMenuPosition(null);
                        },
                        children: actionKey === `reject-${menuPosition.row.InvoiceGroupKey}` ? "Rejecting..." : "\u2715 Reject"
                    })
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");




function $90a432d2bdd32db5$var$isEmptyData(data) {
    if (data === null || data === undefined) return true;
    if (Array.isArray(data)) return data.length === 0;
    if (typeof data === "object") return Object.keys(data).length === 0;
    return false;
}
function $90a432d2bdd32db5$var$deepClone(data) {
    if (data === null || data === undefined) return data;
    return JSON.parse(JSON.stringify(data));
}
function $90a432d2bdd32db5$var$sanitizeNonStandardJson(raw) {
    let result = "";
    let inString = false;
    let escaped = false;
    for(let i = 0; i < raw.length; i++){
        const char = raw[i];
        if (inString) {
            result += char;
            if (escaped) escaped = false;
            else if (char === "\\") escaped = true;
            else if (char === '"') inString = false;
            continue;
        }
        if (char === '"') {
            inString = true;
            result += char;
            continue;
        }
        // Replace non-standard numeric tokens only outside strings.
        const remaining = raw.slice(i);
        const match = remaining.match(/^-Infinity|^(?:NaN|Infinity)\b/);
        if (match) {
            const token = match[0];
            const previous = i > 0 ? raw[i - 1] : "";
            const next = raw[i + token.length] ?? "";
            // Ensure the token is a complete JSON value, not part of a word.
            const validBefore = i === 0 || /[\s:[,{]/.test(previous);
            const validAfter = next === "" || /[\s,\]}]/.test(next);
            if (validBefore && validAfter) {
                result += "null";
                i += token.length - 1;
                continue;
            }
        }
        result += char;
    }
    return result;
}
function $90a432d2bdd32db5$var$parseRawData(rawData) {
    let value = rawData;
    // Parse repeatedly because the outer data and nested data
    // may each be JSON-encoded strings.
    for(let i = 0; i < 5 && typeof value === "string"; i++){
        const input = $90a432d2bdd32db5$var$sanitizeNonStandardJson(value);
        try {
            value = JSON.parse(input);
        } catch (error) {
            console.error("Unable to parse invoice-check data:", error);
            return null;
        }
    }
    return value;
}
function $90a432d2bdd32db5$var$isNumeric(val) {
    return !Number.isNaN(Number(val)) && val !== null && val !== "";
}
function $90a432d2bdd32db5$var$formatIndianInteger(value) {
    if (value === null || value === undefined) return "";
    const normalized = String(value).replace(/,/g, "");
    if (Number.isNaN(Number(normalized))) return String(value);
    const integer = String(Math.floor(Number(normalized)));
    const lastThree = integer.slice(-3);
    const other = integer.slice(0, -3);
    if (!other) return lastThree;
    return `${other.replace(/\B(?=(\d{2})+(?!\d))/g, ",")},${lastThree}`;
}
function $90a432d2bdd32db5$var$beautifyLabel(label) {
    if (!label) return "";
    const tokenOverrides = {
        grn: "GRN",
        ocr: "OCR",
        gst: "GST",
        gstr: "GSTR",
        "3b": "3B",
        of: "of",
        gstn: "GSTN",
        per: "per",
        on: "on",
        to: "to",
        as: "as",
        gl: "GL",
        migo: "MIGO",
        pan: "PAN",
        "206ab": "206AB",
        "(month1)": "(Month1)",
        "(month2)": "(Month2)",
        "(month3)": "(Month3)"
    };
    return String(label).replace(/_/g, " ").replace(/\s+/g, " ").trim().split(" ").map((word)=>{
        const token = word.toLowerCase();
        if (tokenOverrides[token]) return tokenOverrides[token];
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(" ");
}
function $90a432d2bdd32db5$var$getDisplayLabel(label, key) {
    const beautified = $90a432d2bdd32db5$var$beautifyLabel(label);
    const normalized = beautified.trim().toLowerCase();
    if (key === "r4" && (normalized === "vendor gstr 3b filing status" || normalized === "vendor gstr 1 filing status")) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "invoice-check-modal__label-strong",
        children: beautified
    });
    return beautified;
}
function $90a432d2bdd32db5$var$getGroupedHeaderCells(headers) {
    const hasUnitColumns = headers.includes("unit") && headers.includes("GRN_unit");
    const hasRemarkColumns = headers.includes("processor_remark") && headers.includes("checker_remark");
    const invoiceSpan = hasUnitColumns ? 4 : 3;
    const migoSpan = hasUnitColumns ? 5 : 4;
    const resultSpan = hasRemarkColumns ? 7 : 5;
    const remaining = headers.length - invoiceSpan - migoSpan;
    const groups = [
        {
            label: "Invoice",
            span: invoiceSpan
        },
        {
            label: "MIGO",
            span: migoSpan
        }
    ];
    if (remaining >= resultSpan) groups.push({
        label: "PO",
        span: 2
    }, {
        label: "Result",
        span: remaining - 2
    });
    else groups.push({
        label: "Result",
        span: Math.max(remaining, 1)
    });
    return groups;
}
function $90a432d2bdd32db5$var$getHeadersFromArray(data) {
    const headerSet = new Set();
    data.forEach((row)=>{
        Object.keys(row || {}).forEach((key)=>{
            if (String(key).toLowerCase() !== "color") headerSet.add(key);
        });
    });
    return Array.from(headerSet);
}
function $90a432d2bdd32db5$var$getHeadersFromObject(data) {
    const headerSet = new Set();
    Object.values(data || {}).forEach((row)=>{
        Object.keys(row || {}).forEach((key)=>{
            if (String(key).toLowerCase() !== "color") headerSet.add(key);
        });
    });
    return Array.from(headerSet);
}
function $90a432d2bdd32db5$var$isNestedObjectData(data) {
    if (!data || typeof data !== "object" || Array.isArray(data)) return false;
    const firstValue = Object.values(data)[0];
    return Boolean(firstValue) && typeof firstValue === "object" && !Array.isArray(firstValue);
}
function $90a432d2bdd32db5$var$getCellDisplayValue({ key: key, field: field, value: value }) {
    if (field === "processor_remark") return value ?? "";
    if (key !== "r6" && key !== "r7" && $90a432d2bdd32db5$var$isNumeric(value)) return $90a432d2bdd32db5$var$formatIndianInteger(value);
    if (value === null || value === undefined) return "";
    return String(value);
}
function $90a432d2bdd32db5$var$SectionTable({ data: data, keyName: keyName, sectionKey: sectionKey, remarks: remarks, onRemarkChange: onRemarkChange, disagreements: disagreements, onDisagreeChange: onDisagreeChange, scoringOptions: scoringOptions, r1Rows: r1Rows, onR1DragStart: onR1DragStart, onR1DragOver: onR1DragOver, onR1Drop: onR1Drop, onR1Break: onR1Break, onR1Zoom: onR1Zoom, disposedRecordIds: disposedRecordIds, onR1Action: onR1Action, isZoomed: isZoomed }) {
    if (Array.isArray(data)) {
        const headers = $90a432d2bdd32db5$var$getHeadersFromArray(data).filter((header)=>header !== "record_id");
        const isR1 = keyName === "r1";
        const rows = isR1 && Array.isArray(r1Rows) ? r1Rows : data;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "invoice-check-modal__table-wrap",
            children: [
                isR1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "invoice-check-modal__r1-tools",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "invoice-check-modal__help",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    children: [
                                        "\uD83D\uDDB1\uFE0F ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Join:"
                                        }),
                                        " Drag & Drop"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "invoice-check-modal__separator",
                                    children: "\u2022"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    children: [
                                        "\u2702\uFE0F ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Break:"
                                        }),
                                        " Double-click"
                                    ]
                                })
                            ]
                        }),
                        !isZoomed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onR1Zoom,
                            children: "Zoom"
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                    className: `invoice-check-modal__table ${isR1 ? "invoice-check-modal__table--r1" : ""}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("thead", {
                            children: [
                                isR1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: $90a432d2bdd32db5$var$getGroupedHeaderCells(headers).map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            colSpan: group.span,
                                            children: group.label
                                        }, `${sectionKey || "default"}-${group.label}`))
                                }) : null,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: headers.map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: $90a432d2bdd32db5$var$beautifyLabel(header)
                                        }, header))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                            children: rows.map((row, index)=>{
                                const rowIndex = row.__rowIndex ?? index;
                                const draggable = row.__draggable ?? row.status === "Unmatched_df2";
                                const isTemporaryRecord = typeof row.record_id === "string" && row.record_id.startsWith("temp_");
                                const hasRecordId = row.record_id !== null && row.record_id !== undefined && row.record_id !== "";
                                const droppable = row.__droppable ?? (!hasRecordId || isTemporaryRecord);
                                const breakable = row.__breakable ?? (hasRecordId && !isTemporaryRecord);
                                const hidden = row.__hidden === true;
                                const isDisposed = isR1 && row.record_id !== null && row.record_id !== undefined && disposedRecordIds.includes(row.record_id);
                                if (hidden) return null;
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    className: [
                                        draggable ? "invoice-check-modal__row--draggable" : "",
                                        droppable ? "invoice-check-modal__row--droppable" : "",
                                        row.__assigned ? "invoice-check-modal__row--assigned" : "",
                                        row.__dragOver ? "invoice-check-modal__row--drag-over" : "",
                                        isDisposed ? "invoice-check-modal__row--disposed" : ""
                                    ].filter(Boolean).join(" "),
                                    draggable: isR1 ? draggable : undefined,
                                    onDragStart: isR1 ? (event)=>onR1DragStart(event, rowIndex) : undefined,
                                    onDragOver: isR1 && droppable ? (event)=>onR1DragOver(event, rowIndex) : undefined,
                                    onDragLeave: isR1 ? ()=>onR1DragOver(null, null) : undefined,
                                    onDrop: isR1 && droppable ? (event)=>onR1Drop(event, rowIndex) : undefined,
                                    onDoubleClick: isR1 && breakable ? ()=>onR1Break(rowIndex) : undefined,
                                    children: headers.map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: header === "action" ? row.action === "set_unallocated" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "invoice-check-modal__action-dropdown",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        className: "invoice-check-modal__action-button",
                                                        onClick: ()=>onR1Action("set_unallocated", row.record_id, sectionKey, rowIndex, row.item_quantity, row.unit_price),
                                                        children: "Set Unallocated"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        className: "invoice-check-modal__action-button invoice-check-modal__action-button--dispose",
                                                        onClick: ()=>onR1Action("dispose", row.record_id, sectionKey, rowIndex, row.item_quantity, row.unit_price),
                                                        children: "Dispose"
                                                    })
                                                ]
                                            }) : row.action === "dispose" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: "invoice-check-modal__action-button invoice-check-modal__action-button--dispose",
                                                onClick: ()=>onR1Action("dispose", row.record_id, sectionKey, rowIndex, row.item_quantity, row.unit_price),
                                                children: "Dispose"
                                            }) : null : header === "processor_remark" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                className: "invoice-check-modal__remark-input",
                                                type: "text",
                                                maxLength: 50,
                                                value: remarks[`${sectionKey || "default"}::${rowIndex}::${header}`] ?? row[header] ?? "",
                                                onChange: (event)=>onRemarkChange(sectionKey, rowIndex, header, event.target.value),
                                                placeholder: "Enter remark..."
                                            }) : header === "Reason" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "reason-tooltip",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "reason-badge",
                                                        children: "View"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "reason-tooltip__content",
                                                        children: row[header]
                                                    })
                                                ]
                                            }) : header === "item_description" || header === "GRN_description" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "description-cell",
                                                title: row[header] ?? "",
                                                children: row[header]
                                            }) : $90a432d2bdd32db5$var$getCellDisplayValue({
                                                key: keyName,
                                                field: header,
                                                value: row[header]
                                            })
                                        }, `${rowIndex}-${header}`))
                                }, String(rowIndex));
                            })
                        })
                    ]
                })
            ]
        });
    }
    if ($90a432d2bdd32db5$var$isNestedObjectData(data)) {
        const headers = $90a432d2bdd32db5$var$getHeadersFromObject(data);
        const hasDisagreementRemark = Object.entries(disagreements).some(([compositeKey, value])=>{
            const [disagreementSectionKey] = compositeKey.split("::");
            return disagreementSectionKey === (sectionKey || "default") && value === true;
        });
        const displayHeaders = headers.includes("processor_remark") ? headers : hasDisagreementRemark ? [
            ...headers,
            "processor_remark"
        ] : headers;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "invoice-check-modal__table-wrap",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                className: "invoice-check-modal__table",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "Parameter"
                                }),
                                displayHeaders.map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: $90a432d2bdd32db5$var$beautifyLabel(header)
                                    }, header))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                        children: Object.entries(data).map(([rowId, row])=>{
                            const disagreementKey = `${sectionKey || "default"}::${rowId}`;
                            const isDisagreed = disagreements[disagreementKey] ?? row?.disagree ?? false;
                            // Get dropdown options for this specific parameter
                            const options = scoringOptions?.[sectionKey]?.[rowId] || [];
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: $90a432d2bdd32db5$var$getDisplayLabel(rowId, keyName)
                                    }),
                                    displayHeaders.map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: header === "disagree" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: `invoice-check-modal__disagree-button ${isDisagreed ? "invoice-check-modal__disagree-button--revert" : ""}`,
                                                onClick: ()=>onDisagreeChange(sectionKey, rowId, !isDisagreed),
                                                children: isDisagreed ? "Revert" : "Disagree"
                                            }) : header === "processor_remark" ? isDisagreed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "invoice-check-modal__explanation",
                                                title: remarks[`${sectionKey || "default"}::${rowId}::processor_remark`] ?? row?.processor_remark ?? "No explanation provided.",
                                                children: "Explanation"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                className: "invoice-check-modal__remark-input",
                                                type: "text",
                                                maxLength: 50,
                                                value: remarks[`${sectionKey || "default"}::${rowId}::processor_remark`] ?? row?.processor_remark ?? "",
                                                onChange: (event)=>onRemarkChange(sectionKey, rowId, "processor_remark", event.target.value),
                                                placeholder: "Enter remark..."
                                            }) : $90a432d2bdd32db5$var$getCellDisplayValue({
                                                key: keyName,
                                                field: header,
                                                value: row?.[header]
                                            })
                                        }, `${rowId}-${header}`))
                                ]
                            }, rowId);
                        })
                    })
                ]
            })
        });
    }
    if (data && typeof data === "object") {
        const headers = Object.keys(data).filter((header)=>String(header).toLowerCase() !== "color");
        const hasDisagreement = Object.entries(disagreements).some(([compositeKey, value])=>{
            const [disagreementSectionKey] = compositeKey.split("::");
            return disagreementSectionKey === (sectionKey || "default") && value === true;
        });
        const displayHeaders = headers.includes("processor_remark") ? headers : hasDisagreement ? [
            ...headers,
            "processor_remark"
        ] : headers;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "invoice-check-modal__table-wrap",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                className: "invoice-check-modal__table",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "Parameter"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "Status/Value"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                        children: displayHeaders.map((header)=>{
                            const disagreementKey = `${sectionKey || "default"}::flat`;
                            const isDisagreed = disagreements[disagreementKey] ?? data?.disagree ?? false;
                            // For flat data, header itself is the parameter name
                            const options = scoringOptions?.[sectionKey]?.[header] || [];
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: $90a432d2bdd32db5$var$getDisplayLabel(header, keyName)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: header === "disagree" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: `invoice-check-modal__disagree-button ${isDisagreed ? "invoice-check-modal__disagree-button--revert" : ""}`,
                                            onClick: ()=>onDisagreeChange(sectionKey, "flat", !isDisagreed),
                                            children: isDisagreed ? "Revert" : "Disagree"
                                        }) : header === "processor_remark" ? isDisagreed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            className: "invoice-check-modal__remark-select",
                                            value: remarks[`${sectionKey || "default"}::flat::processor_remark`] ?? data?.processor_remark ?? "",
                                            onChange: (event)=>onRemarkChange(sectionKey, "flat", "processor_remark", event.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "",
                                                    children: "Select reason..."
                                                }),
                                                options.map((option, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: option,
                                                        children: option
                                                    }, `flat-option-${index}`))
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "invoice-check-modal__no-disagreement",
                                            children: "\u2014"
                                        }) : $90a432d2bdd32db5$var$getCellDisplayValue({
                                            key: keyName,
                                            field: header,
                                            value: data[header]
                                        })
                                    })
                                ]
                            }, header);
                        })
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "empty-state",
        children: "Unsupported data format."
    });
}
function $90a432d2bdd32db5$var$buildUpdatedSectionData(sectionData, remarks, disagreements, sectionKey) {
    const cloned = $90a432d2bdd32db5$var$deepClone(sectionData);
    const sectionToken = sectionKey || "default";
    // --------------------------------------------------
    // 1. Apply processor remarks
    // --------------------------------------------------
    Object.entries(remarks).forEach(([compositeKey, value])=>{
        const [remarkSectionKey, rowId, field] = compositeKey.split("::");
        if (remarkSectionKey !== sectionToken || field !== "processor_remark") return;
        if (!value.trim()) return;
        // Array - kept for existing functionality
        if (Array.isArray(cloned)) {
            const index = Number(rowId);
            if (Number.isInteger(index) && cloned[index]) cloned[index][field] = value.trim();
            return;
        }
        // Nested object
        if ($90a432d2bdd32db5$var$isNestedObjectData(cloned)) {
            if (cloned[rowId] && typeof cloned[rowId] === "object") cloned[rowId][field] = value.trim();
            return;
        }
        // Flat object
        if (cloned && typeof cloned === "object" && rowId === "flat") cloned[field] = value.trim();
    });
    // --------------------------------------------------
    // 2. Apply disagree / revert state
    // --------------------------------------------------
    Object.entries(disagreements).forEach(([compositeKey, value])=>{
        const [disagreementSectionKey, rowId] = compositeKey.split("::");
        if (disagreementSectionKey !== sectionToken) return;
        // IMPORTANT:
        // R1 is handled separately by buildR1Payload().
        // We don't need disagreement handling here for arrays.
        if (Array.isArray(cloned)) return;
        // Nested object
        if ($90a432d2bdd32db5$var$isNestedObjectData(cloned)) {
            if (cloned[rowId] && typeof cloned[rowId] === "object") cloned[rowId].disagree = Boolean(value);
            return;
        }
        // Flat object
        if (cloned && typeof cloned === "object" && rowId === "flat") cloned.disagree = Boolean(value);
    });
    return cloned;
}
function $90a432d2bdd32db5$var$normalizeR1Rows(data) {
    if (!Array.isArray(data)) return [];
    return data.map((row, index)=>({
            ...$90a432d2bdd32db5$var$deepClone(row),
            __rowIndex: index,
            __draggable: row?.status === "Unmatched_df2",
            __droppable: row?.index_matching === null || row?.index_matching === "",
            __breakable: row?.index_matching !== null && row?.index_matching !== "",
            __hidden: false,
            __assigned: false,
            __dragOver: false
        }));
}
function $90a432d2bdd32db5$var$buildR1Payload(rows) {
    return rows.filter((row)=>!row.__hidden).map((row)=>{
        const cleaned = {};
        Object.entries(row).forEach(([key, value])=>{
            if (!key.startsWith("__")) cleaned[key] = value === "" ? null : value;
        });
        return cleaned;
    });
}
function $90a432d2bdd32db5$export$2e2bcd8739ae039({ detail: detail, invoiceRow: invoiceRow, scoringOptions: scoringOptions, onClose: onClose, onSaved: onSaved }) {
    const parsedData = (0, $acw62.useMemo)(()=>$90a432d2bdd32db5$var$parseRawData(detail?.data), [
        detail
    ]);
    const isMultiSection = (0, $acw62.useMemo)(()=>[
            "r1",
            "r2",
            "r5",
            "r6"
        ].includes(detail?.key) && parsedData && typeof parsedData === "object" && !Array.isArray(parsedData), [
        detail?.key,
        parsedData
    ]);
    const [remarks, setRemarks] = (0, $acw62.useState)({});
    const [r1RowsBySection, setR1RowsBySection] = (0, $acw62.useState)({});
    const [dragSource, setDragSource] = (0, $acw62.useState)(null);
    const [savingSection, setSavingSection] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [zoomedSection, setZoomedSection] = (0, $acw62.useState)("");
    const [disposeRecordIds, setDisposeRecordIds] = (0, $acw62.useState)([]);
    const [showUnallocatedModal, setShowUnallocatedModal] = (0, $acw62.useState)(false);
    const [unplannedForm, setUnplannedForm] = (0, $acw62.useState)(null);
    const [unplannedValues, setUnplannedValues] = (0, $acw62.useState)({});
    const [unallocatedRecordId, setUnallocatedRecordId] = (0, $acw62.useState)(null);
    const [unallocatedCostData, setUnallocatedCostData] = (0, $acw62.useState)(null);
    const [lineItemvalue, setLineItemValue] = (0, $acw62.useState)(null);
    const [unallocatedRowIndex, setUnallocatedRowIndex] = (0, $acw62.useState)(null);
    const [disagreements, setDisagreements] = (0, $acw62.useState)({});
    (0, $acw62.useEffect)(()=>{
        setRemarks({});
        setDragSource(null);
        setSavingSection("");
        setError("");
        if (detail?.key === "r1" && parsedData && typeof parsedData === "object" && !Array.isArray(parsedData)) {
            const nextState = {};
            Object.entries(parsedData).forEach(([sectionKey, sectionValue])=>{
                const sectionRows = Array.isArray(sectionValue?.data) ? sectionValue.data : sectionValue;
                nextState[sectionKey] = $90a432d2bdd32db5$var$normalizeR1Rows(sectionRows);
            });
            setR1RowsBySection(nextState);
            return;
        }
        setR1RowsBySection({});
    }, [
        detail,
        parsedData
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!detail) return undefined;
        function handleEscape(event) {
            if (event.key === "Escape") onClose();
        }
        window.addEventListener("keydown", handleEscape);
        return ()=>window.removeEventListener("keydown", handleEscape);
    }, [
        detail,
        onClose
    ]);
    if (!detail) return null;
    async function loadUnplannedCostForm(materialService) {
        try {
            const payload = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/invoice/unplanned-cost-form/", {
                method: "POST",
                body: {
                    invoice_keys: invoiceRow.invoiceGroupKey,
                    material_service: materialService
                }
            });
            setUnplannedForm(payload);
            const defaults = {};
            Object.values(payload.normal_fields || {}).forEach((field)=>{
                defaults[field.field] = field.default || "";
            });
            Object.values(payload.grn_fields || {}).forEach((field)=>{
                defaults[field.field] = field.default || "";
            });
            Object.values(payload.po_fields || {}).forEach((field)=>{
                defaults[field.field] = field.default || "";
            });
            defaults.amount = "";
            setUnplannedValues(defaults);
            return payload;
        } catch (error) {
            console.error("Unable to load unallocated cost form:", error);
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Unable to Open Unallocated Cost",
                text: error.message || "Unable to load unallocated cost form."
            });
            return null;
        }
    }
    const handleR1Action = async (action, recordId, sectionKey, rowIndex, rowitem_quantity, rowitem_rate)=>{
        console.log("R1 Action:", action);
        console.log("Record ID:", recordId);
        console.log("sectionKey:", sectionKey);
        if (action === "dispose") {
            if (recordId === null || recordId === undefined || recordId === "") return;
            setDisposeRecordIds((prev)=>prev.includes(recordId) ? prev : [
                    ...prev,
                    recordId
                ]);
            return;
        }
        if (action === "set_unallocated") {
            /*
      * Check the invoice-vs-MIGO rule first.
      *
      * We need to use the section3 values that are already
      * available on this page.
      */ const invoiceValue = Number(invoiceRow?.invoiceValue || 0);
            const invoiceValueMigo = Number(invoiceRow?.invoiceMigoValue || 0);
            const LineItemvalue = Number(rowitem_quantity || 0) * Number(rowitem_rate || 0);
            setLineItemValue(LineItemvalue);
            if (invoiceValue <= invoiceValueMigo) {
                const result = await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                    icon: "warning",
                    title: "Cannot Create Unallocated Cost",
                    text: "Invoice Value is equal to or less than MIGO Value. Unallocated Cost cannot be created.",
                    showCancelButton: true,
                    confirmButtonText: "Reject Invoice",
                    cancelButtonText: "Proceed"
                });
                /*
        * User selected Reject Invoice
        */ if (result.isConfirmed) // Put your existing reject-invoice logic here.
                // Example:
                // await rejectInvoice();
                return;
            /*
        * User selected Proceed.
        *
        * Continue to unallocated cost form.
        */ }
            /*
      * Load the dynamic unallocated-cost form.
      */ const materialService = detail?.material_service || invoiceRow.material_service || "material";
            const payload = await loadUnplannedCostForm(materialService);
            if (!payload) return;
            /*
      * Remember which row this form belongs to.
      */ setUnallocatedRecordId(recordId);
            setUnallocatedRowIndex(rowIndex);
            /*
      * Open popup.
      */ setShowUnallocatedModal(true);
        }
    };
    function updateUnplannedField(field, value) {
        setUnplannedValues((current)=>({
                ...current,
                [field]: value
            }));
    }
    function handleUnallocatedCostSave() {
        const temporaryRecordId = r1RowsBySection["2/3 Way Match"]?.[unallocatedRowIndex]?.record_id;
        console.log("Saving unallocated cost");
        console.log("Selected row index:", unallocatedRowIndex);
        console.log("Form values:", unplannedValues);
        // ---------------------------------------------
        // 1. Save complete form data separately
        // ---------------------------------------------
        setUnallocatedCostData({
            ...unplannedValues,
            record_id: temporaryRecordId
        });
        // ---------------------------------------------
        // 2. Update ONLY the selected R1 table row
        // ---------------------------------------------
        setR1RowsBySection((current)=>({
                ...current,
                "2/3 Way Match": (current["2/3 Way Match"] || []).map((item, index)=>{
                    // Don't touch other rows
                    if (index !== unallocatedRowIndex) return item;
                    // Update selected row
                    return {
                        ...item,
                        record_id: temporaryRecordId,
                        GRN_description: unplannedValues.item_descritption || "Unallocated Cost",
                        GRN_qty: 1,
                        GRN_rate: Number(unplannedValues.amount || 0),
                        status: "Manually Matched (Unallocated Cost)",
                        Reason: "Manually matched using Unallocated Cost",
                        action: null
                    };
                })
            }));
        // ---------------------------------------------
        // 3. Store temporary ID
        // ---------------------------------------------
        setUnallocatedRecordId(temporaryRecordId);
        // ---------------------------------------------
        // 4. Close popup
        // ---------------------------------------------
        setShowUnallocatedModal(false);
        // Optional cleanup
        setUnallocatedRowIndex(null);
    }
    function handleRemarkChange(sectionKey, rowId, field, value) {
        setRemarks((current)=>({
                ...current,
                [`${sectionKey || "default"}::${rowId}::${field}`]: value
            }));
    }
    function handleDisagreeChange(sectionKey, rowId, value) {
        setDisagreements((current)=>({
                ...current,
                [`${sectionKey || "default"}::${rowId}`]: value
            }));
    }
    function updateR1Section(sectionKey, updater) {
        setR1RowsBySection((current)=>({
                ...current,
                [sectionKey]: updater(current[sectionKey] || [])
            }));
    }
    function handleR1DragStart(event, rowIndex) {
        setDragSource(rowIndex);
        event.dataTransfer.effectAllowed = "move";
        event.dataTransfer.setData("text/plain", String(rowIndex));
    }
    function handleR1DragOver(sectionKey, targetRowIndex) {
        updateR1Section(sectionKey, (rows)=>rows.map((row)=>({
                    ...row,
                    __dragOver: row.__rowIndex === targetRowIndex
                })));
    }
    function handleR1Drop(event, sectionKey, targetRowIndex) {
        event.preventDefault();
        const sourceRowIndex = dragSource ?? event.dataTransfer.getData("text/plain");
        updateR1Section(sectionKey, (rows)=>{
            const sourceRow = rows.find((row)=>String(row.__rowIndex) === String(sourceRowIndex));
            const targetRow = rows.find((row)=>String(row.__rowIndex) === String(targetRowIndex));
            if (!sourceRow || !targetRow) return rows.map((row)=>({
                    ...row,
                    __dragOver: false
                }));
            if (targetRow.__assigned) {
                setError("This invoice row is already manually matched.");
                return rows.map((row)=>({
                        ...row,
                        __dragOver: false
                    }));
            }
            setError("");
            const grnColumns = [
                "GRN_description",
                "GRN_qty",
                "GRN_rate"
            ];
            const poColumns = [
                "po_qty",
                "po_rate"
            ];
            const matchingIndex = String(sourceRow.index_matching ?? "").trim();
            return rows.map((row)=>{
                if (String(row.__rowIndex) === String(targetRowIndex)) {
                    const updated = {
                        ...row,
                        index_matching: matchingIndex,
                        status: "Manually Matched",
                        Reason: "Manually matched by user",
                        __assigned: true,
                        __droppable: false,
                        __breakable: true,
                        __dragOver: false
                    };
                    [
                        ...grnColumns,
                        ...poColumns
                    ].forEach((column)=>{
                        updated[column] = sourceRow[column] ?? "";
                    });
                    return updated;
                }
                if (String(row.__rowIndex) === String(sourceRowIndex)) return {
                    ...row,
                    __hidden: true,
                    __dragOver: false
                };
                return {
                    ...row,
                    __dragOver: false
                };
            });
        });
        setDragSource(null);
    }
    function handleR1Break(sectionKey, rowIndex) {
        updateR1Section(sectionKey, (rows)=>{
            const targetRow = rows.find((row)=>String(row.__rowIndex) === String(rowIndex));
            if (!targetRow) return rows;
            const headers = Object.keys(targetRow).filter((key)=>!key.startsWith("__"));
            const originalMatchingIndex = targetRow.index_matching;
            const grnColumns = [
                "GRN_description",
                "GRN_qty",
                "GRN_rate",
                "po_qty",
                "po_rate"
            ];
            const timestampIndex = `new_${Date.now()}`;
            const splitRow = {};
            headers.forEach((header)=>{
                splitRow[header] = grnColumns.includes(header) ? targetRow[header] ?? "-" : "-";
            });
            splitRow.index_matching = originalMatchingIndex;
            splitRow.status = "Unmatched_df2";
            splitRow.Reason = "Match broken by user";
            return rows.flatMap((row)=>{
                if (String(row.__rowIndex) !== String(rowIndex)) return [
                    {
                        ...row,
                        __dragOver: false
                    }
                ];
                const invoiceOnlyRow = {
                    ...row,
                    GRN_description: "",
                    GRN_qty: "",
                    GRN_rate: "",
                    po_qty: "",
                    po_rate: "",
                    index_matching: "",
                    status: "Unmatched",
                    Reason: "Match broken by user",
                    __droppable: true,
                    __breakable: false,
                    __assigned: false,
                    __dragOver: false
                };
                const newMigoRow = {
                    ...splitRow,
                    __rowIndex: timestampIndex,
                    __draggable: true,
                    __droppable: false,
                    __breakable: false,
                    __hidden: false,
                    __assigned: false,
                    __dragOver: false
                };
                return [
                    invoiceOnlyRow,
                    newMigoRow
                ];
            });
        });
    }
    async function handleSave(sectionKey, sectionData) {
        setSavingSection(sectionKey || "default");
        setError("");
        try {
            let updatedData;
            // R1 remains completely unchanged
            if (detail.key === "r1" && sectionKey === "2/3 Way Match") updatedData = $90a432d2bdd32db5$var$buildR1Payload(r1RowsBySection[sectionKey] || []);
            else // Normal scoring tables
            updatedData = $90a432d2bdd32db5$var$buildUpdatedSectionData(sectionData, remarks, disagreements, sectionKey);
            const response = await fetch("/api/update-remark/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    key: detail.key,
                    uniqueKey: detail.uniqueKey,
                    sectionKey: sectionKey,
                    role: "processor",
                    updated_data: updatedData,
                    dispose_record_ids: detail.key === "r1" && sectionKey === "2/3 Way Match" ? disposeRecordIds : [],
                    unallocated_cost_data: detail.key === "r1" && sectionKey === "2/3 Way Match" ? unallocatedCostData : null
                })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result?.message || "Unable to save remarks.");
            window.alert(result?.message || "Remarks saved successfully.");
            onSaved?.();
            onClose();
        } catch (requestError) {
            setError(requestError.message || "Unable to save remarks.");
        } finally{
            setSavingSection("");
        }
    }
    function renderSection(sectionKey, sectionValue) {
        const parsedSectionValue = $90a432d2bdd32db5$var$parseRawData(sectionValue);
        const sectionData = parsedSectionValue?.data ?? parsedSectionValue;
        const hasRemarkField = (()=>{
            if (Array.isArray(sectionData)) return sectionData.some((row)=>Object.prototype.hasOwnProperty.call(row || {}, "processor_remark"));
            if ($90a432d2bdd32db5$var$isNestedObjectData(sectionData)) return Object.values(sectionData).some((row)=>Object.prototype.hasOwnProperty.call(row || {}, "processor_remark"));
            return Boolean(sectionData && typeof sectionData === "object" && "processor_remark" in sectionData);
        })();
        const hasDisagreement = Object.entries(disagreements).some(([compositeKey, value])=>{
            const [disagreementSectionKey] = compositeKey.split("::");
            return disagreementSectionKey === (sectionKey || "default") && value === true;
        });
        const shouldShowSaveAction = hasRemarkField || hasDisagreement || detail.key === "r1" && sectionKey === "2/3 Way Match";
        const content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                sectionKey && !zoomedSection ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "invoice-check-modal__section-header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "invoice-check-modal__section-title",
                            children: sectionKey
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "invoice-check-modal__section-score",
                            children: [
                                "Table Reliability:",
                                " ",
                                invoiceRow?.averageTableScores?.[sectionKey] != null ? Number(invoiceRow.averageTableScores[sectionKey]).toFixed(2) : "\u2014"
                            ]
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($90a432d2bdd32db5$var$SectionTable, {
                    data: sectionData,
                    keyName: detail.key,
                    sectionKey: sectionKey,
                    remarks: remarks,
                    onRemarkChange: handleRemarkChange,
                    disagreements: disagreements,
                    onDisagreeChange: handleDisagreeChange,
                    scoringOptions: scoringOptions,
                    r1Rows: r1RowsBySection[sectionKey],
                    // isZoomed={zoomedSection === sectionKey}
                    isZoomed: detail.key === "r1" && zoomedSection === sectionKey,
                    onR1DragStart: handleR1DragStart,
                    onR1DragOver: (event, rowIndex)=>{
                        if (event) event.preventDefault();
                        handleR1DragOver(sectionKey, rowIndex);
                    },
                    onR1Drop: (event, rowIndex)=>handleR1Drop(event, sectionKey, rowIndex),
                    onR1Break: (rowIndex)=>handleR1Break(sectionKey, rowIndex),
                    onR1Zoom: ()=>setZoomedSection(sectionKey),
                    disposedRecordIds: disposeRecordIds,
                    onR1Action: handleR1Action
                }),
                shouldShowSaveAction ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "invoice-check-modal__actions",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "primary-button",
                        type: "button",
                        disabled: savingSection === (sectionKey || "default"),
                        onClick: ()=>handleSave(sectionKey, sectionData),
                        children: savingSection === (sectionKey || "default") ? "Saving..." : "Save Remark"
                    })
                }) : null
            ]
        });
        // const isZoomed = zoomedSection === sectionKey;
        const isZoomed = detail.key === "r1" && zoomedSection === sectionKey;
        return isZoomed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "invoice-check-modal__zoom-shell",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "invoice-check-modal__zoom-header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "invoice-check-modal__zoom-title",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: sectionKey
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "invoice-check-modal__section-score",
                                    children: [
                                        "Table Reliability:",
                                        " ",
                                        invoiceRow?.averageTableScores?.[sectionKey] != null ? Number(invoiceRow.averageTableScores[sectionKey]).toFixed(2) : "\u2014"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: ()=>setZoomedSection(""),
                            children: "Exit Zoom"
                        })
                    ]
                }),
                content
            ]
        }) : content;
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `processor-modal__card processor-modal__card--wide invoice-check-modal ${zoomedSection ? "invoice-check-modal--zoomed" : ""}`,
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "invoice-check-detail-title",
                onClick: (event)=>event.stopPropagation(),
                children: [
                    !zoomedSection && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "processor-modal__header",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "eyebrow",
                                        children: "Status Detail"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        id: "invoice-check-detail-title",
                                        children: detail.message || detail.label
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "ghost-button",
                                type: "button",
                                onClick: onClose,
                                children: "Close"
                            })
                        ]
                    }),
                    !zoomedSection && detail.message && detail.message !== detail.label ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "config-note",
                        children: detail.message
                    }) : null,
                    error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-banner config-banner--error",
                        children: error
                    }) : null,
                    $90a432d2bdd32db5$var$isEmptyData(parsedData) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "empty-state",
                        children: "No data available for this check."
                    }) : isMultiSection ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "invoice-check-modal__sections",
                        children: Object.entries(parsedData).filter(([sectionKey])=>!zoomedSection || sectionKey === zoomedSection).map(([sectionKey, sectionValue])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                                className: "invoice-check-modal__section",
                                children: renderSection(sectionKey, sectionValue)
                            }, sectionKey))
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        className: "invoice-check-modal__section",
                        children: renderSection("", parsedData)
                    })
                ]
            }),
            showUnallocatedModal && /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "unallocated-modal-overlay",
                onClick: ()=>setShowUnallocatedModal(false),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "unallocated-modal",
                    onClick: (event)=>event.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "unallocated-modal__header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            children: "Unallocated Cost"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: "Add unallocated cost details for this invoice item"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "unallocated-modal__close",
                                    onClick: ()=>{
                                        setShowUnallocatedModal(false);
                                        setLineItemValue(null);
                                    },
                                    children: "\xd7"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "unallocated-modal__body",
                            children: (()=>{
                                const invoiceValue = Number(invoiceRow.invoiceValue || 0);
                                const invoiceValueMigo = Number(invoiceRow.invoiceMigoValue || 0);
                                // console.log("invoiceValue",invoiceValue);
                                // console.log("invoiceValueMigo",invoiceValueMigo);
                                // console.log("LineItemValue",lineItemvalue);
                                const existingUnallocatedCost = Number(invoiceRow?.unallocatedCostValue || 0);
                                const availableDifference = invoiceValue - invoiceValueMigo - existingUnallocatedCost;
                                const processorConfig = unplannedForm?.unallocated_cost_config?.processor || {};
                                const thresholdAmount = Number(processorConfig.threshold_amount || 0);
                                const thresholdPercent = Number(processorConfig.threshold_percent || 0);
                                const thresholdPercentValue = invoiceValue * thresholdPercent / 100;
                                let configuredMaxAmount = 0;
                                if (processorConfig.condition === "OR") configuredMaxAmount = Math.min(thresholdAmount, thresholdPercentValue);
                                else configuredMaxAmount = Math.max(thresholdAmount, thresholdPercentValue);
                                const _maxAllowedAmount = Math.min(configuredMaxAmount, availableDifference);
                                const maxAllowedAmount = Math.min(_maxAllowedAmount, lineItemvalue);
                                const enteredAmount = Number(unplannedValues.amount || 0);
                                const thresholdConfigured = thresholdAmount > 0 || thresholdPercent > 0;
                                const canCreate = availableDifference > 0 && thresholdConfigured && maxAllowedAmount > 0;
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "unallocated-modal__summary",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "unallocated-summary-card",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Invoice Value (OCR)"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: invoiceValue
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "unallocated-summary-card",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Invoice Value (MIGO)"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: invoiceValueMigo
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "unallocated-summary-card",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Existing Unallocated Cost"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: existingUnallocatedCost
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "unallocated-summary-card",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Available Difference"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: availableDifference
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        canCreate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "unallocated-modal__info",
                                            children: [
                                                "Maximum Allowed Amount:",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: maxAllowedAmount
                                                })
                                            ]
                                        }),
                                        !thresholdConfigured && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "unallocated-modal__warning",
                                            children: "No threshold configured for Processor."
                                        }),
                                        availableDifference <= 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "unallocated-modal__warning",
                                            children: "Invoice Value must be greater than Invoice Value (MIGO) before Unallocated Cost can be created."
                                        }),
                                        canCreate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "unallocated-section",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                            children: "Unallocated Cost Details"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "unallocated-form-grid",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            children: "Amount"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                            type: "number",
                                                                            min: "0",
                                                                            max: maxAllowedAmount,
                                                                            value: unplannedValues.amount || "",
                                                                            onChange: (event)=>{
                                                                                const value = event.target.value;
                                                                                if (value === "") {
                                                                                    updateUnplannedField("amount", "");
                                                                                    return;
                                                                                }
                                                                                const numericValue = Math.min(Number(value), maxAllowedAmount);
                                                                                updateUnplannedField("amount", numericValue);
                                                                            }
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            children: "Description"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                            type: "text",
                                                                            value: unplannedValues.item_descritption || "",
                                                                            onChange: (event)=>updateUnplannedField("item_descritption", event.target.value)
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            children: "Tax Code"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                            value: unplannedValues.TaxCode || "",
                                                                            onChange: (event)=>updateUnplannedField("TaxCode", event.target.value),
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                    value: "",
                                                                                    children: "Select Tax Code"
                                                                                }),
                                                                                (unplannedForm?.gst_taxcode_list || []).map((code)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                        value: code,
                                                                                        children: code
                                                                                    }, code))
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            children: "Withholding Tax Code"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                            value: unplannedValues.WithholdingTaxCode || "",
                                                                            onChange: (event)=>updateUnplannedField("WithholdingTaxCode", event.target.value),
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                    value: "",
                                                                                    children: "Select Withholding Tax"
                                                                                }),
                                                                                (unplannedForm?.wtaxcode_list || []).map((code)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                        value: code,
                                                                                        children: code
                                                                                    }, code))
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                unplannedForm?.unallocated_cost_config?.add_to_material_service === "Y" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            children: "GL Account"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                            type: "text",
                                                                            value: unplannedValues.GLAccount || "",
                                                                            readOnly: true
                                                                        })
                                                                    ]
                                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            children: "GL Account"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                            value: unplannedValues.GLAccount || "",
                                                                            onChange: (event)=>updateUnplannedField("GLAccount", event.target.value),
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                    value: "",
                                                                                    children: "Select GL Code"
                                                                                }),
                                                                                (unplannedForm?.gl_list || []).map((gl)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                        value: gl.code,
                                                                                        children: gl.description ? `${gl.code} (${gl.description})` : gl.code
                                                                                    }, gl.code))
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                Object.keys(unplannedForm?.grn_fields || {}).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "unallocated-section",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                            children: "GRN Information"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "unallocated-form-grid",
                                                            children: Object.values(unplannedForm?.grn_fields || {}).map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            children: field.field
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                            type: "text",
                                                                            value: unplannedValues[field.field] || "",
                                                                            onChange: (event)=>updateUnplannedField(field.field, event.target.value)
                                                                        })
                                                                    ]
                                                                }, `grn-${field.field}`))
                                                        })
                                                    ]
                                                }),
                                                Object.keys(unplannedForm?.po_fields || {}).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "unallocated-section",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                            children: "PO Information"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "unallocated-form-grid",
                                                            children: Object.values(unplannedForm?.po_fields || {}).map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            children: field.field
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                            type: "text",
                                                                            value: unplannedValues[field.field] || "",
                                                                            onChange: (event)=>updateUnplannedField(field.field, event.target.value)
                                                                        })
                                                                    ]
                                                                }, `po-${field.field}`))
                                                        })
                                                    ]
                                                }),
                                                enteredAmount > maxAllowedAmount && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "unallocated-modal__warning",
                                                    children: [
                                                        "Maximum allowed amount is ",
                                                        maxAllowedAmount
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                });
                            })()
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "unallocated-modal__footer",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "unallocated-btn unallocated-btn--secondary",
                                    onClick: ()=>setShowUnallocatedModal(false),
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "unallocated-btn unallocated-btn--primary",
                                    onClick: handleUnallocatedCostSave,
                                    children: "Save Unallocated Cost"
                                })
                            ]
                        })
                    ]
                })
            }), document.body)
        ]
    });
}





function $711346be82964e0e$var$formatAmount(value) {
    if (value === null || value === undefined || value === "") return "-";
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return String(value);
    return new Intl.NumberFormat("en-IN", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    }).format(numericValue);
}
function $711346be82964e0e$var$StatusModal({ detail: detail, onClose: onClose }) {
    if (!detail) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "checker-generated-status-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Status Detail"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "checker-generated-status-title",
                                    children: detail.label
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: detail.message || "No additional message available."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                    className: "processor-modal__code",
                    children: JSON.stringify(detail.data ?? {}, null, 2)
                })
            ]
        })
    });
}
function $711346be82964e0e$var$TrailModal({ trail: trail, loading: loading, onClose: onClose }) {
    (0, $acw62.useEffect)(()=>{
        if (!trail && !loading) return;
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        trail,
        loading,
        onClose
    ]);
    if (!trail && !loading) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card processor-modal__card--wide",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "processor-trail-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Audit Log"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "processor-trail-title",
                                    children: "Invoice timeline"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: "Loading audit log\u2026"
                }) : trail?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "processor-timeline",
                    children: trail.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                            className: "processor-timeline__item",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__step",
                                    children: [
                                        "Step ",
                                        entry.step
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__content",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: entry.action
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: entry.message || "No message recorded."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                entry.username || "System",
                                                entry.userrole ? ` (${entry.userrole})` : "",
                                                entry.created_at ? ` \u{2022} ${new Date(entry.created_at).toLocaleString()}` : ""
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, `${entry.step}-${entry.created_at}`))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "empty-state",
                    children: "No timeline available for this invoice."
                })
            ]
        })
    });
}
function $711346be82964e0e$export$2e2bcd8739ae039() {
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [actionKey, setActionKey] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [selectedRows, setSelectedRows] = (0, $acw62.useState)([]);
    const [statusDetail, setStatusDetail] = (0, $acw62.useState)(null);
    const [trail, setTrail] = (0, $acw62.useState)(null);
    const [trailLoading, setTrailLoading] = (0, $acw62.useState)(false);
    const allSelected = rows.length > 0 && selectedRows.length === rows.length;
    const summary = (0, $acw62.useMemo)(()=>({
            count: rows.length,
            selected: selectedRows.length,
            redFlags: rows.reduce((count, row)=>count + Object.values(row.InvoiceCheck || {}).filter((item)=>item?.color === "r").length, 0)
        }), [
        rows,
        selectedRows
    ]);
    async function loadRows() {
        setLoading(true);
        setError("");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/get-generated/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                }
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok || payload?.error) throw new Error(payload?.message || payload?.error || `Unable to load checker generated invoices. Backend responded with ${response.status}.`);
            if (!payload) throw new Error("Unable to load checker generated invoices. Backend returned a non-JSON response.");
            setRows(payload.data || []);
        } catch (requestError) {
            setError(requestError.message || "Unable to load checker generated invoices.");
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadRows();
    }, []);
    function toggleRowSelection(invoiceGroupKey) {
        setSelectedRows((current)=>current.includes(invoiceGroupKey) ? current.filter((item)=>item !== invoiceGroupKey) : [
                ...current,
                invoiceGroupKey
            ]);
    }
    function toggleAllRows() {
        setSelectedRows((current)=>current.length === rows.length ? [] : rows.map((row)=>row.InvoiceGroupKey));
    }
    async function handleTrailOpen(row) {
        setTrail(null);
        setTrailLoading(true);
        try {
            const response = await fetch(`/api/invoice/trail/${row.InvoiceId}/`, {
                credentials: "include"
            });
            const payload = await response.json();
            if (!response.ok || !payload.success) throw new Error(payload.message || "Unable to load trail.");
            setTrail(payload.data || []);
        } catch (requestError) {
            setTrail([]);
            setError(requestError.message || "Unable to load trail.");
        } finally{
            setTrailLoading(false);
        }
    }
    async function handleAction(row, type) {
        setStatus("");
        setError("");
        setActionKey(`${type}-${row.InvoiceGroupKey}`);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            let url = "";
            let body = {};
            if (type === "approve") {
                url = "/api/approve-invoice/";
                body = {
                    invoice_group_key: row.InvoiceGroupKey
                };
            } else if (type === "reject") {
                url = "/api/reject-invoice/";
                body = {
                    invoice_group_key: row.InvoiceGroupKey
                };
            }
            const response = await fetch(url, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify(body)
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || `Unable to ${type} invoice.`);
            setStatus(payload.message || `Invoice ${type}d successfully.`);
            setSelectedRows((current)=>current.filter((item)=>item !== row.InvoiceGroupKey));
            await loadRows();
        } catch (requestError) {
            setError(requestError.message || `Unable to ${type} invoice.`);
        } finally{
            setActionKey("");
        }
    }
    async function handlePreview(row) {
        setStatus("");
        setError("");
        setActionKey(`preview-${row.InvoiceGroupKey}`);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/template-preview/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    invoice_keys: [
                        row.InvoiceGroupKey
                    ]
                })
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || "Unable to generate preview.");
            const previewWindow = window.open("", "_blank", "noreferrer");
            if (!previewWindow) throw new Error("Preview window was blocked by the browser.");
            let html = "<html><head><title>Preview</title></head><body style='padding:24px;font-family:Segoe UI,sans-serif;'>";
            Object.entries(payload.template_html || {}).forEach(([key, value])=>{
                html += `<h3>${key}</h3>${value}<hr/>`;
            });
            html += "</body></html>";
            previewWindow.document.write(html);
            previewWindow.document.close();
        } catch (requestError) {
            setError(requestError.message || "Unable to generate preview.");
        } finally{
            setActionKey("");
        }
    }
    function openLegacyGeneratedPage() {
        window.localStorage.setItem("activeApprovalSection", "generated");
        window.open((0, $96e14f2a7c3555e4$export$5d9c32988b6a9848)("/checker-dashboard/"), "_blank", "noreferrer");
    }
    function refreshPendingActions() {
        loadRows();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $96fe7c33bdd2f764$export$2e2bcd8739ae039), {
        title: "Template Generated Invoices",
        intro: "",
        metrics: [
            {
                label: "Queue",
                value: summary.count
            }
        ],
        actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            className: "ghost-button processor-view__refresh",
            type: "button",
            onClick: refreshPendingActions,
            children: "Refresh"
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "processor-view",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "workspace-panel",
                    children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "config-note",
                        children: "Loading checker generated invoices\u2026"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-table processor-table",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice ID"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Vendor Name"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice No."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice Date"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice Value"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice Status"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Response"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "File"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Preview"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Logs"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: rows.length ? rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.InvoiceId
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.VendorName || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.InvoiceNo || row.InvNo || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.InvoiceDate || row.InvDate || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $711346be82964e0e$var$formatAmount(row.InvoiceValue || row.TotalAmount)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "processor-status-list",
                                                        children: Object.entries(row.invoiceCheck || {}).length ? Object.entries(row.invoiceCheck || {}).map(([label, item])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                className: `processor-status-dot processor-status-dot--${item?.color || "o"}`,
                                                                type: "button",
                                                                title: `${label}: ${item?.message || ""}`,
                                                                onClick: ()=>setStatusDetail({
                                                                        label: label,
                                                                        message: item?.message,
                                                                        data: item?.data,
                                                                        key: item?.key || label,
                                                                        checkKey: label,
                                                                        uniqueKey: row.invoiceGroupKey,
                                                                        color: item?.color || "o"
                                                                    })
                                                            }, `${row.invoiceGroupKey}-${label}`)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "empty-state",
                                                            children: "No checks"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.unique_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        onClick: ()=>(0, $3d6d578a87c5904f$export$2926f86deb178d44)(`${row.unique_name}.json`),
                                                        children: "Data"
                                                    }) : "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.unique_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>(0, $e267546ad9d86d30$export$a38ce99a4bdccd4e)(row.InvoiceId),
                                                        children: "\uD83D\uDCCE"
                                                    }) : "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "ghost-button",
                                                        type: "button",
                                                        disabled: actionKey === `preview-${row.InvoiceGroupKey}`,
                                                        onClick: ()=>handlePreview(row),
                                                        children: actionKey === `preview-${row.InvoiceGroupKey}` ? "Previewing..." : "Preview"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "ghost-button",
                                                        type: "button",
                                                        onClick: ()=>handleTrailOpen(row),
                                                        children: "Logs"
                                                    })
                                                })
                                            ]
                                        }, row.InvoiceGroupKey)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            colSpan: "12",
                                            children: "No invoices found in the checker generated queue."
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90a432d2bdd32db5$export$2e2bcd8739ae039), {
                    detail: statusDetail,
                    onClose: ()=>setStatusDetail(null),
                    onSaved: loadRows
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($711346be82964e0e$var$TrailModal, {
                    trail: trail,
                    loading: trailLoading,
                    onClose: ()=>setTrail(null)
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


function $3c5c59f6c0eb6d77$var$formatDateInput(value) {
    if (!value) return "";
    const str = String(value);
    return str.includes("T") ? str.slice(0, 10) : str;
}
function $3c5c59f6c0eb6d77$var$normalizeList(payload) {
    if (Array.isArray(payload)) return payload;
    if (payload && Array.isArray(payload.data)) return payload.data;
    return [];
}
function $3c5c59f6c0eb6d77$var$addCurrentValue(options, currentValue) {
    if (!currentValue) return options;
    return options.includes(currentValue) ? options : [
        currentValue,
        ...options
    ];
}
function $3c5c59f6c0eb6d77$var$formatOptionLabel(item, fallbackKey = "code", fallbackLabel = "description") {
    const code = item?.code || item?.value || item?.[fallbackKey] || "";
    const label = item?.description || item?.label || item?.[fallbackLabel] || "";
    return label ? `${code} - ${label}` : code;
}
function $3c5c59f6c0eb6d77$var$InvoiceItemsTable({ items: items, onChangeTaxCode: onChangeTaxCode, gstCodes: gstCodes }) {
    if (!Array.isArray(items) || !items.length) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "empty-state",
        children: "No items found"
    });
    const headers = Object.keys(items[0] || {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "invoice-edit-modal__table-wrap",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
            className: "invoice-edit-modal__table",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                        children: headers.map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: header
                            }, header))
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                    children: items.map((item, rowIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                            children: headers.map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: header === "TaxCode" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        className: "invoice-edit-modal__select invoice-edit-modal__select--compact",
                                        value: item[header] ?? "",
                                        onChange: (event)=>onChangeTaxCode(rowIndex, event.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Select GST Tax Code"
                                            }),
                                            gstCodes.map((code)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: code,
                                                    children: code
                                                }, code))
                                        ]
                                    }) : String(item[header] ?? "")
                                }, `${rowIndex}-${header}`))
                        }, item.id ?? rowIndex))
                })
            ]
        })
    });
}
function $3c5c59f6c0eb6d77$export$2e2bcd8739ae039({ invoiceGroupKey: invoiceGroupKey, tab: tab, onClose: onClose, onSaved: onSaved }) {
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)("");
    const [invoice, setInvoice] = (0, $acw62.useState)(null);
    const [items, setItems] = (0, $acw62.useState)([]);
    const [section1, setSection1] = (0, $acw62.useState)({
        InvoiceDate: "",
        Narration: "",
        WithholdingTaxCode: "",
        material_service: "",
        tds_value: ""
    });
    const [section4, setSection4] = (0, $acw62.useState)({
        ExchangeRate: "",
        CurrentExchangeRate: "",
        exchange_rate_user: ""
    });
    const [section3, setSection3] = (0, $acw62.useState)({
        InvoiceValue: "",
        InvoiceValueMigo: "",
        unallocatedCost: 0
    });
    const [withholdingTaxCodes, setWithholdingTaxCodes] = (0, $acw62.useState)([]);
    const [gstTaxCodes, setGstTaxCodes] = (0, $acw62.useState)([]);
    const [glCodes, setGlCodes] = (0, $acw62.useState)([]);
    const [activeSection, setActiveSection] = (0, $acw62.useState)("overview");
    const [unplannedForm, setUnplannedForm] = (0, $acw62.useState)(null);
    const [unplannedValues, setUnplannedValues] = (0, $acw62.useState)({});
    const [section3Error, setSection3Error] = (0, $acw62.useState)("");
    const title = (0, $acw62.useMemo)(()=>{
        return tab === "no_data" ? "Edit Missing Invoice" : "Edit Invoice";
    }, [
        tab
    ]);
    // Close modal on Esc
    (0, $acw62.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onClose();
        };
        window.addEventListener("keydown", handleKeyDown);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        onClose
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!invoiceGroupKey) return;
        let cancelled = false;
        async function loadDetails() {
            setLoading(true);
            setError("");
            try {
                const payload = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/get-invoice-details/", {
                    method: "POST",
                    body: {
                        InvoiceGroupKey: invoiceGroupKey,
                        Tab: tab
                    }
                });
                if (cancelled) return;
                const data = payload.data || payload;
                setInvoice(data);
                setItems(Array.isArray(data.TaxCode) ? data.TaxCode : []);
                console.log(data.TaxCode);
                setSection1({
                    InvoiceDate: $3c5c59f6c0eb6d77$var$formatDateInput(data.InvoiceDate),
                    Narration: data.Narration || "",
                    WithholdingTaxCode: data.WithholdingTaxCode || "",
                    material_service: data.material_service || "",
                    tds_value: data.tds_value || ""
                });
                await loadUnplannedCostForm(data.material_service);
                setSection3({
                    InvoiceValue: data.InvoiceValue || "",
                    InvoiceValueMigo: data.InvoiceValueMigo || "",
                    unplanned_cost: data.unplanned_cost || "",
                    unallocatedCost: data.unallocatedCost || 0,
                    gl_code: ""
                });
                setSection4({
                    ExchangeRate: data.ExchangeRate || "",
                    CurrentExchangeRate: data.CurrentExchangeRate || "",
                    exchange_rate_user: ""
                });
                const vendorCode = (data.VendorCode || "").trim();
                const [glPayload, wtPayload, gstPayload] = await Promise.all([
                    (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/unallocatedcost-gl-list/"),
                    vendorCode ? (0, $96e14f2a7c3555e4$export$52e83573e7782585)(`/fetch-withholdingtax/?vendor_code=${encodeURIComponent(vendorCode)}`) : Promise.resolve([]),
                    vendorCode ? (0, $96e14f2a7c3555e4$export$52e83573e7782585)(`/fetch-gsttax/?vendor_code=${encodeURIComponent(vendorCode)}`) : Promise.resolve([])
                ]);
                if (cancelled) return;
                setGlCodes($3c5c59f6c0eb6d77$var$normalizeList(glPayload));
                setWithholdingTaxCodes($3c5c59f6c0eb6d77$var$addCurrentValue($3c5c59f6c0eb6d77$var$normalizeList(wtPayload), data.WithholdingTaxCode));
                setGstTaxCodes($3c5c59f6c0eb6d77$var$addCurrentValue($3c5c59f6c0eb6d77$var$normalizeList(gstPayload), data.TaxCode[0].TaxCode));
            } catch (requestError) {
                if (!cancelled) setError(requestError.message || "Unable to load invoice details.");
            } finally{
                if (!cancelled) setLoading(false);
            }
        }
        loadDetails();
        return ()=>{
            cancelled = true;
        };
    }, [
        invoiceGroupKey,
        tab
    ]);
    function updateUnplannedField(field, value) {
        setUnplannedValues((current)=>({
                ...current,
                [field]: value
            }));
    }
    async function loadUnplannedCostForm(materialService) {
        console.log("called", "/api/invoice/unplanned-cost-form/");
        console.log("invoiceGroupKey", invoiceGroupKey);
        console.log("materialService", materialService);
        try {
            const payload = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/invoice/unplanned-cost-form/", {
                method: "POST",
                body: {
                    invoice_keys: invoiceGroupKey,
                    material_service: materialService
                }
            });
            setUnplannedForm(payload);
            const defaults = {};
            Object.values(payload.normal_fields || {}).forEach((field)=>{
                defaults[field.field] = field.default || "";
            });
            Object.values(payload.grn_fields || {}).forEach((field)=>{
                defaults[field.field] = field.default || "";
            });
            Object.values(payload.po_fields || {}).forEach((field)=>{
                defaults[field.field] = field.default || "";
            });
            defaults.amount = "";
            setUnplannedValues(defaults);
        } catch (error) {
            console.error(error);
            setSection3Error(error.message || "Unable to load unplanned cost form.");
        }
    }
    function updateItemTaxCode(rowIndex, value) {
        setItems((current)=>current.map((item, index)=>index === rowIndex ? {
                    ...item,
                    TaxCode: value
                } : item));
    }
    function updateSection1(field, value) {
        setSection1((current)=>({
                ...current,
                [field]: value
            }));
    }
    // function updateSection3(field, value) {
    //   setSection3((current) => ({ ...current, [field]: value }));
    // }
    function updateSection4(field, value) {
        setSection4((current)=>({
                ...current,
                [field]: value
            }));
    }
    async function saveSection1() {
        setSaving(true);
        setError("");
        try {
            await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/update-invoice-details/", {
                method: "POST",
                body: {
                    InvoiceGroupKey: invoiceGroupKey,
                    section: 1,
                    ...section1
                }
            });
            onSaved?.();
            onClose();
        } catch (requestError) {
            setError(requestError.message || "Unable to save section 1.");
        } finally{
            setSaving(false);
        }
    }
    async function saveSection2() {
        setSaving(true);
        setError("");
        try {
            await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/save-updated-taxcode/", {
                method: "POST",
                body: {
                    invoice_id: invoice?.InvoiceId,
                    items: items.map((item)=>({
                            id: item.id,
                            TaxCode: item.TaxCode
                        }))
                }
            });
            onSaved?.();
            onClose();
        } catch (requestError) {
            setError(requestError.message || "Unable to save section 2.");
        } finally{
            setSaving(false);
        }
    }
    async function saveSection3() {
        setSaving(true);
        setError("");
        try {
            const payload = {
                InvoiceGroupKey: invoiceGroupKey,
                section: 3,
                ...section3,
                ...unplannedValues
            };
            console.log("UNPLANNED COST PAYLOAD");
            console.log(payload);
            await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/create-unallocatedcost/", {
                method: "POST",
                body: payload
            });
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Unplanned Cost Created",
                text: "Line item has been created successfully.",
                confirmButtonText: "OK"
            });
            onSaved?.();
            onClose();
        } catch (requestError) {
            setError(requestError.message || "Unable to save section 3.");
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Save Failed",
                text: requestError.message || "Unable to save unplanned cost."
            });
        } finally{
            setSaving(false);
        }
    }
    async function saveSection4() {
        setSaving(true);
        setError("");
        try {
            await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/update-invoice-details/", {
                method: "POST",
                body: {
                    InvoiceGroupKey: invoiceGroupKey,
                    section: 4,
                    exchange_edit: section4.exchange_rate_user
                }
            });
            onSaved?.();
            onClose();
        } catch (requestError) {
            setError(requestError.message || "Unable to save section 4.");
        } finally{
            setSaving(false);
        }
    }
    if (!invoiceGroupKey) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card processor-modal__card--wide invoice-edit-modal",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "invoice-edit-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "invoice-edit-modal__hero",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Invoice Editor"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "invoice-edit-title",
                                    children: title
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "invoice-edit-modal__subtitle",
                                    children: "Update header fields, tax codes, cost allocation, and exchange rate from one place."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button invoice-edit-modal__close",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: "Loading invoice details..."
                }) : null,
                error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "config-banner config-banner--error",
                    children: error
                }) : null,
                !loading && invoice ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "invoice-edit-modal__shell",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "invoice-edit-modal__tabs",
                            role: "tablist",
                            "aria-label": "Invoice edit sections",
                            children: [
                                [
                                    "overview",
                                    "Overview"
                                ],
                                [
                                    "items",
                                    "Invoice Items"
                                ],
                                [
                                    "cost",
                                    "Cost & GL"
                                ],
                                [
                                    "exchange",
                                    "Exchange Rate"
                                ]
                            ].map(([key, label])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: `invoice-edit-modal__tab ${activeSection === key ? "is-active" : ""}`,
                                    onClick: ()=>setActiveSection(key),
                                    children: label
                                }, key))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: `invoice-edit-modal__section ${activeSection === "overview" ? "is-visible" : ""}`,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Section 1 - Basic Info"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "invoice-edit-modal__grid",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            children: [
                                                "Invoice Date",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    className: "invoice-edit-modal__input",
                                                    type: "date",
                                                    value: section1.InvoiceDate,
                                                    onChange: (event)=>updateSection1("InvoiceDate", event.target.value)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            children: [
                                                "Narration",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    className: "invoice-edit-modal__input",
                                                    type: "text",
                                                    value: section1.Narration,
                                                    onChange: (event)=>updateSection1("Narration", event.target.value)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            children: [
                                                "Withholding Tax Code",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                    className: "invoice-edit-modal__select",
                                                    value: section1.WithholdingTaxCode,
                                                    onChange: (event)=>updateSection1("WithholdingTaxCode", event.target.value),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "",
                                                            children: "Select withholding tax"
                                                        }),
                                                        withholdingTaxCodes.map((code)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: code,
                                                                children: code
                                                            }, code))
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            children: [
                                                "Material/Service",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                    className: "invoice-edit-modal__select",
                                                    value: section1.material_service,
                                                    onChange: (event)=>updateSection1("material_service", event.target.value),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "",
                                                            children: "Select type"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "material",
                                                            children: "Material"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "service",
                                                            children: "Service"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            children: [
                                                "TDS Value",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    className: "invoice-edit-modal__input",
                                                    type: "text",
                                                    value: section1.tds_value,
                                                    onChange: (event)=>updateSection1("tds_value", event.target.value)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "invoice-edit-modal__actions",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "primary-button",
                                        type: "button",
                                        onClick: saveSection1,
                                        disabled: saving,
                                        children: "Save Section 1"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: `invoice-edit-modal__section ${activeSection === "items" ? "is-visible" : ""}`,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Section 2 - Invoice Items with GST Tax"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3c5c59f6c0eb6d77$var$InvoiceItemsTable, {
                                    items: items,
                                    onChangeTaxCode: updateItemTaxCode,
                                    gstCodes: gstTaxCodes
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "invoice-edit-modal__actions",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "primary-button",
                                        type: "button",
                                        onClick: saveSection2,
                                        disabled: saving,
                                        children: "Save Section 2"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: `invoice-edit-modal__section ${activeSection === "cost" ? "is-visible" : ""}`,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Section 3 - Unplanned Cost"
                                }),
                                (()=>{
                                    const invoiceValue = Number(section3.InvoiceValue || 0);
                                    const invoiceValueMigo = Number(section3.InvoiceValueMigo || 0);
                                    const unallocatedCost_ = Number(section3.unallocatedCost || 0);
                                    const _maxallowed = invoiceValue - invoiceValueMigo - unallocatedCost_;
                                    const processorConfig = unplannedForm?.unallocated_cost_config?.processor || {};
                                    const thresholdAmount = Number(processorConfig.threshold_amount || 0);
                                    const thresholdPercent = Number(processorConfig.threshold_percent || 0);
                                    const thresholdPercentValue = invoiceValue * thresholdPercent / 100;
                                    let maxAllowedAmount = 0;
                                    if (processorConfig.condition === "OR") maxAllowedAmount = Math.min(thresholdAmount, thresholdPercentValue);
                                    else maxAllowedAmount = Math.max(thresholdAmount, thresholdPercentValue);
                                    // Final maximum allowed
                                    maxAllowedAmount = Math.min(maxAllowedAmount, _maxallowed);
                                    const invoiceEligible = maxAllowedAmount > 0;
                                    const thresholdConfigured = thresholdAmount > 0 || thresholdPercent > 0;
                                    const disableForm = !invoiceEligible || !thresholdConfigured;
                                    const enteredAmount = Number(unplannedValues.amount || 0);
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "invoice-edit-modal__summary",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "invoice-edit-modal__summary-card",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Invoice Value (OCR)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: section3.InvoiceValue
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "invoice-edit-modal__summary-card",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Invoice Value (MIGO)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: section3.InvoiceValueMigo
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "invoice-edit-modal__summary-card",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Unallocated Cost"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: unallocatedCost_
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "invoice-edit-modal__summary-card",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Diffrence"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: _maxallowed
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            !invoiceEligible && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "invoice-edit-modal__warning",
                                                children: "Invoice Value must be greater than Invoice Value (MIGO) before Unplanned Cost can be created."
                                            }),
                                            !thresholdConfigured && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "invoice-edit-modal__warning",
                                                children: "No threshold configured for Processor. Please configure Unplanned Cost settings first."
                                            }),
                                            invoiceEligible && thresholdConfigured && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "invoice-edit-modal__info",
                                                        children: [
                                                            "Maximum Allowed Amount:",
                                                            " ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: maxAllowedAmount
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        className: "invoice-edit-modal__subheading",
                                                        children: "Unplanned Cost Details"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "invoice-edit-modal__grid invoice-edit-modal__grid--unplanned",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                children: [
                                                                    "Amount",
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        className: "invoice-edit-modal__input",
                                                                        type: "number",
                                                                        min: "0",
                                                                        max: maxAllowedAmount,
                                                                        value: unplannedValues.amount || "",
                                                                        onChange: (event)=>{
                                                                            const value = event.target.value;
                                                                            if (value === "") {
                                                                                updateUnplannedField("amount", "");
                                                                                return;
                                                                            }
                                                                            const numericValue = Math.min(Number(value), maxAllowedAmount);
                                                                            updateUnplannedField("amount", numericValue);
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                children: [
                                                                    "Description",
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        className: "invoice-edit-modal__input",
                                                                        type: "text",
                                                                        value: unplannedValues.item_descritption || "",
                                                                        onChange: (event)=>updateUnplannedField("item_descritption", event.target.value)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                children: [
                                                                    "Tax Code",
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                        className: "invoice-edit-modal__select",
                                                                        value: unplannedValues.TaxCode || "",
                                                                        onChange: (event)=>updateUnplannedField("TaxCode", event.target.value),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: "",
                                                                                children: "Select Tax Code"
                                                                            }),
                                                                            (unplannedForm?.gst_taxcode_list || []).map((code)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                    value: code,
                                                                                    children: code
                                                                                }, code))
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                children: [
                                                                    "Withholding Tax Code",
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                        className: "invoice-edit-modal__select",
                                                                        value: unplannedValues.WithholdingTaxCode || "",
                                                                        onChange: (event)=>updateUnplannedField("WithholdingTaxCode", event.target.value),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: "",
                                                                                children: "Select Tax Code"
                                                                            }),
                                                                            (unplannedForm?.wtaxcode_list || []).map((code)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                    value: code,
                                                                                    children: code
                                                                                }, code))
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            unplannedForm?.unallocated_cost_config?.add_to_material_service === "Y" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                children: [
                                                                    "GL Account",
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        className: "invoice-edit-modal__input",
                                                                        type: "text",
                                                                        value: unplannedValues.GLAccount || "",
                                                                        readOnly: true
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                children: [
                                                                    "GL Account",
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                        className: "invoice-edit-modal__select",
                                                                        value: unplannedValues.GLAccount || "",
                                                                        onChange: (event)=>updateUnplannedField("GLAccount", event.target.value),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: "",
                                                                                children: "Select GL Code"
                                                                            }),
                                                                            (unplannedForm?.gl_list || []).map((gl)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                    value: gl.code,
                                                                                    children: gl.description ? `${gl.code} (${gl.description})` : gl.code
                                                                                }, gl.code))
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        className: "invoice-edit-modal__subheading",
                                                        children: "GRN Information"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "invoice-edit-modal__grid invoice-edit-modal__grid--unplanned",
                                                        children: Object.values(unplannedForm?.grn_fields || {}).map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                children: [
                                                                    field.field,
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        className: "invoice-edit-modal__input",
                                                                        type: "text",
                                                                        value: unplannedValues[field.field] || "",
                                                                        onChange: (event)=>updateUnplannedField(field.field, event.target.value)
                                                                    })
                                                                ]
                                                            }, `grn-${field.field}`))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        className: "invoice-edit-modal__subheading",
                                                        children: "PO Information"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "invoice-edit-modal__grid invoice-edit-modal__grid--unplanned",
                                                        children: Object.values(unplannedForm?.po_fields || {}).map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                children: [
                                                                    field.field,
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        className: "invoice-edit-modal__input",
                                                                        type: "text",
                                                                        value: unplannedValues[field.field] || "",
                                                                        onChange: (event)=>updateUnplannedField(field.field, event.target.value)
                                                                    })
                                                                ]
                                                            }, `po-${field.field}`))
                                                    }),
                                                    enteredAmount > maxAllowedAmount && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "invoice-edit-modal__warning",
                                                        children: [
                                                            "Maximum allowed amount is",
                                                            " ",
                                                            maxAllowedAmount
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "invoice-edit-modal__actions",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: "primary-button",
                                                            type: "button",
                                                            onClick: saveSection3,
                                                            disabled: saving || enteredAmount > maxAllowedAmount || disableForm,
                                                            children: "Save Unplanned Cost"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                })()
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: `invoice-edit-modal__section ${activeSection === "exchange" ? "is-visible" : ""}`,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Section 4 - Exchange Rate"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "invoice-edit-modal__grid",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            children: [
                                                "Exchange Rate (MIGO)",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    className: "invoice-edit-modal__input",
                                                    type: "text",
                                                    value: section4.ExchangeRate,
                                                    readOnly: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            children: [
                                                "Exchange Rate (API)",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    className: "invoice-edit-modal__input",
                                                    type: "text",
                                                    value: section4.CurrentExchangeRate,
                                                    readOnly: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            children: [
                                                "Exchange Rate (User)",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    className: "invoice-edit-modal__input",
                                                    type: "text",
                                                    value: section4.exchange_rate_user,
                                                    onChange: (event)=>updateSection4("exchange_rate_user", event.target.value)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "invoice-edit-modal__actions",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "primary-button",
                                        type: "button",
                                        onClick: saveSection4,
                                        disabled: saving,
                                        children: "Save Section 4"
                                    })
                                })
                            ]
                        })
                    ]
                }) : null
            ]
        })
    });
}






function $5ce0857a82cd5c0f$var$formatAmount(value) {
    if (value === null || value === undefined || value === "") return "-";
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return String(value);
    return new Intl.NumberFormat("en-IN", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    }).format(numericValue);
}
function $5ce0857a82cd5c0f$var$StatusModal({ detail: detail, onClose: onClose }) {
    if (!detail) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "checker-hold-status-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Status Detail"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "checker-hold-status-title",
                                    children: detail.label
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: detail.message || "No additional message available."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                    className: "processor-modal__code",
                    children: JSON.stringify(detail.data ?? {}, null, 2)
                })
            ]
        })
    });
}
function $5ce0857a82cd5c0f$var$TrailModal({ trail: trail, loading: loading, onClose: onClose }) {
    (0, $acw62.useEffect)(()=>{
        if (!trail && !loading) return;
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        trail,
        loading,
        onClose
    ]);
    if (!trail && !loading) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card processor-modal__card--wide",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "processor-trail-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Audit Log"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "processor-trail-title",
                                    children: "Invoice timeline"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: "Loading audit log\u2026"
                }) : trail?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "processor-timeline",
                    children: trail.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                            className: "processor-timeline__item",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__step",
                                    children: [
                                        "Step ",
                                        entry.step
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__content",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: entry.action
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: entry.message || "No message recorded."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                entry.username || "System",
                                                entry.userrole ? ` (${entry.userrole})` : "",
                                                entry.created_at ? ` \u{2022} ${new Date(entry.created_at).toLocaleString()}` : ""
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, `${entry.step}-${entry.created_at}`))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "empty-state",
                    children: "No timeline available for this invoice."
                })
            ]
        })
    });
}
function $5ce0857a82cd5c0f$var$buildGenerateSuccessMessage(payload) {
    const blocked = payload?.blocked_entries || [];
    const skipped = payload?.skipped_entries || [];
    if (!blocked.length && !skipped.length) return "Templates generated successfully.";
    let message = "";
    if (blocked.length) message += "Posting Date belongs to period which is closed as per configuration.\n\n" + `Blocked Invoice IDs: ${blocked.join(", ")}\n\n`;
    if (skipped.length) {
        const skippedList = skipped.map((item)=>`Invoice ${item.InvoiceId} -> ${item.reason}`).join("\n");
        message += "Some invoices were skipped due to missing mandatory mapped fields.\n\n" + `${skippedList}\n\n`;
    }
    message += "Templates generated successfully for remaining entries.";
    return message;
}
function $5ce0857a82cd5c0f$export$2e2bcd8739ae039() {
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [actionKey, setActionKey] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [selectedRows, setSelectedRows] = (0, $acw62.useState)([]);
    const [statusDetail, setStatusDetail] = (0, $acw62.useState)(null);
    const [trail, setTrail] = (0, $acw62.useState)(null);
    const [trailLoading, setTrailLoading] = (0, $acw62.useState)(false);
    const [menuPosition, setMenuPosition] = (0, $acw62.useState)(null);
    const [editTarget, setEditTarget] = (0, $acw62.useState)(null);
    const allSelected = rows.length > 0 && selectedRows.length === rows.length;
    const summary = (0, $acw62.useMemo)(()=>({
            count: rows.length,
            selected: selectedRows.length,
            redFlags: rows.reduce((count, row)=>count + Object.values(row.InvoiceCheck || {}).filter((item)=>item?.color === "r").length, 0)
        }), [
        rows,
        selectedRows
    ]);
    const menuRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!menuPosition) return;
        const handleClickOutside = (event)=>{
            if (menuRef.current && !menuRef.current.contains(event.target)) setMenuPosition(null);
        };
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") setMenuPosition(null);
        };
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        menuPosition
    ]);
    async function loadRows() {
        setLoading(true);
        setError("");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/get-hold/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                }
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok || payload?.error) throw new Error(payload?.message || payload?.error || `Unable to load checker hold invoices. Backend responded with ${response.status}.`);
            if (!payload) throw new Error("Unable to load checker hold invoices. Backend returned a non-JSON response.");
            setRows(payload.data || []);
        } catch (requestError) {
            setError(requestError.message || "Unable to load checker hold invoices.");
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadRows();
    }, []);
    function toggleRowSelection(invoiceGroupKey) {
        setSelectedRows((current)=>current.includes(invoiceGroupKey) ? current.filter((item)=>item !== invoiceGroupKey) : [
                ...current,
                invoiceGroupKey
            ]);
    }
    function toggleAllRows() {
        setSelectedRows((current)=>current.length === rows.length ? [] : rows.map((row)=>row.InvoiceGroupKey));
    }
    async function handleTrailOpen(row) {
        setTrail(null);
        setTrailLoading(true);
        try {
            const response = await fetch(`/api/invoice/trail/${row.InvoiceId}/`, {
                credentials: "include"
            });
            const payload = await response.json();
            if (!response.ok || !payload.success) throw new Error(payload.message || "Unable to load trail.");
            setTrail(payload.data || []);
        } catch (requestError) {
            setTrail([]);
            setError(requestError.message || "Unable to load trail.");
        } finally{
            setTrailLoading(false);
        }
    }
    async function handleAction(row, type) {
        setStatus("");
        setError("");
        setActionKey(`${type}-${row.InvoiceGroupKey}`);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            let url = "";
            let body = {};
            if (type === "approve") {
                url = "/api/approve-invoice/";
                body = {
                    invoice_group_key: row.InvoiceGroupKey
                };
            } else if (type === "reject") {
                url = "/api/reject-invoice/";
                body = {
                    invoice_group_key: row.InvoiceGroupKey
                };
            }
            const response = await fetch(url, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify(body)
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || `Unable to ${type} invoice.`);
            setStatus(payload.message || `Invoice ${type}d successfully.`);
            setSelectedRows((current)=>current.filter((item)=>item !== row.InvoiceGroupKey));
            await loadRows();
        } catch (requestError) {
            setError(requestError.message || `Unable to ${type} invoice.`);
        } finally{
            setActionKey("");
        }
    }
    async function handlePreview(row) {
        console.log(row);
        setStatus("");
        setError("");
        setActionKey(`preview-${row.invoiceGroupKey}`);
        // Open immediately from user click
        const previewWindow = window.open("", "_blank");
        if (!previewWindow) {
            setError("Preview window was blocked by the browser.");
            return;
        }
        previewWindow.document.write("<html><body><h3>Loading preview...</h3></body></html>");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/template-preview/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    invoice_keys: [
                        row.InvoiceGroupKey
                    ],
                    material_service: row.material_service
                })
            });
            const payload = await response.json();
            if (!response.ok || payload?.status !== "success") throw new Error(payload?.message || "Unable to generate preview.");
            let html = "<html><head><title>Preview</title></head><body style='padding:24px;font-family:Segoe UI,sans-serif;'>";
            Object.entries(payload.template_html || {}).forEach(([key, value])=>{
                html += `<h3>${key}</h3>${value}<hr/>`;
            });
            html += "</body></html>";
            previewWindow.document.open();
            previewWindow.document.write(html);
            previewWindow.document.close();
        } catch (requestError) {
            previewWindow.close();
            setError(requestError.message || "Unable to generate preview.");
        } finally{
            setActionKey("");
        }
    }
    function refreshPendingActions() {
        loadRows();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $96fe7c33bdd2f764$export$2e2bcd8739ae039), {
        title: "Hold Invoices",
        intro: "",
        metrics: [
            {
                label: "Queue",
                value: summary.count
            }
        ],
        actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            className: "ghost-button processor-view__refresh",
            type: "button",
            onClick: refreshPendingActions,
            children: "Refresh Pending Actions"
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "processor-view",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "workspace-panel",
                    children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "config-note",
                        children: "Loading checker hold invoices\u2026"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-table processor-table",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice ID"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Vendor Name"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice No."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice Date"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice Value"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice Status"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Response"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "File"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Preview"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Logs"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Action"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: rows.length ? rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.InvoiceId
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.VendorName || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.InvoiceNo || row.InvNo || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.InvoiceDate || row.InvDate || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $5ce0857a82cd5c0f$var$formatAmount(row.InvoiceValue || row.TotalAmount)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "processor-status-list",
                                                        children: Object.entries(row.InvoiceCheck || {}).length ? Object.entries(row.InvoiceCheck || {}).map(([label, item])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                className: `processor-status-dot processor-status-dot--${item?.color || "o"}`,
                                                                type: "button",
                                                                title: `${label}: ${item?.message || ""}`,
                                                                onClick: ()=>setStatusDetail({
                                                                        label: label,
                                                                        message: item?.message,
                                                                        data: item?.data,
                                                                        key: item?.key || label,
                                                                        checkKey: label,
                                                                        uniqueKey: row.InvoiceGroupKey,
                                                                        color: item?.color || "o"
                                                                    })
                                                            }, `${row.InvoiceGroupKey}-${label}`)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "empty-state",
                                                            children: "No checks"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.unique_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        onClick: ()=>(0, $3d6d578a87c5904f$export$2926f86deb178d44)(`${row.unique_name}.json`),
                                                        children: "Data"
                                                    }) : "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.unique_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>(0, $e267546ad9d86d30$export$a38ce99a4bdccd4e)(row.InvoiceId),
                                                        children: "\uD83D\uDCCE"
                                                    }) : "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "ghost-button",
                                                        type: "button",
                                                        disabled: actionKey === `preview-${row.InvoiceGroupKey}`,
                                                        onClick: ()=>handlePreview(row),
                                                        children: actionKey === `preview-${row.InvoiceGroupKey}` ? "Previewing..." : "Preview"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "ghost-button",
                                                        type: "button",
                                                        onClick: ()=>handleTrailOpen(row),
                                                        children: "Logs"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "action-dropdown-wrapper",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "action-menu-button",
                                                            onClick: (e)=>{
                                                                if (menuPosition?.row?.InvoiceGroupKey === row.InvoiceGroupKey) {
                                                                    setMenuPosition(null);
                                                                    return;
                                                                }
                                                                const rect = e.currentTarget.getBoundingClientRect();
                                                                setMenuPosition({
                                                                    row: row,
                                                                    top: rect.bottom + window.scrollY,
                                                                    left: rect.left + window.scrollX
                                                                });
                                                            },
                                                            children: "Actions \u25BC"
                                                        })
                                                    })
                                                })
                                            ]
                                        }, row.InvoiceGroupKey)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            colSpan: "12",
                                            children: "No invoices found in the checker hold queue."
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }),
                menuPosition && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    ref: menuRef,
                    className: "global-action-menu",
                    style: {
                        position: "fixed",
                        top: menuPosition.top,
                        left: menuPosition.left,
                        zIndex: 999999
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>{
                                handleAction(menuPosition.row, "approve");
                                setMenuPosition(null);
                            },
                            children: "\u2713 Approve"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>{
                                handleAction(menuPosition.row, "reject");
                                setMenuPosition(null);
                            },
                            children: "\u2715 Reject"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>{
                                setEditTarget({
                                    invoiceGroupKey: menuPosition.row.invoiceGroupKey
                                });
                                setMenuPosition(null);
                            },
                            children: "\u270E Edit"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90a432d2bdd32db5$export$2e2bcd8739ae039), {
                    detail: statusDetail,
                    onClose: ()=>setStatusDetail(null),
                    onSaved: loadRows
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5ce0857a82cd5c0f$var$TrailModal, {
                    trail: trail,
                    loading: trailLoading,
                    onClose: ()=>setTrail(null)
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c5c59f6c0eb6d77$export$2e2bcd8739ae039), {
                    invoiceGroupKey: editTarget?.invoiceGroupKey,
                    onClose: ()=>setEditTarget(null),
                    onSaved: loadRows
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");



function $b26f6d518cd44f55$var$formatDate(value) {
    if (!value) return "-";
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return value;
    return parsed.toLocaleDateString();
}
function $b26f6d518cd44f55$export$2e2bcd8739ae039() {
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [actionKey, setActionKey] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [menuPosition, setMenuPosition] = (0, $acw62.useState)(null);
    const [approvalModal, setApprovalModal] = (0, $acw62.useState)({
        open: false,
        row: null,
        approvalData: {}
    });
    const summary = (0, $acw62.useMemo)(()=>({
            count: rows.length,
            updatedInvoices: rows.filter((row)=>row.checker_approval?.["Updated InvNumber"]).length,
            updatedGst: rows.filter((row)=>row.checker_approval?.["Updated VendorGST"]).length
        }), [
        rows
    ]);
    const menuRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) setMenuPosition(null);
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    async function loadRows() {
        setLoading(true);
        setError("");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/get-InvoiceNumberChange-pending/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                }
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok || !payload?.success) throw new Error(payload?.message || "Unable to load checker Not found in MIGO approvals.");
            setRows(payload.data || []);
        } catch (requestError) {
            setError(requestError.message || "Unable to load checker Not found in MIGO approvals.");
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadRows();
    }, []);
    async function handleAction(approvalModal, type) {
        setStatus("");
        setError("");
        setActionKey(`${type}-${approvalModal.row.InvoiceGroupKey}`);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const endpoint = type === "approve" ? "/api/approve-InvoicenNum-Change/" : "/api/reject-InvoicenNum-Change/";
            const response = await fetch(endpoint, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    invoice_group_key: approvalModal.row.InvoiceGroupKey,
                    checker_approval: approvalModal.approvalData
                })
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok || payload?.status !== "success") throw new Error(payload?.message || `Unable to ${type} invoice.`);
            setStatus(payload.message || `Invoice ${type}d successfully.`);
            await loadRows();
        } catch (requestError) {
            setError(requestError.message || `Unable to ${type} invoice.`);
        } finally{
            setActionKey("");
        }
    }
    function openLegacyNoMigoPage() {
        window.localStorage.setItem("activeApprovalSection", "other_approvals");
        window.open((0, $96e14f2a7c3555e4$export$5d9c32988b6a9848)("/checker-dashboard/"), "_blank", "noreferrer");
    }
    function refreshPendingActions() {
        loadRows();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $96fe7c33bdd2f764$export$2e2bcd8739ae039), {
        title: "Invoice Number/ Gst Number Change Approvals",
        intro: "Review invoice-number and vendor-GST updates that need checker approval before the invoice returns to processing",
        metrics: [
            {
                label: "Queue",
                value: summary.count
            }
        ],
        actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            className: "ghost-button processor-view__refresh",
            type: "button",
            onClick: refreshPendingActions,
            children: "Refresh"
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "processor-view",
            children: [
                status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "config-banner config-banner--success",
                    children: status
                }) : null,
                error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "config-banner config-banner--error",
                    children: error
                }) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "workspace-panel",
                    children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "config-note",
                        children: "Loading checker MIGO approvals\u2026"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-table processor-table",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice ID"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Vendor Name"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice No"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice Date"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "File"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Action"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: rows.length ? rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.InvoiceId
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.VendorName || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.InvNo || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $b26f6d518cd44f55$var$formatDate(row.InvDate)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.InvoiceId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        href: (0, $96e14f2a7c3555e4$export$5d9c32988b6a9848)(`/api/invoice/view/${row.InvoiceId}/`),
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: "PDF"
                                                    }) : "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "btn btn-primary btn-sm",
                                                        onClick: ()=>setApprovalModal({
                                                                open: true,
                                                                row: row,
                                                                approvalData: structuredClone(row.checker_approval || {})
                                                            }),
                                                        children: "Approvals"
                                                    })
                                                })
                                            ]
                                        }, row.InvoiceGroupKey)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            colSpan: "9",
                                            children: "No invoices found in the checker Not found in MIGO queue."
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }),
                menuPosition && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "global-action-menu",
                    style: {
                        position: "fixed",
                        top: menuPosition.top,
                        left: menuPosition.left,
                        zIndex: 999999
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>{
                                handleAction(menuPosition.row, "approve");
                                setMenuPosition(null);
                            },
                            children: "\u2713 Approve"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>{
                                handleAction(menuPosition.row, "reject");
                                setMenuPosition(null);
                            },
                            children: "\u2715 Reject"
                        })
                    ]
                }),
                approvalModal.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "checker-invoicenum-approval-modal-overlay",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "checker-invoicenum-approval-modal",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "checker-invoicenum-approval-modal-header",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        children: "Checker Approval"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "checker-invoicenum-modal-close",
                                        onClick: ()=>setApprovalModal({
                                                open: false,
                                                row: null,
                                                approvalData: {}
                                            }),
                                        children: "\u2715"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "checker-invoicenum-approval-info",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "Vendor:"
                                            }),
                                            " ",
                                            approvalModal.row?.VendorName
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "Invoice:"
                                            }),
                                            " ",
                                            approvalModal.row?.InvNo
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                className: "checker-invoicenum-approval-table",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Field"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "OCR Value"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Updated Value"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                        children: Object.entries(approvalModal.approvalData).map(([key, item])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: item.label
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: item.OCR || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            value: item.Updated || "",
                                                            onChange: (e)=>{
                                                                setApprovalModal((current)=>{
                                                                    const next = structuredClone(current);
                                                                    next.approvalData[key].Updated = e.target.value;
                                                                    return next;
                                                                });
                                                            }
                                                        })
                                                    })
                                                ]
                                            }, key))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "checker-invoicenum-approval-footer",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "checker-invoicenum-reject-btn",
                                        onClick: ()=>handleAction(approvalModal, "reject"),
                                        children: "Reject"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "checker-invoicenum-approve-btn",
                                        onClick: ()=>handleAction(approvalModal, "approve"),
                                        children: "Approve"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");



function $3eeb7c62d17c8968$var$formatAmount(value) {
    if (value === null || value === undefined || value === "") return "-";
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return String(value);
    return new Intl.NumberFormat("en-IN", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    }).format(numericValue);
}
function $3eeb7c62d17c8968$var$formatDate(value) {
    if (!value) return "-";
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return value;
    return parsed.toLocaleDateString();
}
function $3eeb7c62d17c8968$export$2e2bcd8739ae039({ title: title = "Pending Assignment", intro: intro = "Assign pending processor invoices to available processors by team while continuing to use the current Django assignment flow.", endpoint: endpoint = "/api/get-UnassignedInvoices-team/", legacySection: legacySection = "pendinginvoices", legacyButtonLabel: legacyButtonLabel = "Open Legacy Assignment Page", loadingLabel: loadingLabel = "Loading pending assignments\u2026", emptyLabel: emptyLabel = "No invoices found in the pending assignment queue.", queueLabel: queueLabel = "pending assignments", queueNote: queueNote = "Invoices waiting for processor assignment.", unassignedNote: unassignedNote = "Invoices that do not currently have a processor selected." }) {
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [processors, setProcessors] = (0, $acw62.useState)({});
    const [assignments, setAssignments] = (0, $acw62.useState)({});
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [actionKey, setActionKey] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const summary = (0, $acw62.useMemo)(()=>{
        const teams = new Set(rows.map((row)=>row.team_assigned).filter(Boolean));
        const unassigned = rows.filter((row)=>!row.processor_assigned_id).length;
        return {
            count: rows.length,
            teams: teams.size,
            unassigned: unassigned
        };
    }, [
        rows
    ]);
    async function loadRows() {
        setLoading(true);
        setError("");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch(endpoint, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                }
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok || !payload?.success) throw new Error(payload?.message || `Unable to load ${title.toLowerCase()}.`);
            const nextRows = payload.data || [];
            const nextProcessors = payload.processors || {};
            const nextAssignments = {};
            nextRows.forEach((row)=>{
                nextAssignments[row.InvoiceGroupKey] = row.processor_assigned_id ? String(row.processor_assigned_id) : "";
            });
            setRows(nextRows);
            setProcessors(nextProcessors);
            setAssignments(nextAssignments);
        } catch (requestError) {
            setError(requestError.message || `Unable to load ${title.toLowerCase()}.`);
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadRows();
    }, []);
    async function handleSubmit(row) {
        const selectedProcessorId = assignments[row.InvoiceGroupKey];
        const selectedProcessor = (processors[row.team_assigned] || []).find((processor)=>String(processor.id) === String(selectedProcessorId));
        if (!selectedProcessor) {
            setError("Please select a processor before submitting the assignment.");
            return;
        }
        setStatus("");
        setError("");
        setActionKey(row.InvoiceGroupKey);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/assign-processor/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    InvoiceGroupKey: row.InvoiceGroupKey,
                    processor_id: selectedProcessorId,
                    processor_email: selectedProcessor.email
                })
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok || !payload?.success) throw new Error(payload?.message || "Unable to assign processor.");
            setStatus(`Processor assigned successfully for invoice ${row.InvoiceId}.`);
            await loadRows();
        } catch (requestError) {
            setError(requestError.message || "Unable to assign processor.");
        } finally{
            setActionKey("");
        }
    }
    function openLegacyAssignmentPage() {
        window.localStorage.setItem("activeApprovalSection", legacySection);
        window.open((0, $96e14f2a7c3555e4$export$5d9c32988b6a9848)("/checker-dashboard/"), "_blank", "noreferrer");
    }
    function refreshPendingActions() {
        loadRows();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $96fe7c33bdd2f764$export$2e2bcd8739ae039), {
        title: "Assign available invoices to processors",
        intro: "",
        metrics: [
            {
                label: "Queue",
                value: summary.count
            },
            {
                label: "Teams",
                value: summary.teams
            },
            {
                label: "Unassigned",
                value: summary.unassigned
            }
        ],
        actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            className: "ghost-button processor-view__refresh",
            type: "button",
            onClick: refreshPendingActions,
            children: "Refresh Pending Actions"
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "processor-view",
            children: [
                status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "config-banner config-banner--success",
                    children: status
                }) : null,
                error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "config-banner config-banner--error",
                    children: error
                }) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "workspace-panel",
                    children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "config-note",
                        children: loadingLabel
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-table processor-table",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice ID"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Vendor Name"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice No."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice Date"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice Value"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Team"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "File"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Assign To"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Submit"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: rows.length ? rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.InvoiceId
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.VendorName || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.InvoiceNo || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $3eeb7c62d17c8968$var$formatDate(row.InvoiceDate)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $3eeb7c62d17c8968$var$formatAmount(row.InvoiceValue)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.team_assigned || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.InvoiceId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        href: (0, $96e14f2a7c3555e4$export$5d9c32988b6a9848)(`/api/invoice/view/${row.InvoiceId}/`),
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: "PDF"
                                                    }) : "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        value: assignments[row.InvoiceGroupKey] || "",
                                                        onChange: (event)=>setAssignments((current)=>({
                                                                    ...current,
                                                                    [row.InvoiceGroupKey]: event.target.value
                                                                })),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "",
                                                                children: "-- Select --"
                                                            }),
                                                            (processors[row.team_assigned] || []).map((processor)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: processor.id,
                                                                    children: processor.email || processor.username
                                                                }, processor.id))
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "primary-button processor-action-button",
                                                        type: "button",
                                                        disabled: actionKey === row.InvoiceGroupKey,
                                                        onClick: ()=>handleSubmit(row),
                                                        children: actionKey === row.InvoiceGroupKey ? "Submitting..." : "Submit"
                                                    })
                                                })
                                            ]
                                        }, row.InvoiceGroupKey)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            colSpan: "9",
                                            children: emptyLabel
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");







function $c70bad06ce28be97$var$formatAmount(value) {
    if (value === null || value === undefined || value === "") return "-";
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return String(value);
    return new Intl.NumberFormat("en-IN", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    }).format(numericValue);
}
function $c70bad06ce28be97$var$formatDate(value) {
    if (!value) return "-";
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return value;
    return parsed.toLocaleDateString();
}
function $c70bad06ce28be97$var$getApprovalRows(approvalData) {
    const fieldRows = Object.entries(approvalData?.approval_req_field || {}).map(([parameter, row])=>({
            section: "Field Matrix",
            parameter: parameter,
            sub: "",
            original: row?.Original_Value,
            updated: row?.Updated_Value,
            status: row?.Checker_Approavl || "pending"
        }));
    const radioRows = Object.entries(approvalData?.approval_req_radio || {}).map(([parameter, row])=>({
            section: "Radio Matrix",
            parameter: parameter,
            sub: row?.Param || row?.param || row?.Section || "",
            original: row?.Original_Value,
            updated: row?.Updated_Value,
            status: row?.Checker_Approavl || "pending"
        }));
    return [
        ...fieldRows,
        ...radioRows
    ];
}
function $c70bad06ce28be97$var$hasPendingApprovals(approvalData) {
    return $c70bad06ce28be97$var$getApprovalRows(approvalData).some((row)=>String(row.status).toLowerCase() === "pending");
}
function $c70bad06ce28be97$var$StatusModal({ detail: detail, onClose: onClose }) {
    if (!detail) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "checker-status-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Status Detail"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "checker-status-title",
                                    children: detail.label
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: detail.message || "No additional message available."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                    className: "processor-modal__code",
                    children: JSON.stringify(detail.data ?? {}, null, 2)
                })
            ]
        })
    });
}
function $c70bad06ce28be97$var$TrailModal({ trail: trail, loading: loading, onClose: onClose }) {
    (0, $acw62.useEffect)(()=>{
        if (!trail && !loading) return;
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        trail,
        loading,
        onClose
    ]);
    if (!trail && !loading) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card processor-modal__card--wide",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "processor-trail-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Audit Log"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "processor-trail-title",
                                    children: "Invoice timeline"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: "Loading audit log\u2026"
                }) : trail?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "processor-timeline",
                    children: trail.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                            className: "processor-timeline__item",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__step",
                                    children: [
                                        "Step ",
                                        entry.step
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__content",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: entry.action
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: entry.message || "No message recorded."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                entry.username || "System",
                                                entry.userrole ? ` (${entry.userrole})` : "",
                                                entry.created_at ? ` \u{2022} ${new Date(entry.created_at).toLocaleString()}` : ""
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, `${entry.step}-${entry.created_at}`))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "empty-state",
                    children: "No timeline available for this invoice."
                })
            ]
        })
    });
}
function $c70bad06ce28be97$var$ApprovalModal({ row: row, loadingKey: loadingKey, onApprove: onApprove, onClose: onClose }) {
    if (!row) return null;
    const approvalRows = $c70bad06ce28be97$var$getApprovalRows(row.checkerApproval);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card processor-modal__card--wide",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "checker-approval-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Checker Approval"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                    id: "checker-approval-title",
                                    children: [
                                        "Pending edits for invoice ",
                                        row.invoiceId
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                approvalRows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "config-table processor-table",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Section"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Parameter"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Original"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Updated"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Approve"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                children: [
                                    approvalRows.map((approvalRow)=>{
                                        const actionId = `${row.invoiceGroupKey}-${approvalRow.section}-${approvalRow.parameter}-${approvalRow.sub || "none"}`;
                                        const isApproved = String(approvalRow.status).toLowerCase() !== "pending";
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: approvalRow.section
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: approvalRow.sub ? `${approvalRow.parameter} -> ${approvalRow.sub}` : approvalRow.parameter
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: approvalRow.original || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: approvalRow.updated || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: isApproved ? "Approved" : "Pending"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "ghost-button",
                                                        type: "button",
                                                        disabled: isApproved || loadingKey === actionId,
                                                        onClick: ()=>onApprove(row, {
                                                                matrix: approvalRow.section,
                                                                parameter: approvalRow.parameter,
                                                                sub: approvalRow.sub || "",
                                                                type: "single",
                                                                actionId: actionId
                                                            }),
                                                        children: loadingKey === actionId ? "Approving..." : isApproved ? "Approved" : "Approve"
                                                    })
                                                })
                                            ]
                                        }, actionId);
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            colSpan: "6",
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "primary-button",
                                                type: "button",
                                                disabled: loadingKey === `${row.invoiceGroupKey}-all`,
                                                onClick: ()=>onApprove(row, {
                                                        matrix: "all",
                                                        parameter: "all",
                                                        sub: "all",
                                                        type: "all",
                                                        actionId: `${row.invoiceGroupKey}-all`
                                                    }),
                                                children: loadingKey === `${row.invoiceGroupKey}-all` ? "Approving..." : "Approve All Changes"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "empty-state",
                    children: "No checker approval items are attached to this invoice."
                })
            ]
        })
    });
}
function $c70bad06ce28be97$export$2e2bcd8739ae039() {
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [actionKey, setActionKey] = (0, $acw62.useState)("");
    const [approvalLoadingKey, setApprovalLoadingKey] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [selectedRows, setSelectedRows] = (0, $acw62.useState)([]);
    const [statusDetail, setStatusDetail] = (0, $acw62.useState)(null);
    const [trail, setTrail] = (0, $acw62.useState)(null);
    const [trailLoading, setTrailLoading] = (0, $acw62.useState)(false);
    const [approvalRow, setApprovalRow] = (0, $acw62.useState)(null);
    const [menuPosition, setMenuPosition] = (0, $acw62.useState)(null);
    const [editTarget, setEditTarget] = (0, $acw62.useState)(null);
    const [statusInvoiceRow, setStatusInvoiceRow] = (0, $acw62.useState)(null);
    const [filteredRows, setFilteredRows] = (0, $acw62.useState)([]);
    const [teams, setTeams] = (0, $acw62.useState)([]);
    const [userTeam, setUserTeam] = (0, $acw62.useState)("");
    const [selectedTeam, setSelectedTeam] = (0, $acw62.useState)("");
    const [scoringOptions, setScoringOptions] = (0, $acw62.useState)({});
    const allSelected = rows.length > 0 && selectedRows.length === rows.length;
    const summary = (0, $acw62.useMemo)(()=>{
        const pendingApprovalCount = rows.filter((row)=>$c70bad06ce28be97$var$hasPendingApprovals(row.checkerApproval)).length;
        return {
            count: rows.length,
            selected: selectedRows.length,
            redFlags: rows.reduce((count, row)=>count + Object.values(row.invoiceCheck || {}).filter((item)=>item?.color === "r").length, 0),
            pendingApprovalCount: pendingApprovalCount
        };
    }, [
        rows,
        selectedRows
    ]);
    const menuRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!menuPosition) return;
        const handleClickOutside = (event)=>{
            if (menuRef.current && !menuRef.current.contains(event.target)) setMenuPosition(null);
        };
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") setMenuPosition(null);
        };
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        menuPosition
    ]);
    async function loadRows() {
        setLoading(true);
        setError("");
        try {
            const response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/checker/pending-approvals/");
            const nextRows = response.data || [];
            const nextTeams = response.teams || [];
            const nextUserTeam = response.user_team || "";
            setRows(nextRows);
            setScoringOptions(response.scoringOptions || {});
            setTeams(nextTeams);
            setUserTeam(nextUserTeam);
            // Default filter = logged-in user's team
            setSelectedTeam(nextUserTeam);
            // Initially show only user's team's rows
            const userRows = nextRows.filter((row)=>(row.team || "").trim().toLowerCase() === nextUserTeam.trim().toLowerCase());
            setFilteredRows(userRows);
            return nextRows;
        } catch (requestError) {
            setError(requestError.message || "Unable to load checker pending approvals.");
            return [];
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadRows();
    }, []);
    function toggleRowSelection(invoiceGroupKey) {
        setSelectedRows((current)=>current.includes(invoiceGroupKey) ? current.filter((item)=>item !== invoiceGroupKey) : [
                ...current,
                invoiceGroupKey
            ]);
    }
    function toggleAllRows() {
        setSelectedRows((current)=>current.length === rows.length ? [] : rows.map((row)=>row.invoiceGroupKey));
    }
    async function handleTrailOpen(row) {
        setTrail(null);
        setTrailLoading(true);
        try {
            const response = await fetch(`/api/invoice/trail/${row.invoiceId}/`, {
                credentials: "include"
            });
            const payload = await response.json();
            if (!response.ok || !payload.success) throw new Error(payload.message || "Unable to load trail.");
            setTrail(payload.data || []);
        } catch (requestError) {
            setTrail([]);
            setError(requestError.message || "Unable to load trail.");
        } finally{
            setTrailLoading(false);
        }
    }
    async function handleAction(row, type) {
        setStatus("");
        setError("");
        if (type === "approve" && $c70bad06ce28be97$var$hasPendingApprovals(row.checkerApproval)) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "warning",
                title: "Approval Pending",
                text: "Some changes need approval under the Approval tab. Please confirm all changes before approving the invoice.",
                confirmButtonText: "OK"
            });
            return;
        }
        setActionKey(`${type}-${row.invoiceGroupKey}`);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            let url = "";
            let body = {};
            if (type === "approve") {
                url = "/api/approve-invoice/";
                body = {
                    invoice_group_key: row.invoiceGroupKey,
                    tab: 'Checker'
                };
            } else if (type === "hold") {
                url = "/api/hold-invoice/";
                body = {
                    invoice_group_key: row.invoiceGroupKey,
                    tab: 'Checker'
                };
            } else if (type === "reject") {
                url = "/api/reject-invoice/";
                body = {
                    invoice_group_key: row.invoiceGroupKey,
                    tab: 'Checker'
                };
            }
            const response = await fetch(url, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify(body)
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || `Unable to ${type} invoice.`);
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: `${type.charAt(0).toUpperCase() + type.slice(1)} Successful`,
                text: payload.message || `Invoice ${type}d successfully.`,
                confirmButtonText: "OK"
            });
            setSelectedRows((current)=>current.filter((item)=>item !== row.invoiceGroupKey));
            await loadRows();
        } catch (requestError) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: `${type.charAt(0).toUpperCase() + type.slice(1)} Failed`,
                text: requestError.message || `Unable to ${type} invoice.`,
                confirmButtonText: "OK"
            });
        } finally{
            setActionKey("");
        }
    }
    async function handleApprovalAction(row, approvalAction) {
        setApprovalLoadingKey(approvalAction.actionId);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/checker-edits-approve/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    invoice_group_key: row.invoiceGroupKey,
                    matrix: approvalAction.matrix,
                    parameter: approvalAction.parameter,
                    sub: approvalAction.sub,
                    type: approvalAction.type
                })
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "ok" && payload.status !== "success") throw new Error(payload.message || "Unable to approve checker edits.");
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Approval Updated",
                text: payload.message || "Checker approval updated successfully.",
                confirmButtonText: "OK"
            });
            const nextRows = await loadRows();
            setApprovalRow((current)=>{
                if (!current) return null;
                return nextRows.find((item)=>item.invoiceGroupKey === current.invoiceGroupKey) || null;
            });
        } catch (requestError) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Approval Failed",
                text: requestError.message || "Unable to approve checker edits.",
                confirmButtonText: "OK"
            });
        } finally{
            setApprovalLoadingKey("");
        }
    }
    async function handlePreview(row) {
        setStatus("");
        setError("");
        setActionKey(`preview-${row.invoiceGroupKey}`);
        // Open immediately from user click
        const previewWindow = window.open("", "_blank");
        if (!previewWindow) {
            setError("Preview window was blocked by the browser.");
            return;
        }
        previewWindow.document.write("<html><body><h3>Loading preview...</h3></body></html>");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/template-preview/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    invoice_keys: [
                        row.invoiceGroupKey
                    ],
                    material_service: row.material_service
                })
            });
            const payload = await response.json();
            if (!response.ok || payload?.status !== "success") throw new Error(payload?.message || "Unable to generate preview.");
            let html = "<html><head><title>Preview</title></head><body style='padding:24px;font-family:Segoe UI,sans-serif;'>";
            Object.entries(payload.template_html || {}).forEach(([key, value])=>{
                html += `<h3>${key}</h3>${value}<hr/>`;
            });
            html += "</body></html>";
            previewWindow.document.open();
            previewWindow.document.write(html);
            previewWindow.document.close();
        } catch (requestError) {
            previewWindow.close();
            setError(requestError.message || "Unable to generate preview.");
        } finally{
            setActionKey("");
        }
    }
    function refreshPendingActions() {
        loadRows();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $96fe7c33bdd2f764$export$2e2bcd8739ae039), {
        title: "Checker Pending Approval",
        intro: "Review invoices waiting with checker approval, inspect change approvals",
        metrics: [
            {
                label: "Queue",
                value: summary.count
            }
        ],
        actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            className: "ghost-button processor-view__refresh",
            type: "button",
            onClick: refreshPendingActions,
            children: "Refresh Pending Actions"
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "processor-view",
            children: [
                status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "config-banner config-banner--success",
                    children: status
                }) : null,
                error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "config-banner config-banner--error",
                    children: error
                }) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "workspace-panel",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "team-filter",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "team-filter",
                                    children: "Filter by Team"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                    id: "team-filter",
                                    value: selectedTeam,
                                    onChange: (event)=>{
                                        const team = event.target.value;
                                        setSelectedTeam(team);
                                        setFilteredRows(rows.filter((row)=>(row.team || "").trim().toLowerCase() === team.trim().toLowerCase()));
                                    },
                                    children: teams.map((team)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: team,
                                            children: team
                                        }, team))
                                })
                            ]
                        }),
                        loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "config-note",
                            children: "Loading checker approvals\u2026"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "config-table processor-table",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice ID"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Vendor Name"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice No."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice Date"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice Value"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Status"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Response"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "File"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Preview"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Approval"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                    children: [
                                                        "Select",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            className: "processor-checkbox",
                                                            type: "checkbox",
                                                            checked: allSelected,
                                                            onChange: toggleAllRows
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Logs"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Action"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                        children: filteredRows.length ? filteredRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.invoiceId
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.vendorName || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.invoiceNo || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: $c70bad06ce28be97$var$formatDate(row.invoiceDate)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: $c70bad06ce28be97$var$formatAmount(row.invoiceValue)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "processor-status-list",
                                                            children: Object.entries(row.invoiceCheck || {}).length ? Object.entries(row.invoiceCheck || {}).map(([label, item])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    className: `processor-status-dot processor-status-dot--${item?.color || "o"}`,
                                                                    type: "button",
                                                                    title: `${label}: ${item?.message || ""}`,
                                                                    onClick: ()=>{
                                                                        setStatusInvoiceRow(row);
                                                                        setStatusDetail({
                                                                            label: label,
                                                                            message: item?.message,
                                                                            data: item?.data,
                                                                            key: item?.key || label,
                                                                            checkKey: label,
                                                                            uniqueKey: row.invoiceGroupKey,
                                                                            color: item?.color || "o"
                                                                        });
                                                                    }
                                                                }, `${row.invoiceGroupKey}-${label}`)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "empty-state",
                                                                children: "No checks"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.uniqueName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            onClick: ()=>(0, $3d6d578a87c5904f$export$2926f86deb178d44)(`${row.uniqueName}.json`),
                                                            children: "Data"
                                                        }) : "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.uniqueName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>(0, $e267546ad9d86d30$export$a38ce99a4bdccd4e)(row.invoiceId),
                                                            children: "\uD83D\uDCCE"
                                                        }) : "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: "ghost-button",
                                                            type: "button",
                                                            disabled: actionKey === `preview-${row.InvoiceGroupKey}`,
                                                            onClick: ()=>handlePreview(row),
                                                            children: actionKey === `preview-${row.InvoiceGroupKey}` ? "Previewing..." : "Preview"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: "ghost-button",
                                                            type: "button",
                                                            onClick: ()=>setApprovalRow(row),
                                                            children: $c70bad06ce28be97$var$hasPendingApprovals(row.checkerApproval) ? "Approval Pending" : "Approved"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            className: "processor-checkbox",
                                                            type: "checkbox",
                                                            checked: selectedRows.includes(row.invoiceGroupKey),
                                                            onChange: ()=>toggleRowSelection(row.invoiceGroupKey)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: "ghost-button",
                                                            type: "button",
                                                            onClick: ()=>handleTrailOpen(row),
                                                            children: "Logs"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "action-dropdown-wrapper",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "action-menu-button",
                                                                onClick: (e)=>{
                                                                    if (menuPosition?.row?.invoiceGroupKey === row.invoiceGroupKey) {
                                                                        setMenuPosition(null);
                                                                        return;
                                                                    }
                                                                    const rect = e.currentTarget.getBoundingClientRect();
                                                                    setMenuPosition({
                                                                        row: row,
                                                                        top: rect.bottom + window.scrollY,
                                                                        left: rect.left + window.scrollX
                                                                    });
                                                                },
                                                                children: "Actions \u25BC"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, row.invoiceGroupKey)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                colSpan: "13",
                                                children: "No checker pending approvals found."
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                menuPosition && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    ref: menuRef,
                    className: "global-action-menu",
                    style: {
                        position: "fixed",
                        top: menuPosition.top,
                        left: menuPosition.left,
                        zIndex: 999999
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>{
                                handleAction(menuPosition.row, "approve");
                                setMenuPosition(null);
                            },
                            children: "\u2713 Approve"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>{
                                handleAction(menuPosition.row, "hold");
                                setMenuPosition(null);
                            },
                            children: "\u23F8 Hold"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>{
                                handleAction(menuPosition.row, "reject");
                                setMenuPosition(null);
                            },
                            children: "\u2715 Reject"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>{
                                setEditTarget({
                                    invoiceGroupKey: menuPosition.row.invoiceGroupKey
                                });
                                setMenuPosition(null);
                            },
                            children: "\u270E Edit"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90a432d2bdd32db5$export$2e2bcd8739ae039), {
                    detail: statusDetail,
                    invoiceRow: statusInvoiceRow,
                    scoringOptions: scoringOptions,
                    onClose: ()=>{
                        setStatusDetail(null);
                        setStatusInvoiceRow(null);
                    },
                    onSaved: loadRows
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c70bad06ce28be97$var$TrailModal, {
                    trail: trail,
                    loading: trailLoading,
                    onClose: ()=>setTrail(null)
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c70bad06ce28be97$var$ApprovalModal, {
                    row: approvalRow,
                    loadingKey: approvalLoadingKey,
                    onApprove: handleApprovalAction,
                    onClose: ()=>setApprovalRow(null)
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c5c59f6c0eb6d77$export$2e2bcd8739ae039), {
                    invoiceGroupKey: editTarget?.invoiceGroupKey,
                    onClose: ()=>setEditTarget(null),
                    onSaved: loadRows
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");





function $4d81bcb8b8534864$var$formatAmount(value) {
    if (value === null || value === undefined || value === "") return "-";
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return String(value);
    return new Intl.NumberFormat("en-IN", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    }).format(numericValue);
}
function $4d81bcb8b8534864$var$StatusModal({ detail: detail, onClose: onClose }) {
    if (!detail) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "checker-ready-status-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Status Detail"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "checker-ready-status-title",
                                    children: detail.label
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: detail.message || "No additional message available."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                    className: "processor-modal__code",
                    children: JSON.stringify(detail.data ?? {}, null, 2)
                })
            ]
        })
    });
}
function $4d81bcb8b8534864$var$TrailModal({ trail: trail, loading: loading, onClose: onClose }) {
    (0, $acw62.useEffect)(()=>{
        if (!trail && !loading) return;
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        trail,
        loading,
        onClose
    ]);
    if (!trail && !loading) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card processor-modal__card--wide",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "processor-trail-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Audit Log"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "processor-trail-title",
                                    children: "Invoice timeline"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: "Loading audit log\u2026"
                }) : trail?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "processor-timeline",
                    children: trail.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                            className: "processor-timeline__item",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__step",
                                    children: [
                                        "Step ",
                                        entry.step
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__content",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: entry.action
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: entry.message || "No message recorded."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                entry.username || "System",
                                                entry.userrole ? ` (${entry.userrole})` : "",
                                                entry.created_at ? ` \u{2022} ${new Date(entry.created_at).toLocaleString()}` : ""
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, `${entry.step}-${entry.created_at}`))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "empty-state",
                    children: "No timeline available for this invoice."
                })
            ]
        })
    });
}
function $4d81bcb8b8534864$var$isAccountBlocked(row) {
    const indicator = String(row.account_indicator || "").trim();
    return indicator !== "" && indicator !== "N";
}
function $4d81bcb8b8534864$export$2e2bcd8739ae039() {
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [actionKey, setActionKey] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [selectedRows, setSelectedRows] = (0, $acw62.useState)([]);
    const [statusDetail, setStatusDetail] = (0, $acw62.useState)(null);
    const [trail, setTrail] = (0, $acw62.useState)(null);
    const [trailLoading, setTrailLoading] = (0, $acw62.useState)(false);
    const allSelected = rows.length > 0 && selectedRows.length === rows.length;
    const summary = (0, $acw62.useMemo)(()=>({
            count: rows.length,
            selected: selectedRows.length,
            redFlags: rows.reduce((count, row)=>count + Object.values(row.InvoiceCheck || {}).filter((item)=>item?.color === "r").length, 0)
        }), [
        rows,
        selectedRows
    ]);
    async function loadRows() {
        setLoading(true);
        setError("");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/get-ready/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                }
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok || payload?.error) throw new Error(payload?.message || payload?.error || `Unable to load checker ready invoices. Backend responded with ${response.status}.`);
            if (!payload) throw new Error("Unable to load checker ready invoices. Backend returned a non-JSON response.");
            setRows(payload.data || []);
        } catch (requestError) {
            setError(requestError.message || "Unable to load checker ready invoices.");
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadRows();
    }, []);
    function toggleRowSelection(invoiceGroupKey) {
        setSelectedRows((current)=>current.includes(invoiceGroupKey) ? current.filter((item)=>item !== invoiceGroupKey) : [
                ...current,
                invoiceGroupKey
            ]);
    }
    function toggleAllRows() {
        setSelectedRows((current)=>current.length === rows.length ? [] : rows.map((row)=>row.InvoiceGroupKey));
    }
    async function handleTrailOpen(row) {
        setTrail(null);
        setTrailLoading(true);
        try {
            const response = await fetch(`/api/invoice/trail/${row.InvoiceId}/`, {
                credentials: "include"
            });
            const payload = await response.json();
            if (!response.ok || !payload.success) throw new Error(payload.message || "Unable to load trail.");
            setTrail(payload.data || []);
        } catch (requestError) {
            setTrail([]);
            setError(requestError.message || "Unable to load trail.");
        } finally{
            setTrailLoading(false);
        }
    }
    async function handleAction(row, type) {
        setStatus("");
        setError("");
        setActionKey(`${type}-${row.InvoiceGroupKey}`);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            let url = "";
            let body = {};
            if (type === "approve") {
                url = "/api/approve-invoice/";
                body = {
                    invoice_group_key: row.InvoiceGroupKey
                };
            } else if (type === "reject") {
                url = "/api/reject-invoice/";
                body = {
                    invoice_group_key: row.InvoiceGroupKey
                };
            }
            const response = await fetch(url, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify(body)
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || `Unable to ${type} invoice.`);
            setStatus(payload.message || `Invoice ${type}d successfully.`);
            setSelectedRows((current)=>current.filter((item)=>item !== row.InvoiceGroupKey));
            await loadRows();
        } catch (requestError) {
            setError(requestError.message || `Unable to ${type} invoice.`);
        } finally{
            setActionKey("");
        }
    }
    async function handlePreview(row) {
        setStatus("");
        setError("");
        setActionKey(`preview-${row.InvoiceGroupKey}`);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/template-preview/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    invoice_keys: [
                        row.InvoiceGroupKey
                    ]
                })
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || "Unable to generate preview.");
            const previewWindow = window.open("", "_blank", "noreferrer");
            if (!previewWindow) throw new Error("Preview window was blocked by the browser.");
            let html = "<html><head><title>Preview</title></head><body style='padding:24px;font-family:Segoe UI,sans-serif;'>";
            Object.entries(payload.template_html || {}).forEach(([key, value])=>{
                html += `<h3>${key}</h3>${value}<hr/>`;
            });
            html += "</body></html>";
            previewWindow.document.write(html);
            previewWindow.document.close();
        } catch (requestError) {
            setError(requestError.message || "Unable to generate preview.");
        } finally{
            setActionKey("");
        }
    }
    async function handleGenerateTemplates() {
        setStatus("");
        setError("");
        const selectedItems = rows.filter((row)=>selectedRows.includes(row.InvoiceGroupKey));
        const selectedKeys = selectedItems.filter((row)=>!$4d81bcb8b8534864$var$isAccountBlocked(row)).map((row)=>row.InvoiceGroupKey);
        const blockedKeys = selectedItems.filter((row)=>$4d81bcb8b8534864$var$isAccountBlocked(row)).map((row)=>row.InvoiceGroupKey);
        if (!selectedKeys.length && !blockedKeys.length) {
            setError("Please select at least one invoice to generate template.");
            return;
        }
        let finalKeysToSend = [
            ...selectedKeys
        ];
        if (blockedKeys.length) {
            const confirmProcess = window.confirm("Some selected invoices have Payment Block applied.\n\nOK -> Process all invoices\nCancel -> Skip blocked invoices");
            if (confirmProcess) {
                const finalConfirm = window.confirm("Are you sure you want to generate the template for\nselected Account Block invoices?");
                if (!finalConfirm) return;
                finalKeysToSend = selectedKeys.concat(blockedKeys);
            }
        }
        if (!finalKeysToSend.length) {
            setError("No invoices available to process after filtering.");
            return;
        }
        setActionKey("generate");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/template-generate/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    invoice_keys: finalKeysToSend
                })
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok || payload?.status !== "success") throw new Error(payload?.message || "Template generation failed.");
            setStatus(buildGenerateSuccessMessage(payload));
            setSelectedRows([]);
            await loadRows();
        } catch (requestError) {
            setError(requestError.message || "Error sending data to backend.");
        } finally{
            setActionKey("");
        }
    }
    function openLegacyReadyPage() {
        window.localStorage.setItem("activeApprovalSection", "ready");
        window.open((0, $96e14f2a7c3555e4$export$5d9c32988b6a9848)("/checker-dashboard/"), "_blank", "noreferrer");
    }
    function refreshPendingActions() {
        loadRows();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $96fe7c33bdd2f764$export$2e2bcd8739ae039), {
        title: "Ready For Template",
        intro: "",
        metrics: [
            {
                label: "Queue",
                value: summary.count
            }
        ],
        actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            className: "ghost-button processor-view__refresh",
            type: "button",
            onClick: refreshPendingActions,
            children: "Refresh Pending Actions"
        }),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "processor-view",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "workspace-panel",
                        children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "config-note",
                            children: "Loading checker ready invoices\u2026"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "config-table processor-table",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice ID"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Vendor Name"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice No."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice Date"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice Value"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice Status"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Response"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "File"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Preview"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Logs"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                    children: [
                                                        "Select",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            className: "processor-checkbox",
                                                            type: "checkbox",
                                                            checked: allSelected,
                                                            onChange: toggleAllRows
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                        children: rows.length ? rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.InvoiceId
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.VendorName || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.InvoiceNo || row.InvNo || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.InvoiceDate || row.InvDate || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: $4d81bcb8b8534864$var$formatAmount(row.InvoiceValue || row.TotalAmount)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "processor-status-list",
                                                            children: Object.entries(row.InvoiceCheck || {}).length ? Object.entries(row.InvoiceCheck || {}).map(([label, item])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    className: `processor-status-dot processor-status-dot--${item?.color || "o"}`,
                                                                    type: "button",
                                                                    title: `${label}: ${item?.message || ""}`,
                                                                    onClick: ()=>setStatusDetail({
                                                                            label: label,
                                                                            message: item?.message,
                                                                            data: item?.data,
                                                                            key: item?.key || label,
                                                                            checkKey: label,
                                                                            uniqueKey: row.InvoiceGroupKey,
                                                                            color: item?.color || "o"
                                                                        })
                                                                }, `${row.InvoiceGroupKey}-${label}`)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "empty-state",
                                                                children: "No checks"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.unique_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            onClick: ()=>(0, $3d6d578a87c5904f$export$2926f86deb178d44)(`${row.unique_name}.json`),
                                                            children: "Data"
                                                        }) : "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.unique_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>(0, $e267546ad9d86d30$export$a38ce99a4bdccd4e)(row.InvoiceId),
                                                            children: "\uD83D\uDCCE"
                                                        }) : "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: "ghost-button",
                                                            type: "button",
                                                            disabled: actionKey === `preview-${row.InvoiceGroupKey}`,
                                                            onClick: ()=>handlePreview(row),
                                                            children: actionKey === `preview-${row.InvoiceGroupKey}` ? "Previewing..." : "Preview"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: "ghost-button",
                                                            type: "button",
                                                            onClick: ()=>handleTrailOpen(row),
                                                            children: "Logs"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            className: "processor-checkbox",
                                                            type: "checkbox",
                                                            checked: selectedRows.includes(row.InvoiceGroupKey),
                                                            onChange: ()=>toggleRowSelection(row.InvoiceGroupKey)
                                                        })
                                                    })
                                                ]
                                            }, row.InvoiceGroupKey)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                colSpan: "12",
                                                children: "No invoices found in the checker ready queue."
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90a432d2bdd32db5$export$2e2bcd8739ae039), {
                        detail: statusDetail,
                        onClose: ()=>setStatusDetail(null),
                        onSaved: loadRows
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4d81bcb8b8534864$var$TrailModal, {
                        trail: trail,
                        loading: trailLoading,
                        onClose: ()=>setTrail(null)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    marginTop: "16px",
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "12px",
                    alignItems: "center",
                    flexWrap: "wrap"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "config-note",
                        style: {
                            margin: 0
                        },
                        children: [
                            summary.selected,
                            " invoice",
                            summary.selected === 1 ? "" : "s",
                            " selected for template generation."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "primary-button",
                        type: "button",
                        disabled: actionKey === "generate",
                        onClick: handleGenerateTemplates,
                        children: actionKey === "generate" ? "Generating..." : "Generate Template"
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");






function $7eed194cab7fcbbd$var$formatAmount(value) {
    if (value === null || value === undefined || value === "") return "-";
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return String(value);
    return new Intl.NumberFormat("en-IN", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    }).format(numericValue);
}
function $7eed194cab7fcbbd$var$StatusModal({ detail: detail, onClose: onClose }) {
    if (!detail) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "checker-rejected-status-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Status Detail"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "checker-rejected-status-title",
                                    children: detail.label
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: detail.message || "No additional message available."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                    className: "processor-modal__code",
                    children: JSON.stringify(detail.data ?? {}, null, 2)
                })
            ]
        })
    });
}
function $7eed194cab7fcbbd$var$TrailModal({ trail: trail, loading: loading, onClose: onClose }) {
    (0, $acw62.useEffect)(()=>{
        if (!trail && !loading) return;
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        trail,
        loading,
        onClose
    ]);
    if (!trail && !loading) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card processor-modal__card--wide",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "processor-trail-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Audit Log"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "processor-trail-title",
                                    children: "Invoice timeline"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: "Loading audit log\u2026"
                }) : trail?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "processor-timeline",
                    children: trail.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                            className: "processor-timeline__item",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__step",
                                    children: [
                                        "Step ",
                                        entry.step
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__content",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: entry.action
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: entry.message || "No message recorded."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                entry.username || "System",
                                                entry.userrole ? ` (${entry.userrole})` : "",
                                                entry.created_at ? ` \u{2022} ${new Date(entry.created_at).toLocaleString()}` : ""
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, `${entry.step}-${entry.created_at}`))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "empty-state",
                    children: "No timeline available for this invoice."
                })
            ]
        })
    });
}
function $7eed194cab7fcbbd$export$2e2bcd8739ae039() {
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [actionKey, setActionKey] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [selectedRows, setSelectedRows] = (0, $acw62.useState)([]);
    const [statusDetail, setStatusDetail] = (0, $acw62.useState)(null);
    const [trail, setTrail] = (0, $acw62.useState)(null);
    const [trailLoading, setTrailLoading] = (0, $acw62.useState)(false);
    const allSelected = rows.length > 0 && selectedRows.length === rows.length;
    const summary = (0, $acw62.useMemo)(()=>({
            count: rows.length,
            selected: selectedRows.length,
            redFlags: rows.reduce((count, row)=>count + Object.values(row.InvoiceCheck || {}).filter((item)=>item?.color === "r").length, 0)
        }), [
        rows,
        selectedRows
    ]);
    async function loadRows() {
        setLoading(true);
        setError("");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/get-rejected/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                }
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok || payload?.error) throw new Error(payload?.message || payload?.error || `Unable to load checker rejected invoices. Backend responded with ${response.status}.`);
            if (!payload) throw new Error("Unable to load checker rejected invoices. Backend returned a non-JSON response.");
            setRows(payload.data || []);
        } catch (requestError) {
            setError(requestError.message || "Unable to load checker rejected invoices.");
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadRows();
    }, []);
    function toggleRowSelection(invoiceGroupKey) {
        setSelectedRows((current)=>current.includes(invoiceGroupKey) ? current.filter((item)=>item !== invoiceGroupKey) : [
                ...current,
                invoiceGroupKey
            ]);
    }
    function toggleAllRows() {
        setSelectedRows((current)=>current.length === rows.length ? [] : rows.map((row)=>row.InvoiceGroupKey));
    }
    async function handleTrailOpen(row) {
        setTrail(null);
        setTrailLoading(true);
        try {
            const response = await fetch(`/api/invoice/trail/${row.InvoiceId}/`, {
                credentials: "include"
            });
            const payload = await response.json();
            if (!response.ok || !payload.success) throw new Error(payload.message || "Unable to load trail.");
            setTrail(payload.data || []);
        } catch (requestError) {
            setTrail([]);
            setError(requestError.message || "Unable to load trail.");
        } finally{
            setTrailLoading(false);
        }
    }
    async function handleAction(row, type) {
        setStatus("");
        setError("");
        setActionKey(`${type}-${row.InvoiceGroupKey}`);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            let url = "";
            let body = {};
            if (type === "approve") {
                url = "/api/approve-invoice/";
                body = {
                    invoice_group_key: row.InvoiceGroupKey
                };
            } else if (type === "reject") {
                url = "/api/reject-invoice/";
                body = {
                    invoice_group_key: row.InvoiceGroupKey
                };
            }
            const response = await fetch(url, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify(body)
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || `Unable to ${type} invoice.`);
            setStatus(payload.message || `Invoice ${type}d successfully.`);
            setSelectedRows((current)=>current.filter((item)=>item !== row.InvoiceGroupKey));
            await loadRows();
        } catch (requestError) {
            setError(requestError.message || `Unable to ${type} invoice.`);
        } finally{
            setActionKey("");
        }
    }
    async function handlePreview(row) {
        setStatus("");
        setError("");
        setActionKey(`preview-${row.invoiceGroupKey}`);
        // Open immediately from user click
        const previewWindow = window.open("", "_blank");
        if (!previewWindow) {
            setError("Preview window was blocked by the browser.");
            return;
        }
        previewWindow.document.write("<html><body><h3>Loading preview...</h3></body></html>");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/template-preview/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    invoice_keys: [
                        row.invoiceGroupKey
                    ],
                    material_service: row.material_service
                })
            });
            const payload = await response.json();
            if (!response.ok || payload?.status !== "success") throw new Error(payload?.message || "Unable to generate preview.");
            let html = "<html><head><title>Preview</title></head><body style='padding:24px;font-family:Segoe UI,sans-serif;'>";
            Object.entries(payload.template_html || {}).forEach(([key, value])=>{
                html += `<h3>${key}</h3>${value}<hr/>`;
            });
            html += "</body></html>";
            previewWindow.document.open();
            previewWindow.document.write(html);
            previewWindow.document.close();
        } catch (requestError) {
            previewWindow.close();
            setError(requestError.message || "Unable to generate preview.");
        } finally{
            setActionKey("");
        }
    }
    function openLegacyRejectedPage() {
        window.localStorage.setItem("activeApprovalSection", "rejected");
        window.open((0, $96e14f2a7c3555e4$export$5d9c32988b6a9848)("/checker-dashboard/"), "_blank", "noreferrer");
    }
    function refreshPendingActions() {
        loadRows();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $96fe7c33bdd2f764$export$2e2bcd8739ae039), {
        title: "Checker Rejected Queue",
        intro: "",
        metrics: [
            {
                label: "Queue",
                value: summary.count
            }
        ],
        actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            className: "ghost-button processor-view__refresh",
            type: "button",
            onClick: refreshPendingActions,
            children: "Refresh Pending Actions"
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "processor-view",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "workspace-panel",
                    children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "config-note",
                        children: "Loading checker rejected invoices\u2026"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-table processor-table",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice ID"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Vendor Name"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice No."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice Date"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice Value"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice Status"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Response"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "File"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Preview"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Logs"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: rows.length ? rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.InvoiceId
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.VendorName || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.InvoiceNo || row.InvNo || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.InvoiceDate || row.InvDate || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $7eed194cab7fcbbd$var$formatAmount(row.InvoiceValue || row.TotalAmount)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "processor-status-list",
                                                        children: Object.entries(row.InvoiceCheck || {}).length ? Object.entries(row.InvoiceCheck || {}).map(([label, item])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                className: `processor-status-dot processor-status-dot--${item?.color || "o"}`,
                                                                type: "button",
                                                                title: `${label}: ${item?.message || ""}`,
                                                                onClick: ()=>setStatusDetail({
                                                                        label: label,
                                                                        message: item?.message,
                                                                        data: item?.data,
                                                                        key: item?.key || label,
                                                                        checkKey: label,
                                                                        uniqueKey: row.InvoiceGroupKey,
                                                                        color: item?.color || "o"
                                                                    })
                                                            }, `${row.InvoiceGroupKey}-${label}`)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "empty-state",
                                                            children: "No checks"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.uniqueName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        onClick: ()=>(0, $3d6d578a87c5904f$export$2926f86deb178d44)(`${row.uniqueName}.json`),
                                                        children: "Data"
                                                    }) : "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.uniqueName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>(0, $e267546ad9d86d30$export$a38ce99a4bdccd4e)(row.invoiceId),
                                                        children: "\uD83D\uDCCE"
                                                    }) : "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "ghost-button",
                                                        type: "button",
                                                        disabled: actionKey === `preview-${row.InvoiceGroupKey}`,
                                                        onClick: ()=>handlePreview(row),
                                                        children: actionKey === `preview-${row.InvoiceGroupKey}` ? "Previewing..." : "Preview"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "ghost-button",
                                                        type: "button",
                                                        onClick: ()=>handleTrailOpen(row),
                                                        children: "Logs"
                                                    })
                                                })
                                            ]
                                        }, row.InvoiceGroupKey)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            colSpan: "12",
                                            children: "No invoices found in the checker rejected queue."
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90a432d2bdd32db5$export$2e2bcd8739ae039), {
                    detail: statusDetail,
                    onClose: ()=>setStatusDetail(null),
                    onSaved: loadRows
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7eed194cab7fcbbd$var$TrailModal, {
                    trail: trail,
                    loading: trailLoading,
                    onClose: ()=>setTrail(null)
                })
            ]
        })
    });
}




function $2b196a9ff3e886fa$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3eeb7c62d17c8968$export$2e2bcd8739ae039), {
        title: "Pending with Team",
        intro: "Review invoices currently sitting with your teams and reassign them to available processors using the existing Django team-routing flow.",
        endpoint: "/api/get-pendingInvoices-team/",
        legacySection: "teamspending",
        legacyButtonLabel: "Open Legacy Team Queue",
        loadingLabel: "Loading team pending invoices\u2026",
        emptyLabel: "No invoices found in the pending-with-team queue.",
        queueLabel: "team pending",
        queueNote: "Invoices currently pending with a team and available for reassignment.",
        unassignedNote: "Rows that still do not have a processor selected in the team queue."
    });
}




var $acw62 = parcelRequire("acw62");



const $6fb9ae3ef3a158ef$var$MAPPING_TYPES = [
    {
        key: "system_variables",
        label: "System Variables"
    },
    {
        key: "vendor_master",
        label: "Vendor Master"
    },
    {
        key: "sac_master",
        label: "SAC Master"
    },
    {
        key: "wholdtax_master",
        label: "WithHold Tax Master"
    },
    {
        key: "gsttax_master",
        label: "GST Tax Master"
    },
    {
        key: "hsn_master",
        label: "HSN Master"
    }
];
function $6fb9ae3ef3a158ef$var$buildEmptySelections(context) {
    return {
        system_variables: Object.fromEntries((context.system_variables || []).map((item)=>[
                item.name,
                {
                    po_header: "",
                    po_mapping_type: "",
                    miro_header: "",
                    miro_mapping_type: ""
                }
            ])),
        vendor_master: Object.fromEntries((context.vendor_system_variables || []).map((item)=>[
                item.name,
                {
                    header: "",
                    mapped_type: ""
                }
            ])),
        sac_master: Object.fromEntries((context.sac_system_variables || []).map((item)=>[
                item.name,
                {
                    header: "",
                    mapped_type: ""
                }
            ])),
        wholdtax_master: Object.fromEntries((context.wholdtax_system_variables || []).map((item)=>[
                item.name,
                {
                    header: "",
                    mapped_type: ""
                }
            ])),
        gsttax_master: Object.fromEntries((context.gsttax_system_variables || []).map((item)=>[
                item.name,
                {
                    header: "",
                    mapped_type: ""
                }
            ])),
        hsn_master: Object.fromEntries((context.hsn_system_variables || []).map((item)=>[
                item.name,
                {
                    header: "",
                    mapped_type: ""
                }
            ]))
    };
}
function $6fb9ae3ef3a158ef$export$2e2bcd8739ae039() {
    const [context, setContext] = (0, $acw62.useState)(null);
    const [activeType, setActiveType] = (0, $acw62.useState)("system_variables");
    const [selections, setSelections] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [matchingType, setMatchingType] = (0, $acw62.useState)(null);
    const [materialServiceCodes, setMaterialServiceCodes] = (0, $acw62.useState)({});
    const [blockingActivate, setBlockingActivate] = (0, $acw62.useState)({});
    const [validationRows, setValidationRows] = (0, $acw62.useState)(new Set());
    function getMigoHeaderValue(mapped) {
        return mapped?.miro_header || mapped?.migo_header || "";
    }
    function confirmSystemSuggestion(variableName, field) {
        const mappingTypeField = field === "po_header" ? "po_mapping_type" : "miro_mapping_type";
        setSelections((current)=>({
                ...current,
                system_variables: {
                    ...current.system_variables,
                    [variableName]: {
                        ...current.system_variables[variableName],
                        [mappingTypeField]: "mapped"
                    }
                }
            }));
    }
    function confirmSingleSuggestion(type, variableName) {
        setSelections((current)=>({
                ...current,
                [type]: {
                    ...current[type],
                    [variableName]: {
                        ...current[type][variableName],
                        mapped_type: "mapped"
                    }
                }
            }));
    }
    const currentRows = (0, $acw62.useMemo)(()=>{
        if (!context) return [];
        if (activeType === "system_variables") return context.system_variables || [];
        if (activeType === "vendor_master") return context.vendor_system_variables || [];
        if (activeType === "sac_master") return (context.sac_system_variables || []).map((name)=>({
                name: name,
                mandatory: false
            }));
        if (activeType === "wholdtax_master") return context.wholdtax_system_variables || [];
        if (activeType === "gsttax_master") return context.gsttax_system_variables || [];
        if (activeType === "hsn_master") return (context.hsn_system_variables || []).map((name)=>({
                name: name,
                mandatory: false
            }));
        return [];
    }, [
        activeType,
        context
    ]);
    const optionsByType = (0, $acw62.useMemo)(()=>{
        if (!context) return {};
        return {
            system_variables: {
                migo: context.miro_headers || [],
                po: context.po_headers || []
            },
            vendor_master: context.vendorerp_headers || [],
            sac_master: context.sac_master_headers || [],
            wholdtax_master: context.wholdtax_master_headers || [],
            gsttax_master: context.gsttax_master_headers || [],
            hsn_master: context.hsn_master_headers || []
        };
    }, [
        context
    ]);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        async function loadContext() {
            setLoading(true);
            setError("");
            try {
                const response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/mapping/context/");
                if (cancelled) return;
                const nextContext = response.data;
                setContext(nextContext);
                setSelections($6fb9ae3ef3a158ef$var$buildEmptySelections(nextContext));
            } catch (requestError) {
                if (!cancelled) setError(requestError.message || "Unable to load mapping context.");
            } finally{
                if (!cancelled) setLoading(false);
            }
        }
        loadContext();
        return ()=>{
            cancelled = true;
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        async function loadSavedMapping() {
            if (!context || !selections) return;
            setStatus("");
            setError("");
            try {
                const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
                const response = await fetch("/api/mapping/data/", {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRFToken": csrfToken
                    },
                    body: JSON.stringify({
                        type: activeType
                    })
                });
                const payload = await response.json();
                if (!response.ok || !payload.success) throw new Error(payload.error || "Unable to load saved mappings.");
                if (cancelled) return;
                setSelections((current)=>({
                        ...current,
                        [activeType]: activeType === "system_variables" ? {
                            ...current[activeType],
                            ...payload.data
                        } : {
                            ...current[activeType],
                            ...payload.data
                        }
                    }));
                setMatchingType(payload.matching_type || null);
                setMaterialServiceCodes(payload.material_service_codes || {});
                setBlockingActivate(payload.blocking_activate || {});
            } catch (requestError) {
                if (!cancelled) setError(requestError.message || "Unable to load saved mappings.");
            }
        }
        loadSavedMapping();
        return ()=>{
            cancelled = true;
        };
    }, [
        activeType,
        context,
        selections ? "ready" : "empty"
    ]);
    function updateSystemSelection(variableName, field, value) {
        setSelections((current)=>{
            const mappingTypeField = field === "po_header" ? "po_mapping_type" : field === "miro_header" ? "miro_mapping_type" : null;
            return {
                ...current,
                system_variables: {
                    ...current.system_variables,
                    [variableName]: {
                        ...current.system_variables[variableName],
                        [field]: value,
                        ...mappingTypeField ? {
                            [mappingTypeField]: value ? "mapped" : ""
                        } : {}
                    }
                }
            };
        });
    }
    function updateSingleSelection(type, variableName, value) {
        setSelections((current)=>({
                ...current,
                [type]: {
                    ...current[type],
                    [variableName]: {
                        header: value,
                        mapped_type: value ? "mapped" : ""
                    }
                }
            }));
    }
    function validateSystemVariables() {
        const rows = selections.system_variables;
        const errors = [];
        const invalidRows = [];
        currentRows.forEach((row)=>{
            const mapped = rows[row.name] || {};
            if (row.mandatory && !getMigoHeaderValue(mapped)) {
                errors.push(`${row.name}: MIGO header is required`);
                invalidRows.push(row.name);
            }
            if (matchingType === "3way" && (row.mandatory_sources || []).includes("PO") && !mapped.po_header) {
                errors.push(`${row.name}: PO header is required for 3-way matching`);
                invalidRows.push(row.name);
            }
        });
        const materialCodes = Array.isArray(materialServiceCodes.material) ? materialServiceCodes.material : [];
        const serviceCodes = Array.isArray(materialServiceCodes.service) ? materialServiceCodes.service : [];
        const materialServiceMapping = getMigoHeaderValue(rows.Material_Service);
        if ((materialCodes.length || serviceCodes.length) && !materialServiceMapping) {
            errors.push("Material_Service: MIGO header is required when material/service codes are configured");
            invalidRows.push("Material_Service");
        }
        if (blockingActivate.payment_blocking_activate === "Y" && !getMigoHeaderValue(rows.PaymentBlock)) {
            errors.push("PaymentBlock: MIGO header is required when GRN payment blocking is active");
            invalidRows.push("PaymentBlock");
        }
        return {
            errors: errors,
            invalidRows: invalidRows
        };
    }
    function validateMasterSelections(type) {
        const errors = [];
        const rows = selections[type];
        const invalidRows = [];
        currentRows.forEach((row)=>{
            if (row.mandatory && !rows[row.name]) {
                errors.push(`${row.name}: mapping is required`);
                invalidRows.push(row.name);
            }
        });
        if (type === "vendor_master" && blockingActivate.account_blocking_activate === "Y" && !rows["VendorBlocked(Y/N)"]) {
            errors.push("VendorBlocked(Y/N): mapping is required when Vendor Master blocking is active");
            invalidRows.push("VendorBlocked(Y/N)");
        }
        return {
            errors: errors,
            invalidRows: invalidRows
        };
    }
    function buildSavePayload() {
        if (activeType === "system_variables") return {
            type: activeType,
            mappings: currentRows.map((row)=>({
                    system_variable: row.name,
                    po_header: selections.system_variables[row.name]?.po_mapping_type === "mapped" ? selections.system_variables[row.name]?.po_header || "" : "",
                    migo_header: selections.system_variables[row.name]?.miro_mapping_type === "mapped" ? getMigoHeaderValue(selections.system_variables[row.name]) : ""
                })),
            mappingss: {}
        };
        return {
            type: activeType,
            mappings: [],
            mappingss: Object.fromEntries(Object.entries(selections[activeType]).map(([key, value])=>[
                    key,
                    value?.mapped_type === "mapped" ? value.header : ""
                ]))
        };
    }
    async function handleSave() {
        setSaving(true);
        setError("");
        try {
            const validationResult = activeType === "system_variables" ? validateSystemVariables() : validateMasterSelections(activeType);
            setValidationRows(new Set(validationResult.invalidRows));
            if (validationResult.errors.length) {
                if (validationResult.invalidRows.length) document.querySelector(`[data-row="${validationResult.invalidRows[0]}"]`)?.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
                throw new Error(validationResult.errors.join(" | "));
            }
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/mapping/save/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify(buildSavePayload())
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || "Unable to save mappings.");
            setValidationRows(new Set());
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: payload.message || "Mappings saved successfully.",
                confirmButtonText: "OK"
            });
        } catch (requestError) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Save Failed",
                text: requestError.message || "Unable to save mappings.",
                confirmButtonText: "OK"
            });
            setError(requestError.message || "Unable to save mappings.");
        } finally{
            setSaving(false);
        }
    }
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "workspace-panel",
        children: "Loading header mapping\u2026"
    });
    if (!context || !selections) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "workspace-panel",
        children: "Mapping context is unavailable."
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "mapping-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel mapping-view__hero",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "Header Mapping"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "Mapping Configuration"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-view__intro",
                                children: "Match uploaded ERP headers to the system variables and master fields used by the Django backend validations."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mapping-view__controls",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Mapping Type"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: activeType,
                                        onChange: (event)=>setActiveType(event.target.value),
                                        children: $6fb9ae3ef3a158ef$var$MAPPING_TYPES.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: option.key,
                                                children: option.label
                                            }, option.key))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary-button",
                                type: "button",
                                disabled: saving,
                                onClick: handleSave,
                                children: saving ? "Saving..." : "Save Mapping"
                            })
                        ]
                    })
                ]
            }),
            activeType === "system_variables" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mapping-note-card",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "Important:"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                        className: "mapping-note-list",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    "It is recommended to map all the fields which are mandatory as per your ERP. Otherwise, the accounting entry will be ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "rejected"
                                    }),
                                    " upon uploading the template."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    "In addition to above, fields which are marked with ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "*"
                                    }),
                                    " are",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: " mandatory"
                                    }),
                                    " to map."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    "Fields which are marked with ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "**"
                                    }),
                                    " are ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "conditional mandatory"
                                    }),
                                    " ",
                                    "to map depending on basic configuration settings."
                                ]
                            })
                        ]
                    })
                ]
            }) : null,
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "workspace-panel",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "config-table",
                    children: activeType === "system_variables" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "System Variable"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "MIGO Header"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "PO Header"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: currentRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        "data-row": row.name,
                                        className: validationRows.has(row.name) ? "mapping-row-error" : "",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mapping-variable",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: row.name
                                                            }),
                                                            row.mandatory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "mandatory-star",
                                                                children: "*"
                                                            }) : null,
                                                            row.conditional_mandatory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "mandatory-star",
                                                                children: "**"
                                                            }) : null
                                                        ]
                                                    }),
                                                    row.tooltip ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "mapping-tooltip",
                                                        children: row.tooltip
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        className: "mapping-select mapping-select--migo",
                                                        value: selections.system_variables[row.name]?.miro_header || "",
                                                        onChange: (event)=>updateSystemSelection(row.name, "miro_header", event.target.value),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "",
                                                                children: "-- Select MIGO Header --"
                                                            }),
                                                            (optionsByType.system_variables.migo || []).map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: header,
                                                                    children: header
                                                                }, header))
                                                        ]
                                                    }),
                                                    selections.system_variables[row.name]?.miro_mapping_type === "mapped" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mapping-badge mapping-badge--mapped",
                                                        children: "\u2713 Saved"
                                                    }),
                                                    selections.system_variables[row.name]?.miro_mapping_type === "suggestion" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mapping-badge mapping-badge--suggested mapping-badge--clickable",
                                                        onClick: ()=>confirmSystemSuggestion(row.name, "miro_header"),
                                                        title: "Click to accept this suggestion",
                                                        children: "\uD83D\uDCA1 Suggested"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        className: "mapping-select mapping-select--po",
                                                        value: selections.system_variables[row.name]?.po_header || "",
                                                        onChange: (event)=>updateSystemSelection(row.name, "po_header", event.target.value),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "",
                                                                children: "-- Select PO Header --"
                                                            }),
                                                            (optionsByType.system_variables.po || []).map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: header,
                                                                    children: header
                                                                }, header))
                                                        ]
                                                    }),
                                                    selections.system_variables[row.name]?.po_mapping_type === "mapped" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mapping-badge mapping-badge--mapped",
                                                        children: "\u2713 Saved"
                                                    }),
                                                    selections.system_variables[row.name]?.po_mapping_type === "suggestion" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mapping-badge mapping-badge--suggested mapping-badge--clickable",
                                                        onClick: ()=>confirmSystemSuggestion(row.name, "po_header"),
                                                        title: "Click to accept this suggestion",
                                                        children: "\uD83D\uDCA1 Suggested"
                                                    })
                                                ]
                                            })
                                        ]
                                    }, row.name))
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "System Variable"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "ERP Header"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: currentRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mapping-variable",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: row.name
                                                            }),
                                                            row.mandatory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "mandatory-star",
                                                                children: "*"
                                                            }) : null,
                                                            row.conditional_mandatory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "mandatory-star",
                                                                children: "**"
                                                            }) : null
                                                        ]
                                                    }),
                                                    row.tooltip ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "mapping-tooltip",
                                                        children: row.tooltip
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        value: selections[activeType][row.name]?.header || "",
                                                        onChange: (event)=>updateSingleSelection(activeType, row.name, event.target.value),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "",
                                                                children: "-- Select Header --"
                                                            }),
                                                            (optionsByType[activeType] || []).map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: header,
                                                                    children: header
                                                                }, header))
                                                        ]
                                                    }),
                                                    selections[activeType][row.name]?.mapped_type === "mapped" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mapping-badge mapping-badge--mapped",
                                                        children: "\u2713 Saved"
                                                    }),
                                                    selections[activeType][row.name]?.mapped_type === "suggestion" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mapping-badge mapping-badge--suggested",
                                                        children: "\uD83D\uDCA1 Suggested"
                                                    })
                                                ]
                                            })
                                        ]
                                    }, row.name))
                            })
                        ]
                    })
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");



const $467ac0fa32f18da2$var$MAPPING_TYPES = [
    {
        key: "system_variables",
        label: "System Variables"
    },
    {
        key: "vendor_master",
        label: "Vendor Master"
    }
];
function $467ac0fa32f18da2$var$buildEmptySelections(context) {
    return {
        system_variables: Object.fromEntries((context.system_variables || []).map((item)=>[
                item.name,
                {
                    po_header: "",
                    po_mapping_type: "",
                    miro_header: "",
                    miro_mapping_type: ""
                }
            ])),
        vendor_master: Object.fromEntries((context.vendor_system_variables || []).map((item)=>[
                item.name,
                {
                    header: "",
                    mapped_type: ""
                }
            ])),
        sac_master: Object.fromEntries((context.sac_system_variables || []).map((item)=>[
                item.name,
                {
                    header: "",
                    mapped_type: ""
                }
            ])),
        wholdtax_master: Object.fromEntries((context.wholdtax_system_variables || []).map((item)=>[
                item.name,
                {
                    header: "",
                    mapped_type: ""
                }
            ])),
        gsttax_master: Object.fromEntries((context.gsttax_system_variables || []).map((item)=>[
                item.name,
                {
                    header: "",
                    mapped_type: ""
                }
            ])),
        hsn_master: Object.fromEntries((context.hsn_system_variables || []).map((item)=>[
                item.name,
                {
                    header: "",
                    mapped_type: ""
                }
            ]))
    };
}
function $467ac0fa32f18da2$export$2e2bcd8739ae039() {
    const [context, setContext] = (0, $acw62.useState)(null);
    const [activeType, setActiveType] = (0, $acw62.useState)("system_variables");
    const [selections, setSelections] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [matchingType, setMatchingType] = (0, $acw62.useState)(null);
    const [materialServiceCodes, setMaterialServiceCodes] = (0, $acw62.useState)({});
    const [blockingActivate, setBlockingActivate] = (0, $acw62.useState)({});
    const [validationRows, setValidationRows] = (0, $acw62.useState)(new Set());
    function getMigoHeaderValue(mapped) {
        return mapped?.miro_header || mapped?.migo_header || "";
    }
    function confirmSystemSuggestion(variableName, field) {
        const mappingTypeField = field === "po_header" ? "po_mapping_type" : "miro_mapping_type";
        setSelections((current)=>({
                ...current,
                system_variables: {
                    ...current.system_variables,
                    [variableName]: {
                        ...current.system_variables[variableName],
                        [mappingTypeField]: "mapped"
                    }
                }
            }));
    }
    function confirmSingleSuggestion(type, variableName) {
        setSelections((current)=>({
                ...current,
                [type]: {
                    ...current[type],
                    [variableName]: {
                        ...current[type][variableName],
                        mapped_type: "mapped"
                    }
                }
            }));
    }
    const currentRows = (0, $acw62.useMemo)(()=>{
        if (!context) return [];
        if (activeType === "system_variables") return context.system_variables || [];
        if (activeType === "vendor_master") return context.vendor_system_variables || [];
        if (activeType === "sac_master") return (context.sac_system_variables || []).map((name)=>({
                name: name,
                mandatory: false
            }));
        if (activeType === "wholdtax_master") return context.wholdtax_system_variables || [];
        if (activeType === "gsttax_master") return context.gsttax_system_variables || [];
        if (activeType === "hsn_master") return (context.hsn_system_variables || []).map((name)=>({
                name: name,
                mandatory: false
            }));
        return [];
    }, [
        activeType,
        context
    ]);
    const optionsByType = (0, $acw62.useMemo)(()=>{
        if (!context) return {};
        return {
            system_variables: {
                migo: context.miro_headers || [],
                po: context.po_headers || []
            },
            vendor_master: context.vendorerp_headers || [],
            sac_master: context.sac_master_headers || [],
            wholdtax_master: context.wholdtax_master_headers || [],
            gsttax_master: context.gsttax_master_headers || [],
            hsn_master: context.hsn_master_headers || []
        };
    }, [
        context
    ]);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        async function loadContext() {
            setLoading(true);
            setError("");
            try {
                const response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/mapping/context/");
                if (cancelled) return;
                const nextContext = response.data;
                setContext(nextContext);
                setSelections($467ac0fa32f18da2$var$buildEmptySelections(nextContext));
            } catch (requestError) {
                if (!cancelled) setError(requestError.message || "Unable to load mapping context.");
            } finally{
                if (!cancelled) setLoading(false);
            }
        }
        loadContext();
        return ()=>{
            cancelled = true;
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        async function loadSavedMapping() {
            if (!context || !selections) return;
            setStatus("");
            setError("");
            try {
                const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
                const response = await fetch("/api/mapping/data/", {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRFToken": csrfToken
                    },
                    body: JSON.stringify({
                        type: activeType
                    })
                });
                const payload = await response.json();
                if (!response.ok || !payload.success) throw new Error(payload.error || "Unable to load saved mappings.");
                if (cancelled) return;
                setSelections((current)=>({
                        ...current,
                        [activeType]: activeType === "system_variables" ? {
                            ...current[activeType],
                            ...payload.data
                        } : {
                            ...current[activeType],
                            ...payload.data
                        }
                    }));
                setMatchingType(payload.matching_type || null);
                setMaterialServiceCodes(payload.material_service_codes || {});
                setBlockingActivate(payload.blocking_activate || {});
            } catch (requestError) {
                if (!cancelled) setError(requestError.message || "Unable to load saved mappings.");
            }
        }
        loadSavedMapping();
        return ()=>{
            cancelled = true;
        };
    }, [
        activeType,
        context,
        selections ? "ready" : "empty"
    ]);
    function updateSystemSelection(variableName, field, value) {
        setSelections((current)=>{
            const mappingTypeField = field === "po_header" ? "po_mapping_type" : field === "miro_header" ? "miro_mapping_type" : null;
            return {
                ...current,
                system_variables: {
                    ...current.system_variables,
                    [variableName]: {
                        ...current.system_variables[variableName],
                        [field]: value,
                        ...mappingTypeField ? {
                            [mappingTypeField]: value ? "mapped" : ""
                        } : {}
                    }
                }
            };
        });
    }
    function updateSingleSelection(type, variableName, value) {
        setSelections((current)=>({
                ...current,
                [type]: {
                    ...current[type],
                    [variableName]: {
                        header: value,
                        mapped_type: value ? "mapped" : ""
                    }
                }
            }));
    }
    function validateSystemVariables() {
        const rows = selections.system_variables;
        const errors = [];
        const invalidRows = [];
        currentRows.forEach((row)=>{
            const mapped = rows[row.name] || {};
            if (row.mandatory && !getMigoHeaderValue(mapped)) {
                errors.push(`${row.name}: MIGO header is required`);
                invalidRows.push(row.name);
            }
            if (matchingType === "3way" && (row.mandatory_sources || []).includes("PO") && !mapped.po_header) {
                errors.push(`${row.name}: PO header is required for 3-way matching`);
                invalidRows.push(row.name);
            }
        });
        const materialCodes = Array.isArray(materialServiceCodes.material) ? materialServiceCodes.material : [];
        const serviceCodes = Array.isArray(materialServiceCodes.service) ? materialServiceCodes.service : [];
        const materialServiceMapping = getMigoHeaderValue(rows.Material_Service);
        if ((materialCodes.length || serviceCodes.length) && !materialServiceMapping) {
            errors.push("Material_Service: MIGO header is required when material/service codes are configured");
            invalidRows.push("Material_Service");
        }
        if (blockingActivate.payment_blocking_activate === "Y" && !getMigoHeaderValue(rows.PaymentBlock)) {
            errors.push("PaymentBlock: MIGO header is required when GRN payment blocking is active");
            invalidRows.push("PaymentBlock");
        }
        return {
            errors: errors,
            invalidRows: invalidRows
        };
    }
    function validateMasterSelections(type) {
        const errors = [];
        const rows = selections[type];
        const invalidRows = [];
        currentRows.forEach((row)=>{
            if (row.mandatory && !rows[row.name]) {
                errors.push(`${row.name}: mapping is required`);
                invalidRows.push(row.name);
            }
        });
        if (type === "vendor_master" && blockingActivate.account_blocking_activate === "Y" && !rows["VendorBlocked(Y/N)"]) {
            errors.push("VendorBlocked(Y/N): mapping is required when Vendor Master blocking is active");
            invalidRows.push("VendorBlocked(Y/N)");
        }
        return {
            errors: errors,
            invalidRows: invalidRows
        };
    }
    function buildSavePayload() {
        if (activeType === "system_variables") return {
            type: activeType,
            mappings: currentRows.map((row)=>({
                    system_variable: row.name,
                    po_header: selections.system_variables[row.name]?.po_mapping_type === "mapped" ? selections.system_variables[row.name]?.po_header || "" : "",
                    migo_header: selections.system_variables[row.name]?.miro_mapping_type === "mapped" ? getMigoHeaderValue(selections.system_variables[row.name]) : ""
                })),
            mappingss: {}
        };
        return {
            type: activeType,
            mappings: [],
            mappingss: Object.fromEntries(Object.entries(selections[activeType]).map(([key, value])=>[
                    key,
                    value?.mapped_type === "mapped" ? value.header : ""
                ]))
        };
    }
    async function handleSave() {
        setSaving(true);
        setError("");
        try {
            const validationResult = activeType === "system_variables" ? validateSystemVariables() : validateMasterSelections(activeType);
            setValidationRows(new Set(validationResult.invalidRows));
            if (validationResult.errors.length) {
                if (validationResult.invalidRows.length) document.querySelector(`[data-row="${validationResult.invalidRows[0]}"]`)?.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
                throw new Error(validationResult.errors.join(" | "));
            }
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/mapping/save/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify(buildSavePayload())
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || "Unable to save mappings.");
            setValidationRows(new Set());
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: payload.message || "Mappings saved successfully.",
                confirmButtonText: "OK"
            });
        } catch (requestError) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Save Failed",
                text: requestError.message || "Unable to save mappings.",
                confirmButtonText: "OK"
            });
            setError(requestError.message || "Unable to save mappings.");
        } finally{
            setSaving(false);
        }
    }
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "workspace-panel",
        children: "Loading header mapping\u2026"
    });
    if (!context || !selections) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "workspace-panel",
        children: "Mapping context is unavailable."
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "mapping-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel mapping-view__hero",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "Header Mapping"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "Mapping Configuration"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-view__intro",
                                children: "Match uploaded ERP headers to the system variables and master fields used by the Django backend validations."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mapping-view__controls",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Mapping Type"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: activeType,
                                        onChange: (event)=>setActiveType(event.target.value),
                                        children: $467ac0fa32f18da2$var$MAPPING_TYPES.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: option.key,
                                                children: option.label
                                            }, option.key))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary-button",
                                type: "button",
                                disabled: saving,
                                onClick: handleSave,
                                children: saving ? "Saving..." : "Save Mapping"
                            })
                        ]
                    })
                ]
            }),
            activeType === "system_variables" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mapping-note-card",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "Important:"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                        className: "mapping-note-list",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    "It is recommended to map all the fields which are mandatory as per your ERP. Otherwise, the accounting entry will be ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "rejected"
                                    }),
                                    " upon uploading the template."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    "In addition to above, fields which are marked with ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "*"
                                    }),
                                    " are",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: " mandatory"
                                    }),
                                    " to map."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    "Fields which are marked with ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "**"
                                    }),
                                    " are ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "conditional mandatory"
                                    }),
                                    " ",
                                    "to map depending on basic configuration settings."
                                ]
                            })
                        ]
                    })
                ]
            }) : null,
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "workspace-panel",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "config-table",
                    children: activeType === "system_variables" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "System Variable"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "MIGO Header"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "PO Header"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: currentRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        "data-row": row.name,
                                        className: validationRows.has(row.name) ? "mapping-row-error" : "",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mapping-variable",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: row.name
                                                            }),
                                                            row.mandatory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "mandatory-star",
                                                                children: "*"
                                                            }) : null,
                                                            row.conditional_mandatory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "mandatory-star",
                                                                children: "**"
                                                            }) : null
                                                        ]
                                                    }),
                                                    row.tooltip ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "mapping-tooltip",
                                                        children: row.tooltip
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        className: "mapping-select mapping-select--migo",
                                                        value: selections.system_variables[row.name]?.miro_header || "",
                                                        onChange: (event)=>updateSystemSelection(row.name, "miro_header", event.target.value),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "",
                                                                children: "-- Select MIGO Header --"
                                                            }),
                                                            (optionsByType.system_variables.migo || []).map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: header,
                                                                    children: header
                                                                }, header))
                                                        ]
                                                    }),
                                                    selections.system_variables[row.name]?.miro_mapping_type === "mapped" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mapping-badge mapping-badge--mapped",
                                                        children: "\u2713 Saved"
                                                    }),
                                                    selections.system_variables[row.name]?.miro_mapping_type === "suggestion" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mapping-badge mapping-badge--suggested mapping-badge--clickable",
                                                        onClick: ()=>confirmSystemSuggestion(row.name, "miro_header"),
                                                        title: "Click to accept this suggestion",
                                                        children: "\uD83D\uDCA1 Suggested"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        className: "mapping-select mapping-select--po",
                                                        value: selections.system_variables[row.name]?.po_header || "",
                                                        onChange: (event)=>updateSystemSelection(row.name, "po_header", event.target.value),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "",
                                                                children: "-- Select PO Header --"
                                                            }),
                                                            (optionsByType.system_variables.po || []).map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: header,
                                                                    children: header
                                                                }, header))
                                                        ]
                                                    }),
                                                    selections.system_variables[row.name]?.po_mapping_type === "mapped" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mapping-badge mapping-badge--mapped",
                                                        children: "\u2713 Saved"
                                                    }),
                                                    selections.system_variables[row.name]?.po_mapping_type === "suggestion" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mapping-badge mapping-badge--suggested mapping-badge--clickable",
                                                        onClick: ()=>confirmSystemSuggestion(row.name, "po_header"),
                                                        title: "Click to accept this suggestion",
                                                        children: "\uD83D\uDCA1 Suggested"
                                                    })
                                                ]
                                            })
                                        ]
                                    }, row.name))
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "System Variable"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "ERP Header"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: currentRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mapping-variable",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: row.name
                                                            }),
                                                            row.mandatory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "mandatory-star",
                                                                children: "*"
                                                            }) : null,
                                                            row.conditional_mandatory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "mandatory-star",
                                                                children: "**"
                                                            }) : null
                                                        ]
                                                    }),
                                                    row.tooltip ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "mapping-tooltip",
                                                        children: row.tooltip
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        value: selections[activeType][row.name]?.header || "",
                                                        onChange: (event)=>updateSingleSelection(activeType, row.name, event.target.value),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "",
                                                                children: "-- Select Header --"
                                                            }),
                                                            (optionsByType[activeType] || []).map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: header,
                                                                    children: header
                                                                }, header))
                                                        ]
                                                    }),
                                                    selections[activeType][row.name]?.mapped_type === "mapped" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mapping-badge mapping-badge--mapped",
                                                        children: "\u2713 Saved"
                                                    }),
                                                    selections[activeType][row.name]?.mapped_type === "suggestion" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mapping-badge mapping-badge--suggested",
                                                        children: "\uD83D\uDCA1 Suggested"
                                                    })
                                                ]
                                            })
                                        ]
                                    }, row.name))
                            })
                        ]
                    })
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");



const $4b21ce7440066197$var$MAPPING_TYPES = [
    {
        key: "wholdtax_master",
        label: "WithHold Tax Master"
    },
    {
        key: "gsttax_master",
        label: "GST Tax Master"
    }
];
function $4b21ce7440066197$var$buildEmptySelections(context) {
    return {
        wholdtax_master: Object.fromEntries((context.wholdtax_system_variables || []).map((item)=>[
                item.name,
                {
                    header: "",
                    mapped_type: ""
                }
            ])),
        gsttax_master: Object.fromEntries((context.gsttax_system_variables || []).map((item)=>[
                item.name,
                {
                    header: "",
                    mapped_type: ""
                }
            ]))
    };
}
function $4b21ce7440066197$export$2e2bcd8739ae039() {
    const [context, setContext] = (0, $acw62.useState)(null);
    const [activeType, setActiveType] = (0, $acw62.useState)("wholdtax_master");
    const [selections, setSelections] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [validationRows, setValidationRows] = (0, $acw62.useState)(new Set());
    /*
   * Get system variables for currently selected mapping type
   */ const currentRows = (0, $acw62.useMemo)(()=>{
        if (!context) return [];
        if (activeType === "wholdtax_master") return context.wholdtax_system_variables || [];
        if (activeType === "gsttax_master") return context.gsttax_system_variables || [];
        return [];
    }, [
        activeType,
        context
    ]);
    /*
   * Get ERP headers for currently selected mapping type
   */ const currentHeaders = (0, $acw62.useMemo)(()=>{
        if (!context) return [];
        if (activeType === "wholdtax_master") return context.wholdtax_master_headers || [];
        if (activeType === "gsttax_master") return context.gsttax_master_headers || [];
        return [];
    }, [
        activeType,
        context
    ]);
    /*
   * Load mapping context
   */ (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        async function loadContext() {
            setLoading(true);
            setError("");
            try {
                const response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/mapping/context/");
                if (cancelled) return;
                const nextContext = response.data;
                setContext(nextContext);
                setSelections($4b21ce7440066197$var$buildEmptySelections(nextContext));
            } catch (requestError) {
                if (!cancelled) setError(requestError.message || "Unable to load mapping context.");
            } finally{
                if (!cancelled) setLoading(false);
            }
        }
        loadContext();
        return ()=>{
            cancelled = true;
        };
    }, []);
    /*
   * Load saved mappings whenever mapping type changes
   */ (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        async function loadSavedMapping() {
            if (!context || !selections) return;
            setStatus("");
            setError("");
            try {
                const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
                const response = await fetch("/api/mapping/data/", {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRFToken": csrfToken
                    },
                    body: JSON.stringify({
                        type: activeType
                    })
                });
                const payload = await response.json();
                if (!response.ok || !payload.success) throw new Error(payload.error || "Unable to load saved mappings.");
                if (cancelled) return;
                setSelections((current)=>({
                        ...current,
                        [activeType]: {
                            ...current[activeType],
                            ...payload.data
                        }
                    }));
            } catch (requestError) {
                if (!cancelled) setError(requestError.message || "Unable to load saved mappings.");
            }
        }
        loadSavedMapping();
        return ()=>{
            cancelled = true;
        };
    }, [
        activeType,
        context,
        selections ? "ready" : "empty"
    ]);
    /*
   * Update selected ERP header
   */ function updateSelection(variableName, value) {
        setSelections((current)=>({
                ...current,
                [activeType]: {
                    ...current[activeType],
                    [variableName]: {
                        header: value,
                        mapped_type: value ? "mapped" : ""
                    }
                }
            }));
    }
    /*
   * Validate mandatory mappings
   */ function validateSelections() {
        const errors = [];
        const invalidRows = [];
        currentRows.forEach((row)=>{
            const mapping = selections[activeType]?.[row.name];
            if (row.mandatory && !mapping?.header) {
                errors.push(`${row.name}: mapping is required`);
                invalidRows.push(row.name);
            }
        });
        return {
            errors: errors,
            invalidRows: invalidRows
        };
    }
    /*
   * Build API payload
   */ function buildSavePayload() {
        return {
            type: activeType,
            mappings: [],
            mappingss: Object.fromEntries(Object.entries(selections[activeType] || {}).map(([key, value])=>[
                    key,
                    value?.mapped_type === "mapped" ? value.header : ""
                ]))
        };
    }
    /*
   * Save mappings
   */ async function handleSave() {
        setSaving(true);
        setError("");
        try {
            const validationResult = validateSelections();
            setValidationRows(new Set(validationResult.invalidRows));
            if (validationResult.errors.length) {
                if (validationResult.invalidRows.length) document.querySelector(`[data-row="${validationResult.invalidRows[0]}"]`)?.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
                throw new Error(validationResult.errors.join(" | "));
            }
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/mapping/save/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify(buildSavePayload())
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || "Unable to save mappings.");
            setValidationRows(new Set());
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: payload.message || "Mappings saved successfully.",
                confirmButtonText: "OK"
            });
        } catch (requestError) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Save Failed",
                text: requestError.message || "Unable to save mappings.",
                confirmButtonText: "OK"
            });
            setError(requestError.message || "Unable to save mappings.");
        } finally{
            setSaving(false);
        }
    }
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "workspace-panel",
        children: "Loading header mapping\u2026"
    });
    if (!context || !selections) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "workspace-panel",
        children: "Mapping context is unavailable."
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "mapping-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel mapping-view__hero",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "Header Mapping"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "Mapping Configuration"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-view__intro",
                                children: "Match uploaded ERP headers to the system variables used by the Django backend validations."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mapping-view__controls",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Mapping Type"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: activeType,
                                        onChange: (event)=>setActiveType(event.target.value),
                                        children: $4b21ce7440066197$var$MAPPING_TYPES.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: option.key,
                                                children: option.label
                                            }, option.key))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary-button",
                                type: "button",
                                disabled: saving,
                                onClick: handleSave,
                                children: saving ? "Saving..." : "Save Mapping"
                            })
                        ]
                    })
                ]
            }),
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "workspace-panel",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "config-table",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "System Variable"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "ERP Header"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: currentRows.map((row)=>{
                                    const mapping = selections[activeType]?.[row.name];
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        "data-row": row.name,
                                        className: validationRows.has(row.name) ? "mapping-row-error" : "",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mapping-variable",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: row.name
                                                            }),
                                                            row.mandatory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "mandatory-star",
                                                                children: "*"
                                                            }) : null,
                                                            row.conditional_mandatory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "mandatory-star",
                                                                children: "**"
                                                            }) : null
                                                        ]
                                                    }),
                                                    row.tooltip ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "mapping-tooltip",
                                                        children: row.tooltip
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        className: "mapping-select",
                                                        value: mapping?.header || "",
                                                        onChange: (event)=>updateSelection(row.name, event.target.value),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "",
                                                                children: "-- Select Header --"
                                                            }),
                                                            currentHeaders.map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: header,
                                                                    children: header
                                                                }, header))
                                                        ]
                                                    }),
                                                    mapping?.mapped_type === "mapped" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mapping-badge mapping-badge--mapped",
                                                        children: "\u2713 Saved"
                                                    }) : null,
                                                    mapping?.mapped_type === "suggestion" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mapping-badge mapping-badge--suggested",
                                                        children: "\uD83D\uDCA1 Suggested"
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    }, row.name);
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");



const $e511841a47437487$var$MAPPING_TYPES = [
    {
        key: "wholdtax_master",
        label: "WithHold Tax Master"
    },
    {
        key: "gsttax_master",
        label: "GST Tax Master"
    }
];
function $e511841a47437487$var$buildEmptySelections(context) {
    return {
        wholdtax_master: Object.fromEntries((context.wholdtax_system_variables || []).map((item)=>[
                item.name,
                {
                    header: "",
                    mapped_type: ""
                }
            ])),
        gsttax_master: Object.fromEntries((context.gsttax_system_variables || []).map((item)=>[
                item.name,
                {
                    header: "",
                    mapped_type: ""
                }
            ]))
    };
}
function $e511841a47437487$export$2e2bcd8739ae039() {
    const [context, setContext] = (0, $acw62.useState)(null);
    const [activeType, setActiveType] = (0, $acw62.useState)("wholdtax_master");
    const [selections, setSelections] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [validationRows, setValidationRows] = (0, $acw62.useState)(new Set());
    /*
   * Get system variables for currently selected mapping type
   */ const currentRows = (0, $acw62.useMemo)(()=>{
        if (!context) return [];
        if (activeType === "wholdtax_master") return context.wholdtax_system_variables || [];
        if (activeType === "gsttax_master") return context.gsttax_system_variables || [];
        return [];
    }, [
        activeType,
        context
    ]);
    /*
   * Get ERP headers for currently selected mapping type
   */ const currentHeaders = (0, $acw62.useMemo)(()=>{
        if (!context) return [];
        if (activeType === "wholdtax_master") return context.wholdtax_master_headers || [];
        if (activeType === "gsttax_master") return context.gsttax_master_headers || [];
        return [];
    }, [
        activeType,
        context
    ]);
    /*
   * Load mapping context
   */ (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        async function loadContext() {
            setLoading(true);
            setError("");
            try {
                const response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/mapping/context/");
                if (cancelled) return;
                const nextContext = response.data;
                setContext(nextContext);
                setSelections($e511841a47437487$var$buildEmptySelections(nextContext));
            } catch (requestError) {
                if (!cancelled) setError(requestError.message || "Unable to load mapping context.");
            } finally{
                if (!cancelled) setLoading(false);
            }
        }
        loadContext();
        return ()=>{
            cancelled = true;
        };
    }, []);
    /*
   * Load saved mappings whenever mapping type changes
   */ (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        async function loadSavedMapping() {
            if (!context || !selections) return;
            setStatus("");
            setError("");
            try {
                const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
                const response = await fetch("/api/mapping/data/", {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRFToken": csrfToken
                    },
                    body: JSON.stringify({
                        type: activeType
                    })
                });
                const payload = await response.json();
                if (!response.ok || !payload.success) throw new Error(payload.error || "Unable to load saved mappings.");
                if (cancelled) return;
                setSelections((current)=>({
                        ...current,
                        [activeType]: {
                            ...current[activeType],
                            ...payload.data
                        }
                    }));
            } catch (requestError) {
                if (!cancelled) setError(requestError.message || "Unable to load saved mappings.");
            }
        }
        loadSavedMapping();
        return ()=>{
            cancelled = true;
        };
    }, [
        activeType,
        context,
        selections ? "ready" : "empty"
    ]);
    /*
   * Update selected ERP header
   */ function updateSelection(variableName, value) {
        setSelections((current)=>({
                ...current,
                [activeType]: {
                    ...current[activeType],
                    [variableName]: {
                        header: value,
                        mapped_type: value ? "mapped" : ""
                    }
                }
            }));
    }
    /*
   * Validate mandatory mappings
   */ function validateSelections() {
        const errors = [];
        const invalidRows = [];
        currentRows.forEach((row)=>{
            const mapping = selections[activeType]?.[row.name];
            if (row.mandatory && !mapping?.header) {
                errors.push(`${row.name}: mapping is required`);
                invalidRows.push(row.name);
            }
        });
        return {
            errors: errors,
            invalidRows: invalidRows
        };
    }
    /*
   * Build API payload
   */ function buildSavePayload() {
        return {
            type: activeType,
            mappings: [],
            mappingss: Object.fromEntries(Object.entries(selections[activeType] || {}).map(([key, value])=>[
                    key,
                    value?.mapped_type === "mapped" ? value.header : ""
                ]))
        };
    }
    /*
   * Save mappings
   */ async function handleSave() {
        setSaving(true);
        setError("");
        try {
            const validationResult = validateSelections();
            setValidationRows(new Set(validationResult.invalidRows));
            if (validationResult.errors.length) {
                if (validationResult.invalidRows.length) document.querySelector(`[data-row="${validationResult.invalidRows[0]}"]`)?.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
                throw new Error(validationResult.errors.join(" | "));
            }
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/mapping/save/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify(buildSavePayload())
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || "Unable to save mappings.");
            setValidationRows(new Set());
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: payload.message || "Mappings saved successfully.",
                confirmButtonText: "OK"
            });
        } catch (requestError) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Save Failed",
                text: requestError.message || "Unable to save mappings.",
                confirmButtonText: "OK"
            });
            setError(requestError.message || "Unable to save mappings.");
        } finally{
            setSaving(false);
        }
    }
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "workspace-panel",
        children: "Loading header mapping\u2026"
    });
    if (!context || !selections) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "workspace-panel",
        children: "Mapping context is unavailable."
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "mapping-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel mapping-view__hero",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "Header Mapping"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "Mapping Configuration"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-view__intro",
                                children: "Match uploaded ERP headers to the system variables used by the Django backend validations."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mapping-view__controls",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Mapping Type"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: activeType,
                                        onChange: (event)=>setActiveType(event.target.value),
                                        children: $e511841a47437487$var$MAPPING_TYPES.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: option.key,
                                                children: option.label
                                            }, option.key))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary-button",
                                type: "button",
                                disabled: saving,
                                onClick: handleSave,
                                children: saving ? "Saving..." : "Save Mapping"
                            })
                        ]
                    })
                ]
            }),
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "workspace-panel",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "config-table",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "System Variable"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "ERP Header"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: currentRows.map((row)=>{
                                    const mapping = selections[activeType]?.[row.name];
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        "data-row": row.name,
                                        className: validationRows.has(row.name) ? "mapping-row-error" : "",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mapping-variable",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: row.name
                                                            }),
                                                            row.mandatory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "mandatory-star",
                                                                children: "*"
                                                            }) : null,
                                                            row.conditional_mandatory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "mandatory-star",
                                                                children: "**"
                                                            }) : null
                                                        ]
                                                    }),
                                                    row.tooltip ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "mapping-tooltip",
                                                        children: row.tooltip
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        className: "mapping-select",
                                                        value: mapping?.header || "",
                                                        onChange: (event)=>updateSelection(row.name, event.target.value),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "",
                                                                children: "-- Select Header --"
                                                            }),
                                                            currentHeaders.map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: header,
                                                                    children: header
                                                                }, header))
                                                        ]
                                                    }),
                                                    mapping?.mapped_type === "mapped" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mapping-badge mapping-badge--mapped",
                                                        children: "\u2713 Saved"
                                                    }) : null,
                                                    mapping?.mapped_type === "suggestion" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mapping-badge mapping-badge--suggested",
                                                        children: "\uD83D\uDCA1 Suggested"
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    }, row.name);
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

function $8c012a5104330be1$var$getEntries(value) {
    if (!value || typeof value !== "object") return [];
    return Object.entries(value);
}
function $8c012a5104330be1$var$renderCell(value) {
    if (value === null || value === undefined || value === "") return "-";
    if (typeof value === "object") return JSON.stringify(value);
    return String(value);
}
function $8c012a5104330be1$var$KeyValueTable({ rows: rows, emptyMessage: emptyMessage, className: className = "" }) {
    return rows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
        className: `invoice-display__table ${className}`.trim(),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
            children: rows.map(([key, value])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                            children: key
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                            children: $8c012a5104330be1$var$renderCell(value)
                        })
                    ]
                }, key))
        })
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "empty-state",
        children: emptyMessage
    });
}
function $8c012a5104330be1$var$ObjectRowsTable({ rows: rows, emptyMessage: emptyMessage }) {
    if (!rows?.length) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "empty-state",
        children: emptyMessage
    });
    const headers = Object.keys(rows[0] || {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "config-table invoice-display__table-wrap",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
            className: "invoice-display__table",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                        children: headers.map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: header
                            }, header))
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                    children: rows.map((row, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                            children: headers.map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: $8c012a5104330be1$var$renderCell(row[header])
                                }, header))
                        }, `${index}-${headers.join("-")}`))
                })
            ]
        })
    });
}
function $8c012a5104330be1$export$2e2bcd8739ae039({ responseFile: responseFile, embedded: embedded = false, onClose: onClose = null }) {
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [payload, setPayload] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        async function loadInvoiceDisplay() {
            if (!responseFile) {
                setError("No response file specified.");
                setLoading(false);
                return;
            }
            setLoading(true);
            setError("");
            try {
                const response = await fetch(`/invoice-display/?response_file=${encodeURIComponent(responseFile)}&format=json`, {
                    credentials: "include"
                });
                const data = await response.json();
                if (!response.ok || !data.success) throw new Error(data.message || "Unable to load invoice display data.");
                setPayload(data.data || {});
            } catch (requestError) {
                setError(requestError.message || "Unable to load invoice display data.");
            } finally{
                setLoading(false);
            }
        }
        loadInvoiceDisplay();
    }, [
        responseFile
    ]);
    const invoiceDataRows = (0, $acw62.useMemo)(()=>toEntries(payload?.invoice_data), [
        payload
    ]);
    const checks = payload?.Checks || {};
    const gstData = payload?.gst_data || {};
    const tableData = payload?.table_data || {};
    const grnVsInvoice = payload?.grn_vs_invoice || {};
    const resultOkValues = payload?.["2b_olive_color"] || [];
    const tooltipKeys = payload?.keys_with_tooltip || [];
    function renderInvoiceChecks() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "invoice-display__section-group",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "workspace-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        children: "Invoice Checks"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "invoice-display__subheading",
                        children: "Table 1: Source - GSTN & Invoice"
                    }),
                    toEntries(checks.invoice_vs_gstin_protal).length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-table invoice-display__table-wrap",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "invoice-display__table",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Parameters"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "As per Invoice"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "As per GST Portal"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Result"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: toEntries(checks.invoice_vs_gstin_protal).map(([key, item])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: item?.Result === "Matching" ? "invoice-display__row--good" : "invoice-display__row--bad",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $8c012a5104330be1$var$renderCell(item?.parameter)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $8c012a5104330be1$var$renderCell(item?.As_per_Invoice)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            children: `Trade Name: ${$8c012a5104330be1$var$renderCell(item?.As_per_GST_Portal)}`
                                                        }),
                                                        item?.As_per_GST_Portal_legal ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            children: `Legal Name: ${$8c012a5104330be1$var$renderCell(item?.As_per_GST_Portal_legal)}`
                                                        }) : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $8c012a5104330be1$var$renderCell(item?.Result)
                                                })
                                            ]
                                        }, key))
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "empty-state",
                        children: "No data available"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "invoice-display__subheading",
                        children: "Table 2A: Source - Invoice"
                    }),
                    toEntries(checks.invoice_validations).length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-table invoice-display__table-wrap",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "invoice-display__table",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Parameters"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Result"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Supporting Information (As per Invoice)"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: toEntries(checks.invoice_validations).map(([key, item])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: resultOkValues.includes(item?.Result) ? "invoice-display__row--good" : "invoice-display__row--bad",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $8c012a5104330be1$var$renderCell(item?.parameter)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $8c012a5104330be1$var$renderCell(item?.Result)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: tooltipKeys.includes(key) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "invoice-display__tooltip",
                                                        title: $8c012a5104330be1$var$renderCell(item?.As_per_Invoice),
                                                        children: "info"
                                                    }) : $8c012a5104330be1$var$renderCell(item?.As_per_Invoice)
                                                })
                                            ]
                                        }, key))
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "empty-state",
                        children: "No data available"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "invoice-display__subheading",
                        children: "Table 2B: Source - GSTN Data"
                    }),
                    toEntries(checks.gst_portal_check).length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-table invoice-display__table-wrap",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "invoice-display__table",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Parameters"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Result"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: toEntries(checks.gst_portal_check).map(([key, item])=>{
                                        const rowClass = resultOkValues.includes(item?.Result) ? "invoice-display__row--good" : item?.Result === "" ? "invoice-display__row--neutral" : "invoice-display__row--bad";
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: rowClass,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $8c012a5104330be1$var$renderCell(item?.parameter)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $8c012a5104330be1$var$renderCell(item?.Result)
                                                })
                                            ]
                                        }, key);
                                    })
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "empty-state",
                        children: "No data available"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "invoice-display__subheading",
                        children: "Table 2C: Source - Income Tax Data"
                    }),
                    toEntries(checks.income_tax_check).length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-table invoice-display__table-wrap",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "invoice-display__table",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Parameters"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Result"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: toEntries(checks.income_tax_check).map(([key, item])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $8c012a5104330be1$var$renderCell(item?.parameter)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $8c012a5104330be1$var$renderCell(item?.Result)
                                                })
                                            ]
                                        }, key))
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "empty-state",
                        children: "No data available"
                    })
                ]
            })
        });
    }
    function renderGstData() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "invoice-display__section-group",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "workspace-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        children: "GST Data"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "invoice-display__subheading",
                        children: "Customer GST Data"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c012a5104330be1$var$KeyValueTable, {
                        rows: toEntries(gstData.customer_gst_data),
                        emptyMessage: "No data available, invalid GST no. or invoice does not have GST no."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "invoice-display__subheading",
                        children: "Vendor GST Data"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c012a5104330be1$var$KeyValueTable, {
                        rows: toEntries(gstData.vendor_gst_data),
                        emptyMessage: "No data available, invalid GST no. or invoice does not have GST no."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "invoice-display__subheading",
                        children: "Filing Frequency GST Portal"
                    }),
                    Array.isArray(payload?.Filinq_frequency) && payload.Filinq_frequency.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-table invoice-display__table-wrap",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "invoice-display__table",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "quarter"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "preference"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: payload.Filinq_frequency.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $8c012a5104330be1$var$renderCell(item.quarter)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $8c012a5104330be1$var$renderCell(item.preference)
                                                })
                                            ]
                                        }, `${item.quarter}-${index}`))
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "empty-state",
                        children: "No data available, invalid GST no. or invoice does not have GST no."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "invoice-display__subheading",
                        children: "GSTR-1 Data"
                    }),
                    payload?.df_gstr1_html ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "invoice-display__html-table",
                        dangerouslySetInnerHTML: {
                            __html: payload.df_gstr1_html
                        }
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "empty-state",
                        children: "No GSTR-1 data available."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "invoice-display__subheading",
                        children: "GSTR-3B Data"
                    }),
                    payload?.df_3b_html ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "invoice-display__html-table",
                        dangerouslySetInnerHTML: {
                            __html: payload.df_3b_html
                        }
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "empty-state",
                        children: "No GSTR-3B data available."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "invoice-display__subheading",
                        children: "Pan Details"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c012a5104330be1$var$KeyValueTable, {
                        rows: toEntries(gstData.Pan_Status),
                        emptyMessage: "No data available, invalid PAN no. or invoice does not have PAN no."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "invoice-display__subheading",
                        children: "206AB Compliance"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c012a5104330be1$var$KeyValueTable, {
                        rows: toEntries(gstData["206AB_Compliance"]),
                        emptyMessage: "No data available, invalid PAN no. or invoice does not have PAN no."
                    })
                ]
            })
        });
    }
    function renderInvoiceVsGrn() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "invoice-display__section-group",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "workspace-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        children: "Invoice vs GRN Data"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "invoice-display__subheading",
                        children: "Invoice Table"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c012a5104330be1$var$ObjectRowsTable, {
                        rows: grnVsInvoice.invoice_data,
                        emptyMessage: "No Data Available"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "invoice-display__subheading",
                        children: "GRN Data"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c012a5104330be1$var$ObjectRowsTable, {
                        rows: grnVsInvoice.grn_data,
                        emptyMessage: "Invoice Id did not match any OPEN GRN data or no data available against invoice id."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "invoice-display__subheading",
                        children: "Invoice vs GRN"
                    }),
                    toEntries(payload?.Invoicetable_vs_Grntable_compare).length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-table invoice-display__table-wrap",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "invoice-display__table",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Particulars"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "As per Open GRN Report"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "As per Invoice (OCR)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Result"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: toEntries(payload.Invoicetable_vs_Grntable_compare).map(([key, item])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $8c012a5104330be1$var$renderCell(item?.Particulars)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $8c012a5104330be1$var$renderCell(item?.As_per_grn)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $8c012a5104330be1$var$renderCell(item?.As_per_invoice)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $8c012a5104330be1$var$renderCell(item?.result)
                                                })
                                            ]
                                        }, key))
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "empty-state",
                        children: "No data available"
                    })
                ]
            })
        });
    }
    function renderTableData() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "invoice-display__section-group",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "workspace-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        children: "Table Data"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "invoice-display__subheading",
                        children: "Table"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c012a5104330be1$var$ObjectRowsTable, {
                        rows: tableData.tabledata_,
                        emptyMessage: "No Data Available"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "invoice-display__subheading",
                        children: "Check2"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c012a5104330be1$var$KeyValueTable, {
                        rows: toEntries(tableData.check_2),
                        emptyMessage: "No Data Available"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "invoice-display__subheading",
                        children: "Check3"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c012a5104330be1$var$KeyValueTable, {
                        rows: toEntries(tableData.check_3),
                        emptyMessage: "No Data Available"
                    })
                ]
            })
        });
    }
    function renderInvoiceData() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "invoice-display__section-group",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "workspace-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        children: "Invoice Data"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c012a5104330be1$var$KeyValueTable, {
                        rows: invoiceDataRows,
                        emptyMessage: "No invoice data available."
                    })
                ]
            })
        });
    }
    function renderAllSections() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                renderInvoiceChecks(),
                renderGstData(),
                renderInvoiceVsGrn(),
                renderTableData(),
                renderInvoiceData()
            ]
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
        className: `invoice-display${embedded ? " invoice-display--embedded" : ""}`,
        children: embedded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                    className: "invoice-display__topbar",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Invoice Display"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    children: responseFile || "Invoice response"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "config-note",
                                    children: "Review invoice checks, GST data, GRN comparisons, extracted table data, and raw invoice details from the existing Django backend response file."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "invoice-display__actions",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "ghost-button",
                                type: "button",
                                onClick: onClose,
                                children: "Close"
                            })
                        })
                    ]
                }),
                loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                    className: "workspace-panel",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "config-note",
                        children: "Loading invoice display\u2026"
                    })
                }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                    className: "workspace-panel",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-banner config-banner--error",
                        children: error
                    })
                }) : renderAllSections()
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bridge-card",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    children: "Invoice Display"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Review invoice checks, GST data, GRN comparisons, extracted table data, and raw invoice details from the existing Django backend response file."
                }),
                loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Loading invoice display\u2026"
                }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        color: 'red'
                    },
                    children: error
                }) : renderAllSections()
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");




function $be4094fc57a496e8$export$2e2bcd8739ae039({ title: title, intro: intro, metrics: metrics = [], actions: actions, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "processor-view processor-view--pending-actions",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel processor-view__hero processor-view__hero--compact",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "processor-view__hero-copy",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "processor-view__heading-row",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-view__heading-copy",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "processor-view__intro",
                                            children: intro
                                        })
                                    ]
                                }),
                                metrics.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "processor-metrics processor-metrics--inline",
                                    children: metrics.map((metric)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                                            className: "processor-metric-card",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "processor-metric-card__label",
                                                    children: metric.label
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: metric.value
                                                })
                                            ]
                                        }, metric.label))
                                }) : null
                            ]
                        })
                    }),
                    actions ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "processor-view__hero-actions",
                        children: actions
                    }) : null
                ]
            }),
            children
        ]
    });
}




function $c87047e597edfe49$var$formatAmount(value) {
    if (value === null || value === undefined || value === "") return "-";
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return String(value);
    return new Intl.NumberFormat("en-IN", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    }).format(numericValue);
}
function $c87047e597edfe49$var$formatDate(value) {
    if (!value) return "-";
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return value;
    return parsed.toLocaleDateString();
}
function $c87047e597edfe49$var$getPendingDuration(createdAt) {
    if (!createdAt) return "-";
    const createdTime = new Date(createdAt);
    const now = new Date();
    let diffMs = now - createdTime;
    if (diffMs < 0) diffMs = 0;
    const minutes = Math.floor(diffMs / 60000);
    const hours = Math.floor(diffMs / 3600000);
    const days = Math.floor(diffMs / 86400000);
    if (days > 0) return `${days}d ${hours % 24}h`;
    if (hours > 0) return `${hours}h ${minutes % 60}m`;
    return `${minutes}m`;
}
function $c87047e597edfe49$var$TrailModal({ trail: trail, loading: loading, onClose: onClose }) {
    (0, $acw62.useEffect)(()=>{
        if (!trail && !loading) return;
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        trail,
        loading,
        onClose
    ]);
    if (!trail && !loading) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card processor-modal__card--wide",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "processor-trail-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Audit Log"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "processor-trail-title",
                                    children: "Invoice timeline"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: "Loading audit log\u2026"
                }) : trail?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "processor-timeline",
                    children: trail.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                            className: "processor-timeline__item",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__step",
                                    children: [
                                        "Step ",
                                        entry.step
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__content",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: entry.action
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: entry.message || "No message recorded."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                entry.username || "System",
                                                entry.userrole ? ` (${entry.userrole})` : "",
                                                entry.created_at ? ` \u{2022} ${new Date(entry.created_at).toLocaleString()}` : ""
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, `${entry.step}-${entry.created_at}`))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "empty-state",
                    children: "No timeline available for this invoice."
                })
            ]
        })
    });
}
function $c87047e597edfe49$export$2e2bcd8739ae039() {
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [actionKey, setActionKey] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [selectedRows, setSelectedRows] = (0, $acw62.useState)([]);
    const [statusDetail, setStatusDetail] = (0, $acw62.useState)(null);
    const [editTarget, setEditTarget] = (0, $acw62.useState)(null);
    const [trail, setTrail] = (0, $acw62.useState)(null);
    const [trailLoading, setTrailLoading] = (0, $acw62.useState)(false);
    const [menuPosition, setMenuPosition] = (0, $acw62.useState)(null);
    const allSelected = rows.length > 0 && selectedRows.length === rows.length;
    const summary = (0, $acw62.useMemo)(()=>{
        const redFlags = rows.reduce((count, row)=>count + Object.values(row.invoiceCheck || {}).filter((item)=>item?.color === "r").length, 0);
        return {
            count: rows.length,
            selected: selectedRows.length,
            redFlags: redFlags
        };
    }, [
        rows,
        selectedRows
    ]);
    const menuRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!menuPosition) return;
        const handleClickOutside = (event)=>{
            if (menuRef.current && !menuRef.current.contains(event.target)) setMenuPosition(null);
        };
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") setMenuPosition(null);
        };
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        menuPosition
    ]);
    async function loadRows() {
        setLoading(true);
        setError("");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/get-hold/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                }
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok || payload?.error) throw new Error(payload?.message || payload?.error || `Unable to load on-hold invoices. Backend responded with ${response.status}.`);
            if (!payload) throw new Error("Unable to load on-hold invoices. Backend returned a non-JSON response.");
            setRows(payload.data || []);
        } catch (requestError) {
            setError(requestError.message || "Unable to load on-hold invoices.");
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadRows();
    }, []);
    function toggleRowSelection(invoiceGroupKey) {
        setSelectedRows((current)=>current.includes(invoiceGroupKey) ? current.filter((item)=>item !== invoiceGroupKey) : [
                ...current,
                invoiceGroupKey
            ]);
    }
    function toggleAllRows() {
        setSelectedRows((current)=>current.length === rows.length ? [] : rows.map((row)=>row.invoiceGroupKey));
    }
    async function handleTrailOpen(row) {
        setTrail(null);
        setTrailLoading(true);
        try {
            const response = await fetch(`/api/invoice/trail/${row.invoiceId}/`, {
                credentials: "include"
            });
            const payload = await response.json();
            if (!response.ok || !payload.success) throw new Error(payload.message || "Unable to load trail.");
            setTrail(payload.data || []);
        } catch (requestError) {
            setTrail([]);
            setError(requestError.message || "Unable to load trail.");
        } finally{
            setTrailLoading(false);
        }
    }
    async function handlePreview(row) {
        setStatus("");
        setError("");
        setActionKey(`preview-${row.invoiceGroupKey}`);
        // Open immediately from user click
        const previewWindow = window.open("", "_blank");
        if (!previewWindow) {
            setError("Preview window was blocked by the browser.");
            return;
        }
        previewWindow.document.write("<html><body><h3>Loading preview...</h3></body></html>");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/template-preview/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    invoice_keys: [
                        row.invoiceGroupKey
                    ],
                    material_service: row.material_service
                })
            });
            const payload = await response.json();
            if (!response.ok || payload?.status !== "success") throw new Error(payload?.message || "Unable to generate preview.");
            let html = "<html><head><title>Preview</title></head><body style='padding:24px;font-family:Segoe UI,sans-serif;'>";
            Object.entries(payload.template_html || {}).forEach(([key, value])=>{
                html += `<h3>${key}</h3>${value}<hr/>`;
            });
            html += "</body></html>";
            previewWindow.document.open();
            previewWindow.document.write(html);
            previewWindow.document.close();
        } catch (requestError) {
            previewWindow.close();
            setError(requestError.message || "Unable to generate preview.");
        } finally{
            setActionKey("");
        }
    }
    async function handleAction(row, type) {
        setStatus("");
        setError("");
        if (type === "approve" && Object.values(row.invoiceCheck || {}).some((item)=>item?.color === "r")) {
            setError("There are discrepancies in this invoice. Fix them before approving.");
            return;
        }
        setActionKey(`${type}-${row.invoiceGroupKey}`);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            let url = "";
            let body = {};
            if (type === "approve") {
                url = "/api/approve-invoice/";
                body = {
                    invoice_group_key: row.invoiceGroupKey,
                    tab: 'Processor'
                };
            } else if (type === "hold") {
                url = "/api/hold-invoice/";
                body = {
                    invoice_group_key: row.invoiceGroupKey,
                    tab: 'Processor'
                };
            } else if (type === "reject") {
                url = "/api/reject-invoice/";
                body = {
                    invoice_group_key: row.invoiceGroupKey,
                    tab: 'Processor'
                };
            } else if (type === "delete") {
                url = "/api/delete-invoice/";
                body = {
                    invoice_group_key: row.invoiceGroupKey,
                    tab: "pendingtab"
                };
            }
            const response = await fetch(url, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify(body)
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || `Unable to ${type} invoice.`);
            setStatus(payload.message || `Invoice ${type}d successfully.`);
            setSelectedRows((current)=>current.filter((item)=>item !== row.invoiceGroupKey));
            await loadRows();
        } catch (requestError) {
            setError(requestError.message || `Unable to ${type} invoice.`);
        } finally{
            setActionKey("");
        }
    }
    // function openLegacyProcessorPage() {
    //   window.localStorage.setItem("activeSection", "uploaded");
    //   window.open(getLegacyUrl("/all-invoices/"), "_blank", "noreferrer");
    // }
    function refreshPendingActions() {
        loadRows();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $be4094fc57a496e8$export$2e2bcd8739ae039), {
        title: "Hold Invoices",
        intro: "",
        metrics: [
            {
                label: "Queue",
                value: summary.count
            },
            {
                label: "Selected",
                value: summary.selected
            }
        ],
        actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            className: "ghost-button processor-view__refresh",
            type: "button",
            onClick: refreshPendingActions,
            children: "Refresh"
        }),
        children: [
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "workspace-panel processor-table-panel",
                children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: "Loading pending actions\u2026"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "config-table processor-table",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Invoice ID"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Vendor Name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Invoice No."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Invoice Date"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Invoice Value"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Response"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "File"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Preview"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Age"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                            children: [
                                                "Select",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    className: "processor-checkbox",
                                                    type: "checkbox",
                                                    checked: allSelected,
                                                    onChange: toggleAllRows
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Logs"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Action"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: rows.length ? rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.InvoiceId
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.VendorName || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.InvoiceNo || row.InvNo || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.InvoiceDate || row.InvDate || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: $c87047e597edfe49$var$formatAmount(row.InvoiceValue || row.TotalAmount)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "processor-status-list",
                                                    children: Object.entries(row.InvoiceCheck || {}).length ? Object.entries(row.InvoiceCheck || {}).map(([label, item])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: `processor-status-dot processor-status-dot--${item?.color || "o"}`,
                                                            type: "button",
                                                            title: `${label}: ${item?.message || ""}`,
                                                            onClick: ()=>setStatusDetail({
                                                                    label: label,
                                                                    message: item?.message,
                                                                    data: item?.data,
                                                                    key: item?.key || label,
                                                                    checkKey: label,
                                                                    uniqueKey: row.InvoiceGroupKey,
                                                                    color: item?.color || "o"
                                                                })
                                                        }, `${row.InvoiceGroupKey}-${label}`)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "empty-state",
                                                        children: "No checks"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.unique_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    onClick: ()=>(0, $3d6d578a87c5904f$export$2926f86deb178d44)(`${row.unique_name}.json`),
                                                    children: "Data"
                                                }) : "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.unique_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>(0, $e267546ad9d86d30$export$a38ce99a4bdccd4e)(row.InvoiceId),
                                                    children: "\uD83D\uDCCE"
                                                }) : "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "ghost-button",
                                                    type: "button",
                                                    disabled: actionKey === `preview-${row.InvoiceGroupKey}`,
                                                    onClick: ()=>handlePreview(row),
                                                    children: actionKey === `preview-${row.InvoiceGroupKey}` ? "Previewing..." : "Preview"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: $c87047e597edfe49$var$getPendingDuration(row.CreatedAt)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    className: "processor-checkbox",
                                                    type: "checkbox",
                                                    checked: selectedRows.includes(row.InvoiceGroupKey),
                                                    onChange: ()=>toggleRowSelection(row.InvoiceGroupKey)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "ghost-button",
                                                    type: "button",
                                                    onClick: ()=>handleTrailOpen(row),
                                                    children: "Logs"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "action-dropdown-wrapper",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        className: "action-menu-button",
                                                        onClick: (e)=>{
                                                            if (menuPosition?.row?.InvoiceGroupKey === row.InvoiceGroupKey) {
                                                                setMenuPosition(null);
                                                                return;
                                                            }
                                                            const rect = e.currentTarget.getBoundingClientRect();
                                                            setMenuPosition({
                                                                row: row,
                                                                top: rect.bottom + window.scrollY,
                                                                left: rect.left + window.scrollX
                                                            });
                                                        },
                                                        children: "Actions \u25BC"
                                                    })
                                                })
                                            })
                                        ]
                                    }, row.InvoiceGroupKey)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        colSpan: "12",
                                        children: "No pending processor actions found."
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            menuPosition && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                ref: menuRef,
                className: "global-action-menu",
                style: {
                    position: "fixed",
                    top: menuPosition.top,
                    left: menuPosition.left,
                    zIndex: 999999
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            handleAction(menuPosition.row, "approve");
                            setMenuPosition(null);
                        },
                        children: "\u2713 Approve"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            handleAction(menuPosition.row, "reject");
                            setMenuPosition(null);
                        },
                        children: "\u2715 Reject"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            setEditTarget({
                                invoiceGroupKey: menuPosition.row.invoiceGroupKey
                            });
                            setMenuPosition(null);
                        },
                        children: "\u270E Edit"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: "danger-item",
                        onClick: ()=>{
                            handleAction(menuPosition.row, "delete");
                            setMenuPosition(null);
                        },
                        children: "\uD83D\uDDD1 Delete"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90a432d2bdd32db5$export$2e2bcd8739ae039), {
                detail: statusDetail,
                onClose: ()=>setStatusDetail(null),
                onSaved: loadRows
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c5c59f6c0eb6d77$export$2e2bcd8739ae039), {
                invoiceGroupKey: editTarget?.invoiceGroupKey,
                onClose: ()=>setEditTarget(null),
                onSaved: loadRows
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c87047e597edfe49$var$TrailModal, {
                trail: trail,
                loading: trailLoading,
                onClose: ()=>setTrail(null)
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");





function $07861bca2ee4d297$var$formatAmount(value) {
    if (value === null || value === undefined || value === "") return "-";
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return String(value);
    return new Intl.NumberFormat("en-IN", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    }).format(numericValue);
}
function $07861bca2ee4d297$var$StatusModal({ detail: detail, onClose: onClose }) {
    if (!detail) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "generated-status-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Status Detail"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "generated-status-title",
                                    children: detail.label
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: detail.message || "No additional message available."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                    className: "processor-modal__code",
                    children: JSON.stringify(detail.data ?? {}, null, 2)
                })
            ]
        })
    });
}
function $07861bca2ee4d297$var$TrailModal({ trail: trail, loading: loading, onClose: onClose }) {
    (0, $acw62.useEffect)(()=>{
        if (!trail && !loading) return;
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        trail,
        loading,
        onClose
    ]);
    if (!trail && !loading) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card processor-modal__card--wide",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "processor-trail-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Audit Log"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "processor-trail-title",
                                    children: "Invoice timeline"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: "Loading audit log\u2026"
                }) : trail?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "processor-timeline",
                    children: trail.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                            className: "processor-timeline__item",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__step",
                                    children: [
                                        "Step ",
                                        entry.step
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__content",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: entry.action
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: entry.message || "No message recorded."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                entry.username || "System",
                                                entry.userrole ? ` (${entry.userrole})` : "",
                                                entry.created_at ? ` \u{2022} ${new Date(entry.created_at).toLocaleString()}` : ""
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, `${entry.step}-${entry.created_at}`))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "empty-state",
                    children: "No timeline available for this invoice."
                })
            ]
        })
    });
}
function $07861bca2ee4d297$export$2e2bcd8739ae039() {
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [actionKey, setActionKey] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [statusDetail, setStatusDetail] = (0, $acw62.useState)(null);
    const [trail, setTrail] = (0, $acw62.useState)(null);
    const [trailLoading, setTrailLoading] = (0, $acw62.useState)(false);
    const summary = (0, $acw62.useMemo)(()=>({
            count: rows.length,
            redFlags: rows.reduce((count, row)=>count + Object.values(row.InvoiceCheck || {}).filter((item)=>item?.color === "r").length, 0),
            warnings: rows.reduce((count, row)=>count + Object.values(row.InvoiceCheck || {}).filter((item)=>item?.color === "o").length, 0)
        }), [
        rows
    ]);
    async function loadRows() {
        setLoading(true);
        setError("");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/get-generated/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                }
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok || payload?.error) throw new Error(payload?.message || payload?.error || `Unable to load generated invoices. Backend responded with ${response.status}.`);
            if (!payload) throw new Error("Unable to load generated invoices. Backend returned a non-JSON response.");
            setRows(payload.data || []);
        } catch (requestError) {
            setError(requestError.message || "Unable to load generated invoices.");
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadRows();
    }, []);
    async function handleTrailOpen(row) {
        setTrail(null);
        setTrailLoading(true);
        try {
            const response = await fetch(`/api/invoice/trail/${row.InvoiceId}/`, {
                credentials: "include"
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok || !payload?.success) throw new Error(payload?.message || "Unable to load trail.");
            setTrail(payload.data || []);
        } catch (requestError) {
            setTrail([]);
            setError(requestError.message || "Unable to load trail.");
        } finally{
            setTrailLoading(false);
        }
    }
    async function handlePreview(row) {
        setStatus("");
        setError("");
        setActionKey(`preview-${row.invoiceGroupKey}`);
        // Open immediately from user click
        const previewWindow = window.open("", "_blank");
        if (!previewWindow) {
            setError("Preview window was blocked by the browser.");
            return;
        }
        previewWindow.document.write("<html><body><h3>Loading preview...</h3></body></html>");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/template-preview/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    invoice_keys: [
                        row.InvoiceGroupKey
                    ],
                    material_service: row.material_service
                })
            });
            const payload = await response.json();
            if (!response.ok || payload?.status !== "success") throw new Error(payload?.message || "Unable to generate preview.");
            let html = "<html><head><title>Preview</title></head><body style='padding:24px;font-family:Segoe UI,sans-serif;'>";
            Object.entries(payload.template_html || {}).forEach(([key, value])=>{
                html += `<h3>${key}</h3>${value}<hr/>`;
            });
            html += "</body></html>";
            previewWindow.document.open();
            previewWindow.document.write(html);
            previewWindow.document.close();
        } catch (requestError) {
            previewWindow.close();
            setError(requestError.message || "Unable to generate preview.");
        } finally{
            setActionKey("");
        }
    }
    function openLegacyGeneratedPage() {
        window.localStorage.setItem("activeSection", "generated");
        window.open((0, $96e14f2a7c3555e4$export$5d9c32988b6a9848)("/all-invoices/"), "_blank", "noreferrer");
    }
    function refreshPendingActions() {
        loadRows();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $be4094fc57a496e8$export$2e2bcd8739ae039), {
        title: "Template Generated",
        intro: "",
        metrics: [
            {
                label: "Queue",
                value: summary.count
            }
        ],
        actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            className: "ghost-button processor-view__refresh",
            type: "button",
            onClick: refreshPendingActions,
            children: "Refresh"
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "processor-view",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "workspace-panel",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "processor-table__header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "eyebrow",
                                            children: "Invoice Summary"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            children: "Generated queue"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "ghost-button",
                                    type: "button",
                                    onClick: loadRows,
                                    disabled: loading,
                                    children: loading ? "Refreshing..." : "Refresh"
                                })
                            ]
                        }),
                        loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "config-note",
                            children: "Loading generated invoices\u2026"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "config-table processor-table",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice ID"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Vendor Name"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice No."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice Date"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice Value"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice Status"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Response"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "File"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Logs"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                        children: rows.length ? rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.InvoiceId
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.VendorName || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.InvoiceNo || row.InvNo || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.InvoiceDate || row.InvDate || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: $07861bca2ee4d297$var$formatAmount(row.InvoiceValue || row.TotalAmount)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "processor-status-list",
                                                            children: Object.entries(row.InvoiceCheck || {}).length ? Object.entries(row.InvoiceCheck || {}).map(([label, item])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    className: `processor-status-dot processor-status-dot--${item?.color || "o"}`,
                                                                    type: "button",
                                                                    title: `${label}: ${item?.message || ""}`,
                                                                    onClick: ()=>setStatusDetail({
                                                                            label: label,
                                                                            message: item?.message,
                                                                            data: item?.data
                                                                        })
                                                                }, `${row.InvoiceGroupKey}-${label}`)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "empty-state",
                                                                children: "No checks"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.unique_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            onClick: ()=>(0, $3d6d578a87c5904f$export$2926f86deb178d44)(`${row.unique_name}.json`),
                                                            children: "Data"
                                                        }) : "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.InvoiceId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>(0, $e267546ad9d86d30$export$a38ce99a4bdccd4e)(row.InvoiceId),
                                                            children: "\uD83D\uDCCE"
                                                        }) : "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: "ghost-button",
                                                            type: "button",
                                                            onClick: ()=>handleTrailOpen(row),
                                                            children: "Logs"
                                                        })
                                                    })
                                                ]
                                            }, row.InvoiceGroupKey)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                colSpan: "10",
                                                children: "No invoices found in the generated queue."
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90a432d2bdd32db5$export$2e2bcd8739ae039), {
                    detail: statusDetail,
                    onClose: ()=>setStatusDetail(null),
                    onSaved: loadRows
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07861bca2ee4d297$var$TrailModal, {
                    trail: trail,
                    loading: trailLoading,
                    onClose: ()=>setTrail(null)
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");

function $6ce9fff60e225bdd$export$2e2bcd8739ae039() {
    const [downloading, setDownloading] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    async function handleExport() {
        setDownloading(true);
        setStatus("");
        setError("");
        try {
            const response = await fetch("/api/export-templates/", {
                method: "GET",
                credentials: "include"
            });
            if (!response.ok) throw new Error("Failed to download templates.");
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = url;
            anchor.download = "Templates.zip";
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
            window.URL.revokeObjectURL(url);
            setStatus("Templates downloaded successfully.");
        } catch (requestError) {
            setError(requestError.message || "Failed to download templates.");
        } finally{
            setDownloading(false);
        }
    }
    function openLegacyExportPage() {
        window.open((0, $96e14f2a7c3555e4$export$5d9c32988b6a9848)("/api/export-templates/"), "_blank", "noreferrer");
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "processor-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel processor-view__hero",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "Processor"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "Export Template"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-view__intro",
                                children: "Download the generated template ZIP from the existing Django backend. After export, the backend resets the generated template folder back to its base files."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "processor-view__hero-actions",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "processor-summary-card",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "ZIP"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "template bundle"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "ghost-button",
                                type: "button",
                                onClick: openLegacyExportPage,
                                children: "Open Legacy Export"
                            })
                        ]
                    })
                ]
            }),
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "processor-summary-grid",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                    className: "workspace-panel workspace-panel--compact",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "eyebrow",
                            children: "Download"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            children: "Templates.zip"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "config-note",
                            children: "Exports all generated `.xlsx` templates for the logged-in company."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                className: "workspace-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "processor-table__header",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Export Action"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Download template bundle"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "config-note",
                        children: "Use this action when template generation is complete and you are ready to download the consolidated ZIP package."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "processor-action-list",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary-button processor-action-button",
                                type: "button",
                                onClick: handleExport,
                                disabled: downloading,
                                children: downloading ? "Downloading..." : "Export Templates"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "ghost-button processor-action-button",
                                type: "button",
                                onClick: openLegacyExportPage,
                                children: "Open Legacy Endpoint"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");





function $ed2ab663ad52f25e$var$formatAmount(value) {
    if (value === null || value === undefined || value === "") return "-";
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return String(value);
    return new Intl.NumberFormat("en-IN", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    }).format(numericValue);
}
function $ed2ab663ad52f25e$var$TrailModal({ trail: trail, loading: loading, onClose: onClose }) {
    (0, $acw62.useEffect)(()=>{
        if (!trail && !loading) return;
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        trail,
        loading,
        onClose
    ]);
    if (!trail && !loading) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card processor-modal__card--wide",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "processor-trail-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Audit Log"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "processor-trail-title",
                                    children: "Invoice timeline"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: "Loading audit log\u2026"
                }) : trail?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "processor-timeline",
                    children: trail.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                            className: "processor-timeline__item",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__step",
                                    children: [
                                        "Step ",
                                        entry.step
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__content",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: entry.action
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: entry.message || "No message recorded."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                entry.username || "System",
                                                entry.userrole ? ` (${entry.userrole})` : "",
                                                entry.created_at ? ` \u{2022} ${new Date(entry.created_at).toLocaleString()}` : ""
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, `${entry.step}-${entry.created_at}`))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "empty-state",
                    children: "No timeline available for this invoice."
                })
            ]
        })
    });
}
function $ed2ab663ad52f25e$export$2e2bcd8739ae039() {
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [actionKey, setActionKey] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [trail, setTrail] = (0, $acw62.useState)(null);
    const [trailLoading, setTrailLoading] = (0, $acw62.useState)(false);
    const [showEditModal, setShowEditModal] = (0, $acw62.useState)(false);
    const [editLoading, setEditLoading] = (0, $acw62.useState)(false);
    const [editForm, setEditForm] = (0, $acw62.useState)({
        InvoiceGroupKey: "",
        InvoiceNo: "",
        PoNumber: "",
        GrnNumber: "",
        VendorGst: "",
        VendorCode: "",
        VendorName: ""
    });
    const [vendorVerification, setVendorVerification] = (0, $acw62.useState)({
        status: "",
        message: ""
    });
    const [menuPosition, setMenuPosition] = (0, $acw62.useState)(null);
    const summary = (0, $acw62.useMemo)(()=>({
            count: rows.length,
            withReason: rows.filter((row)=>row.message).length
        }), [
        rows
    ]);
    const menuRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!menuPosition) return;
        const handleClickOutside = (event)=>{
            if (menuRef.current && !menuRef.current.contains(event.target)) setMenuPosition(null);
        };
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") setMenuPosition(null);
        };
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        menuPosition
    ]);
    async function loadRows() {
        setLoading(true);
        setError("");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/get-mandetory-fields-missing/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                }
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok || payload?.error) throw new Error(payload?.message || payload?.error || `Unable to load mandatory info invoices. Backend responded with ${response.status}.`);
            if (!payload) throw new Error("Unable to load mandatory info invoices. Backend returned a non-JSON response.");
            setRows(payload.data || []);
        } catch (requestError) {
            setError(requestError.message || "Unable to load mandatory info invoices.");
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadRows();
    }, []);
    async function handleTrailOpen(row) {
        setTrail(null);
        setTrailLoading(true);
        try {
            const response = await fetch(`/api/invoice/trail/${row.InvoiceId}/`, {
                credentials: "include"
            });
            const payload = await response.json();
            if (!response.ok || !payload.success) throw new Error(payload.message || "Unable to load trail.");
            setTrail(payload.data || []);
        } catch (requestError) {
            setTrail([]);
            setError(requestError.message || "Unable to load trail.");
        } finally{
            setTrailLoading(false);
        }
    }
    async function handleAction(row, type) {
        setStatus("");
        setError("");
        setActionKey(`${type}-${row.InvoiceGroupKey}`);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            let url = "";
            let body = {};
            if (type === "approve") {
                url = "/api/approve-invoice/";
                body = {
                    invoice_group_key: row.InvoiceGroupKey
                };
            } else if (type === "reject") {
                url = "/api/reject-invoice/";
                body = {
                    invoice_group_key: row.InvoiceGroupKey
                };
            } else if (type === "delete") {
                url = "/api/delete-invoice/";
                body = {
                    invoice_group_key: row.InvoiceGroupKey,
                    tab: "mandatoryinfomissing"
                };
            }
            const response = await fetch(url, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify(body)
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || `Unable to ${type} invoice.`);
            setStatus(payload.message || `Invoice ${type}d successfully.`);
            await loadRows();
        } catch (requestError) {
            setError(requestError.message || `Unable to ${type} invoice.`);
        } finally{
            setActionKey("");
        }
    }
    const openEditModal = async (groupKey)=>{
        try {
            setEditLoading(true);
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/get-invoice-details/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    InvoiceGroupKey: groupKey,
                    Tab: "mandatory_missing"
                })
            });
            const result = await response.json();
            if (!result.success) {
                alert(result.message || "Unable to fetch invoice details");
                return;
            }
            setEditForm(result.data);
            setVendorVerification({
                status: "",
                message: ""
            });
            setShowEditModal(true);
        } catch (error) {
            console.error(error);
            alert("Error fetching invoice details");
        } finally{
            setEditLoading(false);
        }
    };
    const handleEditChange = (e)=>{
        const { name: name, value: value } = e.target;
        setEditForm((prev)=>({
                ...prev,
                [name]: value
            }));
    };
    const verifyVendorGst = async ()=>{
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/lookup-vendor-by-gst/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    gst_number: editForm.VendorGst
                })
            });
            const result = await response.json();
            if (result.found) {
                setEditForm((prev)=>({
                        ...prev,
                        VendorCode: result.vendor_code,
                        VendorName: result.vendor_name
                    }));
                setVendorVerification({
                    status: "success",
                    message: "Vendor found"
                });
            } else {
                setEditForm((prev)=>({
                        ...prev,
                        VendorCode: "",
                        VendorName: ""
                    }));
                setVendorVerification({
                    status: "error",
                    message: "No vendor found for entered GST number"
                });
            }
        } catch (err) {
            console.error(err);
            setVendorVerification({
                status: "error",
                message: "Vendor verification failed"
            });
        }
    };
    const submitEditedInvoice = async ()=>{
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/submit-mandatoryinfomissing-invoice/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify(editForm)
            });
            const result = await response.json();
            if (result.success) {
                await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                    icon: "success",
                    title: "Success",
                    text: result.message || "Invoice submitted successfully",
                    confirmButtonText: "OK"
                });
                setShowEditModal(false);
            } else {
                setShowEditModal(false);
                (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                    icon: "error",
                    title: "Submission Failed",
                    text: result.message || "Submission failed",
                    confirmButtonText: "OK"
                });
            }
        } catch (error) {
            console.error(error);
            setShowEditModal(false);
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Failed to submit invoice",
                confirmButtonText: "OK"
            });
        }
    };
    function openLegacyMandatoryPage() {
        window.localStorage.setItem("activeSection", "MandatoryFieldsMissing");
        window.open((0, $96e14f2a7c3555e4$export$5d9c32988b6a9848)("/all-invoices/"), "_blank", "noreferrer");
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $be4094fc57a496e8$export$2e2bcd8739ae039), {
        title: "Mandatory Info Missing",
        metrics: [
            {
                label: "Queue",
                value: summary.count
            },
            {
                label: "Reasoned Rows",
                value: summary.withReason
            }
        ],
        actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "ghost-button",
                type: "button",
                onClick: loadRows,
                disabled: loading,
                children: loading ? "Refreshing..." : "Refresh"
            })
        }),
        children: [
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "workspace-panel",
                children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: "Loading mandatory-info invoices\u2026"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "config-table processor-table",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Invoice ID"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Vendor Name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Invoice No."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Invoice Date"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Invoice Value"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Reason"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Response"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "File"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Logs"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Action"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: rows.length ? rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.InvoiceId
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.VendorName || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.InvNo || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.InvDate || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: $ed2ab663ad52f25e$var$formatAmount(row.TotalAmount)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.message || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.unique_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    href: (0, $96e14f2a7c3555e4$export$5d9c32988b6a9848)(encodeURI(`/api/invoice-display/?response_file=${row.unique_name}.json`)),
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "Raw Data"
                                                }) : "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.InvoiceId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>(0, $e267546ad9d86d30$export$a38ce99a4bdccd4e)(row.InvoiceId),
                                                    children: "\uD83D\uDCCE"
                                                }) : "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "ghost-button",
                                                    type: "button",
                                                    onClick: ()=>handleTrailOpen(row),
                                                    children: "Logs"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "action-menu-button",
                                                    onClick: (e)=>{
                                                        if (menuPosition?.row?.InvoiceGroupKey === row.InvoiceGroupKey) {
                                                            setMenuPosition(null);
                                                            return;
                                                        }
                                                        const rect = e.currentTarget.getBoundingClientRect();
                                                        setMenuPosition({
                                                            row: row,
                                                            top: rect.bottom + 5,
                                                            left: rect.left
                                                        });
                                                    },
                                                    children: "Actions \u25BC"
                                                })
                                            })
                                        ]
                                    }, row.InvoiceGroupKey)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        colSpan: "10",
                                        children: "No invoices found with mandatory info missing."
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            showEditModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "nomigo-edit-modal-overlay",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "nomigo-edit-modal",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "nomigo-edit-modal-header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Edit Mandatory Info"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setShowEditModal(false),
                                    children: "\xd7"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "nomigo-edit-modal-section",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Invoice Information"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "nomigo-edit-form-grid",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "nomigo-edit-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Invoice Number"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    name: "InvoiceNo",
                                                    value: editForm.InvoiceNo || "",
                                                    onChange: handleEditChange
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "nomigo-edit-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "PO Number"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    name: "PoNumber",
                                                    value: editForm.PoNumber || "",
                                                    onChange: handleEditChange
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "nomigo-edit-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "GRN Number"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    name: "GrnNumber",
                                                    value: editForm.GrnNumber || "",
                                                    onChange: handleEditChange
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "nomigo-edit-modal-section",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Vendor Verification"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "nomigo-edit-form-grid",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "nomigo-edit-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Vendor GST"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    name: "VendorGst",
                                                    value: editForm.VendorGst || "",
                                                    onChange: handleEditChange
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "nomigo-edit-verify-wrapper",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: "nomigo-edit-verify-btn",
                                                onClick: verifyVendorGst,
                                                children: "Verify Vendor"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "nomigo-edit-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Vendor Code"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    value: editForm.VendorCode || "",
                                                    readOnly: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "nomigo-edit-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Vendor Name"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    value: editForm.VendorName || "",
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "nomigo-edit-footer",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "primary-button",
                                onClick: submitEditedInvoice,
                                children: "Submit Invoice"
                            })
                        })
                    ]
                })
            }),
            menuPosition && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                ref: menuRef,
                className: "global-action-menu",
                style: {
                    position: "fixed",
                    top: menuPosition.top,
                    left: menuPosition.left,
                    zIndex: 999999
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        disabled: actionKey === `approve-${menuPosition.row.InvoiceGroupKey}`,
                        onClick: ()=>{
                            handleAction(menuPosition.row, "approve");
                            setMenuPosition(null);
                        },
                        children: "\u2713 Approve"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            openEditModal(menuPosition.row.InvoiceGroupKey);
                            setMenuPosition(null);
                        },
                        children: "\u270E Edit"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        disabled: actionKey === `reject-${menuPosition.row.InvoiceGroupKey}`,
                        onClick: ()=>{
                            handleAction(menuPosition.row, "reject");
                            setMenuPosition(null);
                        },
                        children: "\u2715 Reject"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: "danger-item",
                        disabled: actionKey === `delete-${menuPosition.row.InvoiceGroupKey}`,
                        onClick: ()=>{
                            handleAction(menuPosition.row, "delete");
                            setMenuPosition(null);
                        },
                        children: "\uD83D\uDDD1 Delete"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ed2ab663ad52f25e$var$TrailModal, {
                trail: trail,
                loading: trailLoading,
                onClose: ()=>setTrail(null)
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");





function $7260aeda2f1f9087$var$formatAmount(value) {
    if (value === null || value === undefined || value === "") return "-";
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return String(value);
    return new Intl.NumberFormat("en-IN", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    }).format(numericValue);
}
function $7260aeda2f1f9087$var$TrailModal({ trail: trail, loading: loading, onClose: onClose }) {
    (0, $acw62.useEffect)(()=>{
        if (!trail && !loading) return;
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        trail,
        loading,
        onClose
    ]);
    if (!trail && !loading) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card processor-modal__card--wide",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "processor-trail-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Audit Log"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "processor-trail-title",
                                    children: "Invoice timeline"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: "Loading audit log\u2026"
                }) : trail?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "processor-timeline",
                    children: trail.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                            className: "processor-timeline__item",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__step",
                                    children: [
                                        "Step ",
                                        entry.step
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__content",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: entry.action
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: entry.message || "No message recorded."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                entry.username || "System",
                                                entry.userrole ? ` (${entry.userrole})` : "",
                                                entry.created_at ? ` \u{2022} ${new Date(entry.created_at).toLocaleString()}` : ""
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, `${entry.step}-${entry.created_at}`))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "empty-state",
                    children: "No timeline available for this invoice."
                })
            ]
        })
    });
}
function $7260aeda2f1f9087$export$2e2bcd8739ae039() {
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)("");
    const [trail, setTrail] = (0, $acw62.useState)(null);
    const [trailLoading, setTrailLoading] = (0, $acw62.useState)(false);
    const summary = (0, $acw62.useMemo)(()=>({
            count: rows.length,
            withReasons: rows.filter((row)=>row.Reason).length
        }), [
        rows
    ]);
    async function loadRows() {
        setLoading(true);
        setError("");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/get-pendingwithchecker/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                }
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok || payload?.error) throw new Error(payload?.message || payload?.error || `Unable to load pending-approval invoices. Backend responded with ${response.status}.`);
            if (!payload) throw new Error("Unable to load pending-approval invoices. Backend returned a non-JSON response.");
            setRows(payload.data || []);
        } catch (requestError) {
            setError(requestError.message || "Unable to load pending-approval invoices.");
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadRows();
    }, []);
    async function handleTrailOpen(row) {
        setTrail(null);
        setTrailLoading(true);
        try {
            const response = await fetch(`/api/invoice/trail/${row.InvoiceId}/`, {
                credentials: "include"
            });
            const payload = await response.json();
            if (!response.ok || !payload.success) throw new Error(payload.message || "Unable to load trail.");
            setTrail(payload.data || []);
        } catch (requestError) {
            setTrail([]);
            setError(requestError.message || "Unable to load trail.");
        } finally{
            setTrailLoading(false);
        }
    }
    function refreshPendingActions() {
        loadRows();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $be4094fc57a496e8$export$2e2bcd8739ae039), {
        title: "Pending Approval standing at Checker End",
        intro: "Review invoices, inspect status checks, and take action from the dashboard.",
        metrics: [
            {
                label: "Queue",
                value: summary.count
            },
            {
                label: "Selected",
                value: summary.selected
            }
        ],
        actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            className: "ghost-button processor-view__refresh",
            type: "button",
            onClick: refreshPendingActions,
            children: "Refresh"
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "processor-view",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "workspace-panel",
                    children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "config-note",
                        children: "Loading pending-approval invoices\u2026"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-table processor-table",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice ID"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Vendor Name"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice No."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice Date"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice Value"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Reason"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Response"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "File"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Logs"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: rows.length ? rows.map((row, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.InvoiceId
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.VendorName || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.InvoiceNo || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.InvoiceDate || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $7260aeda2f1f9087$var$formatAmount(row.InvoiceValue)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.Reason || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.unique_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        onClick: ()=>(0, $3d6d578a87c5904f$export$2926f86deb178d44)(`${row.unique_name}.json`),
                                                        children: "Data"
                                                    }) : "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.unique_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>(0, $e267546ad9d86d30$export$a38ce99a4bdccd4e)(row.InvoiceId),
                                                        children: "\uD83D\uDCCE"
                                                    }) : "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "ghost-button",
                                                        type: "button",
                                                        onClick: ()=>handleTrailOpen(row),
                                                        children: "Logs"
                                                    })
                                                })
                                            ]
                                        }, `${row.InvoiceId}-${index}`)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            colSpan: "9",
                                            children: "No invoices found in the pending-approval queue."
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7260aeda2f1f9087$var$TrailModal, {
                    trail: trail,
                    loading: trailLoading,
                    onClose: ()=>setTrail(null)
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");





function $9062498f4004e827$var$formatAmount(value) {
    if (value === null || value === undefined || value === "") return "-";
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return String(value);
    return new Intl.NumberFormat("en-IN", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    }).format(numericValue);
}
function $9062498f4004e827$var$StatusModal({ detail: detail, onClose: onClose }) {
    if (!detail) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "rejected-status-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Status Detail"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "rejected-status-title",
                                    children: detail.label
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: detail.message || "No additional message available."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                    className: "processor-modal__code",
                    children: JSON.stringify(detail.data ?? {}, null, 2)
                })
            ]
        })
    });
}
function $9062498f4004e827$var$TrailModal({ trail: trail, loading: loading, onClose: onClose }) {
    (0, $acw62.useEffect)(()=>{
        if (!trail && !loading) return;
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        trail,
        loading,
        onClose
    ]);
    if (!trail && !loading) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card processor-modal__card--wide",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "processor-trail-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Audit Log"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "processor-trail-title",
                                    children: "Invoice timeline"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: "Loading audit log\u2026"
                }) : trail?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "processor-timeline",
                    children: trail.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                            className: "processor-timeline__item",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__step",
                                    children: [
                                        "Step ",
                                        entry.step
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__content",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: entry.action
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: entry.message || "No message recorded."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                entry.username || "System",
                                                entry.userrole ? ` (${entry.userrole})` : "",
                                                entry.created_at ? ` \u{2022} ${new Date(entry.created_at).toLocaleString()}` : ""
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, `${entry.step}-${entry.created_at}`))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "empty-state",
                    children: "No timeline available for this invoice."
                })
            ]
        })
    });
}
function $9062498f4004e827$export$2e2bcd8739ae039() {
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [actionKey, setActionKey] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [selectedRows, setSelectedRows] = (0, $acw62.useState)([]);
    const [statusDetail, setStatusDetail] = (0, $acw62.useState)(null);
    const [trail, setTrail] = (0, $acw62.useState)(null);
    const [trailLoading, setTrailLoading] = (0, $acw62.useState)(false);
    const allSelected = rows.length > 0 && selectedRows.length === rows.length;
    const summary = (0, $acw62.useMemo)(()=>({
            count: rows.length,
            selected: selectedRows.length,
            redFlags: rows.reduce((count, row)=>count + Object.values(row.InvoiceCheck || {}).filter((item)=>item?.color === "r").length, 0)
        }), [
        rows,
        selectedRows
    ]);
    async function loadRows() {
        setLoading(true);
        setError("");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/get-rejected/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                }
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok || payload?.error) throw new Error(payload?.message || payload?.error || `Unable to load rejected invoices. Backend responded with ${response.status}.`);
            if (!payload) throw new Error("Unable to load rejected invoices. Backend returned a non-JSON response.");
            setRows(payload.data || []);
        } catch (requestError) {
            setError(requestError.message || "Unable to load rejected invoices.");
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadRows();
    }, []);
    function toggleRowSelection(invoiceGroupKey) {
        setSelectedRows((current)=>current.includes(invoiceGroupKey) ? current.filter((item)=>item !== invoiceGroupKey) : [
                ...current,
                invoiceGroupKey
            ]);
    }
    function toggleAllRows() {
        setSelectedRows((current)=>current.length === rows.length ? [] : rows.map((row)=>row.InvoiceGroupKey));
    }
    async function handleTrailOpen(row) {
        setTrail(null);
        setTrailLoading(true);
        try {
            const response = await fetch(`/api/invoice/trail/${row.InvoiceId}/`, {
                credentials: "include"
            });
            const payload = await response.json();
            if (!response.ok || !payload.success) throw new Error(payload.message || "Unable to load trail.");
            setTrail(payload.data || []);
        } catch (requestError) {
            setTrail([]);
            setError(requestError.message || "Unable to load trail.");
        } finally{
            setTrailLoading(false);
        }
    }
    async function handleAction(row, type) {
        setStatus("");
        setError("");
        setActionKey(`${type}-${row.InvoiceGroupKey}`);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            let url = "";
            let body = {};
            if (type === "approve") {
                url = "/api/approve-invoice/";
                body = {
                    invoice_group_key: row.InvoiceGroupKey
                };
            } else if (type === "reject") {
                url = "/api/reject-invoice/";
                body = {
                    invoice_group_key: row.InvoiceGroupKey
                };
            }
            const response = await fetch(url, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify(body)
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || `Unable to ${type} invoice.`);
            setStatus(payload.message || `Invoice ${type}d successfully.`);
            setSelectedRows((current)=>current.filter((item)=>item !== row.InvoiceGroupKey));
            await loadRows();
        } catch (requestError) {
            setError(requestError.message || `Unable to ${type} invoice.`);
        } finally{
            setActionKey("");
        }
    }
    async function handlePreview(row) {
        setStatus("");
        setError("");
        setActionKey(`preview-${row.InvoiceGroupKey}`);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/template-preview/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    invoice_keys: [
                        row.InvoiceGroupKey
                    ]
                })
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || "Unable to generate preview.");
            const previewWindow = window.open("", "_blank", "noreferrer");
            if (!previewWindow) throw new Error("Preview window was blocked by the browser.");
            let html = "<html><head><title>Preview</title></head><body style='padding:24px;font-family:Segoe UI,sans-serif;'>";
            Object.entries(payload.template_html || {}).forEach(([key, value])=>{
                html += `<h3>${key}</h3>${value}<hr/>`;
            });
            html += "</body></html>";
            previewWindow.document.write(html);
            previewWindow.document.close();
        } catch (requestError) {
            setError(requestError.message || "Unable to generate preview.");
        } finally{
            setActionKey("");
        }
    }
    function openLegacyRejectedPage() {
        window.localStorage.setItem("activeSection", "rejected");
        window.open((0, $96e14f2a7c3555e4$export$5d9c32988b6a9848)("/all-invoices/"), "_blank", "noreferrer");
    }
    function refreshPendingActions() {
        loadRows();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $be4094fc57a496e8$export$2e2bcd8739ae039), {
        title: "Rejected Invoices",
        intro: "",
        metrics: [
            {
                label: "Queue",
                value: summary.count
            }
        ],
        actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            className: "ghost-button processor-view__refresh",
            type: "button",
            onClick: refreshPendingActions,
            children: "Refresh"
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "processor-view",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "workspace-panel",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "processor-table__header",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "ghost-button",
                                type: "button",
                                onClick: loadRows,
                                disabled: loading,
                                children: loading ? "Refreshing..." : "Refresh"
                            })
                        }),
                        loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "config-note",
                            children: "Loading rejected invoices\u2026"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "config-table processor-table",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice ID"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Vendor Name"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice No."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice Date"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice Value"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice Status"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Response"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "File"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Preview"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Logs"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                        children: rows.length ? rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.InvoiceId
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.VendorName || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.InvoiceNo || row.InvNo || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.InvoiceDate || row.InvDate || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: $9062498f4004e827$var$formatAmount(row.InvoiceValue || row.TotalAmount)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "processor-status-list",
                                                            children: Object.entries(row.InvoiceCheck || {}).length ? Object.entries(row.InvoiceCheck || {}).map(([label, item])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    className: `processor-status-dot processor-status-dot--${item?.color || "o"}`,
                                                                    type: "button",
                                                                    title: `${label}: ${item?.message || ""}`,
                                                                    onClick: ()=>setStatusDetail({
                                                                            label: label,
                                                                            message: item?.message,
                                                                            data: item?.data,
                                                                            key: item?.key || label,
                                                                            checkKey: label,
                                                                            uniqueKey: row.InvoiceGroupKey,
                                                                            color: item?.color || "o"
                                                                        })
                                                                }, `${row.InvoiceGroupKey}-${label}`)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "empty-state",
                                                                children: "No checks"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.unique_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            onClick: ()=>(0, $3d6d578a87c5904f$export$2926f86deb178d44)(`${row.unique_name}.json`),
                                                            children: "Data"
                                                        }) : "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.unique_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>(0, $e267546ad9d86d30$export$a38ce99a4bdccd4e)(row.InvoiceId),
                                                            children: "\uD83D\uDCCE"
                                                        }) : "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: "ghost-button",
                                                            type: "button",
                                                            onClick: ()=>handleTrailOpen(row),
                                                            children: "Logs"
                                                        })
                                                    })
                                                ]
                                            }, row.InvoiceGroupKey)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                colSpan: "12",
                                                children: "No invoices found in the rejected queue."
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90a432d2bdd32db5$export$2e2bcd8739ae039), {
                    detail: statusDetail,
                    onClose: ()=>setStatusDetail(null),
                    onSaved: loadRows
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9062498f4004e827$var$TrailModal, {
                    trail: trail,
                    loading: trailLoading,
                    onClose: ()=>setTrail(null)
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");




function $9b50169461c34fd1$var$formatAmount(value) {
    if (value === null || value === undefined || value === "") return "-";
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return String(value);
    return new Intl.NumberFormat("en-IN", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    }).format(numericValue);
}
function $9b50169461c34fd1$var$getPendingDuration(createdAt) {
    if (!createdAt) return "-";
    const createdTime = new Date(createdAt);
    const now = new Date();
    let diffMs = now - createdTime;
    if (diffMs < 0) diffMs = 0;
    const minutes = Math.floor(diffMs / 60000);
    const hours = Math.floor(diffMs / 3600000);
    const days = Math.floor(diffMs / 86400000);
    if (days > 0) return `${days}d ${hours % 24}h`;
    if (hours > 0) return `${hours}h ${minutes % 60}m`;
    return `${minutes}m`;
}
function $9b50169461c34fd1$var$StatusModal({ detail: detail, onClose: onClose }) {
    if (!detail) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "nomigo-status-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Status Detail"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "nomigo-status-title",
                                    children: detail.label
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: detail.message || "No additional message available."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                    className: "processor-modal__code",
                    children: JSON.stringify(detail.data ?? {}, null, 2)
                })
            ]
        })
    });
}
function $9b50169461c34fd1$var$TrailModal({ trail: trail, loading: loading, onClose: onClose }) {
    (0, $acw62.useEffect)(()=>{
        if (!trail && !loading) return;
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        trail,
        loading,
        onClose
    ]);
    if (!trail && !loading) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card processor-modal__card--wide",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "processor-trail-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Audit Log"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "processor-trail-title",
                                    children: "Invoice timeline"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: "Loading audit log\u2026"
                }) : trail?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "processor-timeline",
                    children: trail.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                            className: "processor-timeline__item",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__step",
                                    children: [
                                        "Step ",
                                        entry.step
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__content",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: entry.action
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: entry.message || "No message recorded."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                entry.username || "System",
                                                entry.userrole ? ` (${entry.userrole})` : "",
                                                entry.created_at ? ` \u{2022} ${new Date(entry.created_at).toLocaleString()}` : ""
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, `${entry.step}-${entry.created_at}`))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "empty-state",
                    children: "No timeline available for this invoice."
                })
            ]
        })
    });
}
function $9b50169461c34fd1$export$2e2bcd8739ae039() {
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [actionKey, setActionKey] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [selectedRows, setSelectedRows] = (0, $acw62.useState)([]);
    const [statusDetail, setStatusDetail] = (0, $acw62.useState)(null);
    const [trail, setTrail] = (0, $acw62.useState)(null);
    const [trailLoading, setTrailLoading] = (0, $acw62.useState)(false);
    const allSelected = rows.length > 0 && selectedRows.length === rows.length;
    const [showEditModal, setShowEditModal] = (0, $acw62.useState)(false);
    const [editLoading, setEditLoading] = (0, $acw62.useState)(false);
    const [editForm, setEditForm] = (0, $acw62.useState)({
        InvoiceGroupKey: "",
        InvoiceNo: "",
        PoNumber: "",
        GrnNumber: "",
        VendorGst: "",
        VendorCode: "",
        VendorName: ""
    });
    const [vendorVerification, setVendorVerification] = (0, $acw62.useState)({
        status: "",
        message: ""
    });
    const [menuPosition, setMenuPosition] = (0, $acw62.useState)(null);
    const summary = (0, $acw62.useMemo)(()=>({
            count: rows.length,
            selected: selectedRows.length,
            redFlags: rows.reduce((count, row)=>count + Object.values(row.InvoiceCheck || {}).filter((item)=>item?.color === "r").length, 0)
        }), [
        rows,
        selectedRows
    ]);
    const menuRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!menuPosition) return;
        const handleClickOutside = (event)=>{
            if (menuRef.current && !menuRef.current.contains(event.target)) setMenuPosition(null);
        };
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") setMenuPosition(null);
        };
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        menuPosition
    ]);
    async function loadRows() {
        setLoading(true);
        setError("");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/get-invoices-with-nogrndata/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                }
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok || payload?.error) throw new Error(payload?.message || payload?.error || `Unable to load invoices. Backend responded with ${response.status}.`);
            if (!payload) throw new Error("Unable to load invoices. Backend returned a non-JSON response.");
            setRows(payload.data || []);
        } catch (requestError) {
            setError(requestError.message || "Unable to load invoices.");
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadRows();
    }, []);
    function toggleRowSelection(invoiceGroupKey) {
        setSelectedRows((current)=>current.includes(invoiceGroupKey) ? current.filter((item)=>item !== invoiceGroupKey) : [
                ...current,
                invoiceGroupKey
            ]);
    }
    function toggleAllRows() {
        setSelectedRows((current)=>current.length === rows.length ? [] : rows.map((row)=>row.InvoiceGroupKey));
    }
    async function handleTrailOpen(row) {
        setTrail(null);
        setTrailLoading(true);
        try {
            const response = await fetch(`/api/invoice/trail/${row.InvoiceId}/`, {
                credentials: "include"
            });
            const payload = await response.json();
            if (!response.ok || !payload.success) throw new Error(payload.message || "Unable to load trail.");
            setTrail(payload.data || []);
        } catch (requestError) {
            setTrail([]);
            setError(requestError.message || "Unable to load trail.");
        } finally{
            setTrailLoading(false);
        }
    }
    async function handleAction(row, type) {
        setStatus("");
        setError("");
        setActionKey(`${type}-${row.InvoiceGroupKey}`);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            let url = "";
            let body = {};
            if (type === "approve") {
                url = "/api/approve-invoice/";
                body = {
                    invoice_group_key: row.InvoiceGroupKey
                };
            } else if (type === "reject") {
                url = "/api/reject-invoice/";
                body = {
                    invoice_group_key: row.InvoiceGroupKey
                };
            } else if (type === "delete") {
                url = "/api/delete-invoice/";
                body = {
                    invoice_group_key: row.InvoiceGroupKey,
                    tab: "nomigodatagtab"
                };
            }
            const response = await fetch(url, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify(body)
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || `Unable to ${type} invoice.`);
            setStatus(payload.message || `Invoice ${type}d successfully.`);
            setSelectedRows((current)=>current.filter((item)=>item !== row.InvoiceGroupKey));
            await loadRows();
        } catch (requestError) {
            setError(requestError.message || `Unable to ${type} invoice.`);
        } finally{
            setActionKey("");
        }
    }
    async function handlePreview(row) {
        setStatus("");
        setError("");
        setActionKey(`preview-${row.InvoiceGroupKey}`);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/template-preview/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    invoice_keys: [
                        row.InvoiceGroupKey
                    ]
                })
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || "Unable to generate preview.");
            const previewWindow = window.open("", "_blank", "noreferrer");
            if (!previewWindow) throw new Error("Preview window was blocked by the browser.");
            let html = "<html><head><title>Preview</title>";
            html += "</head><body style='padding:24px;font-family:Segoe UI,sans-serif;'>";
            Object.entries(payload.template_html || {}).forEach(([key, value])=>{
                html += `<h3>${key}</h3>${value}<hr/>`;
            });
            html += "</body></html>";
            previewWindow.document.write(html);
            previewWindow.document.close();
        } catch (requestError) {
            setError(requestError.message || "Unable to generate preview.");
        } finally{
            setActionKey("");
        }
    }
    const openEditModal = async (groupKey)=>{
        try {
            setEditLoading(true);
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/get-invoice-details/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    InvoiceGroupKey: groupKey,
                    Tab: "no_data"
                })
            });
            const result = await response.json();
            if (!result.success) {
                alert(result.message || "Unable to fetch invoice details");
                return;
            }
            setEditForm(result.data);
            setVendorVerification({
                status: "",
                message: ""
            });
            setShowEditModal(true);
        } catch (error) {
            console.error(error);
            alert("Error fetching invoice details");
        } finally{
            setEditLoading(false);
        }
    };
    const handleEditChange = (e)=>{
        const { name: name, value: value } = e.target;
        setEditForm((prev)=>({
                ...prev,
                [name]: value
            }));
    };
    const verifyVendorGst = async ()=>{
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/lookup-vendor-by-gst/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    gst_number: editForm.VendorGst
                })
            });
            const result = await response.json();
            if (result.found) {
                setEditForm((prev)=>({
                        ...prev,
                        VendorCode: result.vendor_code,
                        VendorName: result.vendor_name
                    }));
                setVendorVerification({
                    status: "success",
                    message: "Vendor found"
                });
            } else {
                setEditForm((prev)=>({
                        ...prev,
                        VendorCode: "",
                        VendorName: ""
                    }));
                setVendorVerification({
                    status: "error",
                    message: "No vendor found for entered GST number"
                });
            }
        } catch (err) {
            console.error(err);
            setVendorVerification({
                status: "error",
                message: "Vendor verification failed"
            });
        }
    };
    const submitEditedInvoice = async ()=>{
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/submit-nomigo-invoice/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify(editForm)
            });
            const result = await response.json();
            if (result.success) {
                setShowEditModal(false);
                await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                    icon: "success",
                    title: "Success",
                    text: result.message || "Invoice submitted successfully",
                    confirmButtonText: "OK"
                });
            } else {
                setShowEditModal(false);
                (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                    icon: "error",
                    title: "Submission Failed",
                    text: result.message || "Submission failed",
                    confirmButtonText: "OK"
                });
            }
        } catch (error) {
            console.error(error);
            setShowEditModal(false);
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Failed to submit invoice",
                confirmButtonText: "OK"
            });
        }
    };
    function refreshNoMigo() {
        loadRows();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "processor-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel processor-view__hero",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "Processor"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "Not Found In Migo/Duplicate"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "processor-view__hero-actions",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "processor-summary-card",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: summary.count
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "invoices in queue"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "ghost-button processor-view__refresh",
                                type: "button",
                                onClick: refreshNoMigo,
                                children: "Refresh Data"
                            })
                        ]
                    })
                ]
            }),
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "workspace-panel",
                children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: "Loading no-MIGO invoices\u2026"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "config-table processor-table",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Invoice ID"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Vendor Name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Invoice No."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Invoice Date"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Invoice Value"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Reason"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Pending Time"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Response"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "File"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Preview"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Logs"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                            children: [
                                                "Select",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    className: "processor-checkbox",
                                                    type: "checkbox",
                                                    checked: allSelected,
                                                    onChange: toggleAllRows
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Action"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: rows.length ? rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.InvoiceId
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.VendorName || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.InvNo || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.InvDate || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: $9b50169461c34fd1$var$formatAmount(row.TotalAmount)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.message || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: $9b50169461c34fd1$var$getPendingDuration(row.created_at)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "processor-status-list",
                                                    children: Object.entries(row.InvoiceCheck || {}).length ? Object.entries(row.InvoiceCheck || {}).map(([label, item])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: `processor-status-dot processor-status-dot--${item?.color || "o"}`,
                                                            type: "button",
                                                            title: `${label}: ${item?.message || ""}`,
                                                            onClick: ()=>setStatusDetail({
                                                                    label: label,
                                                                    message: item?.message,
                                                                    data: item?.data
                                                                })
                                                        }, `${row.InvoiceGroupKey}-${label}`)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "empty-state",
                                                        children: "No checks"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.unique_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    onClick: ()=>(0, $3d6d578a87c5904f$export$2926f86deb178d44)(`${row.unique_name}.json`),
                                                    children: "Data"
                                                }) : "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.unique_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>(0, $e267546ad9d86d30$export$a38ce99a4bdccd4e)(row.InvoiceId),
                                                    children: "\uD83D\uDCCE"
                                                }) : "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "ghost-button",
                                                    type: "button",
                                                    disabled: actionKey === `preview-${row.InvoiceGroupKey}`,
                                                    onClick: ()=>handlePreview(row),
                                                    children: actionKey === `preview-${row.InvoiceGroupKey}` ? "Previewing..." : "Preview"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "ghost-button",
                                                    type: "button",
                                                    onClick: ()=>handleTrailOpen(row),
                                                    children: "Logs"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    className: "processor-checkbox",
                                                    type: "checkbox",
                                                    checked: selectedRows.includes(row.InvoiceGroupKey),
                                                    onChange: ()=>toggleRowSelection(row.InvoiceGroupKey)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "action-menu-button",
                                                    onClick: (e)=>{
                                                        if (menuPosition?.row?.InvoiceGroupKey === row.InvoiceGroupKey) {
                                                            setMenuPosition(null);
                                                            return;
                                                        }
                                                        const rect = e.currentTarget.getBoundingClientRect();
                                                        setMenuPosition({
                                                            row: row,
                                                            top: rect.bottom + 5,
                                                            left: rect.left
                                                        });
                                                    },
                                                    children: "Actions \u25BC"
                                                })
                                            })
                                        ]
                                    }, row.InvoiceGroupKey)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        colSpan: "14",
                                        children: "No invoices found in the no-MIGO or duplicate queue."
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            showEditModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "nomigo-edit-modal-overlay",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "nomigo-edit-modal",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "nomigo-edit-modal-header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Edit Invoice"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setShowEditModal(false),
                                    children: "\xd7"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "nomigo-edit-modal-section",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Invoice Information"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "nomigo-edit-form-grid",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "nomigo-edit-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Invoice Number"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    name: "InvoiceNo",
                                                    value: editForm.InvoiceNo || "",
                                                    onChange: handleEditChange
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "nomigo-edit-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "PO Number"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    name: "PoNumber",
                                                    value: editForm.PoNumber || "",
                                                    onChange: handleEditChange
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "nomigo-edit-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "GRN Number"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    name: "GrnNumber",
                                                    value: editForm.GrnNumber || "",
                                                    onChange: handleEditChange
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "nomigo-edit-modal-section",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Vendor Verification"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "nomigo-edit-form-grid",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "nomigo-edit-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Vendor GST"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    name: "VendorGst",
                                                    value: editForm.VendorGst || "",
                                                    onChange: handleEditChange
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "nomigo-edit-verify-wrapper",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: "nomigo-edit-verify-btn",
                                                onClick: verifyVendorGst,
                                                children: "Verify Vendor"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "nomigo-edit-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Vendor Code"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    value: editForm.VendorCode || "",
                                                    readOnly: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "nomigo-edit-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Vendor Name"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    value: editForm.VendorName || "",
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "nomigo-edit-footer",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "primary-button",
                                onClick: submitEditedInvoice,
                                children: "Submit Invoice"
                            })
                        })
                    ]
                })
            }),
            menuPosition && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                ref: menuRef,
                className: "global-action-menu",
                style: {
                    position: "fixed",
                    top: menuPosition.top,
                    left: menuPosition.left,
                    zIndex: 999999
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            openEditModal(menuPosition.row.InvoiceGroupKey);
                            setMenuPosition(null);
                        },
                        children: "\u270E Edit"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        disabled: actionKey === `reject-${menuPosition.row.InvoiceGroupKey}`,
                        onClick: ()=>{
                            handleAction(menuPosition.row, "reject");
                            setMenuPosition(null);
                        },
                        children: "\u2715 Reject"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: "danger-item",
                        disabled: actionKey === `delete-${menuPosition.row.InvoiceGroupKey}`,
                        onClick: ()=>{
                            handleAction(menuPosition.row, "delete");
                            setMenuPosition(null);
                        },
                        children: "\uD83D\uDDD1 Delete"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9b50169461c34fd1$var$StatusModal, {
                detail: statusDetail,
                onClose: ()=>setStatusDetail(null)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9b50169461c34fd1$var$TrailModal, {
                trail: trail,
                loading: trailLoading,
                onClose: ()=>setTrail(null)
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

const $4b615bf1a908c567$var$titleMap = {
    templatefile1: "Header Template",
    templatefile2: "Line Item Template"
};
function $4b615bf1a908c567$export$2e2bcd8739ae039({ open: open, onClose: onClose, templateHtml: templateHtml = {}, invoiceNo: invoiceNo = "", materialService: materialService = "" }) {
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onClose();
        };
        window.addEventListener("keydown", handleKeyDown);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    if (!open) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "template-preview-overlay",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "template-preview-modal",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "template-preview-header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Template Preview"
                                }),
                                (invoiceNo || materialService) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        invoiceNo && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Invoice:"
                                                }),
                                                " ",
                                                invoiceNo
                                            ]
                                        }),
                                        invoiceNo && materialService && " | ",
                                        materialService && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Type:"
                                                }),
                                                " ",
                                                materialService.charAt(0).toUpperCase() + materialService.slice(1)
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "template-preview-close",
                            onClick: onClose,
                            children: "\u2715"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "template-preview-body",
                    children: Object.entries(templateHtml).map(([key, value])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: "template-preview-card",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "template-preview-card-header",
                                    children: [
                                        "\uD83D\uDCC4 ",
                                        $4b615bf1a908c567$var$titleMap[key] || key
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "template-preview-table",
                                    dangerouslySetInnerHTML: {
                                        __html: value
                                    }
                                })
                            ]
                        }, key))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "template-preview-footer",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "primary-button",
                        onClick: onClose,
                        children: "Close"
                    })
                })
            ]
        })
    });
}






function $6d74480645c158b0$var$formatAmount(value) {
    if (value === null || value === undefined || value === "") return "-";
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return String(value);
    return new Intl.NumberFormat("en-IN", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    }).format(numericValue);
}
function $6d74480645c158b0$var$formatDate(value) {
    if (!value) return "-";
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return value;
    return parsed.toLocaleDateString();
}
function $6d74480645c158b0$var$getPendingDuration(createdAt) {
    if (!createdAt) return "-";
    const createdTime = new Date(createdAt);
    const now = new Date();
    let diffMs = now - createdTime;
    if (diffMs < 0) diffMs = 0;
    const minutes = Math.floor(diffMs / 60000);
    const hours = Math.floor(diffMs / 3600000);
    const days = Math.floor(diffMs / 86400000);
    if (days > 0) return `${days}d ${hours % 24}h`;
    if (hours > 0) return `${hours}h ${minutes % 60}m`;
    return `${minutes}m`;
}
function $6d74480645c158b0$var$TrailModal({ trail: trail, loading: loading, onClose: onClose }) {
    (0, $acw62.useEffect)(()=>{
        if (!trail && !loading) return;
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        trail,
        loading,
        onClose
    ]);
    if (!trail && !loading) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card processor-modal__card--wide",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "processor-trail-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Audit Log"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "processor-trail-title",
                                    children: "Invoice timeline"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: "Loading audit log\u2026"
                }) : trail?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "processor-timeline",
                    children: trail.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                            className: "processor-timeline__item",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__step",
                                    children: [
                                        "Step ",
                                        entry.step
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__content",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: entry.action
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: entry.message || "No message recorded."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                entry.username || "System",
                                                entry.userrole ? ` (${entry.userrole})` : "",
                                                entry.created_at ? ` \u{2022} ${new Date(entry.created_at).toLocaleString()}` : ""
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, `${entry.step}-${entry.created_at}`))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "empty-state",
                    children: "No timeline available for this invoice."
                })
            ]
        })
    });
}
function $6d74480645c158b0$export$2e2bcd8739ae039() {
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [actionKey, setActionKey] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [selectedRows, setSelectedRows] = (0, $acw62.useState)([]);
    const [statusDetail, setStatusDetail] = (0, $acw62.useState)(null);
    const [statusInvoiceRow, setStatusInvoiceRow] = (0, $acw62.useState)(null);
    const [editTarget, setEditTarget] = (0, $acw62.useState)(null);
    const [trail, setTrail] = (0, $acw62.useState)(null);
    const [trailLoading, setTrailLoading] = (0, $acw62.useState)(false);
    const [menuPosition, setMenuPosition] = (0, $acw62.useState)(null);
    const [previewOpen, setPreviewOpen] = (0, $acw62.useState)(false);
    const [previewHtml, setPreviewHtml] = (0, $acw62.useState)({});
    const [previewInfo, setPreviewInfo] = (0, $acw62.useState)({
        invoiceNo: "",
        materialService: ""
    });
    const [scoringOptions, setScoringOptions] = (0, $acw62.useState)({});
    const allSelected = rows.length > 0 && selectedRows.length === rows.length;
    const summary = (0, $acw62.useMemo)(()=>{
        return {
            count: rows.length,
            selected: selectedRows.length
        };
    }, [
        rows,
        selectedRows
    ]);
    const menuRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!menuPosition) return;
        const handleClickOutside = (event)=>{
            if (menuRef.current && !menuRef.current.contains(event.target)) setMenuPosition(null);
        };
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") setMenuPosition(null);
        };
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        menuPosition
    ]);
    async function loadRows() {
        setLoading(true);
        setError("");
        try {
            const response = await fetch("/api/processor/pending-actions/");
            if (!response.ok) throw new Error("Failed to load invoices.");
            const payload = await response.json();
            setRows(payload.data || []);
            setScoringOptions(payload.scoringOptions || {});
        } catch (requestError) {
            setError(requestError.message || "Unable to load pending actions.");
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadRows();
    }, []);
    function toggleRowSelection(invoiceGroupKey) {
        setSelectedRows((current)=>current.includes(invoiceGroupKey) ? current.filter((item)=>item !== invoiceGroupKey) : [
                ...current,
                invoiceGroupKey
            ]);
    }
    function toggleAllRows() {
        setSelectedRows((current)=>current.length === rows.length ? [] : rows.map((row)=>row.invoiceGroupKey));
    }
    async function handleTrailOpen(row) {
        setTrail(null);
        setTrailLoading(true);
        try {
            const response = await fetch(`/api/invoice/trail/${row.invoiceId}/`, {
                credentials: "include"
            });
            const payload = await response.json();
            if (!response.ok || !payload.success) throw new Error(payload.message || "Unable to load trail.");
            setTrail(payload.data || []);
        } catch (requestError) {
            setTrail([]);
            setError(requestError.message || "Unable to load trail.");
        } finally{
            setTrailLoading(false);
        }
    }
    async function handlePreview(row) {
        setStatus("");
        setError("");
        setActionKey(`preview-${row.invoiceGroupKey}`);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/template-preview/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    invoice_keys: [
                        row.invoiceGroupKey
                    ],
                    material_service: row.material_service
                })
            });
            const payload = await response.json();
            if (!response.ok || payload?.status !== "success") throw new Error(payload?.message || "Unable to generate preview.");
            // -----------------------------------------
            // Blocked Invoice
            // -----------------------------------------
            if (payload.blocked_invoice) {
                await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                    icon: "error",
                    title: "Invoice Falls in Blocked Period",
                    html: `
            <p>
              This invoice falls in a blocked posting period.
            </p>

            <p>
              <strong>Posting Date:</strong>
              ${payload.postingdate || "-"}
            </p>
          `,
                    confirmButtonText: "OK"
                });
                return;
            }
            // -----------------------------------------
            // Mandatory Column Warning
            // -----------------------------------------
            if (payload.has_missing_mandatory) {
                const result = await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                    icon: "warning",
                    title: "Mandatory Fields Missing",
                    html: `
            <p>
              The following mandatory columns do not have any value
              against the mapped source.
            </p>

            <div style="text-align:left;">
              <ul>
                ${(payload.missing_mandatory_columns || []).map((column)=>`<li>${column}</li>`).join("")}
              </ul>
            </div>

            <p>
              Do you still want to preview the template with blank
              values for these mandatory columns?
            </p>
          `,
                    showCancelButton: true,
                    confirmButtonText: "Yes, Show Preview",
                    cancelButtonText: "Cancel",
                    focusCancel: true
                });
                if (!result.isConfirmed) return;
            }
            // -----------------------------------------
            // Open Preview Modal
            // -----------------------------------------
            setPreviewHtml(payload.template_html || {});
            setPreviewInfo({
                invoiceNo: row.InvoiceId || row.InvoiceNo || row.invoice_number || "",
                materialService: row.material_service || ""
            });
            setPreviewOpen(true);
        } catch (requestError) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Preview Failed",
                text: requestError.message || "Unable to generate preview.",
                confirmButtonText: "OK"
            });
            setError(requestError.message || "Unable to generate preview.");
        } finally{
            setActionKey("");
        }
    }
    async function handleAction(row, type) {
        setStatus("");
        setError("");
        if (type === "approve" && Object.values(row.invoiceCheck || {}).some((item)=>item?.color === "r")) {
            setError("There are discrepancies in this invoice. Fix them before approving.");
            return;
        }
        setActionKey(`${type}-${row.invoiceGroupKey}`);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            let url = "";
            let body = {};
            if (type === "approve") {
                url = "/api/approve-invoice/";
                body = {
                    invoice_group_key: row.invoiceGroupKey,
                    tab: 'Processor'
                };
            } else if (type === "hold") {
                url = "/api/hold-invoice/";
                body = {
                    invoice_group_key: row.invoiceGroupKey,
                    tab: 'Processor'
                };
            } else if (type === "reject") {
                url = "/api/reject-invoice/";
                body = {
                    invoice_group_key: row.invoiceGroupKey,
                    tab: 'Processor'
                };
            } else if (type === "delete") {
                url = "/api/delete-invoice/";
                body = {
                    invoice_group_key: row.invoiceGroupKey,
                    tab: "pendingtab"
                };
            }
            const response = await fetch(url, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify(body)
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || `Unable to ${type} invoice.`);
            setStatus(payload.message || `Invoice ${type}d successfully.`);
            setSelectedRows((current)=>current.filter((item)=>item !== row.invoiceGroupKey));
            await loadRows();
        } catch (requestError) {
            setError(requestError.message || `Unable to ${type} invoice.`);
        } finally{
            setActionKey("");
        }
    }
    function refreshPendingActions() {
        loadRows();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $be4094fc57a496e8$export$2e2bcd8739ae039), {
        title: "Pending Actions",
        intro: "Review invoices, inspect status checks, and take action from the dashboard.",
        metrics: [
            {
                label: "Queue",
                value: summary.count
            },
            {
                label: "Selected",
                value: summary.selected
            },
            {
                label: "Red Flags",
                value: summary.redFlags
            }
        ],
        actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            className: "ghost-button processor-view__refresh",
            type: "button",
            onClick: refreshPendingActions,
            children: "Refresh Pending Actions"
        }),
        children: [
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "workspace-panel processor-table-panel",
                children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: "Loading pending actions\u2026"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "config-table processor-table",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Invoice ID"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Vendor Name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Invoice No."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Invoice Date"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Invoice Value"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Response"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "File"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Preview"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Age"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                            children: [
                                                "Select",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    className: "processor-checkbox",
                                                    type: "checkbox",
                                                    checked: allSelected,
                                                    onChange: toggleAllRows
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Logs"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Action"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: rows.length ? rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.invoiceId
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.vendorName || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.invoiceNo || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: $6d74480645c158b0$var$formatDate(row.invoiceDate)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: $6d74480645c158b0$var$formatAmount(row.invoiceValue)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "processor-status-list",
                                                    children: Object.entries(row.invoiceCheck || {}).length ? Object.entries(row.invoiceCheck || {}).map(([label, item])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: `processor-status-dot processor-status-dot--${item?.color || "o"}`,
                                                            type: "button",
                                                            title: `${label}: ${item?.message || ""}`,
                                                            onClick: ()=>{
                                                                setStatusInvoiceRow(row);
                                                                setStatusDetail({
                                                                    label: label,
                                                                    message: item?.message,
                                                                    data: item?.data,
                                                                    key: item?.key || label,
                                                                    checkKey: label,
                                                                    uniqueKey: row.invoiceGroupKey,
                                                                    color: item?.color || "o"
                                                                });
                                                            }
                                                        }, `${row.invoiceGroupKey}-${label}`)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "empty-state",
                                                        children: "No checks"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.uniqueName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    onClick: ()=>(0, $3d6d578a87c5904f$export$2926f86deb178d44)(`${row.uniqueName}.json`),
                                                    children: "Data"
                                                }) : "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.uniqueName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>(0, $e267546ad9d86d30$export$a38ce99a4bdccd4e)(row.invoiceId),
                                                    children: "\uD83D\uDCCE"
                                                }) : "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "ghost-button",
                                                    type: "button",
                                                    disabled: actionKey === `preview-${row.InvoiceGroupKey}`,
                                                    onClick: ()=>handlePreview(row),
                                                    children: actionKey === `preview-${row.InvoiceGroupKey}` ? "Previewing..." : "Preview"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: $6d74480645c158b0$var$getPendingDuration(row.createdAt)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    className: "processor-checkbox",
                                                    type: "checkbox",
                                                    checked: selectedRows.includes(row.invoiceGroupKey),
                                                    onChange: ()=>toggleRowSelection(row.invoiceGroupKey)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "ghost-button",
                                                    type: "button",
                                                    onClick: ()=>handleTrailOpen(row),
                                                    children: "Logs"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "action-dropdown-wrapper",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        className: "action-menu-button",
                                                        onClick: (e)=>{
                                                            if (menuPosition?.row?.invoiceGroupKey === row.invoiceGroupKey) {
                                                                setMenuPosition(null);
                                                                return;
                                                            }
                                                            const rect = e.currentTarget.getBoundingClientRect();
                                                            setMenuPosition({
                                                                row: row,
                                                                top: rect.bottom + window.scrollY,
                                                                left: rect.left + window.scrollX
                                                            });
                                                        },
                                                        children: "Actions \u25BC"
                                                    })
                                                })
                                            })
                                        ]
                                    }, row.invoiceGroupKey)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        colSpan: "12",
                                        children: "No pending processor actions found."
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            menuPosition && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                ref: menuRef,
                className: "global-action-menu",
                style: {
                    position: "fixed",
                    top: menuPosition.top,
                    left: menuPosition.left,
                    zIndex: 999999
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            handleAction(menuPosition.row, "approve");
                            setMenuPosition(null);
                        },
                        children: "\u2713 Approve"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            handleAction(menuPosition.row, "hold");
                            setMenuPosition(null);
                        },
                        children: "\u23F8 Hold"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            handleAction(menuPosition.row, "reject");
                            setMenuPosition(null);
                        },
                        children: "\u2715 Reject"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            setEditTarget({
                                invoiceGroupKey: menuPosition.row.invoiceGroupKey
                            });
                            setMenuPosition(null);
                        },
                        children: "\u270E Edit"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: "danger-item",
                        onClick: ()=>{
                            handleAction(menuPosition.row, "delete");
                            setMenuPosition(null);
                        },
                        children: "\uD83D\uDDD1 Delete"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90a432d2bdd32db5$export$2e2bcd8739ae039), {
                detail: statusDetail,
                invoiceRow: statusInvoiceRow,
                scoringOptions: scoringOptions,
                onClose: ()=>{
                    setStatusDetail(null);
                    setStatusInvoiceRow(null);
                },
                onSaved: loadRows
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c5c59f6c0eb6d77$export$2e2bcd8739ae039), {
                invoiceGroupKey: editTarget?.invoiceGroupKey,
                onClose: ()=>setEditTarget(null),
                onSaved: loadRows
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b615bf1a908c567$export$2e2bcd8739ae039), {
                open: previewOpen,
                onClose: ()=>setPreviewOpen(false),
                templateHtml: previewHtml,
                invoiceNo: previewInfo.invoiceNo,
                materialService: previewInfo.materialService
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6d74480645c158b0$var$TrailModal, {
                trail: trail,
                loading: trailLoading,
                onClose: ()=>setTrail(null)
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");






function $a4c852e9044aa2ea$var$formatAmount(value) {
    if (value === null || value === undefined || value === "") return "-";
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return String(value);
    return new Intl.NumberFormat("en-IN", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    }).format(numericValue);
}
function $a4c852e9044aa2ea$var$isAccountBlocked(row) {
    const isBlocked = (value)=>{
        const indicator = String(value || "").trim();
        return indicator !== "" && indicator !== "N";
    };
    // return isBlocked(row.account_indicator) || isBlocked(row.payment_indicator);
    return isBlocked(row.account_indicator);
}
function $a4c852e9044aa2ea$var$buildGenerateSuccessMessage(payload) {
    const blocked = payload?.blocked_entries || [];
    const skipped = payload?.skipped_entries || [];
    if (!blocked.length && !skipped.length) return "Templates generated successfully.";
    let message = "";
    if (blocked.length) message += "Posting Date belongs to period which is closed as per configuration.\n\n" + `Blocked Invoice IDs: ${blocked.join(", ")}\n\n`;
    if (skipped.length) {
        const skippedList = skipped.map((item)=>`Invoice ${item.InvoiceId} -> ${item.reason}`).join("\n");
        message += "Some invoices were skipped due to missing mandatory mapped fields.\n\n" + `${skippedList}\n\n`;
    }
    message += "Templates generated successfully for remaining entries.";
    return message;
}
function $a4c852e9044aa2ea$var$StatusModal({ detail: detail, onClose: onClose }) {
    if (!detail) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "ready-status-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Status Detail"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "ready-status-title",
                                    children: detail.label
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: detail.message || "No additional message available."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                    className: "processor-modal__code",
                    children: JSON.stringify(detail.data ?? {}, null, 2)
                })
            ]
        })
    });
}
function $a4c852e9044aa2ea$var$TrailModal({ trail: trail, loading: loading, onClose: onClose }) {
    (0, $acw62.useEffect)(()=>{
        if (!trail && !loading) return;
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        trail,
        loading,
        onClose
    ]);
    if (!trail && !loading) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "processor-modal",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "processor-modal__card processor-modal__card--wide",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "processor-trail-title",
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "processor-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Audit Log"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "processor-trail-title",
                                    children: "Invoice timeline"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "ghost-button",
                            type: "button",
                            onClick: onClose,
                            children: "Close"
                        })
                    ]
                }),
                loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: "Loading audit log\u2026"
                }) : trail?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "processor-timeline",
                    children: trail.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                            className: "processor-timeline__item",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__step",
                                    children: [
                                        "Step ",
                                        entry.step
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "processor-timeline__content",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: entry.action
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: entry.message || "No message recorded."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                entry.username || "System",
                                                entry.userrole ? ` (${entry.userrole})` : "",
                                                entry.created_at ? ` \u{2022} ${new Date(entry.created_at).toLocaleString()}` : ""
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, `${entry.step}-${entry.created_at}`))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "empty-state",
                    children: "No timeline available for this invoice."
                })
            ]
        })
    });
}
function $a4c852e9044aa2ea$export$2e2bcd8739ae039() {
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [actionKey, setActionKey] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [selectedRows, setSelectedRows] = (0, $acw62.useState)([]);
    const [filter, setFilter] = (0, $acw62.useState)("all");
    const [statusDetail, setStatusDetail] = (0, $acw62.useState)(null);
    const [trail, setTrail] = (0, $acw62.useState)(null);
    const [trailLoading, setTrailLoading] = (0, $acw62.useState)(false);
    const [menuPosition, setMenuPosition] = (0, $acw62.useState)(null);
    const filteredRows = (0, $acw62.useMemo)(()=>{
        if (filter === "account_block_only") return rows.filter((row)=>$a4c852e9044aa2ea$var$isAccountBlocked(row));
        if (filter === "all_minus_account_block") return rows.filter((row)=>!$a4c852e9044aa2ea$var$isAccountBlocked(row));
        return rows;
    }, [
        filter,
        rows
    ]);
    const allVisibleSelected = filteredRows.length > 0 && filteredRows.every((row)=>selectedRows.includes(row.InvoiceGroupKey));
    const summary = (0, $acw62.useMemo)(()=>({
            count: rows.length,
            visible: filteredRows.length,
            blocked: rows.filter((row)=>$a4c852e9044aa2ea$var$isAccountBlocked(row)).length,
            selected: selectedRows.length
        }), [
        filteredRows,
        rows,
        selectedRows
    ]);
    const menuRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!menuPosition) return;
        const handleClickOutside = (event)=>{
            if (menuRef.current && !menuRef.current.contains(event.target)) setMenuPosition(null);
        };
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") setMenuPosition(null);
        };
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        menuPosition
    ]);
    async function loadRows() {
        setLoading(true);
        setError("");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/get-ready/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                }
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok || payload?.error) throw new Error(payload?.message || payload?.error || `Unable to load ready invoices. Backend responded with ${response.status}.`);
            if (!payload) throw new Error("Unable to load ready invoices. Backend returned a non-JSON response.");
            setRows(payload.data || []);
        } catch (requestError) {
            setError(requestError.message || "Unable to load ready invoices.");
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadRows();
    }, []);
    function toggleRowSelection(invoiceGroupKey) {
        setSelectedRows((current)=>current.includes(invoiceGroupKey) ? current.filter((item)=>item !== invoiceGroupKey) : [
                ...current,
                invoiceGroupKey
            ]);
    }
    function toggleAllVisibleRows() {
        const visibleKeys = filteredRows.map((row)=>row.InvoiceGroupKey);
        setSelectedRows((current)=>{
            if (allVisibleSelected) return current.filter((item)=>!visibleKeys.includes(item));
            return Array.from(new Set([
                ...current,
                ...visibleKeys
            ]));
        });
    }
    async function handleTrailOpen(row) {
        setTrail(null);
        setTrailLoading(true);
        try {
            const response = await fetch(`/api/invoice/trail/${row.InvoiceId}/`, {
                credentials: "include"
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok || !payload?.success) throw new Error(payload?.message || "Unable to load trail.");
            setTrail(payload.data || []);
        } catch (requestError) {
            setTrail([]);
            setError(requestError.message || "Unable to load trail.");
        } finally{
            setTrailLoading(false);
        }
    }
    async function handlePreview(row) {
        setStatus("");
        setError("");
        setActionKey(`preview-${row.invoiceGroupKey}`);
        // Open immediately from user click
        const previewWindow = window.open("", "_blank");
        if (!previewWindow) {
            setError("Preview window was blocked by the browser.");
            return;
        }
        previewWindow.document.write("<html><body><h3>Loading preview...</h3></body></html>");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/template-preview/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    invoice_keys: [
                        row.InvoiceGroupKey
                    ],
                    material_service: row.material_service
                })
            });
            const payload = await response.json();
            if (!response.ok || payload?.status !== "success") throw new Error(payload?.message || "Unable to generate preview.");
            let html = "<html><head><title>Preview</title></head><body style='padding:24px;font-family:Segoe UI,sans-serif;'>";
            Object.entries(payload.template_html || {}).forEach(([key, value])=>{
                html += `<h3>${key}</h3>${value}<hr/>`;
            });
            html += "</body></html>";
            previewWindow.document.open();
            previewWindow.document.write(html);
            previewWindow.document.close();
        } catch (requestError) {
            previewWindow.close();
            setError(requestError.message || "Unable to generate preview.");
        } finally{
            setActionKey("");
        }
    }
    async function handleGenerateTemplates() {
        setStatus("");
        setError("");
        const selectedItems = rows.filter((row)=>selectedRows.includes(row.InvoiceGroupKey));
        const selectedKeys = selectedItems.filter((row)=>!$a4c852e9044aa2ea$var$isAccountBlocked(row)).map((row)=>row.InvoiceGroupKey);
        const blockedKeys = selectedItems.filter((row)=>$a4c852e9044aa2ea$var$isAccountBlocked(row)).map((row)=>row.InvoiceGroupKey);
        if (!selectedKeys.length && !blockedKeys.length) {
            setError("Please select at least one invoice to generate template.");
            return;
        }
        let finalKeysToSend = [
            ...selectedKeys
        ];
        if (blockedKeys.length) {
            const confirmProcess = window.confirm("Some selected invoices have Account Block applied.\n\nOK -> Process all invoices\nCancel -> Skip blocked invoices");
            if (confirmProcess) {
                const finalConfirm = window.confirm("Are you sure you want to generate the template for\nselected Account Block invoices?");
                if (!finalConfirm) return;
                finalKeysToSend = selectedKeys.concat(blockedKeys);
            }
        }
        if (!finalKeysToSend.length) {
            setError("No invoices available to process after filtering.");
            return;
        }
        setActionKey("generate");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/template-generate/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    invoice_keys: finalKeysToSend
                })
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (payload?.skipped_invoices?.length || payload?.blocked_entries?.length) {
                let html = "";
                if (payload.skipped_invoices?.length) {
                    html += "<b>Skipped Invoices</b><br><ul>";
                    payload.skipped_invoices.forEach((item)=>{
                        html += `<li><b>${item.InvoiceId}</b> - ${item.reason}</li>`;
                    });
                    html += "</ul>";
                }
                if (payload.blocked_entries?.length) {
                    html += "<br><b>Blocked Invoices</b><br><ul>";
                    payload.blocked_entries.forEach((item)=>{
                        html += `<li><b>${item.InvoiceId}</b> - ${item.reason}</li>`;
                    });
                    html += "</ul>";
                }
                await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                    icon: "warning",
                    title: "Some invoices could not be generated",
                    html: html,
                    width: 700
                });
            }
            setStatus($a4c852e9044aa2ea$var$buildGenerateSuccessMessage(payload));
            setSelectedRows([]);
            await loadRows();
        } catch (requestError) {
            setError(requestError.message || "Error sending data to backend.");
        } finally{
            setActionKey("");
        }
    }
    async function handleAction(row, type) {
        setStatus("");
        setError("");
        if (type === "approve" && Object.values(row.invoiceCheck || {}).some((item)=>item?.color === "r")) {
            setError("There are discrepancies in this invoice. Fix them before approving.");
            return;
        }
        setActionKey(`${type}-${row.invoiceGroupKey}`);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            let url = "";
            let body = {};
            if (type === "approve") {
                url = "/api/approve-invoice/";
                body = {
                    invoice_group_key: row.invoiceGroupKey,
                    tab: 'Processor'
                };
            } else if (type === "hold") {
                url = "/api/hold-invoice/";
                body = {
                    invoice_group_key: row.invoiceGroupKey,
                    tab: 'Processor'
                };
            } else if (type === "reject") {
                url = "/api/reject-invoice/";
                body = {
                    invoice_group_key: row.invoiceGroupKey,
                    tab: 'Processor'
                };
            } else if (type === "delete") {
                url = "/api/delete-invoice/";
                body = {
                    invoice_group_key: row.invoiceGroupKey,
                    tab: "pendingtab"
                };
            }
            const response = await fetch(url, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify(body)
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || `Unable to ${type} invoice.`);
            setStatus(payload.message || `Invoice ${type}d successfully.`);
            setSelectedRows((current)=>current.filter((item)=>item !== row.invoiceGroupKey));
            await loadRows();
        } catch (requestError) {
            setError(requestError.message || `Unable to ${type} invoice.`);
        } finally{
            setActionKey("");
        }
    }
    function refreshPageItems() {
        loadRows();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $be4094fc57a496e8$export$2e2bcd8739ae039), {
        title: "Ready To Generate Template",
        intro: "",
        metrics: [
            {
                label: "Queue",
                value: summary.count
            }
        ],
        actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            className: "ghost-button processor-view__refresh",
            type: "button",
            onClick: refreshPageItems,
            children: "Refresh"
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "processor-view",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "workspace-panel",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "processor-table__header",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-inline",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "config-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            htmlFor: "ready-filter",
                                            children: "Invoice Filter"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            id: "ready-filter",
                                            value: filter,
                                            onChange: (event)=>setFilter(event.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "all",
                                                    children: "All"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "account_block_only",
                                                    children: "Account Block Only"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "all_minus_account_block",
                                                    children: "Other Then Account Block"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "config-note",
                            children: "Loading ready invoices\u2026"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "config-table processor-table",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: "Invoice ID"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: "Vendor Name"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: "Invoice No."
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: "Invoice Date"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: "Invoice Value"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: "Invoice Status"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: "Response"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: "File"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: "Preview"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: "Logs"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                            children: [
                                                                "Select",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    className: "processor-checkbox",
                                                                    type: "checkbox",
                                                                    checked: allVisibleSelected,
                                                                    onChange: toggleAllVisibleRows
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: "Action"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                children: filteredRows.length ? filteredRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: row.InvoiceId
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: row.VendorName || "-"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: row.InvoiceNo || row.InvNo || "-"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: row.InvoiceDate || row.InvDate || "-"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: $a4c852e9044aa2ea$var$formatAmount(row.InvoiceValue || row.TotalAmount)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "processor-status-list",
                                                                    children: Object.entries(row.InvoiceGroupKey || {}).length ? Object.entries(row.InvoiceCheck || {}).map(([label, item])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            className: `processor-status-dot processor-status-dot--${item?.color || "o"}`,
                                                                            type: "button",
                                                                            title: `${label}: ${item?.message || ""}`,
                                                                            onClick: ()=>setStatusDetail({
                                                                                    label: label,
                                                                                    message: item?.message,
                                                                                    data: item?.data,
                                                                                    key: item?.key || label,
                                                                                    checkKey: label,
                                                                                    uniqueKey: row.InvoiceGroupKey,
                                                                                    color: item?.color || "o"
                                                                                })
                                                                        }, `${row.InvoiceGroupKey}-${label}`)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "empty-state",
                                                                        children: "No checks"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: row.unique_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    onClick: ()=>(0, $3d6d578a87c5904f$export$2926f86deb178d44)(`${row.unique_name}.json`),
                                                                    children: "Data"
                                                                }) : "-"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: row.InvoiceId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    type: "button",
                                                                    onClick: ()=>(0, $e267546ad9d86d30$export$a38ce99a4bdccd4e)(row.InvoiceId),
                                                                    children: "\uD83D\uDCCE"
                                                                }) : "-"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    className: "ghost-button",
                                                                    type: "button",
                                                                    disabled: actionKey === `preview-${row.InvoiceGroupKey}`,
                                                                    onClick: ()=>handlePreview(row),
                                                                    children: actionKey === `preview-${row.InvoiceGroupKey}` ? "Previewing..." : "Preview"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    className: "ghost-button",
                                                                    type: "button",
                                                                    onClick: ()=>handleTrailOpen(row),
                                                                    children: "Logs"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    className: "processor-checkbox",
                                                                    type: "checkbox",
                                                                    checked: selectedRows.includes(row.InvoiceGroupKey),
                                                                    onChange: ()=>toggleRowSelection(row.InvoiceGroupKey)
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "action-dropdown-wrapper",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        type: "button",
                                                                        className: "action-menu-button",
                                                                        onClick: (e)=>{
                                                                            if (menuPosition?.row?.InvoiceGroupKey === row.InvoiceGroupKey) {
                                                                                setMenuPosition(null);
                                                                                return;
                                                                            }
                                                                            const rect = e.currentTarget.getBoundingClientRect();
                                                                            setMenuPosition({
                                                                                row: row,
                                                                                top: rect.bottom + window.scrollY,
                                                                                left: rect.left + window.scrollX
                                                                            });
                                                                        },
                                                                        children: "Actions \u25BC"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }, row.InvoiceGroupKey)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        colSpan: "11",
                                                        children: "No invoices found in the ready queue for the selected filter."
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        marginTop: "16px",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        gap: "12px",
                                        alignItems: "center",
                                        flexWrap: "wrap"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "config-note",
                                            style: {
                                                margin: 0
                                            },
                                            children: [
                                                summary.selected,
                                                " invoice",
                                                summary.selected === 1 ? "" : "s",
                                                " selected for template generation."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "primary-button",
                                            type: "button",
                                            disabled: actionKey === "generate",
                                            onClick: handleGenerateTemplates,
                                            children: actionKey === "generate" ? "Generating..." : "Generate Template"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                menuPosition && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    ref: menuRef,
                    className: "global-action-menu",
                    style: {
                        position: "fixed",
                        top: menuPosition.top,
                        left: menuPosition.left,
                        zIndex: 999999
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            handleAction(menuPosition.row, "hold");
                            setMenuPosition(null);
                        },
                        children: "\u23F8 Hold"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90a432d2bdd32db5$export$2e2bcd8739ae039), {
                    detail: statusDetail,
                    onClose: ()=>setStatusDetail(null),
                    onSaved: loadRows
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a4c852e9044aa2ea$var$TrailModal, {
                    trail: trail,
                    loading: trailLoading,
                    onClose: ()=>setTrail(null)
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");


function $02f53f124c46dca8$var$buildVendorUploadSummary(payload) {
    const processedRows = payload?.processed_rows || 0;
    const duplicateVendorCodes = payload?.duplicate_vendor_codes || [];
    const duplicateGSTMappings = payload?.duplicate_gst_vendor_mapping || [];
    const hasWarnings = duplicateVendorCodes.length > 0 || duplicateGSTMappings.length > 0;
    let html = `
    <div style="text-align:left">

      <p style="margin-bottom:16px;font-size:15px;">
        <strong>Processed Records:</strong>
        ${processedRows}
      </p>
  `;
    // -------------------------------------------------
    // Duplicate Vendor Codes
    // -------------------------------------------------
    if (duplicateVendorCodes.length) {
        html += `
      <h4 style="margin-bottom:8px;color:#b45309;">
        Duplicate Vendor Codes
      </h4>

      <table style="
        width:100%;
        border-collapse:collapse;
        margin-bottom:20px;
      ">

        <thead>

          <tr style="background:#f7f7f7">

            <th style="border:1px solid #ddd;padding:8px;">
              Vendor Code
            </th>

            <th style="border:1px solid #ddd;padding:8px;">
              Occurrences
            </th>

          </tr>

        </thead>

        <tbody>
    `;
        duplicateVendorCodes.slice(0, 20).forEach((item)=>{
            html += `
          <tr>

            <td style="border:1px solid #ddd;padding:8px;">
              ${item.VendorCode}
            </td>

            <td style="
                border:1px solid #ddd;
                padding:8px;
                text-align:center;
            ">
              ${item.Count}
            </td>

          </tr>
        `;
        });
        if (duplicateVendorCodes.length > 20) html += `
        <tr>

          <td colspan="2"
              style="padding:8px;text-align:center;font-style:italic;">

            ...and ${duplicateVendorCodes.length - 20} more

          </td>

        </tr>
      `;
        html += `
        </tbody>

      </table>
    `;
    }
    // -------------------------------------------------
    // GST Linked to Multiple Vendor Codes
    // -------------------------------------------------
    if (duplicateGSTMappings.length) {
        html += `
      <h4 style="margin-bottom:8px;color:#b45309;">
        GST Linked to Multiple Vendor Codes
      </h4>

      <table style="
        width:100%;
        border-collapse:collapse;
      ">

        <thead>

          <tr style="background:#f7f7f7">

            <th style="border:1px solid #ddd;padding:8px;">
              GST Number
            </th>

            <th style="border:1px solid #ddd;padding:8px;">
              Vendor Codes
            </th>

          </tr>

        </thead>

        <tbody>
    `;
        duplicateGSTMappings.slice(0, 20).forEach((item)=>{
            html += `
          <tr>

            <td style="border:1px solid #ddd;padding:8px;">
              ${item.GSTNo}
            </td>

            <td style="border:1px solid #ddd;padding:8px;">
              ${item.VendorCodes.join(", ")}
            </td>

          </tr>
        `;
        });
        if (duplicateGSTMappings.length > 20) html += `
        <tr>

          <td colspan="2"
              style="padding:8px;text-align:center;font-style:italic;">

            ...and ${duplicateGSTMappings.length - 20} more

          </td>

        </tr>
      `;
        html += `
        </tbody>

      </table>
    `;
    }
    html += "</div>";
    return {
        html: html,
        hasWarnings: hasWarnings
    };
}
async function $02f53f124c46dca8$export$b2786197665b639d(payload) {
    const { html: html, hasWarnings: hasWarnings } = $02f53f124c46dca8$var$buildVendorUploadSummary(payload);
    await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
        icon: hasWarnings ? "warning" : "success",
        title: "Vendor Master Upload Summary",
        html: html,
        width: "850px",
        confirmButtonText: "OK"
    });
}



const $b11c65d7ae8f97eb$var$dataTypeOptions = [
    {
        value: "migo",
        label: "MIGO"
    },
    {
        value: "po",
        label: "Purchase Order (PO)"
    },
    {
        value: "vendormaster",
        label: "Vendor Master"
    },
    {
        value: "withholdtaxmaster",
        label: "WithHold Tax Master"
    },
    {
        value: "gsttaxmaster",
        label: "GST Tax Master"
    },
    {
        value: "hsnmaster",
        label: "HSN Master"
    },
    {
        value: "sacmaster",
        label: "SAC Master"
    },
    {
        value: "einvoice",
        label: "E Invoice Register"
    }
];
function $b11c65d7ae8f97eb$var$formatCellValue(value) {
    if (value === null || value === undefined || value === "") return "-";
    if (typeof value === "object") return JSON.stringify(value);
    return String(value);
}
function $b11c65d7ae8f97eb$export$2e2bcd8739ae039() {
    const [dataType, setDataType] = (0, $acw62.useState)("");
    const [file, setFile] = (0, $acw62.useState)(null);
    const [tableRows, setTableRows] = (0, $acw62.useState)([]);
    const [tooltips, setTooltips] = (0, $acw62.useState)({});
    const [loadingTable, setLoadingTable] = (0, $acw62.useState)(false);
    const [submitting, setSubmitting] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [missingData, setMissingData] = (0, $acw62.useState)([]);
    const [vendorSearch, setVendorSearch] = (0, $acw62.useState)("");
    const [vendorSuggestions, setVendorSuggestions] = (0, $acw62.useState)([]);
    const [selectedVendor, setSelectedVendor] = (0, $acw62.useState)(null);
    const [showVendorModal, setShowVendorModal] = (0, $acw62.useState)(false);
    console.log("MODAL STATE:", {
        showVendorModal: showVendorModal,
        selectedVendor: selectedVendor
    });
    const headers = (0, $acw62.useMemo)(()=>{
        if (!tableRows.length) return [];
        return Object.keys(tableRows[0]);
    }, [
        tableRows
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!showVendorModal) return;
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") {
                setShowVendorModal(false);
                setSelectedVendor(null);
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        showVendorModal
    ]);
    async function handleVendorSelect(vendorCode) {
        try {
            console.log("1. Selected vendor code:", vendorCode);
            const response = await fetch(`/api/vendor-master/details/?vendor_code=${encodeURIComponent(vendorCode)}`, {
                credentials: "include"
            });
            console.log("2. Response status:", response.status);
            const payload = await response.json();
            console.log("3. Vendor payload:", payload);
            if (!response.ok || payload.status === "error") throw new Error(payload.message || "Unable to load vendor.");
            console.log("4. Setting vendor:", payload.vendor);
            setSelectedVendor(payload.vendor);
            setVendorSearch(`${payload.vendor.VendorCode} - ${payload.vendor.VendorName}`);
            setVendorSuggestions([]);
            console.log("5. Opening modal");
            setShowVendorModal(true);
        } catch (error) {
            console.error("Vendor select error:", error);
            alert(error.message);
        }
    }
    // async function handleVendorSelect(vendorCode) {
    //   try {
    //     const response = await fetch(
    //       `/api/vendor-master/details/?vendor_code=${encodeURIComponent(vendorCode)}`,
    //       {
    //         credentials: "include",
    //       }
    //     );
    //     const payload = await response.json();
    //     if (!response.ok || payload.status === "error") {
    //       throw new Error(
    //         payload.message || "Unable to load vendor."
    //       );
    //     }
    //     setSelectedVendor(payload.vendor);
    //     setVendorSearch(
    //       `${payload.vendor.VendorCode} - ${payload.vendor.VendorName}`
    //     );
    //     setVendorSuggestions([]);
    //     setShowVendorModal(true);
    //   } catch (error) {
    //     alert(error.message);
    //   }
    // }
    async function handleVendorSearch(value) {
        setVendorSearch(value);
        if (!value.trim()) {
            setVendorSuggestions([]);
            return;
        }
        try {
            const response = await fetch(`/api/vendor-master/search/?q=${encodeURIComponent(value)}`, {
                credentials: "include"
            });
            const payload = await response.json();
            setVendorSuggestions(payload.vendors || []);
        } catch (error) {
            console.error("Vendor search failed:", error);
            setVendorSuggestions([]);
        }
    }
    async function handleVendorSave() {
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/vendor-master/update/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    VendorCode: selectedVendor.VendorCode,
                    VendorName: selectedVendor.VendorName,
                    GSTNo: selectedVendor.GSTNo,
                    LDCNo: selectedVendor.LDCNo,
                    LDCThreshold: selectedVendor.LDCThreshold,
                    LDCStartDate: selectedVendor.LDCStartDate,
                    LDCEndDate: selectedVendor.LDCEndDate,
                    LDCWTCode: selectedVendor.LDCWTCode,
                    BlockedYN: selectedVendor.BlockedYN,
                    MSMERegisteredYN: selectedVendor.MSMERegisteredYN,
                    MSMENumber: selectedVendor.MSMENumber
                })
            });
            const payload = await response.json();
            if (!response.ok || payload.status === "error") throw new Error(payload.message || "Unable to update vendor.");
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Vendor Updated",
                text: payload.message || "Vendor updated successfully.",
                confirmButtonText: "OK"
            });
            setShowVendorModal(false);
            setSelectedVendor(null);
            await loadSystemData("vendormaster");
        } catch (error) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Update Failed",
                text: error.message || "Failed to update vendor.",
                confirmButtonText: "OK"
            });
        }
    }
    async function refreshMissingSystemData() {
        try {
            const response = await fetch("/api/missingsytem-data/", {
                credentials: "include"
            });
            const payload = await response.json();
            if (!response.ok || payload.success === false) return;
            setMissingData(Array.isArray(payload.missing) ? payload.missing : []);
        } catch (requestError) {
            setMissingData([]);
        }
    }
    async function loadSystemData(type, { clearMessages: clearMessages = true } = {}) {
        if (!type) {
            setTableRows([]);
            setTooltips({});
            return;
        }
        setLoadingTable(true);
        setError("");
        if (clearMessages) setStatus("");
        try {
            const response = await fetch(`/api/fetch-data/?type=${encodeURIComponent(type)}`, {
                credentials: "include"
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok || payload?.error) throw new Error(payload?.error || `Unable to load ${type} data.`);
            setTableRows(payload?.data || []);
            setTooltips(payload?.tooltips || {});
        } catch (requestError) {
            setTableRows([]);
            setTooltips({});
            setError(requestError.message || "Unable to load system data.");
        } finally{
            setLoadingTable(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        if (!dataType) {
            setTableRows([]);
            setTooltips({});
            return;
        }
        loadSystemData(dataType);
    }, [
        dataType
    ]);
    (0, $acw62.useEffect)(()=>{
        refreshMissingSystemData();
    }, []);
    async function handleUpload(event) {
        event.preventDefault();
        setError("");
        if (!dataType) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "warning",
                title: "Missing Information",
                text: "Please select a data type."
            });
            return;
        }
        if (!file) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "warning",
                title: "Missing Information",
                text: "Please choose a file to upload."
            });
            return;
        }
        setSubmitting(true);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const formData = new FormData();
            formData.append("data_type", dataType);
            formData.append("excel_file", file);
            const response = await fetch("/api/upload-data/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "X-CSRFToken": csrfToken
                },
                body: formData
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!isJson) throw new Error("Upload did not return JSON. Please verify the selected file and server logs.");
            if (!response.ok || payload?.error) throw new Error(payload?.error || payload?.message || "Unable to upload file.");
            if (dataType === "vendormaster") await (0, $02f53f124c46dca8$export$b2786197665b639d)(payload);
            else await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Upload Successful",
                text: payload?.message || "File uploaded successfully.",
                confirmButtonText: "OK"
            });
            setFile(null);
            if (dataType) await loadSystemData(dataType, {
                clearMessages: false
            });
            await refreshMissingSystemData();
        } catch (requestError) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Upload Failed",
                text: requestError.message || "Something went wrong while uploading the file.",
                confirmButtonText: "OK"
            });
            setError(requestError.message || "Something went wrong while uploading the file.");
        } finally{
            setSubmitting(false);
        }
    }
    function openLegacyUploadPage() {
        window.localStorage.setItem("activeSection", "uploaddata");
        window.open((0, $96e14f2a7c3555e4$export$5d9c32988b6a9848)("/all-invoices/"), "_blank", "noreferrer");
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "processor-view",
        children: [
            missingData.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "config-banner config-banner--error",
                children: [
                    "Missing system data: ",
                    missingData.join(", "),
                    ". Upload these datasets to avoid invoice processing gaps."
                ]
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "upload-grid upload-grid--stacked",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "upload-card",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "upload-card__head",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        children: "Upload Data File"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "Select a data category, upload the source file, and let Django process it."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                className: "gl-form upload-form",
                                onSubmit: handleUpload,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "config-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Data Type"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: dataType,
                                                onChange: (event)=>setDataType(event.target.value),
                                                required: true,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "-- Select Type --"
                                                    }),
                                                    $b11c65d7ae8f97eb$var$dataTypeOptions.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: option.value,
                                                            children: option.label
                                                        }, option.value))
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "config-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Source File"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "file",
                                                accept: ".xlsx,.xls,.json",
                                                onChange: (event)=>setFile(event.target.files?.[0] || null),
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "upload-form__button",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "primary-button",
                                            type: "submit",
                                            disabled: submitting,
                                            children: submitting ? "Uploading..." : "Upload"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "upload-card__meta",
                                children: file ? `Selected file: ${file.name}` : "Accepted formats: .xlsx, .xls, .json"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "workspace-panel",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "processor-table__header",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "eyebrow",
                                            children: dataType
                                        })
                                    }),
                                    dataType ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "ghost-button",
                                        type: "button",
                                        onClick: ()=>loadSystemData(dataType),
                                        disabled: loadingTable,
                                        children: loadingTable ? "Refreshing..." : "Refresh"
                                    }) : null
                                ]
                            }),
                            dataType === "vendormaster" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "vendor-search",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        placeholder: "Search by Vendor Code or Vendor Name",
                                        value: vendorSearch,
                                        onChange: (e)=>handleVendorSearch(e.target.value)
                                    }),
                                    vendorSuggestions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "vendor-suggestions",
                                        children: vendorSuggestions.map((vendor)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "vendor-suggestion-item",
                                                onClick: ()=>handleVendorSelect(vendor.VendorCode),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: vendor.VendorCode
                                                    }),
                                                    " - ",
                                                    vendor.VendorName
                                                ]
                                            }, vendor.VendorCode))
                                    })
                                ]
                            }),
                            dataType === "migo" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mapping-note-card",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Note"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "The headers below are system-defined headers. Verify one invoice with the uploaded data to confirm the header mapping is correct in basic configuration."
                                    })
                                ]
                            }) : null,
                            loadingTable ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-note",
                                children: "Loading system data\u2026"
                            }) : !dataType ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "empty-state",
                                children: "Choose a data type to load the corresponding system data preview."
                            }) : headers.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-table processor-table",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    className: "systemdata-table",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                children: headers.map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        title: tooltips[header] || "",
                                                        children: header
                                                    }, header))
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: tableRows.map((row, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                    children: headers.map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: $b11c65d7ae8f97eb$var$formatCellValue(row[header])
                                                        }, `${index}-${header}`))
                                                }, `${dataType}-${index}`))
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "empty-state",
                                children: "No data found for the selected type."
                            })
                        ]
                    })
                ]
            }),
            showVendorModal && selectedVendor && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "modal-overlay",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "modal-content",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "modal-header",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Edit Vendor"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "modal-body",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        "Vendor Name",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedVendor.VendorName || "",
                                            onChange: (e)=>setSelectedVendor({
                                                    ...selectedVendor,
                                                    VendorName: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        "Vendor Code",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedVendor.VendorCode || "",
                                            disabled: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        "GST No",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedVendor.GSTNo || "",
                                            onChange: (e)=>setSelectedVendor({
                                                    ...selectedVendor,
                                                    GSTNo: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        "LDC No",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedVendor.LDCNo || "",
                                            onChange: (e)=>setSelectedVendor({
                                                    ...selectedVendor,
                                                    LDCNo: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        "LDC Threshold",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedVendor.LDCThreshold || "",
                                            onChange: (e)=>setSelectedVendor({
                                                    ...selectedVendor,
                                                    LDCThreshold: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        "LDC Start Date",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedVendor.LDCStartDate || "",
                                            onChange: (e)=>setSelectedVendor({
                                                    ...selectedVendor,
                                                    LDCStartDate: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        "LDC End Date",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedVendor.LDCEndDate || "",
                                            onChange: (e)=>setSelectedVendor({
                                                    ...selectedVendor,
                                                    LDCEndDate: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        "LDC WT Code",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedVendor.LDCWTCode || "",
                                            onChange: (e)=>setSelectedVendor({
                                                    ...selectedVendor,
                                                    LDCWTCode: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        "Blocked Y/N",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedVendor.BlockedYN || "",
                                            onChange: (e)=>setSelectedVendor({
                                                    ...selectedVendor,
                                                    BlockedYN: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        "MSME Registered Y/N",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedVendor.MSMERegisteredYN || "",
                                            onChange: (e)=>setSelectedVendor({
                                                    ...selectedVendor,
                                                    MSMERegisteredYN: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        "MSME Number",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedVendor.MSMENumber || "",
                                            onChange: (e)=>setSelectedVendor({
                                                    ...selectedVendor,
                                                    MSMENumber: e.target.value
                                                })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "modal-footer",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "primary-button",
                                    type: "button",
                                    onClick: handleVendorSave,
                                    children: "Save"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "ghost-button",
                                    type: "button",
                                    onClick: ()=>{
                                        setShowVendorModal(false);
                                        setSelectedVendor(null);
                                    },
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

function $7ae44f22681dec1d$export$2e2bcd8739ae039() {
    const [data, setData] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        async function loadData() {
            try {
                const response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/gathered-data/");
                setData(response.radio_checks);
            } catch (err) {
                setError(err.message || "Unable to load data.");
            } finally{
                setLoading(false);
            }
        }
        loadData();
    }, []);
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "workspace-panel",
        children: "Loading..."
    });
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "workspace-panel",
        children: error
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "workspace-panel",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: "Gathered Data"
            }),
            Object.entries(data).map(([key, section])=>{
                let parsed = section.data;
                try {
                    parsed = JSON.parse(section.data);
                } catch (e) {}
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        border: "1px solid #ddd",
                        marginBottom: "20px",
                        borderRadius: "6px",
                        overflow: "hidden"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                padding: "10px",
                                color: "white",
                                fontWeight: "bold",
                                background: section.color === "g" ? "green" : section.color === "r" ? "red" : "orange"
                            },
                            children: [
                                key,
                                " - ",
                                section.message
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                padding: "15px"
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                                style: {
                                    whiteSpace: "pre-wrap",
                                    wordBreak: "break-word",
                                    margin: 0
                                },
                                children: JSON.stringify(parsed, null, 2)
                            })
                        })
                    ]
                }, key);
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


const $00cd576f0dca8f62$var$EMPTY_FORM = {
    team: "",
    team_name: "",
    department: "",
    location: ""
};
function $00cd576f0dca8f62$export$2e2bcd8739ae039() {
    const [form, setForm] = (0, $acw62.useState)($00cd576f0dca8f62$var$EMPTY_FORM);
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [deletingTeamId, setDeletingTeamId] = (0, $acw62.useState)("");
    const [editingTeamId, setEditingTeamId] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    async function loadTeams() {
        setLoading(true);
        setError("");
        try {
            const adminAccess = await (0, $96e14f2a7c3555e4$export$f1c7cb4900148296)();
            if (!adminAccess.ok) throw new Error(adminAccess.message);
            const [teams, users] = await Promise.all([
                (0, $96e14f2a7c3555e4$export$319baa9921ab97ab)(),
                (0, $96e14f2a7c3555e4$export$a92d70fb86f2009d)()
            ]);
            const usersByTeam = {};
            users.forEach((user)=>{
                (user.team || []).forEach((teamName)=>{
                    if (!usersByTeam[teamName]) usersByTeam[teamName] = [];
                    usersByTeam[teamName].push(user);
                });
            });
            const data = teams.map((team)=>{
                const teamUsers = usersByTeam[team.team] || [];
                return {
                    ...team,
                    processors: teamUsers.filter((user)=>(user.role || []).includes("Processor")).map((user)=>user.first_name || user.email),
                    uploaders: teamUsers.filter((user)=>(user.role || []).includes("Uploader")).map((user)=>user.first_name || user.email)
                };
            });
            setRows(data);
        } catch (requestError) {
            setError(requestError.message || "Unable to load teams.");
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadTeams();
    }, []);
    function updateField(field, value) {
        setForm((current)=>({
                ...current,
                [field]: value
            }));
    }
    function resetForm() {
        setForm($00cd576f0dca8f62$var$EMPTY_FORM);
        setEditingTeamId("");
    }
    function handleEdit(row) {
        setError("");
        setStatus("");
        setEditingTeamId(row.id || "");
        setForm({
            team: row.team || "",
            team_name: row.team_name || "",
            department: row.department || "",
            location: row.location || ""
        });
    }
    async function handleDelete(row) {
        if (!row?.id) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Unable to delete team: missing team id."
            });
            return;
        }
        const result = await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
            title: "Delete Team?",
            text: `Are you sure you want to delete team "${row.team}"?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Delete",
            cancelButtonText: "Cancel",
            reverseButtons: true
        });
        if (!result.isConfirmed) return;
        setDeletingTeamId(row.id);
        setError("");
        try {
            await (0, $96e14f2a7c3555e4$export$ed1b28a9913b41c7)(row.id);
            if (editingTeamId === row.id) resetForm();
            await loadTeams();
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Deleted",
                text: "Team deleted successfully.",
                confirmButtonText: "OK"
            });
        } catch (requestError) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Delete Failed",
                text: requestError.message || "Unable to delete team.",
                confirmButtonText: "OK"
            });
            setError(requestError.message || "Unable to delete team.");
        } finally{
            setDeletingTeamId("");
        }
    }
    async function handleSubmit(event) {
        event.preventDefault();
        setSaving(true);
        setError("");
        try {
            const payload = {
                team: form.team,
                team_name: form.team_name.trim(),
                department: form.department.trim(),
                location: form.location.trim()
            };
            if (editingTeamId) await (0, $96e14f2a7c3555e4$export$918fc4f0bdbe6f55)(editingTeamId, payload);
            else await (0, $96e14f2a7c3555e4$export$abfa3f70bc35d5f3)(payload);
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: editingTeamId ? "Team updated successfully." : "Team added successfully.",
                confirmButtonText: "OK"
            });
            resetForm();
            await loadTeams();
        } catch (requestError) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: requestError.message || `Unable to ${editingTeamId ? "update" : "add"} team.`,
                confirmButtonText: "OK"
            });
            setError(requestError.message || `Unable to ${editingTeamId ? "update" : "add"} team.`);
        } finally{
            setSaving(false);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "teams-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel teams-view__hero",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "Teams"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "Team Management"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-view__intro",
                                children: "Manage teams directly in Keycloak groups from this dashboard, including create, update, and delete."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "teams-view__summary",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "teams-view__summary-count",
                                children: rows.length
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "teams-view__summary-label",
                                children: "teams configured"
                            })
                        ]
                    })
                ]
            }),
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "teams-layout",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        className: "workspace-panel teams-form",
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "users-form__header",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "eyebrow",
                                                children: editingTeamId ? "Edit Team" : "Create Team"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                children: editingTeamId ? "Update team group" : "Add a new team group"
                                            })
                                        ]
                                    }),
                                    editingTeamId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "ghost-button",
                                        type: "button",
                                        onClick: resetForm,
                                        children: "Cancel Edit"
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Team Code"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: form.team,
                                        onChange: (event)=>updateField("team", event.target.value),
                                        required: true,
                                        placeholder: "e.g. Kolkata"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Team Name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: form.team_name,
                                        onChange: (event)=>updateField("team_name", event.target.value),
                                        placeholder: "e.g. Accounts Payable West",
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Department Name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: form.department,
                                        onChange: (event)=>updateField("department", event.target.value),
                                        placeholder: "Optional"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Location"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: form.location,
                                        onChange: (event)=>updateField("location", event.target.value),
                                        placeholder: "Optional"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary-button",
                                type: "submit",
                                disabled: saving,
                                children: saving ? editingTeamId ? "Updating..." : "Adding..." : editingTeamId ? "Update Team" : "Add Team"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "workspace-panel",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "teams-table__header",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "eyebrow",
                                            children: "Directory"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            children: "All Teams"
                                        })
                                    ]
                                })
                            }),
                            loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-note",
                                children: "Loading existing teams\u2026"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-table",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Team"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Team Name"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Department"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Location"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Processors"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Uploaders"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Action"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: rows.length ? rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: row.team
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: row.team_name
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: row.department || "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: row.location || "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: (row.processors || []).join(", ") || "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: (row.uploaders || []).join(", ") || "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    className: "ghost-button",
                                                                    type: "button",
                                                                    onClick: ()=>handleEdit(row),
                                                                    children: "Edit"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    className: "ghost-button",
                                                                    type: "button",
                                                                    onClick: ()=>handleDelete(row),
                                                                    disabled: deletingTeamId === row.id,
                                                                    children: deletingTeamId === row.id ? "Deleting..." : "Delete"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, row.id || row.team)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    colSpan: "7",
                                                    children: "No teams found."
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


const $f4885203b6872874$var$TABS = [
    {
        key: "field_matrix",
        label: "Field Matrix"
    },
    {
        key: "radio_matrix",
        label: "Radio Matrix"
    }
];
function $f4885203b6872874$export$2e2bcd8739ae039() {
    const [activeTab, setActiveTab] = (0, $acw62.useState)("field_matrix");
    const [matrices, setMatrices] = (0, $acw62.useState)({
        field_matrix: [],
        radio_matrix: []
    });
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        async function loadMatrix() {
            setLoading(true);
            setError("");
            try {
                const response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/approval-matrix/");
                if (!cancelled) setMatrices(response.matrices || {
                    field_matrix: [],
                    radio_matrix: []
                });
            } catch (requestError) {
                if (!cancelled) setError(requestError.message || "Unable to load approval matrix.");
            } finally{
                if (!cancelled) setLoading(false);
            }
        }
        loadMatrix();
        return ()=>{
            cancelled = true;
        };
    }, []);
    function updateFieldRow(index, key, value) {
        setMatrices((current)=>({
                ...current,
                field_matrix: current.field_matrix.map((row, rowIndex)=>rowIndex === index ? {
                        ...row,
                        [key]: value
                    } : row)
            }));
    }
    function updateRadioRow(index, subIndex, value) {
        setMatrices((current)=>({
                ...current,
                radio_matrix: current.radio_matrix.map((row, rowIndex)=>rowIndex === index ? {
                        ...row,
                        sub: row.sub.map((subRow, currentSubIndex)=>currentSubIndex === subIndex ? {
                                ...subRow,
                                checker_approval: value
                            } : subRow)
                    } : row)
            }));
    }
    async function handleSave() {
        setSaving(true);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/approval-matrix/save/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    matrix_type: activeTab,
                    matrix: matrices[activeTab]
                })
            });
            const payload = await response.json();
            if (!response.ok) throw new Error(payload.error || "Unable to save approval matrix.");
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Saved",
                text: payload.message || "Approval matrix saved successfully.",
                timer: 1800,
                showConfirmButton: false
            });
        } catch (requestError) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Save Failed",
                text: requestError.message || "Unable to save approval matrix."
            });
        } finally{
            setSaving(false);
        }
    }
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "workspace-panel",
        children: "Loading approval matrix..."
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "roles-view",
        children: [
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "template-tabs",
                        children: $f4885203b6872874$var$TABS.map((tab)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: `template-tab${activeTab === tab.key ? " is-active" : ""}`,
                                type: "button",
                                onClick: ()=>setActiveTab(tab.key),
                                children: tab.label
                            }, tab.key))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-table",
                        children: activeTab === "field_matrix" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Parameter"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Processor Edit"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Checker Approval"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Checker Edit"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: (matrices.field_matrix || []).map((row, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.parameter
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: Boolean(row.processor_edit),
                                                        onChange: (event)=>updateFieldRow(index, "processor_edit", event.target.checked)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: Boolean(row.checker_approval),
                                                        onChange: (event)=>updateFieldRow(index, "checker_approval", event.target.checked)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: Boolean(row.checker_edit),
                                                        onChange: (event)=>updateFieldRow(index, "checker_edit", event.target.checked)
                                                    })
                                                })
                                            ]
                                        }, row.parameter))
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Parameter"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Checker Approval"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: (matrices.radio_matrix || []).map((row, index)=>row.sub.map((subRow, subIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        children: [
                                                            subIndex === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: row.parameter
                                                            }) : null,
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "roles-radio-label--sub",
                                                                children: subRow.name
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            type: "checkbox",
                                                            checked: Boolean(subRow.checker_approval),
                                                            onChange: (event)=>updateRadioRow(index, subIndex, event.target.checked)
                                                        })
                                                    })
                                                ]
                                            }, `${row.parameter}-${subRow.name}`)))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "template-actions",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "primary-button",
                            type: "button",
                            disabled: saving,
                            onClick: handleSave,
                            children: saving ? "Saving..." : "Save Matrix"
                        })
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

const $62a5d34eb4c71539$var$constitutionOptions = [
    "Public Ltd",
    "Private Ltd",
    "LLP",
    "Proprietorship",
    "Partnership",
    "Trust"
];
const $62a5d34eb4c71539$var$countryCodeOptions = [
    {
        value: "+91",
        label: "India (+91)"
    },
    {
        value: "+1",
        label: "USA (+1)"
    },
    {
        value: "+44",
        label: "UK (+44)"
    },
    {
        value: "+61",
        label: "Australia (+61)"
    },
    {
        value: "+81",
        label: "Japan (+81)"
    }
];
const $62a5d34eb4c71539$var$initialForm = {
    business_name: "",
    business_code: "",
    constitution: "",
    contact_person_name: "",
    country_code: "+91",
    contact_person_number: "",
    contact_person_email: "",
    address_line1: "",
    address_line2: ""
};
function $62a5d34eb4c71539$export$2e2bcd8739ae039({ onBackToLogin: onBackToLogin, onOtpSent: onOtpSent }) {
    const [formValues, setFormValues] = (0, $acw62.useState)($62a5d34eb4c71539$var$initialForm);
    const [submitting, setSubmitting] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    function updateField(field, value) {
        setFormValues((current)=>({
                ...current,
                [field]: value
            }));
    }
    async function handleSubmit(event) {
        event.preventDefault();
        setSubmitting(true);
        setStatus("");
        setError("");
        try {
            const payload = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/auth/signup/", {
                method: "POST",
                body: JSON.stringify(formValues)
            });
            setStatus(payload.message || "OTP sent successfully.");
            onOtpSent(payload.email || formValues.contact_person_email);
        } catch (requestError) {
            setError(requestError.message || "Unable to start signup.");
        } finally{
            setSubmitting(false);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "auth-panel auth-panel--signup",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "auth-panel__header",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "eyebrow",
                        children: "Company Signup"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        children: "Register your company workspace"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "config-note",
                        children: "Submit your company details to receive an OTP verification email and continue account setup in the existing Django registration flow."
                    })
                ]
            }),
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "form-error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                className: "auth-form auth-form--signup",
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        children: [
                            "Business Name",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "text",
                                name: "business_name",
                                value: formValues.business_name,
                                onChange: (event)=>updateField("business_name", event.target.value),
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        children: [
                            "Business Code",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "text",
                                name: "business_code",
                                value: formValues.business_code,
                                onChange: (event)=>updateField("business_code", event.target.value),
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        children: [
                            "Constitution",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                name: "constitution",
                                value: formValues.constitution,
                                onChange: (event)=>updateField("constitution", event.target.value),
                                required: true,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "",
                                        children: "Select constitution"
                                    }),
                                    $62a5d34eb4c71539$var$constitutionOptions.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: option,
                                            children: option
                                        }, option))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        children: [
                            "Contact Person Name",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "text",
                                name: "contact_person_name",
                                value: formValues.contact_person_name,
                                onChange: (event)=>updateField("contact_person_name", event.target.value),
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        children: [
                            "Country Code",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                name: "country_code",
                                value: formValues.country_code,
                                onChange: (event)=>updateField("country_code", event.target.value),
                                required: true,
                                children: $62a5d34eb4c71539$var$countryCodeOptions.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: option.value,
                                        children: option.label
                                    }, option.value))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        children: [
                            "Contact Person Number",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "tel",
                                name: "contact_person_number",
                                value: formValues.contact_person_number,
                                onChange: (event)=>updateField("contact_person_number", event.target.value),
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        className: "auth-form__full",
                        children: [
                            "Contact Person Email",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "email",
                                name: "contact_person_email",
                                value: formValues.contact_person_email,
                                onChange: (event)=>updateField("contact_person_email", event.target.value),
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        className: "auth-form__full",
                        children: [
                            "Address Line 1",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                name: "address_line1",
                                rows: "3",
                                value: formValues.address_line1,
                                onChange: (event)=>updateField("address_line1", event.target.value),
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        className: "auth-form__full",
                        children: [
                            "Address Line 2 (Optional)",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                name: "address_line2",
                                rows: "2",
                                value: formValues.address_line2,
                                onChange: (event)=>updateField("address_line2", event.target.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "auth-form__actions auth-form__full",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary-button",
                                type: "submit",
                                disabled: submitting,
                                children: submitting ? "Submitting..." : "Register"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "ghost-button",
                                type: "button",
                                onClick: onBackToLogin,
                                children: "Back to Sign In"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");



function $63d8c23b2607adbc$var$buildMappingRows(headers, savedMapping = {}, suggestions = {}) {
    return headers.map((headerName)=>{
        const saved = savedMapping?.[headerName];
        const suggestion = suggestions?.[headerName];
        // --------------------------------------------------
        // Check whether an ACTUAL mapping exists
        // Empty string, null, undefined, "-", etc. = unmapped
        // --------------------------------------------------
        const savedType = String(saved?.type ?? "").trim();
        const savedField = String(saved?.field ?? "").trim();
        const hasSavedMapping = Boolean(savedType && savedField);
        // --------------------------------------------------
        // CASE 1: Actual saved mapping exists
        // --------------------------------------------------
        if (hasSavedMapping) return {
            headerName: headerName,
            mandatory: saved?.mandatory ?? false,
            mappingType: savedType,
            mappedField: savedField,
            isSaved: true,
            mappingStatus: "mapped",
            // Keep suggestions so user can switch type later
            suggestions: suggestion || null
        };
        // --------------------------------------------------
        // CASE 2: No actual mapping, but suggestion exists
        // --------------------------------------------------
        if (suggestion?.type && suggestion?.header) return {
            headerName: headerName,
            mandatory: saved?.mandatory ?? false,
            // Show best suggestion initially
            mappingType: suggestion.type,
            mappedField: suggestion.header,
            isSaved: false,
            mappingStatus: "suggestion",
            // Keep ALL suggestions:
            // system / po / grn
            suggestions: suggestion
        };
        // --------------------------------------------------
        // CASE 3: No mapping and no suggestion
        // --------------------------------------------------
        return {
            headerName: headerName,
            mandatory: saved?.mandatory ?? false,
            mappingType: "",
            mappedField: "",
            isSaved: false,
            mappingStatus: "unmapped",
            suggestions: suggestion || null
        };
    });
}
function $63d8c23b2607adbc$var$createTemplateOptions(fileCount) {
    const options = [];
    if (fileCount >= 1) options.push({
        key: "templateheader1",
        label: "Template Header 1"
    });
    if (fileCount >= 2) options.push({
        key: "templateheader2",
        label: "Template Header 2"
    });
    return options;
}
function $63d8c23b2607adbc$export$2e2bcd8739ae039() {
    const [context, setContext] = (0, $acw62.useState)(null);
    const [activeTab, setActiveTab] = (0, $acw62.useState)("upload");
    const [templateMode, setTemplateMode] = (0, $acw62.useState)("common");
    const [uploadTemplateFor, setUploadTemplateFor] = (0, $acw62.useState)("material");
    const [mappingTemplateFor, setMappingTemplateFor] = (0, $acw62.useState)("material");
    const [fileCount, setFileCount] = (0, $acw62.useState)("");
    const [uploadFiles, setUploadFiles] = (0, $acw62.useState)({});
    const [uploadStatus, setUploadStatus] = (0, $acw62.useState)("");
    const [mappingStatus, setMappingStatus] = (0, $acw62.useState)("");
    const [notice, setNotice] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [uploading, setUploading] = (0, $acw62.useState)(false);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [selectedTemplate, setSelectedTemplate] = (0, $acw62.useState)("templateheader1");
    const [mappingRows, setMappingRows] = (0, $acw62.useState)([]);
    const mappedFieldOptions = (0, $acw62.useMemo)(()=>{
        if (!context) return {};
        return {
            system: context.system_vars || [],
            po: context.po_headers || [],
            grn: context.grn_headers || []
        };
    }, [
        context
    ]);
    const currentMappingType = templateMode === "separate" ? mappingTemplateFor : "common";
    const currentMappingFileCount = (0, $acw62.useMemo)(()=>{
        if (!context) return 0;
        if (currentMappingType === "material") return context.material_file_no || 0;
        if (currentMappingType === "service") return context.service_file_no || 0;
        return context.file_no || 0;
    }, [
        context,
        currentMappingType
    ]);
    const templateOptions = (0, $acw62.useMemo)(()=>$63d8c23b2607adbc$var$createTemplateOptions(currentMappingFileCount), [
        currentMappingFileCount
    ]);
    const hasMappedTemplates = templateOptions.length > 0;
    function getTemplateHeaders(nextContext, scope, templateKey) {
        if (scope === "material") return templateKey === "templateheader1" ? nextContext.material_templateheader1 || [] : nextContext.material_templateheader2 || [];
        if (scope === "service") return templateKey === "templateheader1" ? nextContext.service_templateheader1 || [] : nextContext.service_templateheader2 || [];
        return templateKey === "templateheader1" ? nextContext.templateheader1 || [] : nextContext.templateheader2 || [];
    }
    function getSavedTemplateMapping(nextContext, scope, templateKey) {
        if (scope === "material") return templateKey === "templateheader1" ? nextContext.material_templateMapping1 || {} : nextContext.material_templateMapping2 || {};
        if (scope === "service") return templateKey === "templateheader1" ? nextContext.service_templateMapping1 || {} : nextContext.service_templateMapping2 || {};
        return templateKey === "templateheader1" ? nextContext.templateMapping1 || {} : nextContext.templateMapping2 || {};
    }
    function getTemplateSuggestions(nextContext, scope, templateKey) {
        if (scope === "material") return templateKey === "templateheader1" ? nextContext.material_mapped_headers1_suggestions || {} : nextContext.material_mapped_headers2_suggestions || {};
        if (scope === "service") return templateKey === "templateheader1" ? nextContext.service_mapped_headers1_suggestions || {} : nextContext.service_mapped_headers2_suggestions || {};
        return templateKey === "templateheader1" ? nextContext.mapped_headers1_suggestions || {} : nextContext.mapped_headers2_suggestions || {};
    }
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        async function loadContext() {
            try {
                setError("");
                const response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/template-setting/context/");
                if (cancelled) return;
                const nextContext = response.data;
                setContext(nextContext);
                setTemplateMode(nextContext.is_separate_template ? "separate" : "common");
                syncTemplateSelection(nextContext, "templateheader1", mappingTemplateFor);
            } catch (requestError) {
                if (!cancelled) setError(requestError.message || "Unable to load template setting context.");
            }
        }
        loadContext();
        return ()=>{
            cancelled = true;
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!context) return;
        const scope = context.is_separate_template ? mappingTemplateFor : "common";
        const options = $63d8c23b2607adbc$var$createTemplateOptions(scope === "material" ? context.material_file_no || 0 : scope === "service" ? context.service_file_no || 0 : context.file_no || 0);
        const nextSelected = options.find((option)=>option.key === selectedTemplate)?.key || options[0]?.key || "templateheader1";
        if (nextSelected !== selectedTemplate) {
            setSelectedTemplate(nextSelected);
            return;
        }
        setMappingRows($63d8c23b2607adbc$var$buildMappingRows(getTemplateHeaders(context, scope, nextSelected), getSavedTemplateMapping(context, scope, nextSelected), getTemplateSuggestions(context, scope, nextSelected)));
    }, [
        context,
        mappingTemplateFor,
        selectedTemplate
    ]);
    function syncTemplateSelection(nextContext, preferredTemplate, preferredScope) {
        const scope = nextContext.is_separate_template ? preferredScope : "common";
        const fileTotal = scope === "material" ? nextContext.material_file_no || 0 : scope === "service" ? nextContext.service_file_no || 0 : nextContext.file_no || 0;
        const options = $63d8c23b2607adbc$var$createTemplateOptions(fileTotal);
        const selected = options.find((option)=>option.key === preferredTemplate)?.key || options[0]?.key || "templateheader1";
        const nextSelected = options.find((option)=>option.key === selectedTemplate)?.key || options[0]?.key || "templateheader1";
        setSelectedTemplate(selected);
        setMappingRows($63d8c23b2607adbc$var$buildMappingRows(getTemplateHeaders(context, scope, nextSelected), getSavedTemplateMapping(context, scope, nextSelected), getTemplateSuggestions(context, scope, nextSelected)));
    }
    function handleFileCountChange(value) {
        setFileCount(value);
        const count = Number(value || 0);
        const next = {};
        for(let index = 1; index <= count; index += 1)next[`file_${index}`] = {
            file: null,
            headerRows: "1"
        };
        setUploadFiles(next);
    }
    function updateUploadFile(key, field, value) {
        setUploadFiles((current)=>({
                ...current,
                [key]: {
                    ...current[key],
                    [field]: value
                }
            }));
    }
    function updateRow(index, field, value) {
        setMappingRows((current)=>current.map((row, rowIndex)=>{
                if (rowIndex !== index) return row;
                // ---------------------------------------------
                // Normal field change
                // ---------------------------------------------
                if (field !== "mappingType") return {
                    ...row,
                    [field]: value,
                    // User manually changed mapped field,
                    // so it is no longer just a suggestion.
                    ...field === "mappedField" ? {
                        mappingStatus: "mapped"
                    } : {}
                };
                // ---------------------------------------------
                // Mapping type changed
                // ---------------------------------------------
                const selectedType = value;
                const typeSuggestion = row.suggestions?.[selectedType];
                const suggestedHeader = typeSuggestion?.header || "";
                return {
                    ...row,
                    mappingType: selectedType,
                    // Automatically use suggestion for selected type
                    mappedField: suggestedHeader,
                    // If suggestion exists for this type,
                    // mark it as suggestion.
                    mappingStatus: typeSuggestion ? "suggestion" : "unmapped"
                };
            }));
    }
    function confirmTemplateSuggestion(index) {
        setMappingRows((current)=>current.map((row, rowIndex)=>rowIndex === index ? {
                    ...row,
                    mappingStatus: "mapped"
                } : row));
    }
    async function reloadContext(preferredTemplate = selectedTemplate, preferredScope = mappingTemplateFor) {
        const response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/template-setting/context/");
        const nextContext = response.data;
        setContext(nextContext);
        setTemplateMode(nextContext.is_separate_template ? "separate" : "common");
        syncTemplateSelection(nextContext, preferredTemplate, preferredScope);
    }
    async function handleTemplateUpload() {
        if (!fileCount) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "warning",
                title: "Missing Information",
                text: "Select number of files first."
            });
            return;
        }
        setUploading(true);
        setError("");
        setNotice("");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const formData = new FormData();
            const count = Number(fileCount);
            const isSeparate = templateMode === "separate";
            const templateFor = isSeparate ? uploadTemplateFor : "common";
            formData.append("template_for", templateFor);
            formData.append("is_separate", String(isSeparate));
            for(let index = 1; index <= count; index += 1){
                const key = `file_${index}`;
                const currentFile = uploadFiles[key]?.file;
                if (!currentFile) throw new Error(`Please upload File ${index}.`);
                formData.append(key, currentFile);
                formData.append(`${key}_header_rows`, uploadFiles[key]?.headerRows || "1");
            }
            const response = await fetch("/api/template-setting/upload/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "X-CSRFToken": csrfToken
                },
                body: formData
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.error || "Unable to upload template headers.");
            setFileCount("");
            setUploadFiles({});
            await reloadContext(count === 2 ? "templateheader2" : "templateheader1", templateFor);
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Upload Successful",
                text: "Base template uploaded successfully.",
                confirmButtonText: "OK"
            });
        } catch (requestError) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Upload Failed",
                text: requestError.message || "Unable to upload template headers.",
                confirmButtonText: "OK"
            });
            setError(requestError.message || "Unable to upload template headers.");
        } finally{
            setUploading(false);
        }
    }
    async function handleMappingSave() {
        setSaving(true);
        setError("");
        setNotice("");
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const mapping = {};
            mappingRows.forEach((row)=>{
                if (row.headerName) mapping[row.headerName] = {
                    mandatory: row.mandatory,
                    type: row.mappingStatus === "mapped" ? row.mappingType : "",
                    field: row.mappingStatus === "mapped" ? row.mappedField : ""
                };
            });
            const response = await fetch("/api/template-setting/mapping/save/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    template_for: context?.is_separate_template ? mappingTemplateFor : "common",
                    template_type: selectedTemplate,
                    mapping: mapping
                })
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || "Unable to save template mapping.");
            await reloadContext(selectedTemplate, mappingTemplateFor);
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: payload.message || "Template mapping saved successfully.",
                confirmButtonText: "OK"
            });
        } catch (requestError) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Save Failed",
                text: requestError.message || "Unable to save template mapping.",
                confirmButtonText: "OK"
            });
            setError(requestError.message || "Unable to save template mapping.");
        } finally{
            setSaving(false);
        }
    }
    function openTab(tab) {
        setError("");
        setNotice("");
        if (tab === "mapping" && !hasMappedTemplates) {
            setActiveTab("mapping");
            setNotice("No base template uploaded. Please upload base template first for mapping.");
            return;
        }
        setActiveTab(tab);
    }
    if (!context) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "workspace-panel",
        children: "Loading template setting\u2026"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        className: "template-setting-view",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "workspace-panel",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "template-tabs",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: `template-tab${activeTab === "upload" ? " is-active" : ""}`,
                            type: "button",
                            onClick: ()=>openTab("upload"),
                            children: "Base Template Upload"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: `template-tab${activeTab === "mapping" ? " is-active" : ""}`,
                            type: "button",
                            onClick: ()=>openTab("mapping"),
                            children: "Template Header Mapping"
                        })
                    ]
                }),
                activeTab === "upload" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "template-panel",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "template-mapping-toolbar",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "template-mode-option",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "radio",
                                            name: "template_split",
                                            value: "common",
                                            checked: templateMode === "common",
                                            onChange: ()=>{
                                                setTemplateMode("common");
                                                setFileCount("");
                                                setUploadFiles({});
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Common Template"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "template-mode-option",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "radio",
                                            name: "template_split",
                                            value: "separate",
                                            checked: templateMode === "separate",
                                            onChange: ()=>{
                                                setTemplateMode("separate");
                                                setFileCount("");
                                                setUploadFiles({});
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Separate (Material / Service)"
                                        })
                                    ]
                                })
                            ]
                        }),
                        templateMode === "separate" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "template-mapping-toolbar",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Select Template For"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: uploadTemplateFor,
                                        onChange: (event)=>{
                                            setUploadTemplateFor(event.target.value);
                                            setFileCount("");
                                            setUploadFiles({});
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "material",
                                                children: "Material"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "service",
                                                children: "Service"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }) : null,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "template-mapping-toolbar",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Select Number of Files"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: fileCount,
                                        onChange: (event)=>handleFileCountChange(event.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "--Select--"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "1",
                                                children: "1 File"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "2",
                                                children: "2 Files"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "upload-grid",
                            children: Object.entries(uploadFiles).map(([key, value], index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                                    className: "upload-card",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "upload-card__head",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                                    children: [
                                                        "File ",
                                                        index + 1
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: "Upload base template and choose header rows."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            className: "upload-card__input",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Select Excel file"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "file",
                                                    accept: ".xlsx,.xls",
                                                    onChange: (event)=>updateUploadFile(key, "file", event.target.files?.[0] || null)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            className: "config-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Header Rows"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                    value: value.headerRows,
                                                    onChange: (event)=>updateUploadFile(key, "headerRows", event.target.value),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "1",
                                                            children: "1"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "2",
                                                            children: "2"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "upload-card__meta",
                                            children: value.file ? value.file.name : "No file selected"
                                        })
                                    ]
                                }, key))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "template-actions",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary-button",
                                type: "button",
                                disabled: uploading,
                                onClick: handleTemplateUpload,
                                children: uploading ? "Uploading..." : "Upload Headers"
                            })
                        }),
                        uploadStatus ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "config-banner config-banner--success",
                            children: uploadStatus
                        }) : null
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "template-panel",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mapping-note-card",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Mode:"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: context.is_separate_template ? "Separate Templates (Material / Service)" : "Common Template"
                                })
                            ]
                        }),
                        context.is_separate_template ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "template-mapping-toolbar",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Select Mapping For"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: mappingTemplateFor,
                                        onChange: (event)=>setMappingTemplateFor(event.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "material",
                                                children: "Material"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "service",
                                                children: "Service"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }) : null,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "template-mapping-toolbar",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "templatesetting-config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Select Template Header"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: selectedTemplate,
                                        disabled: templateOptions.length <= 1,
                                        onChange: (event)=>setSelectedTemplate(event.target.value),
                                        children: templateOptions.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: option.key,
                                                children: option.label
                                            }, option.key))
                                    })
                                ]
                            })
                        }),
                        hasMappedTemplates ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "config-table",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            className: "template-header-name",
                                                            children: "Header Name"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            className: "template-mandatory",
                                                            children: "Mandatory"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            className: "template-mapping-type",
                                                            children: "Mapping Type"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            className: "template-mapped-field",
                                                            children: "Mapped Field"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                children: mappingRows.map((row, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: row.headerName
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "template-mandatory-cell",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    type: "checkbox",
                                                                    checked: row.mandatory,
                                                                    onChange: (event)=>updateRow(index, "mandatory", event.target.checked)
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                    value: row.mappingType,
                                                                    onChange: (event)=>updateRow(index, "mappingType", event.target.value),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "",
                                                                            children: "--Select--"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "system",
                                                                            children: "System"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "po",
                                                                            children: "PO"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "grn",
                                                                            children: "GRN"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "template-mapped-field-wrapper",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                            value: row.mappedField,
                                                                            onChange: (event)=>updateRow(index, "mappedField", event.target.value),
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                    value: "",
                                                                                    children: "Select Mapping Type"
                                                                                }),
                                                                                (mappedFieldOptions[row.mappingType] || []).map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                        value: option,
                                                                                        children: option
                                                                                    }, option))
                                                                            ]
                                                                        }),
                                                                        row.mappingStatus === "mapped" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "mapping-badge mapping-badge--mapped",
                                                                            children: "\u2713 Mapped"
                                                                        }),
                                                                        row.mappingStatus === "suggestion" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "mapping-badge mapping-badge--suggested mapping-badge--clickable",
                                                                            onClick: ()=>confirmTemplateSuggestion(index),
                                                                            title: "Click to accept this suggestion",
                                                                            children: "\uD83D\uDCA1 Suggested"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }, row.headerName))
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "template-mapping-submit",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "primary-button",
                                        type: "button",
                                        disabled: saving,
                                        onClick: handleMappingSave,
                                        children: saving ? "Saving..." : "Submit"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mapping-note-card",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "No base template uploaded."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "Please upload base template first for mapping."
                                })
                            ]
                        }),
                        mappingStatus ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "config-banner config-banner--success",
                            children: mappingStatus
                        }) : null
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");


const $ca9de1316ff6e95f$var$HEADER_FIELDS = [
    {
        key: "po_header",
        label: "Upload PO Header Excel",
        help: "Expected PO column headers from your source workbook."
    },
    {
        key: "miro_header",
        label: "Upload MIGO Header Excel",
        help: "Upload the MIRO or MIGO file used for invoice matching."
    },
    {
        key: "se_header",
        label: "Upload Service Entry Header Excel",
        help: "Used when Service Entry data is maintained separately."
    },
    {
        key: "vmaster_header",
        label: "Upload Vendor Master Header Excel",
        help: "Vendor master columns used for vendor validations and mapping."
    },
    {
        key: "wholdtax_master_header",
        label: "Upload WithholdTax Master Header Excel",
        help: "Supports withholding tax field mapping."
    },
    {
        key: "gsttax_master_header",
        label: "Upload GSTTax Master Header Excel",
        help: "Required for GST tax code mapping and validations."
    },
    {
        key: "hsn_master_header",
        label: "Upload HSN Master Header Excel",
        help: "Used for HSN based mapping and code validation."
    },
    {
        key: "sac_master_header",
        label: "Upload SAC Master Header Excel",
        help: "Used for SAC tax code mapping and service validation."
    }
];
function $ca9de1316ff6e95f$var$createInitialFiles() {
    return $ca9de1316ff6e95f$var$HEADER_FIELDS.reduce((accumulator, field)=>{
        accumulator[field.key] = null;
        return accumulator;
    }, {});
}
function $ca9de1316ff6e95f$export$2e2bcd8739ae039() {
    const [files, setFiles] = (0, $acw62.useState)($ca9de1316ff6e95f$var$createInitialFiles);
    const [uploadStatus, setUploadStatus] = (0, $acw62.useState)({});
    const [loadingStatus, setLoadingStatus] = (0, $acw62.useState)(true);
    const [submitting, setSubmitting] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const selectedCount = (0, $acw62.useMemo)(()=>Object.values(files).filter(Boolean).length, [
        files
    ]);
    const uploadedCount = (0, $acw62.useMemo)(()=>Object.values(uploadStatus || {}).filter(Boolean).length, [
        uploadStatus
    ]);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        async function loadUploadStatus() {
            setLoadingStatus(true);
            try {
                const response = await fetch("/api/upload-headers/status/", {
                    credentials: "include",
                    headers: {
                        Accept: "application/json"
                    }
                });
                const payload = await response.json();
                if (!response.ok) throw new Error(payload.message || "Unable to load header upload status.");
                if (!cancelled) setUploadStatus(payload.status || {});
            } catch (requestError) {
                if (!cancelled) setError(requestError.message || "Unable to load header upload status.");
            } finally{
                if (!cancelled) setLoadingStatus(false);
            }
        }
        loadUploadStatus();
        return ()=>{
            cancelled = true;
        };
    }, []);
    function handleFileChange(fieldKey, event) {
        const file = event.target.files?.[0] || null;
        setFiles((current)=>({
                ...current,
                [fieldKey]: file
            }));
    }
    async function handleSubmit(event) {
        event.preventDefault();
        setSubmitting(true);
        setStatus("");
        setError("");
        if (!selectedCount) {
            setSubmitting(false);
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Select at least one header file before uploading.",
                confirmButtonText: "OK"
            });
            return;
        }
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const formData = new FormData();
            $ca9de1316ff6e95f$var$HEADER_FIELDS.forEach((field)=>{
                if (files[field.key]) formData.append(field.key, files[field.key]);
            });
            const response = await fetch("/api/upload-headers/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "X-CSRFToken": csrfToken
                },
                body: formData
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Unable to upload header files.",
                confirmButtonText: "OK"
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: payload.message || "Headers uploaded successfully.",
                confirmButtonText: "OK"
            });
            setUploadStatus(payload.uploadStatus || {});
            setFiles($ca9de1316ff6e95f$var$createInitialFiles());
        } catch (requestError) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Upload failed. Try again.",
                confirmButtonText: "OK"
            });
        } finally{
            setSubmitting(false);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "upload-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel upload-view__hero",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "Header Library"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "Upload Source Headers"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-view__intro",
                                children: "Manage uploaded header definitions by source type. Re-uploading a type will replace its saved header set for the current company."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "upload-view__summary",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "upload-view__summary-count",
                                children: loadingStatus ? "..." : uploadedCount
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "upload-view__summary-label",
                                children: "header types uploaded"
                            })
                        ]
                    })
                ]
            }),
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                className: "upload-grid",
                onSubmit: handleSubmit,
                children: [
                    $ca9de1316ff6e95f$var$HEADER_FIELDS.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                            className: "upload-card",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "upload-card__head",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "upload-card__title-row",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    children: field.label
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: `pill${uploadStatus[field.key] ? "" : " pill--muted"}`,
                                                    children: uploadStatus[field.key] ? "Uploaded" : "Not uploaded"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: field.help
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "upload-card__input",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Select Excel file"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "file",
                                            accept: ".xlsx,.xls",
                                            onChange: (event)=>handleFileChange(field.key, event)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "upload-card__meta",
                                    children: files[field.key] ? files[field.key].name : "No file selected"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "config-note",
                                    children: uploadStatus[field.key] ? "A header set is already saved for this type. Upload again to replace it." : "No saved header set found yet for this type."
                                })
                            ]
                        }, field.key)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "workspace-panel upload-view__actions",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "eyebrow",
                                        children: "Submit"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        children: "Upload header set"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "config-note",
                                        children: "You can upload one file or several in the same request. Existing saved header sets for the company will be updated by type."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary-button",
                                type: "submit",
                                disabled: submitting,
                                children: submitting ? "Uploading..." : "Upload Headers"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


const $2e2ec5d998192ec0$var$HEADER_FIELDS = [
    {
        key: "po_header",
        label: "Upload PO Header Excel",
        help: "Expected PO column headers from your source workbook."
    },
    {
        key: "miro_header",
        label: "Upload MIGO Header Excel",
        help: "Upload the MIRO or MIGO file used for invoice matching."
    },
    {
        key: "se_header",
        label: "Upload Service Entry Header Excel",
        help: "Used when Service Entry data is maintained separately."
    },
    {
        key: "vmaster_header",
        label: "Upload Vendor Master Header Excel",
        help: "Vendor master columns used for vendor validations and mapping."
    }
];
function $2e2ec5d998192ec0$var$createInitialFiles() {
    return $2e2ec5d998192ec0$var$HEADER_FIELDS.reduce((accumulator, field)=>{
        accumulator[field.key] = null;
        return accumulator;
    }, {});
}
function $2e2ec5d998192ec0$export$2e2bcd8739ae039() {
    const [files, setFiles] = (0, $acw62.useState)($2e2ec5d998192ec0$var$createInitialFiles);
    const [uploadStatus, setUploadStatus] = (0, $acw62.useState)({});
    const [loadingStatus, setLoadingStatus] = (0, $acw62.useState)(true);
    const [submitting, setSubmitting] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const selectedCount = (0, $acw62.useMemo)(()=>Object.values(files).filter(Boolean).length, [
        files
    ]);
    const uploadedCount = (0, $acw62.useMemo)(()=>Object.values(uploadStatus || {}).filter(Boolean).length, [
        uploadStatus
    ]);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        async function loadUploadStatus() {
            setLoadingStatus(true);
            try {
                const response = await fetch("/api/upload-headers/status/", {
                    credentials: "include",
                    headers: {
                        Accept: "application/json"
                    }
                });
                const payload = await response.json();
                if (!response.ok) throw new Error(payload.message || "Unable to load header upload status.");
                if (!cancelled) setUploadStatus(payload.status || {});
            } catch (requestError) {
                if (!cancelled) setError(requestError.message || "Unable to load header upload status.");
            } finally{
                if (!cancelled) setLoadingStatus(false);
            }
        }
        loadUploadStatus();
        return ()=>{
            cancelled = true;
        };
    }, []);
    function handleFileChange(fieldKey, event) {
        const file = event.target.files?.[0] || null;
        setFiles((current)=>({
                ...current,
                [fieldKey]: file
            }));
    }
    async function handleSubmit(event) {
        event.preventDefault();
        setSubmitting(true);
        setStatus("");
        setError("");
        if (!selectedCount) {
            setSubmitting(false);
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Select at least one header file before uploading.",
                confirmButtonText: "OK"
            });
            return;
        }
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const formData = new FormData();
            $2e2ec5d998192ec0$var$HEADER_FIELDS.forEach((field)=>{
                if (files[field.key]) formData.append(field.key, files[field.key]);
            });
            const response = await fetch("/api/upload-headers/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "X-CSRFToken": csrfToken
                },
                body: formData
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Unable to upload header files.",
                confirmButtonText: "OK"
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: payload.message || "Headers uploaded successfully.",
                confirmButtonText: "OK"
            });
            setUploadStatus(payload.uploadStatus || {});
            setFiles($2e2ec5d998192ec0$var$createInitialFiles());
        } catch (requestError) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Upload failed. Try again.",
                confirmButtonText: "OK"
            });
        } finally{
            setSubmitting(false);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "upload-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel upload-view__hero",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "Header Library"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "Upload Source Headers"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-view__intro",
                                children: "Manage uploaded header definitions by source type. Re-uploading a type will replace its saved header set for the current company."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "upload-view__summary",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "upload-view__summary-count",
                                children: loadingStatus ? "..." : uploadedCount
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "upload-view__summary-label",
                                children: "header types uploaded"
                            })
                        ]
                    })
                ]
            }),
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                className: "upload-grid",
                onSubmit: handleSubmit,
                children: [
                    $2e2ec5d998192ec0$var$HEADER_FIELDS.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                            className: "upload-card",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "upload-card__head",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "upload-card__title-row",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    children: field.label
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: `pill${uploadStatus[field.key] ? "" : " pill--muted"}`,
                                                    children: uploadStatus[field.key] ? "Uploaded" : "Not uploaded"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: field.help
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "upload-card__input",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Select Excel file"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "file",
                                            accept: ".xlsx,.xls",
                                            onChange: (event)=>handleFileChange(field.key, event)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "upload-card__meta",
                                    children: files[field.key] ? files[field.key].name : "No file selected"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "config-note",
                                    children: uploadStatus[field.key] ? "A header set is already saved for this type. Upload again to replace it." : "No saved header set found yet for this type."
                                })
                            ]
                        }, field.key)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "workspace-panel upload-view__actions",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "eyebrow",
                                        children: "Submit"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        children: "Upload header set"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "config-note",
                                        children: "You can upload one file or several in the same request. Existing saved header sets for the company will be updated by type."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary-button",
                                type: "submit",
                                disabled: submitting,
                                children: submitting ? "Uploading..." : "Upload Headers"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


const $bec10b6736033413$var$HEADER_FIELDS = [
    {
        key: "wholdtax_master_header",
        label: "Upload WithholdTax Master Header Excel",
        help: "Supports withholding tax field mapping."
    },
    {
        key: "gsttax_master_header",
        label: "Upload GSTTax Master Header Excel",
        help: "Required for GST tax code mapping and validations."
    }
];
function $bec10b6736033413$var$createInitialFiles() {
    return $bec10b6736033413$var$HEADER_FIELDS.reduce((accumulator, field)=>{
        accumulator[field.key] = null;
        return accumulator;
    }, {});
}
function $bec10b6736033413$export$2e2bcd8739ae039() {
    const [files, setFiles] = (0, $acw62.useState)($bec10b6736033413$var$createInitialFiles);
    const [uploadStatus, setUploadStatus] = (0, $acw62.useState)({});
    const [loadingStatus, setLoadingStatus] = (0, $acw62.useState)(true);
    const [submitting, setSubmitting] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const selectedCount = (0, $acw62.useMemo)(()=>Object.values(files).filter(Boolean).length, [
        files
    ]);
    const uploadedCount = (0, $acw62.useMemo)(()=>Object.values(uploadStatus || {}).filter(Boolean).length, [
        uploadStatus
    ]);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        async function loadUploadStatus() {
            setLoadingStatus(true);
            try {
                const response = await fetch("/api/upload-headers/status/", {
                    credentials: "include",
                    headers: {
                        Accept: "application/json"
                    }
                });
                const payload = await response.json();
                if (!response.ok) throw new Error(payload.message || "Unable to load header upload status.");
                if (!cancelled) setUploadStatus(payload.status || {});
            } catch (requestError) {
                if (!cancelled) setError(requestError.message || "Unable to load header upload status.");
            } finally{
                if (!cancelled) setLoadingStatus(false);
            }
        }
        loadUploadStatus();
        return ()=>{
            cancelled = true;
        };
    }, []);
    function handleFileChange(fieldKey, event) {
        const file = event.target.files?.[0] || null;
        setFiles((current)=>({
                ...current,
                [fieldKey]: file
            }));
    }
    async function handleSubmit(event) {
        event.preventDefault();
        setSubmitting(true);
        setStatus("");
        setError("");
        if (!selectedCount) {
            setSubmitting(false);
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Select at least one header file before uploading.",
                confirmButtonText: "OK"
            });
            return;
        }
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const formData = new FormData();
            $bec10b6736033413$var$HEADER_FIELDS.forEach((field)=>{
                if (files[field.key]) formData.append(field.key, files[field.key]);
            });
            const response = await fetch("/api/upload-headers/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "X-CSRFToken": csrfToken
                },
                body: formData
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Unable to upload header files.",
                confirmButtonText: "OK"
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: payload.message || "Headers uploaded successfully.",
                confirmButtonText: "OK"
            });
            setUploadStatus(payload.uploadStatus || {});
            setFiles($bec10b6736033413$var$createInitialFiles());
        } catch (requestError) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Upload failed. Try again.",
                confirmButtonText: "OK"
            });
        } finally{
            setSubmitting(false);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "upload-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel upload-view__hero",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "Header Library"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "Upload Source Headers"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-view__intro",
                                children: "Manage uploaded header definitions by source type. Re-uploading a type will replace its saved header set for the current company."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "upload-view__summary",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "upload-view__summary-count",
                                children: loadingStatus ? "..." : uploadedCount
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "upload-view__summary-label",
                                children: "header types uploaded"
                            })
                        ]
                    })
                ]
            }),
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                className: "upload-grid",
                onSubmit: handleSubmit,
                children: [
                    $bec10b6736033413$var$HEADER_FIELDS.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                            className: "upload-card",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "upload-card__head",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "upload-card__title-row",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    children: field.label
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: `pill${uploadStatus[field.key] ? "" : " pill--muted"}`,
                                                    children: uploadStatus[field.key] ? "Uploaded" : "Not uploaded"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: field.help
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "upload-card__input",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Select Excel file"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "file",
                                            accept: ".xlsx,.xls",
                                            onChange: (event)=>handleFileChange(field.key, event)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "upload-card__meta",
                                    children: files[field.key] ? files[field.key].name : "No file selected"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "config-note",
                                    children: uploadStatus[field.key] ? "A header set is already saved for this type. Upload again to replace it." : "No saved header set found yet for this type."
                                })
                            ]
                        }, field.key)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "workspace-panel upload-view__actions",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "eyebrow",
                                        children: "Submit"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        children: "Upload header set"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "config-note",
                                        children: "You can upload one file or several in the same request. Existing saved header sets for the company will be updated by type."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary-button",
                                type: "submit",
                                disabled: submitting,
                                children: submitting ? "Uploading..." : "Upload Headers"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

var $00483d97acd1a213$exports = {};
$parcel$export($00483d97acd1a213$exports, "PDFDocument", () => $93b2571d4e1dfe94$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $cOQTW = parcelRequire("cOQTW");
parcelRequire("nAWRe");

var $8zvel = parcelRequire("8zvel");

var $cOQTW = parcelRequire("cOQTW");

var $ckCqy = parcelRequire("ckCqy");

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $ab35d5c6c69177c9$var$PDFHeader = /** @class */ function() {
    function PDFHeader(major, minor) {
        this.major = String(major);
        this.minor = String(minor);
    }
    PDFHeader.prototype.toString = function() {
        var bc = (0, $7Kmy8.charFromCode)(129);
        return "%PDF-" + this.major + "." + this.minor + "\n%" + bc + bc + bc + bc;
    };
    PDFHeader.prototype.sizeInBytes = function() {
        return 12 + this.major.length + this.minor.length;
    };
    PDFHeader.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).Percent;
        buffer[offset++] = (0, $8zvel.default).P;
        buffer[offset++] = (0, $8zvel.default).D;
        buffer[offset++] = (0, $8zvel.default).F;
        buffer[offset++] = (0, $8zvel.default).Dash;
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.major, buffer, offset);
        buffer[offset++] = (0, $8zvel.default).Period;
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.minor, buffer, offset);
        buffer[offset++] = (0, $8zvel.default).Newline;
        buffer[offset++] = (0, $8zvel.default).Percent;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        return offset - initialOffset;
    };
    PDFHeader.forVersion = function(major, minor) {
        return new PDFHeader(major, minor);
    };
    return PDFHeader;
}();
var $ab35d5c6c69177c9$export$2e2bcd8739ae039 = $ab35d5c6c69177c9$var$PDFHeader;



var $nAWRe = parcelRequire("nAWRe");

var $8auL6 = parcelRequire("8auL6");

var $8gQNC = parcelRequire("8gQNC");

var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");

var $cOQTW = parcelRequire("cOQTW");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
var $ad8a981877dc5d20$var$PDFNull = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFNull, _super);
    function PDFNull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFNull.prototype.asNull = function() {
        return null;
    };
    PDFNull.prototype.clone = function() {
        return this;
    };
    PDFNull.prototype.toString = function() {
        return 'null';
    };
    PDFNull.prototype.sizeInBytes = function() {
        return 4;
    };
    PDFNull.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $8zvel.default).n;
        buffer[offset++] = (0, $8zvel.default).u;
        buffer[offset++] = (0, $8zvel.default).l;
        buffer[offset++] = (0, $8zvel.default).l;
        return 4;
    };
    return PDFNull;
}((0, $11c5J.default));
var $ad8a981877dc5d20$export$2e2bcd8739ae039 = new $ad8a981877dc5d20$var$PDFNull();



var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
var $85408478fbb7cbde$var$PDFDict = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFDict, _super);
    function PDFDict(map, context) {
        var _this = _super.call(this) || this;
        _this.dict = map;
        _this.context = context;
        return _this;
    }
    PDFDict.prototype.keys = function() {
        return Array.from(this.dict.keys());
    };
    PDFDict.prototype.values = function() {
        return Array.from(this.dict.values());
    };
    PDFDict.prototype.entries = function() {
        return Array.from(this.dict.entries());
    };
    PDFDict.prototype.set = function(key, value) {
        this.dict.set(key, value);
    };
    PDFDict.prototype.get = function(key, // TODO: `preservePDFNull` is for backwards compatibility. Should be
    // removed in next breaking API change.
    preservePDFNull) {
        if (preservePDFNull === void 0) preservePDFNull = false;
        var value = this.dict.get(key);
        if (value === (0, $ad8a981877dc5d20$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.has = function(key) {
        var value = this.dict.get(key);
        return value !== undefined && value !== (0, $ad8a981877dc5d20$export$2e2bcd8739ae039);
    };
    PDFDict.prototype.lookupMaybe = function(key) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $ad8a981877dc5d20$export$2e2bcd8739ae039));
        var value = (_a = this.context).lookupMaybe.apply(_a, (0, $cOQTW.__spreadArrays)([
            this.get(key, preservePDFNull)
        ], types));
        if (value === (0, $ad8a981877dc5d20$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.lookup = function(key) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $ad8a981877dc5d20$export$2e2bcd8739ae039));
        var value = (_a = this.context).lookup.apply(_a, (0, $cOQTW.__spreadArrays)([
            this.get(key, preservePDFNull)
        ], types));
        if (value === (0, $ad8a981877dc5d20$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.delete = function(key) {
        return this.dict.delete(key);
    };
    PDFDict.prototype.asMap = function() {
        return new Map(this.dict);
    };
    /** Generate a random key that doesn't exist in current key set */ PDFDict.prototype.uniqueKey = function(tag) {
        if (tag === void 0) tag = '';
        var existingKeys = this.keys();
        var key = (0, $dPHSK.default).of(this.context.addRandomSuffix(tag, 10));
        while(existingKeys.includes(key))key = (0, $dPHSK.default).of(this.context.addRandomSuffix(tag, 10));
        return key;
    };
    PDFDict.prototype.clone = function(context) {
        var clone = PDFDict.withContext(context || this.context);
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            clone.set(key, value);
        }
        return clone;
    };
    PDFDict.prototype.toString = function() {
        var dictString = '<<\n';
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            dictString += key.toString() + ' ' + value.toString() + '\n';
        }
        dictString += '>>';
        return dictString;
    };
    PDFDict.prototype.sizeInBytes = function() {
        var size = 5;
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            size += key.sizeInBytes() + value.sizeInBytes() + 2;
        }
        return size;
    };
    PDFDict.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).LessThan;
        buffer[offset++] = (0, $8zvel.default).LessThan;
        buffer[offset++] = (0, $8zvel.default).Newline;
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            offset += key.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
            offset += value.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Newline;
        }
        buffer[offset++] = (0, $8zvel.default).GreaterThan;
        buffer[offset++] = (0, $8zvel.default).GreaterThan;
        return offset - initialOffset;
    };
    PDFDict.withContext = function(context) {
        return new PDFDict(new Map(), context);
    };
    PDFDict.fromMapWithContext = function(map, context) {
        return new PDFDict(map, context);
    };
    return PDFDict;
}((0, $11c5J.default));
var $85408478fbb7cbde$export$2e2bcd8739ae039 = $85408478fbb7cbde$var$PDFDict;



var $dPHSK = parcelRequire("dPHSK");


var $j04jt = parcelRequire("j04jt");

var $11c5J = parcelRequire("11c5J");

var $cOQTW = parcelRequire("cOQTW");

var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
var $35c7d4c8e4f2bcc7$var$PDFStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFStream, _super);
    function PDFStream(dict) {
        var _this = _super.call(this) || this;
        _this.dict = dict;
        return _this;
    }
    PDFStream.prototype.clone = function(_context) {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'clone');
    };
    PDFStream.prototype.getContentsString = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'getContentsString');
    };
    PDFStream.prototype.getContents = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'getContents');
    };
    PDFStream.prototype.getContentsSize = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'getContentsSize');
    };
    PDFStream.prototype.updateDict = function() {
        var contentsSize = this.getContentsSize();
        this.dict.set((0, $dPHSK.default).Length, (0, $j04jt.default).of(contentsSize));
    };
    PDFStream.prototype.sizeInBytes = function() {
        this.updateDict();
        return this.dict.sizeInBytes() + this.getContentsSize() + 18;
    };
    PDFStream.prototype.toString = function() {
        this.updateDict();
        var streamString = this.dict.toString();
        streamString += '\nstream\n';
        streamString += this.getContentsString();
        streamString += '\nendstream';
        return streamString;
    };
    PDFStream.prototype.copyBytesInto = function(buffer, offset) {
        this.updateDict();
        var initialOffset = offset;
        offset += this.dict.copyBytesInto(buffer, offset);
        buffer[offset++] = (0, $8zvel.default).Newline;
        buffer[offset++] = (0, $8zvel.default).s;
        buffer[offset++] = (0, $8zvel.default).t;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).a;
        buffer[offset++] = (0, $8zvel.default).m;
        buffer[offset++] = (0, $8zvel.default).Newline;
        var contents = this.getContents();
        for(var idx = 0, len = contents.length; idx < len; idx++)buffer[offset++] = contents[idx];
        buffer[offset++] = (0, $8zvel.default).Newline;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).n;
        buffer[offset++] = (0, $8zvel.default).d;
        buffer[offset++] = (0, $8zvel.default).s;
        buffer[offset++] = (0, $8zvel.default).t;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).a;
        buffer[offset++] = (0, $8zvel.default).m;
        return offset - initialOffset;
    };
    return PDFStream;
}((0, $11c5J.default));
var $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039 = $35c7d4c8e4f2bcc7$var$PDFStream;


parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");
var $ef28c75b0f11042e$var$PDFRawStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFRawStream, _super);
    function PDFRawStream(dict, contents) {
        var _this = _super.call(this, dict) || this;
        _this.contents = contents;
        return _this;
    }
    PDFRawStream.prototype.asUint8Array = function() {
        return this.contents.slice();
    };
    PDFRawStream.prototype.clone = function(context) {
        return PDFRawStream.of(this.dict.clone(context), this.contents.slice());
    };
    PDFRawStream.prototype.getContentsString = function() {
        return (0, $4ISq8.arrayAsString)(this.contents);
    };
    PDFRawStream.prototype.getContents = function() {
        return this.contents;
    };
    PDFRawStream.prototype.getContentsSize = function() {
        return this.contents.length;
    };
    PDFRawStream.of = function(dict, contents) {
        return new PDFRawStream(dict, contents);
    };
    return PDFRawStream;
}((0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039));
var $ef28c75b0f11042e$export$2e2bcd8739ae039 = $ef28c75b0f11042e$var$PDFRawStream;



var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $11c5J = parcelRequire("11c5J");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $f1233b848bc26abe$var$ENFORCER = {};
var $f1233b848bc26abe$var$pool = new Map();
var $f1233b848bc26abe$var$PDFRef = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFRef, _super);
    function PDFRef(enforcer, objectNumber, generationNumber) {
        var _this = this;
        if (enforcer !== $f1233b848bc26abe$var$ENFORCER) throw new (0, $nAWRe.PrivateConstructorError)('PDFRef');
        _this = _super.call(this) || this;
        _this.objectNumber = objectNumber;
        _this.generationNumber = generationNumber;
        _this.tag = objectNumber + " " + generationNumber + " R";
        return _this;
    }
    PDFRef.prototype.clone = function() {
        return this;
    };
    PDFRef.prototype.toString = function() {
        return this.tag;
    };
    PDFRef.prototype.sizeInBytes = function() {
        return this.tag.length;
    };
    PDFRef.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.tag, buffer, offset);
        return this.tag.length;
    };
    PDFRef.of = function(objectNumber, generationNumber) {
        if (generationNumber === void 0) generationNumber = 0;
        var tag = objectNumber + " " + generationNumber + " R";
        var instance = $f1233b848bc26abe$var$pool.get(tag);
        if (!instance) {
            instance = new PDFRef($f1233b848bc26abe$var$ENFORCER, objectNumber, generationNumber);
            $f1233b848bc26abe$var$pool.set(tag, instance);
        }
        return instance;
    };
    return PDFRef;
}((0, $11c5J.default));
var $f1233b848bc26abe$export$2e2bcd8739ae039 = $f1233b848bc26abe$var$PDFRef;



var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $400c0bd11400a1c4$var$PDFOperator = /** @class */ function() {
    function PDFOperator(name, args) {
        this.name = name;
        this.args = args || [];
    }
    PDFOperator.prototype.clone = function(context) {
        var args = new Array(this.args.length);
        for(var idx = 0, len = args.length; idx < len; idx++){
            var arg = this.args[idx];
            args[idx] = arg instanceof (0, $11c5J.default) ? arg.clone(context) : arg;
        }
        return PDFOperator.of(this.name, args);
    };
    PDFOperator.prototype.toString = function() {
        var value = '';
        for(var idx = 0, len = this.args.length; idx < len; idx++)value += String(this.args[idx]) + ' ';
        value += this.name;
        return value;
    };
    PDFOperator.prototype.sizeInBytes = function() {
        var size = 0;
        for(var idx = 0, len = this.args.length; idx < len; idx++){
            var arg = this.args[idx];
            size += (arg instanceof (0, $11c5J.default) ? arg.sizeInBytes() : arg.length) + 1;
        }
        size += this.name.length;
        return size;
    };
    PDFOperator.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        for(var idx = 0, len = this.args.length; idx < len; idx++){
            var arg = this.args[idx];
            if (arg instanceof (0, $11c5J.default)) offset += arg.copyBytesInto(buffer, offset);
            else offset += (0, $7Kmy8.copyStringIntoBuffer)(arg, buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
        }
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.name, buffer, offset);
        return offset - initialOffset;
    };
    PDFOperator.of = function(name, args) {
        return new PDFOperator(name, args);
    };
    return PDFOperator;
}();
var $400c0bd11400a1c4$export$2e2bcd8739ae039 = $400c0bd11400a1c4$var$PDFOperator;


var $27958cc2c5d88a31$var$PDFOperatorNames;
(function(PDFOperatorNames) {
    // Non Stroking Color Operators
    PDFOperatorNames["NonStrokingColor"] = "sc";
    PDFOperatorNames["NonStrokingColorN"] = "scn";
    PDFOperatorNames["NonStrokingColorRgb"] = "rg";
    PDFOperatorNames["NonStrokingColorGray"] = "g";
    PDFOperatorNames["NonStrokingColorCmyk"] = "k";
    PDFOperatorNames["NonStrokingColorspace"] = "cs";
    // Stroking Color Operators
    PDFOperatorNames["StrokingColor"] = "SC";
    PDFOperatorNames["StrokingColorN"] = "SCN";
    PDFOperatorNames["StrokingColorRgb"] = "RG";
    PDFOperatorNames["StrokingColorGray"] = "G";
    PDFOperatorNames["StrokingColorCmyk"] = "K";
    PDFOperatorNames["StrokingColorspace"] = "CS";
    // Marked Content Operators
    PDFOperatorNames["BeginMarkedContentSequence"] = "BDC";
    PDFOperatorNames["BeginMarkedContent"] = "BMC";
    PDFOperatorNames["EndMarkedContent"] = "EMC";
    PDFOperatorNames["MarkedContentPointWithProps"] = "DP";
    PDFOperatorNames["MarkedContentPoint"] = "MP";
    PDFOperatorNames["DrawObject"] = "Do";
    // Graphics State Operators
    PDFOperatorNames["ConcatTransformationMatrix"] = "cm";
    PDFOperatorNames["PopGraphicsState"] = "Q";
    PDFOperatorNames["PushGraphicsState"] = "q";
    PDFOperatorNames["SetFlatness"] = "i";
    PDFOperatorNames["SetGraphicsStateParams"] = "gs";
    PDFOperatorNames["SetLineCapStyle"] = "J";
    PDFOperatorNames["SetLineDashPattern"] = "d";
    PDFOperatorNames["SetLineJoinStyle"] = "j";
    PDFOperatorNames["SetLineMiterLimit"] = "M";
    PDFOperatorNames["SetLineWidth"] = "w";
    PDFOperatorNames["SetTextMatrix"] = "Tm";
    PDFOperatorNames["SetRenderingIntent"] = "ri";
    // Graphics Operators
    PDFOperatorNames["AppendRectangle"] = "re";
    PDFOperatorNames["BeginInlineImage"] = "BI";
    PDFOperatorNames["BeginInlineImageData"] = "ID";
    PDFOperatorNames["EndInlineImage"] = "EI";
    PDFOperatorNames["ClipEvenOdd"] = "W*";
    PDFOperatorNames["ClipNonZero"] = "W";
    PDFOperatorNames["CloseAndStroke"] = "s";
    PDFOperatorNames["CloseFillEvenOddAndStroke"] = "b*";
    PDFOperatorNames["CloseFillNonZeroAndStroke"] = "b";
    PDFOperatorNames["ClosePath"] = "h";
    PDFOperatorNames["AppendBezierCurve"] = "c";
    PDFOperatorNames["CurveToReplicateFinalPoint"] = "y";
    PDFOperatorNames["CurveToReplicateInitialPoint"] = "v";
    PDFOperatorNames["EndPath"] = "n";
    PDFOperatorNames["FillEvenOddAndStroke"] = "B*";
    PDFOperatorNames["FillEvenOdd"] = "f*";
    PDFOperatorNames["FillNonZeroAndStroke"] = "B";
    PDFOperatorNames["FillNonZero"] = "f";
    PDFOperatorNames["LegacyFillNonZero"] = "F";
    PDFOperatorNames["LineTo"] = "l";
    PDFOperatorNames["MoveTo"] = "m";
    PDFOperatorNames["ShadingFill"] = "sh";
    PDFOperatorNames["StrokePath"] = "S";
    // Text Operators
    PDFOperatorNames["BeginText"] = "BT";
    PDFOperatorNames["EndText"] = "ET";
    PDFOperatorNames["MoveText"] = "Td";
    PDFOperatorNames["MoveTextSetLeading"] = "TD";
    PDFOperatorNames["NextLine"] = "T*";
    PDFOperatorNames["SetCharacterSpacing"] = "Tc";
    PDFOperatorNames["SetFontAndSize"] = "Tf";
    PDFOperatorNames["SetTextHorizontalScaling"] = "Tz";
    PDFOperatorNames["SetTextLineHeight"] = "TL";
    PDFOperatorNames["SetTextRenderingMode"] = "Tr";
    PDFOperatorNames["SetTextRise"] = "Ts";
    PDFOperatorNames["SetWordSpacing"] = "Tw";
    PDFOperatorNames["ShowText"] = "Tj";
    PDFOperatorNames["ShowTextAdjusted"] = "TJ";
    PDFOperatorNames["ShowTextLine"] = "'";
    PDFOperatorNames["ShowTextLineAndSpace"] = "\"";
    // Type3 Font Operators
    PDFOperatorNames["Type3D0"] = "d0";
    PDFOperatorNames["Type3D1"] = "d1";
    // Compatibility Section Operators
    PDFOperatorNames["BeginCompatibilitySection"] = "BX";
    PDFOperatorNames["EndCompatibilitySection"] = "EX";
})($27958cc2c5d88a31$var$PDFOperatorNames || ($27958cc2c5d88a31$var$PDFOperatorNames = {}));
var $27958cc2c5d88a31$export$2e2bcd8739ae039 = $27958cc2c5d88a31$var$PDFOperatorNames;



var $cOQTW = parcelRequire("cOQTW");

var $cOQTW = parcelRequire("cOQTW");

var $ckCqy = parcelRequire("ckCqy");

var $nAWRe = parcelRequire("nAWRe");

var $dPHSK = parcelRequire("dPHSK");

parcelRequire("fvYKZ");
var $clYSv = parcelRequire("clYSv");
var $2d4cf9103ab67d11$var$PDFFlateStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFFlateStream, _super);
    function PDFFlateStream(dict, encode) {
        var _this = _super.call(this, dict) || this;
        _this.computeContents = function() {
            var unencodedContents = _this.getUnencodedContents();
            return _this.encode ? (0, (/*@__PURE__*/$parcel$interopDefault($ckCqy))).deflate(unencodedContents) : unencodedContents;
        };
        _this.encode = encode;
        if (encode) dict.set((0, $dPHSK.default).of('Filter'), (0, $dPHSK.default).of('FlateDecode'));
        _this.contentsCache = (0, $clYSv.default).populatedBy(_this.computeContents);
        return _this;
    }
    PDFFlateStream.prototype.getContents = function() {
        return this.contentsCache.access();
    };
    PDFFlateStream.prototype.getContentsSize = function() {
        return this.contentsCache.access().length;
    };
    PDFFlateStream.prototype.getUnencodedContents = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'getUnencodedContents');
    };
    return PDFFlateStream;
}((0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039));
var $2d4cf9103ab67d11$export$2e2bcd8739ae039 = $2d4cf9103ab67d11$var$PDFFlateStream;



var $8zvel = parcelRequire("8zvel");
var $707f21d02e4e1bf4$var$PDFContentStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFContentStream, _super);
    function PDFContentStream(dict, operators, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, dict, encode) || this;
        _this.operators = operators;
        return _this;
    }
    PDFContentStream.prototype.push = function() {
        var _a;
        var operators = [];
        for(var _i = 0; _i < arguments.length; _i++)operators[_i] = arguments[_i];
        (_a = this.operators).push.apply(_a, operators);
    };
    PDFContentStream.prototype.clone = function(context) {
        var operators = new Array(this.operators.length);
        for(var idx = 0, len = this.operators.length; idx < len; idx++)operators[idx] = this.operators[idx].clone(context);
        var _a = this, dict = _a.dict, encode = _a.encode;
        return PDFContentStream.of(dict.clone(context), operators, encode);
    };
    PDFContentStream.prototype.getContentsString = function() {
        var value = '';
        for(var idx = 0, len = this.operators.length; idx < len; idx++)value += this.operators[idx] + "\n";
        return value;
    };
    PDFContentStream.prototype.getUnencodedContents = function() {
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = 0;
        for(var idx = 0, len = this.operators.length; idx < len; idx++){
            offset += this.operators[idx].copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Newline;
        }
        return buffer;
    };
    PDFContentStream.prototype.getUnencodedContentsSize = function() {
        var size = 0;
        for(var idx = 0, len = this.operators.length; idx < len; idx++)size += this.operators[idx].sizeInBytes() + 1;
        return size;
    };
    PDFContentStream.of = function(dict, operators, encode) {
        if (encode === void 0) encode = true;
        return new PDFContentStream(dict, operators, encode);
    };
    return PDFContentStream;
}((0, $2d4cf9103ab67d11$export$2e2bcd8739ae039));
var $707f21d02e4e1bf4$export$2e2bcd8739ae039 = $707f21d02e4e1bf4$var$PDFContentStream;


parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");
/**
 * Generates a pseudo random number. Although it is not cryptographically secure
 * and uniformly distributed, it is not a concern for the intended use-case,
 * which is to generate distinct numbers.
 *
 * Credit: https://stackoverflow.com/a/19303725/10254049
 */ var $440fb620dea1b860$export$205b650d120b95b5 = /** @class */ function() {
    function SimpleRNG(seed) {
        this.seed = seed;
    }
    SimpleRNG.prototype.nextInt = function() {
        var x = Math.sin(this.seed++) * 10000;
        return x - Math.floor(x);
    };
    SimpleRNG.withSeed = function(seed) {
        return new SimpleRNG(seed);
    };
    return SimpleRNG;
}();


var $ece91e5f61c516eb$var$byAscendingObjectNumber = function(_a, _b) {
    var a = _a[0];
    var b = _b[0];
    return a.objectNumber - b.objectNumber;
};
var $ece91e5f61c516eb$var$PDFContext = /** @class */ function() {
    function PDFContext() {
        this.largestObjectNumber = 0;
        this.header = (0, $ab35d5c6c69177c9$export$2e2bcd8739ae039).forVersion(1, 7);
        this.trailerInfo = {};
        this.indirectObjects = new Map();
        this.rng = (0, $440fb620dea1b860$export$205b650d120b95b5).withSeed(1);
    }
    PDFContext.prototype.assign = function(ref, object) {
        this.indirectObjects.set(ref, object);
        if (ref.objectNumber > this.largestObjectNumber) this.largestObjectNumber = ref.objectNumber;
    };
    PDFContext.prototype.nextRef = function() {
        this.largestObjectNumber += 1;
        return (0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(this.largestObjectNumber);
    };
    PDFContext.prototype.register = function(object) {
        var ref = this.nextRef();
        this.assign(ref, object);
        return ref;
    };
    PDFContext.prototype.delete = function(ref) {
        return this.indirectObjects.delete(ref);
    };
    PDFContext.prototype.lookupMaybe = function(ref) {
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $ad8a981877dc5d20$export$2e2bcd8739ae039));
        var result = ref instanceof (0, $f1233b848bc26abe$export$2e2bcd8739ae039) ? this.indirectObjects.get(ref) : ref;
        if (!result || result === (0, $ad8a981877dc5d20$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        for(var idx = 0, len = types.length; idx < len; idx++){
            var type = types[idx];
            if (type === (0, $ad8a981877dc5d20$export$2e2bcd8739ae039)) {
                if (result === (0, $ad8a981877dc5d20$export$2e2bcd8739ae039)) return result;
            } else {
                if (result instanceof type) return result;
            }
        }
        throw new (0, $nAWRe.UnexpectedObjectTypeError)(types, result);
    };
    PDFContext.prototype.lookup = function(ref) {
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        var result = ref instanceof (0, $f1233b848bc26abe$export$2e2bcd8739ae039) ? this.indirectObjects.get(ref) : ref;
        if (types.length === 0) return result;
        for(var idx = 0, len = types.length; idx < len; idx++){
            var type = types[idx];
            if (type === (0, $ad8a981877dc5d20$export$2e2bcd8739ae039)) {
                if (result === (0, $ad8a981877dc5d20$export$2e2bcd8739ae039)) return result;
            } else {
                if (result instanceof type) return result;
            }
        }
        throw new (0, $nAWRe.UnexpectedObjectTypeError)(types, result);
    };
    PDFContext.prototype.getObjectRef = function(pdfObject) {
        var entries = Array.from(this.indirectObjects.entries());
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], ref = _a[0], object = _a[1];
            if (object === pdfObject) return ref;
        }
        return undefined;
    };
    PDFContext.prototype.enumerateIndirectObjects = function() {
        return Array.from(this.indirectObjects.entries()).sort($ece91e5f61c516eb$var$byAscendingObjectNumber);
    };
    PDFContext.prototype.obj = function(literal) {
        if (literal instanceof (0, $11c5J.default)) return literal;
        else if (literal === null || literal === undefined) return 0, $ad8a981877dc5d20$export$2e2bcd8739ae039;
        else if (typeof literal === 'string') return (0, $dPHSK.default).of(literal);
        else if (typeof literal === 'number') return (0, $j04jt.default).of(literal);
        else if (typeof literal === 'boolean') return literal ? (0, $8gQNC.default).True : (0, $8gQNC.default).False;
        else if (Array.isArray(literal)) {
            var array = (0, $8auL6.default).withContext(this);
            for(var idx = 0, len = literal.length; idx < len; idx++)array.push(this.obj(literal[idx]));
            return array;
        } else {
            var dict = (0, $85408478fbb7cbde$export$2e2bcd8739ae039).withContext(this);
            var keys = Object.keys(literal);
            for(var idx = 0, len = keys.length; idx < len; idx++){
                var key = keys[idx];
                var value = literal[key];
                if (value !== undefined) dict.set((0, $dPHSK.default).of(key), this.obj(value));
            }
            return dict;
        }
    };
    PDFContext.prototype.stream = function(contents, dict) {
        if (dict === void 0) dict = {};
        return (0, $ef28c75b0f11042e$export$2e2bcd8739ae039).of(this.obj(dict), (0, $4ISq8.typedArrayFor)(contents));
    };
    PDFContext.prototype.flateStream = function(contents, dict) {
        if (dict === void 0) dict = {};
        return this.stream((0, (/*@__PURE__*/$parcel$interopDefault($ckCqy))).deflate((0, $4ISq8.typedArrayFor)(contents)), (0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, dict), {
            Filter: 'FlateDecode'
        }));
    };
    PDFContext.prototype.contentStream = function(operators, dict) {
        if (dict === void 0) dict = {};
        return (0, $707f21d02e4e1bf4$export$2e2bcd8739ae039).of(this.obj(dict), operators);
    };
    PDFContext.prototype.formXObject = function(operators, dict) {
        if (dict === void 0) dict = {};
        return this.contentStream(operators, (0, $cOQTW.__assign)((0, $cOQTW.__assign)({
            BBox: this.obj([
                0,
                0,
                0,
                0
            ]),
            Matrix: this.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        }, dict), {
            Type: 'XObject',
            Subtype: 'Form'
        }));
    };
    /*
     * Reference to PDFContentStream that contains a single PDFOperator: `q`.
     * Used by [[PDFPageLeaf]] instances to ensure that when content streams are
     * added to a modified PDF, they start in the default, unchanged graphics
     * state.
     */ PDFContext.prototype.getPushGraphicsStateContentStream = function() {
        if (this.pushGraphicsStateContentStreamRef) return this.pushGraphicsStateContentStreamRef;
        var dict = this.obj({});
        var op = (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).PushGraphicsState);
        var stream = (0, $707f21d02e4e1bf4$export$2e2bcd8739ae039).of(dict, [
            op
        ]);
        this.pushGraphicsStateContentStreamRef = this.register(stream);
        return this.pushGraphicsStateContentStreamRef;
    };
    /*
     * Reference to PDFContentStream that contains a single PDFOperator: `Q`.
     * Used by [[PDFPageLeaf]] instances to ensure that when content streams are
     * added to a modified PDF, they start in the default, unchanged graphics
     * state.
     */ PDFContext.prototype.getPopGraphicsStateContentStream = function() {
        if (this.popGraphicsStateContentStreamRef) return this.popGraphicsStateContentStreamRef;
        var dict = this.obj({});
        var op = (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).PopGraphicsState);
        var stream = (0, $707f21d02e4e1bf4$export$2e2bcd8739ae039).of(dict, [
            op
        ]);
        this.popGraphicsStateContentStreamRef = this.register(stream);
        return this.popGraphicsStateContentStreamRef;
    };
    PDFContext.prototype.addRandomSuffix = function(prefix, suffixLength) {
        if (suffixLength === void 0) suffixLength = 4;
        return prefix + "-" + Math.floor(this.rng.nextInt() * Math.pow(10, suffixLength));
    };
    PDFContext.create = function() {
        return new PDFContext();
    };
    return PDFContext;
}();
var $ece91e5f61c516eb$export$2e2bcd8739ae039 = $ece91e5f61c516eb$var$PDFContext;



var $8auL6 = parcelRequire("8auL6");


var $dPHSK = parcelRequire("dPHSK");



var $cOQTW = parcelRequire("cOQTW");

var $8auL6 = parcelRequire("8auL6");


var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $a9e73b7ced5abfa4$var$PDFPageLeaf = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFPageLeaf, _super);
    function PDFPageLeaf(map, context, autoNormalizeCTM) {
        if (autoNormalizeCTM === void 0) autoNormalizeCTM = true;
        var _this = _super.call(this, map, context) || this;
        _this.normalized = false;
        _this.autoNormalizeCTM = autoNormalizeCTM;
        return _this;
    }
    PDFPageLeaf.prototype.clone = function(context) {
        var clone = PDFPageLeaf.fromMapWithContext(new Map(), context || this.context, this.autoNormalizeCTM);
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            clone.set(key, value);
        }
        return clone;
    };
    PDFPageLeaf.prototype.Parent = function() {
        return this.lookupMaybe((0, $dPHSK.default).Parent, (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
    };
    PDFPageLeaf.prototype.Contents = function() {
        return this.lookup((0, $dPHSK.default).of('Contents'));
    };
    PDFPageLeaf.prototype.Annots = function() {
        return this.lookupMaybe((0, $dPHSK.default).Annots, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.BleedBox = function() {
        return this.lookupMaybe((0, $dPHSK.default).BleedBox, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.TrimBox = function() {
        return this.lookupMaybe((0, $dPHSK.default).TrimBox, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.ArtBox = function() {
        return this.lookupMaybe((0, $dPHSK.default).ArtBox, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.Resources = function() {
        var dictOrRef = this.getInheritableAttribute((0, $dPHSK.default).Resources);
        return this.context.lookupMaybe(dictOrRef, (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
    };
    PDFPageLeaf.prototype.MediaBox = function() {
        var arrayOrRef = this.getInheritableAttribute((0, $dPHSK.default).MediaBox);
        return this.context.lookup(arrayOrRef, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.CropBox = function() {
        var arrayOrRef = this.getInheritableAttribute((0, $dPHSK.default).CropBox);
        return this.context.lookupMaybe(arrayOrRef, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.Rotate = function() {
        var numberOrRef = this.getInheritableAttribute((0, $dPHSK.default).Rotate);
        return this.context.lookupMaybe(numberOrRef, (0, $j04jt.default));
    };
    PDFPageLeaf.prototype.getInheritableAttribute = function(name) {
        var attribute;
        this.ascend(function(node) {
            if (!attribute) attribute = node.get(name);
        });
        return attribute;
    };
    PDFPageLeaf.prototype.setParent = function(parentRef) {
        this.set((0, $dPHSK.default).Parent, parentRef);
    };
    PDFPageLeaf.prototype.addContentStream = function(contentStreamRef) {
        var Contents = this.normalizedEntries().Contents || this.context.obj([]);
        this.set((0, $dPHSK.default).Contents, Contents);
        Contents.push(contentStreamRef);
    };
    PDFPageLeaf.prototype.wrapContentStreams = function(startStream, endStream) {
        var Contents = this.Contents();
        if (Contents instanceof (0, $8auL6.default)) {
            Contents.insert(0, startStream);
            Contents.push(endStream);
            return true;
        }
        return false;
    };
    PDFPageLeaf.prototype.addAnnot = function(annotRef) {
        var Annots = this.normalizedEntries().Annots;
        Annots.push(annotRef);
    };
    PDFPageLeaf.prototype.removeAnnot = function(annotRef) {
        var Annots = this.normalizedEntries().Annots;
        var index = Annots.indexOf(annotRef);
        if (index !== undefined) Annots.remove(index);
    };
    PDFPageLeaf.prototype.setFontDictionary = function(name, fontDictRef) {
        var Font = this.normalizedEntries().Font;
        Font.set(name, fontDictRef);
    };
    PDFPageLeaf.prototype.newFontDictionaryKey = function(tag) {
        var Font = this.normalizedEntries().Font;
        return Font.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newFontDictionary = function(tag, fontDictRef) {
        var key = this.newFontDictionaryKey(tag);
        this.setFontDictionary(key, fontDictRef);
        return key;
    };
    PDFPageLeaf.prototype.setXObject = function(name, xObjectRef) {
        var XObject = this.normalizedEntries().XObject;
        XObject.set(name, xObjectRef);
    };
    PDFPageLeaf.prototype.newXObjectKey = function(tag) {
        var XObject = this.normalizedEntries().XObject;
        return XObject.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newXObject = function(tag, xObjectRef) {
        var key = this.newXObjectKey(tag);
        this.setXObject(key, xObjectRef);
        return key;
    };
    PDFPageLeaf.prototype.setExtGState = function(name, extGStateRef) {
        var ExtGState = this.normalizedEntries().ExtGState;
        ExtGState.set(name, extGStateRef);
    };
    PDFPageLeaf.prototype.newExtGStateKey = function(tag) {
        var ExtGState = this.normalizedEntries().ExtGState;
        return ExtGState.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newExtGState = function(tag, extGStateRef) {
        var key = this.newExtGStateKey(tag);
        this.setExtGState(key, extGStateRef);
        return key;
    };
    PDFPageLeaf.prototype.ascend = function(visitor) {
        visitor(this);
        var Parent = this.Parent();
        if (Parent) Parent.ascend(visitor);
    };
    PDFPageLeaf.prototype.normalize = function() {
        if (this.normalized) return;
        var context = this.context;
        var contentsRef = this.get((0, $dPHSK.default).Contents);
        var contents = this.context.lookup(contentsRef);
        if (contents instanceof (0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039)) this.set((0, $dPHSK.default).Contents, context.obj([
            contentsRef
        ]));
        if (this.autoNormalizeCTM) this.wrapContentStreams(this.context.getPushGraphicsStateContentStream(), this.context.getPopGraphicsStateContentStream());
        // TODO: Clone `Resources` if it is inherited
        var dictOrRef = this.getInheritableAttribute((0, $dPHSK.default).Resources);
        var Resources = context.lookupMaybe(dictOrRef, (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) || context.obj({});
        this.set((0, $dPHSK.default).Resources, Resources);
        // TODO: Clone `Font` if it is inherited
        var Font = Resources.lookupMaybe((0, $dPHSK.default).Font, (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) || context.obj({});
        Resources.set((0, $dPHSK.default).Font, Font);
        // TODO: Clone `XObject` if it is inherited
        var XObject = Resources.lookupMaybe((0, $dPHSK.default).XObject, (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) || context.obj({});
        Resources.set((0, $dPHSK.default).XObject, XObject);
        // TODO: Clone `ExtGState` if it is inherited
        var ExtGState = Resources.lookupMaybe((0, $dPHSK.default).ExtGState, (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) || context.obj({});
        Resources.set((0, $dPHSK.default).ExtGState, ExtGState);
        var Annots = this.Annots() || context.obj([]);
        this.set((0, $dPHSK.default).Annots, Annots);
        this.normalized = true;
    };
    PDFPageLeaf.prototype.normalizedEntries = function() {
        this.normalize();
        var Annots = this.Annots();
        var Resources = this.Resources();
        var Contents = this.Contents();
        return {
            Annots: Annots,
            Resources: Resources,
            Contents: Contents,
            Font: Resources.lookup((0, $dPHSK.default).Font, (0, $85408478fbb7cbde$export$2e2bcd8739ae039)),
            XObject: Resources.lookup((0, $dPHSK.default).XObject, (0, $85408478fbb7cbde$export$2e2bcd8739ae039)),
            ExtGState: Resources.lookup((0, $dPHSK.default).ExtGState, (0, $85408478fbb7cbde$export$2e2bcd8739ae039))
        };
    };
    PDFPageLeaf.InheritableEntries = [
        'Resources',
        'MediaBox',
        'CropBox',
        'Rotate'
    ];
    PDFPageLeaf.withContextAndParent = function(context, parent) {
        var dict = new Map();
        dict.set((0, $dPHSK.default).Type, (0, $dPHSK.default).Page);
        dict.set((0, $dPHSK.default).Parent, parent);
        dict.set((0, $dPHSK.default).Resources, context.obj({}));
        dict.set((0, $dPHSK.default).MediaBox, context.obj([
            0,
            0,
            612,
            792
        ]));
        return new PDFPageLeaf(dict, context, false);
    };
    PDFPageLeaf.fromMapWithContext = function(map, context, autoNormalizeCTM) {
        if (autoNormalizeCTM === void 0) autoNormalizeCTM = true;
        return new PDFPageLeaf(map, context, autoNormalizeCTM);
    };
    return PDFPageLeaf;
}((0, $85408478fbb7cbde$export$2e2bcd8739ae039));
var $a9e73b7ced5abfa4$export$2e2bcd8739ae039 = $a9e73b7ced5abfa4$var$PDFPageLeaf;


/**
 * PDFObjectCopier copies PDFObjects from a src context to a dest context.
 * The primary use case for this is to copy pages between PDFs.
 *
 * _Copying_ an object with a PDFObjectCopier is different from _cloning_ an
 * object with its [[PDFObject.clone]] method:
 *
 * ```
 *   const src: PDFContext = ...
 *   const dest: PDFContext = ...
 *   const originalObject: PDFObject = ...
 *   const copiedObject = PDFObjectCopier.for(src, dest).copy(originalObject);
 *   const clonedObject = originalObject.clone();
 * ```
 *
 * Copying an object is equivalent to cloning it and then copying over any other
 * objects that it references. Note that only dictionaries, arrays, and streams
 * (or structures build from them) can contain indirect references to other
 * objects. Copying a PDFObject that is not a dictionary, array, or stream is
 * supported, but is equivalent to cloning it.
 */ var $ea102798c96bfd06$var$PDFObjectCopier = /** @class */ function() {
    function PDFObjectCopier(src, dest) {
        var _this = this;
        this.traversedObjects = new Map();
        // prettier-ignore
        this.copy = function(object) {
            return object instanceof (0, $a9e73b7ced5abfa4$export$2e2bcd8739ae039) ? _this.copyPDFPage(object) : object instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039) ? _this.copyPDFDict(object) : object instanceof (0, $8auL6.default) ? _this.copyPDFArray(object) : object instanceof (0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039) ? _this.copyPDFStream(object) : object instanceof (0, $f1233b848bc26abe$export$2e2bcd8739ae039) ? _this.copyPDFIndirectObject(object) : object.clone();
        };
        this.copyPDFPage = function(originalPage) {
            var clonedPage = originalPage.clone();
            // Move any entries that the originalPage is inheriting from its parent
            // tree nodes directly into originalPage so they are preserved during
            // the copy.
            var InheritableEntries = (0, $a9e73b7ced5abfa4$export$2e2bcd8739ae039).InheritableEntries;
            for(var idx = 0, len = InheritableEntries.length; idx < len; idx++){
                var key = (0, $dPHSK.default).of(InheritableEntries[idx]);
                var value = clonedPage.getInheritableAttribute(key);
                if (!clonedPage.get(key) && value) clonedPage.set(key, value);
            }
            // Remove the parent reference to prevent the whole donor document's page
            // tree from being copied when we only need a single page.
            clonedPage.delete((0, $dPHSK.default).of('Parent'));
            return _this.copyPDFDict(clonedPage);
        };
        this.copyPDFDict = function(originalDict) {
            if (_this.traversedObjects.has(originalDict)) return _this.traversedObjects.get(originalDict);
            var clonedDict = originalDict.clone(_this.dest);
            _this.traversedObjects.set(originalDict, clonedDict);
            var entries = originalDict.entries();
            for(var idx = 0, len = entries.length; idx < len; idx++){
                var _a = entries[idx], key = _a[0], value = _a[1];
                clonedDict.set(key, _this.copy(value));
            }
            return clonedDict;
        };
        this.copyPDFArray = function(originalArray) {
            if (_this.traversedObjects.has(originalArray)) return _this.traversedObjects.get(originalArray);
            var clonedArray = originalArray.clone(_this.dest);
            _this.traversedObjects.set(originalArray, clonedArray);
            for(var idx = 0, len = originalArray.size(); idx < len; idx++){
                var value = originalArray.get(idx);
                clonedArray.set(idx, _this.copy(value));
            }
            return clonedArray;
        };
        this.copyPDFStream = function(originalStream) {
            if (_this.traversedObjects.has(originalStream)) return _this.traversedObjects.get(originalStream);
            var clonedStream = originalStream.clone(_this.dest);
            _this.traversedObjects.set(originalStream, clonedStream);
            var entries = originalStream.dict.entries();
            for(var idx = 0, len = entries.length; idx < len; idx++){
                var _a = entries[idx], key = _a[0], value = _a[1];
                clonedStream.dict.set(key, _this.copy(value));
            }
            return clonedStream;
        };
        this.copyPDFIndirectObject = function(ref) {
            var alreadyMapped = _this.traversedObjects.has(ref);
            if (!alreadyMapped) {
                var newRef = _this.dest.nextRef();
                _this.traversedObjects.set(ref, newRef);
                var dereferencedValue = _this.src.lookup(ref);
                if (dereferencedValue) {
                    var cloned = _this.copy(dereferencedValue);
                    _this.dest.assign(newRef, cloned);
                }
            }
            return _this.traversedObjects.get(ref);
        };
        this.src = src;
        this.dest = dest;
    }
    PDFObjectCopier.for = function(src, dest) {
        return new PDFObjectCopier(src, dest);
    };
    return PDFObjectCopier;
}();
var $ea102798c96bfd06$export$2e2bcd8739ae039 = $ea102798c96bfd06$var$PDFObjectCopier;



var $cOQTW = parcelRequire("cOQTW");


var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
/**
 * Entries should be added using the [[addEntry]] and [[addDeletedEntry]]
 * methods **in order of ascending object number**.
 */ var $0acfb4f0f4898246$var$PDFCrossRefSection = /** @class */ function() {
    function PDFCrossRefSection(firstEntry) {
        this.subsections = firstEntry ? [
            [
                firstEntry
            ]
        ] : [];
        this.chunkIdx = 0;
        this.chunkLength = firstEntry ? 1 : 0;
    }
    PDFCrossRefSection.prototype.addEntry = function(ref, offset) {
        this.append({
            ref: ref,
            offset: offset,
            deleted: false
        });
    };
    PDFCrossRefSection.prototype.addDeletedEntry = function(ref, nextFreeObjectNumber) {
        this.append({
            ref: ref,
            offset: nextFreeObjectNumber,
            deleted: true
        });
    };
    PDFCrossRefSection.prototype.toString = function() {
        var section = "xref\n";
        for(var rangeIdx = 0, rangeLen = this.subsections.length; rangeIdx < rangeLen; rangeIdx++){
            var range = this.subsections[rangeIdx];
            section += range[0].ref.objectNumber + " " + range.length + "\n";
            for(var entryIdx = 0, entryLen = range.length; entryIdx < entryLen; entryIdx++){
                var entry = range[entryIdx];
                section += (0, $7Kmy8.padStart)(String(entry.offset), 10, '0');
                section += ' ';
                section += (0, $7Kmy8.padStart)(String(entry.ref.generationNumber), 5, '0');
                section += ' ';
                section += entry.deleted ? 'f' : 'n';
                section += ' \n';
            }
        }
        return section;
    };
    PDFCrossRefSection.prototype.sizeInBytes = function() {
        var size = 5;
        for(var idx = 0, len = this.subsections.length; idx < len; idx++){
            var subsection = this.subsections[idx];
            var subsectionLength = subsection.length;
            var firstEntry = subsection[0];
            size += 2;
            size += String(firstEntry.ref.objectNumber).length;
            size += String(subsectionLength).length;
            size += 20 * subsectionLength;
        }
        return size;
    };
    PDFCrossRefSection.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).x;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).f;
        buffer[offset++] = (0, $8zvel.default).Newline;
        offset += this.copySubsectionsIntoBuffer(this.subsections, buffer, offset);
        return offset - initialOffset;
    };
    PDFCrossRefSection.prototype.copySubsectionsIntoBuffer = function(subsections, buffer, offset) {
        var initialOffset = offset;
        var length = subsections.length;
        for(var idx = 0; idx < length; idx++){
            var subsection = this.subsections[idx];
            var firstObjectNumber = String(subsection[0].ref.objectNumber);
            offset += (0, $7Kmy8.copyStringIntoBuffer)(firstObjectNumber, buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
            var rangeLength = String(subsection.length);
            offset += (0, $7Kmy8.copyStringIntoBuffer)(rangeLength, buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Newline;
            offset += this.copyEntriesIntoBuffer(subsection, buffer, offset);
        }
        return offset - initialOffset;
    };
    PDFCrossRefSection.prototype.copyEntriesIntoBuffer = function(entries, buffer, offset) {
        var length = entries.length;
        for(var idx = 0; idx < length; idx++){
            var entry = entries[idx];
            var entryOffset = (0, $7Kmy8.padStart)(String(entry.offset), 10, '0');
            offset += (0, $7Kmy8.copyStringIntoBuffer)(entryOffset, buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
            var entryGen = (0, $7Kmy8.padStart)(String(entry.ref.generationNumber), 5, '0');
            offset += (0, $7Kmy8.copyStringIntoBuffer)(entryGen, buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
            buffer[offset++] = entry.deleted ? (0, $8zvel.default).f : (0, $8zvel.default).n;
            buffer[offset++] = (0, $8zvel.default).Space;
            buffer[offset++] = (0, $8zvel.default).Newline;
        }
        return 20 * length;
    };
    PDFCrossRefSection.prototype.append = function(currEntry) {
        if (this.chunkLength === 0) {
            this.subsections.push([
                currEntry
            ]);
            this.chunkIdx = 0;
            this.chunkLength = 1;
            return;
        }
        var chunk = this.subsections[this.chunkIdx];
        var prevEntry = chunk[this.chunkLength - 1];
        if (currEntry.ref.objectNumber - prevEntry.ref.objectNumber > 1) {
            this.subsections.push([
                currEntry
            ]);
            this.chunkIdx += 1;
            this.chunkLength = 1;
        } else {
            chunk.push(currEntry);
            this.chunkLength += 1;
        }
    };
    PDFCrossRefSection.create = function() {
        return new PDFCrossRefSection({
            ref: (0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(0, 65535),
            offset: 0,
            deleted: true
        });
    };
    PDFCrossRefSection.createEmpty = function() {
        return new PDFCrossRefSection();
    };
    return PDFCrossRefSection;
}();
var $0acfb4f0f4898246$export$2e2bcd8739ae039 = $0acfb4f0f4898246$var$PDFCrossRefSection;




var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $38bebcf76e0d2d54$var$PDFTrailer = /** @class */ function() {
    function PDFTrailer(lastXRefOffset) {
        this.lastXRefOffset = String(lastXRefOffset);
    }
    PDFTrailer.prototype.toString = function() {
        return "startxref\n" + this.lastXRefOffset + "\n%%EOF";
    };
    PDFTrailer.prototype.sizeInBytes = function() {
        return 16 + this.lastXRefOffset.length;
    };
    PDFTrailer.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).s;
        buffer[offset++] = (0, $8zvel.default).t;
        buffer[offset++] = (0, $8zvel.default).a;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).t;
        buffer[offset++] = (0, $8zvel.default).x;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).f;
        buffer[offset++] = (0, $8zvel.default).Newline;
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.lastXRefOffset, buffer, offset);
        buffer[offset++] = (0, $8zvel.default).Newline;
        buffer[offset++] = (0, $8zvel.default).Percent;
        buffer[offset++] = (0, $8zvel.default).Percent;
        buffer[offset++] = (0, $8zvel.default).E;
        buffer[offset++] = (0, $8zvel.default).O;
        buffer[offset++] = (0, $8zvel.default).F;
        return offset - initialOffset;
    };
    PDFTrailer.forLastCrossRefSectionOffset = function(offset) {
        return new PDFTrailer(offset);
    };
    return PDFTrailer;
}();
var $38bebcf76e0d2d54$export$2e2bcd8739ae039 = $38bebcf76e0d2d54$var$PDFTrailer;



var $8zvel = parcelRequire("8zvel");
var $b9d4f51bf55d54ab$var$PDFTrailerDict = /** @class */ function() {
    function PDFTrailerDict(dict) {
        this.dict = dict;
    }
    PDFTrailerDict.prototype.toString = function() {
        return "trailer\n" + this.dict.toString();
    };
    PDFTrailerDict.prototype.sizeInBytes = function() {
        return 8 + this.dict.sizeInBytes();
    };
    PDFTrailerDict.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).t;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).a;
        buffer[offset++] = (0, $8zvel.default).i;
        buffer[offset++] = (0, $8zvel.default).l;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).Newline;
        offset += this.dict.copyBytesInto(buffer, offset);
        return offset - initialOffset;
    };
    PDFTrailerDict.of = function(dict) {
        return new PDFTrailerDict(dict);
    };
    return PDFTrailerDict;
}();
var $b9d4f51bf55d54ab$export$2e2bcd8739ae039 = $b9d4f51bf55d54ab$var$PDFTrailerDict;



var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");


var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $4ISq8 = parcelRequire("4ISq8");
var $61a4452f4878bba9$var$PDFObjectStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFObjectStream, _super);
    function PDFObjectStream(context, objects, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, context.obj({}), encode) || this;
        _this.objects = objects;
        _this.offsets = _this.computeObjectOffsets();
        _this.offsetsString = _this.computeOffsetsString();
        _this.dict.set((0, $dPHSK.default).of('Type'), (0, $dPHSK.default).of('ObjStm'));
        _this.dict.set((0, $dPHSK.default).of('N'), (0, $j04jt.default).of(_this.objects.length));
        _this.dict.set((0, $dPHSK.default).of('First'), (0, $j04jt.default).of(_this.offsetsString.length));
        return _this;
    }
    PDFObjectStream.prototype.getObjectsCount = function() {
        return this.objects.length;
    };
    PDFObjectStream.prototype.clone = function(context) {
        return PDFObjectStream.withContextAndObjects(context || this.dict.context, this.objects.slice(), this.encode);
    };
    PDFObjectStream.prototype.getContentsString = function() {
        var value = this.offsetsString;
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], object = _a[1];
            value += object + "\n";
        }
        return value;
    };
    PDFObjectStream.prototype.getUnencodedContents = function() {
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = (0, $7Kmy8.copyStringIntoBuffer)(this.offsetsString, buffer, 0);
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], object = _a[1];
            offset += object.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Newline;
        }
        return buffer;
    };
    PDFObjectStream.prototype.getUnencodedContentsSize = function() {
        return this.offsetsString.length + (0, $4ISq8.last)(this.offsets)[1] + (0, $4ISq8.last)(this.objects)[1].sizeInBytes() + 1;
    };
    PDFObjectStream.prototype.computeOffsetsString = function() {
        var offsetsString = '';
        for(var idx = 0, len = this.offsets.length; idx < len; idx++){
            var _a = this.offsets[idx], objectNumber = _a[0], offset = _a[1];
            offsetsString += objectNumber + " " + offset + " ";
        }
        return offsetsString;
    };
    PDFObjectStream.prototype.computeObjectOffsets = function() {
        var offset = 0;
        var offsets = new Array(this.objects.length);
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], ref = _a[0], object = _a[1];
            offsets[idx] = [
                ref.objectNumber,
                offset
            ];
            offset += object.sizeInBytes() + 1; // '\n'
        }
        return offsets;
    };
    PDFObjectStream.withContextAndObjects = function(context, objects, encode) {
        if (encode === void 0) encode = true;
        return new PDFObjectStream(context, objects, encode);
    };
    return PDFObjectStream;
}((0, $2d4cf9103ab67d11$export$2e2bcd8739ae039));
var $61a4452f4878bba9$export$2e2bcd8739ae039 = $61a4452f4878bba9$var$PDFObjectStream;



var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $ggjMi = parcelRequire("ggjMi");
var $4261dca68d44d2dc$var$PDFWriter = /** @class */ function() {
    function PDFWriter(context, objectsPerTick) {
        var _this = this;
        this.parsedObjects = 0;
        this.shouldWaitForTick = function(n) {
            _this.parsedObjects += n;
            return _this.parsedObjects % _this.objectsPerTick === 0;
        };
        this.context = context;
        this.objectsPerTick = objectsPerTick;
    }
    PDFWriter.prototype.serializeToBuffer = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, size, header, indirectObjects, xref, trailerDict, trailer, offset, buffer, idx, len, _b, ref, object, objectNumber, generationNumber, n;
            return (0, $cOQTW.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.computeBufferSize()
                        ];
                    case 1:
                        _a = _c.sent(), size = _a.size, header = _a.header, indirectObjects = _a.indirectObjects, xref = _a.xref, trailerDict = _a.trailerDict, trailer = _a.trailer;
                        offset = 0;
                        buffer = new Uint8Array(size);
                        offset += header.copyBytesInto(buffer, offset);
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        idx = 0, len = indirectObjects.length;
                        _c.label = 2;
                    case 2:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            5
                        ];
                        _b = indirectObjects[idx], ref = _b[0], object = _b[1];
                        objectNumber = String(ref.objectNumber);
                        offset += (0, $7Kmy8.copyStringIntoBuffer)(objectNumber, buffer, offset);
                        buffer[offset++] = (0, $8zvel.default).Space;
                        generationNumber = String(ref.generationNumber);
                        offset += (0, $7Kmy8.copyStringIntoBuffer)(generationNumber, buffer, offset);
                        buffer[offset++] = (0, $8zvel.default).Space;
                        buffer[offset++] = (0, $8zvel.default).o;
                        buffer[offset++] = (0, $8zvel.default).b;
                        buffer[offset++] = (0, $8zvel.default).j;
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        offset += object.copyBytesInto(buffer, offset);
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        buffer[offset++] = (0, $8zvel.default).e;
                        buffer[offset++] = (0, $8zvel.default).n;
                        buffer[offset++] = (0, $8zvel.default).d;
                        buffer[offset++] = (0, $8zvel.default).o;
                        buffer[offset++] = (0, $8zvel.default).b;
                        buffer[offset++] = (0, $8zvel.default).j;
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        n = object instanceof (0, $61a4452f4878bba9$export$2e2bcd8739ae039) ? object.getObjectsCount() : 1;
                        if (!this.shouldWaitForTick(n)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4:
                        idx++;
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        if (xref) {
                            offset += xref.copyBytesInto(buffer, offset);
                            buffer[offset++] = (0, $8zvel.default).Newline;
                        }
                        if (trailerDict) {
                            offset += trailerDict.copyBytesInto(buffer, offset);
                            buffer[offset++] = (0, $8zvel.default).Newline;
                            buffer[offset++] = (0, $8zvel.default).Newline;
                        }
                        offset += trailer.copyBytesInto(buffer, offset);
                        return [
                            2 /*return*/ ,
                            buffer
                        ];
                }
            });
        });
    };
    PDFWriter.prototype.computeIndirectObjectSize = function(_a) {
        var ref = _a[0], object = _a[1];
        var refSize = ref.sizeInBytes() + 3; // 'R' -> 'obj\n'
        var objectSize = object.sizeInBytes() + 9; // '\nendobj\n\n'
        return refSize + objectSize;
    };
    PDFWriter.prototype.createTrailerDict = function() {
        return this.context.obj({
            Size: this.context.largestObjectNumber + 1,
            Root: this.context.trailerInfo.Root,
            Encrypt: this.context.trailerInfo.Encrypt,
            Info: this.context.trailerInfo.Info,
            ID: this.context.trailerInfo.ID
        });
    };
    PDFWriter.prototype.computeBufferSize = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var header, size, xref, indirectObjects, idx, len, indirectObject, ref, xrefOffset, trailerDict, trailer;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        header = (0, $ab35d5c6c69177c9$export$2e2bcd8739ae039).forVersion(1, 7);
                        size = header.sizeInBytes() + 2;
                        xref = (0, $0acfb4f0f4898246$export$2e2bcd8739ae039).create();
                        indirectObjects = this.context.enumerateIndirectObjects();
                        idx = 0, len = indirectObjects.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        indirectObject = indirectObjects[idx];
                        ref = indirectObject[0];
                        xref.addEntry(ref, size);
                        size += this.computeIndirectObjectSize(indirectObject);
                        if (!this.shouldWaitForTick(1)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        xrefOffset = size;
                        size += xref.sizeInBytes() + 1; // '\n'
                        trailerDict = (0, $b9d4f51bf55d54ab$export$2e2bcd8739ae039).of(this.createTrailerDict());
                        size += trailerDict.sizeInBytes() + 2; // '\n\n'
                        trailer = (0, $38bebcf76e0d2d54$export$2e2bcd8739ae039).forLastCrossRefSectionOffset(xrefOffset);
                        size += trailer.sizeInBytes();
                        return [
                            2 /*return*/ ,
                            {
                                size: size,
                                header: header,
                                indirectObjects: indirectObjects,
                                xref: xref,
                                trailerDict: trailerDict,
                                trailer: trailer
                            }
                        ];
                }
            });
        });
    };
    PDFWriter.forContext = function(context, objectsPerTick) {
        return new PDFWriter(context, objectsPerTick);
    };
    return PDFWriter;
}();
var $4261dca68d44d2dc$export$2e2bcd8739ae039 = $4261dca68d44d2dc$var$PDFWriter;



var $cOQTW = parcelRequire("cOQTW");



var $cOQTW = parcelRequire("cOQTW");

var $11c5J = parcelRequire("11c5J");
var $ad9390730b9495a5$var$PDFInvalidObject = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFInvalidObject, _super);
    function PDFInvalidObject(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    PDFInvalidObject.prototype.clone = function() {
        return PDFInvalidObject.of(this.data.slice());
    };
    PDFInvalidObject.prototype.toString = function() {
        return "PDFInvalidObject(" + this.data.length + " bytes)";
    };
    PDFInvalidObject.prototype.sizeInBytes = function() {
        return this.data.length;
    };
    PDFInvalidObject.prototype.copyBytesInto = function(buffer, offset) {
        var length = this.data.length;
        for(var idx = 0; idx < length; idx++)buffer[offset++] = this.data[idx];
        return length;
    };
    PDFInvalidObject.of = function(data) {
        return new PDFInvalidObject(data);
    };
    return PDFInvalidObject;
}((0, $11c5J.default));
var $ad9390730b9495a5$export$2e2bcd8739ae039 = $ad9390730b9495a5$var$PDFInvalidObject;



var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");



var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");


parcelRequire("fvYKZ");
var $hiEdU = parcelRequire("hiEdU");
var $clYSv = parcelRequire("clYSv");
var $4ISq8 = parcelRequire("4ISq8");
var $ac24be9f2612b58f$export$e41c32906b33062a;
(function(EntryType) {
    EntryType[EntryType["Deleted"] = 0] = "Deleted";
    EntryType[EntryType["Uncompressed"] = 1] = "Uncompressed";
    EntryType[EntryType["Compressed"] = 2] = "Compressed";
})($ac24be9f2612b58f$export$e41c32906b33062a || ($ac24be9f2612b58f$export$e41c32906b33062a = {}));
/**
 * Entries should be added using the [[addDeletedEntry]],
 * [[addUncompressedEntry]], and [[addCompressedEntry]] methods
 * **in order of ascending object number**.
 */ var $ac24be9f2612b58f$var$PDFCrossRefStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFCrossRefStream, _super);
    function PDFCrossRefStream(dict, entries, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, dict, encode) || this;
        // Returns an array of integer pairs for each subsection of the cross ref
        // section, where each integer pair represents:
        //   firstObjectNumber(OfSection), length(OfSection)
        _this.computeIndex = function() {
            var subsections = [];
            var subsectionLength = 0;
            for(var idx = 0, len = _this.entries.length; idx < len; idx++){
                var currEntry = _this.entries[idx];
                var prevEntry = _this.entries[idx - 1];
                if (idx === 0) subsections.push(currEntry.ref.objectNumber);
                else if (currEntry.ref.objectNumber - prevEntry.ref.objectNumber > 1) {
                    subsections.push(subsectionLength);
                    subsections.push(currEntry.ref.objectNumber);
                    subsectionLength = 0;
                }
                subsectionLength += 1;
            }
            subsections.push(subsectionLength);
            return subsections;
        };
        _this.computeEntryTuples = function() {
            var entryTuples = new Array(_this.entries.length);
            for(var idx = 0, len = _this.entries.length; idx < len; idx++){
                var entry = _this.entries[idx];
                if (entry.type === $ac24be9f2612b58f$export$e41c32906b33062a.Deleted) {
                    var type = entry.type, nextFreeObjectNumber = entry.nextFreeObjectNumber, ref = entry.ref;
                    entryTuples[idx] = [
                        type,
                        nextFreeObjectNumber,
                        ref.generationNumber
                    ];
                }
                if (entry.type === $ac24be9f2612b58f$export$e41c32906b33062a.Uncompressed) {
                    var type = entry.type, offset = entry.offset, ref = entry.ref;
                    entryTuples[idx] = [
                        type,
                        offset,
                        ref.generationNumber
                    ];
                }
                if (entry.type === $ac24be9f2612b58f$export$e41c32906b33062a.Compressed) {
                    var type = entry.type, objectStreamRef = entry.objectStreamRef, index = entry.index;
                    entryTuples[idx] = [
                        type,
                        objectStreamRef.objectNumber,
                        index
                    ];
                }
            }
            return entryTuples;
        };
        _this.computeMaxEntryByteWidths = function() {
            var entryTuples = _this.entryTuplesCache.access();
            var widths = [
                0,
                0,
                0
            ];
            for(var idx = 0, len = entryTuples.length; idx < len; idx++){
                var _a = entryTuples[idx], first = _a[0], second = _a[1], third = _a[2];
                var firstSize = (0, $hiEdU.sizeInBytes)(first);
                var secondSize = (0, $hiEdU.sizeInBytes)(second);
                var thirdSize = (0, $hiEdU.sizeInBytes)(third);
                if (firstSize > widths[0]) widths[0] = firstSize;
                if (secondSize > widths[1]) widths[1] = secondSize;
                if (thirdSize > widths[2]) widths[2] = thirdSize;
            }
            return widths;
        };
        _this.entries = entries || [];
        _this.entryTuplesCache = (0, $clYSv.default).populatedBy(_this.computeEntryTuples);
        _this.maxByteWidthsCache = (0, $clYSv.default).populatedBy(_this.computeMaxEntryByteWidths);
        _this.indexCache = (0, $clYSv.default).populatedBy(_this.computeIndex);
        dict.set((0, $dPHSK.default).of('Type'), (0, $dPHSK.default).of('XRef'));
        return _this;
    }
    PDFCrossRefStream.prototype.addDeletedEntry = function(ref, nextFreeObjectNumber) {
        var type = $ac24be9f2612b58f$export$e41c32906b33062a.Deleted;
        this.entries.push({
            type: type,
            ref: ref,
            nextFreeObjectNumber: nextFreeObjectNumber
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.addUncompressedEntry = function(ref, offset) {
        var type = $ac24be9f2612b58f$export$e41c32906b33062a.Uncompressed;
        this.entries.push({
            type: type,
            ref: ref,
            offset: offset
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.addCompressedEntry = function(ref, objectStreamRef, index) {
        var type = $ac24be9f2612b58f$export$e41c32906b33062a.Compressed;
        this.entries.push({
            type: type,
            ref: ref,
            objectStreamRef: objectStreamRef,
            index: index
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.clone = function(context) {
        var _a = this, dict = _a.dict, entries = _a.entries, encode = _a.encode;
        return PDFCrossRefStream.of(dict.clone(context), entries.slice(), encode);
    };
    PDFCrossRefStream.prototype.getContentsString = function() {
        var entryTuples = this.entryTuplesCache.access();
        var byteWidths = this.maxByteWidthsCache.access();
        var value = '';
        for(var entryIdx = 0, entriesLen = entryTuples.length; entryIdx < entriesLen; entryIdx++){
            var _a = entryTuples[entryIdx], first = _a[0], second = _a[1], third = _a[2];
            var firstBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(first));
            var secondBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(second));
            var thirdBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(third));
            for(var idx = byteWidths[0] - 1; idx >= 0; idx--)value += (firstBytes[idx] || 0).toString(2);
            for(var idx = byteWidths[1] - 1; idx >= 0; idx--)value += (secondBytes[idx] || 0).toString(2);
            for(var idx = byteWidths[2] - 1; idx >= 0; idx--)value += (thirdBytes[idx] || 0).toString(2);
        }
        return value;
    };
    PDFCrossRefStream.prototype.getUnencodedContents = function() {
        var entryTuples = this.entryTuplesCache.access();
        var byteWidths = this.maxByteWidthsCache.access();
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = 0;
        for(var entryIdx = 0, entriesLen = entryTuples.length; entryIdx < entriesLen; entryIdx++){
            var _a = entryTuples[entryIdx], first = _a[0], second = _a[1], third = _a[2];
            var firstBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(first));
            var secondBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(second));
            var thirdBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(third));
            for(var idx = byteWidths[0] - 1; idx >= 0; idx--)buffer[offset++] = firstBytes[idx] || 0;
            for(var idx = byteWidths[1] - 1; idx >= 0; idx--)buffer[offset++] = secondBytes[idx] || 0;
            for(var idx = byteWidths[2] - 1; idx >= 0; idx--)buffer[offset++] = thirdBytes[idx] || 0;
        }
        return buffer;
    };
    PDFCrossRefStream.prototype.getUnencodedContentsSize = function() {
        var byteWidths = this.maxByteWidthsCache.access();
        var entryWidth = (0, $4ISq8.sum)(byteWidths);
        return entryWidth * this.entries.length;
    };
    PDFCrossRefStream.prototype.updateDict = function() {
        _super.prototype.updateDict.call(this);
        var byteWidths = this.maxByteWidthsCache.access();
        var index = this.indexCache.access();
        var context = this.dict.context;
        this.dict.set((0, $dPHSK.default).of('W'), context.obj(byteWidths));
        this.dict.set((0, $dPHSK.default).of('Index'), context.obj(index));
    };
    PDFCrossRefStream.create = function(dict, encode) {
        if (encode === void 0) encode = true;
        var stream = new PDFCrossRefStream(dict, [], encode);
        stream.addDeletedEntry((0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(0, 65535), 0);
        return stream;
    };
    PDFCrossRefStream.of = function(dict, entries, encode) {
        if (encode === void 0) encode = true;
        return new PDFCrossRefStream(dict, entries, encode);
    };
    return PDFCrossRefStream;
}((0, $2d4cf9103ab67d11$export$2e2bcd8739ae039));
var $ac24be9f2612b58f$export$2e2bcd8739ae039 = $ac24be9f2612b58f$var$PDFCrossRefStream;




parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");
var $ggjMi = parcelRequire("ggjMi");
var $5cd89dbe12e59987$var$PDFStreamWriter = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFStreamWriter, _super);
    function PDFStreamWriter(context, objectsPerTick, encodeStreams, objectsPerStream) {
        var _this = _super.call(this, context, objectsPerTick) || this;
        _this.encodeStreams = encodeStreams;
        _this.objectsPerStream = objectsPerStream;
        return _this;
    }
    PDFStreamWriter.prototype.computeBufferSize = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var objectNumber, header, size, xrefStream, uncompressedObjects, compressedObjects, objectStreamRefs, indirectObjects, idx, len, indirectObject, ref, object, shouldNotCompress, chunk, objectStreamRef, idx, len, chunk, ref, objectStream, xrefStreamRef, xrefOffset, trailer;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        objectNumber = this.context.largestObjectNumber + 1;
                        header = (0, $ab35d5c6c69177c9$export$2e2bcd8739ae039).forVersion(1, 7);
                        size = header.sizeInBytes() + 2;
                        xrefStream = (0, $ac24be9f2612b58f$export$2e2bcd8739ae039).create(this.createTrailerDict(), this.encodeStreams);
                        uncompressedObjects = [];
                        compressedObjects = [];
                        objectStreamRefs = [];
                        indirectObjects = this.context.enumerateIndirectObjects();
                        idx = 0, len = indirectObjects.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            6
                        ];
                        indirectObject = indirectObjects[idx];
                        ref = indirectObject[0], object = indirectObject[1];
                        shouldNotCompress = ref === this.context.trailerInfo.Encrypt || object instanceof (0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039) || object instanceof (0, $ad9390730b9495a5$export$2e2bcd8739ae039) || ref.generationNumber !== 0;
                        if (!shouldNotCompress) return [
                            3 /*break*/ ,
                            4
                        ];
                        uncompressedObjects.push(indirectObject);
                        xrefStream.addUncompressedEntry(ref, size);
                        size += this.computeIndirectObjectSize(indirectObject);
                        if (!this.shouldWaitForTick(1)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        chunk = (0, $4ISq8.last)(compressedObjects);
                        objectStreamRef = (0, $4ISq8.last)(objectStreamRefs);
                        if (!chunk || chunk.length % this.objectsPerStream === 0) {
                            chunk = [];
                            compressedObjects.push(chunk);
                            objectStreamRef = (0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(objectNumber++);
                            objectStreamRefs.push(objectStreamRef);
                        }
                        xrefStream.addCompressedEntry(ref, objectStreamRef, chunk.length);
                        chunk.push(indirectObject);
                        _a.label = 5;
                    case 5:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 6:
                        idx = 0, len = compressedObjects.length;
                        _a.label = 7;
                    case 7:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            10
                        ];
                        chunk = compressedObjects[idx];
                        ref = objectStreamRefs[idx];
                        objectStream = (0, $61a4452f4878bba9$export$2e2bcd8739ae039).withContextAndObjects(this.context, chunk, this.encodeStreams);
                        xrefStream.addUncompressedEntry(ref, size);
                        size += this.computeIndirectObjectSize([
                            ref,
                            objectStream
                        ]);
                        uncompressedObjects.push([
                            ref,
                            objectStream
                        ]);
                        if (!this.shouldWaitForTick(chunk.length)) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9:
                        idx++;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 10:
                        xrefStreamRef = (0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(objectNumber++);
                        xrefStream.dict.set((0, $dPHSK.default).of('Size'), (0, $j04jt.default).of(objectNumber));
                        xrefStream.addUncompressedEntry(xrefStreamRef, size);
                        xrefOffset = size;
                        size += this.computeIndirectObjectSize([
                            xrefStreamRef,
                            xrefStream
                        ]);
                        uncompressedObjects.push([
                            xrefStreamRef,
                            xrefStream
                        ]);
                        trailer = (0, $38bebcf76e0d2d54$export$2e2bcd8739ae039).forLastCrossRefSectionOffset(xrefOffset);
                        size += trailer.sizeInBytes();
                        return [
                            2 /*return*/ ,
                            {
                                size: size,
                                header: header,
                                indirectObjects: uncompressedObjects,
                                trailer: trailer
                            }
                        ];
                }
            });
        });
    };
    PDFStreamWriter.forContext = function(context, objectsPerTick, encodeStreams, objectsPerStream) {
        if (encodeStreams === void 0) encodeStreams = true;
        if (objectsPerStream === void 0) objectsPerStream = 50;
        return new PDFStreamWriter(context, objectsPerTick, encodeStreams, objectsPerStream);
    };
    return PDFStreamWriter;
}((0, $4261dca68d44d2dc$export$2e2bcd8739ae039));
var $5cd89dbe12e59987$export$2e2bcd8739ae039 = $5cd89dbe12e59987$var$PDFStreamWriter;






parcelRequire("eNCdi");
var $90iSP = parcelRequire("90iSP");
var $kkdJe = parcelRequire("kkdJe");

var $cOQTW = parcelRequire("cOQTW");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $ejAvl = parcelRequire("ejAvl");
var $iSBb0 = parcelRequire("iSBb0");

var $nAWRe = parcelRequire("nAWRe");
var $e8537943f4279a06$var$PDFHexString = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFHexString, _super);
    function PDFHexString(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFHexString.prototype.asBytes = function() {
        // Append a zero if the number of digits is odd. See PDF spec 7.3.4.3
        var hex = this.value + (this.value.length % 2 === 1 ? '0' : '');
        var hexLength = hex.length;
        var bytes = new Uint8Array(hex.length / 2);
        var hexOffset = 0;
        var bytesOffset = 0;
        // Interpret each pair of hex digits as a single byte
        while(hexOffset < hexLength){
            var byte = parseInt(hex.substring(hexOffset, hexOffset + 2), 16);
            bytes[bytesOffset] = byte;
            hexOffset += 2;
            bytesOffset += 1;
        }
        return bytes;
    };
    PDFHexString.prototype.decodeText = function() {
        var bytes = this.asBytes();
        if ((0, $ejAvl.hasUtf16BOM)(bytes)) return (0, $ejAvl.utf16Decode)(bytes);
        return (0, $iSBb0.pdfDocEncodingDecode)(bytes);
    };
    PDFHexString.prototype.decodeDate = function() {
        var text = this.decodeText();
        var date = (0, $7Kmy8.parseDate)(text);
        if (!date) throw new (0, $nAWRe.InvalidPDFDateStringError)(text);
        return date;
    };
    PDFHexString.prototype.asString = function() {
        return this.value;
    };
    PDFHexString.prototype.clone = function() {
        return PDFHexString.of(this.value);
    };
    PDFHexString.prototype.toString = function() {
        return "<" + this.value + ">";
    };
    PDFHexString.prototype.sizeInBytes = function() {
        return this.value.length + 2;
    };
    PDFHexString.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $8zvel.default).LessThan;
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.value, buffer, offset);
        buffer[offset++] = (0, $8zvel.default).GreaterThan;
        return this.value.length + 2;
    };
    PDFHexString.of = function(value) {
        return new PDFHexString(value);
    };
    PDFHexString.fromText = function(value) {
        var encoded = (0, $ejAvl.utf16Encode)(value);
        var hex = '';
        for(var idx = 0, len = encoded.length; idx < len; idx++)hex += (0, $7Kmy8.toHexStringOfMinLength)(encoded[idx], 4);
        return new PDFHexString(hex);
    };
    return PDFHexString;
}((0, $11c5J.default));
var $e8537943f4279a06$export$2e2bcd8739ae039 = $e8537943f4279a06$var$PDFHexString;


parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/foliojs/pdfkit/blob/f91bdd61c164a72ea06be1a43dc0a412afc3925f/lib/font/afm.coffee
 */ var $e3698d9fec5e57b0$var$StandardFontEmbedder = /** @class */ function() {
    function StandardFontEmbedder(fontName, customName) {
        // prettier-ignore
        this.encoding = fontName === (0, $kkdJe.FontNames).ZapfDingbats ? (0, $90iSP.Encodings).ZapfDingbats : fontName === (0, $kkdJe.FontNames).Symbol ? (0, $90iSP.Encodings).Symbol : (0, $90iSP.Encodings).WinAnsi;
        this.font = (0, $kkdJe.Font).load(fontName);
        this.fontName = this.font.FontName;
        this.customName = customName;
    }
    /**
     * Encode the JavaScript string into this font. (JavaScript encodes strings in
     * Unicode, but standard fonts use either WinAnsi, ZapfDingbats, or Symbol
     * encodings)
     */ StandardFontEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.encodeTextAsGlyphs(text);
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++)hexCodes[idx] = (0, $7Kmy8.toHexString)(glyphs[idx].code);
        return (0, $e8537943f4279a06$export$2e2bcd8739ae039).of(hexCodes.join(''));
    };
    StandardFontEmbedder.prototype.widthOfTextAtSize = function(text, size) {
        var glyphs = this.encodeTextAsGlyphs(text);
        var totalWidth = 0;
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var left = glyphs[idx].name;
            var right = (glyphs[idx + 1] || {}).name;
            var kernAmount = this.font.getXAxisKerningForPair(left, right) || 0;
            totalWidth += this.widthOfGlyph(left) + kernAmount;
        }
        var scale = size / 1000;
        return totalWidth * scale;
    };
    StandardFontEmbedder.prototype.heightOfFontAtSize = function(size, options) {
        if (options === void 0) options = {};
        var _a = options.descender, descender = _a === void 0 ? true : _a;
        var _b = this.font, Ascender = _b.Ascender, Descender = _b.Descender, FontBBox = _b.FontBBox;
        var yTop = Ascender || FontBBox[3];
        var yBottom = Descender || FontBBox[1];
        var height = yTop - yBottom;
        if (!descender) height += Descender || 0;
        return height / 1000 * size;
    };
    StandardFontEmbedder.prototype.sizeOfFontAtHeight = function(height) {
        var _a = this.font, Ascender = _a.Ascender, Descender = _a.Descender, FontBBox = _a.FontBBox;
        var yTop = Ascender || FontBBox[3];
        var yBottom = Descender || FontBBox[1];
        return 1000 * height / (yTop - yBottom);
    };
    StandardFontEmbedder.prototype.embedIntoContext = function(context, ref) {
        var fontDict = context.obj({
            Type: 'Font',
            Subtype: 'Type1',
            BaseFont: this.customName || this.fontName,
            Encoding: this.encoding === (0, $90iSP.Encodings).WinAnsi ? 'WinAnsiEncoding' : undefined
        });
        if (ref) {
            context.assign(ref, fontDict);
            return ref;
        } else return context.register(fontDict);
    };
    StandardFontEmbedder.prototype.widthOfGlyph = function(glyphName) {
        // Default to 250 if font doesn't specify a width
        return this.font.getWidthOfGlyph(glyphName) || 250;
    };
    StandardFontEmbedder.prototype.encodeTextAsGlyphs = function(text) {
        var codePoints = Array.from(text);
        var glyphs = new Array(codePoints.length);
        for(var idx = 0, len = codePoints.length; idx < len; idx++){
            var codePoint = (0, $7Kmy8.toCodePoint)(codePoints[idx]);
            glyphs[idx] = this.encoding.encodeUnicodeCodePoint(codePoint);
        }
        return glyphs;
    };
    StandardFontEmbedder.for = function(fontName, customName) {
        return new StandardFontEmbedder(fontName, customName);
    };
    return StandardFontEmbedder;
}();
var $e3698d9fec5e57b0$export$2e2bcd8739ae039 = $e3698d9fec5e57b0$var$StandardFontEmbedder;



var $cOQTW = parcelRequire("cOQTW");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");

var $ejAvl = parcelRequire("ejAvl");
var $8fa4fd029ce650b8$export$ecb273704ecc155f = function(glyphs, glyphId) {
    var bfChars = new Array(glyphs.length);
    for(var idx = 0, len = glyphs.length; idx < len; idx++){
        var glyph = glyphs[idx];
        var id = $8fa4fd029ce650b8$var$cmapHexFormat($8fa4fd029ce650b8$var$cmapHexString(glyphId(glyph)));
        var unicode = $8fa4fd029ce650b8$var$cmapHexFormat.apply(void 0, glyph.codePoints.map($8fa4fd029ce650b8$var$cmapCodePointFormat));
        bfChars[idx] = [
            id,
            unicode
        ];
    }
    return $8fa4fd029ce650b8$var$fillCmapTemplate(bfChars);
};
/* =============================== Templates ================================ */ var $8fa4fd029ce650b8$var$fillCmapTemplate = function(bfChars) {
    return "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange\n" + bfChars.length + " beginbfchar\n" + bfChars.map(function(_a) {
        var glyphId = _a[0], codePoint = _a[1];
        return glyphId + " " + codePoint;
    }).join('\n') + "\nendbfchar\nendcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
};
/* =============================== Utilities ================================ */ var $8fa4fd029ce650b8$var$cmapHexFormat = function() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    return "<" + values.join('') + ">";
};
var $8fa4fd029ce650b8$var$cmapHexString = function(value) {
    return (0, $7Kmy8.toHexStringOfMinLength)(value, 4);
};
var $8fa4fd029ce650b8$var$cmapCodePointFormat = function(codePoint) {
    if ((0, $ejAvl.isWithinBMP)(codePoint)) return $8fa4fd029ce650b8$var$cmapHexString(codePoint);
    if ((0, $ejAvl.hasSurrogates)(codePoint)) {
        var hs = (0, $ejAvl.highSurrogate)(codePoint);
        var ls = (0, $ejAvl.lowSurrogate)(codePoint);
        return "" + $8fa4fd029ce650b8$var$cmapHexString(hs) + $8fa4fd029ce650b8$var$cmapHexString(ls);
    }
    var hex = (0, $7Kmy8.toHexString)(codePoint);
    var msg = "0x" + hex + " is not a valid UTF-8 or UTF-16 codepoint.";
    throw new Error(msg);
};


// prettier-ignore
var $740505aae0fb9700$var$makeFontFlags = function(options) {
    var flags = 0;
    var flipBit = function(bit) {
        flags |= 1 << bit - 1;
    };
    if (options.fixedPitch) flipBit(1);
    if (options.serif) flipBit(2);
    if (options.symbolic) flipBit(3);
    if (options.script) flipBit(4);
    if (options.nonsymbolic) flipBit(6);
    if (options.italic) flipBit(7);
    if (options.allCap) flipBit(17);
    if (options.smallCap) flipBit(18);
    if (options.forceBold) flipBit(19);
    return flags;
};
var $740505aae0fb9700$export$aa92af1a056b24e8 = function(font) {
    var familyClass = font['OS/2'] ? font['OS/2'].sFamilyClass : 0;
    var flags = $740505aae0fb9700$var$makeFontFlags({
        fixedPitch: font.post.isFixedPitch,
        serif: 1 <= familyClass && familyClass <= 7,
        symbolic: true,
        script: familyClass === 10,
        italic: font.head.macStyle.italic
    });
    return flags;
};




var $cOQTW = parcelRequire("cOQTW");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $ejAvl = parcelRequire("ejAvl");
var $iSBb0 = parcelRequire("iSBb0");

var $nAWRe = parcelRequire("nAWRe");
var $5fbdc5307b6362f1$var$PDFString = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFString, _super);
    function PDFString(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFString.prototype.asBytes = function() {
        var bytes = [];
        var octal = '';
        var escaped = false;
        var pushByte = function(byte) {
            if (byte !== undefined) bytes.push(byte);
            escaped = false;
        };
        for(var idx = 0, len = this.value.length; idx < len; idx++){
            var char = this.value[idx];
            var byte = (0, $7Kmy8.toCharCode)(char);
            var nextChar = this.value[idx + 1];
            if (!escaped) {
                if (byte === (0, $8zvel.default).BackSlash) escaped = true;
                else pushByte(byte);
            } else {
                if (byte === (0, $8zvel.default).Newline) pushByte();
                else if (byte === (0, $8zvel.default).CarriageReturn) pushByte();
                else if (byte === (0, $8zvel.default).n) pushByte((0, $8zvel.default).Newline);
                else if (byte === (0, $8zvel.default).r) pushByte((0, $8zvel.default).CarriageReturn);
                else if (byte === (0, $8zvel.default).t) pushByte((0, $8zvel.default).Tab);
                else if (byte === (0, $8zvel.default).b) pushByte((0, $8zvel.default).Backspace);
                else if (byte === (0, $8zvel.default).f) pushByte((0, $8zvel.default).FormFeed);
                else if (byte === (0, $8zvel.default).LeftParen) pushByte((0, $8zvel.default).LeftParen);
                else if (byte === (0, $8zvel.default).RightParen) pushByte((0, $8zvel.default).RightParen);
                else if (byte === (0, $8zvel.default).Backspace) pushByte((0, $8zvel.default).BackSlash);
                else if (byte >= (0, $8zvel.default).Zero && byte <= (0, $8zvel.default).Seven) {
                    octal += char;
                    if (octal.length === 3 || !(nextChar >= '0' && nextChar <= '7')) {
                        pushByte(parseInt(octal, 8));
                        octal = '';
                    }
                } else pushByte(byte);
            }
        }
        return new Uint8Array(bytes);
    };
    PDFString.prototype.decodeText = function() {
        var bytes = this.asBytes();
        if ((0, $ejAvl.hasUtf16BOM)(bytes)) return (0, $ejAvl.utf16Decode)(bytes);
        return (0, $iSBb0.pdfDocEncodingDecode)(bytes);
    };
    PDFString.prototype.decodeDate = function() {
        var text = this.decodeText();
        var date = (0, $7Kmy8.parseDate)(text);
        if (!date) throw new (0, $nAWRe.InvalidPDFDateStringError)(text);
        return date;
    };
    PDFString.prototype.asString = function() {
        return this.value;
    };
    PDFString.prototype.clone = function() {
        return PDFString.of(this.value);
    };
    PDFString.prototype.toString = function() {
        return "(" + this.value + ")";
    };
    PDFString.prototype.sizeInBytes = function() {
        return this.value.length + 2;
    };
    PDFString.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $8zvel.default).LeftParen;
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.value, buffer, offset);
        buffer[offset++] = (0, $8zvel.default).RightParen;
        return this.value.length + 2;
    };
    // The PDF spec allows newlines and parens to appear directly within a literal
    // string. These character _may_ be escaped. But they do not _have_ to be. So
    // for simplicity, we will not bother escaping them.
    PDFString.of = function(value) {
        return new PDFString(value);
    };
    PDFString.fromDate = function(date) {
        var year = (0, $7Kmy8.padStart)(String(date.getUTCFullYear()), 4, '0');
        var month = (0, $7Kmy8.padStart)(String(date.getUTCMonth() + 1), 2, '0');
        var day = (0, $7Kmy8.padStart)(String(date.getUTCDate()), 2, '0');
        var hours = (0, $7Kmy8.padStart)(String(date.getUTCHours()), 2, '0');
        var mins = (0, $7Kmy8.padStart)(String(date.getUTCMinutes()), 2, '0');
        var secs = (0, $7Kmy8.padStart)(String(date.getUTCSeconds()), 2, '0');
        return new PDFString("D:" + year + month + day + hours + mins + secs + "Z");
    };
    return PDFString;
}((0, $11c5J.default));
var $5fbdc5307b6362f1$export$2e2bcd8739ae039 = $5fbdc5307b6362f1$var$PDFString;


parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");
var $clYSv = parcelRequire("clYSv");
var $7Kmy8 = parcelRequire("7Kmy8");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/jpeg.coffee
 */ var $c1a3ddaa0f08fc18$var$CustomFontEmbedder = /** @class */ function() {
    function CustomFontEmbedder(font, fontData, customName, fontFeatures) {
        var _this = this;
        this.allGlyphsInFontSortedById = function() {
            var glyphs = new Array(_this.font.characterSet.length);
            for(var idx = 0, len = glyphs.length; idx < len; idx++){
                var codePoint = _this.font.characterSet[idx];
                glyphs[idx] = _this.font.glyphForCodePoint(codePoint);
            }
            return (0, $4ISq8.sortedUniq)(glyphs.sort((0, $4ISq8.byAscendingId)), function(g) {
                return g.id;
            });
        };
        this.font = font;
        this.scale = 1000 / this.font.unitsPerEm;
        this.fontData = fontData;
        this.fontName = this.font.postscriptName || 'Font';
        this.customName = customName;
        this.fontFeatures = fontFeatures;
        this.baseFontName = '';
        this.glyphCache = (0, $clYSv.default).populatedBy(this.allGlyphsInFontSortedById);
    }
    CustomFontEmbedder.for = function(fontkit, fontData, customName, fontFeatures) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var font;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fontkit.create(fontData)
                        ];
                    case 1:
                        font = _a.sent();
                        return [
                            2 /*return*/ ,
                            new CustomFontEmbedder(font, fontData, customName, fontFeatures)
                        ];
                }
            });
        });
    };
    /**
     * Encode the JavaScript string into this font. (JavaScript encodes strings in
     * Unicode, but embedded fonts use their own custom encodings)
     */ CustomFontEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++)hexCodes[idx] = (0, $7Kmy8.toHexStringOfMinLength)(glyphs[idx].id, 4);
        return (0, $e8537943f4279a06$export$2e2bcd8739ae039).of(hexCodes.join(''));
    };
    // The advanceWidth takes into account kerning automatically, so we don't
    // have to do that manually like we do for the standard fonts.
    CustomFontEmbedder.prototype.widthOfTextAtSize = function(text, size) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var totalWidth = 0;
        for(var idx = 0, len = glyphs.length; idx < len; idx++)totalWidth += glyphs[idx].advanceWidth * this.scale;
        var scale = size / 1000;
        return totalWidth * scale;
    };
    CustomFontEmbedder.prototype.heightOfFontAtSize = function(size, options) {
        if (options === void 0) options = {};
        var _a = options.descender, descender = _a === void 0 ? true : _a;
        var _b = this.font, ascent = _b.ascent, descent = _b.descent, bbox = _b.bbox;
        var yTop = (ascent || bbox.maxY) * this.scale;
        var yBottom = (descent || bbox.minY) * this.scale;
        var height = yTop - yBottom;
        if (!descender) height -= Math.abs(descent) || 0;
        return height / 1000 * size;
    };
    CustomFontEmbedder.prototype.sizeOfFontAtHeight = function(height) {
        var _a = this.font, ascent = _a.ascent, descent = _a.descent, bbox = _a.bbox;
        var yTop = (ascent || bbox.maxY) * this.scale;
        var yBottom = (descent || bbox.minY) * this.scale;
        return 1000 * height / (yTop - yBottom);
    };
    CustomFontEmbedder.prototype.embedIntoContext = function(context, ref) {
        this.baseFontName = this.customName || context.addRandomSuffix(this.fontName);
        return this.embedFontDict(context, ref);
    };
    CustomFontEmbedder.prototype.embedFontDict = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var cidFontDictRef, unicodeCMapRef, fontDict;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedCIDFontDict(context)
                        ];
                    case 1:
                        cidFontDictRef = _a.sent();
                        unicodeCMapRef = this.embedUnicodeCmap(context);
                        fontDict = context.obj({
                            Type: 'Font',
                            Subtype: 'Type0',
                            BaseFont: this.baseFontName,
                            Encoding: 'Identity-H',
                            DescendantFonts: [
                                cidFontDictRef
                            ],
                            ToUnicode: unicodeCMapRef
                        });
                        if (ref) {
                            context.assign(ref, fontDict);
                            return [
                                2 /*return*/ ,
                                ref
                            ];
                        } else return [
                            2 /*return*/ ,
                            context.register(fontDict)
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.isCFF = function() {
        return this.font.cff;
    };
    CustomFontEmbedder.prototype.embedCIDFontDict = function(context) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var fontDescriptorRef, cidFontDict;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedFontDescriptor(context)
                        ];
                    case 1:
                        fontDescriptorRef = _a.sent();
                        cidFontDict = context.obj({
                            Type: 'Font',
                            Subtype: this.isCFF() ? 'CIDFontType0' : 'CIDFontType2',
                            CIDToGIDMap: 'Identity',
                            BaseFont: this.baseFontName,
                            CIDSystemInfo: {
                                Registry: (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039).of('Adobe'),
                                Ordering: (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039).of('Identity'),
                                Supplement: 0
                            },
                            FontDescriptor: fontDescriptorRef,
                            W: this.computeWidths()
                        });
                        return [
                            2 /*return*/ ,
                            context.register(cidFontDict)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.embedFontDescriptor = function(context) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var fontStreamRef, scale, _a, italicAngle, ascent, descent, capHeight, xHeight, _b, minX, minY, maxX, maxY, fontDescriptor;
            var _c;
            return (0, $cOQTW.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedFontStream(context)
                        ];
                    case 1:
                        fontStreamRef = _d.sent();
                        scale = this.scale;
                        _a = this.font, italicAngle = _a.italicAngle, ascent = _a.ascent, descent = _a.descent, capHeight = _a.capHeight, xHeight = _a.xHeight;
                        _b = this.font.bbox, minX = _b.minX, minY = _b.minY, maxX = _b.maxX, maxY = _b.maxY;
                        fontDescriptor = context.obj((_c = {
                            Type: 'FontDescriptor',
                            FontName: this.baseFontName,
                            Flags: (0, $740505aae0fb9700$export$aa92af1a056b24e8)(this.font),
                            FontBBox: [
                                minX * scale,
                                minY * scale,
                                maxX * scale,
                                maxY * scale
                            ],
                            ItalicAngle: italicAngle,
                            Ascent: ascent * scale,
                            Descent: descent * scale,
                            CapHeight: (capHeight || ascent) * scale,
                            XHeight: (xHeight || 0) * scale,
                            // Not sure how to compute/find this, nor is anybody else really:
                            // https://stackoverflow.com/questions/35485179/stemv-value-of-the-truetype-font
                            StemV: 0
                        }, _c[this.isCFF() ? 'FontFile3' : 'FontFile2'] = fontStreamRef, _c));
                        return [
                            2 /*return*/ ,
                            context.register(fontDescriptor)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.serializeFont = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.fontData
                ];
            });
        });
    };
    CustomFontEmbedder.prototype.embedFontStream = function(context) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var fontStream, _a, _b;
            return (0, $cOQTW.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _b = (_a = context).flateStream;
                        return [
                            4 /*yield*/ ,
                            this.serializeFont()
                        ];
                    case 1:
                        fontStream = _b.apply(_a, [
                            _c.sent(),
                            {
                                Subtype: this.isCFF() ? 'CIDFontType0C' : undefined
                            }
                        ]);
                        return [
                            2 /*return*/ ,
                            context.register(fontStream)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.embedUnicodeCmap = function(context) {
        var cmap = (0, $8fa4fd029ce650b8$export$ecb273704ecc155f)(this.glyphCache.access(), this.glyphId.bind(this));
        var cmapStream = context.flateStream(cmap);
        return context.register(cmapStream);
    };
    CustomFontEmbedder.prototype.glyphId = function(glyph) {
        return glyph ? glyph.id : -1;
    };
    CustomFontEmbedder.prototype.computeWidths = function() {
        var glyphs = this.glyphCache.access();
        var widths = [];
        var currSection = [];
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var currGlyph = glyphs[idx];
            var prevGlyph = glyphs[idx - 1];
            var currGlyphId = this.glyphId(currGlyph);
            var prevGlyphId = this.glyphId(prevGlyph);
            if (idx === 0) widths.push(currGlyphId);
            else if (currGlyphId - prevGlyphId !== 1) {
                widths.push(currSection);
                widths.push(currGlyphId);
                currSection = [];
            }
            currSection.push(currGlyph.advanceWidth * this.scale);
        }
        widths.push(currSection);
        return widths;
    };
    return CustomFontEmbedder;
}();
var $c1a3ddaa0f08fc18$export$2e2bcd8739ae039 = $c1a3ddaa0f08fc18$var$CustomFontEmbedder;



var $cOQTW = parcelRequire("cOQTW");


parcelRequire("fvYKZ");
var $clYSv = parcelRequire("clYSv");
var $4ISq8 = parcelRequire("4ISq8");
var $7Kmy8 = parcelRequire("7Kmy8");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/jpeg.coffee
 */ var $4bb3e5ce3694dd68$var$CustomFontSubsetEmbedder = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(CustomFontSubsetEmbedder, _super);
    function CustomFontSubsetEmbedder(font, fontData, customFontName, fontFeatures) {
        var _this = _super.call(this, font, fontData, customFontName, fontFeatures) || this;
        _this.subset = _this.font.createSubset();
        _this.glyphs = [];
        _this.glyphCache = (0, $clYSv.default).populatedBy(function() {
            return _this.glyphs;
        });
        _this.glyphIdMap = new Map();
        return _this;
    }
    CustomFontSubsetEmbedder.for = function(fontkit, fontData, customFontName, fontFeatures) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var font;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fontkit.create(fontData)
                        ];
                    case 1:
                        font = _a.sent();
                        return [
                            2 /*return*/ ,
                            new CustomFontSubsetEmbedder(font, fontData, customFontName, fontFeatures)
                        ];
                }
            });
        });
    };
    CustomFontSubsetEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var glyph = glyphs[idx];
            var subsetGlyphId = this.subset.includeGlyph(glyph);
            this.glyphs[subsetGlyphId - 1] = glyph;
            this.glyphIdMap.set(glyph.id, subsetGlyphId);
            hexCodes[idx] = (0, $7Kmy8.toHexStringOfMinLength)(subsetGlyphId, 4);
        }
        this.glyphCache.invalidate();
        return (0, $e8537943f4279a06$export$2e2bcd8739ae039).of(hexCodes.join(''));
    };
    CustomFontSubsetEmbedder.prototype.isCFF = function() {
        return this.subset.cff;
    };
    CustomFontSubsetEmbedder.prototype.glyphId = function(glyph) {
        return glyph ? this.glyphIdMap.get(glyph.id) : -1;
    };
    CustomFontSubsetEmbedder.prototype.serializeFont = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var parts = [];
            _this.subset.encodeStream().on('data', function(bytes) {
                return parts.push(bytes);
            }).on('end', function() {
                return resolve((0, $4ISq8.mergeUint8Arrays)(parts));
            }).on('error', function(err) {
                return reject(err);
            });
        });
    };
    return CustomFontSubsetEmbedder;
}((0, $c1a3ddaa0f08fc18$export$2e2bcd8739ae039));
var $4bb3e5ce3694dd68$export$2e2bcd8739ae039 = $4bb3e5ce3694dd68$var$CustomFontSubsetEmbedder;



var $cOQTW = parcelRequire("cOQTW");


var $03c8546b8537a071$export$c12eac46fbec1b74;
(function(AFRelationship) {
    AFRelationship["Source"] = "Source";
    AFRelationship["Data"] = "Data";
    AFRelationship["Alternative"] = "Alternative";
    AFRelationship["Supplement"] = "Supplement";
    AFRelationship["EncryptedPayload"] = "EncryptedPayload";
    AFRelationship["FormData"] = "EncryptedPayload";
    AFRelationship["Schema"] = "Schema";
    AFRelationship["Unspecified"] = "Unspecified";
})($03c8546b8537a071$export$c12eac46fbec1b74 || ($03c8546b8537a071$export$c12eac46fbec1b74 = {}));
var $03c8546b8537a071$var$FileEmbedder = /** @class */ function() {
    function FileEmbedder(fileData, fileName, options) {
        if (options === void 0) options = {};
        this.fileData = fileData;
        this.fileName = fileName;
        this.options = options;
    }
    FileEmbedder.for = function(bytes, fileName, options) {
        if (options === void 0) options = {};
        return new FileEmbedder(bytes, fileName, options);
    };
    FileEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, mimeType, description, creationDate, modificationDate, afRelationship, embeddedFileStream, embeddedFileStreamRef, fileSpecDict;
            return (0, $cOQTW.__generator)(this, function(_b) {
                _a = this.options, mimeType = _a.mimeType, description = _a.description, creationDate = _a.creationDate, modificationDate = _a.modificationDate, afRelationship = _a.afRelationship;
                embeddedFileStream = context.flateStream(this.fileData, {
                    Type: 'EmbeddedFile',
                    Subtype: mimeType !== null && mimeType !== void 0 ? mimeType : undefined,
                    Params: {
                        Size: this.fileData.length,
                        CreationDate: creationDate ? (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039).fromDate(creationDate) : undefined,
                        ModDate: modificationDate ? (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039).fromDate(modificationDate) : undefined
                    }
                });
                embeddedFileStreamRef = context.register(embeddedFileStream);
                fileSpecDict = context.obj({
                    Type: 'Filespec',
                    F: (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039).of(this.fileName),
                    UF: (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(this.fileName),
                    EF: {
                        F: embeddedFileStreamRef
                    },
                    Desc: description ? (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(description) : undefined,
                    AFRelationship: afRelationship !== null && afRelationship !== void 0 ? afRelationship : undefined
                });
                if (ref) {
                    context.assign(ref, fileSpecDict);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(fileSpecDict)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return FileEmbedder;
}();
var $03c8546b8537a071$export$2e2bcd8739ae039 = $03c8546b8537a071$var$FileEmbedder;



var $cOQTW = parcelRequire("cOQTW");
// prettier-ignore
var $b2f30d23c2f107ea$var$MARKERS = [
    0xffc0,
    0xffc1,
    0xffc2,
    0xffc3,
    0xffc5,
    0xffc6,
    0xffc7,
    0xffc8,
    0xffc9,
    0xffca,
    0xffcb,
    0xffcc,
    0xffcd,
    0xffce,
    0xffcf
];
var $b2f30d23c2f107ea$var$ColorSpace;
(function(ColorSpace) {
    ColorSpace["DeviceGray"] = "DeviceGray";
    ColorSpace["DeviceRGB"] = "DeviceRGB";
    ColorSpace["DeviceCMYK"] = "DeviceCMYK";
})($b2f30d23c2f107ea$var$ColorSpace || ($b2f30d23c2f107ea$var$ColorSpace = {}));
var $b2f30d23c2f107ea$var$ChannelToColorSpace = {
    1: $b2f30d23c2f107ea$var$ColorSpace.DeviceGray,
    3: $b2f30d23c2f107ea$var$ColorSpace.DeviceRGB,
    4: $b2f30d23c2f107ea$var$ColorSpace.DeviceCMYK
};
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/foliojs/pdfkit/blob/a6af76467ce06bd6a2af4aa7271ccac9ff152a7d/lib/image/jpeg.js
 */ var $b2f30d23c2f107ea$var$JpegEmbedder = /** @class */ function() {
    function JpegEmbedder(imageData, bitsPerComponent, width, height, colorSpace) {
        this.imageData = imageData;
        this.bitsPerComponent = bitsPerComponent;
        this.width = width;
        this.height = height;
        this.colorSpace = colorSpace;
    }
    JpegEmbedder.for = function(imageData) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var dataView, soi, pos, marker, bitsPerComponent, height, width, channelByte, channelName, colorSpace;
            return (0, $cOQTW.__generator)(this, function(_a) {
                dataView = new DataView(imageData.buffer);
                soi = dataView.getUint16(0);
                if (soi !== 0xffd8) throw new Error('SOI not found in JPEG');
                pos = 2;
                while(pos < dataView.byteLength){
                    marker = dataView.getUint16(pos);
                    pos += 2;
                    if ($b2f30d23c2f107ea$var$MARKERS.includes(marker)) break;
                    pos += dataView.getUint16(pos);
                }
                if (!$b2f30d23c2f107ea$var$MARKERS.includes(marker)) throw new Error('Invalid JPEG');
                pos += 2;
                bitsPerComponent = dataView.getUint8(pos++);
                height = dataView.getUint16(pos);
                pos += 2;
                width = dataView.getUint16(pos);
                pos += 2;
                channelByte = dataView.getUint8(pos++);
                channelName = $b2f30d23c2f107ea$var$ChannelToColorSpace[channelByte];
                if (!channelName) throw new Error('Unknown JPEG channel.');
                colorSpace = channelName;
                return [
                    2 /*return*/ ,
                    new JpegEmbedder(imageData, bitsPerComponent, width, height, colorSpace)
                ];
            });
        });
    };
    JpegEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var xObject;
            return (0, $cOQTW.__generator)(this, function(_a) {
                xObject = context.stream(this.imageData, {
                    Type: 'XObject',
                    Subtype: 'Image',
                    BitsPerComponent: this.bitsPerComponent,
                    Width: this.width,
                    Height: this.height,
                    ColorSpace: this.colorSpace,
                    Filter: 'DCTDecode',
                    // CMYK JPEG streams in PDF are typically stored complemented,
                    // with 1 as 'off' and 0 as 'on' (PDF 32000-1:2008, 8.6.4.4).
                    //
                    // Standalone CMYK JPEG (usually exported by Photoshop) are
                    // stored inverse, with 0 as 'off' and 1 as 'on', like RGB.
                    //
                    // Applying a swap here as a hedge that most bytes passing
                    // through this method will benefit from it.
                    Decode: this.colorSpace === $b2f30d23c2f107ea$var$ColorSpace.DeviceCMYK ? [
                        1,
                        0,
                        1,
                        0,
                        1,
                        0,
                        1,
                        0
                    ] : undefined
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return JpegEmbedder;
}();
var $b2f30d23c2f107ea$export$2e2bcd8739ae039 = $b2f30d23c2f107ea$var$JpegEmbedder;



var $cOQTW = parcelRequire("cOQTW");

var $ckCqy = parcelRequire("ckCqy");
var $6ee893d66c44e557$var$UPNG = {};
$6ee893d66c44e557$var$UPNG.toRGBA8 = function(out) {
    var w = out.width, h = out.height;
    if (out.tabs.acTL == null) return [
        $6ee893d66c44e557$var$UPNG.toRGBA8.decodeImage(out.data, w, h, out).buffer
    ];
    var frms = [];
    if (out.frames[0].data == null) out.frames[0].data = out.data;
    var len = w * h * 4, img = new Uint8Array(len), empty = new Uint8Array(len), prev = new Uint8Array(len);
    for(var i = 0; i < out.frames.length; i++){
        var frm = out.frames[i];
        var fx = frm.rect.x, fy = frm.rect.y, fw = frm.rect.width, fh = frm.rect.height;
        var fdata = $6ee893d66c44e557$var$UPNG.toRGBA8.decodeImage(frm.data, fw, fh, out);
        if (i != 0) for(var j = 0; j < len; j++)prev[j] = img[j];
        if (frm.blend == 0) $6ee893d66c44e557$var$UPNG._copyTile(fdata, fw, fh, img, w, h, fx, fy, 0);
        else if (frm.blend == 1) $6ee893d66c44e557$var$UPNG._copyTile(fdata, fw, fh, img, w, h, fx, fy, 1);
        frms.push(img.buffer.slice(0));
        if (frm.dispose == 0) ;
        else if (frm.dispose == 1) $6ee893d66c44e557$var$UPNG._copyTile(empty, fw, fh, img, w, h, fx, fy, 0);
        else if (frm.dispose == 2) for(var j = 0; j < len; j++)img[j] = prev[j];
    }
    return frms;
};
$6ee893d66c44e557$var$UPNG.toRGBA8.decodeImage = function(data, w, h, out) {
    var area = w * h, bpp = $6ee893d66c44e557$var$UPNG.decode._getBPP(out);
    var bpl = Math.ceil(w * bpp / 8); // bytes per line
    var bf = new Uint8Array(area * 4), bf32 = new Uint32Array(bf.buffer);
    var ctype = out.ctype, depth = out.depth;
    var rs = $6ee893d66c44e557$var$UPNG._bin.readUshort;
    //console.log(ctype, depth);
    var time = Date.now();
    if (ctype == 6) {
        var qarea = area << 2;
        if (depth == 8) for(var i = 0; i < qarea; i += 4){
            bf[i] = data[i];
            bf[i + 1] = data[i + 1];
            bf[i + 2] = data[i + 2];
            bf[i + 3] = data[i + 3];
        }
        if (depth == 16) for(var i = 0; i < qarea; i++)bf[i] = data[i << 1];
    } else if (ctype == 2) {
        var ts = out.tabs["tRNS"];
        if (ts == null) {
            if (depth == 8) for(var i = 0; i < area; i++){
                var ti = i * 3;
                bf32[i] = -16777216 | data[ti + 2] << 16 | data[ti + 1] << 8 | data[ti];
            }
            if (depth == 16) for(var i = 0; i < area; i++){
                var ti = i * 6;
                bf32[i] = -16777216 | data[ti + 4] << 16 | data[ti + 2] << 8 | data[ti];
            }
        } else {
            var tr = ts[0], tg = ts[1], tb = ts[2];
            if (depth == 8) for(var i = 0; i < area; i++){
                var qi = i << 2, ti = i * 3;
                bf32[i] = -16777216 | data[ti + 2] << 16 | data[ti + 1] << 8 | data[ti];
                if (data[ti] == tr && data[ti + 1] == tg && data[ti + 2] == tb) bf[qi + 3] = 0;
            }
            if (depth == 16) for(var i = 0; i < area; i++){
                var qi = i << 2, ti = i * 6;
                bf32[i] = -16777216 | data[ti + 4] << 16 | data[ti + 2] << 8 | data[ti];
                if (rs(data, ti) == tr && rs(data, ti + 2) == tg && rs(data, ti + 4) == tb) bf[qi + 3] = 0;
            }
        }
    } else if (ctype == 3) {
        var p = out.tabs["PLTE"], ap = out.tabs["tRNS"], tl = ap ? ap.length : 0;
        //console.log(p, ap);
        if (depth == 1) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 3)] >> 7 - ((i & 7) << 0) & 1, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 2) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 2)] >> 6 - ((i & 3) << 1) & 3, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 4) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 1)] >> 4 - ((i & 1) << 2) & 15, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 8) for(var i = 0; i < area; i++){
            var qi = i << 2, j = data[i], cj = 3 * j;
            bf[qi] = p[cj];
            bf[qi + 1] = p[cj + 1];
            bf[qi + 2] = p[cj + 2];
            bf[qi + 3] = j < tl ? ap[j] : 255;
        }
    } else if (ctype == 4) {
        if (depth == 8) for(var i = 0; i < area; i++){
            var qi = i << 2, di = i << 1, gr = data[di];
            bf[qi] = gr;
            bf[qi + 1] = gr;
            bf[qi + 2] = gr;
            bf[qi + 3] = data[di + 1];
        }
        if (depth == 16) for(var i = 0; i < area; i++){
            var qi = i << 2, di = i << 2, gr = data[di];
            bf[qi] = gr;
            bf[qi + 1] = gr;
            bf[qi + 2] = gr;
            bf[qi + 3] = data[di + 2];
        }
    } else if (ctype == 0) {
        var tr = out.tabs["tRNS"] ? out.tabs["tRNS"] : -1;
        for(var y = 0; y < h; y++){
            var off = y * bpl, to = y * w;
            if (depth == 1) for(var x = 0; x < w; x++){
                var gr = 255 * (data[off + (x >>> 3)] >>> 7 - (x & 7) & 1), al = gr == tr * 255 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 2) for(var x = 0; x < w; x++){
                var gr = 85 * (data[off + (x >>> 2)] >>> 6 - ((x & 3) << 1) & 3), al = gr == tr * 85 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 4) for(var x = 0; x < w; x++){
                var gr = 17 * (data[off + (x >>> 1)] >>> 4 - ((x & 1) << 2) & 15), al = gr == tr * 17 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 8) for(var x = 0; x < w; x++){
                var gr = data[off + x], al = gr == tr ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 16) for(var x = 0; x < w; x++){
                var gr = data[off + (x << 1)], al = rs(data, off + (x << i)) == tr ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
        }
    }
    //console.log(Date.now()-time);
    return bf;
};
$6ee893d66c44e557$var$UPNG.decode = function(buff) {
    var data = new Uint8Array(buff), offset = 8, bin = $6ee893d66c44e557$var$UPNG._bin, rUs = bin.readUshort, rUi = bin.readUint;
    var out = {
        tabs: {},
        frames: []
    };
    var dd = new Uint8Array(data.length), doff = 0; // put all IDAT data into it
    var fd, foff = 0; // frames
    var mgck = [
        0x89,
        0x50,
        0x4e,
        0x47,
        0x0d,
        0x0a,
        0x1a,
        0x0a
    ];
    for(var i = 0; i < 8; i++)if (data[i] != mgck[i]) throw "The input is not a PNG file!";
    while(offset < data.length){
        var len = bin.readUint(data, offset);
        offset += 4;
        var type = bin.readASCII(data, offset, 4);
        offset += 4;
        //console.log(type,len);
        if (type == "IHDR") $6ee893d66c44e557$var$UPNG.decode._IHDR(data, offset, out);
        else if (type == "IDAT") {
            for(var i = 0; i < len; i++)dd[doff + i] = data[offset + i];
            doff += len;
        } else if (type == "acTL") {
            out.tabs[type] = {
                num_frames: rUi(data, offset),
                num_plays: rUi(data, offset + 4)
            };
            fd = new Uint8Array(data.length);
        } else if (type == "fcTL") {
            if (foff != 0) {
                var fr = out.frames[out.frames.length - 1];
                fr.data = $6ee893d66c44e557$var$UPNG.decode._decompress(out, fd.slice(0, foff), fr.rect.width, fr.rect.height);
                foff = 0;
            }
            var rct = {
                x: rUi(data, offset + 12),
                y: rUi(data, offset + 16),
                width: rUi(data, offset + 4),
                height: rUi(data, offset + 8)
            };
            var del = rUs(data, offset + 22);
            del = rUs(data, offset + 20) / (del == 0 ? 100 : del);
            var frm = {
                rect: rct,
                delay: Math.round(del * 1000),
                dispose: data[offset + 24],
                blend: data[offset + 25]
            };
            //console.log(frm);
            out.frames.push(frm);
        } else if (type == "fdAT") {
            for(var i = 0; i < len - 4; i++)fd[foff + i] = data[offset + i + 4];
            foff += len - 4;
        } else if (type == "pHYs") out.tabs[type] = [
            bin.readUint(data, offset),
            bin.readUint(data, offset + 4),
            data[offset + 8]
        ];
        else if (type == "cHRM") {
            out.tabs[type] = [];
            for(var i = 0; i < 8; i++)out.tabs[type].push(bin.readUint(data, offset + i * 4));
        } else if (type == "tEXt") {
            if (out.tabs[type] == null) out.tabs[type] = {};
            var nz = bin.nextZero(data, offset);
            var keyw = bin.readASCII(data, offset, nz - offset);
            var text = bin.readASCII(data, nz + 1, offset + len - nz - 1);
            out.tabs[type][keyw] = text;
        } else if (type == "iTXt") {
            if (out.tabs[type] == null) out.tabs[type] = {};
            var nz = 0, off = offset;
            nz = bin.nextZero(data, off);
            var keyw = bin.readASCII(data, off, nz - off);
            off = nz + 1;
            var cflag = data[off], cmeth = data[off + 1];
            off += 2;
            nz = bin.nextZero(data, off);
            var ltag = bin.readASCII(data, off, nz - off);
            off = nz + 1;
            nz = bin.nextZero(data, off);
            var tkeyw = bin.readUTF8(data, off, nz - off);
            off = nz + 1;
            var text = bin.readUTF8(data, off, len - (off - offset));
            out.tabs[type][keyw] = text;
        } else if (type == "PLTE") out.tabs[type] = bin.readBytes(data, offset, len);
        else if (type == "hIST") {
            var pl = out.tabs["PLTE"].length / 3;
            out.tabs[type] = [];
            for(var i = 0; i < pl; i++)out.tabs[type].push(rUs(data, offset + i * 2));
        } else if (type == "tRNS") {
            if (out.ctype == 3) out.tabs[type] = bin.readBytes(data, offset, len);
            else if (out.ctype == 0) out.tabs[type] = rUs(data, offset);
            else if (out.ctype == 2) out.tabs[type] = [
                rUs(data, offset),
                rUs(data, offset + 2),
                rUs(data, offset + 4)
            ];
        //else console.log("tRNS for unsupported color type",out.ctype, len);
        } else if (type == "gAMA") out.tabs[type] = bin.readUint(data, offset) / 100000;
        else if (type == "sRGB") out.tabs[type] = data[offset];
        else if (type == "bKGD") {
            if (out.ctype == 0 || out.ctype == 4) out.tabs[type] = [
                rUs(data, offset)
            ];
            else if (out.ctype == 2 || out.ctype == 6) out.tabs[type] = [
                rUs(data, offset),
                rUs(data, offset + 2),
                rUs(data, offset + 4)
            ];
            else if (out.ctype == 3) out.tabs[type] = data[offset];
        } else if (type == "IEND") break;
        //else {  log("unknown chunk type", type, len);  }
        offset += len;
        var crc = bin.readUint(data, offset);
        offset += 4;
    }
    if (foff != 0) {
        var fr = out.frames[out.frames.length - 1];
        fr.data = $6ee893d66c44e557$var$UPNG.decode._decompress(out, fd.slice(0, foff), fr.rect.width, fr.rect.height);
        foff = 0;
    }
    out.data = $6ee893d66c44e557$var$UPNG.decode._decompress(out, dd, out.width, out.height);
    delete out.compress;
    delete out.interlace;
    delete out.filter;
    return out;
};
$6ee893d66c44e557$var$UPNG.decode._decompress = function(out, dd, w, h) {
    var time = Date.now();
    var bpp = $6ee893d66c44e557$var$UPNG.decode._getBPP(out), bpl = Math.ceil(w * bpp / 8), buff = new Uint8Array((bpl + 1 + out.interlace) * h);
    dd = $6ee893d66c44e557$var$UPNG.decode._inflate(dd, buff);
    //console.log(dd.length, buff.length);
    //console.log(Date.now()-time);
    var time = Date.now();
    if (out.interlace == 0) dd = $6ee893d66c44e557$var$UPNG.decode._filterZero(dd, out, 0, w, h);
    else if (out.interlace == 1) dd = $6ee893d66c44e557$var$UPNG.decode._readInterlace(dd, out);
    //console.log(Date.now()-time);
    return dd;
};
$6ee893d66c44e557$var$UPNG.decode._inflate = function(data, buff) {
    var out = $6ee893d66c44e557$var$UPNG["inflateRaw"](new Uint8Array(data.buffer, 2, data.length - 6), buff);
    return out;
};
$6ee893d66c44e557$var$UPNG.inflateRaw = function() {
    var H = {};
    H.H = {};
    H.H.N = function(N, W) {
        var R = Uint8Array, i = 0, m = 0, J = 0, h = 0, Q = 0, X = 0, u = 0, w = 0, d = 0, v, C;
        if (N[0] == 3 && N[1] == 0) return W ? W : new R(0);
        var V = H.H, n = V.b, A = V.e, l = V.R, M = V.n, I = V.A, e = V.Z, b = V.m, Z = W == null;
        if (Z) W = new R(N.length >>> 2 << 3);
        while(i == 0){
            i = n(N, d, 1);
            m = n(N, d + 1, 2);
            d += 3;
            if (m == 0) {
                if ((d & 7) != 0) d += 8 - (d & 7);
                var D = (d >>> 3) + 4, q = N[D - 4] | N[D - 3] << 8;
                if (Z) W = H.H.W(W, w + q);
                W.set(new R(N.buffer, N.byteOffset + D, q), w);
                d = D + q << 3;
                w += q;
                continue;
            }
            if (Z) W = H.H.W(W, w + 131072);
            if (m == 1) {
                v = b.J;
                C = b.h;
                X = 511;
                u = 31;
            }
            if (m == 2) {
                J = A(N, d, 5) + 257;
                h = A(N, d + 5, 5) + 1;
                Q = A(N, d + 10, 4) + 4;
                d += 14;
                var E = d, j = 1;
                for(var c = 0; c < 38; c += 2){
                    b.Q[c] = 0;
                    b.Q[c + 1] = 0;
                }
                for(var c = 0; c < Q; c++){
                    var K = A(N, d + c * 3, 3);
                    b.Q[(b.X[c] << 1) + 1] = K;
                    if (K > j) j = K;
                }
                d += 3 * Q;
                M(b.Q, j);
                I(b.Q, j, b.u);
                v = b.w;
                C = b.d;
                d = l(b.u, (1 << j) - 1, J + h, N, d, b.v);
                var r = V.V(b.v, 0, J, b.C);
                X = (1 << r) - 1;
                var S = V.V(b.v, J, h, b.D);
                u = (1 << S) - 1;
                M(b.C, r);
                I(b.C, r, v);
                M(b.D, S);
                I(b.D, S, C);
            }
            while(true){
                var T = v[e(N, d) & X];
                d += T & 15;
                var p = T >>> 4;
                if (p >>> 8 == 0) W[w++] = p;
                else if (p == 256) break;
                else {
                    var z = w + p - 254;
                    if (p > 264) {
                        var _ = b.q[p - 257];
                        z = w + (_ >>> 3) + A(N, d, _ & 7);
                        d += _ & 7;
                    }
                    var $ = C[e(N, d) & u];
                    d += $ & 15;
                    var s = $ >>> 4, Y = b.c[s], a = (Y >>> 4) + n(N, d, Y & 15);
                    d += Y & 15;
                    while(w < z){
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                    }
                    w = z;
                }
            }
        }
        return W.length == w ? W : W.slice(0, w);
    };
    H.H.W = function(N, W) {
        var R = N.length;
        if (W <= R) return N;
        var V = new Uint8Array(R << 1);
        V.set(N, 0);
        return V;
    };
    H.H.R = function(N, W, R, V, n, A) {
        var l = H.H.e, M = H.H.Z, I = 0;
        while(I < R){
            var e = N[M(V, n) & W];
            n += e & 15;
            var b = e >>> 4;
            if (b <= 15) {
                A[I] = b;
                I++;
            } else {
                var Z = 0, m = 0;
                if (b == 16) {
                    m = 3 + l(V, n, 2);
                    n += 2;
                    Z = A[I - 1];
                } else if (b == 17) {
                    m = 3 + l(V, n, 3);
                    n += 3;
                } else if (b == 18) {
                    m = 11 + l(V, n, 7);
                    n += 7;
                }
                var J = I + m;
                while(I < J){
                    A[I] = Z;
                    I++;
                }
            }
        }
        return n;
    };
    H.H.V = function(N, W, R, V) {
        var n = 0, A = 0, l = V.length >>> 1;
        while(A < R){
            var M = N[A + W];
            V[A << 1] = 0;
            V[(A << 1) + 1] = M;
            if (M > n) n = M;
            A++;
        }
        while(A < l){
            V[A << 1] = 0;
            V[(A << 1) + 1] = 0;
            A++;
        }
        return n;
    };
    H.H.n = function(N, W) {
        var R = H.H.m, V = N.length, n, A, l, M, I, e = R.j;
        for(var M = 0; M <= W; M++)e[M] = 0;
        for(M = 1; M < V; M += 2)e[N[M]]++;
        var b = R.K;
        n = 0;
        e[0] = 0;
        for(A = 1; A <= W; A++){
            n = n + e[A - 1] << 1;
            b[A] = n;
        }
        for(l = 0; l < V; l += 2){
            I = N[l + 1];
            if (I != 0) {
                N[l] = b[I];
                b[I]++;
            }
        }
    };
    H.H.A = function(N, W, R) {
        var V = N.length, n = H.H.m, A = n.r;
        for(var l = 0; l < V; l += 2)if (N[l + 1] != 0) {
            var M = l >> 1, I = N[l + 1], e = M << 4 | I, b = W - I, Z = N[l] << b, m = Z + (1 << b);
            while(Z != m){
                var J = A[Z] >>> 15 - W;
                R[J] = e;
                Z++;
            }
        }
    };
    H.H.l = function(N, W) {
        var R = H.H.m.r, V = 15 - W;
        for(var n = 0; n < N.length; n += 2){
            var A = N[n] << W - N[n + 1];
            N[n] = R[A] >>> V;
        }
    };
    H.H.M = function(N, W, R) {
        R = R << (W & 7);
        var V = W >>> 3;
        N[V] |= R;
        N[V + 1] |= R >>> 8;
    };
    H.H.I = function(N, W, R) {
        R = R << (W & 7);
        var V = W >>> 3;
        N[V] |= R;
        N[V + 1] |= R >>> 8;
        N[V + 2] |= R >>> 16;
    };
    H.H.e = function(N, W, R) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8) >>> (W & 7) & (1 << R) - 1;
    };
    H.H.b = function(N, W, R) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16) >>> (W & 7) & (1 << R) - 1;
    };
    H.H.Z = function(N, W) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16) >>> (W & 7);
    };
    H.H.i = function(N, W) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16 | N[(W >>> 3) + 3] << 24) >>> (W & 7);
    };
    H.H.m = function() {
        var N = Uint16Array, W = Uint32Array;
        return {
            K: new N(16),
            j: new N(16),
            X: [
                16,
                17,
                18,
                0,
                8,
                7,
                9,
                6,
                10,
                5,
                11,
                4,
                12,
                3,
                13,
                2,
                14,
                1,
                15
            ],
            S: [
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                13,
                15,
                17,
                19,
                23,
                27,
                31,
                35,
                43,
                51,
                59,
                67,
                83,
                99,
                115,
                131,
                163,
                195,
                227,
                258,
                999,
                999,
                999
            ],
            T: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                1,
                1,
                1,
                2,
                2,
                2,
                2,
                3,
                3,
                3,
                3,
                4,
                4,
                4,
                4,
                5,
                5,
                5,
                5,
                0,
                0,
                0,
                0
            ],
            q: new N(32),
            p: [
                1,
                2,
                3,
                4,
                5,
                7,
                9,
                13,
                17,
                25,
                33,
                49,
                65,
                97,
                129,
                193,
                257,
                385,
                513,
                769,
                1025,
                1537,
                2049,
                3073,
                4097,
                6145,
                8193,
                12289,
                16385,
                24577,
                65535,
                65535
            ],
            z: [
                0,
                0,
                0,
                0,
                1,
                1,
                2,
                2,
                3,
                3,
                4,
                4,
                5,
                5,
                6,
                6,
                7,
                7,
                8,
                8,
                9,
                9,
                10,
                10,
                11,
                11,
                12,
                12,
                13,
                13,
                0,
                0
            ],
            c: new W(32),
            J: new N(512),
            _: [],
            h: new N(32),
            $: [],
            w: new N(32768),
            C: [],
            v: [],
            d: new N(32768),
            D: [],
            u: new N(512),
            Q: [],
            r: new N(32768),
            s: new W(286),
            Y: new W(30),
            a: new W(19),
            t: new W(15e3),
            k: new N(65536),
            g: new N(32768)
        };
    }();
    (function() {
        var N = H.H.m, W = 32768;
        for(var R = 0; R < W; R++){
            var V = R;
            V = (V & 2863311530) >>> 1 | (V & 1431655765) << 1;
            V = (V & 3435973836) >>> 2 | (V & 858993459) << 2;
            V = (V & 4042322160) >>> 4 | (V & 252645135) << 4;
            V = (V & 4278255360) >>> 8 | (V & 16711935) << 8;
            N.r[R] = (V >>> 16 | V << 16) >>> 17;
        }
        function n(A, l, M) {
            while(l-- != 0)A.push(0, M);
        }
        for(var R = 0; R < 32; R++){
            N.q[R] = N.S[R] << 3 | N.T[R];
            N.c[R] = N.p[R] << 4 | N.z[R];
        }
        n(N._, 144, 8);
        n(N._, 112, 9);
        n(N._, 24, 7);
        n(N._, 8, 8);
        H.H.n(N._, 9);
        H.H.A(N._, 9, N.J);
        H.H.l(N._, 9);
        n(N.$, 32, 5);
        H.H.n(N.$, 5);
        H.H.A(N.$, 5, N.h);
        H.H.l(N.$, 5);
        n(N.Q, 19, 0);
        n(N.C, 286, 0);
        n(N.D, 30, 0);
        n(N.v, 320, 0);
    })();
    return H.H.N;
}();
$6ee893d66c44e557$var$UPNG.decode._readInterlace = function(data, out) {
    var w = out.width, h = out.height;
    var bpp = $6ee893d66c44e557$var$UPNG.decode._getBPP(out), cbpp = bpp >> 3, bpl = Math.ceil(w * bpp / 8);
    var img = new Uint8Array(h * bpl);
    var di = 0;
    var starting_row = [
        0,
        0,
        4,
        0,
        2,
        0,
        1
    ];
    var starting_col = [
        0,
        4,
        0,
        2,
        0,
        1,
        0
    ];
    var row_increment = [
        8,
        8,
        8,
        4,
        4,
        2,
        2
    ];
    var col_increment = [
        8,
        8,
        4,
        4,
        2,
        2,
        1
    ];
    var pass = 0;
    while(pass < 7){
        var ri = row_increment[pass], ci = col_increment[pass];
        var sw = 0, sh = 0;
        var cr = starting_row[pass];
        while(cr < h){
            cr += ri;
            sh++;
        }
        var cc = starting_col[pass];
        while(cc < w){
            cc += ci;
            sw++;
        }
        var bpll = Math.ceil(sw * bpp / 8);
        $6ee893d66c44e557$var$UPNG.decode._filterZero(data, out, di, sw, sh);
        var y = 0, row = starting_row[pass];
        while(row < h){
            var col = starting_col[pass];
            var cdi = di + y * bpll << 3;
            while(col < w){
                if (bpp == 1) {
                    var val = data[cdi >> 3];
                    val = val >> 7 - (cdi & 7) & 1;
                    img[row * bpl + (col >> 3)] |= val << 7 - ((col & 7) << 0);
                }
                if (bpp == 2) {
                    var val = data[cdi >> 3];
                    val = val >> 6 - (cdi & 7) & 3;
                    img[row * bpl + (col >> 2)] |= val << 6 - ((col & 3) << 1);
                }
                if (bpp == 4) {
                    var val = data[cdi >> 3];
                    val = val >> 4 - (cdi & 7) & 15;
                    img[row * bpl + (col >> 1)] |= val << 4 - ((col & 1) << 2);
                }
                if (bpp >= 8) {
                    var ii = row * bpl + col * cbpp;
                    for(var j = 0; j < cbpp; j++)img[ii + j] = data[(cdi >> 3) + j];
                }
                cdi += bpp;
                col += ci;
            }
            y++;
            row += ri;
        }
        if (sw * sh != 0) di += sh * (1 + bpll);
        pass = pass + 1;
    }
    return img;
};
$6ee893d66c44e557$var$UPNG.decode._getBPP = function(out) {
    var noc = [
        1,
        null,
        3,
        1,
        2,
        null,
        4
    ][out.ctype];
    return noc * out.depth;
};
$6ee893d66c44e557$var$UPNG.decode._filterZero = function(data, out, off, w, h) {
    var bpp = $6ee893d66c44e557$var$UPNG.decode._getBPP(out), bpl = Math.ceil(w * bpp / 8), paeth = $6ee893d66c44e557$var$UPNG.decode._paeth;
    bpp = Math.ceil(bpp / 8);
    var i = 0, di = 1, type = data[off], x = 0;
    if (type > 1) data[off] = [
        0,
        0,
        1
    ][type - 2];
    if (type == 3) for(x = bpp; x < bpl; x++)data[x + 1] = data[x + 1] + (data[x + 1 - bpp] >>> 1) & 255;
    for(var y = 0; y < h; y++){
        i = off + y * bpl;
        di = i + y + 1;
        type = data[di - 1];
        x = 0;
        if (type == 0) for(; x < bpl; x++)data[i + x] = data[di + x];
        else if (type == 1) {
            for(; x < bpp; x++)data[i + x] = data[di + x];
            for(; x < bpl; x++)data[i + x] = data[di + x] + data[i + x - bpp];
        } else if (type == 2) for(; x < bpl; x++)data[i + x] = data[di + x] + data[i + x - bpl];
        else if (type == 3) {
            for(; x < bpp; x++)data[i + x] = data[di + x] + (data[i + x - bpl] >>> 1);
            for(; x < bpl; x++)data[i + x] = data[di + x] + (data[i + x - bpl] + data[i + x - bpp] >>> 1);
        } else {
            for(; x < bpp; x++)data[i + x] = data[di + x] + paeth(0, data[i + x - bpl], 0);
            for(; x < bpl; x++)data[i + x] = data[di + x] + paeth(data[i + x - bpp], data[i + x - bpl], data[i + x - bpp - bpl]);
        }
    }
    return data;
};
$6ee893d66c44e557$var$UPNG.decode._paeth = function(a, b, c) {
    var p = a + b - c, pa = p - a, pb = p - b, pc = p - c;
    if (pa * pa <= pb * pb && pa * pa <= pc * pc) return a;
    else if (pb * pb <= pc * pc) return b;
    return c;
};
$6ee893d66c44e557$var$UPNG.decode._IHDR = function(data, offset, out) {
    var bin = $6ee893d66c44e557$var$UPNG._bin;
    out.width = bin.readUint(data, offset);
    offset += 4;
    out.height = bin.readUint(data, offset);
    offset += 4;
    out.depth = data[offset];
    offset++;
    out.ctype = data[offset];
    offset++;
    out.compress = data[offset];
    offset++;
    out.filter = data[offset];
    offset++;
    out.interlace = data[offset];
    offset++;
};
$6ee893d66c44e557$var$UPNG._bin = {
    nextZero: function(data, p) {
        while(data[p] != 0)p++;
        return p;
    },
    readUshort: function(buff, p) {
        return buff[p] << 8 | buff[p + 1];
    },
    writeUshort: function(buff, p, n) {
        buff[p] = n >> 8 & 255;
        buff[p + 1] = n & 255;
    },
    readUint: function(buff, p) {
        return buff[p] * 16777216 + (buff[p + 1] << 16 | buff[p + 2] << 8 | buff[p + 3]);
    },
    writeUint: function(buff, p, n) {
        buff[p] = n >> 24 & 255;
        buff[p + 1] = n >> 16 & 255;
        buff[p + 2] = n >> 8 & 255;
        buff[p + 3] = n & 255;
    },
    readASCII: function(buff, p, l) {
        var s = "";
        for(var i = 0; i < l; i++)s += String.fromCharCode(buff[p + i]);
        return s;
    },
    writeASCII: function(data, p, s) {
        for(var i = 0; i < s.length; i++)data[p + i] = s.charCodeAt(i);
    },
    readBytes: function(buff, p, l) {
        var arr = [];
        for(var i = 0; i < l; i++)arr.push(buff[p + i]);
        return arr;
    },
    pad: function(n) {
        return n.length < 2 ? "0" + n : n;
    },
    readUTF8: function(buff, p, l) {
        var s = "", ns;
        for(var i = 0; i < l; i++)s += "%" + $6ee893d66c44e557$var$UPNG._bin.pad(buff[p + i].toString(16));
        try {
            ns = decodeURIComponent(s);
        } catch (e) {
            return $6ee893d66c44e557$var$UPNG._bin.readASCII(buff, p, l);
        }
        return ns;
    }
};
$6ee893d66c44e557$var$UPNG._copyTile = function(sb, sw, sh, tb, tw, th, xoff, yoff, mode) {
    var w = Math.min(sw, tw), h = Math.min(sh, th);
    var si = 0, ti = 0;
    for(var y = 0; y < h; y++)for(var x = 0; x < w; x++){
        if (xoff >= 0 && yoff >= 0) {
            si = y * sw + x << 2;
            ti = (yoff + y) * tw + xoff + x << 2;
        } else {
            si = (-yoff + y) * sw - xoff + x << 2;
            ti = y * tw + x << 2;
        }
        if (mode == 0) {
            tb[ti] = sb[si];
            tb[ti + 1] = sb[si + 1];
            tb[ti + 2] = sb[si + 2];
            tb[ti + 3] = sb[si + 3];
        } else if (mode == 1) {
            var fa = sb[si + 3] * (1 / 255), fr = sb[si] * fa, fg = sb[si + 1] * fa, fb = sb[si + 2] * fa;
            var ba = tb[ti + 3] * (1 / 255), br = tb[ti] * ba, bg = tb[ti + 1] * ba, bb = tb[ti + 2] * ba;
            var ifa = 1 - fa, oa = fa + ba * ifa, ioa = oa == 0 ? 0 : 1 / oa;
            tb[ti + 3] = 255 * oa;
            tb[ti + 0] = (fr + br * ifa) * ioa;
            tb[ti + 1] = (fg + bg * ifa) * ioa;
            tb[ti + 2] = (fb + bb * ifa) * ioa;
        } else if (mode == 2) {
            var fa = sb[si + 3], fr = sb[si], fg = sb[si + 1], fb = sb[si + 2];
            var ba = tb[ti + 3], br = tb[ti], bg = tb[ti + 1], bb = tb[ti + 2];
            if (fa == ba && fr == br && fg == bg && fb == bb) {
                tb[ti] = 0;
                tb[ti + 1] = 0;
                tb[ti + 2] = 0;
                tb[ti + 3] = 0;
            } else {
                tb[ti] = fr;
                tb[ti + 1] = fg;
                tb[ti + 2] = fb;
                tb[ti + 3] = fa;
            }
        } else if (mode == 3) {
            var fa = sb[si + 3], fr = sb[si], fg = sb[si + 1], fb = sb[si + 2];
            var ba = tb[ti + 3], br = tb[ti], bg = tb[ti + 1], bb = tb[ti + 2];
            if (fa == ba && fr == br && fg == bg && fb == bb) continue;
            //if(fa!=255 && ba!=0) return false;
            if (fa < 220 && ba > 20) return false;
        }
    }
    return true;
};
$6ee893d66c44e557$var$UPNG.encode = function(bufs, w, h, ps, dels, tabs, forbidPlte) {
    if (ps == null) ps = 0;
    if (forbidPlte == null) forbidPlte = false;
    var nimg = $6ee893d66c44e557$var$UPNG.encode.compress(bufs, w, h, ps, [
        false,
        false,
        false,
        0,
        forbidPlte
    ]);
    $6ee893d66c44e557$var$UPNG.encode.compressPNG(nimg, -1);
    return $6ee893d66c44e557$var$UPNG.encode._main(nimg, w, h, dels, tabs);
};
$6ee893d66c44e557$var$UPNG.encodeLL = function(bufs, w, h, cc, ac, depth, dels, tabs) {
    var nimg = {
        ctype: 0 + (cc == 1 ? 0 : 2) + (ac == 0 ? 0 : 4),
        depth: depth,
        frames: []
    };
    var time = Date.now();
    var bipp = (cc + ac) * depth, bipl = bipp * w;
    for(var i = 0; i < bufs.length; i++)nimg.frames.push({
        rect: {
            x: 0,
            y: 0,
            width: w,
            height: h
        },
        img: new Uint8Array(bufs[i]),
        blend: 0,
        dispose: 1,
        bpp: Math.ceil(bipp / 8),
        bpl: Math.ceil(bipl / 8)
    });
    $6ee893d66c44e557$var$UPNG.encode.compressPNG(nimg, 0, true);
    var out = $6ee893d66c44e557$var$UPNG.encode._main(nimg, w, h, dels, tabs);
    return out;
};
$6ee893d66c44e557$var$UPNG.encode._main = function(nimg, w, h, dels, tabs) {
    if (tabs == null) tabs = {};
    var crc = $6ee893d66c44e557$var$UPNG.crc.crc, wUi = $6ee893d66c44e557$var$UPNG._bin.writeUint, wUs = $6ee893d66c44e557$var$UPNG._bin.writeUshort, wAs = $6ee893d66c44e557$var$UPNG._bin.writeASCII;
    var offset = 8, anim = nimg.frames.length > 1, pltAlpha = false;
    var leng = 33 + (anim ? 20 : 0);
    if (tabs["sRGB"] != null) leng += 13;
    if (tabs["pHYs"] != null) leng += 21;
    if (nimg.ctype == 3) {
        var dl = nimg.plte.length;
        for(var i = 0; i < dl; i++)if (nimg.plte[i] >>> 24 != 255) pltAlpha = true;
        leng += 8 + dl * 3 + 4 + (pltAlpha ? 8 + dl * 1 + 4 : 0);
    }
    for(var j = 0; j < nimg.frames.length; j++){
        var fr = nimg.frames[j];
        if (anim) leng += 38;
        leng += fr.cimg.length + 12;
        if (j != 0) leng += 4;
    }
    leng += 12;
    var data = new Uint8Array(leng);
    var wr = [
        0x89,
        0x50,
        0x4e,
        0x47,
        0x0d,
        0x0a,
        0x1a,
        0x0a
    ];
    for(var i = 0; i < 8; i++)data[i] = wr[i];
    wUi(data, offset, 13);
    offset += 4;
    wAs(data, offset, "IHDR");
    offset += 4;
    wUi(data, offset, w);
    offset += 4;
    wUi(data, offset, h);
    offset += 4;
    data[offset] = nimg.depth;
    offset++; // depth
    data[offset] = nimg.ctype;
    offset++; // ctype
    data[offset] = 0;
    offset++; // compress
    data[offset] = 0;
    offset++; // filter
    data[offset] = 0;
    offset++; // interlace
    wUi(data, offset, crc(data, offset - 17, 17));
    offset += 4; // crc
    // 13 bytes to say, that it is sRGB
    if (tabs["sRGB"] != null) {
        wUi(data, offset, 1);
        offset += 4;
        wAs(data, offset, "sRGB");
        offset += 4;
        data[offset] = tabs["sRGB"];
        offset++;
        wUi(data, offset, crc(data, offset - 5, 5));
        offset += 4; // crc
    }
    if (tabs["pHYs"] != null) {
        wUi(data, offset, 9);
        offset += 4;
        wAs(data, offset, "pHYs");
        offset += 4;
        wUi(data, offset, tabs["pHYs"][0]);
        offset += 4;
        wUi(data, offset, tabs["pHYs"][1]);
        offset += 4;
        data[offset] = tabs["pHYs"][2];
        offset++;
        wUi(data, offset, crc(data, offset - 13, 13));
        offset += 4; // crc
    }
    if (anim) {
        wUi(data, offset, 8);
        offset += 4;
        wAs(data, offset, "acTL");
        offset += 4;
        wUi(data, offset, nimg.frames.length);
        offset += 4;
        wUi(data, offset, tabs["loop"] != null ? tabs["loop"] : 0);
        offset += 4;
        wUi(data, offset, crc(data, offset - 12, 12));
        offset += 4; // crc
    }
    if (nimg.ctype == 3) {
        var dl = nimg.plte.length;
        wUi(data, offset, dl * 3);
        offset += 4;
        wAs(data, offset, "PLTE");
        offset += 4;
        for(var i = 0; i < dl; i++){
            var ti = i * 3, c = nimg.plte[i], r = c & 255, g = c >>> 8 & 255, b = c >>> 16 & 255;
            data[offset + ti + 0] = r;
            data[offset + ti + 1] = g;
            data[offset + ti + 2] = b;
        }
        offset += dl * 3;
        wUi(data, offset, crc(data, offset - dl * 3 - 4, dl * 3 + 4));
        offset += 4; // crc
        if (pltAlpha) {
            wUi(data, offset, dl);
            offset += 4;
            wAs(data, offset, "tRNS");
            offset += 4;
            for(var i = 0; i < dl; i++)data[offset + i] = nimg.plte[i] >>> 24 & 255;
            offset += dl;
            wUi(data, offset, crc(data, offset - dl - 4, dl + 4));
            offset += 4; // crc
        }
    }
    var fi = 0;
    for(var j = 0; j < nimg.frames.length; j++){
        var fr = nimg.frames[j];
        if (anim) {
            wUi(data, offset, 26);
            offset += 4;
            wAs(data, offset, "fcTL");
            offset += 4;
            wUi(data, offset, fi++);
            offset += 4;
            wUi(data, offset, fr.rect.width);
            offset += 4;
            wUi(data, offset, fr.rect.height);
            offset += 4;
            wUi(data, offset, fr.rect.x);
            offset += 4;
            wUi(data, offset, fr.rect.y);
            offset += 4;
            wUs(data, offset, dels[j]);
            offset += 2;
            wUs(data, offset, 1000);
            offset += 2;
            data[offset] = fr.dispose;
            offset++; // dispose
            data[offset] = fr.blend;
            offset++; // blend
            wUi(data, offset, crc(data, offset - 30, 30));
            offset += 4; // crc
        }
        var imgd = fr.cimg, dl = imgd.length;
        wUi(data, offset, dl + (j == 0 ? 0 : 4));
        offset += 4;
        var ioff = offset;
        wAs(data, offset, j == 0 ? "IDAT" : "fdAT");
        offset += 4;
        if (j != 0) {
            wUi(data, offset, fi++);
            offset += 4;
        }
        data.set(imgd, offset);
        offset += dl;
        wUi(data, offset, crc(data, ioff, offset - ioff));
        offset += 4; // crc
    }
    wUi(data, offset, 0);
    offset += 4;
    wAs(data, offset, "IEND");
    offset += 4;
    wUi(data, offset, crc(data, offset - 4, 4));
    offset += 4; // crc
    return data.buffer;
};
$6ee893d66c44e557$var$UPNG.encode.compressPNG = function(out, filter, levelZero) {
    for(var i = 0; i < out.frames.length; i++){
        var frm = out.frames[i], nw = frm.rect.width, nh = frm.rect.height;
        var fdata = new Uint8Array(nh * frm.bpl + nh);
        frm.cimg = $6ee893d66c44e557$var$UPNG.encode._filterZero(frm.img, nh, frm.bpp, frm.bpl, fdata, filter, levelZero);
    }
};
$6ee893d66c44e557$var$UPNG.encode.compress = function(bufs, w, h, ps, prms) {
    //var time = Date.now();
    var onlyBlend = prms[0], evenCrd = prms[1], forbidPrev = prms[2], minBits = prms[3], forbidPlte = prms[4];
    var ctype = 6, depth = 8, alphaAnd = 255;
    for(var j = 0; j < bufs.length; j++){
        var img = new Uint8Array(bufs[j]), ilen = img.length;
        for(var i = 0; i < ilen; i += 4)alphaAnd &= img[i + 3];
    }
    var gotAlpha = alphaAnd != 255;
    //console.log("alpha check", Date.now()-time);  time = Date.now();
    //var brute = gotAlpha && forGIF;		// brute : frames can only be copied, not "blended"
    var frms = $6ee893d66c44e557$var$UPNG.encode.framize(bufs, w, h, onlyBlend, evenCrd, forbidPrev);
    //console.log("framize", Date.now()-time);  time = Date.now();
    var cmap = {}, plte = [], inds = [];
    if (ps != 0) {
        var nbufs = [];
        for(var i = 0; i < frms.length; i++)nbufs.push(frms[i].img.buffer);
        var abuf = $6ee893d66c44e557$var$UPNG.encode.concatRGBA(nbufs), qres = $6ee893d66c44e557$var$UPNG.quantize(abuf, ps);
        var cof = 0, bb = new Uint8Array(qres.abuf);
        for(var i = 0; i < frms.length; i++){
            var ti = frms[i].img, bln = ti.length;
            inds.push(new Uint8Array(qres.inds.buffer, cof >> 2, bln >> 2));
            for(var j = 0; j < bln; j += 4){
                ti[j] = bb[cof + j];
                ti[j + 1] = bb[cof + j + 1];
                ti[j + 2] = bb[cof + j + 2];
                ti[j + 3] = bb[cof + j + 3];
            }
            cof += bln;
        }
        for(var i = 0; i < qres.plte.length; i++)plte.push(qres.plte[i].est.rgba);
    //console.log("quantize", Date.now()-time);  time = Date.now();
    } else // what if ps==0, but there are <=256 colors?  we still need to detect, if the palette could be used
    for(var j = 0; j < frms.length; j++){
        var frm = frms[j], img32 = new Uint32Array(frm.img.buffer), nw = frm.rect.width, ilen = img32.length;
        var ind = new Uint8Array(ilen);
        inds.push(ind);
        for(var i = 0; i < ilen; i++){
            var c = img32[i];
            if (i != 0 && c == img32[i - 1]) ind[i] = ind[i - 1];
            else if (i > nw && c == img32[i - nw]) ind[i] = ind[i - nw];
            else {
                var cmc = cmap[c];
                if (cmc == null) {
                    cmap[c] = cmc = plte.length;
                    plte.push(c);
                    if (plte.length >= 300) break;
                }
                ind[i] = cmc;
            }
        }
    }
    var cc = plte.length; //console.log("colors:",cc);
    if (cc <= 256 && forbidPlte == false) {
        if (cc <= 2) depth = 1;
        else if (cc <= 4) depth = 2;
        else if (cc <= 16) depth = 4;
        else depth = 8;
        depth = Math.max(depth, minBits);
    }
    for(var j = 0; j < frms.length; j++){
        var frm = frms[j], nx = frm.rect.x, ny = frm.rect.y, nw = frm.rect.width, nh = frm.rect.height;
        var cimg = frm.img, cimg32 = new Uint32Array(cimg.buffer);
        var bpl = 4 * nw, bpp = 4;
        if (cc <= 256 && forbidPlte == false) {
            bpl = Math.ceil(depth * nw / 8);
            var nimg = new Uint8Array(bpl * nh);
            var inj = inds[j];
            for(var y = 0; y < nh; y++){
                var i = y * bpl, ii = y * nw;
                if (depth == 8) for(var x = 0; x < nw; x++)nimg[i + x] = inj[ii + x];
                else if (depth == 4) for(var x = 0; x < nw; x++)nimg[i + (x >> 1)] |= inj[ii + x] << 4 - (x & 1) * 4;
                else if (depth == 2) for(var x = 0; x < nw; x++)nimg[i + (x >> 2)] |= inj[ii + x] << 6 - (x & 3) * 2;
                else if (depth == 1) for(var x = 0; x < nw; x++)nimg[i + (x >> 3)] |= inj[ii + x] << 7 - (x & 7) * 1;
            }
            cimg = nimg;
            ctype = 3;
            bpp = 1;
        } else if (gotAlpha == false && frms.length == 1) {
            var nimg = new Uint8Array(nw * nh * 3), area = nw * nh;
            for(var i = 0; i < area; i++){
                var ti = i * 3, qi = i * 4;
                nimg[ti] = cimg[qi];
                nimg[ti + 1] = cimg[qi + 1];
                nimg[ti + 2] = cimg[qi + 2];
            }
            cimg = nimg;
            ctype = 2;
            bpp = 3;
            bpl = 3 * nw;
        }
        frm.img = cimg;
        frm.bpl = bpl;
        frm.bpp = bpp;
    }
    //console.log("colors => palette indices", Date.now()-time);  time = Date.now();
    return {
        ctype: ctype,
        depth: depth,
        plte: plte,
        frames: frms
    };
};
$6ee893d66c44e557$var$UPNG.encode.framize = function(bufs, w, h, alwaysBlend, evenCrd, forbidPrev) {
    /*  DISPOSE
	    - 0 : no change
		- 1 : clear to transparent
		- 2 : retstore to content before rendering (previous frame disposed)
		BLEND
		- 0 : replace
		- 1 : blend
	*/ var frms = [];
    for(var j = 0; j < bufs.length; j++){
        var cimg = new Uint8Array(bufs[j]), cimg32 = new Uint32Array(cimg.buffer);
        var nimg;
        var nx = 0, ny = 0, nw = w, nh = h, blend = alwaysBlend ? 1 : 0;
        if (j != 0) {
            var tlim = forbidPrev || alwaysBlend || j == 1 || frms[j - 2].dispose != 0 ? 1 : 2, tstp = 0, tarea = 1e9;
            for(var it = 0; it < tlim; it++){
                var pimg = new Uint8Array(bufs[j - 1 - it]), p32 = new Uint32Array(bufs[j - 1 - it]);
                var mix = w, miy = h, max = -1, may = -1;
                for(var y = 0; y < h; y++)for(var x = 0; x < w; x++){
                    var i = y * w + x;
                    if (cimg32[i] != p32[i]) {
                        if (x < mix) mix = x;
                        if (x > max) max = x;
                        if (y < miy) miy = y;
                        if (y > may) may = y;
                    }
                }
                if (max == -1) mix = miy = max = may = 0;
                if (evenCrd) {
                    if ((mix & 1) == 1) mix--;
                    if ((miy & 1) == 1) miy--;
                }
                var sarea = (max - mix + 1) * (may - miy + 1);
                if (sarea < tarea) {
                    tarea = sarea;
                    tstp = it;
                    nx = mix;
                    ny = miy;
                    nw = max - mix + 1;
                    nh = may - miy + 1;
                }
            }
            // alwaysBlend: pokud zjistím, že blendit nelze, nastavím předchozímu snímku dispose=1. Zajistím, aby obsahoval můj obdélník.
            var pimg = new Uint8Array(bufs[j - 1 - tstp]);
            if (tstp == 1) frms[j - 1].dispose = 2;
            nimg = new Uint8Array(nw * nh * 4);
            $6ee893d66c44e557$var$UPNG._copyTile(pimg, w, h, nimg, nw, nh, -nx, -ny, 0);
            blend = $6ee893d66c44e557$var$UPNG._copyTile(cimg, w, h, nimg, nw, nh, -nx, -ny, 3) ? 1 : 0;
            if (blend == 1) $6ee893d66c44e557$var$UPNG.encode._prepareDiff(cimg, w, h, nimg, {
                x: nx,
                y: ny,
                width: nw,
                height: nh
            });
            else $6ee893d66c44e557$var$UPNG._copyTile(cimg, w, h, nimg, nw, nh, -nx, -ny, 0);
        //UPNG._copyTile(cimg,w,h, nimg,nw,nh, -nx,-ny, blend==1?2:0);
        } else nimg = cimg.slice(0); // img may be rewritten further ... don't rewrite input
        frms.push({
            rect: {
                x: nx,
                y: ny,
                width: nw,
                height: nh
            },
            img: nimg,
            blend: blend,
            dispose: 0
        });
    }
    if (alwaysBlend) for(var j = 0; j < frms.length; j++){
        var frm = frms[j];
        if (frm.blend == 1) continue;
        var r0 = frm.rect, r1 = frms[j - 1].rect;
        var miX = Math.min(r0.x, r1.x), miY = Math.min(r0.y, r1.y);
        var maX = Math.max(r0.x + r0.width, r1.x + r1.width), maY = Math.max(r0.y + r0.height, r1.y + r1.height);
        var r = {
            x: miX,
            y: miY,
            width: maX - miX,
            height: maY - miY
        };
        frms[j - 1].dispose = 1;
        if (j - 1 != 0) $6ee893d66c44e557$var$UPNG.encode._updateFrame(bufs, w, h, frms, j - 1, r, evenCrd);
        $6ee893d66c44e557$var$UPNG.encode._updateFrame(bufs, w, h, frms, j, r, evenCrd);
    }
    var area = 0;
    if (bufs.length != 1) for(var i = 0; i < frms.length; i++){
        var frm = frms[i];
        area += frm.rect.width * frm.rect.height;
    //if(i==0 || frm.blend!=1) continue;
    //var ob = new Uint8Array(
    //console.log(frm.blend, frm.dispose, frm.rect);
    }
    //if(area!=0) console.log(area);
    return frms;
};
$6ee893d66c44e557$var$UPNG.encode._updateFrame = function(bufs, w, h, frms, i, r, evenCrd) {
    var U8 = Uint8Array, U32 = Uint32Array;
    var pimg = new U8(bufs[i - 1]), pimg32 = new U32(bufs[i - 1]), nimg = i + 1 < bufs.length ? new U8(bufs[i + 1]) : null;
    var cimg = new U8(bufs[i]), cimg32 = new U32(cimg.buffer);
    var mix = w, miy = h, max = -1, may = -1;
    for(var y = 0; y < r.height; y++)for(var x = 0; x < r.width; x++){
        var cx = r.x + x, cy = r.y + y;
        var j = cy * w + cx, cc = cimg32[j];
        // no need to draw transparency, or to dispose it. Or, if writing the same color and the next one does not need transparency.
        if (cc == 0 || frms[i - 1].dispose == 0 && pimg32[j] == cc && (nimg == null || nimg[j * 4 + 3] != 0)) ;
        else {
            if (cx < mix) mix = cx;
            if (cx > max) max = cx;
            if (cy < miy) miy = cy;
            if (cy > may) may = cy;
        }
    }
    if (max == -1) mix = miy = max = may = 0;
    if (evenCrd) {
        if ((mix & 1) == 1) mix--;
        if ((miy & 1) == 1) miy--;
    }
    r = {
        x: mix,
        y: miy,
        width: max - mix + 1,
        height: may - miy + 1
    };
    var fr = frms[i];
    fr.rect = r;
    fr.blend = 1;
    fr.img = new Uint8Array(r.width * r.height * 4);
    if (frms[i - 1].dispose == 0) {
        $6ee893d66c44e557$var$UPNG._copyTile(pimg, w, h, fr.img, r.width, r.height, -r.x, -r.y, 0);
        $6ee893d66c44e557$var$UPNG.encode._prepareDiff(cimg, w, h, fr.img, r);
    //UPNG._copyTile(cimg,w,h, fr.img,r.width,r.height, -r.x,-r.y, 2);
    } else $6ee893d66c44e557$var$UPNG._copyTile(cimg, w, h, fr.img, r.width, r.height, -r.x, -r.y, 0);
};
$6ee893d66c44e557$var$UPNG.encode._prepareDiff = function(cimg, w, h, nimg, rec) {
    $6ee893d66c44e557$var$UPNG._copyTile(cimg, w, h, nimg, rec.width, rec.height, -rec.x, -rec.y, 2);
/*
	var n32 = new Uint32Array(nimg.buffer);
	var og = new Uint8Array(rec.width*rec.height*4), o32 = new Uint32Array(og.buffer);
	UPNG._copyTile(cimg,w,h, og,rec.width,rec.height, -rec.x,-rec.y, 0);
	for(var i=4; i<nimg.length; i+=4) {
		if(nimg[i-1]!=0 && nimg[i+3]==0 && o32[i>>>2]==o32[(i>>>2)-1]) {
			n32[i>>>2]=o32[i>>>2];
			//var j = i, c=p32[(i>>>2)-1];
			//while(p32[j>>>2]==c) {  n32[j>>>2]=c;  j+=4;  }
		}
	}
	for(var i=nimg.length-8; i>0; i-=4) {
		if(nimg[i+7]!=0 && nimg[i+3]==0 && o32[i>>>2]==o32[(i>>>2)+1]) {
			n32[i>>>2]=o32[i>>>2];
			//var j = i, c=p32[(i>>>2)-1];
			//while(p32[j>>>2]==c) {  n32[j>>>2]=c;  j+=4;  }
		}
	}*/ };
$6ee893d66c44e557$var$UPNG.encode._filterZero = function(img, h, bpp, bpl, data, filter, levelZero) {
    var fls = [], ftry = [
        0,
        1,
        2,
        3,
        4
    ];
    if (filter != -1) ftry = [
        filter
    ];
    else if (h * bpl > 500000 || bpp == 1) ftry = [
        0
    ];
    var opts;
    if (levelZero) opts = {
        level: 0
    };
    var CMPR = levelZero && UZIP != null ? UZIP : (0, (/*@__PURE__*/$parcel$interopDefault($ckCqy)));
    for(var i = 0; i < ftry.length; i++){
        for(var y = 0; y < h; y++)$6ee893d66c44e557$var$UPNG.encode._filterLine(data, img, y, bpl, bpp, ftry[i]);
        //var nimg = new Uint8Array(data.length);
        //var sz = UZIP.F.deflate(data, nimg);  fls.push(nimg.slice(0,sz));
        //var dfl = pako["deflate"](data), dl=dfl.length-4;
        //var crc = (dfl[dl+3]<<24)|(dfl[dl+2]<<16)|(dfl[dl+1]<<8)|(dfl[dl+0]<<0);
        //console.log(crc, UZIP.adler(data,2,data.length-6));
        fls.push(CMPR["deflate"](data, opts));
    }
    var ti, tsize = 1e9;
    for(var i = 0; i < fls.length; i++)if (fls[i].length < tsize) {
        ti = i;
        tsize = fls[i].length;
    }
    return fls[ti];
};
$6ee893d66c44e557$var$UPNG.encode._filterLine = function(data, img, y, bpl, bpp, type) {
    var i = y * bpl, di = i + y, paeth = $6ee893d66c44e557$var$UPNG.decode._paeth;
    data[di] = type;
    di++;
    if (type == 0) {
        if (bpl < 500) for(var x = 0; x < bpl; x++)data[di + x] = img[i + x];
        else data.set(new Uint8Array(img.buffer, i, bpl), di);
    } else if (type == 1) {
        for(var x = 0; x < bpp; x++)data[di + x] = img[i + x];
        for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - img[i + x - bpp] + 256 & 255;
    } else if (y == 0) {
        for(var x = 0; x < bpp; x++)data[di + x] = img[i + x];
        if (type == 2) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x];
        if (type == 3) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - (img[i + x - bpp] >> 1) + 256 & 255;
        if (type == 4) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - paeth(img[i + x - bpp], 0, 0) + 256 & 255;
    } else {
        if (type == 2) for(var x = 0; x < bpl; x++)data[di + x] = img[i + x] + 256 - img[i + x - bpl] & 255;
        if (type == 3) {
            for(var x = 0; x < bpp; x++)data[di + x] = img[i + x] + 256 - (img[i + x - bpl] >> 1) & 255;
            for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] + 256 - (img[i + x - bpl] + img[i + x - bpp] >> 1) & 255;
        }
        if (type == 4) {
            for(var x = 0; x < bpp; x++)data[di + x] = img[i + x] + 256 - paeth(0, img[i + x - bpl], 0) & 255;
            for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] + 256 - paeth(img[i + x - bpp], img[i + x - bpl], img[i + x - bpp - bpl]) & 255;
        }
    }
};
$6ee893d66c44e557$var$UPNG.crc = {
    table: function() {
        var tab = new Uint32Array(256);
        for(var n = 0; n < 256; n++){
            var c = n;
            for(var k = 0; k < 8; k++)if (c & 1) c = 0xedb88320 ^ c >>> 1;
            else c = c >>> 1;
            tab[n] = c;
        }
        return tab;
    }(),
    update: function(c, buf, off, len) {
        for(var i = 0; i < len; i++)c = $6ee893d66c44e557$var$UPNG.crc.table[(c ^ buf[off + i]) & 0xff] ^ c >>> 8;
        return c;
    },
    crc: function(b, o, l) {
        return $6ee893d66c44e557$var$UPNG.crc.update(0xffffffff, b, o, l) ^ 0xffffffff;
    }
};
$6ee893d66c44e557$var$UPNG.quantize = function(abuf, ps) {
    var oimg = new Uint8Array(abuf), nimg = oimg.slice(0), nimg32 = new Uint32Array(nimg.buffer);
    var KD = $6ee893d66c44e557$var$UPNG.quantize.getKDtree(nimg, ps);
    var root = KD[0], leafs = KD[1];
    var planeDst = $6ee893d66c44e557$var$UPNG.quantize.planeDst;
    var sb = oimg, tb = nimg32, len = sb.length;
    var inds = new Uint8Array(oimg.length >> 2);
    for(var i = 0; i < len; i += 4){
        var r = sb[i] * (1 / 255), g = sb[i + 1] * (1 / 255), b = sb[i + 2] * (1 / 255), a = sb[i + 3] * (1 / 255);
        //  exact, but too slow :(
        var nd = $6ee893d66c44e557$var$UPNG.quantize.getNearest(root, r, g, b, a);
        //var nd = root;
        //while(nd.left) nd = (planeDst(nd.est,r,g,b,a)<=0) ? nd.left : nd.right;
        inds[i >> 2] = nd.ind;
        tb[i >> 2] = nd.est.rgba;
    }
    return {
        abuf: nimg.buffer,
        inds: inds,
        plte: leafs
    };
};
$6ee893d66c44e557$var$UPNG.quantize.getKDtree = function(nimg, ps, err) {
    if (err == null) err = 0.0001;
    var nimg32 = new Uint32Array(nimg.buffer);
    var root = {
        i0: 0,
        i1: nimg.length,
        bst: null,
        est: null,
        tdst: 0,
        left: null,
        right: null
    }; // basic statistic, extra statistic
    root.bst = $6ee893d66c44e557$var$UPNG.quantize.stats(nimg, root.i0, root.i1);
    root.est = $6ee893d66c44e557$var$UPNG.quantize.estats(root.bst);
    var leafs = [
        root
    ];
    while(leafs.length < ps){
        var maxL = 0, mi = 0;
        for(var i = 0; i < leafs.length; i++)if (leafs[i].est.L > maxL) {
            maxL = leafs[i].est.L;
            mi = i;
        }
        if (maxL < err) break;
        var node = leafs[mi];
        var s0 = $6ee893d66c44e557$var$UPNG.quantize.splitPixels(nimg, nimg32, node.i0, node.i1, node.est.e, node.est.eMq255);
        var s0wrong = node.i0 >= s0 || node.i1 <= s0;
        //console.log(maxL, leafs.length, mi);
        if (s0wrong) {
            node.est.L = 0;
            continue;
        }
        var ln = {
            i0: node.i0,
            i1: s0,
            bst: null,
            est: null,
            tdst: 0,
            left: null,
            right: null
        };
        ln.bst = $6ee893d66c44e557$var$UPNG.quantize.stats(nimg, ln.i0, ln.i1);
        ln.est = $6ee893d66c44e557$var$UPNG.quantize.estats(ln.bst);
        var rn = {
            i0: s0,
            i1: node.i1,
            bst: null,
            est: null,
            tdst: 0,
            left: null,
            right: null
        };
        rn.bst = {
            R: [],
            m: [],
            N: node.bst.N - ln.bst.N
        };
        for(var i = 0; i < 16; i++)rn.bst.R[i] = node.bst.R[i] - ln.bst.R[i];
        for(var i = 0; i < 4; i++)rn.bst.m[i] = node.bst.m[i] - ln.bst.m[i];
        rn.est = $6ee893d66c44e557$var$UPNG.quantize.estats(rn.bst);
        node.left = ln;
        node.right = rn;
        leafs[mi] = ln;
        leafs.push(rn);
    }
    leafs.sort(function(a, b) {
        return b.bst.N - a.bst.N;
    });
    for(var i = 0; i < leafs.length; i++)leafs[i].ind = i;
    return [
        root,
        leafs
    ];
};
$6ee893d66c44e557$var$UPNG.quantize.getNearest = function(nd, r, g, b, a) {
    if (nd.left == null) {
        nd.tdst = $6ee893d66c44e557$var$UPNG.quantize.dist(nd.est.q, r, g, b, a);
        return nd;
    }
    var planeDst = $6ee893d66c44e557$var$UPNG.quantize.planeDst(nd.est, r, g, b, a);
    var node0 = nd.left, node1 = nd.right;
    if (planeDst > 0) {
        node0 = nd.right;
        node1 = nd.left;
    }
    var ln = $6ee893d66c44e557$var$UPNG.quantize.getNearest(node0, r, g, b, a);
    if (ln.tdst <= planeDst * planeDst) return ln;
    var rn = $6ee893d66c44e557$var$UPNG.quantize.getNearest(node1, r, g, b, a);
    return rn.tdst < ln.tdst ? rn : ln;
};
$6ee893d66c44e557$var$UPNG.quantize.planeDst = function(est, r, g, b, a) {
    var e = est.e;
    return e[0] * r + e[1] * g + e[2] * b + e[3] * a - est.eMq;
};
$6ee893d66c44e557$var$UPNG.quantize.dist = function(q, r, g, b, a) {
    var d0 = r - q[0], d1 = g - q[1], d2 = b - q[2], d3 = a - q[3];
    return d0 * d0 + d1 * d1 + d2 * d2 + d3 * d3;
};
$6ee893d66c44e557$var$UPNG.quantize.splitPixels = function(nimg, nimg32, i0, i1, e, eMq) {
    var vecDot = $6ee893d66c44e557$var$UPNG.quantize.vecDot;
    i1 -= 4;
    var shfs = 0;
    while(i0 < i1){
        while(vecDot(nimg, i0, e) <= eMq)i0 += 4;
        while(vecDot(nimg, i1, e) > eMq)i1 -= 4;
        if (i0 >= i1) break;
        var t = nimg32[i0 >> 2];
        nimg32[i0 >> 2] = nimg32[i1 >> 2];
        nimg32[i1 >> 2] = t;
        i0 += 4;
        i1 -= 4;
    }
    while(vecDot(nimg, i0, e) > eMq)i0 -= 4;
    return i0 + 4;
};
$6ee893d66c44e557$var$UPNG.quantize.vecDot = function(nimg, i, e) {
    return nimg[i] * e[0] + nimg[i + 1] * e[1] + nimg[i + 2] * e[2] + nimg[i + 3] * e[3];
};
$6ee893d66c44e557$var$UPNG.quantize.stats = function(nimg, i0, i1) {
    var R = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var m = [
        0,
        0,
        0,
        0
    ];
    var N = i1 - i0 >> 2;
    for(var i = i0; i < i1; i += 4){
        var r = nimg[i] * (1 / 255), g = nimg[i + 1] * (1 / 255), b = nimg[i + 2] * (1 / 255), a = nimg[i + 3] * (1 / 255);
        //var r = nimg[i], g = nimg[i+1], b = nimg[i+2], a = nimg[i+3];
        m[0] += r;
        m[1] += g;
        m[2] += b;
        m[3] += a;
        R[0] += r * r;
        R[1] += r * g;
        R[2] += r * b;
        R[3] += r * a;
        R[5] += g * g;
        R[6] += g * b;
        R[7] += g * a;
        R[10] += b * b;
        R[11] += b * a;
        R[15] += a * a;
    }
    R[4] = R[1];
    R[8] = R[2];
    R[9] = R[6];
    R[12] = R[3];
    R[13] = R[7];
    R[14] = R[11];
    return {
        R: R,
        m: m,
        N: N
    };
};
$6ee893d66c44e557$var$UPNG.quantize.estats = function(stats) {
    var R = stats.R, m = stats.m, N = stats.N;
    // when all samples are equal, but N is large (millions), the Rj can be non-zero ( 0.0003.... - precission error)
    var m0 = m[0], m1 = m[1], m2 = m[2], m3 = m[3], iN = N == 0 ? 0 : 1 / N;
    var Rj = [
        R[0] - m0 * m0 * iN,
        R[1] - m0 * m1 * iN,
        R[2] - m0 * m2 * iN,
        R[3] - m0 * m3 * iN,
        R[4] - m1 * m0 * iN,
        R[5] - m1 * m1 * iN,
        R[6] - m1 * m2 * iN,
        R[7] - m1 * m3 * iN,
        R[8] - m2 * m0 * iN,
        R[9] - m2 * m1 * iN,
        R[10] - m2 * m2 * iN,
        R[11] - m2 * m3 * iN,
        R[12] - m3 * m0 * iN,
        R[13] - m3 * m1 * iN,
        R[14] - m3 * m2 * iN,
        R[15] - m3 * m3 * iN
    ];
    var A = Rj, M = $6ee893d66c44e557$var$UPNG.M4;
    var b = [
        0.5,
        0.5,
        0.5,
        0.5
    ], mi = 0, tmi = 0;
    if (N != 0) for(var i = 0; i < 10; i++){
        b = M.multVec(A, b);
        tmi = Math.sqrt(M.dot(b, b));
        b = M.sml(1 / tmi, b);
        if (Math.abs(tmi - mi) < 1e-9) break;
        mi = tmi;
    }
    //b = [0,0,1,0];  mi=N;
    var q = [
        m0 * iN,
        m1 * iN,
        m2 * iN,
        m3 * iN
    ];
    var eMq255 = M.dot(M.sml(255, q), b);
    return {
        Cov: Rj,
        q: q,
        e: b,
        L: mi,
        eMq255: eMq255,
        eMq: M.dot(b, q),
        rgba: (Math.round(255 * q[3]) << 24 | Math.round(255 * q[2]) << 16 | Math.round(255 * q[1]) << 8 | Math.round(255 * q[0]) << 0) >>> 0
    };
};
$6ee893d66c44e557$var$UPNG.M4 = {
    multVec: function(m, v) {
        return [
            m[0] * v[0] + m[1] * v[1] + m[2] * v[2] + m[3] * v[3],
            m[4] * v[0] + m[5] * v[1] + m[6] * v[2] + m[7] * v[3],
            m[8] * v[0] + m[9] * v[1] + m[10] * v[2] + m[11] * v[3],
            m[12] * v[0] + m[13] * v[1] + m[14] * v[2] + m[15] * v[3]
        ];
    },
    dot: function(x, y) {
        return x[0] * y[0] + x[1] * y[1] + x[2] * y[2] + x[3] * y[3];
    },
    sml: function(a, y) {
        return [
            a * y[0],
            a * y[1],
            a * y[2],
            a * y[3]
        ];
    }
};
$6ee893d66c44e557$var$UPNG.encode.concatRGBA = function(bufs) {
    var tlen = 0;
    for(var i = 0; i < bufs.length; i++)tlen += bufs[i].byteLength;
    var nimg = new Uint8Array(tlen), noff = 0;
    for(var i = 0; i < bufs.length; i++){
        var img = new Uint8Array(bufs[i]), il = img.length;
        for(var j = 0; j < il; j += 4){
            var r = img[j], g = img[j + 1], b = img[j + 2], a = img[j + 3];
            if (a == 0) r = g = b = 0;
            nimg[noff + j] = r;
            nimg[noff + j + 1] = g;
            nimg[noff + j + 2] = b;
            nimg[noff + j + 3] = a;
        }
        noff += il;
    }
    return nimg.buffer;
};
var $6ee893d66c44e557$export$2e2bcd8739ae039 = $6ee893d66c44e557$var$UPNG;


var $eb710dec6a4e1482$var$getImageType = function(ctype) {
    if (ctype === 0) return $eb710dec6a4e1482$export$3ff975e8f63e458c.Greyscale;
    if (ctype === 2) return $eb710dec6a4e1482$export$3ff975e8f63e458c.Truecolour;
    if (ctype === 3) return $eb710dec6a4e1482$export$3ff975e8f63e458c.IndexedColour;
    if (ctype === 4) return $eb710dec6a4e1482$export$3ff975e8f63e458c.GreyscaleWithAlpha;
    if (ctype === 6) return $eb710dec6a4e1482$export$3ff975e8f63e458c.TruecolourWithAlpha;
    throw new Error("Unknown color type: " + ctype);
};
var $eb710dec6a4e1482$var$splitAlphaChannel = function(rgbaChannel) {
    var pixelCount = Math.floor(rgbaChannel.length / 4);
    var rgbChannel = new Uint8Array(pixelCount * 3);
    var alphaChannel = new Uint8Array(pixelCount * 1);
    var rgbaOffset = 0;
    var rgbOffset = 0;
    var alphaOffset = 0;
    while(rgbaOffset < rgbaChannel.length){
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        alphaChannel[alphaOffset++] = rgbaChannel[rgbaOffset++];
    }
    return {
        rgbChannel: rgbChannel,
        alphaChannel: alphaChannel
    };
};
var $eb710dec6a4e1482$export$3ff975e8f63e458c;
(function(PngType) {
    PngType["Greyscale"] = "Greyscale";
    PngType["Truecolour"] = "Truecolour";
    PngType["IndexedColour"] = "IndexedColour";
    PngType["GreyscaleWithAlpha"] = "GreyscaleWithAlpha";
    PngType["TruecolourWithAlpha"] = "TruecolourWithAlpha";
})($eb710dec6a4e1482$export$3ff975e8f63e458c || ($eb710dec6a4e1482$export$3ff975e8f63e458c = {}));
var $eb710dec6a4e1482$export$1f536085c24cc947 = /** @class */ function() {
    function PNG(pngData) {
        var upng = (0, $6ee893d66c44e557$export$2e2bcd8739ae039).decode(pngData);
        var frames = (0, $6ee893d66c44e557$export$2e2bcd8739ae039).toRGBA8(upng);
        if (frames.length > 1) throw new Error("Animated PNGs are not supported");
        var frame = new Uint8Array(frames[0]);
        var _a = $eb710dec6a4e1482$var$splitAlphaChannel(frame), rgbChannel = _a.rgbChannel, alphaChannel = _a.alphaChannel;
        this.rgbChannel = rgbChannel;
        var hasAlphaValues = alphaChannel.some(function(a) {
            return a < 255;
        });
        if (hasAlphaValues) this.alphaChannel = alphaChannel;
        this.type = $eb710dec6a4e1482$var$getImageType(upng.ctype);
        this.width = upng.width;
        this.height = upng.height;
        this.bitsPerComponent = 8;
    }
    PNG.load = function(pngData) {
        return new PNG(pngData);
    };
    return PNG;
}();


/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/png.coffee
 */ var $79f8a6e417146498$var$PngEmbedder = /** @class */ function() {
    function PngEmbedder(png) {
        this.image = png;
        this.bitsPerComponent = png.bitsPerComponent;
        this.width = png.width;
        this.height = png.height;
        this.colorSpace = 'DeviceRGB';
    }
    PngEmbedder.for = function(imageData) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var png;
            return (0, $cOQTW.__generator)(this, function(_a) {
                png = (0, $eb710dec6a4e1482$export$1f536085c24cc947).load(imageData);
                return [
                    2 /*return*/ ,
                    new PngEmbedder(png)
                ];
            });
        });
    };
    PngEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var SMask, xObject;
            return (0, $cOQTW.__generator)(this, function(_a) {
                SMask = this.embedAlphaChannel(context);
                xObject = context.flateStream(this.image.rgbChannel, {
                    Type: 'XObject',
                    Subtype: 'Image',
                    BitsPerComponent: this.image.bitsPerComponent,
                    Width: this.image.width,
                    Height: this.image.height,
                    ColorSpace: this.colorSpace,
                    SMask: SMask
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    PngEmbedder.prototype.embedAlphaChannel = function(context) {
        if (!this.image.alphaChannel) return undefined;
        var xObject = context.flateStream(this.image.alphaChannel, {
            Type: 'XObject',
            Subtype: 'Image',
            Height: this.image.height,
            Width: this.image.width,
            BitsPerComponent: this.image.bitsPerComponent,
            ColorSpace: 'DeviceGray',
            Decode: [
                0,
                1
            ]
        });
        return context.register(xObject);
    };
    return PngEmbedder;
}();
var $79f8a6e417146498$export$2e2bcd8739ae039 = $79f8a6e417146498$var$PngEmbedder;



var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $j04jt = parcelRequire("j04jt");



var $nAWRe = parcelRequire("nAWRe");

var $8auL6 = parcelRequire("8auL6");


var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The Ascii85Stream class contained in this file is a TypeScript port of the
 * JavaScript Ascii85Stream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The Stream class contained in this file is a TypeScript port of the
 * JavaScript Stream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ var $6994bc106090076a$var$Stream = /** @class */ function() {
    function Stream(buffer, start, length) {
        this.bytes = buffer;
        this.start = start || 0;
        this.pos = this.start;
        this.end = !!start && !!length ? start + length : this.bytes.length;
    }
    Object.defineProperty(Stream.prototype, "length", {
        get: function() {
            return this.end - this.start;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Stream.prototype, "isEmpty", {
        get: function() {
            return this.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Stream.prototype.getByte = function() {
        if (this.pos >= this.end) return -1;
        return this.bytes[this.pos++];
    };
    Stream.prototype.getUint16 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        if (b0 === -1 || b1 === -1) return -1;
        return (b0 << 8) + b1;
    };
    Stream.prototype.getInt32 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        var b2 = this.getByte();
        var b3 = this.getByte();
        return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
    };
    // Returns subarray of original buffer, should only be read.
    Stream.prototype.getBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.bytes;
        var pos = this.pos;
        var strEnd = this.end;
        if (!length) {
            var subarray = bytes.subarray(pos, strEnd);
            // `this.bytes` is always a `Uint8Array` here.
            return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
        } else {
            var end = pos + length;
            if (end > strEnd) end = strEnd;
            this.pos = end;
            var subarray = bytes.subarray(pos, end);
            // `this.bytes` is always a `Uint8Array` here.
            return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
        }
    };
    Stream.prototype.peekByte = function() {
        var peekedByte = this.getByte();
        this.pos--;
        return peekedByte;
    };
    Stream.prototype.peekBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.getBytes(length, forceClamped);
        this.pos -= bytes.length;
        return bytes;
    };
    Stream.prototype.skip = function(n) {
        if (!n) n = 1;
        this.pos += n;
    };
    Stream.prototype.reset = function() {
        this.pos = this.start;
    };
    Stream.prototype.moveStart = function() {
        this.start = this.pos;
    };
    Stream.prototype.makeSubStream = function(start, length) {
        return new Stream(this.bytes, start, length);
    };
    Stream.prototype.decode = function() {
        return this.bytes;
    };
    return Stream;
}();
var $6994bc106090076a$export$2e2bcd8739ae039 = $6994bc106090076a$var$Stream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The DecodeStream class contained in this file is a TypeScript port of the
 * JavaScript DecodeStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ // Lots of DecodeStreams are created whose buffers are never used.  For these
// we share a single empty buffer. This is (a) space-efficient and (b) avoids
// having special cases that would be required if we used |null| for an empty
// buffer.
var $6ff39b2bedd52666$var$emptyBuffer = new Uint8Array(0);
/**
 * Super class for the decoding streams
 */ var $6ff39b2bedd52666$var$DecodeStream = /** @class */ function() {
    function DecodeStream(maybeMinBufferLength) {
        this.pos = 0;
        this.bufferLength = 0;
        this.eof = false;
        this.buffer = $6ff39b2bedd52666$var$emptyBuffer;
        this.minBufferLength = 512;
        if (maybeMinBufferLength) // Compute the first power of two that is as big as maybeMinBufferLength.
        while(this.minBufferLength < maybeMinBufferLength)this.minBufferLength *= 2;
    }
    Object.defineProperty(DecodeStream.prototype, "isEmpty", {
        get: function() {
            while(!this.eof && this.bufferLength === 0)this.readBlock();
            return this.bufferLength === 0;
        },
        enumerable: false,
        configurable: true
    });
    DecodeStream.prototype.getByte = function() {
        var pos = this.pos;
        while(this.bufferLength <= pos){
            if (this.eof) return -1;
            this.readBlock();
        }
        return this.buffer[this.pos++];
    };
    DecodeStream.prototype.getUint16 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        if (b0 === -1 || b1 === -1) return -1;
        return (b0 << 8) + b1;
    };
    DecodeStream.prototype.getInt32 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        var b2 = this.getByte();
        var b3 = this.getByte();
        return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
    };
    DecodeStream.prototype.getBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var end;
        var pos = this.pos;
        if (length) {
            this.ensureBuffer(pos + length);
            end = pos + length;
            while(!this.eof && this.bufferLength < end)this.readBlock();
            var bufEnd = this.bufferLength;
            if (end > bufEnd) end = bufEnd;
        } else {
            while(!this.eof)this.readBlock();
            end = this.bufferLength;
        }
        this.pos = end;
        var subarray = this.buffer.subarray(pos, end);
        // `this.buffer` is either a `Uint8Array` or `Uint8ClampedArray` here.
        return forceClamped && !(subarray instanceof Uint8ClampedArray) ? new Uint8ClampedArray(subarray) : subarray;
    };
    DecodeStream.prototype.peekByte = function() {
        var peekedByte = this.getByte();
        this.pos--;
        return peekedByte;
    };
    DecodeStream.prototype.peekBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.getBytes(length, forceClamped);
        this.pos -= bytes.length;
        return bytes;
    };
    DecodeStream.prototype.skip = function(n) {
        if (!n) n = 1;
        this.pos += n;
    };
    DecodeStream.prototype.reset = function() {
        this.pos = 0;
    };
    DecodeStream.prototype.makeSubStream = function(start, length /* dict */ ) {
        var end = start + length;
        while(this.bufferLength <= end && !this.eof)this.readBlock();
        return new (0, $6994bc106090076a$export$2e2bcd8739ae039)(this.buffer, start, length /* dict */ );
    };
    DecodeStream.prototype.decode = function() {
        while(!this.eof)this.readBlock();
        return this.buffer.subarray(0, this.bufferLength);
    };
    DecodeStream.prototype.readBlock = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'readBlock');
    };
    DecodeStream.prototype.ensureBuffer = function(requested) {
        var buffer = this.buffer;
        if (requested <= buffer.byteLength) return buffer;
        var size = this.minBufferLength;
        while(size < requested)size *= 2;
        var buffer2 = new Uint8Array(size);
        buffer2.set(buffer);
        return this.buffer = buffer2;
    };
    return DecodeStream;
}();
var $6ff39b2bedd52666$export$2e2bcd8739ae039 = $6ff39b2bedd52666$var$DecodeStream;


var $1d792bffef4b9a0f$var$isSpace = function(ch) {
    return ch === 0x20 || ch === 0x09 || ch === 0x0d || ch === 0x0a;
};
var $1d792bffef4b9a0f$var$Ascii85Stream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(Ascii85Stream, _super);
    function Ascii85Stream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.input = new Uint8Array(5);
        // Most streams increase in size when decoded, but Ascii85 streams
        // typically shrink by ~20%.
        if (maybeLength) maybeLength = 0.8 * maybeLength;
        return _this;
    }
    Ascii85Stream.prototype.readBlock = function() {
        var TILDA_CHAR = 0x7e; // '~'
        var Z_LOWER_CHAR = 0x7a; // 'z'
        var EOF = -1;
        var stream = this.stream;
        var c = stream.getByte();
        while($1d792bffef4b9a0f$var$isSpace(c))c = stream.getByte();
        if (c === EOF || c === TILDA_CHAR) {
            this.eof = true;
            return;
        }
        var bufferLength = this.bufferLength;
        var buffer;
        var i;
        // special code for z
        if (c === Z_LOWER_CHAR) {
            buffer = this.ensureBuffer(bufferLength + 4);
            for(i = 0; i < 4; ++i)buffer[bufferLength + i] = 0;
            this.bufferLength += 4;
        } else {
            var input = this.input;
            input[0] = c;
            for(i = 1; i < 5; ++i){
                c = stream.getByte();
                while($1d792bffef4b9a0f$var$isSpace(c))c = stream.getByte();
                input[i] = c;
                if (c === EOF || c === TILDA_CHAR) break;
            }
            buffer = this.ensureBuffer(bufferLength + i - 1);
            this.bufferLength += i - 1;
            // partial ending;
            if (i < 5) {
                for(; i < 5; ++i)input[i] = 117;
                this.eof = true;
            }
            var t = 0;
            for(i = 0; i < 5; ++i)t = t * 85 + (input[i] - 0x21);
            for(i = 3; i >= 0; --i){
                buffer[bufferLength + i] = t & 0xff;
                t >>= 8;
            }
        }
    };
    return Ascii85Stream;
}((0, $6ff39b2bedd52666$export$2e2bcd8739ae039));
var $1d792bffef4b9a0f$export$2e2bcd8739ae039 = $1d792bffef4b9a0f$var$Ascii85Stream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The AsciiHexStream class contained in this file is a TypeScript port of the
 * JavaScript AsciiHexStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $cOQTW = parcelRequire("cOQTW");

var $e8d1eed445279b14$var$AsciiHexStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(AsciiHexStream, _super);
    function AsciiHexStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.firstDigit = -1;
        // Most streams increase in size when decoded, but AsciiHex streams shrink
        // by 50%.
        if (maybeLength) maybeLength = 0.5 * maybeLength;
        return _this;
    }
    AsciiHexStream.prototype.readBlock = function() {
        var UPSTREAM_BLOCK_SIZE = 8000;
        var bytes = this.stream.getBytes(UPSTREAM_BLOCK_SIZE);
        if (!bytes.length) {
            this.eof = true;
            return;
        }
        var maxDecodeLength = bytes.length + 1 >> 1;
        var buffer = this.ensureBuffer(this.bufferLength + maxDecodeLength);
        var bufferLength = this.bufferLength;
        var firstDigit = this.firstDigit;
        for(var i = 0, ii = bytes.length; i < ii; i++){
            var ch = bytes[i];
            var digit = void 0;
            if (ch >= 0x30 && ch <= 0x39) // '0'-'9'
            digit = ch & 0x0f;
            else if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) // 'A'-'Z', 'a'-'z'
            digit = (ch & 0x0f) + 9;
            else if (ch === 0x3e) {
                // '>'
                this.eof = true;
                break;
            } else continue; // ignoring
            if (firstDigit < 0) firstDigit = digit;
            else {
                buffer[bufferLength++] = firstDigit << 4 | digit;
                firstDigit = -1;
            }
        }
        if (firstDigit >= 0 && this.eof) {
            // incomplete byte
            buffer[bufferLength++] = firstDigit << 4;
            firstDigit = -1;
        }
        this.firstDigit = firstDigit;
        this.bufferLength = bufferLength;
    };
    return AsciiHexStream;
}((0, $6ff39b2bedd52666$export$2e2bcd8739ae039));
var $e8d1eed445279b14$export$2e2bcd8739ae039 = $e8d1eed445279b14$var$AsciiHexStream;


/*
 * Copyright 1996-2003 Glyph & Cog, LLC
 *
 * The flate stream implementation contained in this file is a JavaScript port
 * of XPDF's implementation, made available under the Apache 2.0 open source
 * license.
 */ 
var $cOQTW = parcelRequire("cOQTW");

// prettier-ignore
var $106ef4d7516ef3d6$var$codeLenCodeMap = new Int32Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// prettier-ignore
var $106ef4d7516ef3d6$var$lengthDecode = new Int32Array([
    0x00003,
    0x00004,
    0x00005,
    0x00006,
    0x00007,
    0x00008,
    0x00009,
    0x0000a,
    0x1000b,
    0x1000d,
    0x1000f,
    0x10011,
    0x20013,
    0x20017,
    0x2001b,
    0x2001f,
    0x30023,
    0x3002b,
    0x30033,
    0x3003b,
    0x40043,
    0x40053,
    0x40063,
    0x40073,
    0x50083,
    0x500a3,
    0x500c3,
    0x500e3,
    0x00102,
    0x00102,
    0x00102
]);
// prettier-ignore
var $106ef4d7516ef3d6$var$distDecode = new Int32Array([
    0x00001,
    0x00002,
    0x00003,
    0x00004,
    0x10005,
    0x10007,
    0x20009,
    0x2000d,
    0x30011,
    0x30019,
    0x40021,
    0x40031,
    0x50041,
    0x50061,
    0x60081,
    0x600c1,
    0x70101,
    0x70181,
    0x80201,
    0x80301,
    0x90401,
    0x90601,
    0xa0801,
    0xa0c01,
    0xb1001,
    0xb1801,
    0xc2001,
    0xc3001,
    0xd4001,
    0xd6001
]);
// prettier-ignore
var $106ef4d7516ef3d6$var$fixedLitCodeTab = [
    new Int32Array([
        0x70100,
        0x80050,
        0x80010,
        0x80118,
        0x70110,
        0x80070,
        0x80030,
        0x900c0,
        0x70108,
        0x80060,
        0x80020,
        0x900a0,
        0x80000,
        0x80080,
        0x80040,
        0x900e0,
        0x70104,
        0x80058,
        0x80018,
        0x90090,
        0x70114,
        0x80078,
        0x80038,
        0x900d0,
        0x7010c,
        0x80068,
        0x80028,
        0x900b0,
        0x80008,
        0x80088,
        0x80048,
        0x900f0,
        0x70102,
        0x80054,
        0x80014,
        0x8011c,
        0x70112,
        0x80074,
        0x80034,
        0x900c8,
        0x7010a,
        0x80064,
        0x80024,
        0x900a8,
        0x80004,
        0x80084,
        0x80044,
        0x900e8,
        0x70106,
        0x8005c,
        0x8001c,
        0x90098,
        0x70116,
        0x8007c,
        0x8003c,
        0x900d8,
        0x7010e,
        0x8006c,
        0x8002c,
        0x900b8,
        0x8000c,
        0x8008c,
        0x8004c,
        0x900f8,
        0x70101,
        0x80052,
        0x80012,
        0x8011a,
        0x70111,
        0x80072,
        0x80032,
        0x900c4,
        0x70109,
        0x80062,
        0x80022,
        0x900a4,
        0x80002,
        0x80082,
        0x80042,
        0x900e4,
        0x70105,
        0x8005a,
        0x8001a,
        0x90094,
        0x70115,
        0x8007a,
        0x8003a,
        0x900d4,
        0x7010d,
        0x8006a,
        0x8002a,
        0x900b4,
        0x8000a,
        0x8008a,
        0x8004a,
        0x900f4,
        0x70103,
        0x80056,
        0x80016,
        0x8011e,
        0x70113,
        0x80076,
        0x80036,
        0x900cc,
        0x7010b,
        0x80066,
        0x80026,
        0x900ac,
        0x80006,
        0x80086,
        0x80046,
        0x900ec,
        0x70107,
        0x8005e,
        0x8001e,
        0x9009c,
        0x70117,
        0x8007e,
        0x8003e,
        0x900dc,
        0x7010f,
        0x8006e,
        0x8002e,
        0x900bc,
        0x8000e,
        0x8008e,
        0x8004e,
        0x900fc,
        0x70100,
        0x80051,
        0x80011,
        0x80119,
        0x70110,
        0x80071,
        0x80031,
        0x900c2,
        0x70108,
        0x80061,
        0x80021,
        0x900a2,
        0x80001,
        0x80081,
        0x80041,
        0x900e2,
        0x70104,
        0x80059,
        0x80019,
        0x90092,
        0x70114,
        0x80079,
        0x80039,
        0x900d2,
        0x7010c,
        0x80069,
        0x80029,
        0x900b2,
        0x80009,
        0x80089,
        0x80049,
        0x900f2,
        0x70102,
        0x80055,
        0x80015,
        0x8011d,
        0x70112,
        0x80075,
        0x80035,
        0x900ca,
        0x7010a,
        0x80065,
        0x80025,
        0x900aa,
        0x80005,
        0x80085,
        0x80045,
        0x900ea,
        0x70106,
        0x8005d,
        0x8001d,
        0x9009a,
        0x70116,
        0x8007d,
        0x8003d,
        0x900da,
        0x7010e,
        0x8006d,
        0x8002d,
        0x900ba,
        0x8000d,
        0x8008d,
        0x8004d,
        0x900fa,
        0x70101,
        0x80053,
        0x80013,
        0x8011b,
        0x70111,
        0x80073,
        0x80033,
        0x900c6,
        0x70109,
        0x80063,
        0x80023,
        0x900a6,
        0x80003,
        0x80083,
        0x80043,
        0x900e6,
        0x70105,
        0x8005b,
        0x8001b,
        0x90096,
        0x70115,
        0x8007b,
        0x8003b,
        0x900d6,
        0x7010d,
        0x8006b,
        0x8002b,
        0x900b6,
        0x8000b,
        0x8008b,
        0x8004b,
        0x900f6,
        0x70103,
        0x80057,
        0x80017,
        0x8011f,
        0x70113,
        0x80077,
        0x80037,
        0x900ce,
        0x7010b,
        0x80067,
        0x80027,
        0x900ae,
        0x80007,
        0x80087,
        0x80047,
        0x900ee,
        0x70107,
        0x8005f,
        0x8001f,
        0x9009e,
        0x70117,
        0x8007f,
        0x8003f,
        0x900de,
        0x7010f,
        0x8006f,
        0x8002f,
        0x900be,
        0x8000f,
        0x8008f,
        0x8004f,
        0x900fe,
        0x70100,
        0x80050,
        0x80010,
        0x80118,
        0x70110,
        0x80070,
        0x80030,
        0x900c1,
        0x70108,
        0x80060,
        0x80020,
        0x900a1,
        0x80000,
        0x80080,
        0x80040,
        0x900e1,
        0x70104,
        0x80058,
        0x80018,
        0x90091,
        0x70114,
        0x80078,
        0x80038,
        0x900d1,
        0x7010c,
        0x80068,
        0x80028,
        0x900b1,
        0x80008,
        0x80088,
        0x80048,
        0x900f1,
        0x70102,
        0x80054,
        0x80014,
        0x8011c,
        0x70112,
        0x80074,
        0x80034,
        0x900c9,
        0x7010a,
        0x80064,
        0x80024,
        0x900a9,
        0x80004,
        0x80084,
        0x80044,
        0x900e9,
        0x70106,
        0x8005c,
        0x8001c,
        0x90099,
        0x70116,
        0x8007c,
        0x8003c,
        0x900d9,
        0x7010e,
        0x8006c,
        0x8002c,
        0x900b9,
        0x8000c,
        0x8008c,
        0x8004c,
        0x900f9,
        0x70101,
        0x80052,
        0x80012,
        0x8011a,
        0x70111,
        0x80072,
        0x80032,
        0x900c5,
        0x70109,
        0x80062,
        0x80022,
        0x900a5,
        0x80002,
        0x80082,
        0x80042,
        0x900e5,
        0x70105,
        0x8005a,
        0x8001a,
        0x90095,
        0x70115,
        0x8007a,
        0x8003a,
        0x900d5,
        0x7010d,
        0x8006a,
        0x8002a,
        0x900b5,
        0x8000a,
        0x8008a,
        0x8004a,
        0x900f5,
        0x70103,
        0x80056,
        0x80016,
        0x8011e,
        0x70113,
        0x80076,
        0x80036,
        0x900cd,
        0x7010b,
        0x80066,
        0x80026,
        0x900ad,
        0x80006,
        0x80086,
        0x80046,
        0x900ed,
        0x70107,
        0x8005e,
        0x8001e,
        0x9009d,
        0x70117,
        0x8007e,
        0x8003e,
        0x900dd,
        0x7010f,
        0x8006e,
        0x8002e,
        0x900bd,
        0x8000e,
        0x8008e,
        0x8004e,
        0x900fd,
        0x70100,
        0x80051,
        0x80011,
        0x80119,
        0x70110,
        0x80071,
        0x80031,
        0x900c3,
        0x70108,
        0x80061,
        0x80021,
        0x900a3,
        0x80001,
        0x80081,
        0x80041,
        0x900e3,
        0x70104,
        0x80059,
        0x80019,
        0x90093,
        0x70114,
        0x80079,
        0x80039,
        0x900d3,
        0x7010c,
        0x80069,
        0x80029,
        0x900b3,
        0x80009,
        0x80089,
        0x80049,
        0x900f3,
        0x70102,
        0x80055,
        0x80015,
        0x8011d,
        0x70112,
        0x80075,
        0x80035,
        0x900cb,
        0x7010a,
        0x80065,
        0x80025,
        0x900ab,
        0x80005,
        0x80085,
        0x80045,
        0x900eb,
        0x70106,
        0x8005d,
        0x8001d,
        0x9009b,
        0x70116,
        0x8007d,
        0x8003d,
        0x900db,
        0x7010e,
        0x8006d,
        0x8002d,
        0x900bb,
        0x8000d,
        0x8008d,
        0x8004d,
        0x900fb,
        0x70101,
        0x80053,
        0x80013,
        0x8011b,
        0x70111,
        0x80073,
        0x80033,
        0x900c7,
        0x70109,
        0x80063,
        0x80023,
        0x900a7,
        0x80003,
        0x80083,
        0x80043,
        0x900e7,
        0x70105,
        0x8005b,
        0x8001b,
        0x90097,
        0x70115,
        0x8007b,
        0x8003b,
        0x900d7,
        0x7010d,
        0x8006b,
        0x8002b,
        0x900b7,
        0x8000b,
        0x8008b,
        0x8004b,
        0x900f7,
        0x70103,
        0x80057,
        0x80017,
        0x8011f,
        0x70113,
        0x80077,
        0x80037,
        0x900cf,
        0x7010b,
        0x80067,
        0x80027,
        0x900af,
        0x80007,
        0x80087,
        0x80047,
        0x900ef,
        0x70107,
        0x8005f,
        0x8001f,
        0x9009f,
        0x70117,
        0x8007f,
        0x8003f,
        0x900df,
        0x7010f,
        0x8006f,
        0x8002f,
        0x900bf,
        0x8000f,
        0x8008f,
        0x8004f,
        0x900ff
    ]),
    9
];
// prettier-ignore
var $106ef4d7516ef3d6$var$fixedDistCodeTab = [
    new Int32Array([
        0x50000,
        0x50010,
        0x50008,
        0x50018,
        0x50004,
        0x50014,
        0x5000c,
        0x5001c,
        0x50002,
        0x50012,
        0x5000a,
        0x5001a,
        0x50006,
        0x50016,
        0x5000e,
        0x00000,
        0x50001,
        0x50011,
        0x50009,
        0x50019,
        0x50005,
        0x50015,
        0x5000d,
        0x5001d,
        0x50003,
        0x50013,
        0x5000b,
        0x5001b,
        0x50007,
        0x50017,
        0x5000f,
        0x00000
    ]),
    5
];
var $106ef4d7516ef3d6$var$FlateStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(FlateStream, _super);
    function FlateStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        var cmf = stream.getByte();
        var flg = stream.getByte();
        if (cmf === -1 || flg === -1) throw new Error("Invalid header in flate stream: " + cmf + ", " + flg);
        if ((cmf & 0x0f) !== 0x08) throw new Error("Unknown compression method in flate stream: " + cmf + ", " + flg);
        if (((cmf << 8) + flg) % 31 !== 0) throw new Error("Bad FCHECK in flate stream: " + cmf + ", " + flg);
        if (flg & 0x20) throw new Error("FDICT bit set in flate stream: " + cmf + ", " + flg);
        _this.codeSize = 0;
        _this.codeBuf = 0;
        return _this;
    }
    FlateStream.prototype.readBlock = function() {
        var buffer;
        var len;
        var str = this.stream;
        // read block header
        var hdr = this.getBits(3);
        if (hdr & 1) this.eof = true;
        hdr >>= 1;
        if (hdr === 0) {
            // uncompressed block
            var b = void 0;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            var blockLen = b;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            blockLen |= b << 8;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            var check = b;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            check |= b << 8;
            if (check !== (~blockLen & 0xffff) && (blockLen !== 0 || check !== 0)) // Ignoring error for bad "empty" block (see issue 1277)
            throw new Error('Bad uncompressed block length in flate stream');
            this.codeBuf = 0;
            this.codeSize = 0;
            var bufferLength = this.bufferLength;
            buffer = this.ensureBuffer(bufferLength + blockLen);
            var end = bufferLength + blockLen;
            this.bufferLength = end;
            if (blockLen === 0) {
                if (str.peekByte() === -1) this.eof = true;
            } else for(var n = bufferLength; n < end; ++n){
                if ((b = str.getByte()) === -1) {
                    this.eof = true;
                    break;
                }
                buffer[n] = b;
            }
            return;
        }
        var litCodeTable;
        var distCodeTable;
        if (hdr === 1) {
            // compressed block, fixed codes
            litCodeTable = $106ef4d7516ef3d6$var$fixedLitCodeTab;
            distCodeTable = $106ef4d7516ef3d6$var$fixedDistCodeTab;
        } else if (hdr === 2) {
            // compressed block, dynamic codes
            var numLitCodes = this.getBits(5) + 257;
            var numDistCodes = this.getBits(5) + 1;
            var numCodeLenCodes = this.getBits(4) + 4;
            // build the code lengths code table
            var codeLenCodeLengths = new Uint8Array($106ef4d7516ef3d6$var$codeLenCodeMap.length);
            var i = void 0;
            for(i = 0; i < numCodeLenCodes; ++i)codeLenCodeLengths[$106ef4d7516ef3d6$var$codeLenCodeMap[i]] = this.getBits(3);
            var codeLenCodeTab = this.generateHuffmanTable(codeLenCodeLengths);
            // build the literal and distance code tables
            len = 0;
            i = 0;
            var codes = numLitCodes + numDistCodes;
            var codeLengths = new Uint8Array(codes);
            var bitsLength = void 0;
            var bitsOffset = void 0;
            var what = void 0;
            while(i < codes){
                var code = this.getCode(codeLenCodeTab);
                if (code === 16) {
                    bitsLength = 2;
                    bitsOffset = 3;
                    what = len;
                } else if (code === 17) {
                    bitsLength = 3;
                    bitsOffset = 3;
                    what = len = 0;
                } else if (code === 18) {
                    bitsLength = 7;
                    bitsOffset = 11;
                    what = len = 0;
                } else {
                    codeLengths[i++] = len = code;
                    continue;
                }
                var repeatLength = this.getBits(bitsLength) + bitsOffset;
                while(repeatLength-- > 0)codeLengths[i++] = what;
            }
            litCodeTable = this.generateHuffmanTable(codeLengths.subarray(0, numLitCodes));
            distCodeTable = this.generateHuffmanTable(codeLengths.subarray(numLitCodes, codes));
        } else throw new Error('Unknown block type in flate stream');
        buffer = this.buffer;
        var limit = buffer ? buffer.length : 0;
        var pos = this.bufferLength;
        while(true){
            var code1 = this.getCode(litCodeTable);
            if (code1 < 256) {
                if (pos + 1 >= limit) {
                    buffer = this.ensureBuffer(pos + 1);
                    limit = buffer.length;
                }
                buffer[pos++] = code1;
                continue;
            }
            if (code1 === 256) {
                this.bufferLength = pos;
                return;
            }
            code1 -= 257;
            code1 = $106ef4d7516ef3d6$var$lengthDecode[code1];
            var code2 = code1 >> 16;
            if (code2 > 0) code2 = this.getBits(code2);
            len = (code1 & 0xffff) + code2;
            code1 = this.getCode(distCodeTable);
            code1 = $106ef4d7516ef3d6$var$distDecode[code1];
            code2 = code1 >> 16;
            if (code2 > 0) code2 = this.getBits(code2);
            var dist = (code1 & 0xffff) + code2;
            if (pos + len >= limit) {
                buffer = this.ensureBuffer(pos + len);
                limit = buffer.length;
            }
            for(var k = 0; k < len; ++k, ++pos)buffer[pos] = buffer[pos - dist];
        }
    };
    FlateStream.prototype.getBits = function(bits) {
        var str = this.stream;
        var codeSize = this.codeSize;
        var codeBuf = this.codeBuf;
        var b;
        while(codeSize < bits){
            if ((b = str.getByte()) === -1) throw new Error('Bad encoding in flate stream');
            codeBuf |= b << codeSize;
            codeSize += 8;
        }
        b = codeBuf & (1 << bits) - 1;
        this.codeBuf = codeBuf >> bits;
        this.codeSize = codeSize -= bits;
        return b;
    };
    FlateStream.prototype.getCode = function(table) {
        var str = this.stream;
        var codes = table[0];
        var maxLen = table[1];
        var codeSize = this.codeSize;
        var codeBuf = this.codeBuf;
        var b;
        while(codeSize < maxLen){
            if ((b = str.getByte()) === -1) break;
            codeBuf |= b << codeSize;
            codeSize += 8;
        }
        var code = codes[codeBuf & (1 << maxLen) - 1];
        if (typeof codes === 'number') console.log('FLATE:', code);
        var codeLen = code >> 16;
        var codeVal = code & 0xffff;
        if (codeLen < 1 || codeSize < codeLen) throw new Error('Bad encoding in flate stream');
        this.codeBuf = codeBuf >> codeLen;
        this.codeSize = codeSize - codeLen;
        return codeVal;
    };
    FlateStream.prototype.generateHuffmanTable = function(lengths) {
        var n = lengths.length;
        // find max code length
        var maxLen = 0;
        var i;
        for(i = 0; i < n; ++i)if (lengths[i] > maxLen) maxLen = lengths[i];
        // build the table
        var size = 1 << maxLen;
        var codes = new Int32Array(size);
        for(var len = 1, code = 0, skip = 2; len <= maxLen; ++len, code <<= 1, skip <<= 1){
            for(var val = 0; val < n; ++val)if (lengths[val] === len) {
                // bit-reverse the code
                var code2 = 0;
                var t = code;
                for(i = 0; i < len; ++i){
                    code2 = code2 << 1 | t & 1;
                    t >>= 1;
                }
                // fill the table entries
                for(i = code2; i < size; i += skip)codes[i] = len << 16 | val;
                ++code;
            }
        }
        return [
            codes,
            maxLen
        ];
    };
    return FlateStream;
}((0, $6ff39b2bedd52666$export$2e2bcd8739ae039));
var $106ef4d7516ef3d6$export$2e2bcd8739ae039 = $106ef4d7516ef3d6$var$FlateStream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The LZWStream class contained in this file is a TypeScript port of the
 * JavaScript LZWStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $cOQTW = parcelRequire("cOQTW");

var $caad20b69225c7a9$var$LZWStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(LZWStream, _super);
    function LZWStream(stream, maybeLength, earlyChange) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.cachedData = 0;
        _this.bitsCached = 0;
        var maxLzwDictionarySize = 4096;
        var lzwState = {
            earlyChange: earlyChange,
            codeLength: 9,
            nextCode: 258,
            dictionaryValues: new Uint8Array(maxLzwDictionarySize),
            dictionaryLengths: new Uint16Array(maxLzwDictionarySize),
            dictionaryPrevCodes: new Uint16Array(maxLzwDictionarySize),
            currentSequence: new Uint8Array(maxLzwDictionarySize),
            currentSequenceLength: 0
        };
        for(var i = 0; i < 256; ++i){
            lzwState.dictionaryValues[i] = i;
            lzwState.dictionaryLengths[i] = 1;
        }
        _this.lzwState = lzwState;
        return _this;
    }
    LZWStream.prototype.readBlock = function() {
        var blockSize = 512;
        var estimatedDecodedSize = blockSize * 2;
        var decodedSizeDelta = blockSize;
        var i;
        var j;
        var q;
        var lzwState = this.lzwState;
        if (!lzwState) return; // eof was found
        var earlyChange = lzwState.earlyChange;
        var nextCode = lzwState.nextCode;
        var dictionaryValues = lzwState.dictionaryValues;
        var dictionaryLengths = lzwState.dictionaryLengths;
        var dictionaryPrevCodes = lzwState.dictionaryPrevCodes;
        var codeLength = lzwState.codeLength;
        var prevCode = lzwState.prevCode;
        var currentSequence = lzwState.currentSequence;
        var currentSequenceLength = lzwState.currentSequenceLength;
        var decodedLength = 0;
        var currentBufferLength = this.bufferLength;
        var buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
        for(i = 0; i < blockSize; i++){
            var code = this.readBits(codeLength);
            var hasPrev = currentSequenceLength > 0;
            if (!code || code < 256) {
                currentSequence[0] = code;
                currentSequenceLength = 1;
            } else if (code >= 258) {
                if (code < nextCode) {
                    currentSequenceLength = dictionaryLengths[code];
                    for(j = currentSequenceLength - 1, q = code; j >= 0; j--){
                        currentSequence[j] = dictionaryValues[q];
                        q = dictionaryPrevCodes[q];
                    }
                } else currentSequence[currentSequenceLength++] = currentSequence[0];
            } else if (code === 256) {
                codeLength = 9;
                nextCode = 258;
                currentSequenceLength = 0;
                continue;
            } else {
                this.eof = true;
                delete this.lzwState;
                break;
            }
            if (hasPrev) {
                dictionaryPrevCodes[nextCode] = prevCode;
                dictionaryLengths[nextCode] = dictionaryLengths[prevCode] + 1;
                dictionaryValues[nextCode] = currentSequence[0];
                nextCode++;
                codeLength = nextCode + earlyChange & nextCode + earlyChange - 1 ? codeLength : Math.min(Math.log(nextCode + earlyChange) / 0.6931471805599453 + 1, 12) | 0;
            }
            prevCode = code;
            decodedLength += currentSequenceLength;
            if (estimatedDecodedSize < decodedLength) {
                do estimatedDecodedSize += decodedSizeDelta;
                while (estimatedDecodedSize < decodedLength);
                buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
            }
            for(j = 0; j < currentSequenceLength; j++)buffer[currentBufferLength++] = currentSequence[j];
        }
        lzwState.nextCode = nextCode;
        lzwState.codeLength = codeLength;
        lzwState.prevCode = prevCode;
        lzwState.currentSequenceLength = currentSequenceLength;
        this.bufferLength = currentBufferLength;
    };
    LZWStream.prototype.readBits = function(n) {
        var bitsCached = this.bitsCached;
        var cachedData = this.cachedData;
        while(bitsCached < n){
            var c = this.stream.getByte();
            if (c === -1) {
                this.eof = true;
                return null;
            }
            cachedData = cachedData << 8 | c;
            bitsCached += 8;
        }
        this.bitsCached = bitsCached -= n;
        this.cachedData = cachedData;
        return cachedData >>> bitsCached & (1 << n) - 1;
    };
    return LZWStream;
}((0, $6ff39b2bedd52666$export$2e2bcd8739ae039));
var $caad20b69225c7a9$export$2e2bcd8739ae039 = $caad20b69225c7a9$var$LZWStream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The RunLengthStream class contained in this file is a TypeScript port of the
 * JavaScript RunLengthStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $cOQTW = parcelRequire("cOQTW");

var $04ab37ade25dd344$var$RunLengthStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(RunLengthStream, _super);
    function RunLengthStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        return _this;
    }
    RunLengthStream.prototype.readBlock = function() {
        // The repeatHeader has following format. The first byte defines type of run
        // and amount of bytes to repeat/copy: n = 0 through 127 - copy next n bytes
        // (in addition to the second byte from the header), n = 129 through 255 -
        // duplicate the second byte from the header (257 - n) times, n = 128 - end.
        var repeatHeader = this.stream.getBytes(2);
        if (!repeatHeader || repeatHeader.length < 2 || repeatHeader[0] === 128) {
            this.eof = true;
            return;
        }
        var buffer;
        var bufferLength = this.bufferLength;
        var n = repeatHeader[0];
        if (n < 128) {
            // copy n bytes
            buffer = this.ensureBuffer(bufferLength + n + 1);
            buffer[bufferLength++] = repeatHeader[1];
            if (n > 0) {
                var source = this.stream.getBytes(n);
                buffer.set(source, bufferLength);
                bufferLength += n;
            }
        } else {
            n = 257 - n;
            var b = repeatHeader[1];
            buffer = this.ensureBuffer(bufferLength + n + 1);
            for(var i = 0; i < n; i++)buffer[bufferLength++] = b;
        }
        this.bufferLength = bufferLength;
    };
    return RunLengthStream;
}((0, $6ff39b2bedd52666$export$2e2bcd8739ae039));
var $04ab37ade25dd344$export$2e2bcd8739ae039 = $04ab37ade25dd344$var$RunLengthStream;



var $a0659294f562ac04$var$decodeStream = function(stream, encoding, params) {
    if (encoding === (0, $dPHSK.default).of('FlateDecode')) return new (0, $106ef4d7516ef3d6$export$2e2bcd8739ae039)(stream);
    if (encoding === (0, $dPHSK.default).of('LZWDecode')) {
        var earlyChange = 1;
        if (params instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) {
            var EarlyChange = params.lookup((0, $dPHSK.default).of('EarlyChange'));
            if (EarlyChange instanceof (0, $j04jt.default)) earlyChange = EarlyChange.asNumber();
        }
        return new (0, $caad20b69225c7a9$export$2e2bcd8739ae039)(stream, undefined, earlyChange);
    }
    if (encoding === (0, $dPHSK.default).of('ASCII85Decode')) return new (0, $1d792bffef4b9a0f$export$2e2bcd8739ae039)(stream);
    if (encoding === (0, $dPHSK.default).of('ASCIIHexDecode')) return new (0, $e8d1eed445279b14$export$2e2bcd8739ae039)(stream);
    if (encoding === (0, $dPHSK.default).of('RunLengthDecode')) return new (0, $04ab37ade25dd344$export$2e2bcd8739ae039)(stream);
    throw new (0, $nAWRe.UnsupportedEncodingError)(encoding.asString());
};
var $a0659294f562ac04$export$b8317e68ca978594 = function(_a) {
    var dict = _a.dict, contents = _a.contents;
    var stream = new (0, $6994bc106090076a$export$2e2bcd8739ae039)(contents);
    var Filter = dict.lookup((0, $dPHSK.default).of('Filter'));
    var DecodeParms = dict.lookup((0, $dPHSK.default).of('DecodeParms'));
    if (Filter instanceof (0, $dPHSK.default)) stream = $a0659294f562ac04$var$decodeStream(stream, Filter, DecodeParms);
    else if (Filter instanceof (0, $8auL6.default)) for(var idx = 0, len = Filter.size(); idx < len; idx++)stream = $a0659294f562ac04$var$decodeStream(stream, Filter.lookup(idx, (0, $dPHSK.default)), DecodeParms && DecodeParms.lookupMaybe(idx, (0, $85408478fbb7cbde$export$2e2bcd8739ae039)));
    else if (!!Filter) throw new (0, $nAWRe.UnexpectedObjectTypeError)([
        (0, $dPHSK.default),
        (0, $8auL6.default)
    ], Filter);
    return stream;
};




var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");
var $c7d58da35b52112a$var$fullPageBoundingBox = function(page) {
    var mediaBox = page.MediaBox();
    var width = mediaBox.lookup(2, (0, $j04jt.default)).asNumber() - mediaBox.lookup(0, (0, $j04jt.default)).asNumber();
    var height = mediaBox.lookup(3, (0, $j04jt.default)).asNumber() - mediaBox.lookup(1, (0, $j04jt.default)).asNumber();
    return {
        left: 0,
        bottom: 0,
        right: width,
        top: height
    };
};
// Returns the identity matrix, modified to position the content of the given
// bounding box at (0, 0).
var $c7d58da35b52112a$var$boundingBoxAdjustedMatrix = function(bb) {
    return [
        1,
        0,
        0,
        1,
        -bb.left,
        -bb.bottom
    ];
};
var $c7d58da35b52112a$var$PDFPageEmbedder = /** @class */ function() {
    function PDFPageEmbedder(page, boundingBox, transformationMatrix) {
        this.page = page;
        var bb = boundingBox !== null && boundingBox !== void 0 ? boundingBox : $c7d58da35b52112a$var$fullPageBoundingBox(page);
        this.width = bb.right - bb.left;
        this.height = bb.top - bb.bottom;
        this.boundingBox = bb;
        this.transformationMatrix = transformationMatrix !== null && transformationMatrix !== void 0 ? transformationMatrix : $c7d58da35b52112a$var$boundingBoxAdjustedMatrix(bb);
    }
    PDFPageEmbedder.for = function(page, boundingBox, transformationMatrix) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new PDFPageEmbedder(page, boundingBox, transformationMatrix)
                ];
            });
        });
    };
    PDFPageEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, Contents, Resources, decodedContents, _b, left, bottom, right, top, xObject;
            return (0, $cOQTW.__generator)(this, function(_c) {
                _a = this.page.normalizedEntries(), Contents = _a.Contents, Resources = _a.Resources;
                if (!Contents) throw new (0, $nAWRe.MissingPageContentsEmbeddingError)();
                decodedContents = this.decodeContents(Contents);
                _b = this.boundingBox, left = _b.left, bottom = _b.bottom, right = _b.right, top = _b.top;
                xObject = context.flateStream(decodedContents, {
                    Type: 'XObject',
                    Subtype: 'Form',
                    FormType: 1,
                    BBox: [
                        left,
                        bottom,
                        right,
                        top
                    ],
                    Matrix: this.transformationMatrix,
                    Resources: Resources
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    // `contents` is an array of streams which are merged to include them in the XObject.
    // This methods extracts each stream and joins them with a newline character.
    PDFPageEmbedder.prototype.decodeContents = function(contents) {
        var newline = Uint8Array.of((0, $8zvel.default).Newline);
        var decodedContents = [];
        for(var idx = 0, len = contents.size(); idx < len; idx++){
            var stream = contents.lookup(idx, (0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039));
            var content = void 0;
            if (stream instanceof (0, $ef28c75b0f11042e$export$2e2bcd8739ae039)) content = (0, $a0659294f562ac04$export$b8317e68ca978594)(stream).decode();
            else if (stream instanceof (0, $707f21d02e4e1bf4$export$2e2bcd8739ae039)) content = stream.getUnencodedContents();
            else throw new (0, $nAWRe.UnrecognizedStreamTypeError)(stream);
            decodedContents.push(content, newline);
        }
        return (0, $4ISq8.mergeIntoTypedArray).apply(void 0, decodedContents);
    };
    return PDFPageEmbedder;
}();
var $c7d58da35b52112a$export$2e2bcd8739ae039 = $c7d58da35b52112a$var$PDFPageEmbedder;



var $cpTWE = parcelRequire("cpTWE");

var $11c5J = parcelRequire("11c5J");

var $8gQNC = parcelRequire("8gQNC");

var $j04jt = parcelRequire("j04jt");



var $dPHSK = parcelRequire("dPHSK");


var $8auL6 = parcelRequire("8auL6");






var $cOQTW = parcelRequire("cOQTW");


var $dPHSK = parcelRequire("dPHSK");

var $cOQTW = parcelRequire("cOQTW");



var $8auL6 = parcelRequire("8auL6");

var $dPHSK = parcelRequire("dPHSK");

var $cOQTW = parcelRequire("cOQTW");


var $dPHSK = parcelRequire("dPHSK");




var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $8auL6 = parcelRequire("8auL6");

parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");

var $nAWRe = parcelRequire("nAWRe");
// Examples:
//   `/Helv 12 Tf` -> ['Helv', '12']
//   `/HeBo 8.00 Tf` -> ['HeBo', '8.00']
//   `/HeBo Tf` -> ['HeBo', undefined]
var $3a62e0bdc23bf2e5$var$tfRegex = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+Tf/;
var $3a62e0bdc23bf2e5$var$PDFAcroField = /** @class */ function() {
    function PDFAcroField(dict, ref) {
        this.dict = dict;
        this.ref = ref;
    }
    PDFAcroField.prototype.T = function() {
        return this.dict.lookupMaybe((0, $dPHSK.default).of('T'), (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039), (0, $e8537943f4279a06$export$2e2bcd8739ae039));
    };
    PDFAcroField.prototype.Ff = function() {
        var numberOrRef = this.getInheritableAttribute((0, $dPHSK.default).of('Ff'));
        return this.dict.context.lookupMaybe(numberOrRef, (0, $j04jt.default));
    };
    PDFAcroField.prototype.V = function() {
        var valueOrRef = this.getInheritableAttribute((0, $dPHSK.default).of('V'));
        return this.dict.context.lookup(valueOrRef);
    };
    PDFAcroField.prototype.Kids = function() {
        return this.dict.lookupMaybe((0, $dPHSK.default).of('Kids'), (0, $8auL6.default));
    };
    // Parent(): PDFDict | undefined {
    //   return this.dict.lookupMaybe(PDFName.of('Parent'), PDFDict);
    // }
    PDFAcroField.prototype.DA = function() {
        var da = this.dict.lookup((0, $dPHSK.default).of('DA'));
        if (da instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039) || da instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) return da;
        return undefined;
    };
    PDFAcroField.prototype.setKids = function(kids) {
        this.dict.set((0, $dPHSK.default).of('Kids'), this.dict.context.obj(kids));
    };
    PDFAcroField.prototype.getParent = function() {
        // const parent = this.Parent();
        // if (!parent) return undefined;
        // return new PDFAcroField(parent);
        var parentRef = this.dict.get((0, $dPHSK.default).of('Parent'));
        if (parentRef instanceof (0, $f1233b848bc26abe$export$2e2bcd8739ae039)) {
            var parent_1 = this.dict.lookup((0, $dPHSK.default).of('Parent'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
            return new PDFAcroField(parent_1, parentRef);
        }
        return undefined;
    };
    PDFAcroField.prototype.setParent = function(parent) {
        if (!parent) this.dict.delete((0, $dPHSK.default).of('Parent'));
        else this.dict.set((0, $dPHSK.default).of('Parent'), parent);
    };
    PDFAcroField.prototype.getFullyQualifiedName = function() {
        var parent = this.getParent();
        if (!parent) return this.getPartialName();
        return parent.getFullyQualifiedName() + "." + this.getPartialName();
    };
    PDFAcroField.prototype.getPartialName = function() {
        var _a;
        return (_a = this.T()) === null || _a === void 0 ? void 0 : _a.decodeText();
    };
    PDFAcroField.prototype.setPartialName = function(partialName) {
        if (!partialName) this.dict.delete((0, $dPHSK.default).of('T'));
        else this.dict.set((0, $dPHSK.default).of('T'), (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(partialName));
    };
    PDFAcroField.prototype.setDefaultAppearance = function(appearance) {
        this.dict.set((0, $dPHSK.default).of('DA'), (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039).of(appearance));
    };
    PDFAcroField.prototype.getDefaultAppearance = function() {
        var DA = this.DA();
        if (DA instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) return DA.decodeText();
        return DA === null || DA === void 0 ? void 0 : DA.asString();
    };
    PDFAcroField.prototype.setFontSize = function(fontSize) {
        var _a;
        var name = (_a = this.getFullyQualifiedName()) !== null && _a !== void 0 ? _a : '';
        var da = this.getDefaultAppearance();
        if (!da) throw new (0, $nAWRe.MissingDAEntryError)(name);
        var daMatch = (0, $7Kmy8.findLastMatch)(da, $3a62e0bdc23bf2e5$var$tfRegex);
        if (!daMatch.match) throw new (0, $nAWRe.MissingTfOperatorError)(name);
        var daStart = da.slice(0, daMatch.pos - daMatch.match[0].length);
        var daEnd = daMatch.pos <= da.length ? da.slice(daMatch.pos) : '';
        var fontName = daMatch.match[1];
        var modifiedDa = daStart + " /" + fontName + " " + fontSize + " Tf " + daEnd;
        this.setDefaultAppearance(modifiedDa);
    };
    PDFAcroField.prototype.getFlags = function() {
        var _a, _b;
        return (_b = (_a = this.Ff()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 0;
    };
    PDFAcroField.prototype.setFlags = function(flags) {
        this.dict.set((0, $dPHSK.default).of('Ff'), (0, $j04jt.default).of(flags));
    };
    PDFAcroField.prototype.hasFlag = function(flag) {
        var flags = this.getFlags();
        return (flags & flag) !== 0;
    };
    PDFAcroField.prototype.setFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags | flag);
    };
    PDFAcroField.prototype.clearFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags & ~flag);
    };
    PDFAcroField.prototype.setFlagTo = function(flag, enable) {
        if (enable) this.setFlag(flag);
        else this.clearFlag(flag);
    };
    PDFAcroField.prototype.getInheritableAttribute = function(name) {
        var attribute;
        this.ascend(function(node) {
            if (!attribute) attribute = node.dict.get(name);
        });
        return attribute;
    };
    PDFAcroField.prototype.ascend = function(visitor) {
        visitor(this);
        var parent = this.getParent();
        if (parent) parent.ascend(visitor);
    };
    return PDFAcroField;
}();
var $3a62e0bdc23bf2e5$export$2e2bcd8739ae039 = $3a62e0bdc23bf2e5$var$PDFAcroField;



var $cOQTW = parcelRequire("cOQTW");


var $dPHSK = parcelRequire("dPHSK");




var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");
// TODO: Also handle the `/S` and `/D` entries
var $1cccd5df89c90385$var$BorderStyle = /** @class */ function() {
    function BorderStyle(dict) {
        this.dict = dict;
    }
    BorderStyle.prototype.W = function() {
        var W = this.dict.lookup((0, $dPHSK.default).of('W'));
        if (W instanceof (0, $j04jt.default)) return W;
        return undefined;
    };
    BorderStyle.prototype.getWidth = function() {
        var _a, _b;
        return (_b = (_a = this.W()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 1;
    };
    BorderStyle.prototype.setWidth = function(width) {
        var W = this.dict.context.obj(width);
        this.dict.set((0, $dPHSK.default).of('W'), W);
    };
    BorderStyle.fromDict = function(dict) {
        return new BorderStyle(dict);
    };
    return BorderStyle;
}();
var $1cccd5df89c90385$export$2e2bcd8739ae039 = $1cccd5df89c90385$var$BorderStyle;




var $dPHSK = parcelRequire("dPHSK");


var $8auL6 = parcelRequire("8auL6");


var $j04jt = parcelRequire("j04jt");
var $b3d65ce7bc0fb74b$var$PDFAnnotation = /** @class */ function() {
    function PDFAnnotation(dict) {
        this.dict = dict;
    }
    // This is technically required by the PDF spec
    PDFAnnotation.prototype.Rect = function() {
        return this.dict.lookup((0, $dPHSK.default).of('Rect'), (0, $8auL6.default));
    };
    PDFAnnotation.prototype.AP = function() {
        return this.dict.lookupMaybe((0, $dPHSK.default).of('AP'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
    };
    PDFAnnotation.prototype.F = function() {
        var numberOrRef = this.dict.lookup((0, $dPHSK.default).of('F'));
        return this.dict.context.lookupMaybe(numberOrRef, (0, $j04jt.default));
    };
    PDFAnnotation.prototype.getRectangle = function() {
        var _a;
        var Rect = this.Rect();
        return (_a = Rect === null || Rect === void 0 ? void 0 : Rect.asRectangle()) !== null && _a !== void 0 ? _a : {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    };
    PDFAnnotation.prototype.setRectangle = function(rect) {
        var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
        var Rect = this.dict.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.dict.set((0, $dPHSK.default).of('Rect'), Rect);
    };
    PDFAnnotation.prototype.getAppearanceState = function() {
        var AS = this.dict.lookup((0, $dPHSK.default).of('AS'));
        if (AS instanceof (0, $dPHSK.default)) return AS;
        return undefined;
    };
    PDFAnnotation.prototype.setAppearanceState = function(state) {
        this.dict.set((0, $dPHSK.default).of('AS'), state);
    };
    PDFAnnotation.prototype.setAppearances = function(appearances) {
        this.dict.set((0, $dPHSK.default).of('AP'), appearances);
    };
    PDFAnnotation.prototype.ensureAP = function() {
        var AP = this.AP();
        if (!AP) {
            AP = this.dict.context.obj({});
            this.dict.set((0, $dPHSK.default).of('AP'), AP);
        }
        return AP;
    };
    PDFAnnotation.prototype.getNormalAppearance = function() {
        var AP = this.ensureAP();
        var N = AP.get((0, $dPHSK.default).of('N'));
        if (N instanceof (0, $f1233b848bc26abe$export$2e2bcd8739ae039) || N instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) return N;
        throw new Error("Unexpected N type: " + (N === null || N === void 0 ? void 0 : N.constructor.name));
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setNormalAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $dPHSK.default).of('N'), appearance);
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setRolloverAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $dPHSK.default).of('R'), appearance);
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setDownAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $dPHSK.default).of('D'), appearance);
    };
    PDFAnnotation.prototype.removeRolloverAppearance = function() {
        var AP = this.AP();
        AP === null || AP === void 0 || AP.delete((0, $dPHSK.default).of('R'));
    };
    PDFAnnotation.prototype.removeDownAppearance = function() {
        var AP = this.AP();
        AP === null || AP === void 0 || AP.delete((0, $dPHSK.default).of('D'));
    };
    PDFAnnotation.prototype.getAppearances = function() {
        var AP = this.AP();
        if (!AP) return undefined;
        var N = AP.lookup((0, $dPHSK.default).of('N'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039), (0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039));
        var R = AP.lookupMaybe((0, $dPHSK.default).of('R'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039), (0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039));
        var D = AP.lookupMaybe((0, $dPHSK.default).of('D'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039), (0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039));
        return {
            normal: N,
            rollover: R,
            down: D
        };
    };
    PDFAnnotation.prototype.getFlags = function() {
        var _a, _b;
        return (_b = (_a = this.F()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 0;
    };
    PDFAnnotation.prototype.setFlags = function(flags) {
        this.dict.set((0, $dPHSK.default).of('F'), (0, $j04jt.default).of(flags));
    };
    PDFAnnotation.prototype.hasFlag = function(flag) {
        var flags = this.getFlags();
        return (flags & flag) !== 0;
    };
    PDFAnnotation.prototype.setFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags | flag);
    };
    PDFAnnotation.prototype.clearFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags & ~flag);
    };
    PDFAnnotation.prototype.setFlagTo = function(flag, enable) {
        if (enable) this.setFlag(flag);
        else this.clearFlag(flag);
    };
    PDFAnnotation.fromDict = function(dict) {
        return new PDFAnnotation(dict);
    };
    return PDFAnnotation;
}();
var $b3d65ce7bc0fb74b$export$2e2bcd8739ae039 = $b3d65ce7bc0fb74b$var$PDFAnnotation;



var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $8auL6 = parcelRequire("8auL6");


var $4649f56151c7fd29$var$AppearanceCharacteristics = /** @class */ function() {
    function AppearanceCharacteristics(dict) {
        this.dict = dict;
    }
    AppearanceCharacteristics.prototype.R = function() {
        var R = this.dict.lookup((0, $dPHSK.default).of('R'));
        if (R instanceof (0, $j04jt.default)) return R;
        return undefined;
    };
    AppearanceCharacteristics.prototype.BC = function() {
        var BC = this.dict.lookup((0, $dPHSK.default).of('BC'));
        if (BC instanceof (0, $8auL6.default)) return BC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.BG = function() {
        var BG = this.dict.lookup((0, $dPHSK.default).of('BG'));
        if (BG instanceof (0, $8auL6.default)) return BG;
        return undefined;
    };
    AppearanceCharacteristics.prototype.CA = function() {
        var CA = this.dict.lookup((0, $dPHSK.default).of('CA'));
        if (CA instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039) || CA instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039)) return CA;
        return undefined;
    };
    AppearanceCharacteristics.prototype.RC = function() {
        var RC = this.dict.lookup((0, $dPHSK.default).of('RC'));
        if (RC instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039) || RC instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039)) return RC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.AC = function() {
        var AC = this.dict.lookup((0, $dPHSK.default).of('AC'));
        if (AC instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039) || AC instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039)) return AC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.getRotation = function() {
        var _a;
        return (_a = this.R()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    AppearanceCharacteristics.prototype.getBorderColor = function() {
        var BC = this.BC();
        if (!BC) return undefined;
        var components = [];
        for(var idx = 0, len = BC === null || BC === void 0 ? void 0 : BC.size(); idx < len; idx++){
            var component = BC.get(idx);
            if (component instanceof (0, $j04jt.default)) components.push(component.asNumber());
        }
        return components;
    };
    AppearanceCharacteristics.prototype.getBackgroundColor = function() {
        var BG = this.BG();
        if (!BG) return undefined;
        var components = [];
        for(var idx = 0, len = BG === null || BG === void 0 ? void 0 : BG.size(); idx < len; idx++){
            var component = BG.get(idx);
            if (component instanceof (0, $j04jt.default)) components.push(component.asNumber());
        }
        return components;
    };
    AppearanceCharacteristics.prototype.getCaptions = function() {
        var CA = this.CA();
        var RC = this.RC();
        var AC = this.AC();
        return {
            normal: CA === null || CA === void 0 ? void 0 : CA.decodeText(),
            rollover: RC === null || RC === void 0 ? void 0 : RC.decodeText(),
            down: AC === null || AC === void 0 ? void 0 : AC.decodeText()
        };
    };
    AppearanceCharacteristics.prototype.setRotation = function(rotation) {
        var R = this.dict.context.obj(rotation);
        this.dict.set((0, $dPHSK.default).of('R'), R);
    };
    AppearanceCharacteristics.prototype.setBorderColor = function(color) {
        var BC = this.dict.context.obj(color);
        this.dict.set((0, $dPHSK.default).of('BC'), BC);
    };
    AppearanceCharacteristics.prototype.setBackgroundColor = function(color) {
        var BG = this.dict.context.obj(color);
        this.dict.set((0, $dPHSK.default).of('BG'), BG);
    };
    AppearanceCharacteristics.prototype.setCaptions = function(captions) {
        var CA = (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(captions.normal);
        this.dict.set((0, $dPHSK.default).of('CA'), CA);
        if (captions.rollover) {
            var RC = (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(captions.rollover);
            this.dict.set((0, $dPHSK.default).of('RC'), RC);
        } else this.dict.delete((0, $dPHSK.default).of('RC'));
        if (captions.down) {
            var AC = (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(captions.down);
            this.dict.set((0, $dPHSK.default).of('AC'), AC);
        } else this.dict.delete((0, $dPHSK.default).of('AC'));
    };
    AppearanceCharacteristics.fromDict = function(dict) {
        return new AppearanceCharacteristics(dict);
    };
    return AppearanceCharacteristics;
}();
var $4649f56151c7fd29$export$2e2bcd8739ae039 = $4649f56151c7fd29$var$AppearanceCharacteristics;


var $540f7922618e60a2$var$PDFWidgetAnnotation = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFWidgetAnnotation, _super);
    function PDFWidgetAnnotation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFWidgetAnnotation.prototype.MK = function() {
        var MK = this.dict.lookup((0, $dPHSK.default).of('MK'));
        if (MK instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) return MK;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.BS = function() {
        var BS = this.dict.lookup((0, $dPHSK.default).of('BS'));
        if (BS instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) return BS;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.DA = function() {
        var da = this.dict.lookup((0, $dPHSK.default).of('DA'));
        if (da instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039) || da instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) return da;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.P = function() {
        var P = this.dict.get((0, $dPHSK.default).of('P'));
        if (P instanceof (0, $f1233b848bc26abe$export$2e2bcd8739ae039)) return P;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.setP = function(page) {
        this.dict.set((0, $dPHSK.default).of('P'), page);
    };
    PDFWidgetAnnotation.prototype.setDefaultAppearance = function(appearance) {
        this.dict.set((0, $dPHSK.default).of('DA'), (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039).of(appearance));
    };
    PDFWidgetAnnotation.prototype.getDefaultAppearance = function() {
        var DA = this.DA();
        if (DA instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) return DA.decodeText();
        return DA === null || DA === void 0 ? void 0 : DA.asString();
    };
    PDFWidgetAnnotation.prototype.getAppearanceCharacteristics = function() {
        var MK = this.MK();
        if (MK) return (0, $4649f56151c7fd29$export$2e2bcd8739ae039).fromDict(MK);
        return undefined;
    };
    PDFWidgetAnnotation.prototype.getOrCreateAppearanceCharacteristics = function() {
        var MK = this.MK();
        if (MK) return (0, $4649f56151c7fd29$export$2e2bcd8739ae039).fromDict(MK);
        var ac = (0, $4649f56151c7fd29$export$2e2bcd8739ae039).fromDict(this.dict.context.obj({}));
        this.dict.set((0, $dPHSK.default).of('MK'), ac.dict);
        return ac;
    };
    PDFWidgetAnnotation.prototype.getBorderStyle = function() {
        var BS = this.BS();
        if (BS) return (0, $1cccd5df89c90385$export$2e2bcd8739ae039).fromDict(BS);
        return undefined;
    };
    PDFWidgetAnnotation.prototype.getOrCreateBorderStyle = function() {
        var BS = this.BS();
        if (BS) return (0, $1cccd5df89c90385$export$2e2bcd8739ae039).fromDict(BS);
        var bs = (0, $1cccd5df89c90385$export$2e2bcd8739ae039).fromDict(this.dict.context.obj({}));
        this.dict.set((0, $dPHSK.default).of('BS'), bs.dict);
        return bs;
    };
    PDFWidgetAnnotation.prototype.getOnValue = function() {
        var _a;
        var normal = (_a = this.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
        if (normal instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) {
            var keys = normal.keys();
            for(var idx = 0, len = keys.length; idx < len; idx++){
                var key = keys[idx];
                if (key !== (0, $dPHSK.default).of('Off')) return key;
            }
        }
        return undefined;
    };
    PDFWidgetAnnotation.fromDict = function(dict) {
        return new PDFWidgetAnnotation(dict);
    };
    PDFWidgetAnnotation.create = function(context, parent) {
        var dict = context.obj({
            Type: 'Annot',
            Subtype: 'Widget',
            Rect: [
                0,
                0,
                0,
                0
            ],
            Parent: parent
        });
        return new PDFWidgetAnnotation(dict);
    };
    return PDFWidgetAnnotation;
}((0, $b3d65ce7bc0fb74b$export$2e2bcd8739ae039));
var $540f7922618e60a2$export$2e2bcd8739ae039 = $540f7922618e60a2$var$PDFWidgetAnnotation;



var $nAWRe = parcelRequire("nAWRe");
var $46d285649821c095$var$PDFAcroTerminal = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroTerminal, _super);
    function PDFAcroTerminal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroTerminal.prototype.FT = function() {
        var nameOrRef = this.getInheritableAttribute((0, $dPHSK.default).of('FT'));
        return this.dict.context.lookup(nameOrRef, (0, $dPHSK.default));
    };
    PDFAcroTerminal.prototype.getWidgets = function() {
        var kidDicts = this.Kids();
        // This field is itself a widget
        if (!kidDicts) return [
            (0, $540f7922618e60a2$export$2e2bcd8739ae039).fromDict(this.dict)
        ];
        // This field's kids are its widgets
        var widgets = new Array(kidDicts.size());
        for(var idx = 0, len = kidDicts.size(); idx < len; idx++){
            var dict = kidDicts.lookup(idx, (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
            widgets[idx] = (0, $540f7922618e60a2$export$2e2bcd8739ae039).fromDict(dict);
        }
        return widgets;
    };
    PDFAcroTerminal.prototype.addWidget = function(ref) {
        var Kids = this.normalizedEntries().Kids;
        Kids.push(ref);
    };
    PDFAcroTerminal.prototype.removeWidget = function(idx) {
        var kidDicts = this.Kids();
        if (!kidDicts) {
            // This field is itself a widget
            if (idx !== 0) throw new (0, $nAWRe.IndexOutOfBoundsError)(idx, 0, 0);
            this.setKids([]);
        } else {
            // This field's kids are its widgets
            if (idx < 0 || idx > kidDicts.size()) throw new (0, $nAWRe.IndexOutOfBoundsError)(idx, 0, kidDicts.size());
            kidDicts.remove(idx);
        }
    };
    PDFAcroTerminal.prototype.normalizedEntries = function() {
        var Kids = this.Kids();
        // If this field is itself a widget (because it was only rendered once in
        // the document, so the field and widget properties were merged) then we
        // add itself to the `Kids` array. The alternative would be to try
        // splitting apart the widget properties and creating a separate object
        // for them.
        if (!Kids) {
            Kids = this.dict.context.obj([
                this.ref
            ]);
            this.dict.set((0, $dPHSK.default).of('Kids'), Kids);
        }
        return {
            Kids: Kids
        };
    };
    PDFAcroTerminal.fromDict = function(dict, ref) {
        return new PDFAcroTerminal(dict, ref);
    };
    return PDFAcroTerminal;
}((0, $3a62e0bdc23bf2e5$export$2e2bcd8739ae039));
var $46d285649821c095$export$2e2bcd8739ae039 = $46d285649821c095$var$PDFAcroTerminal;



var $nAWRe = parcelRequire("nAWRe");
var $8b75e0d2aabd8761$var$PDFAcroButton = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroButton, _super);
    function PDFAcroButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroButton.prototype.Opt = function() {
        return this.dict.lookupMaybe((0, $dPHSK.default).of('Opt'), (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039), (0, $e8537943f4279a06$export$2e2bcd8739ae039), (0, $8auL6.default));
    };
    PDFAcroButton.prototype.setOpt = function(opt) {
        this.dict.set((0, $dPHSK.default).of('Opt'), this.dict.context.obj(opt));
    };
    PDFAcroButton.prototype.getExportValues = function() {
        var opt = this.Opt();
        if (!opt) return undefined;
        if (opt instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039) || opt instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) return [
            opt
        ];
        var values = [];
        for(var idx = 0, len = opt.size(); idx < len; idx++){
            var value = opt.lookup(idx);
            if (value instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039) || value instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) values.push(value);
        }
        return values;
    };
    PDFAcroButton.prototype.removeExportValue = function(idx) {
        var opt = this.Opt();
        if (!opt) return;
        if (opt instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039) || opt instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) {
            if (idx !== 0) throw new (0, $nAWRe.IndexOutOfBoundsError)(idx, 0, 0);
            this.setOpt([]);
        } else {
            if (idx < 0 || idx > opt.size()) throw new (0, $nAWRe.IndexOutOfBoundsError)(idx, 0, opt.size());
            opt.remove(idx);
        }
    };
    // Enforce use use of /Opt even if it isn't strictly necessary
    PDFAcroButton.prototype.normalizeExportValues = function() {
        var _a, _b, _c, _d;
        var exportValues = (_a = this.getExportValues()) !== null && _a !== void 0 ? _a : [];
        var Opt = [];
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var exportVal = (_b = exportValues[idx]) !== null && _b !== void 0 ? _b : (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText((_d = (_c = widget.getOnValue()) === null || _c === void 0 ? void 0 : _c.decodeText()) !== null && _d !== void 0 ? _d : '');
            Opt.push(exportVal);
        }
        this.setOpt(Opt);
    };
    /**
     * Reuses existing opt if one exists with the same value (assuming
     * `useExistingIdx` is `true`). Returns index of existing (or new) opt.
     */ PDFAcroButton.prototype.addOpt = function(opt, useExistingOptIdx) {
        var _a;
        this.normalizeExportValues();
        var optText = opt.decodeText();
        var existingIdx;
        if (useExistingOptIdx) {
            var exportValues = (_a = this.getExportValues()) !== null && _a !== void 0 ? _a : [];
            for(var idx = 0, len = exportValues.length; idx < len; idx++){
                var exportVal = exportValues[idx];
                if (exportVal.decodeText() === optText) existingIdx = idx;
            }
        }
        var Opt = this.Opt();
        Opt.push(opt);
        return existingIdx !== null && existingIdx !== void 0 ? existingIdx : Opt.size() - 1;
    };
    PDFAcroButton.prototype.addWidgetWithOpt = function(widget, opt, useExistingOptIdx) {
        var optIdx = this.addOpt(opt, useExistingOptIdx);
        var apStateValue = (0, $dPHSK.default).of(String(optIdx));
        this.addWidget(widget);
        return apStateValue;
    };
    return PDFAcroButton;
}((0, $46d285649821c095$export$2e2bcd8739ae039));
var $8b75e0d2aabd8761$export$2e2bcd8739ae039 = $8b75e0d2aabd8761$var$PDFAcroButton;



var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");


var $nAWRe = parcelRequire("nAWRe");
var $f8e31b0e21e15332$var$PDFAcroCheckBox = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroCheckBox, _super);
    function PDFAcroCheckBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroCheckBox.prototype.setValue = function(value) {
        var _a;
        var onValue = (_a = this.getOnValue()) !== null && _a !== void 0 ? _a : (0, $dPHSK.default).of('Yes');
        if (value !== onValue && value !== (0, $dPHSK.default).of('Off')) throw new (0, $nAWRe.InvalidAcroFieldValueError)();
        this.dict.set((0, $dPHSK.default).of('V'), value);
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getOnValue() === value ? value : (0, $dPHSK.default).of('Off');
            widget.setAppearanceState(state);
        }
    };
    PDFAcroCheckBox.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $dPHSK.default)) return v;
        return (0, $dPHSK.default).of('Off');
    };
    PDFAcroCheckBox.prototype.getOnValue = function() {
        var widget = this.getWidgets()[0];
        return widget === null || widget === void 0 ? void 0 : widget.getOnValue();
    };
    PDFAcroCheckBox.fromDict = function(dict, ref) {
        return new PDFAcroCheckBox(dict, ref);
    };
    PDFAcroCheckBox.create = function(context) {
        var dict = context.obj({
            FT: 'Btn',
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroCheckBox(dict, ref);
    };
    return PDFAcroCheckBox;
}((0, $8b75e0d2aabd8761$export$2e2bcd8739ae039));
var $f8e31b0e21e15332$export$2e2bcd8739ae039 = $f8e31b0e21e15332$var$PDFAcroCheckBox;



var $cOQTW = parcelRequire("cOQTW");




var $8auL6 = parcelRequire("8auL6");

var $dPHSK = parcelRequire("dPHSK");
var $987e37c460e8464e$var$flag = function(bitIndex) {
    return 1 << bitIndex;
};
var $987e37c460e8464e$export$3600c95532547643;
(function(AcroFieldFlags) {
    /**
     * If set, the user may not change the value of the field. Any associated
     * widget annotations will not interact with the user; that is, they will not
     * respond to mouse clicks or change their appearance in response to mouse
     * motions. This flag is useful for fields whose values are computed or
     * imported from a database.
     */ AcroFieldFlags[AcroFieldFlags["ReadOnly"] = $987e37c460e8464e$var$flag(0)] = "ReadOnly";
    /**
     * If set, the field shall have a value at the time it is exported by a
     * submit-form action (see 12.7.5.2, "Submit-Form Action").
     */ AcroFieldFlags[AcroFieldFlags["Required"] = $987e37c460e8464e$var$flag(1)] = "Required";
    /**
     * If set, the field shall not be exported by a submit-form action
     * (see 12.7.5.2, "Submit-Form Action").
     */ AcroFieldFlags[AcroFieldFlags["NoExport"] = $987e37c460e8464e$var$flag(2)] = "NoExport";
})($987e37c460e8464e$export$3600c95532547643 || ($987e37c460e8464e$export$3600c95532547643 = {}));
var $987e37c460e8464e$export$59f660e89ffb4f8a;
(function(AcroButtonFlags) {
    /**
     * (Radio buttons only) If set, exactly one radio button shall be selected at
     * all times; selecting the currently selected button has no effect. If clear,
     * clicking the selected button deselects it, leaving no button selected.
     */ AcroButtonFlags[AcroButtonFlags["NoToggleToOff"] = $987e37c460e8464e$var$flag(14)] = "NoToggleToOff";
    /**
     * If set, the field is a set of radio buttons; if clear, the field is a check
     * box. This flag may be set only if the Pushbutton flag is clear.
     */ AcroButtonFlags[AcroButtonFlags["Radio"] = $987e37c460e8464e$var$flag(15)] = "Radio";
    /**
     * If set, the field is a pushbutton that does not retain a permanent value.
     */ AcroButtonFlags[AcroButtonFlags["PushButton"] = $987e37c460e8464e$var$flag(16)] = "PushButton";
    /**
     * If set, a group of radio buttons within a radio button field that use the
     * same value for the on state will turn on and off in unison; that is if one
     * is checked, they are all checked. If clear, the buttons are mutually
     * exclusive (the same behavior as HTML radio buttons).
     */ AcroButtonFlags[AcroButtonFlags["RadiosInUnison"] = $987e37c460e8464e$var$flag(25)] = "RadiosInUnison";
})($987e37c460e8464e$export$59f660e89ffb4f8a || ($987e37c460e8464e$export$59f660e89ffb4f8a = {}));
var $987e37c460e8464e$export$389fc7b97397dc8b;
(function(AcroTextFlags) {
    /**
     * If set, the field may contain multiple lines of text; if clear, the field's
     * text shall be restricted to a single line.
     */ AcroTextFlags[AcroTextFlags["Multiline"] = $987e37c460e8464e$var$flag(12)] = "Multiline";
    /**
     * If set, the field is intended for entering a secure password that should
     * not be echoed visibly to the screen. Characters typed from the keyboard
     * shall instead be echoed in some unreadable form, such as asterisks or
     * bullet characters.
     * > NOTE   To protect password confidentiality, readers should never store
     * >        the value of the text field in the PDF file if this flag is set.
     */ AcroTextFlags[AcroTextFlags["Password"] = $987e37c460e8464e$var$flag(13)] = "Password";
    /**
     * If set, the text entered in the field represents the pathname of a file
     * whose contents shall be submitted as the value of the field.
     */ AcroTextFlags[AcroTextFlags["FileSelect"] = $987e37c460e8464e$var$flag(20)] = "FileSelect";
    /**
     * If set, text entered in the field shall not be spell-checked.
     */ AcroTextFlags[AcroTextFlags["DoNotSpellCheck"] = $987e37c460e8464e$var$flag(22)] = "DoNotSpellCheck";
    /**
     * If set, the field shall not scroll (horizontally for single-line fields,
     * vertically for multiple-line fields) to accommodate more text than fits
     * within its annotation rectangle. Once the field is full, no further text
     * shall be accepted for interactive form filling; for non-interactive form
     * filling, the filler should take care not to add more character than will
     * visibly fit in the defined area.
     */ AcroTextFlags[AcroTextFlags["DoNotScroll"] = $987e37c460e8464e$var$flag(23)] = "DoNotScroll";
    /**
     * May be set only if the MaxLen entry is present in the text field dictionary
     * (see Table 229) and if the Multiline, Password, and FileSelect flags are
     * clear. If set, the field shall be automatically divided into as many
     * equally spaced positions, or combs, as the value of MaxLen, and the text
     * is laid out into those combs.
     */ AcroTextFlags[AcroTextFlags["Comb"] = $987e37c460e8464e$var$flag(24)] = "Comb";
    /**
     * If set, the value of this field shall be a rich text string
     * (see 12.7.3.4, "Rich Text Strings"). If the field has a value, the RV
     * entry of the field dictionary (Table 222) shall specify the rich text
     * string.
     */ AcroTextFlags[AcroTextFlags["RichText"] = $987e37c460e8464e$var$flag(25)] = "RichText";
})($987e37c460e8464e$export$389fc7b97397dc8b || ($987e37c460e8464e$export$389fc7b97397dc8b = {}));
var $987e37c460e8464e$export$eb88827058402599;
(function(AcroChoiceFlags) {
    /**
     * If set, the field is a combo box; if clear, the field is a list box.
     */ AcroChoiceFlags[AcroChoiceFlags["Combo"] = $987e37c460e8464e$var$flag(17)] = "Combo";
    /**
     * If set, the combo box shall include an editable text box as well as a
     * drop-down list; if clear, it shall include only a drop-down list. This
     * flag shall be used only if the Combo flag is set.
     */ AcroChoiceFlags[AcroChoiceFlags["Edit"] = $987e37c460e8464e$var$flag(18)] = "Edit";
    /**
     * If set, the field's option items shall be sorted alphabetically. This flag
     * is intended for use by writers, not by readers. Conforming readers shall
     * display the options in the order in which they occur in the Opt array
     * (see Table 231).
     */ AcroChoiceFlags[AcroChoiceFlags["Sort"] = $987e37c460e8464e$var$flag(19)] = "Sort";
    /**
     * If set, more than one of the field's option items may be selected
     * simultaneously; if clear, at most one item shall be selected.
     */ AcroChoiceFlags[AcroChoiceFlags["MultiSelect"] = $987e37c460e8464e$var$flag(21)] = "MultiSelect";
    /**
     * If set, text entered in the field shall not be spell-checked. This flag
     * shall not be used unless the Combo and Edit flags are both set.
     */ AcroChoiceFlags[AcroChoiceFlags["DoNotSpellCheck"] = $987e37c460e8464e$var$flag(22)] = "DoNotSpellCheck";
    /**
     * If set, the new value shall be committed as soon as a selection is made
     * (commonly with the pointing device). In this case, supplying a value for
     * a field involves three actions: selecting the field for fill-in,
     * selecting a choice for the fill-in value, and leaving that field, which
     * finalizes or "commits" the data choice and triggers any actions associated
     * with the entry or changing of this data. If this flag is on, then
     * processing does not wait for leaving the field action to occur, but
     * immediately proceeds to the third step.
     *
     * This option enables applications to perform an action once a selection is
     * made, without requiring the user to exit the field. If clear, the new
     * value is not committed until the user exits the field.
     */ AcroChoiceFlags[AcroChoiceFlags["CommitOnSelChange"] = $987e37c460e8464e$var$flag(26)] = "CommitOnSelChange";
})($987e37c460e8464e$export$eb88827058402599 || ($987e37c460e8464e$export$eb88827058402599 = {}));



var $nAWRe = parcelRequire("nAWRe");
var $10788dcfb83fdb6c$var$PDFAcroChoice = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroChoice, _super);
    function PDFAcroChoice() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroChoice.prototype.setValues = function(values) {
        if (this.hasFlag((0, $987e37c460e8464e$export$eb88827058402599).Combo) && !this.hasFlag((0, $987e37c460e8464e$export$eb88827058402599).Edit) && !this.valuesAreValid(values)) throw new (0, $nAWRe.InvalidAcroFieldValueError)();
        if (values.length === 0) this.dict.delete((0, $dPHSK.default).of('V'));
        if (values.length === 1) this.dict.set((0, $dPHSK.default).of('V'), values[0]);
        if (values.length > 1) {
            if (!this.hasFlag((0, $987e37c460e8464e$export$eb88827058402599).MultiSelect)) throw new (0, $nAWRe.MultiSelectValueError)();
            this.dict.set((0, $dPHSK.default).of('V'), this.dict.context.obj(values));
        }
        this.updateSelectedIndices(values);
    };
    PDFAcroChoice.prototype.valuesAreValid = function(values) {
        var options = this.getOptions();
        var _loop_1 = function(idx, len) {
            var val = values[idx].decodeText();
            if (!options.find(function(o) {
                return val === (o.display || o.value).decodeText();
            })) return {
                value: false
            };
        };
        for(var idx = 0, len = values.length; idx < len; idx++){
            var state_1 = _loop_1(idx, len);
            if (typeof state_1 === "object") return state_1.value;
        }
        return true;
    };
    PDFAcroChoice.prototype.updateSelectedIndices = function(values) {
        if (values.length > 1) {
            var indices = new Array(values.length);
            var options = this.getOptions();
            var _loop_2 = function(idx, len) {
                var val = values[idx].decodeText();
                indices[idx] = options.findIndex(function(o) {
                    return val === (o.display || o.value).decodeText();
                });
            };
            for(var idx = 0, len = values.length; idx < len; idx++)_loop_2(idx, len);
            this.dict.set((0, $dPHSK.default).of('I'), this.dict.context.obj(indices.sort()));
        } else this.dict.delete((0, $dPHSK.default).of('I'));
    };
    PDFAcroChoice.prototype.getValues = function() {
        var v = this.V();
        if (v instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039) || v instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) return [
            v
        ];
        if (v instanceof (0, $8auL6.default)) {
            var values = [];
            for(var idx = 0, len = v.size(); idx < len; idx++){
                var value = v.lookup(idx);
                if (value instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039) || value instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) values.push(value);
            }
            return values;
        }
        return [];
    };
    PDFAcroChoice.prototype.Opt = function() {
        return this.dict.lookupMaybe((0, $dPHSK.default).of('Opt'), (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039), (0, $e8537943f4279a06$export$2e2bcd8739ae039), (0, $8auL6.default));
    };
    PDFAcroChoice.prototype.setOptions = function(options) {
        var newOpt = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = options[idx], value = _a.value, display = _a.display;
            newOpt[idx] = this.dict.context.obj([
                value,
                display || value
            ]);
        }
        this.dict.set((0, $dPHSK.default).of('Opt'), this.dict.context.obj(newOpt));
    };
    PDFAcroChoice.prototype.getOptions = function() {
        var Opt = this.Opt();
        // Not supposed to happen - Opt _should_ always be `PDFArray | undefined`
        if (Opt instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039) || Opt instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) return [
            {
                value: Opt,
                display: Opt
            }
        ];
        if (Opt instanceof (0, $8auL6.default)) {
            var res = [];
            for(var idx = 0, len = Opt.size(); idx < len; idx++){
                var item = Opt.lookup(idx);
                // If `item` is a string, use that as both the export and text value
                if (item instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039) || item instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) res.push({
                    value: item,
                    display: item
                });
                // If `item` is an array of one, treat it the same as just a string,
                // if it's an array of two then `item[0]` is the export value and
                // `item[1]` is the text value
                if (item instanceof (0, $8auL6.default)) {
                    if (item.size() > 0) {
                        var first = item.lookup(0, (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039), (0, $e8537943f4279a06$export$2e2bcd8739ae039));
                        var second = item.lookupMaybe(1, (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039), (0, $e8537943f4279a06$export$2e2bcd8739ae039));
                        res.push({
                            value: first,
                            display: second || first
                        });
                    }
                }
            }
            return res;
        }
        return [];
    };
    return PDFAcroChoice;
}((0, $46d285649821c095$export$2e2bcd8739ae039));
var $10788dcfb83fdb6c$export$2e2bcd8739ae039 = $10788dcfb83fdb6c$var$PDFAcroChoice;



var $cOQTW = parcelRequire("cOQTW");


var $3488827c1474fcce$var$PDFAcroComboBox = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroComboBox, _super);
    function PDFAcroComboBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroComboBox.fromDict = function(dict, ref) {
        return new PDFAcroComboBox(dict, ref);
    };
    PDFAcroComboBox.create = function(context) {
        var dict = context.obj({
            FT: 'Ch',
            Ff: (0, $987e37c460e8464e$export$eb88827058402599).Combo,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroComboBox(dict, ref);
    };
    return PDFAcroComboBox;
}((0, $10788dcfb83fdb6c$export$2e2bcd8739ae039));
var $3488827c1474fcce$export$2e2bcd8739ae039 = $3488827c1474fcce$var$PDFAcroComboBox;





var $8auL6 = parcelRequire("8auL6");

var $dPHSK = parcelRequire("dPHSK");

var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");

var $a105ec5aeb848914$var$PDFAcroNonTerminal = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroNonTerminal, _super);
    function PDFAcroNonTerminal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroNonTerminal.prototype.addField = function(field) {
        var Kids = this.normalizedEntries().Kids;
        Kids === null || Kids === void 0 || Kids.push(field);
    };
    PDFAcroNonTerminal.prototype.normalizedEntries = function() {
        var Kids = this.Kids();
        if (!Kids) {
            Kids = this.dict.context.obj([]);
            this.dict.set((0, $dPHSK.default).of('Kids'), Kids);
        }
        return {
            Kids: Kids
        };
    };
    PDFAcroNonTerminal.fromDict = function(dict, ref) {
        return new PDFAcroNonTerminal(dict, ref);
    };
    PDFAcroNonTerminal.create = function(context) {
        var dict = context.obj({});
        var ref = context.register(dict);
        return new PDFAcroNonTerminal(dict, ref);
    };
    return PDFAcroNonTerminal;
}((0, $3a62e0bdc23bf2e5$export$2e2bcd8739ae039));
var $a105ec5aeb848914$export$2e2bcd8739ae039 = $a105ec5aeb848914$var$PDFAcroNonTerminal;



var $j04jt = parcelRequire("j04jt");


var $dPHSK = parcelRequire("dPHSK");

var $8auL6 = parcelRequire("8auL6");




var $cOQTW = parcelRequire("cOQTW");

var $54d8c5346cdc5323$var$PDFAcroSignature = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroSignature, _super);
    function PDFAcroSignature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroSignature.fromDict = function(dict, ref) {
        return new PDFAcroSignature(dict, ref);
    };
    return PDFAcroSignature;
}((0, $46d285649821c095$export$2e2bcd8739ae039));
var $54d8c5346cdc5323$export$2e2bcd8739ae039 = $54d8c5346cdc5323$var$PDFAcroSignature;



var $cOQTW = parcelRequire("cOQTW");

var $j04jt = parcelRequire("j04jt");



var $dPHSK = parcelRequire("dPHSK");

var $8fd9de5d2343325e$var$PDFAcroText = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroText, _super);
    function PDFAcroText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroText.prototype.MaxLen = function() {
        var maxLen = this.dict.lookup((0, $dPHSK.default).of('MaxLen'));
        if (maxLen instanceof (0, $j04jt.default)) return maxLen;
        return undefined;
    };
    PDFAcroText.prototype.Q = function() {
        var q = this.dict.lookup((0, $dPHSK.default).of('Q'));
        if (q instanceof (0, $j04jt.default)) return q;
        return undefined;
    };
    PDFAcroText.prototype.setMaxLength = function(maxLength) {
        this.dict.set((0, $dPHSK.default).of('MaxLen'), (0, $j04jt.default).of(maxLength));
    };
    PDFAcroText.prototype.removeMaxLength = function() {
        this.dict.delete((0, $dPHSK.default).of('MaxLen'));
    };
    PDFAcroText.prototype.getMaxLength = function() {
        var _a;
        return (_a = this.MaxLen()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    PDFAcroText.prototype.setQuadding = function(quadding) {
        this.dict.set((0, $dPHSK.default).of('Q'), (0, $j04jt.default).of(quadding));
    };
    PDFAcroText.prototype.getQuadding = function() {
        var _a;
        return (_a = this.Q()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    PDFAcroText.prototype.setValue = function(value) {
        this.dict.set((0, $dPHSK.default).of('V'), value);
    // const widgets = this.getWidgets();
    // for (let idx = 0, len = widgets.length; idx < len; idx++) {
    //   const widget = widgets[idx];
    //   const state = widget.getOnValue() === value ? value : PDFName.of('Off');
    //   widget.setAppearanceState(state);
    // }
    };
    PDFAcroText.prototype.removeValue = function() {
        this.dict.delete((0, $dPHSK.default).of('V'));
    };
    PDFAcroText.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039) || v instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) return v;
        return undefined;
    };
    PDFAcroText.fromDict = function(dict, ref) {
        return new PDFAcroText(dict, ref);
    };
    PDFAcroText.create = function(context) {
        var dict = context.obj({
            FT: 'Tx',
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroText(dict, ref);
    };
    return PDFAcroText;
}((0, $46d285649821c095$export$2e2bcd8739ae039));
var $8fd9de5d2343325e$export$2e2bcd8739ae039 = $8fd9de5d2343325e$var$PDFAcroText;



var $cOQTW = parcelRequire("cOQTW");


var $0cfa6a9523f95402$var$PDFAcroPushButton = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroPushButton, _super);
    function PDFAcroPushButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroPushButton.fromDict = function(dict, ref) {
        return new PDFAcroPushButton(dict, ref);
    };
    PDFAcroPushButton.create = function(context) {
        var dict = context.obj({
            FT: 'Btn',
            Ff: (0, $987e37c460e8464e$export$59f660e89ffb4f8a).PushButton,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroPushButton(dict, ref);
    };
    return PDFAcroPushButton;
}((0, $8b75e0d2aabd8761$export$2e2bcd8739ae039));
var $0cfa6a9523f95402$export$2e2bcd8739ae039 = $0cfa6a9523f95402$var$PDFAcroPushButton;



var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");



var $nAWRe = parcelRequire("nAWRe");
var $cad74455a26124b0$var$PDFAcroRadioButton = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroRadioButton, _super);
    function PDFAcroRadioButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroRadioButton.prototype.setValue = function(value) {
        var onValues = this.getOnValues();
        if (!onValues.includes(value) && value !== (0, $dPHSK.default).of('Off')) throw new (0, $nAWRe.InvalidAcroFieldValueError)();
        this.dict.set((0, $dPHSK.default).of('V'), value);
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getOnValue() === value ? value : (0, $dPHSK.default).of('Off');
            widget.setAppearanceState(state);
        }
    };
    PDFAcroRadioButton.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $dPHSK.default)) return v;
        return (0, $dPHSK.default).of('Off');
    };
    PDFAcroRadioButton.prototype.getOnValues = function() {
        var widgets = this.getWidgets();
        var onValues = [];
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var onValue = widgets[idx].getOnValue();
            if (onValue) onValues.push(onValue);
        }
        return onValues;
    };
    PDFAcroRadioButton.fromDict = function(dict, ref) {
        return new PDFAcroRadioButton(dict, ref);
    };
    PDFAcroRadioButton.create = function(context) {
        var dict = context.obj({
            FT: 'Btn',
            Ff: (0, $987e37c460e8464e$export$59f660e89ffb4f8a).Radio,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroRadioButton(dict, ref);
    };
    return PDFAcroRadioButton;
}((0, $8b75e0d2aabd8761$export$2e2bcd8739ae039));
var $cad74455a26124b0$export$2e2bcd8739ae039 = $cad74455a26124b0$var$PDFAcroRadioButton;





var $cOQTW = parcelRequire("cOQTW");

var $c1f53a89685317ba$var$PDFAcroListBox = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroListBox, _super);
    function PDFAcroListBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroListBox.fromDict = function(dict, ref) {
        return new PDFAcroListBox(dict, ref);
    };
    PDFAcroListBox.create = function(context) {
        var dict = context.obj({
            FT: 'Ch',
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroListBox(dict, ref);
    };
    return PDFAcroListBox;
}((0, $10788dcfb83fdb6c$export$2e2bcd8739ae039));
var $c1f53a89685317ba$export$2e2bcd8739ae039 = $c1f53a89685317ba$var$PDFAcroListBox;



var $be3fb214968b38d5$export$34b4fb8893136c4c = function(kidDicts) {
    if (!kidDicts) return [];
    var kids = [];
    for(var idx = 0, len = kidDicts.size(); idx < len; idx++){
        var ref = kidDicts.get(idx);
        var dict = kidDicts.lookup(idx);
        // if (dict instanceof PDFDict) kids.push(PDFAcroField.fromDict(dict));
        if (ref instanceof (0, $f1233b848bc26abe$export$2e2bcd8739ae039) && dict instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) kids.push([
            $be3fb214968b38d5$export$fe770f59a8fbe6d(dict, ref),
            ref
        ]);
    }
    return kids;
};
var $be3fb214968b38d5$export$fe770f59a8fbe6d = function(dict, ref) {
    var isNonTerminal = $be3fb214968b38d5$var$isNonTerminalAcroField(dict);
    if (isNonTerminal) return (0, $a105ec5aeb848914$export$2e2bcd8739ae039).fromDict(dict, ref);
    return $be3fb214968b38d5$var$createPDFAcroTerminal(dict, ref);
};
// TODO: Maybe just check if the dict is *not* a widget? That might be better.
// According to the PDF spec:
//
//   > A field's children in the hierarchy may also include widget annotations
//   > that define its appearance on the page. A field that has children that
//   > are fields is called a non-terminal field. A field that does not have
//   > children that are fields is called a terminal field.
//
// The spec is not entirely clear about how to determine whether a given
// dictionary represents an acrofield or a widget annotation. So we will assume
// that a dictionary is an acrofield if it is a member of the `/Kids` array
// and it contains a `/T` entry (widgets do not have `/T` entries). This isn't
// a bullet proof solution, because the `/T` entry is technically defined as
// optional for acrofields by the PDF spec. But in practice all acrofields seem
// to have a `/T` entry defined.
var $be3fb214968b38d5$var$isNonTerminalAcroField = function(dict) {
    var kids = dict.lookup((0, $dPHSK.default).of('Kids'));
    if (kids instanceof (0, $8auL6.default)) for(var idx = 0, len = kids.size(); idx < len; idx++){
        var kid = kids.lookup(idx);
        var kidIsField = kid instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039) && kid.has((0, $dPHSK.default).of('T'));
        if (kidIsField) return true;
    }
    return false;
};
var $be3fb214968b38d5$var$createPDFAcroTerminal = function(dict, ref) {
    var ftNameOrRef = $be3fb214968b38d5$var$getInheritableAttribute(dict, (0, $dPHSK.default).of('FT'));
    var type = dict.context.lookup(ftNameOrRef, (0, $dPHSK.default));
    if (type === (0, $dPHSK.default).of('Btn')) return $be3fb214968b38d5$var$createPDFAcroButton(dict, ref);
    if (type === (0, $dPHSK.default).of('Ch')) return $be3fb214968b38d5$var$createPDFAcroChoice(dict, ref);
    if (type === (0, $dPHSK.default).of('Tx')) return (0, $8fd9de5d2343325e$export$2e2bcd8739ae039).fromDict(dict, ref);
    if (type === (0, $dPHSK.default).of('Sig')) return (0, $54d8c5346cdc5323$export$2e2bcd8739ae039).fromDict(dict, ref);
    // We should never reach this line. But there are a lot of weird PDFs out
    // there. So, just to be safe, we'll try to handle things gracefully instead
    // of throwing an error.
    return (0, $46d285649821c095$export$2e2bcd8739ae039).fromDict(dict, ref);
};
var $be3fb214968b38d5$var$createPDFAcroButton = function(dict, ref) {
    var _a;
    var ffNumberOrRef = $be3fb214968b38d5$var$getInheritableAttribute(dict, (0, $dPHSK.default).of('Ff'));
    var ffNumber = dict.context.lookupMaybe(ffNumberOrRef, (0, $j04jt.default));
    var flags = (_a = ffNumber === null || ffNumber === void 0 ? void 0 : ffNumber.asNumber()) !== null && _a !== void 0 ? _a : 0;
    if ($be3fb214968b38d5$var$flagIsSet(flags, (0, $987e37c460e8464e$export$59f660e89ffb4f8a).PushButton)) return (0, $0cfa6a9523f95402$export$2e2bcd8739ae039).fromDict(dict, ref);
    else if ($be3fb214968b38d5$var$flagIsSet(flags, (0, $987e37c460e8464e$export$59f660e89ffb4f8a).Radio)) return (0, $cad74455a26124b0$export$2e2bcd8739ae039).fromDict(dict, ref);
    else return (0, $f8e31b0e21e15332$export$2e2bcd8739ae039).fromDict(dict, ref);
};
var $be3fb214968b38d5$var$createPDFAcroChoice = function(dict, ref) {
    var _a;
    var ffNumberOrRef = $be3fb214968b38d5$var$getInheritableAttribute(dict, (0, $dPHSK.default).of('Ff'));
    var ffNumber = dict.context.lookupMaybe(ffNumberOrRef, (0, $j04jt.default));
    var flags = (_a = ffNumber === null || ffNumber === void 0 ? void 0 : ffNumber.asNumber()) !== null && _a !== void 0 ? _a : 0;
    if ($be3fb214968b38d5$var$flagIsSet(flags, (0, $987e37c460e8464e$export$eb88827058402599).Combo)) return (0, $3488827c1474fcce$export$2e2bcd8739ae039).fromDict(dict, ref);
    else return (0, $c1f53a89685317ba$export$2e2bcd8739ae039).fromDict(dict, ref);
};
var $be3fb214968b38d5$var$flagIsSet = function(flags, flag) {
    return (flags & flag) !== 0;
};
var $be3fb214968b38d5$var$getInheritableAttribute = function(startNode, name) {
    var attribute;
    $be3fb214968b38d5$var$ascend(startNode, function(node) {
        if (!attribute) attribute = node.get(name);
    });
    return attribute;
};
var $be3fb214968b38d5$var$ascend = function(startNode, visitor) {
    visitor(startNode);
    var Parent = startNode.lookupMaybe((0, $dPHSK.default).of('Parent'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
    if (Parent) $be3fb214968b38d5$var$ascend(Parent, visitor);
};


var $b2be38e1e2597241$var$PDFAcroForm = /** @class */ function() {
    function PDFAcroForm(dict) {
        this.dict = dict;
    }
    PDFAcroForm.prototype.Fields = function() {
        var fields = this.dict.lookup((0, $dPHSK.default).of('Fields'));
        if (fields instanceof (0, $8auL6.default)) return fields;
        return undefined;
    };
    PDFAcroForm.prototype.getFields = function() {
        var Fields = this.normalizedEntries().Fields;
        var fields = new Array(Fields.size());
        for(var idx = 0, len = Fields.size(); idx < len; idx++){
            var ref = Fields.get(idx);
            var dict = Fields.lookup(idx, (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
            fields[idx] = [
                (0, $be3fb214968b38d5$export$fe770f59a8fbe6d)(dict, ref),
                ref
            ];
        }
        return fields;
    };
    PDFAcroForm.prototype.getAllFields = function() {
        var allFields = [];
        var pushFields = function(fields) {
            if (!fields) return;
            for(var idx = 0, len = fields.length; idx < len; idx++){
                var field = fields[idx];
                allFields.push(field);
                var fieldModel = field[0];
                if (fieldModel instanceof (0, $a105ec5aeb848914$export$2e2bcd8739ae039)) pushFields((0, $be3fb214968b38d5$export$34b4fb8893136c4c)(fieldModel.Kids()));
            }
        };
        pushFields(this.getFields());
        return allFields;
    };
    PDFAcroForm.prototype.addField = function(field) {
        var Fields = this.normalizedEntries().Fields;
        Fields === null || Fields === void 0 || Fields.push(field);
    };
    PDFAcroForm.prototype.removeField = function(field) {
        var parent = field.getParent();
        var fields = parent === undefined ? this.normalizedEntries().Fields : parent.Kids();
        var index = fields === null || fields === void 0 ? void 0 : fields.indexOf(field.ref);
        if (fields === undefined || index === undefined) throw new Error("Tried to remove inexistent field " + field.getFullyQualifiedName());
        fields.remove(index);
        if (parent !== undefined && fields.size() === 0) this.removeField(parent);
    };
    PDFAcroForm.prototype.normalizedEntries = function() {
        var Fields = this.Fields();
        if (!Fields) {
            Fields = this.dict.context.obj([]);
            this.dict.set((0, $dPHSK.default).of('Fields'), Fields);
        }
        return {
            Fields: Fields
        };
    };
    PDFAcroForm.fromDict = function(dict) {
        return new PDFAcroForm(dict);
    };
    PDFAcroForm.create = function(context) {
        var dict = context.obj({
            Fields: []
        });
        return new PDFAcroForm(dict);
    };
    return PDFAcroForm;
}();
var $b2be38e1e2597241$export$2e2bcd8739ae039 = $b2be38e1e2597241$var$PDFAcroForm;














var $cpTWE = parcelRequire("cpTWE");
var $80c05707f2c8c1f7$var$PDFCatalog = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFCatalog, _super);
    function PDFCatalog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFCatalog.prototype.Pages = function() {
        return this.lookup((0, $dPHSK.default).of('Pages'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
    };
    PDFCatalog.prototype.AcroForm = function() {
        return this.lookupMaybe((0, $dPHSK.default).of('AcroForm'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
    };
    PDFCatalog.prototype.getAcroForm = function() {
        var dict = this.AcroForm();
        if (!dict) return undefined;
        return (0, $b2be38e1e2597241$export$2e2bcd8739ae039).fromDict(dict);
    };
    PDFCatalog.prototype.getOrCreateAcroForm = function() {
        var acroForm = this.getAcroForm();
        if (!acroForm) {
            acroForm = (0, $b2be38e1e2597241$export$2e2bcd8739ae039).create(this.context);
            var acroFormRef = this.context.register(acroForm.dict);
            this.set((0, $dPHSK.default).of('AcroForm'), acroFormRef);
        }
        return acroForm;
    };
    PDFCatalog.prototype.ViewerPreferences = function() {
        return this.lookupMaybe((0, $dPHSK.default).of('ViewerPreferences'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
    };
    PDFCatalog.prototype.getViewerPreferences = function() {
        var dict = this.ViewerPreferences();
        if (!dict) return undefined;
        return (0, $cpTWE.default).fromDict(dict);
    };
    PDFCatalog.prototype.getOrCreateViewerPreferences = function() {
        var viewerPrefs = this.getViewerPreferences();
        if (!viewerPrefs) {
            viewerPrefs = (0, $cpTWE.default).create(this.context);
            var viewerPrefsRef = this.context.register(viewerPrefs.dict);
            this.set((0, $dPHSK.default).of('ViewerPreferences'), viewerPrefsRef);
        }
        return viewerPrefs;
    };
    /**
     * Inserts the given ref as a leaf node of this catalog's page tree at the
     * specified index (zero-based). Also increments the `Count` of each node in
     * the page tree hierarchy to accomodate the new page.
     *
     * Returns the ref of the PDFPageTree node into which `leafRef` was inserted.
     */ PDFCatalog.prototype.insertLeafNode = function(leafRef, index) {
        var pagesRef = this.get((0, $dPHSK.default).of('Pages'));
        var maybeParentRef = this.Pages().insertLeafNode(leafRef, index);
        return maybeParentRef || pagesRef;
    };
    PDFCatalog.prototype.removeLeafNode = function(index) {
        this.Pages().removeLeafNode(index);
    };
    PDFCatalog.withContextAndPages = function(context, pages) {
        var dict = new Map();
        dict.set((0, $dPHSK.default).of('Type'), (0, $dPHSK.default).of('Catalog'));
        dict.set((0, $dPHSK.default).of('Pages'), pages);
        return new PDFCatalog(dict, context);
    };
    PDFCatalog.fromMapWithContext = function(map, context) {
        return new PDFCatalog(map, context);
    };
    return PDFCatalog;
}((0, $85408478fbb7cbde$export$2e2bcd8739ae039));
var $80c05707f2c8c1f7$export$2e2bcd8739ae039 = $80c05707f2c8c1f7$var$PDFCatalog;






var $cOQTW = parcelRequire("cOQTW");

var $8auL6 = parcelRequire("8auL6");


var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");


var $nAWRe = parcelRequire("nAWRe");
var $333acd2e5fba0d32$var$PDFPageTree = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFPageTree, _super);
    function PDFPageTree() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFPageTree.prototype.Parent = function() {
        return this.lookup((0, $dPHSK.default).of('Parent'));
    };
    PDFPageTree.prototype.Kids = function() {
        return this.lookup((0, $dPHSK.default).of('Kids'), (0, $8auL6.default));
    };
    PDFPageTree.prototype.Count = function() {
        return this.lookup((0, $dPHSK.default).of('Count'), (0, $j04jt.default));
    };
    PDFPageTree.prototype.pushTreeNode = function(treeRef) {
        var Kids = this.Kids();
        Kids.push(treeRef);
    };
    PDFPageTree.prototype.pushLeafNode = function(leafRef) {
        var Kids = this.Kids();
        this.insertLeafKid(Kids.size(), leafRef);
    };
    /**
     * Inserts the given ref as a leaf node of this page tree at the specified
     * index (zero-based). Also increments the `Count` of each page tree in the
     * hierarchy to accomodate the new page.
     *
     * Returns the ref of the PDFPageTree node into which `leafRef` was inserted,
     * or `undefined` if it was inserted into the root node (the PDFPageTree upon
     * which the method was first called).
     */ PDFPageTree.prototype.insertLeafNode = function(leafRef, targetIndex) {
        var Kids = this.Kids();
        var Count = this.Count().asNumber();
        if (targetIndex > Count) throw new (0, $nAWRe.InvalidTargetIndexError)(targetIndex, Count);
        var leafsRemainingUntilTarget = targetIndex;
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            if (leafsRemainingUntilTarget === 0) {
                // Insert page and return
                this.insertLeafKid(idx, leafRef);
                return undefined;
            }
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) {
                if (kid.Count().asNumber() > leafsRemainingUntilTarget) // Dig in
                return kid.insertLeafNode(leafRef, leafsRemainingUntilTarget) || kidRef;
                else // Move on
                leafsRemainingUntilTarget -= kid.Count().asNumber();
            }
            if (kid instanceof (0, $a9e73b7ced5abfa4$export$2e2bcd8739ae039)) // Move on
            leafsRemainingUntilTarget -= 1;
        }
        if (leafsRemainingUntilTarget === 0) {
            // Insert page at the end and return
            this.insertLeafKid(Kids.size(), leafRef);
            return undefined;
        }
        // Should never get here if `targetIndex` is valid
        throw new (0, $nAWRe.CorruptPageTreeError)(targetIndex, 'insertLeafNode');
    };
    /**
     * Removes the leaf node at the specified index (zero-based) from this page
     * tree. Also decrements the `Count` of each page tree in the hierarchy to
     * account for the removed page.
     *
     * If `prune` is true, then intermediate tree nodes will be removed from the
     * tree if they contain 0 children after the leaf node is removed.
     */ PDFPageTree.prototype.removeLeafNode = function(targetIndex, prune) {
        if (prune === void 0) prune = true;
        var Kids = this.Kids();
        var Count = this.Count().asNumber();
        if (targetIndex >= Count) throw new (0, $nAWRe.InvalidTargetIndexError)(targetIndex, Count);
        var leafsRemainingUntilTarget = targetIndex;
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) {
                if (kid.Count().asNumber() > leafsRemainingUntilTarget) {
                    // Dig in
                    kid.removeLeafNode(leafsRemainingUntilTarget, prune);
                    if (prune && kid.Kids().size() === 0) Kids.remove(idx);
                    return;
                } else // Move on
                leafsRemainingUntilTarget -= kid.Count().asNumber();
            }
            if (kid instanceof (0, $a9e73b7ced5abfa4$export$2e2bcd8739ae039)) {
                if (leafsRemainingUntilTarget === 0) {
                    // Remove page and return
                    this.removeKid(idx);
                    return;
                } else // Move on
                leafsRemainingUntilTarget -= 1;
            }
        }
        // Should never get here if `targetIndex` is valid
        throw new (0, $nAWRe.CorruptPageTreeError)(targetIndex, 'removeLeafNode');
    };
    PDFPageTree.prototype.ascend = function(visitor) {
        visitor(this);
        var Parent = this.Parent();
        if (Parent) Parent.ascend(visitor);
    };
    /** Performs a Post-Order traversal of this page tree */ PDFPageTree.prototype.traverse = function(visitor) {
        var Kids = this.Kids();
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) kid.traverse(visitor);
            visitor(kid, kidRef);
        }
    };
    PDFPageTree.prototype.insertLeafKid = function(kidIdx, leafRef) {
        var Kids = this.Kids();
        this.ascend(function(node) {
            var newCount = node.Count().asNumber() + 1;
            node.set((0, $dPHSK.default).of('Count'), (0, $j04jt.default).of(newCount));
        });
        Kids.insert(kidIdx, leafRef);
    };
    PDFPageTree.prototype.removeKid = function(kidIdx) {
        var Kids = this.Kids();
        var kid = Kids.lookup(kidIdx);
        if (kid instanceof (0, $a9e73b7ced5abfa4$export$2e2bcd8739ae039)) this.ascend(function(node) {
            var newCount = node.Count().asNumber() - 1;
            node.set((0, $dPHSK.default).of('Count'), (0, $j04jt.default).of(newCount));
        });
        Kids.remove(kidIdx);
    };
    PDFPageTree.withContext = function(context, parent) {
        var dict = new Map();
        dict.set((0, $dPHSK.default).of('Type'), (0, $dPHSK.default).of('Pages'));
        dict.set((0, $dPHSK.default).of('Kids'), context.obj([]));
        dict.set((0, $dPHSK.default).of('Count'), context.obj(0));
        if (parent) dict.set((0, $dPHSK.default).of('Parent'), parent);
        return new PDFPageTree(dict, context);
    };
    PDFPageTree.fromMapWithContext = function(map, context) {
        return new PDFPageTree(map, context);
    };
    return PDFPageTree;
}((0, $85408478fbb7cbde$export$2e2bcd8739ae039));
var $333acd2e5fba0d32$export$2e2bcd8739ae039 = $333acd2e5fba0d32$var$PDFPageTree;







var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $8auL6 = parcelRequire("8auL6");

var $8gQNC = parcelRequire("8gQNC");



var $dPHSK = parcelRequire("dPHSK");


var $j04jt = parcelRequire("j04jt");




var $nAWRe = parcelRequire("nAWRe");

var $8zvel = parcelRequire("8zvel");

var $8zvel = parcelRequire("8zvel");
var $5679a387c9e20301$export$9492c31549e88980 = new Uint8Array(256);
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Zero] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).One] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Two] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Three] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Four] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Five] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Six] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Seven] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Eight] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Nine] = 1;
var $5679a387c9e20301$export$d438b84505bee68c = new Uint8Array(256);
$5679a387c9e20301$export$d438b84505bee68c[(0, $8zvel.default).Period] = 1;
$5679a387c9e20301$export$d438b84505bee68c[(0, $8zvel.default).Plus] = 1;
$5679a387c9e20301$export$d438b84505bee68c[(0, $8zvel.default).Minus] = 1;
var $5679a387c9e20301$export$4d926b029fa61cfe = new Uint8Array(256);
for(var $5679a387c9e20301$var$idx = 0, $5679a387c9e20301$var$len = 256; $5679a387c9e20301$var$idx < $5679a387c9e20301$var$len; $5679a387c9e20301$var$idx++)$5679a387c9e20301$export$4d926b029fa61cfe[$5679a387c9e20301$var$idx] = $5679a387c9e20301$export$9492c31549e88980[$5679a387c9e20301$var$idx] || $5679a387c9e20301$export$d438b84505bee68c[$5679a387c9e20301$var$idx] ? 1 : 0;



var $14u6w = parcelRequire("14u6w");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $ccc28a798e23d674$var$Newline = (0, $8zvel.default).Newline, $ccc28a798e23d674$var$CarriageReturn = (0, $8zvel.default).CarriageReturn;
// TODO: Throw error if eof is reached before finishing object parse...
var $ccc28a798e23d674$var$BaseParser = /** @class */ function() {
    function BaseParser(bytes, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        this.bytes = bytes;
        this.capNumbers = capNumbers;
    }
    BaseParser.prototype.parseRawInt = function() {
        var value = '';
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $5679a387c9e20301$export$9492c31549e88980)[byte]) break;
            value += (0, $7Kmy8.charFromCode)(this.bytes.next());
        }
        var numberValue = Number(value);
        if (!value || !isFinite(numberValue)) throw new (0, $nAWRe.NumberParsingError)(this.bytes.position(), value);
        return numberValue;
    };
    // TODO: Maybe handle exponential format?
    // TODO: Compare performance of string concatenation to charFromCode(...bytes)
    BaseParser.prototype.parseRawNumber = function() {
        var value = '';
        // Parse integer-part, the leading (+ | - | . | 0-9)
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $5679a387c9e20301$export$4d926b029fa61cfe)[byte]) break;
            value += (0, $7Kmy8.charFromCode)(this.bytes.next());
            if (byte === (0, $8zvel.default).Period) break;
        }
        // Parse decimal-part, the trailing (0-9)
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $5679a387c9e20301$export$9492c31549e88980)[byte]) break;
            value += (0, $7Kmy8.charFromCode)(this.bytes.next());
        }
        var numberValue = Number(value);
        if (!value || !isFinite(numberValue)) throw new (0, $nAWRe.NumberParsingError)(this.bytes.position(), value);
        if (numberValue > Number.MAX_SAFE_INTEGER) {
            if (this.capNumbers) {
                var msg = "Parsed number that is too large for some PDF readers: " + value + ", using Number.MAX_SAFE_INTEGER instead.";
                console.warn(msg);
                return Number.MAX_SAFE_INTEGER;
            } else {
                var msg = "Parsed number that is too large for some PDF readers: " + value + ", not capping.";
                console.warn(msg);
            }
        }
        return numberValue;
    };
    BaseParser.prototype.skipWhitespace = function() {
        while(!this.bytes.done() && (0, $14u6w.IsWhitespace)[this.bytes.peek()])this.bytes.next();
    };
    BaseParser.prototype.skipLine = function() {
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (byte === $ccc28a798e23d674$var$Newline || byte === $ccc28a798e23d674$var$CarriageReturn) return;
            this.bytes.next();
        }
    };
    BaseParser.prototype.skipComment = function() {
        if (this.bytes.peek() !== (0, $8zvel.default).Percent) return false;
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (byte === $ccc28a798e23d674$var$Newline || byte === $ccc28a798e23d674$var$CarriageReturn) return true;
            this.bytes.next();
        }
        return true;
    };
    BaseParser.prototype.skipWhitespaceAndComments = function() {
        this.skipWhitespace();
        while(this.skipComment())this.skipWhitespace();
    };
    BaseParser.prototype.matchKeyword = function(keyword) {
        var initialOffset = this.bytes.offset();
        for(var idx = 0, len = keyword.length; idx < len; idx++)if (this.bytes.done() || this.bytes.next() !== keyword[idx]) {
            this.bytes.moveTo(initialOffset);
            return false;
        }
        return true;
    };
    return BaseParser;
}();
var $ccc28a798e23d674$export$2e2bcd8739ae039 = $ccc28a798e23d674$var$BaseParser;



var $nAWRe = parcelRequire("nAWRe");


var $8zvel = parcelRequire("8zvel");
// TODO: See how line/col tracking affects performance
var $93214384d2c510d6$var$ByteStream = /** @class */ function() {
    function ByteStream(bytes) {
        this.idx = 0;
        this.line = 0;
        this.column = 0;
        this.bytes = bytes;
        this.length = this.bytes.length;
    }
    ByteStream.prototype.moveTo = function(offset) {
        this.idx = offset;
    };
    ByteStream.prototype.next = function() {
        var byte = this.bytes[this.idx++];
        if (byte === (0, $8zvel.default).Newline) {
            this.line += 1;
            this.column = 0;
        } else this.column += 1;
        return byte;
    };
    ByteStream.prototype.assertNext = function(expected) {
        if (this.peek() !== expected) throw new (0, $nAWRe.NextByteAssertionError)(this.position(), expected, this.peek());
        return this.next();
    };
    ByteStream.prototype.peek = function() {
        return this.bytes[this.idx];
    };
    ByteStream.prototype.peekAhead = function(steps) {
        return this.bytes[this.idx + steps];
    };
    ByteStream.prototype.peekAt = function(offset) {
        return this.bytes[offset];
    };
    ByteStream.prototype.done = function() {
        return this.idx >= this.length;
    };
    ByteStream.prototype.offset = function() {
        return this.idx;
    };
    ByteStream.prototype.slice = function(start, end) {
        return this.bytes.slice(start, end);
    };
    ByteStream.prototype.position = function() {
        return {
            line: this.line,
            column: this.column,
            offset: this.idx
        };
    };
    ByteStream.of = function(bytes) {
        return new ByteStream(bytes);
    };
    ByteStream.fromPDFRawStream = function(rawStream) {
        return ByteStream.of((0, $a0659294f562ac04$export$b8317e68ca978594)(rawStream).decode());
    };
    return ByteStream;
}();
var $93214384d2c510d6$export$2e2bcd8739ae039 = $93214384d2c510d6$var$ByteStream;






var $8zvel = parcelRequire("8zvel");

var $eOx0D = parcelRequire("eOx0D");

var $cOQTW = parcelRequire("cOQTW");

var $8zvel = parcelRequire("8zvel");
var $f3568ef95260ec55$var$Space = (0, $8zvel.default).Space, $f3568ef95260ec55$var$CarriageReturn = (0, $8zvel.default).CarriageReturn, $f3568ef95260ec55$var$Newline = (0, $8zvel.default).Newline;
var $f3568ef95260ec55$var$stream = [
    (0, $8zvel.default).s,
    (0, $8zvel.default).t,
    (0, $8zvel.default).r,
    (0, $8zvel.default).e,
    (0, $8zvel.default).a,
    (0, $8zvel.default).m
];
var $f3568ef95260ec55$var$endstream = [
    (0, $8zvel.default).e,
    (0, $8zvel.default).n,
    (0, $8zvel.default).d,
    (0, $8zvel.default).s,
    (0, $8zvel.default).t,
    (0, $8zvel.default).r,
    (0, $8zvel.default).e,
    (0, $8zvel.default).a,
    (0, $8zvel.default).m
];
var $f3568ef95260ec55$export$93ad50ccfacdd77 = {
    header: [
        (0, $8zvel.default).Percent,
        (0, $8zvel.default).P,
        (0, $8zvel.default).D,
        (0, $8zvel.default).F,
        (0, $8zvel.default).Dash
    ],
    eof: [
        (0, $8zvel.default).Percent,
        (0, $8zvel.default).Percent,
        (0, $8zvel.default).E,
        (0, $8zvel.default).O,
        (0, $8zvel.default).F
    ],
    obj: [
        (0, $8zvel.default).o,
        (0, $8zvel.default).b,
        (0, $8zvel.default).j
    ],
    endobj: [
        (0, $8zvel.default).e,
        (0, $8zvel.default).n,
        (0, $8zvel.default).d,
        (0, $8zvel.default).o,
        (0, $8zvel.default).b,
        (0, $8zvel.default).j
    ],
    xref: [
        (0, $8zvel.default).x,
        (0, $8zvel.default).r,
        (0, $8zvel.default).e,
        (0, $8zvel.default).f
    ],
    trailer: [
        (0, $8zvel.default).t,
        (0, $8zvel.default).r,
        (0, $8zvel.default).a,
        (0, $8zvel.default).i,
        (0, $8zvel.default).l,
        (0, $8zvel.default).e,
        (0, $8zvel.default).r
    ],
    startxref: [
        (0, $8zvel.default).s,
        (0, $8zvel.default).t,
        (0, $8zvel.default).a,
        (0, $8zvel.default).r,
        (0, $8zvel.default).t,
        (0, $8zvel.default).x,
        (0, $8zvel.default).r,
        (0, $8zvel.default).e,
        (0, $8zvel.default).f
    ],
    true: [
        (0, $8zvel.default).t,
        (0, $8zvel.default).r,
        (0, $8zvel.default).u,
        (0, $8zvel.default).e
    ],
    false: [
        (0, $8zvel.default).f,
        (0, $8zvel.default).a,
        (0, $8zvel.default).l,
        (0, $8zvel.default).s,
        (0, $8zvel.default).e
    ],
    null: [
        (0, $8zvel.default).n,
        (0, $8zvel.default).u,
        (0, $8zvel.default).l,
        (0, $8zvel.default).l
    ],
    stream: $f3568ef95260ec55$var$stream,
    streamEOF1: (0, $cOQTW.__spreadArrays)($f3568ef95260ec55$var$stream, [
        $f3568ef95260ec55$var$Space,
        $f3568ef95260ec55$var$CarriageReturn,
        $f3568ef95260ec55$var$Newline
    ]),
    streamEOF2: (0, $cOQTW.__spreadArrays)($f3568ef95260ec55$var$stream, [
        $f3568ef95260ec55$var$CarriageReturn,
        $f3568ef95260ec55$var$Newline
    ]),
    streamEOF3: (0, $cOQTW.__spreadArrays)($f3568ef95260ec55$var$stream, [
        $f3568ef95260ec55$var$CarriageReturn
    ]),
    streamEOF4: (0, $cOQTW.__spreadArrays)($f3568ef95260ec55$var$stream, [
        $f3568ef95260ec55$var$Newline
    ]),
    endstream: $f3568ef95260ec55$var$endstream,
    EOF1endstream: (0, $cOQTW.__spreadArrays)([
        $f3568ef95260ec55$var$CarriageReturn,
        $f3568ef95260ec55$var$Newline
    ], $f3568ef95260ec55$var$endstream),
    EOF2endstream: (0, $cOQTW.__spreadArrays)([
        $f3568ef95260ec55$var$CarriageReturn
    ], $f3568ef95260ec55$var$endstream),
    EOF3endstream: (0, $cOQTW.__spreadArrays)([
        $f3568ef95260ec55$var$Newline
    ], $f3568ef95260ec55$var$endstream)
};




var $14u6w = parcelRequire("14u6w");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
// TODO: Throw error if eof is reached before finishing object parse...
var $2ce01d1490df00cf$var$PDFObjectParser = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFObjectParser, _super);
    function PDFObjectParser(byteStream, context, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        var _this = _super.call(this, byteStream, capNumbers) || this;
        _this.context = context;
        return _this;
    }
    // TODO: Is it possible to reduce duplicate parsing for ref lookaheads?
    PDFObjectParser.prototype.parseObject = function() {
        this.skipWhitespaceAndComments();
        if (this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).true)) return (0, $8gQNC.default).True;
        if (this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).false)) return (0, $8gQNC.default).False;
        if (this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).null)) return 0, $ad8a981877dc5d20$export$2e2bcd8739ae039;
        var byte = this.bytes.peek();
        if (byte === (0, $8zvel.default).LessThan && this.bytes.peekAhead(1) === (0, $8zvel.default).LessThan) return this.parseDictOrStream();
        if (byte === (0, $8zvel.default).LessThan) return this.parseHexString();
        if (byte === (0, $8zvel.default).LeftParen) return this.parseString();
        if (byte === (0, $8zvel.default).ForwardSlash) return this.parseName();
        if (byte === (0, $8zvel.default).LeftSquareBracket) return this.parseArray();
        if ((0, $5679a387c9e20301$export$4d926b029fa61cfe)[byte]) return this.parseNumberOrRef();
        throw new (0, $nAWRe.PDFObjectParsingError)(this.bytes.position(), byte);
    };
    PDFObjectParser.prototype.parseNumberOrRef = function() {
        var firstNum = this.parseRawNumber();
        this.skipWhitespaceAndComments();
        var lookaheadStart = this.bytes.offset();
        if ((0, $5679a387c9e20301$export$9492c31549e88980)[this.bytes.peek()]) {
            var secondNum = this.parseRawNumber();
            this.skipWhitespaceAndComments();
            if (this.bytes.peek() === (0, $8zvel.default).R) {
                this.bytes.assertNext((0, $8zvel.default).R);
                return (0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(firstNum, secondNum);
            }
        }
        this.bytes.moveTo(lookaheadStart);
        return (0, $j04jt.default).of(firstNum);
    };
    // TODO: Maybe update PDFHexString.of() logic to remove whitespace and validate input?
    PDFObjectParser.prototype.parseHexString = function() {
        var value = '';
        this.bytes.assertNext((0, $8zvel.default).LessThan);
        while(!this.bytes.done() && this.bytes.peek() !== (0, $8zvel.default).GreaterThan)value += (0, $7Kmy8.charFromCode)(this.bytes.next());
        this.bytes.assertNext((0, $8zvel.default).GreaterThan);
        return (0, $e8537943f4279a06$export$2e2bcd8739ae039).of(value);
    };
    PDFObjectParser.prototype.parseString = function() {
        var nestingLvl = 0;
        var isEscaped = false;
        var value = '';
        while(!this.bytes.done()){
            var byte = this.bytes.next();
            value += (0, $7Kmy8.charFromCode)(byte);
            // Check for unescaped parenthesis
            if (!isEscaped) {
                if (byte === (0, $8zvel.default).LeftParen) nestingLvl += 1;
                if (byte === (0, $8zvel.default).RightParen) nestingLvl -= 1;
            }
            // Track whether current character is being escaped or not
            if (byte === (0, $8zvel.default).BackSlash) isEscaped = !isEscaped;
            else if (isEscaped) isEscaped = false;
            // Once (if) the unescaped parenthesis balance out, return their contents
            if (nestingLvl === 0) // Remove the outer parens so they aren't part of the contents
            return (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039).of(value.substring(1, value.length - 1));
        }
        throw new (0, $nAWRe.UnbalancedParenthesisError)(this.bytes.position());
    };
    // TODO: Compare performance of string concatenation to charFromCode(...bytes)
    // TODO: Maybe preallocate small Uint8Array if can use charFromCode?
    PDFObjectParser.prototype.parseName = function() {
        this.bytes.assertNext((0, $8zvel.default).ForwardSlash);
        var name = '';
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if ((0, $14u6w.IsWhitespace)[byte] || (0, $eOx0D.IsDelimiter)[byte]) break;
            name += (0, $7Kmy8.charFromCode)(byte);
            this.bytes.next();
        }
        return (0, $dPHSK.default).of(name);
    };
    PDFObjectParser.prototype.parseArray = function() {
        this.bytes.assertNext((0, $8zvel.default).LeftSquareBracket);
        this.skipWhitespaceAndComments();
        var pdfArray = (0, $8auL6.default).withContext(this.context);
        while(this.bytes.peek() !== (0, $8zvel.default).RightSquareBracket){
            var element = this.parseObject();
            pdfArray.push(element);
            this.skipWhitespaceAndComments();
        }
        this.bytes.assertNext((0, $8zvel.default).RightSquareBracket);
        return pdfArray;
    };
    PDFObjectParser.prototype.parseDict = function() {
        this.bytes.assertNext((0, $8zvel.default).LessThan);
        this.bytes.assertNext((0, $8zvel.default).LessThan);
        this.skipWhitespaceAndComments();
        var dict = new Map();
        while(!this.bytes.done() && this.bytes.peek() !== (0, $8zvel.default).GreaterThan && this.bytes.peekAhead(1) !== (0, $8zvel.default).GreaterThan){
            var key = this.parseName();
            var value = this.parseObject();
            dict.set(key, value);
            this.skipWhitespaceAndComments();
        }
        this.skipWhitespaceAndComments();
        this.bytes.assertNext((0, $8zvel.default).GreaterThan);
        this.bytes.assertNext((0, $8zvel.default).GreaterThan);
        var Type = dict.get((0, $dPHSK.default).of('Type'));
        if (Type === (0, $dPHSK.default).of('Catalog')) return (0, $80c05707f2c8c1f7$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
        else if (Type === (0, $dPHSK.default).of('Pages')) return (0, $333acd2e5fba0d32$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
        else if (Type === (0, $dPHSK.default).of('Page')) return (0, $a9e73b7ced5abfa4$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
        else return (0, $85408478fbb7cbde$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
    };
    PDFObjectParser.prototype.parseDictOrStream = function() {
        var startPos = this.bytes.position();
        var dict = this.parseDict();
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).streamEOF1) && !this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).streamEOF2) && !this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).streamEOF3) && !this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).streamEOF4) && !this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).stream)) return dict;
        var start = this.bytes.offset();
        var end;
        var Length = dict.get((0, $dPHSK.default).of('Length'));
        if (Length instanceof (0, $j04jt.default)) {
            end = start + Length.asNumber();
            this.bytes.moveTo(end);
            this.skipWhitespaceAndComments();
            if (!this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).endstream)) {
                this.bytes.moveTo(start);
                end = this.findEndOfStreamFallback(startPos);
            }
        } else end = this.findEndOfStreamFallback(startPos);
        var contents = this.bytes.slice(start, end);
        return (0, $ef28c75b0f11042e$export$2e2bcd8739ae039).of(dict, contents);
    };
    PDFObjectParser.prototype.findEndOfStreamFallback = function(startPos) {
        // Move to end of stream, while handling nested streams
        var nestingLvl = 1;
        var end = this.bytes.offset();
        while(!this.bytes.done()){
            end = this.bytes.offset();
            if (this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).stream)) nestingLvl += 1;
            else if (this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).EOF1endstream) || this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).EOF2endstream) || this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).EOF3endstream) || this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).endstream)) nestingLvl -= 1;
            else this.bytes.next();
            if (nestingLvl === 0) break;
        }
        if (nestingLvl !== 0) throw new (0, $nAWRe.PDFStreamParsingError)(startPos);
        return end;
    };
    PDFObjectParser.forBytes = function(bytes, context, capNumbers) {
        return new PDFObjectParser((0, $93214384d2c510d6$export$2e2bcd8739ae039).of(bytes), context, capNumbers);
    };
    PDFObjectParser.forByteStream = function(byteStream, context, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        return new PDFObjectParser(byteStream, context, capNumbers);
    };
    return PDFObjectParser;
}((0, $ccc28a798e23d674$export$2e2bcd8739ae039));
var $2ce01d1490df00cf$export$2e2bcd8739ae039 = $2ce01d1490df00cf$var$PDFObjectParser;



var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");



parcelRequire("fvYKZ");
var $ggjMi = parcelRequire("ggjMi");
var $016bbd830ce30da5$var$PDFObjectStreamParser = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFObjectStreamParser, _super);
    function PDFObjectStreamParser(rawStream, shouldWaitForTick) {
        var _this = _super.call(this, (0, $93214384d2c510d6$export$2e2bcd8739ae039).fromPDFRawStream(rawStream), rawStream.dict.context) || this;
        var dict = rawStream.dict;
        _this.alreadyParsed = false;
        _this.shouldWaitForTick = shouldWaitForTick || function() {
            return false;
        };
        _this.firstOffset = dict.lookup((0, $dPHSK.default).of('First'), (0, $j04jt.default)).asNumber();
        _this.objectCount = dict.lookup((0, $dPHSK.default).of('N'), (0, $j04jt.default)).asNumber();
        return _this;
    }
    PDFObjectStreamParser.prototype.parseIntoContext = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var offsetsAndObjectNumbers, idx, len, _a, objectNumber, offset, object, ref;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (this.alreadyParsed) throw new (0, $nAWRe.ReparseError)('PDFObjectStreamParser', 'parseIntoContext');
                        this.alreadyParsed = true;
                        offsetsAndObjectNumbers = this.parseOffsetsAndObjectNumbers();
                        idx = 0, len = offsetsAndObjectNumbers.length;
                        _b.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a = offsetsAndObjectNumbers[idx], objectNumber = _a.objectNumber, offset = _a.offset;
                        this.bytes.moveTo(this.firstOffset + offset);
                        object = this.parseObject();
                        ref = (0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(objectNumber, 0);
                        this.context.assign(ref, object);
                        if (!this.shouldWaitForTick()) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFObjectStreamParser.prototype.parseOffsetsAndObjectNumbers = function() {
        var offsetsAndObjectNumbers = [];
        for(var idx = 0, len = this.objectCount; idx < len; idx++){
            this.skipWhitespaceAndComments();
            var objectNumber = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var offset = this.parseRawInt();
            offsetsAndObjectNumbers.push({
                objectNumber: objectNumber,
                offset: offset
            });
        }
        return offsetsAndObjectNumbers;
    };
    PDFObjectStreamParser.forStream = function(rawStream, shouldWaitForTick) {
        return new PDFObjectStreamParser(rawStream, shouldWaitForTick);
    };
    return PDFObjectStreamParser;
}((0, $2ce01d1490df00cf$export$2e2bcd8739ae039));
var $016bbd830ce30da5$export$2e2bcd8739ae039 = $016bbd830ce30da5$var$PDFObjectStreamParser;



var $cOQTW = parcelRequire("cOQTW");




var $nAWRe = parcelRequire("nAWRe");



var $dPHSK = parcelRequire("dPHSK");






var $nAWRe = parcelRequire("nAWRe");

var $8auL6 = parcelRequire("8auL6");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");


var $805c54c8bff8c138$var$PDFXRefStreamParser = /** @class */ function() {
    function PDFXRefStreamParser(rawStream) {
        this.alreadyParsed = false;
        this.dict = rawStream.dict;
        this.bytes = (0, $93214384d2c510d6$export$2e2bcd8739ae039).fromPDFRawStream(rawStream);
        this.context = this.dict.context;
        var Size = this.dict.lookup((0, $dPHSK.default).of('Size'), (0, $j04jt.default));
        var Index = this.dict.lookup((0, $dPHSK.default).of('Index'));
        if (Index instanceof (0, $8auL6.default)) {
            this.subsections = [];
            for(var idx = 0, len = Index.size(); idx < len; idx += 2){
                var firstObjectNumber = Index.lookup(idx + 0, (0, $j04jt.default)).asNumber();
                var length_1 = Index.lookup(idx + 1, (0, $j04jt.default)).asNumber();
                this.subsections.push({
                    firstObjectNumber: firstObjectNumber,
                    length: length_1
                });
            }
        } else this.subsections = [
            {
                firstObjectNumber: 0,
                length: Size.asNumber()
            }
        ];
        var W = this.dict.lookup((0, $dPHSK.default).of('W'), (0, $8auL6.default));
        this.byteWidths = [
            -1,
            -1,
            -1
        ];
        for(var idx = 0, len = W.size(); idx < len; idx++)this.byteWidths[idx] = W.lookup(idx, (0, $j04jt.default)).asNumber();
    }
    PDFXRefStreamParser.prototype.parseIntoContext = function() {
        if (this.alreadyParsed) throw new (0, $nAWRe.ReparseError)('PDFXRefStreamParser', 'parseIntoContext');
        this.alreadyParsed = true;
        this.context.trailerInfo = {
            Root: this.dict.get((0, $dPHSK.default).of('Root')),
            Encrypt: this.dict.get((0, $dPHSK.default).of('Encrypt')),
            Info: this.dict.get((0, $dPHSK.default).of('Info')),
            ID: this.dict.get((0, $dPHSK.default).of('ID'))
        };
        var entries = this.parseEntries();
        // for (let idx = 0, len = entries.length; idx < len; idx++) {
        // const entry = entries[idx];
        // if (entry.deleted) this.context.delete(entry.ref);
        // }
        return entries;
    };
    PDFXRefStreamParser.prototype.parseEntries = function() {
        var entries = [];
        var _a = this.byteWidths, typeFieldWidth = _a[0], offsetFieldWidth = _a[1], genFieldWidth = _a[2];
        for(var subsectionIdx = 0, subsectionLen = this.subsections.length; subsectionIdx < subsectionLen; subsectionIdx++){
            var _b = this.subsections[subsectionIdx], firstObjectNumber = _b.firstObjectNumber, length_2 = _b.length;
            for(var objIdx = 0; objIdx < length_2; objIdx++){
                var type = 0;
                for(var idx = 0, len = typeFieldWidth; idx < len; idx++)type = type << 8 | this.bytes.next();
                var offset = 0;
                for(var idx = 0, len = offsetFieldWidth; idx < len; idx++)offset = offset << 8 | this.bytes.next();
                var generationNumber = 0;
                for(var idx = 0, len = genFieldWidth; idx < len; idx++)generationNumber = generationNumber << 8 | this.bytes.next();
                // When the `type` field is absent, it defaults to 1
                if (typeFieldWidth === 0) type = 1;
                var objectNumber = firstObjectNumber + objIdx;
                var entry = {
                    ref: (0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(objectNumber, generationNumber),
                    offset: offset,
                    deleted: type === 0,
                    inObjectStream: type === 2
                };
                entries.push(entry);
            }
        }
        return entries;
    };
    PDFXRefStreamParser.forStream = function(rawStream) {
        return new PDFXRefStreamParser(rawStream);
    };
    return PDFXRefStreamParser;
}();
var $805c54c8bff8c138$export$2e2bcd8739ae039 = $805c54c8bff8c138$var$PDFXRefStreamParser;




var $8zvel = parcelRequire("8zvel");


parcelRequire("fvYKZ");
var $ggjMi = parcelRequire("ggjMi");
var $0c78b71d995ee90b$var$PDFParser = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFParser, _super);
    function PDFParser(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers) {
        if (objectsPerTick === void 0) objectsPerTick = Infinity;
        if (throwOnInvalidObject === void 0) throwOnInvalidObject = false;
        if (capNumbers === void 0) capNumbers = false;
        var _this = _super.call(this, (0, $93214384d2c510d6$export$2e2bcd8739ae039).of(pdfBytes), (0, $ece91e5f61c516eb$export$2e2bcd8739ae039).create(), capNumbers) || this;
        _this.alreadyParsed = false;
        _this.parsedObjects = 0;
        _this.shouldWaitForTick = function() {
            _this.parsedObjects += 1;
            return _this.parsedObjects % _this.objectsPerTick === 0;
        };
        _this.objectsPerTick = objectsPerTick;
        _this.throwOnInvalidObject = throwOnInvalidObject;
        return _this;
    }
    PDFParser.prototype.parseDocument = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var prevOffset, offset;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.alreadyParsed) throw new (0, $nAWRe.ReparseError)('PDFParser', 'parseDocument');
                        this.alreadyParsed = true;
                        this.context.header = this.parseHeader();
                        _a.label = 1;
                    case 1:
                        if (!!this.bytes.done()) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.parseDocumentSection()
                        ];
                    case 2:
                        _a.sent();
                        offset = this.bytes.offset();
                        if (offset === prevOffset) throw new (0, $nAWRe.StalledParserError)(this.bytes.position());
                        prevOffset = offset;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 3:
                        this.maybeRecoverRoot();
                        if (this.context.lookup((0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(0))) {
                            console.warn('Removing parsed object: 0 0 R');
                            this.context.delete((0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(0));
                        }
                        return [
                            2 /*return*/ ,
                            this.context
                        ];
                }
            });
        });
    };
    PDFParser.prototype.maybeRecoverRoot = function() {
        var isValidCatalog = function(obj) {
            return obj instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039) && obj.lookup((0, $dPHSK.default).of('Type')) === (0, $dPHSK.default).of('Catalog');
        };
        var catalog = this.context.lookup(this.context.trailerInfo.Root);
        if (!isValidCatalog(catalog)) {
            var indirectObjects = this.context.enumerateIndirectObjects();
            for(var idx = 0, len = indirectObjects.length; idx < len; idx++){
                var _a = indirectObjects[idx], ref = _a[0], object = _a[1];
                if (isValidCatalog(object)) this.context.trailerInfo.Root = ref;
            }
        }
    };
    PDFParser.prototype.parseHeader = function() {
        while(!this.bytes.done()){
            if (this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).header)) {
                var major = this.parseRawInt();
                this.bytes.assertNext((0, $8zvel.default).Period);
                var minor = this.parseRawInt();
                var header = (0, $ab35d5c6c69177c9$export$2e2bcd8739ae039).forVersion(major, minor);
                this.skipBinaryHeaderComment();
                return header;
            }
            this.bytes.next();
        }
        throw new (0, $nAWRe.MissingPDFHeaderError)(this.bytes.position());
    };
    PDFParser.prototype.parseIndirectObjectHeader = function() {
        this.skipWhitespaceAndComments();
        var objectNumber = this.parseRawInt();
        this.skipWhitespaceAndComments();
        var generationNumber = this.parseRawInt();
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).obj)) throw new (0, $nAWRe.MissingKeywordError)(this.bytes.position(), (0, $f3568ef95260ec55$export$93ad50ccfacdd77).obj);
        return (0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(objectNumber, generationNumber);
    };
    PDFParser.prototype.matchIndirectObjectHeader = function() {
        var initialOffset = this.bytes.offset();
        try {
            this.parseIndirectObjectHeader();
            return true;
        } catch (e) {
            this.bytes.moveTo(initialOffset);
            return false;
        }
    };
    PDFParser.prototype.parseIndirectObject = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var ref, object;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ref = this.parseIndirectObjectHeader();
                        this.skipWhitespaceAndComments();
                        object = this.parseObject();
                        this.skipWhitespaceAndComments();
                        // if (!this.matchKeyword(Keywords.endobj)) {
                        // throw new MissingKeywordError(this.bytes.position(), Keywords.endobj);
                        // }
                        // TODO: Log a warning if this fails...
                        this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).endobj);
                        if (!(object instanceof (0, $ef28c75b0f11042e$export$2e2bcd8739ae039) && object.dict.lookup((0, $dPHSK.default).of('Type')) === (0, $dPHSK.default).of('ObjStm'))) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $016bbd830ce30da5$export$2e2bcd8739ae039).forStream(object, this.shouldWaitForTick).parseIntoContext()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        if (object instanceof (0, $ef28c75b0f11042e$export$2e2bcd8739ae039) && object.dict.lookup((0, $dPHSK.default).of('Type')) === (0, $dPHSK.default).of('XRef')) (0, $805c54c8bff8c138$export$2e2bcd8739ae039).forStream(object).parseIntoContext();
                        else this.context.assign(ref, object);
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ ,
                            ref
                        ];
                }
            });
        });
    };
    // TODO: Improve and clean this up
    PDFParser.prototype.tryToParseInvalidIndirectObject = function() {
        var startPos = this.bytes.position();
        var msg = "Trying to parse invalid object: " + JSON.stringify(startPos) + ")";
        if (this.throwOnInvalidObject) throw new Error(msg);
        console.warn(msg);
        var ref = this.parseIndirectObjectHeader();
        console.warn("Invalid object ref: " + ref);
        this.skipWhitespaceAndComments();
        var start = this.bytes.offset();
        var failed = true;
        while(!this.bytes.done()){
            if (this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).endobj)) failed = false;
            if (!failed) break;
            this.bytes.next();
        }
        if (failed) throw new (0, $nAWRe.PDFInvalidObjectParsingError)(startPos);
        var end = this.bytes.offset() - (0, $f3568ef95260ec55$export$93ad50ccfacdd77).endobj.length;
        var object = (0, $ad9390730b9495a5$export$2e2bcd8739ae039).of(this.bytes.slice(start, end));
        this.context.assign(ref, object);
        return ref;
    };
    PDFParser.prototype.parseIndirectObjects = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var initialOffset, e_1;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.skipWhitespaceAndComments();
                        _a.label = 1;
                    case 1:
                        if (!(!this.bytes.done() && (0, $5679a387c9e20301$export$9492c31549e88980)[this.bytes.peek()])) return [
                            3 /*break*/ ,
                            8
                        ];
                        initialOffset = this.bytes.offset();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.parseIndirectObject()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        e_1 = _a.sent();
                        // TODO: Add tracing/logging mechanism to track when this happens!
                        this.bytes.moveTo(initialOffset);
                        this.tryToParseInvalidIndirectObject();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        this.skipWhitespaceAndComments();
                        // TODO: Can this be done only when needed, to avoid harming performance?
                        this.skipJibberish();
                        if (!this.shouldWaitForTick()) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFParser.prototype.maybeParseCrossRefSection = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).xref)) return;
        this.skipWhitespaceAndComments();
        var objectNumber = -1;
        var xref = (0, $0acfb4f0f4898246$export$2e2bcd8739ae039).createEmpty();
        while(!this.bytes.done() && (0, $5679a387c9e20301$export$9492c31549e88980)[this.bytes.peek()]){
            var firstInt = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var secondInt = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var byte = this.bytes.peek();
            if (byte === (0, $8zvel.default).n || byte === (0, $8zvel.default).f) {
                var ref = (0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(objectNumber, secondInt);
                if (this.bytes.next() === (0, $8zvel.default).n) xref.addEntry(ref, firstInt);
                else // this.context.delete(ref);
                xref.addDeletedEntry(ref, firstInt);
                objectNumber += 1;
            } else objectNumber = firstInt;
            this.skipWhitespaceAndComments();
        }
        return xref;
    };
    PDFParser.prototype.maybeParseTrailerDict = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).trailer)) return;
        this.skipWhitespaceAndComments();
        var dict = this.parseDict();
        var context = this.context;
        context.trailerInfo = {
            Root: dict.get((0, $dPHSK.default).of('Root')) || context.trailerInfo.Root,
            Encrypt: dict.get((0, $dPHSK.default).of('Encrypt')) || context.trailerInfo.Encrypt,
            Info: dict.get((0, $dPHSK.default).of('Info')) || context.trailerInfo.Info,
            ID: dict.get((0, $dPHSK.default).of('ID')) || context.trailerInfo.ID
        };
    };
    PDFParser.prototype.maybeParseTrailer = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).startxref)) return;
        this.skipWhitespaceAndComments();
        var offset = this.parseRawInt();
        this.skipWhitespace();
        this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).eof);
        this.skipWhitespaceAndComments();
        this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).eof);
        this.skipWhitespaceAndComments();
        return (0, $38bebcf76e0d2d54$export$2e2bcd8739ae039).forLastCrossRefSectionOffset(offset);
    };
    PDFParser.prototype.parseDocumentSection = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.parseIndirectObjects()
                        ];
                    case 1:
                        _a.sent();
                        this.maybeParseCrossRefSection();
                        this.maybeParseTrailerDict();
                        this.maybeParseTrailer();
                        // TODO: Can this be done only when needed, to avoid harming performance?
                        this.skipJibberish();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * This operation is not necessary for valid PDF files. But some invalid PDFs
     * contain jibberish in between indirect objects. This method is designed to
     * skip past that jibberish, should it exist, until it reaches the next
     * indirect object header, an xref table section, or the file trailer.
     */ PDFParser.prototype.skipJibberish = function() {
        this.skipWhitespaceAndComments();
        while(!this.bytes.done()){
            var initialOffset = this.bytes.offset();
            var byte = this.bytes.peek();
            var isAlphaNumeric = byte >= (0, $8zvel.default).Space && byte <= (0, $8zvel.default).Tilde;
            if (isAlphaNumeric) {
                if (this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).xref) || this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).trailer) || this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).startxref) || this.matchIndirectObjectHeader()) {
                    this.bytes.moveTo(initialOffset);
                    break;
                }
            }
            this.bytes.next();
        }
    };
    /**
     * Skips the binary comment following a PDF header. The specification
     * defines this binary comment (section 7.5.2 File Header) as a sequence of 4
     * or more bytes that are 128 or greater, and which are preceded by a "%".
     *
     * This would imply that to strip out this binary comment, we could check for
     * a sequence of bytes starting with "%", and remove all subsequent bytes that
     * are 128 or greater. This works for many documents that properly comply with
     * the spec. But in the wild, there are PDFs that omit the leading "%", and
     * include bytes that are less than 128 (e.g. 0 or 1). So in order to parse
     * these headers correctly, we just throw out all bytes leading up to the
     * first indirect object header.
     */ PDFParser.prototype.skipBinaryHeaderComment = function() {
        this.skipWhitespaceAndComments();
        try {
            var initialOffset = this.bytes.offset();
            this.parseIndirectObjectHeader();
            this.bytes.moveTo(initialOffset);
        } catch (e) {
            this.bytes.next();
            this.skipWhitespaceAndComments();
        }
    };
    PDFParser.forBytesWithOptions = function(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers) {
        return new PDFParser(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers);
    };
    return PDFParser;
}((0, $2ce01d1490df00cf$export$2e2bcd8739ae039));
var $0c78b71d995ee90b$export$2e2bcd8739ae039 = $0c78b71d995ee90b$var$PDFParser;







var $8f93b7bf8ef0f00e$var$flag = function(bitIndex) {
    return 1 << bitIndex;
};
var $8f93b7bf8ef0f00e$export$1fa7b68b35026177;
(function(AnnotationFlags) {
    /**
     * If set, do not display the annotation if it does not belong to one of the
     * standard annotation types and no annotation handler is available. If clear,
     * display such an unknown annotation using an appearance stream specified by
     * its appearance dictionary, if any.
     */ AnnotationFlags[AnnotationFlags["Invisible"] = $8f93b7bf8ef0f00e$var$flag(0)] = "Invisible";
    /**
     * If set, do not display or print the annotation or allow it to interact with
     * the user, regardless of its annotation type or whether an annotation
     * handler is available.
     *
     * In cases where screen space is limited, the ability to hide and show
     * annotations selectively can be used in combination with appearance streams
     * to display auxiliary pop-up information similar in function to online help
     * systems.
     */ AnnotationFlags[AnnotationFlags["Hidden"] = $8f93b7bf8ef0f00e$var$flag(1)] = "Hidden";
    /**
     * If set, print the annotation when the page is printed. If clear, never
     * print the annotation, regardless of whether it is displayed on the screen.
     *
     * This can be useful for annotations representing interactive pushbuttons,
     * which would serve no meaningful purpose on the printed page.
     */ AnnotationFlags[AnnotationFlags["Print"] = $8f93b7bf8ef0f00e$var$flag(2)] = "Print";
    /**
     * If set, do not scale the annotation’s appearance to match the magnification
     * of the page. The location of the annotation on the page (defined by the
     * upper-left corner of its annotation rectangle) shall remain fixed,
     * regardless of the page magnification.
     */ AnnotationFlags[AnnotationFlags["NoZoom"] = $8f93b7bf8ef0f00e$var$flag(3)] = "NoZoom";
    /**
     * If set, do not rotate the annotation’s appearance to match the rotation of
     * the page. The upper-left corner of the annotation rectangle shall remain in
     * a fixed location on the page, regardless of the page rotation.
     */ AnnotationFlags[AnnotationFlags["NoRotate"] = $8f93b7bf8ef0f00e$var$flag(4)] = "NoRotate";
    /**
     * If set, do not display the annotation on the screen or allow it to interact
     * with the user. The annotation may be printed (depending on the setting of
     * the Print flag) but should be considered hidden for purposes of on-screen
     * display and user interaction.
     */ AnnotationFlags[AnnotationFlags["NoView"] = $8f93b7bf8ef0f00e$var$flag(5)] = "NoView";
    /**
     * If set, do not allow the annotation to interact with the user. The
     * annotation may be displayed or printed (depending on the settings of the
     * NoView and Print flags) but should not respond to mouse clicks or change
     * its appearance in response to mouse motions.
     *
     * This flag shall be ignored for widget annotations; its function is
     * subsumed by the ReadOnly flag of the associated form field.
     */ AnnotationFlags[AnnotationFlags["ReadOnly"] = $8f93b7bf8ef0f00e$var$flag(6)] = "ReadOnly";
    /**
     * If set, do not allow the annotation to be deleted or its properties
     * (including position and size) to be modified by the user. However, this
     * flag does not restrict changes to the annotation’s contents, such as the
     * value of a form field.
     */ AnnotationFlags[AnnotationFlags["Locked"] = $8f93b7bf8ef0f00e$var$flag(7)] = "Locked";
    /**
     * If set, invert the interpretation of the NoView flag for certain events.
     *
     * A typical use is to have an annotation that appears only when a mouse
     * cursor is held over it.
     */ AnnotationFlags[AnnotationFlags["ToggleNoView"] = $8f93b7bf8ef0f00e$var$flag(8)] = "ToggleNoView";
    /**
     * If set, do not allow the contents of the annotation to be modified by the
     * user. This flag does not restrict deletion of the annotation or changes to
     * other annotation properties, such as position and size.
     */ AnnotationFlags[AnnotationFlags["LockedContents"] = $8f93b7bf8ef0f00e$var$flag(9)] = "LockedContents";
})($8f93b7bf8ef0f00e$export$1fa7b68b35026177 || ($8f93b7bf8ef0f00e$export$1fa7b68b35026177 = {}));







var $dPHSK = parcelRequire("dPHSK");
var $j04jt = parcelRequire("j04jt");
var $a25479a44f824b27$export$69d5e1b305482e08 = function(name) {
    return name instanceof (0, $dPHSK.default) ? name : (0, $dPHSK.default).of(name);
};
var $a25479a44f824b27$export$fb5b5e76a3a5c568 = function(num) {
    return num instanceof (0, $j04jt.default) ? num : (0, $j04jt.default).of(num);
};
var $a25479a44f824b27$export$37576b9ba69b50db = function(num) {
    return num instanceof (0, $j04jt.default) ? num.asNumber() : num;
};


parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var $hP0hy = parcelRequire("hP0hy");
var $3b4f8728c2695c8d$export$c3cc0f63dbb3500f;
(function(RotationTypes) {
    RotationTypes["Degrees"] = "degrees";
    RotationTypes["Radians"] = "radians";
})($3b4f8728c2695c8d$export$c3cc0f63dbb3500f || ($3b4f8728c2695c8d$export$c3cc0f63dbb3500f = {}));
var $3b4f8728c2695c8d$export$8449e153fbd325fc = function(radianAngle) {
    (0, $j0tvB.assertIs)(radianAngle, 'radianAngle', [
        'number'
    ]);
    return {
        type: $3b4f8728c2695c8d$export$c3cc0f63dbb3500f.Radians,
        angle: radianAngle
    };
};
var $3b4f8728c2695c8d$export$41fc368e1a942b97 = function(degreeAngle) {
    (0, $j0tvB.assertIs)(degreeAngle, 'degreeAngle', [
        'number'
    ]);
    return {
        type: $3b4f8728c2695c8d$export$c3cc0f63dbb3500f.Degrees,
        angle: degreeAngle
    };
};
var $3b4f8728c2695c8d$var$Radians = $3b4f8728c2695c8d$export$c3cc0f63dbb3500f.Radians, $3b4f8728c2695c8d$var$Degrees = $3b4f8728c2695c8d$export$c3cc0f63dbb3500f.Degrees;
var $3b4f8728c2695c8d$export$c9fcf1a7df975d78 = function(degree) {
    return degree * Math.PI / 180;
};
var $3b4f8728c2695c8d$export$c41dd2a8460d3196 = function(radian) {
    return radian * 180 / Math.PI;
};
var $3b4f8728c2695c8d$export$cba01ba138429a1d = function(rotation) {
    return rotation.type === $3b4f8728c2695c8d$var$Radians ? rotation.angle : rotation.type === $3b4f8728c2695c8d$var$Degrees ? $3b4f8728c2695c8d$export$c9fcf1a7df975d78(rotation.angle) : (0, $hP0hy.error)("Invalid rotation: " + JSON.stringify(rotation));
};
var $3b4f8728c2695c8d$export$56cb859c01fa134d = function(rotation) {
    return rotation.type === $3b4f8728c2695c8d$var$Radians ? $3b4f8728c2695c8d$export$c41dd2a8460d3196(rotation.angle) : rotation.type === $3b4f8728c2695c8d$var$Degrees ? rotation.angle : (0, $hP0hy.error)("Invalid rotation: " + JSON.stringify(rotation));
};
var $3b4f8728c2695c8d$export$ee0ed07fe78ec05 = function(degreeAngle) {
    if (degreeAngle === void 0) degreeAngle = 0;
    var quadrants = degreeAngle / 90 % 4;
    if (quadrants === 0) return 0;
    if (quadrants === 1) return 90;
    if (quadrants === 2) return 180;
    if (quadrants === 3) return 270;
    return 0; // `degreeAngle` is not a multiple of 90
};
var $3b4f8728c2695c8d$export$312e44550db33c6a = function(dims, degreeAngle) {
    if (degreeAngle === void 0) degreeAngle = 0;
    var rotation = $3b4f8728c2695c8d$export$ee0ed07fe78ec05(degreeAngle);
    return rotation === 90 || rotation === 270 ? {
        width: dims.height,
        height: dims.width
    } : {
        width: dims.width,
        height: dims.height
    };
};
var $3b4f8728c2695c8d$export$afddc3b8600307a4 = function(rectangle, borderWidth, degreeAngle) {
    if (borderWidth === void 0) borderWidth = 0;
    if (degreeAngle === void 0) degreeAngle = 0;
    var x = rectangle.x, y = rectangle.y, w = rectangle.width, h = rectangle.height;
    var r = $3b4f8728c2695c8d$export$ee0ed07fe78ec05(degreeAngle);
    var b = borderWidth / 2;
    // prettier-ignore
    if (r === 0) return {
        x: x - b,
        y: y - b,
        width: w,
        height: h
    };
    else if (r === 90) return {
        x: x - h + b,
        y: y - b,
        width: h,
        height: w
    };
    else if (r === 180) return {
        x: x - w + b,
        y: y - h + b,
        width: w,
        height: h
    };
    else if (r === 270) return {
        x: x - b,
        y: y - w + b,
        width: h,
        height: w
    };
    else return {
        x: x - b,
        y: y - b,
        width: w,
        height: h
    };
};



var $cfb765e9daff3c3a$export$e0b576e7a74416cd = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).ClipNonZero);
};
var $cfb765e9daff3c3a$export$dd6fb25f201b5a7a = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).ClipEvenOdd);
};
/* ==================== Graphics State Operators ==================== */ var $cfb765e9daff3c3a$var$cos = Math.cos, $cfb765e9daff3c3a$var$sin = Math.sin, $cfb765e9daff3c3a$var$tan = Math.tan;
var $cfb765e9daff3c3a$export$ed5b99ee38154497 = function(a, b, c, d, e, f) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).ConcatTransformationMatrix, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(a),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(b),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(c),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(d),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(e),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(f)
    ]);
};
var $cfb765e9daff3c3a$export$d73ee8ef04f5226a = function(xPos, yPos) {
    return $cfb765e9daff3c3a$export$ed5b99ee38154497(1, 0, 0, 1, xPos, yPos);
};
var $cfb765e9daff3c3a$export$dcdf75081b88279d = function(xPos, yPos) {
    return $cfb765e9daff3c3a$export$ed5b99ee38154497(xPos, 0, 0, yPos, 0, 0);
};
var $cfb765e9daff3c3a$export$a2ba89726971a90f = function(angle) {
    return $cfb765e9daff3c3a$export$ed5b99ee38154497($cfb765e9daff3c3a$var$cos((0, $a25479a44f824b27$export$37576b9ba69b50db)(angle)), $cfb765e9daff3c3a$var$sin((0, $a25479a44f824b27$export$37576b9ba69b50db)(angle)), -$cfb765e9daff3c3a$var$sin((0, $a25479a44f824b27$export$37576b9ba69b50db)(angle)), $cfb765e9daff3c3a$var$cos((0, $a25479a44f824b27$export$37576b9ba69b50db)(angle)), 0, 0);
};
var $cfb765e9daff3c3a$export$91df22fbff99d059 = function(angle) {
    return $cfb765e9daff3c3a$export$a2ba89726971a90f((0, $3b4f8728c2695c8d$export$c9fcf1a7df975d78)((0, $a25479a44f824b27$export$37576b9ba69b50db)(angle)));
};
var $cfb765e9daff3c3a$export$985cb1d69d6a3add = function(xSkewAngle, ySkewAngle) {
    return $cfb765e9daff3c3a$export$ed5b99ee38154497(1, $cfb765e9daff3c3a$var$tan((0, $a25479a44f824b27$export$37576b9ba69b50db)(xSkewAngle)), $cfb765e9daff3c3a$var$tan((0, $a25479a44f824b27$export$37576b9ba69b50db)(ySkewAngle)), 1, 0, 0);
};
var $cfb765e9daff3c3a$export$8ecb831b3efbb169 = function(xSkewAngle, ySkewAngle) {
    return $cfb765e9daff3c3a$export$985cb1d69d6a3add((0, $3b4f8728c2695c8d$export$c9fcf1a7df975d78)((0, $a25479a44f824b27$export$37576b9ba69b50db)(xSkewAngle)), (0, $3b4f8728c2695c8d$export$c9fcf1a7df975d78)((0, $a25479a44f824b27$export$37576b9ba69b50db)(ySkewAngle)));
};
var $cfb765e9daff3c3a$export$e0e900d241274e06 = function(dashArray, dashPhase) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetLineDashPattern, [
        "[" + dashArray.map((0, $a25479a44f824b27$export$fb5b5e76a3a5c568)).join(' ') + "]",
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(dashPhase)
    ]);
};
var $cfb765e9daff3c3a$export$d10d019aadfd45c7 = function() {
    return $cfb765e9daff3c3a$export$e0e900d241274e06([], 0);
};
var $cfb765e9daff3c3a$export$7a77bc708e50709e;
(function(LineCapStyle) {
    LineCapStyle[LineCapStyle["Butt"] = 0] = "Butt";
    LineCapStyle[LineCapStyle["Round"] = 1] = "Round";
    LineCapStyle[LineCapStyle["Projecting"] = 2] = "Projecting";
})($cfb765e9daff3c3a$export$7a77bc708e50709e || ($cfb765e9daff3c3a$export$7a77bc708e50709e = {}));
var $cfb765e9daff3c3a$export$6c65ed24e870eec = function(style) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetLineCapStyle, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(style)
    ]);
};
var $cfb765e9daff3c3a$export$cba5d0f1cde60b86;
(function(LineJoinStyle) {
    LineJoinStyle[LineJoinStyle["Miter"] = 0] = "Miter";
    LineJoinStyle[LineJoinStyle["Round"] = 1] = "Round";
    LineJoinStyle[LineJoinStyle["Bevel"] = 2] = "Bevel";
})($cfb765e9daff3c3a$export$cba5d0f1cde60b86 || ($cfb765e9daff3c3a$export$cba5d0f1cde60b86 = {}));
var $cfb765e9daff3c3a$export$97dfb3b4509cd5bc = function(style) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetLineJoinStyle, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(style)
    ]);
};
var $cfb765e9daff3c3a$export$568567f665d3f3bb = function(state) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetGraphicsStateParams, [
        (0, $a25479a44f824b27$export$69d5e1b305482e08)(state)
    ]);
};
var $cfb765e9daff3c3a$export$cb182c48e35739ac = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).PushGraphicsState);
};
var $cfb765e9daff3c3a$export$10581a6f45bf75eb = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).PopGraphicsState);
};
var $cfb765e9daff3c3a$export$558e0f90d8262345 = function(width) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetLineWidth, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(width)
    ]);
};
var $cfb765e9daff3c3a$export$45bd49bb15a3c5cb = function(x1, y1, x2, y2, x3, y3) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).AppendBezierCurve, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(x1),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(y1),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(x2),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(y2),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(x3),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(y3)
    ]);
};
var $cfb765e9daff3c3a$export$6f4913b22432f892 = function(x1, y1, x2, y2) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).CurveToReplicateInitialPoint, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(x1),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(y1),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(x2),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(y2)
    ]);
};
var $cfb765e9daff3c3a$export$21f87e210c424cd0 = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).ClosePath);
};
var $cfb765e9daff3c3a$export$75f1ccd6dc32e80a = function(xPos, yPos) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).MoveTo, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(xPos),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(yPos)
    ]);
};
var $cfb765e9daff3c3a$export$73abee0cf983cb99 = function(xPos, yPos) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).LineTo, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(xPos),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(yPos)
    ]);
};
var $cfb765e9daff3c3a$export$405b065079b7caf2 = function(xPos, yPos, width, height) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).AppendRectangle, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(xPos),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(yPos),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(width),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(height)
    ]);
};
var $cfb765e9daff3c3a$export$dd4f28cef696bc7d = function(xPos, yPos, size) {
    return $cfb765e9daff3c3a$export$405b065079b7caf2(xPos, yPos, size, size);
};
var $cfb765e9daff3c3a$export$d9b706f8d0a70aef = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).StrokePath);
};
var $cfb765e9daff3c3a$export$9563e054e6f787fb = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).FillNonZero);
};
var $cfb765e9daff3c3a$export$76d37801baac10fb = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).FillNonZeroAndStroke);
};
var $cfb765e9daff3c3a$export$d366e9c0a9bd860f = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).EndPath);
};
var $cfb765e9daff3c3a$export$829ffc2dbe358942 = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).NextLine);
};
var $cfb765e9daff3c3a$export$b84c1833e225e397 = function(x, y) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).MoveText, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(x),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(y)
    ]);
};
var $cfb765e9daff3c3a$export$778bfc3c1a2b7ba4 = function(text) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).ShowText, [
        text
    ]);
};
var $cfb765e9daff3c3a$export$337b8dbf65fbb95e = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).BeginText);
};
var $cfb765e9daff3c3a$export$e3caa83a99d72806 = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).EndText);
};
var $cfb765e9daff3c3a$export$df01d619ff6ce7f7 = function(name, size) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetFontAndSize, [
        (0, $a25479a44f824b27$export$69d5e1b305482e08)(name),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(size)
    ]);
};
var $cfb765e9daff3c3a$export$710392ce2617f080 = function(spacing) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetCharacterSpacing, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(spacing)
    ]);
};
var $cfb765e9daff3c3a$export$a2801242b2f8967d = function(spacing) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetWordSpacing, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(spacing)
    ]);
};
var $cfb765e9daff3c3a$export$20dbb065c447b4da = function(squeeze) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetTextHorizontalScaling, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(squeeze)
    ]);
};
var $cfb765e9daff3c3a$export$79399e66b6bb212c = function(lineHeight) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetTextLineHeight, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(lineHeight)
    ]);
};
var $cfb765e9daff3c3a$export$ad1653459b07f70c = function(rise) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetTextRise, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(rise)
    ]);
};
var $cfb765e9daff3c3a$export$ca45e4ab114d4814;
(function(TextRenderingMode) {
    TextRenderingMode[TextRenderingMode["Fill"] = 0] = "Fill";
    TextRenderingMode[TextRenderingMode["Outline"] = 1] = "Outline";
    TextRenderingMode[TextRenderingMode["FillAndOutline"] = 2] = "FillAndOutline";
    TextRenderingMode[TextRenderingMode["Invisible"] = 3] = "Invisible";
    TextRenderingMode[TextRenderingMode["FillAndClip"] = 4] = "FillAndClip";
    TextRenderingMode[TextRenderingMode["OutlineAndClip"] = 5] = "OutlineAndClip";
    TextRenderingMode[TextRenderingMode["FillAndOutlineAndClip"] = 6] = "FillAndOutlineAndClip";
    TextRenderingMode[TextRenderingMode["Clip"] = 7] = "Clip";
})($cfb765e9daff3c3a$export$ca45e4ab114d4814 || ($cfb765e9daff3c3a$export$ca45e4ab114d4814 = {}));
var $cfb765e9daff3c3a$export$99f0dc2c4cb099ab = function(mode) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetTextRenderingMode, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(mode)
    ]);
};
var $cfb765e9daff3c3a$export$d3656d656af31043 = function(a, b, c, d, e, f) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetTextMatrix, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(a),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(b),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(c),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(d),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(e),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(f)
    ]);
};
var $cfb765e9daff3c3a$export$f567083ac6aa5aa3 = function(rotationAngle, xSkewAngle, ySkewAngle, x, y) {
    return $cfb765e9daff3c3a$export$d3656d656af31043($cfb765e9daff3c3a$var$cos((0, $a25479a44f824b27$export$37576b9ba69b50db)(rotationAngle)), $cfb765e9daff3c3a$var$sin((0, $a25479a44f824b27$export$37576b9ba69b50db)(rotationAngle)) + $cfb765e9daff3c3a$var$tan((0, $a25479a44f824b27$export$37576b9ba69b50db)(xSkewAngle)), -$cfb765e9daff3c3a$var$sin((0, $a25479a44f824b27$export$37576b9ba69b50db)(rotationAngle)) + $cfb765e9daff3c3a$var$tan((0, $a25479a44f824b27$export$37576b9ba69b50db)(ySkewAngle)), $cfb765e9daff3c3a$var$cos((0, $a25479a44f824b27$export$37576b9ba69b50db)(rotationAngle)), x, y);
};
var $cfb765e9daff3c3a$export$909384d9b9d39aff = function(rotationAngle, xSkewAngle, ySkewAngle, x, y) {
    return $cfb765e9daff3c3a$export$f567083ac6aa5aa3((0, $3b4f8728c2695c8d$export$c9fcf1a7df975d78)((0, $a25479a44f824b27$export$37576b9ba69b50db)(rotationAngle)), (0, $3b4f8728c2695c8d$export$c9fcf1a7df975d78)((0, $a25479a44f824b27$export$37576b9ba69b50db)(xSkewAngle)), (0, $3b4f8728c2695c8d$export$c9fcf1a7df975d78)((0, $a25479a44f824b27$export$37576b9ba69b50db)(ySkewAngle)), x, y);
};
var $cfb765e9daff3c3a$export$382c18f8bccd9e2b = function(name) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).DrawObject, [
        (0, $a25479a44f824b27$export$69d5e1b305482e08)(name)
    ]);
};
var $cfb765e9daff3c3a$export$f30201749d00f572 = function(gray) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).NonStrokingColorGray, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(gray)
    ]);
};
var $cfb765e9daff3c3a$export$6502921112196b8f = function(gray) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).StrokingColorGray, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(gray)
    ]);
};
var $cfb765e9daff3c3a$export$f59cae633978eea7 = function(red, green, blue) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).NonStrokingColorRgb, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(red),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(green),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(blue)
    ]);
};
var $cfb765e9daff3c3a$export$e743468c48a4fd5a = function(red, green, blue) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).StrokingColorRgb, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(red),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(green),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(blue)
    ]);
};
var $cfb765e9daff3c3a$export$e836aceb3db98cc0 = function(cyan, magenta, yellow, key) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).NonStrokingColorCmyk, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(cyan),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(magenta),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(yellow),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(key)
    ]);
};
var $cfb765e9daff3c3a$export$4004b818fda831c1 = function(cyan, magenta, yellow, key) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).StrokingColorCmyk, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(cyan),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(magenta),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(yellow),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(key)
    ]);
};
var $cfb765e9daff3c3a$export$a028b403e40f1ab2 = function(tag) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).BeginMarkedContent, [
        (0, $a25479a44f824b27$export$69d5e1b305482e08)(tag)
    ]);
};
var $cfb765e9daff3c3a$export$935e2334f5a50589 = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).EndMarkedContent);
};


parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var $hP0hy = parcelRequire("hP0hy");
var $030fa0a2c4d1456e$export$4eb09b1c0a6dec24;
(function(ColorTypes) {
    ColorTypes["Grayscale"] = "Grayscale";
    ColorTypes["RGB"] = "RGB";
    ColorTypes["CMYK"] = "CMYK";
})($030fa0a2c4d1456e$export$4eb09b1c0a6dec24 || ($030fa0a2c4d1456e$export$4eb09b1c0a6dec24 = {}));
var $030fa0a2c4d1456e$export$6f416a6db2dfcd5c = function(gray) {
    (0, $j0tvB.assertRange)(gray, 'gray', 0.0, 1.0);
    return {
        type: $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.Grayscale,
        gray: gray
    };
};
var $030fa0a2c4d1456e$export$8972dc0e6ad9238f = function(red, green, blue) {
    (0, $j0tvB.assertRange)(red, 'red', 0, 1);
    (0, $j0tvB.assertRange)(green, 'green', 0, 1);
    (0, $j0tvB.assertRange)(blue, 'blue', 0, 1);
    return {
        type: $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.RGB,
        red: red,
        green: green,
        blue: blue
    };
};
var $030fa0a2c4d1456e$export$358b1a66a3c77756 = function(cyan, magenta, yellow, key) {
    (0, $j0tvB.assertRange)(cyan, 'cyan', 0, 1);
    (0, $j0tvB.assertRange)(magenta, 'magenta', 0, 1);
    (0, $j0tvB.assertRange)(yellow, 'yellow', 0, 1);
    (0, $j0tvB.assertRange)(key, 'key', 0, 1);
    return {
        type: $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.CMYK,
        cyan: cyan,
        magenta: magenta,
        yellow: yellow,
        key: key
    };
};
var $030fa0a2c4d1456e$var$Grayscale = $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.Grayscale, $030fa0a2c4d1456e$var$RGB = $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.RGB, $030fa0a2c4d1456e$var$CMYK = $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.CMYK;
var $030fa0a2c4d1456e$export$6126e5d7ba707741 = function(color) {
    return color.type === $030fa0a2c4d1456e$var$Grayscale ? (0, $cfb765e9daff3c3a$export$f30201749d00f572)(color.gray) : color.type === $030fa0a2c4d1456e$var$RGB ? (0, $cfb765e9daff3c3a$export$f59cae633978eea7)(color.red, color.green, color.blue) : color.type === $030fa0a2c4d1456e$var$CMYK ? (0, $cfb765e9daff3c3a$export$e836aceb3db98cc0)(color.cyan, color.magenta, color.yellow, color.key) : (0, $hP0hy.error)("Invalid color: " + JSON.stringify(color));
};
var $030fa0a2c4d1456e$export$ae31e5cacc8bb23d = function(color) {
    return color.type === $030fa0a2c4d1456e$var$Grayscale ? (0, $cfb765e9daff3c3a$export$6502921112196b8f)(color.gray) : color.type === $030fa0a2c4d1456e$var$RGB ? (0, $cfb765e9daff3c3a$export$e743468c48a4fd5a)(color.red, color.green, color.blue) : color.type === $030fa0a2c4d1456e$var$CMYK ? (0, $cfb765e9daff3c3a$export$4004b818fda831c1)(color.cyan, color.magenta, color.yellow, color.key) : (0, $hP0hy.error)("Invalid color: " + JSON.stringify(color));
};
var $030fa0a2c4d1456e$export$8750a268217b0987 = function(comps, scale) {
    if (scale === void 0) scale = 1;
    return (comps === null || comps === void 0 ? void 0 : comps.length) === 1 ? $030fa0a2c4d1456e$export$6f416a6db2dfcd5c(comps[0] * scale) : (comps === null || comps === void 0 ? void 0 : comps.length) === 3 ? $030fa0a2c4d1456e$export$8972dc0e6ad9238f(comps[0] * scale, comps[1] * scale, comps[2] * scale) : (comps === null || comps === void 0 ? void 0 : comps.length) === 4 ? $030fa0a2c4d1456e$export$358b1a66a3c77756(comps[0] * scale, comps[1] * scale, comps[2] * scale, comps[3] * scale) : undefined;
};
var $030fa0a2c4d1456e$export$ffee2793812e3e56 = function(color) {
    return color.type === $030fa0a2c4d1456e$var$Grayscale ? [
        color.gray
    ] : color.type === $030fa0a2c4d1456e$var$RGB ? [
        color.red,
        color.green,
        color.blue
    ] : color.type === $030fa0a2c4d1456e$var$CMYK ? [
        color.cyan,
        color.magenta,
        color.yellow,
        color.key
    ] : (0, $hP0hy.error)("Invalid color: " + JSON.stringify(color));
};




// Originated from pdfkit Copyright (c) 2014 Devon Govett
// https://github.com/foliojs/pdfkit/blob/1e62e6ffe24b378eb890df507a47610f4c4a7b24/lib/path.js
// MIT LICENSE
// Updated for pdf-lib & TypeScript by Jeremy Messenger

var $d3cf96a299d38647$var$cx = 0;
var $d3cf96a299d38647$var$cy = 0;
var $d3cf96a299d38647$var$px = 0;
var $d3cf96a299d38647$var$py = 0;
var $d3cf96a299d38647$var$sx = 0;
var $d3cf96a299d38647$var$sy = 0;
var $d3cf96a299d38647$var$parameters = new Map([
    [
        'A',
        7
    ],
    [
        'a',
        7
    ],
    [
        'C',
        6
    ],
    [
        'c',
        6
    ],
    [
        'H',
        1
    ],
    [
        'h',
        1
    ],
    [
        'L',
        2
    ],
    [
        'l',
        2
    ],
    [
        'M',
        2
    ],
    [
        'm',
        2
    ],
    [
        'Q',
        4
    ],
    [
        'q',
        4
    ],
    [
        'S',
        4
    ],
    [
        's',
        4
    ],
    [
        'T',
        2
    ],
    [
        't',
        2
    ],
    [
        'V',
        1
    ],
    [
        'v',
        1
    ],
    [
        'Z',
        0
    ],
    [
        'z',
        0
    ]
]);
var $d3cf96a299d38647$var$parse = function(path) {
    var cmd;
    var ret = [];
    var args = [];
    var curArg = '';
    var foundDecimal = false;
    var params = 0;
    for(var _i = 0, path_1 = path; _i < path_1.length; _i++){
        var c = path_1[_i];
        if ($d3cf96a299d38647$var$parameters.has(c)) {
            params = $d3cf96a299d38647$var$parameters.get(c);
            if (cmd) {
                // save existing command
                if (curArg.length > 0) args[args.length] = +curArg;
                ret[ret.length] = {
                    cmd: cmd,
                    args: args
                };
                args = [];
                curArg = '';
                foundDecimal = false;
            }
            cmd = c;
        } else if ([
            ' ',
            ','
        ].includes(c) || c === '-' && curArg.length > 0 && curArg[curArg.length - 1] !== 'e' || c === '.' && foundDecimal) {
            if (curArg.length === 0) continue;
            if (args.length === params) {
                // handle reused commands
                ret[ret.length] = {
                    cmd: cmd,
                    args: args
                };
                args = [
                    +curArg
                ];
                // handle assumed commands
                if (cmd === 'M') cmd = 'L';
                if (cmd === 'm') cmd = 'l';
            } else args[args.length] = +curArg;
            foundDecimal = c === '.';
            // fix for negative numbers or repeated decimals with no delimeter between commands
            curArg = [
                '-',
                '.'
            ].includes(c) ? c : '';
        } else {
            curArg += c;
            if (c === '.') foundDecimal = true;
        }
    }
    // add the last command
    if (curArg.length > 0) {
        if (args.length === params) {
            // handle reused commands
            ret[ret.length] = {
                cmd: cmd,
                args: args
            };
            args = [
                +curArg
            ];
            // handle assumed commands
            if (cmd === 'M') cmd = 'L';
            if (cmd === 'm') cmd = 'l';
        } else args[args.length] = +curArg;
    }
    ret[ret.length] = {
        cmd: cmd,
        args: args
    };
    return ret;
};
var $d3cf96a299d38647$var$apply = function(commands) {
    // current point, control point, and subpath starting point
    $d3cf96a299d38647$var$cx = $d3cf96a299d38647$var$cy = $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$sx = $d3cf96a299d38647$var$sy = 0;
    // run the commands
    var cmds = [];
    for(var i = 0; i < commands.length; i++){
        var c = commands[i];
        if (c.cmd && typeof $d3cf96a299d38647$var$runners[c.cmd] === 'function') {
            var cmd = $d3cf96a299d38647$var$runners[c.cmd](c.args);
            if (Array.isArray(cmd)) cmds = cmds.concat(cmd);
            else cmds.push(cmd);
        }
    }
    return cmds;
};
var $d3cf96a299d38647$var$runners = {
    M: function(a) {
        $d3cf96a299d38647$var$cx = a[0];
        $d3cf96a299d38647$var$cy = a[1];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        $d3cf96a299d38647$var$sx = $d3cf96a299d38647$var$cx;
        $d3cf96a299d38647$var$sy = $d3cf96a299d38647$var$cy;
        return (0, $cfb765e9daff3c3a$export$75f1ccd6dc32e80a)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    m: function(a) {
        $d3cf96a299d38647$var$cx += a[0];
        $d3cf96a299d38647$var$cy += a[1];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        $d3cf96a299d38647$var$sx = $d3cf96a299d38647$var$cx;
        $d3cf96a299d38647$var$sy = $d3cf96a299d38647$var$cy;
        return (0, $cfb765e9daff3c3a$export$75f1ccd6dc32e80a)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    C: function(a) {
        $d3cf96a299d38647$var$cx = a[4];
        $d3cf96a299d38647$var$cy = a[5];
        $d3cf96a299d38647$var$px = a[2];
        $d3cf96a299d38647$var$py = a[3];
        return (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)(a[0], a[1], a[2], a[3], a[4], a[5]);
    },
    c: function(a) {
        var cmd = (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)(a[0] + $d3cf96a299d38647$var$cx, a[1] + $d3cf96a299d38647$var$cy, a[2] + $d3cf96a299d38647$var$cx, a[3] + $d3cf96a299d38647$var$cy, a[4] + $d3cf96a299d38647$var$cx, a[5] + $d3cf96a299d38647$var$cy);
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx + a[2];
        $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy + a[3];
        $d3cf96a299d38647$var$cx += a[4];
        $d3cf96a299d38647$var$cy += a[5];
        return cmd;
    },
    S: function(a) {
        if ($d3cf96a299d38647$var$px === null || $d3cf96a299d38647$var$py === null) {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx;
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy;
        }
        var cmd = (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)($d3cf96a299d38647$var$cx - ($d3cf96a299d38647$var$px - $d3cf96a299d38647$var$cx), $d3cf96a299d38647$var$cy - ($d3cf96a299d38647$var$py - $d3cf96a299d38647$var$cy), a[0], a[1], a[2], a[3]);
        $d3cf96a299d38647$var$px = a[0];
        $d3cf96a299d38647$var$py = a[1];
        $d3cf96a299d38647$var$cx = a[2];
        $d3cf96a299d38647$var$cy = a[3];
        return cmd;
    },
    s: function(a) {
        if ($d3cf96a299d38647$var$px === null || $d3cf96a299d38647$var$py === null) {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx;
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy;
        }
        var cmd = (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)($d3cf96a299d38647$var$cx - ($d3cf96a299d38647$var$px - $d3cf96a299d38647$var$cx), $d3cf96a299d38647$var$cy - ($d3cf96a299d38647$var$py - $d3cf96a299d38647$var$cy), $d3cf96a299d38647$var$cx + a[0], $d3cf96a299d38647$var$cy + a[1], $d3cf96a299d38647$var$cx + a[2], $d3cf96a299d38647$var$cy + a[3]);
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx + a[0];
        $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy + a[1];
        $d3cf96a299d38647$var$cx += a[2];
        $d3cf96a299d38647$var$cy += a[3];
        return cmd;
    },
    Q: function(a) {
        $d3cf96a299d38647$var$px = a[0];
        $d3cf96a299d38647$var$py = a[1];
        $d3cf96a299d38647$var$cx = a[2];
        $d3cf96a299d38647$var$cy = a[3];
        return (0, $cfb765e9daff3c3a$export$6f4913b22432f892)(a[0], a[1], $d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    q: function(a) {
        var cmd = (0, $cfb765e9daff3c3a$export$6f4913b22432f892)(a[0] + $d3cf96a299d38647$var$cx, a[1] + $d3cf96a299d38647$var$cy, a[2] + $d3cf96a299d38647$var$cx, a[3] + $d3cf96a299d38647$var$cy);
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx + a[0];
        $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy + a[1];
        $d3cf96a299d38647$var$cx += a[2];
        $d3cf96a299d38647$var$cy += a[3];
        return cmd;
    },
    T: function(a) {
        if ($d3cf96a299d38647$var$px === null || $d3cf96a299d38647$var$py === null) {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx;
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy;
        } else {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx - ($d3cf96a299d38647$var$px - $d3cf96a299d38647$var$cx);
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy - ($d3cf96a299d38647$var$py - $d3cf96a299d38647$var$cy);
        }
        var cmd = (0, $cfb765e9daff3c3a$export$6f4913b22432f892)($d3cf96a299d38647$var$px, $d3cf96a299d38647$var$py, a[0], a[1]);
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx - ($d3cf96a299d38647$var$px - $d3cf96a299d38647$var$cx);
        $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy - ($d3cf96a299d38647$var$py - $d3cf96a299d38647$var$cy);
        $d3cf96a299d38647$var$cx = a[0];
        $d3cf96a299d38647$var$cy = a[1];
        return cmd;
    },
    t: function(a) {
        if ($d3cf96a299d38647$var$px === null || $d3cf96a299d38647$var$py === null) {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx;
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy;
        } else {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx - ($d3cf96a299d38647$var$px - $d3cf96a299d38647$var$cx);
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy - ($d3cf96a299d38647$var$py - $d3cf96a299d38647$var$cy);
        }
        var cmd = (0, $cfb765e9daff3c3a$export$6f4913b22432f892)($d3cf96a299d38647$var$px, $d3cf96a299d38647$var$py, $d3cf96a299d38647$var$cx + a[0], $d3cf96a299d38647$var$cy + a[1]);
        $d3cf96a299d38647$var$cx += a[0];
        $d3cf96a299d38647$var$cy += a[1];
        return cmd;
    },
    A: function(a) {
        var cmds = $d3cf96a299d38647$var$solveArc($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy, a);
        $d3cf96a299d38647$var$cx = a[5];
        $d3cf96a299d38647$var$cy = a[6];
        return cmds;
    },
    a: function(a) {
        a[5] += $d3cf96a299d38647$var$cx;
        a[6] += $d3cf96a299d38647$var$cy;
        var cmds = $d3cf96a299d38647$var$solveArc($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy, a);
        $d3cf96a299d38647$var$cx = a[5];
        $d3cf96a299d38647$var$cy = a[6];
        return cmds;
    },
    L: function(a) {
        $d3cf96a299d38647$var$cx = a[0];
        $d3cf96a299d38647$var$cy = a[1];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    l: function(a) {
        $d3cf96a299d38647$var$cx += a[0];
        $d3cf96a299d38647$var$cy += a[1];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    H: function(a) {
        $d3cf96a299d38647$var$cx = a[0];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    h: function(a) {
        $d3cf96a299d38647$var$cx += a[0];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    V: function(a) {
        $d3cf96a299d38647$var$cy = a[0];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    v: function(a) {
        $d3cf96a299d38647$var$cy += a[0];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    Z: function() {
        var cmd = (0, $cfb765e9daff3c3a$export$21f87e210c424cd0)();
        $d3cf96a299d38647$var$cx = $d3cf96a299d38647$var$sx;
        $d3cf96a299d38647$var$cy = $d3cf96a299d38647$var$sy;
        return cmd;
    },
    z: function() {
        var cmd = (0, $cfb765e9daff3c3a$export$21f87e210c424cd0)();
        $d3cf96a299d38647$var$cx = $d3cf96a299d38647$var$sx;
        $d3cf96a299d38647$var$cy = $d3cf96a299d38647$var$sy;
        return cmd;
    }
};
var $d3cf96a299d38647$var$solveArc = function(x, y, coords) {
    var rx = coords[0], ry = coords[1], rot = coords[2], large = coords[3], sweep = coords[4], ex = coords[5], ey = coords[6];
    var segs = $d3cf96a299d38647$var$arcToSegments(ex, ey, rx, ry, large, sweep, rot, x, y);
    var cmds = [];
    for(var _i = 0, segs_1 = segs; _i < segs_1.length; _i++){
        var seg = segs_1[_i];
        var bez = $d3cf96a299d38647$var$segmentToBezier.apply(void 0, seg);
        cmds.push((0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb).apply(void 0, bez));
    }
    return cmds;
};
// from Inkscape svgtopdf, thanks!
var $d3cf96a299d38647$var$arcToSegments = function(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
    var th = rotateX * (Math.PI / 180);
    var sinTh = Math.sin(th);
    var cosTh = Math.cos(th);
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    $d3cf96a299d38647$var$px = cosTh * (ox - x) * 0.5 + sinTh * (oy - y) * 0.5;
    $d3cf96a299d38647$var$py = cosTh * (oy - y) * 0.5 - sinTh * (ox - x) * 0.5;
    var pl = $d3cf96a299d38647$var$px * $d3cf96a299d38647$var$px / (rx * rx) + $d3cf96a299d38647$var$py * $d3cf96a299d38647$var$py / (ry * ry);
    if (pl > 1) {
        pl = Math.sqrt(pl);
        rx *= pl;
        ry *= pl;
    }
    var a00 = cosTh / rx;
    var a01 = sinTh / rx;
    var a10 = -sinTh / ry;
    var a11 = cosTh / ry;
    var x0 = a00 * ox + a01 * oy;
    var y0 = a10 * ox + a11 * oy;
    var x1 = a00 * x + a01 * y;
    var y1 = a10 * x + a11 * y;
    var d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
    var sfactorSq = 1 / d - 0.25;
    if (sfactorSq < 0) sfactorSq = 0;
    var sfactor = Math.sqrt(sfactorSq);
    if (sweep === large) sfactor = -sfactor;
    var xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
    var yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
    var th0 = Math.atan2(y0 - yc, x0 - xc);
    var th1 = Math.atan2(y1 - yc, x1 - xc);
    var thArc = th1 - th0;
    if (thArc < 0 && sweep === 1) thArc += 2 * Math.PI;
    else if (thArc > 0 && sweep === 0) thArc -= 2 * Math.PI;
    var segments = Math.ceil(Math.abs(thArc / (Math.PI * 0.5 + 0.001)));
    var result = [];
    for(var i = 0; i < segments; i++){
        var th2 = th0 + i * thArc / segments;
        var th3 = th0 + (i + 1) * thArc / segments;
        result[i] = [
            xc,
            yc,
            th2,
            th3,
            rx,
            ry,
            sinTh,
            cosTh
        ];
    }
    return result;
};
var $d3cf96a299d38647$var$segmentToBezier = function(cx1, cy1, th0, th1, rx, ry, sinTh, cosTh) {
    var a00 = cosTh * rx;
    var a01 = -sinTh * ry;
    var a10 = sinTh * rx;
    var a11 = cosTh * ry;
    var thHalf = 0.5 * (th1 - th0);
    var t = 8 / 3 * Math.sin(thHalf * 0.5) * Math.sin(thHalf * 0.5) / Math.sin(thHalf);
    var x1 = cx1 + Math.cos(th0) - t * Math.sin(th0);
    var y1 = cy1 + Math.sin(th0) + t * Math.cos(th0);
    var x3 = cx1 + Math.cos(th1);
    var y3 = cy1 + Math.sin(th1);
    var x2 = x3 + t * Math.sin(th1);
    var y2 = y3 - t * Math.cos(th1);
    var result = [
        a00 * x1 + a01 * y1,
        a10 * x1 + a11 * y1,
        a00 * x2 + a01 * y2,
        a10 * x2 + a11 * y2,
        a00 * x3 + a01 * y3,
        a10 * x3 + a11 * y3
    ];
    return result;
};
var $d3cf96a299d38647$export$8de5166f0a5bde2a = function(path) {
    return $d3cf96a299d38647$var$apply($d3cf96a299d38647$var$parse(path));
};



var $55cf96b3448598de$export$b11bd9a0808bdc9 = function(line, options) {
    return [
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $cfb765e9daff3c3a$export$568567f665d3f3bb)(options.graphicsState),
        (0, $cfb765e9daff3c3a$export$337b8dbf65fbb95e)(),
        (0, $030fa0a2c4d1456e$export$6126e5d7ba707741)(options.color),
        (0, $cfb765e9daff3c3a$export$df01d619ff6ce7f7)(options.font, options.size),
        (0, $cfb765e9daff3c3a$export$f567083ac6aa5aa3)((0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.rotate), (0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.xSkew), (0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.ySkew), options.x, options.y),
        (0, $cfb765e9daff3c3a$export$778bfc3c1a2b7ba4)(line),
        (0, $cfb765e9daff3c3a$export$e3caa83a99d72806)(),
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $55cf96b3448598de$export$f7b8b44d3d84bc26 = function(lines, options) {
    var operators = [
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $cfb765e9daff3c3a$export$568567f665d3f3bb)(options.graphicsState),
        (0, $cfb765e9daff3c3a$export$337b8dbf65fbb95e)(),
        (0, $030fa0a2c4d1456e$export$6126e5d7ba707741)(options.color),
        (0, $cfb765e9daff3c3a$export$df01d619ff6ce7f7)(options.font, options.size),
        (0, $cfb765e9daff3c3a$export$79399e66b6bb212c)(options.lineHeight),
        (0, $cfb765e9daff3c3a$export$f567083ac6aa5aa3)((0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.rotate), (0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.xSkew), (0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.ySkew), options.x, options.y)
    ].filter(Boolean);
    for(var idx = 0, len = lines.length; idx < len; idx++)operators.push((0, $cfb765e9daff3c3a$export$778bfc3c1a2b7ba4)(lines[idx]), (0, $cfb765e9daff3c3a$export$829ffc2dbe358942)());
    operators.push((0, $cfb765e9daff3c3a$export$e3caa83a99d72806)(), (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)());
    return operators;
};
var $55cf96b3448598de$export$21a059be5bfd5fb = function(name, options) {
    return [
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $cfb765e9daff3c3a$export$568567f665d3f3bb)(options.graphicsState),
        (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $cfb765e9daff3c3a$export$a2ba89726971a90f)((0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.rotate)),
        (0, $cfb765e9daff3c3a$export$dcdf75081b88279d)(options.width, options.height),
        (0, $cfb765e9daff3c3a$export$985cb1d69d6a3add)((0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.xSkew), (0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.ySkew)),
        (0, $cfb765e9daff3c3a$export$382c18f8bccd9e2b)(name),
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $55cf96b3448598de$export$f8ea28c31069cbc9 = function(name, options) {
    return [
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $cfb765e9daff3c3a$export$568567f665d3f3bb)(options.graphicsState),
        (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $cfb765e9daff3c3a$export$a2ba89726971a90f)((0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.rotate)),
        (0, $cfb765e9daff3c3a$export$dcdf75081b88279d)(options.xScale, options.yScale),
        (0, $cfb765e9daff3c3a$export$985cb1d69d6a3add)((0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.xSkew), (0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.ySkew)),
        (0, $cfb765e9daff3c3a$export$382c18f8bccd9e2b)(name),
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $55cf96b3448598de$export$819db45aec5fcbe5 = function(options) {
    var _a, _b;
    return [
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $cfb765e9daff3c3a$export$568567f665d3f3bb)(options.graphicsState),
        options.color && (0, $030fa0a2c4d1456e$export$ae31e5cacc8bb23d)(options.color),
        (0, $cfb765e9daff3c3a$export$558e0f90d8262345)(options.thickness),
        (0, $cfb765e9daff3c3a$export$e0e900d241274e06)((_a = options.dashArray) !== null && _a !== void 0 ? _a : [], (_b = options.dashPhase) !== null && _b !== void 0 ? _b : 0),
        (0, $cfb765e9daff3c3a$export$75f1ccd6dc32e80a)(options.start.x, options.start.y),
        options.lineCap && (0, $cfb765e9daff3c3a$export$6c65ed24e870eec)(options.lineCap),
        (0, $cfb765e9daff3c3a$export$75f1ccd6dc32e80a)(options.start.x, options.start.y),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(options.end.x, options.end.y),
        (0, $cfb765e9daff3c3a$export$d9b706f8d0a70aef)(),
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $55cf96b3448598de$export$cac848e0621718d8 = function(options) {
    var _a, _b;
    return [
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $cfb765e9daff3c3a$export$568567f665d3f3bb)(options.graphicsState),
        options.color && (0, $030fa0a2c4d1456e$export$6126e5d7ba707741)(options.color),
        options.borderColor && (0, $030fa0a2c4d1456e$export$ae31e5cacc8bb23d)(options.borderColor),
        (0, $cfb765e9daff3c3a$export$558e0f90d8262345)(options.borderWidth),
        options.borderLineCap && (0, $cfb765e9daff3c3a$export$6c65ed24e870eec)(options.borderLineCap),
        (0, $cfb765e9daff3c3a$export$e0e900d241274e06)((_a = options.borderDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.borderDashPhase) !== null && _b !== void 0 ? _b : 0),
        (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $cfb765e9daff3c3a$export$a2ba89726971a90f)((0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.rotate)),
        (0, $cfb765e9daff3c3a$export$985cb1d69d6a3add)((0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.xSkew), (0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.ySkew)),
        (0, $cfb765e9daff3c3a$export$75f1ccd6dc32e80a)(0, 0),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(0, options.height),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(options.width, options.height),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(options.width, 0),
        (0, $cfb765e9daff3c3a$export$21f87e210c424cd0)(),
        // prettier-ignore
        options.color && options.borderWidth ? (0, $cfb765e9daff3c3a$export$76d37801baac10fb)() : options.color ? (0, $cfb765e9daff3c3a$export$9563e054e6f787fb)() : options.borderColor ? (0, $cfb765e9daff3c3a$export$d9b706f8d0a70aef)() : (0, $cfb765e9daff3c3a$export$21f87e210c424cd0)(),
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $55cf96b3448598de$var$KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var $55cf96b3448598de$export$f219d5f4b18063ad = function(config) {
    var x = (0, $a25479a44f824b27$export$37576b9ba69b50db)(config.x);
    var y = (0, $a25479a44f824b27$export$37576b9ba69b50db)(config.y);
    var xScale = (0, $a25479a44f824b27$export$37576b9ba69b50db)(config.xScale);
    var yScale = (0, $a25479a44f824b27$export$37576b9ba69b50db)(config.yScale);
    x -= xScale;
    y -= yScale;
    var ox = xScale * $55cf96b3448598de$var$KAPPA;
    var oy = yScale * $55cf96b3448598de$var$KAPPA;
    var xe = x + xScale * 2;
    var ye = y + yScale * 2;
    var xm = x + xScale;
    var ym = y + yScale;
    return [
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(),
        (0, $cfb765e9daff3c3a$export$75f1ccd6dc32e80a)(x, ym),
        (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)(x, ym - oy, xm - ox, y, xm, y),
        (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)(xm + ox, y, xe, ym - oy, xe, ym),
        (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)(xe, ym + oy, xm + ox, ye, xm, ye),
        (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)(xm - ox, ye, x, ym + oy, x, ym),
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ];
};
var $55cf96b3448598de$var$drawEllipseCurves = function(config) {
    var centerX = (0, $a25479a44f824b27$export$37576b9ba69b50db)(config.x);
    var centerY = (0, $a25479a44f824b27$export$37576b9ba69b50db)(config.y);
    var xScale = (0, $a25479a44f824b27$export$37576b9ba69b50db)(config.xScale);
    var yScale = (0, $a25479a44f824b27$export$37576b9ba69b50db)(config.yScale);
    var x = -xScale;
    var y = -yScale;
    var ox = xScale * $55cf96b3448598de$var$KAPPA;
    var oy = yScale * $55cf96b3448598de$var$KAPPA;
    var xe = x + xScale * 2;
    var ye = y + yScale * 2;
    var xm = x + xScale;
    var ym = y + yScale;
    return [
        (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(centerX, centerY),
        (0, $cfb765e9daff3c3a$export$a2ba89726971a90f)((0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(config.rotate)),
        (0, $cfb765e9daff3c3a$export$75f1ccd6dc32e80a)(x, ym),
        (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)(x, ym - oy, xm - ox, y, xm, y),
        (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)(xm + ox, y, xe, ym - oy, xe, ym),
        (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)(xe, ym + oy, xm + ox, ye, xm, ye),
        (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)(xm - ox, ye, x, ym + oy, x, ym)
    ];
};
var $55cf96b3448598de$export$43c9e2bb0dc74582 = function(options) {
    var _a, _b, _c;
    return (0, $cOQTW.__spreadArrays)([
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $cfb765e9daff3c3a$export$568567f665d3f3bb)(options.graphicsState),
        options.color && (0, $030fa0a2c4d1456e$export$6126e5d7ba707741)(options.color),
        options.borderColor && (0, $030fa0a2c4d1456e$export$ae31e5cacc8bb23d)(options.borderColor),
        (0, $cfb765e9daff3c3a$export$558e0f90d8262345)(options.borderWidth),
        options.borderLineCap && (0, $cfb765e9daff3c3a$export$6c65ed24e870eec)(options.borderLineCap),
        (0, $cfb765e9daff3c3a$export$e0e900d241274e06)((_a = options.borderDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.borderDashPhase) !== null && _b !== void 0 ? _b : 0)
    ], options.rotate === undefined ? $55cf96b3448598de$export$f219d5f4b18063ad({
        x: options.x,
        y: options.y,
        xScale: options.xScale,
        yScale: options.yScale
    }) : $55cf96b3448598de$var$drawEllipseCurves({
        x: options.x,
        y: options.y,
        xScale: options.xScale,
        yScale: options.yScale,
        rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0)
    }), [
        // prettier-ignore
        options.color && options.borderWidth ? (0, $cfb765e9daff3c3a$export$76d37801baac10fb)() : options.color ? (0, $cfb765e9daff3c3a$export$9563e054e6f787fb)() : options.borderColor ? (0, $cfb765e9daff3c3a$export$d9b706f8d0a70aef)() : (0, $cfb765e9daff3c3a$export$21f87e210c424cd0)(),
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ]).filter(Boolean);
};
var $55cf96b3448598de$export$47c8a640c39d0756 = function(path, options) {
    var _a, _b, _c;
    return (0, $cOQTW.__spreadArrays)([
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $cfb765e9daff3c3a$export$568567f665d3f3bb)(options.graphicsState),
        (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $cfb765e9daff3c3a$export$a2ba89726971a90f)((0, $3b4f8728c2695c8d$export$cba01ba138429a1d)((_a = options.rotate) !== null && _a !== void 0 ? _a : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0))),
        // SVG path Y axis is opposite pdf-lib's
        options.scale ? (0, $cfb765e9daff3c3a$export$dcdf75081b88279d)(options.scale, -options.scale) : (0, $cfb765e9daff3c3a$export$dcdf75081b88279d)(1, -1),
        options.color && (0, $030fa0a2c4d1456e$export$6126e5d7ba707741)(options.color),
        options.borderColor && (0, $030fa0a2c4d1456e$export$ae31e5cacc8bb23d)(options.borderColor),
        options.borderWidth && (0, $cfb765e9daff3c3a$export$558e0f90d8262345)(options.borderWidth),
        options.borderLineCap && (0, $cfb765e9daff3c3a$export$6c65ed24e870eec)(options.borderLineCap),
        (0, $cfb765e9daff3c3a$export$e0e900d241274e06)((_b = options.borderDashArray) !== null && _b !== void 0 ? _b : [], (_c = options.borderDashPhase) !== null && _c !== void 0 ? _c : 0)
    ], (0, $d3cf96a299d38647$export$8de5166f0a5bde2a)(path), [
        // prettier-ignore
        options.color && options.borderWidth ? (0, $cfb765e9daff3c3a$export$76d37801baac10fb)() : options.color ? (0, $cfb765e9daff3c3a$export$9563e054e6f787fb)() : options.borderColor ? (0, $cfb765e9daff3c3a$export$d9b706f8d0a70aef)() : (0, $cfb765e9daff3c3a$export$21f87e210c424cd0)(),
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ]).filter(Boolean);
};
var $55cf96b3448598de$export$695703ffa02b3ffb = function(options) {
    var size = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.size);
    /*********************** Define Check Mark Points ***************************/ // A check mark is defined by three points in some coordinate space. Here, we
    // define these points in a unit coordinate system, where the range of the x
    // and y axis are both [-1, 1].
    //
    // Note that we do not hard code `p1y` in case we wish to change the
    // size/shape of the check mark in the future. We want the check mark to
    // always form a right angle. This means that the dot product between (p1-p2)
    // and (p3-p2) should be zero:
    //
    //   (p1x-p2x) * (p3x-p2x) + (p1y-p2y) * (p3y-p2y) = 0
    //
    // We can now rejigger this equation to solve for `p1y`:
    //
    //   (p1y-p2y) * (p3y-p2y) = -((p1x-p2x) * (p3x-p2x))
    //   (p1y-p2y) = -((p1x-p2x) * (p3x-p2x)) / (p3y-p2y)
    //   p1y = -((p1x-p2x) * (p3x-p2x)) / (p3y-p2y) + p2y
    //
    // Thanks to my friend Joel Walker (https://github.com/JWalker1995) for
    // devising the above equation and unit coordinate system approach!
    // (x, y) coords of the check mark's bottommost point
    var p2x = -0.25;
    var p2y = -0.49;
    // (x, y) coords of the check mark's topmost point
    var p3y = 0.475;
    var p3x = 0.69;
    // (x, y) coords of the check mark's center (vertically) point
    var p1x = -0.675;
    var p1y = -((p1x - p2x) * (p3x - p2x)) / (p3y - p2y) + p2y;
    /****************************************************************************/ return [
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(),
        options.color && (0, $030fa0a2c4d1456e$export$ae31e5cacc8bb23d)(options.color),
        (0, $cfb765e9daff3c3a$export$558e0f90d8262345)(options.thickness),
        (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $cfb765e9daff3c3a$export$75f1ccd6dc32e80a)(p1x * size, p1y * size),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(p2x * size, p2y * size),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(p3x * size, p3y * size),
        (0, $cfb765e9daff3c3a$export$d9b706f8d0a70aef)(),
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $55cf96b3448598de$export$5dd9a0a87f38a2a6 = function(options) {
    return options.rotation === 0 ? [
        (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(0, 0),
        (0, $cfb765e9daff3c3a$export$91df22fbff99d059)(0)
    ] : options.rotation === 90 ? [
        (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(options.width, 0),
        (0, $cfb765e9daff3c3a$export$91df22fbff99d059)(90)
    ] : options.rotation === 180 ? [
        (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(options.width, options.height),
        (0, $cfb765e9daff3c3a$export$91df22fbff99d059)(180)
    ] : options.rotation === 270 ? [
        (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(0, options.height),
        (0, $cfb765e9daff3c3a$export$91df22fbff99d059)(270)
    ] : [];
}; // Invalid rotation - noop
var $55cf96b3448598de$export$1c2f7a8d0ec539ab = function(options) {
    var outline = $55cf96b3448598de$export$cac848e0621718d8({
        x: options.x,
        y: options.y,
        width: options.width,
        height: options.height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        xSkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        ySkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0)
    });
    if (!options.filled) return outline;
    var width = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.width);
    var height = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.height);
    var checkMarkSize = Math.min(width, height) / 2;
    var checkMark = $55cf96b3448598de$export$695703ffa02b3ffb({
        x: width / 2,
        y: height / 2,
        size: checkMarkSize,
        thickness: options.thickness,
        color: options.markColor
    });
    return (0, $cOQTW.__spreadArrays)([
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)()
    ], outline, checkMark, [
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ]);
};
var $55cf96b3448598de$export$d01bb537f184a293 = function(options) {
    var width = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.width);
    var height = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.height);
    var outlineScale = Math.min(width, height) / 2;
    var outline = $55cf96b3448598de$export$43c9e2bb0dc74582({
        x: options.x,
        y: options.y,
        xScale: outlineScale,
        yScale: outlineScale,
        color: options.color,
        borderColor: options.borderColor,
        borderWidth: options.borderWidth
    });
    if (!options.filled) return outline;
    var dot = $55cf96b3448598de$export$43c9e2bb0dc74582({
        x: options.x,
        y: options.y,
        xScale: outlineScale * 0.45,
        yScale: outlineScale * 0.45,
        color: options.dotColor,
        borderColor: undefined,
        borderWidth: 0
    });
    return (0, $cOQTW.__spreadArrays)([
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)()
    ], outline, dot, [
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ]);
};
var $55cf96b3448598de$export$31046eb8c5070d92 = function(options) {
    var x = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.x);
    var y = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.y);
    var width = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.width);
    var height = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.height);
    var background = $55cf96b3448598de$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        xSkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        ySkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0)
    });
    var lines = $55cf96b3448598de$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        xSkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        ySkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0)
    });
    return (0, $cOQTW.__spreadArrays)([
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)()
    ], background, lines, [
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ]);
};
var $55cf96b3448598de$export$8a28629e0fa0aec4 = function(lines, options) {
    var operators = [
        (0, $cfb765e9daff3c3a$export$337b8dbf65fbb95e)(),
        (0, $030fa0a2c4d1456e$export$6126e5d7ba707741)(options.color),
        (0, $cfb765e9daff3c3a$export$df01d619ff6ce7f7)(options.font, options.size)
    ];
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var _a = lines[idx], encoded = _a.encoded, x = _a.x, y = _a.y;
        operators.push((0, $cfb765e9daff3c3a$export$f567083ac6aa5aa3)((0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.rotate), (0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.xSkew), (0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.ySkew), x, y), (0, $cfb765e9daff3c3a$export$778bfc3c1a2b7ba4)(encoded));
    }
    operators.push((0, $cfb765e9daff3c3a$export$e3caa83a99d72806)());
    return operators;
};
var $55cf96b3448598de$export$7d8517ad99905084 = function(options) {
    var x = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.x);
    var y = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.y);
    var width = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.width);
    var height = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.height);
    var borderWidth = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.borderWidth);
    var padding = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.padding);
    var clipX = x + borderWidth / 2 + padding;
    var clipY = y + borderWidth / 2 + padding;
    var clipWidth = width - (borderWidth / 2 + padding) * 2;
    var clipHeight = height - (borderWidth / 2 + padding) * 2;
    var clippingArea = [
        (0, $cfb765e9daff3c3a$export$75f1ccd6dc32e80a)(clipX, clipY),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(clipX, clipY + clipHeight),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(clipX + clipWidth, clipY + clipHeight),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(clipX + clipWidth, clipY),
        (0, $cfb765e9daff3c3a$export$21f87e210c424cd0)(),
        (0, $cfb765e9daff3c3a$export$e0b576e7a74416cd)(),
        (0, $cfb765e9daff3c3a$export$d366e9c0a9bd860f)()
    ];
    var background = $55cf96b3448598de$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        xSkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        ySkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0)
    });
    var lines = $55cf96b3448598de$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        xSkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        ySkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0)
    });
    var markedContent = (0, $cOQTW.__spreadArrays)([
        (0, $cfb765e9daff3c3a$export$a028b403e40f1ab2)('Tx'),
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)()
    ], lines, [
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)(),
        (0, $cfb765e9daff3c3a$export$935e2334f5a50589)()
    ]);
    return (0, $cOQTW.__spreadArrays)([
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)()
    ], background, clippingArea, markedContent, [
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ]);
};
var $55cf96b3448598de$export$5a3093287b85b7c0 = function(options) {
    var x = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.x);
    var y = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.y);
    var width = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.width);
    var height = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.height);
    var lineHeight = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.lineHeight);
    var borderWidth = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.borderWidth);
    var padding = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.padding);
    var clipX = x + borderWidth / 2 + padding;
    var clipY = y + borderWidth / 2 + padding;
    var clipWidth = width - (borderWidth / 2 + padding) * 2;
    var clipHeight = height - (borderWidth / 2 + padding) * 2;
    var clippingArea = [
        (0, $cfb765e9daff3c3a$export$75f1ccd6dc32e80a)(clipX, clipY),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(clipX, clipY + clipHeight),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(clipX + clipWidth, clipY + clipHeight),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(clipX + clipWidth, clipY),
        (0, $cfb765e9daff3c3a$export$21f87e210c424cd0)(),
        (0, $cfb765e9daff3c3a$export$e0b576e7a74416cd)(),
        (0, $cfb765e9daff3c3a$export$d366e9c0a9bd860f)()
    ];
    var background = $55cf96b3448598de$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        xSkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        ySkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0)
    });
    var highlights = [];
    for(var idx = 0, len = options.selectedLines.length; idx < len; idx++){
        var line = options.textLines[options.selectedLines[idx]];
        highlights.push.apply(highlights, $55cf96b3448598de$export$cac848e0621718d8({
            x: line.x - padding,
            y: line.y - (lineHeight - line.height) / 2,
            width: width - borderWidth,
            height: line.height + (lineHeight - line.height) / 2,
            borderWidth: 0,
            color: options.selectedColor,
            borderColor: undefined,
            rotate: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            xSkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            ySkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0)
        }));
    }
    var lines = $55cf96b3448598de$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        xSkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        ySkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0)
    });
    var markedContent = (0, $cOQTW.__spreadArrays)([
        (0, $cfb765e9daff3c3a$export$a028b403e40f1ab2)('Tx'),
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)()
    ], lines, [
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)(),
        (0, $cfb765e9daff3c3a$export$935e2334f5a50589)()
    ]);
    return (0, $cOQTW.__spreadArrays)([
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)()
    ], background, highlights, clippingArea, markedContent, [
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ]);
};




// tslint:disable: max-classes-per-file

var $cOQTW = parcelRequire("cOQTW");
// TODO: Include link to documentation with example
var $7fe2d034822cb526$export$20fcceeca2b098d2 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(EncryptedPDFError, _super);
    function EncryptedPDFError() {
        var _this = this;
        var msg = 'Input document to `PDFDocument.load` is encrypted. You can use `PDFDocument.load(..., { ignoreEncryption: true })` if you wish to load the document anyways.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return EncryptedPDFError;
}(Error);
// TODO: Include link to documentation with example
var $7fe2d034822cb526$export$529a7c74d0636a48 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(FontkitNotRegisteredError, _super);
    function FontkitNotRegisteredError() {
        var _this = this;
        var msg = 'Input to `PDFDocument.embedFont` was a custom font, but no `fontkit` instance was found. You must register a `fontkit` instance with `PDFDocument.registerFontkit(...)` before embedding custom fonts.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FontkitNotRegisteredError;
}(Error);
// TODO: Include link to documentation with example
var $7fe2d034822cb526$export$9564a4d28d94eae2 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(ForeignPageError, _super);
    function ForeignPageError() {
        var _this = this;
        var msg = 'A `page` passed to `PDFDocument.addPage` or `PDFDocument.insertPage` was from a different (foreign) PDF document. If you want to copy pages from one PDFDocument to another, you must use `PDFDocument.copyPages(...)` to copy the pages before adding or inserting them.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ForeignPageError;
}(Error);
// TODO: Include link to documentation with example
var $7fe2d034822cb526$export$cdca06c5927ddc2d = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(RemovePageFromEmptyDocumentError, _super);
    function RemovePageFromEmptyDocumentError() {
        var _this = this;
        var msg = 'PDFDocument has no pages so `PDFDocument.removePage` cannot be called';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return RemovePageFromEmptyDocumentError;
}(Error);
var $7fe2d034822cb526$export$5bc08baa4a027cbd = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(NoSuchFieldError, _super);
    function NoSuchFieldError(name) {
        var _this = this;
        var msg = "PDFDocument has no form field with the name \"" + name + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return NoSuchFieldError;
}(Error);
var $7fe2d034822cb526$export$8909da6c566ff652 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(UnexpectedFieldTypeError, _super);
    function UnexpectedFieldTypeError(name, expected, actual) {
        var _a, _b;
        var _this = this;
        var expectedType = expected === null || expected === void 0 ? void 0 : expected.name;
        var actualType = (_b = (_a = actual === null || actual === void 0 ? void 0 : actual.constructor) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : actual;
        var msg = "Expected field \"" + name + "\" to be of type " + expectedType + ", " + ("but it is actually of type " + actualType);
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnexpectedFieldTypeError;
}(Error);
var $7fe2d034822cb526$export$3437b42908c7d7a3 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingOnValueCheckError, _super);
    function MissingOnValueCheckError(onValue) {
        var _this = this;
        var msg = "Failed to select check box due to missing onValue: \"" + onValue + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingOnValueCheckError;
}(Error);
var $7fe2d034822cb526$export$c428cfe4dc6c68df = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(FieldAlreadyExistsError, _super);
    function FieldAlreadyExistsError(name) {
        var _this = this;
        var msg = "A field already exists with the specified name: \"" + name + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FieldAlreadyExistsError;
}(Error);
var $7fe2d034822cb526$export$83c39fdacfe38500 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(InvalidFieldNamePartError, _super);
    function InvalidFieldNamePartError(namePart) {
        var _this = this;
        var msg = "Field name contains invalid component: \"" + namePart + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidFieldNamePartError;
}(Error);
var $7fe2d034822cb526$export$6353a2ffd9106bd2 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(FieldExistsAsNonTerminalError, _super);
    function FieldExistsAsNonTerminalError(name) {
        var _this = this;
        var msg = "A non-terminal field already exists with the specified name: \"" + name + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FieldExistsAsNonTerminalError;
}(Error);
var $7fe2d034822cb526$export$f2fed572e1ed57ab = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(RichTextFieldReadError, _super);
    function RichTextFieldReadError(fieldName) {
        var _this = this;
        var msg = "Reading rich text fields is not supported: Attempted to read rich text field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return RichTextFieldReadError;
}(Error);
var $7fe2d034822cb526$export$5283dffc620a5c9f = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(CombedTextLayoutError, _super);
    function CombedTextLayoutError(lineLength, cellCount) {
        var _this = this;
        var msg = "Failed to layout combed text as lineLength=" + lineLength + " is greater than cellCount=" + cellCount;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return CombedTextLayoutError;
}(Error);
var $7fe2d034822cb526$export$1577e99040d42609 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(ExceededMaxLengthError, _super);
    function ExceededMaxLengthError(textLength, maxLength, name) {
        var _this = this;
        var msg = "Attempted to set text with length=" + textLength + " for TextField with maxLength=" + maxLength + " and name=" + name;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ExceededMaxLengthError;
}(Error);
var $7fe2d034822cb526$export$6da6c372180e79b0 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(InvalidMaxLengthError, _super);
    function InvalidMaxLengthError(textLength, maxLength, name) {
        var _this = this;
        var msg = "Attempted to set maxLength=" + maxLength + ", which is less than " + textLength + ", the length of this field's current value (name=" + name + ")";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidMaxLengthError;
}(Error);


var $010595e4078a43c6$export$84b2d1b68830363f;
(function(TextAlignment) {
    TextAlignment[TextAlignment["Left"] = 0] = "Left";
    TextAlignment[TextAlignment["Center"] = 1] = "Center";
    TextAlignment[TextAlignment["Right"] = 2] = "Right";
})($010595e4078a43c6$export$84b2d1b68830363f || ($010595e4078a43c6$export$84b2d1b68830363f = {}));


parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $97c78c294af7eaa8$var$MIN_FONT_SIZE = 4;
var $97c78c294af7eaa8$var$MAX_FONT_SIZE = 500;
var $97c78c294af7eaa8$var$computeFontSize = function(lines, font, bounds, multiline) {
    if (multiline === void 0) multiline = false;
    var fontSize = $97c78c294af7eaa8$var$MIN_FONT_SIZE;
    while(fontSize < $97c78c294af7eaa8$var$MAX_FONT_SIZE){
        var linesUsed = 0;
        for(var lineIdx = 0, lineLen = lines.length; lineIdx < lineLen; lineIdx++){
            linesUsed += 1;
            var line = lines[lineIdx];
            var words = line.split(' ');
            // Layout the words using the current `fontSize`, line wrapping
            // whenever we reach the end of the current line.
            var spaceInLineRemaining = bounds.width;
            for(var idx = 0, len = words.length; idx < len; idx++){
                var isLastWord = idx === len - 1;
                var word = isLastWord ? words[idx] : words[idx] + ' ';
                var widthOfWord = font.widthOfTextAtSize(word, fontSize);
                spaceInLineRemaining -= widthOfWord;
                if (spaceInLineRemaining <= 0) {
                    linesUsed += 1;
                    spaceInLineRemaining = bounds.width - widthOfWord;
                }
            }
        }
        // Return if we exceeded the allowed width
        if (!multiline && linesUsed > lines.length) return fontSize - 1;
        var height = font.heightAtSize(fontSize);
        var lineHeight = height + height * 0.2;
        var totalHeight = lineHeight * linesUsed;
        // Return if we exceeded the allowed height
        if (totalHeight > Math.abs(bounds.height)) return fontSize - 1;
        fontSize += 1;
    }
    return fontSize;
};
var $97c78c294af7eaa8$var$computeCombedFontSize = function(line, font, bounds, cellCount) {
    var cellWidth = bounds.width / cellCount;
    var cellHeight = bounds.height;
    var fontSize = $97c78c294af7eaa8$var$MIN_FONT_SIZE;
    var chars = (0, $7Kmy8.charSplit)(line);
    while(fontSize < $97c78c294af7eaa8$var$MAX_FONT_SIZE){
        for(var idx = 0, len = chars.length; idx < len; idx++){
            var c = chars[idx];
            var tooLong = font.widthOfTextAtSize(c, fontSize) > cellWidth * 0.75;
            if (tooLong) return fontSize - 1;
        }
        var height = font.heightAtSize(fontSize, {
            descender: false
        });
        if (height > cellHeight) return fontSize - 1;
        fontSize += 1;
    }
    return fontSize;
};
var $97c78c294af7eaa8$var$lastIndexOfWhitespace = function(line) {
    for(var idx = line.length; idx > 0; idx--){
        if (/\s/.test(line[idx])) return idx;
    }
    return undefined;
};
var $97c78c294af7eaa8$var$splitOutLines = function(input, maxWidth, font, fontSize) {
    var _a;
    var lastWhitespaceIdx = input.length;
    while(lastWhitespaceIdx > 0){
        var line = input.substring(0, lastWhitespaceIdx);
        var encoded = font.encodeText(line);
        var width = font.widthOfTextAtSize(line, fontSize);
        if (width < maxWidth) {
            var remainder = input.substring(lastWhitespaceIdx) || undefined;
            return {
                line: line,
                encoded: encoded,
                width: width,
                remainder: remainder
            };
        }
        lastWhitespaceIdx = (_a = $97c78c294af7eaa8$var$lastIndexOfWhitespace(line)) !== null && _a !== void 0 ? _a : 0;
    }
    // We were unable to split the input enough to get a chunk that would fit
    // within the specified `maxWidth` so we'll just return everything
    return {
        line: input,
        encoded: font.encodeText(input),
        width: font.widthOfTextAtSize(input, fontSize),
        remainder: undefined
    };
};
var $97c78c294af7eaa8$export$f6ba9f13f815cc95 = function(text, _a) {
    var alignment = _a.alignment, fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds;
    var lines = (0, $7Kmy8.lineSplit)((0, $7Kmy8.cleanText)(text));
    if (fontSize === undefined || fontSize === 0) fontSize = $97c78c294af7eaa8$var$computeFontSize(lines, font, bounds, true);
    var height = font.heightAtSize(fontSize);
    var lineHeight = height + height * 0.2;
    var textLines = [];
    var minX = bounds.x;
    var minY = bounds.y;
    var maxX = bounds.x + bounds.width;
    var maxY = bounds.y + bounds.height;
    var y = bounds.y + bounds.height;
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var prevRemainder = lines[idx];
        while(prevRemainder !== undefined){
            var _b = $97c78c294af7eaa8$var$splitOutLines(prevRemainder, bounds.width, font, fontSize), line = _b.line, encoded = _b.encoded, width = _b.width, remainder = _b.remainder;
            // prettier-ignore
            var x = alignment === (0, $010595e4078a43c6$export$84b2d1b68830363f).Left ? bounds.x : alignment === (0, $010595e4078a43c6$export$84b2d1b68830363f).Center ? bounds.x + bounds.width / 2 - width / 2 : alignment === (0, $010595e4078a43c6$export$84b2d1b68830363f).Right ? bounds.x + bounds.width - width : bounds.x;
            y -= lineHeight;
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x + width > maxX) maxX = x + width;
            if (y + height > maxY) maxY = y + height;
            textLines.push({
                text: line,
                encoded: encoded,
                width: width,
                height: height,
                x: x,
                y: y
            });
            // Only trim lines that we had to split ourselves. So we won't trim lines
            // that the user provided themselves with whitespace.
            prevRemainder = remainder === null || remainder === void 0 ? void 0 : remainder.trim();
        }
    }
    return {
        fontSize: fontSize,
        lineHeight: lineHeight,
        lines: textLines,
        bounds: {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        }
    };
};
var $97c78c294af7eaa8$export$deba41d88dd75dfc = function(text, _a) {
    var fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds, cellCount = _a.cellCount;
    var line = (0, $7Kmy8.mergeLines)((0, $7Kmy8.cleanText)(text));
    if (line.length > cellCount) throw new (0, $7fe2d034822cb526$export$5283dffc620a5c9f)(line.length, cellCount);
    if (fontSize === undefined || fontSize === 0) fontSize = $97c78c294af7eaa8$var$computeCombedFontSize(line, font, bounds, cellCount);
    var cellWidth = bounds.width / cellCount;
    var height = font.heightAtSize(fontSize, {
        descender: false
    });
    var y = bounds.y + (bounds.height / 2 - height / 2);
    var cells = [];
    var minX = bounds.x;
    var minY = bounds.y;
    var maxX = bounds.x + bounds.width;
    var maxY = bounds.y + bounds.height;
    var cellOffset = 0;
    var charOffset = 0;
    while(cellOffset < cellCount){
        var _b = (0, $7Kmy8.charAtIndex)(line, charOffset), char = _b[0], charLength = _b[1];
        var encoded = font.encodeText(char);
        var width = font.widthOfTextAtSize(char, fontSize);
        var cellCenter = bounds.x + (cellWidth * cellOffset + cellWidth / 2);
        var x = cellCenter - width / 2;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x + width > maxX) maxX = x + width;
        if (y + height > maxY) maxY = y + height;
        cells.push({
            text: line,
            encoded: encoded,
            width: width,
            height: height,
            x: x,
            y: y
        });
        cellOffset += 1;
        charOffset += charLength;
    }
    return {
        fontSize: fontSize,
        cells: cells,
        bounds: {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        }
    };
};
var $97c78c294af7eaa8$export$c0030606588cf6f2 = function(text, _a) {
    var alignment = _a.alignment, fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds;
    var line = (0, $7Kmy8.mergeLines)((0, $7Kmy8.cleanText)(text));
    if (fontSize === undefined || fontSize === 0) fontSize = $97c78c294af7eaa8$var$computeFontSize([
        line
    ], font, bounds);
    var encoded = font.encodeText(line);
    var width = font.widthOfTextAtSize(line, fontSize);
    var height = font.heightAtSize(fontSize, {
        descender: false
    });
    // prettier-ignore
    var x = alignment === (0, $010595e4078a43c6$export$84b2d1b68830363f).Left ? bounds.x : alignment === (0, $010595e4078a43c6$export$84b2d1b68830363f).Center ? bounds.x + bounds.width / 2 - width / 2 : alignment === (0, $010595e4078a43c6$export$84b2d1b68830363f).Right ? bounds.x + bounds.width - width : bounds.x;
    var y = bounds.y + (bounds.height / 2 - height / 2);
    return {
        fontSize: fontSize,
        line: {
            text: line,
            encoded: encoded,
            width: width,
            height: height,
            x: x,
            y: y
        },
        bounds: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    };
};




parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $d5944ab433082972$export$8a3aea031520d39b = function(appearance) {
    if ('normal' in appearance) return appearance;
    return {
        normal: appearance
    };
};
// Examples:
//   `/Helv 12 Tf` -> ['/Helv 12 Tf', 'Helv', '12']
//   `/HeBo 8.00 Tf` -> ['/HeBo 8 Tf', 'HeBo', '8.00']
var $d5944ab433082972$var$tfRegex = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]+(\d*\.\d+|\d+)[\0\t\n\f\r\ ]+Tf/;
var $d5944ab433082972$var$getDefaultFontSize = function(field) {
    var _a, _b;
    var da = (_a = field.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
    var daMatch = (_b = (0, $7Kmy8.findLastMatch)(da, $d5944ab433082972$var$tfRegex).match) !== null && _b !== void 0 ? _b : [];
    var defaultFontSize = Number(daMatch[2]);
    return isFinite(defaultFontSize) ? defaultFontSize : undefined;
};
// Examples:
//   `0.3 g` -> ['0.3', 'g']
//   `0.3 1 .3 rg` -> ['0.3', '1', '.3', 'rg']
//   `0.3 1 .3 0 k` -> ['0.3', '1', '.3', '0', 'k']
var $d5944ab433082972$var$colorRegex = /(\d*\.\d+|\d+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+(g|rg|k)/;
var $d5944ab433082972$var$getDefaultColor = function(field) {
    var _a;
    var da = (_a = field.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
    var daMatch = (0, $7Kmy8.findLastMatch)(da, $d5944ab433082972$var$colorRegex).match;
    var _b = daMatch !== null && daMatch !== void 0 ? daMatch : [], c1 = _b[1], c2 = _b[2], c3 = _b[3], c4 = _b[4], colorSpace = _b[5];
    if (colorSpace === 'g' && c1) return (0, $030fa0a2c4d1456e$export$6f416a6db2dfcd5c)(Number(c1));
    if (colorSpace === 'rg' && c1 && c2 && c3) return (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(Number(c1), Number(c2), Number(c3));
    if (colorSpace === 'k' && c1 && c2 && c3 && c4) return (0, $030fa0a2c4d1456e$export$358b1a66a3c77756)(Number(c1), Number(c2), Number(c3), Number(c4));
    return undefined;
};
var $d5944ab433082972$var$updateDefaultAppearance = function(field, color, font, fontSize) {
    var _a;
    if (fontSize === void 0) fontSize = 0;
    var da = [
        (0, $030fa0a2c4d1456e$export$6126e5d7ba707741)(color).toString(),
        (0, $cfb765e9daff3c3a$export$df01d619ff6ce7f7)((_a = font === null || font === void 0 ? void 0 : font.name) !== null && _a !== void 0 ? _a : 'dummy__noop', fontSize).toString()
    ].join('\n');
    field.setDefaultAppearance(da);
};
var $d5944ab433082972$export$e11eab3ac6c06eb0 = function(checkBox, widget) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(checkBox.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $3b4f8728c2695c8d$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $3b4f8728c2695c8d$export$312e44550db33c6a)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $55cf96b3448598de$export$5dd9a0a87f38a2a6)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (_b = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor())) !== null && _b !== void 0 ? _b : black;
    var normalBackgroundColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    // Update color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor);
    else $d5944ab433082972$var$updateDefaultAppearance(checkBox.acroField, textColor);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        thickness: 1.5,
        borderWidth: borderWidth,
        borderColor: borderColor,
        markColor: textColor
    };
    return {
        normal: {
            on: (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$1c2f7a8d0ec539ab)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: true
            }))),
            off: (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$1c2f7a8d0ec539ab)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: false
            })))
        },
        down: {
            on: (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$1c2f7a8d0ec539ab)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: downBackgroundColor,
                filled: true
            }))),
            off: (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$1c2f7a8d0ec539ab)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: downBackgroundColor,
                filled: false
            })))
        }
    };
};
var $d5944ab433082972$export$6440094330a99ef8 = function(radioGroup, widget) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(radioGroup.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $3b4f8728c2695c8d$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $3b4f8728c2695c8d$export$312e44550db33c6a)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $55cf96b3448598de$export$5dd9a0a87f38a2a6)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (_b = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor())) !== null && _b !== void 0 ? _b : black;
    var normalBackgroundColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    // Update color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor);
    else $d5944ab433082972$var$updateDefaultAppearance(radioGroup.acroField, textColor);
    var options = {
        x: width / 2,
        y: height / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth,
        borderColor: borderColor,
        dotColor: textColor
    };
    return {
        normal: {
            on: (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$d01bb537f184a293)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: true
            }))),
            off: (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$d01bb537f184a293)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: false
            })))
        },
        down: {
            on: (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$d01bb537f184a293)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: downBackgroundColor,
                filled: true
            }))),
            off: (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$d01bb537f184a293)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: downBackgroundColor,
                filled: false
            })))
        }
    };
};
var $d5944ab433082972$export$68f9b19f48ffeeec = function(button, widget, font) {
    var _a, _b, _c, _d, _e;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(button.acroField);
    var widgetFontSize = $d5944ab433082972$var$getDefaultFontSize(widget);
    var fieldFontSize = $d5944ab433082972$var$getDefaultFontSize(button.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var captions = ap === null || ap === void 0 ? void 0 : ap.getCaptions();
    var normalText = (_a = captions === null || captions === void 0 ? void 0 : captions.normal) !== null && _a !== void 0 ? _a : '';
    var downText = (_c = (_b = captions === null || captions === void 0 ? void 0 : captions.down) !== null && _b !== void 0 ? _b : normalText) !== null && _c !== void 0 ? _c : '';
    var borderWidth = (_d = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _d !== void 0 ? _d : 0;
    var rotation = (0, $3b4f8728c2695c8d$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _f = (0, $3b4f8728c2695c8d$export$312e44550db33c6a)(rectangle, rotation), width = _f.width, height = _f.height;
    var rotate = (0, $55cf96b3448598de$export$5dd9a0a87f38a2a6)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    var bounds = {
        x: borderWidth,
        y: borderWidth,
        width: width - borderWidth * 2,
        height: height - borderWidth * 2
    };
    var normalLayout = (0, $97c78c294af7eaa8$export$c0030606588cf6f2)(normalText, {
        alignment: (0, $010595e4078a43c6$export$84b2d1b68830363f).Center,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    });
    var downLayout = (0, $97c78c294af7eaa8$export$c0030606588cf6f2)(downText, {
        alignment: (0, $010595e4078a43c6$export$84b2d1b68830363f).Center,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    });
    // Update font size and color
    var fontSize = Math.min(normalLayout.fontSize, downLayout.fontSize);
    var textColor = (_e = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _e !== void 0 ? _e : black;
    if (widgetColor || widgetFontSize !== undefined) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $d5944ab433082972$var$updateDefaultAppearance(button.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize
    };
    return {
        normal: (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$31046eb8c5070d92)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
            color: normalBackgroundColor,
            textLines: [
                normalLayout.line
            ]
        }))),
        down: (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$31046eb8c5070d92)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
            color: downBackgroundColor,
            textLines: [
                downLayout.line
            ]
        })))
    };
};
var $d5944ab433082972$export$42ba95e6b8df3d7 = function(textField, widget, font) {
    var _a, _b, _c, _d;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(textField.acroField);
    var widgetFontSize = $d5944ab433082972$var$getDefaultFontSize(widget);
    var fieldFontSize = $d5944ab433082972$var$getDefaultFontSize(textField.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var text = (_a = textField.getText()) !== null && _a !== void 0 ? _a : '';
    var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
    var rotation = (0, $3b4f8728c2695c8d$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _e = (0, $3b4f8728c2695c8d$export$312e44550db33c6a)(rectangle, rotation), width = _e.width, height = _e.height;
    var rotate = (0, $55cf96b3448598de$export$5dd9a0a87f38a2a6)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var textLines;
    var fontSize;
    var padding = textField.isCombed() ? 0 : 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    if (textField.isMultiline()) {
        var layout = (0, $97c78c294af7eaa8$export$f6ba9f13f815cc95)(text, {
            alignment: textField.getAlignment(),
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds
        });
        textLines = layout.lines;
        fontSize = layout.fontSize;
    } else if (textField.isCombed()) {
        var layout = (0, $97c78c294af7eaa8$export$deba41d88dd75dfc)(text, {
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds,
            cellCount: (_c = textField.getMaxLength()) !== null && _c !== void 0 ? _c : 0
        });
        textLines = layout.cells;
        fontSize = layout.fontSize;
    } else {
        var layout = (0, $97c78c294af7eaa8$export$c0030606588cf6f2)(text, {
            alignment: textField.getAlignment(),
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds
        });
        textLines = [
            layout.line
        ];
        fontSize = layout.fontSize;
    }
    // Update font size and color
    var textColor = (_d = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _d !== void 0 ? _d : black;
    if (widgetColor || widgetFontSize !== undefined) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $d5944ab433082972$var$updateDefaultAppearance(textField.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: textLines,
        padding: padding
    };
    return (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$7d8517ad99905084)(options));
};
var $d5944ab433082972$export$90f1ca03d512ec5 = function(dropdown, widget, font) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(dropdown.acroField);
    var widgetFontSize = $d5944ab433082972$var$getDefaultFontSize(widget);
    var fieldFontSize = $d5944ab433082972$var$getDefaultFontSize(dropdown.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var text = (_a = dropdown.getSelected()[0]) !== null && _a !== void 0 ? _a : '';
    var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
    var rotation = (0, $3b4f8728c2695c8d$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $3b4f8728c2695c8d$export$312e44550db33c6a)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $55cf96b3448598de$export$5dd9a0a87f38a2a6)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var padding = 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    var _e = (0, $97c78c294af7eaa8$export$c0030606588cf6f2)(text, {
        alignment: (0, $010595e4078a43c6$export$84b2d1b68830363f).Left,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    }), line = _e.line, fontSize = _e.fontSize;
    // Update font size and color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor || widgetFontSize !== undefined) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $d5944ab433082972$var$updateDefaultAppearance(dropdown.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: [
            line
        ],
        padding: padding
    };
    return (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$7d8517ad99905084)(options));
};
var $d5944ab433082972$export$f9fab495286778d2 = function(optionList, widget, font) {
    var _a, _b;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(optionList.acroField);
    var widgetFontSize = $d5944ab433082972$var$getDefaultFontSize(widget);
    var fieldFontSize = $d5944ab433082972$var$getDefaultFontSize(optionList.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $3b4f8728c2695c8d$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _c = (0, $3b4f8728c2695c8d$export$312e44550db33c6a)(rectangle, rotation), width = _c.width, height = _c.height;
    var rotate = (0, $55cf96b3448598de$export$5dd9a0a87f38a2a6)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var options = optionList.getOptions();
    var selected = optionList.getSelected();
    if (optionList.isSorted()) options.sort();
    var text = '';
    for(var idx = 0, len = options.length; idx < len; idx++){
        text += options[idx];
        if (idx < len - 1) text += '\n';
    }
    var padding = 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    var _d = (0, $97c78c294af7eaa8$export$f6ba9f13f815cc95)(text, {
        alignment: (0, $010595e4078a43c6$export$84b2d1b68830363f).Left,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    }), lines = _d.lines, fontSize = _d.fontSize, lineHeight = _d.lineHeight;
    var selectedLines = [];
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var line = lines[idx];
        if (selected.includes(line.text)) selectedLines.push(idx);
    }
    var blue = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0.6, 193 / 255, 218 / 255);
    // Update font size and color
    var textColor = (_b = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _b !== void 0 ? _b : black;
    if (widgetColor || widgetFontSize !== undefined) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $d5944ab433082972$var$updateDefaultAppearance(optionList.acroField, textColor, font, fontSize);
    return (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$5a3093287b85b7c0)({
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: lines,
        lineHeight: lineHeight,
        selectedColor: blue,
        selectedLines: selectedLines,
        padding: padding
    }));
};



var $cOQTW = parcelRequire("cOQTW");

var $cOQTW = parcelRequire("cOQTW");




var $cOQTW = parcelRequire("cOQTW");


var $cOQTW = parcelRequire("cOQTW");


parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a PDF page that has been embedded in a [[PDFDocument]].
 */ var $f38ed62eeee08801$var$PDFEmbeddedPage = /** @class */ function() {
    function PDFEmbeddedPage(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        (0, $j0tvB.assertIs)(ref, 'ref', [
            [
                (0, $f1233b848bc26abe$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $93b2571d4e1dfe94$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        (0, $j0tvB.assertIs)(embedder, 'embedder', [
            [
                (0, $c7d58da35b52112a$export$2e2bcd8739ae039),
                'PDFPageEmbedder'
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.width = embedder.width;
        this.height = embedder.height;
        this.embedder = embedder;
    }
    /**
     * Compute the width and height of this page after being scaled by the
     * given `factor`. For example:
     * ```js
     * embeddedPage.width  // => 500
     * embeddedPage.height // => 250
     *
     * const scaled = embeddedPage.scale(0.5)
     * scaled.width  // => 250
     * scaled.height // => 125
     * ```
     * This operation is often useful before drawing a page with
     * [[PDFPage.drawPage]] to compute the `width` and `height` options.
     * @param factor The factor by which this page should be scaled.
     * @returns The width and height of the page after being scaled.
     */ PDFEmbeddedPage.prototype.scale = function(factor) {
        (0, $j0tvB.assertIs)(factor, 'factor', [
            'number'
        ]);
        return {
            width: this.width * factor,
            height: this.height * factor
        };
    };
    /**
     * Get the width and height of this page. For example:
     * ```js
     * const { width, height } = embeddedPage.size()
     * ```
     * @returns The width and height of the page.
     */ PDFEmbeddedPage.prototype.size = function() {
        return this.scale(1);
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all embeddable pages get embedded.
     *
     * Embed this embeddable page in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFEmbeddedPage.prototype.embed = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        _a.sent();
                        this.alreadyEmbedded = true;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedPdf]] and
     * > [[PDFDocument.embedPage]] methods, which will create instances of
     * > [[PDFEmbeddedPage]] for you.
     *
     * Create an instance of [[PDFEmbeddedPage]] from an existing ref and embedder
     *
     * @param ref The unique reference for this embedded page.
     * @param doc The document to which the embedded page will belong.
     * @param embedder The embedder that will be used to embed the page.
     */ PDFEmbeddedPage.of = function(ref, doc, embedder) {
        return new PDFEmbeddedPage(ref, doc, embedder);
    };
    return PDFEmbeddedPage;
}();
var $f38ed62eeee08801$export$2e2bcd8739ae039 = $f38ed62eeee08801$var$PDFEmbeddedPage;



var $cOQTW = parcelRequire("cOQTW");


parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a font that has been embedded in a [[PDFDocument]].
 */ var $fb353673e42bee9b$var$PDFFont = /** @class */ function() {
    function PDFFont(ref, doc, embedder) {
        this.modified = true;
        (0, $j0tvB.assertIs)(ref, 'ref', [
            [
                (0, $f1233b848bc26abe$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $93b2571d4e1dfe94$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        (0, $j0tvB.assertIs)(embedder, 'embedder', [
            [
                (0, $c1a3ddaa0f08fc18$export$2e2bcd8739ae039),
                'CustomFontEmbedder'
            ],
            [
                (0, $e3698d9fec5e57b0$export$2e2bcd8739ae039),
                'StandardFontEmbedder'
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.name = embedder.fontName;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFPage.drawText]] method will automatically encode the text it is
     * > given.
     *
     * Encodes a string of text in this font.
     *
     * @param text The text to be encoded.
     * @returns The encoded text as a hex string.
     */ PDFFont.prototype.encodeText = function(text) {
        (0, $j0tvB.assertIs)(text, 'text', [
            'string'
        ]);
        this.modified = true;
        return this.embedder.encodeText(text);
    };
    /**
     * Measure the width of a string of text drawn in this font at a given size.
     * For example:
     * ```js
     * const width = font.widthOfTextAtSize('Foo Bar Qux Baz', 36)
     * ```
     * @param text The string of text to be measured.
     * @param size The font size to be used for this measurement.
     * @returns The width of the string of text when drawn in this font at the
     *          given size.
     */ PDFFont.prototype.widthOfTextAtSize = function(text, size) {
        (0, $j0tvB.assertIs)(text, 'text', [
            'string'
        ]);
        (0, $j0tvB.assertIs)(size, 'size', [
            'number'
        ]);
        return this.embedder.widthOfTextAtSize(text, size);
    };
    /**
     * Measure the height of this font at a given size. For example:
     * ```js
     * const height = font.heightAtSize(24)
     * ```
     *
     * The `options.descender` value controls whether or not the font's
     * descender is included in the height calculation.
     *
     * @param size The font size to be used for this measurement.
     * @param options The options to be used when computing this measurement.
     * @returns The height of this font at the given size.
     */ PDFFont.prototype.heightAtSize = function(size, options) {
        var _a;
        (0, $j0tvB.assertIs)(size, 'size', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.descender, 'options.descender', [
            'boolean'
        ]);
        return this.embedder.heightOfFontAtSize(size, {
            descender: (_a = options === null || options === void 0 ? void 0 : options.descender) !== null && _a !== void 0 ? _a : true
        });
    };
    /**
     * Compute the font size at which this font is a given height. For example:
     * ```js
     * const fontSize = font.sizeAtHeight(12)
     * ```
     * @param height The height to be used for this calculation.
     * @returns The font size at which this font is the given height.
     */ PDFFont.prototype.sizeAtHeight = function(height) {
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        return this.embedder.sizeOfFontAtHeight(height);
    };
    /**
     * Get the set of unicode code points that can be represented by this font.
     * @returns The set of unicode code points supported by this font.
     */ PDFFont.prototype.getCharacterSet = function() {
        if (this.embedder instanceof (0, $e3698d9fec5e57b0$export$2e2bcd8739ae039)) return this.embedder.encoding.supportedCodePoints;
        else return this.embedder.font.characterSet;
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all fonts get embedded.
     *
     * Embed this font in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFFont.prototype.embed = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.modified) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        _a.sent();
                        this.modified = false;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedFont]] and
     * > [[PDFDocument.embedStandardFont]] methods, which will create instances
     * > of [[PDFFont]] for you.
     *
     * Create an instance of [[PDFFont]] from an existing ref and embedder
     *
     * @param ref The unique reference for this font.
     * @param doc The document to which the font will belong.
     * @param embedder The embedder that will be used to embed the font.
     */ PDFFont.of = function(ref, doc, embedder) {
        return new PDFFont(ref, doc, embedder);
    };
    return PDFFont;
}();
var $fb353673e42bee9b$export$2e2bcd8739ae039 = $fb353673e42bee9b$var$PDFFont;



var $cOQTW = parcelRequire("cOQTW");


parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents an image that has been embedded in a [[PDFDocument]].
 */ var $593e57425d0dad5a$var$PDFImage = /** @class */ function() {
    function PDFImage(ref, doc, embedder) {
        (0, $j0tvB.assertIs)(ref, 'ref', [
            [
                (0, $f1233b848bc26abe$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $93b2571d4e1dfe94$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        (0, $j0tvB.assertIs)(embedder, 'embedder', [
            [
                (0, $b2f30d23c2f107ea$export$2e2bcd8739ae039),
                'JpegEmbedder'
            ],
            [
                (0, $79f8a6e417146498$export$2e2bcd8739ae039),
                'PngEmbedder'
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.width = embedder.width;
        this.height = embedder.height;
        this.embedder = embedder;
    }
    /**
     * Compute the width and height of this image after being scaled by the
     * given `factor`. For example:
     * ```js
     * image.width  // => 500
     * image.height // => 250
     *
     * const scaled = image.scale(0.5)
     * scaled.width  // => 250
     * scaled.height // => 125
     * ```
     * This operation is often useful before drawing an image with
     * [[PDFPage.drawImage]] to compute the `width` and `height` options.
     * @param factor The factor by which this image should be scaled.
     * @returns The width and height of the image after being scaled.
     */ PDFImage.prototype.scale = function(factor) {
        (0, $j0tvB.assertIs)(factor, 'factor', [
            'number'
        ]);
        return {
            width: this.width * factor,
            height: this.height * factor
        };
    };
    /**
     * Get the width and height of this image after scaling it as large as
     * possible while maintaining its aspect ratio and not exceeding the
     * specified `width` and `height`. For example:
     * ```
     * image.width  // => 500
     * image.height // => 250
     *
     * const scaled = image.scaleToFit(750, 1000)
     * scaled.width  // => 750
     * scaled.height // => 375
     * ```
     * The `width` and `height` parameters can also be thought of as the width
     * and height of a box that the scaled image must fit within.
     * @param width The bounding box's width.
     * @param height The bounding box's height.
     * @returns The width and height of the image after being scaled.
     */ PDFImage.prototype.scaleToFit = function(width, height) {
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var imgWidthScale = width / this.width;
        var imgHeightScale = height / this.height;
        var scale = Math.min(imgWidthScale, imgHeightScale);
        return this.scale(scale);
    };
    /**
     * Get the width and height of this image. For example:
     * ```js
     * const { width, height } = image.size()
     * ```
     * @returns The width and height of the image.
     */ PDFImage.prototype.size = function() {
        return this.scale(1);
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all images get embedded.
     *
     * Embed this image in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFImage.prototype.embed = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, doc, ref;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.embedder) return [
                            2 /*return*/ 
                        ];
                        // The image should only be embedded once. If there's a pending embed
                        // operation then wait on it. Otherwise we need to start the embed.
                        if (!this.embedTask) {
                            _a = this, doc = _a.doc, ref = _a.ref;
                            this.embedTask = this.embedder.embedIntoContext(doc.context, ref);
                        }
                        return [
                            4 /*yield*/ ,
                            this.embedTask
                        ];
                    case 1:
                        _b.sent();
                        // We clear `this.embedder` so that the indirectly referenced image data
                        // can be garbage collected, thus avoiding a memory leak.
                        // See https://github.com/Hopding/pdf-lib/pull/1032/files.
                        this.embedder = undefined;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedPng]] and [[PDFDocument.embedJpg]]
     * > methods, which will create instances of [[PDFImage]] for you.
     *
     * Create an instance of [[PDFImage]] from an existing ref and embedder
     *
     * @param ref The unique reference for this image.
     * @param doc The document to which the image will belong.
     * @param embedder The embedder that will be used to embed the image.
     */ PDFImage.of = function(ref, doc, embedder) {
        return new PDFImage(ref, doc, embedder);
    };
    return PDFImage;
}();
var $593e57425d0dad5a$export$2e2bcd8739ae039 = $593e57425d0dad5a$var$PDFImage;




var $cOQTW = parcelRequire("cOQTW");



var $cOQTW = parcelRequire("cOQTW");





var $cOQTW = parcelRequire("cOQTW");




var $nAWRe = parcelRequire("nAWRe");
var $dPHSK = parcelRequire("dPHSK");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var $c5ccd91931a24d5b$export$8efa99ca8f041e7e;
(function(ImageAlignment) {
    ImageAlignment[ImageAlignment["Left"] = 0] = "Left";
    ImageAlignment[ImageAlignment["Center"] = 1] = "Center";
    ImageAlignment[ImageAlignment["Right"] = 2] = "Right";
})($c5ccd91931a24d5b$export$8efa99ca8f041e7e || ($c5ccd91931a24d5b$export$8efa99ca8f041e7e = {}));





var $9a88d5b8c9019f73$export$55643210f1835a35 = function(options) {
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.x, 'options.x', [
        'number'
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.y, 'options.y', [
        'number'
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.width, 'options.width', [
        'number'
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.height, 'options.height', [
        'number'
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.textColor, 'options.textColor', [
        [
            Object,
            'Color'
        ]
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.backgroundColor, 'options.backgroundColor', [
        [
            Object,
            'Color'
        ]
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.borderColor, 'options.borderColor', [
        [
            Object,
            'Color'
        ]
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.borderWidth, 'options.borderWidth', [
        'number'
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.rotate, 'options.rotate', [
        [
            Object,
            'Rotation'
        ]
    ]);
};
/**
 * Represents a field of a [[PDFForm]].
 *
 * This class is effectively abstract. All fields in a [[PDFForm]] will
 * actually be an instance of a subclass of this class.
 *
 * Note that each field in a PDF is represented by a single field object.
 * However, a given field object may be rendered at multiple locations within
 * the document (across one or more pages). The rendering of a field is
 * controlled by its widgets. Each widget causes its field to be displayed at a
 * particular location in the document.
 *
 * Most of the time each field in a PDF has only a single widget, and thus is
 * only rendered once. However, if a field is rendered multiple times, it will
 * have multiple widgets - one for each location it is rendered.
 *
 * This abstraction of field objects and widgets is defined in the PDF
 * specification and dictates how PDF files store fields and where they are
 * to be rendered.
 */ var $9a88d5b8c9019f73$var$PDFField = /** @class */ function() {
    function PDFField(acroField, ref, doc) {
        (0, $j0tvB.assertIs)(acroField, 'acroField', [
            [
                (0, $46d285649821c095$export$2e2bcd8739ae039),
                'PDFAcroTerminal'
            ]
        ]);
        (0, $j0tvB.assertIs)(ref, 'ref', [
            [
                (0, $f1233b848bc26abe$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $93b2571d4e1dfe94$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        this.acroField = acroField;
        this.ref = ref;
        this.doc = doc;
    }
    /**
     * Get the fully qualified name of this field. For example:
     * ```js
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const name = field.getName()
     *   console.log('Field name:', name)
     * })
     * ```
     * Note that PDF fields are structured as a tree. Each field is the
     * descendent of a series of ancestor nodes all the way up to the form node,
     * which is always the root of the tree. Each node in the tree (except for
     * the form node) has a partial name. Partial names can be composed of any
     * unicode characters except a period (`.`). The fully qualified name of a
     * field is composed of the partial names of all its ancestors joined
     * with periods. This means that splitting the fully qualified name on
     * periods and taking the last element of the resulting array will give you
     * the partial name of a specific field.
     * @returns The fully qualified name of this field.
     */ PDFField.prototype.getName = function() {
        var _a;
        return (_a = this.acroField.getFullyQualifiedName()) !== null && _a !== void 0 ? _a : '';
    };
    /**
     * Returns `true` if this field is read only. This means that PDF readers
     * will not allow users to interact with the field or change its value. See
     * [[PDFField.enableReadOnly]] and [[PDFField.disableReadOnly]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isReadOnly()) console.log('Read only is enabled')
     * ```
     * @returns Whether or not this is a read only field.
     */ PDFField.prototype.isReadOnly = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$3600c95532547643).ReadOnly);
    };
    /**
     * Prevent PDF readers from allowing users to interact with this field or
     * change its value. The field will not respond to mouse or keyboard input.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableReadOnly()
     * ```
     * Useful for fields whose values are computed, imported from a database, or
     * prefilled by software before being displayed to the user.
     */ PDFField.prototype.enableReadOnly = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$3600c95532547643).ReadOnly, true);
    };
    /**
     * Allow users to interact with this field and change its value in PDF
     * readers via mouse and keyboard input. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableReadOnly()
     * ```
     */ PDFField.prototype.disableReadOnly = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$3600c95532547643).ReadOnly, false);
    };
    /**
     * Returns `true` if this field must have a value when the form is submitted.
     * See [[PDFField.enableRequired]] and [[PDFField.disableRequired]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isRequired()) console.log('Field is required')
     * ```
     * @returns Whether or not this field is required.
     */ PDFField.prototype.isRequired = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$3600c95532547643).Required);
    };
    /**
     * Require this field to have a value when the form is submitted.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableRequired()
     * ```
     */ PDFField.prototype.enableRequired = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$3600c95532547643).Required, true);
    };
    /**
     * Do not require this field to have a value when the form is submitted.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableRequired()
     * ```
     */ PDFField.prototype.disableRequired = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$3600c95532547643).Required, false);
    };
    /**
     * Returns `true` if this field's value should be exported when the form is
     * submitted. See [[PDFField.enableExporting]] and
     * [[PDFField.disableExporting]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isExported()) console.log('Exporting is enabled')
     * ```
     * @returns Whether or not this field's value should be exported.
     */ PDFField.prototype.isExported = function() {
        return !this.acroField.hasFlag((0, $987e37c460e8464e$export$3600c95532547643).NoExport);
    };
    /**
     * Indicate that this field's value should be exported when the form is
     * submitted in a PDF reader. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableExporting()
     * ```
     */ PDFField.prototype.enableExporting = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$3600c95532547643).NoExport, false);
    };
    /**
     * Indicate that this field's value should **not** be exported when the form
     * is submitted in a PDF reader. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableExporting()
     * ```
     */ PDFField.prototype.disableExporting = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$3600c95532547643).NoExport, true);
    };
    /** @ignore */ PDFField.prototype.needsAppearancesUpdate = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'needsAppearancesUpdate');
    };
    /** @ignore */ PDFField.prototype.defaultUpdateAppearances = function(_font) {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'defaultUpdateAppearances');
    };
    PDFField.prototype.markAsDirty = function() {
        this.doc.getForm().markFieldAsDirty(this.ref);
    };
    PDFField.prototype.markAsClean = function() {
        this.doc.getForm().markFieldAsClean(this.ref);
    };
    PDFField.prototype.isDirty = function() {
        return this.doc.getForm().fieldIsDirty(this.ref);
    };
    PDFField.prototype.createWidget = function(options) {
        var _a;
        var textColor = options.textColor;
        var backgroundColor = options.backgroundColor;
        var borderColor = options.borderColor;
        var borderWidth = options.borderWidth;
        var degreesAngle = (0, $3b4f8728c2695c8d$export$56cb859c01fa134d)(options.rotate);
        var caption = options.caption;
        var x = options.x;
        var y = options.y;
        var width = options.width + borderWidth;
        var height = options.height + borderWidth;
        var hidden = Boolean(options.hidden);
        var pageRef = options.page;
        (0, $j0tvB.assertMultiple)(degreesAngle, 'degreesAngle', 90);
        // Create a widget for this field
        var widget = (0, $540f7922618e60a2$export$2e2bcd8739ae039).create(this.doc.context, this.ref);
        // Set widget properties
        var rect = (0, $3b4f8728c2695c8d$export$afddc3b8600307a4)({
            x: x,
            y: y,
            width: width,
            height: height
        }, borderWidth, degreesAngle);
        widget.setRectangle(rect);
        if (pageRef) widget.setP(pageRef);
        var ac = widget.getOrCreateAppearanceCharacteristics();
        if (backgroundColor) ac.setBackgroundColor((0, $030fa0a2c4d1456e$export$ffee2793812e3e56)(backgroundColor));
        ac.setRotation(degreesAngle);
        if (caption) ac.setCaptions({
            normal: caption
        });
        if (borderColor) ac.setBorderColor((0, $030fa0a2c4d1456e$export$ffee2793812e3e56)(borderColor));
        var bs = widget.getOrCreateBorderStyle();
        if (borderWidth !== undefined) bs.setWidth(borderWidth);
        widget.setFlagTo((0, $8f93b7bf8ef0f00e$export$1fa7b68b35026177).Print, true);
        widget.setFlagTo((0, $8f93b7bf8ef0f00e$export$1fa7b68b35026177).Hidden, hidden);
        widget.setFlagTo((0, $8f93b7bf8ef0f00e$export$1fa7b68b35026177).Invisible, false);
        // Set acrofield properties
        if (textColor) {
            var da = (_a = this.acroField.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
            var newDa = da + '\n' + (0, $030fa0a2c4d1456e$export$6126e5d7ba707741)(textColor).toString();
            this.acroField.setDefaultAppearance(newDa);
        }
        return widget;
    };
    PDFField.prototype.updateWidgetAppearanceWithFont = function(widget, font, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        this.updateWidgetAppearances(widget, {
            normal: this.createAppearanceStream(widget, normal, font),
            rollover: rollover && this.createAppearanceStream(widget, rollover, font),
            down: down && this.createAppearanceStream(widget, down, font)
        });
    };
    PDFField.prototype.updateOnOffWidgetAppearance = function(widget, onValue, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        this.updateWidgetAppearances(widget, {
            normal: this.createAppearanceDict(widget, normal, onValue),
            rollover: rollover && this.createAppearanceDict(widget, rollover, onValue),
            down: down && this.createAppearanceDict(widget, down, onValue)
        });
    };
    PDFField.prototype.updateWidgetAppearances = function(widget, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        widget.setNormalAppearance(normal);
        if (rollover) widget.setRolloverAppearance(rollover);
        else widget.removeRolloverAppearance();
        if (down) widget.setDownAppearance(down);
        else widget.removeDownAppearance();
    };
    // // TODO: Do we need to do this...?
    // private foo(font: PDFFont, dict: PDFDict) {
    //   if (!dict.lookup(PDFName.of('DR'))) {
    //     dict.set(PDFName.of('DR'), dict.context.obj({}));
    //   }
    //   const DR = dict.lookup(PDFName.of('DR'), PDFDict);
    //   if (!DR.lookup(PDFName.of('Font'))) {
    //     DR.set(PDFName.of('Font'), dict.context.obj({}));
    //   }
    //   const Font = DR.lookup(PDFName.of('Font'), PDFDict);
    //   Font.set(PDFName.of(font.name), font.ref);
    // }
    PDFField.prototype.createAppearanceStream = function(widget, appearance, font) {
        var _a;
        var context = this.acroField.dict.context;
        var _b = widget.getRectangle(), width = _b.width, height = _b.height;
        // TODO: Do we need to do this...?
        // if (font) {
        //   this.foo(font, widget.dict);
        //   this.foo(font, this.doc.getForm().acroForm.dict);
        // }
        // END TODO
        var Resources = font && {
            Font: (_a = {}, _a[font.name] = font.ref, _a)
        };
        var stream = context.formXObject(appearance, {
            Resources: Resources,
            BBox: context.obj([
                0,
                0,
                width,
                height
            ]),
            Matrix: context.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        });
        var streamRef = context.register(stream);
        return streamRef;
    };
    /**
     * Create a FormXObject of the supplied image and add it to context.
     * The FormXObject size is calculated based on the widget (including
     * the alignment).
     * @param widget The widget that should display the image.
     * @param alignment The alignment of the image.
     * @param image The image that should be displayed.
     * @returns The ref for the FormXObject that was added to the context.
     */ PDFField.prototype.createImageAppearanceStream = function(widget, image, alignment) {
        // NOTE: This implementation doesn't handle image borders.
        // NOTE: Acrobat seems to resize the image (maybe even skewing its aspect
        //       ratio) to fit perfectly within the widget's rectangle. This method
        //       does not currently do that. Should there be an option for that?
        var _a;
        var _b;
        var context = this.acroField.dict.context;
        var rectangle = widget.getRectangle();
        var ap = widget.getAppearanceCharacteristics();
        var bs = widget.getBorderStyle();
        var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
        var rotation = (0, $3b4f8728c2695c8d$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
        var rotate = (0, $55cf96b3448598de$export$5dd9a0a87f38a2a6)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
            rotation: rotation
        }));
        var adj = (0, $3b4f8728c2695c8d$export$312e44550db33c6a)(rectangle, rotation);
        var imageDims = image.scaleToFit(adj.width - borderWidth * 2, adj.height - borderWidth * 2);
        // Support borders on images and maybe other properties
        var options = {
            x: borderWidth,
            y: borderWidth,
            width: imageDims.width,
            height: imageDims.height,
            //
            rotate: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            xSkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            ySkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0)
        };
        if (alignment === (0, $c5ccd91931a24d5b$export$8efa99ca8f041e7e).Center) {
            options.x += (adj.width - borderWidth * 2) / 2 - imageDims.width / 2;
            options.y += (adj.height - borderWidth * 2) / 2 - imageDims.height / 2;
        } else if (alignment === (0, $c5ccd91931a24d5b$export$8efa99ca8f041e7e).Right) {
            options.x = adj.width - borderWidth - imageDims.width;
            options.y = adj.height - borderWidth - imageDims.height;
        }
        var imageName = this.doc.context.addRandomSuffix('Image', 10);
        var appearance = (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$21a059be5bfd5fb)(imageName, options));
        ////////////
        var Resources = {
            XObject: (_a = {}, _a[imageName] = image.ref, _a)
        };
        var stream = context.formXObject(appearance, {
            Resources: Resources,
            BBox: context.obj([
                0,
                0,
                rectangle.width,
                rectangle.height
            ]),
            Matrix: context.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        });
        return context.register(stream);
    };
    PDFField.prototype.createAppearanceDict = function(widget, appearance, onValue) {
        var context = this.acroField.dict.context;
        var onStreamRef = this.createAppearanceStream(widget, appearance.on);
        var offStreamRef = this.createAppearanceStream(widget, appearance.off);
        var appearanceDict = context.obj({});
        appearanceDict.set(onValue, onStreamRef);
        appearanceDict.set((0, $dPHSK.default).of('Off'), offStreamRef);
        return appearanceDict;
    };
    return PDFField;
}();
var $9a88d5b8c9019f73$export$2e2bcd8739ae039 = $9a88d5b8c9019f73$var$PDFField;



var $dPHSK = parcelRequire("dPHSK");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a check box field of a [[PDFForm]].
 *
 * [[PDFCheckBox]] fields are interactive boxes that users can click with their
 * mouse. This type of [[PDFField]] has two states: `on` and `off`. The purpose
 * of a check box is to enable users to select from one or more options, where
 * each option is represented by a single check box. Check boxes are typically
 * square in shape and display a check mark when they are in the `on` state.
 */ var $4740dcccc2940521$var$PDFCheckBox = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFCheckBox, _super);
    function PDFCheckBox(acroCheckBox, ref, doc) {
        var _this = _super.call(this, acroCheckBox, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroCheckBox, 'acroCheckBox', [
            [
                (0, $f8e31b0e21e15332$export$2e2bcd8739ae039),
                'PDFAcroCheckBox'
            ]
        ]);
        _this.acroField = acroCheckBox;
        return _this;
    }
    /**
     * Mark this check box. This operation is analogous to a human user clicking
     * a check box to fill it in a PDF reader. This method will update the
     * underlying state of the check box field to indicate it has been selected.
     * PDF libraries and readers will be able to extract this value from the
     * saved document and determine that it was selected.
     *
     * For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.check()
     * ```
     *
     * This method will mark this check box as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated appearance
     * streams will display a check mark inside the widgets of this check box
     * field.
     */ PDFCheckBox.prototype.check = function() {
        var _a;
        var onValue = (_a = this.acroField.getOnValue()) !== null && _a !== void 0 ? _a : (0, $dPHSK.default).of('Yes');
        this.markAsDirty();
        this.acroField.setValue(onValue);
    };
    /**
     * Clears this check box. This operation is analogous to a human user clicking
     * a check box to unmark it in a PDF reader. This method will update the
     * underlying state of the check box field to indicate it has been deselected.
     * PDF libraries and readers will be able to extract this value from the
     * saved document and determine that it was not selected.
     *
     * For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.uncheck()
     * ```
     *
     * This method will mark this check box as dirty. See [[PDFCheckBox.check]]
     * for more details about what this means.
     */ PDFCheckBox.prototype.uncheck = function() {
        this.markAsDirty();
        this.acroField.setValue((0, $dPHSK.default).of('Off'));
    };
    /**
     * Returns `true` if this check box is selected (either by a human user via
     * a PDF reader, or else programmatically via software). For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * if (checkBox.isChecked()) console.log('check box is selected')
     * ```
     * @returns Whether or not this check box is selected.
     */ PDFCheckBox.prototype.isChecked = function() {
        var onValue = this.acroField.getOnValue();
        return !!onValue && onValue === this.acroField.getValue();
    };
    /**
     * Show this check box on the specified page. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const checkBox = form.createCheckBox('some.checkBox.field')
     *
     * checkBox.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 25,
     *   height: 25,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     * })
     * ```
     * This will create a new widget for this check box field.
     * @param page The page to which this check box widget should be added.
     * @param options The options to be used when adding this check box widget.
     */ PDFCheckBox.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f;
        (0, $j0tvB.assertIs)(page, 'page', [
            [
                (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $9a88d5b8c9019f73$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this check box
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 50,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        widget.setAppearanceState((0, $dPHSK.default).of('Off'));
        this.updateWidgetAppearance(widget, (0, $dPHSK.default).of('Yes'));
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if any of this check box's widgets do not have an
     * appearance stream for its current state. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * if (checkBox.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this check box needs an appearance update.
     */ PDFCheckBox.prototype.needsAppearancesUpdate = function() {
        var _a;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getAppearanceState();
            var normal = (_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
            if (!(normal instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039))) return true;
            if (state && !normal.has(state)) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this check box's widgets using
     * the default appearance provider for check boxes. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.defaultUpdateAppearances()
     * ```
     */ PDFCheckBox.prototype.defaultUpdateAppearances = function() {
        this.updateAppearances();
    };
    /**
     * Update the appearance streams for each of this check box's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for check boxs will be used. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.updateAppearances((field, widget) => {
     *   ...
     *   return {
     *     normal: { on: drawCheckBox(...), off: drawCheckBox(...) },
     *     down: { on: drawCheckBox(...), off: drawCheckBox(...) },
     *   }
     * })
     * ```
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFCheckBox.prototype.updateAppearances = function(provider) {
        var _a;
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var onValue = (_a = widget.getOnValue()) !== null && _a !== void 0 ? _a : (0, $dPHSK.default).of('Yes');
            if (!onValue) continue;
            this.updateWidgetAppearance(widget, onValue, provider);
        }
        this.markAsClean();
    };
    PDFCheckBox.prototype.updateWidgetAppearance = function(widget, onValue, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $d5944ab433082972$export$e11eab3ac6c06eb0);
        var appearances = (0, $d5944ab433082972$export$8a3aea031520d39b)(apProvider(this, widget));
        this.updateOnOffWidgetAppearance(widget, onValue, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getCheckBox]] method, which will create an
     * > instance of [[PDFCheckBox]] for you.
     *
     * Create an instance of [[PDFCheckBox]] from an existing acroCheckBox and ref
     *
     * @param acroCheckBox The underlying `PDFAcroCheckBox` for this check box.
     * @param ref The unique reference for this check box.
     * @param doc The document to which this check box will belong.
     */ PDFCheckBox.of = function(acroCheckBox, ref, doc) {
        return new PDFCheckBox(acroCheckBox, ref, doc);
    };
    return PDFCheckBox;
}((0, $9a88d5b8c9019f73$export$2e2bcd8739ae039));
var $4740dcccc2940521$export$2e2bcd8739ae039 = $4740dcccc2940521$var$PDFCheckBox;



var $cOQTW = parcelRequire("cOQTW");







parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a dropdown field of a [[PDFForm]].
 *
 * [[PDFDropdown]] fields are interactive text boxes that display a single
 * element (the currently selected value). The purpose of a dropdown is to
 * enable users to select a single option from a set of possible options. Users
 * can click on a dropdown to view the full list of options it provides.
 * Clicking on an option in the list will cause it to be selected and displayed
 * in the dropdown's text box. Some dropdowns allow users to enter text
 * directly into the box from their keyboard, rather than only being allowed to
 * choose an option from the list (see [[PDFDropdown.isEditable]]).
 */ var $8c3a0a776d3c65cf$var$PDFDropdown = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFDropdown, _super);
    function PDFDropdown(acroComboBox, ref, doc) {
        var _this = _super.call(this, acroComboBox, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroComboBox, 'acroComboBox', [
            [
                (0, $3488827c1474fcce$export$2e2bcd8739ae039),
                'PDFAcroComboBox'
            ]
        ]);
        _this.acroField = acroComboBox;
        return _this;
    }
    /**
     * Get the list of available options for this dropdown. These options will be
     * displayed to users who click on this dropdown in a PDF reader.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * const options = dropdown.getOptions()
     * console.log('Dropdown options:', options)
     * ```
     * @returns The options for this dropdown.
     */ PDFDropdown.prototype.getOptions = function() {
        var rawOptions = this.acroField.getOptions();
        var options = new Array(rawOptions.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = rawOptions[idx], display = _a.display, value = _a.value;
            options[idx] = (display !== null && display !== void 0 ? display : value).decodeText();
        }
        return options;
    };
    /**
     * Get the selected options for this dropdown. These are the values that were
     * selected by a human user via a PDF reader, or programatically via
     * software.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * const selections = dropdown.getSelected()
     * console.log('Dropdown selections:', selections)
     * ```
     * > **NOTE:** Note that PDF readers only display one selected option when
     * > rendering dropdowns. However, the PDF specification does allow for
     * > multiple values to be selected in a dropdown. As such, the `pdf-lib`
     * > API supports this. However, in most cases the array returned by this
     * > method will contain only a single element (or no elements).
     * @returns The selected options in this dropdown.
     */ PDFDropdown.prototype.getSelected = function() {
        var values = this.acroField.getValues();
        var selected = new Array(values.length);
        for(var idx = 0, len = values.length; idx < len; idx++)selected[idx] = values[idx].decodeText();
        return selected;
    };
    /**
     * Set the list of options that are available for this dropdown. These are
     * the values that will be available for users to select when they view this
     * dropdown in a PDF reader. Note that preexisting options for this dropdown
     * will be removed. Only the values passed as `options` will be available to
     * select.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('planets.dropdown')
     * dropdown.setOptions(['Earth', 'Mars', 'Pluto', 'Venus'])
     * ```
     * @param options The options that should be available in this dropdown.
     */ PDFDropdown.prototype.setOptions = function(options) {
        (0, $j0tvB.assertIs)(options, 'options', [
            Array
        ]);
        var optionObjects = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++)optionObjects[idx] = {
            value: (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(options[idx])
        };
        this.acroField.setOptions(optionObjects);
    };
    /**
     * Add to the list of options that are available for this dropdown. Users
     * will be able to select these values in a PDF reader. In addition to the
     * values passed as `options`, any preexisting options for this dropdown will
     * still be available for users to select.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('rockets.dropdown')
     * dropdown.addOptions(['Saturn IV', 'Falcon Heavy'])
     * ```
     * @param options New options that should be available in this dropdown.
     */ PDFDropdown.prototype.addOptions = function(options) {
        (0, $j0tvB.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var existingOptions = this.acroField.getOptions();
        var newOptions = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)newOptions[idx] = {
            value: (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(optionsArr[idx])
        };
        this.acroField.setOptions(existingOptions.concat(newOptions));
    };
    /**
     * Select one or more values for this dropdown. This operation is analogous
     * to a human user opening the dropdown in a PDF reader and clicking on a
     * value to select it. This method will update the underlying state of the
     * dropdown to indicate which values have been selected. PDF libraries and
     * readers will be able to extract these values from the saved document and
     * determine which values were selected.
     *
     * For example:
     * ```js
     * const dropdown = form.getDropdown('best.superhero.dropdown')
     * dropdown.select('One Punch Man')
     * ```
     *
     * This method will mark this dropdown as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the selected option inside the widgets of this dropdown.
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if the selected option for this field
     * contains characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFDropdown.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * Selecting an option that does not exist in this dropdown's option list
     * (see [[PDFDropdown.getOptions]]) will enable editing on this dropdown
     * (see [[PDFDropdown.enableEditing]]).
     *
     * > **NOTE:** PDF readers only display one selected option when rendering
     * > dropdowns. However, the PDF specification does allow for multiple values
     * > to be selected in a dropdown. As such, the `pdf-lib` API supports this.
     * > However, it is not recommended to select more than one value with this
     * > method, as only one will be visible. [[PDFOptionList]] fields are better
     * > suited for displaying multiple selected values.
     *
     * @param options The options to be selected.
     * @param merge Whether or not existing selections should be preserved.
     */ PDFDropdown.prototype.select = function(options, merge) {
        if (merge === void 0) merge = false;
        (0, $j0tvB.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        (0, $j0tvB.assertIs)(merge, 'merge', [
            'boolean'
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var validOptions = this.getOptions();
        var hasCustomOption = optionsArr.find(function(option) {
            return !validOptions.includes(option);
        });
        if (hasCustomOption) this.enableEditing();
        this.markAsDirty();
        if (optionsArr.length > 1 || optionsArr.length === 1 && merge) this.enableMultiselect();
        var values = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)values[idx] = (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(optionsArr[idx]);
        if (merge) {
            var existingValues = this.acroField.getValues();
            this.acroField.setValues(existingValues.concat(values));
        } else this.acroField.setValues(values);
    };
    /**
     * Clear all selected values for this dropdown. This operation is equivalent
     * to selecting an empty list. This method will update the underlying state
     * of the dropdown to indicate that no values have been selected.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.clear()
     * ```
     * This method will mark this text field as dirty. See [[PDFDropdown.select]]
     * for more details about what this means.
     */ PDFDropdown.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValues([]);
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this dropdown. Font sizes may
     * be integer or floating point numbers. Supplying a negative font size will
     * cause this method to throw an error.
     *
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.setFontSize(4)
     * dropdown.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFDropdown.prototype.setFontSize = function(fontSize) {
        (0, $j0tvB.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if users are allowed to edit the selected value of this
     * dropdown directly and are not constrained by the list of available
     * options. See [[PDFDropdown.enableEditing]] and
     * [[PDFDropdown.disableEditing]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isEditable()) console.log('Editing is enabled')
     * ```
     * @returns Whether or not this dropdown is editable.
     */ PDFDropdown.prototype.isEditable = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$eb88827058402599).Edit);
    };
    /**
     * Allow users to edit the selected value of this dropdown in PDF readers
     * with their keyboard. This means that the selected value of this dropdown
     * will not be constrained by the list of available options. However, if this
     * dropdown has any available options, users will still be allowed to select
     * from that list.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableEditing()
     * ```
     */ PDFDropdown.prototype.enableEditing = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).Edit, true);
    };
    /**
     * Do not allow users to edit the selected value of this dropdown in PDF
     * readers with their keyboard. This will constrain the selected value of
     * this dropdown to the list of available options. Users will only be able
     * to select an option from that list.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableEditing()
     * ```
     */ PDFDropdown.prototype.disableEditing = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).Edit, false);
    };
    /**
     * Returns `true` if the option list of this dropdown is always displayed
     * in alphabetical order, irrespective of the order in which the options
     * were added to the dropdown. See [[PDFDropdown.enableSorting]] and
     * [[PDFDropdown.disableSorting]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSorted()) console.log('Sorting is enabled')
     * ```
     * @returns Whether or not this dropdown's options are sorted.
     */ PDFDropdown.prototype.isSorted = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$eb88827058402599).Sort);
    };
    /**
     * Always display the option list of this dropdown in alphabetical order,
     * irrespective of the order in which the options were added to this dropdown.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSorting()
     * ```
     */ PDFDropdown.prototype.enableSorting = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).Sort, true);
    };
    /**
     * Do not always display the option list of this dropdown in alphabetical
     * order. Instead, display the options in whichever order they were added
     * to the list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSorting()
     * ```
     */ PDFDropdown.prototype.disableSorting = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).Sort, false);
    };
    /**
     * Returns `true` if multiple options can be selected from this dropdown's
     * option list. See [[PDFDropdown.enableMultiselect]] and
     * [[PDFDropdown.disableMultiselect]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isMultiselect()) console.log('Multiselect is enabled')
     * ```
     * @returns Whether or not multiple options can be selected.
     */ PDFDropdown.prototype.isMultiselect = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$eb88827058402599).MultiSelect);
    };
    /**
     * Allow users to select more than one option from this dropdown's option
     * list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableMultiselect()
     * ```
     */ PDFDropdown.prototype.enableMultiselect = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).MultiSelect, true);
    };
    /**
     * Do not allow users to select more than one option from this dropdown's
     * option list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableMultiselect()
     * ```
     */ PDFDropdown.prototype.disableMultiselect = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).MultiSelect, false);
    };
    /**
     * Returns `true` if the selected option should be spell checked by PDF
     * readers. Spell checking will only be performed if this dropdown allows
     * editing (see [[PDFDropdown.isEditable]]). See
     * [[PDFDropdown.enableSpellChecking]] and
     * [[PDFDropdown.disableSpellChecking]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSpellChecked()) console.log('Spell checking is enabled')
     * ```
     * @returns Whether or not this dropdown can be spell checked.
     */ PDFDropdown.prototype.isSpellChecked = function() {
        return !this.acroField.hasFlag((0, $987e37c460e8464e$export$eb88827058402599).DoNotSpellCheck);
    };
    /**
     * Allow PDF readers to spell check the selected option of this dropdown.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSpellChecking()
     * ```
     */ PDFDropdown.prototype.enableSpellChecking = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).DoNotSpellCheck, false);
    };
    /**
     * Do not allow PDF readers to spell check the selected option of this
     * dropdown. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSpellChecking()
     * ```
     */ PDFDropdown.prototype.disableSpellChecking = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).DoNotSpellCheck, true);
    };
    /**
     * Returns `true` if the option selected by a user is stored, or "committed",
     * when the user clicks the option. The alternative is that the user's
     * selection is stored when the user leaves this dropdown field (by clicking
     * outside of it - on another field, for example). See
     * [[PDFDropdown.enableSelectOnClick]] and
     * [[PDFDropdown.disableSelectOnClick]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSelectOnClick()) console.log('Select on click is enabled')
     * ```
     * @returns Whether or not options are selected immediately after they are
     *          clicked.
     */ PDFDropdown.prototype.isSelectOnClick = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$eb88827058402599).CommitOnSelChange);
    };
    /**
     * Store the option selected by a user immediately after the user clicks the
     * option. Do not wait for the user to leave this dropdown field (by clicking
     * outside of it - on another field, for example). For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSelectOnClick()
     * ```
     */ PDFDropdown.prototype.enableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).CommitOnSelChange, true);
    };
    /**
     * Wait to store the option selected by a user until they leave this dropdown
     * field (by clicking outside of it - on another field, for example).
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSelectOnClick()
     * ```
     */ PDFDropdown.prototype.disableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).CommitOnSelChange, false);
    };
    /**
     * Show this dropdown on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const dropdown = form.createDropdown('best.gundam')
     * dropdown.setOptions(['Exia', 'Dynames'])
     * dropdown.select('Exia')
     *
     * dropdown.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this dropdown field.
     * @param page The page to which this dropdown widget should be added.
     * @param options The options to be used when adding this dropdown widget.
     */ PDFDropdown.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $j0tvB.assertIs)(page, 'page', [
            [
                (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $9a88d5b8c9019f73$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this dropdown
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this dropdown has been marked as dirty, or if any of
     * this dropdown's widgets do not have an appearance stream. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this dropdown needs an appearance update.
     */ PDFDropdown.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this dropdown's widgets using
     * the default appearance provider for dropdowns. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFDropdown.prototype.defaultUpdateAppearances = function(font) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $fb353673e42bee9b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this dropdown's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for dropdowns will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawTextField(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFDropdown.prototype.updateAppearances = function(font, provider) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $fb353673e42bee9b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    // getOption(index: number): string {}
    // getSelectedIndices(): number[] {}
    // removeOptions(option: string | string[]) {}
    // removeIndices(option: number[]) {}
    // deselect(options: string | string[]) {}
    // deselectIndices(optionIndices: number[]) {}
    PDFDropdown.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $d5944ab433082972$export$90f1ca03d512ec5);
        var appearances = (0, $d5944ab433082972$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getDropdown]] method, which will create an
     * > instance of [[PDFDropdown]] for you.
     *
     * Create an instance of [[PDFDropdown]] from an existing acroComboBox and ref
     *
     * @param acroComboBox The underlying `PDFAcroComboBox` for this dropdown.
     * @param ref The unique reference for this dropdown.
     * @param doc The document to which this dropdown will belong.
     */ PDFDropdown.of = function(acroComboBox, ref, doc) {
        return new PDFDropdown(acroComboBox, ref, doc);
    };
    return PDFDropdown;
}((0, $9a88d5b8c9019f73$export$2e2bcd8739ae039));
var $8c3a0a776d3c65cf$export$2e2bcd8739ae039 = $8c3a0a776d3c65cf$var$PDFDropdown;



var $cOQTW = parcelRequire("cOQTW");







parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents an option list field of a [[PDFForm]].
 *
 * [[PDFOptionList]] fields are interactive lists of options. The purpose of an
 * option list is to enable users to select one or more options from a set of
 * possible options. Users are able to see the full set of options without
 * first having to click on the field (though scrolling may be necessary).
 * Clicking an option in the list will cause it to be selected and displayed
 * with a highlighted background. Some option lists allow users to select
 * more than one option (see [[PDFOptionList.isMultiselect]]).
 */ var $41141972e5bafa05$var$PDFOptionList = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFOptionList, _super);
    function PDFOptionList(acroListBox, ref, doc) {
        var _this = _super.call(this, acroListBox, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroListBox, 'acroListBox', [
            [
                (0, $c1f53a89685317ba$export$2e2bcd8739ae039),
                'PDFAcroListBox'
            ]
        ]);
        _this.acroField = acroListBox;
        return _this;
    }
    /**
     * Get the list of available options for this option list. These options will
     * be displayed to users who view this option list in a PDF reader.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * const options = optionList.getOptions()
     * console.log('Option List options:', options)
     * ```
     * @returns The options for this option list.
     */ PDFOptionList.prototype.getOptions = function() {
        var rawOptions = this.acroField.getOptions();
        var options = new Array(rawOptions.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = rawOptions[idx], display = _a.display, value = _a.value;
            options[idx] = (display !== null && display !== void 0 ? display : value).decodeText();
        }
        return options;
    };
    /**
     * Get the selected options for this option list. These are the values that
     * were selected by a human user via a PDF reader, or programatically via
     * software.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * const selections = optionList.getSelected()
     * console.log('Option List selections:', selections)
     * ```
     * @returns The selected options for this option list.
     */ PDFOptionList.prototype.getSelected = function() {
        var values = this.acroField.getValues();
        var selected = new Array(values.length);
        for(var idx = 0, len = values.length; idx < len; idx++)selected[idx] = values[idx].decodeText();
        return selected;
    };
    /**
     * Set the list of options that are available for this option list. These are
     * the values that will be available for users to select when they view this
     * option list in a PDF reader. Note that preexisting options for this
     * option list will be removed. Only the values passed as `options` will be
     * available to select.
     *
     * For example:
     * ```js
     * const optionList = form.getOptionList('planets.optionList')
     * optionList.setOptions(['Earth', 'Mars', 'Pluto', 'Venus'])
     * ```
     *
     * This method will mark this option list as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the options this field contains inside the widgets of this text
     * field (with selected options highlighted).
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if this field contains any options
     * with characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFOptionList.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * @param options The options that should be available in this option list.
     */ PDFOptionList.prototype.setOptions = function(options) {
        (0, $j0tvB.assertIs)(options, 'options', [
            Array
        ]);
        this.markAsDirty();
        var optionObjects = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++)optionObjects[idx] = {
            value: (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(options[idx])
        };
        this.acroField.setOptions(optionObjects);
    };
    /**
     * Add to the list of options that are available for this option list. Users
     * will be able to select these values in a PDF reader. In addition to the
     * values passed as `options`, any preexisting options for this option list
     * will still be available for users to select.
     * For example:
     * ```js
     * const optionList = form.getOptionList('rockets.optionList')
     * optionList.addOptions(['Saturn IV', 'Falcon Heavy'])
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     * @param options New options that should be available in this option list.
     */ PDFOptionList.prototype.addOptions = function(options) {
        (0, $j0tvB.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        this.markAsDirty();
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var existingOptions = this.acroField.getOptions();
        var newOptions = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)newOptions[idx] = {
            value: (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(optionsArr[idx])
        };
        this.acroField.setOptions(existingOptions.concat(newOptions));
    };
    /**
     * Select one or more values for this option list. This operation is analogous
     * to a human user opening the option list in a PDF reader and clicking on one
     * or more values to select them. This method will update the underlying state
     * of the option list to indicate which values have been selected. PDF
     * libraries and readers will be able to extract these values from the saved
     * document and determine which values were selected.
     * For example:
     * ```js
     * const optionList = form.getOptionList('best.superheroes.optionList')
     * optionList.select(['One Punch Man', 'Iron Man'])
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     * @param options The options to be selected.
     * @param merge Whether or not existing selections should be preserved.
     */ PDFOptionList.prototype.select = function(options, merge) {
        if (merge === void 0) merge = false;
        (0, $j0tvB.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        (0, $j0tvB.assertIs)(merge, 'merge', [
            'boolean'
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var validOptions = this.getOptions();
        (0, $j0tvB.assertIsSubset)(optionsArr, 'option', validOptions);
        this.markAsDirty();
        if (optionsArr.length > 1 || optionsArr.length === 1 && merge) this.enableMultiselect();
        var values = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)values[idx] = (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(optionsArr[idx]);
        if (merge) {
            var existingValues = this.acroField.getValues();
            this.acroField.setValues(existingValues.concat(values));
        } else this.acroField.setValues(values);
    };
    /**
     * Clear all selected values for this option list. This operation is
     * equivalent to selecting an empty list. This method will update the
     * underlying state of the option list to indicate that no values have been
     * selected.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.clear()
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     */ PDFOptionList.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValues([]);
    };
    /**
     * Set the font size for the text in this field. There needs to be a
     * default appearance string (DA) set with a font value specified
     * for this to work. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.setFontSize(4);
     * ```
     * @param fontSize The font size to set the font to.
     */ /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this option list. Font sizes
     * may be integer or floating point numbers. Supplying a negative font size
     * will cause this method to throw an error.
     *
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.setFontSize(4)
     * optionList.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFOptionList.prototype.setFontSize = function(fontSize) {
        (0, $j0tvB.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if the options of this option list are always displayed
     * in alphabetical order, irrespective of the order in which the options
     * were added to the option list. See [[PDFOptionList.enableSorting]] and
     * [[PDFOptionList.disableSorting]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isSorted()) console.log('Sorting is enabled')
     * ```
     * @returns Whether or not this option list is sorted.
     */ PDFOptionList.prototype.isSorted = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$eb88827058402599).Sort);
    };
    /**
     * Always display the options of this option list in alphabetical order,
     * irrespective of the order in which the options were added to this option
     * list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableSorting()
     * ```
     */ PDFOptionList.prototype.enableSorting = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).Sort, true);
    };
    /**
     * Do not always display the options of this option list in alphabetical
     * order. Instead, display the options in whichever order they were added
     * to this option list. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableSorting()
     * ```
     */ PDFOptionList.prototype.disableSorting = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).Sort, false);
    };
    /**
     * Returns `true` if multiple options can be selected from this option list.
     * See [[PDFOptionList.enableMultiselect]] and
     * [[PDFOptionList.disableMultiselect]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isMultiselect()) console.log('Multiselect is enabled')
     * ```
     * @returns Whether or not multiple options can be selected.
     */ PDFOptionList.prototype.isMultiselect = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$eb88827058402599).MultiSelect);
    };
    /**
     * Allow users to select more than one option from this option list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableMultiselect()
     * ```
     */ PDFOptionList.prototype.enableMultiselect = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).MultiSelect, true);
    };
    /**
     * Do not allow users to select more than one option from this option list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableMultiselect()
     * ```
     */ PDFOptionList.prototype.disableMultiselect = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).MultiSelect, false);
    };
    /**
     * Returns `true` if the option selected by a user is stored, or "committed",
     * when the user clicks the option. The alternative is that the user's
     * selection is stored when the user leaves this option list field (by
     * clicking outside of it - on another field, for example). See
     * [[PDFOptionList.enableSelectOnClick]] and
     * [[PDFOptionList.disableSelectOnClick]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isSelectOnClick()) console.log('Select on click is enabled')
     * ```
     * @returns Whether or not options are selected immediately after they are
     *          clicked.
     */ PDFOptionList.prototype.isSelectOnClick = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$eb88827058402599).CommitOnSelChange);
    };
    /**
     * Store the option selected by a user immediately after the user clicks the
     * option. Do not wait for the user to leave this option list field (by
     * clicking outside of it - on another field, for example). For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableSelectOnClick()
     * ```
     */ PDFOptionList.prototype.enableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).CommitOnSelChange, true);
    };
    /**
     * Wait to store the option selected by a user until they leave this option
     * list field (by clicking outside of it - on another field, for example).
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableSelectOnClick()
     * ```
     */ PDFOptionList.prototype.disableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).CommitOnSelChange, false);
    };
    /**
     * Show this option list on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const optionList = form.createOptionList('best.gundams')
     * optionList.setOptions(['Exia', 'Dynames', 'Kyrios', 'Virtue'])
     * optionList.select(['Exia', 'Virtue'])
     *
     * optionList.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this option list field.
     * @param page The page to which this option list widget should be added.
     * @param options The options to be used when adding this option list widget.
     */ PDFOptionList.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $j0tvB.assertIs)(page, 'page', [
            [
                (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $9a88d5b8c9019f73$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this option list
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 100,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this option list has been marked as dirty, or if any of
     * this option list's widgets do not have an appearance stream. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this option list needs an appearance update.
     */ PDFOptionList.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this option list's widgets using
     * the default appearance provider for option lists. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFOptionList.prototype.defaultUpdateAppearances = function(font) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $fb353673e42bee9b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this option list's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for option lists will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawOptionList(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFOptionList.prototype.updateAppearances = function(font, provider) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $fb353673e42bee9b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    // getOption(index: number): string {}
    // getSelectedIndices(): number[] {}
    // removeOptions(option: string | string[]) {}
    // removeIndices(option: number[]) {}
    // deselect(options: string | string[]) {}
    // deselectIndices(optionIndices: number[]) {}
    PDFOptionList.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $d5944ab433082972$export$f9fab495286778d2);
        var appearances = (0, $d5944ab433082972$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getOptionList]] method, which will create
     * > an instance of [[PDFOptionList]] for you.
     *
     * Create an instance of [[PDFOptionList]] from an existing acroListBox and
     * ref
     *
     * @param acroComboBox The underlying `PDFAcroListBox` for this option list.
     * @param ref The unique reference for this option list.
     * @param doc The document to which this option list will belong.
     */ PDFOptionList.of = function(acroListBox, ref, doc) {
        return new PDFOptionList(acroListBox, ref, doc);
    };
    return PDFOptionList;
}((0, $9a88d5b8c9019f73$export$2e2bcd8739ae039));
var $41141972e5bafa05$export$2e2bcd8739ae039 = $41141972e5bafa05$var$PDFOptionList;



var $cOQTW = parcelRequire("cOQTW");






var $dPHSK = parcelRequire("dPHSK");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a radio group field of a [[PDFForm]].
 *
 * [[PDFRadioGroup]] fields are collections of radio buttons. The purpose of a
 * radio group is to enable users to select one option from a set of mutually
 * exclusive choices. Each choice in a radio group is represented by a radio
 * button. Radio buttons each have two states: `on` and `off`. At most one
 * radio button in a group may be in the `on` state at any time. Users can
 * click on a radio button to select it (and thereby automatically deselect any
 * other radio button that might have already been selected). Some radio
 * groups allow users to toggle a selected radio button `off` by clicking on
 * it (see [[PDFRadioGroup.isOffToggleable]]).
 *
 * Note that some radio groups allow multiple radio buttons to be in the `on`
 * state at the same type **if** they represent the same underlying value (see
 * [[PDFRadioGroup.isMutuallyExclusive]]).
 */ var $131d580cd94f5347$var$PDFRadioGroup = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFRadioGroup, _super);
    function PDFRadioGroup(acroRadioButton, ref, doc) {
        var _this = _super.call(this, acroRadioButton, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroRadioButton, 'acroRadioButton', [
            [
                (0, $cad74455a26124b0$export$2e2bcd8739ae039),
                'PDFAcroRadioButton'
            ]
        ]);
        _this.acroField = acroRadioButton;
        return _this;
    }
    /**
     * Get the list of available options for this radio group. Each option is
     * represented by a radio button. These radio buttons are displayed at
     * various locations in the document, potentially on different pages (though
     * typically they are stacked horizontally or vertically on the same page).
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * const options = radioGroup.getOptions()
     * console.log('Radio Group options:', options)
     * ```
     * @returns The options for this radio group.
     */ PDFRadioGroup.prototype.getOptions = function() {
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            var exportOptions = new Array(exportValues.length);
            for(var idx = 0, len = exportValues.length; idx < len; idx++)exportOptions[idx] = exportValues[idx].decodeText();
            return exportOptions;
        }
        var onValues = this.acroField.getOnValues();
        var onOptions = new Array(onValues.length);
        for(var idx = 0, len = onOptions.length; idx < len; idx++)onOptions[idx] = onValues[idx].decodeText();
        return onOptions;
    };
    /**
     * Get the selected option for this radio group. The selected option is
     * represented by the radio button in this group that is turned on. At most
     * one radio button in a group can be selected. If no buttons in this group
     * are selected, `undefined` is returned.
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * const selected = radioGroup.getSelected()
     * console.log('Selected radio button:', selected)
     * ```
     * @returns The selected option for this radio group.
     */ PDFRadioGroup.prototype.getSelected = function() {
        var value = this.acroField.getValue();
        if (value === (0, $dPHSK.default).of('Off')) return undefined;
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            var onValues = this.acroField.getOnValues();
            for(var idx = 0, len = onValues.length; idx < len; idx++){
                if (onValues[idx] === value) return exportValues[idx].decodeText();
            }
        }
        return value.decodeText();
    };
    // // TODO: Figure out why this seems to crash Acrobat. Maybe it's because we
    // //       aren't removing the widget reference from the page's Annots?
    // removeOption(option: string) {
    //   assertIs(option, 'option', ['string']);
    //   // TODO: Assert is valid `option`!
    //   const onValues = this.acroField.getOnValues();
    //   const exportValues = this.acroField.getExportValues();
    //   if (exportValues) {
    //     for (let idx = 0, len = exportValues.length; idx < len; idx++) {
    //       if (exportValues[idx].decodeText() === option) {
    //         this.acroField.removeWidget(idx);
    //         this.acroField.removeExportValue(idx);
    //       }
    //     }
    //   } else {
    //     for (let idx = 0, len = onValues.length; idx < len; idx++) {
    //       const value = onValues[idx];
    //       if (value.decodeText() === option) {
    //         this.acroField.removeWidget(idx);
    //         this.acroField.removeExportValue(idx);
    //       }
    //     }
    //   }
    // }
    /**
     * Select an option for this radio group. This operation is analogous to a
     * human user clicking one of the radio buttons in this group via a PDF
     * reader to toggle it on. This method will update the underlying state of
     * the radio group to indicate which option has been selected. PDF libraries
     * and readers will be able to extract this value from the saved document and
     * determine which option was selected.
     *
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('best.superhero.radioGroup')
     * radioGroup.select('One Punch Man')
     * ```
     *
     * This method will mark this radio group as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated appearance
     * streams will display a dot inside the widget of this check box field
     * that represents the selected option.
     *
     * @param option The option to be selected.
     */ PDFRadioGroup.prototype.select = function(option) {
        (0, $j0tvB.assertIs)(option, 'option', [
            'string'
        ]);
        var validOptions = this.getOptions();
        (0, $j0tvB.assertIsOneOf)(option, 'option', validOptions);
        this.markAsDirty();
        var onValues = this.acroField.getOnValues();
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            for(var idx = 0, len = exportValues.length; idx < len; idx++)if (exportValues[idx].decodeText() === option) this.acroField.setValue(onValues[idx]);
        } else for(var idx = 0, len = onValues.length; idx < len; idx++){
            var value = onValues[idx];
            if (value.decodeText() === option) this.acroField.setValue(value);
        }
    };
    /**
     * Clear any selected option for this dropdown. This will result in all
     * radio buttons in this group being toggled off. This method will update
     * the underlying state of the dropdown to indicate that no radio buttons
     * have been selected.
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.clear()
     * ```
     * This method will mark this radio group as dirty. See
     * [[PDFRadioGroup.select]] for more details about what this means.
     */ PDFRadioGroup.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValue((0, $dPHSK.default).of('Off'));
    };
    /**
     * Returns `true` if users can click on radio buttons in this group to toggle
     * them off. The alternative is that once a user clicks on a radio button
     * to select it, the only way to deselect it is by selecting on another radio
     * button in the group. See [[PDFRadioGroup.enableOffToggling]] and
     * [[PDFRadioGroup.disableOffToggling]]. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.isOffToggleable()) console.log('Off toggling is enabled')
     * ```
     */ PDFRadioGroup.prototype.isOffToggleable = function() {
        return !this.acroField.hasFlag((0, $987e37c460e8464e$export$59f660e89ffb4f8a).NoToggleToOff);
    };
    /**
     * Allow users to click on selected radio buttons in this group to toggle
     * them off. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.enableOffToggling()
     * ```
     * > **NOTE:** This feature is documented in the PDF specification
     * > (Table 226). However, most PDF readers do not respect this option and
     * > prevent users from toggling radio buttons off even when it is enabled.
     * > At the time of this writing (9/6/2020) Mac's Preview software did
     * > respect the option. Adobe Acrobat, Foxit Reader, and Google Chrome did
     * > not.
     */ PDFRadioGroup.prototype.enableOffToggling = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$59f660e89ffb4f8a).NoToggleToOff, false);
    };
    /**
     * Prevent users from clicking on selected radio buttons in this group to
     * toggle them off. Clicking on a selected radio button will have no effect.
     * The only way to deselect a selected radio button is to click on a
     * different radio button in the group. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.disableOffToggling()
     * ```
     */ PDFRadioGroup.prototype.disableOffToggling = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$59f660e89ffb4f8a).NoToggleToOff, true);
    };
    /**
     * Returns `true` if the radio buttons in this group are mutually exclusive.
     * This means that when the user selects a radio button, only that specific
     * button will be turned on. Even if other radio buttons in the group
     * represent the same value, they will not be enabled. The alternative to
     * this is that clicking a radio button will select that button along with
     * any other radio buttons in the group that share the same value. See
     * [[PDFRadioGroup.enableMutualExclusion]] and
     * [[PDFRadioGroup.disableMutualExclusion]].
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.isMutuallyExclusive()) console.log('Mutual exclusion is enabled')
     * ```
     */ PDFRadioGroup.prototype.isMutuallyExclusive = function() {
        return !this.acroField.hasFlag((0, $987e37c460e8464e$export$59f660e89ffb4f8a).RadiosInUnison);
    };
    /**
     * When the user clicks a radio button in this group it will be selected. In
     * addition, any other radio buttons in this group that share the same
     * underlying value will also be selected. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.enableMutualExclusion()
     * ```
     * Note that this option must be enabled prior to adding options to the
     * radio group. It does not currently apply retroactively to existing
     * radio buttons in the group.
     */ PDFRadioGroup.prototype.enableMutualExclusion = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$59f660e89ffb4f8a).RadiosInUnison, false);
    };
    /**
     * When the user clicks a radio button in this group only it will be selected.
     * No other radio buttons in the group will be selected, even if they share
     * the same underlying value. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.disableMutualExclusion()
     * ```
     * Note that this option must be disabled prior to adding options to the
     * radio group. It does not currently apply retroactively to existing
     * radio buttons in the group.
     */ PDFRadioGroup.prototype.disableMutualExclusion = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$59f660e89ffb4f8a).RadiosInUnison, true);
    };
    /**
     * Add a new radio button to this group on the specified page. For example:
     * ```js
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const radioGroup = form.createRadioGroup('best.gundam')
     *
     * const options = {
     *   x: 50,
     *   width: 25,
     *   height: 25,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     * }
     *
     * radioGroup.addOptionToPage('Exia', page, { ...options, y: 50 })
     * radioGroup.addOptionToPage('Dynames', page, { ...options, y: 110 })
     * ```
     * This will create a new radio button widget for this radio group field.
     * @param option The option that the radio button widget represents.
     * @param page The page to which the radio button widget should be added.
     * @param options The options to be used when adding the radio button widget.
     */ PDFRadioGroup.prototype.addOptionToPage = function(option, page, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        (0, $j0tvB.assertIs)(option, 'option', [
            'string'
        ]);
        (0, $j0tvB.assertIs)(page, 'page', [
            [
                (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $9a88d5b8c9019f73$export$55643210f1835a35)(options);
        // Create a widget for this radio button
        var widget = this.createWidget({
            x: (_a = options === null || options === void 0 ? void 0 : options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options === null || options === void 0 ? void 0 : options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options === null || options === void 0 ? void 0 : options.width) !== null && _c !== void 0 ? _c : 50,
            height: (_d = options === null || options === void 0 ? void 0 : options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: (_e = options === null || options === void 0 ? void 0 : options.textColor) !== null && _e !== void 0 ? _e : (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0),
            backgroundColor: (_f = options === null || options === void 0 ? void 0 : options.backgroundColor) !== null && _f !== void 0 ? _f : (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(1, 1, 1),
            borderColor: (_g = options === null || options === void 0 ? void 0 : options.borderColor) !== null && _g !== void 0 ? _g : (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0),
            borderWidth: (_h = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _h !== void 0 ? _h : 1,
            rotate: (_j = options === null || options === void 0 ? void 0 : options.rotate) !== null && _j !== void 0 ? _j : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            hidden: options === null || options === void 0 ? void 0 : options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        var apStateValue = this.acroField.addWidgetWithOpt(widgetRef, (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(option), !this.isMutuallyExclusive());
        // Set appearance streams for widget
        widget.setAppearanceState((0, $dPHSK.default).of('Off'));
        this.updateWidgetAppearance(widget, apStateValue);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if any of this group's radio button widgets do not have an
     * appearance stream for their current state. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this radio group needs an appearance update.
     */ PDFRadioGroup.prototype.needsAppearancesUpdate = function() {
        var _a;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getAppearanceState();
            var normal = (_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
            if (!(normal instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039))) return true;
            if (state && !normal.has(state)) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this group's radio button widgets
     * using the default appearance provider for radio groups. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.defaultUpdateAppearances()
     * ```
     */ PDFRadioGroup.prototype.defaultUpdateAppearances = function() {
        this.updateAppearances();
    };
    // rg.updateAppearances((field: any, widget: any) => {
    //   assert(field === rg);
    //   assert(widget instanceof PDFWidgetAnnotation);
    //   return { on: [...rectangle, ...circle], off: [...rectangle, ...circle] };
    // });
    /**
     * Update the appearance streams for each of this group's radio button widgets
     * using the given appearance provider. If no `provider` is passed, the
     * default appearance provider for radio groups will be used. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.updateAppearances((field, widget) => {
     *   ...
     *   return {
     *     normal: { on: drawRadioButton(...), off: drawRadioButton(...) },
     *     down: { on: drawRadioButton(...), off: drawRadioButton(...) },
     *   }
     * })
     * ```
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFRadioGroup.prototype.updateAppearances = function(provider) {
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var onValue = widget.getOnValue();
            if (!onValue) continue;
            this.updateWidgetAppearance(widget, onValue, provider);
        }
    };
    PDFRadioGroup.prototype.updateWidgetAppearance = function(widget, onValue, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $d5944ab433082972$export$6440094330a99ef8);
        var appearances = (0, $d5944ab433082972$export$8a3aea031520d39b)(apProvider(this, widget));
        this.updateOnOffWidgetAppearance(widget, onValue, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getOptionList]] method, which will create an
     * > instance of [[PDFOptionList]] for you.
     *
     * Create an instance of [[PDFOptionList]] from an existing acroRadioButton
     * and ref
     *
     * @param acroRadioButton The underlying `PDFAcroRadioButton` for this
     *                        radio group.
     * @param ref The unique reference for this radio group.
     * @param doc The document to which this radio group will belong.
     */ PDFRadioGroup.of = function(acroRadioButton, ref, doc) {
        return new PDFRadioGroup(acroRadioButton, ref, doc);
    };
    return PDFRadioGroup;
}((0, $9a88d5b8c9019f73$export$2e2bcd8739ae039));
var $131d580cd94f5347$export$2e2bcd8739ae039 = $131d580cd94f5347$var$PDFRadioGroup;



var $cOQTW = parcelRequire("cOQTW");


parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a signature field of a [[PDFForm]].
 *
 * [[PDFSignature]] fields are digital signatures. `pdf-lib` does not
 * currently provide any specialized APIs for creating digital signatures or
 * reading the contents of existing digital signatures.
 */ var $cca3a084a6440272$var$PDFSignature = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFSignature, _super);
    function PDFSignature(acroSignature, ref, doc) {
        var _this = _super.call(this, acroSignature, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroSignature, 'acroSignature', [
            [
                (0, $54d8c5346cdc5323$export$2e2bcd8739ae039),
                'PDFAcroSignature'
            ]
        ]);
        _this.acroField = acroSignature;
        return _this;
    }
    PDFSignature.prototype.needsAppearancesUpdate = function() {
        return false;
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getSignature]] method, which will create an
     * > instance of [[PDFSignature]] for you.
     *
     * Create an instance of [[PDFSignature]] from an existing acroSignature and
     * ref
     *
     * @param acroSignature The underlying `PDFAcroSignature` for this signature.
     * @param ref The unique reference for this signature.
     * @param doc The document to which this signature will belong.
     */ PDFSignature.of = function(acroSignature, ref, doc) {
        return new PDFSignature(acroSignature, ref, doc);
    };
    return PDFSignature;
}((0, $9a88d5b8c9019f73$export$2e2bcd8739ae039));
var $cca3a084a6440272$export$2e2bcd8739ae039 = $cca3a084a6440272$var$PDFSignature;



var $cOQTW = parcelRequire("cOQTW");










parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a text field of a [[PDFForm]].
 *
 * [[PDFTextField]] fields are boxes that display text entered by the user. The
 * purpose of a text field is to enable users to enter text or view text values
 * in the document prefilled by software. Users can click on a text field and
 * input text via their keyboard. Some text fields allow multiple lines of text
 * to be entered (see [[PDFTextField.isMultiline]]).
 */ var $f989cc5b81a68a40$var$PDFTextField = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFTextField, _super);
    function PDFTextField(acroText, ref, doc) {
        var _this = _super.call(this, acroText, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroText, 'acroText', [
            [
                (0, $8fd9de5d2343325e$export$2e2bcd8739ae039),
                'PDFAcroText'
            ]
        ]);
        _this.acroField = acroText;
        return _this;
    }
    /**
     * Get the text that this field contains. This text is visible to users who
     * view this field in a PDF reader.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const text = textField.getText()
     * console.log('Text field contents:', text)
     * ```
     *
     * Note that if this text field contains no underlying value, `undefined`
     * will be returned. Text fields may also contain an underlying value that
     * is simply an empty string (`''`). This detail is largely irrelevant for
     * most applications. In general, you'll want to treat both cases the same
     * way and simply consider the text field to be empty. In either case, the
     * text field will appear empty to users when viewed in a PDF reader.
     *
     * An error will be thrown if this is a rich text field. `pdf-lib` does not
     * support reading rich text fields. Nor do most PDF readers and writers.
     * Rich text fields are based on XFA (XML Forms Architecture). Relatively few
     * PDFs use rich text fields or XFA. Unlike PDF itself, XFA is not an ISO
     * standard. XFA has been deprecated in PDF 2.0:
     * * https://en.wikipedia.org/wiki/XFA
     * * http://blog.pdfshareforms.com/pdf-2-0-release-bid-farewell-xfa-forms/
     *
     * @returns The text contained in this text field.
     */ PDFTextField.prototype.getText = function() {
        var value = this.acroField.getValue();
        if (!value && this.isRichFormatted()) throw new (0, $7fe2d034822cb526$export$f2fed572e1ed57ab)(this.getName());
        return value === null || value === void 0 ? void 0 : value.decodeText();
    };
    /**
     * Set the text for this field. This operation is analogous to a human user
     * clicking on the text field in a PDF reader and typing in text via their
     * keyboard. This method will update the underlying state of the text field
     * to indicate what text has been set. PDF libraries and readers will be able
     * to extract these values from the saved document and determine what text
     * was set.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('best.superhero.text.field')
     * textField.setText('One Punch Man')
     * ```
     *
     * This method will mark this text field as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the text this field contains inside the widgets of this text
     * field.
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if this field contains text outside
     * the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFTextField.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * If this is a rich text field, it will be converted to a standard text
     * field in order to set the text. `pdf-lib` does not support writing rich
     * text strings. Nor do most PDF readers and writers. See
     * [[PDFTextField.getText]] for more information about rich text fields and
     * their deprecation in PDF 2.0.
     *
     * @param text The text this field should contain.
     */ PDFTextField.prototype.setText = function(text) {
        (0, $j0tvB.assertOrUndefined)(text, 'text', [
            'string'
        ]);
        var maxLength = this.getMaxLength();
        if (maxLength !== undefined && text && text.length > maxLength) throw new (0, $7fe2d034822cb526$export$1577e99040d42609)(text.length, maxLength, this.getName());
        this.markAsDirty();
        this.disableRichFormatting();
        if (text) this.acroField.setValue((0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(text));
        else this.acroField.removeValue();
    };
    /**
     * Get the alignment for this text field. This value represents the
     * justification of the text when it is displayed to the user in PDF readers.
     * There are three possible alignments: left, center, and right. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const alignment = textField.getAlignment()
     * if (alignment === TextAlignment.Left) console.log('Text is left justified')
     * if (alignment === TextAlignment.Center) console.log('Text is centered')
     * if (alignment === TextAlignment.Right) console.log('Text is right justified')
     * ```
     * @returns The alignment of this text field.
     */ PDFTextField.prototype.getAlignment = function() {
        var quadding = this.acroField.getQuadding();
        // prettier-ignore
        return quadding === 0 ? (0, $010595e4078a43c6$export$84b2d1b68830363f).Left : quadding === 1 ? (0, $010595e4078a43c6$export$84b2d1b68830363f).Center : quadding === 2 ? (0, $010595e4078a43c6$export$84b2d1b68830363f).Right : (0, $010595e4078a43c6$export$84b2d1b68830363f).Left;
    };
    /**
     * Set the alignment for this text field. This will determine the
     * justification of the text when it is displayed to the user in PDF readers.
     * There are three possible alignments: left, center, and right. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     *
     * // Text will be left justified when displayed
     * textField.setAlignment(TextAlignment.Left)
     *
     * // Text will be centered when displayed
     * textField.setAlignment(TextAlignment.Center)
     *
     * // Text will be right justified when displayed
     * textField.setAlignment(TextAlignment.Right)
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     * @param alignment The alignment for this text field.
     */ PDFTextField.prototype.setAlignment = function(alignment) {
        (0, $j0tvB.assertIsOneOf)(alignment, 'alignment', (0, $010595e4078a43c6$export$84b2d1b68830363f));
        this.markAsDirty();
        this.acroField.setQuadding(alignment);
    };
    /**
     * Get the maximum length of this field. This value represents the maximum
     * number of characters that can be typed into this field by the user. If
     * this field does not have a maximum length, `undefined` is returned.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const maxLength = textField.getMaxLength()
     * if (maxLength === undefined) console.log('No max length')
     * else console.log(`Max length is ${maxLength}`)
     * ```
     * @returns The maximum number of characters allowed in this field, or
     *          `undefined` if no limit exists.
     */ PDFTextField.prototype.getMaxLength = function() {
        return this.acroField.getMaxLength();
    };
    /**
     * Set the maximum length of this field. This limits the number of characters
     * that can be typed into this field by the user. This also limits the length
     * of the string that can be passed to [[PDFTextField.setText]]. This limit
     * can be removed by passing `undefined` as `maxLength`. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     *
     * // Allow between 0 and 5 characters to be entered
     * textField.setMaxLength(5)
     *
     * // Allow any number of characters to be entered
     * textField.setMaxLength(undefined)
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     * @param maxLength The maximum number of characters allowed in this field, or
     *                  `undefined` to remove the limit.
     */ PDFTextField.prototype.setMaxLength = function(maxLength) {
        (0, $j0tvB.assertRangeOrUndefined)(maxLength, 'maxLength', 0, Number.MAX_SAFE_INTEGER);
        this.markAsDirty();
        if (maxLength === undefined) this.acroField.removeMaxLength();
        else {
            var text = this.getText();
            if (text && text.length > maxLength) throw new (0, $7fe2d034822cb526$export$6da6c372180e79b0)(text.length, maxLength, this.getName());
            this.acroField.setMaxLength(maxLength);
        }
    };
    /**
     * Remove the maximum length for this text field. This allows any number of
     * characters to be typed into this field by the user. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.removeMaxLength()
     * ```
     * Calling this method is equivalent to passing `undefined` to
     * [[PDFTextField.setMaxLength]].
     */ PDFTextField.prototype.removeMaxLength = function() {
        this.markAsDirty();
        this.acroField.removeMaxLength();
    };
    /**
     * Display an image inside the bounds of this text field's widgets. For example:
     * ```js
     * const pngImage = await pdfDoc.embedPng(...)
     * const textField = form.getTextField('some.text.field')
     * textField.setImage(pngImage)
     * ```
     * This will update the appearances streams for each of this text field's widgets.
     * @param image The image that should be displayed.
     */ PDFTextField.prototype.setImage = function(image) {
        var fieldAlignment = this.getAlignment();
        // prettier-ignore
        var alignment = fieldAlignment === (0, $010595e4078a43c6$export$84b2d1b68830363f).Center ? (0, $c5ccd91931a24d5b$export$8efa99ca8f041e7e).Center : fieldAlignment === (0, $010595e4078a43c6$export$84b2d1b68830363f).Right ? (0, $c5ccd91931a24d5b$export$8efa99ca8f041e7e).Right : (0, $c5ccd91931a24d5b$export$8efa99ca8f041e7e).Left;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var streamRef = this.createImageAppearanceStream(widget, image, alignment);
            this.updateWidgetAppearances(widget, {
                normal: streamRef
            });
        }
        this.markAsClean();
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this text field. Font sizes
     * may be integer or floating point numbers. Supplying a negative font size
     * will cause this method to throw an error.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.setFontSize(4)
     * textField.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFTextField.prototype.setFontSize = function(fontSize) {
        (0, $j0tvB.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if each line of text is shown on a new line when this
     * field is displayed in a PDF reader. The alternative is that all lines of
     * text are merged onto a single line when displayed. See
     * [[PDFTextField.enableMultiline]] and [[PDFTextField.disableMultiline]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isMultiline()) console.log('Multiline is enabled')
     * ```
     * @returns Whether or not this is a multiline text field.
     */ PDFTextField.prototype.isMultiline = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$389fc7b97397dc8b).Multiline);
    };
    /**
     * Display each line of text on a new line when this field is displayed in a
     * PDF reader. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableMultiline()
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.enableMultiline = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).Multiline, true);
    };
    /**
     * Display each line of text on the same line when this field is displayed
     * in a PDF reader. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableMultiline()
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.disableMultiline = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).Multiline, false);
    };
    /**
     * Returns `true` if this is a password text field. This means that the field
     * is intended for storing a secure password. See
     * [[PDFTextField.enablePassword]] and [[PDFTextField.disablePassword]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isPassword()) console.log('Password is enabled')
     * ```
     * @returns Whether or not this is a password text field.
     */ PDFTextField.prototype.isPassword = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$389fc7b97397dc8b).Password);
    };
    /**
     * Indicate that this text field is intended for storing a secure password.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enablePassword()
     * ```
     * Values entered into password text fields should not be displayed on the
     * screen by PDF readers. Most PDF readers will display the value as
     * asterisks or bullets. PDF readers should never store values entered by the
     * user into password text fields. Similarly, applications should not
     * write data to a password text field.
     *
     * **Please note that this method does not cause entered values to be
     * encrypted or secured in any way! It simply sets a flag that PDF software
     * and readers can access to determine the _purpose_ of this field.**
     */ PDFTextField.prototype.enablePassword = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).Password, true);
    };
    /**
     * Indicate that this text field is **not** intended for storing a secure
     * password. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disablePassword()
     * ```
     */ PDFTextField.prototype.disablePassword = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).Password, false);
    };
    /**
     * Returns `true` if the contents of this text field represent a file path.
     * See [[PDFTextField.enableFileSelection]] and
     * [[PDFTextField.disableFileSelection]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isFileSelector()) console.log('Is a file selector')
     * ```
     * @returns Whether or not this field should contain file paths.
     */ PDFTextField.prototype.isFileSelector = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$389fc7b97397dc8b).FileSelect);
    };
    /**
     * Indicate that this text field is intended to store a file path. The
     * contents of the file stored at that path should be submitted as the value
     * of the field. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableFileSelection()
     * ```
     */ PDFTextField.prototype.enableFileSelection = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).FileSelect, true);
    };
    /**
     * Indicate that this text field is **not** intended to store a file path.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableFileSelection()
     * ```
     */ PDFTextField.prototype.disableFileSelection = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).FileSelect, false);
    };
    /**
     * Returns `true` if the text entered in this field should be spell checked
     * by PDF readers. See [[PDFTextField.enableSpellChecking]] and
     * [[PDFTextField.disableSpellChecking]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isSpellChecked()) console.log('Spell checking is enabled')
     * ```
     * @returns Whether or not this field should be spell checked.
     */ PDFTextField.prototype.isSpellChecked = function() {
        return !this.acroField.hasFlag((0, $987e37c460e8464e$export$389fc7b97397dc8b).DoNotSpellCheck);
    };
    /**
     * Allow PDF readers to spell check the text entered in this field.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableSpellChecking()
     * ```
     */ PDFTextField.prototype.enableSpellChecking = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).DoNotSpellCheck, false);
    };
    /**
     * Do not allow PDF readers to spell check the text entered in this field.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableSpellChecking()
     * ```
     */ PDFTextField.prototype.disableSpellChecking = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).DoNotSpellCheck, true);
    };
    /**
     * Returns `true` if PDF readers should allow the user to scroll the text
     * field when its contents do not fit within the field's view bounds. See
     * [[PDFTextField.enableScrolling]] and [[PDFTextField.disableScrolling]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isScrollable()) console.log('Scrolling is enabled')
     * ```
     * @returns Whether or not the field is scrollable in PDF readers.
     */ PDFTextField.prototype.isScrollable = function() {
        return !this.acroField.hasFlag((0, $987e37c460e8464e$export$389fc7b97397dc8b).DoNotScroll);
    };
    /**
     * Allow PDF readers to present a scroll bar to the user when the contents
     * of this text field do not fit within its view bounds. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableScrolling()
     * ```
     * A horizontal scroll bar should be shown for singleline fields. A vertical
     * scroll bar should be shown for multiline fields.
     */ PDFTextField.prototype.enableScrolling = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).DoNotScroll, false);
    };
    /**
     * Do not allow PDF readers to present a scroll bar to the user when the
     * contents of this text field do not fit within its view bounds. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableScrolling()
     * ```
     */ PDFTextField.prototype.disableScrolling = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).DoNotScroll, true);
    };
    /**
     * Returns `true` if this is a combed text field. This means that the field
     * is split into `n` equal size cells with one character in each (where `n`
     * is equal to the max length of the text field). The result is that all
     * characters in this field are displayed an equal distance apart from one
     * another. See [[PDFTextField.enableCombing]] and
     * [[PDFTextField.disableCombing]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isCombed()) console.log('Combing is enabled')
     * ```
     * Note that in order for a text field to be combed, the following must be
     * true (in addition to enabling combing):
     * * It must not be a multiline field (see [[PDFTextField.isMultiline]])
     * * It must not be a password field (see [[PDFTextField.isPassword]])
     * * It must not be a file selector field (see [[PDFTextField.isFileSelector]])
     * * It must have a max length defined (see [[PDFTextField.setMaxLength]])
     * @returns Whether or not this field is combed.
     */ PDFTextField.prototype.isCombed = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$389fc7b97397dc8b).Comb) && !this.isMultiline() && !this.isPassword() && !this.isFileSelector() && this.getMaxLength() !== undefined;
    };
    /**
     * Split this field into `n` equal size cells with one character in each
     * (where `n` is equal to the max length of the text field). This will cause
     * all characters in the field to be displayed an equal distance apart from
     * one another. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableCombing()
     * ```
     *
     * In addition to calling this method, text fields must have a max length
     * defined in order to be combed (see [[PDFTextField.setMaxLength]]).
     *
     * This method will also call the following three methods internally:
     * * [[PDFTextField.disableMultiline]]
     * * [[PDFTextField.disablePassword]]
     * * [[PDFTextField.disableFileSelection]]
     *
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.enableCombing = function() {
        if (this.getMaxLength() === undefined) {
            var msg = "PDFTextFields must have a max length in order to be combed";
            console.warn(msg);
        }
        this.markAsDirty();
        this.disableMultiline();
        this.disablePassword();
        this.disableFileSelection();
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).Comb, true);
    };
    /**
     * Turn off combing for this text field. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableCombing()
     * ```
     * See [[PDFTextField.isCombed]] and [[PDFTextField.enableCombing]] for more
     * information about what combing is.
     *
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.disableCombing = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).Comb, false);
    };
    /**
     * Returns `true` if this text field contains rich text. See
     * [[PDFTextField.enableRichFormatting]] and
     * [[PDFTextField.disableRichFormatting]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isRichFormatted()) console.log('Rich formatting enabled')
     * ```
     * @returns Whether or not this field contains rich text.
     */ PDFTextField.prototype.isRichFormatted = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$389fc7b97397dc8b).RichText);
    };
    /**
     * Indicate that this field contains XFA data - or rich text. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableRichFormatting()
     * ```
     * Note that `pdf-lib` does not support reading or writing rich text fields.
     * Nor do most PDF readers and writers. Rich text fields are based on XFA
     * (XML Forms Architecture). Relatively few PDFs use rich text fields or XFA.
     * Unlike PDF itself, XFA is not an ISO standard. XFA has been deprecated in
     * PDF 2.0:
     * * https://en.wikipedia.org/wiki/XFA
     * * http://blog.pdfshareforms.com/pdf-2-0-release-bid-farewell-xfa-forms/
     */ PDFTextField.prototype.enableRichFormatting = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).RichText, true);
    };
    /**
     * Indicate that this is a standard text field that does not XFA data (rich
     * text). For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableRichFormatting()
     * ```
     */ PDFTextField.prototype.disableRichFormatting = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).RichText, false);
    };
    /**
     * Show this text field on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const textField = form.createTextField('best.gundam')
     * textField.setText('Exia')
     *
     * textField.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this text field.
     * @param page The page to which this text field widget should be added.
     * @param options The options to be used when adding this text field widget.
     */ PDFTextField.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $j0tvB.assertIs)(page, 'page', [
            [
                (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $9a88d5b8c9019f73$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this text field
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this text field has been marked as dirty, or if any of
     * this text field's widgets do not have an appearance stream. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this text field needs an appearance update.
     */ PDFTextField.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this text field's widgets using
     * the default appearance provider for text fields. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const textField = form.getTextField('some.text.field')
     * textField.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFTextField.prototype.defaultUpdateAppearances = function(font) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $fb353673e42bee9b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this text field's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for text fields will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const textField = form.getTextField('some.text.field')
     * textField.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawTextField(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFTextField.prototype.updateAppearances = function(font, provider) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $fb353673e42bee9b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    PDFTextField.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $d5944ab433082972$export$42ba95e6b8df3d7);
        var appearances = (0, $d5944ab433082972$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getTextField]] method, which will create an
     * > instance of [[PDFTextField]] for you.
     *
     * Create an instance of [[PDFTextField]] from an existing acroText and ref
     *
     * @param acroText The underlying `PDFAcroText` for this text field.
     * @param ref The unique reference for this text field.
     * @param doc The document to which this text field will belong.
     */ PDFTextField.of = function(acroText, ref, doc) {
        return new PDFTextField(acroText, ref, doc);
    };
    return PDFTextField;
}((0, $9a88d5b8c9019f73$export$2e2bcd8739ae039));
var $f989cc5b81a68a40$export$2e2bcd8739ae039 = $f989cc5b81a68a40$var$PDFTextField;




var $d275b823cf3c6e5b$export$7dcb046109e65a3d;
(function(StandardFonts) {
    StandardFonts["Courier"] = "Courier";
    StandardFonts["CourierBold"] = "Courier-Bold";
    StandardFonts["CourierOblique"] = "Courier-Oblique";
    StandardFonts["CourierBoldOblique"] = "Courier-BoldOblique";
    StandardFonts["Helvetica"] = "Helvetica";
    StandardFonts["HelveticaBold"] = "Helvetica-Bold";
    StandardFonts["HelveticaOblique"] = "Helvetica-Oblique";
    StandardFonts["HelveticaBoldOblique"] = "Helvetica-BoldOblique";
    StandardFonts["TimesRoman"] = "Times-Roman";
    StandardFonts["TimesRomanBold"] = "Times-Bold";
    StandardFonts["TimesRomanItalic"] = "Times-Italic";
    StandardFonts["TimesRomanBoldItalic"] = "Times-BoldItalic";
    StandardFonts["Symbol"] = "Symbol";
    StandardFonts["ZapfDingbats"] = "ZapfDingbats";
})($d275b823cf3c6e5b$export$7dcb046109e65a3d || ($d275b823cf3c6e5b$export$7dcb046109e65a3d = {}));





var $dPHSK = parcelRequire("dPHSK");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var $clYSv = parcelRequire("clYSv");
/**
 * Represents the interactive form of a [[PDFDocument]].
 *
 * Interactive forms (sometimes called _AcroForms_) are collections of fields
 * designed to gather information from a user. A PDF document may contains any
 * number of fields that appear on various pages, all of which make up a single,
 * global interactive form spanning the entire document. This means that
 * instances of [[PDFDocument]] shall contain at most one [[PDFForm]].
 *
 * The fields of an interactive form are represented by [[PDFField]] instances.
 */ var $1ca8b80442f19ab5$var$PDFForm = /** @class */ function() {
    function PDFForm(acroForm, doc) {
        var _this = this;
        this.embedDefaultFont = function() {
            return _this.doc.embedStandardFont((0, $d275b823cf3c6e5b$export$7dcb046109e65a3d).Helvetica);
        };
        (0, $j0tvB.assertIs)(acroForm, 'acroForm', [
            [
                (0, $b2be38e1e2597241$export$2e2bcd8739ae039),
                'PDFAcroForm'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $93b2571d4e1dfe94$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        this.acroForm = acroForm;
        this.doc = doc;
        this.dirtyFields = new Set();
        this.defaultFontCache = (0, $clYSv.default).populatedBy(this.embedDefaultFont);
    }
    /**
     * Returns `true` if this [[PDFForm]] has XFA data. Most PDFs with form
     * fields do not use XFA as it is not widely supported by PDF readers.
     *
     * > `pdf-lib` does not support creation, modification, or reading of XFA
     * > fields.
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * if (form.hasXFA()) console.log('PDF has XFA data')
     * ```
     * @returns Whether or not this form has XFA data.
     */ PDFForm.prototype.hasXFA = function() {
        return this.acroForm.dict.has((0, $dPHSK.default).of('XFA'));
    };
    /**
     * Disconnect the XFA data from this [[PDFForm]] (if any exists). This will
     * force readers to fallback to standard fields if the [[PDFDocument]]
     * contains any. For example:
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * form.deleteXFA()
     * ```
     */ PDFForm.prototype.deleteXFA = function() {
        this.acroForm.dict.delete((0, $dPHSK.default).of('XFA'));
    };
    /**
     * Get all fields contained in this [[PDFForm]]. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const type = field.constructor.name
     *   const name = field.getName()
     *   console.log(`${type}: ${name}`)
     * })
     * ```
     * @returns An array of all fields in this form.
     */ PDFForm.prototype.getFields = function() {
        var allFields = this.acroForm.getAllFields();
        var fields = [];
        for(var idx = 0, len = allFields.length; idx < len; idx++){
            var _a = allFields[idx], acroField = _a[0], ref = _a[1];
            var field = $1ca8b80442f19ab5$var$convertToPDFField(acroField, ref, this.doc);
            if (field) fields.push(field);
        }
        return fields;
    };
    /**
     * Get the field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getFieldMaybe('Page1.Foo.Bar[0]')
     * if (field) console.log('Field exists!')
     * ```
     * @param name A fully qualified field name.
     * @returns The field with the specified name, if one exists.
     */ PDFForm.prototype.getFieldMaybe = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var fields = this.getFields();
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var field = fields[idx];
            if (field.getName() === name) return field;
        }
        return undefined;
    };
    /**
     * Get the field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('Page1.Foo.Bar[0]')
     * ```
     * If no field exists with the provided name, an error will be thrown.
     * @param name A fully qualified field name.
     * @returns The field with the specified name.
     */ PDFForm.prototype.getField = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getFieldMaybe(name);
        if (field) return field;
        throw new (0, $7fe2d034822cb526$export$5bc08baa4a027cbd)(name);
    };
    /**
     * Get the button field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const button = form.getButton('Page1.Foo.Button[0]')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a button.
     * @param name A fully qualified button name.
     * @returns The button with the specified name.
     */ PDFForm.prototype.getButton = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $b3771f5aa96680ee$export$2e2bcd8739ae039)) return field;
        throw new (0, $7fe2d034822cb526$export$8909da6c566ff652)(name, (0, $b3771f5aa96680ee$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the check box field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const checkBox = form.getCheckBox('Page1.Foo.CheckBox[0]')
     * checkBox.check()
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a check box.
     * @param name A fully qualified check box name.
     * @returns The check box with the specified name.
     */ PDFForm.prototype.getCheckBox = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $4740dcccc2940521$export$2e2bcd8739ae039)) return field;
        throw new (0, $7fe2d034822cb526$export$8909da6c566ff652)(name, (0, $4740dcccc2940521$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the dropdown field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const dropdown = form.getDropdown('Page1.Foo.Dropdown[0]')
     * const options = dropdown.getOptions()
     * dropdown.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a dropdown.
     * @param name A fully qualified dropdown name.
     * @returns The dropdown with the specified name.
     */ PDFForm.prototype.getDropdown = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $8c3a0a776d3c65cf$export$2e2bcd8739ae039)) return field;
        throw new (0, $7fe2d034822cb526$export$8909da6c566ff652)(name, (0, $8c3a0a776d3c65cf$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the option list field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const optionList = form.getOptionList('Page1.Foo.OptionList[0]')
     * const options = optionList.getOptions()
     * optionList.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not an option list.
     * @param name A fully qualified option list name.
     * @returns The option list with the specified name.
     */ PDFForm.prototype.getOptionList = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $41141972e5bafa05$export$2e2bcd8739ae039)) return field;
        throw new (0, $7fe2d034822cb526$export$8909da6c566ff652)(name, (0, $41141972e5bafa05$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the radio group field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const radioGroup = form.getRadioGroup('Page1.Foo.RadioGroup[0]')
     * const options = radioGroup.getOptions()
     * radioGroup.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a radio group.
     * @param name A fully qualified radio group name.
     * @returns The radio group with the specified name.
     */ PDFForm.prototype.getRadioGroup = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $131d580cd94f5347$export$2e2bcd8739ae039)) return field;
        throw new (0, $7fe2d034822cb526$export$8909da6c566ff652)(name, (0, $131d580cd94f5347$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the signature field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const signature = form.getSignature('Page1.Foo.Signature[0]')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a signature.
     * @param name A fully qualified signature name.
     * @returns The signature with the specified name.
     */ PDFForm.prototype.getSignature = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $cca3a084a6440272$export$2e2bcd8739ae039)) return field;
        throw new (0, $7fe2d034822cb526$export$8909da6c566ff652)(name, (0, $cca3a084a6440272$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the text field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const textField = form.getTextField('Page1.Foo.TextField[0]')
     * textField.setText('Are you designed to act or to be acted upon?')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a text field.
     * @param name A fully qualified text field name.
     * @returns The text field with the specified name.
     */ PDFForm.prototype.getTextField = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $f989cc5b81a68a40$export$2e2bcd8739ae039)) return field;
        throw new (0, $7fe2d034822cb526$export$8909da6c566ff652)(name, (0, $f989cc5b81a68a40$export$2e2bcd8739ae039), field);
    };
    /**
     * Create a new button field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const button = form.createButton('cool.new.button')
     *
     * button.addToPage('Do Stuff', font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new button.
     * @returns The new button field.
     */ PDFForm.prototype.createButton = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var button = (0, $0cfa6a9523f95402$export$2e2bcd8739ae039).create(this.doc.context);
        button.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            button,
            button.ref
        ], nameParts.terminal);
        return (0, $b3771f5aa96680ee$export$2e2bcd8739ae039).of(button, button.ref, this.doc);
    };
    /**
     * Create a new check box field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const checkBox = form.createCheckBox('cool.new.checkBox')
     *
     * checkBox.addToPage(page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new check box.
     * @returns The new check box field.
     */ PDFForm.prototype.createCheckBox = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var checkBox = (0, $f8e31b0e21e15332$export$2e2bcd8739ae039).create(this.doc.context);
        checkBox.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            checkBox,
            checkBox.ref
        ], nameParts.terminal);
        return (0, $4740dcccc2940521$export$2e2bcd8739ae039).of(checkBox, checkBox.ref, this.doc);
    };
    /**
     * Create a new dropdown field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const dropdown = form.createDropdown('cool.new.dropdown')
     *
     * dropdown.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new dropdown.
     * @returns The new dropdown field.
     */ PDFForm.prototype.createDropdown = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var comboBox = (0, $3488827c1474fcce$export$2e2bcd8739ae039).create(this.doc.context);
        comboBox.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            comboBox,
            comboBox.ref
        ], nameParts.terminal);
        return (0, $8c3a0a776d3c65cf$export$2e2bcd8739ae039).of(comboBox, comboBox.ref, this.doc);
    };
    /**
     * Create a new option list field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const optionList = form.createOptionList('cool.new.optionList')
     *
     * optionList.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new option list.
     * @returns The new option list field.
     */ PDFForm.prototype.createOptionList = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var listBox = (0, $c1f53a89685317ba$export$2e2bcd8739ae039).create(this.doc.context);
        listBox.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            listBox,
            listBox.ref
        ], nameParts.terminal);
        return (0, $41141972e5bafa05$export$2e2bcd8739ae039).of(listBox, listBox.ref, this.doc);
    };
    /**
     * Create a new radio group field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const radioGroup = form.createRadioGroup('cool.new.radioGroup')
     *
     * radioGroup.addOptionToPage('is-dog', page, { y: 0 })
     * radioGroup.addOptionToPage('is-cat', page, { y: 75 })
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new radio group.
     * @returns The new radio group field.
     */ PDFForm.prototype.createRadioGroup = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var radioButton = (0, $cad74455a26124b0$export$2e2bcd8739ae039).create(this.doc.context);
        radioButton.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            radioButton,
            radioButton.ref
        ], nameParts.terminal);
        return (0, $131d580cd94f5347$export$2e2bcd8739ae039).of(radioButton, radioButton.ref, this.doc);
    };
    /**
     * Create a new text field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const textField = form.createTextField('cool.new.textField')
     *
     * textField.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new radio group.
     * @returns The new radio group field.
     */ PDFForm.prototype.createTextField = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var text = (0, $8fd9de5d2343325e$export$2e2bcd8739ae039).create(this.doc.context);
        text.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            text,
            text.ref
        ], nameParts.terminal);
        return (0, $f989cc5b81a68a40$export$2e2bcd8739ae039).of(text, text.ref, this.doc);
    };
    /**
     * Flatten all fields in this [[PDFForm]].
     *
     * Flattening a form field will take the current appearance for each of that
     * field's widgets and make them part of their page's content stream. All form
     * fields and annotations associated are then removed. Note that once a form
     * has been flattened its fields can no longer be accessed or edited.
     *
     * This operation is often used after filling form fields to ensure a
     * consistent appearance across different PDF readers and/or printers.
     * Another common use case is to copy a template document with form fields
     * into another document. In this scenario you would load the template
     * document, fill its fields, flatten it, and then copy its pages into the
     * recipient document - the filled fields will be copied over.
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm();
     * form.flatten();
     * ```
     */ PDFForm.prototype.flatten = function(options) {
        if (options === void 0) options = {
            updateFieldAppearances: true
        };
        if (options.updateFieldAppearances) this.updateFieldAppearances();
        var fields = this.getFields();
        for(var i = 0, lenFields = fields.length; i < lenFields; i++){
            var field = fields[i];
            var widgets = field.acroField.getWidgets();
            for(var j = 0, lenWidgets = widgets.length; j < lenWidgets; j++){
                var widget = widgets[j];
                var page = this.findWidgetPage(widget);
                var widgetRef = this.findWidgetAppearanceRef(field, widget);
                var xObjectKey = page.node.newXObject('FlatWidget', widgetRef);
                var rectangle = widget.getRectangle();
                var operators = (0, $cOQTW.__spreadArrays)([
                    (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(),
                    (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(rectangle.x, rectangle.y)
                ], (0, $55cf96b3448598de$export$5dd9a0a87f38a2a6)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
                    rotation: 0
                })), [
                    (0, $cfb765e9daff3c3a$export$382c18f8bccd9e2b)(xObjectKey),
                    (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
                ]).filter(Boolean);
                page.pushOperators.apply(page, operators);
            }
            this.removeField(field);
        }
    };
    /**
     * Remove a field from this [[PDFForm]].
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm();
     * const ageField = form.getFields().find(x => x.getName() === 'Age');
     * form.removeField(ageField);
     * ```
     */ PDFForm.prototype.removeField = function(field) {
        var widgets = field.acroField.getWidgets();
        var pages = new Set();
        for(var i = 0, len = widgets.length; i < len; i++){
            var widget = widgets[i];
            var widgetRef = this.findWidgetAppearanceRef(field, widget);
            var page = this.findWidgetPage(widget);
            pages.add(page);
            page.node.removeAnnot(widgetRef);
        }
        pages.forEach(function(page) {
            return page.node.removeAnnot(field.ref);
        });
        this.acroForm.removeField(field.acroField);
        var fieldKids = field.acroField.normalizedEntries().Kids;
        var kidsCount = fieldKids.size();
        for(var childIndex = 0; childIndex < kidsCount; childIndex++){
            var child = fieldKids.get(childIndex);
            if (child instanceof (0, $f1233b848bc26abe$export$2e2bcd8739ae039)) this.doc.context.delete(child);
        }
        this.doc.context.delete(field.ref);
    };
    /**
     * Update the appearance streams for all widgets of all fields in this
     * [[PDFForm]]. Appearance streams will only be created for a widget if it
     * does not have any existing appearance streams, or the field's value has
     * changed (e.g. by calling [[PDFTextField.setText]] or
     * [[PDFDropdown.select]]).
     *
     * For example:
     * ```js
     * const courier = await pdfDoc.embedFont(StandardFonts.Courier)
     * const form = pdfDoc.getForm()
     * form.updateFieldAppearances(courier)
     * ```
     *
     * **IMPORTANT:** The default value for the `font` parameter is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if any fields contain text with
     * characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing that as the `font`
     * parameter allows you to generate appearance streams with non WinAnsi
     * characters (assuming your custom font supports them).
     *
     * > **NOTE:** The [[PDFDocument.save]] method will call this method to
     * > update appearances automatically if a form was accessed via the
     * > [[PDFDocument.getForm]] method prior to saving.
     *
     * @param font Optionally, the font to use when creating new appearances.
     */ PDFForm.prototype.updateFieldAppearances = function(font) {
        (0, $j0tvB.assertOrUndefined)(font, 'font', [
            [
                (0, $fb353673e42bee9b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        font = font !== null && font !== void 0 ? font : this.getDefaultFont();
        var fields = this.getFields();
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var field = fields[idx];
            if (field.needsAppearancesUpdate()) field.defaultUpdateAppearances(font);
        }
    };
    /**
     * Mark a field as dirty. This will cause its appearance streams to be
     * updated by [[PDFForm.updateFieldAppearances]].
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * form.markFieldAsDirty(field.ref)
     * ```
     * @param fieldRef The reference to the field that should be marked.
     */ PDFForm.prototype.markFieldAsDirty = function(fieldRef) {
        (0, $j0tvB.assertOrUndefined)(fieldRef, 'fieldRef', [
            [
                (0, $f1233b848bc26abe$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        this.dirtyFields.add(fieldRef);
    };
    /**
     * Mark a field as dirty. This will cause its appearance streams to not be
     * updated by [[PDFForm.updateFieldAppearances]].
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * form.markFieldAsClean(field.ref)
     * ```
     * @param fieldRef The reference to the field that should be marked.
     */ PDFForm.prototype.markFieldAsClean = function(fieldRef) {
        (0, $j0tvB.assertOrUndefined)(fieldRef, 'fieldRef', [
            [
                (0, $f1233b848bc26abe$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        this.dirtyFields.delete(fieldRef);
    };
    /**
     * Returns `true` is the specified field has been marked as dirty.
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * if (form.fieldIsDirty(field.ref)) console.log('Field is dirty')
     * ```
     * @param fieldRef The reference to the field that should be checked.
     * @returns Whether or not the specified field is dirty.
     */ PDFForm.prototype.fieldIsDirty = function(fieldRef) {
        (0, $j0tvB.assertOrUndefined)(fieldRef, 'fieldRef', [
            [
                (0, $f1233b848bc26abe$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        return this.dirtyFields.has(fieldRef);
    };
    PDFForm.prototype.getDefaultFont = function() {
        return this.defaultFontCache.access();
    };
    PDFForm.prototype.findWidgetPage = function(widget) {
        var pageRef = widget.P();
        var page = this.doc.getPages().find(function(x) {
            return x.ref === pageRef;
        });
        if (page === undefined) {
            var widgetRef = this.doc.context.getObjectRef(widget.dict);
            if (widgetRef === undefined) throw new Error('Could not find PDFRef for PDFObject');
            page = this.doc.findPageForAnnotationRef(widgetRef);
            if (page === undefined) throw new Error("Could not find page for PDFRef " + widgetRef);
        }
        return page;
    };
    PDFForm.prototype.findWidgetAppearanceRef = function(field, widget) {
        var _a;
        var refOrDict = widget.getNormalAppearance();
        if (refOrDict instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039) && (field instanceof (0, $4740dcccc2940521$export$2e2bcd8739ae039) || field instanceof (0, $131d580cd94f5347$export$2e2bcd8739ae039))) {
            var value = field.acroField.getValue();
            var ref = (_a = refOrDict.get(value)) !== null && _a !== void 0 ? _a : refOrDict.get((0, $dPHSK.default).of('Off'));
            if (ref instanceof (0, $f1233b848bc26abe$export$2e2bcd8739ae039)) refOrDict = ref;
        }
        if (!(refOrDict instanceof (0, $f1233b848bc26abe$export$2e2bcd8739ae039))) {
            var name_1 = field.getName();
            throw new Error("Failed to extract appearance ref for: " + name_1);
        }
        return refOrDict;
    };
    PDFForm.prototype.findOrCreateNonTerminals = function(partialNames) {
        var nonTerminal = [
            this.acroForm
        ];
        for(var idx = 0, len = partialNames.length; idx < len; idx++){
            var namePart = partialNames[idx];
            if (!namePart) throw new (0, $7fe2d034822cb526$export$83c39fdacfe38500)(namePart);
            var parent_1 = nonTerminal[0], parentRef = nonTerminal[1];
            var res = this.findNonTerminal(namePart, parent_1);
            if (res) nonTerminal = res;
            else {
                var node = (0, $a105ec5aeb848914$export$2e2bcd8739ae039).create(this.doc.context);
                node.setPartialName(namePart);
                node.setParent(parentRef);
                var nodeRef = this.doc.context.register(node.dict);
                parent_1.addField(nodeRef);
                nonTerminal = [
                    node,
                    nodeRef
                ];
            }
        }
        return nonTerminal;
    };
    PDFForm.prototype.findNonTerminal = function(partialName, parent) {
        var fields = parent instanceof (0, $b2be38e1e2597241$export$2e2bcd8739ae039) ? this.acroForm.getFields() : (0, $be3fb214968b38d5$export$34b4fb8893136c4c)(parent.Kids());
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var _a = fields[idx], field = _a[0], ref = _a[1];
            if (field.getPartialName() === partialName) {
                if (field instanceof (0, $a105ec5aeb848914$export$2e2bcd8739ae039)) return [
                    field,
                    ref
                ];
                throw new (0, $7fe2d034822cb526$export$c428cfe4dc6c68df)(partialName);
            }
        }
        return undefined;
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.getForm]] method, which will create an
     * > instance of [[PDFForm]] for you.
     *
     * Create an instance of [[PDFForm]] from an existing acroForm and embedder
     *
     * @param acroForm The underlying `PDFAcroForm` for this form.
     * @param doc The document to which the form will belong.
     */ PDFForm.of = function(acroForm, doc) {
        return new PDFForm(acroForm, doc);
    };
    return PDFForm;
}();
var $1ca8b80442f19ab5$export$2e2bcd8739ae039 = $1ca8b80442f19ab5$var$PDFForm;
var $1ca8b80442f19ab5$var$convertToPDFField = function(field, ref, doc) {
    if (field instanceof (0, $0cfa6a9523f95402$export$2e2bcd8739ae039)) return (0, $b3771f5aa96680ee$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $f8e31b0e21e15332$export$2e2bcd8739ae039)) return (0, $4740dcccc2940521$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $3488827c1474fcce$export$2e2bcd8739ae039)) return (0, $8c3a0a776d3c65cf$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $c1f53a89685317ba$export$2e2bcd8739ae039)) return (0, $41141972e5bafa05$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $8fd9de5d2343325e$export$2e2bcd8739ae039)) return (0, $f989cc5b81a68a40$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $cad74455a26124b0$export$2e2bcd8739ae039)) return (0, $131d580cd94f5347$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $54d8c5346cdc5323$export$2e2bcd8739ae039)) return (0, $cca3a084a6440272$export$2e2bcd8739ae039).of(field, ref, doc);
    return undefined;
};
var $1ca8b80442f19ab5$var$splitFieldName = function(fullyQualifiedName) {
    if (fullyQualifiedName.length === 0) throw new Error('PDF field names must not be empty strings');
    var parts = fullyQualifiedName.split('.');
    for(var idx = 0, len = parts.length; idx < len; idx++){
        if (parts[idx] === '') throw new Error("Periods in PDF field names must be separated by at least one character: \"" + fullyQualifiedName + "\"");
    }
    if (parts.length === 1) return {
        nonTerminal: [],
        terminal: parts[0]
    };
    return {
        nonTerminal: parts.slice(0, parts.length - 1),
        terminal: parts[parts.length - 1]
    };
};
var $1ca8b80442f19ab5$var$addFieldToParent = function(_a, _b, partialName) {
    var parent = _a[0], parentRef = _a[1];
    var field = _b[0], fieldRef = _b[1];
    var entries = parent.normalizedEntries();
    var fields = (0, $be3fb214968b38d5$export$34b4fb8893136c4c)('Kids' in entries ? entries.Kids : entries.Fields);
    for(var idx = 0, len = fields.length; idx < len; idx++){
        if (fields[idx][0].getPartialName() === partialName) throw new (0, $7fe2d034822cb526$export$c428cfe4dc6c68df)(partialName);
    }
    parent.addField(fieldRef);
    field.setParent(parentRef);
};


var $bdf8b405f72f9bf0$export$b4a05ae367f5515c = {
    '4A0': [
        4767.87,
        6740.79
    ],
    '2A0': [
        3370.39,
        4767.87
    ],
    A0: [
        2383.94,
        3370.39
    ],
    A1: [
        1683.78,
        2383.94
    ],
    A2: [
        1190.55,
        1683.78
    ],
    A3: [
        841.89,
        1190.55
    ],
    A4: [
        595.28,
        841.89
    ],
    A5: [
        419.53,
        595.28
    ],
    A6: [
        297.64,
        419.53
    ],
    A7: [
        209.76,
        297.64
    ],
    A8: [
        147.4,
        209.76
    ],
    A9: [
        104.88,
        147.4
    ],
    A10: [
        73.7,
        104.88
    ],
    B0: [
        2834.65,
        4008.19
    ],
    B1: [
        2004.09,
        2834.65
    ],
    B2: [
        1417.32,
        2004.09
    ],
    B3: [
        1000.63,
        1417.32
    ],
    B4: [
        708.66,
        1000.63
    ],
    B5: [
        498.9,
        708.66
    ],
    B6: [
        354.33,
        498.9
    ],
    B7: [
        249.45,
        354.33
    ],
    B8: [
        175.75,
        249.45
    ],
    B9: [
        124.72,
        175.75
    ],
    B10: [
        87.87,
        124.72
    ],
    C0: [
        2599.37,
        3676.54
    ],
    C1: [
        1836.85,
        2599.37
    ],
    C2: [
        1298.27,
        1836.85
    ],
    C3: [
        918.43,
        1298.27
    ],
    C4: [
        649.13,
        918.43
    ],
    C5: [
        459.21,
        649.13
    ],
    C6: [
        323.15,
        459.21
    ],
    C7: [
        229.61,
        323.15
    ],
    C8: [
        161.57,
        229.61
    ],
    C9: [
        113.39,
        161.57
    ],
    C10: [
        79.37,
        113.39
    ],
    RA0: [
        2437.8,
        3458.27
    ],
    RA1: [
        1729.13,
        2437.8
    ],
    RA2: [
        1218.9,
        1729.13
    ],
    RA3: [
        864.57,
        1218.9
    ],
    RA4: [
        609.45,
        864.57
    ],
    SRA0: [
        2551.18,
        3628.35
    ],
    SRA1: [
        1814.17,
        2551.18
    ],
    SRA2: [
        1275.59,
        1814.17
    ],
    SRA3: [
        907.09,
        1275.59
    ],
    SRA4: [
        637.8,
        907.09
    ],
    Executive: [
        521.86,
        756.0
    ],
    Folio: [
        612.0,
        936.0
    ],
    Legal: [
        612.0,
        1008.0
    ],
    Letter: [
        612.0,
        792.0
    ],
    Tabloid: [
        792.0,
        1224.0
    ]
};



var $nAWRe = parcelRequire("nAWRe");
var $dPHSK = parcelRequire("dPHSK");
var $9fe7d517881d9f8b$export$ba19d141a3749548;
(function(ParseSpeeds) {
    ParseSpeeds[ParseSpeeds["Fastest"] = Infinity] = "Fastest";
    ParseSpeeds[ParseSpeeds["Fast"] = 1500] = "Fast";
    ParseSpeeds[ParseSpeeds["Medium"] = 500] = "Medium";
    ParseSpeeds[ParseSpeeds["Slow"] = 100] = "Slow";
})($9fe7d517881d9f8b$export$ba19d141a3749548 || ($9fe7d517881d9f8b$export$ba19d141a3749548 = {}));


parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var $clYSv = parcelRequire("clYSv");
var $4ISq8 = parcelRequire("4ISq8");
var $fZ8o5 = parcelRequire("fZ8o5");
var $cbIAG = parcelRequire("cbIAG");


var $cOQTW = parcelRequire("cOQTW");

var $8auL6 = parcelRequire("8auL6");
var $dPHSK = parcelRequire("dPHSK");
/**
 * Represents a file that has been embedded in a [[PDFDocument]].
 */ var $072855dc9321c2b4$var$PDFEmbeddedFile = /** @class */ function() {
    function PDFEmbeddedFile(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        this.ref = ref;
        this.doc = doc;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all embeddable files get embedded.
     *
     * Embed this embeddable file in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFEmbeddedFile.prototype.embed = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var ref, Names, EmbeddedFiles, EFNames, AF;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        ref = _a.sent();
                        if (!this.doc.catalog.has((0, $dPHSK.default).of('Names'))) this.doc.catalog.set((0, $dPHSK.default).of('Names'), this.doc.context.obj({}));
                        Names = this.doc.catalog.lookup((0, $dPHSK.default).of('Names'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
                        if (!Names.has((0, $dPHSK.default).of('EmbeddedFiles'))) Names.set((0, $dPHSK.default).of('EmbeddedFiles'), this.doc.context.obj({}));
                        EmbeddedFiles = Names.lookup((0, $dPHSK.default).of('EmbeddedFiles'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
                        if (!EmbeddedFiles.has((0, $dPHSK.default).of('Names'))) EmbeddedFiles.set((0, $dPHSK.default).of('Names'), this.doc.context.obj([]));
                        EFNames = EmbeddedFiles.lookup((0, $dPHSK.default).of('Names'), (0, $8auL6.default));
                        EFNames.push((0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(this.embedder.fileName));
                        EFNames.push(ref);
                        /**
                         * The AF-Tag is needed to achieve PDF-A3 compliance for embedded files
                         *
                         * The following document outlines the uses cases of the associated files (AF) tag.
                         * See:
                         * https://www.pdfa.org/wp-content/uploads/2018/10/PDF20_AN002-AF.pdf
                         */ if (!this.doc.catalog.has((0, $dPHSK.default).of('AF'))) this.doc.catalog.set((0, $dPHSK.default).of('AF'), this.doc.context.obj([]));
                        AF = this.doc.catalog.lookup((0, $dPHSK.default).of('AF'), (0, $8auL6.default));
                        AF.push(ref);
                        this.alreadyEmbedded = true;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.attach]] method, which will create
     * instances of [[PDFEmbeddedFile]] for you.
     *
     * Create an instance of [[PDFEmbeddedFile]] from an existing ref and embedder
     *
     * @param ref The unique reference for this file.
     * @param doc The document to which the file will belong.
     * @param embedder The embedder that will be used to embed the file.
     */ PDFEmbeddedFile.of = function(ref, doc, embedder) {
        return new PDFEmbeddedFile(ref, doc, embedder);
    };
    return PDFEmbeddedFile;
}();
var $072855dc9321c2b4$export$2e2bcd8739ae039 = $072855dc9321c2b4$var$PDFEmbeddedFile;



var $cOQTW = parcelRequire("cOQTW");

var $8auL6 = parcelRequire("8auL6");
var $dPHSK = parcelRequire("dPHSK");
/**
 * Represents JavaScript that has been embedded in a [[PDFDocument]].
 */ var $8e93f6bd1fec6f6e$var$PDFJavaScript = /** @class */ function() {
    function PDFJavaScript(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        this.ref = ref;
        this.doc = doc;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all JavaScripts get embedded.
     *
     * Embed this JavaScript in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFJavaScript.prototype.embed = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, catalog, context, ref, Names, Javascript, JSNames;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = this.doc, catalog = _a.catalog, context = _a.context;
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        ref = _b.sent();
                        if (!catalog.has((0, $dPHSK.default).of('Names'))) catalog.set((0, $dPHSK.default).of('Names'), context.obj({}));
                        Names = catalog.lookup((0, $dPHSK.default).of('Names'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
                        if (!Names.has((0, $dPHSK.default).of('JavaScript'))) Names.set((0, $dPHSK.default).of('JavaScript'), context.obj({}));
                        Javascript = Names.lookup((0, $dPHSK.default).of('JavaScript'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
                        if (!Javascript.has((0, $dPHSK.default).of('Names'))) Javascript.set((0, $dPHSK.default).of('Names'), context.obj([]));
                        JSNames = Javascript.lookup((0, $dPHSK.default).of('Names'), (0, $8auL6.default));
                        JSNames.push((0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(this.embedder.scriptName));
                        JSNames.push(ref);
                        this.alreadyEmbedded = true;
                        _b.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addJavaScript]] method, which will
     * create instances of [[PDFJavaScript]] for you.
     *
     * Create an instance of [[PDFJavaScript]] from an existing ref and script
     *
     * @param ref The unique reference for this script.
     * @param doc The document to which the script will belong.
     * @param embedder The embedder that will be used to embed the script.
     */ PDFJavaScript.of = function(ref, doc, embedder) {
        return new PDFJavaScript(ref, doc, embedder);
    };
    return PDFJavaScript;
}();
var $8e93f6bd1fec6f6e$export$2e2bcd8739ae039 = $8e93f6bd1fec6f6e$var$PDFJavaScript;



var $cOQTW = parcelRequire("cOQTW");

var $60420ad6933b406d$var$JavaScriptEmbedder = /** @class */ function() {
    function JavaScriptEmbedder(script, scriptName) {
        this.script = script;
        this.scriptName = scriptName;
    }
    JavaScriptEmbedder.for = function(script, scriptName) {
        return new JavaScriptEmbedder(script, scriptName);
    };
    JavaScriptEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var jsActionDict;
            return (0, $cOQTW.__generator)(this, function(_a) {
                jsActionDict = context.obj({
                    Type: 'Action',
                    S: 'JavaScript',
                    JS: (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(this.script)
                });
                if (ref) {
                    context.assign(ref, jsActionDict);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(jsActionDict)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return JavaScriptEmbedder;
}();
var $60420ad6933b406d$export$2e2bcd8739ae039 = $60420ad6933b406d$var$JavaScriptEmbedder;


/**
 * Represents a PDF document.
 */ var $93b2571d4e1dfe94$var$PDFDocument = /** @class */ function() {
    function PDFDocument(context, ignoreEncryption, updateMetadata) {
        var _this = this;
        /** The default word breaks used in PDFPage.drawText */ this.defaultWordBreaks = [
            ' '
        ];
        this.computePages = function() {
            var pages = [];
            _this.catalog.Pages().traverse(function(node, ref) {
                if (node instanceof (0, $a9e73b7ced5abfa4$export$2e2bcd8739ae039)) {
                    var page = _this.pageMap.get(node);
                    if (!page) {
                        page = (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039).of(node, ref, _this);
                        _this.pageMap.set(node, page);
                    }
                    pages.push(page);
                }
            });
            return pages;
        };
        this.getOrCreateForm = function() {
            var acroForm = _this.catalog.getOrCreateAcroForm();
            return (0, $1ca8b80442f19ab5$export$2e2bcd8739ae039).of(acroForm, _this);
        };
        (0, $j0tvB.assertIs)(context, 'context', [
            [
                (0, $ece91e5f61c516eb$export$2e2bcd8739ae039),
                'PDFContext'
            ]
        ]);
        (0, $j0tvB.assertIs)(ignoreEncryption, 'ignoreEncryption', [
            'boolean'
        ]);
        this.context = context;
        this.catalog = context.lookup(context.trailerInfo.Root);
        this.isEncrypted = !!context.lookup(context.trailerInfo.Encrypt);
        this.pageCache = (0, $clYSv.default).populatedBy(this.computePages);
        this.pageMap = new Map();
        this.formCache = (0, $clYSv.default).populatedBy(this.getOrCreateForm);
        this.fonts = [];
        this.images = [];
        this.embeddedPages = [];
        this.embeddedFiles = [];
        this.javaScripts = [];
        if (!ignoreEncryption && this.isEncrypted) throw new (0, $7fe2d034822cb526$export$20fcceeca2b098d2)();
        if (updateMetadata) this.updateInfoDict();
    }
    /**
     * Load an existing [[PDFDocument]]. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                               |
     * | ------------- | ------------------------------------------------------ |
     * | `string`      | A base64 encoded string (or data URI) containing a PDF |
     * | `Uint8Array`  | The raw bytes of a PDF                                 |
     * | `ArrayBuffer` | The raw bytes of a PDF                                 |
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     *
     * // pdf=string
     * const base64 =
     *  'JVBERi0xLjcKJYGBgYEKCjUgMCBvYmoKPDwKL0ZpbHRlciAvRmxhdGVEZWNvZGUKL0xlbm' +
     *  'd0aCAxMDQKPj4Kc3RyZWFtCniccwrhMlAAwaJ0Ln2P1Jyy1JLM5ERdc0MjCwUjE4WQNC4Q' +
     *  '6cNlCFZkqGCqYGSqEJLLZWNuYGZiZmbkYuZsZmlmZGRgZmluDCQNzc3NTM2NzdzMXMxMjQ' +
     *  'ztFEKyuEK0uFxDuAAOERdVCmVuZHN0cmVhbQplbmRvYmoKCjYgMCBvYmoKPDwKL0ZpbHRl' +
     *  'ciAvRmxhdGVEZWNvZGUKL1R5cGUgL09ialN0bQovTiA0Ci9GaXJzdCAyMAovTGVuZ3RoID' +
     *  'IxNQo+PgpzdHJlYW0KeJxVj9GqwjAMhu/zFHkBzTo3nCCCiiKIHPEICuJF3cKoSCu2E8/b' +
     *  '20wPIr1p8v9/8kVhgilmGfawX2CGaVrgcAi0/bsy0lrX7IGWpvJ4iJYEN3gEmrrGBlQwGs' +
     *  'HHO9VBX1wNrxAqMX87RBD5xpJuddqwd82tjAHxzV1U5LPgy52DKXWnr1Lheg+j/c/pzGVr' +
     *  'iqV0VlwZPXGPCJjElw/ybkwUmeoWgxesDXGhHJC/D/iikp1Av80ptKU0FdBEe25pPihAM1' +
     *  'u6ytgaaWfs2Hrz35CJT1+EWmAKZW5kc3RyZWFtCmVuZG9iagoKNyAwIG9iago8PAovU2l6' +
     *  'ZSA4Ci9Sb290IDIgMCBSCi9GaWx0ZXIgL0ZsYXRlRGVjb2RlCi9UeXBlIC9YUmVmCi9MZW' +
     *  '5ndGggMzgKL1cgWyAxIDIgMiBdCi9JbmRleCBbIDAgOCBdCj4+CnN0cmVhbQp4nBXEwREA' +
     *  'EBAEsCwz3vrvRmOOyyOoGhZdutHN2MT55fIAVocD+AplbmRzdHJlYW0KZW5kb2JqCgpzdG' +
     *  'FydHhyZWYKNTEwCiUlRU9G'
     *
     * const dataUri = 'data:application/pdf;base64,' + base64
     *
     * const pdfDoc1 = await PDFDocument.load(base64)
     * const pdfDoc2 = await PDFDocument.load(dataUri)
     *
     * // pdf=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('with_update_sections.pdf')
     * const pdfDoc3 = await PDFDocument.load(uint8Array)
     *
     * // pdf=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/with_update_sections.pdf'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const pdfDoc4 = await PDFDocument.load(arrayBuffer)
     *
     * ```
     *
     * @param pdf The input data containing a PDF document.
     * @param options The options to be used when loading the document.
     * @returns Resolves with a document loaded from the input.
     */ PDFDocument.load = function(pdf, options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, ignoreEncryption, _b, parseSpeed, _c, throwOnInvalidObject, _d, updateMetadata, _e, capNumbers, bytes, context;
            return (0, $cOQTW.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        _a = options.ignoreEncryption, ignoreEncryption = _a === void 0 ? false : _a, _b = options.parseSpeed, parseSpeed = _b === void 0 ? (0, $9fe7d517881d9f8b$export$ba19d141a3749548).Slow : _b, _c = options.throwOnInvalidObject, throwOnInvalidObject = _c === void 0 ? false : _c, _d = options.updateMetadata, updateMetadata = _d === void 0 ? true : _d, _e = options.capNumbers, capNumbers = _e === void 0 ? false : _e;
                        (0, $j0tvB.assertIs)(pdf, 'pdf', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        (0, $j0tvB.assertIs)(ignoreEncryption, 'ignoreEncryption', [
                            'boolean'
                        ]);
                        (0, $j0tvB.assertIs)(parseSpeed, 'parseSpeed', [
                            'number'
                        ]);
                        (0, $j0tvB.assertIs)(throwOnInvalidObject, 'throwOnInvalidObject', [
                            'boolean'
                        ]);
                        bytes = (0, $4ISq8.toUint8Array)(pdf);
                        return [
                            4 /*yield*/ ,
                            (0, $0c78b71d995ee90b$export$2e2bcd8739ae039).forBytesWithOptions(bytes, parseSpeed, throwOnInvalidObject, capNumbers).parseDocument()
                        ];
                    case 1:
                        context = _f.sent();
                        return [
                            2 /*return*/ ,
                            new PDFDocument(context, ignoreEncryption, updateMetadata)
                        ];
                }
            });
        });
    };
    /**
     * Create a new [[PDFDocument]].
     * @returns Resolves with the newly created document.
     */ PDFDocument.create = function(options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, updateMetadata, context, pageTree, pageTreeRef, catalog;
            return (0, $cOQTW.__generator)(this, function(_b) {
                _a = options.updateMetadata, updateMetadata = _a === void 0 ? true : _a;
                context = (0, $ece91e5f61c516eb$export$2e2bcd8739ae039).create();
                pageTree = (0, $333acd2e5fba0d32$export$2e2bcd8739ae039).withContext(context);
                pageTreeRef = context.register(pageTree);
                catalog = (0, $80c05707f2c8c1f7$export$2e2bcd8739ae039).withContextAndPages(context, pageTreeRef);
                context.trailerInfo.Root = context.register(catalog);
                return [
                    2 /*return*/ ,
                    new PDFDocument(context, false, updateMetadata)
                ];
            });
        });
    };
    /**
     * Register a fontkit instance. This must be done before custom fonts can
     * be embedded. See [here](https://github.com/Hopding/pdf-lib/tree/master#fontkit-installation)
     * for instructions on how to install and register a fontkit instance.
     *
     * > You do **not** need to call this method to embed standard fonts.
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     * import fontkit from '@pdf-lib/fontkit'
     *
     * const pdfDoc = await PDFDocument.create()
     * pdfDoc.registerFontkit(fontkit)
     * ```
     *
     * @param fontkit The fontkit instance to be registered.
     */ PDFDocument.prototype.registerFontkit = function(fontkit) {
        this.fontkit = fontkit;
    };
    /**
     * Get the [[PDFForm]] containing all interactive fields for this document.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const type = field.constructor.name
     *   const name = field.getName()
     *   console.log(`${type}: ${name}`)
     * })
     * ```
     * @returns The form for this document.
     */ PDFDocument.prototype.getForm = function() {
        var form = this.formCache.access();
        if (form.hasXFA()) {
            console.warn('Removing XFA form data as pdf-lib does not support reading or writing XFA');
            form.deleteXFA();
        }
        return form;
    };
    /**
     * Get this document's title metadata. The title appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const title = pdfDoc.getTitle()
     * ```
     * @returns A string containing the title of this document, if it has one.
     */ PDFDocument.prototype.getTitle = function() {
        var title = this.getInfoDict().lookup((0, $dPHSK.default).Title);
        if (!title) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(title);
        return title.decodeText();
    };
    /**
     * Get this document's author metadata. The author appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const author = pdfDoc.getAuthor()
     * ```
     * @returns A string containing the author of this document, if it has one.
     */ PDFDocument.prototype.getAuthor = function() {
        var author = this.getInfoDict().lookup((0, $dPHSK.default).Author);
        if (!author) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(author);
        return author.decodeText();
    };
    /**
     * Get this document's subject metadata. The subject appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const subject = pdfDoc.getSubject()
     * ```
     * @returns A string containing the subject of this document, if it has one.
     */ PDFDocument.prototype.getSubject = function() {
        var subject = this.getInfoDict().lookup((0, $dPHSK.default).Subject);
        if (!subject) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(subject);
        return subject.decodeText();
    };
    /**
     * Get this document's keywords metadata. The keywords appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const keywords = pdfDoc.getKeywords()
     * ```
     * @returns A string containing the keywords of this document, if it has any.
     */ PDFDocument.prototype.getKeywords = function() {
        var keywords = this.getInfoDict().lookup((0, $dPHSK.default).Keywords);
        if (!keywords) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(keywords);
        return keywords.decodeText();
    };
    /**
     * Get this document's creator metadata. The creator appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const creator = pdfDoc.getCreator()
     * ```
     * @returns A string containing the creator of this document, if it has one.
     */ PDFDocument.prototype.getCreator = function() {
        var creator = this.getInfoDict().lookup((0, $dPHSK.default).Creator);
        if (!creator) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(creator);
        return creator.decodeText();
    };
    /**
     * Get this document's producer metadata. The producer appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const producer = pdfDoc.getProducer()
     * ```
     * @returns A string containing the producer of this document, if it has one.
     */ PDFDocument.prototype.getProducer = function() {
        var producer = this.getInfoDict().lookup((0, $dPHSK.default).Producer);
        if (!producer) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(producer);
        return producer.decodeText();
    };
    /**
     * Get this document's creation date metadata. The creation date appears in
     * the "Document Properties" section of most PDF readers. For example:
     * ```js
     * const creationDate = pdfDoc.getCreationDate()
     * ```
     * @returns A Date containing the creation date of this document,
     *          if it has one.
     */ PDFDocument.prototype.getCreationDate = function() {
        var creationDate = this.getInfoDict().lookup((0, $dPHSK.default).CreationDate);
        if (!creationDate) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(creationDate);
        return creationDate.decodeDate();
    };
    /**
     * Get this document's modification date metadata. The modification date
     * appears in the "Document Properties" section of most PDF readers.
     * For example:
     * ```js
     * const modification = pdfDoc.getModificationDate()
     * ```
     * @returns A Date containing the modification date of this document,
     *          if it has one.
     */ PDFDocument.prototype.getModificationDate = function() {
        var modificationDate = this.getInfoDict().lookup((0, $dPHSK.default).ModDate);
        if (!modificationDate) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(modificationDate);
        return modificationDate.decodeDate();
    };
    /**
     * Set this document's title metadata. The title will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setTitle('🥚 The Life of an Egg 🍳')
     * ```
     *
     * To display the title in the window's title bar, set the
     * `showInWindowTitleBar` option to `true` (works for _most_ PDF readers).
     * For example:
     * ```js
     * pdfDoc.setTitle('🥚 The Life of an Egg 🍳', { showInWindowTitleBar: true })
     * ```
     *
     * @param title The title of this document.
     * @param options The options to be used when setting the title.
     */ PDFDocument.prototype.setTitle = function(title, options) {
        (0, $j0tvB.assertIs)(title, 'title', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Title');
        this.getInfoDict().set(key, (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(title));
        // Indicate that readers should display the title rather than the filename
        if (options === null || options === void 0 ? void 0 : options.showInWindowTitleBar) {
            var prefs = this.catalog.getOrCreateViewerPreferences();
            prefs.setDisplayDocTitle(true);
        }
    };
    /**
     * Set this document's author metadata. The author will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setAuthor('Humpty Dumpty')
     * ```
     * @param author The author of this document.
     */ PDFDocument.prototype.setAuthor = function(author) {
        (0, $j0tvB.assertIs)(author, 'author', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Author');
        this.getInfoDict().set(key, (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(author));
    };
    /**
     * Set this document's subject metadata. The subject will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setSubject('📘 An Epic Tale of Woe 📖')
     * ```
     * @param subject The subject of this document.
     */ PDFDocument.prototype.setSubject = function(subject) {
        (0, $j0tvB.assertIs)(subject, 'author', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Subject');
        this.getInfoDict().set(key, (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(subject));
    };
    /**
     * Set this document's keyword metadata. These keywords will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setKeywords(['eggs', 'wall', 'fall', 'king', 'horses', 'men'])
     * ```
     * @param keywords An array of keywords associated with this document.
     */ PDFDocument.prototype.setKeywords = function(keywords) {
        (0, $j0tvB.assertIs)(keywords, 'keywords', [
            Array
        ]);
        var key = (0, $dPHSK.default).of('Keywords');
        this.getInfoDict().set(key, (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(keywords.join(' ')));
    };
    /**
     * Set this document's creator metadata. The creator will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setCreator('PDF App 9000 🤖')
     * ```
     * @param creator The creator of this document.
     */ PDFDocument.prototype.setCreator = function(creator) {
        (0, $j0tvB.assertIs)(creator, 'creator', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Creator');
        this.getInfoDict().set(key, (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(creator));
    };
    /**
     * Set this document's producer metadata. The producer will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setProducer('PDF App 9000 🤖')
     * ```
     * @param producer The producer of this document.
     */ PDFDocument.prototype.setProducer = function(producer) {
        (0, $j0tvB.assertIs)(producer, 'creator', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Producer');
        this.getInfoDict().set(key, (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(producer));
    };
    /**
     * Set this document's language metadata. The language will appear in the
     * "Document Properties" section of some PDF readers. For example:
     * ```js
     * pdfDoc.setLanguage('en-us')
     * ```
     *
     * @param language An RFC 3066 _Language-Tag_ denoting the language of this
     *                 document, or an empty string if the language is unknown.
     */ PDFDocument.prototype.setLanguage = function(language) {
        (0, $j0tvB.assertIs)(language, 'language', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Lang');
        this.catalog.set(key, (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039).of(language));
    };
    /**
     * Set this document's creation date metadata. The creation date will appear
     * in the "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setCreationDate(new Date())
     * ```
     * @param creationDate The date this document was created.
     */ PDFDocument.prototype.setCreationDate = function(creationDate) {
        (0, $j0tvB.assertIs)(creationDate, 'creationDate', [
            [
                Date,
                'Date'
            ]
        ]);
        var key = (0, $dPHSK.default).of('CreationDate');
        this.getInfoDict().set(key, (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039).fromDate(creationDate));
    };
    /**
     * Set this document's modification date metadata. The modification date will
     * appear in the "Document Properties" section of most PDF readers. For
     * example:
     * ```js
     * pdfDoc.setModificationDate(new Date())
     * ```
     * @param modificationDate The date this document was last modified.
     */ PDFDocument.prototype.setModificationDate = function(modificationDate) {
        (0, $j0tvB.assertIs)(modificationDate, 'modificationDate', [
            [
                Date,
                'Date'
            ]
        ]);
        var key = (0, $dPHSK.default).of('ModDate');
        this.getInfoDict().set(key, (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039).fromDate(modificationDate));
    };
    /**
     * Get the number of pages contained in this document. For example:
     * ```js
     * const totalPages = pdfDoc.getPageCount()
     * ```
     * @returns The number of pages in this document.
     */ PDFDocument.prototype.getPageCount = function() {
        if (this.pageCount === undefined) this.pageCount = this.getPages().length;
        return this.pageCount;
    };
    /**
     * Get an array of all the pages contained in this document. The pages are
     * stored in the array in the same order that they are rendered in the
     * document. For example:
     * ```js
     * const pages = pdfDoc.getPages()
     * pages[0]   // The first page of the document
     * pages[2]   // The third page of the document
     * pages[197] // The 198th page of the document
     * ```
     * @returns An array of all the pages contained in this document.
     */ PDFDocument.prototype.getPages = function() {
        return this.pageCache.access();
    };
    /**
     * Get the page rendered at a particular `index` of the document. For example:
     * ```js
     * pdfDoc.getPage(0)   // The first page of the document
     * pdfDoc.getPage(2)   // The third page of the document
     * pdfDoc.getPage(197) // The 198th page of the document
     * ```
     * @returns The [[PDFPage]] rendered at the given `index` of the document.
     */ PDFDocument.prototype.getPage = function(index) {
        var pages = this.getPages();
        (0, $j0tvB.assertRange)(index, 'index', 0, pages.length - 1);
        return pages[index];
    };
    /**
     * Get an array of indices for all the pages contained in this document. The
     * array will contain a range of integers from
     * `0..pdfDoc.getPageCount() - 1`. For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     * pdfDoc.addPage()
     * pdfDoc.addPage()
     * pdfDoc.addPage()
     *
     * const indices = pdfDoc.getPageIndices()
     * indices // => [0, 1, 2]
     * ```
     * @returns An array of indices for all pages contained in this document.
     */ PDFDocument.prototype.getPageIndices = function() {
        return (0, $4ISq8.range)(0, this.getPageCount());
    };
    /**
     * Remove the page at a given index from this document. For example:
     * ```js
     * pdfDoc.removePage(0)   // Remove the first page of the document
     * pdfDoc.removePage(2)   // Remove the third page of the document
     * pdfDoc.removePage(197) // Remove the 198th page of the document
     * ```
     * Once a page has been removed, it will no longer be rendered at that index
     * in the document.
     * @param index The index of the page to be removed.
     */ PDFDocument.prototype.removePage = function(index) {
        var pageCount = this.getPageCount();
        if (this.pageCount === 0) throw new (0, $7fe2d034822cb526$export$cdca06c5927ddc2d)();
        (0, $j0tvB.assertRange)(index, 'index', 0, pageCount - 1);
        this.catalog.removeLeafNode(index);
        this.pageCount = pageCount - 1;
    };
    /**
     * Add a page to the end of this document. This method accepts three
     * different value types for the `page` parameter:
     *
     * | Type               | Behavior                                                                            |
     * | ------------------ | ----------------------------------------------------------------------------------- |
     * | `undefined`        | Create a new page and add it to the end of this document                            |
     * | `[number, number]` | Create a new page with the given dimensions and add it to the end of this document  |
     * | `PDFPage`          | Add the existing page to the end of this document                                   |
     *
     * For example:
     * ```js
     * // page=undefined
     * const newPage = pdfDoc.addPage()
     *
     * // page=[number, number]
     * import { PageSizes } from 'pdf-lib'
     * const newPage1 = pdfDoc.addPage(PageSizes.A7)
     * const newPage2 = pdfDoc.addPage(PageSizes.Letter)
     * const newPage3 = pdfDoc.addPage([500, 750])
     *
     * // page=PDFPage
     * const pdfDoc1 = await PDFDocument.create()
     * const pdfDoc2 = await PDFDocument.load(...)
     * const [existingPage] = await pdfDoc1.copyPages(pdfDoc2, [0])
     * pdfDoc1.addPage(existingPage)
     * ```
     *
     * @param page Optionally, the desired dimensions or existing page.
     * @returns The newly created (or existing) page.
     */ PDFDocument.prototype.addPage = function(page) {
        (0, $j0tvB.assertIs)(page, 'page', [
            'undefined',
            [
                (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039),
                'PDFPage'
            ],
            Array
        ]);
        return this.insertPage(this.getPageCount(), page);
    };
    /**
     * Insert a page at a given index within this document. This method accepts
     * three different value types for the `page` parameter:
     *
     * | Type               | Behavior                                                                       |
     * | ------------------ | ------------------------------------------------------------------------------ |
     * | `undefined`        | Create a new page and insert it into this document                             |
     * | `[number, number]` | Create a new page with the given dimensions and insert it into this document   |
     * | `PDFPage`          | Insert the existing page into this document                                    |
     *
     * For example:
     * ```js
     * // page=undefined
     * const newPage = pdfDoc.insertPage(2)
     *
     * // page=[number, number]
     * import { PageSizes } from 'pdf-lib'
     * const newPage1 = pdfDoc.insertPage(2, PageSizes.A7)
     * const newPage2 = pdfDoc.insertPage(0, PageSizes.Letter)
     * const newPage3 = pdfDoc.insertPage(198, [500, 750])
     *
     * // page=PDFPage
     * const pdfDoc1 = await PDFDocument.create()
     * const pdfDoc2 = await PDFDocument.load(...)
     * const [existingPage] = await pdfDoc1.copyPages(pdfDoc2, [0])
     * pdfDoc1.insertPage(0, existingPage)
     * ```
     *
     * @param index The index at which the page should be inserted (zero-based).
     * @param page Optionally, the desired dimensions or existing page.
     * @returns The newly created (or existing) page.
     */ PDFDocument.prototype.insertPage = function(index, page) {
        var pageCount = this.getPageCount();
        (0, $j0tvB.assertRange)(index, 'index', 0, pageCount);
        (0, $j0tvB.assertIs)(page, 'page', [
            'undefined',
            [
                (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039),
                'PDFPage'
            ],
            Array
        ]);
        if (!page || Array.isArray(page)) {
            var dims = Array.isArray(page) ? page : (0, $bdf8b405f72f9bf0$export$b4a05ae367f5515c).A4;
            page = (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039).create(this);
            page.setSize.apply(page, dims);
        } else if (page.doc !== this) throw new (0, $7fe2d034822cb526$export$9564a4d28d94eae2)();
        var parentRef = this.catalog.insertLeafNode(page.ref, index);
        page.node.setParent(parentRef);
        this.pageMap.set(page.node, page);
        this.pageCache.invalidate();
        this.pageCount = pageCount + 1;
        return page;
    };
    /**
     * Copy pages from a source document into this document. Allows pages to be
     * copied between different [[PDFDocument]] instances. For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     * const srcDoc = await PDFDocument.load(...)
     *
     * const copiedPages = await pdfDoc.copyPages(srcDoc, [0, 3, 89])
     * const [firstPage, fourthPage, ninetiethPage] = copiedPages;
     *
     * pdfDoc.addPage(fourthPage)
     * pdfDoc.insertPage(0, ninetiethPage)
     * pdfDoc.addPage(firstPage)
     * ```
     * @param srcDoc The document from which pages should be copied.
     * @param indices The indices of the pages that should be copied.
     * @returns Resolves with an array of pages copied into this document.
     */ PDFDocument.prototype.copyPages = function(srcDoc, indices) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var copier, srcPages, copiedPages, idx, len, srcPage, copiedPage, ref;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $j0tvB.assertIs)(srcDoc, 'srcDoc', [
                            [
                                PDFDocument,
                                'PDFDocument'
                            ]
                        ]);
                        (0, $j0tvB.assertIs)(indices, 'indices', [
                            Array
                        ]);
                        return [
                            4 /*yield*/ ,
                            srcDoc.flush()
                        ];
                    case 1:
                        _a.sent();
                        copier = (0, $ea102798c96bfd06$export$2e2bcd8739ae039).for(srcDoc.context, this.context);
                        srcPages = srcDoc.getPages();
                        copiedPages = new Array(indices.length);
                        for(idx = 0, len = indices.length; idx < len; idx++){
                            srcPage = srcPages[indices[idx]];
                            copiedPage = copier.copy(srcPage.node);
                            ref = this.context.register(copiedPage);
                            copiedPages[idx] = (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039).of(copiedPage, ref, this);
                        }
                        return [
                            2 /*return*/ ,
                            copiedPages
                        ];
                }
            });
        });
    };
    /**
     * Get a copy of this document.
     *
     * For example:
     * ```js
     * const srcDoc = await PDFDocument.load(...)
     * const pdfDoc = await srcDoc.copy()
     * ```
     *
     * > **NOTE:**  This method won't copy all information over to the new
     * > document (acroforms, outlines, etc...).
     *
     * @returns Resolves with a copy this document.
     */ PDFDocument.prototype.copy = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var pdfCopy, contentPages, idx, len;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            PDFDocument.create()
                        ];
                    case 1:
                        pdfCopy = _a.sent();
                        return [
                            4 /*yield*/ ,
                            pdfCopy.copyPages(this, this.getPageIndices())
                        ];
                    case 2:
                        contentPages = _a.sent();
                        for(idx = 0, len = contentPages.length; idx < len; idx++)pdfCopy.addPage(contentPages[idx]);
                        if (this.getAuthor() !== undefined) pdfCopy.setAuthor(this.getAuthor());
                        if (this.getCreationDate() !== undefined) pdfCopy.setCreationDate(this.getCreationDate());
                        if (this.getCreator() !== undefined) pdfCopy.setCreator(this.getCreator());
                        if (this.getModificationDate() !== undefined) pdfCopy.setModificationDate(this.getModificationDate());
                        if (this.getProducer() !== undefined) pdfCopy.setProducer(this.getProducer());
                        if (this.getSubject() !== undefined) pdfCopy.setSubject(this.getSubject());
                        if (this.getTitle() !== undefined) pdfCopy.setTitle(this.getTitle());
                        pdfCopy.defaultWordBreaks = this.defaultWordBreaks;
                        return [
                            2 /*return*/ ,
                            pdfCopy
                        ];
                }
            });
        });
    };
    /**
     * Add JavaScript to this document. The supplied `script` is executed when the
     * document is opened. The `script` can be used to perform some operation
     * when the document is opened (e.g. logging to the console), or it can be
     * used to define a function that can be referenced later in a JavaScript
     * action. For example:
     * ```js
     * // Show "Hello World!" in the console when the PDF is opened
     * pdfDoc.addJavaScript(
     *   'main',
     *   'console.show(); console.println("Hello World!");'
     * );
     *
     * // Define a function named "foo" that can be called in JavaScript Actions
     * pdfDoc.addJavaScript(
     *   'foo',
     *   'function foo() { return "foo"; }'
     * );
     * ```
     * See the [JavaScript for Acrobat API Reference](https://www.adobe.com/content/dam/acom/en/devnet/acrobat/pdfs/js_api_reference.pdf)
     * for details.
     * @param name The name of the script. Must be unique per document.
     * @param script The JavaScript to execute.
     */ PDFDocument.prototype.addJavaScript = function(name, script) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        (0, $j0tvB.assertIs)(script, 'script', [
            'string'
        ]);
        var embedder = (0, $60420ad6933b406d$export$2e2bcd8739ae039).for(script, name);
        var ref = this.context.nextRef();
        var javaScript = (0, $8e93f6bd1fec6f6e$export$2e2bcd8739ae039).of(ref, this, embedder);
        this.javaScripts.push(javaScript);
    };
    /**
     * Add an attachment to this document. Attachments are visible in the
     * "Attachments" panel of Adobe Acrobat and some other PDF readers. Any
     * type of file can be added as an attachment. This includes, but is not
     * limited to, `.png`, `.jpg`, `.pdf`, `.csv`, `.docx`, and `.xlsx` files.
     *
     * The input data can be provided in multiple formats:
     *
     * | Type          | Contents                                                       |
     * | ------------- | -------------------------------------------------------------- |
     * | `string`      | A base64 encoded string (or data URI) containing an attachment |
     * | `Uint8Array`  | The raw bytes of an attachment                                 |
     * | `ArrayBuffer` | The raw bytes of an attachment                                 |
     *
     * For example:
     * ```js
     * // attachment=string
     * await pdfDoc.attach('/9j/4AAQSkZJRgABAQAAAQABAAD/2wBD...', 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     * await pdfDoc.attach('data:image/jpeg;base64,/9j/4AAQ...', 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     *
     * // attachment=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('cat_riding_unicorn.jpg')
     * await pdfDoc.attach(uint8Array, 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     *
     * // attachment=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * await pdfDoc.attach(arrayBuffer, 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     * ```
     *
     * @param attachment The input data containing the file to be attached.
     * @param name The name of the file to be attached.
     * @returns Resolves when the attachment is complete.
     */ PDFDocument.prototype.attach = function(attachment, name, options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, embeddedFile;
            return (0, $cOQTW.__generator)(this, function(_a) {
                (0, $j0tvB.assertIs)(attachment, 'attachment', [
                    'string',
                    Uint8Array,
                    ArrayBuffer
                ]);
                (0, $j0tvB.assertIs)(name, 'name', [
                    'string'
                ]);
                (0, $j0tvB.assertOrUndefined)(options.mimeType, 'mimeType', [
                    'string'
                ]);
                (0, $j0tvB.assertOrUndefined)(options.description, 'description', [
                    'string'
                ]);
                (0, $j0tvB.assertOrUndefined)(options.creationDate, 'options.creationDate', [
                    Date
                ]);
                (0, $j0tvB.assertOrUndefined)(options.modificationDate, 'options.modificationDate', [
                    Date
                ]);
                (0, $j0tvB.assertIsOneOfOrUndefined)(options.afRelationship, 'options.afRelationship', (0, $03c8546b8537a071$export$c12eac46fbec1b74));
                bytes = (0, $4ISq8.toUint8Array)(attachment);
                embedder = (0, $03c8546b8537a071$export$2e2bcd8739ae039).for(bytes, name, options);
                ref = this.context.nextRef();
                embeddedFile = (0, $072855dc9321c2b4$export$2e2bcd8739ae039).of(ref, this, embedder);
                this.embeddedFiles.push(embeddedFile);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Embed a font into this document. The input data can be provided in multiple
     * formats:
     *
     * | Type            | Contents                                                |
     * | --------------- | ------------------------------------------------------- |
     * | `StandardFonts` | One of the standard 14 fonts                            |
     * | `string`        | A base64 encoded string (or data URI) containing a font |
     * | `Uint8Array`    | The raw bytes of a font                                 |
     * | `ArrayBuffer`   | The raw bytes of a font                                 |
     *
     * For example:
     * ```js
     * // font=StandardFonts
     * import { StandardFonts } from 'pdf-lib'
     * const font1 = await pdfDoc.embedFont(StandardFonts.Helvetica)
     *
     * // font=string
     * const font2 = await pdfDoc.embedFont('AAEAAAAVAQAABABQRFNJRx/upe...')
     * const font3 = await pdfDoc.embedFont('data:font/opentype;base64,AAEAAA...')
     *
     * // font=Uint8Array
     * import fs from 'fs'
     * const font4 = await pdfDoc.embedFont(fs.readFileSync('Ubuntu-R.ttf'))
     *
     * // font=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/ubuntu/Ubuntu-R.ttf'
     * const ubuntuBytes = await fetch(url).then(res => res.arrayBuffer())
     * const font5 = await pdfDoc.embedFont(ubuntuBytes)
     * ```
     * See also: [[registerFontkit]]
     * @param font The input data for a font.
     * @param options The options to be used when embedding the font.
     * @returns Resolves with the embedded font.
     */ PDFDocument.prototype.embedFont = function(font, options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, subset, customName, features, embedder, bytes, fontkit, _b, ref, pdfFont;
            return (0, $cOQTW.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = options.subset, subset = _a === void 0 ? false : _a, customName = options.customName, features = options.features;
                        (0, $j0tvB.assertIs)(font, 'font', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        (0, $j0tvB.assertIs)(subset, 'subset', [
                            'boolean'
                        ]);
                        if (!(0, $cbIAG.isStandardFont)(font)) return [
                            3 /*break*/ ,
                            1
                        ];
                        embedder = (0, $e3698d9fec5e57b0$export$2e2bcd8739ae039).for(font, customName);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 1:
                        if (!(0, $4ISq8.canBeConvertedToUint8Array)(font)) return [
                            3 /*break*/ ,
                            6
                        ];
                        bytes = (0, $4ISq8.toUint8Array)(font);
                        fontkit = this.assertFontkit();
                        if (!subset) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $4bb3e5ce3694dd68$export$2e2bcd8739ae039).for(fontkit, bytes, customName, features)
                        ];
                    case 2:
                        _b = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            (0, $c1a3ddaa0f08fc18$export$2e2bcd8739ae039).for(fontkit, bytes, customName, features)
                        ];
                    case 4:
                        _b = _c.sent();
                        _c.label = 5;
                    case 5:
                        embedder = _b;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        throw new TypeError('`font` must be one of `StandardFonts | string | Uint8Array | ArrayBuffer`');
                    case 7:
                        ref = this.context.nextRef();
                        pdfFont = (0, $fb353673e42bee9b$export$2e2bcd8739ae039).of(ref, this, embedder);
                        this.fonts.push(pdfFont);
                        return [
                            2 /*return*/ ,
                            pdfFont
                        ];
                }
            });
        });
    };
    /**
     * Embed a standard font into this document.
     * For example:
     * ```js
     * import { StandardFonts } from 'pdf-lib'
     * const helveticaFont = pdfDoc.embedFont(StandardFonts.Helvetica)
     * ```
     * @param font The standard font to be embedded.
     * @param customName The name to be used when embedding the font.
     * @returns The embedded font.
     */ PDFDocument.prototype.embedStandardFont = function(font, customName) {
        (0, $j0tvB.assertIs)(font, 'font', [
            'string'
        ]);
        if (!(0, $cbIAG.isStandardFont)(font)) throw new TypeError('`font` must be one of type `StandardFonts`');
        var embedder = (0, $e3698d9fec5e57b0$export$2e2bcd8739ae039).for(font, customName);
        var ref = this.context.nextRef();
        var pdfFont = (0, $fb353673e42bee9b$export$2e2bcd8739ae039).of(ref, this, embedder);
        this.fonts.push(pdfFont);
        return pdfFont;
    };
    /**
     * Embed a JPEG image into this document. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                                      |
     * | ------------- | ------------------------------------------------------------- |
     * | `string`      | A base64 encoded string (or data URI) containing a JPEG image |
     * | `Uint8Array`  | The raw bytes of a JPEG image                                 |
     * | `ArrayBuffer` | The raw bytes of a JPEG image                                 |
     *
     * For example:
     * ```js
     * // jpg=string
     * const image1 = await pdfDoc.embedJpg('/9j/4AAQSkZJRgABAQAAAQABAAD/2wBD...')
     * const image2 = await pdfDoc.embedJpg('data:image/jpeg;base64,/9j/4AAQ...')
     *
     * // jpg=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('cat_riding_unicorn.jpg')
     * const image3 = await pdfDoc.embedJpg(uint8Array)
     *
     * // jpg=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const image4 = await pdfDoc.embedJpg(arrayBuffer)
     * ```
     *
     * @param jpg The input data for a JPEG image.
     * @returns Resolves with the embedded image.
     */ PDFDocument.prototype.embedJpg = function(jpg) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, pdfImage;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $j0tvB.assertIs)(jpg, 'jpg', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        bytes = (0, $4ISq8.toUint8Array)(jpg);
                        return [
                            4 /*yield*/ ,
                            (0, $b2f30d23c2f107ea$export$2e2bcd8739ae039).for(bytes)
                        ];
                    case 1:
                        embedder = _a.sent();
                        ref = this.context.nextRef();
                        pdfImage = (0, $593e57425d0dad5a$export$2e2bcd8739ae039).of(ref, this, embedder);
                        this.images.push(pdfImage);
                        return [
                            2 /*return*/ ,
                            pdfImage
                        ];
                }
            });
        });
    };
    /**
     * Embed a PNG image into this document. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                                     |
     * | ------------- | ------------------------------------------------------------ |
     * | `string`      | A base64 encoded string (or data URI) containing a PNG image |
     * | `Uint8Array`  | The raw bytes of a PNG image                                 |
     * | `ArrayBuffer` | The raw bytes of a PNG image                                 |
     *
     * For example:
     * ```js
     * // png=string
     * const image1 = await pdfDoc.embedPng('iVBORw0KGgoAAAANSUhEUgAAAlgAAAF3...')
     * const image2 = await pdfDoc.embedPng('data:image/png;base64,iVBORw0KGg...')
     *
     * // png=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('small_mario.png')
     * const image3 = await pdfDoc.embedPng(uint8Array)
     *
     * // png=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/small_mario.png'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const image4 = await pdfDoc.embedPng(arrayBuffer)
     * ```
     *
     * @param png The input data for a PNG image.
     * @returns Resolves with the embedded image.
     */ PDFDocument.prototype.embedPng = function(png) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, pdfImage;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $j0tvB.assertIs)(png, 'png', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        bytes = (0, $4ISq8.toUint8Array)(png);
                        return [
                            4 /*yield*/ ,
                            (0, $79f8a6e417146498$export$2e2bcd8739ae039).for(bytes)
                        ];
                    case 1:
                        embedder = _a.sent();
                        ref = this.context.nextRef();
                        pdfImage = (0, $593e57425d0dad5a$export$2e2bcd8739ae039).of(ref, this, embedder);
                        this.images.push(pdfImage);
                        return [
                            2 /*return*/ ,
                            pdfImage
                        ];
                }
            });
        });
    };
    /**
     * Embed one or more PDF pages into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourcePdf = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     *
     * // Embed page 74 of `sourcePdf` into `pdfDoc`
     * const [embeddedPage] = await pdfDoc.embedPdf(sourcePdf, [73])
     * ```
     *
     * See [[PDFDocument.load]] for examples of the allowed input data formats.
     *
     * @param pdf The input data containing a PDF document.
     * @param indices The indices of the pages that should be embedded.
     * @returns Resolves with an array of the embedded pages.
     */ PDFDocument.prototype.embedPdf = function(pdf, indices) {
        if (indices === void 0) indices = [
            0
        ];
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var srcDoc, _a, srcPages;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        (0, $j0tvB.assertIs)(pdf, 'pdf', [
                            'string',
                            Uint8Array,
                            ArrayBuffer,
                            [
                                PDFDocument,
                                'PDFDocument'
                            ]
                        ]);
                        (0, $j0tvB.assertIs)(indices, 'indices', [
                            Array
                        ]);
                        if (!(pdf instanceof PDFDocument)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _a = pdf;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            PDFDocument.load(pdf)
                        ];
                    case 2:
                        _a = _b.sent();
                        _b.label = 3;
                    case 3:
                        srcDoc = _a;
                        srcPages = (0, $4ISq8.pluckIndices)(srcDoc.getPages(), indices);
                        return [
                            2 /*return*/ ,
                            this.embedPages(srcPages)
                        ];
                }
            });
        });
    };
    /**
     * Embed a single PDF page into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourceBuffer = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     * const sourcePdfDoc = await PDFDocument.load(sourceBuffer)
     * const sourcePdfPage = sourcePdfDoc.getPages()[73]
     *
     * const embeddedPage = await pdfDoc.embedPage(
     *   sourcePdfPage,
     *
     *   // Clip a section of the source page so that we only embed part of it
     *   { left: 100, right: 450, bottom: 330, top: 570 },
     *
     *   // Translate all drawings of the embedded page by (10, 200) units
     *   [1, 0, 0, 1, 10, 200],
     * )
     * ```
     *
     * @param page The page to be embedded.
     * @param boundingBox
     * Optionally, an area of the source page that should be embedded
     * (defaults to entire page).
     * @param transformationMatrix
     * Optionally, a transformation matrix that is always applied to the embedded
     * page anywhere it is drawn.
     * @returns Resolves with the embedded pdf page.
     */ PDFDocument.prototype.embedPage = function(page, boundingBox, transformationMatrix) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var embeddedPage;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $j0tvB.assertIs)(page, 'page', [
                            [
                                (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039),
                                'PDFPage'
                            ]
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.embedPages([
                                page
                            ], [
                                boundingBox
                            ], [
                                transformationMatrix
                            ])
                        ];
                    case 1:
                        embeddedPage = _a.sent()[0];
                        return [
                            2 /*return*/ ,
                            embeddedPage
                        ];
                }
            });
        });
    };
    /**
     * Embed one or more PDF pages into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourceBuffer = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     * const sourcePdfDoc = await PDFDocument.load(sourceBuffer)
     *
     * const page1 = sourcePdfDoc.getPages()[0]
     * const page2 = sourcePdfDoc.getPages()[52]
     * const page3 = sourcePdfDoc.getPages()[73]
     *
     * const embeddedPages = await pdfDoc.embedPages([page1, page2, page3])
     * ```
     *
     * @param page
     * The pages to be embedded (they must all share the same context).
     * @param boundingBoxes
     * Optionally, an array of clipping boundaries - one for each page
     * (defaults to entirety of each page).
     * @param transformationMatrices
     * Optionally, an array of transformation matrices - one for each page
     * (each page's transformation will apply anywhere it is drawn).
     * @returns Resolves with an array of the embedded pdf pages.
     */ PDFDocument.prototype.embedPages = function(pages, boundingBoxes, transformationMatrices) {
        if (boundingBoxes === void 0) boundingBoxes = [];
        if (transformationMatrices === void 0) transformationMatrices = [];
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var idx, len, currPage, nextPage, context, maybeCopyPage, embeddedPages, idx, len, page, box, matrix, embedder, ref;
            var _a;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (pages.length === 0) return [
                            2 /*return*/ ,
                            []
                        ];
                        // Assert all pages have the same context
                        for(idx = 0, len = pages.length - 1; idx < len; idx++){
                            currPage = pages[idx];
                            nextPage = pages[idx + 1];
                            if (currPage.node.context !== nextPage.node.context) throw new (0, $nAWRe.PageEmbeddingMismatchedContextError)();
                        }
                        context = pages[0].node.context;
                        maybeCopyPage = context === this.context ? function(p) {
                            return p;
                        } : (0, $ea102798c96bfd06$export$2e2bcd8739ae039).for(context, this.context).copy;
                        embeddedPages = new Array(pages.length);
                        idx = 0, len = pages.length;
                        _b.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        page = maybeCopyPage(pages[idx].node);
                        box = boundingBoxes[idx];
                        matrix = transformationMatrices[idx];
                        return [
                            4 /*yield*/ ,
                            (0, $c7d58da35b52112a$export$2e2bcd8739ae039).for(page, box, matrix)
                        ];
                    case 2:
                        embedder = _b.sent();
                        ref = this.context.nextRef();
                        embeddedPages[idx] = (0, $f38ed62eeee08801$export$2e2bcd8739ae039).of(ref, this, embedder);
                        _b.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        (_a = this.embeddedPages).push.apply(_a, embeddedPages);
                        return [
                            2 /*return*/ ,
                            embeddedPages
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You shouldn't need to call this method directly. The [[save]]
     * > and [[saveAsBase64]] methods will automatically ensure that all embedded
     * > assets are flushed before serializing the document.
     *
     * Flush all embedded fonts, PDF pages, and images to this document's
     * [[context]].
     *
     * @returns Resolves when the flush is complete.
     */ PDFDocument.prototype.flush = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.fonts)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.images)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.embeddedPages)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.embeddedFiles)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.javaScripts)
                        ];
                    case 5:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Serialize this document to an array of bytes making up a PDF file.
     * For example:
     * ```js
     * const pdfBytes = await pdfDoc.save()
     * ```
     *
     * There are a number of things you can do with the serialized document,
     * depending on the JavaScript environment you're running in:
     * * Write it to a file in Node or React Native
     * * Download it as a Blob in the browser
     * * Render it in an `iframe`
     *
     * @param options The options to be used when saving the document.
     * @returns Resolves with the bytes of the serialized document.
     */ PDFDocument.prototype.save = function(options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, useObjectStreams, _b, addDefaultPage, _c, objectsPerTick, _d, updateFieldAppearances, form, Writer;
            return (0, $cOQTW.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.useObjectStreams, useObjectStreams = _a === void 0 ? true : _a, _b = options.addDefaultPage, addDefaultPage = _b === void 0 ? true : _b, _c = options.objectsPerTick, objectsPerTick = _c === void 0 ? 50 : _c, _d = options.updateFieldAppearances, updateFieldAppearances = _d === void 0 ? true : _d;
                        (0, $j0tvB.assertIs)(useObjectStreams, 'useObjectStreams', [
                            'boolean'
                        ]);
                        (0, $j0tvB.assertIs)(addDefaultPage, 'addDefaultPage', [
                            'boolean'
                        ]);
                        (0, $j0tvB.assertIs)(objectsPerTick, 'objectsPerTick', [
                            'number'
                        ]);
                        (0, $j0tvB.assertIs)(updateFieldAppearances, 'updateFieldAppearances', [
                            'boolean'
                        ]);
                        if (addDefaultPage && this.getPageCount() === 0) this.addPage();
                        if (updateFieldAppearances) {
                            form = this.formCache.getValue();
                            if (form) form.updateFieldAppearances();
                        }
                        return [
                            4 /*yield*/ ,
                            this.flush()
                        ];
                    case 1:
                        _e.sent();
                        Writer = useObjectStreams ? (0, $5cd89dbe12e59987$export$2e2bcd8739ae039) : (0, $4261dca68d44d2dc$export$2e2bcd8739ae039);
                        return [
                            2 /*return*/ ,
                            Writer.forContext(this.context, objectsPerTick).serializeToBuffer()
                        ];
                }
            });
        });
    };
    /**
     * Serialize this document to a base64 encoded string or data URI making up a
     * PDF file. For example:
     * ```js
     * const base64String = await pdfDoc.saveAsBase64()
     * base64String // => 'JVBERi0xLjcKJYGBgYEKC...'
     *
     * const base64DataUri = await pdfDoc.saveAsBase64({ dataUri: true })
     * base64DataUri // => 'data:application/pdf;base64,JVBERi0xLjcKJYGBgYEKC...'
     * ```
     *
     * @param options The options to be used when saving the document.
     * @returns Resolves with a base64 encoded string or data URI of the
     *          serialized document.
     */ PDFDocument.prototype.saveAsBase64 = function(options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, dataUri, otherOptions, bytes, base64;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = options.dataUri, dataUri = _a === void 0 ? false : _a, otherOptions = (0, $cOQTW.__rest)(options, [
                            "dataUri"
                        ]);
                        (0, $j0tvB.assertIs)(dataUri, 'dataUri', [
                            'boolean'
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.save(otherOptions)
                        ];
                    case 1:
                        bytes = _b.sent();
                        base64 = (0, $fZ8o5.encodeToBase64)(bytes);
                        return [
                            2 /*return*/ ,
                            dataUri ? "data:application/pdf;base64," + base64 : base64
                        ];
                }
            });
        });
    };
    PDFDocument.prototype.findPageForAnnotationRef = function(ref) {
        var pages = this.getPages();
        for(var idx = 0, len = pages.length; idx < len; idx++){
            var page = pages[idx];
            var annotations = page.node.Annots();
            if ((annotations === null || annotations === void 0 ? void 0 : annotations.indexOf(ref)) !== undefined) return page;
        }
        return undefined;
    };
    PDFDocument.prototype.embedAll = function(embeddables) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var idx, len;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        idx = 0, len = embeddables.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            embeddables[idx].embed()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFDocument.prototype.updateInfoDict = function() {
        var pdfLib = "pdf-lib (https://github.com/Hopding/pdf-lib)";
        var now = new Date();
        var info = this.getInfoDict();
        this.setProducer(pdfLib);
        this.setModificationDate(now);
        if (!info.get((0, $dPHSK.default).of('Creator'))) this.setCreator(pdfLib);
        if (!info.get((0, $dPHSK.default).of('CreationDate'))) this.setCreationDate(now);
    };
    PDFDocument.prototype.getInfoDict = function() {
        var existingInfo = this.context.lookup(this.context.trailerInfo.Info);
        if (existingInfo instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) return existingInfo;
        var newInfo = this.context.obj({});
        this.context.trailerInfo.Info = this.context.register(newInfo);
        return newInfo;
    };
    PDFDocument.prototype.assertFontkit = function() {
        if (!this.fontkit) throw new (0, $7fe2d034822cb526$export$529a7c74d0636a48)();
        return this.fontkit;
    };
    return PDFDocument;
}();
var $93b2571d4e1dfe94$export$2e2bcd8739ae039 = $93b2571d4e1dfe94$var$PDFDocument;
/* tslint:disable-next-line only-arrow-functions */ function $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(pdfObject) {
    if (!(pdfObject instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) && !(pdfObject instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039))) throw new (0, $nAWRe.UnexpectedObjectTypeError)([
        (0, $e8537943f4279a06$export$2e2bcd8739ae039),
        (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039)
    ], pdfObject);
}





var $dd8872426cc55b05$export$c9b8fe72ac71821;
(function(BlendMode) {
    BlendMode["Normal"] = "Normal";
    BlendMode["Multiply"] = "Multiply";
    BlendMode["Screen"] = "Screen";
    BlendMode["Overlay"] = "Overlay";
    BlendMode["Darken"] = "Darken";
    BlendMode["Lighten"] = "Lighten";
    BlendMode["ColorDodge"] = "ColorDodge";
    BlendMode["ColorBurn"] = "ColorBurn";
    BlendMode["HardLight"] = "HardLight";
    BlendMode["SoftLight"] = "SoftLight";
    BlendMode["Difference"] = "Difference";
    BlendMode["Exclusion"] = "Exclusion";
})($dd8872426cc55b05$export$c9b8fe72ac71821 || ($dd8872426cc55b05$export$c9b8fe72ac71821 = {}));





var $8auL6 = parcelRequire("8auL6");
var $dPHSK = parcelRequire("dPHSK");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var $7Kmy8 = parcelRequire("7Kmy8");
var $cbIAG = parcelRequire("cbIAG");
/**
 * Represents a single page of a [[PDFDocument]].
 */ var $a7f75cccfbb7eb6c$var$PDFPage = /** @class */ function() {
    function PDFPage(leafNode, ref, doc) {
        this.fontSize = 24;
        this.fontColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        this.lineHeight = 24;
        this.x = 0;
        this.y = 0;
        (0, $j0tvB.assertIs)(leafNode, 'leafNode', [
            [
                (0, $a9e73b7ced5abfa4$export$2e2bcd8739ae039),
                'PDFPageLeaf'
            ]
        ]);
        (0, $j0tvB.assertIs)(ref, 'ref', [
            [
                (0, $f1233b848bc26abe$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $93b2571d4e1dfe94$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        this.node = leafNode;
        this.ref = ref;
        this.doc = doc;
    }
    /**
     * Rotate this page by a multiple of 90 degrees. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * page.setRotation(degrees(-90))
     * page.setRotation(degrees(0))
     * page.setRotation(degrees(90))
     * page.setRotation(degrees(180))
     * page.setRotation(degrees(270))
     * ```
     * @param angle The angle to rotate this page.
     */ PDFPage.prototype.setRotation = function(angle) {
        var degreesAngle = (0, $3b4f8728c2695c8d$export$56cb859c01fa134d)(angle);
        (0, $j0tvB.assertMultiple)(degreesAngle, 'degreesAngle', 90);
        this.node.set((0, $dPHSK.default).of('Rotate'), this.doc.context.obj(degreesAngle));
    };
    /**
     * Get this page's rotation angle in degrees. For example:
     * ```js
     * const rotationAngle = page.getRotation().angle;
     * ```
     * @returns The rotation angle of the page in degrees (always a multiple of
     *          90 degrees).
     */ PDFPage.prototype.getRotation = function() {
        var Rotate = this.node.Rotate();
        return (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(Rotate ? Rotate.asNumber() : 0);
    };
    /**
     * Resize this page by increasing or decreasing its width and height. For
     * example:
     * ```js
     * page.setSize(250, 500)
     * page.setSize(page.getWidth() + 50, page.getHeight() + 100)
     * page.setSize(page.getWidth() - 50, page.getHeight() - 100)
     * ```
     *
     * Note that the PDF specification does not allow for pages to have explicit
     * widths and heights. Instead it defines the "size" of a page in terms of
     * five rectangles: the MediaBox, CropBox, BleedBox, TrimBox, and ArtBox. As a
     * result, this method cannot directly change the width and height of a page.
     * Instead, it works by adjusting these five boxes.
     *
     * This method performs the following steps:
     *   1. Set width & height of MediaBox.
     *   2. Set width & height of CropBox, if it has same dimensions as MediaBox.
     *   3. Set width & height of BleedBox, if it has same dimensions as MediaBox.
     *   4. Set width & height of TrimBox, if it has same dimensions as MediaBox.
     *   5. Set width & height of ArtBox, if it has same dimensions as MediaBox.
     *
     * This approach works well for most PDF documents as all PDF pages must
     * have a MediaBox, but relatively few have a CropBox, BleedBox, TrimBox, or
     * ArtBox. And when they do have these additional boxes, they often have the
     * same dimensions as the MediaBox. However, if you find this method does not
     * work for your document, consider setting the boxes directly:
     *   * [[PDFPage.setMediaBox]]
     *   * [[PDFPage.setCropBox]]
     *   * [[PDFPage.setBleedBox]]
     *   * [[PDFPage.setTrimBox]]
     *   * [[PDFPage.setArtBox]]
     *
     * @param width The new width of the page.
     * @param height The new height of the page.
     */ PDFPage.prototype.setSize = function(width, height) {
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var mediaBox = this.getMediaBox();
        this.setMediaBox(mediaBox.x, mediaBox.y, width, height);
        var cropBox = this.getCropBox();
        var bleedBox = this.getBleedBox();
        var trimBox = this.getTrimBox();
        var artBox = this.getArtBox();
        var hasCropBox = this.node.CropBox();
        var hasBleedBox = this.node.BleedBox();
        var hasTrimBox = this.node.TrimBox();
        var hasArtBox = this.node.ArtBox();
        if (hasCropBox && (0, $cbIAG.rectanglesAreEqual)(cropBox, mediaBox)) this.setCropBox(mediaBox.x, mediaBox.y, width, height);
        if (hasBleedBox && (0, $cbIAG.rectanglesAreEqual)(bleedBox, mediaBox)) this.setBleedBox(mediaBox.x, mediaBox.y, width, height);
        if (hasTrimBox && (0, $cbIAG.rectanglesAreEqual)(trimBox, mediaBox)) this.setTrimBox(mediaBox.x, mediaBox.y, width, height);
        if (hasArtBox && (0, $cbIAG.rectanglesAreEqual)(artBox, mediaBox)) this.setArtBox(mediaBox.x, mediaBox.y, width, height);
    };
    /**
     * Resize this page by increasing or decreasing its width. For example:
     * ```js
     * page.setWidth(250)
     * page.setWidth(page.getWidth() + 50)
     * page.setWidth(page.getWidth() - 50)
     * ```
     *
     * This method uses [[PDFPage.setSize]] to set the page's width.
     *
     * @param width The new width of the page.
     */ PDFPage.prototype.setWidth = function(width) {
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        this.setSize(width, this.getSize().height);
    };
    /**
     * Resize this page by increasing or decreasing its height. For example:
     * ```js
     * page.setHeight(500)
     * page.setHeight(page.getWidth() + 100)
     * page.setHeight(page.getWidth() - 100)
     * ```
     *
     * This method uses [[PDFPage.setSize]] to set the page's height.
     *
     * @param height The new height of the page.
     */ PDFPage.prototype.setHeight = function(height) {
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        this.setSize(this.getSize().width, height);
    };
    /**
     * Set the MediaBox of this page. For example:
     * ```js
     * const mediaBox = page.getMediaBox()
     *
     * page.setMediaBox(0, 0, 250, 500)
     * page.setMediaBox(mediaBox.x, mediaBox.y, 50, 100)
     * page.setMediaBox(15, 5, mediaBox.width - 50, mediaBox.height - 100)
     * ```
     *
     * See [[PDFPage.getMediaBox]] for details about what the MediaBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new MediaBox.
     * @param y The y coordinate of the lower left corner of the new MediaBox.
     * @param width The width of the new MediaBox.
     * @param height The height of the new MediaBox.
     */ PDFPage.prototype.setMediaBox = function(x, y, width, height) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var mediaBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $dPHSK.default).MediaBox, mediaBox);
    };
    /**
     * Set the CropBox of this page. For example:
     * ```js
     * const cropBox = page.getCropBox()
     *
     * page.setCropBox(0, 0, 250, 500)
     * page.setCropBox(cropBox.x, cropBox.y, 50, 100)
     * page.setCropBox(15, 5, cropBox.width - 50, cropBox.height - 100)
     * ```
     *
     * See [[PDFPage.getCropBox]] for details about what the CropBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new CropBox.
     * @param y The y coordinate of the lower left corner of the new CropBox.
     * @param width The width of the new CropBox.
     * @param height The height of the new CropBox.
     */ PDFPage.prototype.setCropBox = function(x, y, width, height) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var cropBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $dPHSK.default).CropBox, cropBox);
    };
    /**
     * Set the BleedBox of this page. For example:
     * ```js
     * const bleedBox = page.getBleedBox()
     *
     * page.setBleedBox(0, 0, 250, 500)
     * page.setBleedBox(bleedBox.x, bleedBox.y, 50, 100)
     * page.setBleedBox(15, 5, bleedBox.width - 50, bleedBox.height - 100)
     * ```
     *
     * See [[PDFPage.getBleedBox]] for details about what the BleedBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new BleedBox.
     * @param y The y coordinate of the lower left corner of the new BleedBox.
     * @param width The width of the new BleedBox.
     * @param height The height of the new BleedBox.
     */ PDFPage.prototype.setBleedBox = function(x, y, width, height) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var bleedBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $dPHSK.default).BleedBox, bleedBox);
    };
    /**
     * Set the TrimBox of this page. For example:
     * ```js
     * const trimBox = page.getTrimBox()
     *
     * page.setTrimBox(0, 0, 250, 500)
     * page.setTrimBox(trimBox.x, trimBox.y, 50, 100)
     * page.setTrimBox(15, 5, trimBox.width - 50, trimBox.height - 100)
     * ```
     *
     * See [[PDFPage.getTrimBox]] for details about what the TrimBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new TrimBox.
     * @param y The y coordinate of the lower left corner of the new TrimBox.
     * @param width The width of the new TrimBox.
     * @param height The height of the new TrimBox.
     */ PDFPage.prototype.setTrimBox = function(x, y, width, height) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var trimBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $dPHSK.default).TrimBox, trimBox);
    };
    /**
     * Set the ArtBox of this page. For example:
     * ```js
     * const artBox = page.getArtBox()
     *
     * page.setArtBox(0, 0, 250, 500)
     * page.setArtBox(artBox.x, artBox.y, 50, 100)
     * page.setArtBox(15, 5, artBox.width - 50, artBox.height - 100)
     * ```
     *
     * See [[PDFPage.getArtBox]] for details about what the ArtBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new ArtBox.
     * @param y The y coordinate of the lower left corner of the new ArtBox.
     * @param width The width of the new ArtBox.
     * @param height The height of the new ArtBox.
     */ PDFPage.prototype.setArtBox = function(x, y, width, height) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var artBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $dPHSK.default).ArtBox, artBox);
    };
    /**
     * Get this page's width and height. For example:
     * ```js
     * const { width, height } = page.getSize()
     * ```
     *
     * This method uses [[PDFPage.getMediaBox]] to obtain the page's
     * width and height.
     *
     * @returns The width and height of the page.
     */ PDFPage.prototype.getSize = function() {
        var _a = this.getMediaBox(), width = _a.width, height = _a.height;
        return {
            width: width,
            height: height
        };
    };
    /**
     * Get this page's width. For example:
     * ```js
     * const width = page.getWidth()
     * ```
     *
     * This method uses [[PDFPage.getSize]] to obtain the page's size.
     *
     * @returns The width of the page.
     */ PDFPage.prototype.getWidth = function() {
        return this.getSize().width;
    };
    /**
     * Get this page's height. For example:
     * ```js
     * const height = page.getHeight()
     * ```
     *
     * This method uses [[PDFPage.getSize]] to obtain the page's size.
     *
     * @returns The height of the page.
     */ PDFPage.prototype.getHeight = function() {
        return this.getSize().height;
    };
    /**
     * Get the rectangle defining this page's MediaBox. For example:
     * ```js
     * const { x, y, width, height } = page.getMediaBox()
     * ```
     *
     * The MediaBox of a page defines the boundaries of the physical medium on
     * which the page is to be displayed/printed. It may include extended area
     * surrounding the page content for bleed marks, printing marks, etc...
     * It may also include areas close to the edges of the medium that cannot be
     * marked because of physical limitations of the output device. Content
     * falling outside this boundary may safely be discarded without affecting
     * the meaning of the PDF file.
     *
     * @returns An object defining the lower left corner of the MediaBox and its
     *          width & height.
     */ PDFPage.prototype.getMediaBox = function() {
        var mediaBox = this.node.MediaBox();
        return mediaBox.asRectangle();
    };
    /**
     * Get the rectangle defining this page's CropBox. For example:
     * ```js
     * const { x, y, width, height } = page.getCropBox()
     * ```
     *
     * The CropBox of a page defines the region to which the contents of the page
     * shall be clipped when displayed or printed. Unlike the other boxes, the
     * CropBox does not necessarily represent the physical page geometry. It
     * merely imposes clipping on the page contents.
     *
     * The CropBox's default value is the page's MediaBox.
     *
     * @returns An object defining the lower left corner of the CropBox and its
     *          width & height.
     */ PDFPage.prototype.getCropBox = function() {
        var _a;
        var cropBox = this.node.CropBox();
        return (_a = cropBox === null || cropBox === void 0 ? void 0 : cropBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getMediaBox();
    };
    /**
     * Get the rectangle defining this page's BleedBox. For example:
     * ```js
     * const { x, y, width, height } = page.getBleedBox()
     * ```
     *
     * The BleedBox of a page defines the region to which the contents of the
     * page shall be clipped when output in a production environment. This may
     * include any extra bleed area needed to accommodate the physical
     * limitations of cutting, folding, and trimming equipment. The actual
     * printed page may include printing marks that fall outside the BleedBox.
     *
     * The BleedBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the BleedBox and its
     *          width & height.
     */ PDFPage.prototype.getBleedBox = function() {
        var _a;
        var bleedBox = this.node.BleedBox();
        return (_a = bleedBox === null || bleedBox === void 0 ? void 0 : bleedBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Get the rectangle defining this page's TrimBox. For example:
     * ```js
     * const { x, y, width, height } = page.getTrimBox()
     * ```
     *
     * The TrimBox of a page defines the intended dimensions of the finished
     * page after trimming. It may be smaller than the MediaBox to allow for
     * production-related content, such as printing instructions, cut marks, or
     * color bars.
     *
     * The TrimBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the TrimBox and its
     *          width & height.
     */ PDFPage.prototype.getTrimBox = function() {
        var _a;
        var trimBox = this.node.TrimBox();
        return (_a = trimBox === null || trimBox === void 0 ? void 0 : trimBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Get the rectangle defining this page's ArtBox. For example:
     * ```js
     * const { x, y, width, height } = page.getArtBox()
     * ```
     *
     * The ArtBox of a page defines the extent of the page's meaningful content
     * (including potential white space).
     *
     * The ArtBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the ArtBox and its
     *          width & height.
     */ PDFPage.prototype.getArtBox = function() {
        var _a;
        var artBox = this.node.ArtBox();
        return (_a = artBox === null || artBox === void 0 ? void 0 : artBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Translate this page's content to a new location on the page. This operation
     * is often useful after resizing the page with [[setSize]]. For example:
     * ```js
     * // Add 50 units of whitespace to the top and right of the page
     * page.setSize(page.getWidth() + 50, page.getHeight() + 50)
     *
     * // Move the page's content from the lower-left corner of the page
     * // to the top-right corner.
     * page.translateContent(50, 50)
     *
     * // Now there are 50 units of whitespace to the left and bottom of the page
     * ```
     * See also: [[resetPosition]]
     * @param x The new position on the x-axis for this page's content.
     * @param y The new position on the y-axis for this page's content.
     */ PDFPage.prototype.translateContent = function(x, y) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        this.node.normalize();
        this.getContentStream();
        var start = this.createContentStream((0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(), (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(x, y));
        var startRef = this.doc.context.register(start);
        var end = this.createContentStream((0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)());
        var endRef = this.doc.context.register(end);
        this.node.wrapContentStreams(startRef, endRef);
    };
    /**
     * Scale the size, content, and annotations of a page.
     *
     * For example:
     * ```js
     * page.scale(0.5, 0.5);
     * ```
     *
     * @param x The factor by which the width for the page should be scaled
     *          (e.g. `0.5` is 50%).
     * @param y The factor by which the height for the page should be scaled
     *          (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scale = function(x, y) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        this.setSize(this.getWidth() * x, this.getHeight() * y);
        this.scaleContent(x, y);
        this.scaleAnnotations(x, y);
    };
    /**
     * Scale the content of a page. This is useful after resizing an existing
     * page. This scales only the content, not the annotations.
     *
     * For example:
     * ```js
     * // Bisect the size of the page
     * page.setSize(page.getWidth() / 2, page.getHeight() / 2);
     *
     * // Scale the content of the page down by 50% in x and y
     * page.scaleContent(0.5, 0.5);
     * ```
     * See also: [[scaleAnnotations]]
     * @param x The factor by which the x-axis for the content should be scaled
     *          (e.g. `0.5` is 50%).
     * @param y The factor by which the y-axis for the content should be scaled
     *          (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scaleContent = function(x, y) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        this.node.normalize();
        this.getContentStream();
        var start = this.createContentStream((0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(), (0, $cfb765e9daff3c3a$export$dcdf75081b88279d)(x, y));
        var startRef = this.doc.context.register(start);
        var end = this.createContentStream((0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)());
        var endRef = this.doc.context.register(end);
        this.node.wrapContentStreams(startRef, endRef);
    };
    /**
     * Scale the annotations of a page. This is useful if you want to scale a
     * page with comments or other annotations.
     * ```js
     * // Scale the content of the page down by 50% in x and y
     * page.scaleContent(0.5, 0.5);
     *
     * // Scale the content of the page down by 50% in x and y
     * page.scaleAnnotations(0.5, 0.5);
     * ```
     * See also: [[scaleContent]]
     * @param x The factor by which the x-axis for the annotations should be
     *          scaled (e.g. `0.5` is 50%).
     * @param y The factor by which the y-axis for the annotations should be
     *          scaled (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scaleAnnotations = function(x, y) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        var annots = this.node.Annots();
        if (!annots) return;
        for(var idx = 0; idx < annots.size(); idx++){
            var annot = annots.lookup(idx);
            if (annot instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) this.scaleAnnot(annot, x, y);
        }
    };
    /**
     * Reset the x and y coordinates of this page to `(0, 0)`. This operation is
     * often useful after calling [[translateContent]]. For example:
     * ```js
     * // Shift the page's contents up and to the right by 50 units
     * page.translateContent(50, 50)
     *
     * // This text will shifted - it will be drawn at (50, 50)
     * page.drawText('I am shifted')
     *
     * // Move back to (0, 0)
     * page.resetPosition()
     *
     * // This text will not be shifted - it will be drawn at (0, 0)
     * page.drawText('I am not shifted')
     * ```
     */ PDFPage.prototype.resetPosition = function() {
        this.getContentStream(false);
        this.x = 0;
        this.y = 0;
    };
    /**
     * Choose a default font for this page. The default font will be used whenever
     * text is drawn on this page and no font is specified. For example:
     * ```js
     * import { StandardFonts } from 'pdf-lib'
     *
     * const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman)
     * const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const courierFont = await pdfDoc.embedFont(StandardFonts.Courier)
     *
     * const page = pdfDoc.addPage()
     *
     * page.setFont(helveticaFont)
     * page.drawText('I will be drawn in Helvetica')
     *
     * page.setFont(timesRomanFont)
     * page.drawText('I will be drawn in Courier', { font: courierFont })
     * ```
     * @param font The default font to be used when drawing text on this page.
     */ PDFPage.prototype.setFont = function(font) {
        // TODO: Reuse image Font name if we've already added this image to Resources.Fonts
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $fb353673e42bee9b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.font = font;
        this.fontKey = this.node.newFontDictionary(this.font.name, this.font.ref);
    };
    /**
     * Choose a default font size for this page. The default font size will be
     * used whenever text is drawn on this page and no font size is specified.
     * For example:
     * ```js
     * page.setFontSize(12)
     * page.drawText('I will be drawn in size 12')
     *
     * page.setFontSize(36)
     * page.drawText('I will be drawn in size 24', { fontSize: 24 })
     * ```
     * @param fontSize The default font size to be used when drawing text on this
     *                 page.
     */ PDFPage.prototype.setFontSize = function(fontSize) {
        (0, $j0tvB.assertIs)(fontSize, 'fontSize', [
            'number'
        ]);
        this.fontSize = fontSize;
    };
    /**
     * Choose a default font color for this page. The default font color will be
     * used whenever text is drawn on this page and no font color is specified.
     * For example:
     * ```js
     * import { rgb, cmyk, grayscale } from 'pdf-lib'
     *
     * page.setFontColor(rgb(0.97, 0.02, 0.97))
     * page.drawText('I will be drawn in pink')
     *
     * page.setFontColor(cmyk(0.4, 0.7, 0.39, 0.15))
     * page.drawText('I will be drawn in gray', { color: grayscale(0.5) })
     * ```
     * @param fontColor The default font color to be used when drawing text on
     *                  this page.
     */ PDFPage.prototype.setFontColor = function(fontColor) {
        (0, $j0tvB.assertIs)(fontColor, 'fontColor', [
            [
                Object,
                'Color'
            ]
        ]);
        this.fontColor = fontColor;
    };
    /**
     * Choose a default line height for this page. The default line height will be
     * used whenever text is drawn on this page and no line height is specified.
     * For example:
     * ```js
     * page.setLineHeight(12);
     * page.drawText('These lines will be vertically \n separated by 12 units')
     *
     * page.setLineHeight(36);
     * page.drawText('These lines will be vertically \n separated by 24 units', {
     *   lineHeight: 24
     * })
     * ```
     * @param lineHeight The default line height to be used when drawing text on
     *                   this page.
     */ PDFPage.prototype.setLineHeight = function(lineHeight) {
        (0, $j0tvB.assertIs)(lineHeight, 'lineHeight', [
            'number'
        ]);
        this.lineHeight = lineHeight;
    };
    /**
     * Get the default position of this page. For example:
     * ```js
     * const { x, y } = page.getPosition()
     * ```
     * @returns The default position of the page.
     */ PDFPage.prototype.getPosition = function() {
        return {
            x: this.x,
            y: this.y
        };
    };
    /**
     * Get the default x coordinate of this page. For example:
     * ```js
     * const x = page.getX()
     * ```
     * @returns The default x coordinate of the page.
     */ PDFPage.prototype.getX = function() {
        return this.x;
    };
    /**
     * Get the default y coordinate of this page. For example:
     * ```js
     * const y = page.getY()
     * ```
     * @returns The default y coordinate of the page.
     */ PDFPage.prototype.getY = function() {
        return this.y;
    };
    /**
     * Change the default position of this page. For example:
     * ```js
     * page.moveTo(0, 0)
     * page.drawText('I will be drawn at the origin')
     *
     * page.moveTo(0, 25)
     * page.drawText('I will be drawn 25 units up')
     *
     * page.moveTo(25, 25)
     * page.drawText('I will be drawn 25 units up and 25 units to the right')
     * ```
     * @param x The new default position on the x-axis for this page.
     * @param y The new default position on the y-axis for this page.
     */ PDFPage.prototype.moveTo = function(x, y) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        this.x = x;
        this.y = y;
    };
    /**
     * Change the default position of this page to be further down the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveDown(10)
     * page.drawText('I will be drawn at (50, 40)')
     * ```
     * @param yDecrease The amount by which the page's default position along the
     *                  y-axis should be decreased.
     */ PDFPage.prototype.moveDown = function(yDecrease) {
        (0, $j0tvB.assertIs)(yDecrease, 'yDecrease', [
            'number'
        ]);
        this.y -= yDecrease;
    };
    /**
     * Change the default position of this page to be further up the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveUp(10)
     * page.drawText('I will be drawn at (50, 60)')
     * ```
     * @param yIncrease The amount by which the page's default position along the
     *                  y-axis should be increased.
     */ PDFPage.prototype.moveUp = function(yIncrease) {
        (0, $j0tvB.assertIs)(yIncrease, 'yIncrease', [
            'number'
        ]);
        this.y += yIncrease;
    };
    /**
     * Change the default position of this page to be further left on the x-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveLeft(10)
     * page.drawText('I will be drawn at (40, 50)')
     * ```
     * @param xDecrease The amount by which the page's default position along the
     *                  x-axis should be decreased.
     */ PDFPage.prototype.moveLeft = function(xDecrease) {
        (0, $j0tvB.assertIs)(xDecrease, 'xDecrease', [
            'number'
        ]);
        this.x -= xDecrease;
    };
    /**
     * Change the default position of this page to be further right on the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveRight(10)
     * page.drawText('I will be drawn at (60, 50)')
     * ```
     * @param xIncrease The amount by which the page's default position along the
     *                  x-axis should be increased.
     */ PDFPage.prototype.moveRight = function(xIncrease) {
        (0, $j0tvB.assertIs)(xIncrease, 'xIncrease', [
            'number'
        ]);
        this.x += xIncrease;
    };
    /**
     * Push one or more operators to the end of this page's current content
     * stream. For example:
     * ```js
     * import {
     *   pushGraphicsState,
     *   moveTo,
     *   lineTo,
     *   closePath,
     *   setFillingColor,
     *   rgb,
     *   fill,
     *   popGraphicsState,
     * } from 'pdf-lib'
     *
     * // Draw a green triangle in the lower-left corner of the page
     * page.pushOperators(
     *   pushGraphicsState(),
     *   moveTo(0, 0),
     *   lineTo(100, 0),
     *   lineTo(50, 100),
     *   closePath(),
     *   setFillingColor(rgb(0.0, 1.0, 0.0)),
     *   fill(),
     *   popGraphicsState(),
     * )
     * ```
     * @param operator The operators to be pushed.
     */ PDFPage.prototype.pushOperators = function() {
        var operator = [];
        for(var _i = 0; _i < arguments.length; _i++)operator[_i] = arguments[_i];
        (0, $j0tvB.assertEachIs)(operator, 'operator', [
            [
                (0, $400c0bd11400a1c4$export$2e2bcd8739ae039),
                'PDFOperator'
            ]
        ]);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, operator);
    };
    /**
     * Draw one or more lines of text on this page. For example:
     * ```js
     * import { StandardFonts, rgb } from 'pdf-lib'
     *
     * const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman)
     *
     * const page = pdfDoc.addPage()
     *
     * page.setFont(helveticaFont)
     *
     * page.moveTo(5, 200)
     * page.drawText('The Life of an Egg', { size: 36 })
     *
     * page.moveDown(36)
     * page.drawText('An Epic Tale of Woe', { size: 30 })
     *
     * page.drawText(
     *   `Humpty Dumpty sat on a wall \n` +
     *   `Humpty Dumpty had a great fall; \n` +
     *   `All the king's horses and all the king's men \n` +
     *   `Couldn't put Humpty together again. \n`,
     *   {
     *     x: 25,
     *     y: 100,
     *     font: timesRomanFont,
     *     size: 24,
     *     color: rgb(1, 0, 0),
     *     lineHeight: 24,
     *     opacity: 0.75,
     *   },
     * )
     * ```
     * @param text The text to be drawn.
     * @param options The options to be used when drawing the text.
     */ PDFPage.prototype.drawText = function(text, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (options === void 0) options = {};
        (0, $j0tvB.assertIs)(text, 'text', [
            'string'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertOrUndefined)(options.font, 'options.font', [
            [
                (0, $fb353673e42bee9b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.size, 'options.size', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.lineHeight, 'options.lineHeight', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.maxWidth, 'options.maxWidth', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.wordBreaks, 'options.wordBreaks', [
            Array
        ]);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $dd8872426cc55b05$export$c9b8fe72ac71821));
        var _h = this.setOrEmbedFont(options.font), oldFont = _h.oldFont, newFont = _h.newFont, newFontKey = _h.newFontKey;
        var fontSize = options.size || this.fontSize;
        var wordBreaks = options.wordBreaks || this.doc.defaultWordBreaks;
        var textWidth = function(t) {
            return newFont.widthOfTextAtSize(t, fontSize);
        };
        var lines = options.maxWidth === undefined ? (0, $7Kmy8.lineSplit)((0, $7Kmy8.cleanText)(text)) : (0, $7Kmy8.breakTextIntoLines)(text, wordBreaks, options.maxWidth, textWidth);
        var encodedLines = new Array(lines.length);
        for(var idx = 0, len = lines.length; idx < len; idx++)encodedLines[idx] = newFont.encodeText(lines[idx]);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $55cf96b3448598de$export$f7b8b44d3d84bc26)(encodedLines, {
            color: (_a = options.color) !== null && _a !== void 0 ? _a : this.fontColor,
            font: newFontKey,
            size: fontSize,
            rotate: (_b = options.rotate) !== null && _b !== void 0 ? _b : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            xSkew: (_c = options.xSkew) !== null && _c !== void 0 ? _c : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            ySkew: (_d = options.ySkew) !== null && _d !== void 0 ? _d : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            x: (_e = options.x) !== null && _e !== void 0 ? _e : this.x,
            y: (_f = options.y) !== null && _f !== void 0 ? _f : this.y,
            lineHeight: (_g = options.lineHeight) !== null && _g !== void 0 ? _g : this.lineHeight,
            graphicsState: graphicsStateKey
        }));
        if (options.font) {
            if (oldFont) this.setFont(oldFont);
            else this.resetFont();
        }
    };
    /**
     * Draw an image on this page. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * const jpgUrl = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const jpgImageBytes = await fetch(jpgUrl).then((res) => res.arrayBuffer())
     *
     * const jpgImage = await pdfDoc.embedJpg(jpgImageBytes)
     * const jpgDims = jpgImage.scale(0.5)
     *
     * const page = pdfDoc.addPage()
     *
     * page.drawImage(jpgImage, {
     *   x: 25,
     *   y: 25,
     *   width: jpgDims.width,
     *   height: jpgDims.height,
     *   rotate: degrees(30),
     *   opacity: 0.75,
     * })
     * ```
     * @param image The image to be drawn.
     * @param options The options to be used when drawing the image.
     */ PDFPage.prototype.drawImage = function(image, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (options === void 0) options = {};
        // TODO: Reuse image XObject name if we've already added this image to Resources.XObjects
        (0, $j0tvB.assertIs)(image, 'image', [
            [
                (0, $593e57425d0dad5a$export$2e2bcd8739ae039),
                'PDFImage'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.width, 'options.width', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.height, 'options.height', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $dd8872426cc55b05$export$c9b8fe72ac71821));
        var xObjectKey = this.node.newXObject('Image', image.ref);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $55cf96b3448598de$export$21a059be5bfd5fb)(xObjectKey, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : image.size().width,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : image.size().height,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            xSkew: (_f = options.xSkew) !== null && _f !== void 0 ? _f : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            ySkew: (_g = options.ySkew) !== null && _g !== void 0 ? _g : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw an embedded PDF page on this page. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const page = pdfDoc.addPage()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourcePdf = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     *
     * // Embed page 74 from the PDF
     * const [embeddedPage] = await pdfDoc.embedPdf(sourcePdf, 73)
     *
     * page.drawPage(embeddedPage, {
     *   x: 250,
     *   y: 200,
     *   xScale: 0.5,
     *   yScale: 0.5,
     *   rotate: degrees(30),
     *   opacity: 0.75,
     * })
     * ```
     *
     * The `options` argument accepts both `width`/`height` and `xScale`/`yScale`
     * as options. Since each of these options defines the size of the drawn page,
     * if both options are given, `width` and `height` take precedence and the
     * corresponding scale variants are ignored.
     *
     * @param embeddedPage The embedded page to be drawn.
     * @param options The options to be used when drawing the embedded page.
     */ PDFPage.prototype.drawPage = function(embeddedPage, options) {
        var _a, _b, _c, _d, _e;
        if (options === void 0) options = {};
        // TODO: Reuse embeddedPage XObject name if we've already added this embeddedPage to Resources.XObjects
        (0, $j0tvB.assertIs)(embeddedPage, 'embeddedPage', [
            [
                (0, $f38ed62eeee08801$export$2e2bcd8739ae039),
                'PDFEmbeddedPage'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xScale, 'options.xScale', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.yScale, 'options.yScale', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.width, 'options.width', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.height, 'options.height', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $dd8872426cc55b05$export$c9b8fe72ac71821));
        var xObjectKey = this.node.newXObject('EmbeddedPdfPage', embeddedPage.ref);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        // prettier-ignore
        var xScale = options.width !== undefined ? options.width / embeddedPage.width : options.xScale !== undefined ? options.xScale : 1;
        // prettier-ignore
        var yScale = options.height !== undefined ? options.height / embeddedPage.height : options.yScale !== undefined ? options.yScale : 1;
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $55cf96b3448598de$export$f8ea28c31069cbc9)(xObjectKey, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            xScale: xScale,
            yScale: yScale,
            rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            xSkew: (_d = options.xSkew) !== null && _d !== void 0 ? _d : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            ySkew: (_e = options.ySkew) !== null && _e !== void 0 ? _e : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw an SVG path on this page. For example:
     * ```js
     * import { rgb } from 'pdf-lib'
     *
     * const svgPath = 'M 0,20 L 100,160 Q 130,200 150,120 C 190,-40 200,200 300,150 L 400,90'
     *
     * // Draw path as black line
     * page.drawSvgPath(svgPath, { x: 25, y: 75 })
     *
     * // Change border style and opacity
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 275,
     *   borderColor: rgb(0.5, 0.5, 0.5),
     *   borderWidth: 2,
     *   borderOpacity: 0.75,
     * })
     *
     * // Set fill color and opacity
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 475,
     *   color: rgb(1.0, 0, 0),
     *   opacity: 0.75,
     * })
     *
     * // Draw 50% of original size
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 675,
     *   scale: 0.5,
     * })
     * ```
     * @param path The SVG path to be drawn.
     * @param options The options to be used when drawing the SVG path.
     */ PDFPage.prototype.drawSvgPath = function(path, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (options === void 0) options = {};
        (0, $j0tvB.assertIs)(path, 'path', [
            'string'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.scale, 'options.scale', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderWidth, 'options.borderWidth', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertOrUndefined)(options.borderColor, 'options.borderColor', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashArray, 'options.borderDashArray', [
            Array
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashPhase, 'options.borderDashPhase', [
            'number'
        ]);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.borderLineCap, 'options.borderLineCap', (0, $cfb765e9daff3c3a$export$7a77bc708e50709e));
        (0, $j0tvB.assertRangeOrUndefined)(options.borderOpacity, 'options.borderOpacity', 0, 1);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $dd8872426cc55b05$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!('color' in options) && !('borderColor' in options)) options.borderColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $55cf96b3448598de$export$47c8a640c39d0756)(path, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            scale: options.scale,
            rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            color: (_d = options.color) !== null && _d !== void 0 ? _d : undefined,
            borderColor: (_e = options.borderColor) !== null && _e !== void 0 ? _e : undefined,
            borderWidth: (_f = options.borderWidth) !== null && _f !== void 0 ? _f : 0,
            borderDashArray: (_g = options.borderDashArray) !== null && _g !== void 0 ? _g : undefined,
            borderDashPhase: (_h = options.borderDashPhase) !== null && _h !== void 0 ? _h : undefined,
            borderLineCap: (_j = options.borderLineCap) !== null && _j !== void 0 ? _j : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a line on this page. For example:
     * ```js
     * import { rgb } from 'pdf-lib'
     *
     * page.drawLine({
     *   start: { x: 25, y: 75 },
     *   end: { x: 125, y: 175 },
     *   thickness: 2,
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the line.
     */ PDFPage.prototype.drawLine = function(options) {
        var _a, _b, _c, _d, _e;
        (0, $j0tvB.assertIs)(options.start, 'options.start', [
            [
                Object,
                '{ x: number, y: number }'
            ]
        ]);
        (0, $j0tvB.assertIs)(options.end, 'options.end', [
            [
                Object,
                '{ x: number, y: number }'
            ]
        ]);
        (0, $j0tvB.assertIs)(options.start.x, 'options.start.x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(options.start.y, 'options.start.y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(options.end.x, 'options.end.x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(options.end.y, 'options.end.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.thickness, 'options.thickness', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.dashArray, 'options.dashArray', [
            Array
        ]);
        (0, $j0tvB.assertOrUndefined)(options.dashPhase, 'options.dashPhase', [
            'number'
        ]);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.lineCap, 'options.lineCap', (0, $cfb765e9daff3c3a$export$7a77bc708e50709e));
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $dd8872426cc55b05$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            borderOpacity: options.opacity,
            blendMode: options.blendMode
        });
        if (!('color' in options)) options.color = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $55cf96b3448598de$export$819db45aec5fcbe5)({
            start: options.start,
            end: options.end,
            thickness: (_a = options.thickness) !== null && _a !== void 0 ? _a : 1,
            color: (_b = options.color) !== null && _b !== void 0 ? _b : undefined,
            dashArray: (_c = options.dashArray) !== null && _c !== void 0 ? _c : undefined,
            dashPhase: (_d = options.dashPhase) !== null && _d !== void 0 ? _d : undefined,
            lineCap: (_e = options.lineCap) !== null && _e !== void 0 ? _e : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a rectangle on this page. For example:
     * ```js
     * import { degrees, grayscale, rgb } from 'pdf-lib'
     *
     * page.drawRectangle({
     *   x: 25,
     *   y: 75,
     *   width: 250,
     *   height: 75,
     *   rotate: degrees(-15),
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the rectangle.
     */ PDFPage.prototype.drawRectangle = function(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (options === void 0) options = {};
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.width, 'options.width', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.height, 'options.height', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderWidth, 'options.borderWidth', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertOrUndefined)(options.borderColor, 'options.borderColor', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashArray, 'options.borderDashArray', [
            Array
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashPhase, 'options.borderDashPhase', [
            'number'
        ]);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.borderLineCap, 'options.borderLineCap', (0, $cfb765e9daff3c3a$export$7a77bc708e50709e));
        (0, $j0tvB.assertRangeOrUndefined)(options.borderOpacity, 'options.borderOpacity', 0, 1);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $dd8872426cc55b05$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!('color' in options) && !('borderColor' in options)) options.color = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $55cf96b3448598de$export$cac848e0621718d8)({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 150,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 100,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            xSkew: (_f = options.xSkew) !== null && _f !== void 0 ? _f : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            ySkew: (_g = options.ySkew) !== null && _g !== void 0 ? _g : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            borderWidth: (_h = options.borderWidth) !== null && _h !== void 0 ? _h : 0,
            color: (_j = options.color) !== null && _j !== void 0 ? _j : undefined,
            borderColor: (_k = options.borderColor) !== null && _k !== void 0 ? _k : undefined,
            borderDashArray: (_l = options.borderDashArray) !== null && _l !== void 0 ? _l : undefined,
            borderDashPhase: (_m = options.borderDashPhase) !== null && _m !== void 0 ? _m : undefined,
            graphicsState: graphicsStateKey,
            borderLineCap: (_o = options.borderLineCap) !== null && _o !== void 0 ? _o : undefined
        }));
    };
    /**
     * Draw a square on this page. For example:
     * ```js
     * import { degrees, grayscale, rgb } from 'pdf-lib'
     *
     * page.drawSquare({
     *   x: 25,
     *   y: 75,
     *   size: 100,
     *   rotate: degrees(-15),
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the square.
     */ PDFPage.prototype.drawSquare = function(options) {
        if (options === void 0) options = {};
        var size = options.size;
        (0, $j0tvB.assertOrUndefined)(size, 'size', [
            'number'
        ]);
        this.drawRectangle((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
            width: size,
            height: size
        }));
    };
    /**
     * Draw an ellipse on this page. For example:
     * ```js
     * import { grayscale, rgb } from 'pdf-lib'
     *
     * page.drawEllipse({
     *   x: 200,
     *   y: 75,
     *   xScale: 100,
     *   yScale: 50,
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the ellipse.
     */ PDFPage.prototype.drawEllipse = function(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (options === void 0) options = {};
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xScale, 'options.xScale', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.yScale, 'options.yScale', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertOrUndefined)(options.borderColor, 'options.borderColor', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.borderOpacity, 'options.borderOpacity', 0, 1);
        (0, $j0tvB.assertOrUndefined)(options.borderWidth, 'options.borderWidth', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashArray, 'options.borderDashArray', [
            Array
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashPhase, 'options.borderDashPhase', [
            'number'
        ]);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.borderLineCap, 'options.borderLineCap', (0, $cfb765e9daff3c3a$export$7a77bc708e50709e));
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $dd8872426cc55b05$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!('color' in options) && !('borderColor' in options)) options.color = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $55cf96b3448598de$export$43c9e2bb0dc74582)({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            xScale: (_c = options.xScale) !== null && _c !== void 0 ? _c : 100,
            yScale: (_d = options.yScale) !== null && _d !== void 0 ? _d : 100,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : undefined,
            color: (_f = options.color) !== null && _f !== void 0 ? _f : undefined,
            borderColor: (_g = options.borderColor) !== null && _g !== void 0 ? _g : undefined,
            borderWidth: (_h = options.borderWidth) !== null && _h !== void 0 ? _h : 0,
            borderDashArray: (_j = options.borderDashArray) !== null && _j !== void 0 ? _j : undefined,
            borderDashPhase: (_k = options.borderDashPhase) !== null && _k !== void 0 ? _k : undefined,
            borderLineCap: (_l = options.borderLineCap) !== null && _l !== void 0 ? _l : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a circle on this page. For example:
     * ```js
     * import { grayscale, rgb } from 'pdf-lib'
     *
     * page.drawCircle({
     *   x: 200,
     *   y: 150,
     *   size: 100,
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the ellipse.
     */ PDFPage.prototype.drawCircle = function(options) {
        if (options === void 0) options = {};
        var _a = options.size, size = _a === void 0 ? 100 : _a;
        (0, $j0tvB.assertOrUndefined)(size, 'size', [
            'number'
        ]);
        this.drawEllipse((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
            xScale: size,
            yScale: size
        }));
    };
    PDFPage.prototype.setOrEmbedFont = function(font) {
        var oldFont = this.font;
        var oldFontKey = this.fontKey;
        if (font) this.setFont(font);
        else this.getFont();
        var newFont = this.font;
        var newFontKey = this.fontKey;
        return {
            oldFont: oldFont,
            oldFontKey: oldFontKey,
            newFont: newFont,
            newFontKey: newFontKey
        };
    };
    PDFPage.prototype.getFont = function() {
        if (!this.font || !this.fontKey) {
            var font = this.doc.embedStandardFont((0, $d275b823cf3c6e5b$export$7dcb046109e65a3d).Helvetica);
            this.setFont(font);
        }
        return [
            this.font,
            this.fontKey
        ];
    };
    PDFPage.prototype.resetFont = function() {
        this.font = undefined;
        this.fontKey = undefined;
    };
    PDFPage.prototype.getContentStream = function(useExisting) {
        if (useExisting === void 0) useExisting = true;
        if (useExisting && this.contentStream) return this.contentStream;
        this.contentStream = this.createContentStream();
        this.contentStreamRef = this.doc.context.register(this.contentStream);
        this.node.addContentStream(this.contentStreamRef);
        return this.contentStream;
    };
    PDFPage.prototype.createContentStream = function() {
        var operators = [];
        for(var _i = 0; _i < arguments.length; _i++)operators[_i] = arguments[_i];
        var dict = this.doc.context.obj({});
        var contentStream = (0, $707f21d02e4e1bf4$export$2e2bcd8739ae039).of(dict, operators);
        return contentStream;
    };
    PDFPage.prototype.maybeEmbedGraphicsState = function(options) {
        var opacity = options.opacity, borderOpacity = options.borderOpacity, blendMode = options.blendMode;
        if (opacity === undefined && borderOpacity === undefined && blendMode === undefined) return undefined;
        var graphicsState = this.doc.context.obj({
            Type: 'ExtGState',
            ca: opacity,
            CA: borderOpacity,
            BM: blendMode
        });
        var key = this.node.newExtGState('GS', graphicsState);
        return key;
    };
    PDFPage.prototype.scaleAnnot = function(annot, x, y) {
        var selectors = [
            'RD',
            'CL',
            'Vertices',
            'QuadPoints',
            'L',
            'Rect'
        ];
        for(var idx = 0, len = selectors.length; idx < len; idx++){
            var list = annot.lookup((0, $dPHSK.default).of(selectors[idx]));
            if (list instanceof (0, $8auL6.default)) list.scalePDFNumbers(x, y);
        }
        var inkLists = annot.lookup((0, $dPHSK.default).of('InkList'));
        if (inkLists instanceof (0, $8auL6.default)) for(var idx = 0, len = inkLists.size(); idx < len; idx++){
            var arr = inkLists.lookup(idx);
            if (arr instanceof (0, $8auL6.default)) arr.scalePDFNumbers(x, y);
        }
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addPage]] and [[PDFDocument.insertPage]]
     * > methods, which can create instances of [[PDFPage]] for you.
     *
     * Create an instance of [[PDFPage]] from an existing leaf node.
     *
     * @param leafNode The leaf node to be wrapped.
     * @param ref The unique reference for the page.
     * @param doc The document to which the page will belong.
     */ PDFPage.of = function(leafNode, ref, doc) {
        return new PDFPage(leafNode, ref, doc);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addPage]] and [[PDFDocument.insertPage]]
     * > methods, which can create instances of [[PDFPage]] for you.
     *
     * Create an instance of [[PDFPage]].
     *
     * @param doc The document to which the page will belong.
     */ PDFPage.create = function(doc) {
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $93b2571d4e1dfe94$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        var dummyRef = (0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(-1);
        var pageLeaf = (0, $a9e73b7ced5abfa4$export$2e2bcd8739ae039).withContextAndParent(doc.context, dummyRef);
        var pageRef = doc.context.register(pageLeaf);
        return new PDFPage(pageLeaf, pageRef, doc);
    };
    return PDFPage;
}();
var $a7f75cccfbb7eb6c$export$2e2bcd8739ae039 = $a7f75cccfbb7eb6c$var$PDFPage;









parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a button field of a [[PDFForm]].
 *
 * [[PDFButton]] fields are interactive controls that users can click with their
 * mouse. This type of [[PDFField]] is not stateful. The purpose of a button
 * is to perform an action when the user clicks on it, such as opening a print
 * modal or resetting the form. Buttons are typically rectangular in shape and
 * have a text label describing the action that they perform when clicked.
 */ var $b3771f5aa96680ee$var$PDFButton = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFButton, _super);
    function PDFButton(acroPushButton, ref, doc) {
        var _this = _super.call(this, acroPushButton, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroPushButton, 'acroButton', [
            [
                (0, $0cfa6a9523f95402$export$2e2bcd8739ae039),
                'PDFAcroPushButton'
            ]
        ]);
        _this.acroField = acroPushButton;
        return _this;
    }
    /**
     * Display an image inside the bounds of this button's widgets. For example:
     * ```js
     * const pngImage = await pdfDoc.embedPng(...)
     * const button = form.getButton('some.button.field')
     * button.setImage(pngImage, ImageAlignment.Center)
     * ```
     * This will update the appearances streams for each of this button's widgets.
     * @param image The image that should be displayed.
     * @param alignment The alignment of the image.
     */ PDFButton.prototype.setImage = function(image, alignment) {
        if (alignment === void 0) alignment = (0, $c5ccd91931a24d5b$export$8efa99ca8f041e7e).Center;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var streamRef = this.createImageAppearanceStream(widget, image, alignment);
            this.updateWidgetAppearances(widget, {
                normal: streamRef
            });
        }
        this.markAsClean();
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this button. Font sizes may
     * be integer or floating point numbers. Supplying a negative font size will
     * cause this method to throw an error.
     *
     * For example:
     * ```js
     * const button = form.getButton('some.button.field')
     * button.setFontSize(4)
     * button.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFButton.prototype.setFontSize = function(fontSize) {
        (0, $j0tvB.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Show this button on the specified page with the given text. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const button = form.createButton('some.button.field')
     *
     * button.addToPage('Do Stuff', page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this button field.
     * @param text The text to be displayed for this button widget.
     * @param page The page to which this button widget should be added.
     * @param options The options to be used when adding this button widget.
     */ PDFButton.prototype.addToPage = function(// TODO: This needs to be optional, e.g. for image buttons
    text, page, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        (0, $j0tvB.assertOrUndefined)(text, 'text', [
            'string'
        ]);
        (0, $j0tvB.assertOrUndefined)(page, 'page', [
            [
                (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $9a88d5b8c9019f73$export$55643210f1835a35)(options);
        // Create a widget for this button
        var widget = this.createWidget({
            x: ((_a = options === null || options === void 0 ? void 0 : options.x) !== null && _a !== void 0 ? _a : 0) - ((_b = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _b !== void 0 ? _b : 0) / 2,
            y: ((_c = options === null || options === void 0 ? void 0 : options.y) !== null && _c !== void 0 ? _c : 0) - ((_d = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _d !== void 0 ? _d : 0) / 2,
            width: (_e = options === null || options === void 0 ? void 0 : options.width) !== null && _e !== void 0 ? _e : 100,
            height: (_f = options === null || options === void 0 ? void 0 : options.height) !== null && _f !== void 0 ? _f : 50,
            textColor: (_g = options === null || options === void 0 ? void 0 : options.textColor) !== null && _g !== void 0 ? _g : (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0),
            backgroundColor: (_h = options === null || options === void 0 ? void 0 : options.backgroundColor) !== null && _h !== void 0 ? _h : (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0.75, 0.75, 0.75),
            borderColor: options === null || options === void 0 ? void 0 : options.borderColor,
            borderWidth: (_j = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _j !== void 0 ? _j : 0,
            rotate: (_k = options === null || options === void 0 ? void 0 : options.rotate) !== null && _k !== void 0 ? _k : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            caption: text,
            hidden: options === null || options === void 0 ? void 0 : options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_l = options === null || options === void 0 ? void 0 : options.font) !== null && _l !== void 0 ? _l : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this button has been marked as dirty, or if any of this
     * button's widgets do not have an appearance stream. For example:
     * ```js
     * const button = form.getButton('some.button.field')
     * if (button.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this button needs an appearance update.
     */ PDFButton.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this button's widgets using
     * the default appearance provider for buttons. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const button = form.getButton('some.button.field')
     * button.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFButton.prototype.defaultUpdateAppearances = function(font) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $fb353673e42bee9b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this button's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for buttons will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const button = form.getButton('some.button.field')
     * button.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return {
     *     normal: drawButton(...),
     *     down: drawButton(...),
     *   }
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFButton.prototype.updateAppearances = function(font, provider) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $fb353673e42bee9b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
    };
    PDFButton.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $d5944ab433082972$export$68f9b19f48ffeeec);
        var appearances = (0, $d5944ab433082972$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getButton]] method, which will create an
     * > instance of [[PDFButton]] for you.
     *
     * Create an instance of [[PDFButton]] from an existing acroPushButton and ref
     *
     * @param acroPushButton The underlying `PDFAcroPushButton` for this button.
     * @param ref The unique reference for this button.
     * @param doc The document to which this button will belong.
     */ PDFButton.of = function(acroPushButton, ref, doc) {
        return new PDFButton(acroPushButton, ref, doc);
    };
    return PDFButton;
}((0, $9a88d5b8c9019f73$export$2e2bcd8739ae039));
var $b3771f5aa96680ee$export$2e2bcd8739ae039 = $b3771f5aa96680ee$var$PDFButton;




































var $37118a317aa117da$exports = {};


parcelRequire("fvYKZ");
$parcel$exportWildcard($00483d97acd1a213$exports, $37118a317aa117da$exports);



function $0b90c494a9a449e0$var$formatTeamLabel(teamCode) {
    return teamCode || "Not selected";
}
function $0b90c494a9a449e0$export$2e2bcd8739ae039({ selectedTeam: selectedTeam, availableTeams: availableTeams = [] }) {
    const inputRef = (0, $acw62.useRef)(null);
    const [team, setTeam] = (0, $acw62.useState)(selectedTeam || availableTeams[0] || "");
    const [files, setFiles] = (0, $acw62.useState)([]);
    const [dragActive, setDragActive] = (0, $acw62.useState)(false);
    const [submitting, setSubmitting] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        if (selectedTeam && availableTeams.includes(selectedTeam)) {
            setTeam(selectedTeam);
            return;
        }
        if (!team && availableTeams.length === 1) setTeam(availableTeams[0]);
    }, [
        availableTeams,
        selectedTeam,
        team
    ]);
    function updateFiles(nextFiles) {
        setFiles(Array.from(nextFiles || []));
        setError("");
    }
    function handleInputChange(event) {
        updateFiles(event.target.files);
    }
    function handleDrop(event) {
        event.preventDefault();
        setDragActive(false);
        updateFiles(event.dataTransfer.files);
    }
    async function isPasswordProtectedPdf(file) {
        try {
            const bytes = await file.arrayBuffer();
            await (0, $93b2571d4e1dfe94$export$2e2bcd8739ae039).load(bytes);
            return false;
        } catch  {
            return true;
        }
    }
    async function checkInvoiceUploadRequirements() {
        const response = await fetch("/api/get-invoice-upload-requirements/");
        if (!response.ok) throw new Error("Failed to check invoice upload requirements.");
        return await response.json();
    }
    function showUploadRequirementsPopup(requirements) {
        const rows = Object.entries(requirements).map(([name, requirement])=>{
            const isConfiguration = name === "configuration";
            const mappingApplicable = ![
                "configuration"
            ].includes(name);
            const mappingStatus = mappingApplicable ? requirement.mapping : null;
            const dataStatus = requirement.data;
            const hasIssue = mappingStatus === false || dataStatus === false;
            return `
          <tr>
            <td style="
              text-align: left;
              font-weight: 500;
              padding: 10px;
              border-bottom: 1px solid #eee;
            ">
              ${name}
            </td>

            <td style="
              text-align: center;
              padding: 10px;
              border-bottom: 1px solid #eee;
            ">
              ${mappingStatus === null ? '<span style="color:#999;">\u2014</span>' : mappingStatus ? '<span style="color:#16a34a; font-size:20px;">\u2713</span>' : '<span style="color:#dc2626; font-size:20px;">\u2717</span>'}
            </td>

            <td style="
              text-align: center;
              padding: 10px;
              border-bottom: 1px solid #eee;
            ">
              ${dataStatus ? '<span style="color:#16a34a; font-size:20px;">\u2713</span>' : '<span style="color:#dc2626; font-size:20px;">\u2717</span>'}
            </td>

            <td style="
              text-align: left;
              padding: 10px;
              border-bottom: 1px solid #eee;
              color: ${hasIssue ? "#dc2626" : "#666"};
              font-size: 13px;
            ">
              ${requirement.action || ""}
            </td>
          </tr>
        `;
        }).join("");
        return (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
            title: "Invoice Upload Requirements",
            html: `
        <div style="
          font-size: 14px;
          color: #555;
          margin-bottom: 15px;
        ">
          Some configurations or required data are missing.
          Please review the details below before continuing.
        </div>

        <div style="
          width: 100%;
          overflow-x: auto;
        ">
          <table style="
            width: 100%;
            border-collapse: collapse;
            font-size: 13px;
          ">
            <thead>
              <tr style="
                background: #f5f6f8;
              ">
                <th style="
                  text-align: left;
                  padding: 10px;
                ">
                  Requirement
                </th>

                <th style="
                  text-align: center;
                  padding: 10px;
                ">
                  Mapping
                </th>

                <th style="
                  text-align: center;
                  padding: 10px;
                ">
                  Data
                </th>

                <th style="
                  text-align: left;
                  padding: 10px;
                ">
                  Action
                </th>
              </tr>
            </thead>

            <tbody>
              ${rows}
            </tbody>
          </table>
        </div>

        <div style="
          margin-top: 18px;
          padding: 12px;
          background: #fff8e1;
          border-radius: 6px;
          font-size: 13px;
          text-align: left;
        ">
          <strong>Warning:</strong>
          Some required configuration or data is missing.
          You can continue uploading, but this may affect invoice processing.
        </div>
      `,
            icon: "warning",
            width: "850px",
            showCancelButton: true,
            confirmButtonText: "Continue Upload",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#6c757d",
            reverseButtons: true,
            allowOutsideClick: false
        });
    }
    async function handleSubmit(event) {
        event.preventDefault();
        setStatus("");
        setError("");
        if (!team) {
            setError("Please select a team before uploading invoices.");
            return;
        }
        if (!files.length) {
            setError("Please choose at least one invoice file to upload.");
            return;
        }
        // ---------------------------------------------------------
        // CHECK CONFIGURATION / MASTER DATA BEFORE UPLOAD
        // ---------------------------------------------------------
        try {
            const requirements = await checkInvoiceUploadRequirements();
            const hasMissingRequirements = Object.values(requirements).some((item)=>item.mapping === false || item.data === false);
            if (hasMissingRequirements) {
                const result = await showUploadRequirementsPopup(requirements);
                // User clicked Cancel
                if (!result.isConfirmed) return;
            // User clicked Continue Upload
            // Continue below
            }
        } catch (error) {
            console.error("Error checking invoice upload requirements:", error);
            setError("Unable to verify invoice upload requirements. Please try again.");
            return;
        }
        setSubmitting(true);
        try {
            const validFiles = [];
            const protectedFiles = [];
            const oversizedFiles = [];
            const MAX_FILE_SIZE = 20971520; // 20 MB
            const ALLOWED_EXTENSIONS = new Set([
                "pdf",
                "jpg",
                "jpeg",
                "png",
                "zip",
                "7z",
                "rar"
            ]);
            const invalidExtensionFiles = [];
            for (const file of files){
                // Extension validation
                const extension = file.name.split(".").pop()?.toLowerCase();
                if (!extension || !ALLOWED_EXTENSIONS.has(extension)) {
                    invalidExtensionFiles.push(file.name);
                    continue;
                }
                // File size validation
                if (file.size > MAX_FILE_SIZE) {
                    oversizedFiles.push({
                        name: file.name,
                        size: (file.size / 1048576).toFixed(2)
                    });
                    continue;
                }
                // Password protected PDF validation
                if (file.name.toLowerCase().endsWith(".pdf")) {
                    const isProtected = await isPasswordProtectedPdf(file);
                    if (isProtected) {
                        protectedFiles.push(file.name);
                        continue;
                    }
                }
                validFiles.push(file);
            }
            // Nothing left to upload
            if (!validFiles.length) {
                await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                    icon: "error",
                    title: "Upload Cancelled",
                    html: `
            <p>No files could be uploaded.</p>

            ${protectedFiles.length ? `
                  <p>
                    <strong>${protectedFiles.length}</strong>
                    password-protected PDF(s) were skipped.
                  </p>
                ` : ""}

            ${oversizedFiles.length ? `
                  <p>
                    <strong>${oversizedFiles.length}</strong>
                    file(s) exceeded the 20 MB limit.
                  </p>
                ` : ""}
          `,
                    confirmButtonText: "OK"
                });
                return;
            }
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const formData = new FormData();
            formData.append("team", team);
            validFiles.forEach((file)=>{
                formData.append("files", file);
            });
            const response = await fetch("/api/upload-invoice/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "X-CSRFToken": csrfToken
                },
                body: formData
            });
            const payload = await response.json();
            if (!response.ok || payload.success !== true) throw new Error(payload.message || `Upload failed. Backend responded with ${response.status}.`);
            const uploadedCount = payload.uploaded_count ?? payload.data?.length ?? validFiles.length;
            const backendSkippedFiles = payload.skipped_files || [];
            const backendSkippedCount = payload.skipped_count || 0;
            let html = `
        <p>
          <strong>${uploadedCount}</strong>
          invoice(s) have been uploaded successfully and queued for processing.
        </p>
      `;
            // Frontend password protected files
            if (protectedFiles.length) html += `
          <hr>
          <p>
            <strong>${protectedFiles.length}</strong>
            password-protected PDF(s) were skipped before upload.
          </p>

          <div style="text-align:left;">
            <strong>Skipped PDFs:</strong>
            <ul>
              ${protectedFiles.map((name)=>`<li>${name}</li>`).join("")}
            </ul>
          </div>
        `;
            // Frontend oversized files
            if (oversizedFiles.length) html += `
          <hr>
          <p>
            <strong>${oversizedFiles.length}</strong>
            file(s) exceeded the 20 MB limit and were skipped.
          </p>

          <div style="text-align:left;">
            <strong>Oversized Files:</strong>
            <ul>
              ${oversizedFiles.map((file)=>`<li>${file.name} (${file.size} MB)</li>`).join("")}
            </ul>
          </div>
        `;
            // Backend password protected files
            if (backendSkippedCount > 0) html += `
          <hr>
          <p>
            <strong>${backendSkippedCount}</strong>
            file(s) were rejected by the server.
          </p>

          <div style="text-align:left;">
            <strong>Server Rejections:</strong>
            <ul>
              ${backendSkippedFiles.map((file)=>`<li>${file.fileName}</li>`).join("")}
            </ul>
          </div>
        `;
            // Frontend invalid extension files
            if (invalidExtensionFiles.length) html += `
          <hr>
          <p>
            <strong>${invalidExtensionFiles.length}</strong>
            file(s) had unsupported file types and were skipped.
          </p>

          <div style="text-align:left;">
            <strong>Unsupported Files:</strong>
            <ul>
              ${invalidExtensionFiles.map((name)=>`<li>${name}</li>`).join("")}
            </ul>
          </div>
        `;
            const hasWarnings = protectedFiles.length > 0 || oversizedFiles.length > 0 || invalidExtensionFiles.length > 0 || backendSkippedCount > 0;
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: hasWarnings ? "warning" : "success",
                title: hasWarnings ? "Upload Completed with Warnings" : "Upload Successful",
                html: html,
                width: "750px",
                confirmButtonText: "OK"
            });
            setFiles([]);
            if (inputRef.current) inputRef.current.value = "";
        } catch (requestError) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Upload Failed",
                text: requestError.message || "Unable to upload invoices.",
                confirmButtonText: "OK"
            });
            setError(requestError.message || "Unable to upload invoices.");
        } finally{
            setSubmitting(false);
        }
    }
    function openLegacyUploadPage() {
        window.localStorage.setItem("activeSection", "upload_invoice");
        window.open((0, $96e14f2a7c3555e4$export$5d9c32988b6a9848)("/uploader_dashboard/"), "_blank", "noreferrer");
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "uploader-view",
        children: [
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "uploader-layout uploader-layout--stacked",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    className: "workspace-panel uploader-form",
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "uploader-form__header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "eyebrow",
                                            children: "Invoice Intake"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            children: "Upload queue"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "ghost-button",
                                    type: "button",
                                    onClick: openLegacyUploadPage,
                                    children: "Open Legacy Upload View"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            className: "config-field",
                            htmlFor: "uploader-team",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "Select Team"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                    id: "uploader-team",
                                    value: team,
                                    disabled: submitting || availableTeams.length <= 1,
                                    onChange: (event)=>setTeam(event.target.value),
                                    children: [
                                        availableTeams.length > 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "",
                                            children: "Please Select"
                                        }) : null,
                                        availableTeams.map((teamCode)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: teamCode,
                                                children: $0b90c494a9a449e0$var$formatTeamLabel(teamCode)
                                            }, teamCode))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: `uploader-dropzone${dragActive ? " is-active" : ""}`,
                            role: "button",
                            tabIndex: 0,
                            onClick: ()=>inputRef.current?.click(),
                            onKeyDown: (event)=>{
                                if (event.key === "Enter" || event.key === " ") {
                                    event.preventDefault();
                                    inputRef.current?.click();
                                }
                            },
                            onDragOver: (event)=>{
                                event.preventDefault();
                                setDragActive(true);
                            },
                            onDragLeave: (event)=>{
                                event.preventDefault();
                                setDragActive(false);
                            },
                            onDrop: handleDrop,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    ref: inputRef,
                                    className: "uploader-dropzone__input",
                                    type: "file",
                                    name: "files",
                                    multiple: true,
                                    accept: ".pdf,.jpg,.jpeg,.png,.zip,.7z,.rar",
                                    disabled: submitting || !team,
                                    onChange: handleInputChange
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "uploader-dropzone__title",
                                    children: "Click to select or drag and drop invoice files"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "config-note",
                                    children: "Accepted formats: PDF, JPG, JPEG, PNG, ZIP(containing pdf,jpg,png)"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "uploader-dropzone__title",
                                    children: "Recommended quality should be atleast 150 DPI for OCR accuracy"
                                }),
                                !team ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "uploader-dropzone__hint",
                                    children: "Select a team to enable file selection."
                                }) : null
                            ]
                        }),
                        files.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "uploader-file-list",
                            children: files.map((file)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                                    className: "uploader-file-item",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: file.name
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                Math.max(1, Math.round(file.size / 1024)),
                                                " KB"
                                            ]
                                        })
                                    ]
                                }, `${file.name}-${file.lastModified}`))
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "empty-state",
                            children: "No files selected yet."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "primary-button uploader-submit",
                            type: "submit",
                            disabled: submitting,
                            children: submitting ? "Uploading..." : "Upload Files"
                        })
                    ]
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");




function $4a9237e49e83dfe7$var$formatDate(value) {
    if (!value) return "-";
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return value;
    return parsed.toLocaleDateString();
}
function $4a9237e49e83dfe7$var$getPendingDuration(createdAt) {
    if (!createdAt) return "-";
    const createdTime = new Date(createdAt);
    const now = new Date();
    let diffMs = now - createdTime;
    if (diffMs < 0) diffMs = 0;
    const minutes = Math.floor(diffMs / 60000);
    const hours = Math.floor(diffMs / 3600000);
    const days = Math.floor(diffMs / 86400000);
    if (days > 0) return `${days}d ${hours % 24}h`;
    if (hours > 0) return `${hours}h ${minutes % 60}m`;
    return `${minutes}m`;
}
function $4a9237e49e83dfe7$export$2e2bcd8739ae039() {
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [actionKey, setActionKey] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const summary = (0, $acw62.useMemo)(()=>({
            count: rows.length,
            failed: rows.filter((row)=>row.status === "Failed").length,
            completed: rows.filter((row)=>row.status && row.status !== "Failed").length
        }), [
        rows
    ]);
    async function loadRows() {
        setLoading(true);
        setError("");
        try {
            const response = await fetch("/api/invoice-upload-status/", {
                credentials: "include"
            });
            const payload = await response.json();
            if (!response.ok) throw new Error(payload?.message || "Unable to load invoice status.");
            setRows(payload.data || []);
        } catch (requestError) {
            setError(requestError.message || "Unable to load invoice status.");
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadRows();
    }, []);
    async function handleAction(invoiceId, type) {
        setStatus("");
        setError("");
        setActionKey(`${type}-${invoiceId}`);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch(type === "resubmit" ? "/invoice/resubmit/" : "/invoice/reject/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    invoice_id: invoiceId
                })
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || `Unable to ${type} invoice.`);
            setStatus(payload.message || `Invoice ${type}ed successfully.`);
            await loadRows();
        } catch (requestError) {
            setError(requestError.message || `Unable to ${type} invoice.`);
        } finally{
            setActionKey("");
        }
    }
    function openLegacyInvoiceStatusPage() {
        window.localStorage.setItem("activeSection", "invoices");
        window.open((0, $96e14f2a7c3555e4$export$5d9c32988b6a9848)("/uploader_dashboard/"), "_blank", "noreferrer");
    }
    function refreshPendingActions() {
        loadRows();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $be4094fc57a496e8$export$2e2bcd8739ae039), {
        title: "Invoice Status",
        intro: "",
        metrics: [
            {
                label: "Uploaded Invoices",
                value: summary.count
            },
            {
                label: "Failed",
                value: summary.failed
            },
            {
                label: "Success",
                value: summary.completed
            }
        ],
        actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            className: "ghost-button processor-view__refresh",
            type: "button",
            onClick: refreshPendingActions,
            children: "Refresh"
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
            className: "uploader-view",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "workspace-panel",
                children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "config-note",
                    children: "Loading invoice status\u2026"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "config-table processor-table",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Invoice ID"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Invoice No"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Vendor"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Invoice Date"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Vendor GST"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "PDF"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Age"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Resubmit"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Reject"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Reason"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: rows.length ? rows.map((row)=>{
                                    const disabled = row.status !== "Failed";
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.id
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.InvoiceNo || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.VendorName || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: $4a9237e49e83dfe7$var$formatDate(row.InvoiceDate)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.VendorGst || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.unique_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>(0, $e267546ad9d86d30$export$a38ce99a4bdccd4e)(row.id),
                                                    children: "\uD83D\uDCCE"
                                                }) : "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: $4a9237e49e83dfe7$var$getPendingDuration(row.UpdatedAt)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.status || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "ghost-button",
                                                    type: "button",
                                                    disabled: disabled || actionKey === `resubmit-${row.id}`,
                                                    onClick: ()=>handleAction(row.id, "resubmit"),
                                                    children: actionKey === `resubmit-${row.id}` ? "Resubmitting..." : "Resubmit"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "ghost-button",
                                                    type: "button",
                                                    disabled: disabled || actionKey === `reject-${row.id}`,
                                                    onClick: ()=>handleAction(row.id, "reject"),
                                                    children: actionKey === `reject-${row.id}` ? "Rejecting..." : "Reject"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.reason || "-"
                                            })
                                        ]
                                    }, row.id);
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        colSpan: "10",
                                        children: "No invoices found."
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");



const $4b59401103b2b567$var$SAC_API_URL = "/api/hsn-sac-list/";
const $4b59401103b2b567$var$SAC_COLUMNS = [
    {
        key: "saccode",
        label: "SAC Code"
    },
    {
        key: "service_code",
        label: "Service Code"
    },
    {
        key: "sacDescription",
        label: "Description"
    },
    {
        key: "block_input",
        label: "BC / IC"
    },
    {
        key: "rcm_fc",
        label: "RCM / FC"
    },
    {
        key: "section",
        label: "Section"
    },
    {
        key: "tds_section_2025",
        label: "TDS Section 2025"
    }
];
/* =========================================================
   SAC EDIT MODAL
========================================================= */ function $4b59401103b2b567$var$SACEditModal({ sac: sac, options: options, saving: saving, onClose: onClose, onSaved: onSaved }) {
    const [formData, setFormData] = (0, $acw62.useState)({
        taxrate: sac.taxrate || "",
        block_input: sac.block_input || "",
        rcm_fc: sac.rcm_fc || "",
        section: sac.section || ""
    });
    const [savingLocal, setSavingLocal] = (0, $acw62.useState)(false);
    function handleChange(event) {
        const { name: name, value: value } = event.target;
        setFormData((current)=>({
                ...current,
                [name]: value
            }));
    }
    async function handleSubmit(event) {
        event.preventDefault();
        try {
            setSavingLocal(true);
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/hsn-sac-list/sac/save/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    default_id: sac.id,
                    taxrate: formData.taxrate,
                    block_input: formData.block_input,
                    rcm_fc: formData.rcm_fc,
                    section: formData.section
                })
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || "Unable to save SAC master data.");
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Saved",
                text: payload.message || "SAC master data saved successfully.",
                confirmButtonText: "OK"
            });
            await onSaved();
        } catch (error) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: error.message || "Unable to save SAC master data.",
                confirmButtonText: "OK"
            });
        } finally{
            setSavingLocal(false);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "hsn-sac-modal__backdrop",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "hsn-sac-modal",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "hsn-sac-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "SAC Master"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                    children: [
                                        "Edit SAC \u2014 ",
                                        sac.saccode || "\u2014"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "hsn-sac-modal__close",
                            onClick: onClose,
                            disabled: savingLocal,
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    className: "hsn-sac-modal__form",
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$SACReadOnlyField, {
                            label: "SAC Code",
                            value: sac.saccode
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$SACReadOnlyField, {
                            label: "Chapter",
                            value: sac.chapter
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$SACReadOnlyField, {
                            label: "Heading",
                            value: sac.heading
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$SACReadOnlyField, {
                            label: "Service Code",
                            value: sac.service_code
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$SACReadOnlyField, {
                            label: "Description",
                            value: sac.sacDescription,
                            multiline: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$SACSelectField, {
                            label: "Tax Rate",
                            name: "taxrate",
                            value: formData.taxrate,
                            options: options.taxrate,
                            onChange: handleChange
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$SACReadOnlyField, {
                            label: "PBC",
                            value: sac.pbc
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$SACSelectField, {
                            label: "Block Input",
                            name: "block_input",
                            value: formData.block_input,
                            options: options.block_input,
                            onChange: handleChange
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$SACReadOnlyField, {
                            label: "Deciding Factor",
                            value: sac.deciding_factor,
                            multiline: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$SACReadOnlyField, {
                            label: "Effective Date",
                            value: sac.effective_date
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$SACReadOnlyField, {
                            label: "PRCM",
                            value: sac.prcm
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$SACSelectField, {
                            label: "RCM / FC",
                            name: "rcm_fc",
                            value: formData.rcm_fc,
                            options: options.rcm_fc,
                            onChange: handleChange
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$SACReadOnlyField, {
                            label: "FC RCM Effective Date",
                            value: sac.fc_rcm_effective_date
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$SACReadOnlyField, {
                            label: "FC RCM Deciding Factor",
                            value: sac.fc_rcm_deciding_factor,
                            multiline: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$SACReadOnlyField, {
                            label: "PRC",
                            value: sac.prc
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$SACSelectField, {
                            label: "Section",
                            name: "section",
                            value: formData.section,
                            options: options.section,
                            onChange: handleChange
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$SACReadOnlyField, {
                            label: "TDS Section 2025",
                            value: sac.tds_section_2025
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$SACReadOnlyField, {
                            label: "TDS Effective Date",
                            value: sac.tds_effective_date
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$SACReadOnlyField, {
                            label: "TDS Deciding Factor",
                            value: sac.tds_deciding_factor,
                            multiline: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "hsn-sac-modal__actions",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "secondary-button",
                                    onClick: onClose,
                                    disabled: savingLocal,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "submit",
                                    className: "primary-button",
                                    disabled: savingLocal || saving,
                                    children: savingLocal ? "Saving..." : "Save Changes"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function $4b59401103b2b567$var$SACReadOnlyField({ label: label, value: value, multiline: multiline = false }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "hsn-sac-modal__field",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                children: label
            }),
            multiline ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                value: value || "",
                readOnly: true,
                rows: 3
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "text",
                value: value || "",
                readOnly: true
            })
        ]
    });
}
function $4b59401103b2b567$var$SACSelectField({ label: label, name: name, value: value, options: options = [], onChange: onChange }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "hsn-sac-modal__field",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: `sac-edit-${name}`,
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                id: `sac-edit-${name}`,
                name: name,
                value: value,
                onChange: onChange,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                        value: "",
                        children: [
                            "Select ",
                            label
                        ]
                    }),
                    options.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: option,
                            children: option
                        }, option))
                ]
            })
        ]
    });
}
/* =========================================================
   HSN EDIT MODAL
========================================================= */ function $4b59401103b2b567$var$HSNEditModal({ hsn: hsn, options: options, saving: saving, onClose: onClose, onSaved: onSaved }) {
    const [formData, setFormData] = (0, $acw62.useState)({
        tax_rate: hsn.tax_rate || "",
        block_input: hsn.block_input || ""
    });
    const [savingLocal, setSavingLocal] = (0, $acw62.useState)(false);
    const handleChange = (field, value)=>{
        setFormData((current)=>({
                ...current,
                [field]: value
            }));
    };
    const handleSubmit = async (event)=>{
        event.preventDefault();
        setSavingLocal(true);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/hsn-sac-list/hsn/save/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    hsncode: hsn.hsncode,
                    tax_rate: formData.tax_rate,
                    block_input: formData.block_input
                })
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || "Unable to save HSN master data.");
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Saved",
                text: payload.message || "HSN master data saved successfully.",
                confirmButtonText: "OK"
            });
            await onSaved();
        } catch (requestError) {
            console.error("Failed to save HSN master:", requestError);
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: requestError.message || "Unable to save HSN master data.",
                confirmButtonText: "OK"
            });
        } finally{
            setSavingLocal(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "hsn-sac-modal__backdrop",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "hsn-sac-modal",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "hsn-sac-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "HSN Master"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                    children: [
                                        "Edit HSN ",
                                        $4b59401103b2b567$var$displayValue(hsn.hsncode)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "hsn-sac-modal__close",
                            onClick: onClose,
                            disabled: savingLocal,
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    className: "hsn-sac-modal__form",
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$HSNReadOnlyField, {
                            label: "HSN Code",
                            value: hsn.hsncode
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$HSNReadOnlyField, {
                            label: "Chapter",
                            value: hsn.chapter
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$HSNReadOnlyField, {
                            label: "Heading",
                            value: hsn.heading
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$HSNReadOnlyField, {
                            label: "Sub Heading",
                            value: hsn.sub_heading
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$HSNReadOnlyField, {
                            label: "Tariff",
                            value: hsn.tarriff
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$HSNReadOnlyField, {
                            label: "Description",
                            value: hsn.hsnDescription,
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$HSNSelectField, {
                            label: "Tax Rate",
                            value: formData.tax_rate,
                            options: options.tax_rate,
                            onChange: (value)=>handleChange("tax_rate", value)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$HSNReadOnlyField, {
                            label: "PBC",
                            value: hsn.pbc
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$HSNSelectField, {
                            label: "Block Input",
                            value: formData.block_input,
                            options: options.block_input,
                            onChange: (value)=>handleChange("block_input", value)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$HSNReadOnlyField, {
                            label: "Effective Date",
                            value: hsn.effective_date
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$HSNReadOnlyField, {
                            label: "Deciding Factor",
                            value: hsn.deciding_factor,
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "hsn-sac-modal__actions",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "secondary-button",
                                    onClick: onClose,
                                    disabled: savingLocal,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "submit",
                                    className: "primary-button",
                                    disabled: savingLocal || saving,
                                    children: savingLocal ? "Saving..." : "Save Changes"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function $4b59401103b2b567$var$HSNReadOnlyField({ label: label, value: value, fullWidth: fullWidth = false }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `hsn-sac-modal__field ${fullWidth ? "hsn-sac-modal__field--full" : ""}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "hsn-sac-modal__readonly",
                children: $4b59401103b2b567$var$displayValue(value)
            })
        ]
    });
}
function $4b59401103b2b567$var$HSNSelectField({ label: label, value: value, options: options = [], onChange: onChange }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "hsn-sac-modal__field",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                value: value,
                onChange: (event)=>onChange(event.target.value),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                        value: "",
                        children: [
                            "Select ",
                            label
                        ]
                    }),
                    options.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: option,
                            children: option
                        }, option))
                ]
            })
        ]
    });
}
/* =========================================================
   PAGINATION
========================================================= */ function $4b59401103b2b567$var$MasterPagination({ pagination: pagination, onPageChange: onPageChange }) {
    if (!pagination || pagination.total_pages <= 1) return null;
    const { page: page, total: total, total_pages: total_pages } = pagination;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "hsn-sac-pagination",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "hsn-sac-pagination__info",
                children: [
                    "Showing page ",
                    page,
                    " of ",
                    total_pages,
                    " ",
                    "(",
                    total,
                    " records)"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "hsn-sac-pagination__controls",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        disabled: page <= 1,
                        onClick: ()=>onPageChange(page - 1),
                        children: "Previous"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "hsn-sac-pagination__current",
                        children: page
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        disabled: page >= total_pages,
                        onClick: ()=>onPageChange(page + 1),
                        children: "Next"
                    })
                ]
            })
        ]
    });
}
function $4b59401103b2b567$export$2e2bcd8739ae039() {
    const [activeTab, setActiveTab] = (0, $acw62.useState)("sac");
    const [sacData, setSacData] = (0, $acw62.useState)([]);
    const [hsnData, setHsnData] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)("");
    /* ---------------- SAC FILTERS ---------------- */ const [sacSearch, setSacSearch] = (0, $acw62.useState)("");
    const [sectionFilter, setSectionFilter] = (0, $acw62.useState)("");
    const [rcmFilter, setRcmFilter] = (0, $acw62.useState)("");
    const [blockInputFilter, setBlockInputFilter] = (0, $acw62.useState)("");
    /* ---------------- HSN FILTERS ---------------- */ const [hsnSearch, setHsnSearch] = (0, $acw62.useState)("");
    const [hsnTaxrateFilter, setHsnTaxrateFilter] = (0, $acw62.useState)("");
    const [hsnBlockInputFilter, setHsnBlockInputFilter] = (0, $acw62.useState)("");
    /* ---------------- OPTIONS ---------------- */ const [sacOptions, setSacOptions] = (0, $acw62.useState)({
        taxrate: [],
        block_input: [],
        rcm_fc: [],
        section: []
    });
    const [hsnOptions, setHsnOptions] = (0, $acw62.useState)({
        tax_rate: [],
        block_input: []
    });
    /* ---------------- EDIT STATE ---------------- */ const [editingSac, setEditingSac] = (0, $acw62.useState)(null);
    const [savingSac, setSavingSac] = (0, $acw62.useState)(false);
    const [editingHsn, setEditingHsn] = (0, $acw62.useState)(null);
    const [savingHsn, setSavingHsn] = (0, $acw62.useState)(false);
    /* ---------------- PAGINATION ---------------- */ const [sacPagination, setSacPagination] = (0, $acw62.useState)({
        page: 1,
        page_size: 50,
        total: 0,
        total_pages: 0
    });
    const [hsnPagination, setHsnPagination] = (0, $acw62.useState)({
        page: 1,
        page_size: 50,
        total: 0,
        total_pages: 0
    });
    /* =========================================================
     LOAD DATA
  ========================================================= */ const loadSACData = (0, $acw62.useCallback)(async ({ type: type = activeTab, page: page = 1, search: search = "", section: section = "", rcm_fc: rcm_fc = "", block_input: block_input = "", tax_rate: tax_rate = "" } = {})=>{
        setLoading(true);
        setError("");
        try {
            const params = new URLSearchParams();
            params.set("type", type);
            params.set("page", String(page));
            params.set("page_size", "50");
            if (search?.trim()) params.set("search", search.trim());
            if (type === "sac") {
                if (section) params.set("section", section);
                if (rcm_fc) params.set("rcm_fc", rcm_fc);
                if (block_input) params.set("block_input", block_input);
            } else {
                if (tax_rate) params.set("tax_rate", tax_rate);
                if (block_input) params.set("block_input", block_input);
            }
            const response = await fetch(`${$4b59401103b2b567$var$SAC_API_URL}?${params.toString()}`, {
                credentials: "include",
                headers: {
                    Accept: "application/json"
                }
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || "Unable to load HSN/SAC master data.");
            if (type === "sac") {
                setSacData(payload.data || []);
                setSacPagination(payload.pagination || {
                    page: 1,
                    page_size: 50,
                    total: 0,
                    total_pages: 0
                });
                setSacOptions(payload.options || {
                    taxrate: [],
                    block_input: [],
                    rcm_fc: [],
                    section: []
                });
            } else {
                setHsnData(payload.data || []);
                setHsnPagination(payload.pagination || {
                    page: 1,
                    page_size: 50,
                    total: 0,
                    total_pages: 0
                });
                setHsnOptions(payload.options || {
                    tax_rate: [],
                    block_input: []
                });
            }
        } catch (requestError) {
            setError(requestError.message || "Unable to load HSN/SAC master data.");
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: requestError.message || "Unable to load HSN/SAC master data.",
                confirmButtonText: "OK"
            });
        } finally{
            setLoading(false);
        }
    }, [
        activeTab
    ]);
    (0, $acw62.useEffect)(()=>{
        loadSACData();
    }, [
        loadSACData
    ]);
    /* =========================================================
     FILTER OPTIONS
     
     These come from backend now.
     ========================================================= */ const sectionOptions = (0, $acw62.useMemo)(()=>sacOptions.section || [], [
        sacOptions.section
    ]);
    const rcmOptions = (0, $acw62.useMemo)(()=>sacOptions.rcm_fc || [], [
        sacOptions.rcm_fc
    ]);
    const blockInputOptions = (0, $acw62.useMemo)(()=>sacOptions.block_input || [], [
        sacOptions.block_input
    ]);
    /* =========================================================
     FILTER STATE
  ========================================================= */ const hasSacFilters = Boolean(sacSearch) || Boolean(sectionFilter) || Boolean(rcmFilter) || Boolean(blockInputFilter);
    const hasHsnFilters = Boolean(hsnSearch) || Boolean(hsnTaxrateFilter) || Boolean(hsnBlockInputFilter);
    /* =========================================================
     CLEAR FILTERS
  ========================================================= */ const clearSacFilters = ()=>{
        setSacSearch("");
        setSectionFilter("");
        setRcmFilter("");
        setBlockInputFilter("");
        loadSACData({
            type: "sac",
            page: 1
        });
    };
    const clearHsnFilters = ()=>{
        setHsnSearch("");
        setHsnTaxrateFilter("");
        setHsnBlockInputFilter("");
        loadSACData({
            type: "hsn",
            page: 1
        });
    };
    /* =========================================================
     EDIT SAC
  ========================================================= */ const openSacEdit = async (row)=>{
        try {
            setLoading(true);
            const params = new URLSearchParams({
                type: "sac",
                code: row.saccode
            });
            const response = await fetch(`${$4b59401103b2b567$var$SAC_API_URL}?${params.toString()}`, {
                credentials: "include",
                headers: {
                    Accept: "application/json"
                }
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || "Unable to load SAC record.");
            setEditingSac(payload.data);
        } catch (requestError) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: requestError.message || "Unable to load SAC record.",
                confirmButtonText: "OK"
            });
        } finally{
            setLoading(false);
        }
    };
    /* =========================================================
     EDIT HSN
  ========================================================= */ const openHsnEdit = async (row)=>{
        try {
            setLoading(true);
            const params = new URLSearchParams({
                type: "hsn",
                code: row.hsncode
            });
            const response = await fetch(`${$4b59401103b2b567$var$SAC_API_URL}?${params.toString()}`, {
                credentials: "include",
                headers: {
                    Accept: "application/json"
                }
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || "Unable to load HSN record.");
            setEditingHsn(payload.data);
        } catch (requestError) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: requestError.message || "Unable to load HSN record.",
                confirmButtonText: "OK"
            });
        } finally{
            setLoading(false);
        }
    };
    /* =========================================================
     RENDER
  ========================================================= */ return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "config-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel upload-view__hero",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "Master Data"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "HSN / SAC Master"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-view__intro",
                                children: "Manage HSN and SAC master data used for tax mapping, validation and invoice processing."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "upload-view__summary",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "upload-view__summary-count",
                                children: loading ? "..." : activeTab === "sac" ? sacPagination.total : hsnPagination.total
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "upload-view__summary-label",
                                children: activeTab === "sac" ? "SAC records" : "HSN records"
                            })
                        ]
                    })
                ]
            }),
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel hsn-sac-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "hsn-sac-panel__tabs",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: `hsn-sac-panel__tab ${activeTab === "sac" ? "hsn-sac-panel__tab--active" : ""}`,
                                onClick: ()=>{
                                    setActiveTab("sac");
                                    loadSACData({
                                        type: "sac",
                                        page: 1,
                                        search: sacSearch,
                                        section: sectionFilter,
                                        rcm_fc: rcmFilter,
                                        block_input: blockInputFilter
                                    });
                                },
                                children: "SAC"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: `hsn-sac-panel__tab ${activeTab === "hsn" ? "hsn-sac-panel__tab--active" : ""}`,
                                onClick: ()=>{
                                    setActiveTab("hsn");
                                    loadSACData({
                                        type: "hsn",
                                        page: 1,
                                        search: hsnSearch,
                                        tax_rate: hsnTaxrateFilter,
                                        block_input: hsnBlockInputFilter
                                    });
                                },
                                children: "HSN"
                            })
                        ]
                    }),
                    activeTab === "sac" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "hsn-sac-panel__content",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "hsn-sac-filters",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "hsn-sac-filter hsn-sac-filter--search",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: "sac-search",
                                                children: "SAC Code"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                id: "sac-search",
                                                type: "text",
                                                value: sacSearch,
                                                placeholder: "Search SAC code...",
                                                onChange: (event)=>setSacSearch(event.target.value),
                                                onKeyDown: (event)=>{
                                                    if (event.key === "Enter") loadSACData({
                                                        type: "sac",
                                                        page: 1,
                                                        search: sacSearch,
                                                        section: sectionFilter,
                                                        rcm_fc: rcmFilter,
                                                        block_input: blockInputFilter
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "hsn-sac-filter",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: "sac-section",
                                                children: "Section"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                id: "sac-section",
                                                value: sectionFilter,
                                                onChange: (event)=>{
                                                    const value = event.target.value;
                                                    setSectionFilter(value);
                                                    loadSACData({
                                                        type: "sac",
                                                        page: 1,
                                                        search: sacSearch,
                                                        section: value,
                                                        rcm_fc: rcmFilter,
                                                        block_input: blockInputFilter
                                                    });
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "All Sections"
                                                    }),
                                                    sectionOptions.map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: value,
                                                            children: value
                                                        }, value))
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "hsn-sac-filter",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: "sac-rcm",
                                                children: "RCM / FC"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                id: "sac-rcm",
                                                value: rcmFilter,
                                                onChange: (event)=>{
                                                    const value = event.target.value;
                                                    setRcmFilter(value);
                                                    loadSACData({
                                                        type: "sac",
                                                        page: 1,
                                                        search: sacSearch,
                                                        section: sectionFilter,
                                                        rcm_fc: value,
                                                        block_input: blockInputFilter
                                                    });
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "All RCM / FC"
                                                    }),
                                                    rcmOptions.map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: value,
                                                            children: value
                                                        }, value))
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "hsn-sac-filter",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: "sac-block-input",
                                                children: "Block Input"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                id: "sac-block-input",
                                                value: blockInputFilter,
                                                onChange: (event)=>{
                                                    const value = event.target.value;
                                                    setBlockInputFilter(value);
                                                    loadSACData({
                                                        type: "sac",
                                                        page: 1,
                                                        search: sacSearch,
                                                        section: sectionFilter,
                                                        rcm_fc: rcmFilter,
                                                        block_input: value
                                                    });
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "All Block Input"
                                                    }),
                                                    blockInputOptions.map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: value,
                                                            children: value
                                                        }, value))
                                                ]
                                            })
                                        ]
                                    }),
                                    hasSacFilters ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "secondary-button hsn-sac-filter__clear",
                                        onClick: clearSacFilters,
                                        children: "Clear Filters"
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "hsn-sac-table-wrap",
                                children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "hsn-sac-table__state",
                                    children: "Loading SAC master data..."
                                }) : sacData.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "hsn-sac-table__state",
                                    children: "No SAC records found for the selected filters."
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    className: "hsn-sac-table",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    $4b59401103b2b567$var$SAC_COLUMNS.map((column)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: column.label
                                                        }, column.key)),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Action"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: sacData.map((row, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: $4b59401103b2b567$var$displayValue(row.saccode)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: $4b59401103b2b567$var$displayValue(row.service_code)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "hsn-sac-table__description",
                                                            children: $4b59401103b2b567$var$displayValue(row.sacDescription)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "hsn-sac-table__tooltip-wrapper",
                                                                title: row.deciding_factor || "No deciding factor available",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "pill",
                                                                    children: $4b59401103b2b567$var$displayValue(row.block_input)
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "hsn-sac-table__tooltip-wrapper",
                                                                title: row.fc_rcm_deciding_factor || "No deciding factor available",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "pill",
                                                                    children: $4b59401103b2b567$var$displayValue(row.rcm_fc)
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: $4b59401103b2b567$var$displayValue(row.section)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: $4b59401103b2b567$var$displayValue(row.tds_section_2025)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "secondary-button",
                                                                onClick: ()=>openSacEdit(row),
                                                                children: "Edit"
                                                            })
                                                        })
                                                    ]
                                                }, row.id ?? `${row.saccode}-${index}`))
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$MasterPagination, {
                                pagination: sacPagination,
                                onPageChange: (page)=>{
                                    loadSACData({
                                        type: "sac",
                                        page: page,
                                        search: sacSearch,
                                        section: sectionFilter,
                                        rcm_fc: rcmFilter,
                                        block_input: blockInputFilter
                                    });
                                }
                            })
                        ]
                    }) : /* =================================================
             HSN
          ================================================= */ /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "hsn-sac-panel__content",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "hsn-sac-filters",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "hsn-sac-filter hsn-sac-filter--search",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: "hsn-search",
                                                children: "HSN Code"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                id: "hsn-search",
                                                type: "text",
                                                value: hsnSearch,
                                                placeholder: "Search HSN code...",
                                                onChange: (event)=>setHsnSearch(event.target.value),
                                                onKeyDown: (event)=>{
                                                    if (event.key === "Enter") loadSACData({
                                                        type: "hsn",
                                                        page: 1,
                                                        search: hsnSearch,
                                                        tax_rate: hsnTaxrateFilter,
                                                        block_input: hsnBlockInputFilter
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "hsn-sac-filter",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: "hsn-taxrate",
                                                children: "Tax Rate"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                id: "hsn-taxrate",
                                                value: hsnTaxrateFilter,
                                                onChange: (event)=>{
                                                    const value = event.target.value;
                                                    setHsnTaxrateFilter(value);
                                                    loadSACData({
                                                        type: "hsn",
                                                        page: 1,
                                                        search: hsnSearch,
                                                        tax_rate: value,
                                                        block_input: hsnBlockInputFilter
                                                    });
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "All Tax Rates"
                                                    }),
                                                    hsnOptions.tax_rate.map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: value,
                                                            children: value
                                                        }, value))
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "hsn-sac-filter",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: "hsn-block-input",
                                                children: "Block Input"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                id: "hsn-block-input",
                                                value: hsnBlockInputFilter,
                                                onChange: (event)=>{
                                                    const value = event.target.value;
                                                    setHsnBlockInputFilter(value);
                                                    loadSACData({
                                                        type: "hsn",
                                                        page: 1,
                                                        search: hsnSearch,
                                                        tax_rate: hsnTaxrateFilter,
                                                        block_input: value
                                                    });
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "All Block Input"
                                                    }),
                                                    hsnOptions.block_input.map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: value,
                                                            children: value
                                                        }, value))
                                                ]
                                            })
                                        ]
                                    }),
                                    hasHsnFilters ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "secondary-button hsn-sac-filter__clear",
                                        onClick: clearHsnFilters,
                                        children: "Clear Filters"
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "hsn-sac-table-wrap",
                                children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "hsn-sac-table__state",
                                    children: "Loading HSN master data..."
                                }) : hsnData.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "hsn-sac-table__state",
                                    children: "No HSN records found for the selected filters."
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    className: "hsn-sac-table",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "HSN Code"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Description"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Tax Rate"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Block Input"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Action"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: hsnData.map((row, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: $4b59401103b2b567$var$displayValue(row.hsncode)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "hsn-sac-table__description",
                                                            children: $4b59401103b2b567$var$displayValue(row.hsnDescription ?? row.description)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "pill",
                                                                children: $4b59401103b2b567$var$displayValue(row.tax_rate)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "hsn-sac-table__tooltip-wrapper",
                                                                title: row.deciding_factor || "No deciding factor available",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "pill",
                                                                    children: $4b59401103b2b567$var$displayValue(row.block_input)
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "secondary-button",
                                                                onClick: ()=>openHsnEdit(row),
                                                                children: "Edit"
                                                            })
                                                        })
                                                    ]
                                                }, row.id ?? `${row.hsncode}-${index}`))
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$MasterPagination, {
                                pagination: hsnPagination,
                                onPageChange: (page)=>{
                                    loadSACData({
                                        type: "hsn",
                                        page: page,
                                        search: hsnSearch,
                                        tax_rate: hsnTaxrateFilter,
                                        block_input: hsnBlockInputFilter
                                    });
                                }
                            })
                        ]
                    })
                ]
            }),
            editingSac ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$SACEditModal, {
                sac: editingSac,
                options: sacOptions,
                saving: savingSac,
                onClose: ()=>setEditingSac(null),
                onSaved: async ()=>{
                    setEditingSac(null);
                    await loadSACData({
                        type: "sac",
                        page: sacPagination.page,
                        search: sacSearch,
                        section: sectionFilter,
                        rcm_fc: rcmFilter,
                        block_input: blockInputFilter
                    });
                }
            }) : null,
            editingHsn ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b59401103b2b567$var$HSNEditModal, {
                hsn: editingHsn,
                options: hsnOptions,
                saving: savingHsn,
                onClose: ()=>setEditingHsn(null),
                onSaved: async ()=>{
                    setEditingHsn(null);
                    await loadSACData({
                        type: "hsn",
                        page: hsnPagination.page,
                        search: hsnSearch,
                        tax_rate: hsnTaxrateFilter,
                        block_input: hsnBlockInputFilter
                    });
                }
            }) : null
        ]
    });
}
/* =========================================================
   HELPERS
========================================================= */ function $4b59401103b2b567$var$normalizeValue(value) {
    if (value === null || value === undefined) return "";
    return String(value).trim();
}
function $4b59401103b2b567$var$displayValue(value) {
    const normalized = $4b59401103b2b567$var$normalizeValue(value);
    return normalized || "\u2014";
}




var $acw62 = parcelRequire("acw62");


const $9bed79cfef3f425c$var$ROLE_OPTIONS = (0, $96e14f2a7c3555e4$export$44ffa8fec8da147b);
const $9bed79cfef3f425c$var$STATUS_OPTIONS = [
    "Active",
    "Disabled"
];
const $9bed79cfef3f425c$var$EMPTY_FORM = {
    name: "",
    email: "",
    password: "",
    role: [],
    team: [],
    status: "Active"
};
function $9bed79cfef3f425c$var$normalizeArray(value) {
    return Array.isArray(value) ? value : value ? [
        value
    ] : [];
}
function $9bed79cfef3f425c$export$2e2bcd8739ae039() {
    const [form, setForm] = (0, $acw62.useState)($9bed79cfef3f425c$var$EMPTY_FORM);
    const [users, setUsers] = (0, $acw62.useState)([]);
    const [teams, setTeams] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [deletingUserId, setDeletingUserId] = (0, $acw62.useState)("");
    const [editingEmail, setEditingEmail] = (0, $acw62.useState)("");
    const [editingUserId, setEditingUserId] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const selectedRoles = form.role;
    const selectedTeams = form.team;
    const roleDisabledState = (0, $acw62.useMemo)(()=>{
        const processorChecked = selectedRoles.includes("Processor");
        const checkerChecked = selectedRoles.includes("Checker");
        const restrictToSelected = selectedTeams.length > 1;
        return $9bed79cfef3f425c$var$ROLE_OPTIONS.reduce((accumulator, role)=>{
            const isSelected = selectedRoles.includes(role);
            accumulator[role] = !isSelected && processorChecked && role === "Checker" || !isSelected && checkerChecked && role === "Processor" || restrictToSelected && !isSelected;
            return accumulator;
        }, {});
    }, [
        selectedRoles,
        selectedTeams
    ]);
    const teamDisabledState = (0, $acw62.useMemo)(()=>{
        const restrictToOneTeam = selectedRoles.length > 1;
        return teams.reduce((accumulator, team)=>{
            const isSelected = selectedTeams.includes(team.team);
            accumulator[team.team] = restrictToOneTeam && !isSelected && selectedTeams.length >= 1;
            return accumulator;
        }, {});
    }, [
        selectedRoles,
        selectedTeams,
        teams
    ]);
    async function loadUsersAndTeams() {
        setLoading(true);
        setError("");
        try {
            const adminAccess = await (0, $96e14f2a7c3555e4$export$f1c7cb4900148296)();
            if (!adminAccess.ok) throw new Error(adminAccess.message);
            const [usersPayload, teamsPayload] = await Promise.all([
                (0, $96e14f2a7c3555e4$export$a92d70fb86f2009d)(),
                (0, $96e14f2a7c3555e4$export$319baa9921ab97ab)()
            ]);
            setUsers((usersPayload || []).map((user)=>({
                    ...user,
                    role: $9bed79cfef3f425c$var$normalizeArray(user.role),
                    team: $9bed79cfef3f425c$var$normalizeArray(user.team)
                })));
            setTeams((teamsPayload || []).map((team)=>({
                    ...team,
                    team: team.team || team.name || ""
                })));
        } catch (requestError) {
            setError(requestError.message || "Unable to load user management data.");
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadUsersAndTeams();
    }, []);
    function updateField(field, value) {
        setForm((current)=>({
                ...current,
                [field]: value
            }));
    }
    function toggleRole(role) {
        setForm((current)=>{
            const nextRoles = current.role.includes(role) ? current.role.filter((item)=>item !== role) : [
                ...current.role,
                role
            ];
            return {
                ...current,
                role: nextRoles
            };
        });
    }
    function toggleTeam(teamCode) {
        setForm((current)=>{
            const nextTeams = current.team.includes(teamCode) ? current.team.filter((item)=>item !== teamCode) : [
                ...current.team,
                teamCode
            ];
            return {
                ...current,
                team: nextTeams
            };
        });
    }
    function resetForm() {
        setForm($9bed79cfef3f425c$var$EMPTY_FORM);
        setEditingEmail("");
        setEditingUserId("");
    }
    function handleEdit(user) {
        setStatus("");
        setError("");
        setEditingEmail(user.email);
        setEditingUserId(user.id || "");
        setForm({
            name: user.first_name || "",
            email: user.email || "",
            password: "",
            role: $9bed79cfef3f425c$var$normalizeArray(user.role),
            team: $9bed79cfef3f425c$var$normalizeArray(user.team),
            status: user.status || "Active"
        });
    }
    async function handleDelete(user) {
        if (!user?.id) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Unable to delete user: missing user id."
            });
            return;
        }
        const result = await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
            title: "Delete User?",
            text: `Are you sure you want to delete ${user.email}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Delete",
            cancelButtonText: "Cancel",
            reverseButtons: true
        });
        if (!result.isConfirmed) return;
        setDeletingUserId(user.id);
        setError("");
        try {
            await (0, $96e14f2a7c3555e4$export$be0a570570b4515e)(user.id);
            if (editingUserId === user.id) resetForm();
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Deleted",
                text: "User deleted successfully.",
                confirmButtonText: "OK"
            });
            await loadUsersAndTeams();
        } catch (requestError) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Delete Failed",
                text: requestError.message || "Unable to delete user.",
                confirmButtonText: "OK"
            });
            setError(requestError.message || "Unable to delete user.");
        } finally{
            setDeletingUserId("");
        }
    }
    async function handleSubmit(event) {
        event.preventDefault();
        setSaving(true);
        setError("");
        try {
            await (0, $96e14f2a7c3555e4$export$b528b6c90ea06b91)({
                id: editingUserId,
                name: form.name.trim(),
                email: form.email.trim().toLowerCase(),
                password: form.password,
                role: form.role,
                team: form.team,
                status: form.status
            });
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: editingEmail ? "User updated successfully." : "User created successfully.",
                confirmButtonText: "OK"
            });
            resetForm();
            await loadUsersAndTeams();
        } catch (requestError) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: requestError.message || "Unable to save user.",
                confirmButtonText: "OK"
            });
            setError(requestError.message || "Unable to save user.");
        } finally{
            setSaving(false);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "users-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel users-view__hero",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "Users"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "User Management"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-view__intro",
                                children: "Manage users directly in Keycloak from this dashboard, including roles and team-group assignments."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "users-view__summary",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "users-view__summary-count",
                                children: users.length
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "users-view__summary-label",
                                children: "users configured"
                            })
                        ]
                    })
                ]
            }),
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "users-layout",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        className: "workspace-panel users-form",
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "users-form__header",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "eyebrow",
                                                children: editingEmail ? "Edit User" : "Create User"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                children: editingEmail ? "Update an existing user" : "Add a new user"
                                            })
                                        ]
                                    }),
                                    editingEmail ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "ghost-button",
                                        type: "button",
                                        onClick: resetForm,
                                        children: "Cancel Edit"
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: form.name,
                                        onChange: (event)=>updateField("name", event.target.value),
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Email"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "email",
                                        value: form.email,
                                        onChange: (event)=>updateField("email", event.target.value),
                                        disabled: Boolean(editingEmail),
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            "Password ",
                                            editingEmail ? "(optional for update)" : ""
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "password",
                                        value: form.password,
                                        onChange: (event)=>updateField("password", event.target.value),
                                        placeholder: editingEmail ? "Leave blank to keep current password" : "",
                                        required: !editingEmail
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Roles"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "selection-grid",
                                        children: $9bed79cfef3f425c$var$ROLE_OPTIONS.map((role)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: `selection-chip${form.role.includes(role) ? " is-selected" : ""}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        value: role,
                                                        checked: form.role.includes(role),
                                                        disabled: roleDisabledState[role],
                                                        onChange: ()=>toggleRole(role)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: role
                                                    })
                                                ]
                                            }, role))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Teams"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "selection-grid",
                                        children: teams.length ? teams.map((team)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: `selection-chip${form.team.includes(team.team) ? " is-selected" : ""}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        value: team.team,
                                                        checked: form.team.includes(team.team),
                                                        disabled: teamDisabledState[team.team],
                                                        onChange: ()=>toggleTeam(team.team)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: team.team_name || team.team
                                                    })
                                                ]
                                            }, team.team)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "empty-state",
                                            children: "Create teams (groups) first to assign users."
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Status"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: form.status,
                                        onChange: (event)=>updateField("status", event.target.value),
                                        children: $9bed79cfef3f425c$var$STATUS_OPTIONS.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: item,
                                                children: item
                                            }, item))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary-button",
                                type: "submit",
                                disabled: saving,
                                children: saving ? "Saving..." : editingEmail ? "Update User" : "Add User"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "workspace-panel",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "users-table__header",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "eyebrow",
                                            children: "Directory"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            children: "All Users"
                                        })
                                    ]
                                })
                            }),
                            loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-note",
                                children: "Loading users\u2026"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-table",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Name"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Email"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Role"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Teams"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Action"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: users.length ? users.map((user)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: user.first_name
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: user.email
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: $9bed79cfef3f425c$var$normalizeArray(user.role).join(", ") || "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: $9bed79cfef3f425c$var$normalizeArray(user.team).map((teamCode)=>teams.find((team)=>team.team === teamCode)?.team_name || teamCode).join(", ") || "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: user.status || "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    className: "ghost-button",
                                                                    type: "button",
                                                                    onClick: ()=>handleEdit(user),
                                                                    children: "Edit"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    className: "ghost-button",
                                                                    type: "button",
                                                                    onClick: ()=>handleDelete(user),
                                                                    disabled: deletingUserId === user.id,
                                                                    children: deletingUserId === user.id ? "Deleting..." : "Delete"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, user.id || user.email)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    colSpan: "6",
                                                    children: "No users found."
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


const $7509c21f19660ffb$var$RIGHTS_FIELDS = [
    {
        key: "invoice_date_edit",
        label: "Invoice Date Edit"
    },
    {
        key: "gsttaxcode_edit",
        label: "GST Tax Code Edit"
    },
    {
        key: "withholdingtaxcode_edit",
        label: "Withholding Tax Code Edit"
    },
    {
        key: "material_service_edit",
        label: "Material/Service Edit"
    },
    {
        key: "unallocatedcost_edit",
        label: "Unallocated Cost Edit"
    },
    {
        key: "narration_edit",
        label: "Narration Edit"
    },
    {
        key: "invoicenumber_edit",
        label: "Invoice Number Edit"
    }
];
const $7509c21f19660ffb$var$ROLE_OPTIONS = [
    {
        value: "processor",
        label: "Processor"
    },
    {
        value: "uploader",
        label: "Uploader"
    },
    {
        value: "data_uploader",
        label: "Data Uploader"
    },
    {
        value: "checker",
        label: "Checker"
    }
];
const $7509c21f19660ffb$var$PROCESSOR_PO_OPTIONS = [
    "Both",
    "PO",
    "Non PO"
];
const $7509c21f19660ffb$var$PROCESSOR_MATERIAL_OPTIONS = [
    "Both",
    "Material",
    "Service"
];
function $7509c21f19660ffb$var$createDefaultRights() {
    const next = {};
    $7509c21f19660ffb$var$RIGHTS_FIELDS.forEach((field)=>{
        next[field.key] = false;
    });
    return next;
}
function $7509c21f19660ffb$export$2e2bcd8739ae039() {
    const [activeTab, setActiveTab] = (0, $acw62.useState)("rights");
    const [teams, setTeams] = (0, $acw62.useState)([]);
    const [users, setUsers] = (0, $acw62.useState)([]);
    const [supportedRoles, setSupportedRoles] = (0, $acw62.useState)([
        "processor"
    ]);
    const [selectedTeam, setSelectedTeam] = (0, $acw62.useState)("");
    const [selectedRole, setSelectedRole] = (0, $acw62.useState)("processor");
    const [rightsByEmail, setRightsByEmail] = (0, $acw62.useState)({});
    const [processorMatrix, setProcessorMatrix] = (0, $acw62.useState)([]);
    const [loadingProcessorMatrix, setLoadingProcessorMatrix] = (0, $acw62.useState)(true);
    const [savingProcessorMatrix, setSavingProcessorMatrix] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const filteredUsers = (0, $acw62.useMemo)(()=>{
        if (!selectedTeam) return [];
        const normalizedRole = selectedRole.toLowerCase();
        return users.filter((user)=>{
            const userRoles = Array.isArray(user.role) ? user.role : [];
            const userTeams = Array.isArray(user.team) ? user.team : [];
            return userTeams.includes(selectedTeam) && userRoles.some((role)=>String(role || "").toLowerCase() === normalizedRole);
        });
    }, [
        selectedRole,
        selectedTeam,
        users
    ]);
    const isRoleSupported = supportedRoles.includes(selectedRole);
    const activeUserCount = activeTab === "rights" ? filteredUsers.length : processorMatrix.length;
    (0, $acw62.useEffect)(()=>{
        async function loadContext() {
            setLoading(true);
            setError("");
            try {
                const payload = await (0, $96e14f2a7c3555e4$export$bffbe311d3d57b6a)();
                const nextTeams = payload.teams || [];
                setTeams(nextTeams);
                setUsers(payload.users || []);
                setSupportedRoles(payload.supportedRoles || [
                    "processor"
                ]);
                setSelectedTeam((current)=>current || nextTeams[0]?.team || "");
            } catch (requestError) {
                setError(requestError.message || "Unable to load user rights context.");
            } finally{
                setLoading(false);
            }
        }
        loadContext();
    }, []);
    (0, $acw62.useEffect)(()=>{
        async function loadProcessorMatrix() {
            if (!selectedTeam) {
                setProcessorMatrix([]);
                setLoadingProcessorMatrix(false);
                return;
            }
            setLoadingProcessorMatrix(true);
            try {
                const payload = await (0, $96e14f2a7c3555e4$export$49da68078f51bd0)(selectedTeam);
                setProcessorMatrix(payload || []);
            } catch (requestError) {
                setError(requestError.message || "Unable to load processor matrix.");
            } finally{
                setLoadingProcessorMatrix(false);
            }
        }
        loadProcessorMatrix();
    }, [
        selectedTeam
    ]);
    (0, $acw62.useEffect)(()=>{
        async function loadRights() {
            if (!selectedTeam || !isRoleSupported) {
                setRightsByEmail({});
                return;
            }
            setError("");
            setStatus("");
            try {
                const payload = await (0, $96e14f2a7c3555e4$export$ccad2a7dac8e08f9)(selectedTeam, selectedRole);
                const next = {};
                filteredUsers.forEach((user)=>{
                    const email = user.email || "";
                    if (!email) return;
                    next[email] = {
                        ...$7509c21f19660ffb$var$createDefaultRights(),
                        ...payload.data?.[email] || {}
                    };
                });
                setRightsByEmail(next);
            } catch (requestError) {
                setRightsByEmail({});
                setError(requestError.message || "Unable to load user rights.");
            }
        }
        loadRights();
    }, [
        filteredUsers,
        isRoleSupported,
        selectedRole,
        selectedTeam
    ]);
    function toggleRight(email, key) {
        setRightsByEmail((current)=>({
                ...current,
                [email]: {
                    ...$7509c21f19660ffb$var$createDefaultRights(),
                    ...current[email] || {},
                    [key]: !(current[email] || {})[key]
                }
            }));
    }
    function updateProcessorRow(email, field, value) {
        setProcessorMatrix((current)=>current.map((row)=>row.email === email ? {
                    ...row,
                    [field]: value
                } : row));
    }
    async function handleSave() {
        setStatus("");
        setError("");
        if (!selectedTeam) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Please select a team.",
                confirmButtonText: "OK"
            });
            return;
        }
        if (!isRoleSupported) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Only processor rights are supported right now.",
                confirmButtonText: "OK"
            });
            return;
        }
        setSaving(true);
        try {
            const assignments = {};
            filteredUsers.forEach((user)=>{
                const email = user.email || "";
                if (!email) return;
                assignments[email] = {
                    ...$7509c21f19660ffb$var$createDefaultRights(),
                    ...rightsByEmail[email] || {}
                };
            });
            const payload = await (0, $96e14f2a7c3555e4$export$439490942e4c7c4e)({
                team: selectedTeam,
                role: selectedRole,
                assignments: assignments
            });
            const skippedUsers = payload.skippedUsers || [];
            if (skippedUsers.length) // setStatus(`Rights saved with ${skippedUsers.length} skipped user record(s).`);
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: "Rights saved with ${skippedUsers.length} skipped user record(s).",
                confirmButtonText: "OK"
            });
            else (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: "Rights saved successfully.",
                confirmButtonText: "OK"
            });
        } catch (requestError) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Unable to save rights.",
                confirmButtonText: "OK"
            });
        } finally{
            setSaving(false);
        }
    }
    async function handleSaveProcessorMatrix() {
        setStatus("");
        setError("");
        setSavingProcessorMatrix(true);
        try {
            const payload = await (0, $96e14f2a7c3555e4$export$ea54bcf9867fe13b)(processorMatrix, selectedTeam);
            const skippedUsers = payload.skippedUsers || [];
            if (skippedUsers.length) setStatus(`Processor matrix saved with ${skippedUsers.length} skipped user record(s).`);
            else setStatus(payload.message || "Processor matrix saved successfully.");
        } catch (requestError) {
            setError(requestError.message || "Unable to save processor matrix.");
        } finally{
            setSavingProcessorMatrix(false);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "users-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "users-view__hero",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "User Rights"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "User Rights Matrix"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-view__intro",
                                children: "Configure user-level edit permissions by team and role. Processor profiles are loaded from the processing profile table."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "users-view__summary",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "users-view__summary-count",
                                children: activeUserCount
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "users-view__summary-label",
                                children: activeTab === "rights" ? "users in scope" : "processors in scope"
                            })
                        ]
                    })
                ]
            }),
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "processor-table__header",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Tabs"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "User Rights Configuration"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "template-tabs",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: `template-tab${activeTab === "rights" ? " is-active" : ""}`,
                                type: "button",
                                onClick: ()=>setActiveTab("rights"),
                                children: "User Rights"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: `template-tab${activeTab === "processors" ? " is-active" : ""}`,
                                type: "button",
                                onClick: ()=>setActiveTab("processors"),
                                children: "Processors"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-inline",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Team"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: selectedTeam,
                                        onChange: (event)=>setSelectedTeam(event.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "-- Select Team --"
                                            }),
                                            teams.map((team)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: team.team,
                                                    children: team.team_name || team.team
                                                }, team.id || team.team))
                                        ]
                                    })
                                ]
                            }),
                            activeTab === "rights" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Role"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: selectedRole,
                                        onChange: (event)=>setSelectedRole(event.target.value),
                                        children: $7509c21f19660ffb$var$ROLE_OPTIONS.map((role)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: role.value,
                                                children: role.label
                                            }, role.value))
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    activeTab === "rights" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "processor-table__header",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "eyebrow",
                                                children: "Rights Matrix"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                children: "User-wise edit permissions"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "primary-button",
                                        type: "button",
                                        disabled: saving || loading || !isRoleSupported,
                                        onClick: handleSave,
                                        children: saving ? "Saving..." : "Save Rights"
                                    })
                                ]
                            }),
                            !isRoleSupported ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-note",
                                children: "Selected role is not backed by the API yet. Processor is the only supported role today."
                            }) : !selectedTeam ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-note",
                                children: "Select a team to configure rights."
                            }) : filteredUsers.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-table",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "User"
                                                    }),
                                                    $7509c21f19660ffb$var$RIGHTS_FIELDS.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: field.label
                                                        }, field.key))
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: filteredUsers.map((user)=>{
                                                const email = user.email || "";
                                                const rights = rightsByEmail[email] || $7509c21f19660ffb$var$createDefaultRights();
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: user.first_name || email
                                                        }),
                                                        $7509c21f19660ffb$var$RIGHTS_FIELDS.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    type: "checkbox",
                                                                    checked: Boolean(rights[field.key]),
                                                                    onChange: ()=>toggleRight(email, field.key)
                                                                })
                                                            }, `${email}-${field.key}`))
                                                    ]
                                                }, user.id || email);
                                            })
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "empty-state",
                                children: "No users found for this team and role."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "processor-table__header",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "eyebrow",
                                                children: "Processor Matrix"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                children: "Processor assignment settings"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "primary-button",
                                        type: "button",
                                        disabled: savingProcessorMatrix || loadingProcessorMatrix,
                                        onClick: handleSaveProcessorMatrix,
                                        children: savingProcessorMatrix ? "Saving..." : "Save Processor Matrix"
                                    })
                                ]
                            }),
                            loadingProcessorMatrix ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-note",
                                children: "Loading processor matrix..."
                            }) : processorMatrix.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-table",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "User"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Email"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Teams"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "PO vs Non PO"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Value Lower Limit"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Value Higher Limit"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Material vs Services"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: processorMatrix.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: row.user
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: row.email
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: (row.teams || []).join(", ") || "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                                value: row.po_type || "Both",
                                                                onChange: (event)=>updateProcessorRow(row.email, "po_type", event.target.value),
                                                                children: $7509c21f19660ffb$var$PROCESSOR_PO_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: option,
                                                                        children: option
                                                                    }, option))
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "number",
                                                                value: row.lower_limit ?? 0,
                                                                onChange: (event)=>updateProcessorRow(row.email, "lower_limit", Number(event.target.value || 0))
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "number",
                                                                value: row.higher_limit ?? -1,
                                                                onChange: (event)=>updateProcessorRow(row.email, "higher_limit", Number(event.target.value || -1))
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                                value: row.material_type || "Both",
                                                                onChange: (event)=>updateProcessorRow(row.email, "material_type", event.target.value),
                                                                children: $7509c21f19660ffb$var$PROCESSOR_MATERIAL_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: option,
                                                                        children: option
                                                                    }, option))
                                                            })
                                                        })
                                                    ]
                                                }, row.id || row.email))
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "empty-state",
                                children: "No processor users found for this team."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


const $e5331923b4e7d0b4$var$RIGHTS_FIELDS = [
    {
        key: "invoice_date_edit",
        label: "Invoice Date Edit"
    },
    {
        key: "gsttaxcode_edit",
        label: "GST Tax Code Edit"
    },
    {
        key: "withholdingtaxcode_edit",
        label: "Withholding Tax Code Edit"
    },
    {
        key: "material_service_edit",
        label: "Material/Service Edit"
    },
    {
        key: "unallocatedcost_edit",
        label: "Unallocated Cost Edit"
    },
    {
        key: "narration_edit",
        label: "Narration Edit"
    },
    {
        key: "invoicenumber_edit",
        label: "Invoice Number Edit"
    }
];
const $e5331923b4e7d0b4$var$ROLE_OPTIONS = [
    {
        value: "processor",
        label: "Processor"
    },
    {
        value: "uploader",
        label: "Uploader"
    },
    {
        value: "data_uploader",
        label: "Data Uploader"
    },
    {
        value: "checker",
        label: "Checker"
    }
];
const $e5331923b4e7d0b4$var$PROCESSOR_PO_OPTIONS = [
    "Both",
    "PO",
    "Non PO"
];
const $e5331923b4e7d0b4$var$PROCESSOR_MATERIAL_OPTIONS = [
    "Both",
    "Material",
    "Service"
];
function $e5331923b4e7d0b4$var$createDefaultRights() {
    const next = {};
    $e5331923b4e7d0b4$var$RIGHTS_FIELDS.forEach((field)=>{
        next[field.key] = false;
    });
    return next;
}
function $e5331923b4e7d0b4$export$2e2bcd8739ae039() {
    const [activeTab, setActiveTab] = (0, $acw62.useState)("rights");
    const [teams, setTeams] = (0, $acw62.useState)([]);
    const [users, setUsers] = (0, $acw62.useState)([]);
    const [supportedRoles, setSupportedRoles] = (0, $acw62.useState)([
        "processor"
    ]);
    const [selectedTeam, setSelectedTeam] = (0, $acw62.useState)("");
    const [selectedRole, setSelectedRole] = (0, $acw62.useState)("processor");
    const [rightsByEmail, setRightsByEmail] = (0, $acw62.useState)({});
    const [processorMatrix, setProcessorMatrix] = (0, $acw62.useState)([]);
    const [loadingProcessorMatrix, setLoadingProcessorMatrix] = (0, $acw62.useState)(true);
    const [savingProcessorMatrix, setSavingProcessorMatrix] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const filteredUsers = (0, $acw62.useMemo)(()=>{
        if (!selectedTeam) return [];
        const normalizedRole = selectedRole.toLowerCase();
        return users.filter((user)=>{
            const userRoles = Array.isArray(user.role) ? user.role : [];
            const userTeams = Array.isArray(user.team) ? user.team : [];
            return userTeams.includes(selectedTeam) && userRoles.some((role)=>String(role || "").toLowerCase() === normalizedRole);
        });
    }, [
        selectedRole,
        selectedTeam,
        users
    ]);
    const isRoleSupported = supportedRoles.includes(selectedRole);
    const activeUserCount = activeTab === "rights" ? filteredUsers.length : processorMatrix.length;
    (0, $acw62.useEffect)(()=>{
        async function loadContext() {
            setLoading(true);
            setError("");
            try {
                const payload = await (0, $96e14f2a7c3555e4$export$bffbe311d3d57b6a)();
                const nextTeams = payload.teams || [];
                setTeams(nextTeams);
                setUsers(payload.users || []);
                setSupportedRoles(payload.supportedRoles || [
                    "processor"
                ]);
                setSelectedTeam((current)=>current || nextTeams[0]?.team || "");
            } catch (requestError) {
                setError(requestError.message || "Unable to load user rights context.");
            } finally{
                setLoading(false);
            }
        }
        loadContext();
    }, []);
    (0, $acw62.useEffect)(()=>{
        async function loadProcessorMatrix() {
            if (!selectedTeam) {
                setProcessorMatrix([]);
                setLoadingProcessorMatrix(false);
                return;
            }
            setLoadingProcessorMatrix(true);
            try {
                const payload = await (0, $96e14f2a7c3555e4$export$49da68078f51bd0)(selectedTeam);
                setProcessorMatrix(payload || []);
            } catch (requestError) {
                setError(requestError.message || "Unable to load processor matrix.");
            } finally{
                setLoadingProcessorMatrix(false);
            }
        }
        loadProcessorMatrix();
    }, [
        selectedTeam
    ]);
    (0, $acw62.useEffect)(()=>{
        async function loadRights() {
            if (!selectedTeam || !isRoleSupported) {
                setRightsByEmail({});
                return;
            }
            setError("");
            setStatus("");
            try {
                const payload = await (0, $96e14f2a7c3555e4$export$ccad2a7dac8e08f9)(selectedTeam, selectedRole);
                const next = {};
                filteredUsers.forEach((user)=>{
                    const email = user.email || "";
                    if (!email) return;
                    next[email] = {
                        ...$e5331923b4e7d0b4$var$createDefaultRights(),
                        ...payload.data?.[email] || {}
                    };
                });
                setRightsByEmail(next);
            } catch (requestError) {
                setRightsByEmail({});
                setError(requestError.message || "Unable to load user rights.");
            }
        }
        loadRights();
    }, [
        filteredUsers,
        isRoleSupported,
        selectedRole,
        selectedTeam
    ]);
    function toggleRight(email, key) {
        setRightsByEmail((current)=>({
                ...current,
                [email]: {
                    ...$e5331923b4e7d0b4$var$createDefaultRights(),
                    ...current[email] || {},
                    [key]: !(current[email] || {})[key]
                }
            }));
    }
    function updateProcessorRow(email, field, value) {
        setProcessorMatrix((current)=>current.map((row)=>row.email === email ? {
                    ...row,
                    [field]: value
                } : row));
    }
    async function handleSave() {
        setStatus("");
        setError("");
        if (!selectedTeam) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Please select a team.",
                confirmButtonText: "OK"
            });
            return;
        }
        if (!isRoleSupported) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Only processor rights are supported right now.",
                confirmButtonText: "OK"
            });
            return;
        }
        setSaving(true);
        try {
            const assignments = {};
            filteredUsers.forEach((user)=>{
                const email = user.email || "";
                if (!email) return;
                assignments[email] = {
                    ...$e5331923b4e7d0b4$var$createDefaultRights(),
                    ...rightsByEmail[email] || {}
                };
            });
            const payload = await (0, $96e14f2a7c3555e4$export$439490942e4c7c4e)({
                team: selectedTeam,
                role: selectedRole,
                assignments: assignments
            });
            const skippedUsers = payload.skippedUsers || [];
            if (skippedUsers.length) // setStatus(`Rights saved with ${skippedUsers.length} skipped user record(s).`);
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: "Rights saved with ${skippedUsers.length} skipped user record(s).",
                confirmButtonText: "OK"
            });
            else (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: "Rights saved successfully.",
                confirmButtonText: "OK"
            });
        } catch (requestError) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Unable to save rights.",
                confirmButtonText: "OK"
            });
        } finally{
            setSaving(false);
        }
    }
    async function handleSaveProcessorMatrix() {
        setStatus("");
        setError("");
        setSavingProcessorMatrix(true);
        try {
            const payload = await (0, $96e14f2a7c3555e4$export$ea54bcf9867fe13b)(processorMatrix, selectedTeam);
            const skippedUsers = payload.skippedUsers || [];
            if (skippedUsers.length) setStatus(`Processor matrix saved with ${skippedUsers.length} skipped user record(s).`);
            else setStatus(payload.message || "Processor matrix saved successfully.");
        } catch (requestError) {
            setError(requestError.message || "Unable to save processor matrix.");
        } finally{
            setSavingProcessorMatrix(false);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "users-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "users-view__hero",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "User Rights"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "User Rights Matrix"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-view__intro",
                                children: "Configure user-level edit permissions by team and role. Processor profiles are loaded from the processing profile table."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "users-view__summary",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "users-view__summary-count",
                                children: activeUserCount
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "users-view__summary-label",
                                children: activeTab === "rights" ? "users in scope" : "processors in scope"
                            })
                        ]
                    })
                ]
            }),
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "processor-table__header",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Tabs"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "User Rights Configuration"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "template-tabs",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: `template-tab${activeTab === "rights" ? " is-active" : ""}`,
                                type: "button",
                                onClick: ()=>setActiveTab("rights"),
                                children: "User Rights"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: `template-tab${activeTab === "processors" ? " is-active" : ""}`,
                                type: "button",
                                onClick: ()=>setActiveTab("processors"),
                                children: "Processors"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-inline",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Team"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: selectedTeam,
                                        onChange: (event)=>setSelectedTeam(event.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "-- Select Team --"
                                            }),
                                            teams.map((team)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: team.team,
                                                    children: team.team_name || team.team
                                                }, team.id || team.team))
                                        ]
                                    })
                                ]
                            }),
                            activeTab === "rights" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Role"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: selectedRole,
                                        onChange: (event)=>setSelectedRole(event.target.value),
                                        children: $e5331923b4e7d0b4$var$ROLE_OPTIONS.map((role)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: role.value,
                                                children: role.label
                                            }, role.value))
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    activeTab === "rights" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "processor-table__header",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "eyebrow",
                                                children: "Rights Matrix"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                children: "User-wise edit permissions"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "primary-button",
                                        type: "button",
                                        disabled: saving || loading || !isRoleSupported,
                                        onClick: handleSave,
                                        children: saving ? "Saving..." : "Save Rights"
                                    })
                                ]
                            }),
                            !isRoleSupported ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-note",
                                children: "Selected role is not backed by the API yet. Processor is the only supported role today."
                            }) : !selectedTeam ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-note",
                                children: "Select a team to configure rights."
                            }) : filteredUsers.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-table",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "User"
                                                    }),
                                                    $e5331923b4e7d0b4$var$RIGHTS_FIELDS.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: field.label
                                                        }, field.key))
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: filteredUsers.map((user)=>{
                                                const email = user.email || "";
                                                const rights = rightsByEmail[email] || $e5331923b4e7d0b4$var$createDefaultRights();
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: user.first_name || email
                                                        }),
                                                        $e5331923b4e7d0b4$var$RIGHTS_FIELDS.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    type: "checkbox",
                                                                    checked: Boolean(rights[field.key]),
                                                                    onChange: ()=>toggleRight(email, field.key)
                                                                })
                                                            }, `${email}-${field.key}`))
                                                    ]
                                                }, user.id || email);
                                            })
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "empty-state",
                                children: "No users found for this team and role."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "processor-table__header",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "eyebrow",
                                                children: "Processor Matrix"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                children: "Processor assignment settings"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "primary-button",
                                        type: "button",
                                        disabled: savingProcessorMatrix || loadingProcessorMatrix,
                                        onClick: handleSaveProcessorMatrix,
                                        children: savingProcessorMatrix ? "Saving..." : "Save Processor Matrix"
                                    })
                                ]
                            }),
                            loadingProcessorMatrix ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-note",
                                children: "Loading processor matrix..."
                            }) : processorMatrix.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-table",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "User"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Email"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Teams"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "PO vs Non PO"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Value Lower Limit"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Value Higher Limit"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Material vs Services"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: processorMatrix.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: row.user
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: row.email
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: (row.teams || []).join(", ") || "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                                value: row.po_type || "Both",
                                                                onChange: (event)=>updateProcessorRow(row.email, "po_type", event.target.value),
                                                                children: $e5331923b4e7d0b4$var$PROCESSOR_PO_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: option,
                                                                        children: option
                                                                    }, option))
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "number",
                                                                value: row.lower_limit ?? 0,
                                                                onChange: (event)=>updateProcessorRow(row.email, "lower_limit", Number(event.target.value || 0))
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "number",
                                                                value: row.higher_limit ?? -1,
                                                                onChange: (event)=>updateProcessorRow(row.email, "higher_limit", Number(event.target.value || -1))
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                                value: row.material_type || "Both",
                                                                onChange: (event)=>updateProcessorRow(row.email, "material_type", event.target.value),
                                                                children: $e5331923b4e7d0b4$var$PROCESSOR_MATERIAL_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: option,
                                                                        children: option
                                                                    }, option))
                                                            })
                                                        })
                                                    ]
                                                }, row.id || row.email))
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "empty-state",
                                children: "No processor users found for this team."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


const $2e06606c4a0025cd$var$RIGHTS_FIELDS = [
    {
        key: "invoice_date_edit",
        label: "Invoice Date Edit"
    },
    {
        key: "gsttaxcode_edit",
        label: "GST Tax Code Edit"
    },
    {
        key: "withholdingtaxcode_edit",
        label: "Withholding Tax Code Edit"
    },
    {
        key: "material_service_edit",
        label: "Material/Service Edit"
    },
    {
        key: "unallocatedcost_edit",
        label: "Unallocated Cost Edit"
    },
    {
        key: "narration_edit",
        label: "Narration Edit"
    },
    {
        key: "invoicenumber_edit",
        label: "Invoice Number Edit"
    }
];
const $2e06606c4a0025cd$var$ROLE_OPTIONS = [
    {
        value: "processor",
        label: "Processor"
    },
    {
        value: "uploader",
        label: "Uploader"
    },
    {
        value: "data_uploader",
        label: "Data Uploader"
    },
    {
        value: "checker",
        label: "Checker"
    }
];
const $2e06606c4a0025cd$var$PROCESSOR_PO_OPTIONS = [
    "Both",
    "PO",
    "Non PO"
];
const $2e06606c4a0025cd$var$PROCESSOR_MATERIAL_OPTIONS = [
    "Both",
    "Material",
    "Service"
];
function $2e06606c4a0025cd$var$createDefaultRights() {
    const next = {};
    $2e06606c4a0025cd$var$RIGHTS_FIELDS.forEach((field)=>{
        next[field.key] = false;
    });
    return next;
}
function $2e06606c4a0025cd$export$2e2bcd8739ae039() {
    const [activeTab, setActiveTab] = (0, $acw62.useState)("rights");
    const [teams, setTeams] = (0, $acw62.useState)([]);
    const [users, setUsers] = (0, $acw62.useState)([]);
    const [supportedRoles, setSupportedRoles] = (0, $acw62.useState)([
        "processor"
    ]);
    const [selectedTeam, setSelectedTeam] = (0, $acw62.useState)("");
    const [selectedRole, setSelectedRole] = (0, $acw62.useState)("processor");
    const [rightsByEmail, setRightsByEmail] = (0, $acw62.useState)({});
    const [processorMatrix, setProcessorMatrix] = (0, $acw62.useState)([]);
    const [loadingProcessorMatrix, setLoadingProcessorMatrix] = (0, $acw62.useState)(true);
    const [savingProcessorMatrix, setSavingProcessorMatrix] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const filteredUsers = (0, $acw62.useMemo)(()=>{
        if (!selectedTeam) return [];
        const normalizedRole = selectedRole.toLowerCase();
        return users.filter((user)=>{
            const userRoles = Array.isArray(user.role) ? user.role : [];
            const userTeams = Array.isArray(user.team) ? user.team : [];
            return userTeams.includes(selectedTeam) && userRoles.some((role)=>String(role || "").toLowerCase() === normalizedRole);
        });
    }, [
        selectedRole,
        selectedTeam,
        users
    ]);
    const isRoleSupported = supportedRoles.includes(selectedRole);
    const activeUserCount = activeTab === "rights" ? filteredUsers.length : processorMatrix.length;
    (0, $acw62.useEffect)(()=>{
        async function loadContext() {
            setLoading(true);
            setError("");
            try {
                const payload = await (0, $96e14f2a7c3555e4$export$bffbe311d3d57b6a)();
                const nextTeams = payload.teams || [];
                setTeams(nextTeams);
                setUsers(payload.users || []);
                setSupportedRoles(payload.supportedRoles || [
                    "processor"
                ]);
                setSelectedTeam((current)=>current || nextTeams[0]?.team || "");
            } catch (requestError) {
                setError(requestError.message || "Unable to load user rights context.");
            } finally{
                setLoading(false);
            }
        }
        loadContext();
    }, []);
    (0, $acw62.useEffect)(()=>{
        async function loadProcessorMatrix() {
            if (!selectedTeam) {
                setProcessorMatrix([]);
                setLoadingProcessorMatrix(false);
                return;
            }
            setLoadingProcessorMatrix(true);
            try {
                const payload = await (0, $96e14f2a7c3555e4$export$49da68078f51bd0)(selectedTeam);
                setProcessorMatrix(payload || []);
            } catch (requestError) {
                setError(requestError.message || "Unable to load processor matrix.");
            } finally{
                setLoadingProcessorMatrix(false);
            }
        }
        loadProcessorMatrix();
    }, [
        selectedTeam
    ]);
    (0, $acw62.useEffect)(()=>{
        async function loadRights() {
            if (!selectedTeam || !isRoleSupported) {
                setRightsByEmail({});
                return;
            }
            setError("");
            setStatus("");
            try {
                const payload = await (0, $96e14f2a7c3555e4$export$ccad2a7dac8e08f9)(selectedTeam, selectedRole);
                const next = {};
                filteredUsers.forEach((user)=>{
                    const email = user.email || "";
                    if (!email) return;
                    next[email] = {
                        ...$2e06606c4a0025cd$var$createDefaultRights(),
                        ...payload.data?.[email] || {}
                    };
                });
                setRightsByEmail(next);
            } catch (requestError) {
                setRightsByEmail({});
                setError(requestError.message || "Unable to load user rights.");
            }
        }
        loadRights();
    }, [
        filteredUsers,
        isRoleSupported,
        selectedRole,
        selectedTeam
    ]);
    function toggleRight(email, key) {
        setRightsByEmail((current)=>({
                ...current,
                [email]: {
                    ...$2e06606c4a0025cd$var$createDefaultRights(),
                    ...current[email] || {},
                    [key]: !(current[email] || {})[key]
                }
            }));
    }
    function updateProcessorRow(email, field, value) {
        setProcessorMatrix((current)=>current.map((row)=>row.email === email ? {
                    ...row,
                    [field]: value
                } : row));
    }
    async function handleSave() {
        setStatus("");
        setError("");
        if (!selectedTeam) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Please select a team.",
                confirmButtonText: "OK"
            });
            return;
        }
        if (!isRoleSupported) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Only processor rights are supported right now.",
                confirmButtonText: "OK"
            });
            return;
        }
        setSaving(true);
        try {
            const assignments = {};
            filteredUsers.forEach((user)=>{
                const email = user.email || "";
                if (!email) return;
                assignments[email] = {
                    ...$2e06606c4a0025cd$var$createDefaultRights(),
                    ...rightsByEmail[email] || {}
                };
            });
            const payload = await (0, $96e14f2a7c3555e4$export$439490942e4c7c4e)({
                team: selectedTeam,
                role: selectedRole,
                assignments: assignments
            });
            const skippedUsers = payload.skippedUsers || [];
            if (skippedUsers.length) // setStatus(`Rights saved with ${skippedUsers.length} skipped user record(s).`);
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: "Rights saved with ${skippedUsers.length} skipped user record(s).",
                confirmButtonText: "OK"
            });
            else (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: "Rights saved successfully.",
                confirmButtonText: "OK"
            });
        } catch (requestError) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Unable to save rights.",
                confirmButtonText: "OK"
            });
        } finally{
            setSaving(false);
        }
    }
    async function handleSaveProcessorMatrix() {
        setStatus("");
        setError("");
        setSavingProcessorMatrix(true);
        try {
            const payload = await (0, $96e14f2a7c3555e4$export$ea54bcf9867fe13b)(processorMatrix, selectedTeam);
            const skippedUsers = payload.skippedUsers || [];
            if (skippedUsers.length) setStatus(`Processor matrix saved with ${skippedUsers.length} skipped user record(s).`);
            else setStatus(payload.message || "Processor matrix saved successfully.");
        } catch (requestError) {
            setError(requestError.message || "Unable to save processor matrix.");
        } finally{
            setSavingProcessorMatrix(false);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "users-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "users-view__hero",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "User Rights"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "User Rights Matrix"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-view__intro",
                                children: "Configure user-level edit permissions by team and role. Processor profiles are loaded from the processing profile table."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "users-view__summary",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "users-view__summary-count",
                                children: activeUserCount
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "users-view__summary-label",
                                children: activeTab === "rights" ? "users in scope" : "processors in scope"
                            })
                        ]
                    })
                ]
            }),
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "processor-table__header",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Tabs"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "User Rights Configuration"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "template-tabs",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: `template-tab${activeTab === "rights" ? " is-active" : ""}`,
                                type: "button",
                                onClick: ()=>setActiveTab("rights"),
                                children: "User Rights"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: `template-tab${activeTab === "processors" ? " is-active" : ""}`,
                                type: "button",
                                onClick: ()=>setActiveTab("processors"),
                                children: "Processors"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-inline",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Team"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: selectedTeam,
                                        onChange: (event)=>setSelectedTeam(event.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "-- Select Team --"
                                            }),
                                            teams.map((team)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: team.team,
                                                    children: team.team_name || team.team
                                                }, team.id || team.team))
                                        ]
                                    })
                                ]
                            }),
                            activeTab === "rights" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Role"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: selectedRole,
                                        onChange: (event)=>setSelectedRole(event.target.value),
                                        children: $2e06606c4a0025cd$var$ROLE_OPTIONS.map((role)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: role.value,
                                                children: role.label
                                            }, role.value))
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    activeTab === "rights" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "processor-table__header",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "eyebrow",
                                                children: "Rights Matrix"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                children: "User-wise edit permissions"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "primary-button",
                                        type: "button",
                                        disabled: saving || loading || !isRoleSupported,
                                        onClick: handleSave,
                                        children: saving ? "Saving..." : "Save Rights"
                                    })
                                ]
                            }),
                            !isRoleSupported ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-note",
                                children: "Selected role is not backed by the API yet. Processor is the only supported role today."
                            }) : !selectedTeam ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-note",
                                children: "Select a team to configure rights."
                            }) : filteredUsers.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-table",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "User"
                                                    }),
                                                    $2e06606c4a0025cd$var$RIGHTS_FIELDS.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: field.label
                                                        }, field.key))
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: filteredUsers.map((user)=>{
                                                const email = user.email || "";
                                                const rights = rightsByEmail[email] || $2e06606c4a0025cd$var$createDefaultRights();
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: user.first_name || email
                                                        }),
                                                        $2e06606c4a0025cd$var$RIGHTS_FIELDS.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    type: "checkbox",
                                                                    checked: Boolean(rights[field.key]),
                                                                    onChange: ()=>toggleRight(email, field.key)
                                                                })
                                                            }, `${email}-${field.key}`))
                                                    ]
                                                }, user.id || email);
                                            })
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "empty-state",
                                children: "No users found for this team and role."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "processor-table__header",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "eyebrow",
                                                children: "Processor Matrix"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                children: "Processor assignment settings"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "primary-button",
                                        type: "button",
                                        disabled: savingProcessorMatrix || loadingProcessorMatrix,
                                        onClick: handleSaveProcessorMatrix,
                                        children: savingProcessorMatrix ? "Saving..." : "Save Processor Matrix"
                                    })
                                ]
                            }),
                            loadingProcessorMatrix ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-note",
                                children: "Loading processor matrix..."
                            }) : processorMatrix.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-table",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "User"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Email"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Teams"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "PO vs Non PO"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Value Lower Limit"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Value Higher Limit"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Material vs Services"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: processorMatrix.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: row.user
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: row.email
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: (row.teams || []).join(", ") || "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                                value: row.po_type || "Both",
                                                                onChange: (event)=>updateProcessorRow(row.email, "po_type", event.target.value),
                                                                children: $2e06606c4a0025cd$var$PROCESSOR_PO_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: option,
                                                                        children: option
                                                                    }, option))
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "number",
                                                                value: row.lower_limit ?? 0,
                                                                onChange: (event)=>updateProcessorRow(row.email, "lower_limit", Number(event.target.value || 0))
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "number",
                                                                value: row.higher_limit ?? -1,
                                                                onChange: (event)=>updateProcessorRow(row.email, "higher_limit", Number(event.target.value || -1))
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                                value: row.material_type || "Both",
                                                                onChange: (event)=>updateProcessorRow(row.email, "material_type", event.target.value),
                                                                children: $2e06606c4a0025cd$var$PROCESSOR_MATERIAL_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: option,
                                                                        children: option
                                                                    }, option))
                                                            })
                                                        })
                                                    ]
                                                }, row.id || row.email))
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "empty-state",
                                children: "No processor users found for this team."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

function $9ecacc5fc8b120bc$var$formatCountdown(totalSeconds) {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}
function $9ecacc5fc8b120bc$export$2e2bcd8739ae039({ email: email, onBackToSignup: onBackToSignup, onVerificationSuccess: onVerificationSuccess }) {
    const [otp, setOtp] = (0, $acw62.useState)("");
    const [submitting, setSubmitting] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [secondsLeft, setSecondsLeft] = (0, $acw62.useState)(300);
    (0, $acw62.useEffect)(()=>{
        setSecondsLeft(300);
    }, [
        email
    ]);
    (0, $acw62.useEffect)(()=>{
        if (secondsLeft <= 0) return undefined;
        const timer = window.setInterval(()=>{
            setSecondsLeft((current)=>{
                if (current <= 1) {
                    window.clearInterval(timer);
                    return 0;
                }
                return current - 1;
            });
        }, 1000);
        return ()=>window.clearInterval(timer);
    }, [
        secondsLeft
    ]);
    async function handleSubmit(event) {
        event.preventDefault();
        setSubmitting(true);
        setStatus("");
        setError("");
        try {
            const payload = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/auth/signup/verify-otp/", {
                method: "POST",
                body: JSON.stringify({
                    email: email,
                    otp: otp
                })
            });
            setStatus(payload.message || "Email verified successfully.");
            onVerificationSuccess(payload.redirectUrl);
        } catch (requestError) {
            setError(requestError.message || "Unable to verify OTP.");
        } finally{
            setSubmitting(false);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "auth-panel",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "auth-panel__header",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "eyebrow",
                        children: "Email Verification"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        children: "Verify your company registration"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "config-note",
                        children: [
                            "We have sent an OTP to ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: email
                            }),
                            ". Enter it below to finish company setup."
                        ]
                    })
                ]
            }),
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "form-error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                className: "auth-form",
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        children: [
                            "One-Time Password",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "text",
                                value: otp,
                                onChange: (event)=>setOtp(event.target.value),
                                placeholder: "Enter OTP",
                                maxLength: 6,
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: `otp-timer${secondsLeft === 0 ? " is-expired" : ""}`,
                        children: [
                            "OTP expires in: ",
                            secondsLeft > 0 ? $9ecacc5fc8b120bc$var$formatCountdown(secondsLeft) : "Expired"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "auth-form__actions",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary-button",
                                type: "submit",
                                disabled: submitting || secondsLeft === 0,
                                children: submitting ? "Verifying..." : "Verify OTP"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "ghost-button",
                                type: "button",
                                onClick: onBackToSignup,
                                children: "Back to Signup"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

const $2a79e089817acc78$var$STORAGE_KEY = "invoice-app-configuration-draft";
const $2a79e089817acc78$var$DEFAULT_FORM = {
    invoiceModule: "Both",
    emailNotifications: "N",
    vendorSPOCEmail: "",
    materialApprovalStage: "before_grn",
    serviceApprovalStage: "before_grn",
    typeOfInvoiceEnabled: "Y",
    typeAssignmentMode: "manual",
    automaticTypeChoice: "",
    checklistEnabled: "Y"
};
const $2a79e089817acc78$var$SECTION_TITLES = {
    basic: "A. Basic Configurations",
    invoiceType: "B. Type of Invoice Setup"
};
const $2a79e089817acc78$var$DEFAULT_OPEN_SECTIONS = {
    basic: true,
    invoiceType: false
};
function $2a79e089817acc78$var$Section({ title: title, subtitle: subtitle, open: open, onToggle: onToggle, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
        className: "config-card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                className: "config-card__head",
                type: "button",
                onClick: onToggle,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-card__title",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-card__subtitle",
                                children: subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "config-card__toggle",
                        children: open ? "Hide" : "Show"
                    })
                ]
            }),
            open ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-card__body",
                children: children
            }) : null
        ]
    });
}
function $2a79e089817acc78$var$ChoiceGroup({ name: name, value: value, options: options, onChange: onChange }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "config-inline",
        children: options.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                className: "config-choice",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "radio",
                        name: name,
                        value: option.value,
                        checked: value === option.value,
                        onChange: ()=>onChange(option.value)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: option.label
                    })
                ]
            }, option.value))
    });
}
function $2a79e089817acc78$var$ToggleChoice({ label: label, value: value, onChange: onChange }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
        className: "config-field",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                value: value,
                onChange: (event)=>onChange(event.target.value),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                        value: "Y",
                        children: "Yes"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                        value: "N",
                        children: "No"
                    })
                ]
            })
        ]
    });
}
function $2a79e089817acc78$var$normalizeApprovalStage(stage) {
    return String(stage || "").toLowerCase().replace(/[^a-z]/g, "");
}
function $2a79e089817acc78$var$isBeforeGrn(stage) {
    return $2a79e089817acc78$var$normalizeApprovalStage(stage).includes("beforegrn");
}
function $2a79e089817acc78$var$isAfterGrn(stage) {
    return $2a79e089817acc78$var$normalizeApprovalStage(stage).includes("aftergrn");
}
function $2a79e089817acc78$var$saveDraft(form) {
    window.localStorage.setItem($2a79e089817acc78$var$STORAGE_KEY, JSON.stringify(form));
}
function $2a79e089817acc78$export$2e2bcd8739ae039({ onBack: onBack }) {
    const [form, setForm] = (0, $acw62.useState)($2a79e089817acc78$var$DEFAULT_FORM);
    const [openSections, setOpenSections] = (0, $acw62.useState)($2a79e089817acc78$var$DEFAULT_OPEN_SECTIONS);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const selectedModule = (0, $acw62.useMemo)(()=>form.invoiceModule, [
        form.invoiceModule
    ]);
    const requiresOpenPoReport = (0, $acw62.useMemo)(()=>{
        const materialNeedsPo = selectedModule !== "Service" && $2a79e089817acc78$var$isBeforeGrn(form.materialApprovalStage);
        const serviceNeedsPo = selectedModule !== "Material" && $2a79e089817acc78$var$isBeforeGrn(form.serviceApprovalStage);
        return materialNeedsPo || serviceNeedsPo;
    }, [
        form.materialApprovalStage,
        form.serviceApprovalStage,
        selectedModule
    ]);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        async function loadConfiguration() {
            setLoading(true);
            try {
                const response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/invoice-configuration/", {
                    method: "GET"
                });
                if (!cancelled && response.status === "success" && response.data) {
                    const loaded = response.data;
                    setForm((current)=>({
                            ...$2a79e089817acc78$var$DEFAULT_FORM,
                            ...current,
                            invoiceModule: loaded.invoiceModule || $2a79e089817acc78$var$DEFAULT_FORM.invoiceModule,
                            emailNotifications: loaded.emailNotifications || $2a79e089817acc78$var$DEFAULT_FORM.emailNotifications,
                            vendorSPOCEmail: loaded.vendorSPOCEmail || "",
                            materialApprovalStage: loaded.materialApprovalStage || $2a79e089817acc78$var$DEFAULT_FORM.materialApprovalStage,
                            serviceApprovalStage: loaded.serviceApprovalStage || $2a79e089817acc78$var$DEFAULT_FORM.serviceApprovalStage,
                            typeOfInvoiceEnabled: loaded.typeOfInvoiceEnabled || $2a79e089817acc78$var$DEFAULT_FORM.typeOfInvoiceEnabled,
                            typeAssignmentMode: loaded.typeAssignmentMode || $2a79e089817acc78$var$DEFAULT_FORM.typeAssignmentMode,
                            automaticTypeChoice: loaded.automaticTypeChoice || "",
                            checklistEnabled: loaded.checklistEnabled || $2a79e089817acc78$var$DEFAULT_FORM.checklistEnabled
                        }));
                    window.localStorage.removeItem($2a79e089817acc78$var$STORAGE_KEY);
                }
            } catch (requestError) {
                if (!cancelled) setError(requestError.message || "Unable to load saved invoice approval configuration.");
            } finally{
                if (!cancelled) setLoading(false);
            }
        }
        loadConfiguration();
        return ()=>{
            cancelled = true;
        };
    }, []);
    function updateField(field, value) {
        setForm((current)=>{
            const nextForm = {
                ...current,
                [field]: value
            };
            $2a79e089817acc78$var$saveDraft(nextForm);
            return nextForm;
        });
    }
    function toggleSection(sectionKey) {
        setOpenSections((current)=>({
                ...current,
                [sectionKey]: !current[sectionKey]
            }));
    }
    //-------------------------------------------------------------
    function buildInvoiceConfigurationPayload() {
        const isMaterialActive = form.invoiceModule === "Material" || form.invoiceModule === "Both";
        const isServiceActive = form.invoiceModule === "Service" || form.invoiceModule === "Both";
        const isAutomaticType = form.typeOfInvoiceEnabled === "Y" && form.typeAssignmentMode === "automatic";
        const isInvoiceTypeEnabled = form.typeOfInvoiceEnabled === "Y";
        return {
            invoiceModule: form.invoiceModule,
            emailNotifications: form.emailNotifications,
            vendorSPOCEmail: form.emailNotifications === "Y" ? form.vendorSPOCEmail : "",
            materialApprovalStage: isMaterialActive ? form.materialApprovalStage : "",
            serviceApprovalStage: isServiceActive ? form.serviceApprovalStage : "",
            typeOfInvoiceEnabled: form.typeOfInvoiceEnabled,
            typeAssignmentMode: isInvoiceTypeEnabled ? form.typeAssignmentMode : "",
            automaticTypeChoice: isAutomaticType ? form.automaticTypeChoice : "",
            checklistEnabled: form.checklistEnabled
        };
    }
    async function handleSaveDraft() {
        setError("");
        $2a79e089817acc78$var$saveDraft(form);
        setStatus("Draft saved locally. Sending invoice configuration to backend...");
        setSaving(true);
        try {
            const response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/invoice-configuration/save/", {
                method: "POST",
                body: buildInvoiceConfigurationPayload()
            });
            setStatus(response.message || "Draft saved locally and invoice configuration sent to backend.");
            window.localStorage.removeItem($2a79e089817acc78$var$STORAGE_KEY);
        } catch (requestError) {
            setStatus("Draft saved locally in the browser.");
            setError(requestError.message || "Unable to send invoice configuration to backend.");
        } finally{
            setSaving(false);
        }
    }
    //--------------------------------------------------------------
    function handleResetDraft() {
        setError("");
        window.localStorage.removeItem($2a79e089817acc78$var$STORAGE_KEY);
        setForm($2a79e089817acc78$var$DEFAULT_FORM);
        setStatus("Draft reset.");
    }
    const showMaterialStage = selectedModule === "Material" || selectedModule === "Both";
    const showServiceStage = selectedModule === "Service" || selectedModule === "Both";
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "workspace-panel",
        children: "Loading invoice approval configuration\u2026"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "config-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "config-view__header workspace-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            children: "Invoice App Configuration"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-view__actions",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary-button",
                                type: "button",
                                onClick: handleSaveDraft,
                                disabled: saving,
                                children: saving ? "Saving..." : "Save Draft"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "ghost-button",
                                type: "button",
                                onClick: handleResetDraft,
                                children: "Reset Draft"
                            })
                        ]
                    })
                ]
            }),
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($2a79e089817acc78$var$Section, {
                title: $2a79e089817acc78$var$SECTION_TITLES.basic,
                subtitle: "Choose the invoice scope and initial approval controls",
                open: openSections.basic,
                onToggle: ()=>toggleSection("basic"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-grid",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Invoices to be dealt in this module"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2a79e089817acc78$var$ChoiceGroup, {
                                        name: "invoiceModule",
                                        value: form.invoiceModule,
                                        options: [
                                            {
                                                value: "Material",
                                                label: "Material"
                                            },
                                            {
                                                value: "Service",
                                                label: "Service"
                                            },
                                            {
                                                value: "Both",
                                                label: "Both"
                                            }
                                        ],
                                        onChange: (value)=>updateField("invoiceModule", value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Activate email notifications to users and vendors?"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: form.emailNotifications,
                                        onChange: (event)=>updateField("emailNotifications", event.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "N",
                                                children: "No"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "Y",
                                                children: "Yes"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            form.emailNotifications === "Y" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Vendor SPOC email"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "email",
                                        value: form.vendorSPOCEmail,
                                        onChange: (event)=>updateField("vendorSPOCEmail", event.target.value),
                                        placeholder: "relevant-user@vendor.com"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "config-field__hint",
                                        children: "Used for email approval, hold, and reject actions."
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-grid",
                        children: [
                            showMaterialStage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Material invoice approval stage"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: form.materialApprovalStage,
                                        onChange: (event)=>updateField("materialApprovalStage", event.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "before_grn",
                                                children: "Before GRN"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "after_grn",
                                                children: "After GRN"
                                            })
                                        ]
                                    })
                                ]
                            }) : null,
                            showServiceStage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Service invoice approval stage"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: form.serviceApprovalStage,
                                        onChange: (event)=>updateField("serviceApprovalStage", event.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "before_grn",
                                                children: "Before GRN"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "after_grn",
                                                children: "After GRN"
                                            })
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($2a79e089817acc78$var$Section, {
                title: $2a79e089817acc78$var$SECTION_TITLES.invoiceType,
                subtitle: "Enable invoice type setup and choose how types are assigned",
                open: openSections.invoiceType,
                onToggle: ()=>toggleSection("invoiceType"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-grid",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2a79e089817acc78$var$ToggleChoice, {
                                label: "Define type of invoice?",
                                value: form.typeOfInvoiceEnabled,
                                onChange: (value)=>updateField("typeOfInvoiceEnabled", value)
                            }),
                            form.typeOfInvoiceEnabled === "Y" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Assignment mode"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: form.typeAssignmentMode,
                                        onChange: (event)=>updateField("typeAssignmentMode", event.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "manual",
                                                children: "Manual"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "automatic",
                                                children: "Automatic"
                                            })
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    form.typeOfInvoiceEnabled === "Y" && form.typeAssignmentMode === "automatic" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-field",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                children: "Automatic type logic"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: form.automaticTypeChoice,
                                onChange: (event)=>updateField("automaticTypeChoice", event.target.value),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "",
                                        children: "Select automatic logic"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "po_grn_mapping",
                                        children: "Map against Open PO / GRN report"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "vendor_master",
                                        children: "Use vendor master type definition"
                                    })
                                ]
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


const $212db93af4368e26$var$MATCH_MODES = [
    "INCLUDE",
    "EXCLUDE",
    "ANY"
];
const $212db93af4368e26$var$APPROVER_OPTIONS = [
    {
        value: "",
        label: "--Select--"
    },
    {
        value: "nasim@gmail.com",
        label: "Nasim"
    },
    {
        value: "chandan@gmail.com",
        label: "Chandan"
    },
    {
        value: "nitin@gmail.com",
        label: "Nitin"
    },
    {
        value: "gaurav@gmail.com",
        label: "Gaurav"
    },
    {
        value: "mayank@gmail.com",
        label: "Mayank"
    }
];
const $212db93af4368e26$var$APPROVER_FIELDS = [
    "approver1",
    "approver2",
    "approver3",
    "approver4",
    "approver5",
    "approver6"
];
function $212db93af4368e26$var$createDraftRow(subconditions) {
    return {
        conditions: Object.fromEntries(subconditions.map((condition)=>[
                condition.key,
                {
                    mode: "INCLUDE",
                    values: []
                }
            ])),
        approver1: "",
        approver2: "",
        approver3: "",
        approver4: "",
        approver5: "",
        approver6: ""
    };
}
function $212db93af4368e26$var$formatConditionCell(cell, conditionLabel = "") {
    if (!cell) return "-";
    const isAmount = String(conditionLabel).trim().toLowerCase() === "amount";
    // --------------------------------
    // Amount
    // --------------------------------
    if (isAmount) {
        const amountValues = cell.values;
        // New format:
        // values: {
        //   lowerLimit: "0",
        //   upperLimit: "500000"
        // }
        if (amountValues && typeof amountValues === "object" && !Array.isArray(amountValues)) {
            const lower = amountValues.lowerLimit ?? "";
            const upper = amountValues.upperLimit ?? "";
            if (lower !== "" || upper !== "") return `${lower !== "" ? lower : "0"}-${upper !== "" ? upper : "\u221E"}`;
        }
        return "-";
    }
    // --------------------------------
    // Normal / Budget conditions
    // --------------------------------
    const modeMap = {
        INCLUDE: "IN",
        EXCLUDE: "EX",
        ANY: "A"
    };
    const mode = modeMap[cell.mode] || cell.mode || "A";
    if (mode === "A") return "A";
    const values = Array.isArray(cell.values) ? cell.values : cell.value != null && cell.value !== "" ? [
        cell.value
    ] : [];
    return `${mode}${values.length ? `: ${values.join(", ")}` : ""}`;
}
function $212db93af4368e26$var$poSubconditionFromApi(condition) {
    return {
        key: condition.conditionKey,
        label: condition.subConditionName || condition.conditionKey,
        values: Array.isArray(condition.availableValues) ? condition.availableValues : []
    };
}
function $212db93af4368e26$export$2e2bcd8739ae039() {
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [subconditions, setSubconditions] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [conditionsLoading, setConditionsLoading] = (0, $acw62.useState)(false);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [statusMessage, setStatusMessage] = (0, $acw62.useState)("");
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)("");
    const [draft, setDraft] = (0, $acw62.useState)($212db93af4368e26$var$createDraftRow([]));
    async function loadRows() {
        setLoading(true);
        setErrorMessage("");
        try {
            const data = await (0, $96e14f2a7c3555e4$export$aab004e0eb724d5b)("po");
            setRows(Array.isArray(data) ? data : []);
        } catch (requestError) {
            setErrorMessage(requestError.message || "Unable to load invoice approval matrix.");
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadRows();
    }, []);
    (0, $acw62.useEffect)(()=>{
        let isActive = true;
        setConditionsLoading(true);
        (0, $96e14f2a7c3555e4$export$eb512712615120e9)().then((data)=>{
            if (!isActive) return;
            const conditions = Array.isArray(data) ? data : data?.conditions || [];
            const nextSubconditions = conditions.slice().sort((left, right)=>left.displayOrder - right.displayOrder).map($212db93af4368e26$var$poSubconditionFromApi);
            setSubconditions(nextSubconditions);
            setDraft($212db93af4368e26$var$createDraftRow(nextSubconditions));
        }).catch((requestError)=>{
            if (isActive) setErrorMessage(requestError.message || "Unable to load configured PO conditions.");
        }).finally(()=>{
            if (isActive) setConditionsLoading(false);
        });
        return ()=>{
            isActive = false;
        };
    }, []);
    function updateDraftCondition(conditionKey, field, value) {
        setDraft((current)=>({
                ...current,
                conditions: {
                    ...current.conditions,
                    [conditionKey]: {
                        ...current.conditions[conditionKey],
                        [field]: value
                    }
                }
            }));
    }
    function updateDraftApprover(field, value) {
        setDraft((current)=>({
                ...current,
                [field]: value
            }));
    }
    async function handleSubmit() {
        setSaving(true);
        setStatusMessage("");
        setErrorMessage("");
        try {
            const cleanedConditions = Object.fromEntries(Object.entries(draft.conditions).map(([key, condition])=>{
                const subcondition = subconditions.find((item)=>item.key === key);
                // -------------------------
                // Amount
                // -------------------------
                if (subcondition?.label === "Amount") return [
                    key,
                    {
                        mode: "INCLUDE",
                        values: {
                            lowerLimit: condition.values?.lowerLimit ?? "",
                            upperLimit: condition.values?.upperLimit ?? ""
                        }
                    }
                ];
                // -------------------------
                // Budget
                // -------------------------
                if (subcondition?.label === "Budget") return [
                    key,
                    {
                        mode: "INCLUDE",
                        values: condition.values || []
                    }
                ];
                // -------------------------
                // Normal conditions
                // -------------------------
                return [
                    key,
                    condition
                ];
            }));
            const payload = {
                matrix_type: "po",
                ...draft,
                conditions: cleanedConditions
            };
            console.log("APPROVAL MATRIX PAYLOAD:", payload);
            const response = await (0, $96e14f2a7c3555e4$export$6bc70d616f171655)(payload);
            setRows(Array.isArray(response?.data) ? response.data : [
                ...rows,
                response.row
            ]);
            setDraft($212db93af4368e26$var$createDraftRow(subconditions));
            setStatusMessage(response?.message || "Invoice approval matrix row saved successfully.");
        } catch (requestError) {
            setErrorMessage(requestError.message || "Unable to save invoice approval matrix row.");
        } finally{
            setSaving(false);
        }
    }
    async function handleRemove(rowId) {
        setStatusMessage("");
        setErrorMessage("");
        try {
            const response = await (0, $96e14f2a7c3555e4$export$728c5e6f0290f179)(rowId);
            setRows(Array.isArray(response?.data) ? response.data : rows.filter((row)=>row.id !== rowId));
            setStatusMessage(response?.message || "Invoice approval matrix row deleted successfully.");
        } catch (requestError) {
            setErrorMessage(requestError.message || "Unable to delete invoice approval matrix row.");
        }
    }
    async function handleUpload(event) {
        const [file] = event.target.files || [];
        if (!file) return;
        setSaving(true);
        setStatusMessage("");
        setErrorMessage("");
        try {
            const response = await (0, $96e14f2a7c3555e4$export$247ba625cb591878)("po", file);
            setRows(Array.isArray(response?.data) ? response.data : rows);
            setStatusMessage(response?.message || "Path table imported successfully.");
        } catch (requestError) {
            setErrorMessage(requestError.message || "Unable to import path table.");
        } finally{
            setSaving(false);
            event.target.value = "";
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "conditions-view conditions-view--approval-matrix",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "workspace-panel conditions-view__hero",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            children: "Approval Matrix_PO"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "config-view__intro",
                            children: "PO invoice approval path setup."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel conditions-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "users-form__header",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "PO Invoices"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Path Table"
                                })
                            ]
                        })
                    }),
                    statusMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-banner config-banner--success",
                        children: statusMessage
                    }) : null,
                    errorMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-banner config-banner--error",
                        children: errorMessage
                    }) : null,
                    !conditionsLoading && !subconditions.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-note",
                        children: "Add PO conditions in Conditions_PO before configuring the approval path table."
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-table conditions-table-wrap",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "approval-matrix-table",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "id"
                                            }),
                                            subconditions.map((condition)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: condition.label
                                                }, condition.key)),
                                            $212db93af4368e26$var$APPROVER_FIELDS.map((field, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: `approver${index + 1}`
                                                }, field)),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Action"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                    children: [
                                        loading || conditionsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                            className: "approval-matrix-input-row",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                colSpan: subconditions.length + $212db93af4368e26$var$APPROVER_FIELDS.length + 2,
                                                children: "Loading path table..."
                                            })
                                        }) : !rows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                colSpan: subconditions.length + $212db93af4368e26$var$APPROVER_FIELDS.length + 2,
                                                children: "No data available for this company, Please Upload Path Table using below Button or insert a row using below input."
                                            })
                                        }) : rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.id
                                                    }),
                                                    subconditions.map((condition)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: $212db93af4368e26$var$formatConditionCell(row.conditions[condition.key], condition.label)
                                                        }, condition.key)),
                                                    $212db93af4368e26$var$APPROVER_FIELDS.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: row[field] || "-"
                                                        }, field)),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: "condition-icon-button condition-icon-button--danger",
                                                            type: "button",
                                                            onClick: ()=>handleRemove(row.id),
                                                            children: "Remove"
                                                        })
                                                    })
                                                ]
                                            }, row.id)),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: rows.length + 1
                                                }),
                                                subconditions.map((condition)=>{
                                                    const cell = draft.conditions[condition.key] || {
                                                        mode: "INCLUDE",
                                                        values: []
                                                    };
                                                    const isBudget = condition.label === "Budget";
                                                    const isAmount = condition.label === "Amount";
                                                    // -------------------------
                                                    // Budget
                                                    // -------------------------
                                                    if (isBudget) {
                                                        const budgetValue = (cell.values || []).join(",");
                                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                className: "approval-matrix-budget-select",
                                                                value: budgetValue,
                                                                onChange: (event)=>{
                                                                    const value = event.target.value;
                                                                    updateDraftCondition(condition.key, "mode", "INCLUDE");
                                                                    updateDraftCondition(condition.key, "values", value ? value.split(",") : []);
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: "",
                                                                        children: "ANY"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: "Y",
                                                                        children: "Y"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: "N",
                                                                        children: "N"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: "Y,N",
                                                                        children: "Y, N"
                                                                    })
                                                                ]
                                                            })
                                                        }, condition.key);
                                                    }
                                                    // -------------------------
                                                    // Amount
                                                    // -------------------------
                                                    if (isAmount) {
                                                        const amountValues = cell.values && !Array.isArray(cell.values) ? cell.values : {
                                                            lowerLimit: "",
                                                            upperLimit: ""
                                                        };
                                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "approval-matrix-amount",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        className: "approval-matrix-amount__input",
                                                                        type: "number",
                                                                        min: "0",
                                                                        step: "0.01",
                                                                        placeholder: "Lower",
                                                                        value: amountValues.lowerLimit ?? "",
                                                                        onChange: (event)=>updateDraftCondition(condition.key, "values", {
                                                                                ...amountValues,
                                                                                lowerLimit: event.target.value
                                                                            })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "approval-matrix-amount__separator",
                                                                        children: "\u2013"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        className: "approval-matrix-amount__input",
                                                                        type: "number",
                                                                        min: "0",
                                                                        step: "0.01",
                                                                        placeholder: "Upper",
                                                                        value: amountValues.upperLimit ?? "",
                                                                        onChange: (event)=>updateDraftCondition(condition.key, "values", {
                                                                                ...amountValues,
                                                                                upperLimit: event.target.value
                                                                            })
                                                                    })
                                                                ]
                                                            })
                                                        }, condition.key);
                                                    }
                                                    // -------------------------
                                                    // Normal conditions
                                                    // -------------------------
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "condition-cell-stack",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                                    className: "approval-matrix-condition-select",
                                                                    value: cell.mode,
                                                                    onChange: (event)=>updateDraftCondition(condition.key, "mode", event.target.value),
                                                                    children: $212db93af4368e26$var$MATCH_MODES.map((mode)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: mode,
                                                                            children: mode
                                                                        }, mode))
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                                                                    className: `approval-matrix-values${cell.mode === "ANY" || !condition.values.length ? " is-disabled" : ""}`,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("summary", {
                                                                            onClick: (event)=>{
                                                                                if (cell.mode === "ANY" || !condition.values.length) event.preventDefault();
                                                                            },
                                                                            children: (cell.values || []).length ? (cell.values || []).join(", ") : condition.values.length ? "--Select--" : "No values configured"
                                                                        }),
                                                                        condition.values.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                            className: "approval-matrix-values__menu",
                                                                            children: condition.values.map((value)=>{
                                                                                const isChecked = (cell.values || []).includes(value);
                                                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                                            type: "checkbox",
                                                                                            checked: isChecked,
                                                                                            disabled: cell.mode === "ANY",
                                                                                            onChange: ()=>updateDraftCondition(condition.key, "values", isChecked ? (cell.values || []).filter((item)=>item !== value) : [
                                                                                                    ...cell.values || [],
                                                                                                    value
                                                                                                ])
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            children: value
                                                                                        })
                                                                                    ]
                                                                                }, value);
                                                                            })
                                                                        }) : null
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }, condition.key);
                                                }),
                                                $212db93af4368e26$var$APPROVER_FIELDS.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                            value: draft[field],
                                                            onChange: (event)=>updateDraftApprover(field, event.target.value),
                                                            children: $212db93af4368e26$var$APPROVER_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: option.value,
                                                                    children: option.label
                                                                }, option.value))
                                                        })
                                                    }, field)),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "primary-button",
                                                        type: "button",
                                                        onClick: handleSubmit,
                                                        disabled: saving || !subconditions.length,
                                                        children: saving ? "Saving..." : "Submit"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "condition-actions-bar",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "ghost-button",
                                htmlFor: "invoice-path-upload-po",
                                children: "Upload Path Table"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                id: "invoice-path-upload-po",
                                type: "file",
                                accept: ".xlsx,.xls,.csv",
                                onChange: handleUpload,
                                hidden: true
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

const $112d6f942c30ce0b$var$MATCH_MODES = [
    "INCLUDE",
    "EXCLUDE",
    "ANY"
];
const $112d6f942c30ce0b$var$APPROVER_FIELDS = [
    "approver1",
    "approver2",
    "approver3",
    "approver4",
    "approver5",
    "approver6"
];
const $112d6f942c30ce0b$var$APPROVER_OPTIONS = [
    {
        value: "",
        label: "--Select--"
    },
    {
        value: "nasim@gmail.com",
        label: "Nasim"
    },
    {
        value: "chandan@gmail.com",
        label: "Chandan"
    },
    {
        value: "nitin@gmail.com",
        label: "Nitin"
    },
    {
        value: "gaurav@gmail.com",
        label: "Gaurav"
    },
    {
        value: "mayank@gmail.com",
        label: "Mayank"
    }
];
function $112d6f942c30ce0b$var$createDraftRow(conditions) {
    return {
        conditions: Object.fromEntries(conditions.map(({ key: key })=>[
                key,
                {
                    mode: "INCLUDE",
                    values: []
                }
            ])),
        ...Object.fromEntries($112d6f942c30ce0b$var$APPROVER_FIELDS.map((field)=>[
                field,
                ""
            ]))
    };
}
function $112d6f942c30ce0b$var$formatConditionCell(cell) {
    if (!cell || cell.mode === "ANY") return "ANY";
    const values = Array.isArray(cell.values) ? cell.values : cell.value ? [
        cell.value
    ] : [];
    return `${cell.mode}${values.length ? `: ${values.join(", ")}` : ""}`;
}
function $112d6f942c30ce0b$export$2e2bcd8739ae039() {
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [conditions, setConditions] = (0, $acw62.useState)([]);
    const [draft, setDraft] = (0, $acw62.useState)($112d6f942c30ce0b$var$createDraftRow([]));
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [conditionsLoading, setConditionsLoading] = (0, $acw62.useState)(true);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [statusMessage, setStatusMessage] = (0, $acw62.useState)("");
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)("");
    async function loadRows() {
        setLoading(true);
        try {
            setRows(await (0, $96e14f2a7c3555e4$export$aab004e0eb724d5b)("non_po"));
        } catch (error) {
            setErrorMessage(error.message || "Unable to load Non-PO approval matrix.");
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadRows();
    }, []);
    (0, $acw62.useEffect)(()=>{
        let active = true;
        (0, $96e14f2a7c3555e4$export$2f4225d126d5377e)().then((data)=>{
            if (!active) return;
            const definitions = (Array.isArray(data) ? data : data?.conditions || []).slice().sort((left, right)=>left.displayOrder - right.displayOrder).map((condition)=>({
                    key: condition.conditionKey,
                    label: condition.subConditionName || condition.conditionKey,
                    values: Array.isArray(condition.availableValues) ? condition.availableValues : []
                }));
            setConditions(definitions);
            setDraft($112d6f942c30ce0b$var$createDraftRow(definitions));
        }).catch((error)=>{
            if (active) setErrorMessage(error.message || "Unable to load configured Non-PO conditions.");
        }).finally(()=>{
            if (active) setConditionsLoading(false);
        });
        return ()=>{
            active = false;
        };
    }, []);
    function updateCondition(key, field, value) {
        setDraft((current)=>({
                ...current,
                conditions: {
                    ...current.conditions,
                    [key]: {
                        ...current.conditions[key],
                        [field]: value
                    }
                }
            }));
    }
    async function submit() {
        setSaving(true);
        setStatusMessage("");
        setErrorMessage("");
        try {
            const response = await (0, $96e14f2a7c3555e4$export$6bc70d616f171655)({
                matrix_type: "non_po",
                ...draft
            });
            setRows(Array.isArray(response?.data) ? response.data : [
                ...rows,
                response.row
            ]);
            setDraft($112d6f942c30ce0b$var$createDraftRow(conditions));
            setStatusMessage(response?.message || "Non-PO approval matrix row saved successfully.");
        } catch (error) {
            setErrorMessage(error.message || "Unable to save Non-PO approval matrix row.");
        } finally{
            setSaving(false);
        }
    }
    async function remove(rowId) {
        setStatusMessage("");
        setErrorMessage("");
        try {
            const response = await (0, $96e14f2a7c3555e4$export$728c5e6f0290f179)(rowId);
            setRows(Array.isArray(response?.data) ? response.data : rows.filter((row)=>row.id !== rowId));
            setStatusMessage(response?.message || "Non-PO approval matrix row deleted successfully.");
        } catch (error) {
            setErrorMessage(error.message || "Unable to delete Non-PO approval matrix row.");
        }
    }
    async function upload(event) {
        const [file] = event.target.files || [];
        if (!file) return;
        setSaving(true);
        setStatusMessage("");
        setErrorMessage("");
        try {
            const response = await (0, $96e14f2a7c3555e4$export$247ba625cb591878)("non_po", file);
            setRows(Array.isArray(response?.data) ? response.data : rows);
            setStatusMessage(response?.message || "Path table imported successfully.");
        } catch (error) {
            setErrorMessage(error.message || "Unable to import Non-PO path table.");
        } finally{
            setSaving(false);
            event.target.value = "";
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "conditions-view conditions-view--approval-matrix",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "workspace-panel conditions-view__hero",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            children: "Approval Matrix_Non-PO"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "config-view__intro",
                            children: "Non-PO invoice approval path setup."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel conditions-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "users-form__header",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Non-PO Invoices"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Path Table"
                                })
                            ]
                        })
                    }),
                    statusMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-banner config-banner--success",
                        children: statusMessage
                    }) : null,
                    errorMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-banner config-banner--error",
                        children: errorMessage
                    }) : null,
                    !conditionsLoading && !conditions.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-note",
                        children: "Add Non-PO conditions in Conditions_Non-PO before configuring the approval path table."
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-table conditions-table-wrap",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "id"
                                            }),
                                            conditions.map((condition)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: condition.label
                                                }, condition.key)),
                                            $112d6f942c30ce0b$var$APPROVER_FIELDS.map((field, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: `approver${index + 1}`
                                                }, field)),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Action"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                    children: [
                                        loading || conditionsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                colSpan: conditions.length + $112d6f942c30ce0b$var$APPROVER_FIELDS.length + 2,
                                                children: "Loading path table..."
                                            })
                                        }) : null,
                                        !loading && !conditionsLoading && !rows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                colSpan: conditions.length + $112d6f942c30ce0b$var$APPROVER_FIELDS.length + 2,
                                                children: "No data available for this company. Add a row below or upload a path table."
                                            })
                                        }) : null,
                                        !loading && !conditionsLoading ? rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.id
                                                    }),
                                                    conditions.map((condition)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: $112d6f942c30ce0b$var$formatConditionCell(row.conditions[condition.key])
                                                        }, condition.key)),
                                                    $112d6f942c30ce0b$var$APPROVER_FIELDS.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: row[field] || "-"
                                                        }, field)),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: "condition-icon-button condition-icon-button--danger",
                                                            type: "button",
                                                            onClick: ()=>remove(row.id),
                                                            children: "Remove"
                                                        })
                                                    })
                                                ]
                                            }, row.id)) : null,
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: rows.length + 1
                                                }),
                                                conditions.map((condition)=>{
                                                    const cell = draft.conditions[condition.key] || {
                                                        mode: "INCLUDE",
                                                        values: []
                                                    };
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "condition-cell-stack",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                                    value: cell.mode,
                                                                    onChange: (event)=>updateCondition(condition.key, "mode", event.target.value),
                                                                    children: $112d6f942c30ce0b$var$MATCH_MODES.map((mode)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: mode,
                                                                            children: mode
                                                                        }, mode))
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                                                                    className: `approval-matrix-values${cell.mode === "ANY" || !condition.values.length ? " is-disabled" : ""}`,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("summary", {
                                                                            onClick: (event)=>{
                                                                                if (cell.mode === "ANY" || !condition.values.length) event.preventDefault();
                                                                            },
                                                                            children: cell.values.length ? cell.values.join(", ") : condition.values.length ? "--Select--" : "No values configured"
                                                                        }),
                                                                        condition.values.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                            className: "approval-matrix-values__menu",
                                                                            children: condition.values.map((value)=>{
                                                                                const checked = cell.values.includes(value);
                                                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                                            type: "checkbox",
                                                                                            checked: checked,
                                                                                            disabled: cell.mode === "ANY",
                                                                                            onChange: ()=>updateCondition(condition.key, "values", checked ? cell.values.filter((item)=>item !== value) : [
                                                                                                    ...cell.values,
                                                                                                    value
                                                                                                ])
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            children: value
                                                                                        })
                                                                                    ]
                                                                                }, value);
                                                                            })
                                                                        }) : null
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }, condition.key);
                                                }),
                                                $112d6f942c30ce0b$var$APPROVER_FIELDS.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                            value: draft[field],
                                                            onChange: (event)=>setDraft((current)=>({
                                                                        ...current,
                                                                        [field]: event.target.value
                                                                    })),
                                                            children: $112d6f942c30ce0b$var$APPROVER_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: option.value,
                                                                    children: option.label
                                                                }, option.value))
                                                        })
                                                    }, field)),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "primary-button",
                                                        type: "button",
                                                        onClick: submit,
                                                        disabled: saving || !conditions.length,
                                                        children: saving ? "Saving..." : "Submit"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "condition-actions-bar",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "ghost-button",
                                htmlFor: "invoice-path-upload-non-po",
                                children: "Upload Path Table"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                id: "invoice-path-upload-non-po",
                                type: "file",
                                accept: ".xlsx,.xls,.csv",
                                onChange: upload,
                                hidden: true
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

function $a49817af4af6f6e4$export$2e2bcd8739ae039() {
    const [poTypeName, setPoTypeName] = (0, $acw62.useState)("");
    const [poTypeDescription, setPoTypeDescription] = (0, $acw62.useState)("");
    const [existingPOs, setExistingPOs] = (0, $acw62.useState)([]);
    const [poTypeLoading, setPoTypeLoading] = (0, $acw62.useState)(false);
    const [poTypeSaving, setPoTypeSaving] = (0, $acw62.useState)(false);
    const [poTypeStatus, setPoTypeStatus] = (0, $acw62.useState)("");
    const [poTypeError, setPoTypeError] = (0, $acw62.useState)("");
    async function loadInvoiceTypes() {
        setPoTypeLoading(true);
        setPoTypeError("");
        try {
            const response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/invoice-types/");
            setExistingPOs(Array.isArray(response?.data) ? response.data : []);
        } catch (requestError) {
            setPoTypeError(requestError.message || "Unable to load invoice types.");
        } finally{
            setPoTypeLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadInvoiceTypes();
    }, []);
    async function handlePoTypeSubmit(event) {
        event.preventDefault();
        const name = poTypeName.trim();
        const description = poTypeDescription.trim();
        if (!name || !description) return;
        setPoTypeSaving(true);
        setPoTypeStatus("");
        setPoTypeError("");
        try {
            const response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/invoice-types/", {
                method: "POST",
                body: {
                    name: name,
                    description: description
                }
            });
            setExistingPOs(Array.isArray(response?.data) ? response.data : []);
            setPoTypeStatus(response?.message || "Invoice type saved successfully.");
            setPoTypeName("");
            setPoTypeDescription("");
        } catch (requestError) {
            setPoTypeError(requestError.message || "Unable to save invoice type.");
        } finally{
            setPoTypeSaving(false);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "teams-view teams-view--invoice-types",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel teams-view__hero",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            children: "Invoice Type Management"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "teams-view__summary",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "teams-view__summary-count",
                                children: existingPOs.length
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "teams-view__summary-label",
                                children: "invoice types configured"
                            })
                        ]
                    })
                ]
            }),
            poTypeStatus ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: poTypeStatus
            }) : null,
            poTypeError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: poTypeError
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "teams-layout",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        className: "workspace-panel teams-form",
                        onSubmit: handlePoTypeSubmit,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "users-form__header",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "eyebrow",
                                            children: "Create Invoice Type"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            children: "Add a new invoice type"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Invoice Type Name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: poTypeName,
                                        onChange: (event)=>setPoTypeName(event.target.value),
                                        placeholder: "e.g. Finance, Material, Operations",
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Description"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                        value: poTypeDescription,
                                        onChange: (event)=>setPoTypeDescription(event.target.value),
                                        placeholder: "Enter description for this invoice type",
                                        rows: 4,
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary-button",
                                type: "submit",
                                disabled: poTypeSaving,
                                children: poTypeSaving ? "Saving..." : "Submit"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "workspace-panel",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "teams-table__header",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "eyebrow",
                                            children: "Directory"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            children: "Existing Invoice Types"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-table",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Invoice Type Name"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Description"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: poTypeLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    colSpan: "2",
                                                    style: {
                                                        textAlign: "center",
                                                        color: "#999"
                                                    },
                                                    children: "Loading invoice types..."
                                                })
                                            }) : existingPOs.length ? existingPOs.map((po, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: po.name
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: po.description
                                                        })
                                                    ]
                                                }, `${po.name}-${index}`)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    colSpan: "2",
                                                    style: {
                                                        textAlign: "center",
                                                        color: "#999"
                                                    },
                                                    children: "No invoice types added yet."
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

const $7cdd700349585511$var$DEFAULT_INVOICE_CONFIGURATION = {
    invoiceModule: "Both",
    emailNotifications: "N",
    vendorSPOCEmail: "",
    materialApprovalStage: "before_grn",
    serviceApprovalStage: "before_grn",
    typeOfInvoiceEnabled: "Y",
    typeAssignmentMode: "manual",
    automaticTypeChoice: "",
    checklistEnabled: "Y"
};
function $7cdd700349585511$var$parseChecklistItems(rawValue) {
    return rawValue.split(",").map((item)=>item.trim()).filter(Boolean);
}
function $7cdd700349585511$export$2e2bcd8739ae039() {
    const [activeTab, setActiveTab] = (0, $acw62.useState)("add_checklist");
    const [invoiceTypes, setInvoiceTypes] = (0, $acw62.useState)([]);
    const [loadingInvoiceTypes, setLoadingInvoiceTypes] = (0, $acw62.useState)(false);
    const [invoiceTypeError, setInvoiceTypeError] = (0, $acw62.useState)("");
    const [checklists, setChecklists] = (0, $acw62.useState)([]);
    const [loadingChecklists, setLoadingChecklists] = (0, $acw62.useState)(false);
    const [selectedDocumentType, setSelectedDocumentType] = (0, $acw62.useState)("");
    const [checklistItemsRaw, setChecklistItemsRaw] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [savingChecklist, setSavingChecklist] = (0, $acw62.useState)(false);
    const [invoiceConfiguration, setInvoiceConfiguration] = (0, $acw62.useState)($7cdd700349585511$var$DEFAULT_INVOICE_CONFIGURATION);
    const [loadingChecklistConfiguration, setLoadingChecklistConfiguration] = (0, $acw62.useState)(true);
    const [savingChecklistConfiguration, setSavingChecklistConfiguration] = (0, $acw62.useState)(false);
    const [approverDocumentType, setApproverDocumentType] = (0, $acw62.useState)("");
    const [approverSelections, setApproverSelections] = (0, $acw62.useState)({});
    // Load invoice types on mount
    (0, $acw62.useEffect)(()=>{
        setLoadingInvoiceTypes(true);
        setInvoiceTypeError("");
        (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/invoice-types/").then((response)=>{
            const invoiceTypeRows = Array.isArray(response?.data) ? response.data : [];
            const names = invoiceTypeRows.map((row)=>(row?.name || "").trim()).filter(Boolean);
            setInvoiceTypes(names);
        }).catch((requestError)=>{
            setInvoiceTypeError(requestError.message || "Unable to load invoice types.");
        }).finally(()=>{
            setLoadingInvoiceTypes(false);
        });
    }, []);
    // Load checklists on mount
    (0, $acw62.useEffect)(()=>{
        loadChecklists();
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!status) return undefined;
        const timer = window.setTimeout(()=>setStatus(""), 3500);
        return ()=>window.clearTimeout(timer);
    }, [
        status
    ]);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/invoice-configuration/").then((response)=>{
            if (!cancelled && response?.status === "success" && response.data) setInvoiceConfiguration((current)=>({
                    ...current,
                    ...response.data
                }));
        }).catch((requestError)=>{
            if (!cancelled) setError(requestError.message || "Unable to load checklist configuration.");
        }).finally(()=>{
            if (!cancelled) setLoadingChecklistConfiguration(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, []);
    function loadChecklists() {
        setLoadingChecklists(true);
        (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/checklists/").then((response)=>{
            const checklistData = Array.isArray(response?.data) ? response.data : [];
            setChecklists(checklistData);
        }).catch((requestError)=>{
            console.error("Error loading checklists:", requestError);
            setChecklists([]);
        }).finally(()=>{
            setLoadingChecklists(false);
        });
    }
    const aggregatedRows = (0, $acw62.useMemo)(()=>checklists, [
        checklists
    ]);
    const checklistsEnabled = invoiceConfiguration.checklistEnabled !== "N";
    async function handleChecklistEnabledChange(value) {
        const nextConfiguration = {
            ...invoiceConfiguration,
            checklistEnabled: value
        };
        setInvoiceConfiguration(nextConfiguration);
        setSavingChecklistConfiguration(true);
        setError("");
        setStatus("");
        try {
            const response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/invoice-configuration/save/", {
                method: "POST",
                body: nextConfiguration
            });
            setInvoiceConfiguration((current)=>({
                    ...current,
                    ...response?.data || {}
                }));
            setStatus(response?.message || "Checklist configuration updated.");
        } catch (requestError) {
            setInvoiceConfiguration(invoiceConfiguration);
            setError(requestError.message || "Unable to update checklist configuration.");
        } finally{
            setSavingChecklistConfiguration(false);
        }
    }
    // Get items for selected approver document type
    const approverRows = (0, $acw62.useMemo)(()=>{
        const checklist = checklists.find((c)=>c.invoice_type_name === approverDocumentType);
        if (!checklist || !Array.isArray(checklist.items)) return [];
        return checklist.items.map((item, index)=>({
                id: `${checklist.id}-${index}`,
                checklistItem: item
            }));
    }, [
        checklists,
        approverDocumentType
    ]);
    function loadApproverSelectionsForType(documentType) {
        if (!documentType) {
            setApproverSelections({});
            return;
        }
        const checklist = checklists.find((c)=>c.invoice_type_name === documentType);
        if (!checklist) {
            setApproverSelections({});
            return;
        }
        const invoiceTypeId = checklist.id;
        const checklistItems = Array.isArray(checklist.items) ? checklist.items : [];
        (0, $96e14f2a7c3555e4$export$52e83573e7782585)(`/checklists/${invoiceTypeId}/`).then((response)=>{
            const savedSelections = response?.data?.approver_selections || {};
            const nextSelections = {};
            for(let approverNum = 1; approverNum <= 6; approverNum++){
                const approverKey = `approver${approverNum}`;
                const selectedItems = Array.isArray(savedSelections[approverKey]) ? savedSelections[approverKey] : [];
                checklistItems.forEach((item, itemIndex)=>{
                    const rowId = `${invoiceTypeId}-${itemIndex}`;
                    const checkboxKey = `${rowId}-approver-${approverNum}`;
                    nextSelections[checkboxKey] = selectedItems.includes(item);
                });
            }
            setApproverSelections(nextSelections);
        }).catch(()=>{
            setApproverSelections({});
        });
    }
    function handleSubmitChecklist(event) {
        event.preventDefault();
        if (!checklistsEnabled) return;
        const documentType = selectedDocumentType.trim();
        const parsedItems = $7cdd700349585511$var$parseChecklistItems(checklistItemsRaw);
        if (!documentType) {
            setError("Please select a document type.");
            setStatus("");
            return;
        }
        if (!parsedItems.length) {
            setError("Please enter at least one checklist item.");
            setStatus("");
            return;
        }
        setError("");
        setStatus("");
        setSavingChecklist(true);
        (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/checklists/", {
            method: "POST",
            body: {
                invoice_type_name: documentType,
                items: parsedItems
            }
        }).then((response)=>{
            setStatus(response?.message || "Checklist items saved successfully.");
            setChecklistItemsRaw("");
            setSelectedDocumentType("");
            loadChecklists();
        }).catch((requestError)=>{
            setError(requestError.message || "Unable to save checklist.");
        }).finally(()=>{
            setSavingChecklist(false);
        });
    }
    function getApproverSelectionValue(rowId, approverIndex) {
        return approverSelections[`${rowId}-approver-${approverIndex}`] || false;
    }
    function toggleApproverSelection(rowId, approverIndex) {
        setApproverSelections((current)=>{
            const key = `${rowId}-approver-${approverIndex}`;
            return {
                ...current,
                [key]: !current[key]
            };
        });
    }
    function handleSubmitApproverChecklist() {
        if (!approverDocumentType) {
            setError("Please select a document type.");
            setStatus("");
            return;
        }
        // Find the checklist and invoice_type_id for the selected document type
        const checklist = checklists.find((c)=>c.invoice_type_name === approverDocumentType);
        if (!checklist) {
            setError("Document type not found.");
            setStatus("");
            return;
        }
        const invoiceTypeId = checklist.id;
        const checklistItems = checklist.items || [];
        // Build approver_selections from checkbox state
        // approverSelections is keyed like: "${rowId}-approver-${approverIndex}" -> boolean
        // We need to convert it to: { approver1: ["item1", "item3"], approver2: [...], ... }
        const approverSelectionsPayload = {};
        for(let approverNum = 1; approverNum <= 6; approverNum++){
            const selectedItems = [];
            checklistItems.forEach((item, itemIndex)=>{
                const rowId = `${invoiceTypeId}-${itemIndex}`;
                const checkboxKey = `${rowId}-approver-${approverNum}`;
                if (approverSelections[checkboxKey]) selectedItems.push(item);
            });
            approverSelectionsPayload[`approver${approverNum}`] = selectedItems;
        }
        setError("");
        setStatus("");
        (0, $96e14f2a7c3555e4$export$52e83573e7782585)(`/checklists/${invoiceTypeId}/`, {
            method: "POST",
            body: {
                approver_selections: approverSelectionsPayload
            }
        }).then((response)=>{
            setStatus(response?.message || `Approver checklist saved for ${approverDocumentType}.`);
            loadApproverSelectionsForType(approverDocumentType);
        }).catch((requestError)=>{
            setError(requestError.message || "Unable to save approver checklist.");
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "teams-view teams-view--checklists",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel teams-view__hero",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            children: "Invoice Approval Checklists"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        className: "config-field checklist-enabled-control",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Checklist Enabled"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: invoiceConfiguration.checklistEnabled,
                                onChange: (event)=>handleChecklistEnabledChange(event.target.value),
                                disabled: loadingChecklistConfiguration || savingChecklistConfiguration,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "Y",
                                        children: "Yes"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "N",
                                        children: "No"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "teams-view__summary",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "teams-view__summary-count",
                                children: checklists.length
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "teams-view__summary-label",
                                children: "document types with checklists"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel checklist-tabs",
                role: "tablist",
                "aria-label": "Checklist options",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: `ghost-button checklist-tabs__button${activeTab === "add_checklist" ? " is-active" : ""}`,
                        onClick: ()=>setActiveTab("add_checklist"),
                        children: "Add Checklist"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: `ghost-button checklist-tabs__button${activeTab === "approver_checklist" ? " is-active" : ""}`,
                        onClick: ()=>setActiveTab("approver_checklist"),
                        children: "Approvers Checklist"
                    })
                ]
            }),
            invoiceTypeError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: invoiceTypeError
            }) : null,
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            activeTab === "add_checklist" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "teams-layout",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        className: `workspace-panel teams-form${checklistsEnabled ? "" : " checklist-creation--disabled"}`,
                        onSubmit: handleSubmitChecklist,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "users-form__header",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "eyebrow",
                                            children: "Add Checklist"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            children: "Create checklist by document type"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Select Document Type"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: selectedDocumentType,
                                        onChange: (event)=>setSelectedDocumentType(event.target.value),
                                        disabled: !checklistsEnabled || loadingInvoiceTypes,
                                        required: true,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Select document type"
                                            }),
                                            invoiceTypes.map((documentType)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: documentType,
                                                    children: documentType
                                                }, documentType))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Checklist Items (comma-separated)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                        value: checklistItemsRaw,
                                        onChange: (event)=>setChecklistItemsRaw(event.target.value),
                                        placeholder: "Invoice Number Match, GST Check, Amount Validation",
                                        rows: 4,
                                        disabled: !checklistsEnabled,
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary-button",
                                type: "submit",
                                disabled: !checklistsEnabled || savingChecklist || loadingInvoiceTypes,
                                children: savingChecklist ? "Saving..." : "Submit"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "workspace-panel",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "teams-table__header",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "eyebrow",
                                            children: "Added Checklists"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            children: "Checklist Directory"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-table",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Document Type"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Checklist Items"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: loadingChecklists ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    colSpan: "2",
                                                    style: {
                                                        textAlign: "center",
                                                        color: "#999"
                                                    },
                                                    children: "Loading checklists..."
                                                })
                                            }) : !aggregatedRows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    colSpan: "2",
                                                    style: {
                                                        textAlign: "center",
                                                        color: "#999"
                                                    },
                                                    children: "No checklist items added yet."
                                                })
                                            }) : aggregatedRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: row.invoice_type_name
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: row.items_joined
                                                        })
                                                    ]
                                                }, row.id))
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "users-form__header",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Approvers Checklist"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Set approver ticks by document type"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        className: "config-field checklist-approver-selector",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Select Document Type"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: approverDocumentType,
                                onChange: (event)=>{
                                    const nextType = event.target.value;
                                    setApproverDocumentType(nextType);
                                    loadApproverSelectionsForType(nextType);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "",
                                        children: "Select document type"
                                    }),
                                    invoiceTypes.map((documentType)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: documentType,
                                            children: documentType
                                        }, documentType))
                                ]
                            })
                        ]
                    }),
                    approverDocumentType ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-table",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Checklist Item"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Approver 1"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Approver 2"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Approver 3"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Approver 4"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Approver 5"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: !approverRows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    colSpan: "6",
                                                    style: {
                                                        textAlign: "center",
                                                        color: "#999"
                                                    },
                                                    children: "No checklist items found for this document type."
                                                })
                                            }) : approverRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: row.checklistItem
                                                        }),
                                                        [
                                                            1,
                                                            2,
                                                            3,
                                                            4,
                                                            5
                                                        ].map((approverIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    type: "checkbox",
                                                                    className: "checklist-approver-checkbox",
                                                                    checked: getApproverSelectionValue(row.id, approverIndex),
                                                                    onChange: ()=>toggleApproverSelection(row.id, approverIndex),
                                                                    "aria-label": `Approver ${approverIndex} for ${row.checklistItem}`
                                                                })
                                                            }, `${row.id}-${approverIndex}`))
                                                    ]
                                                }, row.id))
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "checklist-approver-actions",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "primary-button",
                                    onClick: handleSubmitApproverChecklist,
                                    children: "Submit"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "config-note",
                        children: "Select a document type to view checklist rows and approver options."
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


const $33ce55fb1d9e7a2a$var$CONDITION_TYPE_OPTIONS = [
    "Content",
    "Custom",
    "Expression",
    "Budget",
    "Amount"
];
const $33ce55fb1d9e7a2a$var$CUSTOM_MODE_OPTIONS = [
    {
        value: "Range",
        label: "Range"
    },
    {
        value: "Contains",
        label: "Contains"
    },
    {
        value: "Not Contains",
        label: "Not Contains"
    },
    {
        value: "Starts With",
        label: "Starts With"
    },
    {
        value: "Ends With",
        label: "Ends With"
    }
];
const $33ce55fb1d9e7a2a$var$CONDITION_OPTIONS = Array.from({
    length: 8
}, (_, index)=>`condition${index + 1}`);
const $33ce55fb1d9e7a2a$var$MAPPING_BASED_MODES = new Set([]);
function $33ce55fb1d9e7a2a$var$getColumnHeaderOptions(source, columnHeaderOptions) {
    return columnHeaderOptions[source] || [];
}
function $33ce55fb1d9e7a2a$var$createEmptyCondition(index) {
    return {
        id: `condition-${Date.now()}-${index}`,
        condition: $33ce55fb1d9e7a2a$var$CONDITION_OPTIONS[index] || `condition${index + 1}`,
        subConditionName: "",
        conditionType: "Content",
        isMapped: false,
        customMode: "Range",
        customMapping: "",
        customValue: "",
        customRangeFrom: "",
        customRangeTo: "",
        expression: "",
        columnName: "",
        range: "",
        source: "PO",
        isEditing: false
    };
}
function $33ce55fb1d9e7a2a$var$createEmptyCustomMapping() {
    return {
        id: "",
        customConditionId: "",
        rangeFrom: "",
        rangeTo: "",
        conditionValue: "",
        matchValues: "",
        approvalPath: "",
        uploadFileName: ""
    };
}
function $33ce55fb1d9e7a2a$var$getConditionLabel(row) {
    if (!row) return "";
    return `${row.condition} - ${row.subConditionName || "Unnamed custom condition"}`;
}
function $33ce55fb1d9e7a2a$var$conditionFromApi(condition) {
    return {
        id: condition.id,
        condition: condition.conditionKey,
        subConditionName: condition.subConditionName || "",
        conditionType: condition.conditionType || "Content",
        isMapped: Boolean(condition.isMapped),
        customMode: condition.customMode || "Range",
        customMapping: "",
        customValue: "",
        customRangeFrom: condition.customRangeFrom || "",
        customRangeTo: condition.customRangeTo || "",
        expression: condition.expression || "",
        columnName: condition.columnName || "",
        range: "",
        source: condition.source || "PO",
        displayOrder: condition.displayOrder,
        customMappings: condition.customMappings || [],
        isEditing: false
    };
}
function $33ce55fb1d9e7a2a$var$mappingFromApi(mapping, condition) {
    return {
        id: mapping.id,
        customConditionId: condition.id,
        condition: condition.condition,
        subConditionName: condition.subConditionName,
        customMode: condition.customMode,
        conditionType: condition.conditionType,
        isMapped: condition.isMapped,
        rangeFrom: mapping.rangeFrom || condition.customRangeFrom || "",
        rangeTo: mapping.rangeTo || condition.customRangeTo || "",
        conditionValue: mapping.conditionValues || mapping.approvalPathReference || "",
        matchValues: Array.isArray(mapping.matchValues) ? mapping.matchValues.join(", ") : "",
        approvalPath: mapping.conditionValues || mapping.approvalPathReference || "",
        uploadFileName: mapping.sourceFileName || "",
        source: condition.source,
        columnName: condition.columnName,
        displayOrder: mapping.displayOrder
    };
}
function $33ce55fb1d9e7a2a$var$ConditionRow({ row: row, index: index, columnHeaderOptions: columnHeaderOptions, onChange: onChange, onRemoveRow: onRemoveRow, onToggleEdit: onToggleEdit, canRemove: canRemove, onOpenCustom: onOpenCustom }) {
    const isCustomRow = row.conditionType === "Custom";
    const isExpressionRow = row.conditionType === "Expression";
    const rowHeaderOptions = $33ce55fb1d9e7a2a$var$getColumnHeaderOptions(row.source, columnHeaderOptions);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                children: row.isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                    value: row.condition,
                    onChange: (event)=>onChange(row.id, "condition", event.target.value),
                    children: $33ce55fb1d9e7a2a$var$CONDITION_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: option,
                            children: option
                        }, option))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: row.condition || "\u2014"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                children: row.isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "text",
                    value: row.subConditionName,
                    onChange: (event)=>onChange(row.id, "subConditionName", event.target.value),
                    placeholder: "Sub condition name"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: row.subConditionName || "\u2014"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                children: [
                    row.isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                        value: row.conditionType,
                        onChange: (event)=>{
                            const nextType = event.target.value;
                            onChange(row.id, "conditionType", nextType);
                            if (nextType !== "Custom") {
                                onChange(row.id, "customValue", "");
                                onChange(row.id, "customMapping", "");
                                onChange(row.id, "customRangeFrom", "");
                                onChange(row.id, "customRangeTo", "");
                            }
                        },
                        children: $33ce55fb1d9e7a2a$var$CONDITION_TYPE_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: option,
                                children: option
                            }, option))
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: row.conditionType
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "condition-row__hint",
                        children: [
                            "Row ",
                            index + 1
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                children: row.isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                    value: row.source,
                    onChange: (event)=>{
                        onChange(row.id, "source", event.target.value);
                        onChange(row.id, "columnName", "");
                    },
                    children: Object.keys(columnHeaderOptions).map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: option,
                            children: option
                        }, option))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: row.source
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                children: row.isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                    value: row.columnName,
                    onChange: (event)=>onChange(row.id, "columnName", event.target.value),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: "",
                            children: "Select header"
                        }),
                        rowHeaderOptions.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: option,
                                children: option
                            }, option))
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: row.columnName || "\u2014"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                children: row.isEditing && isCustomRow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "condition-cell-stack",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                            value: row.customMode,
                            onChange: (event)=>onChange(row.id, "customMode", event.target.value),
                            children: $33ce55fb1d9e7a2a$var$CUSTOM_MODE_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: option.value,
                                    children: option.label
                                }, option.value))
                        }),
                        row.customMode === "Range" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "condition-range-inline",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "condition-range-field",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: row.customRangeFrom,
                                        onChange: (event)=>onChange(row.id, "customRangeFrom", event.target.value),
                                        placeholder: "Start position"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "condition-range-field",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: row.customRangeTo,
                                        onChange: (event)=>onChange(row.id, "customRangeTo", event.target.value),
                                        placeholder: "End position"
                                    })
                                })
                            ]
                        }) : null
                    ]
                }) : row.isEditing && isExpressionRow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "text",
                    value: row.expression,
                    onChange: (event)=>onChange(row.id, "expression", event.target.value),
                    placeholder: ">= 100000"
                }) : isCustomRow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "condition-cell-stack",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Mode:"
                                }),
                                " ",
                                row.customMode
                            ]
                        }),
                        row.customMode === "Range" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Range:"
                                }),
                                " ",
                                (row.customRangeFrom || "\u2014") + " to " + (row.customRangeTo || "\u2014")
                            ]
                        }) : $33ce55fb1d9e7a2a$var$MAPPING_BASED_MODES.has(row.customMode) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Mapping:"
                                }),
                                " ",
                                row.customMapping || "\u2014"
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Value:"
                                }),
                                " ",
                                row.customValue || "\u2014"
                            ]
                        })
                    ]
                }) : isExpressionRow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: row.expression || "\u2014"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    style: {
                        color: "#999"
                    },
                    children: "\u2014"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "condition-row__actions",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "condition-icon-button",
                            onClick: ()=>onToggleEdit(row.id),
                            "aria-label": row.isEditing ? "Save condition row" : "Edit condition row",
                            children: row.isEditing ? "Save" : "Edit"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "condition-icon-button condition-icon-button--danger",
                            onClick: ()=>onRemoveRow(row.id),
                            "aria-label": "Remove condition row",
                            children: "Remove"
                        })
                    ]
                })
            })
        ]
    });
}
function $33ce55fb1d9e7a2a$var$groupMappingsForDisplay(mappings) {
    const groups = new Map();
    mappings.forEach((mapping)=>{
        const key = String(mapping.customConditionId);
        if (!groups.has(key)) groups.set(key, {
            customConditionId: mapping.customConditionId,
            condition: mapping.condition,
            subConditionName: mapping.subConditionName,
            conditionType: mapping.conditionType,
            isMapped: mapping.isMapped,
            source: mapping.source,
            columnName: mapping.columnName,
            mappings: []
        });
        groups.get(key).mappings.push(mapping);
    });
    return Array.from(groups.values());
}
function $33ce55fb1d9e7a2a$export$2e2bcd8739ae039() {
    const [activeTab, setActiveTab] = (0, $acw62.useState)("main");
    const [draftCondition, setDraftCondition] = (0, $acw62.useState)($33ce55fb1d9e7a2a$var$createEmptyCondition(0));
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [draftMapping, setDraftMapping] = (0, $acw62.useState)($33ce55fb1d9e7a2a$var$createEmptyCustomMapping());
    const [customMappings, setCustomMappings] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    const [isSaving, setIsSaving] = (0, $acw62.useState)(false);
    const [statusMessage, setStatusMessage] = (0, $acw62.useState)("");
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)("");
    const [columnHeaderOptions, setColumnHeaderOptions] = (0, $acw62.useState)({
        PO: [],
        GRN: []
    });
    const [budgetAvailable, setBudgetAvailable] = (0, $acw62.useState)(false);
    const draftHeaderOptions = $33ce55fb1d9e7a2a$var$getColumnHeaderOptions(draftCondition.source, columnHeaderOptions);
    const mappableConditionRows = rows.filter((row)=>row.conditionType !== "Expression");
    const selectedCustomCondition = mappableConditionRows.find((row)=>String(row.id) === String(draftMapping.customConditionId));
    const isNonRangeCustomMapping = selectedCustomCondition?.conditionType === "Custom" && selectedCustomCondition?.customMode !== "Range";
    const groupedMappings = $33ce55fb1d9e7a2a$var$groupMappingsForDisplay(customMappings);
    function applyApiData(payload) {
        const conditions = Array.isArray(payload) ? payload : payload?.conditions || [];
        const headers = payload?.headers || {};
        // Backend is the source of truth.
        // This now supports PO, GRN and any number of
        // AdditionalReportsInfo sources.
        setColumnHeaderOptions(headers);
        const nextRows = conditions.map($33ce55fb1d9e7a2a$var$conditionFromApi);
        setRows(nextRows);
        setCustomMappings(nextRows.flatMap((condition)=>condition.customMappings.map((mapping)=>$33ce55fb1d9e7a2a$var$mappingFromApi(mapping, condition))));
    }
    function nextAvailableCondition(currentRows) {
        const used = new Set(currentRows.map((row)=>row.condition));
        const condition = $33ce55fb1d9e7a2a$var$CONDITION_OPTIONS.find((option)=>!used.has(option));
        return condition || "";
    }
    function conditionPayload(row) {
        const displayOrder = $33ce55fb1d9e7a2a$var$CONDITION_OPTIONS.indexOf(row.condition) + 1;
        return {
            ...Number.isInteger(row.id) ? {
                id: row.id
            } : {},
            conditionKey: row.condition,
            subConditionName: row.subConditionName,
            conditionType: row.conditionType,
            isMapped: row.conditionType === "Content" ? row.isMapped : false,
            customMode: row.customMode,
            customRangeFrom: row.customRangeFrom,
            customRangeTo: row.customRangeTo,
            expression: row.expression,
            source: row.source,
            columnName: row.columnName,
            displayOrder: displayOrder
        };
    }
    (0, $acw62.useEffect)(()=>{
        let isActive = true;
        async function loadConditions() {
            try {
                const data = await (0, $96e14f2a7c3555e4$export$eb512712615120e9)();
                setBudgetAvailable(Boolean(data.budget));
                console.log("Fetched PO conditions:", data);
                if (isActive) {
                    applyApiData(data);
                    //const loadedRows = data.map(conditionFromApi);
                    const conditions = Array.isArray(data) ? data : data?.conditions || [];
                    //const loadedRows = data.map(conditionFromApi);
                    const nextCondition = nextAvailableCondition(conditions.map($33ce55fb1d9e7a2a$var$conditionFromApi));
                    setDraftCondition((current)=>({
                            ...current,
                            condition: nextCondition || "condition1"
                        }));
                }
            } catch (error) {
                if (isActive) setErrorMessage(error.message || "Unable to load PO conditions.");
            } finally{
                if (isActive) setIsLoading(false);
            }
        }
        loadConditions();
        return ()=>{
            isActive = false;
        };
    }, []);
    function updateDraft(field, value) {
        setDraftCondition((current)=>({
                ...current,
                [field]: value
            }));
    }
    async function addDraftToTable() {
        setIsSaving(true);
        setErrorMessage("");
        setStatusMessage("");
        try {
            const response = await (0, $96e14f2a7c3555e4$export$651266238c1d31a6)(conditionPayload(draftCondition));
            applyApiData(response.data);
            const conditions = Array.isArray(response.data) ? response.data : response.data?.conditions || [];
            const nextCondition = nextAvailableCondition(conditions.map($33ce55fb1d9e7a2a$var$conditionFromApi));
            setDraftCondition({
                ...$33ce55fb1d9e7a2a$var$createEmptyCondition(conditions.length),
                condition: nextCondition || "condition1",
                source: draftCondition.source || "PO"
            });
            setStatusMessage(response.message || "PO condition saved successfully.");
        } catch (error) {
            setErrorMessage(error.message || "Unable to save PO condition.");
        } finally{
            setIsSaving(false);
        }
    }
    function updateRow(rowId, field, value) {
        setRows((current)=>current.map((row)=>row.id === rowId ? {
                    ...row,
                    [field]: value
                } : row));
    }
    async function toggleRowEdit(rowId) {
        const row = rows.find((item)=>item.id === rowId);
        if (!row) return;
        if (!row.isEditing) {
            setRows((current)=>current.map((item)=>item.id === rowId ? {
                        ...item,
                        isEditing: true
                    } : item));
            return;
        }
        setIsSaving(true);
        setErrorMessage("");
        setStatusMessage("");
        try {
            const response = await (0, $96e14f2a7c3555e4$export$651266238c1d31a6)(conditionPayload(row));
            applyApiData(response.data);
            setStatusMessage(response.message || "PO condition saved successfully.");
        } catch (error) {
            setErrorMessage(error.message || "Unable to save PO condition.");
        } finally{
            setIsSaving(false);
        }
    }
    async function removeRow(rowId) {
        if (!Number.isInteger(rowId)) {
            setRows((current)=>current.filter((row)=>row.id !== rowId));
            return;
        }
        setIsSaving(true);
        setErrorMessage("");
        setStatusMessage("");
        try {
            const response = await (0, $96e14f2a7c3555e4$export$3f9a16e716514553)(rowId);
            applyApiData(response.data);
            setDraftMapping((current)=>String(current.customConditionId) === String(rowId) ? $33ce55fb1d9e7a2a$var$createEmptyCustomMapping() : current);
            setStatusMessage(response.message || "PO condition deleted successfully.");
        } catch (error) {
            setErrorMessage(error.message || "Unable to delete PO condition.");
        } finally{
            setIsSaving(false);
        }
    }
    function updateDraftMapping(field, value) {
        setDraftMapping((current)=>({
                ...current,
                [field]: value
            }));
    }
    async function addDraftMappingToTable() {
        if (!selectedCustomCondition) return;
        const conditionValue = String(draftMapping.conditionValue || "").trim();
        const matchValues = String(draftMapping.matchValues || "").trim();
        if (!conditionValue) {
            setErrorMessage("Condition Value is required.");
            return;
        }
        const mappingRequired = selectedCustomCondition.conditionType === "Custom" || selectedCustomCondition.conditionType === "Content" && selectedCustomCondition.isMapped;
        if (mappingRequired && !matchValues) {
            setErrorMessage("Mapped Values are required for this condition.");
            return;
        }
        const nextDisplayOrder = Math.max(0, ...(selectedCustomCondition.customMappings || []).map((mapping)=>Number(mapping.displayOrder) || 0)) + 1;
        setIsSaving(true);
        setErrorMessage("");
        setStatusMessage("");
        try {
            const response = await (0, $96e14f2a7c3555e4$export$8fd59c52d687a33b)({
                poConditionId: selectedCustomCondition.id,
                rangeFrom: selectedCustomCondition.customMode === "Range" ? selectedCustomCondition.customRangeFrom : draftMapping.rangeFrom,
                rangeTo: selectedCustomCondition.customMode === "Range" ? selectedCustomCondition.customRangeTo : draftMapping.rangeTo,
                conditionValues: conditionValue,
                matchValues: matchValues,
                approvalPathReference: conditionValue,
                sourceFileName: draftMapping.uploadFileName,
                displayOrder: nextDisplayOrder
            });
            applyApiData(response.data);
            setDraftMapping($33ce55fb1d9e7a2a$var$createEmptyCustomMapping());
            setStatusMessage(response.message || "PO custom condition mapping saved successfully.");
        } catch (error) {
            setErrorMessage(error.message || "Unable to save custom condition mapping.");
        } finally{
            setIsSaving(false);
        }
    }
    async function removeCustomMapping(mappingId) {
        setIsSaving(true);
        setErrorMessage("");
        setStatusMessage("");
        try {
            const response = await (0, $96e14f2a7c3555e4$export$855fb363082ea033)(mappingId);
            applyApiData(response.data);
            setStatusMessage(response.message || "PO custom condition mapping deleted successfully.");
        } catch (error) {
            setErrorMessage(error.message || "Unable to delete custom condition mapping.");
        } finally{
            setIsSaving(false);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "conditions-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "workspace-panel conditions-view__hero",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        children: "Condition Creation Settings"
                    })
                })
            }),
            errorMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-note config-note--error",
                children: errorMessage
            }) : null,
            statusMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-note",
                children: statusMessage
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel checklist-tabs",
                role: "tablist",
                "aria-label": "Condition options",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: `ghost-button checklist-tabs__button${activeTab === "main" ? " is-active" : ""}`,
                        onClick: ()=>setActiveTab("main"),
                        children: "Main Condition"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: `ghost-button checklist-tabs__button${activeTab === "sub" ? " is-active" : ""}`,
                        onClick: ()=>setActiveTab("sub"),
                        children: "Condition Mapping"
                    })
                ]
            }),
            activeTab === "main" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel conditions-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "users-form__header",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "PO Invoice Setup"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Add PO condition rule"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-grid conditions-grid conditions-grid--single conditions-grid--compact",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field conditions-grid__condition",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Condition"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: draftCondition.condition,
                                        onChange: (event)=>updateDraft("condition", event.target.value),
                                        children: $33ce55fb1d9e7a2a$var$CONDITION_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: option,
                                                children: option
                                            }, option))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field conditions-grid__type",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Condition Type"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: draftCondition.conditionType,
                                        onChange: (event)=>{
                                            const nextType = event.target.value;
                                            // Budget logic is not available
                                            if (nextType === "Budget" && !budgetAvailable) {
                                                (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                                                    icon: "warning",
                                                    title: "Budget Logic Unavailable",
                                                    text: "Budget logic is not uploaded.",
                                                    confirmButtonText: "OK"
                                                });
                                                return;
                                            }
                                            updateDraft("conditionType", nextType);
                                            // Budget and Amount have fixed condition names
                                            if (nextType === "Budget") updateDraft("subConditionName", "Budget");
                                            else if (nextType === "Amount") updateDraft("subConditionName", "Amount");
                                            if (nextType !== "Custom") {
                                                updateDraft("customValue", "");
                                                updateDraft("customMapping", "");
                                                updateDraft("customRangeFrom", "");
                                                updateDraft("customRangeTo", "");
                                            }
                                            if (nextType !== "Content") updateDraft("isMapped", false);
                                            if (nextType !== "Expression") updateDraft("expression", "");
                                            // Budget doesn't have source/column
                                            if (nextType === "Budget") {
                                                updateDraft("source", "");
                                                updateDraft("columnName", "");
                                            }
                                        },
                                        children: $33ce55fb1d9e7a2a$var$CONDITION_TYPE_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: option,
                                                children: option
                                            }, option))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field conditions-grid__sub-condition",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Condition Name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: draftCondition.subConditionName,
                                        onChange: (event)=>updateDraft("subConditionName", event.target.value),
                                        placeholder: "Enter here",
                                        disabled: draftCondition.conditionType === "Budget" || draftCondition.conditionType === "Amount"
                                    })
                                ]
                            }),
                            draftCondition.conditionType === "Content" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Value Mapping"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "condition-checkbox",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                checked: draftCondition.isMapped,
                                                onChange: (event)=>updateDraft("isMapped", event.target.checked)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Enable Value Mapping"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "config-field__hint",
                                        children: "Enable this when source values need to be mapped to business values."
                                    })
                                ]
                            }) : null,
                            draftCondition.conditionType !== "Budget" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "config-field conditions-grid__source",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Source"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                value: draftCondition.source,
                                                onChange: (event)=>{
                                                    updateDraft("source", event.target.value);
                                                    updateDraft("columnName", "");
                                                },
                                                children: Object.keys(columnHeaderOptions).map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: option,
                                                        children: option
                                                    }, option))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "config-field conditions-grid__column-name",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Source Column"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: draftCondition.columnName,
                                                onChange: (event)=>updateDraft("columnName", event.target.value),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Select header"
                                                    }),
                                                    draftHeaderOptions.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: option,
                                                            children: option
                                                        }, option))
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : null,
                            draftCondition.conditionType === "Custom" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "config-field conditions-grid__custom-mode",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Custom Type"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                value: draftCondition.customMode,
                                                onChange: (event)=>{
                                                    const nextMode = event.target.value;
                                                    updateDraft("customMode", nextMode);
                                                    if (nextMode === "Range") {
                                                        updateDraft("customValue", "");
                                                        updateDraft("customMapping", "");
                                                    } else {
                                                        updateDraft("customRangeFrom", "");
                                                        updateDraft("customRangeTo", "");
                                                        updateDraft("customValue", "");
                                                    }
                                                },
                                                children: $33ce55fb1d9e7a2a$var$CUSTOM_MODE_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: option.value,
                                                        children: option.label
                                                    }, option.value))
                                            })
                                        ]
                                    }),
                                    draftCondition.customMode === "Range" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "config-field conditions-grid__custom-value conditions-grid__custom-value--range",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Character Positions"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "condition-range-inline",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "condition-range-field",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            type: "text",
                                                            value: draftCondition.customRangeFrom,
                                                            onChange: (event)=>updateDraft("customRangeFrom", event.target.value),
                                                            placeholder: "Start"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "condition-range-field",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            type: "text",
                                                            value: draftCondition.customRangeTo,
                                                            onChange: (event)=>updateDraft("customRangeTo", event.target.value),
                                                            placeholder: "End"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : null
                                ]
                            }) : draftCondition.conditionType === "Expression" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field conditions-grid__custom-value",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Expression"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: draftCondition.expression,
                                        onChange: (event)=>updateDraft("expression", event.target.value),
                                        placeholder: ">= 100000"
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "condition-actions-bar",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "primary-button",
                            type: "button",
                            onClick: addDraftToTable,
                            disabled: isSaving || isLoading || rows.length >= 8,
                            children: isSaving ? "Saving..." : "Add Condition"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-table conditions-table-wrap",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Condition"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Condition Name"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Type"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Source"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Source Column / Header"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Custom Details"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Actions"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            colSpan: "7",
                                            style: {
                                                textAlign: "center",
                                                color: "#999"
                                            },
                                            children: "Loading PO conditions..."
                                        })
                                    }) : !rows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            colSpan: "7",
                                            style: {
                                                textAlign: "center",
                                                color: "#999"
                                            },
                                            children: "No conditions added yet."
                                        })
                                    }) : rows.map((row, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($33ce55fb1d9e7a2a$var$ConditionRow, {
                                            row: row,
                                            index: index,
                                            columnHeaderOptions: columnHeaderOptions,
                                            onChange: updateRow,
                                            onRemoveRow: removeRow,
                                            onToggleEdit: toggleRowEdit,
                                            canRemove: rows.length > 1,
                                            onOpenCustom: ()=>setActiveTab("sub")
                                        }, row.id))
                                })
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel conditions-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "users-form__header",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "PO Invoice Setup"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Condition Mapping"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "config-view__intro",
                                    children: "Map source values to clean condition values for Approval Matrix_PO."
                                })
                            ]
                        })
                    }),
                    !mappableConditionRows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-note",
                        children: "Add at least one Content or Custom condition row to create condition values."
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `config-grid custom-mapping-grid${isNonRangeCustomMapping ? " custom-mapping-grid--non-range" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field custom-mapping-grid__wide",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Select Condition Name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: draftMapping.customConditionId,
                                        onChange: (event)=>updateDraftMapping("customConditionId", event.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Select condition"
                                            }),
                                            mappableConditionRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: row.id,
                                                    children: $33ce55fb1d9e7a2a$var$getConditionLabel(row)
                                                }, row.id))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Condition"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: selectedCustomCondition?.condition || "",
                                        readOnly: true,
                                        placeholder: "Auto-filled"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Condition Type"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: selectedCustomCondition?.conditionType || "",
                                        readOnly: true,
                                        placeholder: "Auto-filled"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Source"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: selectedCustomCondition?.source || "",
                                        readOnly: true,
                                        placeholder: "Auto-filled"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Source Column"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: selectedCustomCondition?.columnName || "",
                                        readOnly: true,
                                        placeholder: "Auto-filled"
                                    })
                                ]
                            }),
                            selectedCustomCondition?.conditionType === "Custom" && selectedCustomCondition.customMode === "Range" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field custom-mapping-grid__wide",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Range"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "condition-range-inline",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "condition-range-field",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    value: selectedCustomCondition.customRangeFrom || "",
                                                    readOnly: true,
                                                    placeholder: "From value"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "condition-range-field",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    value: selectedCustomCondition.customRangeTo || "",
                                                    readOnly: true,
                                                    placeholder: "To value"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "config-field__hint",
                                        children: "These are 1-based character positions from the source value."
                                    })
                                ]
                            }) : null,
                            selectedCustomCondition ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: `config-field ${selectedCustomCondition.conditionType === "Content" ? "custom-mapping-grid__content-value" : ""} ${selectedCustomCondition.conditionType === "Custom" && selectedCustomCondition.customMode !== "Range" ? "custom-mapping-grid__mapping-row-start" : ""}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Condition Value"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: draftMapping.conditionValue,
                                        onChange: (event)=>updateDraftMapping("conditionValue", event.target.value),
                                        placeholder: "Example: HR"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "config-field__hint",
                                        children: "This value will appear in Approval Matrix_PO."
                                    })
                                ]
                            }) : null,
                            selectedCustomCondition?.conditionType === "Custom" || selectedCustomCondition?.conditionType === "Content" && selectedCustomCondition?.isMapped ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: `config-field ${selectedCustomCondition?.conditionType === "Custom" && selectedCustomCondition?.customMode !== "Range" ? "custom-mapping-grid__mapping-row-value" : ""}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Mapped Values"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: draftMapping.matchValues,
                                        onChange: (event)=>updateDraftMapping("matchValues", event.target.value),
                                        placeholder: "Example: 101,102,103"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "config-field__hint",
                                        children: "Enter comma-separated values to match against the source column."
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: `custom-mapping-or${isNonRangeCustomMapping ? " custom-mapping-grid__mapping-row-or" : ""}`,
                                children: "OR"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: `config-field${isNonRangeCustomMapping ? " custom-mapping-grid__mapping-row-upload" : ""}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Upload Excel"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "file",
                                        accept: ".xlsx,.xls,.csv",
                                        onChange: (event)=>updateDraftMapping("uploadFileName", event.target.files?.[0]?.name || "")
                                    }),
                                    draftMapping.uploadFileName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "config-field__hint",
                                        children: draftMapping.uploadFileName
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "condition-actions-bar",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "primary-button",
                            type: "button",
                            onClick: addDraftMappingToTable,
                            disabled: !selectedCustomCondition || isSaving,
                            children: isSaving ? "Saving..." : "Submit"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-table conditions-table-wrap",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Condition"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Condition Name"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Source Column"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Condition Value / Mapping"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Actions"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: !customMappings.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            colSpan: "5",
                                            style: {
                                                textAlign: "center",
                                                color: "#999"
                                            },
                                            children: "No condition values added yet."
                                        })
                                    }) : groupedMappings.map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: group.condition
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: group.subConditionName || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: group.columnName || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "condition-mapping-display",
                                                        children: group.mappings.map((mapping)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "condition-mapping-display__item",
                                                                children: group.conditionType === "Custom" || group.conditionType === "Content" && group.isMapped ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                            children: mapping.conditionValue || mapping.approvalPath || "-"
                                                                        }),
                                                                        " \u2192 ",
                                                                        mapping.matchValues || mapping.uploadFileName || "-"
                                                                    ]
                                                                }) : mapping.conditionValue || mapping.approvalPath || "-"
                                                            }, mapping.id))
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "condition-row__actions",
                                                        children: group.mappings.map((mapping)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "condition-icon-button condition-icon-button--danger",
                                                                onClick: ()=>removeCustomMapping(mapping.id),
                                                                children: "Remove"
                                                            }, mapping.id))
                                                    })
                                                })
                                            ]
                                        }, group.customConditionId))
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

const $33253bed4093cc92$var$CONDITION_TYPE_OPTIONS = [
    "Content",
    "Custom"
];
const $33253bed4093cc92$var$SOURCE_OPTIONS = [
    "Vendor Master",
    "Invoice OCR"
];
const $33253bed4093cc92$var$CUSTOM_MODE_OPTIONS = [
    {
        value: "Range",
        label: "Range"
    },
    {
        value: "Contains",
        label: "Contains"
    },
    {
        value: "Not Contains",
        label: "Not Contains"
    },
    {
        value: "Starts With",
        label: "Starts With"
    },
    {
        value: "Ends With",
        label: "Ends With"
    }
];
const $33253bed4093cc92$var$CONDITION_OPTIONS = Array.from({
    length: 8
}, (_, index)=>`condition${index + 1}`);
const $33253bed4093cc92$var$MAPPING_BASED_MODES = new Set([
    "Contains",
    "Not Contains",
    "Starts With",
    "Ends With"
]);
function $33253bed4093cc92$var$getColumnHeaderOptions(source, columnHeaderOptions) {
    return columnHeaderOptions[source] || [];
}
function $33253bed4093cc92$var$createEmptyCondition(index) {
    return {
        id: `condition-${Date.now()}-${index}`,
        condition: $33253bed4093cc92$var$CONDITION_OPTIONS[index] || `condition${index + 1}`,
        subConditionName: "",
        conditionType: "Content",
        isMapped: false,
        customMode: "Range",
        customMapping: "",
        customValue: "",
        customRangeFrom: "",
        customRangeTo: "",
        columnName: "",
        range: "",
        source: "Vendor Master",
        conditionValue: "",
        mappings: [],
        isEditing: false
    };
}
function $33253bed4093cc92$var$createEmptyCustomMapping() {
    return {
        id: "",
        customConditionId: "",
        rangeFrom: "",
        rangeTo: "",
        conditionValue: "",
        mappedValues: "",
        uploadFileName: ""
    };
}
function $33253bed4093cc92$var$getConditionLabel(row) {
    if (!row) return "";
    return `${row.condition} - ${row.subConditionName || "Unnamed custom condition"}`;
}
function $33253bed4093cc92$var$conditionFromApi(condition) {
    return {
        id: condition.id,
        condition: condition.conditionKey,
        subConditionName: condition.subConditionName || "",
        conditionType: condition.conditionType || "Content",
        isMapped: Boolean(condition.isMapped),
        customMode: condition.customMode || "Range",
        customMapping: "",
        customValue: "",
        customRangeFrom: condition.customRangeFrom || "",
        customRangeTo: condition.customRangeTo || "",
        columnName: condition.columnName || "",
        range: "",
        source: condition.source || "Vendor Master",
        conditionValue: condition.conditionValue || "",
        mappings: Array.isArray(condition.mappings) ? condition.mappings : [],
        displayOrder: condition.displayOrder,
        isEditing: false
    };
}
function $33253bed4093cc92$var$ConditionRow({ row: row, index: index, columnHeaderOptions: columnHeaderOptions, onChange: onChange, onRemoveRow: onRemoveRow, onToggleEdit: onToggleEdit }) {
    const isCustomRow = row.conditionType === "Custom";
    const rowHeaderOptions = $33253bed4093cc92$var$getColumnHeaderOptions(row.source, columnHeaderOptions);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                children: row.isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                    value: row.condition,
                    onChange: (event)=>onChange(row.id, "condition", event.target.value),
                    children: $33253bed4093cc92$var$CONDITION_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: option,
                            children: option
                        }, option))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: row.condition || "\u2014"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                children: row.isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "text",
                    value: row.subConditionName,
                    onChange: (event)=>onChange(row.id, "subConditionName", event.target.value),
                    placeholder: "Sub condition name"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: row.subConditionName || "\u2014"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                children: [
                    row.isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                        value: row.conditionType,
                        onChange: (event)=>{
                            const nextType = event.target.value;
                            onChange(row.id, "conditionType", nextType);
                            if (nextType !== "Custom") {
                                onChange(row.id, "customValue", "");
                                onChange(row.id, "customMapping", "");
                                onChange(row.id, "customRangeFrom", "");
                                onChange(row.id, "customRangeTo", "");
                            }
                            if (nextType !== "Content") onChange(row.id, "isMapped", false);
                        },
                        children: $33253bed4093cc92$var$CONDITION_TYPE_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: option,
                                children: option
                            }, option))
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: row.conditionType
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "condition-row__hint",
                        children: [
                            "Row ",
                            index + 1
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                children: row.isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                    className: "conditions-non-po__source-select",
                    value: row.source,
                    onChange: (event)=>{
                        onChange(row.id, "source", event.target.value);
                        onChange(row.id, "columnName", "");
                    },
                    children: $33253bed4093cc92$var$SOURCE_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: option,
                            children: option
                        }, option))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: row.source
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                children: row.isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                    value: row.columnName,
                    onChange: (event)=>onChange(row.id, "columnName", event.target.value),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: "",
                            children: "Select header"
                        }),
                        rowHeaderOptions.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: option,
                                children: option
                            }, option))
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: row.columnName || "\u2014"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                children: row.isEditing && isCustomRow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "condition-cell-stack",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                            value: row.customMode,
                            onChange: (event)=>{
                                const nextMode = event.target.value;
                                onChange(row.id, "customMode", nextMode);
                                if (nextMode === "Range") {
                                    onChange(row.id, "customValue", "");
                                    onChange(row.id, "customMapping", "");
                                } else {
                                    onChange(row.id, "customRangeFrom", "");
                                    onChange(row.id, "customRangeTo", "");
                                    onChange(row.id, "customValue", "");
                                }
                            },
                            children: $33253bed4093cc92$var$CUSTOM_MODE_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: option.value,
                                    children: option.label
                                }, option.value))
                        }),
                        row.customMode === "Range" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "condition-range-inline",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "condition-range-field",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: row.customRangeFrom,
                                        onChange: (event)=>onChange(row.id, "customRangeFrom", event.target.value),
                                        placeholder: "From"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "condition-range-field",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: row.customRangeTo,
                                        onChange: (event)=>onChange(row.id, "customRangeTo", event.target.value),
                                        placeholder: "To"
                                    })
                                })
                            ]
                        }) : null
                    ]
                }) : isCustomRow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "condition-cell-stack",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Mode:"
                                }),
                                " ",
                                row.customMode
                            ]
                        }),
                        row.customMode === "Range" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Range:"
                                }),
                                " ",
                                (row.customRangeFrom || "\u2014") + " to " + (row.customRangeTo || "\u2014")
                            ]
                        }) : $33253bed4093cc92$var$MAPPING_BASED_MODES.has(row.customMode) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Mapping:"
                                }),
                                " ",
                                row.customMapping || "\u2014"
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Value:"
                                }),
                                " ",
                                row.customValue || "\u2014"
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    style: {
                        color: "#999"
                    },
                    children: "\u2014"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "condition-row__actions",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "condition-icon-button",
                            onClick: ()=>onToggleEdit(row.id),
                            "aria-label": row.isEditing ? "Save condition row" : "Edit condition row",
                            children: row.isEditing ? "Save" : "Edit"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "condition-icon-button condition-icon-button--danger",
                            onClick: ()=>onRemoveRow(row.id),
                            "aria-label": "Remove condition row",
                            children: "Remove"
                        })
                    ]
                })
            })
        ]
    });
}
function $33253bed4093cc92$export$2e2bcd8739ae039() {
    const [activeTab, setActiveTab] = (0, $acw62.useState)("main");
    const [draftCondition, setDraftCondition] = (0, $acw62.useState)($33253bed4093cc92$var$createEmptyCondition(0));
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [draftMapping, setDraftMapping] = (0, $acw62.useState)($33253bed4093cc92$var$createEmptyCustomMapping());
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    const [isSaving, setIsSaving] = (0, $acw62.useState)(false);
    const [statusMessage, setStatusMessage] = (0, $acw62.useState)("");
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)("");
    const [columnHeaderOptions, setColumnHeaderOptions] = (0, $acw62.useState)({
        "Vendor Master": [],
        "Invoice OCR": []
    });
    (0, $acw62.useEffect)(()=>{
        let isActive = true;
        async function loadConditions() {
            try {
                const data = await (0, $96e14f2a7c3555e4$export$2f4225d126d5377e)();
                if (isActive) {
                    const conditions = Array.isArray(data) ? data : data?.conditions || [];
                    applyApiData(data);
                    const nextCondition = nextAvailableCondition(conditions.map($33253bed4093cc92$var$conditionFromApi));
                    setDraftCondition((current)=>({
                            ...current,
                            condition: nextCondition || "condition1"
                        }));
                }
            } catch (error) {
                if (isActive) setErrorMessage(error.message || "Unable to load Non-PO conditions.");
            } finally{
                if (isActive) setIsLoading(false);
            }
        }
        loadConditions();
        return ()=>{
            isActive = false;
        };
    }, []);
    const draftHeaderOptions = $33253bed4093cc92$var$getColumnHeaderOptions(draftCondition.source, columnHeaderOptions);
    const mappableConditionRows = rows.filter((row)=>row.conditionType === "Content" || row.conditionType === "Custom");
    const selectedCustomCondition = mappableConditionRows.find((row)=>String(row.id) === String(draftMapping.customConditionId));
    const isNonRangeCustomMapping = selectedCustomCondition?.conditionType === "Custom" && selectedCustomCondition.customMode !== "Range";
    const mappingRequired = selectedCustomCondition?.conditionType === "Custom" || selectedCustomCondition?.conditionType === "Content" && selectedCustomCondition.isMapped;
    const mappedConditionRows = mappableConditionRows.filter((row)=>row.conditionValue || row.mappings?.length);
    function applyApiData(payload) {
        const conditions = Array.isArray(payload) ? payload : payload?.conditions || [];
        const headers = payload?.headers || {};
        setRows(conditions.map($33253bed4093cc92$var$conditionFromApi));
        setColumnHeaderOptions({
            "Vendor Master": headers["Vendor Master"] || [],
            "Invoice OCR": headers["Invoice OCR"] || []
        });
    }
    function nextAvailableCondition(currentRows) {
        const used = new Set(currentRows.map((row)=>row.condition));
        return $33253bed4093cc92$var$CONDITION_OPTIONS.find((option)=>!used.has(option)) || "";
    }
    function conditionPayload(row) {
        return {
            ...Number.isInteger(row.id) ? {
                id: row.id
            } : {},
            conditionKey: row.condition,
            subConditionName: row.subConditionName,
            conditionType: row.conditionType,
            isMapped: row.conditionType === "Content" ? row.isMapped : false,
            customMode: row.customMode,
            customRangeFrom: row.customRangeFrom,
            customRangeTo: row.customRangeTo,
            source: row.source,
            columnName: row.columnName,
            conditionValue: row.conditionValue,
            mappings: row.mappings || [],
            displayOrder: $33253bed4093cc92$var$CONDITION_OPTIONS.indexOf(row.condition) + 1
        };
    }
    function updateDraft(field, value) {
        setDraftCondition((current)=>({
                ...current,
                [field]: value
            }));
    }
    async function saveCondition(row) {
        const response = await (0, $96e14f2a7c3555e4$export$6ae993a427eddd10)(conditionPayload(row));
        applyApiData(response.data);
        return response;
    }
    async function addDraftToTable() {
        setIsSaving(true);
        setErrorMessage("");
        setStatusMessage("");
        try {
            const response = await saveCondition(draftCondition);
            const conditions = Array.isArray(response.data) ? response.data : response.data?.conditions || [];
            const nextCondition = nextAvailableCondition(conditions.map($33253bed4093cc92$var$conditionFromApi));
            setDraftCondition({
                ...$33253bed4093cc92$var$createEmptyCondition(conditions.length),
                condition: nextCondition || "condition1",
                source: draftCondition.source || "Vendor Master"
            });
            setStatusMessage(response.message || "Non-PO condition saved successfully.");
        } catch (error) {
            setErrorMessage(error.message || "Unable to save Non-PO condition.");
        } finally{
            setIsSaving(false);
        }
    }
    function updateRow(rowId, field, value) {
        setRows((current)=>current.map((row)=>row.id === rowId ? {
                    ...row,
                    [field]: value
                } : row));
    }
    async function toggleRowEdit(rowId) {
        const row = rows.find((item)=>item.id === rowId);
        if (!row) return;
        if (!row.isEditing) {
            setRows((current)=>current.map((item)=>item.id === rowId ? {
                        ...item,
                        isEditing: true
                    } : item));
            return;
        }
        setIsSaving(true);
        setErrorMessage("");
        setStatusMessage("");
        try {
            const response = await saveCondition(row);
            setStatusMessage(response.message || "Non-PO condition saved successfully.");
        } catch (error) {
            setErrorMessage(error.message || "Unable to save Non-PO condition.");
        } finally{
            setIsSaving(false);
        }
    }
    async function removeRow(rowId) {
        if (!Number.isInteger(rowId)) return;
        setIsSaving(true);
        setErrorMessage("");
        setStatusMessage("");
        try {
            const response = await (0, $96e14f2a7c3555e4$export$211a4b2824e301f)(rowId);
            applyApiData(response.data);
            setDraftMapping((current)=>String(current.customConditionId) === String(rowId) ? $33253bed4093cc92$var$createEmptyCustomMapping() : current);
            setStatusMessage(response.message || "Non-PO condition deleted successfully.");
        } catch (error) {
            setErrorMessage(error.message || "Unable to delete Non-PO condition.");
        } finally{
            setIsSaving(false);
        }
    }
    function updateDraftMapping(field, value) {
        setDraftMapping((current)=>({
                ...current,
                [field]: value
            }));
    }
    async function addDraftMappingToTable() {
        if (!selectedCustomCondition) return;
        const conditionValue = draftMapping.conditionValue.trim();
        if (!conditionValue) {
            setErrorMessage("Condition Value is required.");
            return;
        }
        const mappedValues = draftMapping.mappedValues.split(",").map((value)=>value.trim()).filter(Boolean);
        const requiresMapping = selectedCustomCondition.conditionType === "Custom" || selectedCustomCondition.conditionType === "Content" && selectedCustomCondition.isMapped;
        const updatedCondition = requiresMapping ? {
            ...selectedCustomCondition,
            mappings: [
                ...selectedCustomCondition.mappings || [],
                {
                    id: `mapping-${Date.now()}-${selectedCustomCondition.mappings?.length || 0}`,
                    condition_value: conditionValue,
                    mapped_values: mappedValues,
                    upload_file_name: draftMapping.uploadFileName
                }
            ]
        } : {
            ...selectedCustomCondition,
            conditionValue: conditionValue
        };
        setIsSaving(true);
        setErrorMessage("");
        setStatusMessage("");
        try {
            const response = await saveCondition(updatedCondition);
            setDraftMapping($33253bed4093cc92$var$createEmptyCustomMapping());
            setStatusMessage(response.message || "Non-PO condition mapping saved successfully.");
        } catch (error) {
            setErrorMessage(error.message || "Unable to save Non-PO condition mapping.");
        } finally{
            setIsSaving(false);
        }
    }
    async function removeCustomMapping(conditionId, mappingId) {
        const row = rows.find((item)=>item.id === conditionId);
        if (!row) return;
        setIsSaving(true);
        setErrorMessage("");
        setStatusMessage("");
        try {
            const response = await saveCondition({
                ...row,
                mappings: (row.mappings || []).filter((mapping)=>mapping.id !== mappingId)
            });
            setStatusMessage(response.message || "Non-PO condition mapping removed successfully.");
        } catch (error) {
            setErrorMessage(error.message || "Unable to remove Non-PO condition mapping.");
        } finally{
            setIsSaving(false);
        }
    }
    async function clearConditionValue(conditionId) {
        const row = rows.find((item)=>item.id === conditionId);
        if (!row) return;
        setIsSaving(true);
        setErrorMessage("");
        setStatusMessage("");
        try {
            const response = await saveCondition({
                ...row,
                conditionValue: ""
            });
            setStatusMessage(response.message || "Non-PO condition value removed successfully.");
        } catch (error) {
            setErrorMessage(error.message || "Unable to remove Non-PO condition value.");
        } finally{
            setIsSaving(false);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "conditions-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "workspace-panel conditions-view__hero",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "eyebrow",
                            children: "Invoice Approval"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            children: "Condition Settings"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "config-view__intro",
                            children: "Configure Non-PO invoice conditions using Vendor Master and Invoice OCR inputs."
                        })
                    ]
                })
            }),
            errorMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-note config-note--error",
                children: errorMessage
            }) : null,
            statusMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-note",
                children: statusMessage
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel checklist-tabs",
                role: "tablist",
                "aria-label": "Condition options",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: `ghost-button checklist-tabs__button${activeTab === "main" ? " is-active" : ""}`,
                        onClick: ()=>setActiveTab("main"),
                        children: "Main Condition"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: `ghost-button checklist-tabs__button checklist-tabs__button--custom-mapping${activeTab === "sub" ? " is-active" : ""}`,
                        onClick: ()=>setActiveTab("sub"),
                        children: "Condition Mapping"
                    })
                ]
            }),
            activeTab === "main" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel conditions-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "users-form__header",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Non-PO Invoice Setup"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Add Non-PO condition rule"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "config-grid conditions-grid conditions-grid--single conditions-grid--compact",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field conditions-grid__condition",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Condition"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: draftCondition.condition,
                                        onChange: (event)=>updateDraft("condition", event.target.value),
                                        children: $33253bed4093cc92$var$CONDITION_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: option,
                                                children: option
                                            }, option))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field conditions-grid__sub-condition",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Condition Name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: draftCondition.subConditionName,
                                        onChange: (event)=>updateDraft("subConditionName", event.target.value),
                                        placeholder: "Enter here"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field conditions-grid__type",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Condition Type"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: draftCondition.conditionType,
                                        onChange: (event)=>{
                                            const nextType = event.target.value;
                                            updateDraft("conditionType", nextType);
                                            if (nextType !== "Custom") {
                                                updateDraft("customValue", "");
                                                updateDraft("customMapping", "");
                                                updateDraft("customRangeFrom", "");
                                                updateDraft("customRangeTo", "");
                                            }
                                            if (nextType !== "Content") updateDraft("isMapped", false);
                                        },
                                        children: $33253bed4093cc92$var$CONDITION_TYPE_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: option,
                                                children: option
                                            }, option))
                                    })
                                ]
                            }),
                            draftCondition.conditionType === "Content" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Value Mapping"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "condition-checkbox",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                checked: draftCondition.isMapped,
                                                onChange: (event)=>updateDraft("isMapped", event.target.checked)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Enable Value Mapping"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "config-field__hint",
                                        children: "Enable this when source values need to be mapped to business values."
                                    })
                                ]
                            }) : null,
                            draftCondition.conditionType === "Custom" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "config-field conditions-grid__custom-mode",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Custom Type"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                value: draftCondition.customMode,
                                                onChange: (event)=>{
                                                    const nextMode = event.target.value;
                                                    updateDraft("customMode", nextMode);
                                                    if (nextMode === "Range") {
                                                        updateDraft("customValue", "");
                                                        updateDraft("customMapping", "");
                                                    } else {
                                                        updateDraft("customRangeFrom", "");
                                                        updateDraft("customRangeTo", "");
                                                        updateDraft("customValue", "");
                                                    }
                                                },
                                                children: $33253bed4093cc92$var$CUSTOM_MODE_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: option.value,
                                                        children: option.label
                                                    }, option.value))
                                            })
                                        ]
                                    }),
                                    draftCondition.customMode === "Range" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "config-field conditions-grid__custom-value conditions-grid__custom-value--range",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Enter Range"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "condition-range-inline",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "condition-range-field",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            type: "text",
                                                            value: draftCondition.customRangeFrom,
                                                            onChange: (event)=>updateDraft("customRangeFrom", event.target.value),
                                                            placeholder: "From"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "condition-range-field",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            type: "text",
                                                            value: draftCondition.customRangeTo,
                                                            onChange: (event)=>updateDraft("customRangeTo", event.target.value),
                                                            placeholder: "To"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : null
                                ]
                            }) : null,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field conditions-grid__source",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Source"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        className: "conditions-non-po__source-select",
                                        value: draftCondition.source,
                                        onChange: (event)=>{
                                            updateDraft("source", event.target.value);
                                            updateDraft("columnName", "");
                                        },
                                        children: $33253bed4093cc92$var$SOURCE_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: option,
                                                children: option
                                            }, option))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field conditions-grid__column-name",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Column Name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: draftCondition.columnName,
                                        onChange: (event)=>updateDraft("columnName", event.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Select header"
                                            }),
                                            draftHeaderOptions.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: option,
                                                    children: option
                                                }, option))
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "condition-actions-bar",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "primary-button",
                            type: "button",
                            onClick: addDraftToTable,
                            disabled: isSaving || isLoading || rows.length >= 8,
                            children: isSaving ? "Saving..." : "Add Condition"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-table conditions-table-wrap",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Condition"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Condition Name"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Type"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Source"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Column Name / Header"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Custom Details"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Actions"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            colSpan: "7",
                                            style: {
                                                textAlign: "center",
                                                color: "#999"
                                            },
                                            children: "Loading Non-PO conditions..."
                                        })
                                    }) : !rows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            colSpan: "7",
                                            style: {
                                                textAlign: "center",
                                                color: "#999"
                                            },
                                            children: "No conditions added yet."
                                        })
                                    }) : rows.map((row, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($33253bed4093cc92$var$ConditionRow, {
                                            row: row,
                                            index: index,
                                            columnHeaderOptions: columnHeaderOptions,
                                            onChange: updateRow,
                                            onRemoveRow: removeRow,
                                            onToggleEdit: toggleRowEdit
                                        }, row.id))
                                })
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel conditions-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "users-form__header",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Non-PO Invoice Setup"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Condition Mapping"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "config-view__intro",
                                    children: "Map source values to clean condition values for Non-PO approval routing."
                                })
                            ]
                        })
                    }),
                    !mappableConditionRows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-note",
                        children: "Add at least one Content or Custom condition row to create condition values."
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `config-grid custom-mapping-grid${isNonRangeCustomMapping ? " custom-mapping-grid--non-range" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field custom-mapping-grid__wide",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Select Condition Name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: draftMapping.customConditionId,
                                        onChange: (event)=>updateDraftMapping("customConditionId", event.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Select condition"
                                            }),
                                            mappableConditionRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: row.id,
                                                    children: $33253bed4093cc92$var$getConditionLabel(row)
                                                }, row.id))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Condition"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: selectedCustomCondition?.condition || "",
                                        readOnly: true,
                                        placeholder: "Auto-filled"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Condition Type"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: selectedCustomCondition?.conditionType || "",
                                        readOnly: true,
                                        placeholder: "Auto-filled"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Source"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: selectedCustomCondition?.source || "",
                                        readOnly: true,
                                        placeholder: "Auto-filled"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Column Name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: selectedCustomCondition?.columnName || "",
                                        readOnly: true,
                                        placeholder: "Auto-filled"
                                    })
                                ]
                            }),
                            selectedCustomCondition?.conditionType === "Custom" && selectedCustomCondition.customMode === "Range" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field custom-mapping-grid__wide",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Range"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "condition-range-inline",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "condition-range-field",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    value: selectedCustomCondition.customRangeFrom || "",
                                                    readOnly: true,
                                                    placeholder: "From value"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "condition-range-field",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    value: selectedCustomCondition.customRangeTo || "",
                                                    readOnly: true,
                                                    placeholder: "To value"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "config-field__hint",
                                        children: "These are 1-based character positions from the source value."
                                    })
                                ]
                            }) : null,
                            selectedCustomCondition ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: `config-field${isNonRangeCustomMapping ? " custom-mapping-grid__mapping-row-start" : ""}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Condition Value"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: draftMapping.conditionValue,
                                        onChange: (event)=>updateDraftMapping("conditionValue", event.target.value),
                                        placeholder: "Example: HR"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "config-field__hint",
                                        children: "This value will be stored as condition_value."
                                    })
                                ]
                            }) : null,
                            selectedCustomCondition?.conditionType === "Custom" || selectedCustomCondition?.conditionType === "Content" && selectedCustomCondition?.isMapped ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: `config-field${isNonRangeCustomMapping ? " custom-mapping-grid__mapping-row-value" : ""}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Mapped Values"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        value: draftMapping.mappedValues,
                                        onChange: (event)=>updateDraftMapping("mappedValues", event.target.value),
                                        placeholder: "Example: 101,102,103"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "config-field__hint",
                                        children: "Enter comma-separated values to store in mappings."
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: `custom-mapping-or${isNonRangeCustomMapping ? " custom-mapping-grid__mapping-row-or" : ""}`,
                                children: "OR"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: `config-field${isNonRangeCustomMapping ? " custom-mapping-grid__mapping-row-upload" : ""}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Upload Excel"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "file",
                                        accept: ".xlsx,.xls,.csv",
                                        onChange: (event)=>updateDraftMapping("uploadFileName", event.target.files?.[0]?.name || "")
                                    }),
                                    draftMapping.uploadFileName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "config-field__hint",
                                        children: draftMapping.uploadFileName
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "condition-actions-bar",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "primary-button",
                            type: "button",
                            onClick: addDraftMappingToTable,
                            disabled: !selectedCustomCondition || isSaving || mappingRequired && !draftMapping.mappedValues.trim() && !draftMapping.uploadFileName,
                            children: isSaving ? "Saving..." : "Submit"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-table conditions-table-wrap",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Condition"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Condition Name"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Source Column"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Condition Value / Mapping"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Actions"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: !mappedConditionRows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            colSpan: "5",
                                            style: {
                                                textAlign: "center",
                                                color: "#999"
                                            },
                                            children: "No condition values added yet."
                                        })
                                    }) : mappedConditionRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.condition
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.subConditionName || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.columnName || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.conditionType === "Custom" || row.conditionType === "Content" && row.isMapped ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "condition-mapping-display",
                                                        children: row.mappings.map((mapping)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "condition-mapping-display__item",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                        children: mapping.condition_value || "-"
                                                                    }),
                                                                    " -> ",
                                                                    mapping.mapped_values?.join(", ") || mapping.upload_file_name || "-"
                                                                ]
                                                            }, mapping.id))
                                                    }) : row.conditionValue
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "condition-row__actions",
                                                        children: row.conditionType === "Custom" || row.conditionType === "Content" && row.isMapped ? row.mappings.map((mapping)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "condition-icon-button condition-icon-button--danger",
                                                                onClick: ()=>removeCustomMapping(row.id, mapping.id),
                                                                children: "Remove"
                                                            }, mapping.id)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "condition-icon-button condition-icon-button--danger",
                                                            onClick: ()=>clearConditionValue(row.id),
                                                            children: "Remove"
                                                        })
                                                    })
                                                })
                                            ]
                                        }, row.id))
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


const $f9c5fc8c301dfae6$var$QUEUE_TABS = [
    {
        key: "unidentified",
        label: "Unidentified Invoices",
        queueType: "UNIDENTIFIED_INVOICE"
    },
    {
        key: "nonPoConditions",
        label: "Non-PO Conditions",
        queueType: "NON_PO_MULTIPLE_CONDITION"
    },
    {
        key: "duplicates",
        label: "Duplicate Invoice",
        queueType: "DUPLICATE_INVOICE"
    },
    {
        key: "poReview",
        label: "PO Review",
        queueType: "PO_MISSING_VENDOR_OR_INVOICE"
    }
];
function $f9c5fc8c301dfae6$var$formatAmount(value) {
    if (!value) return "-";
    const numberValue = Number(value);
    if (Number.isNaN(numberValue)) return value;
    return numberValue.toLocaleString("en-IN", {
        maximumFractionDigits: 2
    });
}
function $f9c5fc8c301dfae6$var$formatStatus(value) {
    return value ? value.replace(/_/g, " ") : "-";
}
function $f9c5fc8c301dfae6$var$getInitiatorPoRowClass(row, queueType) {
    if (queueType !== "PO_MISSING_VENDOR_OR_INVOICE" && queueType !== "NON_PO_MULTIPLE_CONDITION") return "";
    if (row.status === "READY_TO_SUBMIT") return "initiator-po-row--ready";
    if (row.status === "PATH_NOT_FOUND") return "initiator-po-row--path-not-found";
    return "";
}
function $f9c5fc8c301dfae6$var$getConditionRows(conditionValues) {
    const values = conditionValues?.values || {};
    const calculatedValues = conditionValues?.calculatedValues || values;
    const sourceDebug = conditionValues?.sourceDebug || {};
    const conditionKeys = Array.from(new Set([
        ...Object.keys(calculatedValues),
        ...Object.keys(values)
    ]));
    return conditionKeys.map((key)=>{
        const hasCalculatedValue = Object.prototype.hasOwnProperty.call(calculatedValues, key);
        return {
            key: key,
            calculatedValue: hasCalculatedValue ? calculatedValues[key] || "-" : values[key] || "-",
            value: values[key] || "-",
            name: sourceDebug[key]?.name || key
        };
    });
}
function $f9c5fc8c301dfae6$var$getApproverRows(matchedApprovalPath) {
    return [
        "approver1",
        "approver2",
        "approver3",
        "approver4",
        "approver5",
        "approver6"
    ].map((field, index)=>({
            field: field,
            label: `Approver ${index + 1}`,
            value: matchedApprovalPath?.[field] || "-"
        }));
}
function $f9c5fc8c301dfae6$var$getDuplicateRows(duplicateDetails) {
    if (!duplicateDetails || !Object.keys(duplicateDetails).length) return [];
    return [
        [
            "Invoice ID",
            duplicateDetails.invoiceId
        ],
        [
            "Invoice No.",
            duplicateDetails.invoiceNo
        ],
        [
            "Invoice Date",
            duplicateDetails.invoiceDate
        ],
        [
            "Invoice Amount",
            duplicateDetails.invoiceAmount
        ],
        [
            "PDF File",
            duplicateDetails.uniqueName || duplicateDetails.pdfPath
        ]
    ].filter(([, value])=>value !== undefined && value !== null && value !== "");
}
function $f9c5fc8c301dfae6$var$buildDraftFromRow(row) {
    if (!row) return {
        selectedInvoiceType: "",
        materialOrService: "",
        vendorGst: "",
        invoiceNo: "",
        invoiceDate: "",
        invoiceAmount: "",
        vendorCode: "",
        selectedPoNumber: ""
    };
    return {
        selectedInvoiceType: row.selectedInvoiceType || row.detectedInvoiceType || "",
        materialOrService: row.materialOrService || row.detectedMaterialOrService || "",
        vendorGst: row.vendorGst || "",
        invoiceNo: row.invoiceNo || "",
        invoiceDate: row.invoiceDate || "",
        invoiceAmount: row.invoiceAmount || "",
        vendorCode: row.vendorCode || "",
        selectedPoNumber: row.selectedPoNumber || ""
    };
}
function $f9c5fc8c301dfae6$export$2e2bcd8739ae039() {
    const [activeTab, setActiveTab] = (0, $acw62.useState)($f9c5fc8c301dfae6$var$QUEUE_TABS[0].key);
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [selectedRowId, setSelectedRowId] = (0, $acw62.useState)(null);
    const [draft, setDraft] = (0, $acw62.useState)($f9c5fc8c301dfae6$var$buildDraftFromRow(null));
    const [editedConditionValues, setEditedConditionValues] = (0, $acw62.useState)({});
    const [previewRow, setPreviewRow] = (0, $acw62.useState)(null);
    const [previewIsCurrent, setPreviewIsCurrent] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [recalculating, setRecalculating] = (0, $acw62.useState)(false);
    const [savingPath, setSavingPath] = (0, $acw62.useState)(false);
    const [submittingWorkflow, setSubmittingWorkflow] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)("");
    const [actionMessage, setActionMessage] = (0, $acw62.useState)("");
    const [activeModal, setActiveModal] = (0, $acw62.useState)("");
    const activeConfig = $f9c5fc8c301dfae6$var$QUEUE_TABS.find((tab)=>tab.key === activeTab) || $f9c5fc8c301dfae6$var$QUEUE_TABS[0];
    const visibleRows = rows.filter((row)=>row.queueType === activeConfig.queueType);
    const selectedRow = rows.find((row)=>row.id === selectedRowId) || visibleRows[0] || null;
    const selectedConditionRows = $f9c5fc8c301dfae6$var$getConditionRows(previewRow?.conditionValues || selectedRow?.conditionValues);
    const pathResultRow = previewIsCurrent ? previewRow || selectedRow : selectedRow;
    const selectedApproverRows = $f9c5fc8c301dfae6$var$getApproverRows(pathResultRow?.matchedApprovalPath);
    const selectedDuplicateRows = $f9c5fc8c301dfae6$var$getDuplicateRows(selectedRow?.duplicateDetails);
    const approvalPath = selectedApproverRows.filter((approver)=>approver.value !== "-").map((approver)=>approver.value).join(" \u2192 ");
    const hasMatchedApprovalPath = Boolean(pathResultRow?.matchedApprovalPath?.id);
    const hasEditedConditionValues = selectedConditionRows.some((condition)=>Object.prototype.hasOwnProperty.call(editedConditionValues, condition.key) && editedConditionValues[condition.key] !== condition.value);
    const summary = (0, $acw62.useMemo)(()=>$f9c5fc8c301dfae6$var$QUEUE_TABS.map((tab)=>({
                ...tab,
                count: rows.filter((row)=>row.queueType === tab.queueType).length
            })), [
        rows
    ]);
    async function loadInitiatorRows() {
        setLoading(true);
        setError("");
        try {
            const data = await (0, $96e14f2a7c3555e4$export$8ddce44871d78da0)();
            setRows(data);
            setSelectedRowId((current)=>{
                if (current && data.some((row)=>row.id === current)) return current;
                const firstVisible = data.find((row)=>row.queueType === activeConfig.queueType);
                return firstVisible?.id || null;
            });
        } catch (requestError) {
            setError(requestError.message || "Unable to load Initiator queue.");
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadInitiatorRows();
    // Initial queue load only. Action APIs refresh the selected row after recalculate.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $acw62.useEffect)(()=>{
        setDraft($f9c5fc8c301dfae6$var$buildDraftFromRow(selectedRow));
        setActionMessage("");
        setEditedConditionValues({});
        setPreviewRow(null);
        setPreviewIsCurrent(false);
        if (activeModal === "review" && selectedRow) previewInitialPath(selectedRow);
    }, [
        selectedRow?.id,
        activeModal
    ]);
    function handleTabChange(tabKey) {
        const nextConfig = $f9c5fc8c301dfae6$var$QUEUE_TABS.find((tab)=>tab.key === tabKey);
        const firstRow = rows.find((row)=>row.queueType === nextConfig?.queueType);
        setActiveTab(tabKey);
        setSelectedRowId(firstRow?.id || null);
    }
    function openRowModal(rowId, modalName) {
        setSelectedRowId(rowId);
        setActiveModal(modalName);
    }
    function updateDraft(field, value) {
        setDraft((current)=>({
                ...current,
                [field]: value
            }));
    }
    function updateEditedConditionValue(conditionKey, value) {
        setPreviewIsCurrent(false);
        setEditedConditionValues((current)=>({
                ...current,
                [conditionKey]: value
            }));
    }
    async function handleRecalculatePath() {
        if (!selectedRow || !hasEditedConditionValues) return;
        setRecalculating(true);
        setError("");
        setActionMessage("");
        try {
            const updatedRow = await (0, $96e14f2a7c3555e4$export$971ecfbcaef84ff)(selectedRow.id, {
                ...draft,
                selectedConditionValues: editedConditionValues,
                saveFinal: false
            });
            if (updatedRow) {
                setPreviewRow(updatedRow);
                setPreviewIsCurrent(true);
                setEditedConditionValues(updatedRow.conditionValues?.values || {});
                setActionMessage("Approval path preview recalculated.");
            }
        } catch (requestError) {
            setError(requestError.message || "Unable to recalculate approval path.");
        } finally{
            setRecalculating(false);
        }
    }
    async function previewInitialPath(row) {
        setRecalculating(true);
        setError("");
        try {
            const updatedRow = await (0, $96e14f2a7c3555e4$export$971ecfbcaef84ff)(row.id, {
                ...$f9c5fc8c301dfae6$var$buildDraftFromRow(row),
                selectedConditionValues: row.conditionValues?.values || {},
                saveFinal: false
            });
            if (updatedRow) {
                setPreviewRow(updatedRow);
                setPreviewIsCurrent(true);
                setEditedConditionValues(updatedRow.conditionValues?.values || {});
            }
        } catch (requestError) {
            setError(requestError.message || "Unable to calculate approval path.");
        } finally{
            setRecalculating(false);
        }
    }
    async function handleSavePath() {
        if (!selectedRow || !previewRow?.matchedApprovalPath?.id) return;
        setSavingPath(true);
        setError("");
        setActionMessage("");
        try {
            const updatedRow = await (0, $96e14f2a7c3555e4$export$971ecfbcaef84ff)(selectedRow.id, {
                ...draft,
                selectedConditionValues: editedConditionValues,
                saveFinal: true
            });
            if (updatedRow) {
                setRows((currentRows)=>currentRows.map((row)=>row.id === updatedRow.id ? updatedRow : row));
                setPreviewRow(null);
                setPreviewIsCurrent(false);
                setEditedConditionValues({});
                setActionMessage("Approval path saved.");
            }
        } catch (requestError) {
            setError(requestError.message || "Unable to save approval path.");
        } finally{
            setSavingPath(false);
        }
    }
    async function handleSubmitToWorkflow(rowId = selectedRow?.id) {
        if (!rowId) return;
        setSubmittingWorkflow(true);
        setError("");
        setActionMessage("");
        try {
            const response = await (0, $96e14f2a7c3555e4$export$5e75df2a611b6790)(rowId);
            setActionMessage(response.message || "Invoice submitted to approval workflow.");
            await loadInitiatorRows();
        } catch (requestError) {
            setError(requestError.message || "Unable to submit invoice to workflow.");
        } finally{
            setSubmittingWorkflow(false);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "initiator-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "workspace-panel initiator-hero initiator-hero--compact",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "initiator-hero__content",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "initiator-hero__copy",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Invoice Approval Initiator Queue"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "initiator-hero__intro",
                                    children: "Review invoice approval paths and submit confirmed invoices."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "initiator-summary-grid",
                            children: summary.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                                    className: "initiator-summary-card",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "eyebrow",
                                            children: item.label
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: item.count
                                        })
                                    ]
                                }, item.key))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel initiator-queue-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "processor-table__header",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "initiator-queue-tabs",
                                role: "group",
                                "aria-label": "Initiator queue filter",
                                children: summary.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        className: `initiator-queue-tabs__button${activeTab === item.key ? " is-active" : ""}`,
                                        type: "button",
                                        "aria-pressed": activeTab === item.key,
                                        onClick: ()=>handleTabChange(item.key),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: item.label
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: item.count
                                            })
                                        ]
                                    }, item.key))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-inline",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "ghost-button",
                                    type: "button",
                                    onClick: loadInitiatorRows,
                                    disabled: loading,
                                    children: loading ? "Refreshing..." : "Refresh"
                                })
                            })
                        ]
                    }),
                    error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-banner config-banner--error",
                        children: error
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-table processor-table initiator-table",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: activeConfig.queueType === "DUPLICATE_INVOICE" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice ID"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice No."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Vendor Name (As Per OCR)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice Date"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice Amount"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Pdf Copy of Invoice"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Details of Duplicate Invoice"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Submit"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice ID"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice No."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Vendor Name"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Vendor Code"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice Date"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Invoice Amount"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Vendor GST"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Status"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "PDF"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Approval Path"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Action"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            colSpan: activeConfig.queueType === "DUPLICATE_INVOICE" ? 8 : 11,
                                            children: "Loading Initiator queue..."
                                        })
                                    }) : visibleRows.length ? visibleRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                            className: $f9c5fc8c301dfae6$var$getInitiatorPoRowClass(row, activeConfig.queueType),
                                            children: activeConfig.queueType === "DUPLICATE_INVOICE" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.invoiceId || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.invoiceNo || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.vendorNameOcr || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.invoiceDate || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: $f9c5fc8c301dfae6$var$formatAmount(row.invoiceAmount)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.uniqueName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "pdf-view-button",
                                                            onClick: ()=>(0, $e267546ad9d86d30$export$a38ce99a4bdccd4e)(row.invoiceId),
                                                            children: "View PDF"
                                                        }) : "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.duplicateDetails && Object.keys(row.duplicateDetails).length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                            children: "Invoice ID:"
                                                                        }),
                                                                        " ",
                                                                        row.duplicateDetails.invoiceId || "-"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                            children: "Invoice No.:"
                                                                        }),
                                                                        " ",
                                                                        row.duplicateDetails.invoiceNo || "-"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                            children: "Invoice Date:"
                                                                        }),
                                                                        " ",
                                                                        row.duplicateDetails.invoiceDate || "-"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                            children: "Invoice Amount:"
                                                                        }),
                                                                        " ",
                                                                        $f9c5fc8c301dfae6$var$formatAmount(row.duplicateDetails.invoiceAmount)
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                            children: "PDF:"
                                                                        }),
                                                                        " ",
                                                                        row.duplicateDetails.uniqueName || row.duplicateDetails.pdfPath ? "View" : "-"
                                                                    ]
                                                                })
                                                            ]
                                                        }) : "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: "primary-button",
                                                            type: "button",
                                                            children: "Submit"
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.invoiceId
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.invoiceNo
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.vendorNameOcr
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.vendorCode
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.invoiceDate
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: $f9c5fc8c301dfae6$var$formatAmount(row.invoiceAmount)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.vendorGst
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: $f9c5fc8c301dfae6$var$formatStatus(row.status)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.uniqueName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "pdf-view-button",
                                                            onClick: ()=>(0, $e267546ad9d86d30$export$a38ce99a4bdccd4e)(row.invoiceId),
                                                            children: "View PDF"
                                                        }) : "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "initiator-action-buttons",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                className: "ghost-button",
                                                                type: "button",
                                                                onClick: ()=>openRowModal(row.id, "review"),
                                                                children: "View Path"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "initiator-action-buttons",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                className: "primary-button initiator-workflow-button",
                                                                type: "button",
                                                                title: "Submit to Workflow",
                                                                "aria-label": "Submit to Workflow",
                                                                onClick: ()=>handleSubmitToWorkflow(row.id),
                                                                disabled: submittingWorkflow || !row.matchedApprovalPath?.id || row.status !== "READY_TO_SUBMIT",
                                                                children: submittingWorkflow ? "Submitting..." : "Submit to Workflow"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        }, row.id)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            colSpan: activeConfig.queueType === "DUPLICATE_INVOICE" ? 8 : 11,
                                            children: "No invoices found in this queue."
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            activeModal && selectedRow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "initiator-modal-backdrop",
                role: "presentation",
                onClick: ()=>setActiveModal(""),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "initiator-modal",
                    role: "dialog",
                    "aria-modal": "true",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "initiator-modal__header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "eyebrow",
                                            children: "Invoice Workspace"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            children: selectedRow.invoiceNo || "Invoice Review"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "ghost-button",
                                    type: "button",
                                    onClick: ()=>setActiveModal(""),
                                    children: "Close"
                                })
                            ]
                        }),
                        activeModal === "review" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "workspace-panel initiator-detail initiator-modal-panel",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "processor-table__header",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "eyebrow",
                                                children: "Invoice Workspace"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                children: selectedRow.invoiceNo || "No invoice selected"
                                            })
                                        ]
                                    })
                                }),
                                actionMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "config-banner",
                                    children: actionMessage
                                }) : null,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                    className: "initiator-result-section",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "initiator-result-section__header",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "eyebrow",
                                                        children: "Calculated Conditions"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                        children: [
                                                            selectedConditionRows.length,
                                                            " condition values"
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        selectedConditionRows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "config-table initiator-result-table",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                    children: "Condition"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                    children: "System Calculated"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                    children: "Select Value"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                        children: selectedConditionRows.map((condition)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        children: condition.name
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        children: condition.calculatedValue
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                            className: "initiator-condition-input",
                                                                            value: editedConditionValues[condition.key] ?? condition.value ?? "",
                                                                            onChange: (event)=>updateEditedConditionValue(condition.key, event.target.value),
                                                                            children: [
                                                                                !selectedRow.conditionOptions?.[condition.key]?.includes(condition.value) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                    value: condition.value,
                                                                                    children: condition.value
                                                                                }) : null,
                                                                                selectedRow.conditionOptions?.[condition.key]?.map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                        value: value,
                                                                                        children: value
                                                                                    }, value))
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            }, condition.key))
                                                    })
                                                ]
                                            })
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "config-note",
                                            children: "No calculated condition values stored yet."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "config-inline",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "ghost-button",
                                        type: "button",
                                        onClick: handleRecalculatePath,
                                        disabled: !selectedRow || !hasEditedConditionValues || recalculating,
                                        children: recalculating ? "Recalculating..." : "Recalculate Path"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                    className: "initiator-result-section",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "initiator-result-section__header",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "eyebrow",
                                                        children: "Calculated Approval Path"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: hasMatchedApprovalPath ? `Matched #${pathResultRow.matchedApprovalPath.id}` : "Not matched"
                                                    })
                                                ]
                                            })
                                        }),
                                        hasMatchedApprovalPath && approvalPath ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "initiator-approval-path",
                                            children: approvalPath
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "config-note",
                                            children: "No approval path is matched for this invoice yet."
                                        })
                                    ]
                                }),
                                previewIsCurrent && previewRow?.matchedApprovalPath?.id ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "config-inline",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "primary-button",
                                        type: "button",
                                        onClick: handleSavePath,
                                        disabled: savingPath,
                                        children: savingPath ? "Saving..." : "Save"
                                    })
                                }) : null
                            ]
                        }) : null
                    ]
                })
            }) : null
        ]
    });
}




var $acw62 = parcelRequire("acw62");


const $58080555b821a069$var$APPROVER_TABS = [
    {
        key: "pending",
        label: "Pending Action"
    },
    {
        key: "hold",
        label: "On Hold"
    },
    {
        key: "rejected",
        label: "Rejected"
    }
];
const $58080555b821a069$var$ACTION_OPTIONS = [
    "Approve with Deduction",
    "Approve with No Deduction",
    "Raise Clarification",
    "Hold & Transfer",
    "Reject",
    "Edit Conditions"
];
function $58080555b821a069$var$formatAmount(numberValue) {
    if (numberValue == null) return "-";
    const n = typeof numberValue === "number" ? numberValue : parseFloat(numberValue) || 0;
    return n.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}
function $58080555b821a069$var$conditionRowsFromWorkflow(workflow) {
    const values = workflow.conditionValues?.values || {};
    const sourceDebug = workflow.conditionValues?.sourceDebug || {};
    return Object.keys(values).map((key)=>({
            name: sourceDebug[key]?.name || key,
            value: values[key] || "-"
        }));
}
function $58080555b821a069$var$workflowToApproverRow(workflow) {
    return {
        id: `workflow-${workflow.id}`,
        workflowId: workflow.id,
        invoiceId: workflow.invoiceId || workflow.id,
        invoiceNo: workflow.invoiceNo || "-",
        vendorNameOcr: workflow.vendorNameOcr || "-",
        vendorNameMaster: workflow.vendorNameMaster || "-",
        vendorCode: workflow.vendorCode || "-",
        invoiceDate: workflow.invoiceDate || "-",
        invoiceAmount: workflow.invoiceAmount || "",
        pdf: workflow.uniqueName || "View PDF",
        materialOrService: workflow.materialOrService || "-",
        invoiceType: workflow.invoiceType || "-",
        queue: "pending",
        highRisk: "Normal",
        currentApprover: workflow.currentApprover || "-",
        nextApprover: workflow.currentApprover || "-",
        conditions: $58080555b821a069$var$conditionRowsFromWorkflow(workflow),
        remarks: "Submitted by Initiator and pending approver action.",
        //previousTransactions: [],
        previousTransactions: Array.isArray(workflow.previousTransactions) ? workflow.previousTransactions : [],
        auditTrail: [
            "Submitted to workflow",
            `Pending with ${workflow.currentApprover || "approver"}`
        ],
        highRiskReasons: [],
        matchedApprovalPath: workflow.matchedApprovalPath || {},
        rawWorkflow: workflow
    };
}
/*
const DUMMY_APPROVER_ROWS = [
    {
        id: 1,
        invoiceId: "1",
        invoiceNo: "INV-1001",
        vendorNameOcr: "Acme Corp OCR",
        vendorNameMaster: "Acme Corporation",
        vendorCode: "ACME01",
        invoiceDate: "2026-06-10",
        invoiceAmount: 7200,
        pdf: "INV-1001.pdf",
        materialOrService: "Material",
        invoiceType: "PO",
        queue: "pending",
        highRisk: "Low Risk",
        currentApprover: "Alice",
        nextApprover: "Bob",
        conditions: [{ name: "PO Number", value: "9500011224" }, { name: "PO Prefix", value: "PO-Series-9500" }],
        remarks: "Sample invoice",
        previousTransactions: [],
        auditTrail: ["Submitted", "Reviewed"],
        highRiskReasons: [],
    },
    {
        id: 4,
        invoiceId: "4",
        invoiceNo: "INV-1004",
        vendorNameOcr: "Delta Traders OCR",
        vendorNameMaster: "Delta Traders",
        vendorCode: "DEL04",
        invoiceDate: "2026-06-13",
        invoiceAmount: 4300,
        pdf: "INV-1004.pdf",
        materialOrService: "Service",
        invoiceType: "Non-PO",
        queue: "rejected",
        highRisk: "Low Risk",
        currentApprover: "Grace",
        nextApprover: "-",
        conditions: [],
        remarks: "Rejected for test",
        previousTransactions: [],
        auditTrail: ["Submitted", "Rejected"],
        highRiskReasons: [],
    },
    {
        id: 3,
        invoiceId: "3",
        invoiceNo: "INV-1003",
        vendorNameOcr: "Gamma Services OCR",
        vendorNameMaster: "Gamma Services",
        vendorCode: "GAM03",
        invoiceDate: "2026-06-12",
        invoiceAmount: 9800,
        pdf: "INV-1003.pdf",
        materialOrService: "Material",
        invoiceType: "PO",
        queue: "pending",
        highRisk: "High Risk",
        currentApprover: "Eve",
        nextApprover: "Frank",
        conditions: [{ name: "PO Number", value: "9500011225" }],
        remarks: "High risk test invoice",
        previousTransactions: [],
        auditTrail: ["Submitted", "Flagged for amount"],
        highRiskReasons: ["Amount mismatch", "Vendor unknown"],
    },
    {
        id: 2,
        invoiceId: "2",
        invoiceNo: "INV-1002",
        vendorNameOcr: "Beta Ltd OCR",
        vendorNameMaster: "Beta Limited",
        vendorCode: "BETA02",
        invoiceDate: "2026-06-11",
        invoiceAmount: 15000,
        pdf: "INV-1002.pdf",
        materialOrService: "Service",
        invoiceType: "Non-PO",
        queue: "hold",
        highRisk: "High Risk",
        currentApprover: "Charlie",
        nextApprover: "Dana",
        conditions: [{ name: "PO Number", value: "" }],
        remarks: "Needs verification",
        previousTransactions: [
            { invoiceNo: "PV-9001", invoiceDate: "2025-12-12", invoiceAmount: 14000, deduction: 0, invoiceType: "PO", materialOrService: "Service", pdf: "PV-9001.pdf" },
        ],
        auditTrail: ["Submitted", "Flagged"],
        highRiskReasons: ["Mismatch amount"],
    },
];
*/ function $58080555b821a069$var$getActionFields(action) {
    if (action === "Approve with Deduction") return [
        "Deduction Amount",
        "Deduction Reason",
        "Remarks"
    ];
    if (action === "Approve with No Deduction") return [
        "Remarks"
    ];
    if (action === "Raise Clarification") return [
        "Send Clarification To",
        "Clarification Text"
    ];
    if (action === "Hold & Transfer") return [
        "Transfer To",
        "Hold Remarks"
    ];
    if (action === "Reject") return [
        "Rejection Reason"
    ];
    if (action === "Edit Conditions") return [
        "Condition 1",
        "Condition 2",
        "Condition Remarks"
    ];
    return [];
}
function $58080555b821a069$export$2e2bcd8739ae039() {
    const [activeTab, setActiveTab] = (0, $acw62.useState)("pending");
    const [workflowRows, setWorkflowRows] = (0, $acw62.useState)([]);
    const [selectedRowId, setSelectedRowId] = (0, $acw62.useState)(null);
    const [selectedAction, setSelectedAction] = (0, $acw62.useState)("Approve with No Deduction");
    const [activeModal, setActiveModal] = (0, $acw62.useState)("");
    // checklists implementation 1
    const [checklistItems, setChecklistItems] = (0, $acw62.useState)([
        {
            name: "Invoice Number Match",
            checked: false
        },
        {
            name: "GST Check",
            checked: false
        },
        {
            name: "Amount Validation",
            checked: false
        }
    ]);
    const [loadingWorkflows, setLoadingWorkflows] = (0, $acw62.useState)(false);
    const [workflowError, setWorkflowError] = (0, $acw62.useState)("");
    // const allRows = [
    //     ...workflowRows,
    //     ...DUMMY_APPROVER_ROWS.filter((row) => row.queue !== "pending"),
    // ];
    const allRows = workflowRows;
    const visibleRows = allRows.filter((row)=>row.queue === activeTab);
    const selectedRow = allRows.find((row)=>row.id === selectedRowId) || visibleRows[0] || null;
    const actionFields = $58080555b821a069$var$getActionFields(selectedAction);
    const tableColumnCount = 12 + (activeTab === "hold" ? 2 : 0) + (activeTab === "rejected" ? 1 : 0);
    const summary = (0, $acw62.useMemo)(()=>({
            pending: allRows.filter((row)=>row.queue === "pending").length,
            hold: allRows.filter((row)=>row.queue === "hold").length,
            rejected: allRows.filter((row)=>row.queue === "rejected").length,
            highRisk: allRows.filter((row)=>row.highRisk === "High Risk").length
        }), [
        allRows
    ]);
    async function loadPendingWorkflows() {
        setLoadingWorkflows(true);
        setWorkflowError("");
        try {
            const workflows = await (0, $96e14f2a7c3555e4$export$d4ba36157df1a074)({
                status: "PENDING_APPROVER"
            });
            const mappedRows = (Array.isArray(workflows) ? workflows : []).map($58080555b821a069$var$workflowToApproverRow);
            setWorkflowRows(mappedRows);
            setSelectedRowId((current)=>{
                if (current && mappedRows.some((row)=>row.id === current)) return current;
                return mappedRows[0]?.id || null;
            });
        } catch (requestError) {
            setWorkflowError(requestError.message || "Unable to load pending approval workflows.");
        } finally{
            setLoadingWorkflows(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadPendingWorkflows();
    }, []);
    function selectTab(tabKey) {
        setActiveTab(tabKey);
        const firstRow = allRows.find((row)=>row.queue === tabKey);
        setSelectedRowId(firstRow?.id || null);
    }
    function renderModalContent() {
        if (!selectedRow) return null;
        if (activeModal === "summary") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "approver-detail-grid",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Invoice No."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            value: selectedRow.invoiceNo,
                            readOnly: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Vendor OCR"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            value: selectedRow.vendorNameOcr,
                            readOnly: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Vendor Master"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            value: selectedRow.vendorNameMaster,
                            readOnly: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Vendor Code"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            value: selectedRow.vendorCode,
                            readOnly: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Invoice Amount"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            value: $58080555b821a069$var$formatAmount(selectedRow.invoiceAmount),
                            readOnly: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Invoice Date"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            value: selectedRow.invoiceDate,
                            readOnly: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Invoice Type"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            value: selectedRow.invoiceType,
                            readOnly: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Material / Service"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            value: selectedRow.materialOrService,
                            readOnly: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Current Approver"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            value: selectedRow.currentApprover || "-",
                            readOnly: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Next Approver"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            value: selectedRow.nextApprover || "-",
                            readOnly: true
                        })
                    ]
                })
            ]
        });
        if (activeModal === "decision") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "workspace-panel approver-review-card",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "users-form__header",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Invoice Review Workspace"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Use this area to take approval action on the selected invoice."
                            })
                        ]
                    })
                }),
                selectedRow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "approver-detail-grid",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Invoice No."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedRow.invoiceNo,
                                            readOnly: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Vendor Code"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedRow.vendorCode,
                                            readOnly: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Invoice Amount"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: $58080555b821a069$var$formatAmount(selectedRow.invoiceAmount),
                                            readOnly: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Current Approver"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedRow.currentApprover || "-",
                                            readOnly: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Decision"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                            value: selectedAction,
                                            onChange: (event)=>setSelectedAction(event.target.value),
                                            children: $58080555b821a069$var$ACTION_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: option,
                                                    children: option
                                                }, option))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Next Approver"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedRow.nextApprover || "-",
                                            readOnly: true
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "approver-action-fields",
                            children: actionFields.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: field
                                        }),
                                        field.toLowerCase().includes("remarks") || field.toLowerCase().includes("reason") || field.toLowerCase().includes("text") ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                            rows: "3",
                                            placeholder: field
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            placeholder: field
                                        })
                                    ]
                                }, field))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "approver-action-bar",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "primary-button",
                                children: "Save Decision"
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "config-note",
                    children: "Select an invoice to review."
                })
            ]
        });
        if (activeModal === "context") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "approver-detail-grid",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Invoice No."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            value: selectedRow.invoiceNo,
                            readOnly: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Route"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            value: selectedRow.invoiceType,
                            readOnly: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Type"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            value: selectedRow.materialOrService,
                            readOnly: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Risk"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            value: selectedRow.highRisk,
                            readOnly: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Invoice Amount"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            value: $58080555b821a069$var$formatAmount(selectedRow.invoiceAmount),
                            readOnly: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "PO Number"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            value: (selectedRow.conditions || []).find((c)=>c.name === "PO Number")?.value || "9500011224",
                            readOnly: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "PO Prefix"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            value: (selectedRow.conditions || []).find((c)=>c.name === "PO Prefix")?.value || "PO-Series-9500",
                            readOnly: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Remarks"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                            rows: "3",
                            value: selectedRow.remarks,
                            readOnly: true
                        })
                    ]
                })
            ]
        });
        if (activeModal === "transactions") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "config-table",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                className: "approver-modal-table",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "Invoice No."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "Invoice Date"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "Invoice Amount"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "Deduction"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "PO / Non PO"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "Material / Service"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "PDF"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                        children: [
                            (Array.isArray(selectedRow.previousTransactions) ? selectedRow.previousTransactions : []).map((transaction, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: transaction.invoiceNo
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: transaction.invoiceDate
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: $58080555b821a069$var$formatAmount(transaction.invoiceAmount)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                            children: [
                                                transaction.anyDeduction || "-",
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: transaction.invoiceType
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: transaction.materialOrService
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: "text-button",
                                                children: transaction.pdfPath ? "View PDF" : "-"
                                            })
                                        })
                                    ]
                                }, index)),
                            Array.isArray(selectedRow.previousTransactions) && selectedRow.previousTransactions.length ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    colSpan: "7",
                                    children: "No previous transactions found."
                                })
                            })
                        ]
                    })
                ]
            })
        });
        if (activeModal === "audit") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "approver-modal-list",
            children: selectedRow.auditTrail.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                            children: [
                                "Step ",
                                index + 1
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: item
                        })
                    ]
                }, item))
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "approver-modal-list",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "Invoice"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: selectedRow.invoiceNo
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "Risk Score"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: selectedRow.highRisk
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "Reasons"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                            className: "approver-risk-list",
                            children: [
                                (selectedRow.highRiskReasons || []).map((reason)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: reason
                                    }, reason)),
                                selectedRow.highRiskReasons?.length ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: "No high risk reason is configured for this invoice."
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "approver-dashboard",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel approver-dashboard__hero",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "Invoice Approval Approver Dashboard"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-view__intro",
                                children: "Review pending invoices, manage holds, and inspect rejected cases from one approval workspace."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "approver-summary",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "approver-summary__card",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Pending"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: summary.pending
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "approver-summary__card",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "On Hold"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: summary.hold
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "approver-summary__card",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Rejected"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: summary.rejected
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "approver-summary__card approver-summary__card--risk",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "High Risk"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: summary.highRisk
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "workspace-panel approver-tabs",
                role: "tablist",
                "aria-label": "Approver queues",
                children: $58080555b821a069$var$APPROVER_TABS.map((tab)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: `ghost-button approver-tabs__button${activeTab === tab.key ? " is-active" : ""}`,
                        onClick: ()=>selectTab(tab.key),
                        children: tab.label
                    }, tab.key))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel approver-table-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "users-form__header",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: $58080555b821a069$var$APPROVER_TABS.find((tab)=>tab.key === activeTab)?.label
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "Select an invoice to review actions, conditions, and audit history."
                                })
                            ]
                        })
                    }),
                    activeTab === "pending" && loadingWorkflows ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-note",
                        children: "Loading pending approval workflows..."
                    }) : null,
                    activeTab === "pending" && workflowError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "config-note config-note--error",
                        children: workflowError
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "approver-table-wrap",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "approver-table",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice Id"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Invoice No."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Vendor Name (OCR)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Vendor Code"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Date"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Amount"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "PDF"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Material/Service"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "PO/Non PO"
                                            }),
                                            activeTab === "hold" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Hold By"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Pending With"
                                                    })
                                                ]
                                            }) : null,
                                            activeTab === "rejected" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Rejected By"
                                            }) : null,
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Risk"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Next Approver"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Action"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                    children: [
                                        visibleRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: selectedRow?.id === row.id ? "is-selected" : "",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.invoiceId
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.invoiceNo
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.vendorNameOcr
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.vendorCode
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.invoiceDate
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: $58080555b821a069$var$formatAmount(row.invoiceAmount)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.rawWorkflow?.uniqueName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "pdf-view-button",
                                                            onClick: ()=>(0, $e267546ad9d86d30$export$a38ce99a4bdccd4e)(row.invoiceId),
                                                            children: "View PDF"
                                                        }) : "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.materialOrService
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.invoiceType
                                                    }),
                                                    activeTab === "hold" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: row.holdBy || "-"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: row.pendingWith || "-"
                                                            })
                                                        ]
                                                    }) : null,
                                                    activeTab === "rejected" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.rejectedBy || "-"
                                                    }) : null,
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.highRisk === "High Risk" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "approver-risk approver-risk-button is-high",
                                                            onClick: ()=>{
                                                                setSelectedRowId(row.id);
                                                                setActiveModal("highRisk");
                                                            },
                                                            children: row.highRisk
                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "approver-risk",
                                                            children: row.highRisk
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.nextApprover || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "approver-action-icons",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "secondary-button",
                                                                title: "Invoice Summary",
                                                                onClick: ()=>{
                                                                    setSelectedRowId(row.id);
                                                                    setActiveModal("summary");
                                                                },
                                                                children: "\uD83D\uDCC4"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "secondary-button",
                                                                title: "Decision",
                                                                onClick: ()=>{
                                                                    setSelectedRowId(row.id);
                                                                    setActiveModal("decision");
                                                                },
                                                                children: "\u2699\uFE0F"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "secondary-button",
                                                                title: "Approval Context",
                                                                onClick: ()=>{
                                                                    setSelectedRowId(row.id);
                                                                    setActiveModal("context");
                                                                },
                                                                children: "\u2139\uFE0F"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "secondary-button",
                                                                title: "Previous Transactions",
                                                                onClick: ()=>{
                                                                    setSelectedRowId(row.id);
                                                                    setActiveModal("transactions");
                                                                },
                                                                children: "\u2935\uFE0F"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "secondary-button",
                                                                title: "Audit Trail",
                                                                onClick: ()=>{
                                                                    setSelectedRowId(row.id);
                                                                    setActiveModal("audit");
                                                                },
                                                                children: "\uD83E\uDDFE"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, row.id)),
                                        !visibleRows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                colSpan: tableColumnCount,
                                                children: "No invoices found for this queue."
                                            })
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            activeModal && selectedRow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "approver-modal-backdrop",
                role: "presentation",
                onClick: ()=>setActiveModal(""),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "approver-modal",
                    role: "dialog",
                    "aria-modal": "true",
                    onClick: (event)=>event.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "users-form__header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            children: activeModal === "summary" ? "Invoice Summary" : activeModal === "decision" ? "Decision" : activeModal === "context" ? "Approval Context" : activeModal === "transactions" ? "Previous Transactions" : activeModal === "audit" ? "Audit Trail" : "High Risk Analysis"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: selectedRow.invoiceNo
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "secondary-button",
                                    onClick: ()=>setActiveModal(""),
                                    children: "Close"
                                })
                            ]
                        }),
                        renderModalContent()
                    ]
                })
            }) : null
        ]
    });
}




var $acw62 = parcelRequire("acw62");



const $2e0d80b926e715a3$var$MAPPING_TYPES = [
    {
        key: "system_variables",
        label: "System Variables"
    },
    {
        key: "vendor_master",
        label: "Vendor Master"
    }
];
function $2e0d80b926e715a3$var$buildEmptySelections(context) {
    return {
        system_variables: Object.fromEntries((context.system_variables || []).map((item)=>[
                item.name,
                {
                    po_header: "",
                    po_mapping_type: "",
                    miro_header: "",
                    miro_mapping_type: ""
                }
            ])),
        vendor_master: Object.fromEntries((context.vendor_system_variables || []).map((item)=>[
                item.name,
                {
                    header: "",
                    mapped_type: ""
                }
            ]))
    };
}
function $2e0d80b926e715a3$export$2e2bcd8739ae039() {
    const [context, setContext] = (0, $acw62.useState)(null);
    const [activeType, setActiveType] = (0, $acw62.useState)("system_variables");
    const [selections, setSelections] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [matchingType, setMatchingType] = (0, $acw62.useState)(null);
    const [blockingActivate, setBlockingActivate] = (0, $acw62.useState)({});
    const [validationRows, setValidationRows] = (0, $acw62.useState)(new Set());
    function getMigoHeaderValue(mapped) {
        return mapped?.miro_header || mapped?.migo_header || "";
    }
    function confirmSystemSuggestion(variableName, field) {
        const mappingTypeField = field === "po_header" ? "po_mapping_type" : "miro_mapping_type";
        setSelections((current)=>({
                ...current,
                system_variables: {
                    ...current.system_variables,
                    [variableName]: {
                        ...current.system_variables[variableName],
                        [mappingTypeField]: "mapped"
                    }
                }
            }));
    }
    const currentRows = (0, $acw62.useMemo)(()=>{
        if (!context) return [];
        if (activeType === "system_variables") return context.invsystem_variables || [];
        if (activeType === "vendor_master") return context.vendor_system_variables || [];
        return [];
    }, [
        activeType,
        context
    ]);
    const optionsByType = (0, $acw62.useMemo)(()=>{
        if (!context) return {};
        return {
            system_variables: {
                migo: context.miro_headers || [],
                po: context.po_headers || []
            },
            vendor_master: context.vendorerp_headers || [],
            sac_master: context.sac_master_headers || [],
            wholdtax_master: context.wholdtax_master_headers || [],
            gsttax_master: context.gsttax_master_headers || [],
            hsn_master: context.hsn_master_headers || []
        };
    }, [
        context
    ]);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        async function loadContext() {
            setLoading(true);
            setError("");
            try {
                const response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/mapping/context/");
                if (cancelled) return;
                const nextContext = response.data;
                setContext(nextContext);
                setSelections($2e0d80b926e715a3$var$buildEmptySelections(nextContext));
            } catch (requestError) {
                if (!cancelled) setError(requestError.message || "Unable to load mapping context.");
            } finally{
                if (!cancelled) setLoading(false);
            }
        }
        loadContext();
        return ()=>{
            cancelled = true;
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        async function loadSavedMapping() {
            if (!context || !selections) return;
            setStatus("");
            setError("");
            try {
                const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
                const response = await fetch("/api/inv/mapping/data/", {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRFToken": csrfToken
                    },
                    body: JSON.stringify({
                        type: activeType
                    })
                });
                const payload = await response.json();
                if (!response.ok || !payload.success) throw new Error(payload.error || "Unable to load saved mappings.");
                if (cancelled) return;
                setSelections((current)=>({
                        ...current,
                        [activeType]: activeType === "system_variables" ? {
                            ...current[activeType],
                            ...payload.data
                        } : {
                            ...current[activeType],
                            ...payload.data
                        }
                    }));
                setMatchingType(payload.matching_type || null);
                setBlockingActivate(payload.blocking_activate || {});
            } catch (requestError) {
                if (!cancelled) setError(requestError.message || "Unable to load saved mappings.");
            }
        }
        loadSavedMapping();
        return ()=>{
            cancelled = true;
        };
    }, [
        activeType,
        context,
        selections ? "ready" : "empty"
    ]);
    function updateSystemSelection(variableName, field, value) {
        setSelections((current)=>{
            const mappingTypeField = field === "po_header" ? "po_mapping_type" : field === "miro_header" ? "miro_mapping_type" : null;
            return {
                ...current,
                system_variables: {
                    ...current.system_variables,
                    [variableName]: {
                        ...current.system_variables[variableName],
                        [field]: value,
                        ...mappingTypeField ? {
                            [mappingTypeField]: value ? "mapped" : ""
                        } : {}
                    }
                }
            };
        });
    }
    function updateSingleSelection(type, variableName, value) {
        setSelections((current)=>({
                ...current,
                [type]: {
                    ...current[type],
                    [variableName]: {
                        header: value,
                        mapped_type: value ? "mapped" : ""
                    }
                }
            }));
    }
    function validateSystemVariables() {
        const rows = selections.system_variables;
        const errors = [];
        const invalidRows = [];
        currentRows.forEach((row)=>{
            const mapped = rows[row.name] || {};
            if (row.mandatory && !getMigoHeaderValue(mapped)) {
                errors.push(`${row.name}: MIGO header is required`);
                invalidRows.push(row.name);
            }
        });
        return {
            errors: errors,
            invalidRows: invalidRows
        };
    }
    function validateMasterSelections(type) {
        const errors = [];
        const rows = selections[type];
        const invalidRows = [];
        currentRows.forEach((row)=>{
            if (row.mandatory && !rows[row.name]) {
                errors.push(`${row.name}: mapping is required`);
                invalidRows.push(row.name);
            }
        });
        if (type === "vendor_master" && blockingActivate.account_blocking_activate === "Y" && !rows["VendorBlocked(Y/N)"]) {
            errors.push("VendorBlocked(Y/N): mapping is required when Vendor Master blocking is active");
            invalidRows.push("VendorBlocked(Y/N)");
        }
        return {
            errors: errors,
            invalidRows: invalidRows
        };
    }
    function buildSavePayload() {
        if (activeType === "system_variables") return {
            type: activeType,
            mappings: currentRows.map((row)=>({
                    system_variable: row.name,
                    po_header: selections.system_variables[row.name]?.po_mapping_type === "mapped" ? selections.system_variables[row.name]?.po_header || "" : "",
                    migo_header: selections.system_variables[row.name]?.miro_mapping_type === "mapped" ? getMigoHeaderValue(selections.system_variables[row.name]) : ""
                })),
            mappingss: {}
        };
        return {
            type: activeType,
            mappings: [],
            mappingss: Object.fromEntries(Object.entries(selections[activeType]).map(([key, value])=>[
                    key,
                    value?.mapped_type === "mapped" ? value.header : ""
                ]))
        };
    }
    async function handleSave() {
        setSaving(true);
        setError("");
        try {
            const validationResult = activeType === "system_variables" ? validateSystemVariables() : validateMasterSelections(activeType);
            setValidationRows(new Set(validationResult.invalidRows));
            if (validationResult.errors.length) {
                if (validationResult.invalidRows.length) document.querySelector(`[data-row="${validationResult.invalidRows[0]}"]`)?.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
                throw new Error(validationResult.errors.join(" | "));
            }
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/inv/mapping/save/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify(buildSavePayload())
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") throw new Error(payload.message || "Unable to save mappings.");
            setValidationRows(new Set());
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: payload.message || "Mappings saved successfully.",
                confirmButtonText: "OK"
            });
        } catch (requestError) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Save Failed",
                text: requestError.message || "Unable to save mappings.",
                confirmButtonText: "OK"
            });
            setError(requestError.message || "Unable to save mappings.");
        } finally{
            setSaving(false);
        }
    }
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "workspace-panel",
        children: "Loading header mapping\u2026"
    });
    if (!context || !selections) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "workspace-panel",
        children: "Mapping context is unavailable."
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "mapping-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "workspace-panel mapping-view__hero",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "Header Mapping"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "Mapping Configuration"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-view__intro",
                                children: "Match uploaded ERP headers to the system variables and master fields used by the Django backend validations."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mapping-view__controls",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "config-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Mapping Type"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: activeType,
                                        onChange: (event)=>setActiveType(event.target.value),
                                        children: $2e0d80b926e715a3$var$MAPPING_TYPES.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: option.key,
                                                children: option.label
                                            }, option.key))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary-button",
                                type: "button",
                                disabled: saving,
                                onClick: handleSave,
                                children: saving ? "Saving..." : "Save Mapping"
                            })
                        ]
                    })
                ]
            }),
            activeType === "system_variables" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mapping-note-card",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "Important:"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                        className: "mapping-note-list",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    "It is recommended to map all the fields which are mandatory as per your ERP. Otherwise, the accounting entry will be ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "rejected"
                                    }),
                                    " upon uploading the template."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    "In addition to above, fields which are marked with ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "*"
                                    }),
                                    " are",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: " mandatory"
                                    }),
                                    " to map."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    "Fields which are marked with ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "**"
                                    }),
                                    " are ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "conditional mandatory"
                                    }),
                                    " ",
                                    "to map depending on basic configuration settings."
                                ]
                            })
                        ]
                    })
                ]
            }) : null,
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "workspace-panel",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "config-table",
                    children: activeType === "system_variables" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "System Variable"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "MIGO Header"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "PO Header"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: currentRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        "data-row": row.name,
                                        className: validationRows.has(row.name) ? "mapping-row-error" : "",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mapping-variable",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: row.name
                                                            }),
                                                            row.mandatory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "mandatory-star",
                                                                children: "*"
                                                            }) : null,
                                                            row.conditional_mandatory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "mandatory-star",
                                                                children: "**"
                                                            }) : null
                                                        ]
                                                    }),
                                                    row.tooltip ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "mapping-tooltip",
                                                        children: row.tooltip
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        className: "mapping-select mapping-select--migo",
                                                        value: selections.system_variables[row.name]?.miro_header || "",
                                                        onChange: (event)=>updateSystemSelection(row.name, "miro_header", event.target.value),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "",
                                                                children: "-- Select MIGO Header --"
                                                            }),
                                                            (optionsByType.system_variables.migo || []).map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: header,
                                                                    children: header
                                                                }, header))
                                                        ]
                                                    }),
                                                    selections.system_variables[row.name]?.miro_mapping_type === "mapped" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mapping-badge mapping-badge--mapped",
                                                        children: "\u2713 Saved"
                                                    }),
                                                    selections.system_variables[row.name]?.miro_mapping_type === "suggestion" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mapping-badge mapping-badge--suggested mapping-badge--clickable",
                                                        onClick: ()=>confirmSystemSuggestion(row.name, "miro_header"),
                                                        title: "Click to accept this suggestion",
                                                        children: "\uD83D\uDCA1 Suggested"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        className: "mapping-select mapping-select--po",
                                                        value: selections.system_variables[row.name]?.po_header || "",
                                                        onChange: (event)=>updateSystemSelection(row.name, "po_header", event.target.value),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "",
                                                                children: "-- Select PO Header --"
                                                            }),
                                                            (optionsByType.system_variables.po || []).map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: header,
                                                                    children: header
                                                                }, header))
                                                        ]
                                                    }),
                                                    selections.system_variables[row.name]?.po_mapping_type === "mapped" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mapping-badge mapping-badge--mapped",
                                                        children: "\u2713 Saved"
                                                    }),
                                                    selections.system_variables[row.name]?.po_mapping_type === "suggestion" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mapping-badge mapping-badge--suggested mapping-badge--clickable",
                                                        onClick: ()=>confirmSystemSuggestion(row.name, "po_header"),
                                                        title: "Click to accept this suggestion",
                                                        children: "\uD83D\uDCA1 Suggested"
                                                    })
                                                ]
                                            })
                                        ]
                                    }, row.name))
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "System Variable"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "ERP Header"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: currentRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mapping-variable",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: row.name
                                                            }),
                                                            row.mandatory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "mandatory-star",
                                                                children: "*"
                                                            }) : null,
                                                            row.conditional_mandatory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "mandatory-star",
                                                                children: "**"
                                                            }) : null
                                                        ]
                                                    }),
                                                    row.tooltip ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "mapping-tooltip",
                                                        children: row.tooltip
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        value: selections[activeType][row.name]?.header || "",
                                                        onChange: (event)=>updateSingleSelection(activeType, row.name, event.target.value),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "",
                                                                children: "-- Select Header --"
                                                            }),
                                                            (optionsByType[activeType] || []).map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: header,
                                                                    children: header
                                                                }, header))
                                                        ]
                                                    }),
                                                    selections[activeType][row.name]?.mapped_type === "mapped" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mapping-badge mapping-badge--mapped",
                                                        children: "\u2713 Saved"
                                                    }),
                                                    selections[activeType][row.name]?.mapped_type === "suggestion" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mapping-badge mapping-badge--suggested",
                                                        children: "\uD83D\uDCA1 Suggested"
                                                    })
                                                ]
                                            })
                                        ]
                                    }, row.name))
                            })
                        ]
                    })
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


const $51817ccb103aae55$var$HEADER_FIELDS = [
    {
        key: "po_header",
        label: "Upload PO Header Excel",
        help: "Expected PO column headers from your source workbook."
    },
    {
        key: "miro_header",
        label: "Upload MIGO Header Excel",
        help: "Upload the MIRO or MIGO file used for invoice matching."
    },
    {
        key: "vmaster_header",
        label: "Upload Vendor Master Header Excel",
        help: "Vendor master columns used for vendor validations and mapping."
    }
];
function $51817ccb103aae55$var$createInitialFiles() {
    return $51817ccb103aae55$var$HEADER_FIELDS.reduce((accumulator, field)=>{
        accumulator[field.key] = null;
        return accumulator;
    }, {});
}
function $51817ccb103aae55$export$2e2bcd8739ae039() {
    const [files, setFiles] = (0, $acw62.useState)($51817ccb103aae55$var$createInitialFiles);
    const [uploadStatus, setUploadStatus] = (0, $acw62.useState)({});
    const [loadingStatus, setLoadingStatus] = (0, $acw62.useState)(true);
    const [submitting, setSubmitting] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const selectedCount = (0, $acw62.useMemo)(()=>Object.values(files).filter(Boolean).length, [
        files
    ]);
    const uploadedCount = (0, $acw62.useMemo)(()=>Object.values(uploadStatus || {}).filter(Boolean).length, [
        uploadStatus
    ]);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        async function loadUploadStatus() {
            setLoadingStatus(true);
            try {
                const response = await fetch("/api/upload-headers/status/", {
                    credentials: "include",
                    headers: {
                        Accept: "application/json"
                    }
                });
                const payload = await response.json();
                if (!response.ok) throw new Error(payload.message || "Unable to load header upload status.");
                if (!cancelled) setUploadStatus(payload.status || {});
            } catch (requestError) {
                if (!cancelled) setError(requestError.message || "Unable to load header upload status.");
            } finally{
                if (!cancelled) setLoadingStatus(false);
            }
        }
        loadUploadStatus();
        return ()=>{
            cancelled = true;
        };
    }, []);
    function handleFileChange(fieldKey, event) {
        const file = event.target.files?.[0] || null;
        setFiles((current)=>({
                ...current,
                [fieldKey]: file
            }));
    }
    async function handleSubmit(event) {
        event.preventDefault();
        setSubmitting(true);
        setStatus("");
        setError("");
        if (!selectedCount) {
            setSubmitting(false);
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Select at least one header file before uploading.",
                confirmButtonText: "OK"
            });
            return;
        }
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const formData = new FormData();
            $51817ccb103aae55$var$HEADER_FIELDS.forEach((field)=>{
                if (files[field.key]) formData.append(field.key, files[field.key]);
            });
            const response = await fetch("/api/inv/upload-headers/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "X-CSRFToken": csrfToken
                },
                body: formData
            });
            const payload = await response.json();
            if (!response.ok || payload.status !== "success") (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Unable to upload header files.",
                confirmButtonText: "OK"
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Success",
                text: payload.message || "Headers uploaded successfully.",
                confirmButtonText: "OK"
            });
            setUploadStatus(payload.uploadStatus || {});
            setFiles($51817ccb103aae55$var$createInitialFiles());
        } catch (requestError) {
            (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Error",
                text: "Upload failed. Try again.",
                confirmButtonText: "OK"
            });
        } finally{
            setSubmitting(false);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "upload-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "workspace-panel upload-view__hero",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "eyebrow",
                            children: "Header Library"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            children: "Upload Source Headers"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "config-view__intro",
                            children: "Manage uploaded header definitions by source type. Re-uploading a type will replace its saved header set for the current company."
                        })
                    ]
                })
            }),
            status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--success",
                children: status
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "config-banner config-banner--error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                className: "upload-grid",
                onSubmit: handleSubmit,
                children: [
                    $51817ccb103aae55$var$HEADER_FIELDS.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                            className: "upload-card",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "upload-card__head",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "upload-card__title-row",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    children: field.label
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: `pill${uploadStatus[field.key] ? "" : " pill--muted"}`,
                                                    children: uploadStatus[field.key] ? "Uploaded" : "Not uploaded"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: field.help
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "upload-card__input",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Select Excel file"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "file",
                                            accept: ".xlsx,.xls",
                                            onChange: (event)=>handleFileChange(field.key, event)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "upload-card__meta",
                                    children: files[field.key] ? files[field.key].name : "No file selected"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "config-note",
                                    children: uploadStatus[field.key] ? "A header set is already saved for this type. Upload again to replace it." : "No saved header set found yet for this type."
                                })
                            ]
                        }, field.key)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "workspace-panel upload-view__actions",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "eyebrow",
                                        children: "Submit"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        children: "Upload header set"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "config-note",
                                        children: "You can upload one file or several in the same request. Existing saved header sets for the company will be updated by type."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary-button",
                                type: "submit",
                                disabled: submitting,
                                children: submitting ? "Uploading..." : "Upload Headers"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");



const $6d5e38e7223b7db2$var$dataTypeOptions = [
    {
        value: "migo",
        label: "MIGO"
    },
    {
        value: "po",
        label: "Purchase Order (PO)"
    }
];
function $6d5e38e7223b7db2$var$formatCellValue(value) {
    if (value === null || value === undefined || value === "") return "-";
    if (typeof value === "object") return JSON.stringify(value);
    return String(value);
}
function $6d5e38e7223b7db2$export$2e2bcd8739ae039() {
    const [dataType, setDataType] = (0, $acw62.useState)("");
    const [file, setFile] = (0, $acw62.useState)(null);
    const [tableRows, setTableRows] = (0, $acw62.useState)([]);
    const [tooltips, setTooltips] = (0, $acw62.useState)({});
    const [loadingTable, setLoadingTable] = (0, $acw62.useState)(false);
    const [submitting, setSubmitting] = (0, $acw62.useState)(false);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [missingData, setMissingData] = (0, $acw62.useState)([]);
    const [vendorSearch, setVendorSearch] = (0, $acw62.useState)("");
    const [vendorSuggestions, setVendorSuggestions] = (0, $acw62.useState)([]);
    const [selectedVendor, setSelectedVendor] = (0, $acw62.useState)(null);
    const [showVendorModal, setShowVendorModal] = (0, $acw62.useState)(false);
    console.log("MODAL STATE:", {
        showVendorModal: showVendorModal,
        selectedVendor: selectedVendor
    });
    const headers = (0, $acw62.useMemo)(()=>{
        if (!tableRows.length) return [];
        return Object.keys(tableRows[0]);
    }, [
        tableRows
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!showVendorModal) return;
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") {
                setShowVendorModal(false);
                setSelectedVendor(null);
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        showVendorModal
    ]);
    async function handleVendorSelect(vendorCode) {
        try {
            console.log("1. Selected vendor code:", vendorCode);
            const response = await fetch(`/api/vendor-master/details/?vendor_code=${encodeURIComponent(vendorCode)}`, {
                credentials: "include"
            });
            console.log("2. Response status:", response.status);
            const payload = await response.json();
            console.log("3. Vendor payload:", payload);
            if (!response.ok || payload.status === "error") throw new Error(payload.message || "Unable to load vendor.");
            console.log("4. Setting vendor:", payload.vendor);
            setSelectedVendor(payload.vendor);
            setVendorSearch(`${payload.vendor.VendorCode} - ${payload.vendor.VendorName}`);
            setVendorSuggestions([]);
            console.log("5. Opening modal");
            setShowVendorModal(true);
        } catch (error) {
            console.error("Vendor select error:", error);
            alert(error.message);
        }
    }
    async function handleVendorSearch(value) {
        setVendorSearch(value);
        if (!value.trim()) {
            setVendorSuggestions([]);
            return;
        }
        try {
            const response = await fetch(`/api/vendor-master/search/?q=${encodeURIComponent(value)}`, {
                credentials: "include"
            });
            const payload = await response.json();
            setVendorSuggestions(payload.vendors || []);
        } catch (error) {
            console.error("Vendor search failed:", error);
            setVendorSuggestions([]);
        }
    }
    async function handleVendorSave() {
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const response = await fetch("/api/vendor-master/update/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken
                },
                body: JSON.stringify({
                    VendorCode: selectedVendor.VendorCode,
                    VendorName: selectedVendor.VendorName,
                    GSTNo: selectedVendor.GSTNo,
                    LDCNo: selectedVendor.LDCNo,
                    LDCThreshold: selectedVendor.LDCThreshold,
                    LDCStartDate: selectedVendor.LDCStartDate,
                    LDCEndDate: selectedVendor.LDCEndDate,
                    LDCWTCode: selectedVendor.LDCWTCode,
                    BlockedYN: selectedVendor.BlockedYN,
                    MSMERegisteredYN: selectedVendor.MSMERegisteredYN,
                    MSMENumber: selectedVendor.MSMENumber
                })
            });
            const payload = await response.json();
            if (!response.ok || payload.status === "error") throw new Error(payload.message || "Unable to update vendor.");
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Vendor Updated",
                text: payload.message || "Vendor updated successfully.",
                confirmButtonText: "OK"
            });
            setShowVendorModal(false);
            setSelectedVendor(null);
            await loadSystemData("vendormaster");
        } catch (error) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Update Failed",
                text: error.message || "Failed to update vendor.",
                confirmButtonText: "OK"
            });
        }
    }
    async function refreshMissingSystemData() {
        try {
            const response = await fetch("/api/missingsytem-data/", {
                credentials: "include"
            });
            const payload = await response.json();
            if (!response.ok || payload.success === false) return;
            setMissingData(Array.isArray(payload.missing) ? payload.missing : []);
        } catch (requestError) {
            setMissingData([]);
        }
    }
    async function loadSystemData(type, { clearMessages: clearMessages = true } = {}) {
        if (!type) {
            setTableRows([]);
            setTooltips({});
            return;
        }
        setLoadingTable(true);
        setError("");
        if (clearMessages) setStatus("");
        try {
            const response = await fetch(`/api/inv/fetch-data/?type=${encodeURIComponent(type)}`, {
                credentials: "include"
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!response.ok || payload?.error) throw new Error(payload?.error || `Unable to load ${type} data.`);
            setTableRows(payload?.data || []);
            setTooltips(payload?.tooltips || {});
        } catch (requestError) {
            setTableRows([]);
            setTooltips({});
            setError(requestError.message || "Unable to load system data.");
        } finally{
            setLoadingTable(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        if (!dataType) {
            setTableRows([]);
            setTooltips({});
            return;
        }
        loadSystemData(dataType);
    }, [
        dataType
    ]);
    (0, $acw62.useEffect)(()=>{
        refreshMissingSystemData();
    }, []);
    async function handleUpload(event) {
        event.preventDefault();
        setError("");
        if (!dataType) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "warning",
                title: "Missing Information",
                text: "Please select a data type."
            });
            return;
        }
        if (!file) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "warning",
                title: "Missing Information",
                text: "Please choose a file to upload."
            });
            return;
        }
        setSubmitting(true);
        try {
            const csrfToken = await (0, $96e14f2a7c3555e4$export$84e83902d3a16987)();
            const formData = new FormData();
            formData.append("data_type", dataType);
            formData.append("excel_file", file);
            const response = await fetch("/api/inv/upload-data/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "X-CSRFToken": csrfToken
                },
                body: formData
            });
            const isJson = response.headers.get("content-type")?.includes("application/json");
            const payload = isJson ? await response.json() : null;
            if (!isJson) throw new Error("Upload did not return JSON. Please verify the selected file and server logs.");
            if (!response.ok || payload?.error) throw new Error(payload?.error || payload?.message || "Unable to upload file.");
            if (dataType === "vendormaster") await (0, $02f53f124c46dca8$export$b2786197665b639d)(payload);
            else await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "success",
                title: "Upload Successful",
                text: payload?.message || "File uploaded successfully.",
                confirmButtonText: "OK"
            });
            setFile(null);
            if (dataType) await loadSystemData(dataType, {
                clearMessages: false
            });
            await refreshMissingSystemData();
        } catch (requestError) {
            await (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
                icon: "error",
                title: "Upload Failed",
                text: requestError.message || "Something went wrong while uploading the file.",
                confirmButtonText: "OK"
            });
            setError(requestError.message || "Something went wrong while uploading the file.");
        } finally{
            setSubmitting(false);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "processor-view",
        children: [
            missingData.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "config-banner config-banner--error",
                children: [
                    "Missing system data: ",
                    missingData.join(", "),
                    ". Upload these datasets to avoid invoice processing gaps."
                ]
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "upload-grid upload-grid--stacked",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "upload-card",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "upload-card__head",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        children: "Upload Data File"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "Select a data category, upload the source file, and let Django process it."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                className: "gl-form upload-form",
                                onSubmit: handleUpload,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "config-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Data Type"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: dataType,
                                                onChange: (event)=>setDataType(event.target.value),
                                                required: true,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "-- Select Type --"
                                                    }),
                                                    $6d5e38e7223b7db2$var$dataTypeOptions.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: option.value,
                                                            children: option.label
                                                        }, option.value))
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "config-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Source File"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "file",
                                                accept: ".xlsx,.xls,.json",
                                                onChange: (event)=>setFile(event.target.files?.[0] || null),
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "upload-form__button",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "primary-button",
                                            type: "submit",
                                            disabled: submitting,
                                            children: submitting ? "Uploading..." : "Upload"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "upload-card__meta",
                                children: file ? `Selected file: ${file.name}` : "Accepted formats: .xlsx, .xls, .json"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "workspace-panel",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "processor-table__header",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "eyebrow",
                                            children: dataType
                                        })
                                    }),
                                    dataType ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "ghost-button",
                                        type: "button",
                                        onClick: ()=>loadSystemData(dataType),
                                        disabled: loadingTable,
                                        children: loadingTable ? "Refreshing..." : "Refresh"
                                    }) : null
                                ]
                            }),
                            dataType === "vendormaster" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "vendor-search",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        placeholder: "Search by Vendor Code or Vendor Name",
                                        value: vendorSearch,
                                        onChange: (e)=>handleVendorSearch(e.target.value)
                                    }),
                                    vendorSuggestions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "vendor-suggestions",
                                        children: vendorSuggestions.map((vendor)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "vendor-suggestion-item",
                                                onClick: ()=>handleVendorSelect(vendor.VendorCode),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: vendor.VendorCode
                                                    }),
                                                    " - ",
                                                    vendor.VendorName
                                                ]
                                            }, vendor.VendorCode))
                                    })
                                ]
                            }),
                            dataType === "migo" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mapping-note-card",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Note"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "The headers below are system-defined headers. Verify one invoice with the uploaded data to confirm the header mapping is correct in basic configuration."
                                    })
                                ]
                            }) : null,
                            loadingTable ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "config-note",
                                children: "Loading system data\u2026"
                            }) : !dataType ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "empty-state",
                                children: "Choose a data type to load the corresponding system data preview."
                            }) : headers.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "config-table processor-table",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    className: "systemdata-table",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                children: headers.map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        title: tooltips[header] || "",
                                                        children: header
                                                    }, header))
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: tableRows.map((row, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                    children: headers.map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: $6d5e38e7223b7db2$var$formatCellValue(row[header])
                                                        }, `${index}-${header}`))
                                                }, `${dataType}-${index}`))
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "empty-state",
                                children: "No data found for the selected type."
                            })
                        ]
                    })
                ]
            }),
            showVendorModal && selectedVendor && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "modal-overlay",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "modal-content",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "modal-header",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Edit Vendor"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "modal-body",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        "Vendor Name",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedVendor.VendorName || "",
                                            onChange: (e)=>setSelectedVendor({
                                                    ...selectedVendor,
                                                    VendorName: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        "Vendor Code",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedVendor.VendorCode || "",
                                            disabled: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        "GST No",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedVendor.GSTNo || "",
                                            onChange: (e)=>setSelectedVendor({
                                                    ...selectedVendor,
                                                    GSTNo: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        "LDC No",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedVendor.LDCNo || "",
                                            onChange: (e)=>setSelectedVendor({
                                                    ...selectedVendor,
                                                    LDCNo: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        "LDC Threshold",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedVendor.LDCThreshold || "",
                                            onChange: (e)=>setSelectedVendor({
                                                    ...selectedVendor,
                                                    LDCThreshold: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        "LDC Start Date",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedVendor.LDCStartDate || "",
                                            onChange: (e)=>setSelectedVendor({
                                                    ...selectedVendor,
                                                    LDCStartDate: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        "LDC End Date",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedVendor.LDCEndDate || "",
                                            onChange: (e)=>setSelectedVendor({
                                                    ...selectedVendor,
                                                    LDCEndDate: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        "LDC WT Code",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedVendor.LDCWTCode || "",
                                            onChange: (e)=>setSelectedVendor({
                                                    ...selectedVendor,
                                                    LDCWTCode: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        "Blocked Y/N",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedVendor.BlockedYN || "",
                                            onChange: (e)=>setSelectedVendor({
                                                    ...selectedVendor,
                                                    BlockedYN: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        "MSME Registered Y/N",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedVendor.MSMERegisteredYN || "",
                                            onChange: (e)=>setSelectedVendor({
                                                    ...selectedVendor,
                                                    MSMERegisteredYN: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        "MSME Number",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: selectedVendor.MSMENumber || "",
                                            onChange: (e)=>setSelectedVendor({
                                                    ...selectedVendor,
                                                    MSMENumber: e.target.value
                                                })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "modal-footer",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "primary-button",
                                    type: "button",
                                    onClick: handleVendorSave,
                                    children: "Save"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "ghost-button",
                                    type: "button",
                                    onClick: ()=>{
                                        setShowVendorModal(false);
                                        setSelectedVendor(null);
                                    },
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


const $5a208ad29556473c$var$MAX_IDENTIFIERS = 6;
const $5a208ad29556473c$var$EMPTY_IDENTIFIER = {
    secondaryHeader: "",
    primaryHeader: ""
};
const $5a208ad29556473c$var$createEmptyIdentifiers = ()=>Array.from({
        length: $5a208ad29556473c$var$MAX_IDENTIFIERS
    }, ()=>({
            ...$5a208ad29556473c$var$EMPTY_IDENTIFIER
        }));
const $5a208ad29556473c$var$getIdentifierKey = (index)=>`identifier${index + 1}`;
function $5a208ad29556473c$export$2e2bcd8739ae039() {
    const [activeTab, setActiveTab] = (0, $acw62.useState)("add");
    // ---------------------------------------------------------
    // Configured reports
    // ---------------------------------------------------------
    const [reports, setReports] = (0, $acw62.useState)([]);
    const [loadingReports, setLoadingReports] = (0, $acw62.useState)(false);
    // ---------------------------------------------------------
    // Form
    // ---------------------------------------------------------
    const [reportName, setReportName] = (0, $acw62.useState)("");
    const [selectedFile, setSelectedFile] = (0, $acw62.useState)(null);
    const [headers, setHeaders] = (0, $acw62.useState)([]);
    const [identifiers, setIdentifiers] = (0, $acw62.useState)($5a208ad29556473c$var$createEmptyIdentifiers());
    const [connectingReport, setConnectingReport] = (0, $acw62.useState)("");
    // ---------------------------------------------------------
    // UI state
    // ---------------------------------------------------------
    const [editingReportId, setEditingReportId] = (0, $acw62.useState)(null);
    const [loadingDetails, setLoadingDetails] = (0, $acw62.useState)(false);
    const [loadingFileHeaders, setLoadingFileHeaders] = (0, $acw62.useState)(false);
    const [savingReport, setSavingReport] = (0, $acw62.useState)(false);
    const [detailsReport, setDetailsReport] = (0, $acw62.useState)(null);
    const [message, setMessage] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [success, setSuccess] = (0, $acw62.useState)("");
    // ---------------------------------------------------------
    // Primary report headers
    // ---------------------------------------------------------
    const [primaryHeaders, setPrimaryHeaders] = (0, $acw62.useState)({
        PO: [],
        GRN: [],
        VendorMasters: []
    });
    const [uploadReportId, setUploadReportId] = (0, $acw62.useState)("");
    const [uploadFile, setUploadFile] = (0, $acw62.useState)(null);
    const [uploadRows, setUploadRows] = (0, $acw62.useState)([]);
    const [uploadHeaders, setUploadHeaders] = (0, $acw62.useState)([]);
    const [uploadPage, setUploadPage] = (0, $acw62.useState)(1);
    const [uploadPageSize] = (0, $acw62.useState)(25);
    const [uploadTotalCount, setUploadTotalCount] = (0, $acw62.useState)(0);
    const [uploadTotalPages, setUploadTotalPages] = (0, $acw62.useState)(0);
    const [loadingUploadData, setLoadingUploadData] = (0, $acw62.useState)(false);
    const [uploadingReport, setUploadingReport] = (0, $acw62.useState)(false);
    // ---------------------------------------------------------
    // Load primary report headers
    // ---------------------------------------------------------
    (0, $acw62.useEffect)(()=>{
        loadPrimaryHeaders();
        loadReports();
    }, []);
    async function loadPrimaryHeaders() {
        try {
            const response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/primary-reports/headers/", {
                method: "GET"
            });
            const data = response?.data || {};
            setPrimaryHeaders({
                PO: Array.isArray(data.PO) ? data.PO : [],
                GRN: Array.isArray(data.GRN) ? data.GRN : [],
                VendorMasters: Array.isArray(data.VendorMasters) ? data.VendorMasters : []
            });
        } catch (err) {
            setError(err?.message || "Unable to load primary report headers.");
        }
    }
    // ---------------------------------------------------------
    // Load configured reports
    // ---------------------------------------------------------
    async function loadReports() {
        setLoadingReports(true);
        try {
            const response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/secondary-reports/", {
                method: "GET"
            });
            const reportList = response?.data?.reports;
            setReports(Array.isArray(reportList) ? reportList : []);
        } catch (err) {
            setError(err?.message || "Unable to load configured reports.");
        } finally{
            setLoadingReports(false);
        }
    }
    // ---------------------------------------------------------
    // Reset form
    // ---------------------------------------------------------
    function resetForm() {
        setReportName("");
        setSelectedFile(null);
        setHeaders([]);
        setIdentifiers($5a208ad29556473c$var$createEmptyIdentifiers());
        setConnectingReport("");
        setEditingReportId(null);
        // Reset actual file input.
        const fileInput = document.getElementById("additional-report-file");
        if (fileInput) fileInput.value = "";
    }
    // ---------------------------------------------------------
    // Add mode
    // ---------------------------------------------------------
    function startNewReport() {
        setError("");
        setMessage("");
        resetForm();
        setActiveTab("add");
    }
    // ---------------------------------------------------------
    // File selection
    // ---------------------------------------------------------
    async function handleFileChange(event) {
        const file = event.target.files?.[0];
        if (!file) return;
        setError("");
        setMessage("");
        setSelectedFile(file);
        setLoadingFileHeaders(true);
        try {
            const formData = new FormData();
            formData.append("file", file);
            const response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/secondary-reports/headers/", {
                method: "POST",
                body: formData
            });
            const newHeaders = response?.headers || response?.data?.headers || [];
            if (!Array.isArray(newHeaders)) throw new Error("Backend did not return valid report headers.");
            if (!newHeaders.length) throw new Error("No headers were found in the selected XLSX file.");
            // -----------------------------------------------------
            // IMPORTANT:
            // New XLSX replaces the current headers.
            // Preserve identifiers whose secondary header still
            // exists. Clear only invalid mappings.
            // -----------------------------------------------------
            setHeaders(newHeaders);
            setIdentifiers((previous)=>previous.map((item)=>{
                    if (item.secondaryHeader && newHeaders.includes(item.secondaryHeader)) return item;
                    return {
                        secondaryHeader: "",
                        primaryHeader: ""
                    };
                }));
            setMessage(`XLSX loaded successfully. ${newHeaders.length} headers found.`);
        } catch (err) {
            setSelectedFile(null);
            setError(err?.message || "Unable to process the selected XLSX file.");
        } finally{
            setLoadingFileHeaders(false);
        }
    }
    // ---------------------------------------------------------
    // Identifier update
    // ---------------------------------------------------------
    function updateIdentifier(index, field, value) {
        setIdentifiers((previous)=>previous.map((item, itemIndex)=>{
                if (itemIndex !== index) return item;
                const updated = {
                    ...item,
                    [field]: value
                };
                // If the secondary header changes, keep the primary
                // mapping for now. The user can change it separately.
                return updated;
            }));
    }
    // ---------------------------------------------------------
    // Prevent duplicate secondary headers
    // ---------------------------------------------------------
    const selectedSecondaryHeaders = (0, $acw62.useMemo)(()=>{
        return identifiers.map((item)=>item.secondaryHeader).filter(Boolean);
    }, [
        identifiers
    ]);
    function isSecondaryHeaderAlreadySelected(header, currentIndex) {
        return identifiers.some((item, index)=>index !== currentIndex && item.secondaryHeader === header);
    }
    // ---------------------------------------------------------
    // Available primary headers
    // ---------------------------------------------------------
    const availablePrimaryHeaders = connectingReport ? primaryHeaders[connectingReport] || [] : [];
    // ---------------------------------------------------------
    // Primary report change
    // ---------------------------------------------------------
    function handleConnectingReportChange(value) {
        setConnectingReport(value);
        // Primary mappings belong to the selected primary report.
        // Therefore clear them when the primary report changes.
        setIdentifiers((previous)=>previous.map((item)=>({
                    ...item,
                    primaryHeader: ""
                })));
    }
    // ---------------------------------------------------------
    // Validation
    // ---------------------------------------------------------
    function validateForm() {
        if (!reportName.trim()) return "Report name is required.";
        if (!headers.length) return "Please select an XLSX file first.";
        if (!connectingReport) return "Please select a primary report.";
        const configuredIdentifiers = identifiers.filter((item)=>item.secondaryHeader);
        if (!configuredIdentifiers.length) return "Please configure at least one identifier.";
        for(let index = 0; index < identifiers.length; index++){
            const item = identifiers[index];
            if (!item.secondaryHeader) {
                if (item.primaryHeader) return `Please select a secondary header for Identifier ${index + 1}.`;
                continue;
            }
            if (!item.primaryHeader) return `Please select a connecting column for Identifier ${index + 1}.`;
            if (isSecondaryHeaderAlreadySelected(item.secondaryHeader, index)) return `The header "${item.secondaryHeader}" is already selected for another identifier.`;
        }
        return null;
    }
    //   ---------------------------------------------------------
    //   load data when report chnages
    // ---------------------------------------------------------
    const loadUploadReportData = async (reportId, page = 1)=>{
        if (!reportId) {
            setUploadRows([]);
            setUploadHeaders([]);
            setUploadTotalCount(0);
            setUploadTotalPages(0);
            return;
        }
        try {
            setLoadingUploadData(true);
            const response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)(`/secondary-reports/data/${reportId}/?page=${page}&page_size=${uploadPageSize}`, {
                method: "GET"
            });
            const data = response?.data || {};
            setUploadHeaders(data.headers || []);
            setUploadRows(data.rows || []);
            setUploadTotalCount(data.count || 0);
            setUploadTotalPages(data.total_pages || 0);
            setUploadPage(data.page || page);
        } catch (error) {
            setError(error?.message || "Unable to load report data.");
            setUploadRows([]);
            setUploadHeaders([]);
        } finally{
            setLoadingUploadData(false);
        }
    };
    const handleUploadReportChange = async (event)=>{
        const reportId = event.target.value;
        setUploadReportId(reportId);
        setUploadFile(null);
        setUploadPage(1);
        await loadUploadReportData(reportId, 1);
    };
    const handleUploadReport = async ()=>{
        if (!uploadReportId) {
            setError("Please select a report.");
            return;
        }
        if (!uploadFile) {
            setError("Please select an XLSX file.");
            return;
        }
        try {
            setUploadingReport(true);
            setError("");
            setSuccess("");
            const formData = new FormData();
            formData.append("file", uploadFile);
            const response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)(`/secondary-reports/data/${uploadReportId}/upload/`, {
                method: "POST",
                body: formData
            });
            setSuccess(response?.message || "Report uploaded successfully. Previous data was replaced.");
            setUploadFile(null);
            setUploadPage(1);
            await loadUploadReportData(uploadReportId, 1);
        } catch (error) {
            const payload = error?.payload || {};
            if (Array.isArray(payload.missing_columns)) setError(`Missing required columns: ${payload.missing_columns.join(", ")}`);
            else setError(error?.message || "Unable to upload report.");
        } finally{
            setUploadingReport(false);
        }
    };
    const renderUploadReportTable = ()=>{
        if (loadingUploadData) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "additional-reports-upload-loading",
            children: "Loading report data..."
        });
        if (!uploadReportId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "additional-reports-upload-empty",
            children: "Select a report to view its existing data."
        });
        if (!uploadRows.length) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "additional-reports-upload-empty",
            children: "No data uploaded for this report yet."
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "additional-reports-upload-table-wrap",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                className: "additional-reports-upload-table",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                            children: uploadHeaders.map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: header
                                }, header))
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                        children: uploadRows.map((row)=>{
                            const rawData = row.raw_data || {};
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                children: uploadHeaders.map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: rawData[header] === null || rawData[header] === undefined ? "" : String(rawData[header])
                                    }, `${row.id}-${header}`))
                            }, row.id);
                        })
                    })
                ]
            })
        });
    };
    const handleUploadPageChange = async (page)=>{
        if (page < 1 || page > uploadTotalPages || page === uploadPage) return;
        await loadUploadReportData(uploadReportId, page);
    };
    const renderUploadPagination = ()=>{
        if (!uploadReportId || uploadTotalPages <= 1) return null;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "additional-reports-upload-pagination",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    disabled: uploadPage <= 1 || loadingUploadData,
                    onClick: ()=>handleUploadPageChange(uploadPage - 1),
                    children: "\u2190"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        "Page ",
                        uploadPage,
                        " of ",
                        uploadTotalPages
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    disabled: uploadPage >= uploadTotalPages || loadingUploadData,
                    onClick: ()=>handleUploadPageChange(uploadPage + 1),
                    children: "\u2192"
                })
            ]
        });
    };
    // ---------------------------------------------------------
    // Build API payload
    // ---------------------------------------------------------
    function buildPayload() {
        const payloadIdentifiers = {};
        const payloadConnectingColumns = {};
        identifiers.forEach((item, index)=>{
            if (!item.secondaryHeader) return;
            const key = $5a208ad29556473c$var$getIdentifierKey(index);
            payloadIdentifiers[key] = item.secondaryHeader;
            payloadConnectingColumns[key] = item.primaryHeader;
        });
        return {
            report_name: reportName.trim(),
            headers: headers,
            identifiers: payloadIdentifiers,
            connecting_report: connectingReport,
            connecting_columns: payloadConnectingColumns
        };
    }
    // ---------------------------------------------------------
    // Save / Update
    // ---------------------------------------------------------
    async function handleSubmit(event) {
        event.preventDefault();
        setError("");
        setMessage("");
        const validationError = validateForm();
        if (validationError) {
            setError(validationError);
            return;
        }
        const payload = buildPayload();
        setSavingReport(true);
        try {
            let response;
            if (editingReportId) response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)(`/secondary-reports/${editingReportId}/update/`, {
                method: "PUT",
                body: payload
            });
            else response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/secondary-reports/create/", {
                method: "POST",
                body: payload
            });
            setMessage(response?.message || (editingReportId ? "Additional report updated successfully." : "Additional report saved successfully."));
            resetForm();
            await loadReports();
            setActiveTab("add");
        } catch (err) {
            // apiRequest already puts backend payload on error.
            const backendMessage = err?.payload?.message || err?.message;
            setError(backendMessage || (editingReportId ? "Unable to update the report." : "Unable to save the report."));
        } finally{
            setSavingReport(false);
        }
    }
    // ---------------------------------------------------------
    // Details
    // ---------------------------------------------------------
    async function handleDetails(reportId) {
        setError("");
        setMessage("");
        setLoadingDetails(true);
        try {
            const response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)(`/secondary-reports/${reportId}/`, {
                method: "GET"
            });
            setDetailsReport(response?.data || null);
        } catch (err) {
            setError(err?.message || "Unable to load report details.");
        } finally{
            setLoadingDetails(false);
        }
    }
    // ---------------------------------------------------------
    // Edit
    // ---------------------------------------------------------
    async function handleEdit(reportId) {
        setError("");
        setMessage("");
        setLoadingDetails(true);
        try {
            const response = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)(`/secondary-reports/${reportId}/`, {
                method: "GET"
            });
            const report = response?.data;
            if (!report) throw new Error("Report details were not returned by the backend.");
            setEditingReportId(report.id);
            setReportName(report.report_name || "");
            // IMPORTANT:
            // Existing stored headers are used.
            // No XLSX is required during edit.
            setHeaders(Array.isArray(report.headers) ? report.headers : []);
            setConnectingReport(report.connecting_report || "");
            const storedIdentifiers = report.identifiers || {};
            const storedConnectingColumns = report.connecting_columns || {};
            const populatedIdentifiers = $5a208ad29556473c$var$createEmptyIdentifiers();
            for(let index = 0; index < $5a208ad29556473c$var$MAX_IDENTIFIERS; index++){
                const key = $5a208ad29556473c$var$getIdentifierKey(index);
                populatedIdentifiers[index] = {
                    secondaryHeader: storedIdentifiers[key] || "",
                    primaryHeader: storedConnectingColumns[key] || ""
                };
            }
            setIdentifiers(populatedIdentifiers);
            setSelectedFile(null);
            const fileInput = document.getElementById("additional-report-file");
            if (fileInput) fileInput.value = "";
            setActiveTab("add");
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        } catch (err) {
            setError(err?.message || "Unable to load report for editing.");
        } finally{
            setLoadingDetails(false);
        }
    }
    // ---------------------------------------------------------
    // Delete
    // ---------------------------------------------------------
    function handleDelete(report) {
        // Intentionally not implemented yet.
        // Delete will have additional backend functionality
        // that needs to be defined first.
        setError(`Delete functionality for "${report.report_name}" will be implemented after the deletion workflow is defined.`);
    }
    // ---------------------------------------------------------
    // Details modal
    // ---------------------------------------------------------
    function closeDetails() {
        setDetailsReport(null);
    }
    // ---------------------------------------------------------
    // Render
    // ---------------------------------------------------------
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "additional-reports-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "additional-reports-header",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                children: "Additional Reports"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Configure secondary reports and map their identifiers to your primary reports."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: "additional-reports-add-button",
                        onClick: startNewReport,
                        children: "+ Add Report"
                    })
                ]
            }),
            message ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "additional-reports-message success",
                children: message
            }) : null,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "additional-reports-message error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "additional-reports-tabs",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: activeTab === "add" ? "additional-reports-tab active" : "additional-reports-tab",
                        onClick: ()=>setActiveTab("add"),
                        children: "Add Report"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: activeTab === "upload" ? "additional-reports-tab active" : "additional-reports-tab",
                        onClick: ()=>setActiveTab("upload"),
                        children: "Upload Report"
                    })
                ]
            }),
            activeTab === "add" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "additional-reports-content",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        className: "additional-reports-form",
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "additional-reports-form-header",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            children: editingReportId ? "Edit Report" : "Add Report"
                                        }),
                                        editingReportId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: "Existing report headers are being used. Selecting a new XLSX is optional."
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: "Select an XLSX file to load its headers."
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "additional-reports-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "additional-report-name",
                                        children: "Report Name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        id: "additional-report-name",
                                        type: "text",
                                        value: reportName,
                                        onChange: (event)=>setReportName(event.target.value),
                                        placeholder: "Enter report name",
                                        disabled: savingReport
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "additional-reports-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        htmlFor: "additional-report-file",
                                        children: [
                                            "XLSX File",
                                            editingReportId ? " (Optional)" : ""
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        id: "additional-report-file",
                                        type: "file",
                                        accept: ".xlsx",
                                        onChange: handleFileChange,
                                        disabled: savingReport || loadingFileHeaders
                                    }),
                                    editingReportId && !selectedFile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        className: "additional-reports-help",
                                        children: "No new file selected. Existing stored headers will be used."
                                    }) : null,
                                    selectedFile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                        className: "additional-reports-help",
                                        children: [
                                            "Selected: ",
                                            selectedFile.name
                                        ]
                                    }) : null,
                                    loadingFileHeaders ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        className: "additional-reports-help",
                                        children: "Reading XLSX headers..."
                                    }) : null
                                ]
                            }),
                            headers.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "additional-reports-header-info",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        children: [
                                            "Available Headers (",
                                            headers.length,
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "additional-reports-header-list",
                                        children: headers.map((header, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "additional-reports-header-chip",
                                                children: header
                                            }, `${header}-${index}`))
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "additional-reports-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "additional-report-primary",
                                        children: "Primary Report"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        id: "additional-report-primary",
                                        value: connectingReport,
                                        onChange: (event)=>handleConnectingReportChange(event.target.value),
                                        disabled: savingReport || !headers.length,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Select Primary Report"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "PO",
                                                children: "PO"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "GRN",
                                                children: "GRN"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "VendorMasters",
                                                children: "Vendor Masters"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "additional-reports-identifiers",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "additional-reports-section-title",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                children: "Identifiers"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "Select up to 6 unique secondary report headers and map each one to a primary report column."
                                            })
                                        ]
                                    }),
                                    identifiers.map((item, index)=>{
                                        const identifierNumber = index + 1;
                                        const identifierKey = $5a208ad29556473c$var$getIdentifierKey(index);
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "additional-reports-identifier-row",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "additional-reports-identifier-number",
                                                    children: [
                                                        "Identifier ",
                                                        identifierNumber
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "additional-reports-field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            children: "Secondary Header"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                            value: item.secondaryHeader,
                                                            onChange: (event)=>updateIdentifier(index, "secondaryHeader", event.target.value),
                                                            disabled: savingReport || !headers.length,
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "",
                                                                    children: "Select Header"
                                                                }),
                                                                headers.map((header, headerIndex)=>{
                                                                    const alreadySelected = isSecondaryHeaderAlreadySelected(header, index);
                                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: header,
                                                                        disabled: alreadySelected,
                                                                        children: header
                                                                    }, `${header}-${headerIndex}`);
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "additional-reports-field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            children: "Connecting Column"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                            value: item.primaryHeader,
                                                            onChange: (event)=>updateIdentifier(index, "primaryHeader", event.target.value),
                                                            disabled: savingReport || !connectingReport || !item.secondaryHeader,
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "",
                                                                    children: "Select Connecting Column"
                                                                }),
                                                                availablePrimaryHeaders.map((header, headerIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: header,
                                                                        children: header
                                                                    }, `${header}-${headerIndex}`))
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, identifierKey);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "additional-reports-form-actions",
                                children: [
                                    editingReportId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "additional-reports-secondary-button",
                                        onClick: startNewReport,
                                        disabled: savingReport,
                                        children: "Cancel Edit"
                                    }) : null,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "submit",
                                        className: "additional-reports-primary-button",
                                        disabled: savingReport || loadingFileHeaders,
                                        children: savingReport ? editingReportId ? "Updating..." : "Saving..." : editingReportId ? "Update Report" : "Save Report"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "additional-reports-list-section",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "additional-reports-list-header",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                children: "Configured Reports"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: loadingReports ? "Loading reports..." : `${reports.length} report${reports.length === 1 ? "" : "s"} configured`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "additional-reports-refresh-button",
                                        onClick: loadReports,
                                        disabled: loadingReports,
                                        children: "Refresh"
                                    })
                                ]
                            }),
                            loadingReports ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "additional-reports-empty",
                                children: "Loading configured reports..."
                            }) : reports.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "additional-reports-empty",
                                children: "No additional reports have been configured yet."
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "additional-reports-list",
                                children: reports.map((report)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "additional-reports-card",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "additional-reports-card-info",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                        children: report.report_name
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "additional-reports-card-meta",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                children: [
                                                                    report.identifier_count,
                                                                    " ",
                                                                    "identifier",
                                                                    report.identifier_count === 1 ? "" : "s"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                children: [
                                                                    "Primary:",
                                                                    " ",
                                                                    report.connecting_report
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "additional-reports-card-actions",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>handleDetails(report.id),
                                                        disabled: loadingDetails,
                                                        children: "Details"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>handleEdit(report.id),
                                                        disabled: loadingDetails,
                                                        children: "Edit"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        className: "danger",
                                                        onClick: ()=>handleDelete(report),
                                                        children: "Delete"
                                                    })
                                                ]
                                            })
                                        ]
                                    }, report.id))
                            })
                        ]
                    })
                ]
            }) : null,
            activeTab === "upload" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "additional-reports-upload",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "additional-reports-upload-form",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "additional-reports-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "additional-report-upload-select",
                                        children: "Select Report"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        id: "additional-report-upload-select",
                                        value: uploadReportId,
                                        onChange: handleUploadReportChange,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Select a report"
                                            }),
                                            reports.map((report)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: report.id,
                                                    children: report.report_name
                                                }, report.id))
                                        ]
                                    })
                                ]
                            }),
                            uploadReportId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "additional-reports-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: "additional-report-upload-file",
                                                children: "XLSX File"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                id: "additional-report-upload-file",
                                                type: "file",
                                                accept: ".xlsx",
                                                onChange: (event)=>{
                                                    setUploadFile(event.target.files?.[0] || null);
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "additional-reports-upload-actions",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "additional-reports-primary-button",
                                            onClick: handleUploadReport,
                                            disabled: uploadingReport || !uploadFile,
                                            children: uploadingReport ? "Uploading..." : "Upload & Replace"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    uploadReportId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "additional-reports-upload-data",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "additional-reports-upload-data-header",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            children: "Existing Data"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                uploadTotalCount.toLocaleString(),
                                                " rows"
                                            ]
                                        })
                                    ]
                                })
                            }),
                            renderUploadReportTable(),
                            renderUploadPagination()
                        ]
                    })
                ]
            }),
            detailsReport ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "additional-reports-modal-backdrop",
                onClick: closeDetails,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "additional-reports-modal",
                    onClick: (event)=>event.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "additional-reports-modal-header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            children: detailsReport.report_name
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: "Report Configuration"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: closeDetails,
                                    className: "additional-reports-modal-close",
                                    children: "\xd7"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "additional-reports-modal-body",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "additional-reports-detail-item",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Primary Report"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: detailsReport.connecting_report
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "additional-reports-detail-item",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Headers"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "additional-reports-header-list",
                                            children: (detailsReport.headers || []).map((header, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "additional-reports-header-chip",
                                                    children: header
                                                }, `${header}-${index}`))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "additional-reports-detail-item",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Identifier Mappings"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "additional-reports-detail-mappings",
                                            children: Object.entries(detailsReport.identifiers || {}).map(([identifier, secondaryHeader])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "additional-reports-detail-mapping",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: identifier
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: secondaryHeader
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "\u2192"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: (detailsReport.connecting_columns || {})[identifier]
                                                        })
                                                    ]
                                                }, identifier))
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "additional-reports-modal-footer",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "additional-reports-secondary-button",
                                onClick: closeDetails,
                                children: "Close"
                            })
                        })
                    ]
                })
            }) : null
        ]
    });
}


const $1b8e0994176c9ade$var$superUserNavGroups = [
    {
        key: "common_settings",
        label: "Enterprise Level Settings",
        children: [
            {
                key: "common_configuration",
                label: "Configuration",
                mode: "internal"
            },
            {
                key: "common_upload_headers",
                label: "Upload Headers",
                mode: "internal"
            },
            {
                key: "common_header_mapping",
                label: "Header Mapping",
                mode: "internal"
            },
            {
                key: "hsn_sac_masters",
                label: "HSN/SAC List",
                mode: "internal"
            }
        ]
    },
    {
        key: "miro_app_settings",
        label: "AP Bot Settings",
        children: [
            {
                key: "ap_common_settings",
                label: "AP Bot Common Settings",
                children: [
                    {
                        key: "ap_configuration",
                        label: "Configuration",
                        mode: "internal"
                    },
                    {
                        key: "ap_upload_headers",
                        label: "Upload Headers",
                        mode: "internal"
                    },
                    {
                        key: "ap_header_mapping",
                        label: "Header Mapping",
                        mode: "internal"
                    },
                    {
                        key: "ap_user_rights",
                        label: "User Rights",
                        mode: "internal"
                    }
                ]
            },
            {
                key: "po_settings",
                label: "PO Settings",
                children: [
                    {
                        key: "po_configuration",
                        label: "Configuration",
                        mode: "internal"
                    },
                    {
                        key: "po_template_setting",
                        label: "Template Setting",
                        mode: "internal"
                    },
                    {
                        key: "po_gl_codes",
                        label: "Unallocated Cost GL Codes",
                        mode: "internal"
                    },
                    {
                        key: "po_roles",
                        label: "Approval Matrix",
                        mode: "internal"
                    },
                    {
                        key: "po_user_rights",
                        label: "User Rights",
                        mode: "internal"
                    }
                ]
            },
            {
                key: "non_po_settings",
                label: "Non-PO Settings",
                children: [
                    {
                        key: "non_po_configuration",
                        label: "Configuration",
                        mode: "internal"
                    },
                    {
                        key: "non_po_header_mapping",
                        label: "Header Mapping",
                        mode: "internal"
                    },
                    {
                        key: "non_po_template_setting",
                        label: "Template Setting",
                        mode: "internal"
                    },
                    {
                        key: "non_po_roles",
                        label: "Approval Matrix",
                        mode: "internal"
                    },
                    {
                        key: "non_po_user_rights",
                        label: "User Rights",
                        mode: "internal"
                    }
                ]
            }
        ]
    },
    {
        key: "invoice_app_settings",
        label: "Invoice Approval App Settings",
        children: [
            {
                key: "invoice_configuration",
                label: "Invoice Configuration",
                mode: "internal"
            },
            {
                key: "invoice_type",
                label: "Invoice Type",
                mode: "internal"
            },
            {
                key: "checklists",
                label: "Checklists",
                mode: "internal"
            },
            {
                key: "conditions_po",
                label: "Conditions_PO",
                mode: "internal"
            },
            {
                key: "conditions_non_po",
                label: "Conditions_Non-PO",
                mode: "internal"
            },
            {
                key: "approval_matrix_po",
                label: "Approval Matrix_PO",
                mode: "internal"
            },
            {
                key: "approval_matrix_non_po",
                label: "Approval Matrix_Non-PO",
                mode: "internal"
            },
            {
                key: "inv_headers_upload",
                label: "Upload Headers",
                mode: "internal"
            },
            {
                key: "inv_headers_mapping",
                label: "Map Headers",
                mode: "internal"
            },
            {
                key: "additional_reports",
                label: "Additional Reports",
                mode: "internal"
            },
            {
                key: "invoice_upload_data",
                label: "Upload Master Data",
                mode: "internal"
            }
        ]
    }
];
const $1b8e0994176c9ade$var$processorNavItems = [
    {
        key: "processor_pending",
        label: "Pending Actions",
        mode: "internal"
    },
    {
        key: "processor_missing",
        label: "Mandatory Info Missing",
        mode: "internal"
    },
    {
        key: "processor_duplicate",
        label: "Not Found In Migo/Duplicate",
        mode: "internal"
    },
    {
        key: "processor_hold",
        label: "On Hold",
        mode: "internal"
    },
    {
        key: "processor_approval",
        label: "Pending For Approval",
        mode: "internal"
    },
    {
        key: "processor_rejected",
        label: "Rejected",
        mode: "internal"
    },
    {
        key: "processor_ready",
        label: "Ready For Template",
        mode: "internal"
    },
    {
        key: "processor_generated",
        label: "Template Generated",
        mode: "internal"
    },
    {
        key: "processor_upload",
        label: "Upload Data",
        mode: "internal"
    },
    {
        key: "processor_export",
        label: "Export Template",
        mode: "internal"
    },
    {
        key: "test_data",
        label: "Test Data",
        mode: "internal"
    }
];
const $1b8e0994176c9ade$var$checkerNavItems = [
    {
        key: "checker_pending",
        label: "Pending Approval",
        mode: "internal"
    },
    // {
    //   key: "checker_assignment",
    //   label: "Pending Assignment",
    //   mode: "internal",
    // },
    {
        key: "checker_nomigo",
        label: "Invoice Number Approvals",
        mode: "internal"
    },
    {
        key: "checker_exceptions",
        label: "Exception Approval",
        mode: "internal"
    },
    {
        key: "checker_team",
        label: "Pending with Team",
        mode: "internal"
    },
    {
        key: "checker_hold",
        label: "On Hold",
        mode: "internal"
    },
    {
        key: "checker_rejected",
        label: "Rejected",
        mode: "internal"
    },
    {
        key: "checker_ready",
        label: "Ready For Template",
        mode: "internal"
    },
    {
        key: "checker_generated",
        label: "Template Generated",
        mode: "internal"
    }
];
const $1b8e0994176c9ade$var$uploaderNavItems = [
    {
        key: "uploader_upload",
        label: "Upload Invoice",
        mode: "internal"
    },
    {
        key: "uploader_status",
        label: "Invoice Status",
        mode: "internal"
    }
];
const $1b8e0994176c9ade$var$initiatorNavItems = [
    {
        key: "initiator_queue",
        label: "Initiator Queue",
        mode: "internal"
    }
];
const $1b8e0994176c9ade$var$approverNavItems = [
    {
        key: "approver_dashboard",
        label: "Approver Dashboard",
        mode: "internal"
    }
];
const $1b8e0994176c9ade$var$APP_LAUNCHER_ITEMS = [
    {
        name: "App1",
        host: "app1.ngrisetech.com",
        icon: "A1"
    },
    {
        name: "App2",
        host: "app2.ngrisetech.com",
        icon: "A2"
    },
    {
        name: "App3",
        host: "app3.ngrisetech.com",
        icon: "A3"
    },
    {
        name: "App4",
        host: "app4.ngrisetech.com",
        icon: "A4"
    },
    {
        name: "App5",
        host: "app5.ngrisetech.com",
        icon: "A5"
    }
];
const $1b8e0994176c9ade$var$authQueryParams = new URLSearchParams(window.location.search);
const $1b8e0994176c9ade$var$initialAuthScreen = $1b8e0994176c9ade$var$authQueryParams.get("screen") === "verify-otp" ? "verify_otp" : "login";
const $1b8e0994176c9ade$var$initialAuthEmail = $1b8e0994176c9ade$var$authQueryParams.get("email") || "";
const $1b8e0994176c9ade$var$initialStandaloneScreen = $1b8e0994176c9ade$var$authQueryParams.get("screen") || "";
const $1b8e0994176c9ade$var$initialResponseFile = $1b8e0994176c9ade$var$authQueryParams.get("response_file") || "";
const $1b8e0994176c9ade$var$ACTIVE_ROLE_STORAGE_KEY = "miro-active-role";
const $1b8e0994176c9ade$var$ACTIVE_PANEL_STORAGE_KEY = "miro-active-panel";
function $1b8e0994176c9ade$var$getDefaultPanel(role) {
    if ((role || "").toLowerCase() === "superuser") return "configuration";
    if ((role || "").toLowerCase() === "processor") return "processor_pending";
    if ((role || "").toLowerCase() === "checker") return "checker_pending";
    if ((role || "").toLowerCase() === "uploader") return "uploader_upload";
    if ((role || "").toLowerCase() === "initiator") return "initiator_queue";
    if ((role || "").toLowerCase() === "approver") return "approver_dashboard";
    return "overview";
}
function $1b8e0994176c9ade$var$getSidebarItemsForRole(role, summary, session) {
    if (role === "SuperUser") return $1b8e0994176c9ade$var$superUserNavGroups.flatMap((group)=>group.children || []);
    if (role === "Processor") return $1b8e0994176c9ade$var$processorNavItems;
    if (role === "Checker") return $1b8e0994176c9ade$var$checkerNavItems;
    if (role === "Uploader") return $1b8e0994176c9ade$var$uploaderNavItems;
    if (role === "Initiator") return $1b8e0994176c9ade$var$initiatorNavItems;
    if (role === "Approver") return $1b8e0994176c9ade$var$approverNavItems;
    return summary?.legacyLinks || session?.legacyLinks || [];
}
function $1b8e0994176c9ade$var$findSidebarItem(items, panelKey) {
    for (const item of items){
        // Check current item
        if (item.mode === "internal" && item.key === panelKey) return true;
        // Check nested children recursively
        if (item.children?.length) {
            const found = $1b8e0994176c9ade$var$findSidebarItem(item.children, panelKey);
            if (found) return true;
        }
    }
    return false;
}
function $1b8e0994176c9ade$var$isValidPanelForRole(role, panelKey) {
    if (!panelKey) return false;
    const sidebarItems = $1b8e0994176c9ade$var$getSidebarItemsForRole(role, null, null);
    return $1b8e0994176c9ade$var$findSidebarItem(sidebarItems, panelKey);
}
function $1b8e0994176c9ade$var$readStoredActivePanel(role) {
    try {
        const storedRole = window.localStorage.getItem($1b8e0994176c9ade$var$ACTIVE_ROLE_STORAGE_KEY);
        const storedPanel = window.localStorage.getItem($1b8e0994176c9ade$var$ACTIVE_PANEL_STORAGE_KEY);
        if (storedRole === role && $1b8e0994176c9ade$var$isValidPanelForRole(role, storedPanel)) return storedPanel;
    } catch  {
        return "";
    }
    return "";
}
function $1b8e0994176c9ade$var$saveActiveNavigation(role, panelKey) {
    try {
        window.localStorage.setItem($1b8e0994176c9ade$var$ACTIVE_ROLE_STORAGE_KEY, role || "");
        window.localStorage.setItem($1b8e0994176c9ade$var$ACTIVE_PANEL_STORAGE_KEY, panelKey || "");
    } catch  {
    // Local storage can be unavailable in private/locked-down browser modes.
    }
}
function $1b8e0994176c9ade$var$StatCard({ stat: stat }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
        className: "stat-card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "stat-card__label",
                children: stat.label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "stat-card__value",
                children: stat.value
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "stat-card__description",
                children: stat.description
            })
        ]
    });
}
function $1b8e0994176c9ade$var$LinkCard({ link: link }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
        className: "link-card",
        href: (0, $96e14f2a7c3555e4$export$5d9c32988b6a9848)(link.url),
        target: "_blank",
        rel: "noreferrer",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: link.label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "link-card__arrow",
                children: "Open"
            })
        ]
    });
}
function $1b8e0994176c9ade$var$SidebarNav({ items: items, activeKey: activeKey, onSelect: onSelect }) {
    function handleExternalNavigation(item) {
        if (item.section) window.localStorage.setItem(item.storageKey || "activeSection", item.section);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
        className: "sidebar-nav",
        children: items.map((item)=>item.mode === "group" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "sidebar-nav__group-label",
                children: item.label
            }, item.key || item.label) : item.mode === "internal" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: `sidebar-nav__item sidebar-nav__item--button${activeKey === item.key ? " is-active" : ""}`,
                type: "button",
                onClick: ()=>onSelect(item.key),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: item.label
                })
            }, item.key || item.label) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                className: "sidebar-nav__item",
                href: (0, $96e14f2a7c3555e4$export$5d9c32988b6a9848)(item.url),
                target: "_blank",
                rel: "noreferrer",
                onClick: ()=>handleExternalNavigation(item),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: item.label
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "sidebar-nav__meta",
                        children: "Open"
                    })
                ]
            }, item.key || item.url || item.label))
    });
}
function $1b8e0994176c9ade$export$2e2bcd8739ae039() {
    const appsMenuRef = (0, $acw62.useRef)(null);
    const sessionMenuRef = (0, $acw62.useRef)(null);
    const [session, setSession] = (0, $acw62.useState)(null);
    const [summary, setSummary] = (0, $acw62.useState)(null);
    const [authScreen, setAuthScreen] = (0, $acw62.useState)($1b8e0994176c9ade$var$initialAuthScreen);
    const [authEmail, setAuthEmail] = (0, $acw62.useState)($1b8e0994176c9ade$var$initialAuthEmail);
    const [standaloneScreen] = (0, $acw62.useState)($1b8e0994176c9ade$var$initialStandaloneScreen);
    const [standaloneResponseFile] = (0, $acw62.useState)($1b8e0994176c9ade$var$initialResponseFile);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [submitting, setSubmitting] = (0, $acw62.useState)(false);
    const [invoiceDisplayFile, setInvoiceDisplayFile] = (0, $acw62.useState)("");
    const [activePanel, setActivePanel] = (0, $acw62.useState)("overview");
    const [selectedRole, setSelectedRole] = (0, $acw62.useState)("");
    const [selectedTeam, setSelectedTeam] = (0, $acw62.useState)("");
    const [isAppsMenuOpen, setIsAppsMenuOpen] = (0, $acw62.useState)(false);
    const [isSessionMenuOpen, setIsSessionMenuOpen] = (0, $acw62.useState)(false);
    function selectPanel(panelKey, role = selectedRole || session?.roles?.[0] || "") {
        setActivePanel(panelKey);
        $1b8e0994176c9ade$var$saveActiveNavigation(role, panelKey);
    }
    async function loadSession() {
        setLoading(true);
        try {
            const authenticated = await (0, $96e14f2a7c3555e4$export$e9dbbdd5c9d6144f)();
            if (!authenticated) {
                setSession({
                    authenticated: false,
                    roles: []
                });
                setSummary(null);
                return;
            }
            const keycloakSession = (0, $96e14f2a7c3555e4$export$e819be646df26d02)();
            const baseSession = {
                authenticated: keycloakSession.authenticated,
                roles: keycloakSession.roles,
                team: keycloakSession.teams,
                organizations: keycloakSession.organizations,
                fullName: keycloakSession.profile?.name || keycloakSession.profile?.username || "",
                email: keycloakSession.profile?.email || "",
                username: keycloakSession.profile?.username || "",
                company: {
                    code: null,
                    name: ""
                }
            };
            let dashboard = null;
            try {
                dashboard = await (0, $96e14f2a7c3555e4$export$52e83573e7782585)("/dashboard/summary/");
                setSummary(dashboard);
            } catch (summaryError) {
                console.error(summaryError);
                setSummary(null);
            }
            const mergedSession = dashboard ? {
                ...baseSession,
                fullName: dashboard?.user?.fullName || baseSession.fullName,
                email: dashboard?.user?.email || baseSession.email,
                company: {
                    code: null,
                    name: dashboard?.companyName || ""
                }
            } : baseSession;
            setSession(mergedSession);
            const roles = keycloakSession.roles || [];
            const savedRole = sessionStorage.getItem("activeRole");
            const initialRole = savedRole && roles.includes(savedRole) ? savedRole : roles.find((role)=>(role || "").toLowerCase() === "superuser") ? "SuperUser" : roles[0] || "";
            setSelectedRole(initialRole);
            setSelectedTeam((keycloakSession.teams || [])[0] || "");
            const storageKey = getPanelStorageKey(initialRole);
            const savedPanel = sessionStorage.getItem(storageKey);
            setActivePanel(savedPanel || $1b8e0994176c9ade$var$getDefaultPanel(initialRole));
        } catch (requestError) {
            setSession({
                authenticated: false,
                roles: []
            });
            setSummary(null);
        } finally{
            setLoading(false);
        }
    }
    (0, $acw62.useEffect)(()=>{
        loadSession();
    }, []);
    (0, $acw62.useEffect)(()=>{
        function handlePointerDown(event) {
            if (!appsMenuRef.current?.contains(event.target)) setIsAppsMenuOpen(false);
            if (!sessionMenuRef.current?.contains(event.target)) setIsSessionMenuOpen(false);
        }
        if (isAppsMenuOpen || isSessionMenuOpen) {
            document.addEventListener("mousedown", handlePointerDown);
            document.addEventListener("touchstart", handlePointerDown);
        }
        return ()=>{
            document.removeEventListener("mousedown", handlePointerDown);
            document.removeEventListener("touchstart", handlePointerDown);
        };
    }, [
        isAppsMenuOpen,
        isSessionMenuOpen,
        loading,
        session
    ]);
    (0, $acw62.useEffect)(()=>{
        function handleEscape(event) {
            if (event.key === "Escape") setInvoiceDisplayFile("");
        }
        if (invoiceDisplayFile) document.addEventListener("keydown", handleEscape);
        return ()=>{
            document.removeEventListener("keydown", handleEscape);
        };
    }, [
        invoiceDisplayFile
    ]);
    async function handleLogout() {
        setSubmitting(true);
        try {
            await (0, $96e14f2a7c3555e4$export$aea3261845a0a415)();
        } catch (requestError) {
            console.error(requestError);
        } finally{
            setSubmitting(false);
        }
    }
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
        className: "app-shell app-shell--centered",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "loading-card",
            children: "Loading Miro workspace\u2026"
        })
    });
    if (!session?.authenticated) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
        className: "app-shell",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "hero-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "hero-panel__badge",
                        children: "MiroFlow AP"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        children: "From upload to approval, streamline invoice processing with role-based AP control."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "MiroFlow AP is a role-based accounts payable workflow platform that streamlines invoice upload, validation, exception handling, approvals, template generation, and financial processing across uploader, processor, checker, and admin teams."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "hero-panel__list",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Session-based login"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "React company signup"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Role-aware dashboard"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Legacy workflow links"
                            })
                        ]
                    })
                ]
            }),
            authScreen === "signup" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62a5d34eb4c71539$export$2e2bcd8739ae039), {
                onBackToLogin: ()=>setAuthScreen("login"),
                onOtpSent: (email)=>{
                    setAuthEmail(email);
                    setAuthScreen("verify_otp");
                    window.history.replaceState({}, "", `/?screen=verify-otp&email=${encodeURIComponent(email)}`);
                }
            }) : authScreen === "verify_otp" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ecacc5fc8b120bc$export$2e2bcd8739ae039), {
                email: authEmail,
                onBackToSignup: ()=>{
                    setAuthScreen("signup");
                    window.history.replaceState({}, "", "/");
                },
                onVerificationSuccess: (redirectUrl)=>{
                    window.location.href = (0, $96e14f2a7c3555e4$export$5d9c32988b6a9848)(redirectUrl || "/password-reset-confirmation/");
                }
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "auth-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "auth-panel__header",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "Sign In"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "Continue to your invoice workspace"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "auth-form",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary-button",
                                type: "button",
                                onClick: ()=>(0, $96e14f2a7c3555e4$export$ab2fed14dcfadce5)(),
                                children: "Sign in with Keycloak"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "auth-form__hint",
                                children: "You will be redirected to Keycloak to sign in."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "secondary-link secondary-link--button",
                        type: "button",
                        onClick: ()=>{
                            setAuthScreen("signup");
                            window.history.replaceState({}, "", "/");
                        },
                        children: "Need an account? Create a company workspace"
                    })
                ]
            })
        ]
    });
    if (session?.authenticated && standaloneScreen === "invoice-display") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c012a5104330be1$export$2e2bcd8739ae039), {
        responseFile: standaloneResponseFile
    });
    const activeRole = selectedRole || session.roles[0] || "";
    const activeTeam = selectedTeam || session.team?.[0] || "";
    const sidebarItems = $1b8e0994176c9ade$var$getSidebarItemsForRole(activeRole, summary, session);
    function getPanelStorageKey(role) {
        return `activePanel_${(role || "").toLowerCase()}`;
    }
    // function SuperUserSidebarNav({ groups, activeKey, onSelect }) {
    //   const [openGroup, setOpenGroup] = useState(null);
    //   useEffect(() => {
    //     const activeGroup = groups.find((group) =>
    //       group.children.some((item) => item.key === activeKey)
    //     );
    //     if (activeGroup) {
    //       setOpenGroup(activeGroup.key);
    //     }
    //   }, [activeKey, groups]);
    //   const handleGroupClick = (groupKey) => {
    //     setOpenGroup((current) =>
    //       current === groupKey ? null : groupKey
    //     );
    //   };
    //   return (
    //     <div className="superuser-sidebar-nav">
    //       {groups.map((group) => {
    //         const isOpen = openGroup === group.key;
    //         const hasActiveChild = group.children.some(
    //           (item) => item.key === activeKey
    //         );
    //         return (
    //           <div
    //             key={group.key}
    //             className={`superuser-sidebar-group ${
    //               isOpen ? "is-open" : ""
    //             } ${hasActiveChild ? "has-active-child" : ""}`}
    //           >
    //             <button
    //               type="button"
    //               className="superuser-sidebar-group-button"
    //               onClick={() => handleGroupClick(group.key)}
    //             >
    //               <span>{group.label}</span>
    //               <span
    //                 className={`superuser-sidebar-arrow ${
    //                   isOpen ? "is-open" : ""
    //                 }`}
    //               >
    //                 ›
    //               </span>
    //             </button>
    //             {isOpen && (
    //               <div className="superuser-sidebar-submenu">
    //                 {group.children.map((item) => (
    //                   <button
    //                     key={item.key}
    //                     type="button"
    //                     className={`superuser-sidebar-submenu-item ${
    //                       activeKey === item.key ? "active" : ""
    //                     }`}
    //                     onClick={() => onSelect(item.key)}
    //                   >
    //                     {item.label}
    //                   </button>
    //                 ))}
    //               </div>
    //             )}
    //           </div>
    //         );
    //       })}
    //     </div>
    //   );
    // }
    function SuperUserSidebarNav({ groups: groups, activeKey: activeKey, onSelect: onSelect }) {
        const [openItems, setOpenItems] = (0, $acw62.useState)({});
        const hasActiveItem = (item)=>{
            if (item.key === activeKey) return true;
            if (item.children?.length) return item.children.some((child)=>hasActiveItem(child));
            return false;
        };
        (0, $acw62.useEffect)(()=>{
            const newOpenItems = {};
            const collectParents = (items)=>{
                items.forEach((item)=>{
                    if (item.children?.length) {
                        const containsActive = item.children.some((child)=>hasActiveItem(child));
                        if (containsActive) newOpenItems[item.key] = true;
                        collectParents(item.children);
                    }
                });
            };
            collectParents(groups);
            setOpenItems(newOpenItems);
        }, [
            activeKey,
            groups
        ]);
        const handleItemClick = (item)=>{
            if (item.children?.length) {
                setOpenItems((current)=>({
                        ...current,
                        [item.key]: !current[item.key]
                    }));
                return;
            }
            onSelect(item.key);
        };
        const renderItems = (items, level = 0)=>{
            return items.map((item)=>{
                const hasChildren = item.children?.length > 0;
                const isOpen = !!openItems[item.key];
                const isActive = item.key === activeKey;
                const containsActive = hasActiveItem(item);
                // Top-level item
                if (level === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: `superuser-sidebar-group ${isOpen ? "is-open" : ""} ${containsActive ? "has-active-child" : ""}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            className: "superuser-sidebar-group-button",
                            onClick: ()=>handleItemClick(item),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: item.label
                                }),
                                hasChildren && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: `superuser-sidebar-arrow ${isOpen ? "is-open" : ""}`,
                                    children: "\u203A"
                                })
                            ]
                        }),
                        hasChildren && isOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "superuser-sidebar-submenu",
                            children: renderItems(item.children, level + 1)
                        })
                    ]
                }, item.key);
                // Nested item
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: `superuser-sidebar-nested-item level-${level} ${isOpen ? "is-open" : ""} ${containsActive ? "has-active-child" : ""}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            className: `superuser-sidebar-submenu-item ${hasChildren ? "has-children" : ""} ${isActive ? "active" : ""}`,
                            onClick: ()=>handleItemClick(item),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: item.label
                                }),
                                hasChildren && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: `superuser-sidebar-arrow ${isOpen ? "is-open" : ""}`,
                                    children: "\u203A"
                                })
                            ]
                        }),
                        hasChildren && isOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "superuser-sidebar-nested-submenu",
                            children: renderItems(item.children, level + 1)
                        })
                    ]
                }, item.key);
            });
        };
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "superuser-sidebar-nav",
            children: renderItems(groups)
        });
    }
    const handlePanelChange = (panel)=>{
        setActivePanel(panel);
        const storageKey = getPanelStorageKey(selectedRole);
        sessionStorage.setItem(storageKey, panel);
    };
    function handleDashboardClickCapture(event) {
        const link = event.target.closest('a[href*="/invoice-display/?response_file="]');
        if (!link) return;
        const href = link.getAttribute("href");
        if (!href) return;
        const parsedUrl = new URL(href, window.location.origin);
        const responseFile = parsedUrl.searchParams.get("response_file");
        if (!responseFile) return;
        event.preventDefault();
        event.stopPropagation();
        setInvoiceDisplayFile(responseFile);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
        className: "dashboard-shell",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "dashboard-topbar dashboard-topbar--compact",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "Connected Session"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                children: summary?.companyName || session.company.name
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "dashboard-subtitle",
                                children: [
                                    "Signed in as ",
                                    session.fullName,
                                    ". Viewing ",
                                    activeRole || "assigned",
                                    " access",
                                    activeTeam ? ` for ${activeTeam}.` : "."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "dashboard-topbar__controls",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "header-switcher",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Role"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: activeRole,
                                        onChange: (event)=>{
                                            const nextRole = event.target.value;
                                            setSelectedRole(nextRole);
                                            sessionStorage.setItem("activeRole", nextRole);
                                            const storageKey = getPanelStorageKey(nextRole);
                                            const savedPanel = sessionStorage.getItem(storageKey);
                                            setActivePanel(savedPanel || $1b8e0994176c9ade$var$getDefaultPanel(nextRole));
                                        },
                                        disabled: session.roles.length <= 1,
                                        children: session.roles.map((role)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: role,
                                                children: role
                                            }, role))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "header-switcher",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Team"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: activeTeam,
                                        onChange: (event)=>{
                                            setSelectedTeam(event.target.value);
                                        },
                                        disabled: (session.team || []).length <= 1,
                                        children: (session.team || []).length ? session.team.map((team)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: team,
                                                children: team
                                            }, team)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "",
                                            children: "No team assigned"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                                ref: appsMenuRef,
                                className: "apps-menu",
                                open: isAppsMenuOpen,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("summary", {
                                        className: "apps-menu__trigger",
                                        onClick: (event)=>{
                                            event.preventDefault();
                                            setIsAppsMenuOpen((current)=>!current);
                                        },
                                        "aria-label": "Open applications menu",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "apps-menu__dots",
                                            "aria-hidden": "true",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {})
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "apps-menu__panel",
                                        children: $1b8e0994176c9ade$var$APP_LAUNCHER_ITEMS.map((app)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                className: "apps-menu__item",
                                                href: `https://${app.host}`,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                onClick: ()=>setIsAppsMenuOpen(false),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "apps-menu__item-icon",
                                                        "aria-hidden": "true",
                                                        children: app.icon
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: app.name
                                                    })
                                                ]
                                            }, app.name))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                                ref: sessionMenuRef,
                                className: "session-menu",
                                open: isSessionMenuOpen,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("summary", {
                                        className: "session-menu__trigger",
                                        onClick: (event)=>{
                                            event.preventDefault();
                                            setIsSessionMenuOpen((current)=>!current);
                                        },
                                        children: session.fullName
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "session-menu__panel",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "primary-button session-menu__logout",
                                            type: "button",
                                            onClick: ()=>{
                                                setIsSessionMenuOpen(false);
                                                handleLogout();
                                            },
                                            disabled: submitting,
                                            children: submitting ? "Logging out..." : "Log Out"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "dashboard-layout dashboard-layout--compact",
                onClickCapture: handleDashboardClickCapture,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("aside", {
                        className: "dashboard-sidebar dashboard-sidebar--compact",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "workspace-panel workspace-panel--compact workspace-panel--sidebar",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Navigation"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Dashboard Options"
                                }),
                                activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(SuperUserSidebarNav, {
                                    groups: $1b8e0994176c9ade$var$superUserNavGroups,
                                    activeKey: activePanel,
                                    onSelect: handlePanelChange
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1b8e0994176c9ade$var$SidebarNav, {
                                    items: sidebarItems,
                                    activeKey: activePanel,
                                    onSelect: handlePanelChange
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        className: "dashboard-main dashboard-main--workspace",
                        children: activePanel === "common_configuration" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab10cea82ecaf379$export$2e2bcd8739ae039), {}) : activePanel === "po_configuration" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f5222ccf0af895eb$export$2e2bcd8739ae039), {}) : activePanel === "non_po_configuration" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $29801a9c2c8d5f6b$export$2e2bcd8739ae039), {}) : activePanel === "ap_configuration" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99c1db87b1ee001c$export$2e2bcd8739ae039), {}) : activePanel === "invoice_configuration" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a79e089817acc78$export$2e2bcd8739ae039), {
                            onBack: ()=>selectPanel("configuration", activeRole)
                        }) : activePanel === "processor_pending" && activeRole === "Processor" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6d74480645c158b0$export$2e2bcd8739ae039), {}) : activePanel === "processor_missing" && activeRole === "Processor" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed2ab663ad52f25e$export$2e2bcd8739ae039), {}) : activePanel === "processor_duplicate" && activeRole === "Processor" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b50169461c34fd1$export$2e2bcd8739ae039), {}) : activePanel === "processor_hold" && activeRole === "Processor" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c87047e597edfe49$export$2e2bcd8739ae039), {}) : activePanel === "processor_approval" && activeRole === "Processor" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7260aeda2f1f9087$export$2e2bcd8739ae039), {}) : activePanel === "processor_rejected" && activeRole === "Processor" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9062498f4004e827$export$2e2bcd8739ae039), {}) : activePanel === "processor_ready" && activeRole === "Processor" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a4c852e9044aa2ea$export$2e2bcd8739ae039), {}) : activePanel === "processor_generated" && activeRole === "Processor" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07861bca2ee4d297$export$2e2bcd8739ae039), {}) : activePanel === "processor_upload" && activeRole === "Processor" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b11c65d7ae8f97eb$export$2e2bcd8739ae039), {}) : activePanel === "processor_export" && activeRole === "Processor" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ce9fff60e225bdd$export$2e2bcd8739ae039), {}) : activePanel === "test_data" && activeRole === "Processor" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00cd576f0dca8f62$export$2e2bcd8739ae039), {}) : activePanel === "checker_pending" && activeRole === "Checker" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c70bad06ce28be97$export$2e2bcd8739ae039), {}) : activePanel === "checker_assignment" && activeRole === "Checker" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3eeb7c62d17c8968$export$2e2bcd8739ae039), {}) : activePanel === "checker_nomigo" && activeRole === "Checker" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b26f6d518cd44f55$export$2e2bcd8739ae039), {}) : activePanel === "checker_exceptions" && activeRole === "Checker" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa35cf08dc84bb84$export$2e2bcd8739ae039), {}) : activePanel === "checker_hold" && activeRole === "Checker" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ce0857a82cd5c0f$export$2e2bcd8739ae039), {}) : activePanel === "checker_rejected" && activeRole === "Checker" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7eed194cab7fcbbd$export$2e2bcd8739ae039), {}) : activePanel === "checker_ready" && activeRole === "Checker" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d81bcb8b8534864$export$2e2bcd8739ae039), {}) : activePanel === "checker_generated" && activeRole === "Checker" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $711346be82964e0e$export$2e2bcd8739ae039), {}) : activePanel === "checker_team" && activeRole === "Checker" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b196a9ff3e886fa$export$2e2bcd8739ae039), {}) : activePanel === "upload_headers" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca9de1316ff6e95f$export$2e2bcd8739ae039), {}) : activePanel === "ap_upload_headers" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bec10b6736033413$export$2e2bcd8739ae039), {}) : activePanel === "common_upload_headers" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e2ec5d998192ec0$export$2e2bcd8739ae039), {}) : activePanel === "hsn_sac_masters" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b59401103b2b567$export$2e2bcd8739ae039), {}) : activePanel === "non_po_upload_headers" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(NonPoUploadHeadersView, {}) : activePanel === "ap_header_mapping" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e511841a47437487$export$2e2bcd8739ae039), {}) : activePanel === "header_mapping" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6fb9ae3ef3a158ef$export$2e2bcd8739ae039), {}) : activePanel === "common_header_mapping" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $467ac0fa32f18da2$export$2e2bcd8739ae039), {}) : activePanel === "non_po_header_mapping" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b21ce7440066197$export$2e2bcd8739ae039), {}) : activePanel === "po_template_setting" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63d8c23b2607adbc$export$2e2bcd8739ae039), {}) : activePanel === "non_po_template_setting" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63d8c23b2607adbc$export$2e2bcd8739ae039), {}) : activePanel === "gl_codes" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ab9920e663be072$export$2e2bcd8739ae039), {}) : activePanel === "po_gl_codes" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ab9920e663be072$export$2e2bcd8739ae039), {}) : activePanel === "po_roles" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4885203b6872874$export$2e2bcd8739ae039), {}) : activePanel === "non_po_roles" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4885203b6872874$export$2e2bcd8739ae039), {}) : activePanel === "teams" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00cd576f0dca8f62$export$2e2bcd8739ae039), {}) : activePanel === "users" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9bed79cfef3f425c$export$2e2bcd8739ae039), {}) : activePanel === "user_rights" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7509c21f19660ffb$export$2e2bcd8739ae039), {}) : activePanel === "ap_user_rights" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5331923b4e7d0b4$export$2e2bcd8739ae039), {}) : activePanel === "po_user_rights" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e06606c4a0025cd$export$2e2bcd8739ae039), {}) : activePanel === "invoice_type" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a49817af4af6f6e4$export$2e2bcd8739ae039), {}) : activePanel === "checklists" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7cdd700349585511$export$2e2bcd8739ae039), {}) : activePanel === "conditions_po" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $33ce55fb1d9e7a2a$export$2e2bcd8739ae039), {}) : activePanel === "conditions_non_po" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $33253bed4093cc92$export$2e2bcd8739ae039), {}) : activePanel === "approval_matrix_po" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $212db93af4368e26$export$2e2bcd8739ae039), {}) : activePanel === "approval_matrix_non_po" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $112d6f942c30ce0b$export$2e2bcd8739ae039), {}) : activePanel === "inv_headers_upload" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51817ccb103aae55$export$2e2bcd8739ae039), {}) : activePanel === "inv_headers_mapping" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e0d80b926e715a3$export$2e2bcd8739ae039), {}) : activePanel === "invoice_upload_data" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6d5e38e7223b7db2$export$2e2bcd8739ae039), {}) : activePanel === "additional_reports" && activeRole === "SuperUser" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a208ad29556473c$export$2e2bcd8739ae039), {}) : activePanel === "uploader_upload" && activeRole === "Uploader" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0b90c494a9a449e0$export$2e2bcd8739ae039), {
                            selectedTeam: activeTeam,
                            availableTeams: session.team || []
                        }) : activePanel === "uploader_status" && activeRole === "Uploader" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a9237e49e83dfe7$export$2e2bcd8739ae039), {}) : activePanel === "initiator_queue" && activeRole === "Initiator" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9c5fc8c301dfae6$export$2e2bcd8739ae039), {}) : activePanel === "approver_dashboard" && activeRole === "Approver" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $58080555b821a069$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                                className: "stats-grid",
                                children: (summary?.stats || []).map((stat)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1b8e0994176c9ade$var$StatCard, {
                                        stat: stat
                                    }, stat.key))
                            })
                        })
                    })
                ]
            }),
            invoiceDisplayFile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "invoice-display-modal",
                role: "presentation",
                onClick: ()=>setInvoiceDisplayFile(""),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "invoice-display-modal__panel",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-label": "Invoice display",
                    onClick: (event)=>event.stopPropagation(),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c012a5104330be1$export$2e2bcd8739ae039), {
                        responseFile: invoiceDisplayFile,
                        embedded: true,
                        onClose: ()=>setInvoiceDisplayFile("")
                    })
                })
            }) : null
        ]
    });
}




(0, $96e14f2a7c3555e4$export$521461945d438145)();
(0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot(document.getElementById("root")).render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).StrictMode, {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b8e0994176c9ade$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=app.93b652c3.js.map
